// @ts-nocheck
import { newDate, newDateTime } from "src/utils/tests/testDates";
import {
  AbortAssetMultipartUploadResult,
  ActivateItemTemplateVersionsResult,
  ActivateUserResult,
  ActivateUsersResult,
  ActivityPlanningState,
  ActivityPlanningStateDetail,
  ActivityResponsibility,
  ActivityResponsibilityDetail,
  ActivityType,
  ActivityTypeDetail,
  Address,
  AggregateVersionStatus,
  AggregateVersionStatusDetail,
  AllEnumDetails,
  AllocationStrategy,
  AllocationStrategyDetail,
  AnnotatedCost,
  ApplyInvoiceScheduleResult,
  ApplyItemTemplateResult,
  ApplyItemTemplateToChangeEventResult,
  ApplyProjectReadyPlanConfigsResult,
  ApplyScheduleTemplatesResult,
  Approval,
  ApprovalPage,
  ApprovalSource,
  ApprovalStatus,
  ApprovalStatusDetail,
  ApprovalSubject,
  ApprovePreConBudgetLineItemResult,
  Approver,
  ApproverStatus,
  ApproverStatusDetail,
  ApproverSubjectData,
  ApproverUser,
  Asset,
  Attachment,
  AttachmentParent,
  BackfillGlobalOptionNamesResult,
  BackfillResponse,
  BaseItemLike,
  BaseItemParentVersion,
  BidContract,
  BidContractLineItem,
  BidContractLineItemsPageResult,
  BidContractPotentialItem,
  BidContractRevision,
  BidContractRevisionDraw,
  BidContractRevisionStatus,
  BidContractRevisionStatusDetail,
  BidContractsPage,
  BidContractTradeLineItem,
  BidContractType,
  BidContractTypeDetail,
  BidItem,
  BidItemEstimate,
  BidItemEstimatesPageResult,
  BidItemsPage,
  BidPackage,
  BidPackageAward,
  BidPackageGroup,
  BidPackageGroupProductOfferingsResult,
  BidPackageGroupsPageResult,
  BidPackageIncomingUpdate,
  BidPackageIncomingUpdateStats,
  BidPackageLineItem,
  BidPackageRequest,
  BidPackageScopeLine,
  BidPackageStatus,
  BidPackageStatusDetail,
  BidPackageVersion,
  BidPackageVersionRequest,
  BidScopeSource,
  BidScopeSourceDetail,
  Bill,
  BillGmailAttachment,
  BillGmailAttachmentResult,
  BillGmailAttachmentResultDetail,
  BillGmailMessage,
  BillGmailMessageResult,
  BillGmailMessageResultDetail,
  BillLineItem,
  BillLineItemAllocation,
  BillMetric,
  BillMetricsResult,
  BillOcr,
  BillReviewReason,
  BillReviewReasonDetail,
  BillSource,
  BillSourceDetail,
  BillsPage,
  BillStatus,
  BillStatusDetail,
  BillType,
  BillTypeDetail,
  BudgetPhaseRollup,
  Builder,
  BulkSaveGlobalPlanTagsResult,
  BulkUpdateProjectRoleResult,
  BusinessFunction,
  BusinessFunctionType,
  BusinessFunctionTypeDetail,
  BuyoutStatus,
  BuyoutStatusDetail,
  CalculateScopeChangeResult,
  CalendarInterval,
  CalendarInterval2,
  ChangeEvent,
  ChangeEventBudgetPhase,
  ChangeEventBudgetPhaseDetail,
  ChangeEventCreatedBy,
  ChangeEventLineItem,
  ChangeEventLineItemAllocation,
  ChangeEventLineItemType,
  ChangeEventLineItemTypeDetail,
  ChangeEventOriginalOption,
  ChangeEventProposedOption,
  ChangeEventReason,
  ChangeEventStatus,
  ChangeEventStatusDetail,
  ChangeEventTemplateConfig,
  ChangeEventType,
  ChangeEventTypeDetail,
  ChangeRequest,
  ChangeRequestApproverSubjectData,
  ChangeRequestAsset,
  ChangeRequestAssetPlatform,
  ChangeRequestAssetPlatformDetail,
  ChangeRequestAssetScope,
  ChangeRequestAssetScopeDetail,
  ChangeRequestAssetsPageResult,
  ChangeRequestGroup,
  ChangeRequestPriority,
  ChangeRequestPriorityDetail,
  ChangeRequestScope,
  ChangeRequestScopeTarget,
  ChangeRequestSource,
  ChangeRequestSourceDetail,
  ChangeRequestsPageResult,
  ChangeRequestStatus,
  ChangeRequestStatusDetail,
  ChangeRequestToDo,
  ChangeRequestToDoType,
  ChangeRequestToDoTypeDetail,
  ChangeType,
  ChangeTypeDetail,
  CheckoutConfig,
  CheckoutConfigInteriorSubStep,
  CheckoutConfigOption,
  CheckoutConfigOptionGroup,
  CheckoutConfigOptionGroupStep,
  CheckoutConfigOptionGroupStepDetail,
  CheckoutConfigPackageOptionProduct,
  CheckoutConfigPackageOptionSlot,
  CheckoutConfigPotentialOption,
  CheckoutConfigsPage,
  CheckoutConfigStatus,
  CheckoutConfigStatusDetail,
  CheckoutPricingTrace,
  CheckoutPricingTraceOption,
  CheckoutPricingTraceOptionChange,
  CheckoutPricingTraceOptionGroup,
  Client,
  ClientPlatform,
  ClientPlatformDetail,
  CloneItemTemplateResult,
  CloneProjectCostAllocationsResult,
  Cohort,
  CohortLotSummaryChart,
  Comment,
  Commentable,
  CommentStream,
  CommentStreams,
  CommentStreamVisibility,
  CommentStreamVisibilityDetail,
  CommentTag,
  Commitment,
  CommitmentBillingScheduleItem,
  CommitmentBillingScheduleLineItem,
  CommitmentChangeOrder,
  CommitmentCostCodeSummary,
  CommitmentCostCodeSummaryLineItem,
  CommitmentDraw,
  CommitmentLike,
  CommitmentLineItem,
  CommitmentLineItemAllocation,
  CommitmentLineItemSummary,
  CommitmentsPage,
  CommitmentStatus,
  CommitmentStatusDetail,
  CommitmentType,
  CommitmentTypeDetail,
  CommunicationChannel,
  CommunicationChannelDetail,
  CommunitiesPageResult,
  Community,
  CommunityType,
  CommunityTypeDetail,
  CompanyInfo,
  ComputeProductOfferingConfigCostsResult,
  ComputeProductOfferingCostsAndPricesResponse,
  ComputeReadyPlanCostResult,
  ConfigCostsResult,
  ConstructionType,
  ConstructionTypeDetail,
  ContractProjectFinancials,
  ContractType,
  ContractTypeDetail,
  ConvertExpenseToBillResult,
  CopyDesignPackageCardsResult,
  CopyDesignPackageSelectionsResult,
  CopyItemTemplateItemsResult,
  CopyTakeoffLineItemsResult,
  CostAccrualAdjustmentType,
  CostClassificationType,
  CostClassificationTypeDetail,
  CostCode,
  CostCodeAward,
  CostCodeInvoiceCategory,
  CostCodeInvoiceCategoryDetail,
  CostConfidence,
  CostConfidenceDetail,
  CostDivision,
  CostEstimate,
  CostLineItem,
  CostLineItemAllocation,
  CostLineItemEntity,
  CostMappingProgress,
  CostSubClassificationType,
  CostSubClassificationTypeDetail,
  CostType,
  CostTypeDetail,
  CreateAssetMultipartUploadUrlResult,
  CreateAssetResult,
  CreateAssetUploadUrlResult,
  CreateBillOcrResult,
  CreateCommitmentFromBillResult,
  CreateDesignPackageAlternateLocationResult,
  CreateDesignPackagePlaceholderTliResult,
  CreateDocumentPendingUploadResult,
  CreateNewItemTemplateVersionsResult,
  Customer,
  CustomerItemConfig,
  CustomerOwnerEntity,
  Cutoff,
  DashboardConfig,
  DashboardTile,
  DashboardTileConfig,
  DashboardTileSize,
  DayOfWeek,
  DayOfWeekDetail,
  DeactivateUserResult,
  DeactivateUsersResult,
  DedupedItemTemplateItemVersion,
  DedupeReadyPlanItemTemplateItemVersionsResult,
  DeleteAttachmentResult,
  DeleteAuditEventResult,
  DeleteAuditEventsResult,
  DeleteBidContractLineItemResult,
  DeleteCommentResult,
  DeleteDevelopmentCommitmentProjectsAndCommitmentsResult,
  DeleteDocumentsResult,
  DeleteInvoiceScheduleResult,
  DeleteJobLogImageResult,
  DeleteJobLogNoteResult,
  DeletePandaDocResult,
  DeletePreConBudgetLineItemResult,
  DeleteReadyPlanAggregateVersionResult,
  DeleteReadyPlanOptionProgramDataModificationsResult,
  DeleteRequiredTaskDocumentResult,
  DeleteScheduleFlagResult,
  DeleteSchedulePhasesResult,
  DeleteScheduleSubPhasesResult,
  DeleteTradePartnerAgreementResult,
  DeleteTradePartnerContactResult,
  DeleteTradePartnerMarketContactResult,
  DesignPackage,
  DesignPackageCombination,
  DesignPackageFinishSchedulePageResult,
  DesignPackageLocation,
  DesignPackageLocationDetail,
  DesignPackageOptionCombination,
  DesignPackagePlanUpdate,
  DesignPackageSlot,
  DesignPackageSource,
  DesignPackageSourceVersion,
  DesignPackagesPageResult,
  DesignPackageVersion,
  Development,
  DevelopmentCommitment,
  DevelopmentCommitmentCostCodeSummary,
  DevelopmentCommitmentPotentialLineItem,
  DevelopmentCommitmentsPage,
  DevelopmentCommitmentSummary,
  DevelopmentCommitmentSummaryLineItem,
  DevelopmentCommitmentType,
  DevelopmentCommitmentTypeDetail,
  DevelopmentItemMapping,
  DevelopmentLotSummaryChartsResult,
  DevelopmentOption,
  DevelopmentTeamMember,
  Document,
  DocumentAttachmentPlace,
  DocumentAttachmentPlaceDetail,
  DocumentCategory,
  DocumentCategoryDetail,
  DocumentOwner,
  DocumentParent,
  DocumentsPageResult,
  DocumentType,
  DocumentTypeDetail,
  DraftScheduleResult,
  Drop,
  DuplicateJobLogsResult,
  DuplicateProjectItemsResult,
  DuplicateScheduleTemplateResult,
  EarnedValueCurve,
  EarnedValueDataPoint,
  EmptyResult,
  Entity,
  ErpAccountBillLineItem,
  ErpAccountBillLineItemErpSource,
  ErpAccrualLineItemSourceLine,
  ErpAccrualType,
  ErpAccrualTypeDetail,
  ErpRevenueLineItemSourceEvent,
  ErpRevenueLineItemSourceEventDetail,
  ErpTransactionGroupEvent,
  ErpTransactionGroupEventDetail,
  ErpTransactionGroupStatus,
  ErpTransactionGroupStatusDetail,
  ErpTransactionStatus,
  ErpTransactionStatusDetail,
  Estimate,
  EstimatedInvoiceScheduleItem,
  EstimateLineItem,
  EstimateStatus,
  EstimateStatusDetail,
  EstimateType,
  EstimateTypeDetail,
  Expense,
  ExpenseAllocation,
  ExpenseAllocationAllocation,
  ExpensesPage,
  ExportProjectBillsResult,
  FeatureFlag,
  FeatureFlagStatus,
  FeatureFlagStatusDetail,
  FeatureFlagTarget,
  FeatureFlagTargetTarget,
  FeatureFlagType,
  FeatureFlagTypeDetail,
  FloodPlain,
  FloodPlainDetail,
  FloodZone,
  FloodZoneDetail,
  Followable,
  FollowSequenceSheetResult,
  FoundationType,
  FoundationTypeDetail,
  GlobalOption,
  GlobalOptionGroup,
  GlobalOptionStatus,
  GlobalOptionStatusDetail,
  GlobalOptionTag,
  GlobalOptionType,
  GlobalOptionTypeStatus,
  GlobalOptionTypeStatusDetail,
  GlobalPhase,
  GlobalPlanAllowance,
  GlobalPlanConstraint,
  GlobalPlanConstraintItem,
  GlobalPlanMilestone,
  GlobalPlanMilestoneGroup,
  GlobalPlanMilestonesPageResult,
  GlobalPlanStage,
  GlobalPlanStageVariant,
  GlobalPlanTag,
  GlobalPlanTask,
  GlobalPlanTaskChecklistItem,
  GlobalPlanTaskScope,
  GlobalPlanTasksPageResult,
  GlobalPlanTaskVariant,
  GlobalRequiredTaskDocument,
  GlobalSearchRecord,
  GlobalSearchRecordParent,
  GlobalSearchResult,
  GlobalSubPhase,
  GlobalTask,
  HasBlueprintUrl,
  HasDisplayName,
  History,
  HomeboundHoliday,
  Homeowner,
  HomeownerContract,
  HomeownerContractChangeOrder,
  HomeownerContractDraw,
  HomeownerContractLike,
  HomeownerContractLineItem,
  HomeownerContractLineItemAllocation,
  HomeownerContractLineItemsByProjectItem,
  HomeownerLocationSelection,
  HomeownerNote,
  HomeownerSelection,
  HomeownerSelectionOption,
  HomeownerSelectionOptionLike,
  HomeownerSelectionOptionPricingType,
  HomeownerSelectionOptionPricingTypeDetail,
  HomeownerSelectionProductOption,
  HomeownerSelectionStatus,
  HomeownerSelectionStatusDetail,
  HomeownerSelectionStatusProgress,
  HomeownersPage,
  IdentifyProjectAccrualAdjustmentsResult,
  InboxItemStatus,
  InboxItemStatusDetail,
  IncomingChanges,
  InsideMapsCamera,
  InsideMapsCameraTextureSwaps,
  InsideMapsDebugSlot,
  InsideMapsRoomRendering,
  InsideMapsSlotAuditResult,
  InsideMapsSlotDiffResult,
  InsideMapsTextureSwap,
  InsideMapsTextureSwaps,
  InteriorRoomRendering,
  InternalUser,
  Invoice,
  InvoiceAccruedLineItem,
  InvoiceDisplayLineItem,
  InvoiceDocument,
  InvoiceDocumentSource,
  InvoiceDocumentSourceDetail,
  InvoiceDrawLineItem,
  InvoiceLineItem,
  InvoiceLineItemsByCostCode,
  InvoiceParent,
  InvoiceSchedule,
  InvoiceScheduleAmountType,
  InvoiceScheduleAmountTypeDetail,
  InvoiceScheduledLineItem,
  InvoiceScheduleItem,
  InvoiceScheduleItemFrequency,
  InvoiceScheduleItemFrequencyDetail,
  InvoiceScheduleItemGlobalParent,
  InvoiceScheduleItemParent,
  InvoiceScheduleTemplate,
  InvoiceScheduleTemplateItem,
  InvoiceScheduleTriggerType,
  InvoiceScheduleTriggerTypeDetail,
  InvoiceSource,
  InvoiceSourceDetail,
  InvoicesPage,
  InvoiceStatus,
  InvoiceStatusDetail,
  InvoiceType,
  InvoiceTypeDetail,
  Item,
  ItemPlanTaskMapping,
  ItemPlanTaskMappingPage,
  ItemSlot,
  ItemStatus,
  ItemStatusDetail,
  ItemTemplate,
  ItemTemplateAnomaly,
  ItemTemplateAnomalyParent,
  ItemTemplateAnomalyType,
  ItemTemplateCollection,
  ItemTemplateCostUpdate,
  ItemTemplateItem,
  ItemTemplateItemCostStatus,
  ItemTemplateItemCostStatusDetail,
  ItemTemplateItemPlan,
  ItemTemplateItemVersion,
  ItemTemplateItemVersionGroupTotal,
  ItemTemplateItemVersionsPage,
  ItemTemplateStatus,
  ItemTemplateStatusDetail,
  ItiAnomaly,
  JobLog,
  JobLogFlag,
  JobLogFlagDetail,
  JobLogImage,
  JobLogImageParent,
  JobLogNote,
  JobLogNoteType,
  JobLogNoteTypeDetail,
  JobLogsPageResult,
  LienWaiver,
  LienWaiverClaimant,
  LienWaiverCondition,
  LienWaiverConditionDetail,
  LienWaiverOwner,
  LienWaiverParent,
  LienWaiverPayer,
  LienWaiverSignatory,
  LienWaiversPage,
  LienWaiverStatus,
  LienWaiverStatusDetail,
  LienWaiverType,
  LienWaiverTypeDetail,
  Location,
  LocationType,
  LocationTypeDetail,
  Lot,
  LotRating,
  LotSalesStatus,
  LotSalesStatusDetail,
  LotType,
  LotTypeDetail,
  MakeHomeownerSelectionResult,
  MarkDocumentAsUploadedResult,
  Market,
  MarketContactWithRoles,
  MarkupApplicationMethod,
  MarkupApplicationMethodDetail,
  MaterialAssemblyComponent,
  MaterialAttributeDimension,
  MaterialAttributeDimensionType,
  MaterialAttributeDimensionTypeDetail,
  MaterialAttributeValue,
  MaterialAttributeValueType,
  MaterialAttributeValueTypeDetail,
  MaterialBrand,
  MaterialCostSource,
  MaterialLeadTimeConfig,
  MaterialLeadTimeConfigParent,
  MaterialLeadTimeConfigVariant,
  MaterialListing,
  MaterialListingsPage,
  MaterialType,
  MaterialTypeDetail,
  MaterialVariant,
  MaterialVariantCostSourcesPage,
  MaterialVariantImage,
  MaterialVariantsPage,
  MaterialVariantTag,
  Maybe,
  MergeMaterialListingsResult,
  MergeReadyPlanOptionsResult,
  MermaidResult,
  MigrateMaterialListingItemResult,
  MobileSyncUpdate,
  MobileSyncUpdatesPageResult,
  MobileSyncUpdateType,
  MobileSyncUpdateTypeDetail,
  MoveScheduleSubPhasesResult,
  MultipartPartUploadUrl,
  NewProgramData,
  OptionPricingConfig,
  OptionPricingConfigParent,
  OptionPricingConfigVariant,
  OptionToUpdate,
  OptionWithCutoffDate,
  OverlappingBidPackagesResult,
  Page,
  PageInfo,
  PandaDoc,
  PandaDocIntendedRecipient,
  PandaDocOwner,
  PandaDocRecipient,
  PandaDocRole,
  PandaDocRoleDetail,
  PandaDocSession,
  PandaDocStatus,
  PandaDocStatusDetail,
  PandaDocWorkspace,
  PandaDocWorkspaceDetail,
  PaymentTerm,
  PaymentTermDueFrom,
  PaymentTermDueFromDetail,
  Permissions,
  Permit,
  PermitDetail,
  PlaceholderCombinationsResult,
  PlanMilestone,
  PlanMilestoneSnapshot,
  PlanMilestonesResult,
  PlanPackage,
  PlanPackagesPageResult,
  PlanPackageVersion,
  PlanSchedule,
  PlanScheduleParent,
  PlanScheduleSnapshotsResult,
  PlanTask,
  PlanTaskChecklistItem,
  PlanTasksResult,
  PotentialBidContractLineItem,
  PotentialBidContractRevision,
  PotentialDateBasisPoints,
  PotentialOperation,
  PotentialOperation2,
  PotentialProjectItem,
  PreConBudgetCostCodeLineItem,
  PreConBudgetCostDivisionLineItem,
  PreconContractType,
  Product,
  ProductAttribute,
  ProductAttributeType,
  ProductAttributeTypeDetail,
  ProductDimension,
  ProductDimensionType,
  ProductDimensionTypeDetail,
  ProductImage,
  ProductOffering,
  ProductOfferingConfig,
  ProductOfferingConfigsPage,
  ProductOfferingIncomingUpdate,
  ProductOfferingIncomingUpdateSource,
  ProductOfferingInfo,
  ProductOfferingsPageResult,
  ProductOfferingVersion,
  ProductsPage,
  ProductStatus,
  ProductStatusDetail,
  ProductType,
  ProgramData,
  ProgramDataBasementConfig,
  ProgramDataBasementConfigDetail,
  ProgramDataGarageConfig,
  ProgramDataGarageConfigDetail,
  ProgramDataMatchState,
  ProgramDataMatchStateDetail,
  ProgramDataPrimaryBedroomConfig,
  ProgramDataPrimaryBedroomConfigDetail,
  ProgramDataWindowColor,
  ProgramDataWindowColorDetail,
  ProgressSummary,
  ProgressSummaryStatus,
  Project,
  ProjectAllocationRule,
  ProjectBudgetFinancials,
  ProjectChangeEventGraph,
  ProjectChangeEventGraphData,
  ProjectChangeEventGraphsResult,
  ProjectChangeEventGraphType,
  ProjectCollaborator,
  ProjectCollaboratorRole,
  ProjectCollaboratorRoleDetail,
  ProjectCompletedTaskBudgetReview,
  ProjectContact,
  ProjectCostCode,
  ProjectCostCodesPageResult,
  ProjectCutoff,
  ProjectDictionary,
  ProjectDirectMarginGraph,
  ProjectDirectMarginGraphData,
  ProjectDirectMarginGraphResolution,
  ProjectDocumentAssociation,
  ProjectFeature,
  ProjectFeatureDetail,
  ProjectInvoiceSetting,
  ProjectItem,
  ProjectItemAllocation,
  ProjectItemBudgetFinancials,
  ProjectItemScopeChange,
  ProjectItemsPage,
  ProjectJobLogInsights,
  ProjectLotDetail,
  ProjectReadyPlanConfig,
  ProjectReadyPlanConfigOption,
  ProjectReadyPlanConfigOrientation,
  ProjectReadyPlanConfigOrientationDetail,
  ProjectRole,
  ProjectRoleDetail,
  ProjectSalesforceOpportunity,
  ProjectSiteCondition,
  ProjectSiteSpecificInfo,
  ProjectSnapshot,
  ProjectsPageResult,
  ProjectStage,
  ProjectStageHocFinancials,
  ProjectStageHomeownerFinancials,
  ProjectStageStatus,
  ProjectStageStatusDetail,
  ProjectStageTemplateConfig,
  ProjectStatus,
  ProjectStatusChange,
  ProjectStatusChangeReason,
  ProjectStatusDetail,
  ProjectsToUpdateByTemplatesResult,
  ProjectTeamMember,
  ProjectToUpdate,
  ProjectUpdate,
  ProjectUpdateActionType,
  ProjectUpdateActionTypeDetail,
  PromotionStatus,
  PromotionStatusDetail,
  ProtoBill,
  ProtoBillLineItem,
  ProtoCommitmentLineItemToBuyout,
  ProtoProjectItem,
  PunchlistItemTodo,
  PushNotificationEnvironment,
  PushNotificationEnvironmentDetail,
  PushNotificationPlatform,
  PushNotificationPlatformDetail,
  PushNotificationToken,
  ReadyPlan,
  ReadyPlanAggregateVersion,
  ReadyPlanAggregateVersionsPageResult,
  ReadyPlanAsset,
  ReadyPlanAssetParent,
  ReadyPlanAssetType,
  ReadyPlanAssetTypeDetail,
  ReadyPlanAssetVersion,
  ReadyPlanDesignNote,
  ReadyPlanDesignNoteVersion,
  ReadyPlanDesignPackage,
  ReadyPlanDesignPackageVersion,
  ReadyPlanDocumentVersion,
  ReadyPlanLike,
  ReadyPlanLocation,
  ReadyPlanLocationVersion,
  ReadyPlanOption,
  ReadyPlanOptionConfigCosts,
  ReadyPlanOptionCostAndPriceDelta,
  ReadyPlanOptionCostDelta,
  ReadyPlanOptionGroup,
  ReadyPlanOptionGroupPersonalizationType,
  ReadyPlanOptionGroupPersonalizationTypeDetail,
  ReadyPlanOptionGroupVersion,
  ReadyPlanOptionProgramDataModification,
  ReadyPlanOptionVersion,
  ReadyPlanProgramData,
  ReadyPlanProgramDataVersion,
  ReadyPlanRequiredOption,
  ReadyPlanRequiredOptionVersion,
  ReadyPlanStatus,
  ReadyPlanStatusDetail,
  ReadyPlanType,
  ReadyPlanTypeDetail,
  ReadyPlanVersion,
  Reason,
  Referencable,
  Reference,
  Region,
  RegisterPushNotificationTokenResult,
  RenderingAsset,
  ReplaceGlobalSubPhaseResult,
  RequiredTaskDocument,
  ResetScheduleBaselinesResult,
  ResultingDelay,
  ResyncPreconProjectItemCostResult,
  RoomType,
  RunCheckoutPricingReportResult,
  SaveApprovalResult,
  SaveApprovalsResult,
  SaveApproverResult,
  SaveApproversResult,
  SaveAttachmentResult,
  SaveBidContractLineItemResult,
  SaveBidContractLineItemsResult,
  SaveBidContractResult,
  SaveBidContractRevisionResult,
  SaveBidContractTradeLineItemsResult,
  SaveBidItemEstimateResult,
  SaveBidItemResult,
  SaveBidPackageAwardsResult,
  SaveBidPackageRequestResult,
  SaveBidPackageResult,
  SaveBidPackagesResult,
  SaveBillResult,
  SaveBillsResult,
  SaveBuilderResult,
  SaveBusinessFunctionResult,
  SaveChangeEventLineItemsResult,
  SaveChangeEventReasonResult,
  SaveChangeEventResult,
  SaveChangeEventsResult,
  SaveChangeRequestAssetsResult,
  SaveChangeRequestGroupResult,
  SaveChangeRequestGroupsResult,
  SaveChangeRequestResult,
  SaveChangeRequestsResult,
  SaveCheckoutConfigResult,
  SaveCohortsResult,
  SaveCommentResult,
  SaveCommitmentChangeOrderResult,
  SaveCommitmentResult,
  SaveCommitmentsResult,
  SaveCommunityResult,
  SaveCostCodesResult,
  SaveCostDivisionsResult,
  SaveCustomerItemConfigResult,
  SaveCustomerOwnerEntityResult,
  SaveCustomerResult,
  SaveCutoffResult,
  SaveDesignPackageLocationPlanMappingsResult,
  SaveDesignPackageResult,
  SaveDesignPackageSourceResult,
  SaveDesignPackageUpdatesResult,
  SaveDevelopmentCommitmentResult,
  SaveDevelopmentOptionsResult,
  SaveDevelopmentsResult,
  SaveDocumentsResult,
  SaveDropResult,
  SaveEstimateResult,
  SaveExpenseAllocationsResult,
  SaveExpensesResult,
  SaveFeatureFlagResult,
  SaveFeatureFlagTargetResult,
  SaveFollowersResult,
  SaveGlobalOptionGroupResult,
  SaveGlobalOptionsResult,
  SaveGlobalOptionTagsResult,
  SaveGlobalOptionTypesResult,
  SaveGlobalPhasesResult,
  SaveGlobalPlanConstraintItemResult,
  SaveGlobalPlanConstraintItemsResult,
  SaveGlobalPlanMilestoneGroupResult,
  SaveGlobalPlanMilestoneResult,
  SaveGlobalPlanMilestonesResult,
  SaveGlobalPlanStageResult,
  SaveGlobalPlanStageVariantsResult,
  SaveGlobalPlanTagResult,
  SaveGlobalPlanTaskResult,
  SaveGlobalPlanTasksResult,
  SaveGlobalRequiredTaskDocumentResult,
  SaveGlobalSubPhasesResult,
  SaveGlobalTasksResult,
  SaveHomeboundHolidayResult,
  SaveHomeownerContractChangeOrderResult,
  SaveHomeownerContractResult,
  SaveHomeownerNoteResult,
  SaveHomeownerResult,
  SaveHomeownerSelectionOptionResult,
  SaveHomeownerSelectionResult,
  SaveInternalUserResult,
  SaveInvoiceDocumentResult,
  SaveInvoiceResult,
  SaveInvoiceScheduleTemplateResult,
  SaveInvoicesResult,
  SaveItemPlanTaskMappingResult,
  SaveItemSlotResult,
  SaveItemTemplateItemVersionsResult,
  SaveItemTemplateResult,
  SaveItemTemplatesResult,
  SaveJobLogImageResult,
  SaveJobLogNoteResult,
  SaveJobLogResult,
  SaveLienWaiverResult,
  SaveLocationsResult,
  SaveLotRatingResult,
  SaveLotResult,
  SaveMarketResult,
  SaveMaterialAssemblyComponentResult,
  SaveMaterialAttributeDimensionResult,
  SaveMaterialAttributeDimensionResults,
  SaveMaterialAttributeValueResult,
  SaveMaterialBrandResult,
  SaveMaterialLeadTimeConfigResult,
  SaveMaterialVariantResult,
  SaveMaterialVariantTagResult,
  SaveOptionPricingConfigsResult,
  SavePandaDocResult,
  SavePaymentTermResult,
  SavePersonalizationOptionGroupResult,
  SavePlanPackageResult,
  SavePlanScheduleResult,
  SavePlanTaskChecklistItemResult,
  SavePlanTaskResult,
  SavePreConBudgetLineItemResult,
  SavePreconContractTypeResult,
  SaveProductAttributesResult,
  SaveProductOfferingConfigResult,
  SaveProductOfferingResult,
  SaveProductsResult,
  SaveProductTypeResult,
  SaveProjectAllocationRuleResult,
  SaveProjectContactResult,
  SaveProjectCutoffResult,
  SaveProjectInvoiceSettingResult,
  SaveProjectItemsResult,
  SaveProjectLotDetailsResult,
  SaveProjectReadyPlanConfigOptionsResult,
  SaveProjectReadyPlanConfigsResult,
  SaveProjectResult,
  SaveProjectSiteConditionResult,
  SaveProjectSiteSpecificInfoResult,
  SaveProjectStatusChangeReasonsResult,
  SavePunchlistItemTodoResult,
  SavePunchlistItemTodosResult,
  SaveReadyPlanAggregateVersionResult,
  SaveReadyPlanDesignNoteResult,
  SaveReadyPlanLocationBulkResult,
  SaveReadyPlanOptionGroupResult,
  SaveReadyPlanOptionGroupsResult,
  SaveReadyPlanOptionProgramDataModificationsResult,
  SaveReadyPlanOptionsResult,
  SaveReadyPlanRequiredOptionsResult,
  SaveReadyPlanResult,
  SaveReadyPlansResult,
  SaveReferencesResult,
  SaveRegionResult,
  SaveRequiredTaskDocumentResult,
  SaveRoomTypeResult,
  SaveScheduleFlagReasonsResult,
  SaveScheduleFlagResult,
  SaveSchedulePhasesResult,
  SaveScheduleResult,
  SaveScheduleSettingsResult,
  SaveScheduleSubPhasesResult,
  SaveScheduleTaskChecklistItemResult,
  SaveScheduleTasksResult,
  SaveScheduleTemplateItemMappingsResult,
  SaveScheduleTemplatesResult,
  SaveScopeChangeReasonResult,
  SaveSiteSpecificInfoResult,
  SaveStructureResult,
  SaveSubdivisionResult,
  SaveSubmarketResult,
  SaveTakeoffLineItemResult,
  SaveTaskWorkDayResult,
  SaveToDoChecklistItemResult,
  SaveToDosResult,
  SaveTradeCategoryLeadTimesResult,
  SaveTradeCategoryResult,
  SaveTradePartnerAgreementResult,
  SaveTradePartnerAvailabilityRequestResult,
  SaveTradePartnerAvailabilityRequestsResult,
  SaveTradePartnerContactResult,
  SaveTradePartnerMarketContactResult,
  SaveTradePartnerRequirementResult,
  SaveTradePartnerResult,
  SaveTradePartnerReviewResult,
  SaveTradePartnersResult,
  SaveUnitResult,
  SaveUnitsOfMeasureResult,
  SaveUserCommunicationPreferenceResult,
  SaveUserGroupResult,
  SaveUserResult,
  SaveWarrantyTicketItemResult,
  SaveWarrantyTicketItemsResult,
  SaveWarrantyTicketResult,
  SaveWorkAuthorizationResult,
  Schedule,
  ScheduleEntity,
  ScheduleFlag,
  ScheduleFlagImpact,
  ScheduleFlagImpactImpacted,
  ScheduleFlagReason,
  ScheduleFlagReasonType,
  ScheduleFlagReasonTypeDetail,
  ScheduleLike,
  ScheduleParent,
  SchedulePhase,
  SchedulePhaseProgress,
  ScheduleSetting,
  SchedulesResult,
  ScheduleStatus,
  ScheduleStatusDetail,
  ScheduleSubPhase,
  ScheduleSubPhaseProgress,
  ScheduleTask,
  ScheduleTaskChecklistItem,
  ScheduleTaskDependency,
  ScheduleTemplate,
  ScheduleTemplateItemMapping,
  ScheduleTemplateStatus,
  ScheduleTemplateStatusDetail,
  SchedulingExclusionDate,
  SchedulingExclusionDateParent,
  ScopeChangeReason,
  ScopeChangeType,
  ScopeChangeTypeDetail,
  ScopeGlobalOptionGroupsToReadyPlansResult,
  ScopeMode,
  ScopeModeDetail,
  SelectionCutoff,
  SelectionCutoffDetail,
  SelectionPricingMode,
  SelectionPricingModeDetail,
  SendInviteEmailResult,
  SendPunchlistExportEmailFailure,
  SendPunchlistExportEmailResult,
  SendPunchlistExportEmailResults,
  SendPunchlistExportEmailSuccess,
  SendTradePartnerPunchlistEmailFailure,
  SendTradePartnerPunchlistEmailResult,
  SendTradePartnerPunchlistEmailResults,
  SendTradePartnerPunchlistEmailSuccess,
  SimulationProbability,
  SiteSpecificInfo,
  Stage,
  StageDetail,
  StageProgress,
  StandaloneProject,
  Structure,
  StructuresPageResult,
  Subdivision,
  Submarket,
  SuburbanAssetCategory,
  SuburbanAssetCategoryDetail,
  SyncCostsForHomeownerSelectionOptionsResult,
  SystemChangeRequestAsset,
  SystemChangeRequestAssetDetail,
  SystemPlanMilestone,
  SystemPlanMilestoneDetail,
  SystemTask,
  SystemTaskDetail,
  TakeoffLineItem,
  TakeoffLineItemDesignPackageType,
  TakeoffLineItemDesignPackageTypeDetail,
  TakeoffLineItemGroupTotal,
  TakeoffLineItemsPage,
  TakeoffLineItemType,
  TakeoffLineItemTypeDetail,
  TakeoffLineItemVersion,
  Task,
  TaskDeadlineType,
  TaskDeadlineTypeDetail,
  TaskDependency,
  TaskDependencyType,
  TaskDependencyTypeDetail,
  TaskPage,
  TaskSchedulingStatus,
  TaskSnapshot,
  TaskStatus,
  TaskStatusDetail,
  TaskType,
  TaskTypeDetail,
  TaskWorkDay,
  TestMutationResult,
  TimeFrequency,
  TimeFrequencyDetail,
  TimeOfDay,
  TimeOfDayDetail,
  ToDo,
  ToDoChecklistItem,
  ToDoChecklistProgress,
  ToDoParent,
  ToDoStatus,
  ToDoStatusDetail,
  ToDoType,
  ToDoTypeDetail,
  ToggleDocumentAsFavoritedResult,
  TrackedJob,
  TrackedJobResult,
  TrackedJobStatus,
  TrackedJobStatusDetail,
  TradeCategory,
  TradeCategoryLeadTime,
  TradeCategoryLeadTimeDefault,
  TradePartner,
  TradePartnerAgreement,
  TradePartnerAvailabilityRequest,
  TradePartnerAvailabilityRequestEmail,
  TradePartnerAvailabilityRequestStatus,
  TradePartnerAvailabilityRequestStatusDetail,
  TradePartnerAvailabilityRequestTextMessage,
  TradePartnerContact,
  TradePartnerMailingList,
  TradePartnerMarketContact,
  TradePartnerMarketRole,
  TradePartnerMarketRoleDetail,
  TradePartnerOnboardingStatus,
  TradePartnerOnboardingStatusDetail,
  TradePartnerRequirement,
  TradePartnerRequirementStatus,
  TradePartnerRequirementStatusDetail,
  TradePartnerRequirementType,
  TradePartnerRequirementTypeDetail,
  TradePartnerReview,
  TradePartnersPage,
  TradePartnerTaskStatus,
  TradePartnerTaskStatusDetail,
  TradePartnerUser,
  Unit,
  UnitOfMeasure,
  UpdateProjectRoleResult,
  UploadMaterialVariantResult,
  UploadMaterialVariantsResult,
  UploadPandaDocResult,
  Url,
  User,
  UserCommunicationPreference,
  UserError,
  UserEvent,
  UserEventParent,
  UserEventParentType,
  UserEventType,
  UserEventTypeDetail,
  UserGroup,
  UserRelevantCommentStreamsResult,
  UserType,
  UserTypeDetail,
  WarrantyTicket,
  WarrantyTicketAvailability,
  WarrantyTicketItem,
  WarrantyTicketItemStatus,
  WarrantyTicketItemStatusDetail,
  WarrantyTicketItemType,
  WarrantyTicketItemTypeDetail,
  WarrantyTicketsPage,
  WarrantyTicketStatus,
  WarrantyTicketStatusDetail,
  WarrantyTicketType,
  WarrantyTicketTypeDetail,
  WeatherType,
  WeatherTypeDetail,
  WorkAuthorization,
} from "./graphqlTypes";

const factories: Record<string, Function> = {};
type RequireTypename<T extends { __typename?: string }> = Omit<T, "__typename"> & Required<Pick<T, "__typename">>;
export interface ScheduleTaskOptions {
  __typename?: "ScheduleTask";
  kind?: ScheduleTask["kind"];
  references?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: ScheduleTask["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: ScheduleTask["isFollowed"];
  id?: ScheduleTask["id"];
  globalPhase?: GlobalPhase | GlobalPhaseOptions | null;
  globalSubPhase?: GlobalSubPhase | GlobalSubPhaseOptions | null;
  schedulePhase?: SchedulePhase | SchedulePhaseOptions | null;
  scheduleSubPhase?: ScheduleSubPhase | ScheduleSubPhaseOptions | null;
  schedule?: Schedule | ScheduleOptions;
  parent?:
    | ScheduleParent
    | StandaloneProjectOptions
    | RequireTypename<RegionOptions>
    | RequireTypename<DevelopmentOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>
    | RequireTypename<ScheduleTemplateOptions>;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  name?: ScheduleTask["name"];
  status?: ScheduleTask["status"];
  statusDetail?: TaskStatusDetailOptions | TaskStatus;
  schedulingStatus?: ScheduleTask["schedulingStatus"];
  homeownerVisible?: ScheduleTask["homeownerVisible"];
  homeownerDescription?: ScheduleTask["homeownerDescription"];
  interval?: CalendarInterval | CalendarIntervalOptions;
  baselineInterval?: CalendarInterval | CalendarIntervalOptions;
  baselineInterval2?: CalendarInterval2 | CalendarInterval2Options | null;
  completedAt?: ScheduleTask["completedAt"];
  startDate?: ScheduleTask["startDate"];
  assignee?: InternalUser | InternalUserOptions | null;
  internalNote?: ScheduleTask["internalNote"];
  slackInDays?: ScheduleTask["slackInDays"];
  aheadOrBehindInDays?: ScheduleTask["aheadOrBehindInDays"];
  isStale?: ScheduleTask["isStale"];
  isCriticalPath?: ScheduleTask["isCriticalPath"];
  predecessors?: Array<ScheduleTask | ScheduleTaskOptions>;
  successors?: Array<ScheduleTask | ScheduleTaskOptions>;
  predecessorDependencies?: Array<ScheduleTaskDependency | ScheduleTaskDependencyOptions>;
  successorDependencies?: Array<ScheduleTaskDependency | ScheduleTaskDependencyOptions>;
  homeownerContractDraws?: Array<HomeownerContractDraw | HomeownerContractDrawOptions>;
  blueprintUrl?: Url | UrlOptions;
  salesforceId?: ScheduleTask["salesforceId"];
  tradePartner?: TradePartner | TradePartnerOptions | null;
  canEditStartDate?: PotentialOperation2 | PotentialOperation2Options;
  canEditEndDate?: PotentialOperation2 | PotentialOperation2Options;
  canEditDuration?: PotentialOperation2 | PotentialOperation2Options;
  canComplete?: PotentialOperation2 | PotentialOperation2Options;
  canStart?: PotentialOperation2 | PotentialOperation2Options;
  canDelete?: PotentialOperation2 | PotentialOperation2Options;
  canSetTraderPartner?: PotentialOperation2 | PotentialOperation2Options;
  projectCutoffs?: Array<ProjectCutoff | ProjectCutoffOptions>;
  projectItems?: Array<ProjectItem | ProjectItemOptions>;
  deadlineType?: ScheduleTask["deadlineType"];
  templateProjectRole?: ScheduleTask["templateProjectRole"];
  documents?: Array<Document | DocumentOptions>;
  globalTask?: GlobalTask | GlobalTaskOptions | null;
  isGlobalMilestoneTask?: ScheduleTask["isGlobalMilestoneTask"];
  sortOrder?: ScheduleTask["sortOrder"];
  requiredTaskDocuments?: Array<RequiredTaskDocument | RequiredTaskDocumentOptions>;
  history?: Array<History | HistoryOptions>;
  scheduleTaskChecklistItems?: Array<ScheduleTaskChecklistItem | ScheduleTaskChecklistItemOptions>;
  scheduleFlags?: Array<ScheduleFlag | ScheduleFlagOptions>;
  jobLogNotes?: Array<JobLogNote | JobLogNoteOptions>;
  tradePartnerIsScheduled?: ScheduleTask["tradePartnerIsScheduled"];
  checklistComplete?: ScheduleTask["checklistComplete"];
  hasScheduleFlags?: ScheduleTask["hasScheduleFlags"];
  systemTask?: ScheduleTask["systemTask"];
  bills?: Array<Bill | BillOptions>;
  tradePartners?: Array<TradePartner | TradePartnerOptions>;
  committedTradePartners?: Array<TradePartner | TradePartnerOptions>;
  billLineItems?: Array<BillLineItem | BillLineItemOptions>;
  defaultedHomeownerDescription?: ScheduleTask["defaultedHomeownerDescription"];
  templateTask?: Task | TaskOptions | null;
  tradePartnerStatus?: TradePartnerTaskStatusDetailOptions | TradePartnerTaskStatus;
  tradePartnerAvailabilityRequests?:
    | Array<TradePartnerAvailabilityRequest | TradePartnerAvailabilityRequestOptions>
    | null;
  protoBills?: Array<ProtoBill | ProtoBillOptions>;
  type?: TaskTypeDetailOptions | TaskType;
  workDays?: Array<TaskWorkDay | TaskWorkDayOptions>;
  commitmentDraws?: Array<CommitmentDraw | CommitmentDrawOptions>;
}

export function newScheduleTask(options: ScheduleTaskOptions = {}, cache: Record<string, any> = {}): ScheduleTask {
  const o = (options.__typename ? options : cache["ScheduleTask"] = {}) as ScheduleTask;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ScheduleTask";
  o.kind = options.kind ?? "kind";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("ScheduleTask");
  o.globalPhase = maybeNewOrNull("GlobalPhase", options.globalPhase, cache);
  o.globalSubPhase = maybeNewOrNull("GlobalSubPhase", options.globalSubPhase, cache);
  o.schedulePhase = maybeNewOrNull("SchedulePhase", options.schedulePhase, cache);
  o.scheduleSubPhase = maybeNewOrNull("ScheduleSubPhase", options.scheduleSubPhase, cache);
  o.schedule = maybeNew("Schedule", options.schedule, cache, options.hasOwnProperty("schedule"));
  o.parent = maybeNew(options.parent?.__typename ?? "StandaloneProject", options.parent, cache);
  o.project = maybeNewOrNull("Project", options.project, cache);
  o.name = options.name ?? "name";
  o.status = options.status ?? TaskStatus.NotStarted;
  o.statusDetail = enumOrDetailOfTaskStatus(options.statusDetail);
  o.schedulingStatus = options.schedulingStatus ?? TaskSchedulingStatus.Stale;
  o.homeownerVisible = options.homeownerVisible ?? false;
  o.homeownerDescription = options.homeownerDescription ?? null;
  o.interval = maybeNew("CalendarInterval", options.interval, cache, options.hasOwnProperty("interval"));
  o.baselineInterval = maybeNew(
    "CalendarInterval",
    options.baselineInterval,
    cache,
    options.hasOwnProperty("baselineInterval"),
  );
  o.baselineInterval2 = maybeNewOrNull("CalendarInterval2", options.baselineInterval2, cache);
  o.completedAt = options.completedAt ?? null;
  o.startDate = options.startDate ?? null;
  o.assignee = maybeNewOrNull("InternalUser", options.assignee, cache);
  o.internalNote = options.internalNote ?? null;
  o.slackInDays = options.slackInDays ?? null;
  o.aheadOrBehindInDays = options.aheadOrBehindInDays ?? null;
  o.isStale = options.isStale ?? false;
  o.isCriticalPath = options.isCriticalPath ?? false;
  o.predecessors = (options.predecessors ?? []).map((i) =>
    maybeNew("ScheduleTask", i, cache, options.hasOwnProperty("predecessors"))
  );
  o.successors = (options.successors ?? []).map((i) =>
    maybeNew("ScheduleTask", i, cache, options.hasOwnProperty("successors"))
  );
  o.predecessorDependencies = (options.predecessorDependencies ?? []).map((i) =>
    maybeNew("ScheduleTaskDependency", i, cache, options.hasOwnProperty("predecessorDependencies"))
  );
  o.successorDependencies = (options.successorDependencies ?? []).map((i) =>
    maybeNew("ScheduleTaskDependency", i, cache, options.hasOwnProperty("successorDependencies"))
  );
  o.homeownerContractDraws = (options.homeownerContractDraws ?? []).map((i) =>
    maybeNew("HomeownerContractDraw", i, cache, options.hasOwnProperty("homeownerContractDraws"))
  );
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.salesforceId = options.salesforceId ?? null;
  o.tradePartner = maybeNewOrNull("TradePartner", options.tradePartner, cache);
  o.canEditStartDate = maybeNew(
    "PotentialOperation2",
    options.canEditStartDate,
    cache,
    options.hasOwnProperty("canEditStartDate"),
  );
  o.canEditEndDate = maybeNew(
    "PotentialOperation2",
    options.canEditEndDate,
    cache,
    options.hasOwnProperty("canEditEndDate"),
  );
  o.canEditDuration = maybeNew(
    "PotentialOperation2",
    options.canEditDuration,
    cache,
    options.hasOwnProperty("canEditDuration"),
  );
  o.canComplete = maybeNew("PotentialOperation2", options.canComplete, cache, options.hasOwnProperty("canComplete"));
  o.canStart = maybeNew("PotentialOperation2", options.canStart, cache, options.hasOwnProperty("canStart"));
  o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
  o.canSetTraderPartner = maybeNew(
    "PotentialOperation2",
    options.canSetTraderPartner,
    cache,
    options.hasOwnProperty("canSetTraderPartner"),
  );
  o.projectCutoffs = (options.projectCutoffs ?? []).map((i) =>
    maybeNew("ProjectCutoff", i, cache, options.hasOwnProperty("projectCutoffs"))
  );
  o.projectItems = (options.projectItems ?? []).map((i) =>
    maybeNew("ProjectItem", i, cache, options.hasOwnProperty("projectItems"))
  );
  o.deadlineType = options.deadlineType ?? null;
  o.templateProjectRole = options.templateProjectRole ?? null;
  o.documents = (options.documents ?? []).map((i) =>
    maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
  );
  o.globalTask = maybeNewOrNull("GlobalTask", options.globalTask, cache);
  o.isGlobalMilestoneTask = options.isGlobalMilestoneTask ?? false;
  o.sortOrder = options.sortOrder ?? 0;
  o.requiredTaskDocuments = (options.requiredTaskDocuments ?? []).map((i) =>
    maybeNew("RequiredTaskDocument", i, cache, options.hasOwnProperty("requiredTaskDocuments"))
  );
  o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
  o.scheduleTaskChecklistItems = (options.scheduleTaskChecklistItems ?? []).map((i) =>
    maybeNew("ScheduleTaskChecklistItem", i, cache, options.hasOwnProperty("scheduleTaskChecklistItems"))
  );
  o.scheduleFlags = (options.scheduleFlags ?? []).map((i) =>
    maybeNew("ScheduleFlag", i, cache, options.hasOwnProperty("scheduleFlags"))
  );
  o.jobLogNotes = (options.jobLogNotes ?? []).map((i) =>
    maybeNew("JobLogNote", i, cache, options.hasOwnProperty("jobLogNotes"))
  );
  o.tradePartnerIsScheduled = options.tradePartnerIsScheduled ?? null;
  o.checklistComplete = options.checklistComplete ?? null;
  o.hasScheduleFlags = options.hasScheduleFlags ?? false;
  o.systemTask = options.systemTask ?? null;
  o.bills = (options.bills ?? []).map((i) => maybeNew("Bill", i, cache, options.hasOwnProperty("bills")));
  o.tradePartners = (options.tradePartners ?? []).map((i) =>
    maybeNew("TradePartner", i, cache, options.hasOwnProperty("tradePartners"))
  );
  o.committedTradePartners = (options.committedTradePartners ?? []).map((i) =>
    maybeNew("TradePartner", i, cache, options.hasOwnProperty("committedTradePartners"))
  );
  o.billLineItems = (options.billLineItems ?? []).map((i) =>
    maybeNew("BillLineItem", i, cache, options.hasOwnProperty("billLineItems"))
  );
  o.defaultedHomeownerDescription = options.defaultedHomeownerDescription ?? "defaultedHomeownerDescription";
  o.templateTask = maybeNewOrNull("Task", options.templateTask, cache);
  o.tradePartnerStatus = enumOrDetailOfTradePartnerTaskStatus(options.tradePartnerStatus);
  o.tradePartnerAvailabilityRequests = (options.tradePartnerAvailabilityRequests ?? []).map((i) =>
    maybeNew("TradePartnerAvailabilityRequest", i, cache, options.hasOwnProperty("tradePartnerAvailabilityRequests"))
  );
  o.protoBills = (options.protoBills ?? []).map((i) =>
    maybeNew("ProtoBill", i, cache, options.hasOwnProperty("protoBills"))
  );
  o.type = enumOrDetailOfTaskType(options.type);
  o.workDays = (options.workDays ?? []).map((i) =>
    maybeNew("TaskWorkDay", i, cache, options.hasOwnProperty("workDays"))
  );
  o.commitmentDraws = (options.commitmentDraws ?? []).map((i) =>
    maybeNew("CommitmentDraw", i, cache, options.hasOwnProperty("commitmentDraws"))
  );
  return o;
}

factories["ScheduleTask"] = newScheduleTask;

export interface HomeownerContractLineItemOptions {
  __typename?: "HomeownerContractLineItem";
  id?: HomeownerContractLineItem["id"];
  priceChangeInCents?: HomeownerContractLineItem["priceChangeInCents"];
  budgetChangeInCents?: HomeownerContractLineItem["budgetChangeInCents"];
  quantity?: HomeownerContractLineItem["quantity"];
  costCode?: CostCode | CostCodeOptions;
  internalNote?: HomeownerContractLineItem["internalNote"];
  invoiceLineItems?: Array<InvoiceLineItem | InvoiceLineItemOptions>;
  projectItem?: ProjectItem | ProjectItemOptions;
  parent?: HomeownerContract | HomeownerContractChangeOrder | HomeownerContractLike | HomeownerContractLikeOptions;
  owner?: HomeownerContract | HomeownerContractChangeOrder | HomeownerContractLike | HomeownerContractLikeOptions;
  amountPaidInCents?: HomeownerContractLineItem["amountPaidInCents"];
  invoicedAmountInCents?: HomeownerContractLineItem["invoicedAmountInCents"];
  changeEventLineItem?: ChangeEventLineItem | ChangeEventLineItemOptions | null;
  tradePartnerNote?: HomeownerContractLineItem["tradePartnerNote"];
  specifications?: HomeownerContractLineItem["specifications"];
  bidItem?: BidItem | BidItemOptions | null;
  allocations?: Array<HomeownerContractLineItemAllocation | HomeownerContractLineItemAllocationOptions>;
}

export function newHomeownerContractLineItem(
  options: HomeownerContractLineItemOptions = {},
  cache: Record<string, any> = {},
): HomeownerContractLineItem {
  const o = (options.__typename ? options : cache["HomeownerContractLineItem"] = {}) as HomeownerContractLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "HomeownerContractLineItem";
  o.id = options.id ?? nextFactoryId("HomeownerContractLineItem");
  o.priceChangeInCents = options.priceChangeInCents ?? null;
  o.budgetChangeInCents = options.budgetChangeInCents ?? null;
  o.quantity = options.quantity ?? null;
  o.costCode = maybeNew("CostCode", options.costCode, cache, options.hasOwnProperty("costCode"));
  o.internalNote = options.internalNote ?? null;
  o.invoiceLineItems = (options.invoiceLineItems ?? []).map((i) =>
    maybeNew("InvoiceLineItem", i, cache, options.hasOwnProperty("invoiceLineItems"))
  );
  o.projectItem = maybeNew("ProjectItem", options.projectItem, cache, options.hasOwnProperty("projectItem"));
  o.parent = maybeNew("HomeownerContractLike", options.parent, cache, options.hasOwnProperty("parent"));
  o.owner = maybeNew("HomeownerContractLike", options.owner, cache, options.hasOwnProperty("owner"));
  o.amountPaidInCents = options.amountPaidInCents ?? null;
  o.invoicedAmountInCents = options.invoicedAmountInCents ?? 0;
  o.changeEventLineItem = maybeNewOrNull("ChangeEventLineItem", options.changeEventLineItem, cache);
  o.tradePartnerNote = options.tradePartnerNote ?? null;
  o.specifications = options.specifications ?? null;
  o.bidItem = maybeNewOrNull("BidItem", options.bidItem, cache);
  o.allocations = (options.allocations ?? []).map((i) =>
    maybeNew("HomeownerContractLineItemAllocation", i, cache, options.hasOwnProperty("allocations"))
  );
  return o;
}

factories["HomeownerContractLineItem"] = newHomeownerContractLineItem;

export interface AddressOptions {
  __typename?: "Address";
  id?: Address["id"];
  street1?: Address["street1"];
  street2?: Address["street2"];
  city?: Address["city"];
  state?: Address["state"];
  postalCode?: Address["postalCode"];
  country?: Address["country"];
}

export function newAddress(options: AddressOptions = {}, cache: Record<string, any> = {}): Address {
  const o = (options.__typename ? options : cache["Address"] = {}) as Address;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Address";
  o.id = options.id ?? nextFactoryId("Address");
  o.street1 = options.street1 ?? "street1";
  o.street2 = options.street2 ?? null;
  o.city = options.city ?? "city";
  o.state = options.state ?? "state";
  o.postalCode = options.postalCode ?? "postalCode";
  o.country = options.country ?? "country";
  return o;
}

factories["Address"] = newAddress;

export interface ApprovalOptions {
  __typename?: "Approval";
  id?: Approval["id"];
  name?: Approval["name"];
  requestedAt?: Approval["requestedAt"];
  dueOn?: Approval["dueOn"];
  createdAt?: Approval["createdAt"];
  updatedAt?: Approval["updatedAt"];
  status?: ApprovalStatusDetailOptions | ApprovalStatus;
  requestedBy?: User | UserOptions | null;
  rootProject?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  approvers?: Array<Approver | ApproverOptions>;
  source?:
    | ApprovalSource
    | BidContractRevisionOptions
    | RequireTypename<ItemTemplateOptions>
    | RequireTypename<ReadyPlanAggregateVersionOptions>
    | null;
  subject?:
    | ApprovalSubject
    | BillOptions
    | RequireTypename<ChangeEventOptions>
    | RequireTypename<ChangeRequestOptions>
    | RequireTypename<InvoiceOptions>;
  blueprintUrl?: Url | UrlOptions;
  isFinalized?: Approval["isFinalized"];
  userEvents?: Array<UserEvent | UserEventOptions>;
  references?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: Approval["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: Approval["isFollowed"];
}

export function newApproval(options: ApprovalOptions = {}, cache: Record<string, any> = {}): Approval {
  const o = (options.__typename ? options : cache["Approval"] = {}) as Approval;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Approval";
  o.id = options.id ?? nextFactoryId("Approval");
  o.name = options.name ?? "name";
  o.requestedAt = options.requestedAt ?? null;
  o.dueOn = options.dueOn ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.status = enumOrDetailOfApprovalStatus(options.status);
  o.requestedBy = maybeNewOrNull("User", options.requestedBy, cache);
  o.rootProject = maybeNewOrNull("Project", options.rootProject, cache);
  o.approvers = (options.approvers ?? []).map((i) =>
    maybeNew("Approver", i, cache, options.hasOwnProperty("approvers"))
  );
  o.source = maybeNewOrNull(options.source?.__typename ?? "BidContractRevision", options.source, cache);
  o.subject = maybeNew(options.subject?.__typename ?? "Bill", options.subject, cache);
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.isFinalized = options.isFinalized ?? false;
  o.userEvents = (options.userEvents ?? []).map((i) =>
    maybeNew("UserEvent", i, cache, options.hasOwnProperty("userEvents"))
  );
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  return o;
}

factories["Approval"] = newApproval;

export interface ApprovalPageOptions {
  __typename?: "ApprovalPage";
  approvals?: Array<Approval | ApprovalOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newApprovalPage(options: ApprovalPageOptions = {}, cache: Record<string, any> = {}): ApprovalPage {
  const o = (options.__typename ? options : cache["ApprovalPage"] = {}) as ApprovalPage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ApprovalPage";
  o.approvals = (options.approvals ?? []).map((i) =>
    maybeNew("Approval", i, cache, options.hasOwnProperty("approvals"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["ApprovalPage"] = newApprovalPage;

export interface SaveApprovalResultOptions {
  __typename?: "SaveApprovalResult";
  approval?: Approval | ApprovalOptions;
}

export function newSaveApprovalResult(
  options: SaveApprovalResultOptions = {},
  cache: Record<string, any> = {},
): SaveApprovalResult {
  const o = (options.__typename ? options : cache["SaveApprovalResult"] = {}) as SaveApprovalResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveApprovalResult";
  o.approval = maybeNew("Approval", options.approval, cache, options.hasOwnProperty("approval"));
  return o;
}

factories["SaveApprovalResult"] = newSaveApprovalResult;

export interface SaveApprovalsResultOptions {
  __typename?: "SaveApprovalsResult";
  approvals?: Array<Approval | ApprovalOptions>;
}

export function newSaveApprovalsResult(
  options: SaveApprovalsResultOptions = {},
  cache: Record<string, any> = {},
): SaveApprovalsResult {
  const o = (options.__typename ? options : cache["SaveApprovalsResult"] = {}) as SaveApprovalsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveApprovalsResult";
  o.approvals = (options.approvals ?? []).map((i) =>
    maybeNew("Approval", i, cache, options.hasOwnProperty("approvals"))
  );
  return o;
}

factories["SaveApprovalsResult"] = newSaveApprovalsResult;

export interface ApproverOptions {
  __typename?: "Approver";
  id?: Approver["id"];
  order?: Approver["order"];
  statusUpdatedAt?: Approver["statusUpdatedAt"];
  createdAt?: Approver["createdAt"];
  updatedAt?: Approver["updatedAt"];
  status?: ApproverStatusDetailOptions | ApproverStatus;
  nextApprover?: Approver | ApproverOptions | null;
  approval?: Approval | ApprovalOptions;
  user?: ApproverUser | ClientOptions | RequireTypename<InternalUserOptions> | RequireTypename<TradePartnerUserOptions>;
  wasAutoApproved?: Approver["wasAutoApproved"];
  subjectData?: ApproverSubjectData | ChangeRequestApproverSubjectDataOptions | null;
  requireSignature?: Approver["requireSignature"];
  pandaDocRecipient?: PandaDocRecipient | PandaDocRecipientOptions | null;
}

export function newApprover(options: ApproverOptions = {}, cache: Record<string, any> = {}): Approver {
  const o = (options.__typename ? options : cache["Approver"] = {}) as Approver;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Approver";
  o.id = options.id ?? nextFactoryId("Approver");
  o.order = options.order ?? 0;
  o.statusUpdatedAt = options.statusUpdatedAt ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.status = enumOrDetailOfApproverStatus(options.status);
  o.nextApprover = maybeNewOrNull("Approver", options.nextApprover, cache);
  o.approval = maybeNew("Approval", options.approval, cache, options.hasOwnProperty("approval"));
  o.user = maybeNew(options.user?.__typename ?? "Client", options.user, cache);
  o.wasAutoApproved = options.wasAutoApproved ?? false;
  o.subjectData = maybeNewOrNull(
    options.subjectData?.__typename ?? "ChangeRequestApproverSubjectData",
    options.subjectData,
    cache,
  );
  o.requireSignature = options.requireSignature ?? false;
  o.pandaDocRecipient = maybeNewOrNull("PandaDocRecipient", options.pandaDocRecipient, cache);
  return o;
}

factories["Approver"] = newApprover;

export interface SaveApproverResultOptions {
  __typename?: "SaveApproverResult";
  approver?: Approver | ApproverOptions;
}

export function newSaveApproverResult(
  options: SaveApproverResultOptions = {},
  cache: Record<string, any> = {},
): SaveApproverResult {
  const o = (options.__typename ? options : cache["SaveApproverResult"] = {}) as SaveApproverResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveApproverResult";
  o.approver = maybeNew("Approver", options.approver, cache, options.hasOwnProperty("approver"));
  return o;
}

factories["SaveApproverResult"] = newSaveApproverResult;

export interface SaveApproversResultOptions {
  __typename?: "SaveApproversResult";
  approvers?: Array<Approver | ApproverOptions>;
}

export function newSaveApproversResult(
  options: SaveApproversResultOptions = {},
  cache: Record<string, any> = {},
): SaveApproversResult {
  const o = (options.__typename ? options : cache["SaveApproversResult"] = {}) as SaveApproversResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveApproversResult";
  o.approvers = (options.approvers ?? []).map((i) =>
    maybeNew("Approver", i, cache, options.hasOwnProperty("approvers"))
  );
  return o;
}

factories["SaveApproversResult"] = newSaveApproversResult;

export interface CreateAssetUploadUrlResultOptions {
  __typename?: "CreateAssetUploadUrlResult";
  s3Key?: CreateAssetUploadUrlResult["s3Key"];
  uploadUrl?: CreateAssetUploadUrlResult["uploadUrl"];
  downloadUrl?: CreateAssetUploadUrlResult["downloadUrl"];
  attachmentUrl?: CreateAssetUploadUrlResult["attachmentUrl"];
  previewUrl?: CreateAssetUploadUrlResult["previewUrl"];
}

export function newCreateAssetUploadUrlResult(
  options: CreateAssetUploadUrlResultOptions = {},
  cache: Record<string, any> = {},
): CreateAssetUploadUrlResult {
  const o = (options.__typename ? options : cache["CreateAssetUploadUrlResult"] = {}) as CreateAssetUploadUrlResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CreateAssetUploadUrlResult";
  o.s3Key = options.s3Key ?? "s3Key";
  o.uploadUrl = options.uploadUrl ?? "uploadUrl";
  o.downloadUrl = options.downloadUrl ?? "downloadUrl";
  o.attachmentUrl = options.attachmentUrl ?? "attachmentUrl";
  o.previewUrl = options.previewUrl ?? null;
  return o;
}

factories["CreateAssetUploadUrlResult"] = newCreateAssetUploadUrlResult;

export interface CreateAssetMultipartUploadUrlResultOptions {
  __typename?: "CreateAssetMultipartUploadUrlResult";
  uploadId?: CreateAssetMultipartUploadUrlResult["uploadId"];
  s3Key?: CreateAssetMultipartUploadUrlResult["s3Key"];
  totalParts?: CreateAssetMultipartUploadUrlResult["totalParts"];
  partUploadUrls?: Array<MultipartPartUploadUrl | MultipartPartUploadUrlOptions>;
  expiresAt?: CreateAssetMultipartUploadUrlResult["expiresAt"];
}

export function newCreateAssetMultipartUploadUrlResult(
  options: CreateAssetMultipartUploadUrlResultOptions = {},
  cache: Record<string, any> = {},
): CreateAssetMultipartUploadUrlResult {
  const o =
    (options.__typename
      ? options
      : cache["CreateAssetMultipartUploadUrlResult"] = {}) as CreateAssetMultipartUploadUrlResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CreateAssetMultipartUploadUrlResult";
  o.uploadId = options.uploadId ?? "uploadId";
  o.s3Key = options.s3Key ?? "s3Key";
  o.totalParts = options.totalParts ?? 0;
  o.partUploadUrls = (options.partUploadUrls ?? []).map((i) =>
    maybeNew("MultipartPartUploadUrl", i, cache, options.hasOwnProperty("partUploadUrls"))
  );
  o.expiresAt = options.expiresAt ?? newDateTime();
  return o;
}

factories["CreateAssetMultipartUploadUrlResult"] = newCreateAssetMultipartUploadUrlResult;

export interface MultipartPartUploadUrlOptions {
  __typename?: "MultipartPartUploadUrl";
  partNumber?: MultipartPartUploadUrl["partNumber"];
  uploadUrl?: MultipartPartUploadUrl["uploadUrl"];
}

export function newMultipartPartUploadUrl(
  options: MultipartPartUploadUrlOptions = {},
  cache: Record<string, any> = {},
): MultipartPartUploadUrl {
  const o = (options.__typename ? options : cache["MultipartPartUploadUrl"] = {}) as MultipartPartUploadUrl;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MultipartPartUploadUrl";
  o.partNumber = options.partNumber ?? 0;
  o.uploadUrl = options.uploadUrl ?? "uploadUrl";
  return o;
}

factories["MultipartPartUploadUrl"] = newMultipartPartUploadUrl;

export interface AbortAssetMultipartUploadResultOptions {
  __typename?: "AbortAssetMultipartUploadResult";
  uploadId?: AbortAssetMultipartUploadResult["uploadId"];
  s3Key?: AbortAssetMultipartUploadResult["s3Key"];
}

export function newAbortAssetMultipartUploadResult(
  options: AbortAssetMultipartUploadResultOptions = {},
  cache: Record<string, any> = {},
): AbortAssetMultipartUploadResult {
  const o =
    (options.__typename ? options : cache["AbortAssetMultipartUploadResult"] = {}) as AbortAssetMultipartUploadResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "AbortAssetMultipartUploadResult";
  o.uploadId = options.uploadId ?? "uploadId";
  o.s3Key = options.s3Key ?? "s3Key";
  return o;
}

factories["AbortAssetMultipartUploadResult"] = newAbortAssetMultipartUploadResult;

export interface AssetOptions {
  __typename?: "Asset";
  id?: Asset["id"];
  contentType?: Asset["contentType"];
  downloadUrl?: Asset["downloadUrl"];
  attachmentUrl?: Asset["attachmentUrl"];
  previewUrl?: Asset["previewUrl"];
  url?: Asset["url"];
  fileName?: Asset["fileName"];
  sizeInBytes?: Asset["sizeInBytes"];
  createdAt?: Asset["createdAt"];
  updatedAt?: Asset["updatedAt"];
  version?: Asset["version"];
  s3Key?: Asset["s3Key"];
}

export function newAsset(options: AssetOptions = {}, cache: Record<string, any> = {}): Asset {
  const o = (options.__typename ? options : cache["Asset"] = {}) as Asset;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Asset";
  o.id = options.id ?? nextFactoryId("Asset");
  o.contentType = options.contentType ?? "contentType";
  o.downloadUrl = options.downloadUrl ?? "downloadUrl";
  o.attachmentUrl = options.attachmentUrl ?? "attachmentUrl";
  o.previewUrl = options.previewUrl ?? null;
  o.url = options.url ?? "url";
  o.fileName = options.fileName ?? null;
  o.sizeInBytes = options.sizeInBytes ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.version = options.version ?? "version";
  o.s3Key = options.s3Key ?? "s3Key";
  return o;
}

factories["Asset"] = newAsset;

export interface CreateAssetResultOptions {
  __typename?: "CreateAssetResult";
  asset?: Asset | AssetOptions;
}

export function newCreateAssetResult(
  options: CreateAssetResultOptions = {},
  cache: Record<string, any> = {},
): CreateAssetResult {
  const o = (options.__typename ? options : cache["CreateAssetResult"] = {}) as CreateAssetResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CreateAssetResult";
  o.asset = maybeNew("Asset", options.asset, cache, options.hasOwnProperty("asset"));
  return o;
}

factories["CreateAssetResult"] = newCreateAssetResult;

export interface AttachmentOptions {
  __typename?: "Attachment";
  id?: Attachment["id"];
  createdAt?: Attachment["createdAt"];
  updatedAt?: Attachment["updatedAt"];
  asset?: Asset | AssetOptions;
  parent?:
    | AttachmentParent
    | ChangeRequestOptions
    | RequireTypename<CommentOptions>
    | RequireTypename<GlobalOptionOptions>
    | RequireTypename<ProductOptions>
    | RequireTypename<ProjectSiteConditionOptions>
    | RequireTypename<ScheduleFlagOptions>
    | RequireTypename<ToDoOptions>
    | RequireTypename<TradePartnerAvailabilityRequestEmailOptions>
    | RequireTypename<TradePartnerRequirementOptions>
    | RequireTypename<WarrantyTicketOptions>
    | RequireTypename<WarrantyTicketItemOptions>;
}

export function newAttachment(options: AttachmentOptions = {}, cache: Record<string, any> = {}): Attachment {
  const o = (options.__typename ? options : cache["Attachment"] = {}) as Attachment;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Attachment";
  o.id = options.id ?? nextFactoryId("Attachment");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.asset = maybeNew("Asset", options.asset, cache, options.hasOwnProperty("asset"));
  o.parent = maybeNew(options.parent?.__typename ?? "ChangeRequest", options.parent, cache);
  return o;
}

factories["Attachment"] = newAttachment;

export interface SaveAttachmentResultOptions {
  __typename?: "SaveAttachmentResult";
  attachment?: Attachment | AttachmentOptions;
}

export function newSaveAttachmentResult(
  options: SaveAttachmentResultOptions = {},
  cache: Record<string, any> = {},
): SaveAttachmentResult {
  const o = (options.__typename ? options : cache["SaveAttachmentResult"] = {}) as SaveAttachmentResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveAttachmentResult";
  o.attachment = maybeNew("Attachment", options.attachment, cache, options.hasOwnProperty("attachment"));
  return o;
}

factories["SaveAttachmentResult"] = newSaveAttachmentResult;

export interface DeleteAttachmentResultOptions {
  __typename?: "DeleteAttachmentResult";
  parent?:
    | AttachmentParent
    | ChangeRequestOptions
    | RequireTypename<CommentOptions>
    | RequireTypename<GlobalOptionOptions>
    | RequireTypename<ProductOptions>
    | RequireTypename<ProjectSiteConditionOptions>
    | RequireTypename<ScheduleFlagOptions>
    | RequireTypename<ToDoOptions>
    | RequireTypename<TradePartnerAvailabilityRequestEmailOptions>
    | RequireTypename<TradePartnerRequirementOptions>
    | RequireTypename<WarrantyTicketOptions>
    | RequireTypename<WarrantyTicketItemOptions>
    | null;
}

export function newDeleteAttachmentResult(
  options: DeleteAttachmentResultOptions = {},
  cache: Record<string, any> = {},
): DeleteAttachmentResult {
  const o = (options.__typename ? options : cache["DeleteAttachmentResult"] = {}) as DeleteAttachmentResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeleteAttachmentResult";
  o.parent = maybeNewOrNull(options.parent?.__typename ?? "ChangeRequest", options.parent, cache);
  return o;
}

factories["DeleteAttachmentResult"] = newDeleteAttachmentResult;

export interface DeleteAuditEventsResultOptions {
  __typename?: "DeleteAuditEventsResult";
  results?: Array<DeleteAuditEventResult | DeleteAuditEventResultOptions>;
}

export function newDeleteAuditEventsResult(
  options: DeleteAuditEventsResultOptions = {},
  cache: Record<string, any> = {},
): DeleteAuditEventsResult {
  const o = (options.__typename ? options : cache["DeleteAuditEventsResult"] = {}) as DeleteAuditEventsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeleteAuditEventsResult";
  o.results = (options.results ?? []).map((i) =>
    maybeNew("DeleteAuditEventResult", i, cache, options.hasOwnProperty("results"))
  );
  return o;
}

factories["DeleteAuditEventsResult"] = newDeleteAuditEventsResult;

export interface DeleteAuditEventResultOptions {
  __typename?: "DeleteAuditEventResult";
  table?: DeleteAuditEventResult["table"];
  column?: DeleteAuditEventResult["column"];
  deletedCount?: DeleteAuditEventResult["deletedCount"];
}

export function newDeleteAuditEventResult(
  options: DeleteAuditEventResultOptions = {},
  cache: Record<string, any> = {},
): DeleteAuditEventResult {
  const o = (options.__typename ? options : cache["DeleteAuditEventResult"] = {}) as DeleteAuditEventResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeleteAuditEventResult";
  o.table = options.table ?? "table";
  o.column = options.column ?? "column";
  o.deletedCount = options.deletedCount ?? 0;
  return o;
}

factories["DeleteAuditEventResult"] = newDeleteAuditEventResult;

export interface BidContractOptions {
  __typename?: "BidContract";
  id?: BidContract["id"];
  name?: BidContract["name"];
  blueprintUrl?: Url | UrlOptions;
  displayName?: BidContract["displayName"];
  isPrimary?: BidContract["isPrimary"];
  createdAt?: BidContract["createdAt"];
  updatedAt?: BidContract["updatedAt"];
  tradePartner?: TradePartner | TradePartnerOptions | null;
  revisions?: Array<BidContractRevision | BidContractRevisionOptions>;
  currentRevision?: BidContractRevision | BidContractRevisionOptions;
  latestSignedRevision?: BidContractRevision | BidContractRevisionOptions | null;
  unsignedRevision?: BidContractRevision | BidContractRevisionOptions | null;
  latestRevision?: BidContractRevision | BidContractRevisionOptions;
  isInternalEstimate?: BidContract["isInternalEstimate"];
  developments?: Array<Development | DevelopmentOptions>;
  bidRequest?: BidPackageRequest | BidPackageRequestOptions | null;
  type?: BidContractTypeDetailOptions | BidContractType | null;
  projects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  relevantMarket?: Market | MarketOptions;
  scopeSource?: BidScopeSourceDetailOptions | BidScopeSource | null;
  isProjectLevelBidding?: BidContract["isProjectLevelBidding"];
  internalEstimateBidPackage?: BidPackage | BidPackageOptions | null;
  archivedAt?: BidContract["archivedAt"];
  references?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: BidContract["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: BidContract["isFollowed"];
}

export function newBidContract(options: BidContractOptions = {}, cache: Record<string, any> = {}): BidContract {
  const o = (options.__typename ? options : cache["BidContract"] = {}) as BidContract;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidContract";
  o.id = options.id ?? nextFactoryId("BidContract");
  o.name = options.name ?? "name";
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.displayName = options.displayName ?? "displayName";
  o.isPrimary = options.isPrimary ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.tradePartner = maybeNewOrNull("TradePartner", options.tradePartner, cache);
  o.revisions = (options.revisions ?? []).map((i) =>
    maybeNew("BidContractRevision", i, cache, options.hasOwnProperty("revisions"))
  );
  o.currentRevision = maybeNew(
    "BidContractRevision",
    options.currentRevision,
    cache,
    options.hasOwnProperty("currentRevision"),
  );
  o.latestSignedRevision = maybeNewOrNull("BidContractRevision", options.latestSignedRevision, cache);
  o.unsignedRevision = maybeNewOrNull("BidContractRevision", options.unsignedRevision, cache);
  o.latestRevision = maybeNew(
    "BidContractRevision",
    options.latestRevision,
    cache,
    options.hasOwnProperty("latestRevision"),
  );
  o.isInternalEstimate = options.isInternalEstimate ?? false;
  o.developments = (options.developments ?? []).map((i) =>
    maybeNew("Development", i, cache, options.hasOwnProperty("developments"))
  );
  o.bidRequest = maybeNewOrNull("BidPackageRequest", options.bidRequest, cache);
  o.type = enumOrDetailOrNullOfBidContractType(options.type);
  o.projects = (options.projects ?? []).map((i) => maybeNew("Project", i, cache, options.hasOwnProperty("projects")));
  o.relevantMarket = maybeNew("Market", options.relevantMarket, cache, options.hasOwnProperty("relevantMarket"));
  o.scopeSource = enumOrDetailOrNullOfBidScopeSource(options.scopeSource);
  o.isProjectLevelBidding = options.isProjectLevelBidding ?? false;
  o.internalEstimateBidPackage = maybeNewOrNull("BidPackage", options.internalEstimateBidPackage, cache);
  o.archivedAt = options.archivedAt ?? null;
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  return o;
}

factories["BidContract"] = newBidContract;

export interface SaveBidContractResultOptions {
  __typename?: "SaveBidContractResult";
  bidContract?: BidContract | BidContractOptions;
}

export function newSaveBidContractResult(
  options: SaveBidContractResultOptions = {},
  cache: Record<string, any> = {},
): SaveBidContractResult {
  const o = (options.__typename ? options : cache["SaveBidContractResult"] = {}) as SaveBidContractResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveBidContractResult";
  o.bidContract = maybeNew("BidContract", options.bidContract, cache, options.hasOwnProperty("bidContract"));
  return o;
}

factories["SaveBidContractResult"] = newSaveBidContractResult;

export interface BidContractPotentialItemOptions {
  __typename?: "BidContractPotentialItem";
  item?: Item | ItemOptions;
  templateItemIds?: BidContractPotentialItem["templateItemIds"];
  needsBid?: BidContractPotentialItem["needsBid"];
}

export function newBidContractPotentialItem(
  options: BidContractPotentialItemOptions = {},
  cache: Record<string, any> = {},
): BidContractPotentialItem {
  const o = (options.__typename ? options : cache["BidContractPotentialItem"] = {}) as BidContractPotentialItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidContractPotentialItem";
  o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
  o.templateItemIds = options.templateItemIds ?? [];
  o.needsBid = options.needsBid ?? false;
  return o;
}

factories["BidContractPotentialItem"] = newBidContractPotentialItem;

export interface BidContractsPageOptions {
  __typename?: "BidContractsPage";
  entities?: Array<BidContract | BidContractOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newBidContractsPage(
  options: BidContractsPageOptions = {},
  cache: Record<string, any> = {},
): BidContractsPage {
  const o = (options.__typename ? options : cache["BidContractsPage"] = {}) as BidContractsPage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidContractsPage";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("BidContract", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["BidContractsPage"] = newBidContractsPage;

export interface BidContractLineItemOptions {
  __typename?: "BidContractLineItem";
  id?: BidContractLineItem["id"];
  name?: BidContractLineItem["name"];
  totalCostInCents?: BidContractLineItem["totalCostInCents"];
  unitCostInCents?: BidContractLineItem["unitCostInCents"];
  unitCostInMills?: BidContractLineItem["unitCostInMills"];
  createdAt?: BidContractLineItem["createdAt"];
  updatedAt?: BidContractLineItem["updatedAt"];
  itemTemplateItem?:
    | ItemTemplateItemVersion
    | ItemTemplateItem
    | TakeoffLineItem
    | TakeoffLineItemVersion
    | BaseItemLike
    | BaseItemLikeOptions
    | null;
  revision?: BidContractRevision | BidContractRevisionOptions;
  previousLineItem?: BidContractLineItem | BidContractLineItemOptions | null;
  bidItem?: BidItem | BidItemOptions | null;
  scopeUpdated?: BidContractLineItem["scopeUpdated"];
  ofIti?: BidContractLineItem["ofIti"];
  ofBi?: BidContractLineItem["ofBi"];
  preferredByItemTemplateItems?: Array<
    | ItemTemplateItemVersion
    | ItemTemplateItem
    | TakeoffLineItem
    | TakeoffLineItemVersion
    | BaseItemLike
    | BaseItemLikeOptions
  >;
  potentialUsages?: Array<
    | ItemTemplateItemVersion
    | ItemTemplateItem
    | TakeoffLineItem
    | TakeoffLineItemVersion
    | BaseItemLike
    | BaseItemLikeOptions
  >;
  isTaxExempt?: BidContractLineItem["isTaxExempt"];
  tradeLineItem?: BidContractTradeLineItem | BidContractTradeLineItemOptions | null;
}

export function newBidContractLineItem(
  options: BidContractLineItemOptions = {},
  cache: Record<string, any> = {},
): BidContractLineItem {
  const o = (options.__typename ? options : cache["BidContractLineItem"] = {}) as BidContractLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidContractLineItem";
  o.id = options.id ?? nextFactoryId("BidContractLineItem");
  o.name = options.name ?? "name";
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.unitCostInCents = options.unitCostInCents ?? 0;
  o.unitCostInMills = options.unitCostInMills ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.itemTemplateItem = maybeNewOrNull("BaseItemLike", options.itemTemplateItem, cache);
  o.revision = maybeNew("BidContractRevision", options.revision, cache, options.hasOwnProperty("revision"));
  o.previousLineItem = maybeNewOrNull("BidContractLineItem", options.previousLineItem, cache);
  o.bidItem = maybeNewOrNull("BidItem", options.bidItem, cache);
  o.scopeUpdated = options.scopeUpdated ?? false;
  o.ofIti = options.ofIti ?? false;
  o.ofBi = options.ofBi ?? false;
  o.preferredByItemTemplateItems = (options.preferredByItemTemplateItems ?? []).map((i) =>
    maybeNew("BaseItemLike", i, cache, options.hasOwnProperty("preferredByItemTemplateItems"))
  );
  o.potentialUsages = (options.potentialUsages ?? []).map((i) =>
    maybeNew("BaseItemLike", i, cache, options.hasOwnProperty("potentialUsages"))
  );
  o.isTaxExempt = options.isTaxExempt ?? false;
  o.tradeLineItem = maybeNewOrNull("BidContractTradeLineItem", options.tradeLineItem, cache);
  return o;
}

factories["BidContractLineItem"] = newBidContractLineItem;

export interface SaveBidContractLineItemResultOptions {
  __typename?: "SaveBidContractLineItemResult";
  bidContractLineItem?: BidContractLineItem | BidContractLineItemOptions;
}

export function newSaveBidContractLineItemResult(
  options: SaveBidContractLineItemResultOptions = {},
  cache: Record<string, any> = {},
): SaveBidContractLineItemResult {
  const o =
    (options.__typename ? options : cache["SaveBidContractLineItemResult"] = {}) as SaveBidContractLineItemResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveBidContractLineItemResult";
  o.bidContractLineItem = maybeNew(
    "BidContractLineItem",
    options.bidContractLineItem,
    cache,
    options.hasOwnProperty("bidContractLineItem"),
  );
  return o;
}

factories["SaveBidContractLineItemResult"] = newSaveBidContractLineItemResult;

export interface SaveBidContractLineItemsResultOptions {
  __typename?: "SaveBidContractLineItemsResult";
  bidContractRevision?: BidContractRevision | BidContractRevisionOptions;
}

export function newSaveBidContractLineItemsResult(
  options: SaveBidContractLineItemsResultOptions = {},
  cache: Record<string, any> = {},
): SaveBidContractLineItemsResult {
  const o =
    (options.__typename ? options : cache["SaveBidContractLineItemsResult"] = {}) as SaveBidContractLineItemsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveBidContractLineItemsResult";
  o.bidContractRevision = maybeNew(
    "BidContractRevision",
    options.bidContractRevision,
    cache,
    options.hasOwnProperty("bidContractRevision"),
  );
  return o;
}

factories["SaveBidContractLineItemsResult"] = newSaveBidContractLineItemsResult;

export interface DeleteBidContractLineItemResultOptions {
  __typename?: "DeleteBidContractLineItemResult";
  bidContractRevision?: BidContractRevision | BidContractRevisionOptions;
}

export function newDeleteBidContractLineItemResult(
  options: DeleteBidContractLineItemResultOptions = {},
  cache: Record<string, any> = {},
): DeleteBidContractLineItemResult {
  const o =
    (options.__typename ? options : cache["DeleteBidContractLineItemResult"] = {}) as DeleteBidContractLineItemResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeleteBidContractLineItemResult";
  o.bidContractRevision = maybeNew(
    "BidContractRevision",
    options.bidContractRevision,
    cache,
    options.hasOwnProperty("bidContractRevision"),
  );
  return o;
}

factories["DeleteBidContractLineItemResult"] = newDeleteBidContractLineItemResult;

export interface BidContractLineItemsPageResultOptions {
  __typename?: "BidContractLineItemsPageResult";
  entities?: Array<BidContractLineItem | BidContractLineItemOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newBidContractLineItemsPageResult(
  options: BidContractLineItemsPageResultOptions = {},
  cache: Record<string, any> = {},
): BidContractLineItemsPageResult {
  const o =
    (options.__typename ? options : cache["BidContractLineItemsPageResult"] = {}) as BidContractLineItemsPageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidContractLineItemsPageResult";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("BidContractLineItem", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["BidContractLineItemsPageResult"] = newBidContractLineItemsPageResult;

export interface BidContractRevisionOptions {
  __typename?: "BidContractRevision";
  id?: BidContractRevision["id"];
  displayName?: BidContractRevision["displayName"];
  version?: BidContractRevision["version"];
  createdAt?: BidContractRevision["createdAt"];
  updatedAt?: BidContractRevision["updatedAt"];
  status?: BidContractRevisionStatusDetailOptions | BidContractRevisionStatus;
  bidContract?: BidContract | BidContractOptions;
  lineItems?: Array<BidContractLineItem | BidContractLineItemOptions>;
  canEdit?: PotentialOperation2 | PotentialOperation2Options;
  costCodes?: Array<CostCode | CostCodeOptions>;
  costCodeAwards?: Array<CostCodeAward | CostCodeAwardOptions>;
  pandaDocRecipients?: Array<PandaDocIntendedRecipient | PandaDocIntendedRecipientOptions>;
  pandaDoc?: PandaDoc | PandaDocOptions | null;
  document?: Document | DocumentOptions | null;
  canCreatePandaDoc?: PotentialOperation2 | PotentialOperation2Options;
  canDelete?: PotentialOperation2 | PotentialOperation2Options;
  startDate?: BidContractRevision["startDate"];
  endDate?: BidContractRevision["endDate"];
  isEffective?: BidContractRevision["isEffective"];
  commitments?: Array<Commitment | CommitmentOptions>;
  blueprintUrl?: Url | UrlOptions;
  hasOutdatedScope?: BidContractRevision["hasOutdatedScope"];
  sourceForApprovals?: Array<Approval | ApprovalOptions>;
  tradeSignatory?: TradePartnerContact | TradePartnerContactOptions | null;
  potentialProjectItems?: Array<PotentialProjectItem | PotentialProjectItemOptions>;
  itemTemplateCostUpdates?: Array<ItemTemplateCostUpdate | ItemTemplateCostUpdateOptions>;
  signedOn?: BidContractRevision["signedOn"];
  internalNote?: BidContractRevision["internalNote"];
  tradeLineItems?: Array<BidContractTradeLineItem | BidContractTradeLineItemOptions>;
  hasValidTradeCosts?: BidContractRevision["hasValidTradeCosts"];
  draws?: Array<BidContractRevisionDraw | BidContractRevisionDrawOptions>;
  canAddDraws?: PotentialOperation2 | PotentialOperation2Options;
  primaryRevisionBidPackageAwards?: Array<BidPackageAward | BidPackageAwardOptions>;
  bidPackageVersion?: BidPackageVersion | BidPackageVersionOptions | null;
  hasValidDrawTasks?: BidContractRevision["hasValidDrawTasks"];
  hasAwardedBidPackageVersion?: BidContractRevision["hasAwardedBidPackageVersion"];
}

export function newBidContractRevision(
  options: BidContractRevisionOptions = {},
  cache: Record<string, any> = {},
): BidContractRevision {
  const o = (options.__typename ? options : cache["BidContractRevision"] = {}) as BidContractRevision;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidContractRevision";
  o.id = options.id ?? nextFactoryId("BidContractRevision");
  o.displayName = options.displayName ?? "displayName";
  o.version = options.version ?? "version";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.status = enumOrDetailOfBidContractRevisionStatus(options.status);
  o.bidContract = maybeNew("BidContract", options.bidContract, cache, options.hasOwnProperty("bidContract"));
  o.lineItems = (options.lineItems ?? []).map((i) =>
    maybeNew("BidContractLineItem", i, cache, options.hasOwnProperty("lineItems"))
  );
  o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
  o.costCodes = (options.costCodes ?? []).map((i) =>
    maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
  );
  o.costCodeAwards = (options.costCodeAwards ?? []).map((i) =>
    maybeNew("CostCodeAward", i, cache, options.hasOwnProperty("costCodeAwards"))
  );
  o.pandaDocRecipients = (options.pandaDocRecipients ?? []).map((i) =>
    maybeNew("PandaDocIntendedRecipient", i, cache, options.hasOwnProperty("pandaDocRecipients"))
  );
  o.pandaDoc = maybeNewOrNull("PandaDoc", options.pandaDoc, cache);
  o.document = maybeNewOrNull("Document", options.document, cache);
  o.canCreatePandaDoc = maybeNew(
    "PotentialOperation2",
    options.canCreatePandaDoc,
    cache,
    options.hasOwnProperty("canCreatePandaDoc"),
  );
  o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
  o.startDate = options.startDate ?? newDate();
  o.endDate = options.endDate ?? null;
  o.isEffective = options.isEffective ?? false;
  o.commitments = (options.commitments ?? []).map((i) =>
    maybeNew("Commitment", i, cache, options.hasOwnProperty("commitments"))
  );
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.hasOutdatedScope = options.hasOutdatedScope ?? false;
  o.sourceForApprovals = (options.sourceForApprovals ?? []).map((i) =>
    maybeNew("Approval", i, cache, options.hasOwnProperty("sourceForApprovals"))
  );
  o.tradeSignatory = maybeNewOrNull("TradePartnerContact", options.tradeSignatory, cache);
  o.potentialProjectItems = (options.potentialProjectItems ?? []).map((i) =>
    maybeNew("PotentialProjectItem", i, cache, options.hasOwnProperty("potentialProjectItems"))
  );
  o.itemTemplateCostUpdates = (options.itemTemplateCostUpdates ?? []).map((i) =>
    maybeNew("ItemTemplateCostUpdate", i, cache, options.hasOwnProperty("itemTemplateCostUpdates"))
  );
  o.signedOn = options.signedOn ?? null;
  o.internalNote = options.internalNote ?? null;
  o.tradeLineItems = (options.tradeLineItems ?? []).map((i) =>
    maybeNew("BidContractTradeLineItem", i, cache, options.hasOwnProperty("tradeLineItems"))
  );
  o.hasValidTradeCosts = options.hasValidTradeCosts ?? false;
  o.draws = (options.draws ?? []).map((i) =>
    maybeNew("BidContractRevisionDraw", i, cache, options.hasOwnProperty("draws"))
  );
  o.canAddDraws = maybeNew("PotentialOperation2", options.canAddDraws, cache, options.hasOwnProperty("canAddDraws"));
  o.primaryRevisionBidPackageAwards = (options.primaryRevisionBidPackageAwards ?? []).map((i) =>
    maybeNew("BidPackageAward", i, cache, options.hasOwnProperty("primaryRevisionBidPackageAwards"))
  );
  o.bidPackageVersion = maybeNewOrNull("BidPackageVersion", options.bidPackageVersion, cache);
  o.hasValidDrawTasks = options.hasValidDrawTasks ?? false;
  o.hasAwardedBidPackageVersion = options.hasAwardedBidPackageVersion ?? false;
  return o;
}

factories["BidContractRevision"] = newBidContractRevision;

export interface SaveBidContractRevisionResultOptions {
  __typename?: "SaveBidContractRevisionResult";
  bidContractRevision?: BidContractRevision | BidContractRevisionOptions;
}

export function newSaveBidContractRevisionResult(
  options: SaveBidContractRevisionResultOptions = {},
  cache: Record<string, any> = {},
): SaveBidContractRevisionResult {
  const o =
    (options.__typename ? options : cache["SaveBidContractRevisionResult"] = {}) as SaveBidContractRevisionResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveBidContractRevisionResult";
  o.bidContractRevision = maybeNew(
    "BidContractRevision",
    options.bidContractRevision,
    cache,
    options.hasOwnProperty("bidContractRevision"),
  );
  return o;
}

factories["SaveBidContractRevisionResult"] = newSaveBidContractRevisionResult;

export interface PandaDocIntendedRecipientOptions {
  __typename?: "PandaDocIntendedRecipient";
  name?: PandaDocIntendedRecipient["name"];
  email?: PandaDocIntendedRecipient["email"];
  role?: PandaDocIntendedRecipient["role"];
  tradePartnerContact?: TradePartnerContact | TradePartnerContactOptions | null;
  user?: User | UserOptions | null;
  signingOrder?: PandaDocIntendedRecipient["signingOrder"];
}

export function newPandaDocIntendedRecipient(
  options: PandaDocIntendedRecipientOptions = {},
  cache: Record<string, any> = {},
): PandaDocIntendedRecipient {
  const o = (options.__typename ? options : cache["PandaDocIntendedRecipient"] = {}) as PandaDocIntendedRecipient;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PandaDocIntendedRecipient";
  o.name = options.name ?? "name";
  o.email = options.email ?? "email";
  o.role = options.role ?? PandaDocRole.User;
  o.tradePartnerContact = maybeNewOrNull("TradePartnerContact", options.tradePartnerContact, cache);
  o.user = maybeNewOrNull("User", options.user, cache);
  o.signingOrder = options.signingOrder ?? null;
  return o;
}

factories["PandaDocIntendedRecipient"] = newPandaDocIntendedRecipient;

export interface PotentialProjectItemOptions {
  __typename?: "PotentialProjectItem";
  projectItem?: ProjectItem | ProjectItemOptions;
  totalCostInCents?: PotentialProjectItem["totalCostInCents"];
}

export function newPotentialProjectItem(
  options: PotentialProjectItemOptions = {},
  cache: Record<string, any> = {},
): PotentialProjectItem {
  const o = (options.__typename ? options : cache["PotentialProjectItem"] = {}) as PotentialProjectItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PotentialProjectItem";
  o.projectItem = maybeNew("ProjectItem", options.projectItem, cache, options.hasOwnProperty("projectItem"));
  o.totalCostInCents = options.totalCostInCents ?? 0;
  return o;
}

factories["PotentialProjectItem"] = newPotentialProjectItem;

export interface CostCodeAwardOptions {
  __typename?: "CostCodeAward";
  costCode?: CostCode | CostCodeOptions;
  isPrimary?: CostCodeAward["isPrimary"];
  isSecondary?: CostCodeAward["isSecondary"];
}

export function newCostCodeAward(options: CostCodeAwardOptions = {}, cache: Record<string, any> = {}): CostCodeAward {
  const o = (options.__typename ? options : cache["CostCodeAward"] = {}) as CostCodeAward;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CostCodeAward";
  o.costCode = maybeNew("CostCode", options.costCode, cache, options.hasOwnProperty("costCode"));
  o.isPrimary = options.isPrimary ?? false;
  o.isSecondary = options.isSecondary ?? false;
  return o;
}

factories["CostCodeAward"] = newCostCodeAward;

export interface BidContractRevisionDrawOptions {
  __typename?: "BidContractRevisionDraw";
  id?: BidContractRevisionDraw["id"];
  amountInBasisPoints?: BidContractRevisionDraw["amountInBasisPoints"];
  isDeposit?: BidContractRevisionDraw["isDeposit"];
  description?: BidContractRevisionDraw["description"];
  createdAt?: BidContractRevisionDraw["createdAt"];
  updatedAt?: BidContractRevisionDraw["updatedAt"];
  bidContractRevision?: BidContractRevision | BidContractRevisionOptions;
  globalPlanTask?: GlobalPlanTask | GlobalPlanTaskOptions | null;
  canEdit?: PotentialOperation2 | PotentialOperation2Options;
}

export function newBidContractRevisionDraw(
  options: BidContractRevisionDrawOptions = {},
  cache: Record<string, any> = {},
): BidContractRevisionDraw {
  const o = (options.__typename ? options : cache["BidContractRevisionDraw"] = {}) as BidContractRevisionDraw;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidContractRevisionDraw";
  o.id = options.id ?? nextFactoryId("BidContractRevisionDraw");
  o.amountInBasisPoints = options.amountInBasisPoints ?? 0;
  o.isDeposit = options.isDeposit ?? false;
  o.description = options.description ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.bidContractRevision = maybeNew(
    "BidContractRevision",
    options.bidContractRevision,
    cache,
    options.hasOwnProperty("bidContractRevision"),
  );
  o.globalPlanTask = maybeNewOrNull("GlobalPlanTask", options.globalPlanTask, cache);
  o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
  return o;
}

factories["BidContractRevisionDraw"] = newBidContractRevisionDraw;

export interface BidContractTradeLineItemOptions {
  __typename?: "BidContractTradeLineItem";
  id?: BidContractTradeLineItem["id"];
  totalCostInCents?: BidContractTradeLineItem["totalCostInCents"];
  createdAt?: BidContractTradeLineItem["createdAt"];
  updatedAt?: BidContractTradeLineItem["updatedAt"];
  revision?: BidContractRevision | BidContractRevisionOptions;
  productOffering?: ProductOffering | ProductOfferingOptions;
  options?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  hasValidCost?: BidContractTradeLineItem["hasValidCost"];
  lineItems?: Array<BidContractLineItem | BidContractLineItemOptions>;
}

export function newBidContractTradeLineItem(
  options: BidContractTradeLineItemOptions = {},
  cache: Record<string, any> = {},
): BidContractTradeLineItem {
  const o = (options.__typename ? options : cache["BidContractTradeLineItem"] = {}) as BidContractTradeLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidContractTradeLineItem";
  o.id = options.id ?? nextFactoryId("BidContractTradeLineItem");
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.revision = maybeNew("BidContractRevision", options.revision, cache, options.hasOwnProperty("revision"));
  o.productOffering = maybeNew(
    "ProductOffering",
    options.productOffering,
    cache,
    options.hasOwnProperty("productOffering"),
  );
  o.options = (options.options ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("options"))
  );
  o.hasValidCost = options.hasValidCost ?? false;
  o.lineItems = (options.lineItems ?? []).map((i) =>
    maybeNew("BidContractLineItem", i, cache, options.hasOwnProperty("lineItems"))
  );
  return o;
}

factories["BidContractTradeLineItem"] = newBidContractTradeLineItem;

export interface SaveBidContractTradeLineItemsResultOptions {
  __typename?: "SaveBidContractTradeLineItemsResult";
  bidContractTradeLineItems?: Array<BidContractTradeLineItem | BidContractTradeLineItemOptions>;
}

export function newSaveBidContractTradeLineItemsResult(
  options: SaveBidContractTradeLineItemsResultOptions = {},
  cache: Record<string, any> = {},
): SaveBidContractTradeLineItemsResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveBidContractTradeLineItemsResult"] = {}) as SaveBidContractTradeLineItemsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveBidContractTradeLineItemsResult";
  o.bidContractTradeLineItems = (options.bidContractTradeLineItems ?? []).map((i) =>
    maybeNew("BidContractTradeLineItem", i, cache, options.hasOwnProperty("bidContractTradeLineItems"))
  );
  return o;
}

factories["SaveBidContractTradeLineItemsResult"] = newSaveBidContractTradeLineItemsResult;

export interface BidItemOptions {
  __typename?: "BidItem";
  id?: BidItem["id"];
  name?: BidItem["name"];
  code?: BidItem["code"];
  displayName?: BidItem["displayName"];
  createdAt?: BidItem["createdAt"];
  updatedAt?: BidItem["updatedAt"];
  costType?: CostTypeDetailOptions | CostType;
  unitOfMeasure?: UnitOfMeasure | UnitOfMeasureOptions;
  items?: Array<Item | ItemOptions>;
  products?: Array<Product | ProductOptions>;
  bidContractLineItems?: Array<BidContractLineItem | BidContractLineItemOptions>;
  blueprintUrl?: Url | UrlOptions;
  parentMaterialVariant?: MaterialVariant | MaterialVariantOptions | null;
  parentTask?: GlobalPlanTask | GlobalPlanTaskOptions | null;
  estimates?: Array<BidItemEstimate | BidItemEstimateOptions>;
  references?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: BidItem["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: BidItem["isFollowed"];
}

export function newBidItem(options: BidItemOptions = {}, cache: Record<string, any> = {}): BidItem {
  const o = (options.__typename ? options : cache["BidItem"] = {}) as BidItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidItem";
  o.id = options.id ?? nextFactoryId("BidItem");
  o.name = options.name ?? "name";
  o.code = options.code ?? "code";
  o.displayName = options.displayName ?? "displayName";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.costType = enumOrDetailOfCostType(options.costType);
  o.unitOfMeasure = maybeNew("UnitOfMeasure", options.unitOfMeasure, cache, options.hasOwnProperty("unitOfMeasure"));
  o.items = (options.items ?? []).map((i) => maybeNew("Item", i, cache, options.hasOwnProperty("items")));
  o.products = (options.products ?? []).map((i) => maybeNew("Product", i, cache, options.hasOwnProperty("products")));
  o.bidContractLineItems = (options.bidContractLineItems ?? []).map((i) =>
    maybeNew("BidContractLineItem", i, cache, options.hasOwnProperty("bidContractLineItems"))
  );
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.parentMaterialVariant = maybeNewOrNull("MaterialVariant", options.parentMaterialVariant, cache);
  o.parentTask = maybeNewOrNull("GlobalPlanTask", options.parentTask, cache);
  o.estimates = (options.estimates ?? []).map((i) =>
    maybeNew("BidItemEstimate", i, cache, options.hasOwnProperty("estimates"))
  );
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  return o;
}

factories["BidItem"] = newBidItem;

export interface BidItemsPageOptions {
  __typename?: "BidItemsPage";
  bidItems?: Array<BidItem | BidItemOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newBidItemsPage(options: BidItemsPageOptions = {}, cache: Record<string, any> = {}): BidItemsPage {
  const o = (options.__typename ? options : cache["BidItemsPage"] = {}) as BidItemsPage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidItemsPage";
  o.bidItems = (options.bidItems ?? []).map((i) => maybeNew("BidItem", i, cache, options.hasOwnProperty("bidItems")));
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["BidItemsPage"] = newBidItemsPage;

export interface SaveBidItemResultOptions {
  __typename?: "SaveBidItemResult";
  bidItem?: BidItem | BidItemOptions;
}

export function newSaveBidItemResult(
  options: SaveBidItemResultOptions = {},
  cache: Record<string, any> = {},
): SaveBidItemResult {
  const o = (options.__typename ? options : cache["SaveBidItemResult"] = {}) as SaveBidItemResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveBidItemResult";
  o.bidItem = maybeNew("BidItem", options.bidItem, cache, options.hasOwnProperty("bidItem"));
  return o;
}

factories["SaveBidItemResult"] = newSaveBidItemResult;

export interface BidItemEstimateOptions {
  __typename?: "BidItemEstimate";
  id?: BidItemEstimate["id"];
  costInMills?: BidItemEstimate["costInMills"];
  sourceUrl?: BidItemEstimate["sourceUrl"];
  createdAt?: BidItemEstimate["createdAt"];
  updatedAt?: BidItemEstimate["updatedAt"];
  bidItem?: BidItem | BidItemOptions;
  createdBy?: User | UserOptions;
  markets?: Array<Market | MarketOptions>;
}

export function newBidItemEstimate(
  options: BidItemEstimateOptions = {},
  cache: Record<string, any> = {},
): BidItemEstimate {
  const o = (options.__typename ? options : cache["BidItemEstimate"] = {}) as BidItemEstimate;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidItemEstimate";
  o.id = options.id ?? nextFactoryId("BidItemEstimate");
  o.costInMills = options.costInMills ?? 0;
  o.sourceUrl = options.sourceUrl ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.bidItem = maybeNew("BidItem", options.bidItem, cache, options.hasOwnProperty("bidItem"));
  o.createdBy = maybeNew("User", options.createdBy, cache, options.hasOwnProperty("createdBy"));
  o.markets = (options.markets ?? []).map((i) => maybeNew("Market", i, cache, options.hasOwnProperty("markets")));
  return o;
}

factories["BidItemEstimate"] = newBidItemEstimate;

export interface SaveBidItemEstimateResultOptions {
  __typename?: "SaveBidItemEstimateResult";
  bidItemEstimate?: BidItemEstimate | BidItemEstimateOptions;
}

export function newSaveBidItemEstimateResult(
  options: SaveBidItemEstimateResultOptions = {},
  cache: Record<string, any> = {},
): SaveBidItemEstimateResult {
  const o = (options.__typename ? options : cache["SaveBidItemEstimateResult"] = {}) as SaveBidItemEstimateResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveBidItemEstimateResult";
  o.bidItemEstimate = maybeNew(
    "BidItemEstimate",
    options.bidItemEstimate,
    cache,
    options.hasOwnProperty("bidItemEstimate"),
  );
  return o;
}

factories["SaveBidItemEstimateResult"] = newSaveBidItemEstimateResult;

export interface BidItemEstimatesPageResultOptions {
  __typename?: "BidItemEstimatesPageResult";
  entities?: Array<BidItemEstimate | BidItemEstimateOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newBidItemEstimatesPageResult(
  options: BidItemEstimatesPageResultOptions = {},
  cache: Record<string, any> = {},
): BidItemEstimatesPageResult {
  const o = (options.__typename ? options : cache["BidItemEstimatesPageResult"] = {}) as BidItemEstimatesPageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidItemEstimatesPageResult";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("BidItemEstimate", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["BidItemEstimatesPageResult"] = newBidItemEstimatesPageResult;

export interface BidPackageOptions {
  __typename?: "BidPackage";
  id?: BidPackage["id"];
  name?: BidPackage["name"];
  costCodesName?: BidPackage["costCodesName"];
  planRoomLink?: BidPackage["planRoomLink"];
  invitationText?: BidPackage["invitationText"];
  bidInstructionsText?: BidPackage["bidInstructionsText"];
  existingInvitationText?: BidPackage["existingInvitationText"];
  dueDate?: BidPackage["dueDate"];
  estimatedAwardDate?: BidPackage["estimatedAwardDate"];
  estimatedConstructionDate?: BidPackage["estimatedConstructionDate"];
  sendReminderDate?: BidPackage["sendReminderDate"];
  createdAt?: BidPackage["createdAt"];
  updatedAt?: BidPackage["updatedAt"];
  productOfferings?: Array<ProductOffering | ProductOfferingOptions>;
  status?: BidPackageStatusDetailOptions | BidPackageStatus;
  lineItems?: Array<BidPackageLineItem | BidPackageLineItemOptions>;
  requests?: Array<BidPackageRequest | BidPackageRequestOptions>;
  potentialBidPackageLineItems?: Array<BidItem | BidItemOptions>;
  bidPackageGroup?: BidPackageGroup | BidPackageGroupOptions | null;
  scopeLines?: Array<BidPackageScopeLine | BidPackageScopeLineOptions>;
  awards?: Array<BidPackageAward | BidPackageAwardOptions>;
  isHistoricalBid?: BidPackage["isHistoricalBid"];
  costCodes?: Array<CostCode | CostCodeOptions>;
  costType?: CostTypeDetailOptions | CostType;
  basePlanGlobalPlanTasks?: Array<GlobalPlanTask | GlobalPlanTaskOptions>;
  isUnitBased?: BidPackage["isUnitBased"];
  versions?: Array<BidPackageVersion | BidPackageVersionOptions>;
  latestVersion?: BidPackageVersion | BidPackageVersionOptions;
  canComplete?: PotentialOperation2 | PotentialOperation2Options;
  versionNotes?: BidPackage["versionNotes"];
  availableUpdates?: Array<BidPackageIncomingUpdate | BidPackageIncomingUpdateOptions>;
  activeRequests?: Array<BidPackageRequest | BidPackageRequestOptions>;
  scopeHasChanged?: BidPackage["scopeHasChanged"];
  canDelete?: PotentialOperation2 | PotentialOperation2Options;
  projects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  relevantMarket?: Market | MarketOptions;
  primaryHomeboundUser?: User | UserOptions | null;
  secondaryHomeboundUsers?: Array<User | UserOptions>;
  overlappingBidPackages?: Array<BidPackage | BidPackageOptions>;
  latestAwards?: Array<BidPackageAward | BidPackageAwardOptions>;
  scopeSource?: BidScopeSourceDetailOptions | BidScopeSource;
  isProjectLevelBidding?: BidPackage["isProjectLevelBidding"];
  isInternalEstimate?: BidPackage["isInternalEstimate"];
  internalEstimateBidContract?: BidContract | BidContractOptions | null;
  archivedAt?: BidPackage["archivedAt"];
}

export function newBidPackage(options: BidPackageOptions = {}, cache: Record<string, any> = {}): BidPackage {
  const o = (options.__typename ? options : cache["BidPackage"] = {}) as BidPackage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidPackage";
  o.id = options.id ?? nextFactoryId("BidPackage");
  o.name = options.name ?? "name";
  o.costCodesName = options.costCodesName ?? "costCodesName";
  o.planRoomLink = options.planRoomLink ?? null;
  o.invitationText = options.invitationText ?? null;
  o.bidInstructionsText = options.bidInstructionsText ?? null;
  o.existingInvitationText = options.existingInvitationText ?? null;
  o.dueDate = options.dueDate ?? null;
  o.estimatedAwardDate = options.estimatedAwardDate ?? null;
  o.estimatedConstructionDate = options.estimatedConstructionDate ?? null;
  o.sendReminderDate = options.sendReminderDate ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.productOfferings = (options.productOfferings ?? []).map((i) =>
    maybeNew("ProductOffering", i, cache, options.hasOwnProperty("productOfferings"))
  );
  o.status = enumOrDetailOfBidPackageStatus(options.status);
  o.lineItems = (options.lineItems ?? []).map((i) =>
    maybeNew("BidPackageLineItem", i, cache, options.hasOwnProperty("lineItems"))
  );
  o.requests = (options.requests ?? []).map((i) =>
    maybeNew("BidPackageRequest", i, cache, options.hasOwnProperty("requests"))
  );
  o.potentialBidPackageLineItems = (options.potentialBidPackageLineItems ?? []).map((i) =>
    maybeNew("BidItem", i, cache, options.hasOwnProperty("potentialBidPackageLineItems"))
  );
  o.bidPackageGroup = maybeNewOrNull("BidPackageGroup", options.bidPackageGroup, cache);
  o.scopeLines = (options.scopeLines ?? []).map((i) =>
    maybeNew("BidPackageScopeLine", i, cache, options.hasOwnProperty("scopeLines"))
  );
  o.awards = (options.awards ?? []).map((i) => maybeNew("BidPackageAward", i, cache, options.hasOwnProperty("awards")));
  o.isHistoricalBid = options.isHistoricalBid ?? false;
  o.costCodes = (options.costCodes ?? []).map((i) =>
    maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
  );
  o.costType = enumOrDetailOfCostType(options.costType);
  o.basePlanGlobalPlanTasks = (options.basePlanGlobalPlanTasks ?? []).map((i) =>
    maybeNew("GlobalPlanTask", i, cache, options.hasOwnProperty("basePlanGlobalPlanTasks"))
  );
  o.isUnitBased = options.isUnitBased ?? false;
  o.versions = (options.versions ?? []).map((i) =>
    maybeNew("BidPackageVersion", i, cache, options.hasOwnProperty("versions"))
  );
  o.latestVersion = maybeNew(
    "BidPackageVersion",
    options.latestVersion,
    cache,
    options.hasOwnProperty("latestVersion"),
  );
  o.canComplete = maybeNew("PotentialOperation2", options.canComplete, cache, options.hasOwnProperty("canComplete"));
  o.versionNotes = options.versionNotes ?? null;
  o.availableUpdates = (options.availableUpdates ?? []).map((i) =>
    maybeNew("BidPackageIncomingUpdate", i, cache, options.hasOwnProperty("availableUpdates"))
  );
  o.activeRequests = (options.activeRequests ?? []).map((i) =>
    maybeNew("BidPackageRequest", i, cache, options.hasOwnProperty("activeRequests"))
  );
  o.scopeHasChanged = options.scopeHasChanged ?? false;
  o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
  o.projects = (options.projects ?? []).map((i) => maybeNew("Project", i, cache, options.hasOwnProperty("projects")));
  o.relevantMarket = maybeNew("Market", options.relevantMarket, cache, options.hasOwnProperty("relevantMarket"));
  o.primaryHomeboundUser = maybeNewOrNull("User", options.primaryHomeboundUser, cache);
  o.secondaryHomeboundUsers = (options.secondaryHomeboundUsers ?? []).map((i) =>
    maybeNew("User", i, cache, options.hasOwnProperty("secondaryHomeboundUsers"))
  );
  o.overlappingBidPackages = (options.overlappingBidPackages ?? []).map((i) =>
    maybeNew("BidPackage", i, cache, options.hasOwnProperty("overlappingBidPackages"))
  );
  o.latestAwards = (options.latestAwards ?? []).map((i) =>
    maybeNew("BidPackageAward", i, cache, options.hasOwnProperty("latestAwards"))
  );
  o.scopeSource = enumOrDetailOfBidScopeSource(options.scopeSource);
  o.isProjectLevelBidding = options.isProjectLevelBidding ?? false;
  o.isInternalEstimate = options.isInternalEstimate ?? false;
  o.internalEstimateBidContract = maybeNewOrNull("BidContract", options.internalEstimateBidContract, cache);
  o.archivedAt = options.archivedAt ?? null;
  return o;
}

factories["BidPackage"] = newBidPackage;

export interface BidPackageScopeLineOptions {
  __typename?: "BidPackageScopeLine";
  takeoffLineItemVersion?: TakeoffLineItemVersion | TakeoffLineItemVersionOptions;
  changeType?: BidPackageScopeLine["changeType"];
  previous?: TakeoffLineItemVersion | TakeoffLineItemVersionOptions | null;
}

export function newBidPackageScopeLine(
  options: BidPackageScopeLineOptions = {},
  cache: Record<string, any> = {},
): BidPackageScopeLine {
  const o = (options.__typename ? options : cache["BidPackageScopeLine"] = {}) as BidPackageScopeLine;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidPackageScopeLine";
  o.takeoffLineItemVersion = maybeNew(
    "TakeoffLineItemVersion",
    options.takeoffLineItemVersion,
    cache,
    options.hasOwnProperty("takeoffLineItemVersion"),
  );
  o.changeType = options.changeType ?? null;
  o.previous = maybeNewOrNull("TakeoffLineItemVersion", options.previous, cache);
  return o;
}

factories["BidPackageScopeLine"] = newBidPackageScopeLine;

export interface SaveBidPackageResultOptions {
  __typename?: "SaveBidPackageResult";
  bidPackage?: BidPackage | BidPackageOptions;
}

export function newSaveBidPackageResult(
  options: SaveBidPackageResultOptions = {},
  cache: Record<string, any> = {},
): SaveBidPackageResult {
  const o = (options.__typename ? options : cache["SaveBidPackageResult"] = {}) as SaveBidPackageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveBidPackageResult";
  o.bidPackage = maybeNew("BidPackage", options.bidPackage, cache, options.hasOwnProperty("bidPackage"));
  return o;
}

factories["SaveBidPackageResult"] = newSaveBidPackageResult;

export interface SaveBidPackagesResultOptions {
  __typename?: "SaveBidPackagesResult";
  bidPackages?: Array<BidPackage | BidPackageOptions>;
}

export function newSaveBidPackagesResult(
  options: SaveBidPackagesResultOptions = {},
  cache: Record<string, any> = {},
): SaveBidPackagesResult {
  const o = (options.__typename ? options : cache["SaveBidPackagesResult"] = {}) as SaveBidPackagesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveBidPackagesResult";
  o.bidPackages = (options.bidPackages ?? []).map((i) =>
    maybeNew("BidPackage", i, cache, options.hasOwnProperty("bidPackages"))
  );
  return o;
}

factories["SaveBidPackagesResult"] = newSaveBidPackagesResult;

export interface OverlappingBidPackagesResultOptions {
  __typename?: "OverlappingBidPackagesResult";
  bidPackages?: Array<BidPackage | BidPackageOptions>;
}

export function newOverlappingBidPackagesResult(
  options: OverlappingBidPackagesResultOptions = {},
  cache: Record<string, any> = {},
): OverlappingBidPackagesResult {
  const o = (options.__typename ? options : cache["OverlappingBidPackagesResult"] = {}) as OverlappingBidPackagesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "OverlappingBidPackagesResult";
  o.bidPackages = (options.bidPackages ?? []).map((i) =>
    maybeNew("BidPackage", i, cache, options.hasOwnProperty("bidPackages"))
  );
  return o;
}

factories["OverlappingBidPackagesResult"] = newOverlappingBidPackagesResult;

export interface BidPackageAwardOptions {
  __typename?: "BidPackageAward";
  id?: BidPackageAward["id"];
  createdAt?: BidPackageAward["createdAt"];
  updatedAt?: BidPackageAward["updatedAt"];
  primaryRevision?: BidContractRevision | BidContractRevisionOptions;
  secondaryRevision?: BidContractRevision | BidContractRevisionOptions | null;
  costCode?: CostCode | CostCodeOptions;
  bidPackageVersion?: BidPackageVersion | BidPackageVersionOptions | null;
}

export function newBidPackageAward(
  options: BidPackageAwardOptions = {},
  cache: Record<string, any> = {},
): BidPackageAward {
  const o = (options.__typename ? options : cache["BidPackageAward"] = {}) as BidPackageAward;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidPackageAward";
  o.id = options.id ?? nextFactoryId("BidPackageAward");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.primaryRevision = maybeNew(
    "BidContractRevision",
    options.primaryRevision,
    cache,
    options.hasOwnProperty("primaryRevision"),
  );
  o.secondaryRevision = maybeNewOrNull("BidContractRevision", options.secondaryRevision, cache);
  o.costCode = maybeNew("CostCode", options.costCode, cache, options.hasOwnProperty("costCode"));
  o.bidPackageVersion = maybeNewOrNull("BidPackageVersion", options.bidPackageVersion, cache);
  return o;
}

factories["BidPackageAward"] = newBidPackageAward;

export interface SaveBidPackageAwardsResultOptions {
  __typename?: "SaveBidPackageAwardsResult";
  bidPackageAwards?: Array<BidPackageAward | BidPackageAwardOptions>;
}

export function newSaveBidPackageAwardsResult(
  options: SaveBidPackageAwardsResultOptions = {},
  cache: Record<string, any> = {},
): SaveBidPackageAwardsResult {
  const o = (options.__typename ? options : cache["SaveBidPackageAwardsResult"] = {}) as SaveBidPackageAwardsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveBidPackageAwardsResult";
  o.bidPackageAwards = (options.bidPackageAwards ?? []).map((i) =>
    maybeNew("BidPackageAward", i, cache, options.hasOwnProperty("bidPackageAwards"))
  );
  return o;
}

factories["SaveBidPackageAwardsResult"] = newSaveBidPackageAwardsResult;

export interface BidPackageGroupOptions {
  __typename?: "BidPackageGroup";
  id?: BidPackageGroup["id"];
  createdAt?: BidPackageGroup["createdAt"];
  updatedAt?: BidPackageGroup["updatedAt"];
  bidPackages?: Array<BidPackage | BidPackageOptions>;
  displayName?: BidPackageGroup["displayName"];
  productOfferings?: Array<ProductOffering | ProductOfferingOptions>;
  projects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  status?: BidPackageStatusDetailOptions | BidPackageStatus;
}

export function newBidPackageGroup(
  options: BidPackageGroupOptions = {},
  cache: Record<string, any> = {},
): BidPackageGroup {
  const o = (options.__typename ? options : cache["BidPackageGroup"] = {}) as BidPackageGroup;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidPackageGroup";
  o.id = options.id ?? nextFactoryId("BidPackageGroup");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.bidPackages = (options.bidPackages ?? []).map((i) =>
    maybeNew("BidPackage", i, cache, options.hasOwnProperty("bidPackages"))
  );
  o.displayName = options.displayName ?? "displayName";
  o.productOfferings = (options.productOfferings ?? []).map((i) =>
    maybeNew("ProductOffering", i, cache, options.hasOwnProperty("productOfferings"))
  );
  o.projects = (options.projects ?? []).map((i) => maybeNew("Project", i, cache, options.hasOwnProperty("projects")));
  o.status = enumOrDetailOfBidPackageStatus(options.status);
  return o;
}

factories["BidPackageGroup"] = newBidPackageGroup;

export interface BidPackageGroupProductOfferingsResultOptions {
  __typename?: "BidPackageGroupProductOfferingsResult";
  productOfferingInfos?: Array<ProductOfferingInfo | ProductOfferingInfoOptions>;
}

export function newBidPackageGroupProductOfferingsResult(
  options: BidPackageGroupProductOfferingsResultOptions = {},
  cache: Record<string, any> = {},
): BidPackageGroupProductOfferingsResult {
  const o =
    (options.__typename
      ? options
      : cache["BidPackageGroupProductOfferingsResult"] = {}) as BidPackageGroupProductOfferingsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidPackageGroupProductOfferingsResult";
  o.productOfferingInfos = (options.productOfferingInfos ?? []).map((i) =>
    maybeNew("ProductOfferingInfo", i, cache, options.hasOwnProperty("productOfferingInfos"))
  );
  return o;
}

factories["BidPackageGroupProductOfferingsResult"] = newBidPackageGroupProductOfferingsResult;

export interface ProductOfferingInfoOptions {
  __typename?: "ProductOfferingInfo";
  productOffering?: ProductOffering | ProductOfferingOptions;
  bidPackage?: BidPackage | BidPackageOptions;
  numberOfLineItems?: ProductOfferingInfo["numberOfLineItems"];
  relevantOptions?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
}

export function newProductOfferingInfo(
  options: ProductOfferingInfoOptions = {},
  cache: Record<string, any> = {},
): ProductOfferingInfo {
  const o = (options.__typename ? options : cache["ProductOfferingInfo"] = {}) as ProductOfferingInfo;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProductOfferingInfo";
  o.productOffering = maybeNew(
    "ProductOffering",
    options.productOffering,
    cache,
    options.hasOwnProperty("productOffering"),
  );
  o.bidPackage = maybeNew("BidPackage", options.bidPackage, cache, options.hasOwnProperty("bidPackage"));
  o.numberOfLineItems = options.numberOfLineItems ?? 0;
  o.relevantOptions = (options.relevantOptions ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("relevantOptions"))
  );
  return o;
}

factories["ProductOfferingInfo"] = newProductOfferingInfo;

export interface BidPackageGroupsPageResultOptions {
  __typename?: "BidPackageGroupsPageResult";
  entities?: Array<BidPackageGroup | BidPackageGroupOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newBidPackageGroupsPageResult(
  options: BidPackageGroupsPageResultOptions = {},
  cache: Record<string, any> = {},
): BidPackageGroupsPageResult {
  const o = (options.__typename ? options : cache["BidPackageGroupsPageResult"] = {}) as BidPackageGroupsPageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidPackageGroupsPageResult";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("BidPackageGroup", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["BidPackageGroupsPageResult"] = newBidPackageGroupsPageResult;

export interface BidPackageIncomingUpdateOptions {
  __typename?: "BidPackageIncomingUpdate";
  id?: BidPackageIncomingUpdate["id"];
  accepted?: BidPackageIncomingUpdate["accepted"];
  createdAt?: BidPackageIncomingUpdate["createdAt"];
  updatedAt?: BidPackageIncomingUpdate["updatedAt"];
  bidPackage?: BidPackage | BidPackageOptions;
  source?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  updateStats?: BidPackageIncomingUpdateStats | BidPackageIncomingUpdateStatsOptions;
}

export function newBidPackageIncomingUpdate(
  options: BidPackageIncomingUpdateOptions = {},
  cache: Record<string, any> = {},
): BidPackageIncomingUpdate {
  const o = (options.__typename ? options : cache["BidPackageIncomingUpdate"] = {}) as BidPackageIncomingUpdate;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidPackageIncomingUpdate";
  o.id = options.id ?? nextFactoryId("BidPackageIncomingUpdate");
  o.accepted = options.accepted ?? false;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.bidPackage = maybeNew("BidPackage", options.bidPackage, cache, options.hasOwnProperty("bidPackage"));
  o.source = maybeNew("ReadyPlanAggregateVersion", options.source, cache, options.hasOwnProperty("source"));
  o.updateStats = maybeNew(
    "BidPackageIncomingUpdateStats",
    options.updateStats,
    cache,
    options.hasOwnProperty("updateStats"),
  );
  return o;
}

factories["BidPackageIncomingUpdate"] = newBidPackageIncomingUpdate;

export interface BidPackageIncomingUpdateStatsOptions {
  __typename?: "BidPackageIncomingUpdateStats";
  tlivs?: IncomingChanges | IncomingChangesOptions;
  rplvs?: IncomingChanges | IncomingChangesOptions;
}

export function newBidPackageIncomingUpdateStats(
  options: BidPackageIncomingUpdateStatsOptions = {},
  cache: Record<string, any> = {},
): BidPackageIncomingUpdateStats {
  const o =
    (options.__typename ? options : cache["BidPackageIncomingUpdateStats"] = {}) as BidPackageIncomingUpdateStats;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidPackageIncomingUpdateStats";
  o.tlivs = maybeNew("IncomingChanges", options.tlivs, cache, options.hasOwnProperty("tlivs"));
  o.rplvs = maybeNew("IncomingChanges", options.rplvs, cache, options.hasOwnProperty("rplvs"));
  return o;
}

factories["BidPackageIncomingUpdateStats"] = newBidPackageIncomingUpdateStats;

export interface IncomingChangesOptions {
  __typename?: "IncomingChanges";
  added?: IncomingChanges["added"];
  removed?: IncomingChanges["removed"];
  updated?: IncomingChanges["updated"];
}

export function newIncomingChanges(
  options: IncomingChangesOptions = {},
  cache: Record<string, any> = {},
): IncomingChanges {
  const o = (options.__typename ? options : cache["IncomingChanges"] = {}) as IncomingChanges;
  (cache.all ??= new Set()).add(o);
  o.__typename = "IncomingChanges";
  o.added = options.added ?? 0;
  o.removed = options.removed ?? 0;
  o.updated = options.updated ?? 0;
  return o;
}

factories["IncomingChanges"] = newIncomingChanges;

export interface BidPackageLineItemOptions {
  __typename?: "BidPackageLineItem";
  id?: BidPackageLineItem["id"];
  createdAt?: BidPackageLineItem["createdAt"];
  updatedAt?: BidPackageLineItem["updatedAt"];
  bidItem?: BidItem | BidItemOptions;
  bidPackageVersion?: BidPackageVersion | BidPackageVersionOptions | null;
}

export function newBidPackageLineItem(
  options: BidPackageLineItemOptions = {},
  cache: Record<string, any> = {},
): BidPackageLineItem {
  const o = (options.__typename ? options : cache["BidPackageLineItem"] = {}) as BidPackageLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidPackageLineItem";
  o.id = options.id ?? nextFactoryId("BidPackageLineItem");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.bidItem = maybeNew("BidItem", options.bidItem, cache, options.hasOwnProperty("bidItem"));
  o.bidPackageVersion = maybeNewOrNull("BidPackageVersion", options.bidPackageVersion, cache);
  return o;
}

factories["BidPackageLineItem"] = newBidPackageLineItem;

export interface BidPackageRequestOptions {
  __typename?: "BidPackageRequest";
  id?: BidPackageRequest["id"];
  name?: BidPackageRequest["name"];
  blueprintUrl?: Url | UrlOptions;
  createdAt?: BidPackageRequest["createdAt"];
  updatedAt?: BidPackageRequest["updatedAt"];
  bidPackage?: BidPackage | BidPackageOptions;
  tradePartner?: TradePartner | TradePartnerOptions;
  primaryContact?: TradePartnerContact | TradePartnerContactOptions | null;
  secondaryContact?: TradePartnerContact | TradePartnerContactOptions | null;
  bidContract?: BidContract | BidContractOptions | null;
  sentDate?: BidPackageRequest["sentDate"];
  archivedAt?: BidPackageRequest["archivedAt"];
  lastVersion?: BidPackageVersion | BidPackageVersionOptions | null;
  references?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: BidPackageRequest["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: BidPackageRequest["isFollowed"];
}

export function newBidPackageRequest(
  options: BidPackageRequestOptions = {},
  cache: Record<string, any> = {},
): BidPackageRequest {
  const o = (options.__typename ? options : cache["BidPackageRequest"] = {}) as BidPackageRequest;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidPackageRequest";
  o.id = options.id ?? nextFactoryId("BidPackageRequest");
  o.name = options.name ?? "name";
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.bidPackage = maybeNew("BidPackage", options.bidPackage, cache, options.hasOwnProperty("bidPackage"));
  o.tradePartner = maybeNew("TradePartner", options.tradePartner, cache, options.hasOwnProperty("tradePartner"));
  o.primaryContact = maybeNewOrNull("TradePartnerContact", options.primaryContact, cache);
  o.secondaryContact = maybeNewOrNull("TradePartnerContact", options.secondaryContact, cache);
  o.bidContract = maybeNewOrNull("BidContract", options.bidContract, cache);
  o.sentDate = options.sentDate ?? null;
  o.archivedAt = options.archivedAt ?? null;
  o.lastVersion = maybeNewOrNull("BidPackageVersion", options.lastVersion, cache);
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  return o;
}

factories["BidPackageRequest"] = newBidPackageRequest;

export interface SaveBidPackageRequestResultOptions {
  __typename?: "SaveBidPackageRequestResult";
  bidPackageRequest?: BidPackageRequest | BidPackageRequestOptions;
}

export function newSaveBidPackageRequestResult(
  options: SaveBidPackageRequestResultOptions = {},
  cache: Record<string, any> = {},
): SaveBidPackageRequestResult {
  const o = (options.__typename ? options : cache["SaveBidPackageRequestResult"] = {}) as SaveBidPackageRequestResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveBidPackageRequestResult";
  o.bidPackageRequest = maybeNew(
    "BidPackageRequest",
    options.bidPackageRequest,
    cache,
    options.hasOwnProperty("bidPackageRequest"),
  );
  return o;
}

factories["SaveBidPackageRequestResult"] = newSaveBidPackageRequestResult;

export interface BidPackageVersionOptions {
  __typename?: "BidPackageVersion";
  id?: BidPackageVersion["id"];
  createdAt?: BidPackageVersion["createdAt"];
  updatedAt?: BidPackageVersion["updatedAt"];
  displayVersion?: BidPackageVersion["displayVersion"];
  version?: BidPackageVersion["version"];
  status?: BidPackageStatusDetailOptions | BidPackageStatus;
  dueDate?: BidPackageVersion["dueDate"];
  estimatedConstructionDate?: BidPackageVersion["estimatedConstructionDate"];
  readyPlanAggregateVersions?: Array<ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions>;
  previous?: BidPackageVersion | BidPackageVersionOptions | null;
  lineItems?: Array<BidPackageLineItem | BidPackageLineItemOptions>;
  latestBidContractRevisions?: Array<BidContractRevision | BidContractRevisionOptions>;
  requests?: Array<BidPackageVersionRequest | BidPackageVersionRequestOptions>;
  relevantTakeoffLineItemVersions?: Array<TakeoffLineItemVersion | TakeoffLineItemVersionOptions>;
  scopeLines?: Array<BidPackageScopeLine | BidPackageScopeLineOptions>;
  basePlanGlobalPlanTasks?: Array<GlobalPlanTask | GlobalPlanTaskOptions>;
  awards?: Array<BidPackageAward | BidPackageAwardOptions>;
  bidPackage?: BidPackage | BidPackageOptions;
  canComplete?: PotentialOperation2 | PotentialOperation2Options;
}

export function newBidPackageVersion(
  options: BidPackageVersionOptions = {},
  cache: Record<string, any> = {},
): BidPackageVersion {
  const o = (options.__typename ? options : cache["BidPackageVersion"] = {}) as BidPackageVersion;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidPackageVersion";
  o.id = options.id ?? nextFactoryId("BidPackageVersion");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.displayVersion = options.displayVersion ?? "displayVersion";
  o.version = options.version ?? 0;
  o.status = enumOrDetailOfBidPackageStatus(options.status);
  o.dueDate = options.dueDate ?? null;
  o.estimatedConstructionDate = options.estimatedConstructionDate ?? null;
  o.readyPlanAggregateVersions = (options.readyPlanAggregateVersions ?? []).map((i) =>
    maybeNew("ReadyPlanAggregateVersion", i, cache, options.hasOwnProperty("readyPlanAggregateVersions"))
  );
  o.previous = maybeNewOrNull("BidPackageVersion", options.previous, cache);
  o.lineItems = (options.lineItems ?? []).map((i) =>
    maybeNew("BidPackageLineItem", i, cache, options.hasOwnProperty("lineItems"))
  );
  o.latestBidContractRevisions = (options.latestBidContractRevisions ?? []).map((i) =>
    maybeNew("BidContractRevision", i, cache, options.hasOwnProperty("latestBidContractRevisions"))
  );
  o.requests = (options.requests ?? []).map((i) =>
    maybeNew("BidPackageVersionRequest", i, cache, options.hasOwnProperty("requests"))
  );
  o.relevantTakeoffLineItemVersions = (options.relevantTakeoffLineItemVersions ?? []).map((i) =>
    maybeNew("TakeoffLineItemVersion", i, cache, options.hasOwnProperty("relevantTakeoffLineItemVersions"))
  );
  o.scopeLines = (options.scopeLines ?? []).map((i) =>
    maybeNew("BidPackageScopeLine", i, cache, options.hasOwnProperty("scopeLines"))
  );
  o.basePlanGlobalPlanTasks = (options.basePlanGlobalPlanTasks ?? []).map((i) =>
    maybeNew("GlobalPlanTask", i, cache, options.hasOwnProperty("basePlanGlobalPlanTasks"))
  );
  o.awards = (options.awards ?? []).map((i) => maybeNew("BidPackageAward", i, cache, options.hasOwnProperty("awards")));
  o.bidPackage = maybeNew("BidPackage", options.bidPackage, cache, options.hasOwnProperty("bidPackage"));
  o.canComplete = maybeNew("PotentialOperation2", options.canComplete, cache, options.hasOwnProperty("canComplete"));
  return o;
}

factories["BidPackageVersion"] = newBidPackageVersion;

export interface BidPackageVersionRequestOptions {
  __typename?: "BidPackageVersionRequest";
  id?: BidPackageVersionRequest["id"];
  notify?: BidPackageVersionRequest["notify"];
  bidPackageRequest?: BidPackageRequest | BidPackageRequestOptions;
  bidPackageVersion?: BidPackageVersion | BidPackageVersionOptions;
}

export function newBidPackageVersionRequest(
  options: BidPackageVersionRequestOptions = {},
  cache: Record<string, any> = {},
): BidPackageVersionRequest {
  const o = (options.__typename ? options : cache["BidPackageVersionRequest"] = {}) as BidPackageVersionRequest;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidPackageVersionRequest";
  o.id = options.id ?? nextFactoryId("BidPackageVersionRequest");
  o.notify = options.notify ?? false;
  o.bidPackageRequest = maybeNew(
    "BidPackageRequest",
    options.bidPackageRequest,
    cache,
    options.hasOwnProperty("bidPackageRequest"),
  );
  o.bidPackageVersion = maybeNew(
    "BidPackageVersion",
    options.bidPackageVersion,
    cache,
    options.hasOwnProperty("bidPackageVersion"),
  );
  return o;
}

factories["BidPackageVersionRequest"] = newBidPackageVersionRequest;

export interface BillMetricsResultOptions {
  __typename?: "BillMetricsResult";
  openPayables?: Array<BillMetric | BillMetricOptions>;
  totalOpenPayables?: BillMetricsResult["totalOpenPayables"];
  agingOfPayables?: Array<BillMetric | BillMetricOptions>;
  totalAgingOfPayables?: BillMetricsResult["totalAgingOfPayables"];
  awaitingApprovals?: Array<BillMetric | BillMetricOptions>;
  totalAwaitingApprovals?: BillMetricsResult["totalAwaitingApprovals"];
}

export function newBillMetricsResult(
  options: BillMetricsResultOptions = {},
  cache: Record<string, any> = {},
): BillMetricsResult {
  const o = (options.__typename ? options : cache["BillMetricsResult"] = {}) as BillMetricsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BillMetricsResult";
  o.openPayables = (options.openPayables ?? []).map((i) =>
    maybeNew("BillMetric", i, cache, options.hasOwnProperty("openPayables"))
  );
  o.totalOpenPayables = options.totalOpenPayables ?? 0;
  o.agingOfPayables = (options.agingOfPayables ?? []).map((i) =>
    maybeNew("BillMetric", i, cache, options.hasOwnProperty("agingOfPayables"))
  );
  o.totalAgingOfPayables = options.totalAgingOfPayables ?? 0;
  o.awaitingApprovals = (options.awaitingApprovals ?? []).map((i) =>
    maybeNew("BillMetric", i, cache, options.hasOwnProperty("awaitingApprovals"))
  );
  o.totalAwaitingApprovals = options.totalAwaitingApprovals ?? 0;
  return o;
}

factories["BillMetricsResult"] = newBillMetricsResult;

export interface BillMetricOptions {
  __typename?: "BillMetric";
  label?: BillMetric["label"];
  totalCount?: BillMetric["totalCount"];
  totalAmount?: BillMetric["totalAmount"];
}

export function newBillMetric(options: BillMetricOptions = {}, cache: Record<string, any> = {}): BillMetric {
  const o = (options.__typename ? options : cache["BillMetric"] = {}) as BillMetric;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BillMetric";
  o.label = options.label ?? "label";
  o.totalCount = options.totalCount ?? 0;
  o.totalAmount = options.totalAmount ?? null;
  return o;
}

factories["BillMetric"] = newBillMetric;

export interface TradePartnerOptions {
  __typename?: "TradePartner";
  bills?: Array<Bill | BillOptions>;
  id?: TradePartner["id"];
  name?: TradePartner["name"];
  internalNote?: TradePartner["internalNote"];
  commitments?: Array<Commitment | CommitmentOptions>;
  quickbooksId?: TradePartner["quickbooksId"];
  tasks?: Array<Task | TaskOptions>;
  markets?: Array<Market | MarketOptions>;
  users?: Array<TradePartnerUser | TradePartnerUserOptions>;
  contacts?: Array<TradePartnerContact | TradePartnerContactOptions>;
  doesMaterials?: TradePartner["doesMaterials"];
  doesLabor?: TradePartner["doesLabor"];
  isSweetheart?: TradePartner["isSweetheart"];
  sourceNote?: TradePartner["sourceNote"];
  source?: InternalUser | InternalUserOptions | null;
  website?: TradePartner["website"];
  agreements?: Array<TradePartnerAgreement | TradePartnerAgreementOptions>;
  reviews?: Array<TradePartnerReview | TradePartnerReviewOptions>;
  reviewCount?: TradePartner["reviewCount"];
  doNotUse?: TradePartner["doNotUse"];
  intacctId?: TradePartner["intacctId"];
  developmentCommitments?: Array<DevelopmentCommitment | DevelopmentCommitmentOptions>;
  costCodes?: Array<CostCode | CostCodeOptions>;
  tradeCategories?: Array<TradeCategory | TradeCategoryOptions>;
  requirements?: Array<TradePartnerRequirement | TradePartnerRequirementOptions>;
  meetsRequirements?: TradePartner["meetsRequirements"];
  meetsRequirementsExpiresAt?: TradePartner["meetsRequirementsExpiresAt"];
  meetsRequirementsExpiresOn?: TradePartner["meetsRequirementsExpiresOn"];
  averageScore?: TradePartner["averageScore"];
  homeboundAccountNumber?: TradePartner["homeboundAccountNumber"];
  bidContracts?: Array<BidContract | BidContractOptions>;
  createdAt?: TradePartner["createdAt"];
  onboardingStatus?: TradePartnerOnboardingStatusDetailOptions | TradePartnerOnboardingStatus;
  contactsForDevelopmentAndRoles?: Array<Maybe<TradePartnerContact | TradePartnerContactOptions>>;
  contactsForProjectAndRoles?: Array<Maybe<TradePartnerContact | TradePartnerContactOptions>>;
  contactsForMarket?: Array<Maybe<TradePartnerContact | TradePartnerContactOptions>>;
  billDueDateFor?: TradePartner["billDueDateFor"];
  primaryForMarket?: TradePartnerContact | TradePartnerContactOptions | null;
  signatoryForMarket?: TradePartnerContact | TradePartnerContactOptions | null;
  primaryForDevelopment?: TradePartnerContact | TradePartnerContactOptions | null;
  signatoryForDevelopment?: TradePartnerContact | TradePartnerContactOptions | null;
  billApproverForDevelopment?: TradePartnerContact | TradePartnerContactOptions | null;
  primaryForProject?: TradePartnerContact | TradePartnerContactOptions | null;
  signatoryForProject?: TradePartnerContact | TradePartnerContactOptions | null;
  billApproverForProject?: TradePartnerContact | TradePartnerContactOptions | null;
  marketContacts?: Array<TradePartnerMarketContact | TradePartnerMarketContactOptions>;
  pendingChangeEventsToCreateCommitments?: Array<ChangeEvent | ChangeEventOptions>;
  leadTimeInDays?: TradePartner["leadTimeInDays"];
  canLoginToPortal?: TradePartner["canLoginToPortal"];
  paymentTerm?: PaymentTerm | PaymentTermOptions;
  lienWaivers?: Array<LienWaiver | LienWaiverOptions>;
  enableClickToPay?: TradePartner["enableClickToPay"];
  isLienWaiverReceiver?: TradePartner["isLienWaiverReceiver"];
  activeTasksCount?: TradePartner["activeTasksCount"];
  activeProjectsCount?: TradePartner["activeProjectsCount"];
  activeContractsCount?: TradePartner["activeContractsCount"];
  totalBilledInCents?: TradePartner["totalBilledInCents"];
  totalPaidInCents?: TradePartner["totalPaidInCents"];
  totalCommittedInCents?: TradePartner["totalCommittedInCents"];
  commitmentCountThisWeek?: TradePartner["commitmentCountThisWeek"];
  commitmentCountLastWeek?: TradePartner["commitmentCountLastWeek"];
  bidPackageRequests?: Array<BidPackageRequest | BidPackageRequestOptions>;
}

export function newTradePartner(options: TradePartnerOptions = {}, cache: Record<string, any> = {}): TradePartner {
  const o = (options.__typename ? options : cache["TradePartner"] = {}) as TradePartner;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TradePartner";
  o.bills = (options.bills ?? []).map((i) => maybeNew("Bill", i, cache, options.hasOwnProperty("bills")));
  o.id = options.id ?? nextFactoryId("TradePartner");
  o.name = options.name ?? "name";
  o.internalNote = options.internalNote ?? null;
  o.commitments = (options.commitments ?? []).map((i) =>
    maybeNew("Commitment", i, cache, options.hasOwnProperty("commitments"))
  );
  o.quickbooksId = options.quickbooksId ?? null;
  o.tasks = (options.tasks ?? []).map((i) => maybeNew("Task", i, cache, options.hasOwnProperty("tasks")));
  o.markets = (options.markets ?? []).map((i) => maybeNew("Market", i, cache, options.hasOwnProperty("markets")));
  o.users = (options.users ?? []).map((i) => maybeNew("TradePartnerUser", i, cache, options.hasOwnProperty("users")));
  o.contacts = (options.contacts ?? []).map((i) =>
    maybeNew("TradePartnerContact", i, cache, options.hasOwnProperty("contacts"))
  );
  o.doesMaterials = options.doesMaterials ?? false;
  o.doesLabor = options.doesLabor ?? false;
  o.isSweetheart = options.isSweetheart ?? false;
  o.sourceNote = options.sourceNote ?? null;
  o.source = maybeNewOrNull("InternalUser", options.source, cache);
  o.website = options.website ?? null;
  o.agreements = (options.agreements ?? []).map((i) =>
    maybeNew("TradePartnerAgreement", i, cache, options.hasOwnProperty("agreements"))
  );
  o.reviews = (options.reviews ?? []).map((i) =>
    maybeNew("TradePartnerReview", i, cache, options.hasOwnProperty("reviews"))
  );
  o.reviewCount = options.reviewCount ?? 0;
  o.doNotUse = options.doNotUse ?? false;
  o.intacctId = options.intacctId ?? null;
  o.developmentCommitments = (options.developmentCommitments ?? []).map((i) =>
    maybeNew("DevelopmentCommitment", i, cache, options.hasOwnProperty("developmentCommitments"))
  );
  o.costCodes = (options.costCodes ?? []).map((i) =>
    maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
  );
  o.tradeCategories = (options.tradeCategories ?? []).map((i) =>
    maybeNew("TradeCategory", i, cache, options.hasOwnProperty("tradeCategories"))
  );
  o.requirements = (options.requirements ?? []).map((i) =>
    maybeNew("TradePartnerRequirement", i, cache, options.hasOwnProperty("requirements"))
  );
  o.meetsRequirements = options.meetsRequirements ?? false;
  o.meetsRequirementsExpiresAt = options.meetsRequirementsExpiresAt ?? null;
  o.meetsRequirementsExpiresOn = options.meetsRequirementsExpiresOn ?? null;
  o.averageScore = options.averageScore ?? "" as any;
  o.homeboundAccountNumber = options.homeboundAccountNumber ?? null;
  o.bidContracts = (options.bidContracts ?? []).map((i) =>
    maybeNew("BidContract", i, cache, options.hasOwnProperty("bidContracts"))
  );
  o.createdAt = options.createdAt ?? newDateTime();
  o.onboardingStatus = enumOrDetailOfTradePartnerOnboardingStatus(options.onboardingStatus);
  o.contactsForDevelopmentAndRoles = (options.contactsForDevelopmentAndRoles ?? []).map((i) =>
    maybeNewOrNull("TradePartnerContact", i, cache)
  );
  o.contactsForProjectAndRoles = (options.contactsForProjectAndRoles ?? []).map((i) =>
    maybeNewOrNull("TradePartnerContact", i, cache)
  );
  o.contactsForMarket = (options.contactsForMarket ?? []).map((i) => maybeNewOrNull("TradePartnerContact", i, cache));
  o.billDueDateFor = options.billDueDateFor ?? newDate();
  o.primaryForMarket = maybeNewOrNull("TradePartnerContact", options.primaryForMarket, cache);
  o.signatoryForMarket = maybeNewOrNull("TradePartnerContact", options.signatoryForMarket, cache);
  o.primaryForDevelopment = maybeNewOrNull("TradePartnerContact", options.primaryForDevelopment, cache);
  o.signatoryForDevelopment = maybeNewOrNull("TradePartnerContact", options.signatoryForDevelopment, cache);
  o.billApproverForDevelopment = maybeNewOrNull("TradePartnerContact", options.billApproverForDevelopment, cache);
  o.primaryForProject = maybeNewOrNull("TradePartnerContact", options.primaryForProject, cache);
  o.signatoryForProject = maybeNewOrNull("TradePartnerContact", options.signatoryForProject, cache);
  o.billApproverForProject = maybeNewOrNull("TradePartnerContact", options.billApproverForProject, cache);
  o.marketContacts = (options.marketContacts ?? []).map((i) =>
    maybeNew("TradePartnerMarketContact", i, cache, options.hasOwnProperty("marketContacts"))
  );
  o.pendingChangeEventsToCreateCommitments = (options.pendingChangeEventsToCreateCommitments ?? []).map((i) =>
    maybeNew("ChangeEvent", i, cache, options.hasOwnProperty("pendingChangeEventsToCreateCommitments"))
  );
  o.leadTimeInDays = options.leadTimeInDays ?? 0;
  o.canLoginToPortal = options.canLoginToPortal ?? false;
  o.paymentTerm = maybeNew("PaymentTerm", options.paymentTerm, cache, options.hasOwnProperty("paymentTerm"));
  o.lienWaivers = (options.lienWaivers ?? []).map((i) =>
    maybeNew("LienWaiver", i, cache, options.hasOwnProperty("lienWaivers"))
  );
  o.enableClickToPay = options.enableClickToPay ?? false;
  o.isLienWaiverReceiver = options.isLienWaiverReceiver ?? false;
  o.activeTasksCount = options.activeTasksCount ?? 0;
  o.activeProjectsCount = options.activeProjectsCount ?? 0;
  o.activeContractsCount = options.activeContractsCount ?? 0;
  o.totalBilledInCents = options.totalBilledInCents ?? 0;
  o.totalPaidInCents = options.totalPaidInCents ?? 0;
  o.totalCommittedInCents = options.totalCommittedInCents ?? 0;
  o.commitmentCountThisWeek = options.commitmentCountThisWeek ?? 0;
  o.commitmentCountLastWeek = options.commitmentCountLastWeek ?? 0;
  o.bidPackageRequests = (options.bidPackageRequests ?? []).map((i) =>
    maybeNew("BidPackageRequest", i, cache, options.hasOwnProperty("bidPackageRequests"))
  );
  return o;
}

factories["TradePartner"] = newTradePartner;

export interface BillOptions {
  __typename?: "Bill";
  id?: Bill["id"];
  name?: Bill["name"];
  tradePartnerNumber?: Bill["tradePartnerNumber"];
  tradePartner?: TradePartner | TradePartnerOptions;
  projectStage?: ProjectStage | ProjectStageOptions;
  parents?: Array<Commitment | CommitmentChangeOrder | CommitmentLike | CommitmentLikeOptions>;
  document?: Document | DocumentOptions | null;
  internalNote?: Bill["internalNote"];
  billDate?: Bill["billDate"];
  dueDate?: Bill["dueDate"];
  billedInCents?: Bill["billedInCents"];
  paidInCents?: Bill["paidInCents"];
  balanceInCents?: Bill["balanceInCents"];
  lineItems?: Array<BillLineItem | BillLineItemOptions>;
  quickbooksId?: Bill["quickbooksId"];
  history?: Array<History | HistoryOptions>;
  quickbooksPullOnly?: Bill["quickbooksPullOnly"];
  isTradePartnerCredit?: Bill["isTradePartnerCredit"];
  blueprintUrl?: Url | UrlOptions;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  quickbooksAmountPaidInCents?: Bill["quickbooksAmountPaidInCents"];
  intacctAmountPaidInCents?: Bill["intacctAmountPaidInCents"];
  intacctSyncError?: Bill["intacctSyncError"];
  createdBy?: User | UserOptions | null;
  intacctId?: Bill["intacctId"];
  paidDate?: Bill["paidDate"];
  documents?: Array<Document | DocumentOptions>;
  postedDate?: Bill["postedDate"];
  shouldSyncToIntacct?: Bill["shouldSyncToIntacct"];
  predictedApprovers?: Array<
    ApproverUser | ClientOptions | RequireTypename<InternalUserOptions> | RequireTypename<TradePartnerUserOptions>
  >;
  type?: BillTypeDetailOptions | BillType;
  status?: BillStatusDetailOptions | BillStatus;
  approval?: Approval | ApprovalOptions | null;
  approvedAt?: Bill["approvedAt"];
  sentDate?: Bill["sentDate"];
  isEditable?: Bill["isEditable"];
  isPendingOrBilled?: Bill["isPendingOrBilled"];
  isProcessingReversal?: Bill["isProcessingReversal"];
  canSubmitForApproval?: PotentialOperation2 | PotentialOperation2Options;
  canDelete?: PotentialOperation2 | PotentialOperation2Options;
  canReverse?: PotentialOperation2 | PotentialOperation2Options;
  updatedAt?: Bill["updatedAt"];
  canEdit?: PotentialOperation2 | PotentialOperation2Options;
  lienWaivers?: Array<LienWaiver | LienWaiverOptions>;
  referenceNumber?: Bill["referenceNumber"];
  reversalIntacctId?: Bill["reversalIntacctId"];
  canCancel?: PotentialOperation2 | PotentialOperation2Options;
  skipCostAccountDerivation?: Bill["skipCostAccountDerivation"];
  pendingReview?: Bill["pendingReview"];
  reviewReason?: Bill["reviewReason"];
  reviewReasonDetail?: BillReviewReasonDetailOptions | BillReviewReason | null;
  isHeadless?: Bill["isHeadless"];
  syncedToIntacctAt?: Bill["syncedToIntacctAt"];
  isBilled?: Bill["isBilled"];
  proposedAmountInCents?: Bill["proposedAmountInCents"];
  amountInCents?: Bill["amountInCents"];
  changeEvents?: Array<ChangeEvent | ChangeEventOptions>;
  source?: BillSourceDetailOptions | BillSource;
  ocrs?: Array<BillOcr | BillOcrOptions>;
  isDeferred?: Bill["isDeferred"];
  reviewers?: Array<InternalUser | InternalUserOptions>;
  erpAccountLines?: Array<ErpAccountBillLineItem | ErpAccountBillLineItemOptions>;
  billOcr?: BillOcr | BillOcrOptions | null;
  references?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: Bill["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: Bill["isFollowed"];
}

export function newBill(options: BillOptions = {}, cache: Record<string, any> = {}): Bill {
  const o = (options.__typename ? options : cache["Bill"] = {}) as Bill;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Bill";
  o.id = options.id ?? nextFactoryId("Bill");
  o.name = options.name ?? "name";
  o.tradePartnerNumber = options.tradePartnerNumber ?? "tradePartnerNumber";
  o.tradePartner = maybeNew("TradePartner", options.tradePartner, cache, options.hasOwnProperty("tradePartner"));
  o.projectStage = maybeNew("ProjectStage", options.projectStage, cache, options.hasOwnProperty("projectStage"));
  o.parents = (options.parents ?? []).map((i) =>
    maybeNew("CommitmentLike", i, cache, options.hasOwnProperty("parents"))
  );
  o.document = maybeNewOrNull("Document", options.document, cache);
  o.internalNote = options.internalNote ?? null;
  o.billDate = options.billDate ?? newDate();
  o.dueDate = options.dueDate ?? null;
  o.billedInCents = options.billedInCents ?? 0;
  o.paidInCents = options.paidInCents ?? 0;
  o.balanceInCents = options.balanceInCents ?? 0;
  o.lineItems = (options.lineItems ?? []).map((i) =>
    maybeNew("BillLineItem", i, cache, options.hasOwnProperty("lineItems"))
  );
  o.quickbooksId = options.quickbooksId ?? null;
  o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
  o.quickbooksPullOnly = options.quickbooksPullOnly ?? false;
  o.isTradePartnerCredit = options.isTradePartnerCredit ?? false;
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.quickbooksAmountPaidInCents = options.quickbooksAmountPaidInCents ?? 0;
  o.intacctAmountPaidInCents = options.intacctAmountPaidInCents ?? 0;
  o.intacctSyncError = options.intacctSyncError ?? null;
  o.createdBy = maybeNewOrNull("User", options.createdBy, cache);
  o.intacctId = options.intacctId ?? null;
  o.paidDate = options.paidDate ?? null;
  o.documents = (options.documents ?? []).map((i) =>
    maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
  );
  o.postedDate = options.postedDate ?? null;
  o.shouldSyncToIntacct = options.shouldSyncToIntacct ?? false;
  o.predictedApprovers = (options.predictedApprovers ?? []).map((i) =>
    maybeNew(i?.__typename ?? "{Client", i, cache, options.hasOwnProperty("predictedApprovers"))
  );
  o.type = enumOrDetailOfBillType(options.type);
  o.status = enumOrDetailOfBillStatus(options.status);
  o.approval = maybeNewOrNull("Approval", options.approval, cache);
  o.approvedAt = options.approvedAt ?? null;
  o.sentDate = options.sentDate ?? null;
  o.isEditable = options.isEditable ?? false;
  o.isPendingOrBilled = options.isPendingOrBilled ?? false;
  o.isProcessingReversal = options.isProcessingReversal ?? false;
  o.canSubmitForApproval = maybeNew(
    "PotentialOperation2",
    options.canSubmitForApproval,
    cache,
    options.hasOwnProperty("canSubmitForApproval"),
  );
  o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
  o.canReverse = maybeNew("PotentialOperation2", options.canReverse, cache, options.hasOwnProperty("canReverse"));
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
  o.lienWaivers = (options.lienWaivers ?? []).map((i) =>
    maybeNew("LienWaiver", i, cache, options.hasOwnProperty("lienWaivers"))
  );
  o.referenceNumber = options.referenceNumber ?? null;
  o.reversalIntacctId = options.reversalIntacctId ?? null;
  o.canCancel = maybeNew("PotentialOperation2", options.canCancel, cache, options.hasOwnProperty("canCancel"));
  o.skipCostAccountDerivation = options.skipCostAccountDerivation ?? null;
  o.pendingReview = options.pendingReview ?? false;
  o.reviewReason = options.reviewReason ?? null;
  o.reviewReasonDetail = enumOrDetailOrNullOfBillReviewReason(options.reviewReasonDetail);
  o.isHeadless = options.isHeadless ?? false;
  o.syncedToIntacctAt = options.syncedToIntacctAt ?? null;
  o.isBilled = options.isBilled ?? false;
  o.proposedAmountInCents = options.proposedAmountInCents ?? 0;
  o.amountInCents = options.amountInCents ?? 0;
  o.changeEvents = (options.changeEvents ?? []).map((i) =>
    maybeNew("ChangeEvent", i, cache, options.hasOwnProperty("changeEvents"))
  );
  o.source = enumOrDetailOfBillSource(options.source);
  o.ocrs = (options.ocrs ?? []).map((i) => maybeNew("BillOcr", i, cache, options.hasOwnProperty("ocrs")));
  o.isDeferred = options.isDeferred ?? false;
  o.reviewers = (options.reviewers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("reviewers"))
  );
  o.erpAccountLines = (options.erpAccountLines ?? []).map((i) =>
    maybeNew("ErpAccountBillLineItem", i, cache, options.hasOwnProperty("erpAccountLines"))
  );
  o.billOcr = maybeNewOrNull("BillOcr", options.billOcr, cache);
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  return o;
}

factories["Bill"] = newBill;

export interface SaveBillResultOptions {
  __typename?: "SaveBillResult";
  bill?: Bill | BillOptions | null;
}

export function newSaveBillResult(
  options: SaveBillResultOptions = {},
  cache: Record<string, any> = {},
): SaveBillResult {
  const o = (options.__typename ? options : cache["SaveBillResult"] = {}) as SaveBillResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveBillResult";
  o.bill = maybeNewOrNull("Bill", options.bill, cache);
  return o;
}

factories["SaveBillResult"] = newSaveBillResult;

export interface SaveBillsResultOptions {
  __typename?: "SaveBillsResult";
  bills?: Array<Bill | BillOptions>;
}

export function newSaveBillsResult(
  options: SaveBillsResultOptions = {},
  cache: Record<string, any> = {},
): SaveBillsResult {
  const o = (options.__typename ? options : cache["SaveBillsResult"] = {}) as SaveBillsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveBillsResult";
  o.bills = (options.bills ?? []).map((i) => maybeNew("Bill", i, cache, options.hasOwnProperty("bills")));
  return o;
}

factories["SaveBillsResult"] = newSaveBillsResult;

export interface BillsPageOptions {
  __typename?: "BillsPage";
  entities?: Array<Bill | BillOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newBillsPage(options: BillsPageOptions = {}, cache: Record<string, any> = {}): BillsPage {
  const o = (options.__typename ? options : cache["BillsPage"] = {}) as BillsPage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BillsPage";
  o.entities = (options.entities ?? []).map((i) => maybeNew("Bill", i, cache, options.hasOwnProperty("entities")));
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["BillsPage"] = newBillsPage;

export interface ProtoBillOptions {
  __typename?: "ProtoBill";
  id?: ProtoBill["id"];
  existingBills?: Array<Bill | BillOptions>;
  commitmentLineItems?: Array<CommitmentLineItem | CommitmentLineItemOptions>;
  tradePartner?: TradePartner | TradePartnerOptions;
  lineItems?: Array<ProtoBillLineItem | ProtoBillLineItemOptions>;
}

export function newProtoBill(options: ProtoBillOptions = {}, cache: Record<string, any> = {}): ProtoBill {
  const o = (options.__typename ? options : cache["ProtoBill"] = {}) as ProtoBill;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProtoBill";
  o.id = options.id ?? nextFactoryId("ProtoBill");
  o.existingBills = (options.existingBills ?? []).map((i) =>
    maybeNew("Bill", i, cache, options.hasOwnProperty("existingBills"))
  );
  o.commitmentLineItems = (options.commitmentLineItems ?? []).map((i) =>
    maybeNew("CommitmentLineItem", i, cache, options.hasOwnProperty("commitmentLineItems"))
  );
  o.tradePartner = maybeNew("TradePartner", options.tradePartner, cache, options.hasOwnProperty("tradePartner"));
  o.lineItems = (options.lineItems ?? []).map((i) =>
    maybeNew("ProtoBillLineItem", i, cache, options.hasOwnProperty("lineItems"))
  );
  return o;
}

factories["ProtoBill"] = newProtoBill;

export interface ErpAccountBillLineItemOptions {
  __typename?: "ErpAccountBillLineItem";
  amountInCents?: ErpAccountBillLineItem["amountInCents"];
  sourceLine?:
    | ErpAccrualLineItemSourceLine
    | BillLineItemAllocationOptions
    | RequireTypename<CommitmentDrawOptions>
    | RequireTypename<CommitmentLineItemOptions>
    | RequireTypename<ExpenseAllocationAllocationOptions>
    | RequireTypename<ProjectItemOptions>
    | RequireTypename<CostCodeOptions>;
  erpSource?:
    | ErpAccountBillLineItemErpSource
    | CommitmentDrawOptions
    | RequireTypename<CommitmentLineItemOptions>
    | RequireTypename<ProjectItemOptions>
    | RequireTypename<CostCodeOptions>
    | RequireTypename<CommitmentOptions>;
  costCode?: CostCode | CostCodeOptions;
  task?: Task | TaskOptions | null;
  shouldAccrueAsComplete?: ErpAccountBillLineItem["shouldAccrueAsComplete"];
}

export function newErpAccountBillLineItem(
  options: ErpAccountBillLineItemOptions = {},
  cache: Record<string, any> = {},
): ErpAccountBillLineItem {
  const o = (options.__typename ? options : cache["ErpAccountBillLineItem"] = {}) as ErpAccountBillLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ErpAccountBillLineItem";
  o.amountInCents = options.amountInCents ?? 0;
  o.sourceLine = maybeNew(options.sourceLine?.__typename ?? "BillLineItemAllocation", options.sourceLine, cache);
  o.erpSource = maybeNew(options.erpSource?.__typename ?? "CommitmentDraw", options.erpSource, cache);
  o.costCode = maybeNew("CostCode", options.costCode, cache, options.hasOwnProperty("costCode"));
  o.task = maybeNewOrNull("Task", options.task, cache);
  o.shouldAccrueAsComplete = options.shouldAccrueAsComplete ?? false;
  return o;
}

factories["ErpAccountBillLineItem"] = newErpAccountBillLineItem;

export interface BillGmailAttachmentOptions {
  __typename?: "BillGmailAttachment";
  id?: BillGmailAttachment["id"];
  filename?: BillGmailAttachment["filename"];
  mimeType?: BillGmailAttachment["mimeType"];
  sizeInBytes?: BillGmailAttachment["sizeInBytes"];
  createdAt?: BillGmailAttachment["createdAt"];
  updatedAt?: BillGmailAttachment["updatedAt"];
  results?: BillGmailAttachment["results"];
  message?: BillGmailMessage | BillGmailMessageOptions;
  gmailPartId?: BillGmailAttachment["gmailPartId"];
  gmailAttachmentId?: BillGmailAttachment["gmailAttachmentId"];
  billOcrs?: Array<BillOcr | BillOcrOptions>;
  asset?: Asset | AssetOptions | null;
}

export function newBillGmailAttachment(
  options: BillGmailAttachmentOptions = {},
  cache: Record<string, any> = {},
): BillGmailAttachment {
  const o = (options.__typename ? options : cache["BillGmailAttachment"] = {}) as BillGmailAttachment;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BillGmailAttachment";
  o.id = options.id ?? nextFactoryId("BillGmailAttachment");
  o.filename = options.filename ?? "filename";
  o.mimeType = options.mimeType ?? "mimeType";
  o.sizeInBytes = options.sizeInBytes ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.results = options.results ?? [];
  o.message = maybeNew("BillGmailMessage", options.message, cache, options.hasOwnProperty("message"));
  o.gmailPartId = options.gmailPartId ?? "gmailPartId";
  o.gmailAttachmentId = options.gmailAttachmentId ?? null;
  o.billOcrs = (options.billOcrs ?? []).map((i) => maybeNew("BillOcr", i, cache, options.hasOwnProperty("billOcrs")));
  o.asset = maybeNewOrNull("Asset", options.asset, cache);
  return o;
}

factories["BillGmailAttachment"] = newBillGmailAttachment;

export interface BillGmailMessageOptions {
  __typename?: "BillGmailMessage";
  id?: BillGmailMessage["id"];
  gmailMessageId?: BillGmailMessage["gmailMessageId"];
  gmailUserId?: BillGmailMessage["gmailUserId"];
  subject?: BillGmailMessage["subject"];
  sender?: BillGmailMessage["sender"];
  receivedAt?: BillGmailMessage["receivedAt"];
  createdAt?: BillGmailMessage["createdAt"];
  updatedAt?: BillGmailMessage["updatedAt"];
  result?: BillGmailMessageResultDetailOptions | BillGmailMessageResult;
  attachments?: Array<BillGmailAttachment | BillGmailAttachmentOptions>;
}

export function newBillGmailMessage(
  options: BillGmailMessageOptions = {},
  cache: Record<string, any> = {},
): BillGmailMessage {
  const o = (options.__typename ? options : cache["BillGmailMessage"] = {}) as BillGmailMessage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BillGmailMessage";
  o.id = options.id ?? nextFactoryId("BillGmailMessage");
  o.gmailMessageId = options.gmailMessageId ?? "gmailMessageId";
  o.gmailUserId = options.gmailUserId ?? "gmailUserId";
  o.subject = options.subject ?? null;
  o.sender = options.sender ?? null;
  o.receivedAt = options.receivedAt ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.result = enumOrDetailOfBillGmailMessageResult(options.result);
  o.attachments = (options.attachments ?? []).map((i) =>
    maybeNew("BillGmailAttachment", i, cache, options.hasOwnProperty("attachments"))
  );
  return o;
}

factories["BillGmailMessage"] = newBillGmailMessage;

export interface BillLineItemOptions {
  __typename?: "BillLineItem";
  id?: BillLineItem["id"];
  bill?: Bill | BillOptions;
  amountInCents?: BillLineItem["amountInCents"];
  commitmentLineItem?: CommitmentLineItem | CommitmentLineItemOptions | null;
  paidInCents?: BillLineItem["paidInCents"];
  historicBillAmountInvoiced?: BillLineItem["historicBillAmountInvoiced"];
  scheduleTask?: Task | TaskOptions | null;
  projectItem?: ProjectItem | ProjectItemOptions;
  commitmentDraw?: CommitmentDraw | CommitmentDrawOptions | null;
  task?: Task | TaskOptions | null;
  shouldAccrueAsComplete?: BillLineItem["shouldAccrueAsComplete"];
  isTaxExempt?: BillLineItem["isTaxExempt"];
  taxableAmountInCents?: BillLineItem["taxableAmountInCents"];
  taxInCents?: BillLineItem["taxInCents"];
  allocations?: Array<BillLineItemAllocation | BillLineItemAllocationOptions>;
}

export function newBillLineItem(options: BillLineItemOptions = {}, cache: Record<string, any> = {}): BillLineItem {
  const o = (options.__typename ? options : cache["BillLineItem"] = {}) as BillLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BillLineItem";
  o.id = options.id ?? nextFactoryId("BillLineItem");
  o.bill = maybeNew("Bill", options.bill, cache, options.hasOwnProperty("bill"));
  o.amountInCents = options.amountInCents ?? 0;
  o.commitmentLineItem = maybeNewOrNull("CommitmentLineItem", options.commitmentLineItem, cache);
  o.paidInCents = options.paidInCents ?? 0;
  o.historicBillAmountInvoiced = options.historicBillAmountInvoiced ?? null;
  o.scheduleTask = maybeNewOrNull("Task", options.scheduleTask, cache);
  o.projectItem = maybeNew("ProjectItem", options.projectItem, cache, options.hasOwnProperty("projectItem"));
  o.commitmentDraw = maybeNewOrNull("CommitmentDraw", options.commitmentDraw, cache);
  o.task = maybeNewOrNull("Task", options.task, cache);
  o.shouldAccrueAsComplete = options.shouldAccrueAsComplete ?? false;
  o.isTaxExempt = options.isTaxExempt ?? false;
  o.taxableAmountInCents = options.taxableAmountInCents ?? 0;
  o.taxInCents = options.taxInCents ?? 0;
  o.allocations = (options.allocations ?? []).map((i) =>
    maybeNew("BillLineItemAllocation", i, cache, options.hasOwnProperty("allocations"))
  );
  return o;
}

factories["BillLineItem"] = newBillLineItem;

export interface ProtoBillLineItemOptions {
  __typename?: "ProtoBillLineItem";
  commitmentLineItem?: CommitmentLineItem | CommitmentLineItemOptions;
  commitmentDraw?: CommitmentDraw | CommitmentDrawOptions | null;
  amountInCents?: ProtoBillLineItem["amountInCents"];
}

export function newProtoBillLineItem(
  options: ProtoBillLineItemOptions = {},
  cache: Record<string, any> = {},
): ProtoBillLineItem {
  const o = (options.__typename ? options : cache["ProtoBillLineItem"] = {}) as ProtoBillLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProtoBillLineItem";
  o.commitmentLineItem = maybeNew(
    "CommitmentLineItem",
    options.commitmentLineItem,
    cache,
    options.hasOwnProperty("commitmentLineItem"),
  );
  o.commitmentDraw = maybeNewOrNull("CommitmentDraw", options.commitmentDraw, cache);
  o.amountInCents = options.amountInCents ?? 0;
  return o;
}

factories["ProtoBillLineItem"] = newProtoBillLineItem;

export interface BillLineItemAllocationOptions {
  __typename?: "BillLineItemAllocation";
  id?: BillLineItemAllocation["id"];
  createdAt?: BillLineItemAllocation["createdAt"];
  updatedAt?: BillLineItemAllocation["updatedAt"];
  costInCents?: BillLineItemAllocation["costInCents"];
  paidCostInCents?: BillLineItemAllocation["paidCostInCents"];
  commitmentLineItemAllocation?: CommitmentLineItemAllocation | CommitmentLineItemAllocationOptions | null;
  projectItemAllocation?: ProjectItemAllocation | ProjectItemAllocationOptions;
}

export function newBillLineItemAllocation(
  options: BillLineItemAllocationOptions = {},
  cache: Record<string, any> = {},
): BillLineItemAllocation {
  const o = (options.__typename ? options : cache["BillLineItemAllocation"] = {}) as BillLineItemAllocation;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BillLineItemAllocation";
  o.id = options.id ?? nextFactoryId("BillLineItemAllocation");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.costInCents = options.costInCents ?? 0;
  o.paidCostInCents = options.paidCostInCents ?? 0;
  o.commitmentLineItemAllocation = maybeNewOrNull(
    "CommitmentLineItemAllocation",
    options.commitmentLineItemAllocation,
    cache,
  );
  o.projectItemAllocation = maybeNew(
    "ProjectItemAllocation",
    options.projectItemAllocation,
    cache,
    options.hasOwnProperty("projectItemAllocation"),
  );
  return o;
}

factories["BillLineItemAllocation"] = newBillLineItemAllocation;

export interface BillOcrOptions {
  __typename?: "BillOcr";
  id?: BillOcr["id"];
  createdAt?: BillOcr["createdAt"];
  updatedAt?: BillOcr["updatedAt"];
  asset?: Asset | AssetOptions;
  bill?: Bill | BillOptions | null;
  tradePartner?: TradePartner | TradePartnerOptions | null;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  commitmentLikes?: Array<Commitment | CommitmentChangeOrder | CommitmentLike | CommitmentLikeOptions>;
  invoiceNumber?: BillOcr["invoiceNumber"];
  billDate?: BillOcr["billDate"];
  dueDate?: BillOcr["dueDate"];
  totalInCents?: BillOcr["totalInCents"];
  type?: BillTypeDetailOptions | BillType;
  gmailAttachment?: BillGmailAttachment | BillGmailAttachmentOptions | null;
  billOcrBill?: Bill | BillOptions | null;
}

export function newBillOcr(options: BillOcrOptions = {}, cache: Record<string, any> = {}): BillOcr {
  const o = (options.__typename ? options : cache["BillOcr"] = {}) as BillOcr;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BillOcr";
  o.id = options.id ?? nextFactoryId("BillOcr");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.asset = maybeNew("Asset", options.asset, cache, options.hasOwnProperty("asset"));
  o.bill = maybeNewOrNull("Bill", options.bill, cache);
  o.tradePartner = maybeNewOrNull("TradePartner", options.tradePartner, cache);
  o.project = maybeNewOrNull("Project", options.project, cache);
  o.commitmentLikes = (options.commitmentLikes ?? []).map((i) =>
    maybeNew("CommitmentLike", i, cache, options.hasOwnProperty("commitmentLikes"))
  );
  o.invoiceNumber = options.invoiceNumber ?? null;
  o.billDate = options.billDate ?? null;
  o.dueDate = options.dueDate ?? null;
  o.totalInCents = options.totalInCents ?? null;
  o.type = enumOrDetailOfBillType(options.type);
  o.gmailAttachment = maybeNewOrNull("BillGmailAttachment", options.gmailAttachment, cache);
  o.billOcrBill = maybeNewOrNull("Bill", options.billOcrBill, cache);
  return o;
}

factories["BillOcr"] = newBillOcr;

export interface CreateBillOcrResultOptions {
  __typename?: "CreateBillOcrResult";
  billOcr?: BillOcr | BillOcrOptions;
}

export function newCreateBillOcrResult(
  options: CreateBillOcrResultOptions = {},
  cache: Record<string, any> = {},
): CreateBillOcrResult {
  const o = (options.__typename ? options : cache["CreateBillOcrResult"] = {}) as CreateBillOcrResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CreateBillOcrResult";
  o.billOcr = maybeNew("BillOcr", options.billOcr, cache, options.hasOwnProperty("billOcr"));
  return o;
}

factories["CreateBillOcrResult"] = newCreateBillOcrResult;

export interface PreConBudgetCostDivisionLineItemOptions {
  __typename?: "PreConBudgetCostDivisionLineItem";
  costDivision?: CostDivision | CostDivisionOptions;
  lines?: Array<PreConBudgetCostCodeLineItem | PreConBudgetCostCodeLineItemOptions>;
  priceInCents?: PreConBudgetCostDivisionLineItem["priceInCents"];
  budgetInCents?: PreConBudgetCostDivisionLineItem["budgetInCents"];
}

export function newPreConBudgetCostDivisionLineItem(
  options: PreConBudgetCostDivisionLineItemOptions = {},
  cache: Record<string, any> = {},
): PreConBudgetCostDivisionLineItem {
  const o =
    (options.__typename ? options : cache["PreConBudgetCostDivisionLineItem"] = {}) as PreConBudgetCostDivisionLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PreConBudgetCostDivisionLineItem";
  o.costDivision = maybeNew("CostDivision", options.costDivision, cache, options.hasOwnProperty("costDivision"));
  o.lines = (options.lines ?? []).map((i) =>
    maybeNew("PreConBudgetCostCodeLineItem", i, cache, options.hasOwnProperty("lines"))
  );
  o.priceInCents = options.priceInCents ?? null;
  o.budgetInCents = options.budgetInCents ?? null;
  return o;
}

factories["PreConBudgetCostDivisionLineItem"] = newPreConBudgetCostDivisionLineItem;

export interface PreConBudgetCostCodeLineItemOptions {
  __typename?: "PreConBudgetCostCodeLineItem";
  costCode?: CostCode | CostCodeOptions;
  internalNote?: PreConBudgetCostCodeLineItem["internalNote"];
  priceInCents?: PreConBudgetCostCodeLineItem["priceInCents"];
  budgetInCents?: PreConBudgetCostCodeLineItem["budgetInCents"];
}

export function newPreConBudgetCostCodeLineItem(
  options: PreConBudgetCostCodeLineItemOptions = {},
  cache: Record<string, any> = {},
): PreConBudgetCostCodeLineItem {
  const o = (options.__typename ? options : cache["PreConBudgetCostCodeLineItem"] = {}) as PreConBudgetCostCodeLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PreConBudgetCostCodeLineItem";
  o.costCode = maybeNew("CostCode", options.costCode, cache, options.hasOwnProperty("costCode"));
  o.internalNote = options.internalNote ?? null;
  o.priceInCents = options.priceInCents ?? null;
  o.budgetInCents = options.budgetInCents ?? null;
  return o;
}

factories["PreConBudgetCostCodeLineItem"] = newPreConBudgetCostCodeLineItem;

export interface SavePreConBudgetLineItemResultOptions {
  __typename?: "SavePreConBudgetLineItemResult";
  lineItem?: PreConBudgetCostCodeLineItem | PreConBudgetCostCodeLineItemOptions;
}

export function newSavePreConBudgetLineItemResult(
  options: SavePreConBudgetLineItemResultOptions = {},
  cache: Record<string, any> = {},
): SavePreConBudgetLineItemResult {
  const o =
    (options.__typename ? options : cache["SavePreConBudgetLineItemResult"] = {}) as SavePreConBudgetLineItemResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SavePreConBudgetLineItemResult";
  o.lineItem = maybeNew("PreConBudgetCostCodeLineItem", options.lineItem, cache, options.hasOwnProperty("lineItem"));
  return o;
}

factories["SavePreConBudgetLineItemResult"] = newSavePreConBudgetLineItemResult;

export interface DeletePreConBudgetLineItemResultOptions {
  __typename?: "DeletePreConBudgetLineItemResult";
  emptyResult?: EmptyResult | EmptyResultOptions | null;
}

export function newDeletePreConBudgetLineItemResult(
  options: DeletePreConBudgetLineItemResultOptions = {},
  cache: Record<string, any> = {},
): DeletePreConBudgetLineItemResult {
  const o =
    (options.__typename ? options : cache["DeletePreConBudgetLineItemResult"] = {}) as DeletePreConBudgetLineItemResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeletePreConBudgetLineItemResult";
  o.emptyResult = maybeNewOrNull("EmptyResult", options.emptyResult, cache);
  return o;
}

factories["DeletePreConBudgetLineItemResult"] = newDeletePreConBudgetLineItemResult;

export interface ApprovePreConBudgetLineItemResultOptions {
  __typename?: "ApprovePreConBudgetLineItemResult";
  contract?: HomeownerContract | HomeownerContractOptions;
}

export function newApprovePreConBudgetLineItemResult(
  options: ApprovePreConBudgetLineItemResultOptions = {},
  cache: Record<string, any> = {},
): ApprovePreConBudgetLineItemResult {
  const o =
    (options.__typename
      ? options
      : cache["ApprovePreConBudgetLineItemResult"] = {}) as ApprovePreConBudgetLineItemResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ApprovePreConBudgetLineItemResult";
  o.contract = maybeNew("HomeownerContract", options.contract, cache, options.hasOwnProperty("contract"));
  return o;
}

factories["ApprovePreConBudgetLineItemResult"] = newApprovePreConBudgetLineItemResult;

export interface BuilderOptions {
  __typename?: "Builder";
  id?: Builder["id"];
  name?: Builder["name"];
}

export function newBuilder(options: BuilderOptions = {}, cache: Record<string, any> = {}): Builder {
  const o = (options.__typename ? options : cache["Builder"] = {}) as Builder;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Builder";
  o.id = options.id ?? nextFactoryId("Builder");
  o.name = options.name ?? "name";
  return o;
}

factories["Builder"] = newBuilder;

export interface SaveBuilderResultOptions {
  __typename?: "SaveBuilderResult";
  builder?: Builder | BuilderOptions;
}

export function newSaveBuilderResult(
  options: SaveBuilderResultOptions = {},
  cache: Record<string, any> = {},
): SaveBuilderResult {
  const o = (options.__typename ? options : cache["SaveBuilderResult"] = {}) as SaveBuilderResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveBuilderResult";
  o.builder = maybeNew("Builder", options.builder, cache, options.hasOwnProperty("builder"));
  return o;
}

factories["SaveBuilderResult"] = newSaveBuilderResult;

export interface BusinessFunctionOptions {
  __typename?: "BusinessFunction";
  id?: BusinessFunction["id"];
  name?: BusinessFunction["name"];
  priority?: BusinessFunction["priority"];
  autoApprovalAmountInCents?: BusinessFunction["autoApprovalAmountInCents"];
  createdAt?: BusinessFunction["createdAt"];
  updatedAt?: BusinessFunction["updatedAt"];
  impactReviewer?: ProjectRoleDetailOptions | ProjectRole | null;
  initialReviewer?: ProjectRoleDetailOptions | ProjectRole | null;
  businessFunctionType?: BusinessFunctionTypeDetailOptions | BusinessFunctionType;
  blueprintUrl?: Url | UrlOptions;
  approverProjectRole?: ProjectRoleDetailOptions | ProjectRole | null;
  applicableChangeTypes?: Array<ChangeTypeDetail | ChangeTypeDetailOptions>;
}

export function newBusinessFunction(
  options: BusinessFunctionOptions = {},
  cache: Record<string, any> = {},
): BusinessFunction {
  const o = (options.__typename ? options : cache["BusinessFunction"] = {}) as BusinessFunction;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BusinessFunction";
  o.id = options.id ?? nextFactoryId("BusinessFunction");
  o.name = options.name ?? "name";
  o.priority = options.priority ?? 0;
  o.autoApprovalAmountInCents = options.autoApprovalAmountInCents ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.impactReviewer = enumOrDetailOrNullOfProjectRole(options.impactReviewer);
  o.initialReviewer = enumOrDetailOrNullOfProjectRole(options.initialReviewer);
  o.businessFunctionType = enumOrDetailOfBusinessFunctionType(options.businessFunctionType);
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.approverProjectRole = enumOrDetailOrNullOfProjectRole(options.approverProjectRole);
  o.applicableChangeTypes = (options.applicableChangeTypes ?? []).map((i) => enumOrDetailOfChangeType(i));
  return o;
}

factories["BusinessFunction"] = newBusinessFunction;

export interface SaveBusinessFunctionResultOptions {
  __typename?: "SaveBusinessFunctionResult";
  businessFunction?: BusinessFunction | BusinessFunctionOptions;
}

export function newSaveBusinessFunctionResult(
  options: SaveBusinessFunctionResultOptions = {},
  cache: Record<string, any> = {},
): SaveBusinessFunctionResult {
  const o = (options.__typename ? options : cache["SaveBusinessFunctionResult"] = {}) as SaveBusinessFunctionResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveBusinessFunctionResult";
  o.businessFunction = maybeNew(
    "BusinessFunction",
    options.businessFunction,
    cache,
    options.hasOwnProperty("businessFunction"),
  );
  return o;
}

factories["SaveBusinessFunctionResult"] = newSaveBusinessFunctionResult;

export interface CalendarIntervalOptions {
  __typename?: "CalendarInterval";
  startDate?: CalendarInterval["startDate"];
  endDate?: CalendarInterval["endDate"];
  durationInDays?: CalendarInterval["durationInDays"];
  calendarProgress?: CalendarInterval["calendarProgress"];
}

export function newCalendarInterval(
  options: CalendarIntervalOptions = {},
  cache: Record<string, any> = {},
): CalendarInterval {
  const o = (options.__typename ? options : cache["CalendarInterval"] = {}) as CalendarInterval;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CalendarInterval";
  o.startDate = options.startDate ?? newDate();
  o.endDate = options.endDate ?? newDate();
  o.durationInDays = options.durationInDays ?? 0;
  o.calendarProgress = options.calendarProgress ?? 0;
  return o;
}

factories["CalendarInterval"] = newCalendarInterval;

export interface CalendarInterval2Options {
  __typename?: "CalendarInterval2";
  startDate?: CalendarInterval2["startDate"];
  endDate?: CalendarInterval2["endDate"];
  durationInDays?: CalendarInterval2["durationInDays"];
}

export function newCalendarInterval2(
  options: CalendarInterval2Options = {},
  cache: Record<string, any> = {},
): CalendarInterval2 {
  const o = (options.__typename ? options : cache["CalendarInterval2"] = {}) as CalendarInterval2;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CalendarInterval2";
  o.startDate = options.startDate ?? null;
  o.endDate = options.endDate ?? null;
  o.durationInDays = options.durationInDays ?? null;
  return o;
}

factories["CalendarInterval2"] = newCalendarInterval2;

export interface ChangeEventOptions {
  __typename?: "ChangeEvent";
  id?: ChangeEvent["id"];
  title?: ChangeEvent["title"];
  commitments?: Array<Commitment | CommitmentChangeOrder | CommitmentLike | CommitmentLikeOptions>;
  internalNote?: ChangeEvent["internalNote"];
  createdAt?: ChangeEvent["createdAt"];
  displayName?: ChangeEvent["displayName"];
  updatedAt?: ChangeEvent["updatedAt"];
  status?: ChangeEvent["status"];
  statusDetail?: ChangeEventStatusDetailOptions | ChangeEventStatus;
  projectStage?: ProjectStage | ProjectStageOptions;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  lineItems?: Array<ChangeEventLineItem | ChangeEventLineItemOptions>;
  homeownerContractChangeOrder?: HomeownerContractChangeOrder | HomeownerContractChangeOrderOptions | null;
  blueprintUrl?: Url | UrlOptions;
  name?: ChangeEvent["name"];
  history?: Array<History | HistoryOptions>;
  estimates?: Array<Estimate | EstimateOptions>;
  canCreateFinalEstimate?: ChangeEvent["canCreateFinalEstimate"];
  totalCostInCents?: ChangeEvent["totalCostInCents"];
  totalPriceInCents?: ChangeEvent["totalPriceInCents"];
  originalTotalCostInCents?: ChangeEvent["originalTotalCostInCents"];
  originalTotalPriceInCents?: ChangeEvent["originalTotalPriceInCents"];
  proposedTotalCostInCents?: ChangeEvent["proposedTotalCostInCents"];
  proposedTotalPriceInCents?: ChangeEvent["proposedTotalPriceInCents"];
  budgetImpactInCents?: ChangeEvent["budgetImpactInCents"];
  revisedBudgetInCents?: ChangeEvent["revisedBudgetInCents"];
  isHomeownerChangeEvent?: ChangeEvent["isHomeownerChangeEvent"];
  isReadyHomeManaged?: ChangeEvent["isReadyHomeManaged"];
  canEditLineItems?: PotentialOperation2 | PotentialOperation2Options;
  internalImpactInDays?: ChangeEvent["internalImpactInDays"];
  homeownerImpactInDays?: ChangeEvent["homeownerImpactInDays"];
  reasonDetails?: ChangeEvent["reasonDetails"];
  reason?: ChangeEventReason | ChangeEventReasonOptions;
  identifier?: ChangeEvent["identifier"];
  appliedTemplates?: Array<ItemTemplate | ItemTemplateOptions>;
  templateConfigs?: Array<ChangeEventTemplateConfig | ChangeEventTemplateConfigOptions>;
  projectCutoff?: ProjectCutoff | ProjectCutoffOptions | null;
  budgetPhase?: ChangeEventBudgetPhaseDetailOptions | ChangeEventBudgetPhase;
  acceptedAt?: ChangeEvent["acceptedAt"];
  approval?: Approval | ApprovalOptions | null;
  impactedCommitments?: Array<Commitment | CommitmentChangeOrder | CommitmentLike | CommitmentLikeOptions>;
  predictedApprovers?: Array<
    ApproverUser | ClientOptions | RequireTypename<InternalUserOptions> | RequireTypename<TradePartnerUserOptions>
  >;
  type?: ChangeEventTypeDetailOptions | ChangeEventType;
  canBeLocked?: PotentialOperation2 | PotentialOperation2Options;
  canSubmitForApproval?: PotentialOperation2 | PotentialOperation2Options;
  tradesToDraftCommitmentsFor?: Array<TradePartner | TradePartnerOptions>;
  impactedTrades?: Array<TradePartner | TradePartnerOptions>;
  pandaDoc?: PandaDoc | PandaDocOptions | null;
  requireSignature?: ChangeEvent["requireSignature"];
  createdBy?: ChangeEventCreatedBy | BillOptions | RequireTypename<ExpenseOptions> | null;
  readyPlan?: ReadyPlan | PlanPackage | DesignPackage | ProductOffering | ReadyPlanLike | ReadyPlanLikeOptions | null;
  originalReadyPlan?:
    | ReadyPlan
    | PlanPackage
    | DesignPackage
    | ProductOffering
    | ReadyPlanLike
    | ReadyPlanLikeOptions
    | null;
  originalReadyPlanOptions?: Array<ChangeEventOriginalOption | ChangeEventOriginalOptionOptions>;
  proposedReadyPlanOptions?: Array<ChangeEventProposedOption | ChangeEventProposedOptionOptions>;
  isContractAddendum?: ChangeEvent["isContractAddendum"];
  removedReadyPlanOptions?: Array<ChangeEventOriginalOption | ChangeEventOriginalOptionOptions>;
  addedReadyPlanOptions?: Array<ChangeEventProposedOption | ChangeEventProposedOptionOptions>;
  checkoutConfig?: CheckoutConfig | CheckoutConfigOptions | null;
  proposedOrientation?: ProjectReadyPlanConfigOrientationDetailOptions | ProjectReadyPlanConfigOrientation | null;
  hasPreSignedContract?: ChangeEvent["hasPreSignedContract"];
  document?: Document | DocumentOptions | null;
  references?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: ChangeEvent["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: ChangeEvent["isFollowed"];
}

export function newChangeEvent(options: ChangeEventOptions = {}, cache: Record<string, any> = {}): ChangeEvent {
  const o = (options.__typename ? options : cache["ChangeEvent"] = {}) as ChangeEvent;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeEvent";
  o.id = options.id ?? nextFactoryId("ChangeEvent");
  o.title = options.title ?? "title";
  o.commitments = (options.commitments ?? []).map((i) =>
    maybeNew("CommitmentLike", i, cache, options.hasOwnProperty("commitments"))
  );
  o.internalNote = options.internalNote ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.displayName = options.displayName ?? "displayName";
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.status = options.status ?? ChangeEventStatus.Draft;
  o.statusDetail = enumOrDetailOfChangeEventStatus(options.statusDetail);
  o.projectStage = maybeNew("ProjectStage", options.projectStage, cache, options.hasOwnProperty("projectStage"));
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.lineItems = (options.lineItems ?? []).map((i) =>
    maybeNew("ChangeEventLineItem", i, cache, options.hasOwnProperty("lineItems"))
  );
  o.homeownerContractChangeOrder = maybeNewOrNull(
    "HomeownerContractChangeOrder",
    options.homeownerContractChangeOrder,
    cache,
  );
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.name = options.name ?? "name";
  o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
  o.estimates = (options.estimates ?? []).map((i) =>
    maybeNew("Estimate", i, cache, options.hasOwnProperty("estimates"))
  );
  o.canCreateFinalEstimate = options.canCreateFinalEstimate ?? false;
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.totalPriceInCents = options.totalPriceInCents ?? 0;
  o.originalTotalCostInCents = options.originalTotalCostInCents ?? 0;
  o.originalTotalPriceInCents = options.originalTotalPriceInCents ?? 0;
  o.proposedTotalCostInCents = options.proposedTotalCostInCents ?? 0;
  o.proposedTotalPriceInCents = options.proposedTotalPriceInCents ?? 0;
  o.budgetImpactInCents = options.budgetImpactInCents ?? 0;
  o.revisedBudgetInCents = options.revisedBudgetInCents ?? 0;
  o.isHomeownerChangeEvent = options.isHomeownerChangeEvent ?? false;
  o.isReadyHomeManaged = options.isReadyHomeManaged ?? false;
  o.canEditLineItems = maybeNew(
    "PotentialOperation2",
    options.canEditLineItems,
    cache,
    options.hasOwnProperty("canEditLineItems"),
  );
  o.internalImpactInDays = options.internalImpactInDays ?? null;
  o.homeownerImpactInDays = options.homeownerImpactInDays ?? null;
  o.reasonDetails = options.reasonDetails ?? null;
  o.reason = maybeNew("ChangeEventReason", options.reason, cache, options.hasOwnProperty("reason"));
  o.identifier = options.identifier ?? 0;
  o.appliedTemplates = (options.appliedTemplates ?? []).map((i) =>
    maybeNew("ItemTemplate", i, cache, options.hasOwnProperty("appliedTemplates"))
  );
  o.templateConfigs = (options.templateConfigs ?? []).map((i) =>
    maybeNew("ChangeEventTemplateConfig", i, cache, options.hasOwnProperty("templateConfigs"))
  );
  o.projectCutoff = maybeNewOrNull("ProjectCutoff", options.projectCutoff, cache);
  o.budgetPhase = enumOrDetailOfChangeEventBudgetPhase(options.budgetPhase);
  o.acceptedAt = options.acceptedAt ?? null;
  o.approval = maybeNewOrNull("Approval", options.approval, cache);
  o.impactedCommitments = (options.impactedCommitments ?? []).map((i) =>
    maybeNew("CommitmentLike", i, cache, options.hasOwnProperty("impactedCommitments"))
  );
  o.predictedApprovers = (options.predictedApprovers ?? []).map((i) =>
    maybeNew(i?.__typename ?? "{Client", i, cache, options.hasOwnProperty("predictedApprovers"))
  );
  o.type = enumOrDetailOfChangeEventType(options.type);
  o.canBeLocked = maybeNew("PotentialOperation2", options.canBeLocked, cache, options.hasOwnProperty("canBeLocked"));
  o.canSubmitForApproval = maybeNew(
    "PotentialOperation2",
    options.canSubmitForApproval,
    cache,
    options.hasOwnProperty("canSubmitForApproval"),
  );
  o.tradesToDraftCommitmentsFor = (options.tradesToDraftCommitmentsFor ?? []).map((i) =>
    maybeNew("TradePartner", i, cache, options.hasOwnProperty("tradesToDraftCommitmentsFor"))
  );
  o.impactedTrades = (options.impactedTrades ?? []).map((i) =>
    maybeNew("TradePartner", i, cache, options.hasOwnProperty("impactedTrades"))
  );
  o.pandaDoc = maybeNewOrNull("PandaDoc", options.pandaDoc, cache);
  o.requireSignature = options.requireSignature ?? false;
  o.createdBy = maybeNewOrNull(options.createdBy?.__typename ?? "Bill", options.createdBy, cache);
  o.readyPlan = maybeNewOrNull("ReadyPlanLike", options.readyPlan, cache);
  o.originalReadyPlan = maybeNewOrNull("ReadyPlanLike", options.originalReadyPlan, cache);
  o.originalReadyPlanOptions = (options.originalReadyPlanOptions ?? []).map((i) =>
    maybeNew("ChangeEventOriginalOption", i, cache, options.hasOwnProperty("originalReadyPlanOptions"))
  );
  o.proposedReadyPlanOptions = (options.proposedReadyPlanOptions ?? []).map((i) =>
    maybeNew("ChangeEventProposedOption", i, cache, options.hasOwnProperty("proposedReadyPlanOptions"))
  );
  o.isContractAddendum = options.isContractAddendum ?? false;
  o.removedReadyPlanOptions = (options.removedReadyPlanOptions ?? []).map((i) =>
    maybeNew("ChangeEventOriginalOption", i, cache, options.hasOwnProperty("removedReadyPlanOptions"))
  );
  o.addedReadyPlanOptions = (options.addedReadyPlanOptions ?? []).map((i) =>
    maybeNew("ChangeEventProposedOption", i, cache, options.hasOwnProperty("addedReadyPlanOptions"))
  );
  o.checkoutConfig = maybeNewOrNull("CheckoutConfig", options.checkoutConfig, cache);
  o.proposedOrientation = enumOrDetailOrNullOfProjectReadyPlanConfigOrientation(options.proposedOrientation);
  o.hasPreSignedContract = options.hasPreSignedContract ?? false;
  o.document = maybeNewOrNull("Document", options.document, cache);
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  return o;
}

factories["ChangeEvent"] = newChangeEvent;

export interface SaveChangeEventResultOptions {
  __typename?: "SaveChangeEventResult";
  changeEvent?: ChangeEvent | ChangeEventOptions;
}

export function newSaveChangeEventResult(
  options: SaveChangeEventResultOptions = {},
  cache: Record<string, any> = {},
): SaveChangeEventResult {
  const o = (options.__typename ? options : cache["SaveChangeEventResult"] = {}) as SaveChangeEventResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveChangeEventResult";
  o.changeEvent = maybeNew("ChangeEvent", options.changeEvent, cache, options.hasOwnProperty("changeEvent"));
  return o;
}

factories["SaveChangeEventResult"] = newSaveChangeEventResult;

export interface SaveChangeEventsResultOptions {
  __typename?: "SaveChangeEventsResult";
  changeEvents?: Array<ChangeEvent | ChangeEventOptions>;
}

export function newSaveChangeEventsResult(
  options: SaveChangeEventsResultOptions = {},
  cache: Record<string, any> = {},
): SaveChangeEventsResult {
  const o = (options.__typename ? options : cache["SaveChangeEventsResult"] = {}) as SaveChangeEventsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveChangeEventsResult";
  o.changeEvents = (options.changeEvents ?? []).map((i) =>
    maybeNew("ChangeEvent", i, cache, options.hasOwnProperty("changeEvents"))
  );
  return o;
}

factories["SaveChangeEventsResult"] = newSaveChangeEventsResult;

export interface ChangeEventLineItemOptions {
  __typename?: "ChangeEventLineItem";
  id?: ChangeEventLineItem["id"];
  createdAt?: ChangeEventLineItem["createdAt"];
  updatedAt?: ChangeEventLineItem["updatedAt"];
  changeEvent?: ChangeEvent | ChangeEventOptions;
  projectItem?: ProjectItem | ProjectItemOptions;
  quantity?: ChangeEventLineItem["quantity"];
  totalPriceInCents?: ChangeEventLineItem["totalPriceInCents"];
  totalCostInCents?: ChangeEventLineItem["totalCostInCents"];
  unitCostInCents?: ChangeEventLineItem["unitCostInCents"];
  originalQuantity?: ChangeEventLineItem["originalQuantity"];
  originalTotalCostInCents?: ChangeEventLineItem["originalTotalCostInCents"];
  originalTotalPriceInCents?: ChangeEventLineItem["originalTotalPriceInCents"];
  proposedTotalCostInCents?: ChangeEventLineItem["proposedTotalCostInCents"];
  originalSelection?: HomeownerSelection | HomeownerSelectionOptions | null;
  proposedSelection?: HomeownerSelection | HomeownerSelectionOptions | null;
  item?: Item | ItemOptions;
  name?: ChangeEventLineItem["name"];
  costType?: ChangeEventLineItem["costType"];
  location?: Location | LocationOptions;
  unitOfMeasure?: UnitOfMeasure | UnitOfMeasureOptions;
  homeownerSelection?: HomeownerSelection | HomeownerSelectionOptions | null;
  displayName?: ChangeEventLineItem["displayName"];
  costConfidence?: ChangeEventLineItem["costConfidence"];
  costConfidenceDetail?: CostConfidenceDetailOptions | CostConfidence;
  type?: ChangeEventLineItem["type"];
  typeDetail?: ChangeEventLineItemTypeDetailOptions | ChangeEventLineItemType;
  specifications?: ChangeEventLineItem["specifications"];
  tradePartnerNote?: ChangeEventLineItem["tradePartnerNote"];
  canEditName?: PotentialOperation2 | PotentialOperation2Options;
  canEditCost?: PotentialOperation2 | PotentialOperation2Options;
  itemTemplateItem?:
    | ItemTemplateItemVersion
    | ItemTemplateItem
    | TakeoffLineItem
    | TakeoffLineItemVersion
    | BaseItemLike
    | BaseItemLikeOptions
    | null;
  modifyingTemplateItems?: Array<
    | ItemTemplateItemVersion
    | ItemTemplateItem
    | TakeoffLineItem
    | TakeoffLineItemVersion
    | BaseItemLike
    | BaseItemLikeOptions
  >;
  tradePartner?: TradePartner | TradePartnerOptions | null;
  originalTradePartner?: TradePartner | TradePartnerOptions | null;
  internalNote?: ChangeEventLineItem["internalNote"];
  originalBidItem?: BidItem | BidItemOptions | null;
  proposedBidItem?: BidItem | BidItemOptions | null;
  originalBidContractLineItem?: BidContractLineItem | BidContractLineItemOptions | null;
  proposedBidContractLineItem?: BidContractLineItem | BidContractLineItemOptions | null;
  proposedProduct?: Product | ProductOptions | null;
  originalProduct?: Product | ProductOptions | null;
  originalTask?: GlobalPlanTask | GlobalPlanTaskOptions | null;
  proposedTask?: GlobalPlanTask | GlobalPlanTaskOptions | null;
  originalMaterialVariant?: MaterialVariant | MaterialVariantOptions | null;
  proposedMaterialVariant?: MaterialVariant | MaterialVariantOptions | null;
  allocations?: Array<ChangeEventLineItemAllocation | ChangeEventLineItemAllocationOptions>;
  originalPackageDesignNotes?: ChangeEventLineItem["originalPackageDesignNotes"];
  proposedPackageDesignNotes?: ChangeEventLineItem["proposedPackageDesignNotes"];
}

export function newChangeEventLineItem(
  options: ChangeEventLineItemOptions = {},
  cache: Record<string, any> = {},
): ChangeEventLineItem {
  const o = (options.__typename ? options : cache["ChangeEventLineItem"] = {}) as ChangeEventLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeEventLineItem";
  o.id = options.id ?? nextFactoryId("ChangeEventLineItem");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.changeEvent = maybeNew("ChangeEvent", options.changeEvent, cache, options.hasOwnProperty("changeEvent"));
  o.projectItem = maybeNew("ProjectItem", options.projectItem, cache, options.hasOwnProperty("projectItem"));
  o.quantity = options.quantity ?? null;
  o.totalPriceInCents = options.totalPriceInCents ?? 0;
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.unitCostInCents = options.unitCostInCents ?? 0;
  o.originalQuantity = options.originalQuantity ?? null;
  o.originalTotalCostInCents = options.originalTotalCostInCents ?? 0;
  o.originalTotalPriceInCents = options.originalTotalPriceInCents ?? 0;
  o.proposedTotalCostInCents = options.proposedTotalCostInCents ?? 0;
  o.originalSelection = maybeNewOrNull("HomeownerSelection", options.originalSelection, cache);
  o.proposedSelection = maybeNewOrNull("HomeownerSelection", options.proposedSelection, cache);
  o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
  o.name = options.name ?? "name";
  o.costType = options.costType ?? CostType.Labor;
  o.location = maybeNew("Location", options.location, cache, options.hasOwnProperty("location"));
  o.unitOfMeasure = maybeNew("UnitOfMeasure", options.unitOfMeasure, cache, options.hasOwnProperty("unitOfMeasure"));
  o.homeownerSelection = maybeNewOrNull("HomeownerSelection", options.homeownerSelection, cache);
  o.displayName = options.displayName ?? "displayName";
  o.costConfidence = options.costConfidence ?? CostConfidence.Low;
  o.costConfidenceDetail = enumOrDetailOfCostConfidence(options.costConfidenceDetail);
  o.type = options.type ?? ChangeEventLineItemType.Add;
  o.typeDetail = enumOrDetailOfChangeEventLineItemType(options.typeDetail);
  o.specifications = options.specifications ?? null;
  o.tradePartnerNote = options.tradePartnerNote ?? null;
  o.canEditName = maybeNew("PotentialOperation2", options.canEditName, cache, options.hasOwnProperty("canEditName"));
  o.canEditCost = maybeNew("PotentialOperation2", options.canEditCost, cache, options.hasOwnProperty("canEditCost"));
  o.itemTemplateItem = maybeNewOrNull("BaseItemLike", options.itemTemplateItem, cache);
  o.modifyingTemplateItems = (options.modifyingTemplateItems ?? []).map((i) =>
    maybeNew("BaseItemLike", i, cache, options.hasOwnProperty("modifyingTemplateItems"))
  );
  o.tradePartner = maybeNewOrNull("TradePartner", options.tradePartner, cache);
  o.originalTradePartner = maybeNewOrNull("TradePartner", options.originalTradePartner, cache);
  o.internalNote = options.internalNote ?? null;
  o.originalBidItem = maybeNewOrNull("BidItem", options.originalBidItem, cache);
  o.proposedBidItem = maybeNewOrNull("BidItem", options.proposedBidItem, cache);
  o.originalBidContractLineItem = maybeNewOrNull("BidContractLineItem", options.originalBidContractLineItem, cache);
  o.proposedBidContractLineItem = maybeNewOrNull("BidContractLineItem", options.proposedBidContractLineItem, cache);
  o.proposedProduct = maybeNewOrNull("Product", options.proposedProduct, cache);
  o.originalProduct = maybeNewOrNull("Product", options.originalProduct, cache);
  o.originalTask = maybeNewOrNull("GlobalPlanTask", options.originalTask, cache);
  o.proposedTask = maybeNewOrNull("GlobalPlanTask", options.proposedTask, cache);
  o.originalMaterialVariant = maybeNewOrNull("MaterialVariant", options.originalMaterialVariant, cache);
  o.proposedMaterialVariant = maybeNewOrNull("MaterialVariant", options.proposedMaterialVariant, cache);
  o.allocations = (options.allocations ?? []).map((i) =>
    maybeNew("ChangeEventLineItemAllocation", i, cache, options.hasOwnProperty("allocations"))
  );
  o.originalPackageDesignNotes = options.originalPackageDesignNotes ?? null;
  o.proposedPackageDesignNotes = options.proposedPackageDesignNotes ?? null;
  return o;
}

factories["ChangeEventLineItem"] = newChangeEventLineItem;

export interface SaveChangeEventLineItemsResultOptions {
  __typename?: "SaveChangeEventLineItemsResult";
  changeEventLineItems?: Array<ChangeEventLineItem | ChangeEventLineItemOptions>;
  autoAddedLaborLines?: Array<ChangeEventLineItem | ChangeEventLineItemOptions>;
}

export function newSaveChangeEventLineItemsResult(
  options: SaveChangeEventLineItemsResultOptions = {},
  cache: Record<string, any> = {},
): SaveChangeEventLineItemsResult {
  const o =
    (options.__typename ? options : cache["SaveChangeEventLineItemsResult"] = {}) as SaveChangeEventLineItemsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveChangeEventLineItemsResult";
  o.changeEventLineItems = (options.changeEventLineItems ?? []).map((i) =>
    maybeNew("ChangeEventLineItem", i, cache, options.hasOwnProperty("changeEventLineItems"))
  );
  o.autoAddedLaborLines = (options.autoAddedLaborLines ?? []).map((i) =>
    maybeNew("ChangeEventLineItem", i, cache, options.hasOwnProperty("autoAddedLaborLines"))
  );
  return o;
}

factories["SaveChangeEventLineItemsResult"] = newSaveChangeEventLineItemsResult;

export interface ChangeEventLineItemAllocationOptions {
  __typename?: "ChangeEventLineItemAllocation";
  id?: ChangeEventLineItemAllocation["id"];
  costInCents?: ChangeEventLineItemAllocation["costInCents"];
  priceInCents?: ChangeEventLineItemAllocation["priceInCents"];
  createdAt?: ChangeEventLineItemAllocation["createdAt"];
  updatedAt?: ChangeEventLineItemAllocation["updatedAt"];
  changeEventLineItem?: ChangeEventLineItem | ChangeEventLineItemOptions;
  projectItemAllocation?: ProjectItemAllocation | ProjectItemAllocationOptions;
}

export function newChangeEventLineItemAllocation(
  options: ChangeEventLineItemAllocationOptions = {},
  cache: Record<string, any> = {},
): ChangeEventLineItemAllocation {
  const o =
    (options.__typename ? options : cache["ChangeEventLineItemAllocation"] = {}) as ChangeEventLineItemAllocation;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeEventLineItemAllocation";
  o.id = options.id ?? nextFactoryId("ChangeEventLineItemAllocation");
  o.costInCents = options.costInCents ?? 0;
  o.priceInCents = options.priceInCents ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.changeEventLineItem = maybeNew(
    "ChangeEventLineItem",
    options.changeEventLineItem,
    cache,
    options.hasOwnProperty("changeEventLineItem"),
  );
  o.projectItemAllocation = maybeNew(
    "ProjectItemAllocation",
    options.projectItemAllocation,
    cache,
    options.hasOwnProperty("projectItemAllocation"),
  );
  return o;
}

factories["ChangeEventLineItemAllocation"] = newChangeEventLineItemAllocation;

export interface ChangeEventOriginalOptionOptions {
  __typename?: "ChangeEventOriginalOption";
  id?: ChangeEventOriginalOption["id"];
  createdAt?: ChangeEventOriginalOption["createdAt"];
  priceInCents?: ChangeEventOriginalOption["priceInCents"];
  changeEvent?: ChangeEvent | ChangeEventOptions;
  readyPlanOption?: ReadyPlanOption | ReadyPlanOptionOptions;
}

export function newChangeEventOriginalOption(
  options: ChangeEventOriginalOptionOptions = {},
  cache: Record<string, any> = {},
): ChangeEventOriginalOption {
  const o = (options.__typename ? options : cache["ChangeEventOriginalOption"] = {}) as ChangeEventOriginalOption;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeEventOriginalOption";
  o.id = options.id ?? nextFactoryId("ChangeEventOriginalOption");
  o.createdAt = options.createdAt ?? newDateTime();
  o.priceInCents = options.priceInCents ?? 0;
  o.changeEvent = maybeNew("ChangeEvent", options.changeEvent, cache, options.hasOwnProperty("changeEvent"));
  o.readyPlanOption = maybeNew(
    "ReadyPlanOption",
    options.readyPlanOption,
    cache,
    options.hasOwnProperty("readyPlanOption"),
  );
  return o;
}

factories["ChangeEventOriginalOption"] = newChangeEventOriginalOption;

export interface ChangeEventProposedOptionOptions {
  __typename?: "ChangeEventProposedOption";
  id?: ChangeEventProposedOption["id"];
  createdAt?: ChangeEventProposedOption["createdAt"];
  priceInCents?: ChangeEventProposedOption["priceInCents"];
  changeEvent?: ChangeEvent | ChangeEventOptions;
  readyPlanOption?: ReadyPlanOption | ReadyPlanOptionOptions;
}

export function newChangeEventProposedOption(
  options: ChangeEventProposedOptionOptions = {},
  cache: Record<string, any> = {},
): ChangeEventProposedOption {
  const o = (options.__typename ? options : cache["ChangeEventProposedOption"] = {}) as ChangeEventProposedOption;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeEventProposedOption";
  o.id = options.id ?? nextFactoryId("ChangeEventProposedOption");
  o.createdAt = options.createdAt ?? newDateTime();
  o.priceInCents = options.priceInCents ?? 0;
  o.changeEvent = maybeNew("ChangeEvent", options.changeEvent, cache, options.hasOwnProperty("changeEvent"));
  o.readyPlanOption = maybeNew(
    "ReadyPlanOption",
    options.readyPlanOption,
    cache,
    options.hasOwnProperty("readyPlanOption"),
  );
  return o;
}

factories["ChangeEventProposedOption"] = newChangeEventProposedOption;

export interface ChangeEventReasonOptions {
  __typename?: "ChangeEventReason";
  id?: ChangeEventReason["id"];
  code?: ChangeEventReason["code"];
  name?: ChangeEventReason["name"];
  createdAt?: ChangeEventReason["createdAt"];
  updatedAt?: ChangeEventReason["updatedAt"];
  changeEvents?: Array<ChangeEvent | ChangeEventOptions>;
  isEpo?: ChangeEventReason["isEpo"];
  archived?: ChangeEventReason["archived"];
  isIncludedInVariance?: ChangeEventReason["isIncludedInVariance"];
}

export function newChangeEventReason(
  options: ChangeEventReasonOptions = {},
  cache: Record<string, any> = {},
): ChangeEventReason {
  const o = (options.__typename ? options : cache["ChangeEventReason"] = {}) as ChangeEventReason;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeEventReason";
  o.id = options.id ?? nextFactoryId("ChangeEventReason");
  o.code = options.code ?? "code";
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.changeEvents = (options.changeEvents ?? []).map((i) =>
    maybeNew("ChangeEvent", i, cache, options.hasOwnProperty("changeEvents"))
  );
  o.isEpo = options.isEpo ?? false;
  o.archived = options.archived ?? false;
  o.isIncludedInVariance = options.isIncludedInVariance ?? null;
  return o;
}

factories["ChangeEventReason"] = newChangeEventReason;

export interface SaveChangeEventReasonResultOptions {
  __typename?: "SaveChangeEventReasonResult";
  changeEventReason?: ChangeEventReason | ChangeEventReasonOptions;
}

export function newSaveChangeEventReasonResult(
  options: SaveChangeEventReasonResultOptions = {},
  cache: Record<string, any> = {},
): SaveChangeEventReasonResult {
  const o = (options.__typename ? options : cache["SaveChangeEventReasonResult"] = {}) as SaveChangeEventReasonResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveChangeEventReasonResult";
  o.changeEventReason = maybeNew(
    "ChangeEventReason",
    options.changeEventReason,
    cache,
    options.hasOwnProperty("changeEventReason"),
  );
  return o;
}

factories["SaveChangeEventReasonResult"] = newSaveChangeEventReasonResult;

export interface ChangeEventTemplateConfigOptions {
  __typename?: "ChangeEventTemplateConfig";
  id?: ChangeEventTemplateConfig["id"];
  onlyChangedInVersion?: ChangeEventTemplateConfig["onlyChangedInVersion"];
  projectStage?: ProjectStage | ProjectStageOptions;
  changeEvent?: ChangeEvent | ChangeEventOptions;
  itemTemplate?: ItemTemplate | ItemTemplateOptions;
  parent?: ItemTemplate | ReadyPlanAggregateVersion | BaseItemParentVersion | BaseItemParentVersionOptions;
  name?: ChangeEventTemplateConfig["name"];
  createdAt?: ChangeEventTemplateConfig["createdAt"];
}

export function newChangeEventTemplateConfig(
  options: ChangeEventTemplateConfigOptions = {},
  cache: Record<string, any> = {},
): ChangeEventTemplateConfig {
  const o = (options.__typename ? options : cache["ChangeEventTemplateConfig"] = {}) as ChangeEventTemplateConfig;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeEventTemplateConfig";
  o.id = options.id ?? nextFactoryId("ChangeEventTemplateConfig");
  o.onlyChangedInVersion = options.onlyChangedInVersion ?? null;
  o.projectStage = maybeNew("ProjectStage", options.projectStage, cache, options.hasOwnProperty("projectStage"));
  o.changeEvent = maybeNew("ChangeEvent", options.changeEvent, cache, options.hasOwnProperty("changeEvent"));
  o.itemTemplate = maybeNew("ItemTemplate", options.itemTemplate, cache, options.hasOwnProperty("itemTemplate"));
  o.parent = maybeNew("BaseItemParentVersion", options.parent, cache, options.hasOwnProperty("parent"));
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  return o;
}

factories["ChangeEventTemplateConfig"] = newChangeEventTemplateConfig;

export interface ChangeRequestOptions {
  __typename?: "ChangeRequest";
  id?: ChangeRequest["id"];
  title?: ChangeRequest["title"];
  name?: ChangeRequest["name"];
  rationale?: ChangeRequest["rationale"];
  estimateBudgetImpactInCents?: ChangeRequest["estimateBudgetImpactInCents"];
  estimateBudgetImpactInCentsFallback?: ChangeRequest["estimateBudgetImpactInCentsFallback"];
  estimateScheduleImpactInDays?: ChangeRequest["estimateScheduleImpactInDays"];
  createdAt?: ChangeRequest["createdAt"];
  updatedAt?: ChangeRequest["updatedAt"];
  priority?: ChangeRequestPriorityDetailOptions | ChangeRequestPriority;
  source?: ChangeRequestSourceDetailOptions | ChangeRequestSource;
  status?: ChangeRequestStatusDetailOptions | ChangeRequestStatus;
  createdBy?: User | UserOptions;
  blueprintUrl?: Url | UrlOptions;
  scopes?: Array<ChangeRequestScope | ChangeRequestScopeOptions>;
  attachments?: Array<Attachment | AttachmentOptions>;
  blocking?: Array<ChangeRequest | ChangeRequestOptions>;
  blockers?: Array<ChangeRequest | ChangeRequestOptions>;
  changeRequestAssets?: Array<ChangeRequestAsset | ChangeRequestAssetOptions>;
  toDos?: Array<ChangeRequestToDo | ChangeRequestToDoOptions>;
  history?: Array<History | HistoryOptions>;
  changeTypes?: ChangeRequest["changeTypes"];
  approval?: Approval | ApprovalOptions | null;
  predictedApprovers?: Array<
    ApproverUser | ClientOptions | RequireTypename<InternalUserOptions> | RequireTypename<TradePartnerUserOptions>
  >;
  estimateRevenueImpactInCents?: ChangeRequest["estimateRevenueImpactInCents"];
  estimateMarginImpactBasisPoints?: ChangeRequest["estimateMarginImpactBasisPoints"];
  linkedTo?: Array<ChangeRequest | ChangeRequestOptions>;
  groups?: Array<ChangeRequestGroup | ChangeRequestGroupOptions>;
  isStandardOffering?: ChangeRequest["isStandardOffering"];
  salesforceOpportunityUrl?: ChangeRequest["salesforceOpportunityUrl"];
  isUnderContract?: ChangeRequest["isUnderContract"];
  productSelection?: ChangeRequest["productSelection"];
  markupBasisPoints?: ChangeRequest["markupBasisPoints"];
  estimatedBuyerOutOfPocketInCents?: ChangeRequest["estimatedBuyerOutOfPocketInCents"];
  estimatedRetailPriceInCents?: ChangeRequest["estimatedRetailPriceInCents"];
  references?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: ChangeRequest["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: ChangeRequest["isFollowed"];
}

export function newChangeRequest(options: ChangeRequestOptions = {}, cache: Record<string, any> = {}): ChangeRequest {
  const o = (options.__typename ? options : cache["ChangeRequest"] = {}) as ChangeRequest;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeRequest";
  o.id = options.id ?? nextFactoryId("ChangeRequest");
  o.title = options.title ?? "title";
  o.name = options.name ?? "name";
  o.rationale = options.rationale ?? "rationale";
  o.estimateBudgetImpactInCents = options.estimateBudgetImpactInCents ?? null;
  o.estimateBudgetImpactInCentsFallback = options.estimateBudgetImpactInCentsFallback ?? 0;
  o.estimateScheduleImpactInDays = options.estimateScheduleImpactInDays ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.priority = enumOrDetailOfChangeRequestPriority(options.priority);
  o.source = enumOrDetailOfChangeRequestSource(options.source);
  o.status = enumOrDetailOfChangeRequestStatus(options.status);
  o.createdBy = maybeNew("User", options.createdBy, cache, options.hasOwnProperty("createdBy"));
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.scopes = (options.scopes ?? []).map((i) =>
    maybeNew("ChangeRequestScope", i, cache, options.hasOwnProperty("scopes"))
  );
  o.attachments = (options.attachments ?? []).map((i) =>
    maybeNew("Attachment", i, cache, options.hasOwnProperty("attachments"))
  );
  o.blocking = (options.blocking ?? []).map((i) =>
    maybeNew("ChangeRequest", i, cache, options.hasOwnProperty("blocking"))
  );
  o.blockers = (options.blockers ?? []).map((i) =>
    maybeNew("ChangeRequest", i, cache, options.hasOwnProperty("blockers"))
  );
  o.changeRequestAssets = (options.changeRequestAssets ?? []).map((i) =>
    maybeNew("ChangeRequestAsset", i, cache, options.hasOwnProperty("changeRequestAssets"))
  );
  o.toDos = (options.toDos ?? []).map((i) => maybeNew("ChangeRequestToDo", i, cache, options.hasOwnProperty("toDos")));
  o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
  o.changeTypes = options.changeTypes ?? [];
  o.approval = maybeNewOrNull("Approval", options.approval, cache);
  o.predictedApprovers = (options.predictedApprovers ?? []).map((i) =>
    maybeNew(i?.__typename ?? "{Client", i, cache, options.hasOwnProperty("predictedApprovers"))
  );
  o.estimateRevenueImpactInCents = options.estimateRevenueImpactInCents ?? null;
  o.estimateMarginImpactBasisPoints = options.estimateMarginImpactBasisPoints ?? null;
  o.linkedTo = (options.linkedTo ?? []).map((i) =>
    maybeNew("ChangeRequest", i, cache, options.hasOwnProperty("linkedTo"))
  );
  o.groups = (options.groups ?? []).map((i) =>
    maybeNew("ChangeRequestGroup", i, cache, options.hasOwnProperty("groups"))
  );
  o.isStandardOffering = options.isStandardOffering ?? null;
  o.salesforceOpportunityUrl = options.salesforceOpportunityUrl ?? null;
  o.isUnderContract = options.isUnderContract ?? null;
  o.productSelection = options.productSelection ?? null;
  o.markupBasisPoints = options.markupBasisPoints ?? null;
  o.estimatedBuyerOutOfPocketInCents = options.estimatedBuyerOutOfPocketInCents ?? null;
  o.estimatedRetailPriceInCents = options.estimatedRetailPriceInCents ?? null;
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  return o;
}

factories["ChangeRequest"] = newChangeRequest;

export interface ChangeRequestsPageResultOptions {
  __typename?: "ChangeRequestsPageResult";
  entities?: Array<ChangeRequest | ChangeRequestOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newChangeRequestsPageResult(
  options: ChangeRequestsPageResultOptions = {},
  cache: Record<string, any> = {},
): ChangeRequestsPageResult {
  const o = (options.__typename ? options : cache["ChangeRequestsPageResult"] = {}) as ChangeRequestsPageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeRequestsPageResult";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("ChangeRequest", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["ChangeRequestsPageResult"] = newChangeRequestsPageResult;

export interface SaveChangeRequestResultOptions {
  __typename?: "SaveChangeRequestResult";
  changeRequest?: ChangeRequest | ChangeRequestOptions;
}

export function newSaveChangeRequestResult(
  options: SaveChangeRequestResultOptions = {},
  cache: Record<string, any> = {},
): SaveChangeRequestResult {
  const o = (options.__typename ? options : cache["SaveChangeRequestResult"] = {}) as SaveChangeRequestResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveChangeRequestResult";
  o.changeRequest = maybeNew("ChangeRequest", options.changeRequest, cache, options.hasOwnProperty("changeRequest"));
  return o;
}

factories["SaveChangeRequestResult"] = newSaveChangeRequestResult;

export interface SaveChangeRequestsResultOptions {
  __typename?: "SaveChangeRequestsResult";
  changeRequests?: Array<ChangeRequest | ChangeRequestOptions>;
}

export function newSaveChangeRequestsResult(
  options: SaveChangeRequestsResultOptions = {},
  cache: Record<string, any> = {},
): SaveChangeRequestsResult {
  const o = (options.__typename ? options : cache["SaveChangeRequestsResult"] = {}) as SaveChangeRequestsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveChangeRequestsResult";
  o.changeRequests = (options.changeRequests ?? []).map((i) =>
    maybeNew("ChangeRequest", i, cache, options.hasOwnProperty("changeRequests"))
  );
  return o;
}

factories["SaveChangeRequestsResult"] = newSaveChangeRequestsResult;

export interface ChangeRequestApproverSubjectDataOptions {
  __typename?: "ChangeRequestApproverSubjectData";
  businessFunction?: ChangeRequestApproverSubjectData["businessFunction"];
  autoApprovalAmountInCents?: ChangeRequestApproverSubjectData["autoApprovalAmountInCents"];
}

export function newChangeRequestApproverSubjectData(
  options: ChangeRequestApproverSubjectDataOptions = {},
  cache: Record<string, any> = {},
): ChangeRequestApproverSubjectData {
  const o =
    (options.__typename ? options : cache["ChangeRequestApproverSubjectData"] = {}) as ChangeRequestApproverSubjectData;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeRequestApproverSubjectData";
  o.businessFunction = options.businessFunction ?? "businessFunction";
  o.autoApprovalAmountInCents = options.autoApprovalAmountInCents ?? null;
  return o;
}

factories["ChangeRequestApproverSubjectData"] = newChangeRequestApproverSubjectData;

export interface ChangeRequestAssetOptions {
  __typename?: "ChangeRequestAsset";
  id?: ChangeRequestAsset["id"];
  name?: ChangeRequestAsset["name"];
  deletedAt?: ChangeRequestAsset["deletedAt"];
  createdAt?: ChangeRequestAsset["createdAt"];
  updatedAt?: ChangeRequestAsset["updatedAt"];
  functionType?: BusinessFunctionTypeDetailOptions | BusinessFunctionType;
  platform?: ChangeRequestAssetPlatformDetailOptions | ChangeRequestAssetPlatform;
  implementationReviewer?: ProjectRoleDetailOptions | ProjectRole | null;
  changeRequests?: Array<ChangeRequest | ChangeRequestOptions>;
  scopes?: ChangeRequestAsset["scopes"];
  implementer?: ProjectRoleDetailOptions | ProjectRole;
  requiredForChangeRequestSource?: ChangeRequestAsset["requiredForChangeRequestSource"];
  systemChangeRequestAsset?: SystemChangeRequestAssetDetailOptions | SystemChangeRequestAsset | null;
}

export function newChangeRequestAsset(
  options: ChangeRequestAssetOptions = {},
  cache: Record<string, any> = {},
): ChangeRequestAsset {
  const o = (options.__typename ? options : cache["ChangeRequestAsset"] = {}) as ChangeRequestAsset;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeRequestAsset";
  o.id = options.id ?? nextFactoryId("ChangeRequestAsset");
  o.name = options.name ?? "name";
  o.deletedAt = options.deletedAt ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.functionType = enumOrDetailOfBusinessFunctionType(options.functionType);
  o.platform = enumOrDetailOfChangeRequestAssetPlatform(options.platform);
  o.implementationReviewer = enumOrDetailOrNullOfProjectRole(options.implementationReviewer);
  o.changeRequests = (options.changeRequests ?? []).map((i) =>
    maybeNew("ChangeRequest", i, cache, options.hasOwnProperty("changeRequests"))
  );
  o.scopes = options.scopes ?? [];
  o.implementer = enumOrDetailOfProjectRole(options.implementer);
  o.requiredForChangeRequestSource = options.requiredForChangeRequestSource ?? [];
  o.systemChangeRequestAsset = enumOrDetailOrNullOfSystemChangeRequestAsset(options.systemChangeRequestAsset);
  return o;
}

factories["ChangeRequestAsset"] = newChangeRequestAsset;

export interface SaveChangeRequestAssetsResultOptions {
  __typename?: "SaveChangeRequestAssetsResult";
  changeRequestAssets?: Array<ChangeRequestAsset | ChangeRequestAssetOptions>;
}

export function newSaveChangeRequestAssetsResult(
  options: SaveChangeRequestAssetsResultOptions = {},
  cache: Record<string, any> = {},
): SaveChangeRequestAssetsResult {
  const o =
    (options.__typename ? options : cache["SaveChangeRequestAssetsResult"] = {}) as SaveChangeRequestAssetsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveChangeRequestAssetsResult";
  o.changeRequestAssets = (options.changeRequestAssets ?? []).map((i) =>
    maybeNew("ChangeRequestAsset", i, cache, options.hasOwnProperty("changeRequestAssets"))
  );
  return o;
}

factories["SaveChangeRequestAssetsResult"] = newSaveChangeRequestAssetsResult;

export interface ChangeRequestAssetsPageResultOptions {
  __typename?: "ChangeRequestAssetsPageResult";
  entities?: Array<ChangeRequestAsset | ChangeRequestAssetOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newChangeRequestAssetsPageResult(
  options: ChangeRequestAssetsPageResultOptions = {},
  cache: Record<string, any> = {},
): ChangeRequestAssetsPageResult {
  const o =
    (options.__typename ? options : cache["ChangeRequestAssetsPageResult"] = {}) as ChangeRequestAssetsPageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeRequestAssetsPageResult";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("ChangeRequestAsset", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["ChangeRequestAssetsPageResult"] = newChangeRequestAssetsPageResult;

export interface ChangeRequestGroupOptions {
  __typename?: "ChangeRequestGroup";
  id?: ChangeRequestGroup["id"];
  name?: ChangeRequestGroup["name"];
  createdAt?: ChangeRequestGroup["createdAt"];
  updatedAt?: ChangeRequestGroup["updatedAt"];
  changeRequests?: Array<ChangeRequest | ChangeRequestOptions>;
  salesforceOpportunityLink?: ChangeRequestGroup["salesforceOpportunityLink"];
  underContract?: ChangeRequestGroup["underContract"];
}

export function newChangeRequestGroup(
  options: ChangeRequestGroupOptions = {},
  cache: Record<string, any> = {},
): ChangeRequestGroup {
  const o = (options.__typename ? options : cache["ChangeRequestGroup"] = {}) as ChangeRequestGroup;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeRequestGroup";
  o.id = options.id ?? nextFactoryId("ChangeRequestGroup");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.changeRequests = (options.changeRequests ?? []).map((i) =>
    maybeNew("ChangeRequest", i, cache, options.hasOwnProperty("changeRequests"))
  );
  o.salesforceOpportunityLink = options.salesforceOpportunityLink ?? null;
  o.underContract = options.underContract ?? null;
  return o;
}

factories["ChangeRequestGroup"] = newChangeRequestGroup;

export interface SaveChangeRequestGroupResultOptions {
  __typename?: "SaveChangeRequestGroupResult";
  changeRequestGroup?: ChangeRequestGroup | ChangeRequestGroupOptions;
}

export function newSaveChangeRequestGroupResult(
  options: SaveChangeRequestGroupResultOptions = {},
  cache: Record<string, any> = {},
): SaveChangeRequestGroupResult {
  const o = (options.__typename ? options : cache["SaveChangeRequestGroupResult"] = {}) as SaveChangeRequestGroupResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveChangeRequestGroupResult";
  o.changeRequestGroup = maybeNew(
    "ChangeRequestGroup",
    options.changeRequestGroup,
    cache,
    options.hasOwnProperty("changeRequestGroup"),
  );
  return o;
}

factories["SaveChangeRequestGroupResult"] = newSaveChangeRequestGroupResult;

export interface SaveChangeRequestGroupsResultOptions {
  __typename?: "SaveChangeRequestGroupsResult";
  changeRequestGroups?: Array<ChangeRequestGroup | ChangeRequestGroupOptions>;
}

export function newSaveChangeRequestGroupsResult(
  options: SaveChangeRequestGroupsResultOptions = {},
  cache: Record<string, any> = {},
): SaveChangeRequestGroupsResult {
  const o =
    (options.__typename ? options : cache["SaveChangeRequestGroupsResult"] = {}) as SaveChangeRequestGroupsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveChangeRequestGroupsResult";
  o.changeRequestGroups = (options.changeRequestGroups ?? []).map((i) =>
    maybeNew("ChangeRequestGroup", i, cache, options.hasOwnProperty("changeRequestGroups"))
  );
  return o;
}

factories["SaveChangeRequestGroupsResult"] = newSaveChangeRequestGroupsResult;

export interface ChangeRequestScopeOptions {
  __typename?: "ChangeRequestScope";
  id?: ChangeRequestScope["id"];
  createdAt?: ChangeRequestScope["createdAt"];
  updatedAt?: ChangeRequestScope["updatedAt"];
  changeRequest?: ChangeRequest | ChangeRequestOptions;
  target?:
    | ChangeRequestScopeTarget
    | StandaloneProjectOptions
    | RequireTypename<RegionOptions>
    | RequireTypename<DevelopmentOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>;
  deletedAt?: ChangeRequestScope["deletedAt"];
}

export function newChangeRequestScope(
  options: ChangeRequestScopeOptions = {},
  cache: Record<string, any> = {},
): ChangeRequestScope {
  const o = (options.__typename ? options : cache["ChangeRequestScope"] = {}) as ChangeRequestScope;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeRequestScope";
  o.id = options.id ?? nextFactoryId("ChangeRequestScope");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.changeRequest = maybeNew("ChangeRequest", options.changeRequest, cache, options.hasOwnProperty("changeRequest"));
  o.target = maybeNew(options.target?.__typename ?? "StandaloneProject", options.target, cache);
  o.deletedAt = options.deletedAt ?? null;
  return o;
}

factories["ChangeRequestScope"] = newChangeRequestScope;

export interface ChangeRequestToDoOptions {
  __typename?: "ChangeRequestToDo";
  id?: ChangeRequestToDo["id"];
  name?: ChangeRequestToDo["name"];
  description?: ChangeRequestToDo["description"];
  deletedAt?: ChangeRequestToDo["deletedAt"];
  createdAt?: ChangeRequestToDo["createdAt"];
  updatedAt?: ChangeRequestToDo["updatedAt"];
  dueDate?: ChangeRequestToDo["dueDate"];
  order?: ChangeRequestToDo["order"];
  urgent?: ChangeRequestToDo["urgent"];
  status?: ToDoStatusDetailOptions | ToDoStatus;
  type?: ToDoTypeDetailOptions | ToDoType;
  createdBy?: User | UserOptions;
  attachments?: Array<Attachment | AttachmentOptions>;
  checklistItems?: Array<ToDoChecklistItem | ToDoChecklistItemOptions>;
  assignees?: Array<User | UserOptions>;
  parent?:
    | ToDoParent
    | StandaloneProjectOptions
    | RequireTypename<RegionOptions>
    | RequireTypename<CohortOptions>
    | RequireTypename<DevelopmentOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>
    | null;
  priorityGroup?: ChangeRequestToDo["priorityGroup"];
  changeRequestToDoType?: ChangeRequestToDoTypeDetailOptions | ChangeRequestToDoType;
  businessFunction?: BusinessFunction | BusinessFunctionOptions;
  changeRequest?: ChangeRequest | ChangeRequestOptions;
  changeRequestAsset?: ChangeRequestAsset | ChangeRequestAssetOptions | null;
  originalAssignee?: User | UserOptions;
  blueprintUrl?: Url | UrlOptions;
  references?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: ChangeRequestToDo["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: ChangeRequestToDo["isFollowed"];
}

export function newChangeRequestToDo(
  options: ChangeRequestToDoOptions = {},
  cache: Record<string, any> = {},
): ChangeRequestToDo {
  const o = (options.__typename ? options : cache["ChangeRequestToDo"] = {}) as ChangeRequestToDo;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeRequestToDo";
  o.id = options.id ?? nextFactoryId("ChangeRequestToDo");
  o.name = options.name ?? "name";
  o.description = options.description ?? null;
  o.deletedAt = options.deletedAt ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.dueDate = options.dueDate ?? null;
  o.order = options.order ?? "order";
  o.urgent = options.urgent ?? false;
  o.status = enumOrDetailOfToDoStatus(options.status);
  o.type = enumOrDetailOfToDoType(options.type);
  o.createdBy = maybeNew("User", options.createdBy, cache, options.hasOwnProperty("createdBy"));
  o.attachments = (options.attachments ?? []).map((i) =>
    maybeNew("Attachment", i, cache, options.hasOwnProperty("attachments"))
  );
  o.checklistItems = (options.checklistItems ?? []).map((i) =>
    maybeNew("ToDoChecklistItem", i, cache, options.hasOwnProperty("checklistItems"))
  );
  o.assignees = (options.assignees ?? []).map((i) => maybeNew("User", i, cache, options.hasOwnProperty("assignees")));
  o.parent = maybeNewOrNull(options.parent?.__typename ?? "StandaloneProject", options.parent, cache);
  o.priorityGroup = options.priorityGroup ?? 0;
  o.changeRequestToDoType = enumOrDetailOfChangeRequestToDoType(options.changeRequestToDoType);
  o.businessFunction = maybeNew(
    "BusinessFunction",
    options.businessFunction,
    cache,
    options.hasOwnProperty("businessFunction"),
  );
  o.changeRequest = maybeNew("ChangeRequest", options.changeRequest, cache, options.hasOwnProperty("changeRequest"));
  o.changeRequestAsset = maybeNewOrNull("ChangeRequestAsset", options.changeRequestAsset, cache);
  o.originalAssignee = maybeNew("User", options.originalAssignee, cache, options.hasOwnProperty("originalAssignee"));
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  return o;
}

factories["ChangeRequestToDo"] = newChangeRequestToDo;

export interface CheckoutConfigOptions {
  __typename?: "CheckoutConfig";
  id?: CheckoutConfig["id"];
  name?: CheckoutConfig["name"];
  reservedAt?: CheckoutConfig["reservedAt"];
  expiresAt?: CheckoutConfig["expiresAt"];
  status?: CheckoutConfig["status"];
  customerEmail?: CheckoutConfig["customerEmail"];
  customerFirstName?: CheckoutConfig["customerFirstName"];
  customerLastName?: CheckoutConfig["customerLastName"];
  customerPhone?: CheckoutConfig["customerPhone"];
  structure?: Structure | StructureOptions;
  community?: Community | CommunityOptions;
  productOffering?: ProductOffering | ProductOfferingOptions | null;
  readyPlan?: ReadyPlan | PlanPackage | DesignPackage | ProductOffering | ReadyPlanLike | ReadyPlanLikeOptions | null;
  readyPlanOptions?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  isReversed?: CheckoutConfig["isReversed"];
  options?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  optionGroups?: Array<CheckoutConfigOptionGroup | CheckoutConfigOptionGroupOptions>;
  mhSalesPriceInCents?: CheckoutConfig["mhSalesPriceInCents"];
  aduSalesPriceInCents?: CheckoutConfig["aduSalesPriceInCents"];
  salesPriceInCents?: CheckoutConfig["salesPriceInCents"];
  mhTotalPriceInCents?: CheckoutConfig["mhTotalPriceInCents"];
  aduTotalPriceInCents?: CheckoutConfig["aduTotalPriceInCents"];
  totalPriceInCents?: CheckoutConfig["totalPriceInCents"];
  createdAt?: CheckoutConfig["createdAt"];
  updatedAt?: CheckoutConfig["updatedAt"];
  checkoutUrl?: Url | UrlOptions;
  pricingTraceUrl?: Url | UrlOptions | null;
  canChangeProductOffering?: PotentialOperation2 | PotentialOperation2Options;
  canEdit?: PotentialOperation2 | PotentialOperation2Options;
  programData?: ProgramData | ProgramDataOptions | null;
  aduProgramData?: ProgramData | ProgramDataOptions | null;
  rendering?: Asset | AssetOptions | null;
  interiorRenderings?: Array<InteriorRoomRendering | InteriorRoomRenderingOptions>;
  renderings?: Array<RenderingAsset | RenderingAssetOptions>;
  storedPriceInCents?: CheckoutConfig["storedPriceInCents"];
  createdBy?: User | UserOptions | null;
  interiorSubSteps?: Array<CheckoutConfigInteriorSubStep | CheckoutConfigInteriorSubStepOptions>;
  insideMapsTextureSwaps?: InsideMapsTextureSwaps | InsideMapsTextureSwapsOptions | null;
  insideMapsRoomRenderings?: Array<InsideMapsRoomRendering | InsideMapsRoomRenderingOptions>;
  homeowners?: Array<Homeowner | HomeownerOptions>;
  aggregateVersion?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  changeEvents?: Array<ChangeEvent | ChangeEventOptions>;
  archivedAt?: CheckoutConfig["archivedAt"];
  useStackedPricing?: CheckoutConfig["useStackedPricing"];
  estimatedInvoiceSchedule?: Array<EstimatedInvoiceScheduleItem | EstimatedInvoiceScheduleItemOptions>;
  buildablePlans?: Array<ProductOffering | ProductOfferingOptions>;
  buildableAduPlans?: Array<ProductOffering | ProductOfferingOptions>;
  aduProductOffering?: ProductOffering | ProductOfferingOptions | null;
  aduAggregateVersion?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  potentialAdus?: Array<ProductOffering | ProductOfferingOptions>;
}

export function newCheckoutConfig(
  options: CheckoutConfigOptions = {},
  cache: Record<string, any> = {},
): CheckoutConfig {
  const o = (options.__typename ? options : cache["CheckoutConfig"] = {}) as CheckoutConfig;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CheckoutConfig";
  o.id = options.id ?? nextFactoryId("CheckoutConfig");
  o.name = options.name ?? null;
  o.reservedAt = options.reservedAt ?? null;
  o.expiresAt = options.expiresAt ?? null;
  o.status = options.status ?? CheckoutConfigStatus.Draft;
  o.customerEmail = options.customerEmail ?? null;
  o.customerFirstName = options.customerFirstName ?? null;
  o.customerLastName = options.customerLastName ?? null;
  o.customerPhone = options.customerPhone ?? null;
  o.structure = maybeNew("Structure", options.structure, cache, options.hasOwnProperty("structure"));
  o.community = maybeNew("Community", options.community, cache, options.hasOwnProperty("community"));
  o.productOffering = maybeNewOrNull("ProductOffering", options.productOffering, cache);
  o.readyPlan = maybeNewOrNull("ReadyPlanLike", options.readyPlan, cache);
  o.readyPlanOptions = (options.readyPlanOptions ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("readyPlanOptions"))
  );
  o.isReversed = options.isReversed ?? false;
  o.options = (options.options ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("options"))
  );
  o.optionGroups = (options.optionGroups ?? []).map((i) =>
    maybeNew("CheckoutConfigOptionGroup", i, cache, options.hasOwnProperty("optionGroups"))
  );
  o.mhSalesPriceInCents = options.mhSalesPriceInCents ?? 0;
  o.aduSalesPriceInCents = options.aduSalesPriceInCents ?? 0;
  o.salesPriceInCents = options.salesPriceInCents ?? 0;
  o.mhTotalPriceInCents = options.mhTotalPriceInCents ?? 0;
  o.aduTotalPriceInCents = options.aduTotalPriceInCents ?? 0;
  o.totalPriceInCents = options.totalPriceInCents ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.checkoutUrl = maybeNew("Url", options.checkoutUrl, cache, options.hasOwnProperty("checkoutUrl"));
  o.pricingTraceUrl = maybeNewOrNull("Url", options.pricingTraceUrl, cache);
  o.canChangeProductOffering = maybeNew(
    "PotentialOperation2",
    options.canChangeProductOffering,
    cache,
    options.hasOwnProperty("canChangeProductOffering"),
  );
  o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
  o.programData = maybeNewOrNull("ProgramData", options.programData, cache);
  o.aduProgramData = maybeNewOrNull("ProgramData", options.aduProgramData, cache);
  o.rendering = maybeNewOrNull("Asset", options.rendering, cache);
  o.interiorRenderings = (options.interiorRenderings ?? []).map((i) =>
    maybeNew("InteriorRoomRendering", i, cache, options.hasOwnProperty("interiorRenderings"))
  );
  o.renderings = (options.renderings ?? []).map((i) =>
    maybeNew("RenderingAsset", i, cache, options.hasOwnProperty("renderings"))
  );
  o.storedPriceInCents = options.storedPriceInCents ?? null;
  o.createdBy = maybeNewOrNull("User", options.createdBy, cache);
  o.interiorSubSteps = (options.interiorSubSteps ?? []).map((i) =>
    maybeNew("CheckoutConfigInteriorSubStep", i, cache, options.hasOwnProperty("interiorSubSteps"))
  );
  o.insideMapsTextureSwaps = maybeNewOrNull("InsideMapsTextureSwaps", options.insideMapsTextureSwaps, cache);
  o.insideMapsRoomRenderings = (options.insideMapsRoomRenderings ?? []).map((i) =>
    maybeNew("InsideMapsRoomRendering", i, cache, options.hasOwnProperty("insideMapsRoomRenderings"))
  );
  o.homeowners = (options.homeowners ?? []).map((i) =>
    maybeNew("Homeowner", i, cache, options.hasOwnProperty("homeowners"))
  );
  o.aggregateVersion = maybeNewOrNull("ReadyPlanAggregateVersion", options.aggregateVersion, cache);
  o.changeEvents = (options.changeEvents ?? []).map((i) =>
    maybeNew("ChangeEvent", i, cache, options.hasOwnProperty("changeEvents"))
  );
  o.archivedAt = options.archivedAt ?? null;
  o.useStackedPricing = options.useStackedPricing ?? false;
  o.estimatedInvoiceSchedule = (options.estimatedInvoiceSchedule ?? []).map((i) =>
    maybeNew("EstimatedInvoiceScheduleItem", i, cache, options.hasOwnProperty("estimatedInvoiceSchedule"))
  );
  o.buildablePlans = (options.buildablePlans ?? []).map((i) =>
    maybeNew("ProductOffering", i, cache, options.hasOwnProperty("buildablePlans"))
  );
  o.buildableAduPlans = (options.buildableAduPlans ?? []).map((i) =>
    maybeNew("ProductOffering", i, cache, options.hasOwnProperty("buildableAduPlans"))
  );
  o.aduProductOffering = maybeNewOrNull("ProductOffering", options.aduProductOffering, cache);
  o.aduAggregateVersion = maybeNewOrNull("ReadyPlanAggregateVersion", options.aduAggregateVersion, cache);
  o.potentialAdus = (options.potentialAdus ?? []).map((i) =>
    maybeNew("ProductOffering", i, cache, options.hasOwnProperty("potentialAdus"))
  );
  return o;
}

factories["CheckoutConfig"] = newCheckoutConfig;

export interface EstimatedInvoiceScheduleItemOptions {
  __typename?: "EstimatedInvoiceScheduleItem";
  costCodeInvoiceCategory?: EstimatedInvoiceScheduleItem["costCodeInvoiceCategory"];
  invoiceAmountInCents?: EstimatedInvoiceScheduleItem["invoiceAmountInCents"];
}

export function newEstimatedInvoiceScheduleItem(
  options: EstimatedInvoiceScheduleItemOptions = {},
  cache: Record<string, any> = {},
): EstimatedInvoiceScheduleItem {
  const o = (options.__typename ? options : cache["EstimatedInvoiceScheduleItem"] = {}) as EstimatedInvoiceScheduleItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "EstimatedInvoiceScheduleItem";
  o.costCodeInvoiceCategory = options.costCodeInvoiceCategory ?? CostCodeInvoiceCategory.PreCon;
  o.invoiceAmountInCents = options.invoiceAmountInCents ?? 0;
  return o;
}

factories["EstimatedInvoiceScheduleItem"] = newEstimatedInvoiceScheduleItem;

export interface CheckoutConfigOptionGroupOptions {
  __typename?: "CheckoutConfigOptionGroup";
  id?: CheckoutConfigOptionGroup["id"];
  step?: CheckoutConfigOptionGroup["step"];
  subStepNumber?: CheckoutConfigOptionGroup["subStepNumber"];
  group?: ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions;
  options?: Array<CheckoutConfigPotentialOption | CheckoutConfigPotentialOptionOptions>;
  selectedOption?: CheckoutConfigPotentialOption | CheckoutConfigPotentialOptionOptions | null;
  cutoffDate?: CheckoutConfigOptionGroup["cutoffDate"];
  isEnabled?: CheckoutConfigOptionGroup["isEnabled"];
  parentGroup?: ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions | null;
  childGroup?: ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions | null;
}

export function newCheckoutConfigOptionGroup(
  options: CheckoutConfigOptionGroupOptions = {},
  cache: Record<string, any> = {},
): CheckoutConfigOptionGroup {
  const o = (options.__typename ? options : cache["CheckoutConfigOptionGroup"] = {}) as CheckoutConfigOptionGroup;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CheckoutConfigOptionGroup";
  o.id = options.id ?? nextFactoryId("CheckoutConfigOptionGroup");
  o.step = options.step ?? CheckoutConfigOptionGroupStep.ExteriorElevation;
  o.subStepNumber = options.subStepNumber ?? null;
  o.group = maybeNew("ReadyPlanOptionGroup", options.group, cache, options.hasOwnProperty("group"));
  o.options = (options.options ?? []).map((i) =>
    maybeNew("CheckoutConfigPotentialOption", i, cache, options.hasOwnProperty("options"))
  );
  o.selectedOption = maybeNewOrNull("CheckoutConfigPotentialOption", options.selectedOption, cache);
  o.cutoffDate = options.cutoffDate ?? null;
  o.isEnabled = options.isEnabled ?? false;
  o.parentGroup = maybeNewOrNull("ReadyPlanOptionGroup", options.parentGroup, cache);
  o.childGroup = maybeNewOrNull("ReadyPlanOptionGroup", options.childGroup, cache);
  return o;
}

factories["CheckoutConfigOptionGroup"] = newCheckoutConfigOptionGroup;

export interface CheckoutConfigPotentialOptionOptions {
  __typename?: "CheckoutConfigPotentialOption";
  id?: CheckoutConfigPotentialOption["id"];
  option?: ReadyPlanOption | ReadyPlanOptionOptions;
  isSelected?: CheckoutConfigPotentialOption["isSelected"];
  isEnabled?: CheckoutConfigPotentialOption["isEnabled"];
  canBeSelected?: PotentialOperation2 | PotentialOperation2Options;
  showOnSummary?: CheckoutConfigPotentialOption["showOnSummary"];
  totalPriceInCents?: CheckoutConfigPotentialOption["totalPriceInCents"];
  packageOptionMaterials?: Array<MaterialVariant | MaterialVariantOptions>;
  primaryProduct?: MaterialVariant | MaterialVariantOptions | null;
  displayProducts?: Array<MaterialVariant | MaterialVariantOptions>;
  includedBy?: CheckoutConfigPotentialOption | CheckoutConfigPotentialOptionOptions | null;
  includedByRoot?: CheckoutConfigPotentialOption | CheckoutConfigPotentialOptionOptions | null;
}

export function newCheckoutConfigPotentialOption(
  options: CheckoutConfigPotentialOptionOptions = {},
  cache: Record<string, any> = {},
): CheckoutConfigPotentialOption {
  const o =
    (options.__typename ? options : cache["CheckoutConfigPotentialOption"] = {}) as CheckoutConfigPotentialOption;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CheckoutConfigPotentialOption";
  o.id = options.id ?? nextFactoryId("CheckoutConfigPotentialOption");
  o.option = maybeNew("ReadyPlanOption", options.option, cache, options.hasOwnProperty("option"));
  o.isSelected = options.isSelected ?? false;
  o.isEnabled = options.isEnabled ?? false;
  o.canBeSelected = maybeNew(
    "PotentialOperation2",
    options.canBeSelected,
    cache,
    options.hasOwnProperty("canBeSelected"),
  );
  o.showOnSummary = options.showOnSummary ?? false;
  o.totalPriceInCents = options.totalPriceInCents ?? 0;
  o.packageOptionMaterials = (options.packageOptionMaterials ?? []).map((i) =>
    maybeNew("MaterialVariant", i, cache, options.hasOwnProperty("packageOptionMaterials"))
  );
  o.primaryProduct = maybeNewOrNull("MaterialVariant", options.primaryProduct, cache);
  o.displayProducts = (options.displayProducts ?? []).map((i) =>
    maybeNew("MaterialVariant", i, cache, options.hasOwnProperty("displayProducts"))
  );
  o.includedBy = maybeNewOrNull("CheckoutConfigPotentialOption", options.includedBy, cache);
  o.includedByRoot = maybeNewOrNull("CheckoutConfigPotentialOption", options.includedByRoot, cache);
  return o;
}

factories["CheckoutConfigPotentialOption"] = newCheckoutConfigPotentialOption;

export interface CheckoutConfigPackageOptionSlotOptions {
  __typename?: "CheckoutConfigPackageOptionSlot";
  id?: CheckoutConfigPackageOptionSlot["id"];
  location?: Location | LocationOptions;
  materialVariant?: MaterialVariant | MaterialVariantOptions;
}

export function newCheckoutConfigPackageOptionSlot(
  options: CheckoutConfigPackageOptionSlotOptions = {},
  cache: Record<string, any> = {},
): CheckoutConfigPackageOptionSlot {
  const o =
    (options.__typename ? options : cache["CheckoutConfigPackageOptionSlot"] = {}) as CheckoutConfigPackageOptionSlot;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CheckoutConfigPackageOptionSlot";
  o.id = options.id ?? nextFactoryId("CheckoutConfigPackageOptionSlot");
  o.location = maybeNew("Location", options.location, cache, options.hasOwnProperty("location"));
  o.materialVariant = maybeNew(
    "MaterialVariant",
    options.materialVariant,
    cache,
    options.hasOwnProperty("materialVariant"),
  );
  return o;
}

factories["CheckoutConfigPackageOptionSlot"] = newCheckoutConfigPackageOptionSlot;

export interface CheckoutConfigPackageOptionProductOptions {
  __typename?: "CheckoutConfigPackageOptionProduct";
  id?: CheckoutConfigPackageOptionProduct["id"];
  slotId?: CheckoutConfigPackageOptionProduct["slotId"];
  placeholder?: MaterialVariant | MaterialVariantOptions;
  location?: Location | LocationOptions;
  product?: MaterialVariant | MaterialVariantOptions;
  displayPackageOptionsAsSingleProduct?: CheckoutConfigPackageOptionProduct["displayPackageOptionsAsSingleProduct"];
}

export function newCheckoutConfigPackageOptionProduct(
  options: CheckoutConfigPackageOptionProductOptions = {},
  cache: Record<string, any> = {},
): CheckoutConfigPackageOptionProduct {
  const o =
    (options.__typename
      ? options
      : cache["CheckoutConfigPackageOptionProduct"] = {}) as CheckoutConfigPackageOptionProduct;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CheckoutConfigPackageOptionProduct";
  o.id = options.id ?? nextFactoryId("CheckoutConfigPackageOptionProduct");
  o.slotId = options.slotId ?? "slotId";
  o.placeholder = maybeNew("MaterialVariant", options.placeholder, cache, options.hasOwnProperty("placeholder"));
  o.location = maybeNew("Location", options.location, cache, options.hasOwnProperty("location"));
  o.product = maybeNew("MaterialVariant", options.product, cache, options.hasOwnProperty("product"));
  o.displayPackageOptionsAsSingleProduct = options.displayPackageOptionsAsSingleProduct ?? false;
  return o;
}

factories["CheckoutConfigPackageOptionProduct"] = newCheckoutConfigPackageOptionProduct;

export interface SaveCheckoutConfigResultOptions {
  __typename?: "SaveCheckoutConfigResult";
  checkoutConfig?: CheckoutConfig | CheckoutConfigOptions;
}

export function newSaveCheckoutConfigResult(
  options: SaveCheckoutConfigResultOptions = {},
  cache: Record<string, any> = {},
): SaveCheckoutConfigResult {
  const o = (options.__typename ? options : cache["SaveCheckoutConfigResult"] = {}) as SaveCheckoutConfigResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveCheckoutConfigResult";
  o.checkoutConfig = maybeNew(
    "CheckoutConfig",
    options.checkoutConfig,
    cache,
    options.hasOwnProperty("checkoutConfig"),
  );
  return o;
}

factories["SaveCheckoutConfigResult"] = newSaveCheckoutConfigResult;

export interface CheckoutConfigsPageOptions {
  __typename?: "CheckoutConfigsPage";
  entities?: Array<CheckoutConfig | CheckoutConfigOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newCheckoutConfigsPage(
  options: CheckoutConfigsPageOptions = {},
  cache: Record<string, any> = {},
): CheckoutConfigsPage {
  const o = (options.__typename ? options : cache["CheckoutConfigsPage"] = {}) as CheckoutConfigsPage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CheckoutConfigsPage";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("CheckoutConfig", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["CheckoutConfigsPage"] = newCheckoutConfigsPage;

export interface CheckoutPricingTraceOptions {
  __typename?: "CheckoutPricingTrace";
  checkoutConfig?: CheckoutConfig | CheckoutConfigOptions | null;
  baseHousePriceInCents?: CheckoutPricingTrace["baseHousePriceInCents"];
  includedPriceInCents?: CheckoutPricingTrace["includedPriceInCents"];
  selectedPriceInCents?: CheckoutPricingTrace["selectedPriceInCents"];
  optionGroups?: Array<CheckoutPricingTraceOptionGroup | CheckoutPricingTraceOptionGroupOptions>;
}

export function newCheckoutPricingTrace(
  options: CheckoutPricingTraceOptions = {},
  cache: Record<string, any> = {},
): CheckoutPricingTrace {
  const o = (options.__typename ? options : cache["CheckoutPricingTrace"] = {}) as CheckoutPricingTrace;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CheckoutPricingTrace";
  o.checkoutConfig = maybeNewOrNull("CheckoutConfig", options.checkoutConfig, cache);
  o.baseHousePriceInCents = options.baseHousePriceInCents ?? 0;
  o.includedPriceInCents = options.includedPriceInCents ?? 0;
  o.selectedPriceInCents = options.selectedPriceInCents ?? 0;
  o.optionGroups = (options.optionGroups ?? []).map((i) =>
    maybeNew("CheckoutPricingTraceOptionGroup", i, cache, options.hasOwnProperty("optionGroups"))
  );
  return o;
}

factories["CheckoutPricingTrace"] = newCheckoutPricingTrace;

export interface CheckoutPricingTraceOptionGroupOptions {
  __typename?: "CheckoutPricingTraceOptionGroup";
  group?: ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions;
  included?: CheckoutPricingTraceOption | CheckoutPricingTraceOptionOptions | null;
  selected?: CheckoutPricingTraceOption | CheckoutPricingTraceOptionOptions | null;
  availableCreditInCents?: CheckoutPricingTraceOptionGroup["availableCreditInCents"];
  priceChangeInCents?: CheckoutPricingTraceOptionGroup["priceChangeInCents"];
}

export function newCheckoutPricingTraceOptionGroup(
  options: CheckoutPricingTraceOptionGroupOptions = {},
  cache: Record<string, any> = {},
): CheckoutPricingTraceOptionGroup {
  const o =
    (options.__typename ? options : cache["CheckoutPricingTraceOptionGroup"] = {}) as CheckoutPricingTraceOptionGroup;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CheckoutPricingTraceOptionGroup";
  o.group = maybeNew("ReadyPlanOptionGroup", options.group, cache, options.hasOwnProperty("group"));
  o.included = maybeNewOrNull("CheckoutPricingTraceOption", options.included, cache);
  o.selected = maybeNewOrNull("CheckoutPricingTraceOption", options.selected, cache);
  o.availableCreditInCents = options.availableCreditInCents ?? 0;
  o.priceChangeInCents = options.priceChangeInCents ?? 0;
  return o;
}

factories["CheckoutPricingTraceOptionGroup"] = newCheckoutPricingTraceOptionGroup;

export interface CheckoutPricingTraceOptionOptions {
  __typename?: "CheckoutPricingTraceOption";
  option?: ReadyPlanOption | ReadyPlanOptionOptions | null;
  totalPriceInCents?: CheckoutPricingTraceOption["totalPriceInCents"];
  changed?: Array<CheckoutPricingTraceOptionChange | CheckoutPricingTraceOptionChangeOptions>;
}

export function newCheckoutPricingTraceOption(
  options: CheckoutPricingTraceOptionOptions = {},
  cache: Record<string, any> = {},
): CheckoutPricingTraceOption {
  const o = (options.__typename ? options : cache["CheckoutPricingTraceOption"] = {}) as CheckoutPricingTraceOption;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CheckoutPricingTraceOption";
  o.option = maybeNewOrNull("ReadyPlanOption", options.option, cache);
  o.totalPriceInCents = options.totalPriceInCents ?? 0;
  o.changed = (options.changed ?? []).map((i) =>
    maybeNew("CheckoutPricingTraceOptionChange", i, cache, options.hasOwnProperty("changed"))
  );
  return o;
}

factories["CheckoutPricingTraceOption"] = newCheckoutPricingTraceOption;

export interface CheckoutPricingTraceOptionChangeOptions {
  __typename?: "CheckoutPricingTraceOptionChange";
  group?: ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions;
  option?: ReadyPlanOption | ReadyPlanOptionOptions | null;
  previousOption?: ReadyPlanOption | ReadyPlanOptionOptions | null;
  priceInCents?: CheckoutPricingTraceOptionChange["priceInCents"];
  costInCents?: CheckoutPricingTraceOptionChange["costInCents"];
  selectionFeeInCents?: CheckoutPricingTraceOptionChange["selectionFeeInCents"];
  minimumPriceInCents?: CheckoutPricingTraceOptionChange["minimumPriceInCents"];
}

export function newCheckoutPricingTraceOptionChange(
  options: CheckoutPricingTraceOptionChangeOptions = {},
  cache: Record<string, any> = {},
): CheckoutPricingTraceOptionChange {
  const o =
    (options.__typename ? options : cache["CheckoutPricingTraceOptionChange"] = {}) as CheckoutPricingTraceOptionChange;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CheckoutPricingTraceOptionChange";
  o.group = maybeNew("ReadyPlanOptionGroup", options.group, cache, options.hasOwnProperty("group"));
  o.option = maybeNewOrNull("ReadyPlanOption", options.option, cache);
  o.previousOption = maybeNewOrNull("ReadyPlanOption", options.previousOption, cache);
  o.priceInCents = options.priceInCents ?? 0;
  o.costInCents = options.costInCents ?? 0;
  o.selectionFeeInCents = options.selectionFeeInCents ?? 0;
  o.minimumPriceInCents = options.minimumPriceInCents ?? 0;
  return o;
}

factories["CheckoutPricingTraceOptionChange"] = newCheckoutPricingTraceOptionChange;

export interface CheckoutConfigInteriorSubStepOptions {
  __typename?: "CheckoutConfigInteriorSubStep";
  id?: CheckoutConfigInteriorSubStep["id"];
  location?: ReadyPlanLocation | ReadyPlanLocationOptions | null;
  displayName?: CheckoutConfigInteriorSubStep["displayName"];
  stepNumber?: CheckoutConfigInteriorSubStep["stepNumber"];
}

export function newCheckoutConfigInteriorSubStep(
  options: CheckoutConfigInteriorSubStepOptions = {},
  cache: Record<string, any> = {},
): CheckoutConfigInteriorSubStep {
  const o =
    (options.__typename ? options : cache["CheckoutConfigInteriorSubStep"] = {}) as CheckoutConfigInteriorSubStep;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CheckoutConfigInteriorSubStep";
  o.id = options.id ?? nextFactoryId("CheckoutConfigInteriorSubStep");
  o.location = maybeNewOrNull("ReadyPlanLocation", options.location, cache);
  o.displayName = options.displayName ?? "displayName";
  o.stepNumber = options.stepNumber ?? 0;
  return o;
}

factories["CheckoutConfigInteriorSubStep"] = newCheckoutConfigInteriorSubStep;

export interface InsideMapsTextureSwapsOptions {
  __typename?: "InsideMapsTextureSwaps";
  cameras?: Array<InsideMapsCamera | InsideMapsCameraOptions>;
  textureSwapsByCamera?: Array<InsideMapsCameraTextureSwaps | InsideMapsCameraTextureSwapsOptions>;
  projectId?: InsideMapsTextureSwaps["projectId"];
  debugSlots?: Array<InsideMapsDebugSlot | InsideMapsDebugSlotOptions> | null;
}

export function newInsideMapsTextureSwaps(
  options: InsideMapsTextureSwapsOptions = {},
  cache: Record<string, any> = {},
): InsideMapsTextureSwaps {
  const o = (options.__typename ? options : cache["InsideMapsTextureSwaps"] = {}) as InsideMapsTextureSwaps;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InsideMapsTextureSwaps";
  o.cameras = (options.cameras ?? []).map((i) =>
    maybeNew("InsideMapsCamera", i, cache, options.hasOwnProperty("cameras"))
  );
  o.textureSwapsByCamera = (options.textureSwapsByCamera ?? []).map((i) =>
    maybeNew("InsideMapsCameraTextureSwaps", i, cache, options.hasOwnProperty("textureSwapsByCamera"))
  );
  o.projectId = options.projectId ?? null;
  o.debugSlots = (options.debugSlots ?? []).map((i) =>
    maybeNew("InsideMapsDebugSlot", i, cache, options.hasOwnProperty("debugSlots"))
  );
  return o;
}

factories["InsideMapsTextureSwaps"] = newInsideMapsTextureSwaps;

export interface InsideMapsCameraOptions {
  __typename?: "InsideMapsCamera";
  cameraName?: InsideMapsCamera["cameraName"];
  displayName?: InsideMapsCamera["displayName"];
  isPrimary?: InsideMapsCamera["isPrimary"];
  isDefault?: InsideMapsCamera["isDefault"];
  locationId?: InsideMapsCamera["locationId"];
  alternateViewFor?: InsideMapsCamera["alternateViewFor"];
  alternateCameras?: Array<InsideMapsCamera | InsideMapsCameraOptions>;
}

export function newInsideMapsCamera(
  options: InsideMapsCameraOptions = {},
  cache: Record<string, any> = {},
): InsideMapsCamera {
  const o = (options.__typename ? options : cache["InsideMapsCamera"] = {}) as InsideMapsCamera;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InsideMapsCamera";
  o.cameraName = options.cameraName ?? "cameraName";
  o.displayName = options.displayName ?? "displayName";
  o.isPrimary = options.isPrimary ?? false;
  o.isDefault = options.isDefault ?? false;
  o.locationId = options.locationId ?? null;
  o.alternateViewFor = options.alternateViewFor ?? null;
  o.alternateCameras = (options.alternateCameras ?? []).map((i) =>
    maybeNew("InsideMapsCamera", i, cache, options.hasOwnProperty("alternateCameras"))
  );
  return o;
}

factories["InsideMapsCamera"] = newInsideMapsCamera;

export interface InsideMapsCameraTextureSwapsOptions {
  __typename?: "InsideMapsCameraTextureSwaps";
  cameraName?: InsideMapsCameraTextureSwaps["cameraName"];
  textureSwaps?: Array<InsideMapsTextureSwap | InsideMapsTextureSwapOptions>;
}

export function newInsideMapsCameraTextureSwaps(
  options: InsideMapsCameraTextureSwapsOptions = {},
  cache: Record<string, any> = {},
): InsideMapsCameraTextureSwaps {
  const o = (options.__typename ? options : cache["InsideMapsCameraTextureSwaps"] = {}) as InsideMapsCameraTextureSwaps;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InsideMapsCameraTextureSwaps";
  o.cameraName = options.cameraName ?? "cameraName";
  o.textureSwaps = (options.textureSwaps ?? []).map((i) =>
    maybeNew("InsideMapsTextureSwap", i, cache, options.hasOwnProperty("textureSwaps"))
  );
  return o;
}

factories["InsideMapsCameraTextureSwaps"] = newInsideMapsCameraTextureSwaps;

export interface InsideMapsTextureSwapOptions {
  __typename?: "InsideMapsTextureSwap";
  part?: InsideMapsTextureSwap["part"];
  texture?: InsideMapsTextureSwap["texture"];
}

export function newInsideMapsTextureSwap(
  options: InsideMapsTextureSwapOptions = {},
  cache: Record<string, any> = {},
): InsideMapsTextureSwap {
  const o = (options.__typename ? options : cache["InsideMapsTextureSwap"] = {}) as InsideMapsTextureSwap;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InsideMapsTextureSwap";
  o.part = options.part ?? "part";
  o.texture = options.texture ?? "texture";
  return o;
}

factories["InsideMapsTextureSwap"] = newInsideMapsTextureSwap;

export interface InsideMapsDebugSlotOptions {
  __typename?: "InsideMapsDebugSlot";
  message?: InsideMapsDebugSlot["message"];
}

export function newInsideMapsDebugSlot(
  options: InsideMapsDebugSlotOptions = {},
  cache: Record<string, any> = {},
): InsideMapsDebugSlot {
  const o = (options.__typename ? options : cache["InsideMapsDebugSlot"] = {}) as InsideMapsDebugSlot;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InsideMapsDebugSlot";
  o.message = options.message ?? "message";
  return o;
}

factories["InsideMapsDebugSlot"] = newInsideMapsDebugSlot;

export interface InsideMapsSlotAuditResultOptions {
  __typename?: "InsideMapsSlotAuditResult";
  audit?: InsideMapsSlotAuditResult["audit"];
}

export function newInsideMapsSlotAuditResult(
  options: InsideMapsSlotAuditResultOptions = {},
  cache: Record<string, any> = {},
): InsideMapsSlotAuditResult {
  const o = (options.__typename ? options : cache["InsideMapsSlotAuditResult"] = {}) as InsideMapsSlotAuditResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InsideMapsSlotAuditResult";
  o.audit = options.audit ?? [];
  return o;
}

factories["InsideMapsSlotAuditResult"] = newInsideMapsSlotAuditResult;

export interface InsideMapsSlotDiffResultOptions {
  __typename?: "InsideMapsSlotDiffResult";
  diffs?: InsideMapsSlotDiffResult["diffs"];
}

export function newInsideMapsSlotDiffResult(
  options: InsideMapsSlotDiffResultOptions = {},
  cache: Record<string, any> = {},
): InsideMapsSlotDiffResult {
  const o = (options.__typename ? options : cache["InsideMapsSlotDiffResult"] = {}) as InsideMapsSlotDiffResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InsideMapsSlotDiffResult";
  o.diffs = options.diffs ?? [];
  return o;
}

factories["InsideMapsSlotDiffResult"] = newInsideMapsSlotDiffResult;

export interface RunCheckoutPricingReportResultOptions {
  __typename?: "RunCheckoutPricingReportResult";
  report?: TrackedJob | TrackedJobOptions;
}

export function newRunCheckoutPricingReportResult(
  options: RunCheckoutPricingReportResultOptions = {},
  cache: Record<string, any> = {},
): RunCheckoutPricingReportResult {
  const o =
    (options.__typename ? options : cache["RunCheckoutPricingReportResult"] = {}) as RunCheckoutPricingReportResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "RunCheckoutPricingReportResult";
  o.report = maybeNew("TrackedJob", options.report, cache, options.hasOwnProperty("report"));
  return o;
}

factories["RunCheckoutPricingReportResult"] = newRunCheckoutPricingReportResult;

export interface CheckoutConfigOptionOptions {
  __typename?: "CheckoutConfigOption";
  id?: CheckoutConfigOption["id"];
  readyPlanOption?: ReadyPlanOption | ReadyPlanOptionOptions;
  checkoutConfig?: CheckoutConfig | CheckoutConfigOptions;
  createdAt?: CheckoutConfigOption["createdAt"];
  updatedAt?: CheckoutConfigOption["updatedAt"];
  reservedPriceInCents?: CheckoutConfigOption["reservedPriceInCents"];
  isSelected?: CheckoutConfigOption["isSelected"];
  isIncluded?: CheckoutConfigOption["isIncluded"];
  showOnSummary?: CheckoutConfigOption["showOnSummary"];
  reservedCutoffDate?: CheckoutConfigOption["reservedCutoffDate"];
  includedByCheckoutConfigOption?: CheckoutConfigOption | CheckoutConfigOptionOptions | null;
  includedByRoot?: CheckoutConfigOption | CheckoutConfigOptionOptions | null;
}

export function newCheckoutConfigOption(
  options: CheckoutConfigOptionOptions = {},
  cache: Record<string, any> = {},
): CheckoutConfigOption {
  const o = (options.__typename ? options : cache["CheckoutConfigOption"] = {}) as CheckoutConfigOption;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CheckoutConfigOption";
  o.id = options.id ?? nextFactoryId("CheckoutConfigOption");
  o.readyPlanOption = maybeNew(
    "ReadyPlanOption",
    options.readyPlanOption,
    cache,
    options.hasOwnProperty("readyPlanOption"),
  );
  o.checkoutConfig = maybeNew(
    "CheckoutConfig",
    options.checkoutConfig,
    cache,
    options.hasOwnProperty("checkoutConfig"),
  );
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.reservedPriceInCents = options.reservedPriceInCents ?? null;
  o.isSelected = options.isSelected ?? false;
  o.isIncluded = options.isIncluded ?? false;
  o.showOnSummary = options.showOnSummary ?? false;
  o.reservedCutoffDate = options.reservedCutoffDate ?? null;
  o.includedByCheckoutConfigOption = maybeNewOrNull(
    "CheckoutConfigOption",
    options.includedByCheckoutConfigOption,
    cache,
  );
  o.includedByRoot = maybeNewOrNull("CheckoutConfigOption", options.includedByRoot, cache);
  return o;
}

factories["CheckoutConfigOption"] = newCheckoutConfigOption;

export interface ClientOptions {
  __typename?: "Client";
  id?: Client["id"];
  name?: Client["name"];
  email?: Client["email"];
  firstName?: Client["firstName"];
  lastName?: Client["lastName"];
  shortName?: Client["shortName"];
  fullName?: Client["fullName"];
  lastActiveAt?: Client["lastActiveAt"];
  lastActive?: Client["lastActive"];
  address?: Address | AddressOptions | null;
  phone?: Client["phone"];
}

export function newClient(options: ClientOptions = {}, cache: Record<string, any> = {}): Client {
  const o = (options.__typename ? options : cache["Client"] = {}) as Client;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Client";
  o.id = options.id ?? nextFactoryId("Client");
  o.name = options.name ?? "name";
  o.email = options.email ?? "email";
  o.firstName = options.firstName ?? "firstName";
  o.lastName = options.lastName ?? "lastName";
  o.shortName = options.shortName ?? "shortName";
  o.fullName = options.fullName ?? "fullName";
  o.lastActiveAt = options.lastActiveAt ?? null;
  o.lastActive = options.lastActive ?? null;
  o.address = maybeNewOrNull("Address", options.address, cache);
  o.phone = options.phone ?? null;
  return o;
}

factories["Client"] = newClient;

export interface CohortOptions {
  __typename?: "Cohort";
  id?: Cohort["id"];
  name?: Cohort["name"];
  market?: Market | MarketOptions;
  projects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  developer?: InternalUser | InternalUserOptions | null;
  createdAt?: Cohort["createdAt"];
  updatedAt?: Cohort["updatedAt"];
  development?: Development | DevelopmentOptions | null;
  scopeMode?: ScopeModeDetailOptions | ScopeMode;
  isBoolDefaultForDevelopment?: Cohort["isBoolDefaultForDevelopment"];
}

export function newCohort(options: CohortOptions = {}, cache: Record<string, any> = {}): Cohort {
  const o = (options.__typename ? options : cache["Cohort"] = {}) as Cohort;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Cohort";
  o.id = options.id ?? nextFactoryId("Cohort");
  o.name = options.name ?? "name";
  o.market = maybeNew("Market", options.market, cache, options.hasOwnProperty("market"));
  o.projects = (options.projects ?? []).map((i) => maybeNew("Project", i, cache, options.hasOwnProperty("projects")));
  o.developer = maybeNewOrNull("InternalUser", options.developer, cache);
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.development = maybeNewOrNull("Development", options.development, cache);
  o.scopeMode = enumOrDetailOfScopeMode(options.scopeMode);
  o.isBoolDefaultForDevelopment = options.isBoolDefaultForDevelopment ?? null;
  return o;
}

factories["Cohort"] = newCohort;

export interface SaveCohortsResultOptions {
  __typename?: "SaveCohortsResult";
  cohorts?: Array<Cohort | CohortOptions>;
}

export function newSaveCohortsResult(
  options: SaveCohortsResultOptions = {},
  cache: Record<string, any> = {},
): SaveCohortsResult {
  const o = (options.__typename ? options : cache["SaveCohortsResult"] = {}) as SaveCohortsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveCohortsResult";
  o.cohorts = (options.cohorts ?? []).map((i) => maybeNew("Cohort", i, cache, options.hasOwnProperty("cohorts")));
  return o;
}

factories["SaveCohortsResult"] = newSaveCohortsResult;

export interface SchedulePhaseOptions {
  __typename?: "SchedulePhase";
  references?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: SchedulePhase["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: SchedulePhase["isFollowed"];
  id?: SchedulePhase["id"];
  name?: SchedulePhase["name"];
  parent?:
    | ScheduleParent
    | StandaloneProjectOptions
    | RequireTypename<RegionOptions>
    | RequireTypename<DevelopmentOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>
    | RequireTypename<ScheduleTemplateOptions>;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  schedule?: Schedule | ScheduleOptions;
  interval?: CalendarInterval | CalendarIntervalOptions | null;
  baselineInterval?: CalendarInterval | CalendarIntervalOptions | null;
  blueprintUrl?: Url | UrlOptions;
  progress?: SchedulePhaseProgress | SchedulePhaseProgressOptions;
  cmsId?: SchedulePhase["cmsId"];
  scheduleSubPhases?: Array<ScheduleSubPhase | ScheduleSubPhaseOptions>;
  globalPhase?: GlobalPhase | GlobalPhaseOptions;
  taskStatusRollup?: SchedulePhase["taskStatusRollup"];
}

export function newSchedulePhase(options: SchedulePhaseOptions = {}, cache: Record<string, any> = {}): SchedulePhase {
  const o = (options.__typename ? options : cache["SchedulePhase"] = {}) as SchedulePhase;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SchedulePhase";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("SchedulePhase");
  o.name = options.name ?? "name";
  o.parent = maybeNew(options.parent?.__typename ?? "StandaloneProject", options.parent, cache);
  o.project = maybeNewOrNull("Project", options.project, cache);
  o.schedule = maybeNew("Schedule", options.schedule, cache, options.hasOwnProperty("schedule"));
  o.interval = maybeNewOrNull("CalendarInterval", options.interval, cache);
  o.baselineInterval = maybeNewOrNull("CalendarInterval", options.baselineInterval, cache);
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.progress = maybeNew("SchedulePhaseProgress", options.progress, cache, options.hasOwnProperty("progress"));
  o.cmsId = options.cmsId ?? null;
  o.scheduleSubPhases = (options.scheduleSubPhases ?? []).map((i) =>
    maybeNew("ScheduleSubPhase", i, cache, options.hasOwnProperty("scheduleSubPhases"))
  );
  o.globalPhase = maybeNew("GlobalPhase", options.globalPhase, cache, options.hasOwnProperty("globalPhase"));
  o.taskStatusRollup = options.taskStatusRollup ?? null;
  return o;
}

factories["SchedulePhase"] = newSchedulePhase;

export interface ScheduleSubPhaseOptions {
  __typename?: "ScheduleSubPhase";
  references?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: ScheduleSubPhase["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: ScheduleSubPhase["isFollowed"];
  id?: ScheduleSubPhase["id"];
  name?: ScheduleSubPhase["name"];
  parent?:
    | ScheduleParent
    | StandaloneProjectOptions
    | RequireTypename<RegionOptions>
    | RequireTypename<DevelopmentOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>
    | RequireTypename<ScheduleTemplateOptions>;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  schedule?: Schedule | ScheduleOptions;
  schedulePhase?: SchedulePhase | SchedulePhaseOptions;
  scheduleTasks?: Array<ScheduleTask | ScheduleTaskOptions>;
  globalSubPhase?: GlobalSubPhase | GlobalSubPhaseOptions;
  blueprintUrl?: Url | UrlOptions;
  interval?: CalendarInterval | CalendarIntervalOptions | null;
  baselineInterval?: CalendarInterval | CalendarIntervalOptions | null;
  progress?: ScheduleSubPhaseProgress | ScheduleSubPhaseProgressOptions;
  cmsId?: ScheduleSubPhase["cmsId"];
}

export function newScheduleSubPhase(
  options: ScheduleSubPhaseOptions = {},
  cache: Record<string, any> = {},
): ScheduleSubPhase {
  const o = (options.__typename ? options : cache["ScheduleSubPhase"] = {}) as ScheduleSubPhase;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ScheduleSubPhase";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("ScheduleSubPhase");
  o.name = options.name ?? "name";
  o.parent = maybeNew(options.parent?.__typename ?? "StandaloneProject", options.parent, cache);
  o.project = maybeNewOrNull("Project", options.project, cache);
  o.schedule = maybeNew("Schedule", options.schedule, cache, options.hasOwnProperty("schedule"));
  o.schedulePhase = maybeNew("SchedulePhase", options.schedulePhase, cache, options.hasOwnProperty("schedulePhase"));
  o.scheduleTasks = (options.scheduleTasks ?? []).map((i) =>
    maybeNew("ScheduleTask", i, cache, options.hasOwnProperty("scheduleTasks"))
  );
  o.globalSubPhase = maybeNew(
    "GlobalSubPhase",
    options.globalSubPhase,
    cache,
    options.hasOwnProperty("globalSubPhase"),
  );
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.interval = maybeNewOrNull("CalendarInterval", options.interval, cache);
  o.baselineInterval = maybeNewOrNull("CalendarInterval", options.baselineInterval, cache);
  o.progress = maybeNew("ScheduleSubPhaseProgress", options.progress, cache, options.hasOwnProperty("progress"));
  o.cmsId = options.cmsId ?? null;
  return o;
}

factories["ScheduleSubPhase"] = newScheduleSubPhase;

export interface TaskOptions {
  __typename?: "Task";
  references?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: Task["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: Task["isFollowed"];
  id?: Task["id"];
  stage?: ProjectStage | ProjectStageOptions;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  name?: Task["name"];
  userCreated?: Task["userCreated"];
  status?: TaskStatusDetailOptions | TaskStatus;
  homeownerVisible?: Task["homeownerVisible"];
  homeownerDescription?: Task["homeownerDescription"];
  interval?: CalendarInterval | CalendarIntervalOptions;
  baselineInterval?: CalendarInterval | CalendarIntervalOptions;
  baselineInterval2?: CalendarInterval2 | CalendarInterval2Options | null;
  completedAt?: Task["completedAt"];
  startDate?: Task["startDate"];
  assignee?: InternalUser | InternalUserOptions | null;
  internalNote?: Task["internalNote"];
  cmsId?: Task["cmsId"];
  slackInDays?: Task["slackInDays"];
  aheadOrBehindInDays?: Task["aheadOrBehindInDays"];
  isStale?: Task["isStale"];
  isCriticalPath?: Task["isCriticalPath"];
  predecessors?: Array<Task | TaskOptions>;
  successors?: Array<Task | TaskOptions>;
  predecessorDependencies?: Array<TaskDependency | TaskDependencyOptions>;
  successorDependencies?: Array<TaskDependency | TaskDependencyOptions>;
  homeownerContractDraws?: Array<HomeownerContractDraw | HomeownerContractDrawOptions>;
  isManuallyScheduled?: Task["isManuallyScheduled"];
  isBaselineManuallyScheduled?: Task["isBaselineManuallyScheduled"];
  blueprintUrl?: Url | UrlOptions;
  isMilestone?: Task["isMilestone"];
  salesforceId?: Task["salesforceId"];
  tradePartner?: TradePartner | TradePartnerOptions | null;
  canEditStartDate?: PotentialOperation2 | PotentialOperation2Options;
  canEditEndDate?: PotentialOperation2 | PotentialOperation2Options;
  canEditDuration?: PotentialOperation2 | PotentialOperation2Options;
  canComplete?: PotentialOperation2 | PotentialOperation2Options;
  canStart?: PotentialOperation2 | PotentialOperation2Options;
  canDelete?: PotentialOperation2 | PotentialOperation2Options;
  canSetTraderPartner?: PotentialOperation2 | PotentialOperation2Options;
  projectCutoffs?: Array<ProjectCutoff | ProjectCutoffOptions>;
  projectItems?: Array<ProjectItem | ProjectItemOptions>;
  deadlineType?: Task["deadlineType"];
  deadlineTypeDetail?: TaskDeadlineTypeDetailOptions | TaskDeadlineType | null;
  templateProjectRole?: Task["templateProjectRole"];
  templateProjectRoleDetail?: ProjectRoleDetailOptions | ProjectRole | null;
  documents?: Array<Document | DocumentOptions>;
  globalTask?: GlobalTask | GlobalTaskOptions | null;
  isGlobalMilestoneTask?: Task["isGlobalMilestoneTask"];
  scheduleTemplateItemMappings?: Array<ScheduleTemplateItemMapping | ScheduleTemplateItemMappingOptions>;
  requiredTaskDocuments?: Array<RequiredTaskDocument | RequiredTaskDocumentOptions>;
  scheduleTaskChecklistItems?: Array<ScheduleTaskChecklistItem | ScheduleTaskChecklistItemOptions>;
  scheduleFlags?: Array<ScheduleFlag | ScheduleFlagOptions>;
  jobLogNotes?: Array<JobLogNote | JobLogNoteOptions>;
  tradePartnerIsScheduled?: Task["tradePartnerIsScheduled"];
  hasScheduleFlags?: Task["hasScheduleFlags"];
  systemTask?: Task["systemTask"];
  tradePartners?: Array<TradePartner | TradePartnerOptions>;
  committedTradePartners?: Array<TradePartner | TradePartnerOptions>;
  billLineItems?: Array<BillLineItem | BillLineItemOptions>;
  defaultedHomeownerDescription?: Task["defaultedHomeownerDescription"];
  templateTask?: Task | TaskOptions | null;
  tradePartnerStatus?: TradePartnerTaskStatusDetailOptions | TradePartnerTaskStatus;
  tradePartnerAvailabilityRequests?:
    | Array<TradePartnerAvailabilityRequest | TradePartnerAvailabilityRequestOptions>
    | null;
  depositCommitments?: Array<Commitment | CommitmentOptions>;
  type?: TaskTypeDetailOptions | TaskType;
  workDays?: Array<TaskWorkDay | TaskWorkDayOptions>;
  commitmentDraws?: Array<CommitmentDraw | CommitmentDrawOptions>;
  protoBills?: Array<ProtoBill | ProtoBillOptions>;
  checklistComplete?: Task["checklistComplete"];
  schedule?: ScheduleLike | ScheduleOptions | RequireTypename<PlanScheduleOptions>;
}

export function newTask(options: TaskOptions = {}, cache: Record<string, any> = {}): Task {
  const o = (options.__typename ? options : cache["Task"] = {}) as Task;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Task";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("Task");
  o.stage = maybeNew("ProjectStage", options.stage, cache, options.hasOwnProperty("stage"));
  o.project = maybeNewOrNull("Project", options.project, cache);
  o.name = options.name ?? "name";
  o.userCreated = options.userCreated ?? false;
  o.status = enumOrDetailOfTaskStatus(options.status);
  o.homeownerVisible = options.homeownerVisible ?? false;
  o.homeownerDescription = options.homeownerDescription ?? null;
  o.interval = maybeNew("CalendarInterval", options.interval, cache, options.hasOwnProperty("interval"));
  o.baselineInterval = maybeNew(
    "CalendarInterval",
    options.baselineInterval,
    cache,
    options.hasOwnProperty("baselineInterval"),
  );
  o.baselineInterval2 = maybeNewOrNull("CalendarInterval2", options.baselineInterval2, cache);
  o.completedAt = options.completedAt ?? null;
  o.startDate = options.startDate ?? null;
  o.assignee = maybeNewOrNull("InternalUser", options.assignee, cache);
  o.internalNote = options.internalNote ?? null;
  o.cmsId = options.cmsId ?? "cmsId";
  o.slackInDays = options.slackInDays ?? null;
  o.aheadOrBehindInDays = options.aheadOrBehindInDays ?? null;
  o.isStale = options.isStale ?? false;
  o.isCriticalPath = options.isCriticalPath ?? false;
  o.predecessors = (options.predecessors ?? []).map((i) =>
    maybeNew("Task", i, cache, options.hasOwnProperty("predecessors"))
  );
  o.successors = (options.successors ?? []).map((i) =>
    maybeNew("Task", i, cache, options.hasOwnProperty("successors"))
  );
  o.predecessorDependencies = (options.predecessorDependencies ?? []).map((i) =>
    maybeNew("TaskDependency", i, cache, options.hasOwnProperty("predecessorDependencies"))
  );
  o.successorDependencies = (options.successorDependencies ?? []).map((i) =>
    maybeNew("TaskDependency", i, cache, options.hasOwnProperty("successorDependencies"))
  );
  o.homeownerContractDraws = (options.homeownerContractDraws ?? []).map((i) =>
    maybeNew("HomeownerContractDraw", i, cache, options.hasOwnProperty("homeownerContractDraws"))
  );
  o.isManuallyScheduled = options.isManuallyScheduled ?? false;
  o.isBaselineManuallyScheduled = options.isBaselineManuallyScheduled ?? null;
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.isMilestone = options.isMilestone ?? false;
  o.salesforceId = options.salesforceId ?? null;
  o.tradePartner = maybeNewOrNull("TradePartner", options.tradePartner, cache);
  o.canEditStartDate = maybeNew(
    "PotentialOperation2",
    options.canEditStartDate,
    cache,
    options.hasOwnProperty("canEditStartDate"),
  );
  o.canEditEndDate = maybeNew(
    "PotentialOperation2",
    options.canEditEndDate,
    cache,
    options.hasOwnProperty("canEditEndDate"),
  );
  o.canEditDuration = maybeNew(
    "PotentialOperation2",
    options.canEditDuration,
    cache,
    options.hasOwnProperty("canEditDuration"),
  );
  o.canComplete = maybeNew("PotentialOperation2", options.canComplete, cache, options.hasOwnProperty("canComplete"));
  o.canStart = maybeNew("PotentialOperation2", options.canStart, cache, options.hasOwnProperty("canStart"));
  o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
  o.canSetTraderPartner = maybeNew(
    "PotentialOperation2",
    options.canSetTraderPartner,
    cache,
    options.hasOwnProperty("canSetTraderPartner"),
  );
  o.projectCutoffs = (options.projectCutoffs ?? []).map((i) =>
    maybeNew("ProjectCutoff", i, cache, options.hasOwnProperty("projectCutoffs"))
  );
  o.projectItems = (options.projectItems ?? []).map((i) =>
    maybeNew("ProjectItem", i, cache, options.hasOwnProperty("projectItems"))
  );
  o.deadlineType = options.deadlineType ?? null;
  o.deadlineTypeDetail = enumOrDetailOrNullOfTaskDeadlineType(options.deadlineTypeDetail);
  o.templateProjectRole = options.templateProjectRole ?? null;
  o.templateProjectRoleDetail = enumOrDetailOrNullOfProjectRole(options.templateProjectRoleDetail);
  o.documents = (options.documents ?? []).map((i) =>
    maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
  );
  o.globalTask = maybeNewOrNull("GlobalTask", options.globalTask, cache);
  o.isGlobalMilestoneTask = options.isGlobalMilestoneTask ?? false;
  o.scheduleTemplateItemMappings = (options.scheduleTemplateItemMappings ?? []).map((i) =>
    maybeNew("ScheduleTemplateItemMapping", i, cache, options.hasOwnProperty("scheduleTemplateItemMappings"))
  );
  o.requiredTaskDocuments = (options.requiredTaskDocuments ?? []).map((i) =>
    maybeNew("RequiredTaskDocument", i, cache, options.hasOwnProperty("requiredTaskDocuments"))
  );
  o.scheduleTaskChecklistItems = (options.scheduleTaskChecklistItems ?? []).map((i) =>
    maybeNew("ScheduleTaskChecklistItem", i, cache, options.hasOwnProperty("scheduleTaskChecklistItems"))
  );
  o.scheduleFlags = (options.scheduleFlags ?? []).map((i) =>
    maybeNew("ScheduleFlag", i, cache, options.hasOwnProperty("scheduleFlags"))
  );
  o.jobLogNotes = (options.jobLogNotes ?? []).map((i) =>
    maybeNew("JobLogNote", i, cache, options.hasOwnProperty("jobLogNotes"))
  );
  o.tradePartnerIsScheduled = options.tradePartnerIsScheduled ?? null;
  o.hasScheduleFlags = options.hasScheduleFlags ?? false;
  o.systemTask = options.systemTask ?? null;
  o.tradePartners = (options.tradePartners ?? []).map((i) =>
    maybeNew("TradePartner", i, cache, options.hasOwnProperty("tradePartners"))
  );
  o.committedTradePartners = (options.committedTradePartners ?? []).map((i) =>
    maybeNew("TradePartner", i, cache, options.hasOwnProperty("committedTradePartners"))
  );
  o.billLineItems = (options.billLineItems ?? []).map((i) =>
    maybeNew("BillLineItem", i, cache, options.hasOwnProperty("billLineItems"))
  );
  o.defaultedHomeownerDescription = options.defaultedHomeownerDescription ?? "defaultedHomeownerDescription";
  o.templateTask = maybeNewOrNull("Task", options.templateTask, cache);
  o.tradePartnerStatus = enumOrDetailOfTradePartnerTaskStatus(options.tradePartnerStatus);
  o.tradePartnerAvailabilityRequests = (options.tradePartnerAvailabilityRequests ?? []).map((i) =>
    maybeNew("TradePartnerAvailabilityRequest", i, cache, options.hasOwnProperty("tradePartnerAvailabilityRequests"))
  );
  o.depositCommitments = (options.depositCommitments ?? []).map((i) =>
    maybeNew("Commitment", i, cache, options.hasOwnProperty("depositCommitments"))
  );
  o.type = enumOrDetailOfTaskType(options.type);
  o.workDays = (options.workDays ?? []).map((i) =>
    maybeNew("TaskWorkDay", i, cache, options.hasOwnProperty("workDays"))
  );
  o.commitmentDraws = (options.commitmentDraws ?? []).map((i) =>
    maybeNew("CommitmentDraw", i, cache, options.hasOwnProperty("commitmentDraws"))
  );
  o.protoBills = (options.protoBills ?? []).map((i) =>
    maybeNew("ProtoBill", i, cache, options.hasOwnProperty("protoBills"))
  );
  o.checklistComplete = options.checklistComplete ?? null;
  o.schedule = maybeNew(options.schedule?.__typename ?? "Schedule", options.schedule, cache);
  return o;
}

factories["Task"] = newTask;

export interface PlanTaskOptions {
  __typename?: "PlanTask";
  references?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: PlanTask["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: PlanTask["isFollowed"];
  id?: PlanTask["id"];
  name?: PlanTask["name"];
  createdAt?: PlanTask["createdAt"];
  updatedAt?: PlanTask["updatedAt"];
  durationInDays?: PlanTask["durationInDays"];
  startDate?: PlanTask["startDate"];
  endDate?: PlanTask["endDate"];
  completedAt?: PlanTask["completedAt"];
  slackInDays?: PlanTask["slackInDays"];
  isCriticalPath?: PlanTask["isCriticalPath"];
  homeownerVisible?: PlanTask["homeownerVisible"];
  status?: TaskStatusDetailOptions | TaskStatus;
  type?: TaskTypeDetailOptions | TaskType;
  sortOrder?: PlanTask["sortOrder"];
  internalUser?: InternalUser | InternalUserOptions | null;
  blueprintUrl?: Url | UrlOptions;
  schedule?: PlanSchedule | PlanScheduleOptions;
  globalPlanTask?: GlobalPlanTask | GlobalPlanTaskOptions;
  globalChecklistItems?: Array<GlobalPlanTaskChecklistItem | GlobalPlanTaskChecklistItemOptions>;
  checklistItems?: Array<PlanTaskChecklistItem | PlanTaskChecklistItemOptions>;
  requiredTaskDocuments?: Array<RequiredTaskDocument | RequiredTaskDocumentOptions>;
  documents?: Array<Document | DocumentOptions>;
  history?: Array<History | HistoryOptions>;
  earliestStartDate?: PlanTask["earliestStartDate"];
  knownDurationInDays?: PlanTask["knownDurationInDays"];
  isManuallyScheduled?: PlanTask["isManuallyScheduled"];
  canStart?: PotentialOperation2 | PotentialOperation2Options;
  canComplete?: PotentialOperation2 | PotentialOperation2Options;
  canDeleteWithWarning?: PotentialOperation2 | PotentialOperation2Options;
  canDelete?: PotentialOperation2 | PotentialOperation2Options;
  canSetTraderPartner?: PotentialOperation2 | PotentialOperation2Options;
  constraintItems?: Array<GlobalPlanConstraintItem | GlobalPlanConstraintItemOptions>;
  allowanceItems?: Array<GlobalPlanConstraintItem | GlobalPlanConstraintItemOptions>;
  tradePartner?: TradePartner | TradePartnerOptions | null;
  tradePartners?: Array<TradePartner | TradePartnerOptions>;
  committedTradePartners?: Array<TradePartner | TradePartnerOptions>;
  billLineItems?: Array<BillLineItem | BillLineItemOptions>;
  tradePartnerStatus?: TradePartnerTaskStatusDetailOptions | TradePartnerTaskStatus;
  tradePartnerAvailabilityRequests?:
    | Array<TradePartnerAvailabilityRequest | TradePartnerAvailabilityRequestOptions>
    | null;
  simulationProbability?: SimulationProbability | SimulationProbabilityOptions;
  scheduleFlags?: Array<ScheduleFlag | ScheduleFlagOptions>;
  ignoredConstraintsOnTaskEnd?: Array<GlobalPlanConstraintItem | GlobalPlanConstraintItemOptions>;
  ignoredConstraintsOnTaskStart?: Array<GlobalPlanConstraintItem | GlobalPlanConstraintItemOptions>;
  workDays?: Array<TaskWorkDay | TaskWorkDayOptions>;
  workingDaysProgress?: PlanTask["workingDaysProgress"];
  projectItems?: Array<ProjectItem | ProjectItemOptions>;
  isStale?: PlanTask["isStale"];
  stage?: GlobalPlanStage | GlobalPlanStageOptions | null;
  commitmentDraws?: Array<CommitmentDraw | CommitmentDrawOptions>;
  protoBills?: Array<ProtoBill | ProtoBillOptions>;
  customWorkableDays?: PlanTask["customWorkableDays"];
  allowsPlanMilestones?: Array<PlanMilestone | PlanMilestoneOptions>;
  knownSchedulingContacts?: Array<TradePartnerContact | TradePartnerContactOptions>;
}

export function newPlanTask(options: PlanTaskOptions = {}, cache: Record<string, any> = {}): PlanTask {
  const o = (options.__typename ? options : cache["PlanTask"] = {}) as PlanTask;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PlanTask";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("PlanTask");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.durationInDays = options.durationInDays ?? 0;
  o.startDate = options.startDate ?? newDate();
  o.endDate = options.endDate ?? newDate();
  o.completedAt = options.completedAt ?? null;
  o.slackInDays = options.slackInDays ?? null;
  o.isCriticalPath = options.isCriticalPath ?? false;
  o.homeownerVisible = options.homeownerVisible ?? null;
  o.status = enumOrDetailOfTaskStatus(options.status);
  o.type = enumOrDetailOfTaskType(options.type);
  o.sortOrder = options.sortOrder ?? 0;
  o.internalUser = maybeNewOrNull("InternalUser", options.internalUser, cache);
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.schedule = maybeNew("PlanSchedule", options.schedule, cache, options.hasOwnProperty("schedule"));
  o.globalPlanTask = maybeNew(
    "GlobalPlanTask",
    options.globalPlanTask,
    cache,
    options.hasOwnProperty("globalPlanTask"),
  );
  o.globalChecklistItems = (options.globalChecklistItems ?? []).map((i) =>
    maybeNew("GlobalPlanTaskChecklistItem", i, cache, options.hasOwnProperty("globalChecklistItems"))
  );
  o.checklistItems = (options.checklistItems ?? []).map((i) =>
    maybeNew("PlanTaskChecklistItem", i, cache, options.hasOwnProperty("checklistItems"))
  );
  o.requiredTaskDocuments = (options.requiredTaskDocuments ?? []).map((i) =>
    maybeNew("RequiredTaskDocument", i, cache, options.hasOwnProperty("requiredTaskDocuments"))
  );
  o.documents = (options.documents ?? []).map((i) =>
    maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
  );
  o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
  o.earliestStartDate = options.earliestStartDate ?? null;
  o.knownDurationInDays = options.knownDurationInDays ?? null;
  o.isManuallyScheduled = options.isManuallyScheduled ?? null;
  o.canStart = maybeNew("PotentialOperation2", options.canStart, cache, options.hasOwnProperty("canStart"));
  o.canComplete = maybeNew("PotentialOperation2", options.canComplete, cache, options.hasOwnProperty("canComplete"));
  o.canDeleteWithWarning = maybeNew(
    "PotentialOperation2",
    options.canDeleteWithWarning,
    cache,
    options.hasOwnProperty("canDeleteWithWarning"),
  );
  o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
  o.canSetTraderPartner = maybeNew(
    "PotentialOperation2",
    options.canSetTraderPartner,
    cache,
    options.hasOwnProperty("canSetTraderPartner"),
  );
  o.constraintItems = (options.constraintItems ?? []).map((i) =>
    maybeNew("GlobalPlanConstraintItem", i, cache, options.hasOwnProperty("constraintItems"))
  );
  o.allowanceItems = (options.allowanceItems ?? []).map((i) =>
    maybeNew("GlobalPlanConstraintItem", i, cache, options.hasOwnProperty("allowanceItems"))
  );
  o.tradePartner = maybeNewOrNull("TradePartner", options.tradePartner, cache);
  o.tradePartners = (options.tradePartners ?? []).map((i) =>
    maybeNew("TradePartner", i, cache, options.hasOwnProperty("tradePartners"))
  );
  o.committedTradePartners = (options.committedTradePartners ?? []).map((i) =>
    maybeNew("TradePartner", i, cache, options.hasOwnProperty("committedTradePartners"))
  );
  o.billLineItems = (options.billLineItems ?? []).map((i) =>
    maybeNew("BillLineItem", i, cache, options.hasOwnProperty("billLineItems"))
  );
  o.tradePartnerStatus = enumOrDetailOfTradePartnerTaskStatus(options.tradePartnerStatus);
  o.tradePartnerAvailabilityRequests = (options.tradePartnerAvailabilityRequests ?? []).map((i) =>
    maybeNew("TradePartnerAvailabilityRequest", i, cache, options.hasOwnProperty("tradePartnerAvailabilityRequests"))
  );
  o.simulationProbability = maybeNew(
    "SimulationProbability",
    options.simulationProbability,
    cache,
    options.hasOwnProperty("simulationProbability"),
  );
  o.scheduleFlags = (options.scheduleFlags ?? []).map((i) =>
    maybeNew("ScheduleFlag", i, cache, options.hasOwnProperty("scheduleFlags"))
  );
  o.ignoredConstraintsOnTaskEnd = (options.ignoredConstraintsOnTaskEnd ?? []).map((i) =>
    maybeNew("GlobalPlanConstraintItem", i, cache, options.hasOwnProperty("ignoredConstraintsOnTaskEnd"))
  );
  o.ignoredConstraintsOnTaskStart = (options.ignoredConstraintsOnTaskStart ?? []).map((i) =>
    maybeNew("GlobalPlanConstraintItem", i, cache, options.hasOwnProperty("ignoredConstraintsOnTaskStart"))
  );
  o.workDays = (options.workDays ?? []).map((i) =>
    maybeNew("TaskWorkDay", i, cache, options.hasOwnProperty("workDays"))
  );
  o.workingDaysProgress = options.workingDaysProgress ?? 0;
  o.projectItems = (options.projectItems ?? []).map((i) =>
    maybeNew("ProjectItem", i, cache, options.hasOwnProperty("projectItems"))
  );
  o.isStale = options.isStale ?? false;
  o.stage = maybeNewOrNull("GlobalPlanStage", options.stage, cache);
  o.commitmentDraws = (options.commitmentDraws ?? []).map((i) =>
    maybeNew("CommitmentDraw", i, cache, options.hasOwnProperty("commitmentDraws"))
  );
  o.protoBills = (options.protoBills ?? []).map((i) =>
    maybeNew("ProtoBill", i, cache, options.hasOwnProperty("protoBills"))
  );
  o.customWorkableDays = options.customWorkableDays ?? [];
  o.allowsPlanMilestones = (options.allowsPlanMilestones ?? []).map((i) =>
    maybeNew("PlanMilestone", i, cache, options.hasOwnProperty("allowsPlanMilestones"))
  );
  o.knownSchedulingContacts = (options.knownSchedulingContacts ?? []).map((i) =>
    maybeNew("TradePartnerContact", i, cache, options.hasOwnProperty("knownSchedulingContacts"))
  );
  return o;
}

factories["PlanTask"] = newPlanTask;

export interface ToDoOptions {
  __typename?: "ToDo";
  references?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: ToDo["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: ToDo["isFollowed"];
  id?: ToDo["id"];
  name?: ToDo["name"];
  blueprintUrl?: Url | UrlOptions;
  description?: ToDo["description"];
  deletedAt?: ToDo["deletedAt"];
  createdAt?: ToDo["createdAt"];
  updatedAt?: ToDo["updatedAt"];
  dueDate?: ToDo["dueDate"];
  order?: ToDo["order"];
  status?: ToDoStatusDetailOptions | ToDoStatus;
  type?: ToDoTypeDetailOptions | ToDoType;
  parent?:
    | ToDoParent
    | StandaloneProjectOptions
    | RequireTypename<RegionOptions>
    | RequireTypename<CohortOptions>
    | RequireTypename<DevelopmentOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>
    | null;
  createdBy?: User | UserOptions;
  assignee?: User | UserOptions | null;
  assignees?: Array<User | UserOptions>;
  attachments?: Array<Attachment | AttachmentOptions>;
  urgent?: ToDo["urgent"];
  checklistItems?: Array<ToDoChecklistItem | ToDoChecklistItemOptions>;
  checklistProgress?: ToDoChecklistProgress | ToDoChecklistProgressOptions;
  changeRequest?: ChangeRequest | ChangeRequestOptions | null;
}

export function newToDo(options: ToDoOptions = {}, cache: Record<string, any> = {}): ToDo {
  const o = (options.__typename ? options : cache["ToDo"] = {}) as ToDo;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ToDo";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("ToDo");
  o.name = options.name ?? "name";
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.description = options.description ?? null;
  o.deletedAt = options.deletedAt ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.dueDate = options.dueDate ?? null;
  o.order = options.order ?? "order";
  o.status = enumOrDetailOfToDoStatus(options.status);
  o.type = enumOrDetailOfToDoType(options.type);
  o.parent = maybeNewOrNull(options.parent?.__typename ?? "StandaloneProject", options.parent, cache);
  o.createdBy = maybeNew("User", options.createdBy, cache, options.hasOwnProperty("createdBy"));
  o.assignee = maybeNewOrNull("User", options.assignee, cache);
  o.assignees = (options.assignees ?? []).map((i) => maybeNew("User", i, cache, options.hasOwnProperty("assignees")));
  o.attachments = (options.attachments ?? []).map((i) =>
    maybeNew("Attachment", i, cache, options.hasOwnProperty("attachments"))
  );
  o.urgent = options.urgent ?? false;
  o.checklistItems = (options.checklistItems ?? []).map((i) =>
    maybeNew("ToDoChecklistItem", i, cache, options.hasOwnProperty("checklistItems"))
  );
  o.checklistProgress = maybeNew(
    "ToDoChecklistProgress",
    options.checklistProgress,
    cache,
    options.hasOwnProperty("checklistProgress"),
  );
  o.changeRequest = maybeNewOrNull("ChangeRequest", options.changeRequest, cache);
  return o;
}

factories["ToDo"] = newToDo;

export interface InvoiceOptions {
  __typename?: "Invoice";
  references?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: Invoice["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: Invoice["isFollowed"];
  id?: Invoice["id"];
  name?: Invoice["name"];
  invoiceDate?: Invoice["invoiceDate"];
  dueDate?: Invoice["dueDate"];
  description?: Invoice["description"];
  title?: Invoice["title"];
  quickbooksId?: Invoice["quickbooksId"];
  amountInCents?: Invoice["amountInCents"];
  balanceInCents?: Invoice["balanceInCents"];
  amountPaidInCents?: Invoice["amountPaidInCents"];
  projectStage?: ProjectStage | ProjectStageOptions;
  lineItems?: Array<InvoiceLineItem | InvoiceLineItemOptions>;
  lineItemsByCostCode?: Array<InvoiceLineItemsByCostCode | InvoiceLineItemsByCostCodeOptions>;
  drawLineItems?: Array<InvoiceDrawLineItem | InvoiceDrawLineItemOptions>;
  quickbooksPullOnly?: Invoice["quickbooksPullOnly"];
  document?: Document | DocumentOptions | null;
  invoiceNumber?: Invoice["invoiceNumber"];
  isHistoricalInvoiceNumber?: Invoice["isHistoricalInvoiceNumber"];
  isFinalInvoice?: Invoice["isFinalInvoice"];
  history?: Array<History | HistoryOptions>;
  blueprintUrl?: Url | UrlOptions;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  intacctAmountPaidInCents?: Invoice["intacctAmountPaidInCents"];
  documents?: Array<InvoiceDocument | InvoiceDocumentOptions>;
  quickbooksAmountPaidInCents?: Invoice["quickbooksAmountPaidInCents"];
  intacctSyncError?: Invoice["intacctSyncError"];
  approval?: Approval | ApprovalOptions | null;
  status?: InvoiceStatusDetailOptions | InvoiceStatus;
  lineItemCutoffDate?: Invoice["lineItemCutoffDate"];
  lineItemStartDate?: Invoice["lineItemStartDate"];
  predictedApprovers?: Array<
    ApproverUser | ClientOptions | RequireTypename<InternalUserOptions> | RequireTypename<TradePartnerUserOptions>
  >;
  paidDate?: Invoice["paidDate"];
  creditForInvoice?: Invoice | InvoiceOptions | null;
  shouldSyncToIntacct?: Invoice["shouldSyncToIntacct"];
  intacctId?: Invoice["intacctId"];
  type?: InvoiceTypeDetailOptions | InvoiceType;
  canEdit?: PotentialOperation2 | PotentialOperation2Options;
  canDelete?: PotentialOperation2 | PotentialOperation2Options;
  pandaDocs?: Array<PandaDoc | PandaDocOptions>;
  scheduledLineItems?: Array<InvoiceScheduledLineItem | InvoiceScheduledLineItemOptions>;
  accruedLineItems?: Array<InvoiceAccruedLineItem | InvoiceAccruedLineItemOptions>;
  displayLineItems?: Array<InvoiceDisplayLineItem | InvoiceDisplayLineItemOptions>;
  updatedAt?: Invoice["updatedAt"];
  createdAt?: Invoice["createdAt"];
  isHistorical?: Invoice["isHistorical"];
  parent?:
    | InvoiceParent
    | PlanMilestoneOptions
    | RequireTypename<TaskOptions>
    | RequireTypename<ScheduleTaskOptions>
    | RequireTypename<PlanTaskOptions>
    | null;
  source?: InvoiceSourceDetailOptions | InvoiceSource;
  remainingDownPaymentInCents?: Invoice["remainingDownPaymentInCents"];
  downPaymentConsumingLineItems?: Array<InvoiceLineItem | InvoiceLineItemOptions>;
  pocInvoicedToDateInCents?: Invoice["pocInvoicedToDateInCents"];
  contractPriceSnapshotInCents?: Invoice["contractPriceSnapshotInCents"];
}

export function newInvoice(options: InvoiceOptions = {}, cache: Record<string, any> = {}): Invoice {
  const o = (options.__typename ? options : cache["Invoice"] = {}) as Invoice;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Invoice";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("Invoice");
  o.name = options.name ?? "name";
  o.invoiceDate = options.invoiceDate ?? newDate();
  o.dueDate = options.dueDate ?? newDate();
  o.description = options.description ?? null;
  o.title = options.title ?? "title";
  o.quickbooksId = options.quickbooksId ?? null;
  o.amountInCents = options.amountInCents ?? 0;
  o.balanceInCents = options.balanceInCents ?? 0;
  o.amountPaidInCents = options.amountPaidInCents ?? 0;
  o.projectStage = maybeNew("ProjectStage", options.projectStage, cache, options.hasOwnProperty("projectStage"));
  o.lineItems = (options.lineItems ?? []).map((i) =>
    maybeNew("InvoiceLineItem", i, cache, options.hasOwnProperty("lineItems"))
  );
  o.lineItemsByCostCode = (options.lineItemsByCostCode ?? []).map((i) =>
    maybeNew("InvoiceLineItemsByCostCode", i, cache, options.hasOwnProperty("lineItemsByCostCode"))
  );
  o.drawLineItems = (options.drawLineItems ?? []).map((i) =>
    maybeNew("InvoiceDrawLineItem", i, cache, options.hasOwnProperty("drawLineItems"))
  );
  o.quickbooksPullOnly = options.quickbooksPullOnly ?? false;
  o.document = maybeNewOrNull("Document", options.document, cache);
  o.invoiceNumber = options.invoiceNumber ?? "invoiceNumber";
  o.isHistoricalInvoiceNumber = options.isHistoricalInvoiceNumber ?? false;
  o.isFinalInvoice = options.isFinalInvoice ?? false;
  o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.intacctAmountPaidInCents = options.intacctAmountPaidInCents ?? 0;
  o.documents = (options.documents ?? []).map((i) =>
    maybeNew("InvoiceDocument", i, cache, options.hasOwnProperty("documents"))
  );
  o.quickbooksAmountPaidInCents = options.quickbooksAmountPaidInCents ?? 0;
  o.intacctSyncError = options.intacctSyncError ?? null;
  o.approval = maybeNewOrNull("Approval", options.approval, cache);
  o.status = enumOrDetailOfInvoiceStatus(options.status);
  o.lineItemCutoffDate = options.lineItemCutoffDate ?? null;
  o.lineItemStartDate = options.lineItemStartDate ?? null;
  o.predictedApprovers = (options.predictedApprovers ?? []).map((i) =>
    maybeNew(i?.__typename ?? "{Client", i, cache, options.hasOwnProperty("predictedApprovers"))
  );
  o.paidDate = options.paidDate ?? null;
  o.creditForInvoice = maybeNewOrNull("Invoice", options.creditForInvoice, cache);
  o.shouldSyncToIntacct = options.shouldSyncToIntacct ?? false;
  o.intacctId = options.intacctId ?? null;
  o.type = enumOrDetailOfInvoiceType(options.type);
  o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
  o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
  o.pandaDocs = (options.pandaDocs ?? []).map((i) =>
    maybeNew("PandaDoc", i, cache, options.hasOwnProperty("pandaDocs"))
  );
  o.scheduledLineItems = (options.scheduledLineItems ?? []).map((i) =>
    maybeNew("InvoiceScheduledLineItem", i, cache, options.hasOwnProperty("scheduledLineItems"))
  );
  o.accruedLineItems = (options.accruedLineItems ?? []).map((i) =>
    maybeNew("InvoiceAccruedLineItem", i, cache, options.hasOwnProperty("accruedLineItems"))
  );
  o.displayLineItems = (options.displayLineItems ?? []).map((i) =>
    maybeNew("InvoiceDisplayLineItem", i, cache, options.hasOwnProperty("displayLineItems"))
  );
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.createdAt = options.createdAt ?? newDateTime();
  o.isHistorical = options.isHistorical ?? false;
  o.parent = maybeNewOrNull(options.parent?.__typename ?? "PlanMilestone", options.parent, cache);
  o.source = enumOrDetailOfInvoiceSource(options.source);
  o.remainingDownPaymentInCents = options.remainingDownPaymentInCents ?? 0;
  o.downPaymentConsumingLineItems = (options.downPaymentConsumingLineItems ?? []).map((i) =>
    maybeNew("InvoiceLineItem", i, cache, options.hasOwnProperty("downPaymentConsumingLineItems"))
  );
  o.pocInvoicedToDateInCents = options.pocInvoicedToDateInCents ?? 0;
  o.contractPriceSnapshotInCents = options.contractPriceSnapshotInCents ?? 0;
  return o;
}

factories["Invoice"] = newInvoice;

export interface StandaloneProjectOptions {
  __typename?: "StandaloneProject";
  references?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: StandaloneProject["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: StandaloneProject["isFollowed"];
  id?: StandaloneProject["id"];
  buildAddress?: Address | AddressOptions;
  market?: Market | MarketOptions;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  cohort?: Cohort | CohortOptions | null;
  constructionConfidenceFactor?: StandaloneProject["constructionConfidenceFactor"];
  lotRating?: LotRating | LotRatingOptions | null;
  preConBudgetLineItems?: Array<PreConBudgetCostDivisionLineItem | PreConBudgetCostDivisionLineItemOptions>;
  preconContractType?: PreconContractType | PreconContractTypeOptions | null;
  primaryProject?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  quickbooksCustomerId?: StandaloneProject["quickbooksCustomerId"];
  shadowProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  submarket?: Submarket | SubmarketOptions | null;
  collaborators?: Array<ProjectCollaborator | ProjectCollaboratorOptions>;
  coverImage?: Asset | AssetOptions | null;
  teamMembers?: Array<ProjectTeamMember | ProjectTeamMemberOptions>;
  projectLead?: ProjectTeamMember | ProjectTeamMemberOptions | null;
  activeStage?: StageDetailOptions | Stage;
  activeProjectStage?: ProjectStage | ProjectStageOptions | null;
  stages?: Array<ProjectStage | ProjectStageOptions>;
  stage?: ProjectStage | ProjectStageOptions;
  blueprintUrl?: Url | UrlOptions;
  hopUrl?: StandaloneProject["hopUrl"];
  propcoUrl?: StandaloneProject["propcoUrl"];
  name?: StandaloneProject["name"];
  availableAssignees?: Array<InternalUser | InternalUserOptions>;
  startDate?: StandaloneProject["startDate"];
  features?: StandaloneProject["features"];
  isTest?: StandaloneProject["isTest"];
  status?: ProjectStatusDetailOptions | ProjectStatus;
  latitude?: StandaloneProject["latitude"];
  longitude?: StandaloneProject["longitude"];
  googleDriveFolderId?: StandaloneProject["googleDriveFolderId"];
  salesforceAccountId?: StandaloneProject["salesforceAccountId"];
  salesforceOpportunities?: Array<ProjectSalesforceOpportunity | ProjectSalesforceOpportunityOptions>;
  projectStatusChange?: ProjectStatusChange | ProjectStatusChangeOptions | null;
  planRoomLink?: StandaloneProject["planRoomLink"];
  isDisaster?: StandaloneProject["isDisaster"];
  intakeStyleNotes?: StandaloneProject["intakeStyleNotes"];
  lotType?: LotTypeDetailOptions | LotType;
  communityType?: CommunityTypeDetailOptions | CommunityType | null;
  productType?: ProductType | ProductTypeOptions | null;
  enableSchedulesV2?: StandaloneProject["enableSchedulesV2"];
  tradePartners?: Array<TradePartner | TradePartnerOptions>;
  cutoffs?: Array<ProjectCutoff | ProjectCutoffOptions>;
  jobLogs?: Array<JobLog | JobLogOptions>;
  salesforcePropertyId?: StandaloneProject["salesforcePropertyId"];
  schedules?: Array<Schedule | ScheduleOptions>;
  expenses?: Array<Expense | ExpenseOptions>;
  unallocatedExpenses?: Array<Expense | ExpenseOptions>;
  unallocatedAmountInCents?: StandaloneProject["unallocatedAmountInCents"];
  enableSchedulesV2Gantt?: StandaloneProject["enableSchedulesV2Gantt"];
  enableSchedulesCalendar?: StandaloneProject["enableSchedulesCalendar"];
  readyPlanConfig?: ProjectReadyPlanConfig | ProjectReadyPlanConfigOptions | null;
  earnedValueCurves?: Array<EarnedValueCurve | EarnedValueCurveOptions>;
  enableInvoiceV2?: StandaloneProject["enableInvoiceV2"];
  invoiceSettings?: ProjectInvoiceSetting | ProjectInvoiceSettingOptions | null;
  scopeMode?: ScopeModeDetailOptions | ScopeMode;
  lotPartitionId?: StandaloneProject["lotPartitionId"];
  budgetFinancials?: ProjectBudgetFinancials | ProjectBudgetFinancialsOptions;
  enableDelayFlags?: StandaloneProject["enableDelayFlags"];
  warrantyStartDate?: StandaloneProject["warrantyStartDate"];
  verticalCompleteDate?: StandaloneProject["verticalCompleteDate"];
  jobLogInsights?: ProjectJobLogInsights | ProjectJobLogInsightsOptions;
  targetEndDate?: StandaloneProject["targetEndDate"];
  latestActiveStage?: ProjectStage | ProjectStageOptions | null;
  primaryHomeowner?: Client | ClientOptions | null;
  toDos?: Array<ToDo | ToDoOptions> | null;
  lotDetail?: ProjectLotDetail | ProjectLotDetailOptions;
  siteSpecificInfos?: Array<ProjectSiteSpecificInfo | ProjectSiteSpecificInfoOptions>;
  projectSiteCondition?: ProjectSiteCondition | ProjectSiteConditionOptions | null;
  unassignedTaskCount?: StandaloneProject["unassignedTaskCount"];
  enableHomeownerNotes?: StandaloneProject["enableHomeownerNotes"];
  checkoutCustomerConfigId?: StandaloneProject["checkoutCustomerConfigId"];
  canEditJobLogs?: PotentialOperation2 | PotentialOperation2Options;
  canEditPrice?: PotentialOperation2 | PotentialOperation2Options;
  canHaveBudget?: PotentialOperation2 | PotentialOperation2Options;
  homeownerNotes?: Array<HomeownerNote | HomeownerNoteOptions>;
  enableHomeownerJourneyV2?: StandaloneProject["enableHomeownerJourneyV2"];
  featureFlags?: Array<FeatureFlag | FeatureFlagOptions>;
  homeownerDeliveryDate?: StandaloneProject["homeownerDeliveryDate"];
  tasksCompletedThisWeek?: StandaloneProject["tasksCompletedThisWeek"];
  contacts?: Array<ProjectContact | ProjectContactOptions>;
  warrantyTickets?: Array<WarrantyTicket | WarrantyTicketOptions>;
  shouldAccrueAsComplete?: StandaloneProject["shouldAccrueAsComplete"];
  directCostMarkupOverrideBasisPoints?: StandaloneProject["directCostMarkupOverrideBasisPoints"];
  indirectCostMarkupOverrideBasisPoints?: StandaloneProject["indirectCostMarkupOverrideBasisPoints"];
  customer?: Customer | CustomerOptions | null;
  customerOwnerEntity?: CustomerOwnerEntity | CustomerOwnerEntityOptions | null;
  invoiceSchedule?: InvoiceSchedule | InvoiceScheduleOptions | null;
  allowExcludedCostCodesOnPurchaseOrders?: StandaloneProject["allowExcludedCostCodesOnPurchaseOrders"];
  enableProductConfigPlan?: StandaloneProject["enableProductConfigPlan"];
  planSchedule?: PlanSchedule | PlanScheduleOptions | null;
  builder?: Builder | BuilderOptions | null;
  bidOutPercentage?: StandaloneProject["bidOutPercentage"];
  enableChangeEventSignatures?: StandaloneProject["enableChangeEventSignatures"];
  enablePocInvoiceSchedule?: StandaloneProject["enablePocInvoiceSchedule"];
  softCostMarkupInBasisPoints?: StandaloneProject["softCostMarkupInBasisPoints"];
  indirectHardCostMarkupInBasisPoints?: StandaloneProject["indirectHardCostMarkupInBasisPoints"];
  directHardCostMarkupInBasisPoints?: StandaloneProject["directHardCostMarkupInBasisPoints"];
  legalDescription?: StandaloneProject["legalDescription"];
  salesTaxOverrideInBasisPoints?: StandaloneProject["salesTaxOverrideInBasisPoints"];
  salesTaxInBasisPoints?: StandaloneProject["salesTaxInBasisPoints"];
  projectItemAllocations?: Array<ProjectItemAllocation | ProjectItemAllocationOptions>;
  allocationRules?: Array<ProjectAllocationRule | ProjectAllocationRuleOptions>;
  warrantyLengthInDays?: StandaloneProject["warrantyLengthInDays"];
  warrantyOverrideLengthInDays?: StandaloneProject["warrantyOverrideLengthInDays"];
  bidPackages?: Array<BidPackage | BidPackageOptions>;
  bidContracts?: Array<BidContract | BidContractOptions>;
  selectionsByLocation?: Array<HomeownerLocationSelection | HomeownerLocationSelectionOptions>;
  hasSelections?: StandaloneProject["hasSelections"];
  homeownerContracts?: Array<HomeownerContract | HomeownerContractOptions>;
  documents?: Array<Document | DocumentOptions>;
  commitments?: Array<Commitment | CommitmentOptions>;
  directCostInCents?: StandaloneProject["directCostInCents"];
  directPriceInCents?: StandaloneProject["directPriceInCents"];
  totalHardCostInCents?: StandaloneProject["totalHardCostInCents"];
  totalSoftCostInCents?: StandaloneProject["totalSoftCostInCents"];
  totalCostInCents?: StandaloneProject["totalCostInCents"];
  totalPriceInCents?: StandaloneProject["totalPriceInCents"];
  readyToStartDate?: StandaloneProject["readyToStartDate"];
  committedCostCodesAtStartInBasisPoints?: StandaloneProject["committedCostCodesAtStartInBasisPoints"];
  directCostAtStartInCents?: StandaloneProject["directCostAtStartInCents"];
  directCostVarianceInCents?: StandaloneProject["directCostVarianceInCents"];
  uncommittedCostInCents?: StandaloneProject["uncommittedCostInCents"];
  snapshots?: Array<ProjectSnapshot | ProjectSnapshotOptions>;
  warrantyEndDate?: StandaloneProject["warrantyEndDate"];
  companyInfo?: CompanyInfo | CompanyInfoOptions;
  invoicePaymentNetDays?: StandaloneProject["invoicePaymentNetDays"];
  snapshotAsOf?: ProjectSnapshot | ProjectSnapshotOptions | null;
  purchaseCostInCents?: StandaloneProject["purchaseCostInCents"];
  grossSalesPriceInCents?: StandaloneProject["grossSalesPriceInCents"];
  closingCostsForDirectMarginInCents?: StandaloneProject["closingCostsForDirectMarginInCents"];
  directMarginInBasisPoints?: StandaloneProject["directMarginInBasisPoints"];
  projectCostCodes?: Array<ProjectCostCode | ProjectCostCodeOptions>;
  parent?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  children?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  parentsRecursive?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  childrenRecursive?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  siblingProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  sellableProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  isSellableProject?: StandaloneProject["isSellableProject"];
  originalCostInCents?: StandaloneProject["originalCostInCents"];
  startCostInCents?: StandaloneProject["startCostInCents"];
  changeEventCostInCents?: StandaloneProject["changeEventCostInCents"];
  projectedCostInCents?: StandaloneProject["projectedCostInCents"];
  revisedCostInCents?: StandaloneProject["revisedCostInCents"];
  committedCostInCents?: StandaloneProject["committedCostInCents"];
  availableCostInCents?: StandaloneProject["availableCostInCents"];
  billedCostInCents?: StandaloneProject["billedCostInCents"];
  unbilledCostInCents?: StandaloneProject["unbilledCostInCents"];
  client?: Client | ClientOptions | null;
  url?: StandaloneProject["url"];
  projectName?: StandaloneProject["projectName"];
  salesforceId?: StandaloneProject["salesforceId"];
  activeSalesforceOpportunity?: ProjectSalesforceOpportunity | ProjectSalesforceOpportunityOptions | null;
  dictionary?: ProjectDictionary | ProjectDictionaryOptions;
}

export function newStandaloneProject(
  options: StandaloneProjectOptions = {},
  cache: Record<string, any> = {},
): StandaloneProject {
  const o = (options.__typename ? options : cache["StandaloneProject"] = {}) as StandaloneProject;
  (cache.all ??= new Set()).add(o);
  o.__typename = "StandaloneProject";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("StandaloneProject");
  o.buildAddress = maybeNew("Address", options.buildAddress, cache, options.hasOwnProperty("buildAddress"));
  o.market = maybeNew("Market", options.market, cache, options.hasOwnProperty("market"));
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.cohort = maybeNewOrNull("Cohort", options.cohort, cache);
  o.constructionConfidenceFactor = options.constructionConfidenceFactor ?? null;
  o.lotRating = maybeNewOrNull("LotRating", options.lotRating, cache);
  o.preConBudgetLineItems = (options.preConBudgetLineItems ?? []).map((i) =>
    maybeNew("PreConBudgetCostDivisionLineItem", i, cache, options.hasOwnProperty("preConBudgetLineItems"))
  );
  o.preconContractType = maybeNewOrNull("PreconContractType", options.preconContractType, cache);
  o.primaryProject = maybeNewOrNull("Project", options.primaryProject, cache);
  o.quickbooksCustomerId = options.quickbooksCustomerId ?? null;
  o.shadowProjects = (options.shadowProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("shadowProjects"))
  );
  o.submarket = maybeNewOrNull("Submarket", options.submarket, cache);
  o.collaborators = (options.collaborators ?? []).map((i) =>
    maybeNew("ProjectCollaborator", i, cache, options.hasOwnProperty("collaborators"))
  );
  o.coverImage = maybeNewOrNull("Asset", options.coverImage, cache);
  o.teamMembers = (options.teamMembers ?? []).map((i) =>
    maybeNew("ProjectTeamMember", i, cache, options.hasOwnProperty("teamMembers"))
  );
  o.projectLead = maybeNewOrNull("ProjectTeamMember", options.projectLead, cache);
  o.activeStage = enumOrDetailOfStage(options.activeStage);
  o.activeProjectStage = maybeNewOrNull("ProjectStage", options.activeProjectStage, cache);
  o.stages = (options.stages ?? []).map((i) => maybeNew("ProjectStage", i, cache, options.hasOwnProperty("stages")));
  o.stage = maybeNew("ProjectStage", options.stage, cache, options.hasOwnProperty("stage"));
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.hopUrl = options.hopUrl ?? "hopUrl";
  o.propcoUrl = options.propcoUrl ?? null;
  o.name = options.name ?? "name";
  o.availableAssignees = (options.availableAssignees ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableAssignees"))
  );
  o.startDate = options.startDate ?? newDate();
  o.features = options.features ?? [];
  o.isTest = options.isTest ?? false;
  o.status = enumOrDetailOfProjectStatus(options.status);
  o.latitude = options.latitude ?? null;
  o.longitude = options.longitude ?? null;
  o.googleDriveFolderId = options.googleDriveFolderId ?? null;
  o.salesforceAccountId = options.salesforceAccountId ?? null;
  o.salesforceOpportunities = (options.salesforceOpportunities ?? []).map((i) =>
    maybeNew("ProjectSalesforceOpportunity", i, cache, options.hasOwnProperty("salesforceOpportunities"))
  );
  o.projectStatusChange = maybeNewOrNull("ProjectStatusChange", options.projectStatusChange, cache);
  o.planRoomLink = options.planRoomLink ?? null;
  o.isDisaster = options.isDisaster ?? null;
  o.intakeStyleNotes = options.intakeStyleNotes ?? null;
  o.lotType = enumOrDetailOfLotType(options.lotType);
  o.communityType = enumOrDetailOrNullOfCommunityType(options.communityType);
  o.productType = maybeNewOrNull("ProductType", options.productType, cache);
  o.enableSchedulesV2 = options.enableSchedulesV2 ?? false;
  o.tradePartners = (options.tradePartners ?? []).map((i) =>
    maybeNew("TradePartner", i, cache, options.hasOwnProperty("tradePartners"))
  );
  o.cutoffs = (options.cutoffs ?? []).map((i) =>
    maybeNew("ProjectCutoff", i, cache, options.hasOwnProperty("cutoffs"))
  );
  o.jobLogs = (options.jobLogs ?? []).map((i) => maybeNew("JobLog", i, cache, options.hasOwnProperty("jobLogs")));
  o.salesforcePropertyId = options.salesforcePropertyId ?? null;
  o.schedules = (options.schedules ?? []).map((i) =>
    maybeNew("Schedule", i, cache, options.hasOwnProperty("schedules"))
  );
  o.expenses = (options.expenses ?? []).map((i) => maybeNew("Expense", i, cache, options.hasOwnProperty("expenses")));
  o.unallocatedExpenses = (options.unallocatedExpenses ?? []).map((i) =>
    maybeNew("Expense", i, cache, options.hasOwnProperty("unallocatedExpenses"))
  );
  o.unallocatedAmountInCents = options.unallocatedAmountInCents ?? 0;
  o.enableSchedulesV2Gantt = options.enableSchedulesV2Gantt ?? false;
  o.enableSchedulesCalendar = options.enableSchedulesCalendar ?? false;
  o.readyPlanConfig = maybeNewOrNull("ProjectReadyPlanConfig", options.readyPlanConfig, cache);
  o.earnedValueCurves = (options.earnedValueCurves ?? []).map((i) =>
    maybeNew("EarnedValueCurve", i, cache, options.hasOwnProperty("earnedValueCurves"))
  );
  o.enableInvoiceV2 = options.enableInvoiceV2 ?? false;
  o.invoiceSettings = maybeNewOrNull("ProjectInvoiceSetting", options.invoiceSettings, cache);
  o.scopeMode = enumOrDetailOfScopeMode(options.scopeMode);
  o.lotPartitionId = options.lotPartitionId ?? null;
  o.budgetFinancials = maybeNew(
    "ProjectBudgetFinancials",
    options.budgetFinancials,
    cache,
    options.hasOwnProperty("budgetFinancials"),
  );
  o.enableDelayFlags = options.enableDelayFlags ?? false;
  o.warrantyStartDate = options.warrantyStartDate ?? null;
  o.verticalCompleteDate = options.verticalCompleteDate ?? null;
  o.jobLogInsights = maybeNew(
    "ProjectJobLogInsights",
    options.jobLogInsights,
    cache,
    options.hasOwnProperty("jobLogInsights"),
  );
  o.targetEndDate = options.targetEndDate ?? null;
  o.latestActiveStage = maybeNewOrNull("ProjectStage", options.latestActiveStage, cache);
  o.primaryHomeowner = maybeNewOrNull("Client", options.primaryHomeowner, cache);
  o.toDos = (options.toDos ?? []).map((i) => maybeNew("ToDo", i, cache, options.hasOwnProperty("toDos")));
  o.lotDetail = maybeNew("ProjectLotDetail", options.lotDetail, cache, options.hasOwnProperty("lotDetail"));
  o.siteSpecificInfos = (options.siteSpecificInfos ?? []).map((i) =>
    maybeNew("ProjectSiteSpecificInfo", i, cache, options.hasOwnProperty("siteSpecificInfos"))
  );
  o.projectSiteCondition = maybeNewOrNull("ProjectSiteCondition", options.projectSiteCondition, cache);
  o.unassignedTaskCount = options.unassignedTaskCount ?? 0;
  o.enableHomeownerNotes = options.enableHomeownerNotes ?? false;
  o.checkoutCustomerConfigId = options.checkoutCustomerConfigId ?? null;
  o.canEditJobLogs = maybeNew(
    "PotentialOperation2",
    options.canEditJobLogs,
    cache,
    options.hasOwnProperty("canEditJobLogs"),
  );
  o.canEditPrice = maybeNew("PotentialOperation2", options.canEditPrice, cache, options.hasOwnProperty("canEditPrice"));
  o.canHaveBudget = maybeNew(
    "PotentialOperation2",
    options.canHaveBudget,
    cache,
    options.hasOwnProperty("canHaveBudget"),
  );
  o.homeownerNotes = (options.homeownerNotes ?? []).map((i) =>
    maybeNew("HomeownerNote", i, cache, options.hasOwnProperty("homeownerNotes"))
  );
  o.enableHomeownerJourneyV2 = options.enableHomeownerJourneyV2 ?? false;
  o.featureFlags = (options.featureFlags ?? []).map((i) =>
    maybeNew("FeatureFlag", i, cache, options.hasOwnProperty("featureFlags"))
  );
  o.homeownerDeliveryDate = options.homeownerDeliveryDate ?? null;
  o.tasksCompletedThisWeek = options.tasksCompletedThisWeek ?? 0;
  o.contacts = (options.contacts ?? []).map((i) =>
    maybeNew("ProjectContact", i, cache, options.hasOwnProperty("contacts"))
  );
  o.warrantyTickets = (options.warrantyTickets ?? []).map((i) =>
    maybeNew("WarrantyTicket", i, cache, options.hasOwnProperty("warrantyTickets"))
  );
  o.shouldAccrueAsComplete = options.shouldAccrueAsComplete ?? false;
  o.directCostMarkupOverrideBasisPoints = options.directCostMarkupOverrideBasisPoints ?? null;
  o.indirectCostMarkupOverrideBasisPoints = options.indirectCostMarkupOverrideBasisPoints ?? null;
  o.customer = maybeNewOrNull("Customer", options.customer, cache);
  o.customerOwnerEntity = maybeNewOrNull("CustomerOwnerEntity", options.customerOwnerEntity, cache);
  o.invoiceSchedule = maybeNewOrNull("InvoiceSchedule", options.invoiceSchedule, cache);
  o.allowExcludedCostCodesOnPurchaseOrders = options.allowExcludedCostCodesOnPurchaseOrders ?? false;
  o.enableProductConfigPlan = options.enableProductConfigPlan ?? false;
  o.planSchedule = maybeNewOrNull("PlanSchedule", options.planSchedule, cache);
  o.builder = maybeNewOrNull("Builder", options.builder, cache);
  o.bidOutPercentage = options.bidOutPercentage ?? 0;
  o.enableChangeEventSignatures = options.enableChangeEventSignatures ?? false;
  o.enablePocInvoiceSchedule = options.enablePocInvoiceSchedule ?? false;
  o.softCostMarkupInBasisPoints = options.softCostMarkupInBasisPoints ?? null;
  o.indirectHardCostMarkupInBasisPoints = options.indirectHardCostMarkupInBasisPoints ?? null;
  o.directHardCostMarkupInBasisPoints = options.directHardCostMarkupInBasisPoints ?? null;
  o.legalDescription = options.legalDescription ?? null;
  o.salesTaxOverrideInBasisPoints = options.salesTaxOverrideInBasisPoints ?? null;
  o.salesTaxInBasisPoints = options.salesTaxInBasisPoints ?? 0;
  o.projectItemAllocations = (options.projectItemAllocations ?? []).map((i) =>
    maybeNew("ProjectItemAllocation", i, cache, options.hasOwnProperty("projectItemAllocations"))
  );
  o.allocationRules = (options.allocationRules ?? []).map((i) =>
    maybeNew("ProjectAllocationRule", i, cache, options.hasOwnProperty("allocationRules"))
  );
  o.warrantyLengthInDays = options.warrantyLengthInDays ?? 0;
  o.warrantyOverrideLengthInDays = options.warrantyOverrideLengthInDays ?? null;
  o.bidPackages = (options.bidPackages ?? []).map((i) =>
    maybeNew("BidPackage", i, cache, options.hasOwnProperty("bidPackages"))
  );
  o.bidContracts = (options.bidContracts ?? []).map((i) =>
    maybeNew("BidContract", i, cache, options.hasOwnProperty("bidContracts"))
  );
  o.selectionsByLocation = (options.selectionsByLocation ?? []).map((i) =>
    maybeNew("HomeownerLocationSelection", i, cache, options.hasOwnProperty("selectionsByLocation"))
  );
  o.hasSelections = options.hasSelections ?? false;
  o.homeownerContracts = (options.homeownerContracts ?? []).map((i) =>
    maybeNew("HomeownerContract", i, cache, options.hasOwnProperty("homeownerContracts"))
  );
  o.documents = (options.documents ?? []).map((i) =>
    maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
  );
  o.commitments = (options.commitments ?? []).map((i) =>
    maybeNew("Commitment", i, cache, options.hasOwnProperty("commitments"))
  );
  o.directCostInCents = options.directCostInCents ?? 0;
  o.directPriceInCents = options.directPriceInCents ?? 0;
  o.totalHardCostInCents = options.totalHardCostInCents ?? 0;
  o.totalSoftCostInCents = options.totalSoftCostInCents ?? 0;
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.totalPriceInCents = options.totalPriceInCents ?? 0;
  o.readyToStartDate = options.readyToStartDate ?? null;
  o.committedCostCodesAtStartInBasisPoints = options.committedCostCodesAtStartInBasisPoints ?? null;
  o.directCostAtStartInCents = options.directCostAtStartInCents ?? null;
  o.directCostVarianceInCents = options.directCostVarianceInCents ?? null;
  o.uncommittedCostInCents = options.uncommittedCostInCents ?? 0;
  o.snapshots = (options.snapshots ?? []).map((i) =>
    maybeNew("ProjectSnapshot", i, cache, options.hasOwnProperty("snapshots"))
  );
  o.warrantyEndDate = options.warrantyEndDate ?? null;
  o.companyInfo = maybeNew("CompanyInfo", options.companyInfo, cache, options.hasOwnProperty("companyInfo"));
  o.invoicePaymentNetDays = options.invoicePaymentNetDays ?? 0;
  o.snapshotAsOf = maybeNewOrNull("ProjectSnapshot", options.snapshotAsOf, cache);
  o.purchaseCostInCents = options.purchaseCostInCents ?? null;
  o.grossSalesPriceInCents = options.grossSalesPriceInCents ?? null;
  o.closingCostsForDirectMarginInCents = options.closingCostsForDirectMarginInCents ?? null;
  o.directMarginInBasisPoints = options.directMarginInBasisPoints ?? null;
  o.projectCostCodes = (options.projectCostCodes ?? []).map((i) =>
    maybeNew("ProjectCostCode", i, cache, options.hasOwnProperty("projectCostCodes"))
  );
  o.parent = maybeNewOrNull("Project", options.parent, cache);
  o.children = (options.children ?? []).map((i) => maybeNew("Project", i, cache, options.hasOwnProperty("children")));
  o.parentsRecursive = (options.parentsRecursive ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("parentsRecursive"))
  );
  o.childrenRecursive = (options.childrenRecursive ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("childrenRecursive"))
  );
  o.siblingProjects = (options.siblingProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("siblingProjects"))
  );
  o.sellableProjects = (options.sellableProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("sellableProjects"))
  );
  o.isSellableProject = options.isSellableProject ?? false;
  o.originalCostInCents = options.originalCostInCents ?? 0;
  o.startCostInCents = options.startCostInCents ?? 0;
  o.changeEventCostInCents = options.changeEventCostInCents ?? 0;
  o.projectedCostInCents = options.projectedCostInCents ?? 0;
  o.revisedCostInCents = options.revisedCostInCents ?? 0;
  o.committedCostInCents = options.committedCostInCents ?? 0;
  o.availableCostInCents = options.availableCostInCents ?? 0;
  o.billedCostInCents = options.billedCostInCents ?? 0;
  o.unbilledCostInCents = options.unbilledCostInCents ?? 0;
  o.client = maybeNewOrNull("Client", options.client, cache);
  o.url = options.url ?? "url";
  o.projectName = options.projectName ?? "projectName";
  o.salesforceId = options.salesforceId ?? null;
  o.activeSalesforceOpportunity = maybeNewOrNull(
    "ProjectSalesforceOpportunity",
    options.activeSalesforceOpportunity,
    cache,
  );
  o.dictionary = maybeNew("ProjectDictionary", options.dictionary, cache, options.hasOwnProperty("dictionary"));
  return o;
}

factories["StandaloneProject"] = newStandaloneProject;

export interface RegionOptions {
  __typename?: "Region";
  references?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: Region["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: Region["isFollowed"];
  id?: Region["id"];
  abbreviation?: Region["abbreviation"];
  createdAt?: Region["createdAt"];
  updatedAt?: Region["updatedAt"];
  children?: Array<Market | MarketOptions>;
  collaborators?: Array<ProjectCollaborator | ProjectCollaboratorOptions>;
  coverImage?: Asset | AssetOptions | null;
  buildAddress?: Address | AddressOptions | null;
  market?: Market | MarketOptions | null;
  teamMembers?: Array<ProjectTeamMember | ProjectTeamMemberOptions>;
  projectLead?: ProjectTeamMember | ProjectTeamMemberOptions | null;
  activeStage?: StageDetailOptions | Stage;
  activeProjectStage?: ProjectStage | ProjectStageOptions | null;
  stages?: Array<ProjectStage | ProjectStageOptions>;
  stage?: ProjectStage | ProjectStageOptions;
  blueprintUrl?: Url | UrlOptions;
  hopUrl?: Region["hopUrl"];
  name?: Region["name"];
  availableAssignees?: Array<InternalUser | InternalUserOptions>;
  startDate?: Region["startDate"];
  features?: Region["features"];
  isTest?: Region["isTest"];
  status?: ProjectStatusDetailOptions | ProjectStatus;
  latitude?: Region["latitude"];
  longitude?: Region["longitude"];
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  googleDriveFolderId?: Region["googleDriveFolderId"];
  salesforceAccountId?: Region["salesforceAccountId"];
  salesforceOpportunities?: Array<ProjectSalesforceOpportunity | ProjectSalesforceOpportunityOptions>;
  projectStatusChange?: ProjectStatusChange | ProjectStatusChangeOptions | null;
  planRoomLink?: Region["planRoomLink"];
  isDisaster?: Region["isDisaster"];
  intakeStyleNotes?: Region["intakeStyleNotes"];
  lotType?: LotTypeDetailOptions | LotType;
  communityType?: CommunityTypeDetailOptions | CommunityType | null;
  productType?: ProductType | ProductTypeOptions | null;
  enableSchedulesV2?: Region["enableSchedulesV2"];
  tradePartners?: Array<TradePartner | TradePartnerOptions>;
  cutoffs?: Array<ProjectCutoff | ProjectCutoffOptions>;
  jobLogs?: Array<JobLog | JobLogOptions>;
  salesforcePropertyId?: Region["salesforcePropertyId"];
  schedules?: Array<Schedule | ScheduleOptions>;
  expenses?: Array<Expense | ExpenseOptions>;
  unallocatedExpenses?: Array<Expense | ExpenseOptions>;
  unallocatedAmountInCents?: Region["unallocatedAmountInCents"];
  enableSchedulesV2Gantt?: Region["enableSchedulesV2Gantt"];
  enableSchedulesCalendar?: Region["enableSchedulesCalendar"];
  readyPlanConfig?: ProjectReadyPlanConfig | ProjectReadyPlanConfigOptions | null;
  earnedValueCurves?: Array<EarnedValueCurve | EarnedValueCurveOptions>;
  enableInvoiceV2?: Region["enableInvoiceV2"];
  invoiceSettings?: ProjectInvoiceSetting | ProjectInvoiceSettingOptions | null;
  scopeMode?: ScopeModeDetailOptions | ScopeMode;
  lotPartitionId?: Region["lotPartitionId"];
  budgetFinancials?: ProjectBudgetFinancials | ProjectBudgetFinancialsOptions;
  enableDelayFlags?: Region["enableDelayFlags"];
  warrantyStartDate?: Region["warrantyStartDate"];
  verticalCompleteDate?: Region["verticalCompleteDate"];
  jobLogInsights?: ProjectJobLogInsights | ProjectJobLogInsightsOptions;
  targetEndDate?: Region["targetEndDate"];
  latestActiveStage?: ProjectStage | ProjectStageOptions | null;
  primaryHomeowner?: Client | ClientOptions | null;
  toDos?: Array<ToDo | ToDoOptions> | null;
  lotDetail?: ProjectLotDetail | ProjectLotDetailOptions;
  siteSpecificInfos?: Array<ProjectSiteSpecificInfo | ProjectSiteSpecificInfoOptions>;
  projectSiteCondition?: ProjectSiteCondition | ProjectSiteConditionOptions | null;
  unassignedTaskCount?: Region["unassignedTaskCount"];
  enableHomeownerNotes?: Region["enableHomeownerNotes"];
  checkoutCustomerConfigId?: Region["checkoutCustomerConfigId"];
  canEditJobLogs?: PotentialOperation2 | PotentialOperation2Options;
  canEditPrice?: PotentialOperation2 | PotentialOperation2Options;
  canHaveBudget?: PotentialOperation2 | PotentialOperation2Options;
  homeownerNotes?: Array<HomeownerNote | HomeownerNoteOptions>;
  enableHomeownerJourneyV2?: Region["enableHomeownerJourneyV2"];
  featureFlags?: Array<FeatureFlag | FeatureFlagOptions>;
  homeownerDeliveryDate?: Region["homeownerDeliveryDate"];
  tasksCompletedThisWeek?: Region["tasksCompletedThisWeek"];
  contacts?: Array<ProjectContact | ProjectContactOptions>;
  warrantyTickets?: Array<WarrantyTicket | WarrantyTicketOptions>;
  shouldAccrueAsComplete?: Region["shouldAccrueAsComplete"];
  directCostMarkupOverrideBasisPoints?: Region["directCostMarkupOverrideBasisPoints"];
  indirectCostMarkupOverrideBasisPoints?: Region["indirectCostMarkupOverrideBasisPoints"];
  customer?: Customer | CustomerOptions | null;
  customerOwnerEntity?: CustomerOwnerEntity | CustomerOwnerEntityOptions | null;
  invoiceSchedule?: InvoiceSchedule | InvoiceScheduleOptions | null;
  allowExcludedCostCodesOnPurchaseOrders?: Region["allowExcludedCostCodesOnPurchaseOrders"];
  enableProductConfigPlan?: Region["enableProductConfigPlan"];
  planSchedule?: PlanSchedule | PlanScheduleOptions | null;
  builder?: Builder | BuilderOptions | null;
  bidOutPercentage?: Region["bidOutPercentage"];
  enableChangeEventSignatures?: Region["enableChangeEventSignatures"];
  enablePocInvoiceSchedule?: Region["enablePocInvoiceSchedule"];
  softCostMarkupInBasisPoints?: Region["softCostMarkupInBasisPoints"];
  indirectHardCostMarkupInBasisPoints?: Region["indirectHardCostMarkupInBasisPoints"];
  directHardCostMarkupInBasisPoints?: Region["directHardCostMarkupInBasisPoints"];
  legalDescription?: Region["legalDescription"];
  salesTaxOverrideInBasisPoints?: Region["salesTaxOverrideInBasisPoints"];
  salesTaxInBasisPoints?: Region["salesTaxInBasisPoints"];
  projectItemAllocations?: Array<ProjectItemAllocation | ProjectItemAllocationOptions>;
  allocationRules?: Array<ProjectAllocationRule | ProjectAllocationRuleOptions>;
  warrantyLengthInDays?: Region["warrantyLengthInDays"];
  warrantyOverrideLengthInDays?: Region["warrantyOverrideLengthInDays"];
  bidPackages?: Array<BidPackage | BidPackageOptions>;
  bidContracts?: Array<BidContract | BidContractOptions>;
  selectionsByLocation?: Array<HomeownerLocationSelection | HomeownerLocationSelectionOptions>;
  hasSelections?: Region["hasSelections"];
  homeownerContracts?: Array<HomeownerContract | HomeownerContractOptions>;
  documents?: Array<Document | DocumentOptions>;
  commitments?: Array<Commitment | CommitmentOptions>;
  directCostInCents?: Region["directCostInCents"];
  directPriceInCents?: Region["directPriceInCents"];
  totalHardCostInCents?: Region["totalHardCostInCents"];
  totalSoftCostInCents?: Region["totalSoftCostInCents"];
  totalCostInCents?: Region["totalCostInCents"];
  totalPriceInCents?: Region["totalPriceInCents"];
  readyToStartDate?: Region["readyToStartDate"];
  committedCostCodesAtStartInBasisPoints?: Region["committedCostCodesAtStartInBasisPoints"];
  directCostAtStartInCents?: Region["directCostAtStartInCents"];
  directCostVarianceInCents?: Region["directCostVarianceInCents"];
  uncommittedCostInCents?: Region["uncommittedCostInCents"];
  snapshots?: Array<ProjectSnapshot | ProjectSnapshotOptions>;
  companyInfo?: CompanyInfo | CompanyInfoOptions;
  invoicePaymentNetDays?: Region["invoicePaymentNetDays"];
  snapshotAsOf?: ProjectSnapshot | ProjectSnapshotOptions | null;
  purchaseCostInCents?: Region["purchaseCostInCents"];
  grossSalesPriceInCents?: Region["grossSalesPriceInCents"];
  closingCostsForDirectMarginInCents?: Region["closingCostsForDirectMarginInCents"];
  directMarginInBasisPoints?: Region["directMarginInBasisPoints"];
  projectCostCodes?: Array<ProjectCostCode | ProjectCostCodeOptions>;
  parent?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  parentsRecursive?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  childrenRecursive?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  siblingProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  sellableProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  isSellableProject?: Region["isSellableProject"];
  originalCostInCents?: Region["originalCostInCents"];
  startCostInCents?: Region["startCostInCents"];
  changeEventCostInCents?: Region["changeEventCostInCents"];
  projectedCostInCents?: Region["projectedCostInCents"];
  revisedCostInCents?: Region["revisedCostInCents"];
  committedCostInCents?: Region["committedCostInCents"];
  availableCostInCents?: Region["availableCostInCents"];
  billedCostInCents?: Region["billedCostInCents"];
  unbilledCostInCents?: Region["unbilledCostInCents"];
  cohort?: Cohort | CohortOptions | null;
  constructionConfidenceFactor?: Region["constructionConfidenceFactor"];
  lotRating?: LotRating | LotRatingOptions | null;
  preConBudgetLineItems?: Array<PreConBudgetCostDivisionLineItem | PreConBudgetCostDivisionLineItemOptions>;
  preconContractType?: PreconContractType | PreconContractTypeOptions | null;
  primaryProject?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  quickbooksCustomerId?: Region["quickbooksCustomerId"];
  shadowProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  submarket?: Submarket | SubmarketOptions | null;
  client?: Client | ClientOptions | null;
  url?: Region["url"];
  projectName?: Region["projectName"];
  salesforceId?: Region["salesforceId"];
  activeSalesforceOpportunity?: ProjectSalesforceOpportunity | ProjectSalesforceOpportunityOptions | null;
  dictionary?: ProjectDictionary | ProjectDictionaryOptions;
  warrantyEndDate?: Region["warrantyEndDate"];
  invoiceScheduleTemplates?: Array<InvoiceScheduleTemplate | InvoiceScheduleTemplateOptions>;
}

export function newRegion(options: RegionOptions = {}, cache: Record<string, any> = {}): Region {
  const o = (options.__typename ? options : cache["Region"] = {}) as Region;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Region";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("Region");
  o.abbreviation = options.abbreviation ?? "abbreviation";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.children = (options.children ?? []).map((i) => maybeNew("Market", i, cache, options.hasOwnProperty("children")));
  o.collaborators = (options.collaborators ?? []).map((i) =>
    maybeNew("ProjectCollaborator", i, cache, options.hasOwnProperty("collaborators"))
  );
  o.coverImage = maybeNewOrNull("Asset", options.coverImage, cache);
  o.buildAddress = maybeNewOrNull("Address", options.buildAddress, cache);
  o.market = maybeNewOrNull("Market", options.market, cache);
  o.teamMembers = (options.teamMembers ?? []).map((i) =>
    maybeNew("ProjectTeamMember", i, cache, options.hasOwnProperty("teamMembers"))
  );
  o.projectLead = maybeNewOrNull("ProjectTeamMember", options.projectLead, cache);
  o.activeStage = enumOrDetailOfStage(options.activeStage);
  o.activeProjectStage = maybeNewOrNull("ProjectStage", options.activeProjectStage, cache);
  o.stages = (options.stages ?? []).map((i) => maybeNew("ProjectStage", i, cache, options.hasOwnProperty("stages")));
  o.stage = maybeNew("ProjectStage", options.stage, cache, options.hasOwnProperty("stage"));
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.hopUrl = options.hopUrl ?? "hopUrl";
  o.name = options.name ?? "name";
  o.availableAssignees = (options.availableAssignees ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableAssignees"))
  );
  o.startDate = options.startDate ?? newDate();
  o.features = options.features ?? [];
  o.isTest = options.isTest ?? false;
  o.status = enumOrDetailOfProjectStatus(options.status);
  o.latitude = options.latitude ?? null;
  o.longitude = options.longitude ?? null;
  o.project = maybeNewOrNull("Project", options.project, cache);
  o.googleDriveFolderId = options.googleDriveFolderId ?? null;
  o.salesforceAccountId = options.salesforceAccountId ?? null;
  o.salesforceOpportunities = (options.salesforceOpportunities ?? []).map((i) =>
    maybeNew("ProjectSalesforceOpportunity", i, cache, options.hasOwnProperty("salesforceOpportunities"))
  );
  o.projectStatusChange = maybeNewOrNull("ProjectStatusChange", options.projectStatusChange, cache);
  o.planRoomLink = options.planRoomLink ?? null;
  o.isDisaster = options.isDisaster ?? null;
  o.intakeStyleNotes = options.intakeStyleNotes ?? null;
  o.lotType = enumOrDetailOfLotType(options.lotType);
  o.communityType = enumOrDetailOrNullOfCommunityType(options.communityType);
  o.productType = maybeNewOrNull("ProductType", options.productType, cache);
  o.enableSchedulesV2 = options.enableSchedulesV2 ?? false;
  o.tradePartners = (options.tradePartners ?? []).map((i) =>
    maybeNew("TradePartner", i, cache, options.hasOwnProperty("tradePartners"))
  );
  o.cutoffs = (options.cutoffs ?? []).map((i) =>
    maybeNew("ProjectCutoff", i, cache, options.hasOwnProperty("cutoffs"))
  );
  o.jobLogs = (options.jobLogs ?? []).map((i) => maybeNew("JobLog", i, cache, options.hasOwnProperty("jobLogs")));
  o.salesforcePropertyId = options.salesforcePropertyId ?? null;
  o.schedules = (options.schedules ?? []).map((i) =>
    maybeNew("Schedule", i, cache, options.hasOwnProperty("schedules"))
  );
  o.expenses = (options.expenses ?? []).map((i) => maybeNew("Expense", i, cache, options.hasOwnProperty("expenses")));
  o.unallocatedExpenses = (options.unallocatedExpenses ?? []).map((i) =>
    maybeNew("Expense", i, cache, options.hasOwnProperty("unallocatedExpenses"))
  );
  o.unallocatedAmountInCents = options.unallocatedAmountInCents ?? 0;
  o.enableSchedulesV2Gantt = options.enableSchedulesV2Gantt ?? false;
  o.enableSchedulesCalendar = options.enableSchedulesCalendar ?? false;
  o.readyPlanConfig = maybeNewOrNull("ProjectReadyPlanConfig", options.readyPlanConfig, cache);
  o.earnedValueCurves = (options.earnedValueCurves ?? []).map((i) =>
    maybeNew("EarnedValueCurve", i, cache, options.hasOwnProperty("earnedValueCurves"))
  );
  o.enableInvoiceV2 = options.enableInvoiceV2 ?? false;
  o.invoiceSettings = maybeNewOrNull("ProjectInvoiceSetting", options.invoiceSettings, cache);
  o.scopeMode = enumOrDetailOfScopeMode(options.scopeMode);
  o.lotPartitionId = options.lotPartitionId ?? null;
  o.budgetFinancials = maybeNew(
    "ProjectBudgetFinancials",
    options.budgetFinancials,
    cache,
    options.hasOwnProperty("budgetFinancials"),
  );
  o.enableDelayFlags = options.enableDelayFlags ?? false;
  o.warrantyStartDate = options.warrantyStartDate ?? null;
  o.verticalCompleteDate = options.verticalCompleteDate ?? null;
  o.jobLogInsights = maybeNew(
    "ProjectJobLogInsights",
    options.jobLogInsights,
    cache,
    options.hasOwnProperty("jobLogInsights"),
  );
  o.targetEndDate = options.targetEndDate ?? null;
  o.latestActiveStage = maybeNewOrNull("ProjectStage", options.latestActiveStage, cache);
  o.primaryHomeowner = maybeNewOrNull("Client", options.primaryHomeowner, cache);
  o.toDos = (options.toDos ?? []).map((i) => maybeNew("ToDo", i, cache, options.hasOwnProperty("toDos")));
  o.lotDetail = maybeNew("ProjectLotDetail", options.lotDetail, cache, options.hasOwnProperty("lotDetail"));
  o.siteSpecificInfos = (options.siteSpecificInfos ?? []).map((i) =>
    maybeNew("ProjectSiteSpecificInfo", i, cache, options.hasOwnProperty("siteSpecificInfos"))
  );
  o.projectSiteCondition = maybeNewOrNull("ProjectSiteCondition", options.projectSiteCondition, cache);
  o.unassignedTaskCount = options.unassignedTaskCount ?? 0;
  o.enableHomeownerNotes = options.enableHomeownerNotes ?? false;
  o.checkoutCustomerConfigId = options.checkoutCustomerConfigId ?? null;
  o.canEditJobLogs = maybeNew(
    "PotentialOperation2",
    options.canEditJobLogs,
    cache,
    options.hasOwnProperty("canEditJobLogs"),
  );
  o.canEditPrice = maybeNew("PotentialOperation2", options.canEditPrice, cache, options.hasOwnProperty("canEditPrice"));
  o.canHaveBudget = maybeNew(
    "PotentialOperation2",
    options.canHaveBudget,
    cache,
    options.hasOwnProperty("canHaveBudget"),
  );
  o.homeownerNotes = (options.homeownerNotes ?? []).map((i) =>
    maybeNew("HomeownerNote", i, cache, options.hasOwnProperty("homeownerNotes"))
  );
  o.enableHomeownerJourneyV2 = options.enableHomeownerJourneyV2 ?? false;
  o.featureFlags = (options.featureFlags ?? []).map((i) =>
    maybeNew("FeatureFlag", i, cache, options.hasOwnProperty("featureFlags"))
  );
  o.homeownerDeliveryDate = options.homeownerDeliveryDate ?? null;
  o.tasksCompletedThisWeek = options.tasksCompletedThisWeek ?? 0;
  o.contacts = (options.contacts ?? []).map((i) =>
    maybeNew("ProjectContact", i, cache, options.hasOwnProperty("contacts"))
  );
  o.warrantyTickets = (options.warrantyTickets ?? []).map((i) =>
    maybeNew("WarrantyTicket", i, cache, options.hasOwnProperty("warrantyTickets"))
  );
  o.shouldAccrueAsComplete = options.shouldAccrueAsComplete ?? false;
  o.directCostMarkupOverrideBasisPoints = options.directCostMarkupOverrideBasisPoints ?? null;
  o.indirectCostMarkupOverrideBasisPoints = options.indirectCostMarkupOverrideBasisPoints ?? null;
  o.customer = maybeNewOrNull("Customer", options.customer, cache);
  o.customerOwnerEntity = maybeNewOrNull("CustomerOwnerEntity", options.customerOwnerEntity, cache);
  o.invoiceSchedule = maybeNewOrNull("InvoiceSchedule", options.invoiceSchedule, cache);
  o.allowExcludedCostCodesOnPurchaseOrders = options.allowExcludedCostCodesOnPurchaseOrders ?? false;
  o.enableProductConfigPlan = options.enableProductConfigPlan ?? false;
  o.planSchedule = maybeNewOrNull("PlanSchedule", options.planSchedule, cache);
  o.builder = maybeNewOrNull("Builder", options.builder, cache);
  o.bidOutPercentage = options.bidOutPercentage ?? 0;
  o.enableChangeEventSignatures = options.enableChangeEventSignatures ?? false;
  o.enablePocInvoiceSchedule = options.enablePocInvoiceSchedule ?? false;
  o.softCostMarkupInBasisPoints = options.softCostMarkupInBasisPoints ?? null;
  o.indirectHardCostMarkupInBasisPoints = options.indirectHardCostMarkupInBasisPoints ?? null;
  o.directHardCostMarkupInBasisPoints = options.directHardCostMarkupInBasisPoints ?? null;
  o.legalDescription = options.legalDescription ?? null;
  o.salesTaxOverrideInBasisPoints = options.salesTaxOverrideInBasisPoints ?? null;
  o.salesTaxInBasisPoints = options.salesTaxInBasisPoints ?? 0;
  o.projectItemAllocations = (options.projectItemAllocations ?? []).map((i) =>
    maybeNew("ProjectItemAllocation", i, cache, options.hasOwnProperty("projectItemAllocations"))
  );
  o.allocationRules = (options.allocationRules ?? []).map((i) =>
    maybeNew("ProjectAllocationRule", i, cache, options.hasOwnProperty("allocationRules"))
  );
  o.warrantyLengthInDays = options.warrantyLengthInDays ?? 0;
  o.warrantyOverrideLengthInDays = options.warrantyOverrideLengthInDays ?? null;
  o.bidPackages = (options.bidPackages ?? []).map((i) =>
    maybeNew("BidPackage", i, cache, options.hasOwnProperty("bidPackages"))
  );
  o.bidContracts = (options.bidContracts ?? []).map((i) =>
    maybeNew("BidContract", i, cache, options.hasOwnProperty("bidContracts"))
  );
  o.selectionsByLocation = (options.selectionsByLocation ?? []).map((i) =>
    maybeNew("HomeownerLocationSelection", i, cache, options.hasOwnProperty("selectionsByLocation"))
  );
  o.hasSelections = options.hasSelections ?? false;
  o.homeownerContracts = (options.homeownerContracts ?? []).map((i) =>
    maybeNew("HomeownerContract", i, cache, options.hasOwnProperty("homeownerContracts"))
  );
  o.documents = (options.documents ?? []).map((i) =>
    maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
  );
  o.commitments = (options.commitments ?? []).map((i) =>
    maybeNew("Commitment", i, cache, options.hasOwnProperty("commitments"))
  );
  o.directCostInCents = options.directCostInCents ?? 0;
  o.directPriceInCents = options.directPriceInCents ?? 0;
  o.totalHardCostInCents = options.totalHardCostInCents ?? 0;
  o.totalSoftCostInCents = options.totalSoftCostInCents ?? 0;
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.totalPriceInCents = options.totalPriceInCents ?? 0;
  o.readyToStartDate = options.readyToStartDate ?? null;
  o.committedCostCodesAtStartInBasisPoints = options.committedCostCodesAtStartInBasisPoints ?? null;
  o.directCostAtStartInCents = options.directCostAtStartInCents ?? null;
  o.directCostVarianceInCents = options.directCostVarianceInCents ?? null;
  o.uncommittedCostInCents = options.uncommittedCostInCents ?? 0;
  o.snapshots = (options.snapshots ?? []).map((i) =>
    maybeNew("ProjectSnapshot", i, cache, options.hasOwnProperty("snapshots"))
  );
  o.companyInfo = maybeNew("CompanyInfo", options.companyInfo, cache, options.hasOwnProperty("companyInfo"));
  o.invoicePaymentNetDays = options.invoicePaymentNetDays ?? 0;
  o.snapshotAsOf = maybeNewOrNull("ProjectSnapshot", options.snapshotAsOf, cache);
  o.purchaseCostInCents = options.purchaseCostInCents ?? null;
  o.grossSalesPriceInCents = options.grossSalesPriceInCents ?? null;
  o.closingCostsForDirectMarginInCents = options.closingCostsForDirectMarginInCents ?? null;
  o.directMarginInBasisPoints = options.directMarginInBasisPoints ?? null;
  o.projectCostCodes = (options.projectCostCodes ?? []).map((i) =>
    maybeNew("ProjectCostCode", i, cache, options.hasOwnProperty("projectCostCodes"))
  );
  o.parent = maybeNewOrNull("Project", options.parent, cache);
  o.parentsRecursive = (options.parentsRecursive ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("parentsRecursive"))
  );
  o.childrenRecursive = (options.childrenRecursive ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("childrenRecursive"))
  );
  o.siblingProjects = (options.siblingProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("siblingProjects"))
  );
  o.sellableProjects = (options.sellableProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("sellableProjects"))
  );
  o.isSellableProject = options.isSellableProject ?? false;
  o.originalCostInCents = options.originalCostInCents ?? 0;
  o.startCostInCents = options.startCostInCents ?? 0;
  o.changeEventCostInCents = options.changeEventCostInCents ?? 0;
  o.projectedCostInCents = options.projectedCostInCents ?? 0;
  o.revisedCostInCents = options.revisedCostInCents ?? 0;
  o.committedCostInCents = options.committedCostInCents ?? 0;
  o.availableCostInCents = options.availableCostInCents ?? 0;
  o.billedCostInCents = options.billedCostInCents ?? 0;
  o.unbilledCostInCents = options.unbilledCostInCents ?? 0;
  o.cohort = maybeNewOrNull("Cohort", options.cohort, cache);
  o.constructionConfidenceFactor = options.constructionConfidenceFactor ?? null;
  o.lotRating = maybeNewOrNull("LotRating", options.lotRating, cache);
  o.preConBudgetLineItems = (options.preConBudgetLineItems ?? []).map((i) =>
    maybeNew("PreConBudgetCostDivisionLineItem", i, cache, options.hasOwnProperty("preConBudgetLineItems"))
  );
  o.preconContractType = maybeNewOrNull("PreconContractType", options.preconContractType, cache);
  o.primaryProject = maybeNewOrNull("Project", options.primaryProject, cache);
  o.quickbooksCustomerId = options.quickbooksCustomerId ?? null;
  o.shadowProjects = (options.shadowProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("shadowProjects"))
  );
  o.submarket = maybeNewOrNull("Submarket", options.submarket, cache);
  o.client = maybeNewOrNull("Client", options.client, cache);
  o.url = options.url ?? "url";
  o.projectName = options.projectName ?? "projectName";
  o.salesforceId = options.salesforceId ?? null;
  o.activeSalesforceOpportunity = maybeNewOrNull(
    "ProjectSalesforceOpportunity",
    options.activeSalesforceOpportunity,
    cache,
  );
  o.dictionary = maybeNew("ProjectDictionary", options.dictionary, cache, options.hasOwnProperty("dictionary"));
  o.warrantyEndDate = options.warrantyEndDate ?? null;
  o.invoiceScheduleTemplates = (options.invoiceScheduleTemplates ?? []).map((i) =>
    maybeNew("InvoiceScheduleTemplate", i, cache, options.hasOwnProperty("invoiceScheduleTemplates"))
  );
  return o;
}

factories["Region"] = newRegion;

export interface MarketOptions {
  __typename?: "Market";
  references?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: Market["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: Market["isFollowed"];
  id?: Market["id"];
  abbreviation?: Market["abbreviation"];
  phone?: Market["phone"];
  salesforceMarketCode?: Market["salesforceMarketCode"];
  submarkets?: Array<Submarket | SubmarketOptions>;
  timeZone?: Market["timeZone"];
  msaName?: Market["msaName"];
  developments?: Array<Development | DevelopmentOptions>;
  bidItemEstimates?: Array<BidItemEstimate | BidItemEstimateOptions>;
  readyPlans?: Array<ReadyPlan | ReadyPlanOptions>;
  optionPricingConfigVariants?: Array<OptionPricingConfigVariant | OptionPricingConfigVariantOptions>;
  state?: Market["state"];
  materialLeadTimeConfigVariants?: Array<MaterialLeadTimeConfigVariant | MaterialLeadTimeConfigVariantOptions>;
  standaloneProjects?: Array<StandaloneProject | StandaloneProjectOptions>;
  marketDevelopmentContracts?: Array<DevelopmentCommitment | DevelopmentCommitmentOptions>;
  drops?: Array<Drop | DropOptions>;
  market?: Market | MarketOptions;
  parent?: Region | RegionOptions;
  children?: Array<Community | CommunityOptions>;
  collaborators?: Array<ProjectCollaborator | ProjectCollaboratorOptions>;
  coverImage?: Asset | AssetOptions | null;
  buildAddress?: Address | AddressOptions | null;
  teamMembers?: Array<ProjectTeamMember | ProjectTeamMemberOptions>;
  projectLead?: ProjectTeamMember | ProjectTeamMemberOptions | null;
  activeStage?: StageDetailOptions | Stage;
  activeProjectStage?: ProjectStage | ProjectStageOptions | null;
  stages?: Array<ProjectStage | ProjectStageOptions>;
  stage?: ProjectStage | ProjectStageOptions;
  blueprintUrl?: Url | UrlOptions;
  hopUrl?: Market["hopUrl"];
  name?: Market["name"];
  availableAssignees?: Array<InternalUser | InternalUserOptions>;
  startDate?: Market["startDate"];
  features?: Market["features"];
  isTest?: Market["isTest"];
  status?: ProjectStatusDetailOptions | ProjectStatus;
  latitude?: Market["latitude"];
  longitude?: Market["longitude"];
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  googleDriveFolderId?: Market["googleDriveFolderId"];
  salesforceAccountId?: Market["salesforceAccountId"];
  salesforceOpportunities?: Array<ProjectSalesforceOpportunity | ProjectSalesforceOpportunityOptions>;
  projectStatusChange?: ProjectStatusChange | ProjectStatusChangeOptions | null;
  planRoomLink?: Market["planRoomLink"];
  isDisaster?: Market["isDisaster"];
  intakeStyleNotes?: Market["intakeStyleNotes"];
  lotType?: LotTypeDetailOptions | LotType;
  communityType?: CommunityTypeDetailOptions | CommunityType | null;
  productType?: ProductType | ProductTypeOptions | null;
  enableSchedulesV2?: Market["enableSchedulesV2"];
  tradePartners?: Array<TradePartner | TradePartnerOptions>;
  cutoffs?: Array<ProjectCutoff | ProjectCutoffOptions>;
  jobLogs?: Array<JobLog | JobLogOptions>;
  salesforcePropertyId?: Market["salesforcePropertyId"];
  schedules?: Array<Schedule | ScheduleOptions>;
  expenses?: Array<Expense | ExpenseOptions>;
  unallocatedExpenses?: Array<Expense | ExpenseOptions>;
  unallocatedAmountInCents?: Market["unallocatedAmountInCents"];
  enableSchedulesV2Gantt?: Market["enableSchedulesV2Gantt"];
  enableSchedulesCalendar?: Market["enableSchedulesCalendar"];
  readyPlanConfig?: ProjectReadyPlanConfig | ProjectReadyPlanConfigOptions | null;
  earnedValueCurves?: Array<EarnedValueCurve | EarnedValueCurveOptions>;
  enableInvoiceV2?: Market["enableInvoiceV2"];
  invoiceSettings?: ProjectInvoiceSetting | ProjectInvoiceSettingOptions | null;
  scopeMode?: ScopeModeDetailOptions | ScopeMode;
  lotPartitionId?: Market["lotPartitionId"];
  budgetFinancials?: ProjectBudgetFinancials | ProjectBudgetFinancialsOptions;
  enableDelayFlags?: Market["enableDelayFlags"];
  warrantyStartDate?: Market["warrantyStartDate"];
  verticalCompleteDate?: Market["verticalCompleteDate"];
  jobLogInsights?: ProjectJobLogInsights | ProjectJobLogInsightsOptions;
  targetEndDate?: Market["targetEndDate"];
  latestActiveStage?: ProjectStage | ProjectStageOptions | null;
  primaryHomeowner?: Client | ClientOptions | null;
  toDos?: Array<ToDo | ToDoOptions> | null;
  lotDetail?: ProjectLotDetail | ProjectLotDetailOptions;
  siteSpecificInfos?: Array<ProjectSiteSpecificInfo | ProjectSiteSpecificInfoOptions>;
  projectSiteCondition?: ProjectSiteCondition | ProjectSiteConditionOptions | null;
  unassignedTaskCount?: Market["unassignedTaskCount"];
  enableHomeownerNotes?: Market["enableHomeownerNotes"];
  checkoutCustomerConfigId?: Market["checkoutCustomerConfigId"];
  canEditJobLogs?: PotentialOperation2 | PotentialOperation2Options;
  canEditPrice?: PotentialOperation2 | PotentialOperation2Options;
  canHaveBudget?: PotentialOperation2 | PotentialOperation2Options;
  homeownerNotes?: Array<HomeownerNote | HomeownerNoteOptions>;
  enableHomeownerJourneyV2?: Market["enableHomeownerJourneyV2"];
  featureFlags?: Array<FeatureFlag | FeatureFlagOptions>;
  homeownerDeliveryDate?: Market["homeownerDeliveryDate"];
  tasksCompletedThisWeek?: Market["tasksCompletedThisWeek"];
  contacts?: Array<ProjectContact | ProjectContactOptions>;
  warrantyTickets?: Array<WarrantyTicket | WarrantyTicketOptions>;
  shouldAccrueAsComplete?: Market["shouldAccrueAsComplete"];
  directCostMarkupOverrideBasisPoints?: Market["directCostMarkupOverrideBasisPoints"];
  indirectCostMarkupOverrideBasisPoints?: Market["indirectCostMarkupOverrideBasisPoints"];
  customer?: Customer | CustomerOptions | null;
  customerOwnerEntity?: CustomerOwnerEntity | CustomerOwnerEntityOptions | null;
  invoiceSchedule?: InvoiceSchedule | InvoiceScheduleOptions | null;
  allowExcludedCostCodesOnPurchaseOrders?: Market["allowExcludedCostCodesOnPurchaseOrders"];
  enableProductConfigPlan?: Market["enableProductConfigPlan"];
  planSchedule?: PlanSchedule | PlanScheduleOptions | null;
  builder?: Builder | BuilderOptions | null;
  bidOutPercentage?: Market["bidOutPercentage"];
  enableChangeEventSignatures?: Market["enableChangeEventSignatures"];
  enablePocInvoiceSchedule?: Market["enablePocInvoiceSchedule"];
  softCostMarkupInBasisPoints?: Market["softCostMarkupInBasisPoints"];
  indirectHardCostMarkupInBasisPoints?: Market["indirectHardCostMarkupInBasisPoints"];
  directHardCostMarkupInBasisPoints?: Market["directHardCostMarkupInBasisPoints"];
  legalDescription?: Market["legalDescription"];
  salesTaxOverrideInBasisPoints?: Market["salesTaxOverrideInBasisPoints"];
  salesTaxInBasisPoints?: Market["salesTaxInBasisPoints"];
  projectItemAllocations?: Array<ProjectItemAllocation | ProjectItemAllocationOptions>;
  allocationRules?: Array<ProjectAllocationRule | ProjectAllocationRuleOptions>;
  warrantyLengthInDays?: Market["warrantyLengthInDays"];
  warrantyOverrideLengthInDays?: Market["warrantyOverrideLengthInDays"];
  bidPackages?: Array<BidPackage | BidPackageOptions>;
  bidContracts?: Array<BidContract | BidContractOptions>;
  selectionsByLocation?: Array<HomeownerLocationSelection | HomeownerLocationSelectionOptions>;
  hasSelections?: Market["hasSelections"];
  homeownerContracts?: Array<HomeownerContract | HomeownerContractOptions>;
  documents?: Array<Document | DocumentOptions>;
  commitments?: Array<Commitment | CommitmentOptions>;
  directCostInCents?: Market["directCostInCents"];
  directPriceInCents?: Market["directPriceInCents"];
  totalHardCostInCents?: Market["totalHardCostInCents"];
  totalSoftCostInCents?: Market["totalSoftCostInCents"];
  totalCostInCents?: Market["totalCostInCents"];
  totalPriceInCents?: Market["totalPriceInCents"];
  readyToStartDate?: Market["readyToStartDate"];
  committedCostCodesAtStartInBasisPoints?: Market["committedCostCodesAtStartInBasisPoints"];
  directCostAtStartInCents?: Market["directCostAtStartInCents"];
  directCostVarianceInCents?: Market["directCostVarianceInCents"];
  uncommittedCostInCents?: Market["uncommittedCostInCents"];
  snapshots?: Array<ProjectSnapshot | ProjectSnapshotOptions>;
  warrantyEndDate?: Market["warrantyEndDate"];
  companyInfo?: CompanyInfo | CompanyInfoOptions;
  invoicePaymentNetDays?: Market["invoicePaymentNetDays"];
  snapshotAsOf?: ProjectSnapshot | ProjectSnapshotOptions | null;
  purchaseCostInCents?: Market["purchaseCostInCents"];
  grossSalesPriceInCents?: Market["grossSalesPriceInCents"];
  closingCostsForDirectMarginInCents?: Market["closingCostsForDirectMarginInCents"];
  directMarginInBasisPoints?: Market["directMarginInBasisPoints"];
  projectCostCodes?: Array<ProjectCostCode | ProjectCostCodeOptions>;
  parentsRecursive?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  childrenRecursive?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  siblingProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  sellableProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  isSellableProject?: Market["isSellableProject"];
  originalCostInCents?: Market["originalCostInCents"];
  startCostInCents?: Market["startCostInCents"];
  changeEventCostInCents?: Market["changeEventCostInCents"];
  projectedCostInCents?: Market["projectedCostInCents"];
  revisedCostInCents?: Market["revisedCostInCents"];
  committedCostInCents?: Market["committedCostInCents"];
  availableCostInCents?: Market["availableCostInCents"];
  billedCostInCents?: Market["billedCostInCents"];
  unbilledCostInCents?: Market["unbilledCostInCents"];
  cohort?: Cohort | CohortOptions | null;
  constructionConfidenceFactor?: Market["constructionConfidenceFactor"];
  lotRating?: LotRating | LotRatingOptions | null;
  preConBudgetLineItems?: Array<PreConBudgetCostDivisionLineItem | PreConBudgetCostDivisionLineItemOptions>;
  preconContractType?: PreconContractType | PreconContractTypeOptions | null;
  primaryProject?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  quickbooksCustomerId?: Market["quickbooksCustomerId"];
  shadowProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  submarket?: Submarket | SubmarketOptions | null;
  client?: Client | ClientOptions | null;
  url?: Market["url"];
  projectName?: Market["projectName"];
  salesforceId?: Market["salesforceId"];
  activeSalesforceOpportunity?: ProjectSalesforceOpportunity | ProjectSalesforceOpportunityOptions | null;
  dictionary?: ProjectDictionary | ProjectDictionaryOptions;
}

export function newMarket(options: MarketOptions = {}, cache: Record<string, any> = {}): Market {
  const o = (options.__typename ? options : cache["Market"] = {}) as Market;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Market";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("Market");
  o.abbreviation = options.abbreviation ?? "abbreviation";
  o.phone = options.phone ?? null;
  o.salesforceMarketCode = options.salesforceMarketCode ?? null;
  o.submarkets = (options.submarkets ?? []).map((i) =>
    maybeNew("Submarket", i, cache, options.hasOwnProperty("submarkets"))
  );
  o.timeZone = options.timeZone ?? "timeZone";
  o.msaName = options.msaName ?? null;
  o.developments = (options.developments ?? []).map((i) =>
    maybeNew("Development", i, cache, options.hasOwnProperty("developments"))
  );
  o.bidItemEstimates = (options.bidItemEstimates ?? []).map((i) =>
    maybeNew("BidItemEstimate", i, cache, options.hasOwnProperty("bidItemEstimates"))
  );
  o.readyPlans = (options.readyPlans ?? []).map((i) =>
    maybeNew("ReadyPlan", i, cache, options.hasOwnProperty("readyPlans"))
  );
  o.optionPricingConfigVariants = (options.optionPricingConfigVariants ?? []).map((i) =>
    maybeNew("OptionPricingConfigVariant", i, cache, options.hasOwnProperty("optionPricingConfigVariants"))
  );
  o.state = options.state ?? "state";
  o.materialLeadTimeConfigVariants = (options.materialLeadTimeConfigVariants ?? []).map((i) =>
    maybeNew("MaterialLeadTimeConfigVariant", i, cache, options.hasOwnProperty("materialLeadTimeConfigVariants"))
  );
  o.standaloneProjects = (options.standaloneProjects ?? []).map((i) =>
    maybeNew("StandaloneProject", i, cache, options.hasOwnProperty("standaloneProjects"))
  );
  o.marketDevelopmentContracts = (options.marketDevelopmentContracts ?? []).map((i) =>
    maybeNew("DevelopmentCommitment", i, cache, options.hasOwnProperty("marketDevelopmentContracts"))
  );
  o.drops = (options.drops ?? []).map((i) => maybeNew("Drop", i, cache, options.hasOwnProperty("drops")));
  o.market = maybeNew("Market", options.market, cache, options.hasOwnProperty("market"));
  o.parent = maybeNew("Region", options.parent, cache, options.hasOwnProperty("parent"));
  o.children = (options.children ?? []).map((i) => maybeNew("Community", i, cache, options.hasOwnProperty("children")));
  o.collaborators = (options.collaborators ?? []).map((i) =>
    maybeNew("ProjectCollaborator", i, cache, options.hasOwnProperty("collaborators"))
  );
  o.coverImage = maybeNewOrNull("Asset", options.coverImage, cache);
  o.buildAddress = maybeNewOrNull("Address", options.buildAddress, cache);
  o.teamMembers = (options.teamMembers ?? []).map((i) =>
    maybeNew("ProjectTeamMember", i, cache, options.hasOwnProperty("teamMembers"))
  );
  o.projectLead = maybeNewOrNull("ProjectTeamMember", options.projectLead, cache);
  o.activeStage = enumOrDetailOfStage(options.activeStage);
  o.activeProjectStage = maybeNewOrNull("ProjectStage", options.activeProjectStage, cache);
  o.stages = (options.stages ?? []).map((i) => maybeNew("ProjectStage", i, cache, options.hasOwnProperty("stages")));
  o.stage = maybeNew("ProjectStage", options.stage, cache, options.hasOwnProperty("stage"));
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.hopUrl = options.hopUrl ?? "hopUrl";
  o.name = options.name ?? "name";
  o.availableAssignees = (options.availableAssignees ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableAssignees"))
  );
  o.startDate = options.startDate ?? newDate();
  o.features = options.features ?? [];
  o.isTest = options.isTest ?? false;
  o.status = enumOrDetailOfProjectStatus(options.status);
  o.latitude = options.latitude ?? null;
  o.longitude = options.longitude ?? null;
  o.project = maybeNewOrNull("Project", options.project, cache);
  o.googleDriveFolderId = options.googleDriveFolderId ?? null;
  o.salesforceAccountId = options.salesforceAccountId ?? null;
  o.salesforceOpportunities = (options.salesforceOpportunities ?? []).map((i) =>
    maybeNew("ProjectSalesforceOpportunity", i, cache, options.hasOwnProperty("salesforceOpportunities"))
  );
  o.projectStatusChange = maybeNewOrNull("ProjectStatusChange", options.projectStatusChange, cache);
  o.planRoomLink = options.planRoomLink ?? null;
  o.isDisaster = options.isDisaster ?? null;
  o.intakeStyleNotes = options.intakeStyleNotes ?? null;
  o.lotType = enumOrDetailOfLotType(options.lotType);
  o.communityType = enumOrDetailOrNullOfCommunityType(options.communityType);
  o.productType = maybeNewOrNull("ProductType", options.productType, cache);
  o.enableSchedulesV2 = options.enableSchedulesV2 ?? false;
  o.tradePartners = (options.tradePartners ?? []).map((i) =>
    maybeNew("TradePartner", i, cache, options.hasOwnProperty("tradePartners"))
  );
  o.cutoffs = (options.cutoffs ?? []).map((i) =>
    maybeNew("ProjectCutoff", i, cache, options.hasOwnProperty("cutoffs"))
  );
  o.jobLogs = (options.jobLogs ?? []).map((i) => maybeNew("JobLog", i, cache, options.hasOwnProperty("jobLogs")));
  o.salesforcePropertyId = options.salesforcePropertyId ?? null;
  o.schedules = (options.schedules ?? []).map((i) =>
    maybeNew("Schedule", i, cache, options.hasOwnProperty("schedules"))
  );
  o.expenses = (options.expenses ?? []).map((i) => maybeNew("Expense", i, cache, options.hasOwnProperty("expenses")));
  o.unallocatedExpenses = (options.unallocatedExpenses ?? []).map((i) =>
    maybeNew("Expense", i, cache, options.hasOwnProperty("unallocatedExpenses"))
  );
  o.unallocatedAmountInCents = options.unallocatedAmountInCents ?? 0;
  o.enableSchedulesV2Gantt = options.enableSchedulesV2Gantt ?? false;
  o.enableSchedulesCalendar = options.enableSchedulesCalendar ?? false;
  o.readyPlanConfig = maybeNewOrNull("ProjectReadyPlanConfig", options.readyPlanConfig, cache);
  o.earnedValueCurves = (options.earnedValueCurves ?? []).map((i) =>
    maybeNew("EarnedValueCurve", i, cache, options.hasOwnProperty("earnedValueCurves"))
  );
  o.enableInvoiceV2 = options.enableInvoiceV2 ?? false;
  o.invoiceSettings = maybeNewOrNull("ProjectInvoiceSetting", options.invoiceSettings, cache);
  o.scopeMode = enumOrDetailOfScopeMode(options.scopeMode);
  o.lotPartitionId = options.lotPartitionId ?? null;
  o.budgetFinancials = maybeNew(
    "ProjectBudgetFinancials",
    options.budgetFinancials,
    cache,
    options.hasOwnProperty("budgetFinancials"),
  );
  o.enableDelayFlags = options.enableDelayFlags ?? false;
  o.warrantyStartDate = options.warrantyStartDate ?? null;
  o.verticalCompleteDate = options.verticalCompleteDate ?? null;
  o.jobLogInsights = maybeNew(
    "ProjectJobLogInsights",
    options.jobLogInsights,
    cache,
    options.hasOwnProperty("jobLogInsights"),
  );
  o.targetEndDate = options.targetEndDate ?? null;
  o.latestActiveStage = maybeNewOrNull("ProjectStage", options.latestActiveStage, cache);
  o.primaryHomeowner = maybeNewOrNull("Client", options.primaryHomeowner, cache);
  o.toDos = (options.toDos ?? []).map((i) => maybeNew("ToDo", i, cache, options.hasOwnProperty("toDos")));
  o.lotDetail = maybeNew("ProjectLotDetail", options.lotDetail, cache, options.hasOwnProperty("lotDetail"));
  o.siteSpecificInfos = (options.siteSpecificInfos ?? []).map((i) =>
    maybeNew("ProjectSiteSpecificInfo", i, cache, options.hasOwnProperty("siteSpecificInfos"))
  );
  o.projectSiteCondition = maybeNewOrNull("ProjectSiteCondition", options.projectSiteCondition, cache);
  o.unassignedTaskCount = options.unassignedTaskCount ?? 0;
  o.enableHomeownerNotes = options.enableHomeownerNotes ?? false;
  o.checkoutCustomerConfigId = options.checkoutCustomerConfigId ?? null;
  o.canEditJobLogs = maybeNew(
    "PotentialOperation2",
    options.canEditJobLogs,
    cache,
    options.hasOwnProperty("canEditJobLogs"),
  );
  o.canEditPrice = maybeNew("PotentialOperation2", options.canEditPrice, cache, options.hasOwnProperty("canEditPrice"));
  o.canHaveBudget = maybeNew(
    "PotentialOperation2",
    options.canHaveBudget,
    cache,
    options.hasOwnProperty("canHaveBudget"),
  );
  o.homeownerNotes = (options.homeownerNotes ?? []).map((i) =>
    maybeNew("HomeownerNote", i, cache, options.hasOwnProperty("homeownerNotes"))
  );
  o.enableHomeownerJourneyV2 = options.enableHomeownerJourneyV2 ?? false;
  o.featureFlags = (options.featureFlags ?? []).map((i) =>
    maybeNew("FeatureFlag", i, cache, options.hasOwnProperty("featureFlags"))
  );
  o.homeownerDeliveryDate = options.homeownerDeliveryDate ?? null;
  o.tasksCompletedThisWeek = options.tasksCompletedThisWeek ?? 0;
  o.contacts = (options.contacts ?? []).map((i) =>
    maybeNew("ProjectContact", i, cache, options.hasOwnProperty("contacts"))
  );
  o.warrantyTickets = (options.warrantyTickets ?? []).map((i) =>
    maybeNew("WarrantyTicket", i, cache, options.hasOwnProperty("warrantyTickets"))
  );
  o.shouldAccrueAsComplete = options.shouldAccrueAsComplete ?? false;
  o.directCostMarkupOverrideBasisPoints = options.directCostMarkupOverrideBasisPoints ?? null;
  o.indirectCostMarkupOverrideBasisPoints = options.indirectCostMarkupOverrideBasisPoints ?? null;
  o.customer = maybeNewOrNull("Customer", options.customer, cache);
  o.customerOwnerEntity = maybeNewOrNull("CustomerOwnerEntity", options.customerOwnerEntity, cache);
  o.invoiceSchedule = maybeNewOrNull("InvoiceSchedule", options.invoiceSchedule, cache);
  o.allowExcludedCostCodesOnPurchaseOrders = options.allowExcludedCostCodesOnPurchaseOrders ?? false;
  o.enableProductConfigPlan = options.enableProductConfigPlan ?? false;
  o.planSchedule = maybeNewOrNull("PlanSchedule", options.planSchedule, cache);
  o.builder = maybeNewOrNull("Builder", options.builder, cache);
  o.bidOutPercentage = options.bidOutPercentage ?? 0;
  o.enableChangeEventSignatures = options.enableChangeEventSignatures ?? false;
  o.enablePocInvoiceSchedule = options.enablePocInvoiceSchedule ?? false;
  o.softCostMarkupInBasisPoints = options.softCostMarkupInBasisPoints ?? null;
  o.indirectHardCostMarkupInBasisPoints = options.indirectHardCostMarkupInBasisPoints ?? null;
  o.directHardCostMarkupInBasisPoints = options.directHardCostMarkupInBasisPoints ?? null;
  o.legalDescription = options.legalDescription ?? null;
  o.salesTaxOverrideInBasisPoints = options.salesTaxOverrideInBasisPoints ?? null;
  o.salesTaxInBasisPoints = options.salesTaxInBasisPoints ?? 0;
  o.projectItemAllocations = (options.projectItemAllocations ?? []).map((i) =>
    maybeNew("ProjectItemAllocation", i, cache, options.hasOwnProperty("projectItemAllocations"))
  );
  o.allocationRules = (options.allocationRules ?? []).map((i) =>
    maybeNew("ProjectAllocationRule", i, cache, options.hasOwnProperty("allocationRules"))
  );
  o.warrantyLengthInDays = options.warrantyLengthInDays ?? 0;
  o.warrantyOverrideLengthInDays = options.warrantyOverrideLengthInDays ?? null;
  o.bidPackages = (options.bidPackages ?? []).map((i) =>
    maybeNew("BidPackage", i, cache, options.hasOwnProperty("bidPackages"))
  );
  o.bidContracts = (options.bidContracts ?? []).map((i) =>
    maybeNew("BidContract", i, cache, options.hasOwnProperty("bidContracts"))
  );
  o.selectionsByLocation = (options.selectionsByLocation ?? []).map((i) =>
    maybeNew("HomeownerLocationSelection", i, cache, options.hasOwnProperty("selectionsByLocation"))
  );
  o.hasSelections = options.hasSelections ?? false;
  o.homeownerContracts = (options.homeownerContracts ?? []).map((i) =>
    maybeNew("HomeownerContract", i, cache, options.hasOwnProperty("homeownerContracts"))
  );
  o.documents = (options.documents ?? []).map((i) =>
    maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
  );
  o.commitments = (options.commitments ?? []).map((i) =>
    maybeNew("Commitment", i, cache, options.hasOwnProperty("commitments"))
  );
  o.directCostInCents = options.directCostInCents ?? 0;
  o.directPriceInCents = options.directPriceInCents ?? 0;
  o.totalHardCostInCents = options.totalHardCostInCents ?? 0;
  o.totalSoftCostInCents = options.totalSoftCostInCents ?? 0;
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.totalPriceInCents = options.totalPriceInCents ?? 0;
  o.readyToStartDate = options.readyToStartDate ?? null;
  o.committedCostCodesAtStartInBasisPoints = options.committedCostCodesAtStartInBasisPoints ?? null;
  o.directCostAtStartInCents = options.directCostAtStartInCents ?? null;
  o.directCostVarianceInCents = options.directCostVarianceInCents ?? null;
  o.uncommittedCostInCents = options.uncommittedCostInCents ?? 0;
  o.snapshots = (options.snapshots ?? []).map((i) =>
    maybeNew("ProjectSnapshot", i, cache, options.hasOwnProperty("snapshots"))
  );
  o.warrantyEndDate = options.warrantyEndDate ?? null;
  o.companyInfo = maybeNew("CompanyInfo", options.companyInfo, cache, options.hasOwnProperty("companyInfo"));
  o.invoicePaymentNetDays = options.invoicePaymentNetDays ?? 0;
  o.snapshotAsOf = maybeNewOrNull("ProjectSnapshot", options.snapshotAsOf, cache);
  o.purchaseCostInCents = options.purchaseCostInCents ?? null;
  o.grossSalesPriceInCents = options.grossSalesPriceInCents ?? null;
  o.closingCostsForDirectMarginInCents = options.closingCostsForDirectMarginInCents ?? null;
  o.directMarginInBasisPoints = options.directMarginInBasisPoints ?? null;
  o.projectCostCodes = (options.projectCostCodes ?? []).map((i) =>
    maybeNew("ProjectCostCode", i, cache, options.hasOwnProperty("projectCostCodes"))
  );
  o.parentsRecursive = (options.parentsRecursive ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("parentsRecursive"))
  );
  o.childrenRecursive = (options.childrenRecursive ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("childrenRecursive"))
  );
  o.siblingProjects = (options.siblingProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("siblingProjects"))
  );
  o.sellableProjects = (options.sellableProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("sellableProjects"))
  );
  o.isSellableProject = options.isSellableProject ?? false;
  o.originalCostInCents = options.originalCostInCents ?? 0;
  o.startCostInCents = options.startCostInCents ?? 0;
  o.changeEventCostInCents = options.changeEventCostInCents ?? 0;
  o.projectedCostInCents = options.projectedCostInCents ?? 0;
  o.revisedCostInCents = options.revisedCostInCents ?? 0;
  o.committedCostInCents = options.committedCostInCents ?? 0;
  o.availableCostInCents = options.availableCostInCents ?? 0;
  o.billedCostInCents = options.billedCostInCents ?? 0;
  o.unbilledCostInCents = options.unbilledCostInCents ?? 0;
  o.cohort = maybeNewOrNull("Cohort", options.cohort, cache);
  o.constructionConfidenceFactor = options.constructionConfidenceFactor ?? null;
  o.lotRating = maybeNewOrNull("LotRating", options.lotRating, cache);
  o.preConBudgetLineItems = (options.preConBudgetLineItems ?? []).map((i) =>
    maybeNew("PreConBudgetCostDivisionLineItem", i, cache, options.hasOwnProperty("preConBudgetLineItems"))
  );
  o.preconContractType = maybeNewOrNull("PreconContractType", options.preconContractType, cache);
  o.primaryProject = maybeNewOrNull("Project", options.primaryProject, cache);
  o.quickbooksCustomerId = options.quickbooksCustomerId ?? null;
  o.shadowProjects = (options.shadowProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("shadowProjects"))
  );
  o.submarket = maybeNewOrNull("Submarket", options.submarket, cache);
  o.client = maybeNewOrNull("Client", options.client, cache);
  o.url = options.url ?? "url";
  o.projectName = options.projectName ?? "projectName";
  o.salesforceId = options.salesforceId ?? null;
  o.activeSalesforceOpportunity = maybeNewOrNull(
    "ProjectSalesforceOpportunity",
    options.activeSalesforceOpportunity,
    cache,
  );
  o.dictionary = maybeNew("ProjectDictionary", options.dictionary, cache, options.hasOwnProperty("dictionary"));
  return o;
}

factories["Market"] = newMarket;

export interface CommunityOptions {
  __typename?: "Community";
  references?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: Community["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: Community["isFollowed"];
  id?: Community["id"];
  productOfferings?: Array<ProductOffering | ProductOfferingOptions>;
  drops?: Array<Drop | DropOptions>;
  costCodesWithDraws?: Array<CostCode | CostCodeOptions>;
  salesforceNeighborhoodId?: Community["salesforceNeighborhoodId"];
  pricingTeaser?: Community["pricingTeaser"];
  market?: Market | MarketOptions;
  parent?: Market | MarketOptions;
  children?: Array<Subdivision | SubdivisionOptions>;
  collaborators?: Array<ProjectCollaborator | ProjectCollaboratorOptions>;
  coverImage?: Asset | AssetOptions | null;
  buildAddress?: Address | AddressOptions | null;
  teamMembers?: Array<ProjectTeamMember | ProjectTeamMemberOptions>;
  projectLead?: ProjectTeamMember | ProjectTeamMemberOptions | null;
  activeStage?: StageDetailOptions | Stage;
  activeProjectStage?: ProjectStage | ProjectStageOptions | null;
  stages?: Array<ProjectStage | ProjectStageOptions>;
  stage?: ProjectStage | ProjectStageOptions;
  blueprintUrl?: Url | UrlOptions;
  hopUrl?: Community["hopUrl"];
  name?: Community["name"];
  availableAssignees?: Array<InternalUser | InternalUserOptions>;
  startDate?: Community["startDate"];
  features?: Community["features"];
  isTest?: Community["isTest"];
  status?: ProjectStatusDetailOptions | ProjectStatus;
  latitude?: Community["latitude"];
  longitude?: Community["longitude"];
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  googleDriveFolderId?: Community["googleDriveFolderId"];
  salesforceAccountId?: Community["salesforceAccountId"];
  salesforceOpportunities?: Array<ProjectSalesforceOpportunity | ProjectSalesforceOpportunityOptions>;
  projectStatusChange?: ProjectStatusChange | ProjectStatusChangeOptions | null;
  planRoomLink?: Community["planRoomLink"];
  isDisaster?: Community["isDisaster"];
  intakeStyleNotes?: Community["intakeStyleNotes"];
  lotType?: LotTypeDetailOptions | LotType;
  communityType?: CommunityTypeDetailOptions | CommunityType | null;
  productType?: ProductType | ProductTypeOptions | null;
  enableSchedulesV2?: Community["enableSchedulesV2"];
  tradePartners?: Array<TradePartner | TradePartnerOptions>;
  cutoffs?: Array<ProjectCutoff | ProjectCutoffOptions>;
  jobLogs?: Array<JobLog | JobLogOptions>;
  salesforcePropertyId?: Community["salesforcePropertyId"];
  schedules?: Array<Schedule | ScheduleOptions>;
  expenses?: Array<Expense | ExpenseOptions>;
  unallocatedExpenses?: Array<Expense | ExpenseOptions>;
  unallocatedAmountInCents?: Community["unallocatedAmountInCents"];
  enableSchedulesV2Gantt?: Community["enableSchedulesV2Gantt"];
  enableSchedulesCalendar?: Community["enableSchedulesCalendar"];
  readyPlanConfig?: ProjectReadyPlanConfig | ProjectReadyPlanConfigOptions | null;
  earnedValueCurves?: Array<EarnedValueCurve | EarnedValueCurveOptions>;
  enableInvoiceV2?: Community["enableInvoiceV2"];
  invoiceSettings?: ProjectInvoiceSetting | ProjectInvoiceSettingOptions | null;
  scopeMode?: ScopeModeDetailOptions | ScopeMode;
  lotPartitionId?: Community["lotPartitionId"];
  budgetFinancials?: ProjectBudgetFinancials | ProjectBudgetFinancialsOptions;
  enableDelayFlags?: Community["enableDelayFlags"];
  warrantyStartDate?: Community["warrantyStartDate"];
  verticalCompleteDate?: Community["verticalCompleteDate"];
  jobLogInsights?: ProjectJobLogInsights | ProjectJobLogInsightsOptions;
  targetEndDate?: Community["targetEndDate"];
  latestActiveStage?: ProjectStage | ProjectStageOptions | null;
  primaryHomeowner?: Client | ClientOptions | null;
  toDos?: Array<ToDo | ToDoOptions> | null;
  lotDetail?: ProjectLotDetail | ProjectLotDetailOptions;
  siteSpecificInfos?: Array<ProjectSiteSpecificInfo | ProjectSiteSpecificInfoOptions>;
  projectSiteCondition?: ProjectSiteCondition | ProjectSiteConditionOptions | null;
  unassignedTaskCount?: Community["unassignedTaskCount"];
  enableHomeownerNotes?: Community["enableHomeownerNotes"];
  checkoutCustomerConfigId?: Community["checkoutCustomerConfigId"];
  canEditJobLogs?: PotentialOperation2 | PotentialOperation2Options;
  canEditPrice?: PotentialOperation2 | PotentialOperation2Options;
  canHaveBudget?: PotentialOperation2 | PotentialOperation2Options;
  homeownerNotes?: Array<HomeownerNote | HomeownerNoteOptions>;
  enableHomeownerJourneyV2?: Community["enableHomeownerJourneyV2"];
  featureFlags?: Array<FeatureFlag | FeatureFlagOptions>;
  homeownerDeliveryDate?: Community["homeownerDeliveryDate"];
  tasksCompletedThisWeek?: Community["tasksCompletedThisWeek"];
  contacts?: Array<ProjectContact | ProjectContactOptions>;
  warrantyTickets?: Array<WarrantyTicket | WarrantyTicketOptions>;
  shouldAccrueAsComplete?: Community["shouldAccrueAsComplete"];
  directCostMarkupOverrideBasisPoints?: Community["directCostMarkupOverrideBasisPoints"];
  indirectCostMarkupOverrideBasisPoints?: Community["indirectCostMarkupOverrideBasisPoints"];
  customer?: Customer | CustomerOptions | null;
  customerOwnerEntity?: CustomerOwnerEntity | CustomerOwnerEntityOptions | null;
  invoiceSchedule?: InvoiceSchedule | InvoiceScheduleOptions | null;
  allowExcludedCostCodesOnPurchaseOrders?: Community["allowExcludedCostCodesOnPurchaseOrders"];
  enableProductConfigPlan?: Community["enableProductConfigPlan"];
  planSchedule?: PlanSchedule | PlanScheduleOptions | null;
  builder?: Builder | BuilderOptions | null;
  bidOutPercentage?: Community["bidOutPercentage"];
  enableChangeEventSignatures?: Community["enableChangeEventSignatures"];
  enablePocInvoiceSchedule?: Community["enablePocInvoiceSchedule"];
  softCostMarkupInBasisPoints?: Community["softCostMarkupInBasisPoints"];
  indirectHardCostMarkupInBasisPoints?: Community["indirectHardCostMarkupInBasisPoints"];
  directHardCostMarkupInBasisPoints?: Community["directHardCostMarkupInBasisPoints"];
  legalDescription?: Community["legalDescription"];
  salesTaxOverrideInBasisPoints?: Community["salesTaxOverrideInBasisPoints"];
  salesTaxInBasisPoints?: Community["salesTaxInBasisPoints"];
  projectItemAllocations?: Array<ProjectItemAllocation | ProjectItemAllocationOptions>;
  allocationRules?: Array<ProjectAllocationRule | ProjectAllocationRuleOptions>;
  warrantyLengthInDays?: Community["warrantyLengthInDays"];
  warrantyOverrideLengthInDays?: Community["warrantyOverrideLengthInDays"];
  bidPackages?: Array<BidPackage | BidPackageOptions>;
  bidContracts?: Array<BidContract | BidContractOptions>;
  selectionsByLocation?: Array<HomeownerLocationSelection | HomeownerLocationSelectionOptions>;
  hasSelections?: Community["hasSelections"];
  homeownerContracts?: Array<HomeownerContract | HomeownerContractOptions>;
  documents?: Array<Document | DocumentOptions>;
  commitments?: Array<Commitment | CommitmentOptions>;
  directCostInCents?: Community["directCostInCents"];
  directPriceInCents?: Community["directPriceInCents"];
  totalHardCostInCents?: Community["totalHardCostInCents"];
  totalSoftCostInCents?: Community["totalSoftCostInCents"];
  totalCostInCents?: Community["totalCostInCents"];
  totalPriceInCents?: Community["totalPriceInCents"];
  readyToStartDate?: Community["readyToStartDate"];
  committedCostCodesAtStartInBasisPoints?: Community["committedCostCodesAtStartInBasisPoints"];
  directCostAtStartInCents?: Community["directCostAtStartInCents"];
  directCostVarianceInCents?: Community["directCostVarianceInCents"];
  uncommittedCostInCents?: Community["uncommittedCostInCents"];
  snapshots?: Array<ProjectSnapshot | ProjectSnapshotOptions>;
  warrantyEndDate?: Community["warrantyEndDate"];
  companyInfo?: CompanyInfo | CompanyInfoOptions;
  invoicePaymentNetDays?: Community["invoicePaymentNetDays"];
  snapshotAsOf?: ProjectSnapshot | ProjectSnapshotOptions | null;
  purchaseCostInCents?: Community["purchaseCostInCents"];
  grossSalesPriceInCents?: Community["grossSalesPriceInCents"];
  closingCostsForDirectMarginInCents?: Community["closingCostsForDirectMarginInCents"];
  directMarginInBasisPoints?: Community["directMarginInBasisPoints"];
  projectCostCodes?: Array<ProjectCostCode | ProjectCostCodeOptions>;
  showInCheckout?: Community["showInCheckout"];
  parentsRecursive?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  childrenRecursive?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  siblingProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  sellableProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  isSellableProject?: Community["isSellableProject"];
  originalCostInCents?: Community["originalCostInCents"];
  startCostInCents?: Community["startCostInCents"];
  changeEventCostInCents?: Community["changeEventCostInCents"];
  projectedCostInCents?: Community["projectedCostInCents"];
  revisedCostInCents?: Community["revisedCostInCents"];
  committedCostInCents?: Community["committedCostInCents"];
  availableCostInCents?: Community["availableCostInCents"];
  billedCostInCents?: Community["billedCostInCents"];
  unbilledCostInCents?: Community["unbilledCostInCents"];
  cohort?: Cohort | CohortOptions | null;
  constructionConfidenceFactor?: Community["constructionConfidenceFactor"];
  lotRating?: LotRating | LotRatingOptions | null;
  preConBudgetLineItems?: Array<PreConBudgetCostDivisionLineItem | PreConBudgetCostDivisionLineItemOptions>;
  preconContractType?: PreconContractType | PreconContractTypeOptions | null;
  primaryProject?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  quickbooksCustomerId?: Community["quickbooksCustomerId"];
  shadowProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  submarket?: Submarket | SubmarketOptions | null;
  client?: Client | ClientOptions | null;
  url?: Community["url"];
  projectName?: Community["projectName"];
  salesforceId?: Community["salesforceId"];
  activeSalesforceOpportunity?: ProjectSalesforceOpportunity | ProjectSalesforceOpportunityOptions | null;
  dictionary?: ProjectDictionary | ProjectDictionaryOptions;
  packageComparison?: Asset | AssetOptions | null;
  globalPlanStageVariants?: Array<GlobalPlanStageVariant | GlobalPlanStageVariantOptions>;
}

export function newCommunity(options: CommunityOptions = {}, cache: Record<string, any> = {}): Community {
  const o = (options.__typename ? options : cache["Community"] = {}) as Community;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Community";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("Community");
  o.productOfferings = (options.productOfferings ?? []).map((i) =>
    maybeNew("ProductOffering", i, cache, options.hasOwnProperty("productOfferings"))
  );
  o.drops = (options.drops ?? []).map((i) => maybeNew("Drop", i, cache, options.hasOwnProperty("drops")));
  o.costCodesWithDraws = (options.costCodesWithDraws ?? []).map((i) =>
    maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodesWithDraws"))
  );
  o.salesforceNeighborhoodId = options.salesforceNeighborhoodId ?? null;
  o.pricingTeaser = options.pricingTeaser ?? null;
  o.market = maybeNew("Market", options.market, cache, options.hasOwnProperty("market"));
  o.parent = maybeNew("Market", options.parent, cache, options.hasOwnProperty("parent"));
  o.children = (options.children ?? []).map((i) =>
    maybeNew("Subdivision", i, cache, options.hasOwnProperty("children"))
  );
  o.collaborators = (options.collaborators ?? []).map((i) =>
    maybeNew("ProjectCollaborator", i, cache, options.hasOwnProperty("collaborators"))
  );
  o.coverImage = maybeNewOrNull("Asset", options.coverImage, cache);
  o.buildAddress = maybeNewOrNull("Address", options.buildAddress, cache);
  o.teamMembers = (options.teamMembers ?? []).map((i) =>
    maybeNew("ProjectTeamMember", i, cache, options.hasOwnProperty("teamMembers"))
  );
  o.projectLead = maybeNewOrNull("ProjectTeamMember", options.projectLead, cache);
  o.activeStage = enumOrDetailOfStage(options.activeStage);
  o.activeProjectStage = maybeNewOrNull("ProjectStage", options.activeProjectStage, cache);
  o.stages = (options.stages ?? []).map((i) => maybeNew("ProjectStage", i, cache, options.hasOwnProperty("stages")));
  o.stage = maybeNew("ProjectStage", options.stage, cache, options.hasOwnProperty("stage"));
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.hopUrl = options.hopUrl ?? "hopUrl";
  o.name = options.name ?? "name";
  o.availableAssignees = (options.availableAssignees ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableAssignees"))
  );
  o.startDate = options.startDate ?? newDate();
  o.features = options.features ?? [];
  o.isTest = options.isTest ?? false;
  o.status = enumOrDetailOfProjectStatus(options.status);
  o.latitude = options.latitude ?? null;
  o.longitude = options.longitude ?? null;
  o.project = maybeNewOrNull("Project", options.project, cache);
  o.googleDriveFolderId = options.googleDriveFolderId ?? null;
  o.salesforceAccountId = options.salesforceAccountId ?? null;
  o.salesforceOpportunities = (options.salesforceOpportunities ?? []).map((i) =>
    maybeNew("ProjectSalesforceOpportunity", i, cache, options.hasOwnProperty("salesforceOpportunities"))
  );
  o.projectStatusChange = maybeNewOrNull("ProjectStatusChange", options.projectStatusChange, cache);
  o.planRoomLink = options.planRoomLink ?? null;
  o.isDisaster = options.isDisaster ?? null;
  o.intakeStyleNotes = options.intakeStyleNotes ?? null;
  o.lotType = enumOrDetailOfLotType(options.lotType);
  o.communityType = enumOrDetailOrNullOfCommunityType(options.communityType);
  o.productType = maybeNewOrNull("ProductType", options.productType, cache);
  o.enableSchedulesV2 = options.enableSchedulesV2 ?? false;
  o.tradePartners = (options.tradePartners ?? []).map((i) =>
    maybeNew("TradePartner", i, cache, options.hasOwnProperty("tradePartners"))
  );
  o.cutoffs = (options.cutoffs ?? []).map((i) =>
    maybeNew("ProjectCutoff", i, cache, options.hasOwnProperty("cutoffs"))
  );
  o.jobLogs = (options.jobLogs ?? []).map((i) => maybeNew("JobLog", i, cache, options.hasOwnProperty("jobLogs")));
  o.salesforcePropertyId = options.salesforcePropertyId ?? null;
  o.schedules = (options.schedules ?? []).map((i) =>
    maybeNew("Schedule", i, cache, options.hasOwnProperty("schedules"))
  );
  o.expenses = (options.expenses ?? []).map((i) => maybeNew("Expense", i, cache, options.hasOwnProperty("expenses")));
  o.unallocatedExpenses = (options.unallocatedExpenses ?? []).map((i) =>
    maybeNew("Expense", i, cache, options.hasOwnProperty("unallocatedExpenses"))
  );
  o.unallocatedAmountInCents = options.unallocatedAmountInCents ?? 0;
  o.enableSchedulesV2Gantt = options.enableSchedulesV2Gantt ?? false;
  o.enableSchedulesCalendar = options.enableSchedulesCalendar ?? false;
  o.readyPlanConfig = maybeNewOrNull("ProjectReadyPlanConfig", options.readyPlanConfig, cache);
  o.earnedValueCurves = (options.earnedValueCurves ?? []).map((i) =>
    maybeNew("EarnedValueCurve", i, cache, options.hasOwnProperty("earnedValueCurves"))
  );
  o.enableInvoiceV2 = options.enableInvoiceV2 ?? false;
  o.invoiceSettings = maybeNewOrNull("ProjectInvoiceSetting", options.invoiceSettings, cache);
  o.scopeMode = enumOrDetailOfScopeMode(options.scopeMode);
  o.lotPartitionId = options.lotPartitionId ?? null;
  o.budgetFinancials = maybeNew(
    "ProjectBudgetFinancials",
    options.budgetFinancials,
    cache,
    options.hasOwnProperty("budgetFinancials"),
  );
  o.enableDelayFlags = options.enableDelayFlags ?? false;
  o.warrantyStartDate = options.warrantyStartDate ?? null;
  o.verticalCompleteDate = options.verticalCompleteDate ?? null;
  o.jobLogInsights = maybeNew(
    "ProjectJobLogInsights",
    options.jobLogInsights,
    cache,
    options.hasOwnProperty("jobLogInsights"),
  );
  o.targetEndDate = options.targetEndDate ?? null;
  o.latestActiveStage = maybeNewOrNull("ProjectStage", options.latestActiveStage, cache);
  o.primaryHomeowner = maybeNewOrNull("Client", options.primaryHomeowner, cache);
  o.toDos = (options.toDos ?? []).map((i) => maybeNew("ToDo", i, cache, options.hasOwnProperty("toDos")));
  o.lotDetail = maybeNew("ProjectLotDetail", options.lotDetail, cache, options.hasOwnProperty("lotDetail"));
  o.siteSpecificInfos = (options.siteSpecificInfos ?? []).map((i) =>
    maybeNew("ProjectSiteSpecificInfo", i, cache, options.hasOwnProperty("siteSpecificInfos"))
  );
  o.projectSiteCondition = maybeNewOrNull("ProjectSiteCondition", options.projectSiteCondition, cache);
  o.unassignedTaskCount = options.unassignedTaskCount ?? 0;
  o.enableHomeownerNotes = options.enableHomeownerNotes ?? false;
  o.checkoutCustomerConfigId = options.checkoutCustomerConfigId ?? null;
  o.canEditJobLogs = maybeNew(
    "PotentialOperation2",
    options.canEditJobLogs,
    cache,
    options.hasOwnProperty("canEditJobLogs"),
  );
  o.canEditPrice = maybeNew("PotentialOperation2", options.canEditPrice, cache, options.hasOwnProperty("canEditPrice"));
  o.canHaveBudget = maybeNew(
    "PotentialOperation2",
    options.canHaveBudget,
    cache,
    options.hasOwnProperty("canHaveBudget"),
  );
  o.homeownerNotes = (options.homeownerNotes ?? []).map((i) =>
    maybeNew("HomeownerNote", i, cache, options.hasOwnProperty("homeownerNotes"))
  );
  o.enableHomeownerJourneyV2 = options.enableHomeownerJourneyV2 ?? false;
  o.featureFlags = (options.featureFlags ?? []).map((i) =>
    maybeNew("FeatureFlag", i, cache, options.hasOwnProperty("featureFlags"))
  );
  o.homeownerDeliveryDate = options.homeownerDeliveryDate ?? null;
  o.tasksCompletedThisWeek = options.tasksCompletedThisWeek ?? 0;
  o.contacts = (options.contacts ?? []).map((i) =>
    maybeNew("ProjectContact", i, cache, options.hasOwnProperty("contacts"))
  );
  o.warrantyTickets = (options.warrantyTickets ?? []).map((i) =>
    maybeNew("WarrantyTicket", i, cache, options.hasOwnProperty("warrantyTickets"))
  );
  o.shouldAccrueAsComplete = options.shouldAccrueAsComplete ?? false;
  o.directCostMarkupOverrideBasisPoints = options.directCostMarkupOverrideBasisPoints ?? null;
  o.indirectCostMarkupOverrideBasisPoints = options.indirectCostMarkupOverrideBasisPoints ?? null;
  o.customer = maybeNewOrNull("Customer", options.customer, cache);
  o.customerOwnerEntity = maybeNewOrNull("CustomerOwnerEntity", options.customerOwnerEntity, cache);
  o.invoiceSchedule = maybeNewOrNull("InvoiceSchedule", options.invoiceSchedule, cache);
  o.allowExcludedCostCodesOnPurchaseOrders = options.allowExcludedCostCodesOnPurchaseOrders ?? false;
  o.enableProductConfigPlan = options.enableProductConfigPlan ?? false;
  o.planSchedule = maybeNewOrNull("PlanSchedule", options.planSchedule, cache);
  o.builder = maybeNewOrNull("Builder", options.builder, cache);
  o.bidOutPercentage = options.bidOutPercentage ?? 0;
  o.enableChangeEventSignatures = options.enableChangeEventSignatures ?? false;
  o.enablePocInvoiceSchedule = options.enablePocInvoiceSchedule ?? false;
  o.softCostMarkupInBasisPoints = options.softCostMarkupInBasisPoints ?? null;
  o.indirectHardCostMarkupInBasisPoints = options.indirectHardCostMarkupInBasisPoints ?? null;
  o.directHardCostMarkupInBasisPoints = options.directHardCostMarkupInBasisPoints ?? null;
  o.legalDescription = options.legalDescription ?? null;
  o.salesTaxOverrideInBasisPoints = options.salesTaxOverrideInBasisPoints ?? null;
  o.salesTaxInBasisPoints = options.salesTaxInBasisPoints ?? 0;
  o.projectItemAllocations = (options.projectItemAllocations ?? []).map((i) =>
    maybeNew("ProjectItemAllocation", i, cache, options.hasOwnProperty("projectItemAllocations"))
  );
  o.allocationRules = (options.allocationRules ?? []).map((i) =>
    maybeNew("ProjectAllocationRule", i, cache, options.hasOwnProperty("allocationRules"))
  );
  o.warrantyLengthInDays = options.warrantyLengthInDays ?? 0;
  o.warrantyOverrideLengthInDays = options.warrantyOverrideLengthInDays ?? null;
  o.bidPackages = (options.bidPackages ?? []).map((i) =>
    maybeNew("BidPackage", i, cache, options.hasOwnProperty("bidPackages"))
  );
  o.bidContracts = (options.bidContracts ?? []).map((i) =>
    maybeNew("BidContract", i, cache, options.hasOwnProperty("bidContracts"))
  );
  o.selectionsByLocation = (options.selectionsByLocation ?? []).map((i) =>
    maybeNew("HomeownerLocationSelection", i, cache, options.hasOwnProperty("selectionsByLocation"))
  );
  o.hasSelections = options.hasSelections ?? false;
  o.homeownerContracts = (options.homeownerContracts ?? []).map((i) =>
    maybeNew("HomeownerContract", i, cache, options.hasOwnProperty("homeownerContracts"))
  );
  o.documents = (options.documents ?? []).map((i) =>
    maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
  );
  o.commitments = (options.commitments ?? []).map((i) =>
    maybeNew("Commitment", i, cache, options.hasOwnProperty("commitments"))
  );
  o.directCostInCents = options.directCostInCents ?? 0;
  o.directPriceInCents = options.directPriceInCents ?? 0;
  o.totalHardCostInCents = options.totalHardCostInCents ?? 0;
  o.totalSoftCostInCents = options.totalSoftCostInCents ?? 0;
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.totalPriceInCents = options.totalPriceInCents ?? 0;
  o.readyToStartDate = options.readyToStartDate ?? null;
  o.committedCostCodesAtStartInBasisPoints = options.committedCostCodesAtStartInBasisPoints ?? null;
  o.directCostAtStartInCents = options.directCostAtStartInCents ?? null;
  o.directCostVarianceInCents = options.directCostVarianceInCents ?? null;
  o.uncommittedCostInCents = options.uncommittedCostInCents ?? 0;
  o.snapshots = (options.snapshots ?? []).map((i) =>
    maybeNew("ProjectSnapshot", i, cache, options.hasOwnProperty("snapshots"))
  );
  o.warrantyEndDate = options.warrantyEndDate ?? null;
  o.companyInfo = maybeNew("CompanyInfo", options.companyInfo, cache, options.hasOwnProperty("companyInfo"));
  o.invoicePaymentNetDays = options.invoicePaymentNetDays ?? 0;
  o.snapshotAsOf = maybeNewOrNull("ProjectSnapshot", options.snapshotAsOf, cache);
  o.purchaseCostInCents = options.purchaseCostInCents ?? null;
  o.grossSalesPriceInCents = options.grossSalesPriceInCents ?? null;
  o.closingCostsForDirectMarginInCents = options.closingCostsForDirectMarginInCents ?? null;
  o.directMarginInBasisPoints = options.directMarginInBasisPoints ?? null;
  o.projectCostCodes = (options.projectCostCodes ?? []).map((i) =>
    maybeNew("ProjectCostCode", i, cache, options.hasOwnProperty("projectCostCodes"))
  );
  o.showInCheckout = options.showInCheckout ?? false;
  o.parentsRecursive = (options.parentsRecursive ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("parentsRecursive"))
  );
  o.childrenRecursive = (options.childrenRecursive ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("childrenRecursive"))
  );
  o.siblingProjects = (options.siblingProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("siblingProjects"))
  );
  o.sellableProjects = (options.sellableProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("sellableProjects"))
  );
  o.isSellableProject = options.isSellableProject ?? false;
  o.originalCostInCents = options.originalCostInCents ?? 0;
  o.startCostInCents = options.startCostInCents ?? 0;
  o.changeEventCostInCents = options.changeEventCostInCents ?? 0;
  o.projectedCostInCents = options.projectedCostInCents ?? 0;
  o.revisedCostInCents = options.revisedCostInCents ?? 0;
  o.committedCostInCents = options.committedCostInCents ?? 0;
  o.availableCostInCents = options.availableCostInCents ?? 0;
  o.billedCostInCents = options.billedCostInCents ?? 0;
  o.unbilledCostInCents = options.unbilledCostInCents ?? 0;
  o.cohort = maybeNewOrNull("Cohort", options.cohort, cache);
  o.constructionConfidenceFactor = options.constructionConfidenceFactor ?? null;
  o.lotRating = maybeNewOrNull("LotRating", options.lotRating, cache);
  o.preConBudgetLineItems = (options.preConBudgetLineItems ?? []).map((i) =>
    maybeNew("PreConBudgetCostDivisionLineItem", i, cache, options.hasOwnProperty("preConBudgetLineItems"))
  );
  o.preconContractType = maybeNewOrNull("PreconContractType", options.preconContractType, cache);
  o.primaryProject = maybeNewOrNull("Project", options.primaryProject, cache);
  o.quickbooksCustomerId = options.quickbooksCustomerId ?? null;
  o.shadowProjects = (options.shadowProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("shadowProjects"))
  );
  o.submarket = maybeNewOrNull("Submarket", options.submarket, cache);
  o.client = maybeNewOrNull("Client", options.client, cache);
  o.url = options.url ?? "url";
  o.projectName = options.projectName ?? "projectName";
  o.salesforceId = options.salesforceId ?? null;
  o.activeSalesforceOpportunity = maybeNewOrNull(
    "ProjectSalesforceOpportunity",
    options.activeSalesforceOpportunity,
    cache,
  );
  o.dictionary = maybeNew("ProjectDictionary", options.dictionary, cache, options.hasOwnProperty("dictionary"));
  o.packageComparison = maybeNewOrNull("Asset", options.packageComparison, cache);
  o.globalPlanStageVariants = (options.globalPlanStageVariants ?? []).map((i) =>
    maybeNew("GlobalPlanStageVariant", i, cache, options.hasOwnProperty("globalPlanStageVariants"))
  );
  return o;
}

factories["Community"] = newCommunity;

export interface SubdivisionOptions {
  __typename?: "Subdivision";
  references?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: Subdivision["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: Subdivision["isFollowed"];
  id?: Subdivision["id"];
  salesforceBusinessDevelopmentOpportunityId?: Subdivision["salesforceBusinessDevelopmentOpportunityId"];
  salesforceTakedownId?: Subdivision["salesforceTakedownId"];
  market?: Market | MarketOptions;
  parent?: Community | CommunityOptions;
  children?: Array<Lot | LotOptions>;
  collaborators?: Array<ProjectCollaborator | ProjectCollaboratorOptions>;
  coverImage?: Asset | AssetOptions | null;
  buildAddress?: Address | AddressOptions | null;
  teamMembers?: Array<ProjectTeamMember | ProjectTeamMemberOptions>;
  projectLead?: ProjectTeamMember | ProjectTeamMemberOptions | null;
  activeStage?: StageDetailOptions | Stage;
  activeProjectStage?: ProjectStage | ProjectStageOptions | null;
  stages?: Array<ProjectStage | ProjectStageOptions>;
  stage?: ProjectStage | ProjectStageOptions;
  blueprintUrl?: Url | UrlOptions;
  hopUrl?: Subdivision["hopUrl"];
  name?: Subdivision["name"];
  availableAssignees?: Array<InternalUser | InternalUserOptions>;
  startDate?: Subdivision["startDate"];
  features?: Subdivision["features"];
  isTest?: Subdivision["isTest"];
  status?: ProjectStatusDetailOptions | ProjectStatus;
  latitude?: Subdivision["latitude"];
  longitude?: Subdivision["longitude"];
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  googleDriveFolderId?: Subdivision["googleDriveFolderId"];
  salesforceAccountId?: Subdivision["salesforceAccountId"];
  salesforceOpportunities?: Array<ProjectSalesforceOpportunity | ProjectSalesforceOpportunityOptions>;
  projectStatusChange?: ProjectStatusChange | ProjectStatusChangeOptions | null;
  planRoomLink?: Subdivision["planRoomLink"];
  isDisaster?: Subdivision["isDisaster"];
  intakeStyleNotes?: Subdivision["intakeStyleNotes"];
  lotType?: LotTypeDetailOptions | LotType;
  communityType?: CommunityTypeDetailOptions | CommunityType | null;
  productType?: ProductType | ProductTypeOptions | null;
  enableSchedulesV2?: Subdivision["enableSchedulesV2"];
  tradePartners?: Array<TradePartner | TradePartnerOptions>;
  cutoffs?: Array<ProjectCutoff | ProjectCutoffOptions>;
  jobLogs?: Array<JobLog | JobLogOptions>;
  salesforcePropertyId?: Subdivision["salesforcePropertyId"];
  schedules?: Array<Schedule | ScheduleOptions>;
  expenses?: Array<Expense | ExpenseOptions>;
  unallocatedExpenses?: Array<Expense | ExpenseOptions>;
  unallocatedAmountInCents?: Subdivision["unallocatedAmountInCents"];
  enableSchedulesV2Gantt?: Subdivision["enableSchedulesV2Gantt"];
  enableSchedulesCalendar?: Subdivision["enableSchedulesCalendar"];
  readyPlanConfig?: ProjectReadyPlanConfig | ProjectReadyPlanConfigOptions | null;
  earnedValueCurves?: Array<EarnedValueCurve | EarnedValueCurveOptions>;
  enableInvoiceV2?: Subdivision["enableInvoiceV2"];
  invoiceSettings?: ProjectInvoiceSetting | ProjectInvoiceSettingOptions | null;
  scopeMode?: ScopeModeDetailOptions | ScopeMode;
  lotPartitionId?: Subdivision["lotPartitionId"];
  budgetFinancials?: ProjectBudgetFinancials | ProjectBudgetFinancialsOptions;
  enableDelayFlags?: Subdivision["enableDelayFlags"];
  warrantyStartDate?: Subdivision["warrantyStartDate"];
  verticalCompleteDate?: Subdivision["verticalCompleteDate"];
  jobLogInsights?: ProjectJobLogInsights | ProjectJobLogInsightsOptions;
  targetEndDate?: Subdivision["targetEndDate"];
  latestActiveStage?: ProjectStage | ProjectStageOptions | null;
  primaryHomeowner?: Client | ClientOptions | null;
  toDos?: Array<ToDo | ToDoOptions> | null;
  lotDetail?: ProjectLotDetail | ProjectLotDetailOptions;
  siteSpecificInfos?: Array<ProjectSiteSpecificInfo | ProjectSiteSpecificInfoOptions>;
  projectSiteCondition?: ProjectSiteCondition | ProjectSiteConditionOptions | null;
  unassignedTaskCount?: Subdivision["unassignedTaskCount"];
  enableHomeownerNotes?: Subdivision["enableHomeownerNotes"];
  checkoutCustomerConfigId?: Subdivision["checkoutCustomerConfigId"];
  canEditJobLogs?: PotentialOperation2 | PotentialOperation2Options;
  canEditPrice?: PotentialOperation2 | PotentialOperation2Options;
  canHaveBudget?: PotentialOperation2 | PotentialOperation2Options;
  homeownerNotes?: Array<HomeownerNote | HomeownerNoteOptions>;
  enableHomeownerJourneyV2?: Subdivision["enableHomeownerJourneyV2"];
  featureFlags?: Array<FeatureFlag | FeatureFlagOptions>;
  homeownerDeliveryDate?: Subdivision["homeownerDeliveryDate"];
  tasksCompletedThisWeek?: Subdivision["tasksCompletedThisWeek"];
  contacts?: Array<ProjectContact | ProjectContactOptions>;
  warrantyTickets?: Array<WarrantyTicket | WarrantyTicketOptions>;
  shouldAccrueAsComplete?: Subdivision["shouldAccrueAsComplete"];
  directCostMarkupOverrideBasisPoints?: Subdivision["directCostMarkupOverrideBasisPoints"];
  indirectCostMarkupOverrideBasisPoints?: Subdivision["indirectCostMarkupOverrideBasisPoints"];
  customer?: Customer | CustomerOptions | null;
  customerOwnerEntity?: CustomerOwnerEntity | CustomerOwnerEntityOptions | null;
  invoiceSchedule?: InvoiceSchedule | InvoiceScheduleOptions | null;
  allowExcludedCostCodesOnPurchaseOrders?: Subdivision["allowExcludedCostCodesOnPurchaseOrders"];
  enableProductConfigPlan?: Subdivision["enableProductConfigPlan"];
  planSchedule?: PlanSchedule | PlanScheduleOptions | null;
  builder?: Builder | BuilderOptions | null;
  bidOutPercentage?: Subdivision["bidOutPercentage"];
  enableChangeEventSignatures?: Subdivision["enableChangeEventSignatures"];
  enablePocInvoiceSchedule?: Subdivision["enablePocInvoiceSchedule"];
  softCostMarkupInBasisPoints?: Subdivision["softCostMarkupInBasisPoints"];
  indirectHardCostMarkupInBasisPoints?: Subdivision["indirectHardCostMarkupInBasisPoints"];
  directHardCostMarkupInBasisPoints?: Subdivision["directHardCostMarkupInBasisPoints"];
  legalDescription?: Subdivision["legalDescription"];
  salesTaxOverrideInBasisPoints?: Subdivision["salesTaxOverrideInBasisPoints"];
  salesTaxInBasisPoints?: Subdivision["salesTaxInBasisPoints"];
  projectItemAllocations?: Array<ProjectItemAllocation | ProjectItemAllocationOptions>;
  allocationRules?: Array<ProjectAllocationRule | ProjectAllocationRuleOptions>;
  warrantyLengthInDays?: Subdivision["warrantyLengthInDays"];
  warrantyOverrideLengthInDays?: Subdivision["warrantyOverrideLengthInDays"];
  bidPackages?: Array<BidPackage | BidPackageOptions>;
  bidContracts?: Array<BidContract | BidContractOptions>;
  selectionsByLocation?: Array<HomeownerLocationSelection | HomeownerLocationSelectionOptions>;
  hasSelections?: Subdivision["hasSelections"];
  homeownerContracts?: Array<HomeownerContract | HomeownerContractOptions>;
  documents?: Array<Document | DocumentOptions>;
  commitments?: Array<Commitment | CommitmentOptions>;
  directCostInCents?: Subdivision["directCostInCents"];
  directPriceInCents?: Subdivision["directPriceInCents"];
  totalHardCostInCents?: Subdivision["totalHardCostInCents"];
  totalSoftCostInCents?: Subdivision["totalSoftCostInCents"];
  totalCostInCents?: Subdivision["totalCostInCents"];
  totalPriceInCents?: Subdivision["totalPriceInCents"];
  readyToStartDate?: Subdivision["readyToStartDate"];
  committedCostCodesAtStartInBasisPoints?: Subdivision["committedCostCodesAtStartInBasisPoints"];
  directCostAtStartInCents?: Subdivision["directCostAtStartInCents"];
  directCostVarianceInCents?: Subdivision["directCostVarianceInCents"];
  uncommittedCostInCents?: Subdivision["uncommittedCostInCents"];
  snapshots?: Array<ProjectSnapshot | ProjectSnapshotOptions>;
  warrantyEndDate?: Subdivision["warrantyEndDate"];
  companyInfo?: CompanyInfo | CompanyInfoOptions;
  invoicePaymentNetDays?: Subdivision["invoicePaymentNetDays"];
  snapshotAsOf?: ProjectSnapshot | ProjectSnapshotOptions | null;
  purchaseCostInCents?: Subdivision["purchaseCostInCents"];
  grossSalesPriceInCents?: Subdivision["grossSalesPriceInCents"];
  closingCostsForDirectMarginInCents?: Subdivision["closingCostsForDirectMarginInCents"];
  directMarginInBasisPoints?: Subdivision["directMarginInBasisPoints"];
  projectCostCodes?: Array<ProjectCostCode | ProjectCostCodeOptions>;
  parentsRecursive?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  childrenRecursive?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  siblingProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  sellableProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  isSellableProject?: Subdivision["isSellableProject"];
  originalCostInCents?: Subdivision["originalCostInCents"];
  startCostInCents?: Subdivision["startCostInCents"];
  changeEventCostInCents?: Subdivision["changeEventCostInCents"];
  projectedCostInCents?: Subdivision["projectedCostInCents"];
  revisedCostInCents?: Subdivision["revisedCostInCents"];
  committedCostInCents?: Subdivision["committedCostInCents"];
  availableCostInCents?: Subdivision["availableCostInCents"];
  billedCostInCents?: Subdivision["billedCostInCents"];
  unbilledCostInCents?: Subdivision["unbilledCostInCents"];
  cohort?: Cohort | CohortOptions | null;
  constructionConfidenceFactor?: Subdivision["constructionConfidenceFactor"];
  lotRating?: LotRating | LotRatingOptions | null;
  preConBudgetLineItems?: Array<PreConBudgetCostDivisionLineItem | PreConBudgetCostDivisionLineItemOptions>;
  preconContractType?: PreconContractType | PreconContractTypeOptions | null;
  primaryProject?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  quickbooksCustomerId?: Subdivision["quickbooksCustomerId"];
  shadowProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  submarket?: Submarket | SubmarketOptions | null;
  client?: Client | ClientOptions | null;
  url?: Subdivision["url"];
  projectName?: Subdivision["projectName"];
  salesforceId?: Subdivision["salesforceId"];
  activeSalesforceOpportunity?: ProjectSalesforceOpportunity | ProjectSalesforceOpportunityOptions | null;
  dictionary?: ProjectDictionary | ProjectDictionaryOptions;
}

export function newSubdivision(options: SubdivisionOptions = {}, cache: Record<string, any> = {}): Subdivision {
  const o = (options.__typename ? options : cache["Subdivision"] = {}) as Subdivision;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Subdivision";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("Subdivision");
  o.salesforceBusinessDevelopmentOpportunityId = options.salesforceBusinessDevelopmentOpportunityId ?? null;
  o.salesforceTakedownId = options.salesforceTakedownId ?? null;
  o.market = maybeNew("Market", options.market, cache, options.hasOwnProperty("market"));
  o.parent = maybeNew("Community", options.parent, cache, options.hasOwnProperty("parent"));
  o.children = (options.children ?? []).map((i) => maybeNew("Lot", i, cache, options.hasOwnProperty("children")));
  o.collaborators = (options.collaborators ?? []).map((i) =>
    maybeNew("ProjectCollaborator", i, cache, options.hasOwnProperty("collaborators"))
  );
  o.coverImage = maybeNewOrNull("Asset", options.coverImage, cache);
  o.buildAddress = maybeNewOrNull("Address", options.buildAddress, cache);
  o.teamMembers = (options.teamMembers ?? []).map((i) =>
    maybeNew("ProjectTeamMember", i, cache, options.hasOwnProperty("teamMembers"))
  );
  o.projectLead = maybeNewOrNull("ProjectTeamMember", options.projectLead, cache);
  o.activeStage = enumOrDetailOfStage(options.activeStage);
  o.activeProjectStage = maybeNewOrNull("ProjectStage", options.activeProjectStage, cache);
  o.stages = (options.stages ?? []).map((i) => maybeNew("ProjectStage", i, cache, options.hasOwnProperty("stages")));
  o.stage = maybeNew("ProjectStage", options.stage, cache, options.hasOwnProperty("stage"));
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.hopUrl = options.hopUrl ?? "hopUrl";
  o.name = options.name ?? "name";
  o.availableAssignees = (options.availableAssignees ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableAssignees"))
  );
  o.startDate = options.startDate ?? newDate();
  o.features = options.features ?? [];
  o.isTest = options.isTest ?? false;
  o.status = enumOrDetailOfProjectStatus(options.status);
  o.latitude = options.latitude ?? null;
  o.longitude = options.longitude ?? null;
  o.project = maybeNewOrNull("Project", options.project, cache);
  o.googleDriveFolderId = options.googleDriveFolderId ?? null;
  o.salesforceAccountId = options.salesforceAccountId ?? null;
  o.salesforceOpportunities = (options.salesforceOpportunities ?? []).map((i) =>
    maybeNew("ProjectSalesforceOpportunity", i, cache, options.hasOwnProperty("salesforceOpportunities"))
  );
  o.projectStatusChange = maybeNewOrNull("ProjectStatusChange", options.projectStatusChange, cache);
  o.planRoomLink = options.planRoomLink ?? null;
  o.isDisaster = options.isDisaster ?? null;
  o.intakeStyleNotes = options.intakeStyleNotes ?? null;
  o.lotType = enumOrDetailOfLotType(options.lotType);
  o.communityType = enumOrDetailOrNullOfCommunityType(options.communityType);
  o.productType = maybeNewOrNull("ProductType", options.productType, cache);
  o.enableSchedulesV2 = options.enableSchedulesV2 ?? false;
  o.tradePartners = (options.tradePartners ?? []).map((i) =>
    maybeNew("TradePartner", i, cache, options.hasOwnProperty("tradePartners"))
  );
  o.cutoffs = (options.cutoffs ?? []).map((i) =>
    maybeNew("ProjectCutoff", i, cache, options.hasOwnProperty("cutoffs"))
  );
  o.jobLogs = (options.jobLogs ?? []).map((i) => maybeNew("JobLog", i, cache, options.hasOwnProperty("jobLogs")));
  o.salesforcePropertyId = options.salesforcePropertyId ?? null;
  o.schedules = (options.schedules ?? []).map((i) =>
    maybeNew("Schedule", i, cache, options.hasOwnProperty("schedules"))
  );
  o.expenses = (options.expenses ?? []).map((i) => maybeNew("Expense", i, cache, options.hasOwnProperty("expenses")));
  o.unallocatedExpenses = (options.unallocatedExpenses ?? []).map((i) =>
    maybeNew("Expense", i, cache, options.hasOwnProperty("unallocatedExpenses"))
  );
  o.unallocatedAmountInCents = options.unallocatedAmountInCents ?? 0;
  o.enableSchedulesV2Gantt = options.enableSchedulesV2Gantt ?? false;
  o.enableSchedulesCalendar = options.enableSchedulesCalendar ?? false;
  o.readyPlanConfig = maybeNewOrNull("ProjectReadyPlanConfig", options.readyPlanConfig, cache);
  o.earnedValueCurves = (options.earnedValueCurves ?? []).map((i) =>
    maybeNew("EarnedValueCurve", i, cache, options.hasOwnProperty("earnedValueCurves"))
  );
  o.enableInvoiceV2 = options.enableInvoiceV2 ?? false;
  o.invoiceSettings = maybeNewOrNull("ProjectInvoiceSetting", options.invoiceSettings, cache);
  o.scopeMode = enumOrDetailOfScopeMode(options.scopeMode);
  o.lotPartitionId = options.lotPartitionId ?? null;
  o.budgetFinancials = maybeNew(
    "ProjectBudgetFinancials",
    options.budgetFinancials,
    cache,
    options.hasOwnProperty("budgetFinancials"),
  );
  o.enableDelayFlags = options.enableDelayFlags ?? false;
  o.warrantyStartDate = options.warrantyStartDate ?? null;
  o.verticalCompleteDate = options.verticalCompleteDate ?? null;
  o.jobLogInsights = maybeNew(
    "ProjectJobLogInsights",
    options.jobLogInsights,
    cache,
    options.hasOwnProperty("jobLogInsights"),
  );
  o.targetEndDate = options.targetEndDate ?? null;
  o.latestActiveStage = maybeNewOrNull("ProjectStage", options.latestActiveStage, cache);
  o.primaryHomeowner = maybeNewOrNull("Client", options.primaryHomeowner, cache);
  o.toDos = (options.toDos ?? []).map((i) => maybeNew("ToDo", i, cache, options.hasOwnProperty("toDos")));
  o.lotDetail = maybeNew("ProjectLotDetail", options.lotDetail, cache, options.hasOwnProperty("lotDetail"));
  o.siteSpecificInfos = (options.siteSpecificInfos ?? []).map((i) =>
    maybeNew("ProjectSiteSpecificInfo", i, cache, options.hasOwnProperty("siteSpecificInfos"))
  );
  o.projectSiteCondition = maybeNewOrNull("ProjectSiteCondition", options.projectSiteCondition, cache);
  o.unassignedTaskCount = options.unassignedTaskCount ?? 0;
  o.enableHomeownerNotes = options.enableHomeownerNotes ?? false;
  o.checkoutCustomerConfigId = options.checkoutCustomerConfigId ?? null;
  o.canEditJobLogs = maybeNew(
    "PotentialOperation2",
    options.canEditJobLogs,
    cache,
    options.hasOwnProperty("canEditJobLogs"),
  );
  o.canEditPrice = maybeNew("PotentialOperation2", options.canEditPrice, cache, options.hasOwnProperty("canEditPrice"));
  o.canHaveBudget = maybeNew(
    "PotentialOperation2",
    options.canHaveBudget,
    cache,
    options.hasOwnProperty("canHaveBudget"),
  );
  o.homeownerNotes = (options.homeownerNotes ?? []).map((i) =>
    maybeNew("HomeownerNote", i, cache, options.hasOwnProperty("homeownerNotes"))
  );
  o.enableHomeownerJourneyV2 = options.enableHomeownerJourneyV2 ?? false;
  o.featureFlags = (options.featureFlags ?? []).map((i) =>
    maybeNew("FeatureFlag", i, cache, options.hasOwnProperty("featureFlags"))
  );
  o.homeownerDeliveryDate = options.homeownerDeliveryDate ?? null;
  o.tasksCompletedThisWeek = options.tasksCompletedThisWeek ?? 0;
  o.contacts = (options.contacts ?? []).map((i) =>
    maybeNew("ProjectContact", i, cache, options.hasOwnProperty("contacts"))
  );
  o.warrantyTickets = (options.warrantyTickets ?? []).map((i) =>
    maybeNew("WarrantyTicket", i, cache, options.hasOwnProperty("warrantyTickets"))
  );
  o.shouldAccrueAsComplete = options.shouldAccrueAsComplete ?? false;
  o.directCostMarkupOverrideBasisPoints = options.directCostMarkupOverrideBasisPoints ?? null;
  o.indirectCostMarkupOverrideBasisPoints = options.indirectCostMarkupOverrideBasisPoints ?? null;
  o.customer = maybeNewOrNull("Customer", options.customer, cache);
  o.customerOwnerEntity = maybeNewOrNull("CustomerOwnerEntity", options.customerOwnerEntity, cache);
  o.invoiceSchedule = maybeNewOrNull("InvoiceSchedule", options.invoiceSchedule, cache);
  o.allowExcludedCostCodesOnPurchaseOrders = options.allowExcludedCostCodesOnPurchaseOrders ?? false;
  o.enableProductConfigPlan = options.enableProductConfigPlan ?? false;
  o.planSchedule = maybeNewOrNull("PlanSchedule", options.planSchedule, cache);
  o.builder = maybeNewOrNull("Builder", options.builder, cache);
  o.bidOutPercentage = options.bidOutPercentage ?? 0;
  o.enableChangeEventSignatures = options.enableChangeEventSignatures ?? false;
  o.enablePocInvoiceSchedule = options.enablePocInvoiceSchedule ?? false;
  o.softCostMarkupInBasisPoints = options.softCostMarkupInBasisPoints ?? null;
  o.indirectHardCostMarkupInBasisPoints = options.indirectHardCostMarkupInBasisPoints ?? null;
  o.directHardCostMarkupInBasisPoints = options.directHardCostMarkupInBasisPoints ?? null;
  o.legalDescription = options.legalDescription ?? null;
  o.salesTaxOverrideInBasisPoints = options.salesTaxOverrideInBasisPoints ?? null;
  o.salesTaxInBasisPoints = options.salesTaxInBasisPoints ?? 0;
  o.projectItemAllocations = (options.projectItemAllocations ?? []).map((i) =>
    maybeNew("ProjectItemAllocation", i, cache, options.hasOwnProperty("projectItemAllocations"))
  );
  o.allocationRules = (options.allocationRules ?? []).map((i) =>
    maybeNew("ProjectAllocationRule", i, cache, options.hasOwnProperty("allocationRules"))
  );
  o.warrantyLengthInDays = options.warrantyLengthInDays ?? 0;
  o.warrantyOverrideLengthInDays = options.warrantyOverrideLengthInDays ?? null;
  o.bidPackages = (options.bidPackages ?? []).map((i) =>
    maybeNew("BidPackage", i, cache, options.hasOwnProperty("bidPackages"))
  );
  o.bidContracts = (options.bidContracts ?? []).map((i) =>
    maybeNew("BidContract", i, cache, options.hasOwnProperty("bidContracts"))
  );
  o.selectionsByLocation = (options.selectionsByLocation ?? []).map((i) =>
    maybeNew("HomeownerLocationSelection", i, cache, options.hasOwnProperty("selectionsByLocation"))
  );
  o.hasSelections = options.hasSelections ?? false;
  o.homeownerContracts = (options.homeownerContracts ?? []).map((i) =>
    maybeNew("HomeownerContract", i, cache, options.hasOwnProperty("homeownerContracts"))
  );
  o.documents = (options.documents ?? []).map((i) =>
    maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
  );
  o.commitments = (options.commitments ?? []).map((i) =>
    maybeNew("Commitment", i, cache, options.hasOwnProperty("commitments"))
  );
  o.directCostInCents = options.directCostInCents ?? 0;
  o.directPriceInCents = options.directPriceInCents ?? 0;
  o.totalHardCostInCents = options.totalHardCostInCents ?? 0;
  o.totalSoftCostInCents = options.totalSoftCostInCents ?? 0;
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.totalPriceInCents = options.totalPriceInCents ?? 0;
  o.readyToStartDate = options.readyToStartDate ?? null;
  o.committedCostCodesAtStartInBasisPoints = options.committedCostCodesAtStartInBasisPoints ?? null;
  o.directCostAtStartInCents = options.directCostAtStartInCents ?? null;
  o.directCostVarianceInCents = options.directCostVarianceInCents ?? null;
  o.uncommittedCostInCents = options.uncommittedCostInCents ?? 0;
  o.snapshots = (options.snapshots ?? []).map((i) =>
    maybeNew("ProjectSnapshot", i, cache, options.hasOwnProperty("snapshots"))
  );
  o.warrantyEndDate = options.warrantyEndDate ?? null;
  o.companyInfo = maybeNew("CompanyInfo", options.companyInfo, cache, options.hasOwnProperty("companyInfo"));
  o.invoicePaymentNetDays = options.invoicePaymentNetDays ?? 0;
  o.snapshotAsOf = maybeNewOrNull("ProjectSnapshot", options.snapshotAsOf, cache);
  o.purchaseCostInCents = options.purchaseCostInCents ?? null;
  o.grossSalesPriceInCents = options.grossSalesPriceInCents ?? null;
  o.closingCostsForDirectMarginInCents = options.closingCostsForDirectMarginInCents ?? null;
  o.directMarginInBasisPoints = options.directMarginInBasisPoints ?? null;
  o.projectCostCodes = (options.projectCostCodes ?? []).map((i) =>
    maybeNew("ProjectCostCode", i, cache, options.hasOwnProperty("projectCostCodes"))
  );
  o.parentsRecursive = (options.parentsRecursive ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("parentsRecursive"))
  );
  o.childrenRecursive = (options.childrenRecursive ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("childrenRecursive"))
  );
  o.siblingProjects = (options.siblingProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("siblingProjects"))
  );
  o.sellableProjects = (options.sellableProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("sellableProjects"))
  );
  o.isSellableProject = options.isSellableProject ?? false;
  o.originalCostInCents = options.originalCostInCents ?? 0;
  o.startCostInCents = options.startCostInCents ?? 0;
  o.changeEventCostInCents = options.changeEventCostInCents ?? 0;
  o.projectedCostInCents = options.projectedCostInCents ?? 0;
  o.revisedCostInCents = options.revisedCostInCents ?? 0;
  o.committedCostInCents = options.committedCostInCents ?? 0;
  o.availableCostInCents = options.availableCostInCents ?? 0;
  o.billedCostInCents = options.billedCostInCents ?? 0;
  o.unbilledCostInCents = options.unbilledCostInCents ?? 0;
  o.cohort = maybeNewOrNull("Cohort", options.cohort, cache);
  o.constructionConfidenceFactor = options.constructionConfidenceFactor ?? null;
  o.lotRating = maybeNewOrNull("LotRating", options.lotRating, cache);
  o.preConBudgetLineItems = (options.preConBudgetLineItems ?? []).map((i) =>
    maybeNew("PreConBudgetCostDivisionLineItem", i, cache, options.hasOwnProperty("preConBudgetLineItems"))
  );
  o.preconContractType = maybeNewOrNull("PreconContractType", options.preconContractType, cache);
  o.primaryProject = maybeNewOrNull("Project", options.primaryProject, cache);
  o.quickbooksCustomerId = options.quickbooksCustomerId ?? null;
  o.shadowProjects = (options.shadowProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("shadowProjects"))
  );
  o.submarket = maybeNewOrNull("Submarket", options.submarket, cache);
  o.client = maybeNewOrNull("Client", options.client, cache);
  o.url = options.url ?? "url";
  o.projectName = options.projectName ?? "projectName";
  o.salesforceId = options.salesforceId ?? null;
  o.activeSalesforceOpportunity = maybeNewOrNull(
    "ProjectSalesforceOpportunity",
    options.activeSalesforceOpportunity,
    cache,
  );
  o.dictionary = maybeNew("ProjectDictionary", options.dictionary, cache, options.hasOwnProperty("dictionary"));
  return o;
}

factories["Subdivision"] = newSubdivision;

export interface LotOptions {
  __typename?: "Lot";
  references?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: Lot["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: Lot["isFollowed"];
  id?: Lot["id"];
  buildablePlans?: Array<ProductOffering | ProductOfferingOptions>;
  buildableSfhPlans?: Array<ProductOffering | ProductOfferingOptions>;
  buildAddress?: Address | AddressOptions;
  market?: Market | MarketOptions;
  parent?: Subdivision | SubdivisionOptions;
  children?: Array<Structure | StructureOptions>;
  collaborators?: Array<ProjectCollaborator | ProjectCollaboratorOptions>;
  coverImage?: Asset | AssetOptions | null;
  teamMembers?: Array<ProjectTeamMember | ProjectTeamMemberOptions>;
  projectLead?: ProjectTeamMember | ProjectTeamMemberOptions | null;
  activeStage?: StageDetailOptions | Stage;
  activeProjectStage?: ProjectStage | ProjectStageOptions | null;
  stages?: Array<ProjectStage | ProjectStageOptions>;
  stage?: ProjectStage | ProjectStageOptions;
  blueprintUrl?: Url | UrlOptions;
  hopUrl?: Lot["hopUrl"];
  name?: Lot["name"];
  availableAssignees?: Array<InternalUser | InternalUserOptions>;
  startDate?: Lot["startDate"];
  features?: Lot["features"];
  isTest?: Lot["isTest"];
  status?: ProjectStatusDetailOptions | ProjectStatus;
  latitude?: Lot["latitude"];
  longitude?: Lot["longitude"];
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  googleDriveFolderId?: Lot["googleDriveFolderId"];
  salesforceAccountId?: Lot["salesforceAccountId"];
  salesforceOpportunities?: Array<ProjectSalesforceOpportunity | ProjectSalesforceOpportunityOptions>;
  projectStatusChange?: ProjectStatusChange | ProjectStatusChangeOptions | null;
  planRoomLink?: Lot["planRoomLink"];
  isDisaster?: Lot["isDisaster"];
  intakeStyleNotes?: Lot["intakeStyleNotes"];
  lotType?: LotTypeDetailOptions | LotType;
  communityType?: CommunityTypeDetailOptions | CommunityType | null;
  productType?: ProductType | ProductTypeOptions | null;
  enableSchedulesV2?: Lot["enableSchedulesV2"];
  tradePartners?: Array<TradePartner | TradePartnerOptions>;
  cutoffs?: Array<ProjectCutoff | ProjectCutoffOptions>;
  jobLogs?: Array<JobLog | JobLogOptions>;
  salesforcePropertyId?: Lot["salesforcePropertyId"];
  schedules?: Array<Schedule | ScheduleOptions>;
  expenses?: Array<Expense | ExpenseOptions>;
  unallocatedExpenses?: Array<Expense | ExpenseOptions>;
  unallocatedAmountInCents?: Lot["unallocatedAmountInCents"];
  enableSchedulesV2Gantt?: Lot["enableSchedulesV2Gantt"];
  enableSchedulesCalendar?: Lot["enableSchedulesCalendar"];
  readyPlanConfig?: ProjectReadyPlanConfig | ProjectReadyPlanConfigOptions | null;
  earnedValueCurves?: Array<EarnedValueCurve | EarnedValueCurveOptions>;
  enableInvoiceV2?: Lot["enableInvoiceV2"];
  invoiceSettings?: ProjectInvoiceSetting | ProjectInvoiceSettingOptions | null;
  scopeMode?: ScopeModeDetailOptions | ScopeMode;
  lotPartitionId?: Lot["lotPartitionId"];
  budgetFinancials?: ProjectBudgetFinancials | ProjectBudgetFinancialsOptions;
  enableDelayFlags?: Lot["enableDelayFlags"];
  warrantyStartDate?: Lot["warrantyStartDate"];
  verticalCompleteDate?: Lot["verticalCompleteDate"];
  jobLogInsights?: ProjectJobLogInsights | ProjectJobLogInsightsOptions;
  targetEndDate?: Lot["targetEndDate"];
  latestActiveStage?: ProjectStage | ProjectStageOptions | null;
  primaryHomeowner?: Client | ClientOptions | null;
  toDos?: Array<ToDo | ToDoOptions> | null;
  lotDetail?: ProjectLotDetail | ProjectLotDetailOptions;
  siteSpecificInfos?: Array<ProjectSiteSpecificInfo | ProjectSiteSpecificInfoOptions>;
  projectSiteCondition?: ProjectSiteCondition | ProjectSiteConditionOptions | null;
  unassignedTaskCount?: Lot["unassignedTaskCount"];
  enableHomeownerNotes?: Lot["enableHomeownerNotes"];
  checkoutCustomerConfigId?: Lot["checkoutCustomerConfigId"];
  canEditJobLogs?: PotentialOperation2 | PotentialOperation2Options;
  canEditPrice?: PotentialOperation2 | PotentialOperation2Options;
  canHaveBudget?: PotentialOperation2 | PotentialOperation2Options;
  homeownerNotes?: Array<HomeownerNote | HomeownerNoteOptions>;
  enableHomeownerJourneyV2?: Lot["enableHomeownerJourneyV2"];
  featureFlags?: Array<FeatureFlag | FeatureFlagOptions>;
  homeownerDeliveryDate?: Lot["homeownerDeliveryDate"];
  tasksCompletedThisWeek?: Lot["tasksCompletedThisWeek"];
  contacts?: Array<ProjectContact | ProjectContactOptions>;
  warrantyTickets?: Array<WarrantyTicket | WarrantyTicketOptions>;
  shouldAccrueAsComplete?: Lot["shouldAccrueAsComplete"];
  directCostMarkupOverrideBasisPoints?: Lot["directCostMarkupOverrideBasisPoints"];
  indirectCostMarkupOverrideBasisPoints?: Lot["indirectCostMarkupOverrideBasisPoints"];
  customer?: Customer | CustomerOptions | null;
  customerOwnerEntity?: CustomerOwnerEntity | CustomerOwnerEntityOptions | null;
  invoiceSchedule?: InvoiceSchedule | InvoiceScheduleOptions | null;
  allowExcludedCostCodesOnPurchaseOrders?: Lot["allowExcludedCostCodesOnPurchaseOrders"];
  enableProductConfigPlan?: Lot["enableProductConfigPlan"];
  planSchedule?: PlanSchedule | PlanScheduleOptions | null;
  builder?: Builder | BuilderOptions | null;
  bidOutPercentage?: Lot["bidOutPercentage"];
  enableChangeEventSignatures?: Lot["enableChangeEventSignatures"];
  enablePocInvoiceSchedule?: Lot["enablePocInvoiceSchedule"];
  softCostMarkupInBasisPoints?: Lot["softCostMarkupInBasisPoints"];
  indirectHardCostMarkupInBasisPoints?: Lot["indirectHardCostMarkupInBasisPoints"];
  directHardCostMarkupInBasisPoints?: Lot["directHardCostMarkupInBasisPoints"];
  legalDescription?: Lot["legalDescription"];
  salesTaxOverrideInBasisPoints?: Lot["salesTaxOverrideInBasisPoints"];
  salesTaxInBasisPoints?: Lot["salesTaxInBasisPoints"];
  projectItemAllocations?: Array<ProjectItemAllocation | ProjectItemAllocationOptions>;
  allocationRules?: Array<ProjectAllocationRule | ProjectAllocationRuleOptions>;
  warrantyLengthInDays?: Lot["warrantyLengthInDays"];
  warrantyOverrideLengthInDays?: Lot["warrantyOverrideLengthInDays"];
  bidPackages?: Array<BidPackage | BidPackageOptions>;
  bidContracts?: Array<BidContract | BidContractOptions>;
  selectionsByLocation?: Array<HomeownerLocationSelection | HomeownerLocationSelectionOptions>;
  hasSelections?: Lot["hasSelections"];
  homeownerContracts?: Array<HomeownerContract | HomeownerContractOptions>;
  documents?: Array<Document | DocumentOptions>;
  commitments?: Array<Commitment | CommitmentOptions>;
  directCostInCents?: Lot["directCostInCents"];
  directPriceInCents?: Lot["directPriceInCents"];
  totalHardCostInCents?: Lot["totalHardCostInCents"];
  totalSoftCostInCents?: Lot["totalSoftCostInCents"];
  totalCostInCents?: Lot["totalCostInCents"];
  totalPriceInCents?: Lot["totalPriceInCents"];
  readyToStartDate?: Lot["readyToStartDate"];
  committedCostCodesAtStartInBasisPoints?: Lot["committedCostCodesAtStartInBasisPoints"];
  directCostAtStartInCents?: Lot["directCostAtStartInCents"];
  directCostVarianceInCents?: Lot["directCostVarianceInCents"];
  uncommittedCostInCents?: Lot["uncommittedCostInCents"];
  snapshots?: Array<ProjectSnapshot | ProjectSnapshotOptions>;
  warrantyEndDate?: Lot["warrantyEndDate"];
  companyInfo?: CompanyInfo | CompanyInfoOptions;
  invoicePaymentNetDays?: Lot["invoicePaymentNetDays"];
  snapshotAsOf?: ProjectSnapshot | ProjectSnapshotOptions | null;
  purchaseCostInCents?: Lot["purchaseCostInCents"];
  grossSalesPriceInCents?: Lot["grossSalesPriceInCents"];
  closingCostsForDirectMarginInCents?: Lot["closingCostsForDirectMarginInCents"];
  directMarginInBasisPoints?: Lot["directMarginInBasisPoints"];
  projectCostCodes?: Array<ProjectCostCode | ProjectCostCodeOptions>;
  parentsRecursive?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  childrenRecursive?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  siblingProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  sellableProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  isSellableProject?: Lot["isSellableProject"];
  originalCostInCents?: Lot["originalCostInCents"];
  startCostInCents?: Lot["startCostInCents"];
  changeEventCostInCents?: Lot["changeEventCostInCents"];
  projectedCostInCents?: Lot["projectedCostInCents"];
  revisedCostInCents?: Lot["revisedCostInCents"];
  committedCostInCents?: Lot["committedCostInCents"];
  availableCostInCents?: Lot["availableCostInCents"];
  billedCostInCents?: Lot["billedCostInCents"];
  unbilledCostInCents?: Lot["unbilledCostInCents"];
  cohort?: Cohort | CohortOptions | null;
  constructionConfidenceFactor?: Lot["constructionConfidenceFactor"];
  lotRating?: LotRating | LotRatingOptions | null;
  preConBudgetLineItems?: Array<PreConBudgetCostDivisionLineItem | PreConBudgetCostDivisionLineItemOptions>;
  preconContractType?: PreconContractType | PreconContractTypeOptions | null;
  primaryProject?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  quickbooksCustomerId?: Lot["quickbooksCustomerId"];
  shadowProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  submarket?: Submarket | SubmarketOptions | null;
  client?: Client | ClientOptions | null;
  url?: Lot["url"];
  projectName?: Lot["projectName"];
  salesforceId?: Lot["salesforceId"];
  activeSalesforceOpportunity?: ProjectSalesforceOpportunity | ProjectSalesforceOpportunityOptions | null;
  dictionary?: ProjectDictionary | ProjectDictionaryOptions;
}

export function newLot(options: LotOptions = {}, cache: Record<string, any> = {}): Lot {
  const o = (options.__typename ? options : cache["Lot"] = {}) as Lot;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Lot";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("Lot");
  o.buildablePlans = (options.buildablePlans ?? []).map((i) =>
    maybeNew("ProductOffering", i, cache, options.hasOwnProperty("buildablePlans"))
  );
  o.buildableSfhPlans = (options.buildableSfhPlans ?? []).map((i) =>
    maybeNew("ProductOffering", i, cache, options.hasOwnProperty("buildableSfhPlans"))
  );
  o.buildAddress = maybeNew("Address", options.buildAddress, cache, options.hasOwnProperty("buildAddress"));
  o.market = maybeNew("Market", options.market, cache, options.hasOwnProperty("market"));
  o.parent = maybeNew("Subdivision", options.parent, cache, options.hasOwnProperty("parent"));
  o.children = (options.children ?? []).map((i) => maybeNew("Structure", i, cache, options.hasOwnProperty("children")));
  o.collaborators = (options.collaborators ?? []).map((i) =>
    maybeNew("ProjectCollaborator", i, cache, options.hasOwnProperty("collaborators"))
  );
  o.coverImage = maybeNewOrNull("Asset", options.coverImage, cache);
  o.teamMembers = (options.teamMembers ?? []).map((i) =>
    maybeNew("ProjectTeamMember", i, cache, options.hasOwnProperty("teamMembers"))
  );
  o.projectLead = maybeNewOrNull("ProjectTeamMember", options.projectLead, cache);
  o.activeStage = enumOrDetailOfStage(options.activeStage);
  o.activeProjectStage = maybeNewOrNull("ProjectStage", options.activeProjectStage, cache);
  o.stages = (options.stages ?? []).map((i) => maybeNew("ProjectStage", i, cache, options.hasOwnProperty("stages")));
  o.stage = maybeNew("ProjectStage", options.stage, cache, options.hasOwnProperty("stage"));
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.hopUrl = options.hopUrl ?? "hopUrl";
  o.name = options.name ?? "name";
  o.availableAssignees = (options.availableAssignees ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableAssignees"))
  );
  o.startDate = options.startDate ?? newDate();
  o.features = options.features ?? [];
  o.isTest = options.isTest ?? false;
  o.status = enumOrDetailOfProjectStatus(options.status);
  o.latitude = options.latitude ?? null;
  o.longitude = options.longitude ?? null;
  o.project = maybeNewOrNull("Project", options.project, cache);
  o.googleDriveFolderId = options.googleDriveFolderId ?? null;
  o.salesforceAccountId = options.salesforceAccountId ?? null;
  o.salesforceOpportunities = (options.salesforceOpportunities ?? []).map((i) =>
    maybeNew("ProjectSalesforceOpportunity", i, cache, options.hasOwnProperty("salesforceOpportunities"))
  );
  o.projectStatusChange = maybeNewOrNull("ProjectStatusChange", options.projectStatusChange, cache);
  o.planRoomLink = options.planRoomLink ?? null;
  o.isDisaster = options.isDisaster ?? null;
  o.intakeStyleNotes = options.intakeStyleNotes ?? null;
  o.lotType = enumOrDetailOfLotType(options.lotType);
  o.communityType = enumOrDetailOrNullOfCommunityType(options.communityType);
  o.productType = maybeNewOrNull("ProductType", options.productType, cache);
  o.enableSchedulesV2 = options.enableSchedulesV2 ?? false;
  o.tradePartners = (options.tradePartners ?? []).map((i) =>
    maybeNew("TradePartner", i, cache, options.hasOwnProperty("tradePartners"))
  );
  o.cutoffs = (options.cutoffs ?? []).map((i) =>
    maybeNew("ProjectCutoff", i, cache, options.hasOwnProperty("cutoffs"))
  );
  o.jobLogs = (options.jobLogs ?? []).map((i) => maybeNew("JobLog", i, cache, options.hasOwnProperty("jobLogs")));
  o.salesforcePropertyId = options.salesforcePropertyId ?? null;
  o.schedules = (options.schedules ?? []).map((i) =>
    maybeNew("Schedule", i, cache, options.hasOwnProperty("schedules"))
  );
  o.expenses = (options.expenses ?? []).map((i) => maybeNew("Expense", i, cache, options.hasOwnProperty("expenses")));
  o.unallocatedExpenses = (options.unallocatedExpenses ?? []).map((i) =>
    maybeNew("Expense", i, cache, options.hasOwnProperty("unallocatedExpenses"))
  );
  o.unallocatedAmountInCents = options.unallocatedAmountInCents ?? 0;
  o.enableSchedulesV2Gantt = options.enableSchedulesV2Gantt ?? false;
  o.enableSchedulesCalendar = options.enableSchedulesCalendar ?? false;
  o.readyPlanConfig = maybeNewOrNull("ProjectReadyPlanConfig", options.readyPlanConfig, cache);
  o.earnedValueCurves = (options.earnedValueCurves ?? []).map((i) =>
    maybeNew("EarnedValueCurve", i, cache, options.hasOwnProperty("earnedValueCurves"))
  );
  o.enableInvoiceV2 = options.enableInvoiceV2 ?? false;
  o.invoiceSettings = maybeNewOrNull("ProjectInvoiceSetting", options.invoiceSettings, cache);
  o.scopeMode = enumOrDetailOfScopeMode(options.scopeMode);
  o.lotPartitionId = options.lotPartitionId ?? null;
  o.budgetFinancials = maybeNew(
    "ProjectBudgetFinancials",
    options.budgetFinancials,
    cache,
    options.hasOwnProperty("budgetFinancials"),
  );
  o.enableDelayFlags = options.enableDelayFlags ?? false;
  o.warrantyStartDate = options.warrantyStartDate ?? null;
  o.verticalCompleteDate = options.verticalCompleteDate ?? null;
  o.jobLogInsights = maybeNew(
    "ProjectJobLogInsights",
    options.jobLogInsights,
    cache,
    options.hasOwnProperty("jobLogInsights"),
  );
  o.targetEndDate = options.targetEndDate ?? null;
  o.latestActiveStage = maybeNewOrNull("ProjectStage", options.latestActiveStage, cache);
  o.primaryHomeowner = maybeNewOrNull("Client", options.primaryHomeowner, cache);
  o.toDos = (options.toDos ?? []).map((i) => maybeNew("ToDo", i, cache, options.hasOwnProperty("toDos")));
  o.lotDetail = maybeNew("ProjectLotDetail", options.lotDetail, cache, options.hasOwnProperty("lotDetail"));
  o.siteSpecificInfos = (options.siteSpecificInfos ?? []).map((i) =>
    maybeNew("ProjectSiteSpecificInfo", i, cache, options.hasOwnProperty("siteSpecificInfos"))
  );
  o.projectSiteCondition = maybeNewOrNull("ProjectSiteCondition", options.projectSiteCondition, cache);
  o.unassignedTaskCount = options.unassignedTaskCount ?? 0;
  o.enableHomeownerNotes = options.enableHomeownerNotes ?? false;
  o.checkoutCustomerConfigId = options.checkoutCustomerConfigId ?? null;
  o.canEditJobLogs = maybeNew(
    "PotentialOperation2",
    options.canEditJobLogs,
    cache,
    options.hasOwnProperty("canEditJobLogs"),
  );
  o.canEditPrice = maybeNew("PotentialOperation2", options.canEditPrice, cache, options.hasOwnProperty("canEditPrice"));
  o.canHaveBudget = maybeNew(
    "PotentialOperation2",
    options.canHaveBudget,
    cache,
    options.hasOwnProperty("canHaveBudget"),
  );
  o.homeownerNotes = (options.homeownerNotes ?? []).map((i) =>
    maybeNew("HomeownerNote", i, cache, options.hasOwnProperty("homeownerNotes"))
  );
  o.enableHomeownerJourneyV2 = options.enableHomeownerJourneyV2 ?? false;
  o.featureFlags = (options.featureFlags ?? []).map((i) =>
    maybeNew("FeatureFlag", i, cache, options.hasOwnProperty("featureFlags"))
  );
  o.homeownerDeliveryDate = options.homeownerDeliveryDate ?? null;
  o.tasksCompletedThisWeek = options.tasksCompletedThisWeek ?? 0;
  o.contacts = (options.contacts ?? []).map((i) =>
    maybeNew("ProjectContact", i, cache, options.hasOwnProperty("contacts"))
  );
  o.warrantyTickets = (options.warrantyTickets ?? []).map((i) =>
    maybeNew("WarrantyTicket", i, cache, options.hasOwnProperty("warrantyTickets"))
  );
  o.shouldAccrueAsComplete = options.shouldAccrueAsComplete ?? false;
  o.directCostMarkupOverrideBasisPoints = options.directCostMarkupOverrideBasisPoints ?? null;
  o.indirectCostMarkupOverrideBasisPoints = options.indirectCostMarkupOverrideBasisPoints ?? null;
  o.customer = maybeNewOrNull("Customer", options.customer, cache);
  o.customerOwnerEntity = maybeNewOrNull("CustomerOwnerEntity", options.customerOwnerEntity, cache);
  o.invoiceSchedule = maybeNewOrNull("InvoiceSchedule", options.invoiceSchedule, cache);
  o.allowExcludedCostCodesOnPurchaseOrders = options.allowExcludedCostCodesOnPurchaseOrders ?? false;
  o.enableProductConfigPlan = options.enableProductConfigPlan ?? false;
  o.planSchedule = maybeNewOrNull("PlanSchedule", options.planSchedule, cache);
  o.builder = maybeNewOrNull("Builder", options.builder, cache);
  o.bidOutPercentage = options.bidOutPercentage ?? 0;
  o.enableChangeEventSignatures = options.enableChangeEventSignatures ?? false;
  o.enablePocInvoiceSchedule = options.enablePocInvoiceSchedule ?? false;
  o.softCostMarkupInBasisPoints = options.softCostMarkupInBasisPoints ?? null;
  o.indirectHardCostMarkupInBasisPoints = options.indirectHardCostMarkupInBasisPoints ?? null;
  o.directHardCostMarkupInBasisPoints = options.directHardCostMarkupInBasisPoints ?? null;
  o.legalDescription = options.legalDescription ?? null;
  o.salesTaxOverrideInBasisPoints = options.salesTaxOverrideInBasisPoints ?? null;
  o.salesTaxInBasisPoints = options.salesTaxInBasisPoints ?? 0;
  o.projectItemAllocations = (options.projectItemAllocations ?? []).map((i) =>
    maybeNew("ProjectItemAllocation", i, cache, options.hasOwnProperty("projectItemAllocations"))
  );
  o.allocationRules = (options.allocationRules ?? []).map((i) =>
    maybeNew("ProjectAllocationRule", i, cache, options.hasOwnProperty("allocationRules"))
  );
  o.warrantyLengthInDays = options.warrantyLengthInDays ?? 0;
  o.warrantyOverrideLengthInDays = options.warrantyOverrideLengthInDays ?? null;
  o.bidPackages = (options.bidPackages ?? []).map((i) =>
    maybeNew("BidPackage", i, cache, options.hasOwnProperty("bidPackages"))
  );
  o.bidContracts = (options.bidContracts ?? []).map((i) =>
    maybeNew("BidContract", i, cache, options.hasOwnProperty("bidContracts"))
  );
  o.selectionsByLocation = (options.selectionsByLocation ?? []).map((i) =>
    maybeNew("HomeownerLocationSelection", i, cache, options.hasOwnProperty("selectionsByLocation"))
  );
  o.hasSelections = options.hasSelections ?? false;
  o.homeownerContracts = (options.homeownerContracts ?? []).map((i) =>
    maybeNew("HomeownerContract", i, cache, options.hasOwnProperty("homeownerContracts"))
  );
  o.documents = (options.documents ?? []).map((i) =>
    maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
  );
  o.commitments = (options.commitments ?? []).map((i) =>
    maybeNew("Commitment", i, cache, options.hasOwnProperty("commitments"))
  );
  o.directCostInCents = options.directCostInCents ?? 0;
  o.directPriceInCents = options.directPriceInCents ?? 0;
  o.totalHardCostInCents = options.totalHardCostInCents ?? 0;
  o.totalSoftCostInCents = options.totalSoftCostInCents ?? 0;
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.totalPriceInCents = options.totalPriceInCents ?? 0;
  o.readyToStartDate = options.readyToStartDate ?? null;
  o.committedCostCodesAtStartInBasisPoints = options.committedCostCodesAtStartInBasisPoints ?? null;
  o.directCostAtStartInCents = options.directCostAtStartInCents ?? null;
  o.directCostVarianceInCents = options.directCostVarianceInCents ?? null;
  o.uncommittedCostInCents = options.uncommittedCostInCents ?? 0;
  o.snapshots = (options.snapshots ?? []).map((i) =>
    maybeNew("ProjectSnapshot", i, cache, options.hasOwnProperty("snapshots"))
  );
  o.warrantyEndDate = options.warrantyEndDate ?? null;
  o.companyInfo = maybeNew("CompanyInfo", options.companyInfo, cache, options.hasOwnProperty("companyInfo"));
  o.invoicePaymentNetDays = options.invoicePaymentNetDays ?? 0;
  o.snapshotAsOf = maybeNewOrNull("ProjectSnapshot", options.snapshotAsOf, cache);
  o.purchaseCostInCents = options.purchaseCostInCents ?? null;
  o.grossSalesPriceInCents = options.grossSalesPriceInCents ?? null;
  o.closingCostsForDirectMarginInCents = options.closingCostsForDirectMarginInCents ?? null;
  o.directMarginInBasisPoints = options.directMarginInBasisPoints ?? null;
  o.projectCostCodes = (options.projectCostCodes ?? []).map((i) =>
    maybeNew("ProjectCostCode", i, cache, options.hasOwnProperty("projectCostCodes"))
  );
  o.parentsRecursive = (options.parentsRecursive ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("parentsRecursive"))
  );
  o.childrenRecursive = (options.childrenRecursive ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("childrenRecursive"))
  );
  o.siblingProjects = (options.siblingProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("siblingProjects"))
  );
  o.sellableProjects = (options.sellableProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("sellableProjects"))
  );
  o.isSellableProject = options.isSellableProject ?? false;
  o.originalCostInCents = options.originalCostInCents ?? 0;
  o.startCostInCents = options.startCostInCents ?? 0;
  o.changeEventCostInCents = options.changeEventCostInCents ?? 0;
  o.projectedCostInCents = options.projectedCostInCents ?? 0;
  o.revisedCostInCents = options.revisedCostInCents ?? 0;
  o.committedCostInCents = options.committedCostInCents ?? 0;
  o.availableCostInCents = options.availableCostInCents ?? 0;
  o.billedCostInCents = options.billedCostInCents ?? 0;
  o.unbilledCostInCents = options.unbilledCostInCents ?? 0;
  o.cohort = maybeNewOrNull("Cohort", options.cohort, cache);
  o.constructionConfidenceFactor = options.constructionConfidenceFactor ?? null;
  o.lotRating = maybeNewOrNull("LotRating", options.lotRating, cache);
  o.preConBudgetLineItems = (options.preConBudgetLineItems ?? []).map((i) =>
    maybeNew("PreConBudgetCostDivisionLineItem", i, cache, options.hasOwnProperty("preConBudgetLineItems"))
  );
  o.preconContractType = maybeNewOrNull("PreconContractType", options.preconContractType, cache);
  o.primaryProject = maybeNewOrNull("Project", options.primaryProject, cache);
  o.quickbooksCustomerId = options.quickbooksCustomerId ?? null;
  o.shadowProjects = (options.shadowProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("shadowProjects"))
  );
  o.submarket = maybeNewOrNull("Submarket", options.submarket, cache);
  o.client = maybeNewOrNull("Client", options.client, cache);
  o.url = options.url ?? "url";
  o.projectName = options.projectName ?? "projectName";
  o.salesforceId = options.salesforceId ?? null;
  o.activeSalesforceOpportunity = maybeNewOrNull(
    "ProjectSalesforceOpportunity",
    options.activeSalesforceOpportunity,
    cache,
  );
  o.dictionary = maybeNew("ProjectDictionary", options.dictionary, cache, options.hasOwnProperty("dictionary"));
  return o;
}

factories["Lot"] = newLot;

export interface StructureOptions {
  __typename?: "Structure";
  references?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: Structure["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: Structure["isFollowed"];
  id?: Structure["id"];
  buildAddress?: Address | AddressOptions;
  market?: Market | MarketOptions;
  parent?: Lot | LotOptions;
  children?: Array<Unit | UnitOptions>;
  primaryProject?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  showInCheckout?: Structure["showInCheckout"];
  community?: Community | CommunityOptions;
  modelHomeHardCostsInCents?: Structure["modelHomeHardCostsInCents"];
  modelHomeSoftCostsInCents?: Structure["modelHomeSoftCostsInCents"];
  mainHouseStructure?: Structure | StructureOptions | null;
  aduStructure?: Structure | StructureOptions | null;
  planType?: ReadyPlanTypeDetailOptions | ReadyPlanType | null;
  hasStartedConstruction?: Structure["hasStartedConstruction"];
  isConstructionComplete?: Structure["isConstructionComplete"];
  canChangeProductOffering?: PotentialOperation2 | PotentialOperation2Options;
  collaborators?: Array<ProjectCollaborator | ProjectCollaboratorOptions>;
  coverImage?: Asset | AssetOptions | null;
  teamMembers?: Array<ProjectTeamMember | ProjectTeamMemberOptions>;
  projectLead?: ProjectTeamMember | ProjectTeamMemberOptions | null;
  activeStage?: StageDetailOptions | Stage;
  activeProjectStage?: ProjectStage | ProjectStageOptions | null;
  stages?: Array<ProjectStage | ProjectStageOptions>;
  stage?: ProjectStage | ProjectStageOptions;
  blueprintUrl?: Url | UrlOptions;
  hopUrl?: Structure["hopUrl"];
  propcoUrl?: Structure["propcoUrl"];
  name?: Structure["name"];
  availableAssignees?: Array<InternalUser | InternalUserOptions>;
  startDate?: Structure["startDate"];
  features?: Structure["features"];
  isTest?: Structure["isTest"];
  status?: ProjectStatusDetailOptions | ProjectStatus;
  latitude?: Structure["latitude"];
  longitude?: Structure["longitude"];
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  googleDriveFolderId?: Structure["googleDriveFolderId"];
  salesforceAccountId?: Structure["salesforceAccountId"];
  salesforceOpportunities?: Array<ProjectSalesforceOpportunity | ProjectSalesforceOpportunityOptions>;
  projectStatusChange?: ProjectStatusChange | ProjectStatusChangeOptions | null;
  planRoomLink?: Structure["planRoomLink"];
  isDisaster?: Structure["isDisaster"];
  intakeStyleNotes?: Structure["intakeStyleNotes"];
  lotType?: LotTypeDetailOptions | LotType;
  communityType?: CommunityTypeDetailOptions | CommunityType | null;
  productType?: ProductType | ProductTypeOptions | null;
  enableSchedulesV2?: Structure["enableSchedulesV2"];
  tradePartners?: Array<TradePartner | TradePartnerOptions>;
  cutoffs?: Array<ProjectCutoff | ProjectCutoffOptions>;
  jobLogs?: Array<JobLog | JobLogOptions>;
  salesforcePropertyId?: Structure["salesforcePropertyId"];
  schedules?: Array<Schedule | ScheduleOptions>;
  expenses?: Array<Expense | ExpenseOptions>;
  unallocatedExpenses?: Array<Expense | ExpenseOptions>;
  unallocatedAmountInCents?: Structure["unallocatedAmountInCents"];
  enableSchedulesV2Gantt?: Structure["enableSchedulesV2Gantt"];
  enableSchedulesCalendar?: Structure["enableSchedulesCalendar"];
  readyPlanConfig?: ProjectReadyPlanConfig | ProjectReadyPlanConfigOptions | null;
  earnedValueCurves?: Array<EarnedValueCurve | EarnedValueCurveOptions>;
  enableInvoiceV2?: Structure["enableInvoiceV2"];
  invoiceSettings?: ProjectInvoiceSetting | ProjectInvoiceSettingOptions | null;
  scopeMode?: ScopeModeDetailOptions | ScopeMode;
  lotPartitionId?: Structure["lotPartitionId"];
  budgetFinancials?: ProjectBudgetFinancials | ProjectBudgetFinancialsOptions;
  enableDelayFlags?: Structure["enableDelayFlags"];
  warrantyStartDate?: Structure["warrantyStartDate"];
  verticalCompleteDate?: Structure["verticalCompleteDate"];
  jobLogInsights?: ProjectJobLogInsights | ProjectJobLogInsightsOptions;
  targetEndDate?: Structure["targetEndDate"];
  latestActiveStage?: ProjectStage | ProjectStageOptions | null;
  primaryHomeowner?: Client | ClientOptions | null;
  toDos?: Array<ToDo | ToDoOptions> | null;
  lotDetail?: ProjectLotDetail | ProjectLotDetailOptions;
  siteSpecificInfos?: Array<ProjectSiteSpecificInfo | ProjectSiteSpecificInfoOptions>;
  projectSiteCondition?: ProjectSiteCondition | ProjectSiteConditionOptions | null;
  unassignedTaskCount?: Structure["unassignedTaskCount"];
  enableHomeownerNotes?: Structure["enableHomeownerNotes"];
  checkoutCustomerConfigId?: Structure["checkoutCustomerConfigId"];
  canEditJobLogs?: PotentialOperation2 | PotentialOperation2Options;
  canEditPrice?: PotentialOperation2 | PotentialOperation2Options;
  canHaveBudget?: PotentialOperation2 | PotentialOperation2Options;
  homeownerNotes?: Array<HomeownerNote | HomeownerNoteOptions>;
  enableHomeownerJourneyV2?: Structure["enableHomeownerJourneyV2"];
  featureFlags?: Array<FeatureFlag | FeatureFlagOptions>;
  homeownerDeliveryDate?: Structure["homeownerDeliveryDate"];
  tasksCompletedThisWeek?: Structure["tasksCompletedThisWeek"];
  contacts?: Array<ProjectContact | ProjectContactOptions>;
  warrantyTickets?: Array<WarrantyTicket | WarrantyTicketOptions>;
  shouldAccrueAsComplete?: Structure["shouldAccrueAsComplete"];
  directCostMarkupOverrideBasisPoints?: Structure["directCostMarkupOverrideBasisPoints"];
  indirectCostMarkupOverrideBasisPoints?: Structure["indirectCostMarkupOverrideBasisPoints"];
  customer?: Customer | CustomerOptions | null;
  customerOwnerEntity?: CustomerOwnerEntity | CustomerOwnerEntityOptions | null;
  invoiceSchedule?: InvoiceSchedule | InvoiceScheduleOptions | null;
  allowExcludedCostCodesOnPurchaseOrders?: Structure["allowExcludedCostCodesOnPurchaseOrders"];
  enableProductConfigPlan?: Structure["enableProductConfigPlan"];
  planSchedule?: PlanSchedule | PlanScheduleOptions | null;
  builder?: Builder | BuilderOptions | null;
  bidOutPercentage?: Structure["bidOutPercentage"];
  enableChangeEventSignatures?: Structure["enableChangeEventSignatures"];
  enablePocInvoiceSchedule?: Structure["enablePocInvoiceSchedule"];
  softCostMarkupInBasisPoints?: Structure["softCostMarkupInBasisPoints"];
  indirectHardCostMarkupInBasisPoints?: Structure["indirectHardCostMarkupInBasisPoints"];
  directHardCostMarkupInBasisPoints?: Structure["directHardCostMarkupInBasisPoints"];
  legalDescription?: Structure["legalDescription"];
  salesTaxOverrideInBasisPoints?: Structure["salesTaxOverrideInBasisPoints"];
  salesTaxInBasisPoints?: Structure["salesTaxInBasisPoints"];
  projectItemAllocations?: Array<ProjectItemAllocation | ProjectItemAllocationOptions>;
  allocationRules?: Array<ProjectAllocationRule | ProjectAllocationRuleOptions>;
  warrantyLengthInDays?: Structure["warrantyLengthInDays"];
  warrantyOverrideLengthInDays?: Structure["warrantyOverrideLengthInDays"];
  bidPackages?: Array<BidPackage | BidPackageOptions>;
  bidContracts?: Array<BidContract | BidContractOptions>;
  selectionsByLocation?: Array<HomeownerLocationSelection | HomeownerLocationSelectionOptions>;
  hasSelections?: Structure["hasSelections"];
  homeownerContracts?: Array<HomeownerContract | HomeownerContractOptions>;
  documents?: Array<Document | DocumentOptions>;
  commitments?: Array<Commitment | CommitmentOptions>;
  directCostInCents?: Structure["directCostInCents"];
  directPriceInCents?: Structure["directPriceInCents"];
  totalHardCostInCents?: Structure["totalHardCostInCents"];
  totalSoftCostInCents?: Structure["totalSoftCostInCents"];
  totalCostInCents?: Structure["totalCostInCents"];
  totalPriceInCents?: Structure["totalPriceInCents"];
  readyToStartDate?: Structure["readyToStartDate"];
  committedCostCodesAtStartInBasisPoints?: Structure["committedCostCodesAtStartInBasisPoints"];
  directCostAtStartInCents?: Structure["directCostAtStartInCents"];
  directCostVarianceInCents?: Structure["directCostVarianceInCents"];
  uncommittedCostInCents?: Structure["uncommittedCostInCents"];
  snapshots?: Array<ProjectSnapshot | ProjectSnapshotOptions>;
  warrantyEndDate?: Structure["warrantyEndDate"];
  companyInfo?: CompanyInfo | CompanyInfoOptions;
  invoicePaymentNetDays?: Structure["invoicePaymentNetDays"];
  snapshotAsOf?: ProjectSnapshot | ProjectSnapshotOptions | null;
  purchaseCostInCents?: Structure["purchaseCostInCents"];
  grossSalesPriceInCents?: Structure["grossSalesPriceInCents"];
  closingCostsForDirectMarginInCents?: Structure["closingCostsForDirectMarginInCents"];
  directMarginInBasisPoints?: Structure["directMarginInBasisPoints"];
  projectCostCodes?: Array<ProjectCostCode | ProjectCostCodeOptions>;
  parentsRecursive?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  childrenRecursive?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  siblingProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  sellableProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  isSellableProject?: Structure["isSellableProject"];
  originalCostInCents?: Structure["originalCostInCents"];
  startCostInCents?: Structure["startCostInCents"];
  changeEventCostInCents?: Structure["changeEventCostInCents"];
  projectedCostInCents?: Structure["projectedCostInCents"];
  revisedCostInCents?: Structure["revisedCostInCents"];
  committedCostInCents?: Structure["committedCostInCents"];
  availableCostInCents?: Structure["availableCostInCents"];
  billedCostInCents?: Structure["billedCostInCents"];
  unbilledCostInCents?: Structure["unbilledCostInCents"];
  cohort?: Cohort | CohortOptions | null;
  constructionConfidenceFactor?: Structure["constructionConfidenceFactor"];
  lotRating?: LotRating | LotRatingOptions | null;
  preConBudgetLineItems?: Array<PreConBudgetCostDivisionLineItem | PreConBudgetCostDivisionLineItemOptions>;
  preconContractType?: PreconContractType | PreconContractTypeOptions | null;
  quickbooksCustomerId?: Structure["quickbooksCustomerId"];
  shadowProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  submarket?: Submarket | SubmarketOptions | null;
  client?: Client | ClientOptions | null;
  url?: Structure["url"];
  projectName?: Structure["projectName"];
  salesforceId?: Structure["salesforceId"];
  activeSalesforceOpportunity?: ProjectSalesforceOpportunity | ProjectSalesforceOpportunityOptions | null;
  dictionary?: ProjectDictionary | ProjectDictionaryOptions;
  suburbanAssetCategory?: SuburbanAssetCategoryDetailOptions | SuburbanAssetCategory | null;
  lotSalesStatus?: LotSalesStatusDetailOptions | LotSalesStatus | null;
}

export function newStructure(options: StructureOptions = {}, cache: Record<string, any> = {}): Structure {
  const o = (options.__typename ? options : cache["Structure"] = {}) as Structure;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Structure";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("Structure");
  o.buildAddress = maybeNew("Address", options.buildAddress, cache, options.hasOwnProperty("buildAddress"));
  o.market = maybeNew("Market", options.market, cache, options.hasOwnProperty("market"));
  o.parent = maybeNew("Lot", options.parent, cache, options.hasOwnProperty("parent"));
  o.children = (options.children ?? []).map((i) => maybeNew("Unit", i, cache, options.hasOwnProperty("children")));
  o.primaryProject = maybeNewOrNull("Project", options.primaryProject, cache);
  o.showInCheckout = options.showInCheckout ?? false;
  o.community = maybeNew("Community", options.community, cache, options.hasOwnProperty("community"));
  o.modelHomeHardCostsInCents = options.modelHomeHardCostsInCents ?? 0;
  o.modelHomeSoftCostsInCents = options.modelHomeSoftCostsInCents ?? 0;
  o.mainHouseStructure = maybeNewOrNull("Structure", options.mainHouseStructure, cache);
  o.aduStructure = maybeNewOrNull("Structure", options.aduStructure, cache);
  o.planType = enumOrDetailOrNullOfReadyPlanType(options.planType);
  o.hasStartedConstruction = options.hasStartedConstruction ?? false;
  o.isConstructionComplete = options.isConstructionComplete ?? false;
  o.canChangeProductOffering = maybeNew(
    "PotentialOperation2",
    options.canChangeProductOffering,
    cache,
    options.hasOwnProperty("canChangeProductOffering"),
  );
  o.collaborators = (options.collaborators ?? []).map((i) =>
    maybeNew("ProjectCollaborator", i, cache, options.hasOwnProperty("collaborators"))
  );
  o.coverImage = maybeNewOrNull("Asset", options.coverImage, cache);
  o.teamMembers = (options.teamMembers ?? []).map((i) =>
    maybeNew("ProjectTeamMember", i, cache, options.hasOwnProperty("teamMembers"))
  );
  o.projectLead = maybeNewOrNull("ProjectTeamMember", options.projectLead, cache);
  o.activeStage = enumOrDetailOfStage(options.activeStage);
  o.activeProjectStage = maybeNewOrNull("ProjectStage", options.activeProjectStage, cache);
  o.stages = (options.stages ?? []).map((i) => maybeNew("ProjectStage", i, cache, options.hasOwnProperty("stages")));
  o.stage = maybeNew("ProjectStage", options.stage, cache, options.hasOwnProperty("stage"));
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.hopUrl = options.hopUrl ?? "hopUrl";
  o.propcoUrl = options.propcoUrl ?? null;
  o.name = options.name ?? "name";
  o.availableAssignees = (options.availableAssignees ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableAssignees"))
  );
  o.startDate = options.startDate ?? newDate();
  o.features = options.features ?? [];
  o.isTest = options.isTest ?? false;
  o.status = enumOrDetailOfProjectStatus(options.status);
  o.latitude = options.latitude ?? null;
  o.longitude = options.longitude ?? null;
  o.project = maybeNewOrNull("Project", options.project, cache);
  o.googleDriveFolderId = options.googleDriveFolderId ?? null;
  o.salesforceAccountId = options.salesforceAccountId ?? null;
  o.salesforceOpportunities = (options.salesforceOpportunities ?? []).map((i) =>
    maybeNew("ProjectSalesforceOpportunity", i, cache, options.hasOwnProperty("salesforceOpportunities"))
  );
  o.projectStatusChange = maybeNewOrNull("ProjectStatusChange", options.projectStatusChange, cache);
  o.planRoomLink = options.planRoomLink ?? null;
  o.isDisaster = options.isDisaster ?? null;
  o.intakeStyleNotes = options.intakeStyleNotes ?? null;
  o.lotType = enumOrDetailOfLotType(options.lotType);
  o.communityType = enumOrDetailOrNullOfCommunityType(options.communityType);
  o.productType = maybeNewOrNull("ProductType", options.productType, cache);
  o.enableSchedulesV2 = options.enableSchedulesV2 ?? false;
  o.tradePartners = (options.tradePartners ?? []).map((i) =>
    maybeNew("TradePartner", i, cache, options.hasOwnProperty("tradePartners"))
  );
  o.cutoffs = (options.cutoffs ?? []).map((i) =>
    maybeNew("ProjectCutoff", i, cache, options.hasOwnProperty("cutoffs"))
  );
  o.jobLogs = (options.jobLogs ?? []).map((i) => maybeNew("JobLog", i, cache, options.hasOwnProperty("jobLogs")));
  o.salesforcePropertyId = options.salesforcePropertyId ?? null;
  o.schedules = (options.schedules ?? []).map((i) =>
    maybeNew("Schedule", i, cache, options.hasOwnProperty("schedules"))
  );
  o.expenses = (options.expenses ?? []).map((i) => maybeNew("Expense", i, cache, options.hasOwnProperty("expenses")));
  o.unallocatedExpenses = (options.unallocatedExpenses ?? []).map((i) =>
    maybeNew("Expense", i, cache, options.hasOwnProperty("unallocatedExpenses"))
  );
  o.unallocatedAmountInCents = options.unallocatedAmountInCents ?? 0;
  o.enableSchedulesV2Gantt = options.enableSchedulesV2Gantt ?? false;
  o.enableSchedulesCalendar = options.enableSchedulesCalendar ?? false;
  o.readyPlanConfig = maybeNewOrNull("ProjectReadyPlanConfig", options.readyPlanConfig, cache);
  o.earnedValueCurves = (options.earnedValueCurves ?? []).map((i) =>
    maybeNew("EarnedValueCurve", i, cache, options.hasOwnProperty("earnedValueCurves"))
  );
  o.enableInvoiceV2 = options.enableInvoiceV2 ?? false;
  o.invoiceSettings = maybeNewOrNull("ProjectInvoiceSetting", options.invoiceSettings, cache);
  o.scopeMode = enumOrDetailOfScopeMode(options.scopeMode);
  o.lotPartitionId = options.lotPartitionId ?? null;
  o.budgetFinancials = maybeNew(
    "ProjectBudgetFinancials",
    options.budgetFinancials,
    cache,
    options.hasOwnProperty("budgetFinancials"),
  );
  o.enableDelayFlags = options.enableDelayFlags ?? false;
  o.warrantyStartDate = options.warrantyStartDate ?? null;
  o.verticalCompleteDate = options.verticalCompleteDate ?? null;
  o.jobLogInsights = maybeNew(
    "ProjectJobLogInsights",
    options.jobLogInsights,
    cache,
    options.hasOwnProperty("jobLogInsights"),
  );
  o.targetEndDate = options.targetEndDate ?? null;
  o.latestActiveStage = maybeNewOrNull("ProjectStage", options.latestActiveStage, cache);
  o.primaryHomeowner = maybeNewOrNull("Client", options.primaryHomeowner, cache);
  o.toDos = (options.toDos ?? []).map((i) => maybeNew("ToDo", i, cache, options.hasOwnProperty("toDos")));
  o.lotDetail = maybeNew("ProjectLotDetail", options.lotDetail, cache, options.hasOwnProperty("lotDetail"));
  o.siteSpecificInfos = (options.siteSpecificInfos ?? []).map((i) =>
    maybeNew("ProjectSiteSpecificInfo", i, cache, options.hasOwnProperty("siteSpecificInfos"))
  );
  o.projectSiteCondition = maybeNewOrNull("ProjectSiteCondition", options.projectSiteCondition, cache);
  o.unassignedTaskCount = options.unassignedTaskCount ?? 0;
  o.enableHomeownerNotes = options.enableHomeownerNotes ?? false;
  o.checkoutCustomerConfigId = options.checkoutCustomerConfigId ?? null;
  o.canEditJobLogs = maybeNew(
    "PotentialOperation2",
    options.canEditJobLogs,
    cache,
    options.hasOwnProperty("canEditJobLogs"),
  );
  o.canEditPrice = maybeNew("PotentialOperation2", options.canEditPrice, cache, options.hasOwnProperty("canEditPrice"));
  o.canHaveBudget = maybeNew(
    "PotentialOperation2",
    options.canHaveBudget,
    cache,
    options.hasOwnProperty("canHaveBudget"),
  );
  o.homeownerNotes = (options.homeownerNotes ?? []).map((i) =>
    maybeNew("HomeownerNote", i, cache, options.hasOwnProperty("homeownerNotes"))
  );
  o.enableHomeownerJourneyV2 = options.enableHomeownerJourneyV2 ?? false;
  o.featureFlags = (options.featureFlags ?? []).map((i) =>
    maybeNew("FeatureFlag", i, cache, options.hasOwnProperty("featureFlags"))
  );
  o.homeownerDeliveryDate = options.homeownerDeliveryDate ?? null;
  o.tasksCompletedThisWeek = options.tasksCompletedThisWeek ?? 0;
  o.contacts = (options.contacts ?? []).map((i) =>
    maybeNew("ProjectContact", i, cache, options.hasOwnProperty("contacts"))
  );
  o.warrantyTickets = (options.warrantyTickets ?? []).map((i) =>
    maybeNew("WarrantyTicket", i, cache, options.hasOwnProperty("warrantyTickets"))
  );
  o.shouldAccrueAsComplete = options.shouldAccrueAsComplete ?? false;
  o.directCostMarkupOverrideBasisPoints = options.directCostMarkupOverrideBasisPoints ?? null;
  o.indirectCostMarkupOverrideBasisPoints = options.indirectCostMarkupOverrideBasisPoints ?? null;
  o.customer = maybeNewOrNull("Customer", options.customer, cache);
  o.customerOwnerEntity = maybeNewOrNull("CustomerOwnerEntity", options.customerOwnerEntity, cache);
  o.invoiceSchedule = maybeNewOrNull("InvoiceSchedule", options.invoiceSchedule, cache);
  o.allowExcludedCostCodesOnPurchaseOrders = options.allowExcludedCostCodesOnPurchaseOrders ?? false;
  o.enableProductConfigPlan = options.enableProductConfigPlan ?? false;
  o.planSchedule = maybeNewOrNull("PlanSchedule", options.planSchedule, cache);
  o.builder = maybeNewOrNull("Builder", options.builder, cache);
  o.bidOutPercentage = options.bidOutPercentage ?? 0;
  o.enableChangeEventSignatures = options.enableChangeEventSignatures ?? false;
  o.enablePocInvoiceSchedule = options.enablePocInvoiceSchedule ?? false;
  o.softCostMarkupInBasisPoints = options.softCostMarkupInBasisPoints ?? null;
  o.indirectHardCostMarkupInBasisPoints = options.indirectHardCostMarkupInBasisPoints ?? null;
  o.directHardCostMarkupInBasisPoints = options.directHardCostMarkupInBasisPoints ?? null;
  o.legalDescription = options.legalDescription ?? null;
  o.salesTaxOverrideInBasisPoints = options.salesTaxOverrideInBasisPoints ?? null;
  o.salesTaxInBasisPoints = options.salesTaxInBasisPoints ?? 0;
  o.projectItemAllocations = (options.projectItemAllocations ?? []).map((i) =>
    maybeNew("ProjectItemAllocation", i, cache, options.hasOwnProperty("projectItemAllocations"))
  );
  o.allocationRules = (options.allocationRules ?? []).map((i) =>
    maybeNew("ProjectAllocationRule", i, cache, options.hasOwnProperty("allocationRules"))
  );
  o.warrantyLengthInDays = options.warrantyLengthInDays ?? 0;
  o.warrantyOverrideLengthInDays = options.warrantyOverrideLengthInDays ?? null;
  o.bidPackages = (options.bidPackages ?? []).map((i) =>
    maybeNew("BidPackage", i, cache, options.hasOwnProperty("bidPackages"))
  );
  o.bidContracts = (options.bidContracts ?? []).map((i) =>
    maybeNew("BidContract", i, cache, options.hasOwnProperty("bidContracts"))
  );
  o.selectionsByLocation = (options.selectionsByLocation ?? []).map((i) =>
    maybeNew("HomeownerLocationSelection", i, cache, options.hasOwnProperty("selectionsByLocation"))
  );
  o.hasSelections = options.hasSelections ?? false;
  o.homeownerContracts = (options.homeownerContracts ?? []).map((i) =>
    maybeNew("HomeownerContract", i, cache, options.hasOwnProperty("homeownerContracts"))
  );
  o.documents = (options.documents ?? []).map((i) =>
    maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
  );
  o.commitments = (options.commitments ?? []).map((i) =>
    maybeNew("Commitment", i, cache, options.hasOwnProperty("commitments"))
  );
  o.directCostInCents = options.directCostInCents ?? 0;
  o.directPriceInCents = options.directPriceInCents ?? 0;
  o.totalHardCostInCents = options.totalHardCostInCents ?? 0;
  o.totalSoftCostInCents = options.totalSoftCostInCents ?? 0;
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.totalPriceInCents = options.totalPriceInCents ?? 0;
  o.readyToStartDate = options.readyToStartDate ?? null;
  o.committedCostCodesAtStartInBasisPoints = options.committedCostCodesAtStartInBasisPoints ?? null;
  o.directCostAtStartInCents = options.directCostAtStartInCents ?? null;
  o.directCostVarianceInCents = options.directCostVarianceInCents ?? null;
  o.uncommittedCostInCents = options.uncommittedCostInCents ?? 0;
  o.snapshots = (options.snapshots ?? []).map((i) =>
    maybeNew("ProjectSnapshot", i, cache, options.hasOwnProperty("snapshots"))
  );
  o.warrantyEndDate = options.warrantyEndDate ?? null;
  o.companyInfo = maybeNew("CompanyInfo", options.companyInfo, cache, options.hasOwnProperty("companyInfo"));
  o.invoicePaymentNetDays = options.invoicePaymentNetDays ?? 0;
  o.snapshotAsOf = maybeNewOrNull("ProjectSnapshot", options.snapshotAsOf, cache);
  o.purchaseCostInCents = options.purchaseCostInCents ?? null;
  o.grossSalesPriceInCents = options.grossSalesPriceInCents ?? null;
  o.closingCostsForDirectMarginInCents = options.closingCostsForDirectMarginInCents ?? null;
  o.directMarginInBasisPoints = options.directMarginInBasisPoints ?? null;
  o.projectCostCodes = (options.projectCostCodes ?? []).map((i) =>
    maybeNew("ProjectCostCode", i, cache, options.hasOwnProperty("projectCostCodes"))
  );
  o.parentsRecursive = (options.parentsRecursive ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("parentsRecursive"))
  );
  o.childrenRecursive = (options.childrenRecursive ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("childrenRecursive"))
  );
  o.siblingProjects = (options.siblingProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("siblingProjects"))
  );
  o.sellableProjects = (options.sellableProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("sellableProjects"))
  );
  o.isSellableProject = options.isSellableProject ?? false;
  o.originalCostInCents = options.originalCostInCents ?? 0;
  o.startCostInCents = options.startCostInCents ?? 0;
  o.changeEventCostInCents = options.changeEventCostInCents ?? 0;
  o.projectedCostInCents = options.projectedCostInCents ?? 0;
  o.revisedCostInCents = options.revisedCostInCents ?? 0;
  o.committedCostInCents = options.committedCostInCents ?? 0;
  o.availableCostInCents = options.availableCostInCents ?? 0;
  o.billedCostInCents = options.billedCostInCents ?? 0;
  o.unbilledCostInCents = options.unbilledCostInCents ?? 0;
  o.cohort = maybeNewOrNull("Cohort", options.cohort, cache);
  o.constructionConfidenceFactor = options.constructionConfidenceFactor ?? null;
  o.lotRating = maybeNewOrNull("LotRating", options.lotRating, cache);
  o.preConBudgetLineItems = (options.preConBudgetLineItems ?? []).map((i) =>
    maybeNew("PreConBudgetCostDivisionLineItem", i, cache, options.hasOwnProperty("preConBudgetLineItems"))
  );
  o.preconContractType = maybeNewOrNull("PreconContractType", options.preconContractType, cache);
  o.quickbooksCustomerId = options.quickbooksCustomerId ?? null;
  o.shadowProjects = (options.shadowProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("shadowProjects"))
  );
  o.submarket = maybeNewOrNull("Submarket", options.submarket, cache);
  o.client = maybeNewOrNull("Client", options.client, cache);
  o.url = options.url ?? "url";
  o.projectName = options.projectName ?? "projectName";
  o.salesforceId = options.salesforceId ?? null;
  o.activeSalesforceOpportunity = maybeNewOrNull(
    "ProjectSalesforceOpportunity",
    options.activeSalesforceOpportunity,
    cache,
  );
  o.dictionary = maybeNew("ProjectDictionary", options.dictionary, cache, options.hasOwnProperty("dictionary"));
  o.suburbanAssetCategory = enumOrDetailOrNullOfSuburbanAssetCategory(options.suburbanAssetCategory);
  o.lotSalesStatus = enumOrDetailOrNullOfLotSalesStatus(options.lotSalesStatus);
  return o;
}

factories["Structure"] = newStructure;

export interface UnitOptions {
  __typename?: "Unit";
  references?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: Unit["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: Unit["isFollowed"];
  id?: Unit["id"];
  buildAddress?: Address | AddressOptions;
  market?: Market | MarketOptions;
  parent?: Structure | StructureOptions;
  collaborators?: Array<ProjectCollaborator | ProjectCollaboratorOptions>;
  coverImage?: Asset | AssetOptions | null;
  teamMembers?: Array<ProjectTeamMember | ProjectTeamMemberOptions>;
  projectLead?: ProjectTeamMember | ProjectTeamMemberOptions | null;
  activeStage?: StageDetailOptions | Stage;
  activeProjectStage?: ProjectStage | ProjectStageOptions | null;
  stages?: Array<ProjectStage | ProjectStageOptions>;
  stage?: ProjectStage | ProjectStageOptions;
  blueprintUrl?: Url | UrlOptions;
  hopUrl?: Unit["hopUrl"];
  name?: Unit["name"];
  availableAssignees?: Array<InternalUser | InternalUserOptions>;
  startDate?: Unit["startDate"];
  features?: Unit["features"];
  isTest?: Unit["isTest"];
  status?: ProjectStatusDetailOptions | ProjectStatus;
  latitude?: Unit["latitude"];
  longitude?: Unit["longitude"];
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  googleDriveFolderId?: Unit["googleDriveFolderId"];
  salesforceAccountId?: Unit["salesforceAccountId"];
  salesforceOpportunities?: Array<ProjectSalesforceOpportunity | ProjectSalesforceOpportunityOptions>;
  projectStatusChange?: ProjectStatusChange | ProjectStatusChangeOptions | null;
  planRoomLink?: Unit["planRoomLink"];
  isDisaster?: Unit["isDisaster"];
  intakeStyleNotes?: Unit["intakeStyleNotes"];
  lotType?: LotTypeDetailOptions | LotType;
  communityType?: CommunityTypeDetailOptions | CommunityType | null;
  productType?: ProductType | ProductTypeOptions | null;
  enableSchedulesV2?: Unit["enableSchedulesV2"];
  tradePartners?: Array<TradePartner | TradePartnerOptions>;
  cutoffs?: Array<ProjectCutoff | ProjectCutoffOptions>;
  jobLogs?: Array<JobLog | JobLogOptions>;
  salesforcePropertyId?: Unit["salesforcePropertyId"];
  schedules?: Array<Schedule | ScheduleOptions>;
  expenses?: Array<Expense | ExpenseOptions>;
  unallocatedExpenses?: Array<Expense | ExpenseOptions>;
  unallocatedAmountInCents?: Unit["unallocatedAmountInCents"];
  enableSchedulesV2Gantt?: Unit["enableSchedulesV2Gantt"];
  enableSchedulesCalendar?: Unit["enableSchedulesCalendar"];
  readyPlanConfig?: ProjectReadyPlanConfig | ProjectReadyPlanConfigOptions | null;
  earnedValueCurves?: Array<EarnedValueCurve | EarnedValueCurveOptions>;
  enableInvoiceV2?: Unit["enableInvoiceV2"];
  invoiceSettings?: ProjectInvoiceSetting | ProjectInvoiceSettingOptions | null;
  scopeMode?: ScopeModeDetailOptions | ScopeMode;
  lotPartitionId?: Unit["lotPartitionId"];
  budgetFinancials?: ProjectBudgetFinancials | ProjectBudgetFinancialsOptions;
  enableDelayFlags?: Unit["enableDelayFlags"];
  warrantyStartDate?: Unit["warrantyStartDate"];
  verticalCompleteDate?: Unit["verticalCompleteDate"];
  jobLogInsights?: ProjectJobLogInsights | ProjectJobLogInsightsOptions;
  targetEndDate?: Unit["targetEndDate"];
  latestActiveStage?: ProjectStage | ProjectStageOptions | null;
  primaryHomeowner?: Client | ClientOptions | null;
  toDos?: Array<ToDo | ToDoOptions> | null;
  lotDetail?: ProjectLotDetail | ProjectLotDetailOptions;
  siteSpecificInfos?: Array<ProjectSiteSpecificInfo | ProjectSiteSpecificInfoOptions>;
  projectSiteCondition?: ProjectSiteCondition | ProjectSiteConditionOptions | null;
  unassignedTaskCount?: Unit["unassignedTaskCount"];
  enableHomeownerNotes?: Unit["enableHomeownerNotes"];
  checkoutCustomerConfigId?: Unit["checkoutCustomerConfigId"];
  canEditJobLogs?: PotentialOperation2 | PotentialOperation2Options;
  canEditPrice?: PotentialOperation2 | PotentialOperation2Options;
  canHaveBudget?: PotentialOperation2 | PotentialOperation2Options;
  homeownerNotes?: Array<HomeownerNote | HomeownerNoteOptions>;
  enableHomeownerJourneyV2?: Unit["enableHomeownerJourneyV2"];
  featureFlags?: Array<FeatureFlag | FeatureFlagOptions>;
  homeownerDeliveryDate?: Unit["homeownerDeliveryDate"];
  tasksCompletedThisWeek?: Unit["tasksCompletedThisWeek"];
  contacts?: Array<ProjectContact | ProjectContactOptions>;
  warrantyTickets?: Array<WarrantyTicket | WarrantyTicketOptions>;
  shouldAccrueAsComplete?: Unit["shouldAccrueAsComplete"];
  directCostMarkupOverrideBasisPoints?: Unit["directCostMarkupOverrideBasisPoints"];
  indirectCostMarkupOverrideBasisPoints?: Unit["indirectCostMarkupOverrideBasisPoints"];
  customer?: Customer | CustomerOptions | null;
  customerOwnerEntity?: CustomerOwnerEntity | CustomerOwnerEntityOptions | null;
  invoiceSchedule?: InvoiceSchedule | InvoiceScheduleOptions | null;
  allowExcludedCostCodesOnPurchaseOrders?: Unit["allowExcludedCostCodesOnPurchaseOrders"];
  enableProductConfigPlan?: Unit["enableProductConfigPlan"];
  planSchedule?: PlanSchedule | PlanScheduleOptions | null;
  builder?: Builder | BuilderOptions | null;
  bidOutPercentage?: Unit["bidOutPercentage"];
  enableChangeEventSignatures?: Unit["enableChangeEventSignatures"];
  enablePocInvoiceSchedule?: Unit["enablePocInvoiceSchedule"];
  softCostMarkupInBasisPoints?: Unit["softCostMarkupInBasisPoints"];
  indirectHardCostMarkupInBasisPoints?: Unit["indirectHardCostMarkupInBasisPoints"];
  directHardCostMarkupInBasisPoints?: Unit["directHardCostMarkupInBasisPoints"];
  legalDescription?: Unit["legalDescription"];
  salesTaxOverrideInBasisPoints?: Unit["salesTaxOverrideInBasisPoints"];
  salesTaxInBasisPoints?: Unit["salesTaxInBasisPoints"];
  projectItemAllocations?: Array<ProjectItemAllocation | ProjectItemAllocationOptions>;
  allocationRules?: Array<ProjectAllocationRule | ProjectAllocationRuleOptions>;
  warrantyLengthInDays?: Unit["warrantyLengthInDays"];
  warrantyOverrideLengthInDays?: Unit["warrantyOverrideLengthInDays"];
  bidPackages?: Array<BidPackage | BidPackageOptions>;
  bidContracts?: Array<BidContract | BidContractOptions>;
  selectionsByLocation?: Array<HomeownerLocationSelection | HomeownerLocationSelectionOptions>;
  hasSelections?: Unit["hasSelections"];
  homeownerContracts?: Array<HomeownerContract | HomeownerContractOptions>;
  documents?: Array<Document | DocumentOptions>;
  commitments?: Array<Commitment | CommitmentOptions>;
  directCostInCents?: Unit["directCostInCents"];
  directPriceInCents?: Unit["directPriceInCents"];
  totalHardCostInCents?: Unit["totalHardCostInCents"];
  totalSoftCostInCents?: Unit["totalSoftCostInCents"];
  totalCostInCents?: Unit["totalCostInCents"];
  totalPriceInCents?: Unit["totalPriceInCents"];
  readyToStartDate?: Unit["readyToStartDate"];
  committedCostCodesAtStartInBasisPoints?: Unit["committedCostCodesAtStartInBasisPoints"];
  directCostAtStartInCents?: Unit["directCostAtStartInCents"];
  directCostVarianceInCents?: Unit["directCostVarianceInCents"];
  uncommittedCostInCents?: Unit["uncommittedCostInCents"];
  snapshots?: Array<ProjectSnapshot | ProjectSnapshotOptions>;
  warrantyEndDate?: Unit["warrantyEndDate"];
  companyInfo?: CompanyInfo | CompanyInfoOptions;
  invoicePaymentNetDays?: Unit["invoicePaymentNetDays"];
  snapshotAsOf?: ProjectSnapshot | ProjectSnapshotOptions | null;
  purchaseCostInCents?: Unit["purchaseCostInCents"];
  grossSalesPriceInCents?: Unit["grossSalesPriceInCents"];
  closingCostsForDirectMarginInCents?: Unit["closingCostsForDirectMarginInCents"];
  directMarginInBasisPoints?: Unit["directMarginInBasisPoints"];
  projectCostCodes?: Array<ProjectCostCode | ProjectCostCodeOptions>;
  children?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  parentsRecursive?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  childrenRecursive?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  siblingProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  sellableProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  isSellableProject?: Unit["isSellableProject"];
  originalCostInCents?: Unit["originalCostInCents"];
  startCostInCents?: Unit["startCostInCents"];
  changeEventCostInCents?: Unit["changeEventCostInCents"];
  projectedCostInCents?: Unit["projectedCostInCents"];
  revisedCostInCents?: Unit["revisedCostInCents"];
  committedCostInCents?: Unit["committedCostInCents"];
  availableCostInCents?: Unit["availableCostInCents"];
  billedCostInCents?: Unit["billedCostInCents"];
  unbilledCostInCents?: Unit["unbilledCostInCents"];
  cohort?: Cohort | CohortOptions | null;
  constructionConfidenceFactor?: Unit["constructionConfidenceFactor"];
  lotRating?: LotRating | LotRatingOptions | null;
  preConBudgetLineItems?: Array<PreConBudgetCostDivisionLineItem | PreConBudgetCostDivisionLineItemOptions>;
  preconContractType?: PreconContractType | PreconContractTypeOptions | null;
  primaryProject?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  quickbooksCustomerId?: Unit["quickbooksCustomerId"];
  shadowProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  submarket?: Submarket | SubmarketOptions | null;
  client?: Client | ClientOptions | null;
  url?: Unit["url"];
  projectName?: Unit["projectName"];
  salesforceId?: Unit["salesforceId"];
  activeSalesforceOpportunity?: ProjectSalesforceOpportunity | ProjectSalesforceOpportunityOptions | null;
  dictionary?: ProjectDictionary | ProjectDictionaryOptions;
}

export function newUnit(options: UnitOptions = {}, cache: Record<string, any> = {}): Unit {
  const o = (options.__typename ? options : cache["Unit"] = {}) as Unit;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Unit";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("Unit");
  o.buildAddress = maybeNew("Address", options.buildAddress, cache, options.hasOwnProperty("buildAddress"));
  o.market = maybeNew("Market", options.market, cache, options.hasOwnProperty("market"));
  o.parent = maybeNew("Structure", options.parent, cache, options.hasOwnProperty("parent"));
  o.collaborators = (options.collaborators ?? []).map((i) =>
    maybeNew("ProjectCollaborator", i, cache, options.hasOwnProperty("collaborators"))
  );
  o.coverImage = maybeNewOrNull("Asset", options.coverImage, cache);
  o.teamMembers = (options.teamMembers ?? []).map((i) =>
    maybeNew("ProjectTeamMember", i, cache, options.hasOwnProperty("teamMembers"))
  );
  o.projectLead = maybeNewOrNull("ProjectTeamMember", options.projectLead, cache);
  o.activeStage = enumOrDetailOfStage(options.activeStage);
  o.activeProjectStage = maybeNewOrNull("ProjectStage", options.activeProjectStage, cache);
  o.stages = (options.stages ?? []).map((i) => maybeNew("ProjectStage", i, cache, options.hasOwnProperty("stages")));
  o.stage = maybeNew("ProjectStage", options.stage, cache, options.hasOwnProperty("stage"));
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.hopUrl = options.hopUrl ?? "hopUrl";
  o.name = options.name ?? "name";
  o.availableAssignees = (options.availableAssignees ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableAssignees"))
  );
  o.startDate = options.startDate ?? newDate();
  o.features = options.features ?? [];
  o.isTest = options.isTest ?? false;
  o.status = enumOrDetailOfProjectStatus(options.status);
  o.latitude = options.latitude ?? null;
  o.longitude = options.longitude ?? null;
  o.project = maybeNewOrNull("Project", options.project, cache);
  o.googleDriveFolderId = options.googleDriveFolderId ?? null;
  o.salesforceAccountId = options.salesforceAccountId ?? null;
  o.salesforceOpportunities = (options.salesforceOpportunities ?? []).map((i) =>
    maybeNew("ProjectSalesforceOpportunity", i, cache, options.hasOwnProperty("salesforceOpportunities"))
  );
  o.projectStatusChange = maybeNewOrNull("ProjectStatusChange", options.projectStatusChange, cache);
  o.planRoomLink = options.planRoomLink ?? null;
  o.isDisaster = options.isDisaster ?? null;
  o.intakeStyleNotes = options.intakeStyleNotes ?? null;
  o.lotType = enumOrDetailOfLotType(options.lotType);
  o.communityType = enumOrDetailOrNullOfCommunityType(options.communityType);
  o.productType = maybeNewOrNull("ProductType", options.productType, cache);
  o.enableSchedulesV2 = options.enableSchedulesV2 ?? false;
  o.tradePartners = (options.tradePartners ?? []).map((i) =>
    maybeNew("TradePartner", i, cache, options.hasOwnProperty("tradePartners"))
  );
  o.cutoffs = (options.cutoffs ?? []).map((i) =>
    maybeNew("ProjectCutoff", i, cache, options.hasOwnProperty("cutoffs"))
  );
  o.jobLogs = (options.jobLogs ?? []).map((i) => maybeNew("JobLog", i, cache, options.hasOwnProperty("jobLogs")));
  o.salesforcePropertyId = options.salesforcePropertyId ?? null;
  o.schedules = (options.schedules ?? []).map((i) =>
    maybeNew("Schedule", i, cache, options.hasOwnProperty("schedules"))
  );
  o.expenses = (options.expenses ?? []).map((i) => maybeNew("Expense", i, cache, options.hasOwnProperty("expenses")));
  o.unallocatedExpenses = (options.unallocatedExpenses ?? []).map((i) =>
    maybeNew("Expense", i, cache, options.hasOwnProperty("unallocatedExpenses"))
  );
  o.unallocatedAmountInCents = options.unallocatedAmountInCents ?? 0;
  o.enableSchedulesV2Gantt = options.enableSchedulesV2Gantt ?? false;
  o.enableSchedulesCalendar = options.enableSchedulesCalendar ?? false;
  o.readyPlanConfig = maybeNewOrNull("ProjectReadyPlanConfig", options.readyPlanConfig, cache);
  o.earnedValueCurves = (options.earnedValueCurves ?? []).map((i) =>
    maybeNew("EarnedValueCurve", i, cache, options.hasOwnProperty("earnedValueCurves"))
  );
  o.enableInvoiceV2 = options.enableInvoiceV2 ?? false;
  o.invoiceSettings = maybeNewOrNull("ProjectInvoiceSetting", options.invoiceSettings, cache);
  o.scopeMode = enumOrDetailOfScopeMode(options.scopeMode);
  o.lotPartitionId = options.lotPartitionId ?? null;
  o.budgetFinancials = maybeNew(
    "ProjectBudgetFinancials",
    options.budgetFinancials,
    cache,
    options.hasOwnProperty("budgetFinancials"),
  );
  o.enableDelayFlags = options.enableDelayFlags ?? false;
  o.warrantyStartDate = options.warrantyStartDate ?? null;
  o.verticalCompleteDate = options.verticalCompleteDate ?? null;
  o.jobLogInsights = maybeNew(
    "ProjectJobLogInsights",
    options.jobLogInsights,
    cache,
    options.hasOwnProperty("jobLogInsights"),
  );
  o.targetEndDate = options.targetEndDate ?? null;
  o.latestActiveStage = maybeNewOrNull("ProjectStage", options.latestActiveStage, cache);
  o.primaryHomeowner = maybeNewOrNull("Client", options.primaryHomeowner, cache);
  o.toDos = (options.toDos ?? []).map((i) => maybeNew("ToDo", i, cache, options.hasOwnProperty("toDos")));
  o.lotDetail = maybeNew("ProjectLotDetail", options.lotDetail, cache, options.hasOwnProperty("lotDetail"));
  o.siteSpecificInfos = (options.siteSpecificInfos ?? []).map((i) =>
    maybeNew("ProjectSiteSpecificInfo", i, cache, options.hasOwnProperty("siteSpecificInfos"))
  );
  o.projectSiteCondition = maybeNewOrNull("ProjectSiteCondition", options.projectSiteCondition, cache);
  o.unassignedTaskCount = options.unassignedTaskCount ?? 0;
  o.enableHomeownerNotes = options.enableHomeownerNotes ?? false;
  o.checkoutCustomerConfigId = options.checkoutCustomerConfigId ?? null;
  o.canEditJobLogs = maybeNew(
    "PotentialOperation2",
    options.canEditJobLogs,
    cache,
    options.hasOwnProperty("canEditJobLogs"),
  );
  o.canEditPrice = maybeNew("PotentialOperation2", options.canEditPrice, cache, options.hasOwnProperty("canEditPrice"));
  o.canHaveBudget = maybeNew(
    "PotentialOperation2",
    options.canHaveBudget,
    cache,
    options.hasOwnProperty("canHaveBudget"),
  );
  o.homeownerNotes = (options.homeownerNotes ?? []).map((i) =>
    maybeNew("HomeownerNote", i, cache, options.hasOwnProperty("homeownerNotes"))
  );
  o.enableHomeownerJourneyV2 = options.enableHomeownerJourneyV2 ?? false;
  o.featureFlags = (options.featureFlags ?? []).map((i) =>
    maybeNew("FeatureFlag", i, cache, options.hasOwnProperty("featureFlags"))
  );
  o.homeownerDeliveryDate = options.homeownerDeliveryDate ?? null;
  o.tasksCompletedThisWeek = options.tasksCompletedThisWeek ?? 0;
  o.contacts = (options.contacts ?? []).map((i) =>
    maybeNew("ProjectContact", i, cache, options.hasOwnProperty("contacts"))
  );
  o.warrantyTickets = (options.warrantyTickets ?? []).map((i) =>
    maybeNew("WarrantyTicket", i, cache, options.hasOwnProperty("warrantyTickets"))
  );
  o.shouldAccrueAsComplete = options.shouldAccrueAsComplete ?? false;
  o.directCostMarkupOverrideBasisPoints = options.directCostMarkupOverrideBasisPoints ?? null;
  o.indirectCostMarkupOverrideBasisPoints = options.indirectCostMarkupOverrideBasisPoints ?? null;
  o.customer = maybeNewOrNull("Customer", options.customer, cache);
  o.customerOwnerEntity = maybeNewOrNull("CustomerOwnerEntity", options.customerOwnerEntity, cache);
  o.invoiceSchedule = maybeNewOrNull("InvoiceSchedule", options.invoiceSchedule, cache);
  o.allowExcludedCostCodesOnPurchaseOrders = options.allowExcludedCostCodesOnPurchaseOrders ?? false;
  o.enableProductConfigPlan = options.enableProductConfigPlan ?? false;
  o.planSchedule = maybeNewOrNull("PlanSchedule", options.planSchedule, cache);
  o.builder = maybeNewOrNull("Builder", options.builder, cache);
  o.bidOutPercentage = options.bidOutPercentage ?? 0;
  o.enableChangeEventSignatures = options.enableChangeEventSignatures ?? false;
  o.enablePocInvoiceSchedule = options.enablePocInvoiceSchedule ?? false;
  o.softCostMarkupInBasisPoints = options.softCostMarkupInBasisPoints ?? null;
  o.indirectHardCostMarkupInBasisPoints = options.indirectHardCostMarkupInBasisPoints ?? null;
  o.directHardCostMarkupInBasisPoints = options.directHardCostMarkupInBasisPoints ?? null;
  o.legalDescription = options.legalDescription ?? null;
  o.salesTaxOverrideInBasisPoints = options.salesTaxOverrideInBasisPoints ?? null;
  o.salesTaxInBasisPoints = options.salesTaxInBasisPoints ?? 0;
  o.projectItemAllocations = (options.projectItemAllocations ?? []).map((i) =>
    maybeNew("ProjectItemAllocation", i, cache, options.hasOwnProperty("projectItemAllocations"))
  );
  o.allocationRules = (options.allocationRules ?? []).map((i) =>
    maybeNew("ProjectAllocationRule", i, cache, options.hasOwnProperty("allocationRules"))
  );
  o.warrantyLengthInDays = options.warrantyLengthInDays ?? 0;
  o.warrantyOverrideLengthInDays = options.warrantyOverrideLengthInDays ?? null;
  o.bidPackages = (options.bidPackages ?? []).map((i) =>
    maybeNew("BidPackage", i, cache, options.hasOwnProperty("bidPackages"))
  );
  o.bidContracts = (options.bidContracts ?? []).map((i) =>
    maybeNew("BidContract", i, cache, options.hasOwnProperty("bidContracts"))
  );
  o.selectionsByLocation = (options.selectionsByLocation ?? []).map((i) =>
    maybeNew("HomeownerLocationSelection", i, cache, options.hasOwnProperty("selectionsByLocation"))
  );
  o.hasSelections = options.hasSelections ?? false;
  o.homeownerContracts = (options.homeownerContracts ?? []).map((i) =>
    maybeNew("HomeownerContract", i, cache, options.hasOwnProperty("homeownerContracts"))
  );
  o.documents = (options.documents ?? []).map((i) =>
    maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
  );
  o.commitments = (options.commitments ?? []).map((i) =>
    maybeNew("Commitment", i, cache, options.hasOwnProperty("commitments"))
  );
  o.directCostInCents = options.directCostInCents ?? 0;
  o.directPriceInCents = options.directPriceInCents ?? 0;
  o.totalHardCostInCents = options.totalHardCostInCents ?? 0;
  o.totalSoftCostInCents = options.totalSoftCostInCents ?? 0;
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.totalPriceInCents = options.totalPriceInCents ?? 0;
  o.readyToStartDate = options.readyToStartDate ?? null;
  o.committedCostCodesAtStartInBasisPoints = options.committedCostCodesAtStartInBasisPoints ?? null;
  o.directCostAtStartInCents = options.directCostAtStartInCents ?? null;
  o.directCostVarianceInCents = options.directCostVarianceInCents ?? null;
  o.uncommittedCostInCents = options.uncommittedCostInCents ?? 0;
  o.snapshots = (options.snapshots ?? []).map((i) =>
    maybeNew("ProjectSnapshot", i, cache, options.hasOwnProperty("snapshots"))
  );
  o.warrantyEndDate = options.warrantyEndDate ?? null;
  o.companyInfo = maybeNew("CompanyInfo", options.companyInfo, cache, options.hasOwnProperty("companyInfo"));
  o.invoicePaymentNetDays = options.invoicePaymentNetDays ?? 0;
  o.snapshotAsOf = maybeNewOrNull("ProjectSnapshot", options.snapshotAsOf, cache);
  o.purchaseCostInCents = options.purchaseCostInCents ?? null;
  o.grossSalesPriceInCents = options.grossSalesPriceInCents ?? null;
  o.closingCostsForDirectMarginInCents = options.closingCostsForDirectMarginInCents ?? null;
  o.directMarginInBasisPoints = options.directMarginInBasisPoints ?? null;
  o.projectCostCodes = (options.projectCostCodes ?? []).map((i) =>
    maybeNew("ProjectCostCode", i, cache, options.hasOwnProperty("projectCostCodes"))
  );
  o.children = (options.children ?? []).map((i) => maybeNew("Project", i, cache, options.hasOwnProperty("children")));
  o.parentsRecursive = (options.parentsRecursive ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("parentsRecursive"))
  );
  o.childrenRecursive = (options.childrenRecursive ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("childrenRecursive"))
  );
  o.siblingProjects = (options.siblingProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("siblingProjects"))
  );
  o.sellableProjects = (options.sellableProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("sellableProjects"))
  );
  o.isSellableProject = options.isSellableProject ?? false;
  o.originalCostInCents = options.originalCostInCents ?? 0;
  o.startCostInCents = options.startCostInCents ?? 0;
  o.changeEventCostInCents = options.changeEventCostInCents ?? 0;
  o.projectedCostInCents = options.projectedCostInCents ?? 0;
  o.revisedCostInCents = options.revisedCostInCents ?? 0;
  o.committedCostInCents = options.committedCostInCents ?? 0;
  o.availableCostInCents = options.availableCostInCents ?? 0;
  o.billedCostInCents = options.billedCostInCents ?? 0;
  o.unbilledCostInCents = options.unbilledCostInCents ?? 0;
  o.cohort = maybeNewOrNull("Cohort", options.cohort, cache);
  o.constructionConfidenceFactor = options.constructionConfidenceFactor ?? null;
  o.lotRating = maybeNewOrNull("LotRating", options.lotRating, cache);
  o.preConBudgetLineItems = (options.preConBudgetLineItems ?? []).map((i) =>
    maybeNew("PreConBudgetCostDivisionLineItem", i, cache, options.hasOwnProperty("preConBudgetLineItems"))
  );
  o.preconContractType = maybeNewOrNull("PreconContractType", options.preconContractType, cache);
  o.primaryProject = maybeNewOrNull("Project", options.primaryProject, cache);
  o.quickbooksCustomerId = options.quickbooksCustomerId ?? null;
  o.shadowProjects = (options.shadowProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("shadowProjects"))
  );
  o.submarket = maybeNewOrNull("Submarket", options.submarket, cache);
  o.client = maybeNewOrNull("Client", options.client, cache);
  o.url = options.url ?? "url";
  o.projectName = options.projectName ?? "projectName";
  o.salesforceId = options.salesforceId ?? null;
  o.activeSalesforceOpportunity = maybeNewOrNull(
    "ProjectSalesforceOpportunity",
    options.activeSalesforceOpportunity,
    cache,
  );
  o.dictionary = maybeNew("ProjectDictionary", options.dictionary, cache, options.hasOwnProperty("dictionary"));
  return o;
}

factories["Unit"] = newUnit;

export interface ProjectItemOptions {
  __typename?: "ProjectItem";
  references?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: ProjectItem["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: ProjectItem["isFollowed"];
  id?: ProjectItem["id"];
  projectStage?: ProjectStage | ProjectStageOptions;
  slot?: ItemSlot | ItemSlotOptions;
  item?: Item | ItemOptions;
  name?: ProjectItem["name"];
  description?: ProjectItem["description"];
  markupInCents?: ProjectItem["markupInCents"];
  priceInCents?: ProjectItem["priceInCents"];
  costInCents?: ProjectItem["costInCents"];
  unitCostInCents?: ProjectItem["unitCostInCents"];
  unitPriceInCents?: ProjectItem["unitPriceInCents"];
  totalCostInCents?: ProjectItem["totalCostInCents"];
  totalPriceInCents?: ProjectItem["totalPriceInCents"];
  totalMarkupInCents?: ProjectItem["totalMarkupInCents"];
  markupBasisPoints?: ProjectItem["markupBasisPoints"];
  projectMarkupBasisPoints?: ProjectItem["projectMarkupBasisPoints"];
  quantity?: ProjectItem["quantity"];
  location?: Location | LocationOptions;
  quantityCalculated?: ProjectItem["quantityCalculated"];
  isSelection?: ProjectItem["isSelection"];
  billedBills?: Array<Bill | BillOptions>;
  bills?: Array<Bill | BillOptions>;
  displayName?: ProjectItem["displayName"];
  billLineItems?: Array<BillLineItem | BillLineItemOptions>;
  commitmentLineItems?: Array<CommitmentLineItem | CommitmentLineItemOptions>;
  signedCommitmentLineItems?: Array<CommitmentLineItem | CommitmentLineItemOptions>;
  totalCommittedCostInCents?: ProjectItem["totalCommittedCostInCents"];
  allCommittedCostInCents?: ProjectItem["allCommittedCostInCents"];
  costType?: ProjectItem["costType"];
  costTypeDetail?: CostTypeDetailOptions | CostType;
  estimateLineItems?: Array<EstimateLineItem | EstimateLineItemOptions>;
  blueprintUrl?: Url | UrlOptions;
  unitOfMeasure?: UnitOfMeasure | UnitOfMeasureOptions;
  homeownerPaidInCents?: ProjectItem["homeownerPaidInCents"];
  tradePartnerNote?: ProjectItem["tradePartnerNote"];
  specifications?: ProjectItem["specifications"];
  history?: Array<History | HistoryOptions>;
  changeEventLineItems?: Array<ChangeEventLineItem | ChangeEventLineItemOptions>;
  homeownerSelection?: HomeownerSelection | HomeownerSelectionOptions | null;
  isPendingChangeEvent?: ProjectItem["isPendingChangeEvent"];
  internalNote?: ProjectItem["internalNote"];
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  costConfidence?: CostConfidenceDetailOptions | CostConfidence;
  buyoutStatus?: ProjectItem["buyoutStatus"];
  buyoutStatusDetail?: BuyoutStatusDetailOptions | BuyoutStatus;
  canEditCost?: PotentialOperation2 | PotentialOperation2Options;
  protoCommitmentLineItemToBuyout?: ProtoCommitmentLineItemToBuyout | ProtoCommitmentLineItemToBuyoutOptions | null;
  scopeHistory?: Array<ProjectItemScopeChange | ProjectItemScopeChangeOptions>;
  canEditScope?: PotentialOperation2 | PotentialOperation2Options;
  canEditName?: PotentialOperation2 | PotentialOperation2Options;
  canEditCostConfidence?: PotentialOperation2 | PotentialOperation2Options;
  canEditBuyoutStatus?: PotentialOperation2 | PotentialOperation2Options;
  itemTemplateItem?:
    | ItemTemplateItemVersion
    | ItemTemplateItem
    | TakeoffLineItem
    | TakeoffLineItemVersion
    | BaseItemLike
    | BaseItemLikeOptions
    | null;
  modifyingTemplateItems?: Array<
    | ItemTemplateItemVersion
    | ItemTemplateItem
    | TakeoffLineItem
    | TakeoffLineItemVersion
    | BaseItemLike
    | BaseItemLikeOptions
  >;
  task?: Task | TaskOptions | null;
  currentTradePartner?: TradePartner | TradePartnerOptions | null;
  currentCommitment?: Commitment | CommitmentChangeOrder | CommitmentLike | CommitmentLikeOptions | null;
  originalBudgetInCents?: ProjectItem["originalBudgetInCents"];
  originalPriceInCents?: ProjectItem["originalPriceInCents"];
  contractBudgetChangesInCents?: ProjectItem["contractBudgetChangesInCents"];
  budgetReallocationsInCents?: ProjectItem["budgetReallocationsInCents"];
  revisedApprovedBudgetInCents?: ProjectItem["revisedApprovedBudgetInCents"];
  uncommittedBudgetAmountInCents?: ProjectItem["uncommittedBudgetAmountInCents"];
  unbilledCommittedInCents?: ProjectItem["unbilledCommittedInCents"];
  actualCostInCents?: ProjectItem["actualCostInCents"];
  costToCompleteInCents?: ProjectItem["costToCompleteInCents"];
  homeownerContractLineItems?: Array<HomeownerContractLineItem | HomeownerContractLineItemOptions>;
  internalBudgetChangeInCents?: ProjectItem["internalBudgetChangeInCents"];
  bidContractLineItem?: BidContractLineItem | BidContractLineItemOptions | null;
  probableBidContractLineItem?: BidContractLineItem | BidContractLineItemOptions | null;
  potentialBidContractLineItems?: Array<PotentialBidContractLineItem | PotentialBidContractLineItemOptions>;
  preferredPotentialBidContractLineItem?: PotentialBidContractLineItem | PotentialBidContractLineItemOptions | null;
  isFromReadyHomeTemplate?: ProjectItem["isFromReadyHomeTemplate"];
  isRemovedScope?: ProjectItem["isRemovedScope"];
  expenseAllocations?: Array<ExpenseAllocation | ExpenseAllocationOptions>;
  budgetRollupInCents?: BudgetPhaseRollup | BudgetPhaseRollupOptions;
  prebidBudgetChangeInCents?: ProjectItem["prebidBudgetChangeInCents"];
  awardedBudgetChangeInCents?: ProjectItem["awardedBudgetChangeInCents"];
  revisedBudgetChangeInCents?: ProjectItem["revisedBudgetChangeInCents"];
  costLineItems?: Array<CostLineItem | CostLineItemOptions>;
  workAuthorizations?: Array<WorkAuthorization | WorkAuthorizationOptions>;
  bidItem?: BidItem | BidItemOptions | null;
  externalBudgetChangeInCents?: ProjectItem["externalBudgetChangeInCents"];
  budgetFinancials?: ProjectItemBudgetFinancials | ProjectItemBudgetFinancialsOptions;
  tradePartnerPaidInCents?: ProjectItem["tradePartnerPaidInCents"];
  tradeBilledInCents?: ProjectItem["tradeBilledInCents"];
  canAssignBidContractLineItem?: PotentialOperation2 | PotentialOperation2Options;
  product?: Product | ProductOptions | null;
  currentPriceInCents?: ProjectItem["currentPriceInCents"];
  allocationReason?: ProjectItem["allocationReason"];
  configuredOptions?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  baseOrOptionName?: ProjectItem["baseOrOptionName"];
  materialVariant?: MaterialVariant | MaterialVariantOptions | null;
  lastAcceptedChangeEventLineItem?: ChangeEventLineItem | ChangeEventLineItemOptions | null;
  allocations?: Array<ProjectItemAllocation | ProjectItemAllocationOptions>;
  directCostAtStartInCents?: ProjectItem["directCostAtStartInCents"];
  directCostVarianceInCents?: ProjectItem["directCostVarianceInCents"];
  projectCostCode?: ProjectCostCode | ProjectCostCodeOptions;
  originalCostInCents?: ProjectItem["originalCostInCents"];
  startCostInCents?: ProjectItem["startCostInCents"];
  changeEventCostInCents?: ProjectItem["changeEventCostInCents"];
  revisedCostInCents?: ProjectItem["revisedCostInCents"];
  revisedPriceInCents?: ProjectItem["revisedPriceInCents"];
  projectedCostInCents?: ProjectItem["projectedCostInCents"];
  committedCostInCents?: ProjectItem["committedCostInCents"];
  availableCostInCents?: ProjectItem["availableCostInCents"];
  billedCostInCents?: ProjectItem["billedCostInCents"];
  unbilledCostInCents?: ProjectItem["unbilledCostInCents"];
  bidTask?: GlobalPlanTask | GlobalPlanTaskOptions | null;
  packageDesignNotes?: ProjectItem["packageDesignNotes"];
}

export function newProjectItem(options: ProjectItemOptions = {}, cache: Record<string, any> = {}): ProjectItem {
  const o = (options.__typename ? options : cache["ProjectItem"] = {}) as ProjectItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectItem";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("ProjectItem");
  o.projectStage = maybeNew("ProjectStage", options.projectStage, cache, options.hasOwnProperty("projectStage"));
  o.slot = maybeNew("ItemSlot", options.slot, cache, options.hasOwnProperty("slot"));
  o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
  o.name = options.name ?? "name";
  o.description = options.description ?? null;
  o.markupInCents = options.markupInCents ?? 0;
  o.priceInCents = options.priceInCents ?? 0;
  o.costInCents = options.costInCents ?? 0;
  o.unitCostInCents = options.unitCostInCents ?? 0;
  o.unitPriceInCents = options.unitPriceInCents ?? 0;
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.totalPriceInCents = options.totalPriceInCents ?? 0;
  o.totalMarkupInCents = options.totalMarkupInCents ?? 0;
  o.markupBasisPoints = options.markupBasisPoints ?? null;
  o.projectMarkupBasisPoints = options.projectMarkupBasisPoints ?? 0;
  o.quantity = options.quantity ?? null;
  o.location = maybeNew("Location", options.location, cache, options.hasOwnProperty("location"));
  o.quantityCalculated = options.quantityCalculated ?? null;
  o.isSelection = options.isSelection ?? false;
  o.billedBills = (options.billedBills ?? []).map((i) =>
    maybeNew("Bill", i, cache, options.hasOwnProperty("billedBills"))
  );
  o.bills = (options.bills ?? []).map((i) => maybeNew("Bill", i, cache, options.hasOwnProperty("bills")));
  o.displayName = options.displayName ?? "displayName";
  o.billLineItems = (options.billLineItems ?? []).map((i) =>
    maybeNew("BillLineItem", i, cache, options.hasOwnProperty("billLineItems"))
  );
  o.commitmentLineItems = (options.commitmentLineItems ?? []).map((i) =>
    maybeNew("CommitmentLineItem", i, cache, options.hasOwnProperty("commitmentLineItems"))
  );
  o.signedCommitmentLineItems = (options.signedCommitmentLineItems ?? []).map((i) =>
    maybeNew("CommitmentLineItem", i, cache, options.hasOwnProperty("signedCommitmentLineItems"))
  );
  o.totalCommittedCostInCents = options.totalCommittedCostInCents ?? 0;
  o.allCommittedCostInCents = options.allCommittedCostInCents ?? 0;
  o.costType = options.costType ?? CostType.Labor;
  o.costTypeDetail = enumOrDetailOfCostType(options.costTypeDetail);
  o.estimateLineItems = (options.estimateLineItems ?? []).map((i) =>
    maybeNew("EstimateLineItem", i, cache, options.hasOwnProperty("estimateLineItems"))
  );
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.unitOfMeasure = maybeNew("UnitOfMeasure", options.unitOfMeasure, cache, options.hasOwnProperty("unitOfMeasure"));
  o.homeownerPaidInCents = options.homeownerPaidInCents ?? null;
  o.tradePartnerNote = options.tradePartnerNote ?? null;
  o.specifications = options.specifications ?? null;
  o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
  o.changeEventLineItems = (options.changeEventLineItems ?? []).map((i) =>
    maybeNew("ChangeEventLineItem", i, cache, options.hasOwnProperty("changeEventLineItems"))
  );
  o.homeownerSelection = maybeNewOrNull("HomeownerSelection", options.homeownerSelection, cache);
  o.isPendingChangeEvent = options.isPendingChangeEvent ?? false;
  o.internalNote = options.internalNote ?? null;
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.costConfidence = enumOrDetailOfCostConfidence(options.costConfidence);
  o.buyoutStatus = options.buyoutStatus ?? BuyoutStatus.NotBoughtOut;
  o.buyoutStatusDetail = enumOrDetailOfBuyoutStatus(options.buyoutStatusDetail);
  o.canEditCost = maybeNew("PotentialOperation2", options.canEditCost, cache, options.hasOwnProperty("canEditCost"));
  o.protoCommitmentLineItemToBuyout = maybeNewOrNull(
    "ProtoCommitmentLineItemToBuyout",
    options.protoCommitmentLineItemToBuyout,
    cache,
  );
  o.scopeHistory = (options.scopeHistory ?? []).map((i) =>
    maybeNew("ProjectItemScopeChange", i, cache, options.hasOwnProperty("scopeHistory"))
  );
  o.canEditScope = maybeNew("PotentialOperation2", options.canEditScope, cache, options.hasOwnProperty("canEditScope"));
  o.canEditName = maybeNew("PotentialOperation2", options.canEditName, cache, options.hasOwnProperty("canEditName"));
  o.canEditCostConfidence = maybeNew(
    "PotentialOperation2",
    options.canEditCostConfidence,
    cache,
    options.hasOwnProperty("canEditCostConfidence"),
  );
  o.canEditBuyoutStatus = maybeNew(
    "PotentialOperation2",
    options.canEditBuyoutStatus,
    cache,
    options.hasOwnProperty("canEditBuyoutStatus"),
  );
  o.itemTemplateItem = maybeNewOrNull("BaseItemLike", options.itemTemplateItem, cache);
  o.modifyingTemplateItems = (options.modifyingTemplateItems ?? []).map((i) =>
    maybeNew("BaseItemLike", i, cache, options.hasOwnProperty("modifyingTemplateItems"))
  );
  o.task = maybeNewOrNull("Task", options.task, cache);
  o.currentTradePartner = maybeNewOrNull("TradePartner", options.currentTradePartner, cache);
  o.currentCommitment = maybeNewOrNull("CommitmentLike", options.currentCommitment, cache);
  o.originalBudgetInCents = options.originalBudgetInCents ?? 0;
  o.originalPriceInCents = options.originalPriceInCents ?? 0;
  o.contractBudgetChangesInCents = options.contractBudgetChangesInCents ?? 0;
  o.budgetReallocationsInCents = options.budgetReallocationsInCents ?? 0;
  o.revisedApprovedBudgetInCents = options.revisedApprovedBudgetInCents ?? 0;
  o.uncommittedBudgetAmountInCents = options.uncommittedBudgetAmountInCents ?? 0;
  o.unbilledCommittedInCents = options.unbilledCommittedInCents ?? 0;
  o.actualCostInCents = options.actualCostInCents ?? 0;
  o.costToCompleteInCents = options.costToCompleteInCents ?? 0;
  o.homeownerContractLineItems = (options.homeownerContractLineItems ?? []).map((i) =>
    maybeNew("HomeownerContractLineItem", i, cache, options.hasOwnProperty("homeownerContractLineItems"))
  );
  o.internalBudgetChangeInCents = options.internalBudgetChangeInCents ?? 0;
  o.bidContractLineItem = maybeNewOrNull("BidContractLineItem", options.bidContractLineItem, cache);
  o.probableBidContractLineItem = maybeNewOrNull("BidContractLineItem", options.probableBidContractLineItem, cache);
  o.potentialBidContractLineItems = (options.potentialBidContractLineItems ?? []).map((i) =>
    maybeNew("PotentialBidContractLineItem", i, cache, options.hasOwnProperty("potentialBidContractLineItems"))
  );
  o.preferredPotentialBidContractLineItem = maybeNewOrNull(
    "PotentialBidContractLineItem",
    options.preferredPotentialBidContractLineItem,
    cache,
  );
  o.isFromReadyHomeTemplate = options.isFromReadyHomeTemplate ?? false;
  o.isRemovedScope = options.isRemovedScope ?? false;
  o.expenseAllocations = (options.expenseAllocations ?? []).map((i) =>
    maybeNew("ExpenseAllocation", i, cache, options.hasOwnProperty("expenseAllocations"))
  );
  o.budgetRollupInCents = maybeNew(
    "BudgetPhaseRollup",
    options.budgetRollupInCents,
    cache,
    options.hasOwnProperty("budgetRollupInCents"),
  );
  o.prebidBudgetChangeInCents = options.prebidBudgetChangeInCents ?? 0;
  o.awardedBudgetChangeInCents = options.awardedBudgetChangeInCents ?? 0;
  o.revisedBudgetChangeInCents = options.revisedBudgetChangeInCents ?? 0;
  o.costLineItems = (options.costLineItems ?? []).map((i) =>
    maybeNew("CostLineItem", i, cache, options.hasOwnProperty("costLineItems"))
  );
  o.workAuthorizations = (options.workAuthorizations ?? []).map((i) =>
    maybeNew("WorkAuthorization", i, cache, options.hasOwnProperty("workAuthorizations"))
  );
  o.bidItem = maybeNewOrNull("BidItem", options.bidItem, cache);
  o.externalBudgetChangeInCents = options.externalBudgetChangeInCents ?? 0;
  o.budgetFinancials = maybeNew(
    "ProjectItemBudgetFinancials",
    options.budgetFinancials,
    cache,
    options.hasOwnProperty("budgetFinancials"),
  );
  o.tradePartnerPaidInCents = options.tradePartnerPaidInCents ?? 0;
  o.tradeBilledInCents = options.tradeBilledInCents ?? 0;
  o.canAssignBidContractLineItem = maybeNew(
    "PotentialOperation2",
    options.canAssignBidContractLineItem,
    cache,
    options.hasOwnProperty("canAssignBidContractLineItem"),
  );
  o.product = maybeNewOrNull("Product", options.product, cache);
  o.currentPriceInCents = options.currentPriceInCents ?? 0;
  o.allocationReason = options.allocationReason ?? null;
  o.configuredOptions = (options.configuredOptions ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("configuredOptions"))
  );
  o.baseOrOptionName = options.baseOrOptionName ?? "baseOrOptionName";
  o.materialVariant = maybeNewOrNull("MaterialVariant", options.materialVariant, cache);
  o.lastAcceptedChangeEventLineItem = maybeNewOrNull(
    "ChangeEventLineItem",
    options.lastAcceptedChangeEventLineItem,
    cache,
  );
  o.allocations = (options.allocations ?? []).map((i) =>
    maybeNew("ProjectItemAllocation", i, cache, options.hasOwnProperty("allocations"))
  );
  o.directCostAtStartInCents = options.directCostAtStartInCents ?? null;
  o.directCostVarianceInCents = options.directCostVarianceInCents ?? null;
  o.projectCostCode = maybeNew(
    "ProjectCostCode",
    options.projectCostCode,
    cache,
    options.hasOwnProperty("projectCostCode"),
  );
  o.originalCostInCents = options.originalCostInCents ?? 0;
  o.startCostInCents = options.startCostInCents ?? 0;
  o.changeEventCostInCents = options.changeEventCostInCents ?? 0;
  o.revisedCostInCents = options.revisedCostInCents ?? 0;
  o.revisedPriceInCents = options.revisedPriceInCents ?? 0;
  o.projectedCostInCents = options.projectedCostInCents ?? 0;
  o.committedCostInCents = options.committedCostInCents ?? 0;
  o.availableCostInCents = options.availableCostInCents ?? 0;
  o.billedCostInCents = options.billedCostInCents ?? 0;
  o.unbilledCostInCents = options.unbilledCostInCents ?? 0;
  o.bidTask = maybeNewOrNull("GlobalPlanTask", options.bidTask, cache);
  o.packageDesignNotes = options.packageDesignNotes ?? null;
  return o;
}

factories["ProjectItem"] = newProjectItem;

export interface EstimateOptions {
  __typename?: "Estimate";
  references?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: Estimate["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: Estimate["isFollowed"];
  id?: Estimate["id"];
  name?: Estimate["name"];
  blueprintUrl?: Url | UrlOptions;
  status?: EstimateStatusDetailOptions | EstimateStatus;
  type?: EstimateTypeDetailOptions | EstimateType;
  projectStage?: ProjectStage | ProjectStageOptions;
  lineItems?: Array<EstimateLineItem | EstimateLineItemOptions>;
  title?: Estimate["title"];
  description?: Estimate["description"];
  createdAt?: Estimate["createdAt"];
  updatedAt?: Estimate["updatedAt"];
  totalCostInCents?: Estimate["totalCostInCents"];
  totalMarkupInCents?: Estimate["totalMarkupInCents"];
  totalPriceInCents?: Estimate["totalPriceInCents"];
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  changeEvent?: ChangeEvent | ChangeEventOptions | null;
  history?: Array<History | HistoryOptions>;
  homeownerContractChangeOrder?: HomeownerContractChangeOrder | HomeownerContractChangeOrderOptions | null;
  canEditStatus?: PotentialOperation2 | PotentialOperation2Options;
  softCostInCents?: Estimate["softCostInCents"];
  hardCostInCents?: Estimate["hardCostInCents"];
  directHardCostInCents?: Estimate["directHardCostInCents"];
  indirectHardCostInCents?: Estimate["indirectHardCostInCents"];
  annotatedCosts?: Array<AnnotatedCost | AnnotatedCostOptions>;
}

export function newEstimate(options: EstimateOptions = {}, cache: Record<string, any> = {}): Estimate {
  const o = (options.__typename ? options : cache["Estimate"] = {}) as Estimate;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Estimate";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("Estimate");
  o.name = options.name ?? "name";
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.status = enumOrDetailOfEstimateStatus(options.status);
  o.type = enumOrDetailOfEstimateType(options.type);
  o.projectStage = maybeNew("ProjectStage", options.projectStage, cache, options.hasOwnProperty("projectStage"));
  o.lineItems = (options.lineItems ?? []).map((i) =>
    maybeNew("EstimateLineItem", i, cache, options.hasOwnProperty("lineItems"))
  );
  o.title = options.title ?? "title";
  o.description = options.description ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.totalMarkupInCents = options.totalMarkupInCents ?? 0;
  o.totalPriceInCents = options.totalPriceInCents ?? 0;
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.changeEvent = maybeNewOrNull("ChangeEvent", options.changeEvent, cache);
  o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
  o.homeownerContractChangeOrder = maybeNewOrNull(
    "HomeownerContractChangeOrder",
    options.homeownerContractChangeOrder,
    cache,
  );
  o.canEditStatus = maybeNew(
    "PotentialOperation2",
    options.canEditStatus,
    cache,
    options.hasOwnProperty("canEditStatus"),
  );
  o.softCostInCents = options.softCostInCents ?? 0;
  o.hardCostInCents = options.hardCostInCents ?? 0;
  o.directHardCostInCents = options.directHardCostInCents ?? 0;
  o.indirectHardCostInCents = options.indirectHardCostInCents ?? 0;
  o.annotatedCosts = (options.annotatedCosts ?? []).map((i) =>
    maybeNew("AnnotatedCost", i, cache, options.hasOwnProperty("annotatedCosts"))
  );
  return o;
}

factories["Estimate"] = newEstimate;

export interface DevelopmentCommitmentOptions {
  __typename?: "DevelopmentCommitment";
  references?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: DevelopmentCommitment["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: DevelopmentCommitment["isFollowed"];
  id?: DevelopmentCommitment["id"];
  tradePartner?: TradePartner | TradePartnerOptions | null;
  projects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  commitments?: Array<Commitment | CommitmentOptions>;
  tradeCategories?: Array<TradeCategory | TradeCategoryOptions>;
  market?: Market | MarketOptions;
  status?: DevelopmentCommitment["status"];
  statusDetail?: CommitmentStatusDetailOptions | CommitmentStatus;
  statusText?: DevelopmentCommitment["statusText"];
  type?: DevelopmentCommitment["type"];
  typeDetail?: DevelopmentCommitmentTypeDetailOptions | DevelopmentCommitmentType | null;
  name?: DevelopmentCommitment["name"];
  executionDate?: DevelopmentCommitment["executionDate"];
  createdAt?: DevelopmentCommitment["createdAt"];
  updatedAt?: DevelopmentCommitment["updatedAt"];
  releasedDate?: DevelopmentCommitment["releasedDate"];
  releasedAt?: DevelopmentCommitment["releasedAt"];
  contractExhibits?: DevelopmentCommitment["contractExhibits"];
  contractSchedule?: DevelopmentCommitment["contractSchedule"];
  contractTerms?: DevelopmentCommitment["contractTerms"];
  contractExclusions?: DevelopmentCommitment["contractExclusions"];
  committedInCents?: DevelopmentCommitment["committedInCents"];
  pandaDoc?: PandaDoc | PandaDocOptions | null;
  headOfConstruction?: InternalUser | InternalUserOptions | null;
  homeboundAuthorizedSignatory?: InternalUser | InternalUserOptions | null;
  conOpsProjectManager?: InternalUser | InternalUserOptions | null;
  areaManager?: InternalUser | InternalUserOptions | null;
  canCreatePandaDoc?: PotentialOperation2 | PotentialOperation2Options;
  history?: Array<History | HistoryOptions>;
  summary?: DevelopmentCommitmentSummary | DevelopmentCommitmentSummaryOptions;
  blueprintUrl?: Url | UrlOptions;
  stage?: DevelopmentCommitment["stage"];
  stageDetail?: StageDetailOptions | Stage;
  costTypes?: Array<CostTypeDetail | CostTypeDetailOptions> | null;
  internalNote?: DevelopmentCommitment["internalNote"];
  costCodes?: Array<CostCode | CostCodeOptions>;
  costCodeSummary?: Array<DevelopmentCommitmentCostCodeSummary | DevelopmentCommitmentCostCodeSummaryOptions>;
  canBeEdited?: DevelopmentCommitment["canBeEdited"];
  development?: Development | DevelopmentOptions;
  document?: Document | DocumentOptions | null;
  signatoryContact?: TradePartnerContact | TradePartnerContactOptions | null;
}

export function newDevelopmentCommitment(
  options: DevelopmentCommitmentOptions = {},
  cache: Record<string, any> = {},
): DevelopmentCommitment {
  const o = (options.__typename ? options : cache["DevelopmentCommitment"] = {}) as DevelopmentCommitment;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DevelopmentCommitment";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("DevelopmentCommitment");
  o.tradePartner = maybeNewOrNull("TradePartner", options.tradePartner, cache);
  o.projects = (options.projects ?? []).map((i) => maybeNew("Project", i, cache, options.hasOwnProperty("projects")));
  o.commitments = (options.commitments ?? []).map((i) =>
    maybeNew("Commitment", i, cache, options.hasOwnProperty("commitments"))
  );
  o.tradeCategories = (options.tradeCategories ?? []).map((i) =>
    maybeNew("TradeCategory", i, cache, options.hasOwnProperty("tradeCategories"))
  );
  o.market = maybeNew("Market", options.market, cache, options.hasOwnProperty("market"));
  o.status = options.status ?? CommitmentStatus.Draft;
  o.statusDetail = enumOrDetailOfCommitmentStatus(options.statusDetail);
  o.statusText = options.statusText ?? "statusText";
  o.type = options.type ?? null;
  o.typeDetail = enumOrDetailOrNullOfDevelopmentCommitmentType(options.typeDetail);
  o.name = options.name ?? "name";
  o.executionDate = options.executionDate ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.releasedDate = options.releasedDate ?? null;
  o.releasedAt = options.releasedAt ?? null;
  o.contractExhibits = options.contractExhibits ?? null;
  o.contractSchedule = options.contractSchedule ?? null;
  o.contractTerms = options.contractTerms ?? null;
  o.contractExclusions = options.contractExclusions ?? null;
  o.committedInCents = options.committedInCents ?? 0;
  o.pandaDoc = maybeNewOrNull("PandaDoc", options.pandaDoc, cache);
  o.headOfConstruction = maybeNewOrNull("InternalUser", options.headOfConstruction, cache);
  o.homeboundAuthorizedSignatory = maybeNewOrNull("InternalUser", options.homeboundAuthorizedSignatory, cache);
  o.conOpsProjectManager = maybeNewOrNull("InternalUser", options.conOpsProjectManager, cache);
  o.areaManager = maybeNewOrNull("InternalUser", options.areaManager, cache);
  o.canCreatePandaDoc = maybeNew(
    "PotentialOperation2",
    options.canCreatePandaDoc,
    cache,
    options.hasOwnProperty("canCreatePandaDoc"),
  );
  o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
  o.summary = maybeNew("DevelopmentCommitmentSummary", options.summary, cache, options.hasOwnProperty("summary"));
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.stage = options.stage ?? Stage.PreConPlanning;
  o.stageDetail = enumOrDetailOfStage(options.stageDetail);
  o.costTypes = (options.costTypes ?? []).map((i) => enumOrDetailOfCostType(i));
  o.internalNote = options.internalNote ?? null;
  o.costCodes = (options.costCodes ?? []).map((i) =>
    maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
  );
  o.costCodeSummary = (options.costCodeSummary ?? []).map((i) =>
    maybeNew("DevelopmentCommitmentCostCodeSummary", i, cache, options.hasOwnProperty("costCodeSummary"))
  );
  o.canBeEdited = options.canBeEdited ?? false;
  o.development = maybeNew("Development", options.development, cache, options.hasOwnProperty("development"));
  o.document = maybeNewOrNull("Document", options.document, cache);
  o.signatoryContact = maybeNewOrNull("TradePartnerContact", options.signatoryContact, cache);
  return o;
}

factories["DevelopmentCommitment"] = newDevelopmentCommitment;

export interface CommitmentOptions {
  __typename?: "Commitment";
  references?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: Commitment["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: Commitment["isFollowed"];
  id?: Commitment["id"];
  accountingNumber?: Commitment["accountingNumber"];
  name?: Commitment["name"];
  displayName?: Commitment["displayName"];
  shortName?: Commitment["shortName"];
  commitmentType?: CommitmentTypeDetailOptions | CommitmentType;
  projectStage?: ProjectStage | ProjectStageOptions;
  tradePartner?: TradePartner | TradePartnerOptions | null;
  internalNote?: Commitment["internalNote"];
  costChangeInCents?: Commitment["costChangeInCents"];
  executionDate?: Commitment["executionDate"];
  createdAt?: Commitment["createdAt"];
  document?: Document | DocumentOptions | null;
  pandaDoc?: PandaDoc | PandaDocOptions | null;
  canCreatePandaDoc?: PotentialOperation2 | PotentialOperation2Options;
  changeOrders?: Array<CommitmentChangeOrder | CommitmentChangeOrderOptions>;
  lineItems?: Array<CommitmentLineItem | CommitmentLineItemOptions>;
  bills?: Array<Bill | BillOptions>;
  expenseAllocations?: Array<ExpenseAllocation | ExpenseAllocationOptions>;
  lineItemSummaries?: Array<CommitmentLineItemSummary | CommitmentLineItemSummaryOptions>;
  committedInCents?: Commitment["committedInCents"];
  taxableCostInCents?: Commitment["taxableCostInCents"];
  remainingInCents?: Commitment["remainingInCents"];
  pendingRemainingInCents?: Commitment["pendingRemainingInCents"];
  billedInCents?: Commitment["billedInCents"];
  pendingBilledInCents?: Commitment["pendingBilledInCents"];
  unbilledInCents?: Commitment["unbilledInCents"];
  paidInCents?: Commitment["paidInCents"];
  balanceInCents?: Commitment["balanceInCents"];
  blueprintUrl?: Url | UrlOptions;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  protoCommitmentLineItemsToBuyout?: Array<ProtoCommitmentLineItemToBuyout | ProtoCommitmentLineItemToBuyoutOptions>;
  hasPartiallyBoughtOutScope?: Commitment["hasPartiallyBoughtOutScope"];
  status?: Commitment["status"];
  statusDetail?: CommitmentStatusDetailOptions | CommitmentStatus;
  statusText?: Commitment["statusText"];
  developmentCommitment?: DevelopmentCommitment | DevelopmentCommitmentOptions | null;
  contractExhibits?: Commitment["contractExhibits"];
  contractSchedule?: Commitment["contractSchedule"];
  contractTerms?: Commitment["contractTerms"];
  contractExclusions?: Commitment["contractExclusions"];
  updatedAt?: Commitment["updatedAt"];
  tradeCategories?: Array<TradeCategory | TradeCategoryOptions>;
  costTypes?: Array<CostTypeDetail | CostTypeDetailOptions>;
  costCodeSummary?: CommitmentCostCodeSummary | CommitmentCostCodeSummaryOptions;
  changeEvent?: ChangeEvent | ChangeEventOptions | null;
  canEditLineItems?: PotentialOperation2 | PotentialOperation2Options;
  canBeReleased?: PotentialOperation2 | PotentialOperation2Options;
  isBidCommitment?: Commitment["isBidCommitment"];
  bidContractRevision?: BidContractRevision | BidContractRevisionOptions | null;
  canBeVoided?: PotentialOperation2 | PotentialOperation2Options;
  canDelete?: PotentialOperation2 | PotentialOperation2Options;
  canBeEdited?: Commitment["canBeEdited"];
  costCodes?: Array<CostCode | CostCodeOptions>;
  items?: Array<Item | ItemOptions>;
  potentialBidContractRevisions?: Array<PotentialBidContractRevision | PotentialBidContractRevisionOptions>;
  pandaDocRecipients?: Array<PandaDocIntendedRecipient | PandaDocIntendedRecipientOptions>;
  preferredBidContractRevision?: PotentialBidContractRevision | PotentialBidContractRevisionOptions | null;
  history?: Array<History | HistoryOptions> | null;
  tradeSignatory?: TradePartnerContact | TradePartnerContactOptions | null;
  readyPlanConfigOptions?: Array<ProjectReadyPlanConfigOption | ProjectReadyPlanConfigOptionOptions> | null;
  percentagePaid?: Commitment["percentagePaid"];
  releaseWhenReady?: Commitment["releaseWhenReady"];
  eventuallyVoidedBy?: Commitment | CommitmentOptions | null;
  voidsCommitments?: Array<Commitment | CommitmentOptions>;
  sentDate?: Commitment["sentDate"];
  depositInBasisPoints?: Commitment["depositInBasisPoints"];
  depositScheduleTask?: Task | TaskOptions | null;
  depositBill?: Bill | BillOptions | null;
  referenceNumber?: Commitment["referenceNumber"];
  drop?: Drop | DropOptions | null;
  draws?: Array<CommitmentDraw | CommitmentDrawOptions>;
  billingSchedule?: Array<CommitmentBillingScheduleItem | CommitmentBillingScheduleItemOptions>;
}

export function newCommitment(options: CommitmentOptions = {}, cache: Record<string, any> = {}): Commitment {
  const o = (options.__typename ? options : cache["Commitment"] = {}) as Commitment;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Commitment";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("Commitment");
  o.accountingNumber = options.accountingNumber ?? 0;
  o.name = options.name ?? "name";
  o.displayName = options.displayName ?? "displayName";
  o.shortName = options.shortName ?? "shortName";
  o.commitmentType = enumOrDetailOfCommitmentType(options.commitmentType);
  o.projectStage = maybeNew("ProjectStage", options.projectStage, cache, options.hasOwnProperty("projectStage"));
  o.tradePartner = maybeNewOrNull("TradePartner", options.tradePartner, cache);
  o.internalNote = options.internalNote ?? null;
  o.costChangeInCents = options.costChangeInCents ?? 0;
  o.executionDate = options.executionDate ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.document = maybeNewOrNull("Document", options.document, cache);
  o.pandaDoc = maybeNewOrNull("PandaDoc", options.pandaDoc, cache);
  o.canCreatePandaDoc = maybeNew(
    "PotentialOperation2",
    options.canCreatePandaDoc,
    cache,
    options.hasOwnProperty("canCreatePandaDoc"),
  );
  o.changeOrders = (options.changeOrders ?? []).map((i) =>
    maybeNew("CommitmentChangeOrder", i, cache, options.hasOwnProperty("changeOrders"))
  );
  o.lineItems = (options.lineItems ?? []).map((i) =>
    maybeNew("CommitmentLineItem", i, cache, options.hasOwnProperty("lineItems"))
  );
  o.bills = (options.bills ?? []).map((i) => maybeNew("Bill", i, cache, options.hasOwnProperty("bills")));
  o.expenseAllocations = (options.expenseAllocations ?? []).map((i) =>
    maybeNew("ExpenseAllocation", i, cache, options.hasOwnProperty("expenseAllocations"))
  );
  o.lineItemSummaries = (options.lineItemSummaries ?? []).map((i) =>
    maybeNew("CommitmentLineItemSummary", i, cache, options.hasOwnProperty("lineItemSummaries"))
  );
  o.committedInCents = options.committedInCents ?? 0;
  o.taxableCostInCents = options.taxableCostInCents ?? 0;
  o.remainingInCents = options.remainingInCents ?? 0;
  o.pendingRemainingInCents = options.pendingRemainingInCents ?? 0;
  o.billedInCents = options.billedInCents ?? null;
  o.pendingBilledInCents = options.pendingBilledInCents ?? null;
  o.unbilledInCents = options.unbilledInCents ?? 0;
  o.paidInCents = options.paidInCents ?? null;
  o.balanceInCents = options.balanceInCents ?? null;
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.protoCommitmentLineItemsToBuyout = (options.protoCommitmentLineItemsToBuyout ?? []).map((i) =>
    maybeNew("ProtoCommitmentLineItemToBuyout", i, cache, options.hasOwnProperty("protoCommitmentLineItemsToBuyout"))
  );
  o.hasPartiallyBoughtOutScope = options.hasPartiallyBoughtOutScope ?? false;
  o.status = options.status ?? CommitmentStatus.Draft;
  o.statusDetail = enumOrDetailOfCommitmentStatus(options.statusDetail);
  o.statusText = options.statusText ?? "statusText";
  o.developmentCommitment = maybeNewOrNull("DevelopmentCommitment", options.developmentCommitment, cache);
  o.contractExhibits = options.contractExhibits ?? null;
  o.contractSchedule = options.contractSchedule ?? null;
  o.contractTerms = options.contractTerms ?? null;
  o.contractExclusions = options.contractExclusions ?? null;
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.tradeCategories = (options.tradeCategories ?? []).map((i) =>
    maybeNew("TradeCategory", i, cache, options.hasOwnProperty("tradeCategories"))
  );
  o.costTypes = (options.costTypes ?? []).map((i) => enumOrDetailOfCostType(i));
  o.costCodeSummary = maybeNew(
    "CommitmentCostCodeSummary",
    options.costCodeSummary,
    cache,
    options.hasOwnProperty("costCodeSummary"),
  );
  o.changeEvent = maybeNewOrNull("ChangeEvent", options.changeEvent, cache);
  o.canEditLineItems = maybeNew(
    "PotentialOperation2",
    options.canEditLineItems,
    cache,
    options.hasOwnProperty("canEditLineItems"),
  );
  o.canBeReleased = maybeNew(
    "PotentialOperation2",
    options.canBeReleased,
    cache,
    options.hasOwnProperty("canBeReleased"),
  );
  o.isBidCommitment = options.isBidCommitment ?? false;
  o.bidContractRevision = maybeNewOrNull("BidContractRevision", options.bidContractRevision, cache);
  o.canBeVoided = maybeNew("PotentialOperation2", options.canBeVoided, cache, options.hasOwnProperty("canBeVoided"));
  o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
  o.canBeEdited = options.canBeEdited ?? false;
  o.costCodes = (options.costCodes ?? []).map((i) =>
    maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
  );
  o.items = (options.items ?? []).map((i) => maybeNew("Item", i, cache, options.hasOwnProperty("items")));
  o.potentialBidContractRevisions = (options.potentialBidContractRevisions ?? []).map((i) =>
    maybeNew("PotentialBidContractRevision", i, cache, options.hasOwnProperty("potentialBidContractRevisions"))
  );
  o.pandaDocRecipients = (options.pandaDocRecipients ?? []).map((i) =>
    maybeNew("PandaDocIntendedRecipient", i, cache, options.hasOwnProperty("pandaDocRecipients"))
  );
  o.preferredBidContractRevision = maybeNewOrNull(
    "PotentialBidContractRevision",
    options.preferredBidContractRevision,
    cache,
  );
  o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
  o.tradeSignatory = maybeNewOrNull("TradePartnerContact", options.tradeSignatory, cache);
  o.readyPlanConfigOptions = (options.readyPlanConfigOptions ?? []).map((i) =>
    maybeNew("ProjectReadyPlanConfigOption", i, cache, options.hasOwnProperty("readyPlanConfigOptions"))
  );
  o.percentagePaid = options.percentagePaid ?? 0;
  o.releaseWhenReady = options.releaseWhenReady ?? null;
  o.eventuallyVoidedBy = maybeNewOrNull("Commitment", options.eventuallyVoidedBy, cache);
  o.voidsCommitments = (options.voidsCommitments ?? []).map((i) =>
    maybeNew("Commitment", i, cache, options.hasOwnProperty("voidsCommitments"))
  );
  o.sentDate = options.sentDate ?? null;
  o.depositInBasisPoints = options.depositInBasisPoints ?? null;
  o.depositScheduleTask = maybeNewOrNull("Task", options.depositScheduleTask, cache);
  o.depositBill = maybeNewOrNull("Bill", options.depositBill, cache);
  o.referenceNumber = options.referenceNumber ?? null;
  o.drop = maybeNewOrNull("Drop", options.drop, cache);
  o.draws = (options.draws ?? []).map((i) => maybeNew("CommitmentDraw", i, cache, options.hasOwnProperty("draws")));
  o.billingSchedule = (options.billingSchedule ?? []).map((i) =>
    maybeNew("CommitmentBillingScheduleItem", i, cache, options.hasOwnProperty("billingSchedule"))
  );
  return o;
}

factories["Commitment"] = newCommitment;

export interface DocumentOptions {
  __typename?: "Document";
  references?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: Document["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: Document["isFollowed"];
  id?: Document["id"];
  documentType?: DocumentTypeDetailOptions | DocumentType;
  name?: Document["name"];
  sizeInBytes?: Document["sizeInBytes"];
  url?: Document["url"];
  displayName?: Document["displayName"];
  homeownerVisible?: Document["homeownerVisible"];
  asset?: Asset | AssetOptions;
  createdAt?: Document["createdAt"];
  updatedAt?: Document["updatedAt"];
  createdBy?: User | UserOptions;
  pandaDoc?: PandaDoc | PandaDocOptions | null;
  assets?: Array<Asset | AssetOptions>;
  canDelete?: PotentialOperation2 | PotentialOperation2Options;
  isDeleted?: Document["isDeleted"];
  parent?:
    | DocumentParent
    | DevelopmentOptions
    | RequireTypename<PlanPackageOptions>
    | RequireTypename<StandaloneProjectOptions>
    | RequireTypename<RegionOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>;
  category?: Document["category"];
  categoryDetail?: DocumentCategoryDetailOptions | DocumentCategory | null;
  tasks?: Array<Task | TaskOptions>;
  isFavorited?: Document["isFavorited"];
  blueprintUrl?: Url | UrlOptions;
  issuanceDate?: Document["issuanceDate"];
  ownerWorkAuthorization?: WorkAuthorization | WorkAuthorizationOptions | null;
  associatedProjects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  owner?:
    | DocumentOwner
    | HomeownerContractOptions
    | RequireTypename<HomeownerContractChangeOrderOptions>
    | RequireTypename<CommitmentOptions>
    | RequireTypename<CommitmentChangeOrderOptions>
    | RequireTypename<DevelopmentCommitmentOptions>
    | RequireTypename<InvoiceDocumentOptions>
    | RequireTypename<DevelopmentOptions>
    | RequireTypename<PlanPackageOptions>
    | RequireTypename<StandaloneProjectOptions>
    | RequireTypename<RegionOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>
    | RequireTypename<BidContractRevisionOptions>
    | RequireTypename<LienWaiverOptions>
    | RequireTypename<ChangeEventOptions>
    | null;
  homeownerContract?: HomeownerContract | HomeownerContractOptions | null;
  homeownerContractChangeOrder?: HomeownerContractChangeOrder | HomeownerContractChangeOrderOptions | null;
  attachOn?: Document["attachOn"];
  lienWaiver?: LienWaiver | LienWaiverOptions | null;
  active?: Document["active"];
  canEdit?: PotentialOperation2 | PotentialOperation2Options;
  canArchive?: PotentialOperation2 | PotentialOperation2Options;
}

export function newDocument(options: DocumentOptions = {}, cache: Record<string, any> = {}): Document {
  const o = (options.__typename ? options : cache["Document"] = {}) as Document;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Document";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("Document");
  o.documentType = enumOrDetailOfDocumentType(options.documentType);
  o.name = options.name ?? "name";
  o.sizeInBytes = options.sizeInBytes ?? 0;
  o.url = options.url ?? "url";
  o.displayName = options.displayName ?? "displayName";
  o.homeownerVisible = options.homeownerVisible ?? false;
  o.asset = maybeNew("Asset", options.asset, cache, options.hasOwnProperty("asset"));
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.createdBy = maybeNew("User", options.createdBy, cache, options.hasOwnProperty("createdBy"));
  o.pandaDoc = maybeNewOrNull("PandaDoc", options.pandaDoc, cache);
  o.assets = (options.assets ?? []).map((i) => maybeNew("Asset", i, cache, options.hasOwnProperty("assets")));
  o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
  o.isDeleted = options.isDeleted ?? null;
  o.parent = maybeNew(options.parent?.__typename ?? "Development", options.parent, cache);
  o.category = options.category ?? DocumentCategory.Contractual;
  o.categoryDetail = enumOrDetailOrNullOfDocumentCategory(options.categoryDetail);
  o.tasks = (options.tasks ?? []).map((i) => maybeNew("Task", i, cache, options.hasOwnProperty("tasks")));
  o.isFavorited = options.isFavorited ?? false;
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.issuanceDate = options.issuanceDate ?? null;
  o.ownerWorkAuthorization = maybeNewOrNull("WorkAuthorization", options.ownerWorkAuthorization, cache);
  o.associatedProjects = (options.associatedProjects ?? []).map((i) =>
    maybeNew("Project", i, cache, options.hasOwnProperty("associatedProjects"))
  );
  o.owner = maybeNewOrNull(options.owner?.__typename ?? "HomeownerContract", options.owner, cache);
  o.homeownerContract = maybeNewOrNull("HomeownerContract", options.homeownerContract, cache);
  o.homeownerContractChangeOrder = maybeNewOrNull(
    "HomeownerContractChangeOrder",
    options.homeownerContractChangeOrder,
    cache,
  );
  o.attachOn = options.attachOn ?? [];
  o.lienWaiver = maybeNewOrNull("LienWaiver", options.lienWaiver, cache);
  o.active = options.active ?? false;
  o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
  o.canArchive = maybeNew("PotentialOperation2", options.canArchive, cache, options.hasOwnProperty("canArchive"));
  return o;
}

factories["Document"] = newDocument;

export interface ProductOptions {
  __typename?: "Product";
  references?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: Product["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: Product["isFollowed"];
  id?: Product["id"];
  createdAt?: Product["createdAt"];
  updatedAt?: Product["updatedAt"];
  custom?: Product["custom"];
  name?: Product["name"];
  items?: Array<Item | ItemOptions>;
  description?: Product["description"];
  upc?: Product["upc"];
  sku?: Product["sku"];
  manufacturerUrl?: Product["manufacturerUrl"];
  costInCents?: Product["costInCents"];
  msrpInCents?: Product["msrpInCents"];
  priceInCents?: Product["priceInCents"];
  priceLastUpdatedAt?: Product["priceLastUpdatedAt"];
  priceLastUpdated?: Product["priceLastUpdated"];
  variantOfProduct?: Product | ProductOptions | null;
  variants?: Array<Product | ProductOptions> | null;
  attributes?: Array<ProductAttribute | ProductAttributeOptions>;
  dimensions?: Array<ProductDimension | ProductDimensionOptions>;
  images?: Array<Asset | AssetOptions>;
  airtableId?: Product["airtableId"];
  airtableData?: Product["airtableData"];
  status?: ProductStatusDetailOptions | ProductStatus;
  unitOfMeasure?: UnitOfMeasure | UnitOfMeasureOptions;
  internalNote?: Product["internalNote"];
  promotionStatus?: PromotionStatusDetailOptions | PromotionStatus | null;
  specifications?: Product["specifications"];
  blueprintUrl?: Url | UrlOptions;
  history?: Array<History | HistoryOptions>;
  bidItems?: Array<BidItem | BidItemOptions>;
  attachments?: Array<Attachment | AttachmentOptions>;
}

export function newProduct(options: ProductOptions = {}, cache: Record<string, any> = {}): Product {
  const o = (options.__typename ? options : cache["Product"] = {}) as Product;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Product";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("Product");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? null;
  o.custom = options.custom ?? false;
  o.name = options.name ?? "name";
  o.items = (options.items ?? []).map((i) => maybeNew("Item", i, cache, options.hasOwnProperty("items")));
  o.description = options.description ?? null;
  o.upc = options.upc ?? null;
  o.sku = options.sku ?? null;
  o.manufacturerUrl = options.manufacturerUrl ?? null;
  o.costInCents = options.costInCents ?? null;
  o.msrpInCents = options.msrpInCents ?? null;
  o.priceInCents = options.priceInCents ?? null;
  o.priceLastUpdatedAt = options.priceLastUpdatedAt ?? null;
  o.priceLastUpdated = options.priceLastUpdated ?? null;
  o.variantOfProduct = maybeNewOrNull("Product", options.variantOfProduct, cache);
  o.variants = (options.variants ?? []).map((i) => maybeNew("Product", i, cache, options.hasOwnProperty("variants")));
  o.attributes = (options.attributes ?? []).map((i) =>
    maybeNew("ProductAttribute", i, cache, options.hasOwnProperty("attributes"))
  );
  o.dimensions = (options.dimensions ?? []).map((i) =>
    maybeNew("ProductDimension", i, cache, options.hasOwnProperty("dimensions"))
  );
  o.images = (options.images ?? []).map((i) => maybeNew("Asset", i, cache, options.hasOwnProperty("images")));
  o.airtableId = options.airtableId ?? null;
  o.airtableData = options.airtableData ?? null;
  o.status = enumOrDetailOfProductStatus(options.status);
  o.unitOfMeasure = maybeNew("UnitOfMeasure", options.unitOfMeasure, cache, options.hasOwnProperty("unitOfMeasure"));
  o.internalNote = options.internalNote ?? null;
  o.promotionStatus = enumOrDetailOrNullOfPromotionStatus(options.promotionStatus);
  o.specifications = options.specifications ?? null;
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
  o.bidItems = (options.bidItems ?? []).map((i) => maybeNew("BidItem", i, cache, options.hasOwnProperty("bidItems")));
  o.attachments = (options.attachments ?? []).map((i) =>
    maybeNew("Attachment", i, cache, options.hasOwnProperty("attachments"))
  );
  return o;
}

factories["Product"] = newProduct;

export interface ItemTemplateItemVersionOptions {
  __typename?: "ItemTemplateItemVersion";
  references?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: ItemTemplateItemVersion["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: ItemTemplateItemVersion["isFollowed"];
  id?: ItemTemplateItemVersion["id"];
  identityId?: ItemTemplateItemVersion["identityId"];
  createdAt?: ItemTemplateItemVersion["createdAt"];
  updatedAt?: ItemTemplateItemVersion["updatedAt"];
  template?: ItemTemplate | ItemTemplateOptions;
  scope?: ItemTemplateItem | ItemTemplateItemOptions;
  scopeChangeType?: ItemTemplateItemVersion["scopeChangeType"];
  scopeChangeTypeDetail?: ScopeChangeTypeDetailOptions | ScopeChangeType;
  scopeChangeReason?: ScopeChangeReason | ScopeChangeReasonOptions | null;
  slot?: ItemSlot | ItemSlotOptions;
  item?: Item | ItemOptions;
  location?: Location | LocationOptions;
  quantity?: ItemTemplateItemVersion["quantity"];
  baseProduct?: Product | ProductOptions | null;
  costType?: ItemTemplateItemVersion["costType"];
  costTypeDetail?: CostTypeDetailOptions | CostType;
  isSelection?: ItemTemplateItemVersion["isSelection"];
  specifications?: ItemTemplateItemVersion["specifications"];
  unitOfMeasure?: UnitOfMeasure | UnitOfMeasureOptions;
  tradePartnerNote?: ItemTemplateItemVersion["tradePartnerNote"];
  internalNote?: ItemTemplateItemVersion["internalNote"];
  name?: ItemTemplateItemVersion["name"];
  displayName?: ItemTemplateItemVersion["displayName"];
  parent?: ItemTemplate | ItemTemplateOptions;
  readyPlan?: ReadyPlan | PlanPackage | DesignPackage | ProductOffering | ReadyPlanLike | ReadyPlanLikeOptions;
  first?: ItemTemplate | ItemTemplateOptions;
  basedOn?: ItemTemplateItem | ItemTemplateItemOptions | null;
  totalCostInCents?: ItemTemplateItemVersion["totalCostInCents"];
  unitCostInCents?: ItemTemplateItemVersion["unitCostInCents"];
  canDeleteItem?: PotentialOperation2 | PotentialOperation2Options;
  canEdit?: PotentialOperation2 | PotentialOperation2Options;
  preferredBidContractLineItem?: BidContractLineItem | BidContractLineItemOptions | null;
  bidItem?: BidItem | BidItemOptions | null;
  bidItemTemplateItem?: ItemTemplateItem | ItemTemplateItemOptions | null;
  potentialBidItems?: Array<BidItem | BidItemOptions>;
  elevationIds?: ItemTemplateItemVersion["elevationIds"];
  specOptionIds?: ItemTemplateItemVersion["specOptionIds"];
  otherOptionIds?: ItemTemplateItemVersion["otherOptionIds"];
  options?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  customPlaceholderName?: ItemTemplateItemVersion["customPlaceholderName"];
  blueprintUrl?: Url | UrlOptions;
  scopeChangeReasonNote?: ItemTemplateItemVersion["scopeChangeReasonNote"];
  task?: GlobalPlanTask | GlobalPlanTaskOptions | null;
  materialVariant?: MaterialVariant | MaterialVariantOptions | null;
  development?: Development | DevelopmentOptions | null;
  laborLine?: ItemTemplateItemVersion | ItemTemplateItemVersionOptions | null;
  costEstimate?: CostEstimate | CostEstimateOptions;
}

export function newItemTemplateItemVersion(
  options: ItemTemplateItemVersionOptions = {},
  cache: Record<string, any> = {},
): ItemTemplateItemVersion {
  const o = (options.__typename ? options : cache["ItemTemplateItemVersion"] = {}) as ItemTemplateItemVersion;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ItemTemplateItemVersion";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("ItemTemplateItemVersion");
  o.identityId = options.identityId ?? "identityId";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.template = maybeNew("ItemTemplate", options.template, cache, options.hasOwnProperty("template"));
  o.scope = maybeNew("ItemTemplateItem", options.scope, cache, options.hasOwnProperty("scope"));
  o.scopeChangeType = options.scopeChangeType ?? ScopeChangeType.None;
  o.scopeChangeTypeDetail = enumOrDetailOfScopeChangeType(options.scopeChangeTypeDetail);
  o.scopeChangeReason = maybeNewOrNull("ScopeChangeReason", options.scopeChangeReason, cache);
  o.slot = maybeNew("ItemSlot", options.slot, cache, options.hasOwnProperty("slot"));
  o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
  o.location = maybeNew("Location", options.location, cache, options.hasOwnProperty("location"));
  o.quantity = options.quantity ?? null;
  o.baseProduct = maybeNewOrNull("Product", options.baseProduct, cache);
  o.costType = options.costType ?? CostType.Labor;
  o.costTypeDetail = enumOrDetailOfCostType(options.costTypeDetail);
  o.isSelection = options.isSelection ?? false;
  o.specifications = options.specifications ?? null;
  o.unitOfMeasure = maybeNew("UnitOfMeasure", options.unitOfMeasure, cache, options.hasOwnProperty("unitOfMeasure"));
  o.tradePartnerNote = options.tradePartnerNote ?? null;
  o.internalNote = options.internalNote ?? null;
  o.name = options.name ?? "name";
  o.displayName = options.displayName ?? "displayName";
  o.parent = maybeNew("ItemTemplate", options.parent, cache, options.hasOwnProperty("parent"));
  o.readyPlan = maybeNew("ReadyPlanLike", options.readyPlan, cache, options.hasOwnProperty("readyPlan"));
  o.first = maybeNew("ItemTemplate", options.first, cache, options.hasOwnProperty("first"));
  o.basedOn = maybeNewOrNull("ItemTemplateItem", options.basedOn, cache);
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.unitCostInCents = options.unitCostInCents ?? 0;
  o.canDeleteItem = maybeNew(
    "PotentialOperation2",
    options.canDeleteItem,
    cache,
    options.hasOwnProperty("canDeleteItem"),
  );
  o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
  o.preferredBidContractLineItem = maybeNewOrNull("BidContractLineItem", options.preferredBidContractLineItem, cache);
  o.bidItem = maybeNewOrNull("BidItem", options.bidItem, cache);
  o.bidItemTemplateItem = maybeNewOrNull("ItemTemplateItem", options.bidItemTemplateItem, cache);
  o.potentialBidItems = (options.potentialBidItems ?? []).map((i) =>
    maybeNew("BidItem", i, cache, options.hasOwnProperty("potentialBidItems"))
  );
  o.elevationIds = options.elevationIds ?? [];
  o.specOptionIds = options.specOptionIds ?? [];
  o.otherOptionIds = options.otherOptionIds ?? [];
  o.options = (options.options ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("options"))
  );
  o.customPlaceholderName = options.customPlaceholderName ?? null;
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.scopeChangeReasonNote = options.scopeChangeReasonNote ?? null;
  o.task = maybeNewOrNull("GlobalPlanTask", options.task, cache);
  o.materialVariant = maybeNewOrNull("MaterialVariant", options.materialVariant, cache);
  o.development = maybeNewOrNull("Development", options.development, cache);
  o.laborLine = maybeNewOrNull("ItemTemplateItemVersion", options.laborLine, cache);
  o.costEstimate = maybeNew("CostEstimate", options.costEstimate, cache, options.hasOwnProperty("costEstimate"));
  return o;
}

factories["ItemTemplateItemVersion"] = newItemTemplateItemVersion;

export interface JobLogNoteOptions {
  __typename?: "JobLogNote";
  references?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: JobLogNote["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: JobLogNote["isFollowed"];
  id?: JobLogNote["id"];
  name?: JobLogNote["name"];
  blueprintUrl?: Url | UrlOptions;
  title?: JobLogNote["title"];
  content?: JobLogNote["content"];
  createdAt?: JobLogNote["createdAt"];
  updatedAt?: JobLogNote["updatedAt"];
  type?: JobLogNote["type"];
  typeDetail?: JobLogNoteTypeDetailOptions | JobLogNoteType | null;
  internalUser?: InternalUser | InternalUserOptions;
  jobLog?: JobLog | JobLogOptions;
  tradePartner?: TradePartner | TradePartnerOptions | null;
  jobLogImages?: Array<JobLogImage | JobLogImageOptions> | null;
  flags?: JobLogNote["flags"];
  scheduleTasks?: Array<ScheduleTask | ScheduleTaskOptions>;
  history?: Array<History | HistoryOptions>;
  clientPlatform?: ClientPlatformDetailOptions | ClientPlatform;
  additionalContext?: JobLogNote["additionalContext"];
}

export function newJobLogNote(options: JobLogNoteOptions = {}, cache: Record<string, any> = {}): JobLogNote {
  const o = (options.__typename ? options : cache["JobLogNote"] = {}) as JobLogNote;
  (cache.all ??= new Set()).add(o);
  o.__typename = "JobLogNote";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("JobLogNote");
  o.name = options.name ?? "name";
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.title = options.title ?? null;
  o.content = options.content ?? "content";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.type = options.type ?? null;
  o.typeDetail = enumOrDetailOrNullOfJobLogNoteType(options.typeDetail);
  o.internalUser = maybeNew("InternalUser", options.internalUser, cache, options.hasOwnProperty("internalUser"));
  o.jobLog = maybeNew("JobLog", options.jobLog, cache, options.hasOwnProperty("jobLog"));
  o.tradePartner = maybeNewOrNull("TradePartner", options.tradePartner, cache);
  o.jobLogImages = (options.jobLogImages ?? []).map((i) =>
    maybeNew("JobLogImage", i, cache, options.hasOwnProperty("jobLogImages"))
  );
  o.flags = options.flags ?? [];
  o.scheduleTasks = (options.scheduleTasks ?? []).map((i) =>
    maybeNew("ScheduleTask", i, cache, options.hasOwnProperty("scheduleTasks"))
  );
  o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
  o.clientPlatform = enumOrDetailOfClientPlatform(options.clientPlatform);
  o.additionalContext = options.additionalContext ?? null;
  return o;
}

factories["JobLogNote"] = newJobLogNote;

export interface TradePartnerAvailabilityRequestOptions {
  __typename?: "TradePartnerAvailabilityRequest";
  references?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: TradePartnerAvailabilityRequest["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: TradePartnerAvailabilityRequest["isFollowed"];
  id?: TradePartnerAvailabilityRequest["id"];
  name?: TradePartnerAvailabilityRequest["name"];
  blueprintUrl?: Url | UrlOptions;
  createdAt?: TradePartnerAvailabilityRequest["createdAt"];
  updatedAt?: TradePartnerAvailabilityRequest["updatedAt"];
  internalUser?: InternalUser | InternalUserOptions;
  task?: Task | TaskOptions;
  tradePartnerContacts?: Array<TradePartnerContact | TradePartnerContactOptions>;
  tradePartnerConfirmationDate?: TradePartnerAvailabilityRequest["tradePartnerConfirmationDate"];
  emails?: Array<TradePartnerAvailabilityRequestEmail | TradePartnerAvailabilityRequestEmailOptions>;
  textMessages?: Array<TradePartnerAvailabilityRequestTextMessage | TradePartnerAvailabilityRequestTextMessageOptions>;
  rescheduleDates?: TradePartnerAvailabilityRequest["rescheduleDates"] | null;
  status?: TradePartnerAvailabilityRequestStatusDetailOptions | TradePartnerAvailabilityRequestStatus;
  tradePartner?: TradePartner | TradePartnerOptions;
  canSave?: PotentialOperation2 | PotentialOperation2Options;
  rescheduleReasonNote?: TradePartnerAvailabilityRequest["rescheduleReasonNote"];
}

export function newTradePartnerAvailabilityRequest(
  options: TradePartnerAvailabilityRequestOptions = {},
  cache: Record<string, any> = {},
): TradePartnerAvailabilityRequest {
  const o =
    (options.__typename ? options : cache["TradePartnerAvailabilityRequest"] = {}) as TradePartnerAvailabilityRequest;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TradePartnerAvailabilityRequest";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("TradePartnerAvailabilityRequest");
  o.name = options.name ?? "name";
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.internalUser = maybeNew("InternalUser", options.internalUser, cache, options.hasOwnProperty("internalUser"));
  o.task = maybeNew("Task", options.task, cache, options.hasOwnProperty("task"));
  o.tradePartnerContacts = (options.tradePartnerContacts ?? []).map((i) =>
    maybeNew("TradePartnerContact", i, cache, options.hasOwnProperty("tradePartnerContacts"))
  );
  o.tradePartnerConfirmationDate = options.tradePartnerConfirmationDate ?? null;
  o.emails = (options.emails ?? []).map((i) =>
    maybeNew("TradePartnerAvailabilityRequestEmail", i, cache, options.hasOwnProperty("emails"))
  );
  o.textMessages = (options.textMessages ?? []).map((i) =>
    maybeNew("TradePartnerAvailabilityRequestTextMessage", i, cache, options.hasOwnProperty("textMessages"))
  );
  o.rescheduleDates = options.rescheduleDates ?? [];
  o.status = enumOrDetailOfTradePartnerAvailabilityRequestStatus(options.status);
  o.tradePartner = maybeNew("TradePartner", options.tradePartner, cache, options.hasOwnProperty("tradePartner"));
  o.canSave = maybeNew("PotentialOperation2", options.canSave, cache, options.hasOwnProperty("canSave"));
  o.rescheduleReasonNote = options.rescheduleReasonNote ?? null;
  return o;
}

factories["TradePartnerAvailabilityRequest"] = newTradePartnerAvailabilityRequest;

export interface PunchlistItemTodoOptions {
  __typename?: "PunchlistItemTodo";
  references?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: PunchlistItemTodo["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: PunchlistItemTodo["isFollowed"];
  id?: PunchlistItemTodo["id"];
  name?: PunchlistItemTodo["name"];
  description?: PunchlistItemTodo["description"];
  deletedAt?: PunchlistItemTodo["deletedAt"];
  createdAt?: PunchlistItemTodo["createdAt"];
  updatedAt?: PunchlistItemTodo["updatedAt"];
  dueDate?: PunchlistItemTodo["dueDate"];
  order?: PunchlistItemTodo["order"];
  urgent?: PunchlistItemTodo["urgent"];
  status?: ToDoStatusDetailOptions | ToDoStatus;
  type?: ToDoTypeDetailOptions | ToDoType;
  createdBy?: User | UserOptions;
  attachments?: Array<Attachment | AttachmentOptions>;
  assignees?: Array<User | UserOptions>;
  parent?:
    | ToDoParent
    | StandaloneProjectOptions
    | RequireTypename<RegionOptions>
    | RequireTypename<CohortOptions>
    | RequireTypename<DevelopmentOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>
    | null;
  location?: Location | LocationOptions | null;
  tradePartner?: TradePartner | TradePartnerOptions | null;
  blueprintUrl?: Url | UrlOptions;
}

export function newPunchlistItemTodo(
  options: PunchlistItemTodoOptions = {},
  cache: Record<string, any> = {},
): PunchlistItemTodo {
  const o = (options.__typename ? options : cache["PunchlistItemTodo"] = {}) as PunchlistItemTodo;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PunchlistItemTodo";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("PunchlistItemTodo");
  o.name = options.name ?? "name";
  o.description = options.description ?? null;
  o.deletedAt = options.deletedAt ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.dueDate = options.dueDate ?? null;
  o.order = options.order ?? "order";
  o.urgent = options.urgent ?? false;
  o.status = enumOrDetailOfToDoStatus(options.status);
  o.type = enumOrDetailOfToDoType(options.type);
  o.createdBy = maybeNew("User", options.createdBy, cache, options.hasOwnProperty("createdBy"));
  o.attachments = (options.attachments ?? []).map((i) =>
    maybeNew("Attachment", i, cache, options.hasOwnProperty("attachments"))
  );
  o.assignees = (options.assignees ?? []).map((i) => maybeNew("User", i, cache, options.hasOwnProperty("assignees")));
  o.parent = maybeNewOrNull(options.parent?.__typename ?? "StandaloneProject", options.parent, cache);
  o.location = maybeNewOrNull("Location", options.location, cache);
  o.tradePartner = maybeNewOrNull("TradePartner", options.tradePartner, cache);
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  return o;
}

factories["PunchlistItemTodo"] = newPunchlistItemTodo;

export interface WarrantyTicketOptions {
  __typename?: "WarrantyTicket";
  references?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: WarrantyTicket["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: WarrantyTicket["isFollowed"];
  id?: WarrantyTicket["id"];
  createdAt?: WarrantyTicket["createdAt"];
  updatedAt?: WarrantyTicket["updatedAt"];
  name?: WarrantyTicket["name"];
  type?: WarrantyTicketTypeDetailOptions | WarrantyTicketType | null;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  projectContacts?: Array<ProjectContact | ProjectContactOptions>;
  availabilities?: Array<WarrantyTicketAvailability | WarrantyTicketAvailabilityOptions>;
  items?: Array<WarrantyTicketItem | WarrantyTicketItemOptions>;
  title?: WarrantyTicket["title"];
  homeownerVisible?: WarrantyTicket["homeownerVisible"];
  blueprintUrl?: Url | UrlOptions;
  urgent?: WarrantyTicket["urgent"];
  history?: Array<History | HistoryOptions>;
  attachments?: Array<Attachment | AttachmentOptions>;
  totalItems?: WarrantyTicket["totalItems"];
  totalAvailableItems?: WarrantyTicket["totalAvailableItems"];
  totalCompletedItems?: WarrantyTicket["totalCompletedItems"];
  totalRejectedItems?: WarrantyTicket["totalRejectedItems"];
  status?: WarrantyTicketStatusDetailOptions | WarrantyTicketStatus;
  assignees?: Array<InternalUser | InternalUserOptions>;
}

export function newWarrantyTicket(
  options: WarrantyTicketOptions = {},
  cache: Record<string, any> = {},
): WarrantyTicket {
  const o = (options.__typename ? options : cache["WarrantyTicket"] = {}) as WarrantyTicket;
  (cache.all ??= new Set()).add(o);
  o.__typename = "WarrantyTicket";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("WarrantyTicket");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.name = options.name ?? "name";
  o.type = enumOrDetailOrNullOfWarrantyTicketType(options.type);
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.projectContacts = (options.projectContacts ?? []).map((i) =>
    maybeNew("ProjectContact", i, cache, options.hasOwnProperty("projectContacts"))
  );
  o.availabilities = (options.availabilities ?? []).map((i) =>
    maybeNew("WarrantyTicketAvailability", i, cache, options.hasOwnProperty("availabilities"))
  );
  o.items = (options.items ?? []).map((i) => maybeNew("WarrantyTicketItem", i, cache, options.hasOwnProperty("items")));
  o.title = options.title ?? "title";
  o.homeownerVisible = options.homeownerVisible ?? false;
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.urgent = options.urgent ?? false;
  o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
  o.attachments = (options.attachments ?? []).map((i) =>
    maybeNew("Attachment", i, cache, options.hasOwnProperty("attachments"))
  );
  o.totalItems = options.totalItems ?? 0;
  o.totalAvailableItems = options.totalAvailableItems ?? 0;
  o.totalCompletedItems = options.totalCompletedItems ?? 0;
  o.totalRejectedItems = options.totalRejectedItems ?? 0;
  o.status = enumOrDetailOfWarrantyTicketStatus(options.status);
  o.assignees = (options.assignees ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("assignees"))
  );
  return o;
}

factories["WarrantyTicket"] = newWarrantyTicket;

export interface HomeownerContractOptions {
  __typename?: "HomeownerContract";
  references?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: HomeownerContract["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: HomeownerContract["isFollowed"];
  id?: HomeownerContract["id"];
  projectStage?: ProjectStage | ProjectStageOptions;
  name?: HomeownerContract["name"];
  internalNote?: HomeownerContract["internalNote"];
  priceChangeInCents?: HomeownerContract["priceChangeInCents"];
  budgetChangeInCents?: HomeownerContract["budgetChangeInCents"];
  invoicedInCents?: HomeownerContract["invoicedInCents"];
  amountPaidInCents?: HomeownerContract["amountPaidInCents"];
  balanceInCents?: HomeownerContract["balanceInCents"];
  uninvoicedInCents?: HomeownerContract["uninvoicedInCents"];
  executionDate?: HomeownerContract["executionDate"];
  contractType?: HomeownerContract["contractType"];
  contractTypeDetail?: ContractTypeDetailOptions | ContractType;
  costPlusMarkupBasisPoints?: HomeownerContract["costPlusMarkupBasisPoints"];
  document?: Document | DocumentOptions | null;
  draws?: Array<HomeownerContractDraw | HomeownerContractDrawOptions>;
  changeOrders?: Array<HomeownerContractChangeOrder | HomeownerContractChangeOrderOptions>;
  lineItems?: Array<HomeownerContractLineItem | HomeownerContractLineItemOptions>;
  lineItemsByProjectItem?: Array<
    HomeownerContractLineItemsByProjectItem | HomeownerContractLineItemsByProjectItemOptions
  >;
  title?: HomeownerContract["title"];
  blueprintUrl?: Url | UrlOptions;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  softCostBudgetInCents?: HomeownerContract["softCostBudgetInCents"];
  directHardCostBudgetInCents?: HomeownerContract["directHardCostBudgetInCents"];
  indirectHardCostBudgetInCents?: HomeownerContract["indirectHardCostBudgetInCents"];
  totalMarkupInCents?: HomeownerContract["totalMarkupInCents"];
  annotatedCosts?: Array<AnnotatedCost | AnnotatedCostOptions>;
  projectFinancials?: Array<ContractProjectFinancials | ContractProjectFinancialsOptions>;
}

export function newHomeownerContract(
  options: HomeownerContractOptions = {},
  cache: Record<string, any> = {},
): HomeownerContract {
  const o = (options.__typename ? options : cache["HomeownerContract"] = {}) as HomeownerContract;
  (cache.all ??= new Set()).add(o);
  o.__typename = "HomeownerContract";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("HomeownerContract");
  o.projectStage = maybeNew("ProjectStage", options.projectStage, cache, options.hasOwnProperty("projectStage"));
  o.name = options.name ?? "name";
  o.internalNote = options.internalNote ?? null;
  o.priceChangeInCents = options.priceChangeInCents ?? 0;
  o.budgetChangeInCents = options.budgetChangeInCents ?? 0;
  o.invoicedInCents = options.invoicedInCents ?? null;
  o.amountPaidInCents = options.amountPaidInCents ?? null;
  o.balanceInCents = options.balanceInCents ?? null;
  o.uninvoicedInCents = options.uninvoicedInCents ?? null;
  o.executionDate = options.executionDate ?? null;
  o.contractType = options.contractType ?? ContractType.Fixed;
  o.contractTypeDetail = enumOrDetailOfContractType(options.contractTypeDetail);
  o.costPlusMarkupBasisPoints = options.costPlusMarkupBasisPoints ?? null;
  o.document = maybeNewOrNull("Document", options.document, cache);
  o.draws = (options.draws ?? []).map((i) =>
    maybeNew("HomeownerContractDraw", i, cache, options.hasOwnProperty("draws"))
  );
  o.changeOrders = (options.changeOrders ?? []).map((i) =>
    maybeNew("HomeownerContractChangeOrder", i, cache, options.hasOwnProperty("changeOrders"))
  );
  o.lineItems = (options.lineItems ?? []).map((i) =>
    maybeNew("HomeownerContractLineItem", i, cache, options.hasOwnProperty("lineItems"))
  );
  o.lineItemsByProjectItem = (options.lineItemsByProjectItem ?? []).map((i) =>
    maybeNew("HomeownerContractLineItemsByProjectItem", i, cache, options.hasOwnProperty("lineItemsByProjectItem"))
  );
  o.title = options.title ?? "title";
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.softCostBudgetInCents = options.softCostBudgetInCents ?? 0;
  o.directHardCostBudgetInCents = options.directHardCostBudgetInCents ?? 0;
  o.indirectHardCostBudgetInCents = options.indirectHardCostBudgetInCents ?? 0;
  o.totalMarkupInCents = options.totalMarkupInCents ?? 0;
  o.annotatedCosts = (options.annotatedCosts ?? []).map((i) =>
    maybeNew("AnnotatedCost", i, cache, options.hasOwnProperty("annotatedCosts"))
  );
  o.projectFinancials = (options.projectFinancials ?? []).map((i) =>
    maybeNew("ContractProjectFinancials", i, cache, options.hasOwnProperty("projectFinancials"))
  );
  return o;
}

factories["HomeownerContract"] = newHomeownerContract;

export interface HomeownerContractChangeOrderOptions {
  __typename?: "HomeownerContractChangeOrder";
  references?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: HomeownerContractChangeOrder["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: HomeownerContractChangeOrder["isFollowed"];
  id?: HomeownerContractChangeOrder["id"];
  contract?: HomeownerContract | HomeownerContractOptions;
  identifier?: HomeownerContractChangeOrder["identifier"];
  name?: HomeownerContractChangeOrder["name"];
  shortName?: HomeownerContractChangeOrder["shortName"];
  internalNote?: HomeownerContractChangeOrder["internalNote"];
  priceChangeInCents?: HomeownerContractChangeOrder["priceChangeInCents"];
  budgetChangeInCents?: HomeownerContractChangeOrder["budgetChangeInCents"];
  invoicedInCents?: HomeownerContractChangeOrder["invoicedInCents"];
  amountPaidInCents?: HomeownerContractChangeOrder["amountPaidInCents"];
  balanceInCents?: HomeownerContractChangeOrder["balanceInCents"];
  uninvoicedInCents?: HomeownerContractChangeOrder["uninvoicedInCents"];
  executionDate?: HomeownerContractChangeOrder["executionDate"];
  contractType?: HomeownerContractChangeOrder["contractType"];
  costPlusMarkupBasisPoints?: HomeownerContractChangeOrder["costPlusMarkupBasisPoints"];
  document?: Document | DocumentOptions | null;
  draws?: Array<HomeownerContractDraw | HomeownerContractDrawOptions>;
  lineItems?: Array<HomeownerContractLineItem | HomeownerContractLineItemOptions>;
  title?: HomeownerContractChangeOrder["title"];
  blueprintUrl?: Url | UrlOptions;
  changeEvent?: ChangeEvent | ChangeEventOptions | null;
  estimate?: Estimate | EstimateOptions | null;
  softCostBudgetInCents?: HomeownerContractChangeOrder["softCostBudgetInCents"];
  directHardCostBudgetInCents?: HomeownerContractChangeOrder["directHardCostBudgetInCents"];
  indirectHardCostBudgetInCents?: HomeownerContractChangeOrder["indirectHardCostBudgetInCents"];
  totalMarkupInCents?: HomeownerContractChangeOrder["totalMarkupInCents"];
  annotatedCosts?: Array<AnnotatedCost | AnnotatedCostOptions>;
  projectFinancials?: Array<ContractProjectFinancials | ContractProjectFinancialsOptions>;
  isContractAddendum?: HomeownerContractChangeOrder["isContractAddendum"];
}

export function newHomeownerContractChangeOrder(
  options: HomeownerContractChangeOrderOptions = {},
  cache: Record<string, any> = {},
): HomeownerContractChangeOrder {
  const o = (options.__typename ? options : cache["HomeownerContractChangeOrder"] = {}) as HomeownerContractChangeOrder;
  (cache.all ??= new Set()).add(o);
  o.__typename = "HomeownerContractChangeOrder";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("HomeownerContractChangeOrder");
  o.contract = maybeNew("HomeownerContract", options.contract, cache, options.hasOwnProperty("contract"));
  o.identifier = options.identifier ?? "identifier";
  o.name = options.name ?? "name";
  o.shortName = options.shortName ?? "shortName";
  o.internalNote = options.internalNote ?? null;
  o.priceChangeInCents = options.priceChangeInCents ?? 0;
  o.budgetChangeInCents = options.budgetChangeInCents ?? 0;
  o.invoicedInCents = options.invoicedInCents ?? null;
  o.amountPaidInCents = options.amountPaidInCents ?? null;
  o.balanceInCents = options.balanceInCents ?? null;
  o.uninvoicedInCents = options.uninvoicedInCents ?? null;
  o.executionDate = options.executionDate ?? null;
  o.contractType = options.contractType ?? ContractType.Fixed;
  o.costPlusMarkupBasisPoints = options.costPlusMarkupBasisPoints ?? null;
  o.document = maybeNewOrNull("Document", options.document, cache);
  o.draws = (options.draws ?? []).map((i) =>
    maybeNew("HomeownerContractDraw", i, cache, options.hasOwnProperty("draws"))
  );
  o.lineItems = (options.lineItems ?? []).map((i) =>
    maybeNew("HomeownerContractLineItem", i, cache, options.hasOwnProperty("lineItems"))
  );
  o.title = options.title ?? "title";
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.changeEvent = maybeNewOrNull("ChangeEvent", options.changeEvent, cache);
  o.estimate = maybeNewOrNull("Estimate", options.estimate, cache);
  o.softCostBudgetInCents = options.softCostBudgetInCents ?? 0;
  o.directHardCostBudgetInCents = options.directHardCostBudgetInCents ?? 0;
  o.indirectHardCostBudgetInCents = options.indirectHardCostBudgetInCents ?? 0;
  o.totalMarkupInCents = options.totalMarkupInCents ?? 0;
  o.annotatedCosts = (options.annotatedCosts ?? []).map((i) =>
    maybeNew("AnnotatedCost", i, cache, options.hasOwnProperty("annotatedCosts"))
  );
  o.projectFinancials = (options.projectFinancials ?? []).map((i) =>
    maybeNew("ContractProjectFinancials", i, cache, options.hasOwnProperty("projectFinancials"))
  );
  o.isContractAddendum = options.isContractAddendum ?? false;
  return o;
}

factories["HomeownerContractChangeOrder"] = newHomeownerContractChangeOrder;

export interface ReadyPlanOptions {
  __typename?: "ReadyPlan";
  references?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: ReadyPlan["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: ReadyPlan["isFollowed"];
  id?: ReadyPlan["id"];
  name?: ReadyPlan["name"];
  displayName?: ReadyPlan["displayName"];
  description?: ReadyPlan["description"];
  createdAt?: ReadyPlan["createdAt"];
  updatedAt?: ReadyPlan["updatedAt"];
  status?: ReadyPlanStatusDetailOptions | ReadyPlanStatus;
  effectiveStatus?: ReadyPlanStatusDetailOptions | ReadyPlanStatus;
  development?: Development | DevelopmentOptions | null;
  itemTemplates?: Array<ItemTemplate | ItemTemplateOptions>;
  options?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  hasOptions?: ReadyPlan["hasOptions"];
  code?: ReadyPlan["code"];
  activeOptionsCount?: ReadyPlan["activeOptionsCount"];
  type?: ReadyPlanTypeDetailOptions | ReadyPlanType | null;
  isValidForReadyPlanConfiguration?: ReadyPlan["isValidForReadyPlanConfiguration"];
  displayCode?: ReadyPlan["displayCode"];
  programData?: ProgramData | ProgramDataOptions;
  maxProgramData?: ProgramData | ProgramDataOptions;
  minProgramData?: ProgramData | ProgramDataOptions;
  optionGroups?: Array<ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions>;
  userEvents?: Array<UserEvent | UserEventOptions>;
  blueprintUrl?: Url | UrlOptions;
  underwritingTemplate?: ItemTemplate | ItemTemplateOptions | null;
  constructionDocumentCompletePercentage?: ReadyPlan["constructionDocumentCompletePercentage"];
  programDatas?: Array<ReadyPlanProgramData | ReadyPlanProgramDataOptions>;
  assets?: Array<ReadyPlanAsset | ReadyPlanAssetOptions>;
  lotTypes?: ReadyPlan["lotTypes"];
  aggregateActive?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  aggregateDraft?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  aggregateLatest?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  aggregateVersions?: Array<ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions>;
  version?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  itemLocations?: Array<Location | LocationOptions>;
  costCodes?: Array<CostCode | CostCodeOptions>;
  canCreateNewVersion?: PotentialOperation2 | PotentialOperation2Options;
  canEditLineItems?: PotentialOperation2 | PotentialOperation2Options;
  contingencyMarkupPercentage?: ReadyPlan["contingencyMarkupPercentage"];
  canEdit?: PotentialOperation2 | PotentialOperation2Options;
  documents?: Array<Document | DocumentOptions>;
  requiredOptions?: Array<ReadyPlanRequiredOption | ReadyPlanRequiredOptionOptions>;
  projectConfigs?: Array<ProjectReadyPlanConfig | ProjectReadyPlanConfigOptions>;
  owner?: InternalUser | InternalUserOptions | null;
  cloneInProgress?: ReadyPlan["cloneInProgress"];
}

export function newReadyPlan(options: ReadyPlanOptions = {}, cache: Record<string, any> = {}): ReadyPlan {
  const o = (options.__typename ? options : cache["ReadyPlan"] = {}) as ReadyPlan;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlan";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("ReadyPlan");
  o.name = options.name ?? "name";
  o.displayName = options.displayName ?? "displayName";
  o.description = options.description ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.status = enumOrDetailOfReadyPlanStatus(options.status);
  o.effectiveStatus = enumOrDetailOfReadyPlanStatus(options.effectiveStatus);
  o.development = maybeNewOrNull("Development", options.development, cache);
  o.itemTemplates = (options.itemTemplates ?? []).map((i) =>
    maybeNew("ItemTemplate", i, cache, options.hasOwnProperty("itemTemplates"))
  );
  o.options = (options.options ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("options"))
  );
  o.hasOptions = options.hasOptions ?? false;
  o.code = options.code ?? null;
  o.activeOptionsCount = options.activeOptionsCount ?? 0;
  o.type = enumOrDetailOrNullOfReadyPlanType(options.type);
  o.isValidForReadyPlanConfiguration = options.isValidForReadyPlanConfiguration ?? false;
  o.displayCode = options.displayCode ?? null;
  o.programData = maybeNew("ProgramData", options.programData, cache, options.hasOwnProperty("programData"));
  o.maxProgramData = maybeNew("ProgramData", options.maxProgramData, cache, options.hasOwnProperty("maxProgramData"));
  o.minProgramData = maybeNew("ProgramData", options.minProgramData, cache, options.hasOwnProperty("minProgramData"));
  o.optionGroups = (options.optionGroups ?? []).map((i) =>
    maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("optionGroups"))
  );
  o.userEvents = (options.userEvents ?? []).map((i) =>
    maybeNew("UserEvent", i, cache, options.hasOwnProperty("userEvents"))
  );
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.underwritingTemplate = maybeNewOrNull("ItemTemplate", options.underwritingTemplate, cache);
  o.constructionDocumentCompletePercentage = options.constructionDocumentCompletePercentage ?? 0;
  o.programDatas = (options.programDatas ?? []).map((i) =>
    maybeNew("ReadyPlanProgramData", i, cache, options.hasOwnProperty("programDatas"))
  );
  o.assets = (options.assets ?? []).map((i) => maybeNew("ReadyPlanAsset", i, cache, options.hasOwnProperty("assets")));
  o.lotTypes = options.lotTypes ?? [];
  o.aggregateActive = maybeNewOrNull("ReadyPlanAggregateVersion", options.aggregateActive, cache);
  o.aggregateDraft = maybeNewOrNull("ReadyPlanAggregateVersion", options.aggregateDraft, cache);
  o.aggregateLatest = maybeNew(
    "ReadyPlanAggregateVersion",
    options.aggregateLatest,
    cache,
    options.hasOwnProperty("aggregateLatest"),
  );
  o.aggregateVersions = (options.aggregateVersions ?? []).map((i) =>
    maybeNew("ReadyPlanAggregateVersion", i, cache, options.hasOwnProperty("aggregateVersions"))
  );
  o.version = maybeNew("ReadyPlanAggregateVersion", options.version, cache, options.hasOwnProperty("version"));
  o.itemLocations = (options.itemLocations ?? []).map((i) =>
    maybeNew("Location", i, cache, options.hasOwnProperty("itemLocations"))
  );
  o.costCodes = (options.costCodes ?? []).map((i) =>
    maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
  );
  o.canCreateNewVersion = maybeNew(
    "PotentialOperation2",
    options.canCreateNewVersion,
    cache,
    options.hasOwnProperty("canCreateNewVersion"),
  );
  o.canEditLineItems = maybeNew(
    "PotentialOperation2",
    options.canEditLineItems,
    cache,
    options.hasOwnProperty("canEditLineItems"),
  );
  o.contingencyMarkupPercentage = options.contingencyMarkupPercentage ?? null;
  o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
  o.documents = (options.documents ?? []).map((i) =>
    maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
  );
  o.requiredOptions = (options.requiredOptions ?? []).map((i) =>
    maybeNew("ReadyPlanRequiredOption", i, cache, options.hasOwnProperty("requiredOptions"))
  );
  o.projectConfigs = (options.projectConfigs ?? []).map((i) =>
    maybeNew("ProjectReadyPlanConfig", i, cache, options.hasOwnProperty("projectConfigs"))
  );
  o.owner = maybeNewOrNull("InternalUser", options.owner, cache);
  o.cloneInProgress = options.cloneInProgress ?? false;
  return o;
}

factories["ReadyPlan"] = newReadyPlan;

export interface PlanPackageOptions {
  __typename?: "PlanPackage";
  references?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: PlanPackage["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: PlanPackage["isFollowed"];
  id?: PlanPackage["id"];
  name?: PlanPackage["name"];
  displayName?: PlanPackage["displayName"];
  description?: PlanPackage["description"];
  createdAt?: PlanPackage["createdAt"];
  updatedAt?: PlanPackage["updatedAt"];
  type?: ReadyPlanTypeDetailOptions | ReadyPlanType;
  code?: PlanPackage["code"];
  displayCode?: PlanPackage["displayCode"];
  blueprintUrl?: Url | UrlOptions;
  constructionDocumentCompletePercentage?: PlanPackage["constructionDocumentCompletePercentage"];
  status?: ReadyPlanStatusDetailOptions | ReadyPlanStatus;
  effectiveStatus?: ReadyPlanStatusDetailOptions | ReadyPlanStatus;
  development?: Development | DevelopmentOptions | null;
  maxProgramData?: ProgramData | ProgramDataOptions;
  minProgramData?: ProgramData | ProgramDataOptions;
  programData?: ProgramData | ProgramDataOptions;
  itemTemplates?: Array<ItemTemplate | ItemTemplateOptions>;
  takeoff?: ItemTemplate | ItemTemplateOptions;
  projectConfigs?: Array<ProjectReadyPlanConfig | ProjectReadyPlanConfigOptions>;
  options?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  optionGroups?: Array<ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions>;
  productOfferings?: Array<ProductOffering | ProductOfferingOptions>;
  designPackages?: Array<DesignPackage | DesignPackageOptions>;
  designPackageSources?: Array<DesignPackageSource | DesignPackageSourceOptions>;
  lotTypes?: PlanPackage["lotTypes"] | null;
  programDatas?: Array<ReadyPlanProgramData | ReadyPlanProgramDataOptions>;
  assets?: Array<ReadyPlanAsset | ReadyPlanAssetOptions>;
  activeOptionsCount?: PlanPackage["activeOptionsCount"];
  projectCount?: PlanPackage["projectCount"];
  designPackageCount?: PlanPackage["designPackageCount"];
  productOfferingCount?: PlanPackage["productOfferingCount"];
  asGlobalOption?: GlobalOption | GlobalOptionOptions | null;
  markets?: Array<Market | MarketOptions>;
  aggregateActive?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  aggregateDraft?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  aggregateLatest?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  aggregateVersions?: Array<ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions>;
  version?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  itemLocations?: Array<Location | LocationOptions>;
  costCodes?: Array<CostCode | CostCodeOptions>;
  canEditLineItems?: PotentialOperation2 | PotentialOperation2Options;
  locations?: Array<Location | LocationOptions>;
  roomLocations?: Array<ReadyPlanLocation | ReadyPlanLocationOptions>;
  contingencyMarkupPercentage?: PlanPackage["contingencyMarkupPercentage"];
  canEdit?: PotentialOperation2 | PotentialOperation2Options;
  documents?: Array<Document | DocumentOptions>;
  insideMapsProjectId?: PlanPackage["insideMapsProjectId"];
  insideMapsConfig?: PlanPackage["insideMapsConfig"];
  requiredOptions?: Array<ReadyPlanRequiredOption | ReadyPlanRequiredOptionOptions>;
  owner?: InternalUser | InternalUserOptions | null;
  cloneInProgress?: PlanPackage["cloneInProgress"];
}

export function newPlanPackage(options: PlanPackageOptions = {}, cache: Record<string, any> = {}): PlanPackage {
  const o = (options.__typename ? options : cache["PlanPackage"] = {}) as PlanPackage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PlanPackage";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("PlanPackage");
  o.name = options.name ?? "name";
  o.displayName = options.displayName ?? "displayName";
  o.description = options.description ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.type = enumOrDetailOfReadyPlanType(options.type);
  o.code = options.code ?? null;
  o.displayCode = options.displayCode ?? null;
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.constructionDocumentCompletePercentage = options.constructionDocumentCompletePercentage ?? 0;
  o.status = enumOrDetailOfReadyPlanStatus(options.status);
  o.effectiveStatus = enumOrDetailOfReadyPlanStatus(options.effectiveStatus);
  o.development = maybeNewOrNull("Development", options.development, cache);
  o.maxProgramData = maybeNew("ProgramData", options.maxProgramData, cache, options.hasOwnProperty("maxProgramData"));
  o.minProgramData = maybeNew("ProgramData", options.minProgramData, cache, options.hasOwnProperty("minProgramData"));
  o.programData = maybeNew("ProgramData", options.programData, cache, options.hasOwnProperty("programData"));
  o.itemTemplates = (options.itemTemplates ?? []).map((i) =>
    maybeNew("ItemTemplate", i, cache, options.hasOwnProperty("itemTemplates"))
  );
  o.takeoff = maybeNew("ItemTemplate", options.takeoff, cache, options.hasOwnProperty("takeoff"));
  o.projectConfigs = (options.projectConfigs ?? []).map((i) =>
    maybeNew("ProjectReadyPlanConfig", i, cache, options.hasOwnProperty("projectConfigs"))
  );
  o.options = (options.options ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("options"))
  );
  o.optionGroups = (options.optionGroups ?? []).map((i) =>
    maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("optionGroups"))
  );
  o.productOfferings = (options.productOfferings ?? []).map((i) =>
    maybeNew("ProductOffering", i, cache, options.hasOwnProperty("productOfferings"))
  );
  o.designPackages = (options.designPackages ?? []).map((i) =>
    maybeNew("DesignPackage", i, cache, options.hasOwnProperty("designPackages"))
  );
  o.designPackageSources = (options.designPackageSources ?? []).map((i) =>
    maybeNew("DesignPackageSource", i, cache, options.hasOwnProperty("designPackageSources"))
  );
  o.lotTypes = options.lotTypes ?? [];
  o.programDatas = (options.programDatas ?? []).map((i) =>
    maybeNew("ReadyPlanProgramData", i, cache, options.hasOwnProperty("programDatas"))
  );
  o.assets = (options.assets ?? []).map((i) => maybeNew("ReadyPlanAsset", i, cache, options.hasOwnProperty("assets")));
  o.activeOptionsCount = options.activeOptionsCount ?? 0;
  o.projectCount = options.projectCount ?? 0;
  o.designPackageCount = options.designPackageCount ?? 0;
  o.productOfferingCount = options.productOfferingCount ?? 0;
  o.asGlobalOption = maybeNewOrNull("GlobalOption", options.asGlobalOption, cache);
  o.markets = (options.markets ?? []).map((i) => maybeNew("Market", i, cache, options.hasOwnProperty("markets")));
  o.aggregateActive = maybeNewOrNull("ReadyPlanAggregateVersion", options.aggregateActive, cache);
  o.aggregateDraft = maybeNewOrNull("ReadyPlanAggregateVersion", options.aggregateDraft, cache);
  o.aggregateLatest = maybeNew(
    "ReadyPlanAggregateVersion",
    options.aggregateLatest,
    cache,
    options.hasOwnProperty("aggregateLatest"),
  );
  o.aggregateVersions = (options.aggregateVersions ?? []).map((i) =>
    maybeNew("ReadyPlanAggregateVersion", i, cache, options.hasOwnProperty("aggregateVersions"))
  );
  o.version = maybeNew("ReadyPlanAggregateVersion", options.version, cache, options.hasOwnProperty("version"));
  o.itemLocations = (options.itemLocations ?? []).map((i) =>
    maybeNew("Location", i, cache, options.hasOwnProperty("itemLocations"))
  );
  o.costCodes = (options.costCodes ?? []).map((i) =>
    maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
  );
  o.canEditLineItems = maybeNew(
    "PotentialOperation2",
    options.canEditLineItems,
    cache,
    options.hasOwnProperty("canEditLineItems"),
  );
  o.locations = (options.locations ?? []).map((i) =>
    maybeNew("Location", i, cache, options.hasOwnProperty("locations"))
  );
  o.roomLocations = (options.roomLocations ?? []).map((i) =>
    maybeNew("ReadyPlanLocation", i, cache, options.hasOwnProperty("roomLocations"))
  );
  o.contingencyMarkupPercentage = options.contingencyMarkupPercentage ?? null;
  o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
  o.documents = (options.documents ?? []).map((i) =>
    maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
  );
  o.insideMapsProjectId = options.insideMapsProjectId ?? null;
  o.insideMapsConfig = options.insideMapsConfig ?? null;
  o.requiredOptions = (options.requiredOptions ?? []).map((i) =>
    maybeNew("ReadyPlanRequiredOption", i, cache, options.hasOwnProperty("requiredOptions"))
  );
  o.owner = maybeNewOrNull("InternalUser", options.owner, cache);
  o.cloneInProgress = options.cloneInProgress ?? false;
  return o;
}

factories["PlanPackage"] = newPlanPackage;

export interface GlobalOptionOptions {
  __typename?: "GlobalOption";
  references?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: GlobalOption["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: GlobalOption["isFollowed"];
  id?: GlobalOption["id"];
  group?: GlobalOptionGroup | GlobalOptionGroupOptions;
  readyPlanOptions?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  name?: GlobalOption["name"];
  displayName?: GlobalOption["displayName"];
  blueprintUrl?: Url | UrlOptions;
  description?: GlobalOption["description"];
  isPlanSpecific?: GlobalOption["isPlanSpecific"];
  standardDetailRequired?: GlobalOption["standardDetailRequired"];
  status?: GlobalOption["status"];
  statusDetail?: GlobalOptionStatusDetailOptions | GlobalOptionStatus;
  type?: GlobalOptionType | GlobalOptionTypeOptions;
  locations?: Array<Location | LocationOptions>;
  locationsInUse?: Array<Location | LocationOptions>;
  activeDate?: GlobalOption["activeDate"];
  archivedDate?: GlobalOption["archivedDate"];
  elevationRequired?: GlobalOption["elevationRequired"];
  requiredInPlanDrawing?: GlobalOption["requiredInPlanDrawing"];
  shopDrawingRequired?: GlobalOption["shopDrawingRequired"];
  tags?: Array<GlobalOptionTag | GlobalOptionTagOptions>;
  supportedTags?: Array<GlobalOptionTag | GlobalOptionTagOptions>;
  canEditType?: PotentialOperation2 | PotentialOperation2Options;
  canEditLocations?: PotentialOperation2 | PotentialOperation2Options;
  code?: GlobalOption["code"];
  designUpgradeIconName?: GlobalOption["designUpgradeIconName"];
  defaultOrder?: GlobalOption["defaultOrder"];
  lastUsedAt?: GlobalOption["lastUsedAt"];
  createdAt?: GlobalOption["createdAt"];
  updatedAt?: GlobalOption["updatedAt"];
  asset?: Asset | AssetOptions | null;
  estimatedLeadTimeInDays?: GlobalOption["estimatedLeadTimeInDays"];
  marketingDescription?: GlobalOption["marketingDescription"];
  permits?: GlobalOption["permits"];
  attachments?: Array<Attachment | AttachmentOptions>;
  materialVariant?: MaterialVariant | MaterialVariantOptions | null;
  optionPricingConfig?: OptionPricingConfig | OptionPricingConfigOptions | null;
  version?: GlobalOption["version"];
  history?: Array<History | HistoryOptions>;
  readyPlan?: ReadyPlan | ReadyPlanOptions | null;
}

export function newGlobalOption(options: GlobalOptionOptions = {}, cache: Record<string, any> = {}): GlobalOption {
  const o = (options.__typename ? options : cache["GlobalOption"] = {}) as GlobalOption;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalOption";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("GlobalOption");
  o.group = maybeNew("GlobalOptionGroup", options.group, cache, options.hasOwnProperty("group"));
  o.readyPlanOptions = (options.readyPlanOptions ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("readyPlanOptions"))
  );
  o.name = options.name ?? "name";
  o.displayName = options.displayName ?? "displayName";
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.description = options.description ?? null;
  o.isPlanSpecific = options.isPlanSpecific ?? null;
  o.standardDetailRequired = options.standardDetailRequired ?? null;
  o.status = options.status ?? GlobalOptionStatus.Active;
  o.statusDetail = enumOrDetailOfGlobalOptionStatus(options.statusDetail);
  o.type = maybeNew("GlobalOptionType", options.type, cache, options.hasOwnProperty("type"));
  o.locations = (options.locations ?? []).map((i) =>
    maybeNew("Location", i, cache, options.hasOwnProperty("locations"))
  );
  o.locationsInUse = (options.locationsInUse ?? []).map((i) =>
    maybeNew("Location", i, cache, options.hasOwnProperty("locationsInUse"))
  );
  o.activeDate = options.activeDate ?? null;
  o.archivedDate = options.archivedDate ?? null;
  o.elevationRequired = options.elevationRequired ?? null;
  o.requiredInPlanDrawing = options.requiredInPlanDrawing ?? null;
  o.shopDrawingRequired = options.shopDrawingRequired ?? null;
  o.tags = (options.tags ?? []).map((i) => maybeNew("GlobalOptionTag", i, cache, options.hasOwnProperty("tags")));
  o.supportedTags = (options.supportedTags ?? []).map((i) =>
    maybeNew("GlobalOptionTag", i, cache, options.hasOwnProperty("supportedTags"))
  );
  o.canEditType = maybeNew("PotentialOperation2", options.canEditType, cache, options.hasOwnProperty("canEditType"));
  o.canEditLocations = maybeNew(
    "PotentialOperation2",
    options.canEditLocations,
    cache,
    options.hasOwnProperty("canEditLocations"),
  );
  o.code = options.code ?? "code";
  o.designUpgradeIconName = options.designUpgradeIconName ?? null;
  o.defaultOrder = options.defaultOrder ?? null;
  o.lastUsedAt = options.lastUsedAt ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.asset = maybeNewOrNull("Asset", options.asset, cache);
  o.estimatedLeadTimeInDays = options.estimatedLeadTimeInDays ?? 0;
  o.marketingDescription = options.marketingDescription ?? null;
  o.permits = options.permits ?? [];
  o.attachments = (options.attachments ?? []).map((i) =>
    maybeNew("Attachment", i, cache, options.hasOwnProperty("attachments"))
  );
  o.materialVariant = maybeNewOrNull("MaterialVariant", options.materialVariant, cache);
  o.optionPricingConfig = maybeNewOrNull("OptionPricingConfig", options.optionPricingConfig, cache);
  o.version = options.version ?? 0;
  o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
  o.readyPlan = maybeNewOrNull("ReadyPlan", options.readyPlan, cache);
  return o;
}

factories["GlobalOption"] = newGlobalOption;

export interface ProjectCostCodeOptions {
  __typename?: "ProjectCostCode";
  references?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  referencedBy?: Array<
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions
  >;
  commentStreams?: CommentStreams | CommentStreamsOptions;
  streams?: Array<CommentStream | CommentStreamOptions>;
  supportedVisibilities?: ProjectCostCode["supportedVisibilities"];
  followers?: Array<InternalUser | InternalUserOptions>;
  availableFollowers?: Array<InternalUser | InternalUserOptions>;
  isFollowed?: ProjectCostCode["isFollowed"];
  id?: ProjectCostCode["id"];
  name?: ProjectCostCode["name"];
  blueprintUrl?: Url | UrlOptions;
  costCode?: CostCode | CostCodeOptions;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  projectItems?: Array<ProjectItem | ProjectItemOptions>;
  committedAtStartInCents?: ProjectCostCode["committedAtStartInCents"];
  originalCostInCents?: ProjectCostCode["originalCostInCents"];
  startCostInCents?: ProjectCostCode["startCostInCents"];
  changeEventCostInCents?: ProjectCostCode["changeEventCostInCents"];
  revisedCostInCents?: ProjectCostCode["revisedCostInCents"];
  projectedCostInCents?: ProjectCostCode["projectedCostInCents"];
  committedCostInCents?: ProjectCostCode["committedCostInCents"];
  availableCostInCents?: ProjectCostCode["availableCostInCents"];
  billedCostInCents?: ProjectCostCode["billedCostInCents"];
  unbilledCostInCents?: ProjectCostCode["unbilledCostInCents"];
}

export function newProjectCostCode(
  options: ProjectCostCodeOptions = {},
  cache: Record<string, any> = {},
): ProjectCostCode {
  const o = (options.__typename ? options : cache["ProjectCostCode"] = {}) as ProjectCostCode;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectCostCode";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("references"))
  );
  o.referencedBy = (options.referencedBy ?? []).map((i) =>
    maybeNew("Referencable", i, cache, options.hasOwnProperty("referencedBy"))
  );
  o.commentStreams = maybeNew(
    "CommentStreams",
    options.commentStreams,
    cache,
    options.hasOwnProperty("commentStreams"),
  );
  o.streams = (options.streams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("streams"))
  );
  o.supportedVisibilities = options.supportedVisibilities ?? [];
  o.followers = (options.followers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("followers"))
  );
  o.availableFollowers = (options.availableFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("availableFollowers"))
  );
  o.isFollowed = options.isFollowed ?? false;
  o.id = options.id ?? nextFactoryId("ProjectCostCode");
  o.name = options.name ?? "name";
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.costCode = maybeNew("CostCode", options.costCode, cache, options.hasOwnProperty("costCode"));
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.projectItems = (options.projectItems ?? []).map((i) =>
    maybeNew("ProjectItem", i, cache, options.hasOwnProperty("projectItems"))
  );
  o.committedAtStartInCents = options.committedAtStartInCents ?? 0;
  o.originalCostInCents = options.originalCostInCents ?? 0;
  o.startCostInCents = options.startCostInCents ?? 0;
  o.changeEventCostInCents = options.changeEventCostInCents ?? 0;
  o.revisedCostInCents = options.revisedCostInCents ?? 0;
  o.projectedCostInCents = options.projectedCostInCents ?? 0;
  o.committedCostInCents = options.committedCostInCents ?? 0;
  o.availableCostInCents = options.availableCostInCents ?? 0;
  o.billedCostInCents = options.billedCostInCents ?? 0;
  o.unbilledCostInCents = options.unbilledCostInCents ?? 0;
  return o;
}

factories["ProjectCostCode"] = newProjectCostCode;

export interface CommentOptions {
  __typename?: "Comment";
  id?: Comment["id"];
  html?: Comment["html"];
  text?: Comment["text"];
  createdAt?: Comment["createdAt"];
  updatedAt?: Comment["updatedAt"];
  stream?: CommentStream | CommentStreamOptions;
  author?: User | UserOptions;
  permissions?: Permissions | PermissionsOptions;
  attachments?: Array<Attachment | AttachmentOptions>;
  tags?: Array<CommentTag | CommentTagOptions>;
}

export function newComment(options: CommentOptions = {}, cache: Record<string, any> = {}): Comment {
  const o = (options.__typename ? options : cache["Comment"] = {}) as Comment;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Comment";
  o.id = options.id ?? nextFactoryId("Comment");
  o.html = options.html ?? "html";
  o.text = options.text ?? "text";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.stream = maybeNew("CommentStream", options.stream, cache, options.hasOwnProperty("stream"));
  o.author = maybeNew("User", options.author, cache, options.hasOwnProperty("author"));
  o.permissions = maybeNew("Permissions", options.permissions, cache, options.hasOwnProperty("permissions"));
  o.attachments = (options.attachments ?? []).map((i) =>
    maybeNew("Attachment", i, cache, options.hasOwnProperty("attachments"))
  );
  o.tags = (options.tags ?? []).map((i) => maybeNew("CommentTag", i, cache, options.hasOwnProperty("tags")));
  return o;
}

factories["Comment"] = newComment;

export interface SaveCommentResultOptions {
  __typename?: "SaveCommentResult";
  comment?: Comment | CommentOptions | null;
  userErrors?: Array<UserError | UserErrorOptions>;
}

export function newSaveCommentResult(
  options: SaveCommentResultOptions = {},
  cache: Record<string, any> = {},
): SaveCommentResult {
  const o = (options.__typename ? options : cache["SaveCommentResult"] = {}) as SaveCommentResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveCommentResult";
  o.comment = maybeNewOrNull("Comment", options.comment, cache);
  o.userErrors = (options.userErrors ?? []).map((i) =>
    maybeNew("UserError", i, cache, options.hasOwnProperty("userErrors"))
  );
  return o;
}

factories["SaveCommentResult"] = newSaveCommentResult;

export interface DeleteCommentResultOptions {
  __typename?: "DeleteCommentResult";
  stream?: CommentStream | CommentStreamOptions | null;
  userErrors?: Array<UserError | UserErrorOptions>;
}

export function newDeleteCommentResult(
  options: DeleteCommentResultOptions = {},
  cache: Record<string, any> = {},
): DeleteCommentResult {
  const o = (options.__typename ? options : cache["DeleteCommentResult"] = {}) as DeleteCommentResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeleteCommentResult";
  o.stream = maybeNewOrNull("CommentStream", options.stream, cache);
  o.userErrors = (options.userErrors ?? []).map((i) =>
    maybeNew("UserError", i, cache, options.hasOwnProperty("userErrors"))
  );
  return o;
}

factories["DeleteCommentResult"] = newDeleteCommentResult;

export interface CommentStreamOptions {
  __typename?: "CommentStream";
  id?: CommentStream["id"];
  streamVisibility?: CommentStreamVisibilityDetailOptions | CommentStreamVisibility;
  name?: CommentStream["name"];
  commentable?:
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Commentable
    | CommentableOptions;
  comments?: Array<Comment | CommentOptions>;
  latestComment?: Comment | CommentOptions | null;
  commentCount?: CommentStream["commentCount"];
  unreadCount?: CommentStream["unreadCount"];
  fromAddress?: CommentStream["fromAddress"];
  tradePartnerUsers?: Array<TradePartnerUser | TradePartnerUserOptions>;
}

export function newCommentStream(options: CommentStreamOptions = {}, cache: Record<string, any> = {}): CommentStream {
  const o = (options.__typename ? options : cache["CommentStream"] = {}) as CommentStream;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CommentStream";
  o.id = options.id ?? nextFactoryId("CommentStream");
  o.streamVisibility = enumOrDetailOfCommentStreamVisibility(options.streamVisibility);
  o.name = options.name ?? "name";
  o.commentable = maybeNew("Commentable", options.commentable, cache, options.hasOwnProperty("commentable"));
  o.comments = (options.comments ?? []).map((i) => maybeNew("Comment", i, cache, options.hasOwnProperty("comments")));
  o.latestComment = maybeNewOrNull("Comment", options.latestComment, cache);
  o.commentCount = options.commentCount ?? 0;
  o.unreadCount = options.unreadCount ?? 0;
  o.fromAddress = options.fromAddress ?? "fromAddress";
  o.tradePartnerUsers = (options.tradePartnerUsers ?? []).map((i) =>
    maybeNew("TradePartnerUser", i, cache, options.hasOwnProperty("tradePartnerUsers"))
  );
  return o;
}

factories["CommentStream"] = newCommentStream;

export interface CommentStreamsOptions {
  __typename?: "CommentStreams";
  internalStream?: CommentStream | CommentStreamOptions | null;
  tradesStream?: CommentStream | CommentStreamOptions | null;
  homeownerStream?: CommentStream | CommentStreamOptions | null;
  commentCount?: CommentStreams["commentCount"];
}

export function newCommentStreams(
  options: CommentStreamsOptions = {},
  cache: Record<string, any> = {},
): CommentStreams {
  const o = (options.__typename ? options : cache["CommentStreams"] = {}) as CommentStreams;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CommentStreams";
  o.internalStream = maybeNewOrNull("CommentStream", options.internalStream, cache);
  o.tradesStream = maybeNewOrNull("CommentStream", options.tradesStream, cache);
  o.homeownerStream = maybeNewOrNull("CommentStream", options.homeownerStream, cache);
  o.commentCount = options.commentCount ?? 0;
  return o;
}

factories["CommentStreams"] = newCommentStreams;

export interface UserRelevantCommentStreamsResultOptions {
  __typename?: "UserRelevantCommentStreamsResult";
  entities?: Array<CommentStream | CommentStreamOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newUserRelevantCommentStreamsResult(
  options: UserRelevantCommentStreamsResultOptions = {},
  cache: Record<string, any> = {},
): UserRelevantCommentStreamsResult {
  const o =
    (options.__typename ? options : cache["UserRelevantCommentStreamsResult"] = {}) as UserRelevantCommentStreamsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "UserRelevantCommentStreamsResult";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["UserRelevantCommentStreamsResult"] = newUserRelevantCommentStreamsResult;

export interface CommentTagOptions {
  __typename?: "CommentTag";
  id?: CommentTag["id"];
  createdAt?: CommentTag["createdAt"];
  updatedAt?: CommentTag["updatedAt"];
  comment?: Comment | CommentOptions;
  internalUser?: InternalUser | InternalUserOptions;
}

export function newCommentTag(options: CommentTagOptions = {}, cache: Record<string, any> = {}): CommentTag {
  const o = (options.__typename ? options : cache["CommentTag"] = {}) as CommentTag;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CommentTag";
  o.id = options.id ?? nextFactoryId("CommentTag");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.comment = maybeNew("Comment", options.comment, cache, options.hasOwnProperty("comment"));
  o.internalUser = maybeNew("InternalUser", options.internalUser, cache, options.hasOwnProperty("internalUser"));
  return o;
}

factories["CommentTag"] = newCommentTag;

export interface ProjectStageOptions {
  __typename?: "ProjectStage";
  commitments?: Array<Commitment | CommitmentOptions>;
  commitmentLikes?: Array<Commitment | CommitmentChangeOrder | CommitmentLike | CommitmentLikeOptions>;
  homeownerContracts?: Array<HomeownerContract | HomeownerContractOptions>;
  id?: ProjectStage["id"];
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  stage?: StageDetailOptions | Stage;
  hasSignedContract?: ProjectStage["hasSignedContract"];
  canEditProjectItemsDirectly?: ProjectStage["canEditProjectItemsDirectly"];
  canEditProjectScope?: PotentialOperation2 | PotentialOperation2Options;
  canCreateFinalEstimate?: ProjectStage["canCreateFinalEstimate"];
  canCompleteStage?: PotentialOperation2 | PotentialOperation2Options;
  canPublishSchedule?: PotentialOperation | PotentialOperationOptions;
  nextStage?: ProjectStage | ProjectStageOptions | null;
  previousStage?: ProjectStage | ProjectStageOptions | null;
  status?: ProjectStageStatusDetailOptions | ProjectStageStatus;
  interval?: CalendarInterval | CalendarIntervalOptions;
  baselineInterval?: CalendarInterval | CalendarIntervalOptions;
  schedulePhases?: Array<SchedulePhase | SchedulePhaseOptions>;
  bills?: Array<Bill | BillOptions>;
  priceInCents?: ProjectStage["priceInCents"];
  progress?: StageProgress | StageProgressOptions;
  cmsId?: ProjectStage["cmsId"];
  invoices?: Array<Invoice | InvoiceOptions>;
  homeownerFinancials?: ProjectStageHomeownerFinancials | ProjectStageHomeownerFinancialsOptions;
  estimates?: Array<Estimate | EstimateOptions>;
  hocFinancials?: ProjectStageHocFinancials | ProjectStageHocFinancialsOptions;
  projectItems?: Array<ProjectItem | ProjectItemOptions>;
  itemLocations?: Array<Location | LocationOptions>;
  costCodes?: Array<CostCode | CostCodeOptions>;
  changeEvents?: Array<ChangeEvent | ChangeEventOptions>;
  totalCostInCents?: ProjectStage["totalCostInCents"];
  clientPresentationDate?: ProjectStage["clientPresentationDate"];
  appliedTemplates?: Array<ItemTemplate | ItemTemplateOptions>;
  templateConfigs?: Array<ProjectStageTemplateConfig | ProjectStageTemplateConfigOptions>;
  readyHomePlanTemplate?: ProjectStageTemplateConfig | ProjectStageTemplateConfigOptions | null;
  percentReleased?: ProjectStage["percentReleased"];
  unallocatedExpenses?: Array<Expense | ExpenseOptions>;
  hasDrawsToInvoice?: ProjectStage["hasDrawsToInvoice"];
  hasCostsToInvoice?: ProjectStage["hasCostsToInvoice"];
  hasFixedToInvoice?: ProjectStage["hasFixedToInvoice"];
  workAuthorizations?: Array<WorkAuthorization | WorkAuthorizationOptions>;
  allContractDraws?: Array<HomeownerContractDraw | HomeownerContractDrawOptions>;
}

export function newProjectStage(options: ProjectStageOptions = {}, cache: Record<string, any> = {}): ProjectStage {
  const o = (options.__typename ? options : cache["ProjectStage"] = {}) as ProjectStage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectStage";
  o.commitments = (options.commitments ?? []).map((i) =>
    maybeNew("Commitment", i, cache, options.hasOwnProperty("commitments"))
  );
  o.commitmentLikes = (options.commitmentLikes ?? []).map((i) =>
    maybeNew("CommitmentLike", i, cache, options.hasOwnProperty("commitmentLikes"))
  );
  o.homeownerContracts = (options.homeownerContracts ?? []).map((i) =>
    maybeNew("HomeownerContract", i, cache, options.hasOwnProperty("homeownerContracts"))
  );
  o.id = options.id ?? nextFactoryId("ProjectStage");
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.stage = enumOrDetailOfStage(options.stage);
  o.hasSignedContract = options.hasSignedContract ?? false;
  o.canEditProjectItemsDirectly = options.canEditProjectItemsDirectly ?? false;
  o.canEditProjectScope = maybeNew(
    "PotentialOperation2",
    options.canEditProjectScope,
    cache,
    options.hasOwnProperty("canEditProjectScope"),
  );
  o.canCreateFinalEstimate = options.canCreateFinalEstimate ?? false;
  o.canCompleteStage = maybeNew(
    "PotentialOperation2",
    options.canCompleteStage,
    cache,
    options.hasOwnProperty("canCompleteStage"),
  );
  o.canPublishSchedule = maybeNew(
    "PotentialOperation",
    options.canPublishSchedule,
    cache,
    options.hasOwnProperty("canPublishSchedule"),
  );
  o.nextStage = maybeNewOrNull("ProjectStage", options.nextStage, cache);
  o.previousStage = maybeNewOrNull("ProjectStage", options.previousStage, cache);
  o.status = enumOrDetailOfProjectStageStatus(options.status);
  o.interval = maybeNew("CalendarInterval", options.interval, cache, options.hasOwnProperty("interval"));
  o.baselineInterval = maybeNew(
    "CalendarInterval",
    options.baselineInterval,
    cache,
    options.hasOwnProperty("baselineInterval"),
  );
  o.schedulePhases = (options.schedulePhases ?? []).map((i) =>
    maybeNew("SchedulePhase", i, cache, options.hasOwnProperty("schedulePhases"))
  );
  o.bills = (options.bills ?? []).map((i) => maybeNew("Bill", i, cache, options.hasOwnProperty("bills")));
  o.priceInCents = options.priceInCents ?? 0;
  o.progress = maybeNew("StageProgress", options.progress, cache, options.hasOwnProperty("progress"));
  o.cmsId = options.cmsId ?? null;
  o.invoices = (options.invoices ?? []).map((i) => maybeNew("Invoice", i, cache, options.hasOwnProperty("invoices")));
  o.homeownerFinancials = maybeNew(
    "ProjectStageHomeownerFinancials",
    options.homeownerFinancials,
    cache,
    options.hasOwnProperty("homeownerFinancials"),
  );
  o.estimates = (options.estimates ?? []).map((i) =>
    maybeNew("Estimate", i, cache, options.hasOwnProperty("estimates"))
  );
  o.hocFinancials = maybeNew(
    "ProjectStageHocFinancials",
    options.hocFinancials,
    cache,
    options.hasOwnProperty("hocFinancials"),
  );
  o.projectItems = (options.projectItems ?? []).map((i) =>
    maybeNew("ProjectItem", i, cache, options.hasOwnProperty("projectItems"))
  );
  o.itemLocations = (options.itemLocations ?? []).map((i) =>
    maybeNew("Location", i, cache, options.hasOwnProperty("itemLocations"))
  );
  o.costCodes = (options.costCodes ?? []).map((i) =>
    maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
  );
  o.changeEvents = (options.changeEvents ?? []).map((i) =>
    maybeNew("ChangeEvent", i, cache, options.hasOwnProperty("changeEvents"))
  );
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.clientPresentationDate = options.clientPresentationDate ?? null;
  o.appliedTemplates = (options.appliedTemplates ?? []).map((i) =>
    maybeNew("ItemTemplate", i, cache, options.hasOwnProperty("appliedTemplates"))
  );
  o.templateConfigs = (options.templateConfigs ?? []).map((i) =>
    maybeNew("ProjectStageTemplateConfig", i, cache, options.hasOwnProperty("templateConfigs"))
  );
  o.readyHomePlanTemplate = maybeNewOrNull("ProjectStageTemplateConfig", options.readyHomePlanTemplate, cache);
  o.percentReleased = options.percentReleased ?? 0;
  o.unallocatedExpenses = (options.unallocatedExpenses ?? []).map((i) =>
    maybeNew("Expense", i, cache, options.hasOwnProperty("unallocatedExpenses"))
  );
  o.hasDrawsToInvoice = options.hasDrawsToInvoice ?? false;
  o.hasCostsToInvoice = options.hasCostsToInvoice ?? false;
  o.hasFixedToInvoice = options.hasFixedToInvoice ?? false;
  o.workAuthorizations = (options.workAuthorizations ?? []).map((i) =>
    maybeNew("WorkAuthorization", i, cache, options.hasOwnProperty("workAuthorizations"))
  );
  o.allContractDraws = (options.allContractDraws ?? []).map((i) =>
    maybeNew("HomeownerContractDraw", i, cache, options.hasOwnProperty("allContractDraws"))
  );
  return o;
}

factories["ProjectStage"] = newProjectStage;

export interface CommitmentLineItemSummaryOptions {
  __typename?: "CommitmentLineItemSummary";
  costCode?: CostCode | CostCodeOptions;
  committedInCents?: CommitmentLineItemSummary["committedInCents"];
  changeOrderInCents?: CommitmentLineItemSummary["changeOrderInCents"];
  totalCommittedInCents?: CommitmentLineItemSummary["totalCommittedInCents"];
  billedInCents?: CommitmentLineItemSummary["billedInCents"];
  paidInCents?: CommitmentLineItemSummary["paidInCents"];
  balanceInCents?: CommitmentLineItemSummary["balanceInCents"];
}

export function newCommitmentLineItemSummary(
  options: CommitmentLineItemSummaryOptions = {},
  cache: Record<string, any> = {},
): CommitmentLineItemSummary {
  const o = (options.__typename ? options : cache["CommitmentLineItemSummary"] = {}) as CommitmentLineItemSummary;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CommitmentLineItemSummary";
  o.costCode = maybeNew("CostCode", options.costCode, cache, options.hasOwnProperty("costCode"));
  o.committedInCents = options.committedInCents ?? 0;
  o.changeOrderInCents = options.changeOrderInCents ?? 0;
  o.totalCommittedInCents = options.totalCommittedInCents ?? 0;
  o.billedInCents = options.billedInCents ?? 0;
  o.paidInCents = options.paidInCents ?? 0;
  o.balanceInCents = options.balanceInCents ?? 0;
  return o;
}

factories["CommitmentLineItemSummary"] = newCommitmentLineItemSummary;

export interface CommitmentsPageOptions {
  __typename?: "CommitmentsPage";
  commitments?: Array<Commitment | CommitmentOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newCommitmentsPage(
  options: CommitmentsPageOptions = {},
  cache: Record<string, any> = {},
): CommitmentsPage {
  const o = (options.__typename ? options : cache["CommitmentsPage"] = {}) as CommitmentsPage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CommitmentsPage";
  o.commitments = (options.commitments ?? []).map((i) =>
    maybeNew("Commitment", i, cache, options.hasOwnProperty("commitments"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["CommitmentsPage"] = newCommitmentsPage;

export interface PotentialBidContractRevisionOptions {
  __typename?: "PotentialBidContractRevision";
  bidContractRevision?: BidContractRevision | BidContractRevisionOptions;
  totalCostInCents?: PotentialBidContractRevision["totalCostInCents"];
}

export function newPotentialBidContractRevision(
  options: PotentialBidContractRevisionOptions = {},
  cache: Record<string, any> = {},
): PotentialBidContractRevision {
  const o = (options.__typename ? options : cache["PotentialBidContractRevision"] = {}) as PotentialBidContractRevision;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PotentialBidContractRevision";
  o.bidContractRevision = maybeNew(
    "BidContractRevision",
    options.bidContractRevision,
    cache,
    options.hasOwnProperty("bidContractRevision"),
  );
  o.totalCostInCents = options.totalCostInCents ?? 0;
  return o;
}

factories["PotentialBidContractRevision"] = newPotentialBidContractRevision;

export interface CommitmentCostCodeSummaryOptions {
  __typename?: "CommitmentCostCodeSummary";
  lineItems?: Array<CommitmentCostCodeSummaryLineItem | CommitmentCostCodeSummaryLineItemOptions>;
}

export function newCommitmentCostCodeSummary(
  options: CommitmentCostCodeSummaryOptions = {},
  cache: Record<string, any> = {},
): CommitmentCostCodeSummary {
  const o = (options.__typename ? options : cache["CommitmentCostCodeSummary"] = {}) as CommitmentCostCodeSummary;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CommitmentCostCodeSummary";
  o.lineItems = (options.lineItems ?? []).map((i) =>
    maybeNew("CommitmentCostCodeSummaryLineItem", i, cache, options.hasOwnProperty("lineItems"))
  );
  return o;
}

factories["CommitmentCostCodeSummary"] = newCommitmentCostCodeSummary;

export interface CommitmentCostCodeSummaryLineItemOptions {
  __typename?: "CommitmentCostCodeSummaryLineItem";
  costCode?: CostCode | CostCodeOptions;
  quantity?: CommitmentCostCodeSummaryLineItem["quantity"];
}

export function newCommitmentCostCodeSummaryLineItem(
  options: CommitmentCostCodeSummaryLineItemOptions = {},
  cache: Record<string, any> = {},
): CommitmentCostCodeSummaryLineItem {
  const o =
    (options.__typename
      ? options
      : cache["CommitmentCostCodeSummaryLineItem"] = {}) as CommitmentCostCodeSummaryLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CommitmentCostCodeSummaryLineItem";
  o.costCode = maybeNew("CostCode", options.costCode, cache, options.hasOwnProperty("costCode"));
  o.quantity = options.quantity ?? 0;
  return o;
}

factories["CommitmentCostCodeSummaryLineItem"] = newCommitmentCostCodeSummaryLineItem;

export interface SaveCommitmentResultOptions {
  __typename?: "SaveCommitmentResult";
  commitment?: Commitment | CommitmentOptions;
}

export function newSaveCommitmentResult(
  options: SaveCommitmentResultOptions = {},
  cache: Record<string, any> = {},
): SaveCommitmentResult {
  const o = (options.__typename ? options : cache["SaveCommitmentResult"] = {}) as SaveCommitmentResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveCommitmentResult";
  o.commitment = maybeNew("Commitment", options.commitment, cache, options.hasOwnProperty("commitment"));
  return o;
}

factories["SaveCommitmentResult"] = newSaveCommitmentResult;

export interface SaveCommitmentsResultOptions {
  __typename?: "SaveCommitmentsResult";
  commitments?: Array<Commitment | CommitmentOptions>;
}

export function newSaveCommitmentsResult(
  options: SaveCommitmentsResultOptions = {},
  cache: Record<string, any> = {},
): SaveCommitmentsResult {
  const o = (options.__typename ? options : cache["SaveCommitmentsResult"] = {}) as SaveCommitmentsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveCommitmentsResult";
  o.commitments = (options.commitments ?? []).map((i) =>
    maybeNew("Commitment", i, cache, options.hasOwnProperty("commitments"))
  );
  return o;
}

factories["SaveCommitmentsResult"] = newSaveCommitmentsResult;

export interface CreateCommitmentFromBillResultOptions {
  __typename?: "CreateCommitmentFromBillResult";
  commitment?: Commitment | CommitmentOptions | null;
  changeEvent?: ChangeEvent | ChangeEventOptions | null;
}

export function newCreateCommitmentFromBillResult(
  options: CreateCommitmentFromBillResultOptions = {},
  cache: Record<string, any> = {},
): CreateCommitmentFromBillResult {
  const o =
    (options.__typename ? options : cache["CreateCommitmentFromBillResult"] = {}) as CreateCommitmentFromBillResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CreateCommitmentFromBillResult";
  o.commitment = maybeNewOrNull("Commitment", options.commitment, cache);
  o.changeEvent = maybeNewOrNull("ChangeEvent", options.changeEvent, cache);
  return o;
}

factories["CreateCommitmentFromBillResult"] = newCreateCommitmentFromBillResult;

export interface CommitmentBillingScheduleItemOptions {
  __typename?: "CommitmentBillingScheduleItem";
  commitmentDraw?: CommitmentDraw | CommitmentDrawOptions | null;
  isDeposit?: CommitmentBillingScheduleItem["isDeposit"];
  committedInCents?: CommitmentBillingScheduleItem["committedInCents"];
  pendingBilledInCents?: CommitmentBillingScheduleItem["pendingBilledInCents"];
  pendingUnbilledInCents?: CommitmentBillingScheduleItem["pendingUnbilledInCents"];
  lineItems?: Array<CommitmentBillingScheduleLineItem | CommitmentBillingScheduleLineItemOptions>;
}

export function newCommitmentBillingScheduleItem(
  options: CommitmentBillingScheduleItemOptions = {},
  cache: Record<string, any> = {},
): CommitmentBillingScheduleItem {
  const o =
    (options.__typename ? options : cache["CommitmentBillingScheduleItem"] = {}) as CommitmentBillingScheduleItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CommitmentBillingScheduleItem";
  o.commitmentDraw = maybeNewOrNull("CommitmentDraw", options.commitmentDraw, cache);
  o.isDeposit = options.isDeposit ?? false;
  o.committedInCents = options.committedInCents ?? 0;
  o.pendingBilledInCents = options.pendingBilledInCents ?? 0;
  o.pendingUnbilledInCents = options.pendingUnbilledInCents ?? 0;
  o.lineItems = (options.lineItems ?? []).map((i) =>
    maybeNew("CommitmentBillingScheduleLineItem", i, cache, options.hasOwnProperty("lineItems"))
  );
  return o;
}

factories["CommitmentBillingScheduleItem"] = newCommitmentBillingScheduleItem;

export interface CommitmentBillingScheduleLineItemOptions {
  __typename?: "CommitmentBillingScheduleLineItem";
  amountInCents?: CommitmentBillingScheduleLineItem["amountInCents"];
  commitmentLineItem?: CommitmentLineItem | CommitmentLineItemOptions;
}

export function newCommitmentBillingScheduleLineItem(
  options: CommitmentBillingScheduleLineItemOptions = {},
  cache: Record<string, any> = {},
): CommitmentBillingScheduleLineItem {
  const o =
    (options.__typename
      ? options
      : cache["CommitmentBillingScheduleLineItem"] = {}) as CommitmentBillingScheduleLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CommitmentBillingScheduleLineItem";
  o.amountInCents = options.amountInCents ?? 0;
  o.commitmentLineItem = maybeNew(
    "CommitmentLineItem",
    options.commitmentLineItem,
    cache,
    options.hasOwnProperty("commitmentLineItem"),
  );
  return o;
}

factories["CommitmentBillingScheduleLineItem"] = newCommitmentBillingScheduleLineItem;

export interface CommitmentChangeOrderOptions {
  __typename?: "CommitmentChangeOrder";
  id?: CommitmentChangeOrder["id"];
  accountingNumber?: CommitmentChangeOrder["accountingNumber"];
  name?: CommitmentChangeOrder["name"];
  displayName?: CommitmentChangeOrder["displayName"];
  shortName?: CommitmentChangeOrder["shortName"];
  commitment?: Commitment | CommitmentOptions;
  commitmentType?: CommitmentTypeDetailOptions | CommitmentType;
  identifier?: CommitmentChangeOrder["identifier"];
  costChangeInCents?: CommitmentChangeOrder["costChangeInCents"];
  internalNote?: CommitmentChangeOrder["internalNote"];
  executionDate?: CommitmentChangeOrder["executionDate"];
  createdAt?: CommitmentChangeOrder["createdAt"];
  document?: Document | DocumentOptions | null;
  lineItems?: Array<CommitmentLineItem | CommitmentLineItemOptions>;
  bills?: Array<Bill | BillOptions>;
  committedInCents?: CommitmentChangeOrder["committedInCents"];
  taxableCostInCents?: CommitmentChangeOrder["taxableCostInCents"];
  remainingInCents?: CommitmentChangeOrder["remainingInCents"];
  pendingRemainingInCents?: CommitmentChangeOrder["pendingRemainingInCents"];
  billedInCents?: CommitmentChangeOrder["billedInCents"];
  pendingBilledInCents?: CommitmentChangeOrder["pendingBilledInCents"];
  unbilledInCents?: CommitmentChangeOrder["unbilledInCents"];
  paidInCents?: CommitmentChangeOrder["paidInCents"];
  balanceInCents?: CommitmentChangeOrder["balanceInCents"];
  blueprintUrl?: Url | UrlOptions;
  updatedAt?: CommitmentChangeOrder["updatedAt"];
  tradeCategories?: Array<TradeCategory | TradeCategoryOptions>;
  tradePartner?: TradePartner | TradePartnerOptions | null;
  changeEvent?: ChangeEvent | ChangeEventOptions | null;
  status?: CommitmentChangeOrder["status"];
  statusDetail?: CommitmentStatusDetailOptions | CommitmentStatus;
  statusText?: CommitmentChangeOrder["statusText"];
  pandaDoc?: PandaDoc | PandaDocOptions | null;
  canEditLineItems?: PotentialOperation2 | PotentialOperation2Options;
  canCreatePandaDoc?: PotentialOperation2 | PotentialOperation2Options;
  isBidCommitment?: CommitmentChangeOrder["isBidCommitment"];
  canBeEdited?: CommitmentChangeOrder["canBeEdited"];
  costCodes?: Array<CostCode | CostCodeOptions>;
  items?: Array<Item | ItemOptions>;
  canDelete?: PotentialOperation2 | PotentialOperation2Options;
  canVoid?: PotentialOperation2 | PotentialOperation2Options;
  canBeReleased?: PotentialOperation2 | PotentialOperation2Options;
  tradeSignatory?: TradePartnerContact | TradePartnerContactOptions | null;
  percentagePaid?: CommitmentChangeOrder["percentagePaid"];
  sentDate?: CommitmentChangeOrder["sentDate"];
  referenceNumber?: CommitmentChangeOrder["referenceNumber"];
}

export function newCommitmentChangeOrder(
  options: CommitmentChangeOrderOptions = {},
  cache: Record<string, any> = {},
): CommitmentChangeOrder {
  const o = (options.__typename ? options : cache["CommitmentChangeOrder"] = {}) as CommitmentChangeOrder;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CommitmentChangeOrder";
  o.id = options.id ?? nextFactoryId("CommitmentChangeOrder");
  o.accountingNumber = options.accountingNumber ?? 0;
  o.name = options.name ?? "name";
  o.displayName = options.displayName ?? "displayName";
  o.shortName = options.shortName ?? "shortName";
  o.commitment = maybeNew("Commitment", options.commitment, cache, options.hasOwnProperty("commitment"));
  o.commitmentType = enumOrDetailOfCommitmentType(options.commitmentType);
  o.identifier = options.identifier ?? "identifier";
  o.costChangeInCents = options.costChangeInCents ?? 0;
  o.internalNote = options.internalNote ?? null;
  o.executionDate = options.executionDate ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.document = maybeNewOrNull("Document", options.document, cache);
  o.lineItems = (options.lineItems ?? []).map((i) =>
    maybeNew("CommitmentLineItem", i, cache, options.hasOwnProperty("lineItems"))
  );
  o.bills = (options.bills ?? []).map((i) => maybeNew("Bill", i, cache, options.hasOwnProperty("bills")));
  o.committedInCents = options.committedInCents ?? 0;
  o.taxableCostInCents = options.taxableCostInCents ?? 0;
  o.remainingInCents = options.remainingInCents ?? 0;
  o.pendingRemainingInCents = options.pendingRemainingInCents ?? 0;
  o.billedInCents = options.billedInCents ?? null;
  o.pendingBilledInCents = options.pendingBilledInCents ?? null;
  o.unbilledInCents = options.unbilledInCents ?? 0;
  o.paidInCents = options.paidInCents ?? null;
  o.balanceInCents = options.balanceInCents ?? null;
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.tradeCategories = (options.tradeCategories ?? []).map((i) =>
    maybeNew("TradeCategory", i, cache, options.hasOwnProperty("tradeCategories"))
  );
  o.tradePartner = maybeNewOrNull("TradePartner", options.tradePartner, cache);
  o.changeEvent = maybeNewOrNull("ChangeEvent", options.changeEvent, cache);
  o.status = options.status ?? CommitmentStatus.Draft;
  o.statusDetail = enumOrDetailOfCommitmentStatus(options.statusDetail);
  o.statusText = options.statusText ?? "statusText";
  o.pandaDoc = maybeNewOrNull("PandaDoc", options.pandaDoc, cache);
  o.canEditLineItems = maybeNew(
    "PotentialOperation2",
    options.canEditLineItems,
    cache,
    options.hasOwnProperty("canEditLineItems"),
  );
  o.canCreatePandaDoc = maybeNew(
    "PotentialOperation2",
    options.canCreatePandaDoc,
    cache,
    options.hasOwnProperty("canCreatePandaDoc"),
  );
  o.isBidCommitment = options.isBidCommitment ?? false;
  o.canBeEdited = options.canBeEdited ?? false;
  o.costCodes = (options.costCodes ?? []).map((i) =>
    maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
  );
  o.items = (options.items ?? []).map((i) => maybeNew("Item", i, cache, options.hasOwnProperty("items")));
  o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
  o.canVoid = maybeNew("PotentialOperation2", options.canVoid, cache, options.hasOwnProperty("canVoid"));
  o.canBeReleased = maybeNew(
    "PotentialOperation2",
    options.canBeReleased,
    cache,
    options.hasOwnProperty("canBeReleased"),
  );
  o.tradeSignatory = maybeNewOrNull("TradePartnerContact", options.tradeSignatory, cache);
  o.percentagePaid = options.percentagePaid ?? 0;
  o.sentDate = options.sentDate ?? null;
  o.referenceNumber = options.referenceNumber ?? null;
  return o;
}

factories["CommitmentChangeOrder"] = newCommitmentChangeOrder;

export interface SaveCommitmentChangeOrderResultOptions {
  __typename?: "SaveCommitmentChangeOrderResult";
  commitmentChangeOrder?: CommitmentChangeOrder | CommitmentChangeOrderOptions;
}

export function newSaveCommitmentChangeOrderResult(
  options: SaveCommitmentChangeOrderResultOptions = {},
  cache: Record<string, any> = {},
): SaveCommitmentChangeOrderResult {
  const o =
    (options.__typename ? options : cache["SaveCommitmentChangeOrderResult"] = {}) as SaveCommitmentChangeOrderResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveCommitmentChangeOrderResult";
  o.commitmentChangeOrder = maybeNew(
    "CommitmentChangeOrder",
    options.commitmentChangeOrder,
    cache,
    options.hasOwnProperty("commitmentChangeOrder"),
  );
  return o;
}

factories["SaveCommitmentChangeOrderResult"] = newSaveCommitmentChangeOrderResult;

export interface CommitmentDrawOptions {
  __typename?: "CommitmentDraw";
  id?: CommitmentDraw["id"];
  amountInBasisPoints?: CommitmentDraw["amountInBasisPoints"];
  description?: CommitmentDraw["description"];
  createdAt?: CommitmentDraw["createdAt"];
  updatedAt?: CommitmentDraw["updatedAt"];
  bidContractRevisionDraw?: BidContractRevisionDraw | BidContractRevisionDrawOptions;
  commitment?: Commitment | CommitmentOptions;
  task?: Task | TaskOptions;
  costCode?: CostCode | CostCodeOptions;
}

export function newCommitmentDraw(
  options: CommitmentDrawOptions = {},
  cache: Record<string, any> = {},
): CommitmentDraw {
  const o = (options.__typename ? options : cache["CommitmentDraw"] = {}) as CommitmentDraw;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CommitmentDraw";
  o.id = options.id ?? nextFactoryId("CommitmentDraw");
  o.amountInBasisPoints = options.amountInBasisPoints ?? 0;
  o.description = options.description ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.bidContractRevisionDraw = maybeNew(
    "BidContractRevisionDraw",
    options.bidContractRevisionDraw,
    cache,
    options.hasOwnProperty("bidContractRevisionDraw"),
  );
  o.commitment = maybeNew("Commitment", options.commitment, cache, options.hasOwnProperty("commitment"));
  o.task = maybeNew("Task", options.task, cache, options.hasOwnProperty("task"));
  o.costCode = maybeNew("CostCode", options.costCode, cache, options.hasOwnProperty("costCode"));
  return o;
}

factories["CommitmentDraw"] = newCommitmentDraw;

export interface CommitmentLineItemOptions {
  __typename?: "CommitmentLineItem";
  id?: CommitmentLineItem["id"];
  owner?: Commitment | CommitmentChangeOrder | CommitmentLike | CommitmentLikeOptions;
  ownerCommitment?: Commitment | CommitmentOptions;
  costChangeInCents?: CommitmentLineItem["costChangeInCents"];
  internalNote?: CommitmentLineItem["internalNote"];
  costCode?: CostCode | CostCodeOptions;
  committedInCents?: CommitmentLineItem["committedInCents"];
  billedInCents?: CommitmentLineItem["billedInCents"];
  unbilledInCents?: CommitmentLineItem["unbilledInCents"];
  pendingBilledInCents?: CommitmentLineItem["pendingBilledInCents"];
  pendingUnbilledInCents?: CommitmentLineItem["pendingUnbilledInCents"];
  billableLimitInCents?: CommitmentLineItem["billableLimitInCents"];
  paidInCents?: CommitmentLineItem["paidInCents"];
  balanceInCents?: CommitmentLineItem["balanceInCents"];
  quantity?: CommitmentLineItem["quantity"];
  projectItem?: ProjectItem | ProjectItemOptions;
  specifications?: CommitmentLineItem["specifications"];
  tradePartnerNote?: CommitmentLineItem["tradePartnerNote"];
  changeEventLineItem?: ChangeEventLineItem | ChangeEventLineItemOptions | null;
  newTaxableCostInCents?: CommitmentLineItem["newTaxableCostInCents"];
  newTaxInCents?: CommitmentLineItem["newTaxInCents"];
  newTotalCostInCents?: CommitmentLineItem["newTotalCostInCents"];
  originalTaxableCostInCents?: CommitmentLineItem["originalTaxableCostInCents"];
  originalTaxInCents?: CommitmentLineItem["originalTaxInCents"];
  originalTotalCostInCents?: CommitmentLineItem["originalTotalCostInCents"];
  originalQuantity?: CommitmentLineItem["originalQuantity"];
  newQuantity?: CommitmentLineItem["newQuantity"];
  bidItem?: BidItem | BidItemOptions | null;
  primaryBidContractLineItem?: BidContractLineItem | BidContractLineItemOptions | null;
  modifyingBidContractLineItems?: Array<BidContractLineItem | BidContractLineItemOptions>;
  expenseAllocations?: Array<ExpenseAllocation | ExpenseAllocationOptions>;
  isTaxExempt?: CommitmentLineItem["isTaxExempt"];
  taxableCostInCents?: CommitmentLineItem["taxableCostInCents"];
  taxInCents?: CommitmentLineItem["taxInCents"];
  allocations?: Array<CommitmentLineItemAllocation | CommitmentLineItemAllocationOptions>;
}

export function newCommitmentLineItem(
  options: CommitmentLineItemOptions = {},
  cache: Record<string, any> = {},
): CommitmentLineItem {
  const o = (options.__typename ? options : cache["CommitmentLineItem"] = {}) as CommitmentLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CommitmentLineItem";
  o.id = options.id ?? nextFactoryId("CommitmentLineItem");
  o.owner = maybeNew("CommitmentLike", options.owner, cache, options.hasOwnProperty("owner"));
  o.ownerCommitment = maybeNew("Commitment", options.ownerCommitment, cache, options.hasOwnProperty("ownerCommitment"));
  o.costChangeInCents = options.costChangeInCents ?? null;
  o.internalNote = options.internalNote ?? null;
  o.costCode = maybeNew("CostCode", options.costCode, cache, options.hasOwnProperty("costCode"));
  o.committedInCents = options.committedInCents ?? 0;
  o.billedInCents = options.billedInCents ?? null;
  o.unbilledInCents = options.unbilledInCents ?? 0;
  o.pendingBilledInCents = options.pendingBilledInCents ?? 0;
  o.pendingUnbilledInCents = options.pendingUnbilledInCents ?? 0;
  o.billableLimitInCents = options.billableLimitInCents ?? 0;
  o.paidInCents = options.paidInCents ?? null;
  o.balanceInCents = options.balanceInCents ?? null;
  o.quantity = options.quantity ?? null;
  o.projectItem = maybeNew("ProjectItem", options.projectItem, cache, options.hasOwnProperty("projectItem"));
  o.specifications = options.specifications ?? null;
  o.tradePartnerNote = options.tradePartnerNote ?? null;
  o.changeEventLineItem = maybeNewOrNull("ChangeEventLineItem", options.changeEventLineItem, cache);
  o.newTaxableCostInCents = options.newTaxableCostInCents ?? 0;
  o.newTaxInCents = options.newTaxInCents ?? 0;
  o.newTotalCostInCents = options.newTotalCostInCents ?? 0;
  o.originalTaxableCostInCents = options.originalTaxableCostInCents ?? 0;
  o.originalTaxInCents = options.originalTaxInCents ?? 0;
  o.originalTotalCostInCents = options.originalTotalCostInCents ?? 0;
  o.originalQuantity = options.originalQuantity ?? 0;
  o.newQuantity = options.newQuantity ?? 0;
  o.bidItem = maybeNewOrNull("BidItem", options.bidItem, cache);
  o.primaryBidContractLineItem = maybeNewOrNull("BidContractLineItem", options.primaryBidContractLineItem, cache);
  o.modifyingBidContractLineItems = (options.modifyingBidContractLineItems ?? []).map((i) =>
    maybeNew("BidContractLineItem", i, cache, options.hasOwnProperty("modifyingBidContractLineItems"))
  );
  o.expenseAllocations = (options.expenseAllocations ?? []).map((i) =>
    maybeNew("ExpenseAllocation", i, cache, options.hasOwnProperty("expenseAllocations"))
  );
  o.isTaxExempt = options.isTaxExempt ?? false;
  o.taxableCostInCents = options.taxableCostInCents ?? 0;
  o.taxInCents = options.taxInCents ?? 0;
  o.allocations = (options.allocations ?? []).map((i) =>
    maybeNew("CommitmentLineItemAllocation", i, cache, options.hasOwnProperty("allocations"))
  );
  return o;
}

factories["CommitmentLineItem"] = newCommitmentLineItem;

export interface ProtoCommitmentLineItemToBuyoutOptions {
  __typename?: "ProtoCommitmentLineItemToBuyout";
  projectItem?: ProjectItem | ProjectItemOptions;
  quantity?: ProtoCommitmentLineItemToBuyout["quantity"];
  costChangeInCents?: ProtoCommitmentLineItemToBuyout["costChangeInCents"];
  specifications?: ProtoCommitmentLineItemToBuyout["specifications"];
  tradePartnerNote?: ProtoCommitmentLineItemToBuyout["tradePartnerNote"];
}

export function newProtoCommitmentLineItemToBuyout(
  options: ProtoCommitmentLineItemToBuyoutOptions = {},
  cache: Record<string, any> = {},
): ProtoCommitmentLineItemToBuyout {
  const o =
    (options.__typename ? options : cache["ProtoCommitmentLineItemToBuyout"] = {}) as ProtoCommitmentLineItemToBuyout;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProtoCommitmentLineItemToBuyout";
  o.projectItem = maybeNew("ProjectItem", options.projectItem, cache, options.hasOwnProperty("projectItem"));
  o.quantity = options.quantity ?? null;
  o.costChangeInCents = options.costChangeInCents ?? null;
  o.specifications = options.specifications ?? null;
  o.tradePartnerNote = options.tradePartnerNote ?? null;
  return o;
}

factories["ProtoCommitmentLineItemToBuyout"] = newProtoCommitmentLineItemToBuyout;

export interface CommitmentLineItemAllocationOptions {
  __typename?: "CommitmentLineItemAllocation";
  id?: CommitmentLineItemAllocation["id"];
  costInCents?: CommitmentLineItemAllocation["costInCents"];
  createdAt?: CommitmentLineItemAllocation["createdAt"];
  updatedAt?: CommitmentLineItemAllocation["updatedAt"];
  commitmentLineItem?: CommitmentLineItem | CommitmentLineItemOptions;
  projectItemAllocation?: ProjectItemAllocation | ProjectItemAllocationOptions;
  billLineItemAllocations?: Array<BillLineItemAllocation | BillLineItemAllocationOptions>;
}

export function newCommitmentLineItemAllocation(
  options: CommitmentLineItemAllocationOptions = {},
  cache: Record<string, any> = {},
): CommitmentLineItemAllocation {
  const o = (options.__typename ? options : cache["CommitmentLineItemAllocation"] = {}) as CommitmentLineItemAllocation;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CommitmentLineItemAllocation";
  o.id = options.id ?? nextFactoryId("CommitmentLineItemAllocation");
  o.costInCents = options.costInCents ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.commitmentLineItem = maybeNew(
    "CommitmentLineItem",
    options.commitmentLineItem,
    cache,
    options.hasOwnProperty("commitmentLineItem"),
  );
  o.projectItemAllocation = maybeNew(
    "ProjectItemAllocation",
    options.projectItemAllocation,
    cache,
    options.hasOwnProperty("projectItemAllocation"),
  );
  o.billLineItemAllocations = (options.billLineItemAllocations ?? []).map((i) =>
    maybeNew("BillLineItemAllocation", i, cache, options.hasOwnProperty("billLineItemAllocations"))
  );
  return o;
}

factories["CommitmentLineItemAllocation"] = newCommitmentLineItemAllocation;

export interface SaveCommunityResultOptions {
  __typename?: "SaveCommunityResult";
  community?: Community | CommunityOptions;
}

export function newSaveCommunityResult(
  options: SaveCommunityResultOptions = {},
  cache: Record<string, any> = {},
): SaveCommunityResult {
  const o = (options.__typename ? options : cache["SaveCommunityResult"] = {}) as SaveCommunityResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveCommunityResult";
  o.community = maybeNew("Community", options.community, cache, options.hasOwnProperty("community"));
  return o;
}

factories["SaveCommunityResult"] = newSaveCommunityResult;

export interface CommunitiesPageResultOptions {
  __typename?: "CommunitiesPageResult";
  entities?: Array<Community | CommunityOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newCommunitiesPageResult(
  options: CommunitiesPageResultOptions = {},
  cache: Record<string, any> = {},
): CommunitiesPageResult {
  const o = (options.__typename ? options : cache["CommunitiesPageResult"] = {}) as CommunitiesPageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CommunitiesPageResult";
  o.entities = (options.entities ?? []).map((i) => maybeNew("Community", i, cache, options.hasOwnProperty("entities")));
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["CommunitiesPageResult"] = newCommunitiesPageResult;

export interface CostCodeOptions {
  __typename?: "CostCode";
  id?: CostCode["id"];
  version?: CostCode["version"];
  division?: CostDivision | CostDivisionOptions;
  number?: CostCode["number"];
  name?: CostCode["name"];
  displayName?: CostCode["displayName"];
  quickbooksCategoryId?: CostCode["quickbooksCategoryId"];
  quickbooksItemId?: CostCode["quickbooksItemId"];
  items?: Array<Item | ItemOptions>;
  tsaSpecifications?: CostCode["tsaSpecifications"];
  intacctApAccountId?: CostCode["intacctApAccountId"];
  costClassification?: CostClassificationTypeDetailOptions | CostClassificationType;
  costSubClassification?: CostSubClassificationTypeDetailOptions | CostSubClassificationType | null;
  excludeFromPurchaseOrders?: CostCode["excludeFromPurchaseOrders"];
  billType?: BillTypeDetailOptions | BillType | null;
  changeEventAutoAcceptThresholdInCents?: CostCode["changeEventAutoAcceptThresholdInCents"];
  isPriceOnly?: CostCode["isPriceOnly"];
  optionPricingConfig?: OptionPricingConfig | OptionPricingConfigOptions | null;
  materialLeadTimeConfig?: MaterialLeadTimeConfig | MaterialLeadTimeConfigOptions | null;
  minLeadTimeInDays?: CostCode["minLeadTimeInDays"];
  expectedLeadTimeInDays?: CostCode["expectedLeadTimeInDays"];
  maxLeadTimeInDays?: CostCode["maxLeadTimeInDays"];
  history?: Array<History | HistoryOptions>;
  isUnderwritingBudget?: CostCode["isUnderwritingBudget"];
  finishScheduleOrder?: CostCode["finishScheduleOrder"];
  invoiceCategory?: CostCodeInvoiceCategoryDetailOptions | CostCodeInvoiceCategory | null;
}

export function newCostCode(options: CostCodeOptions = {}, cache: Record<string, any> = {}): CostCode {
  const o = (options.__typename ? options : cache["CostCode"] = {}) as CostCode;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CostCode";
  o.id = options.id ?? nextFactoryId("CostCode");
  o.version = options.version ?? 0;
  o.division = maybeNew("CostDivision", options.division, cache, options.hasOwnProperty("division"));
  o.number = options.number ?? "number";
  o.name = options.name ?? "name";
  o.displayName = options.displayName ?? "displayName";
  o.quickbooksCategoryId = options.quickbooksCategoryId ?? null;
  o.quickbooksItemId = options.quickbooksItemId ?? null;
  o.items = (options.items ?? []).map((i) => maybeNew("Item", i, cache, options.hasOwnProperty("items")));
  o.tsaSpecifications = options.tsaSpecifications ?? null;
  o.intacctApAccountId = options.intacctApAccountId ?? null;
  o.costClassification = enumOrDetailOfCostClassificationType(options.costClassification);
  o.costSubClassification = enumOrDetailOrNullOfCostSubClassificationType(options.costSubClassification);
  o.excludeFromPurchaseOrders = options.excludeFromPurchaseOrders ?? false;
  o.billType = enumOrDetailOrNullOfBillType(options.billType);
  o.changeEventAutoAcceptThresholdInCents = options.changeEventAutoAcceptThresholdInCents ?? null;
  o.isPriceOnly = options.isPriceOnly ?? null;
  o.optionPricingConfig = maybeNewOrNull("OptionPricingConfig", options.optionPricingConfig, cache);
  o.materialLeadTimeConfig = maybeNewOrNull("MaterialLeadTimeConfig", options.materialLeadTimeConfig, cache);
  o.minLeadTimeInDays = options.minLeadTimeInDays ?? 0;
  o.expectedLeadTimeInDays = options.expectedLeadTimeInDays ?? 0;
  o.maxLeadTimeInDays = options.maxLeadTimeInDays ?? 0;
  o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
  o.isUnderwritingBudget = options.isUnderwritingBudget ?? false;
  o.finishScheduleOrder = options.finishScheduleOrder ?? null;
  o.invoiceCategory = enumOrDetailOrNullOfCostCodeInvoiceCategory(options.invoiceCategory);
  return o;
}

factories["CostCode"] = newCostCode;

export interface SaveCostCodesResultOptions {
  __typename?: "SaveCostCodesResult";
  costCodes?: Array<CostCode | CostCodeOptions>;
}

export function newSaveCostCodesResult(
  options: SaveCostCodesResultOptions = {},
  cache: Record<string, any> = {},
): SaveCostCodesResult {
  const o = (options.__typename ? options : cache["SaveCostCodesResult"] = {}) as SaveCostCodesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveCostCodesResult";
  o.costCodes = (options.costCodes ?? []).map((i) =>
    maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
  );
  return o;
}

factories["SaveCostCodesResult"] = newSaveCostCodesResult;

export interface CostDivisionOptions {
  __typename?: "CostDivision";
  id?: CostDivision["id"];
  version?: CostDivision["version"];
  number?: CostDivision["number"];
  name?: CostDivision["name"];
  displayName?: CostDivision["displayName"];
  stage?: StageDetailOptions | Stage;
  selectionCutoff?: SelectionCutoffDetailOptions | SelectionCutoff | null;
  costCodes?: Array<CostCode | CostCodeOptions>;
  tsaPolicySection?: CostDivision["tsaPolicySection"];
  tsaPaymentSection?: CostDivision["tsaPaymentSection"];
  tsaWarrantySection?: CostDivision["tsaWarrantySection"];
  tsaGeneralScope?: CostDivision["tsaGeneralScope"];
}

export function newCostDivision(options: CostDivisionOptions = {}, cache: Record<string, any> = {}): CostDivision {
  const o = (options.__typename ? options : cache["CostDivision"] = {}) as CostDivision;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CostDivision";
  o.id = options.id ?? nextFactoryId("CostDivision");
  o.version = options.version ?? 0;
  o.number = options.number ?? "number";
  o.name = options.name ?? "name";
  o.displayName = options.displayName ?? "displayName";
  o.stage = enumOrDetailOfStage(options.stage);
  o.selectionCutoff = enumOrDetailOrNullOfSelectionCutoff(options.selectionCutoff);
  o.costCodes = (options.costCodes ?? []).map((i) =>
    maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
  );
  o.tsaPolicySection = options.tsaPolicySection ?? null;
  o.tsaPaymentSection = options.tsaPaymentSection ?? null;
  o.tsaWarrantySection = options.tsaWarrantySection ?? null;
  o.tsaGeneralScope = options.tsaGeneralScope ?? null;
  return o;
}

factories["CostDivision"] = newCostDivision;

export interface SaveCostDivisionsResultOptions {
  __typename?: "SaveCostDivisionsResult";
  costDivisions?: Array<CostDivision | CostDivisionOptions>;
}

export function newSaveCostDivisionsResult(
  options: SaveCostDivisionsResultOptions = {},
  cache: Record<string, any> = {},
): SaveCostDivisionsResult {
  const o = (options.__typename ? options : cache["SaveCostDivisionsResult"] = {}) as SaveCostDivisionsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveCostDivisionsResult";
  o.costDivisions = (options.costDivisions ?? []).map((i) =>
    maybeNew("CostDivision", i, cache, options.hasOwnProperty("costDivisions"))
  );
  return o;
}

factories["SaveCostDivisionsResult"] = newSaveCostDivisionsResult;

export interface CostLineItemAllocationOptions {
  __typename?: "CostLineItemAllocation";
  id?: CostLineItemAllocation["id"];
  invoicedAmountInCents?: CostLineItemAllocation["invoicedAmountInCents"];
  createdAt?: CostLineItemAllocation["createdAt"];
  updatedAt?: CostLineItemAllocation["updatedAt"];
  billLineItem?: BillLineItem | BillLineItemOptions | null;
  expenseAllocation?: ExpenseAllocation | ExpenseAllocationOptions | null;
  invoiceLineItem?: InvoiceLineItem | InvoiceLineItemOptions;
  costAmountInCents?: CostLineItemAllocation["costAmountInCents"];
  costLineItemId?: CostLineItemAllocation["costLineItemId"];
}

export function newCostLineItemAllocation(
  options: CostLineItemAllocationOptions = {},
  cache: Record<string, any> = {},
): CostLineItemAllocation {
  const o = (options.__typename ? options : cache["CostLineItemAllocation"] = {}) as CostLineItemAllocation;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CostLineItemAllocation";
  o.id = options.id ?? nextFactoryId("CostLineItemAllocation");
  o.invoicedAmountInCents = options.invoicedAmountInCents ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.billLineItem = maybeNewOrNull("BillLineItem", options.billLineItem, cache);
  o.expenseAllocation = maybeNewOrNull("ExpenseAllocation", options.expenseAllocation, cache);
  o.invoiceLineItem = maybeNew(
    "InvoiceLineItem",
    options.invoiceLineItem,
    cache,
    options.hasOwnProperty("invoiceLineItem"),
  );
  o.costAmountInCents = options.costAmountInCents ?? 0;
  o.costLineItemId = options.costLineItemId ?? "costLineItemId";
  return o;
}

factories["CostLineItemAllocation"] = newCostLineItemAllocation;

export interface CustomerOptions {
  __typename?: "Customer";
  id?: Customer["id"];
  name?: Customer["name"];
  softCostMarkupInBasisPoints?: Customer["softCostMarkupInBasisPoints"];
  indirectHardCostMarkupInBasisPoints?: Customer["indirectHardCostMarkupInBasisPoints"];
  directHardCostMarkupInBasisPoints?: Customer["directHardCostMarkupInBasisPoints"];
  createdAt?: Customer["createdAt"];
  updatedAt?: Customer["updatedAt"];
  isHti?: Customer["isHti"];
  itemConfigs?: Array<CustomerItemConfig | CustomerItemConfigOptions>;
  shouldCoverConstructionCosts?: Customer["shouldCoverConstructionCosts"];
}

export function newCustomer(options: CustomerOptions = {}, cache: Record<string, any> = {}): Customer {
  const o = (options.__typename ? options : cache["Customer"] = {}) as Customer;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Customer";
  o.id = options.id ?? nextFactoryId("Customer");
  o.name = options.name ?? "name";
  o.softCostMarkupInBasisPoints = options.softCostMarkupInBasisPoints ?? 0;
  o.indirectHardCostMarkupInBasisPoints = options.indirectHardCostMarkupInBasisPoints ?? 0;
  o.directHardCostMarkupInBasisPoints = options.directHardCostMarkupInBasisPoints ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.isHti = options.isHti ?? null;
  o.itemConfigs = (options.itemConfigs ?? []).map((i) =>
    maybeNew("CustomerItemConfig", i, cache, options.hasOwnProperty("itemConfigs"))
  );
  o.shouldCoverConstructionCosts = options.shouldCoverConstructionCosts ?? false;
  return o;
}

factories["Customer"] = newCustomer;

export interface SaveCustomerResultOptions {
  __typename?: "SaveCustomerResult";
  customer?: Customer | CustomerOptions;
}

export function newSaveCustomerResult(
  options: SaveCustomerResultOptions = {},
  cache: Record<string, any> = {},
): SaveCustomerResult {
  const o = (options.__typename ? options : cache["SaveCustomerResult"] = {}) as SaveCustomerResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveCustomerResult";
  o.customer = maybeNew("Customer", options.customer, cache, options.hasOwnProperty("customer"));
  return o;
}

factories["SaveCustomerResult"] = newSaveCustomerResult;

export interface CustomerItemConfigOptions {
  __typename?: "CustomerItemConfig";
  id?: CustomerItemConfig["id"];
  markupInBasisPoints?: CustomerItemConfig["markupInBasisPoints"];
  createdAt?: CustomerItemConfig["createdAt"];
  updatedAt?: CustomerItemConfig["updatedAt"];
  customer?: Customer | CustomerOptions;
  item?: Item | ItemOptions;
}

export function newCustomerItemConfig(
  options: CustomerItemConfigOptions = {},
  cache: Record<string, any> = {},
): CustomerItemConfig {
  const o = (options.__typename ? options : cache["CustomerItemConfig"] = {}) as CustomerItemConfig;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CustomerItemConfig";
  o.id = options.id ?? nextFactoryId("CustomerItemConfig");
  o.markupInBasisPoints = options.markupInBasisPoints ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.customer = maybeNew("Customer", options.customer, cache, options.hasOwnProperty("customer"));
  o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
  return o;
}

factories["CustomerItemConfig"] = newCustomerItemConfig;

export interface SaveCustomerItemConfigResultOptions {
  __typename?: "SaveCustomerItemConfigResult";
  customerItemConfig?: CustomerItemConfig | CustomerItemConfigOptions;
}

export function newSaveCustomerItemConfigResult(
  options: SaveCustomerItemConfigResultOptions = {},
  cache: Record<string, any> = {},
): SaveCustomerItemConfigResult {
  const o = (options.__typename ? options : cache["SaveCustomerItemConfigResult"] = {}) as SaveCustomerItemConfigResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveCustomerItemConfigResult";
  o.customerItemConfig = maybeNew(
    "CustomerItemConfig",
    options.customerItemConfig,
    cache,
    options.hasOwnProperty("customerItemConfig"),
  );
  return o;
}

factories["SaveCustomerItemConfigResult"] = newSaveCustomerItemConfigResult;

export interface CustomerOwnerEntityOptions {
  __typename?: "CustomerOwnerEntity";
  id?: CustomerOwnerEntity["id"];
  name?: CustomerOwnerEntity["name"];
  intacctId?: CustomerOwnerEntity["intacctId"];
  createdAt?: CustomerOwnerEntity["createdAt"];
  updatedAt?: CustomerOwnerEntity["updatedAt"];
  isHti?: CustomerOwnerEntity["isHti"];
  warrantyLengthInDays?: CustomerOwnerEntity["warrantyLengthInDays"];
}

export function newCustomerOwnerEntity(
  options: CustomerOwnerEntityOptions = {},
  cache: Record<string, any> = {},
): CustomerOwnerEntity {
  const o = (options.__typename ? options : cache["CustomerOwnerEntity"] = {}) as CustomerOwnerEntity;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CustomerOwnerEntity";
  o.id = options.id ?? nextFactoryId("CustomerOwnerEntity");
  o.name = options.name ?? "name";
  o.intacctId = options.intacctId ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.isHti = options.isHti ?? false;
  o.warrantyLengthInDays = options.warrantyLengthInDays ?? 0;
  return o;
}

factories["CustomerOwnerEntity"] = newCustomerOwnerEntity;

export interface SaveCustomerOwnerEntityResultOptions {
  __typename?: "SaveCustomerOwnerEntityResult";
  customerOwnerEntity?: CustomerOwnerEntity | CustomerOwnerEntityOptions;
}

export function newSaveCustomerOwnerEntityResult(
  options: SaveCustomerOwnerEntityResultOptions = {},
  cache: Record<string, any> = {},
): SaveCustomerOwnerEntityResult {
  const o =
    (options.__typename ? options : cache["SaveCustomerOwnerEntityResult"] = {}) as SaveCustomerOwnerEntityResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveCustomerOwnerEntityResult";
  o.customerOwnerEntity = maybeNew(
    "CustomerOwnerEntity",
    options.customerOwnerEntity,
    cache,
    options.hasOwnProperty("customerOwnerEntity"),
  );
  return o;
}

factories["SaveCustomerOwnerEntityResult"] = newSaveCustomerOwnerEntityResult;

export interface CutoffOptions {
  __typename?: "Cutoff";
  id?: Cutoff["id"];
  name?: Cutoff["name"];
  description?: Cutoff["description"];
  createdAt?: Cutoff["createdAt"];
  updatedAt?: Cutoff["updatedAt"];
  items?: Array<Item | ItemOptions>;
  projects?: Array<ProjectCutoff | ProjectCutoffOptions>;
}

export function newCutoff(options: CutoffOptions = {}, cache: Record<string, any> = {}): Cutoff {
  const o = (options.__typename ? options : cache["Cutoff"] = {}) as Cutoff;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Cutoff";
  o.id = options.id ?? nextFactoryId("Cutoff");
  o.name = options.name ?? "name";
  o.description = options.description ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.items = (options.items ?? []).map((i) => maybeNew("Item", i, cache, options.hasOwnProperty("items")));
  o.projects = (options.projects ?? []).map((i) =>
    maybeNew("ProjectCutoff", i, cache, options.hasOwnProperty("projects"))
  );
  return o;
}

factories["Cutoff"] = newCutoff;

export interface SaveCutoffResultOptions {
  __typename?: "SaveCutoffResult";
  cutoff?: Cutoff | CutoffOptions;
}

export function newSaveCutoffResult(
  options: SaveCutoffResultOptions = {},
  cache: Record<string, any> = {},
): SaveCutoffResult {
  const o = (options.__typename ? options : cache["SaveCutoffResult"] = {}) as SaveCutoffResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveCutoffResult";
  o.cutoff = maybeNew("Cutoff", options.cutoff, cache, options.hasOwnProperty("cutoff"));
  return o;
}

factories["SaveCutoffResult"] = newSaveCutoffResult;

export interface DesignPackageOptions {
  __typename?: "DesignPackage";
  id?: DesignPackage["id"];
  name?: DesignPackage["name"];
  displayName?: DesignPackage["displayName"];
  description?: DesignPackage["description"];
  createdAt?: DesignPackage["createdAt"];
  updatedAt?: DesignPackage["updatedAt"];
  code?: DesignPackage["code"];
  displayCode?: DesignPackage["displayCode"];
  blueprintUrl?: Url | UrlOptions;
  status?: ReadyPlanStatusDetailOptions | ReadyPlanStatus;
  effectiveStatus?: ReadyPlanStatusDetailOptions | ReadyPlanStatus;
  options?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  optionGroups?: Array<ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions>;
  interiorDesignPackageProductOfferings?: Array<ProductOffering | ProductOfferingOptions>;
  exteriorDesignPackageProductOfferings?: Array<ProductOffering | ProductOfferingOptions>;
  planPackages?: Array<PlanPackage | PlanPackageOptions>;
  designPackageSources?: Array<DesignPackageSource | DesignPackageSourceOptions>;
  copyInProgress?: DesignPackage["copyInProgress"];
  slots?: Array<DesignPackageSlot | DesignPackageSlotOptions>;
  assets?: Array<ReadyPlanAsset | ReadyPlanAssetOptions>;
  lotTypes?: DesignPackage["lotTypes"];
  location?: DesignPackageLocationDetailOptions | DesignPackageLocation;
  markets?: Array<Market | MarketOptions>;
  aggregateActive?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  aggregateDraft?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  aggregateLatest?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  aggregateVersions?: Array<ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions>;
  availableUpdates?: Array<DesignPackagePlanUpdate | DesignPackagePlanUpdateOptions>;
  version?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  itemLocations?: Array<Location | LocationOptions>;
  costCodes?: Array<CostCode | CostCodeOptions>;
  canEditLineItems?: PotentialOperation2 | PotentialOperation2Options;
  contingencyMarkupPercentage?: DesignPackage["contingencyMarkupPercentage"];
  canEdit?: PotentialOperation2 | PotentialOperation2Options;
  syncErrors?: DesignPackage["syncErrors"];
  readyPlanLocations?: Array<ReadyPlanLocation | ReadyPlanLocationOptions>;
  potentialPersonalizationOptions?: Array<ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions>;
  potentialAddOnOptions?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  documents?: Array<Document | DocumentOptions>;
  combinations?: Array<DesignPackageOptionCombination | DesignPackageOptionCombinationOptions>;
  availableTargetGroups?: Array<ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions>;
  requiredOptions?: Array<ReadyPlanRequiredOption | ReadyPlanRequiredOptionOptions>;
  projectConfigs?: Array<ProjectReadyPlanConfig | ProjectReadyPlanConfigOptions>;
  owner?: InternalUser | InternalUserOptions | null;
  cabinetNotes?: DesignPackage["cabinetNotes"];
  cloneInProgress?: DesignPackage["cloneInProgress"];
}

export function newDesignPackage(options: DesignPackageOptions = {}, cache: Record<string, any> = {}): DesignPackage {
  const o = (options.__typename ? options : cache["DesignPackage"] = {}) as DesignPackage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DesignPackage";
  o.id = options.id ?? nextFactoryId("DesignPackage");
  o.name = options.name ?? "name";
  o.displayName = options.displayName ?? "displayName";
  o.description = options.description ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.code = options.code ?? null;
  o.displayCode = options.displayCode ?? null;
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.status = enumOrDetailOfReadyPlanStatus(options.status);
  o.effectiveStatus = enumOrDetailOfReadyPlanStatus(options.effectiveStatus);
  o.options = (options.options ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("options"))
  );
  o.optionGroups = (options.optionGroups ?? []).map((i) =>
    maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("optionGroups"))
  );
  o.interiorDesignPackageProductOfferings = (options.interiorDesignPackageProductOfferings ?? []).map((i) =>
    maybeNew("ProductOffering", i, cache, options.hasOwnProperty("interiorDesignPackageProductOfferings"))
  );
  o.exteriorDesignPackageProductOfferings = (options.exteriorDesignPackageProductOfferings ?? []).map((i) =>
    maybeNew("ProductOffering", i, cache, options.hasOwnProperty("exteriorDesignPackageProductOfferings"))
  );
  o.planPackages = (options.planPackages ?? []).map((i) =>
    maybeNew("PlanPackage", i, cache, options.hasOwnProperty("planPackages"))
  );
  o.designPackageSources = (options.designPackageSources ?? []).map((i) =>
    maybeNew("DesignPackageSource", i, cache, options.hasOwnProperty("designPackageSources"))
  );
  o.copyInProgress = options.copyInProgress ?? false;
  o.slots = (options.slots ?? []).map((i) => maybeNew("DesignPackageSlot", i, cache, options.hasOwnProperty("slots")));
  o.assets = (options.assets ?? []).map((i) => maybeNew("ReadyPlanAsset", i, cache, options.hasOwnProperty("assets")));
  o.lotTypes = options.lotTypes ?? [];
  o.location = enumOrDetailOfDesignPackageLocation(options.location);
  o.markets = (options.markets ?? []).map((i) => maybeNew("Market", i, cache, options.hasOwnProperty("markets")));
  o.aggregateActive = maybeNewOrNull("ReadyPlanAggregateVersion", options.aggregateActive, cache);
  o.aggregateDraft = maybeNewOrNull("ReadyPlanAggregateVersion", options.aggregateDraft, cache);
  o.aggregateLatest = maybeNew(
    "ReadyPlanAggregateVersion",
    options.aggregateLatest,
    cache,
    options.hasOwnProperty("aggregateLatest"),
  );
  o.aggregateVersions = (options.aggregateVersions ?? []).map((i) =>
    maybeNew("ReadyPlanAggregateVersion", i, cache, options.hasOwnProperty("aggregateVersions"))
  );
  o.availableUpdates = (options.availableUpdates ?? []).map((i) =>
    maybeNew("DesignPackagePlanUpdate", i, cache, options.hasOwnProperty("availableUpdates"))
  );
  o.version = maybeNew("ReadyPlanAggregateVersion", options.version, cache, options.hasOwnProperty("version"));
  o.itemLocations = (options.itemLocations ?? []).map((i) =>
    maybeNew("Location", i, cache, options.hasOwnProperty("itemLocations"))
  );
  o.costCodes = (options.costCodes ?? []).map((i) =>
    maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
  );
  o.canEditLineItems = maybeNew(
    "PotentialOperation2",
    options.canEditLineItems,
    cache,
    options.hasOwnProperty("canEditLineItems"),
  );
  o.contingencyMarkupPercentage = options.contingencyMarkupPercentage ?? null;
  o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
  o.syncErrors = options.syncErrors ?? null;
  o.readyPlanLocations = (options.readyPlanLocations ?? []).map((i) =>
    maybeNew("ReadyPlanLocation", i, cache, options.hasOwnProperty("readyPlanLocations"))
  );
  o.potentialPersonalizationOptions = (options.potentialPersonalizationOptions ?? []).map((i) =>
    maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("potentialPersonalizationOptions"))
  );
  o.potentialAddOnOptions = (options.potentialAddOnOptions ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("potentialAddOnOptions"))
  );
  o.documents = (options.documents ?? []).map((i) =>
    maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
  );
  o.combinations = (options.combinations ?? []).map((i) =>
    maybeNew("DesignPackageOptionCombination", i, cache, options.hasOwnProperty("combinations"))
  );
  o.availableTargetGroups = (options.availableTargetGroups ?? []).map((i) =>
    maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("availableTargetGroups"))
  );
  o.requiredOptions = (options.requiredOptions ?? []).map((i) =>
    maybeNew("ReadyPlanRequiredOption", i, cache, options.hasOwnProperty("requiredOptions"))
  );
  o.projectConfigs = (options.projectConfigs ?? []).map((i) =>
    maybeNew("ProjectReadyPlanConfig", i, cache, options.hasOwnProperty("projectConfigs"))
  );
  o.owner = maybeNewOrNull("InternalUser", options.owner, cache);
  o.cabinetNotes = options.cabinetNotes ?? null;
  o.cloneInProgress = options.cloneInProgress ?? false;
  return o;
}

factories["DesignPackage"] = newDesignPackage;

export interface CreateDesignPackagePlaceholderTliResultOptions {
  __typename?: "CreateDesignPackagePlaceholderTliResult";
  placeholderTli?: TakeoffLineItem | TakeoffLineItemOptions;
  readyPlanAggregateVersion?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
}

export function newCreateDesignPackagePlaceholderTliResult(
  options: CreateDesignPackagePlaceholderTliResultOptions = {},
  cache: Record<string, any> = {},
): CreateDesignPackagePlaceholderTliResult {
  const o =
    (options.__typename
      ? options
      : cache["CreateDesignPackagePlaceholderTliResult"] = {}) as CreateDesignPackagePlaceholderTliResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CreateDesignPackagePlaceholderTliResult";
  o.placeholderTli = maybeNew(
    "TakeoffLineItem",
    options.placeholderTli,
    cache,
    options.hasOwnProperty("placeholderTli"),
  );
  o.readyPlanAggregateVersion = maybeNew(
    "ReadyPlanAggregateVersion",
    options.readyPlanAggregateVersion,
    cache,
    options.hasOwnProperty("readyPlanAggregateVersion"),
  );
  return o;
}

factories["CreateDesignPackagePlaceholderTliResult"] = newCreateDesignPackagePlaceholderTliResult;

export interface SaveDesignPackageResultOptions {
  __typename?: "SaveDesignPackageResult";
  designPackage?: DesignPackage | DesignPackageOptions;
}

export function newSaveDesignPackageResult(
  options: SaveDesignPackageResultOptions = {},
  cache: Record<string, any> = {},
): SaveDesignPackageResult {
  const o = (options.__typename ? options : cache["SaveDesignPackageResult"] = {}) as SaveDesignPackageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveDesignPackageResult";
  o.designPackage = maybeNew("DesignPackage", options.designPackage, cache, options.hasOwnProperty("designPackage"));
  return o;
}

factories["SaveDesignPackageResult"] = newSaveDesignPackageResult;

export interface SaveDesignPackageUpdatesResultOptions {
  __typename?: "SaveDesignPackageUpdatesResult";
  designPackage?: DesignPackage | DesignPackageOptions;
}

export function newSaveDesignPackageUpdatesResult(
  options: SaveDesignPackageUpdatesResultOptions = {},
  cache: Record<string, any> = {},
): SaveDesignPackageUpdatesResult {
  const o =
    (options.__typename ? options : cache["SaveDesignPackageUpdatesResult"] = {}) as SaveDesignPackageUpdatesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveDesignPackageUpdatesResult";
  o.designPackage = maybeNew("DesignPackage", options.designPackage, cache, options.hasOwnProperty("designPackage"));
  return o;
}

factories["SaveDesignPackageUpdatesResult"] = newSaveDesignPackageUpdatesResult;

export interface DesignPackagesPageResultOptions {
  __typename?: "DesignPackagesPageResult";
  entities?: Array<DesignPackage | DesignPackageOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newDesignPackagesPageResult(
  options: DesignPackagesPageResultOptions = {},
  cache: Record<string, any> = {},
): DesignPackagesPageResult {
  const o = (options.__typename ? options : cache["DesignPackagesPageResult"] = {}) as DesignPackagesPageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DesignPackagesPageResult";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("DesignPackage", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["DesignPackagesPageResult"] = newDesignPackagesPageResult;

export interface DesignPackageSlotOptions {
  __typename?: "DesignPackageSlot";
  id?: DesignPackageSlot["id"];
  slot?: ItemSlot | ItemSlotOptions;
  coverage?: DesignPackageSlot["coverage"];
  isFullyAssigned?: DesignPackageSlot["isFullyAssigned"];
  items?: Array<TakeoffLineItem | TakeoffLineItemOptions>;
}

export function newDesignPackageSlot(
  options: DesignPackageSlotOptions = {},
  cache: Record<string, any> = {},
): DesignPackageSlot {
  const o = (options.__typename ? options : cache["DesignPackageSlot"] = {}) as DesignPackageSlot;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DesignPackageSlot";
  o.id = options.id ?? nextFactoryId("DesignPackageSlot");
  o.slot = maybeNew("ItemSlot", options.slot, cache, options.hasOwnProperty("slot"));
  o.coverage = options.coverage ?? 0;
  o.isFullyAssigned = options.isFullyAssigned ?? false;
  o.items = (options.items ?? []).map((i) => maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("items")));
  return o;
}

factories["DesignPackageSlot"] = newDesignPackageSlot;

export interface DesignPackageOptionCombinationOptions {
  __typename?: "DesignPackageOptionCombination";
  id?: DesignPackageOptionCombination["id"];
  combination?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  options?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  name?: DesignPackageOptionCombination["name"];
}

export function newDesignPackageOptionCombination(
  options: DesignPackageOptionCombinationOptions = {},
  cache: Record<string, any> = {},
): DesignPackageOptionCombination {
  const o =
    (options.__typename ? options : cache["DesignPackageOptionCombination"] = {}) as DesignPackageOptionCombination;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DesignPackageOptionCombination";
  o.id = options.id ?? nextFactoryId("DesignPackageOptionCombination");
  o.combination = (options.combination ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("combination"))
  );
  o.options = (options.options ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("options"))
  );
  o.name = options.name ?? "name";
  return o;
}

factories["DesignPackageOptionCombination"] = newDesignPackageOptionCombination;

export interface DesignPackageFinishSchedulePageResultOptions {
  __typename?: "DesignPackageFinishSchedulePageResult";
  entities?: Array<TakeoffLineItem | TakeoffLineItemOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newDesignPackageFinishSchedulePageResult(
  options: DesignPackageFinishSchedulePageResultOptions = {},
  cache: Record<string, any> = {},
): DesignPackageFinishSchedulePageResult {
  const o =
    (options.__typename
      ? options
      : cache["DesignPackageFinishSchedulePageResult"] = {}) as DesignPackageFinishSchedulePageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DesignPackageFinishSchedulePageResult";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["DesignPackageFinishSchedulePageResult"] = newDesignPackageFinishSchedulePageResult;

export interface PlaceholderCombinationsResultOptions {
  __typename?: "PlaceholderCombinationsResult";
  takeoffLineItem?: TakeoffLineItem | TakeoffLineItemOptions;
  combinations?: Array<DesignPackageOptionCombination | DesignPackageOptionCombinationOptions>;
}

export function newPlaceholderCombinationsResult(
  options: PlaceholderCombinationsResultOptions = {},
  cache: Record<string, any> = {},
): PlaceholderCombinationsResult {
  const o =
    (options.__typename ? options : cache["PlaceholderCombinationsResult"] = {}) as PlaceholderCombinationsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PlaceholderCombinationsResult";
  o.takeoffLineItem = maybeNew(
    "TakeoffLineItem",
    options.takeoffLineItem,
    cache,
    options.hasOwnProperty("takeoffLineItem"),
  );
  o.combinations = (options.combinations ?? []).map((i) =>
    maybeNew("DesignPackageOptionCombination", i, cache, options.hasOwnProperty("combinations"))
  );
  return o;
}

factories["PlaceholderCombinationsResult"] = newPlaceholderCombinationsResult;

export interface SavePersonalizationOptionGroupResultOptions {
  __typename?: "SavePersonalizationOptionGroupResult";
  version?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  optionGroup?: ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions;
}

export function newSavePersonalizationOptionGroupResult(
  options: SavePersonalizationOptionGroupResultOptions = {},
  cache: Record<string, any> = {},
): SavePersonalizationOptionGroupResult {
  const o =
    (options.__typename
      ? options
      : cache["SavePersonalizationOptionGroupResult"] = {}) as SavePersonalizationOptionGroupResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SavePersonalizationOptionGroupResult";
  o.version = maybeNew("ReadyPlanAggregateVersion", options.version, cache, options.hasOwnProperty("version"));
  o.optionGroup = maybeNew("ReadyPlanOptionGroup", options.optionGroup, cache, options.hasOwnProperty("optionGroup"));
  return o;
}

factories["SavePersonalizationOptionGroupResult"] = newSavePersonalizationOptionGroupResult;

export interface CopyDesignPackageCardsResultOptions {
  __typename?: "CopyDesignPackageCardsResult";
  sourePlaceholderTli?: TakeoffLineItem | TakeoffLineItemOptions;
  targetPlaceholderTlis?: Array<TakeoffLineItem | TakeoffLineItemOptions>;
  addedTlis?: Array<TakeoffLineItem | TakeoffLineItemOptions>;
  version?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
}

export function newCopyDesignPackageCardsResult(
  options: CopyDesignPackageCardsResultOptions = {},
  cache: Record<string, any> = {},
): CopyDesignPackageCardsResult {
  const o = (options.__typename ? options : cache["CopyDesignPackageCardsResult"] = {}) as CopyDesignPackageCardsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CopyDesignPackageCardsResult";
  o.sourePlaceholderTli = maybeNew(
    "TakeoffLineItem",
    options.sourePlaceholderTli,
    cache,
    options.hasOwnProperty("sourePlaceholderTli"),
  );
  o.targetPlaceholderTlis = (options.targetPlaceholderTlis ?? []).map((i) =>
    maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("targetPlaceholderTlis"))
  );
  o.addedTlis = (options.addedTlis ?? []).map((i) =>
    maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("addedTlis"))
  );
  o.version = maybeNew("ReadyPlanAggregateVersion", options.version, cache, options.hasOwnProperty("version"));
  return o;
}

factories["CopyDesignPackageCardsResult"] = newCopyDesignPackageCardsResult;

export interface CopyDesignPackageSelectionsResultOptions {
  __typename?: "CopyDesignPackageSelectionsResult";
  updatedTakeoffLineItems?: Array<TakeoffLineItem | TakeoffLineItemOptions>;
  updatedReadyPlanOptions?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  updatedReadyPlanRequiredOptions?: Array<ReadyPlanRequiredOption | ReadyPlanRequiredOptionOptions>;
}

export function newCopyDesignPackageSelectionsResult(
  options: CopyDesignPackageSelectionsResultOptions = {},
  cache: Record<string, any> = {},
): CopyDesignPackageSelectionsResult {
  const o =
    (options.__typename
      ? options
      : cache["CopyDesignPackageSelectionsResult"] = {}) as CopyDesignPackageSelectionsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CopyDesignPackageSelectionsResult";
  o.updatedTakeoffLineItems = (options.updatedTakeoffLineItems ?? []).map((i) =>
    maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("updatedTakeoffLineItems"))
  );
  o.updatedReadyPlanOptions = (options.updatedReadyPlanOptions ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("updatedReadyPlanOptions"))
  );
  o.updatedReadyPlanRequiredOptions = (options.updatedReadyPlanRequiredOptions ?? []).map((i) =>
    maybeNew("ReadyPlanRequiredOption", i, cache, options.hasOwnProperty("updatedReadyPlanRequiredOptions"))
  );
  return o;
}

factories["CopyDesignPackageSelectionsResult"] = newCopyDesignPackageSelectionsResult;

export interface DesignPackagePlanUpdateOptions {
  __typename?: "DesignPackagePlanUpdate";
  id?: DesignPackagePlanUpdate["id"];
  createdAt?: DesignPackagePlanUpdate["createdAt"];
  updatedAt?: DesignPackagePlanUpdate["updatedAt"];
  source?: DesignPackageSource | DesignPackageSourceOptions;
  designPackage?: DesignPackage | DesignPackageOptions;
  accepted?: DesignPackagePlanUpdate["accepted"];
  planVersion?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  acceptedInVersion?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
}

export function newDesignPackagePlanUpdate(
  options: DesignPackagePlanUpdateOptions = {},
  cache: Record<string, any> = {},
): DesignPackagePlanUpdate {
  const o = (options.__typename ? options : cache["DesignPackagePlanUpdate"] = {}) as DesignPackagePlanUpdate;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DesignPackagePlanUpdate";
  o.id = options.id ?? nextFactoryId("DesignPackagePlanUpdate");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.source = maybeNew("DesignPackageSource", options.source, cache, options.hasOwnProperty("source"));
  o.designPackage = maybeNew("DesignPackage", options.designPackage, cache, options.hasOwnProperty("designPackage"));
  o.accepted = options.accepted ?? false;
  o.planVersion = maybeNew(
    "ReadyPlanAggregateVersion",
    options.planVersion,
    cache,
    options.hasOwnProperty("planVersion"),
  );
  o.acceptedInVersion = maybeNewOrNull("ReadyPlanAggregateVersion", options.acceptedInVersion, cache);
  return o;
}

factories["DesignPackagePlanUpdate"] = newDesignPackagePlanUpdate;

export interface DesignPackageSourceOptions {
  __typename?: "DesignPackageSource";
  id?: DesignPackageSource["id"];
  createdAt?: DesignPackageSource["createdAt"];
  updatedAt?: DesignPackageSource["updatedAt"];
  readyPlan?: DesignPackage | DesignPackageOptions;
  planPackage?: PlanPackage | PlanPackageOptions;
  copyInProgress?: DesignPackageSource["copyInProgress"];
  active?: DesignPackageSource["active"];
  versions?: Array<DesignPackageSourceVersion | DesignPackageSourceVersionOptions>;
  planUpdates?: Array<DesignPackagePlanUpdate | DesignPackagePlanUpdateOptions>;
  planPackageVersion?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
}

export function newDesignPackageSource(
  options: DesignPackageSourceOptions = {},
  cache: Record<string, any> = {},
): DesignPackageSource {
  const o = (options.__typename ? options : cache["DesignPackageSource"] = {}) as DesignPackageSource;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DesignPackageSource";
  o.id = options.id ?? nextFactoryId("DesignPackageSource");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.readyPlan = maybeNew("DesignPackage", options.readyPlan, cache, options.hasOwnProperty("readyPlan"));
  o.planPackage = maybeNew("PlanPackage", options.planPackage, cache, options.hasOwnProperty("planPackage"));
  o.copyInProgress = options.copyInProgress ?? false;
  o.active = options.active ?? false;
  o.versions = (options.versions ?? []).map((i) =>
    maybeNew("DesignPackageSourceVersion", i, cache, options.hasOwnProperty("versions"))
  );
  o.planUpdates = (options.planUpdates ?? []).map((i) =>
    maybeNew("DesignPackagePlanUpdate", i, cache, options.hasOwnProperty("planUpdates"))
  );
  o.planPackageVersion = maybeNewOrNull("ReadyPlanAggregateVersion", options.planPackageVersion, cache);
  return o;
}

factories["DesignPackageSource"] = newDesignPackageSource;

export interface SaveDesignPackageSourceResultOptions {
  __typename?: "SaveDesignPackageSourceResult";
  designPackageSource?: DesignPackageSource | DesignPackageSourceOptions;
}

export function newSaveDesignPackageSourceResult(
  options: SaveDesignPackageSourceResultOptions = {},
  cache: Record<string, any> = {},
): SaveDesignPackageSourceResult {
  const o =
    (options.__typename ? options : cache["SaveDesignPackageSourceResult"] = {}) as SaveDesignPackageSourceResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveDesignPackageSourceResult";
  o.designPackageSource = maybeNew(
    "DesignPackageSource",
    options.designPackageSource,
    cache,
    options.hasOwnProperty("designPackageSource"),
  );
  return o;
}

factories["SaveDesignPackageSourceResult"] = newSaveDesignPackageSourceResult;

export interface DesignPackageSourceVersionOptions {
  __typename?: "DesignPackageSourceVersion";
  id?: DesignPackageSourceVersion["id"];
  active?: DesignPackageSourceVersion["active"];
  createdAt?: DesignPackageSourceVersion["createdAt"];
  updatedAt?: DesignPackageSourceVersion["updatedAt"];
  identity?: DesignPackageSource | DesignPackageSourceOptions;
  final?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  first?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
}

export function newDesignPackageSourceVersion(
  options: DesignPackageSourceVersionOptions = {},
  cache: Record<string, any> = {},
): DesignPackageSourceVersion {
  const o = (options.__typename ? options : cache["DesignPackageSourceVersion"] = {}) as DesignPackageSourceVersion;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DesignPackageSourceVersion";
  o.id = options.id ?? nextFactoryId("DesignPackageSourceVersion");
  o.active = options.active ?? false;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.identity = maybeNew("DesignPackageSource", options.identity, cache, options.hasOwnProperty("identity"));
  o.final = maybeNewOrNull("ReadyPlanAggregateVersion", options.final, cache);
  o.first = maybeNew("ReadyPlanAggregateVersion", options.first, cache, options.hasOwnProperty("first"));
  return o;
}

factories["DesignPackageSourceVersion"] = newDesignPackageSourceVersion;

export interface DesignPackageVersionOptions {
  __typename?: "DesignPackageVersion";
  id?: DesignPackageVersion["id"];
  name?: DesignPackageVersion["name"];
  createdAt?: DesignPackageVersion["createdAt"];
  updatedAt?: DesignPackageVersion["updatedAt"];
  code?: DesignPackageVersion["code"];
  contingencyMarkupPercentage?: DesignPackageVersion["contingencyMarkupPercentage"];
  description?: DesignPackageVersion["description"];
  type?: ReadyPlanTypeDetailOptions | ReadyPlanType;
  lotTypes?: DesignPackageVersion["lotTypes"];
  identity?: DesignPackage | DesignPackageOptions;
  final?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  first?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  markets?: Array<Market | MarketOptions>;
  owner?: InternalUser | InternalUserOptions | null;
}

export function newDesignPackageVersion(
  options: DesignPackageVersionOptions = {},
  cache: Record<string, any> = {},
): DesignPackageVersion {
  const o = (options.__typename ? options : cache["DesignPackageVersion"] = {}) as DesignPackageVersion;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DesignPackageVersion";
  o.id = options.id ?? nextFactoryId("DesignPackageVersion");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.code = options.code ?? null;
  o.contingencyMarkupPercentage = options.contingencyMarkupPercentage ?? null;
  o.description = options.description ?? null;
  o.type = enumOrDetailOfReadyPlanType(options.type);
  o.lotTypes = options.lotTypes ?? [];
  o.identity = maybeNew("DesignPackage", options.identity, cache, options.hasOwnProperty("identity"));
  o.final = maybeNewOrNull("ReadyPlanAggregateVersion", options.final, cache);
  o.first = maybeNew("ReadyPlanAggregateVersion", options.first, cache, options.hasOwnProperty("first"));
  o.markets = (options.markets ?? []).map((i) => maybeNew("Market", i, cache, options.hasOwnProperty("markets")));
  o.owner = maybeNewOrNull("InternalUser", options.owner, cache);
  return o;
}

factories["DesignPackageVersion"] = newDesignPackageVersion;

export interface DevelopmentOptions {
  __typename?: "Development";
  id?: Development["id"];
  name?: Development["name"];
  blueprintUrl?: Url | UrlOptions;
  createdAt?: Development["createdAt"];
  updatedAt?: Development["updatedAt"];
  market?: Market | MarketOptions;
  cohorts?: Array<Cohort | CohortOptions> | null;
  schedules?: Array<Schedule | ScheduleOptions>;
  itemTemplates?: Array<ItemTemplate | ItemTemplateOptions>;
  commitments?: Array<DevelopmentCommitment | DevelopmentCommitmentOptions>;
  documents?: Array<Document | DocumentOptions>;
  bidContracts?: Array<BidContract | BidContractOptions>;
  readyPlans?: Array<ReadyPlan | ReadyPlanOptions>;
  directorOfConstruction?: InternalUser | InternalUserOptions | null;
  teamMembers?: Array<DevelopmentTeamMember | DevelopmentTeamMemberOptions>;
  toDos?: Array<ToDo | ToDoOptions>;
  options?: Array<DevelopmentOption | DevelopmentOptionOptions>;
  scheduleTemplates?: Array<ScheduleTemplate | ScheduleTemplateOptions>;
  sequenceSheetFollowers?: Array<InternalUser | InternalUserOptions>;
  isSequenceSheetFollower?: Development["isSequenceSheetFollower"];
  isTeamMember?: Development["isTeamMember"];
  canStopFollowingSequenceSheet?: PotentialOperation2 | PotentialOperation2Options;
  canGenerateTemplates?: PotentialOperation2 | PotentialOperation2Options;
  itemMappings?: Array<DevelopmentItemMapping | DevelopmentItemMappingOptions>;
  costMappingProgress?: CostMappingProgress | CostMappingProgressOptions;
  internalBudgetEstimate?: BidContract | BidContractOptions;
  specOptions?: Array<GlobalOption | GlobalOptionOptions>;
  featureFlags?: Array<FeatureFlag | FeatureFlagOptions>;
  tradePartners?: Array<TradePartner | TradePartnerOptions>;
  costCodes?: Array<CostCode | CostCodeOptions>;
  drops?: Array<Drop | DropOptions>;
  costCodesWithDraws?: Array<CostCode | CostCodeOptions>;
  schedulingExclusionDates?: Array<SchedulingExclusionDate | SchedulingExclusionDateOptions>;
  salesTaxOverrideInBasisPoints?: Development["salesTaxOverrideInBasisPoints"];
  salesTaxInBasisPoints?: Development["salesTaxInBasisPoints"];
}

export function newDevelopment(options: DevelopmentOptions = {}, cache: Record<string, any> = {}): Development {
  const o = (options.__typename ? options : cache["Development"] = {}) as Development;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Development";
  o.id = options.id ?? nextFactoryId("Development");
  o.name = options.name ?? "name";
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.market = maybeNew("Market", options.market, cache, options.hasOwnProperty("market"));
  o.cohorts = (options.cohorts ?? []).map((i) => maybeNew("Cohort", i, cache, options.hasOwnProperty("cohorts")));
  o.schedules = (options.schedules ?? []).map((i) =>
    maybeNew("Schedule", i, cache, options.hasOwnProperty("schedules"))
  );
  o.itemTemplates = (options.itemTemplates ?? []).map((i) =>
    maybeNew("ItemTemplate", i, cache, options.hasOwnProperty("itemTemplates"))
  );
  o.commitments = (options.commitments ?? []).map((i) =>
    maybeNew("DevelopmentCommitment", i, cache, options.hasOwnProperty("commitments"))
  );
  o.documents = (options.documents ?? []).map((i) =>
    maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
  );
  o.bidContracts = (options.bidContracts ?? []).map((i) =>
    maybeNew("BidContract", i, cache, options.hasOwnProperty("bidContracts"))
  );
  o.readyPlans = (options.readyPlans ?? []).map((i) =>
    maybeNew("ReadyPlan", i, cache, options.hasOwnProperty("readyPlans"))
  );
  o.directorOfConstruction = maybeNewOrNull("InternalUser", options.directorOfConstruction, cache);
  o.teamMembers = (options.teamMembers ?? []).map((i) =>
    maybeNew("DevelopmentTeamMember", i, cache, options.hasOwnProperty("teamMembers"))
  );
  o.toDos = (options.toDos ?? []).map((i) => maybeNew("ToDo", i, cache, options.hasOwnProperty("toDos")));
  o.options = (options.options ?? []).map((i) =>
    maybeNew("DevelopmentOption", i, cache, options.hasOwnProperty("options"))
  );
  o.scheduleTemplates = (options.scheduleTemplates ?? []).map((i) =>
    maybeNew("ScheduleTemplate", i, cache, options.hasOwnProperty("scheduleTemplates"))
  );
  o.sequenceSheetFollowers = (options.sequenceSheetFollowers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("sequenceSheetFollowers"))
  );
  o.isSequenceSheetFollower = options.isSequenceSheetFollower ?? false;
  o.isTeamMember = options.isTeamMember ?? false;
  o.canStopFollowingSequenceSheet = maybeNew(
    "PotentialOperation2",
    options.canStopFollowingSequenceSheet,
    cache,
    options.hasOwnProperty("canStopFollowingSequenceSheet"),
  );
  o.canGenerateTemplates = maybeNew(
    "PotentialOperation2",
    options.canGenerateTemplates,
    cache,
    options.hasOwnProperty("canGenerateTemplates"),
  );
  o.itemMappings = (options.itemMappings ?? []).map((i) =>
    maybeNew("DevelopmentItemMapping", i, cache, options.hasOwnProperty("itemMappings"))
  );
  o.costMappingProgress = maybeNew(
    "CostMappingProgress",
    options.costMappingProgress,
    cache,
    options.hasOwnProperty("costMappingProgress"),
  );
  o.internalBudgetEstimate = maybeNew(
    "BidContract",
    options.internalBudgetEstimate,
    cache,
    options.hasOwnProperty("internalBudgetEstimate"),
  );
  o.specOptions = (options.specOptions ?? []).map((i) =>
    maybeNew("GlobalOption", i, cache, options.hasOwnProperty("specOptions"))
  );
  o.featureFlags = (options.featureFlags ?? []).map((i) =>
    maybeNew("FeatureFlag", i, cache, options.hasOwnProperty("featureFlags"))
  );
  o.tradePartners = (options.tradePartners ?? []).map((i) =>
    maybeNew("TradePartner", i, cache, options.hasOwnProperty("tradePartners"))
  );
  o.costCodes = (options.costCodes ?? []).map((i) =>
    maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
  );
  o.drops = (options.drops ?? []).map((i) => maybeNew("Drop", i, cache, options.hasOwnProperty("drops")));
  o.costCodesWithDraws = (options.costCodesWithDraws ?? []).map((i) =>
    maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodesWithDraws"))
  );
  o.schedulingExclusionDates = (options.schedulingExclusionDates ?? []).map((i) =>
    maybeNew("SchedulingExclusionDate", i, cache, options.hasOwnProperty("schedulingExclusionDates"))
  );
  o.salesTaxOverrideInBasisPoints = options.salesTaxOverrideInBasisPoints ?? null;
  o.salesTaxInBasisPoints = options.salesTaxInBasisPoints ?? 0;
  return o;
}

factories["Development"] = newDevelopment;

export interface SaveDevelopmentsResultOptions {
  __typename?: "SaveDevelopmentsResult";
  developments?: Array<Development | DevelopmentOptions>;
}

export function newSaveDevelopmentsResult(
  options: SaveDevelopmentsResultOptions = {},
  cache: Record<string, any> = {},
): SaveDevelopmentsResult {
  const o = (options.__typename ? options : cache["SaveDevelopmentsResult"] = {}) as SaveDevelopmentsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveDevelopmentsResult";
  o.developments = (options.developments ?? []).map((i) =>
    maybeNew("Development", i, cache, options.hasOwnProperty("developments"))
  );
  return o;
}

factories["SaveDevelopmentsResult"] = newSaveDevelopmentsResult;

export interface DevelopmentItemMappingOptions {
  __typename?: "DevelopmentItemMapping";
  item?: Item | ItemOptions;
  costType?: DevelopmentItemMapping["costType"];
  location?: Location | LocationOptions;
  stage?: DevelopmentItemMapping["stage"];
  scheduleTemplateItemMappings?: Array<ScheduleTemplateItemMapping | ScheduleTemplateItemMappingOptions>;
}

export function newDevelopmentItemMapping(
  options: DevelopmentItemMappingOptions = {},
  cache: Record<string, any> = {},
): DevelopmentItemMapping {
  const o = (options.__typename ? options : cache["DevelopmentItemMapping"] = {}) as DevelopmentItemMapping;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DevelopmentItemMapping";
  o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
  o.costType = options.costType ?? CostType.Labor;
  o.location = maybeNew("Location", options.location, cache, options.hasOwnProperty("location"));
  o.stage = options.stage ?? Stage.PreConPlanning;
  o.scheduleTemplateItemMappings = (options.scheduleTemplateItemMappings ?? []).map((i) =>
    maybeNew("ScheduleTemplateItemMapping", i, cache, options.hasOwnProperty("scheduleTemplateItemMappings"))
  );
  return o;
}

factories["DevelopmentItemMapping"] = newDevelopmentItemMapping;

export interface CostMappingProgressOptions {
  __typename?: "CostMappingProgress";
  totalScheduleTemplateItemMappings?: CostMappingProgress["totalScheduleTemplateItemMappings"];
  totalMappingsForDevelopment?: CostMappingProgress["totalMappingsForDevelopment"];
  showCostMappingProgress?: CostMappingProgress["showCostMappingProgress"];
}

export function newCostMappingProgress(
  options: CostMappingProgressOptions = {},
  cache: Record<string, any> = {},
): CostMappingProgress {
  const o = (options.__typename ? options : cache["CostMappingProgress"] = {}) as CostMappingProgress;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CostMappingProgress";
  o.totalScheduleTemplateItemMappings = options.totalScheduleTemplateItemMappings ?? 0;
  o.totalMappingsForDevelopment = options.totalMappingsForDevelopment ?? 0;
  o.showCostMappingProgress = options.showCostMappingProgress ?? false;
  return o;
}

factories["CostMappingProgress"] = newCostMappingProgress;

export interface DevelopmentLotSummaryChartsResultOptions {
  __typename?: "DevelopmentLotSummaryChartsResult";
  development?: Development | DevelopmentOptions;
  acquired?: Array<CohortLotSummaryChart | CohortLotSummaryChartOptions>;
  totalAcquired?: DevelopmentLotSummaryChartsResult["totalAcquired"];
  permitSubmitted?: Array<CohortLotSummaryChart | CohortLotSummaryChartOptions>;
  totalPermitSubmitted?: DevelopmentLotSummaryChartsResult["totalPermitSubmitted"];
  permitReceived?: Array<CohortLotSummaryChart | CohortLotSummaryChartOptions>;
  totalPermitReceived?: DevelopmentLotSummaryChartsResult["totalPermitReceived"];
  verticalMobilization?: Array<CohortLotSummaryChart | CohortLotSummaryChartOptions>;
  totalVerticalMobilization?: DevelopmentLotSummaryChartsResult["totalVerticalMobilization"];
  verticalComplete?: Array<CohortLotSummaryChart | CohortLotSummaryChartOptions>;
  totalVerticalComplete?: DevelopmentLotSummaryChartsResult["totalVerticalComplete"];
  delivered?: Array<CohortLotSummaryChart | CohortLotSummaryChartOptions>;
  totalDelivered?: DevelopmentLotSummaryChartsResult["totalDelivered"];
}

export function newDevelopmentLotSummaryChartsResult(
  options: DevelopmentLotSummaryChartsResultOptions = {},
  cache: Record<string, any> = {},
): DevelopmentLotSummaryChartsResult {
  const o =
    (options.__typename
      ? options
      : cache["DevelopmentLotSummaryChartsResult"] = {}) as DevelopmentLotSummaryChartsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DevelopmentLotSummaryChartsResult";
  o.development = maybeNew("Development", options.development, cache, options.hasOwnProperty("development"));
  o.acquired = (options.acquired ?? []).map((i) =>
    maybeNew("CohortLotSummaryChart", i, cache, options.hasOwnProperty("acquired"))
  );
  o.totalAcquired = options.totalAcquired ?? 0;
  o.permitSubmitted = (options.permitSubmitted ?? []).map((i) =>
    maybeNew("CohortLotSummaryChart", i, cache, options.hasOwnProperty("permitSubmitted"))
  );
  o.totalPermitSubmitted = options.totalPermitSubmitted ?? 0;
  o.permitReceived = (options.permitReceived ?? []).map((i) =>
    maybeNew("CohortLotSummaryChart", i, cache, options.hasOwnProperty("permitReceived"))
  );
  o.totalPermitReceived = options.totalPermitReceived ?? 0;
  o.verticalMobilization = (options.verticalMobilization ?? []).map((i) =>
    maybeNew("CohortLotSummaryChart", i, cache, options.hasOwnProperty("verticalMobilization"))
  );
  o.totalVerticalMobilization = options.totalVerticalMobilization ?? 0;
  o.verticalComplete = (options.verticalComplete ?? []).map((i) =>
    maybeNew("CohortLotSummaryChart", i, cache, options.hasOwnProperty("verticalComplete"))
  );
  o.totalVerticalComplete = options.totalVerticalComplete ?? 0;
  o.delivered = (options.delivered ?? []).map((i) =>
    maybeNew("CohortLotSummaryChart", i, cache, options.hasOwnProperty("delivered"))
  );
  o.totalDelivered = options.totalDelivered ?? 0;
  return o;
}

factories["DevelopmentLotSummaryChartsResult"] = newDevelopmentLotSummaryChartsResult;

export interface CohortLotSummaryChartOptions {
  __typename?: "CohortLotSummaryChart";
  cohort?: Cohort | CohortOptions;
  total?: CohortLotSummaryChart["total"];
}

export function newCohortLotSummaryChart(
  options: CohortLotSummaryChartOptions = {},
  cache: Record<string, any> = {},
): CohortLotSummaryChart {
  const o = (options.__typename ? options : cache["CohortLotSummaryChart"] = {}) as CohortLotSummaryChart;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CohortLotSummaryChart";
  o.cohort = maybeNew("Cohort", options.cohort, cache, options.hasOwnProperty("cohort"));
  o.total = options.total ?? 0;
  return o;
}

factories["CohortLotSummaryChart"] = newCohortLotSummaryChart;

export interface DevelopmentCommitmentSummaryLineItemOptions {
  __typename?: "DevelopmentCommitmentSummaryLineItem";
  costInCents?: DevelopmentCommitmentSummaryLineItem["costInCents"];
  numberOfProjects?: DevelopmentCommitmentSummaryLineItem["numberOfProjects"];
  item?: Item | ItemOptions;
  quantity?: DevelopmentCommitmentSummaryLineItem["quantity"];
}

export function newDevelopmentCommitmentSummaryLineItem(
  options: DevelopmentCommitmentSummaryLineItemOptions = {},
  cache: Record<string, any> = {},
): DevelopmentCommitmentSummaryLineItem {
  const o =
    (options.__typename
      ? options
      : cache["DevelopmentCommitmentSummaryLineItem"] = {}) as DevelopmentCommitmentSummaryLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DevelopmentCommitmentSummaryLineItem";
  o.costInCents = options.costInCents ?? 0;
  o.numberOfProjects = options.numberOfProjects ?? 0;
  o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
  o.quantity = options.quantity ?? 0;
  return o;
}

factories["DevelopmentCommitmentSummaryLineItem"] = newDevelopmentCommitmentSummaryLineItem;

export interface DevelopmentCommitmentSummaryOptions {
  __typename?: "DevelopmentCommitmentSummary";
  lineItems?: Array<DevelopmentCommitmentSummaryLineItem | DevelopmentCommitmentSummaryLineItemOptions>;
}

export function newDevelopmentCommitmentSummary(
  options: DevelopmentCommitmentSummaryOptions = {},
  cache: Record<string, any> = {},
): DevelopmentCommitmentSummary {
  const o = (options.__typename ? options : cache["DevelopmentCommitmentSummary"] = {}) as DevelopmentCommitmentSummary;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DevelopmentCommitmentSummary";
  o.lineItems = (options.lineItems ?? []).map((i) =>
    maybeNew("DevelopmentCommitmentSummaryLineItem", i, cache, options.hasOwnProperty("lineItems"))
  );
  return o;
}

factories["DevelopmentCommitmentSummary"] = newDevelopmentCommitmentSummary;

export interface SaveDevelopmentCommitmentResultOptions {
  __typename?: "SaveDevelopmentCommitmentResult";
  developmentCommitment?: DevelopmentCommitment | DevelopmentCommitmentOptions;
}

export function newSaveDevelopmentCommitmentResult(
  options: SaveDevelopmentCommitmentResultOptions = {},
  cache: Record<string, any> = {},
): SaveDevelopmentCommitmentResult {
  const o =
    (options.__typename ? options : cache["SaveDevelopmentCommitmentResult"] = {}) as SaveDevelopmentCommitmentResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveDevelopmentCommitmentResult";
  o.developmentCommitment = maybeNew(
    "DevelopmentCommitment",
    options.developmentCommitment,
    cache,
    options.hasOwnProperty("developmentCommitment"),
  );
  return o;
}

factories["SaveDevelopmentCommitmentResult"] = newSaveDevelopmentCommitmentResult;

export interface DevelopmentCommitmentPotentialLineItemOptions {
  __typename?: "DevelopmentCommitmentPotentialLineItem";
  item?: Item | ItemOptions;
  costType?: DevelopmentCommitmentPotentialLineItem["costType"];
  location?: Location | LocationOptions;
  totalCostInCents?: DevelopmentCommitmentPotentialLineItem["totalCostInCents"];
  projects?: DevelopmentCommitmentPotentialLineItem["projects"];
}

export function newDevelopmentCommitmentPotentialLineItem(
  options: DevelopmentCommitmentPotentialLineItemOptions = {},
  cache: Record<string, any> = {},
): DevelopmentCommitmentPotentialLineItem {
  const o =
    (options.__typename
      ? options
      : cache["DevelopmentCommitmentPotentialLineItem"] = {}) as DevelopmentCommitmentPotentialLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DevelopmentCommitmentPotentialLineItem";
  o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
  o.costType = options.costType ?? CostType.Labor;
  o.location = maybeNew("Location", options.location, cache, options.hasOwnProperty("location"));
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.projects = options.projects ?? [];
  return o;
}

factories["DevelopmentCommitmentPotentialLineItem"] = newDevelopmentCommitmentPotentialLineItem;

export interface DevelopmentCommitmentCostCodeSummaryOptions {
  __typename?: "DevelopmentCommitmentCostCodeSummary";
  costCode?: CostCode | CostCodeOptions;
  numberOfProjects?: DevelopmentCommitmentCostCodeSummary["numberOfProjects"];
  quantity?: DevelopmentCommitmentCostCodeSummary["quantity"];
}

export function newDevelopmentCommitmentCostCodeSummary(
  options: DevelopmentCommitmentCostCodeSummaryOptions = {},
  cache: Record<string, any> = {},
): DevelopmentCommitmentCostCodeSummary {
  const o =
    (options.__typename
      ? options
      : cache["DevelopmentCommitmentCostCodeSummary"] = {}) as DevelopmentCommitmentCostCodeSummary;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DevelopmentCommitmentCostCodeSummary";
  o.costCode = maybeNew("CostCode", options.costCode, cache, options.hasOwnProperty("costCode"));
  o.numberOfProjects = options.numberOfProjects ?? 0;
  o.quantity = options.quantity ?? 0;
  return o;
}

factories["DevelopmentCommitmentCostCodeSummary"] = newDevelopmentCommitmentCostCodeSummary;

export interface DeleteDevelopmentCommitmentProjectsAndCommitmentsResultOptions {
  __typename?: "DeleteDevelopmentCommitmentProjectsAndCommitmentsResult";
  developmentCommitment?: DevelopmentCommitment | DevelopmentCommitmentOptions;
}

export function newDeleteDevelopmentCommitmentProjectsAndCommitmentsResult(
  options: DeleteDevelopmentCommitmentProjectsAndCommitmentsResultOptions = {},
  cache: Record<string, any> = {},
): DeleteDevelopmentCommitmentProjectsAndCommitmentsResult {
  const o =
    (options.__typename
      ? options
      : cache["DeleteDevelopmentCommitmentProjectsAndCommitmentsResult"] =
        {}) as DeleteDevelopmentCommitmentProjectsAndCommitmentsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeleteDevelopmentCommitmentProjectsAndCommitmentsResult";
  o.developmentCommitment = maybeNew(
    "DevelopmentCommitment",
    options.developmentCommitment,
    cache,
    options.hasOwnProperty("developmentCommitment"),
  );
  return o;
}

factories["DeleteDevelopmentCommitmentProjectsAndCommitmentsResult"] =
  newDeleteDevelopmentCommitmentProjectsAndCommitmentsResult;

export interface DevelopmentCommitmentsPageOptions {
  __typename?: "DevelopmentCommitmentsPage";
  entities?: Array<DevelopmentCommitment | DevelopmentCommitmentOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newDevelopmentCommitmentsPage(
  options: DevelopmentCommitmentsPageOptions = {},
  cache: Record<string, any> = {},
): DevelopmentCommitmentsPage {
  const o = (options.__typename ? options : cache["DevelopmentCommitmentsPage"] = {}) as DevelopmentCommitmentsPage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DevelopmentCommitmentsPage";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("DevelopmentCommitment", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["DevelopmentCommitmentsPage"] = newDevelopmentCommitmentsPage;

export interface DevelopmentOptionOptions {
  __typename?: "DevelopmentOption";
  id?: DevelopmentOption["id"];
  shortName?: DevelopmentOption["shortName"];
  createdAt?: DevelopmentOption["createdAt"];
  updatedAt?: DevelopmentOption["updatedAt"];
  development?: Development | DevelopmentOptions;
  globalOption?: GlobalOption | GlobalOptionOptions;
}

export function newDevelopmentOption(
  options: DevelopmentOptionOptions = {},
  cache: Record<string, any> = {},
): DevelopmentOption {
  const o = (options.__typename ? options : cache["DevelopmentOption"] = {}) as DevelopmentOption;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DevelopmentOption";
  o.id = options.id ?? nextFactoryId("DevelopmentOption");
  o.shortName = options.shortName ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.development = maybeNew("Development", options.development, cache, options.hasOwnProperty("development"));
  o.globalOption = maybeNew("GlobalOption", options.globalOption, cache, options.hasOwnProperty("globalOption"));
  return o;
}

factories["DevelopmentOption"] = newDevelopmentOption;

export interface SaveDevelopmentOptionsResultOptions {
  __typename?: "SaveDevelopmentOptionsResult";
  developmentOptions?: Array<DevelopmentOption | DevelopmentOptionOptions>;
}

export function newSaveDevelopmentOptionsResult(
  options: SaveDevelopmentOptionsResultOptions = {},
  cache: Record<string, any> = {},
): SaveDevelopmentOptionsResult {
  const o = (options.__typename ? options : cache["SaveDevelopmentOptionsResult"] = {}) as SaveDevelopmentOptionsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveDevelopmentOptionsResult";
  o.developmentOptions = (options.developmentOptions ?? []).map((i) =>
    maybeNew("DevelopmentOption", i, cache, options.hasOwnProperty("developmentOptions"))
  );
  return o;
}

factories["SaveDevelopmentOptionsResult"] = newSaveDevelopmentOptionsResult;

export interface DevelopmentTeamMemberOptions {
  __typename?: "DevelopmentTeamMember";
  id?: DevelopmentTeamMember["id"];
  createdAt?: DevelopmentTeamMember["createdAt"];
  updatedAt?: DevelopmentTeamMember["updatedAt"];
  projectRole?: ProjectRoleDetailOptions | ProjectRole;
  development?: Development | DevelopmentOptions;
  internalUser?: InternalUser | InternalUserOptions;
}

export function newDevelopmentTeamMember(
  options: DevelopmentTeamMemberOptions = {},
  cache: Record<string, any> = {},
): DevelopmentTeamMember {
  const o = (options.__typename ? options : cache["DevelopmentTeamMember"] = {}) as DevelopmentTeamMember;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DevelopmentTeamMember";
  o.id = options.id ?? nextFactoryId("DevelopmentTeamMember");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.projectRole = enumOrDetailOfProjectRole(options.projectRole);
  o.development = maybeNew("Development", options.development, cache, options.hasOwnProperty("development"));
  o.internalUser = maybeNew("InternalUser", options.internalUser, cache, options.hasOwnProperty("internalUser"));
  return o;
}

factories["DevelopmentTeamMember"] = newDevelopmentTeamMember;

export interface DocumentsPageResultOptions {
  __typename?: "DocumentsPageResult";
  entities?: Array<Document | DocumentOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newDocumentsPageResult(
  options: DocumentsPageResultOptions = {},
  cache: Record<string, any> = {},
): DocumentsPageResult {
  const o = (options.__typename ? options : cache["DocumentsPageResult"] = {}) as DocumentsPageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DocumentsPageResult";
  o.entities = (options.entities ?? []).map((i) => maybeNew("Document", i, cache, options.hasOwnProperty("entities")));
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["DocumentsPageResult"] = newDocumentsPageResult;

export interface DeleteDocumentsResultOptions {
  __typename?: "DeleteDocumentsResult";
  parents?: Array<
    | DocumentParent
    | DevelopmentOptions
    | RequireTypename<PlanPackageOptions>
    | RequireTypename<StandaloneProjectOptions>
    | RequireTypename<RegionOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>
  >;
  emptyResult?: DeleteDocumentsResult["emptyResult"];
  dummyString?: DeleteDocumentsResult["dummyString"];
}

export function newDeleteDocumentsResult(
  options: DeleteDocumentsResultOptions = {},
  cache: Record<string, any> = {},
): DeleteDocumentsResult {
  const o = (options.__typename ? options : cache["DeleteDocumentsResult"] = {}) as DeleteDocumentsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeleteDocumentsResult";
  o.parents = (options.parents ?? []).map((i) =>
    maybeNew(i?.__typename ?? "{Development", i, cache, options.hasOwnProperty("parents"))
  );
  o.emptyResult = options.emptyResult ?? null;
  o.dummyString = options.dummyString ?? null;
  return o;
}

factories["DeleteDocumentsResult"] = newDeleteDocumentsResult;

export interface CreateDocumentPendingUploadResultOptions {
  __typename?: "CreateDocumentPendingUploadResult";
  signedUrl?: CreateDocumentPendingUploadResult["signedUrl"];
  documentId?: CreateDocumentPendingUploadResult["documentId"];
}

export function newCreateDocumentPendingUploadResult(
  options: CreateDocumentPendingUploadResultOptions = {},
  cache: Record<string, any> = {},
): CreateDocumentPendingUploadResult {
  const o =
    (options.__typename
      ? options
      : cache["CreateDocumentPendingUploadResult"] = {}) as CreateDocumentPendingUploadResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CreateDocumentPendingUploadResult";
  o.signedUrl = options.signedUrl ?? "signedUrl";
  o.documentId = options.documentId ?? "documentId";
  return o;
}

factories["CreateDocumentPendingUploadResult"] = newCreateDocumentPendingUploadResult;

export interface MarkDocumentAsUploadedResultOptions {
  __typename?: "MarkDocumentAsUploadedResult";
  document?: Document | DocumentOptions;
}

export function newMarkDocumentAsUploadedResult(
  options: MarkDocumentAsUploadedResultOptions = {},
  cache: Record<string, any> = {},
): MarkDocumentAsUploadedResult {
  const o = (options.__typename ? options : cache["MarkDocumentAsUploadedResult"] = {}) as MarkDocumentAsUploadedResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MarkDocumentAsUploadedResult";
  o.document = maybeNew("Document", options.document, cache, options.hasOwnProperty("document"));
  return o;
}

factories["MarkDocumentAsUploadedResult"] = newMarkDocumentAsUploadedResult;

export interface ToggleDocumentAsFavoritedResultOptions {
  __typename?: "ToggleDocumentAsFavoritedResult";
  document?: Document | DocumentOptions;
}

export function newToggleDocumentAsFavoritedResult(
  options: ToggleDocumentAsFavoritedResultOptions = {},
  cache: Record<string, any> = {},
): ToggleDocumentAsFavoritedResult {
  const o =
    (options.__typename ? options : cache["ToggleDocumentAsFavoritedResult"] = {}) as ToggleDocumentAsFavoritedResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ToggleDocumentAsFavoritedResult";
  o.document = maybeNew("Document", options.document, cache, options.hasOwnProperty("document"));
  return o;
}

factories["ToggleDocumentAsFavoritedResult"] = newToggleDocumentAsFavoritedResult;

export interface SaveDocumentsResultOptions {
  __typename?: "SaveDocumentsResult";
  documents?: Array<Document | DocumentOptions>;
}

export function newSaveDocumentsResult(
  options: SaveDocumentsResultOptions = {},
  cache: Record<string, any> = {},
): SaveDocumentsResult {
  const o = (options.__typename ? options : cache["SaveDocumentsResult"] = {}) as SaveDocumentsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveDocumentsResult";
  o.documents = (options.documents ?? []).map((i) =>
    maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
  );
  return o;
}

factories["SaveDocumentsResult"] = newSaveDocumentsResult;

export interface DropOptions {
  __typename?: "Drop";
  id?: Drop["id"];
  name?: Drop["name"];
  code?: Drop["code"];
  createdAt?: Drop["createdAt"];
  updatedAt?: Drop["updatedAt"];
  costCode?: CostCode | CostCodeOptions;
  development?: Development | DevelopmentOptions | null;
  globalPlanTask?: GlobalPlanTask | GlobalPlanTaskOptions;
  locations?: Array<Location | LocationOptions>;
  order?: Drop["order"];
  commitments?: Array<Commitment | CommitmentOptions>;
  productOfferingIncomingUpdates?: Array<ProductOfferingIncomingUpdate | ProductOfferingIncomingUpdateOptions>;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
}

export function newDrop(options: DropOptions = {}, cache: Record<string, any> = {}): Drop {
  const o = (options.__typename ? options : cache["Drop"] = {}) as Drop;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Drop";
  o.id = options.id ?? nextFactoryId("Drop");
  o.name = options.name ?? "name";
  o.code = options.code ?? "code";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.costCode = maybeNew("CostCode", options.costCode, cache, options.hasOwnProperty("costCode"));
  o.development = maybeNewOrNull("Development", options.development, cache);
  o.globalPlanTask = maybeNew(
    "GlobalPlanTask",
    options.globalPlanTask,
    cache,
    options.hasOwnProperty("globalPlanTask"),
  );
  o.locations = (options.locations ?? []).map((i) =>
    maybeNew("Location", i, cache, options.hasOwnProperty("locations"))
  );
  o.order = options.order ?? 0;
  o.commitments = (options.commitments ?? []).map((i) =>
    maybeNew("Commitment", i, cache, options.hasOwnProperty("commitments"))
  );
  o.productOfferingIncomingUpdates = (options.productOfferingIncomingUpdates ?? []).map((i) =>
    maybeNew("ProductOfferingIncomingUpdate", i, cache, options.hasOwnProperty("productOfferingIncomingUpdates"))
  );
  o.project = maybeNewOrNull("Project", options.project, cache);
  return o;
}

factories["Drop"] = newDrop;

export interface SaveDropResultOptions {
  __typename?: "SaveDropResult";
  drop?: Drop | DropOptions;
}

export function newSaveDropResult(
  options: SaveDropResultOptions = {},
  cache: Record<string, any> = {},
): SaveDropResult {
  const o = (options.__typename ? options : cache["SaveDropResult"] = {}) as SaveDropResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveDropResult";
  o.drop = maybeNew("Drop", options.drop, cache, options.hasOwnProperty("drop"));
  return o;
}

factories["SaveDropResult"] = newSaveDropResult;

export interface ActivityPlanningStateDetailOptions {
  __typename?: "ActivityPlanningStateDetail";
  code?: ActivityPlanningStateDetail["code"];
  name?: ActivityPlanningStateDetail["name"];
}

export function newActivityPlanningStateDetail(
  options: ActivityPlanningStateDetailOptions = {},
  cache: Record<string, any> = {},
): ActivityPlanningStateDetail {
  const o = (options.__typename ? options : cache["ActivityPlanningStateDetail"] = {}) as ActivityPlanningStateDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ActivityPlanningStateDetail";
  o.code = options.code ?? ActivityPlanningState.Draft;
  o.name = options.name ?? "Draft";
  return o;
}

factories["ActivityPlanningStateDetail"] = newActivityPlanningStateDetail;

export interface ActivityResponsibilityDetailOptions {
  __typename?: "ActivityResponsibilityDetail";
  code?: ActivityResponsibilityDetail["code"];
  name?: ActivityResponsibilityDetail["name"];
}

export function newActivityResponsibilityDetail(
  options: ActivityResponsibilityDetailOptions = {},
  cache: Record<string, any> = {},
): ActivityResponsibilityDetail {
  const o = (options.__typename ? options : cache["ActivityResponsibilityDetail"] = {}) as ActivityResponsibilityDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ActivityResponsibilityDetail";
  o.code = options.code ?? ActivityResponsibility.Homebound;
  o.name = options.name ?? "Homebound";
  return o;
}

factories["ActivityResponsibilityDetail"] = newActivityResponsibilityDetail;

export interface ActivityTypeDetailOptions {
  __typename?: "ActivityTypeDetail";
  code?: ActivityTypeDetail["code"];
  name?: ActivityTypeDetail["name"];
}

export function newActivityTypeDetail(
  options: ActivityTypeDetailOptions = {},
  cache: Record<string, any> = {},
): ActivityTypeDetail {
  const o = (options.__typename ? options : cache["ActivityTypeDetail"] = {}) as ActivityTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ActivityTypeDetail";
  o.code = options.code ?? ActivityType.PreconPlanning;
  o.name = options.name ?? "Precon planning";
  return o;
}

factories["ActivityTypeDetail"] = newActivityTypeDetail;

export interface AggregateVersionStatusDetailOptions {
  __typename?: "AggregateVersionStatusDetail";
  code?: AggregateVersionStatusDetail["code"];
  name?: AggregateVersionStatusDetail["name"];
}

export function newAggregateVersionStatusDetail(
  options: AggregateVersionStatusDetailOptions = {},
  cache: Record<string, any> = {},
): AggregateVersionStatusDetail {
  const o = (options.__typename ? options : cache["AggregateVersionStatusDetail"] = {}) as AggregateVersionStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "AggregateVersionStatusDetail";
  o.code = options.code ?? AggregateVersionStatus.Draft;
  o.name = options.name ?? "Draft";
  return o;
}

factories["AggregateVersionStatusDetail"] = newAggregateVersionStatusDetail;

export interface AllocationStrategyDetailOptions {
  __typename?: "AllocationStrategyDetail";
  code?: AllocationStrategyDetail["code"];
  name?: AllocationStrategyDetail["name"];
}

export function newAllocationStrategyDetail(
  options: AllocationStrategyDetailOptions = {},
  cache: Record<string, any> = {},
): AllocationStrategyDetail {
  const o = (options.__typename ? options : cache["AllocationStrategyDetail"] = {}) as AllocationStrategyDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "AllocationStrategyDetail";
  o.code = options.code ?? AllocationStrategy.SizeBased;
  o.name = options.name ?? "Size based";
  return o;
}

factories["AllocationStrategyDetail"] = newAllocationStrategyDetail;

export interface ApprovalStatusDetailOptions {
  __typename?: "ApprovalStatusDetail";
  code?: ApprovalStatusDetail["code"];
  name?: ApprovalStatusDetail["name"];
  sortOrder?: ApprovalStatusDetail["sortOrder"];
}

export function newApprovalStatusDetail(
  options: ApprovalStatusDetailOptions = {},
  cache: Record<string, any> = {},
): ApprovalStatusDetail {
  const o = (options.__typename ? options : cache["ApprovalStatusDetail"] = {}) as ApprovalStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ApprovalStatusDetail";
  o.code = options.code ?? ApprovalStatus.ChangesNeeded;
  o.name = options.name ?? "Changes needed";
  o.sortOrder = options.sortOrder ?? 0;
  return o;
}

factories["ApprovalStatusDetail"] = newApprovalStatusDetail;

export interface ApproverStatusDetailOptions {
  __typename?: "ApproverStatusDetail";
  code?: ApproverStatusDetail["code"];
  name?: ApproverStatusDetail["name"];
  sortOrder?: ApproverStatusDetail["sortOrder"];
}

export function newApproverStatusDetail(
  options: ApproverStatusDetailOptions = {},
  cache: Record<string, any> = {},
): ApproverStatusDetail {
  const o = (options.__typename ? options : cache["ApproverStatusDetail"] = {}) as ApproverStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ApproverStatusDetail";
  o.code = options.code ?? ApproverStatus.Pending;
  o.name = options.name ?? "Pending";
  o.sortOrder = options.sortOrder ?? 0;
  return o;
}

factories["ApproverStatusDetail"] = newApproverStatusDetail;

export interface BidContractRevisionStatusDetailOptions {
  __typename?: "BidContractRevisionStatusDetail";
  code?: BidContractRevisionStatusDetail["code"];
  name?: BidContractRevisionStatusDetail["name"];
}

export function newBidContractRevisionStatusDetail(
  options: BidContractRevisionStatusDetailOptions = {},
  cache: Record<string, any> = {},
): BidContractRevisionStatusDetail {
  const o =
    (options.__typename ? options : cache["BidContractRevisionStatusDetail"] = {}) as BidContractRevisionStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidContractRevisionStatusDetail";
  o.code = options.code ?? BidContractRevisionStatus.Draft;
  o.name = options.name ?? "Draft";
  return o;
}

factories["BidContractRevisionStatusDetail"] = newBidContractRevisionStatusDetail;

export interface BidContractTypeDetailOptions {
  __typename?: "BidContractTypeDetail";
  code?: BidContractTypeDetail["code"];
  name?: BidContractTypeDetail["name"];
}

export function newBidContractTypeDetail(
  options: BidContractTypeDetailOptions = {},
  cache: Record<string, any> = {},
): BidContractTypeDetail {
  const o = (options.__typename ? options : cache["BidContractTypeDetail"] = {}) as BidContractTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidContractTypeDetail";
  o.code = options.code ?? BidContractType.UnitBased;
  o.name = options.name ?? "Unit based";
  return o;
}

factories["BidContractTypeDetail"] = newBidContractTypeDetail;

export interface BidPackageStatusDetailOptions {
  __typename?: "BidPackageStatusDetail";
  code?: BidPackageStatusDetail["code"];
  name?: BidPackageStatusDetail["name"];
}

export function newBidPackageStatusDetail(
  options: BidPackageStatusDetailOptions = {},
  cache: Record<string, any> = {},
): BidPackageStatusDetail {
  const o = (options.__typename ? options : cache["BidPackageStatusDetail"] = {}) as BidPackageStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidPackageStatusDetail";
  o.code = options.code ?? BidPackageStatus.Draft;
  o.name = options.name ?? "Draft";
  return o;
}

factories["BidPackageStatusDetail"] = newBidPackageStatusDetail;

export interface BidScopeSourceDetailOptions {
  __typename?: "BidScopeSourceDetail";
  code?: BidScopeSourceDetail["code"];
  name?: BidScopeSourceDetail["name"];
}

export function newBidScopeSourceDetail(
  options: BidScopeSourceDetailOptions = {},
  cache: Record<string, any> = {},
): BidScopeSourceDetail {
  const o = (options.__typename ? options : cache["BidScopeSourceDetail"] = {}) as BidScopeSourceDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BidScopeSourceDetail";
  o.code = options.code ?? BidScopeSource.Community;
  o.name = options.name ?? "Community";
  return o;
}

factories["BidScopeSourceDetail"] = newBidScopeSourceDetail;

export interface BillGmailAttachmentResultDetailOptions {
  __typename?: "BillGmailAttachmentResultDetail";
  code?: BillGmailAttachmentResultDetail["code"];
  name?: BillGmailAttachmentResultDetail["name"];
}

export function newBillGmailAttachmentResultDetail(
  options: BillGmailAttachmentResultDetailOptions = {},
  cache: Record<string, any> = {},
): BillGmailAttachmentResultDetail {
  const o =
    (options.__typename ? options : cache["BillGmailAttachmentResultDetail"] = {}) as BillGmailAttachmentResultDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BillGmailAttachmentResultDetail";
  o.code = options.code ?? BillGmailAttachmentResult.NotPdf;
  o.name = options.name ?? "Not pdf";
  return o;
}

factories["BillGmailAttachmentResultDetail"] = newBillGmailAttachmentResultDetail;

export interface BillGmailMessageResultDetailOptions {
  __typename?: "BillGmailMessageResultDetail";
  code?: BillGmailMessageResultDetail["code"];
  name?: BillGmailMessageResultDetail["name"];
}

export function newBillGmailMessageResultDetail(
  options: BillGmailMessageResultDetailOptions = {},
  cache: Record<string, any> = {},
): BillGmailMessageResultDetail {
  const o = (options.__typename ? options : cache["BillGmailMessageResultDetail"] = {}) as BillGmailMessageResultDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BillGmailMessageResultDetail";
  o.code = options.code ?? BillGmailMessageResult.NotFound;
  o.name = options.name ?? "Not found";
  return o;
}

factories["BillGmailMessageResultDetail"] = newBillGmailMessageResultDetail;

export interface BillReviewReasonDetailOptions {
  __typename?: "BillReviewReasonDetail";
  code?: BillReviewReasonDetail["code"];
  name?: BillReviewReasonDetail["name"];
}

export function newBillReviewReasonDetail(
  options: BillReviewReasonDetailOptions = {},
  cache: Record<string, any> = {},
): BillReviewReasonDetail {
  const o = (options.__typename ? options : cache["BillReviewReasonDetail"] = {}) as BillReviewReasonDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BillReviewReasonDetail";
  o.code = options.code ?? BillReviewReason.MissingPo;
  o.name = options.name ?? "Missing po";
  return o;
}

factories["BillReviewReasonDetail"] = newBillReviewReasonDetail;

export interface BillSourceDetailOptions {
  __typename?: "BillSourceDetail";
  code?: BillSourceDetail["code"];
  name?: BillSourceDetail["name"];
}

export function newBillSourceDetail(
  options: BillSourceDetailOptions = {},
  cache: Record<string, any> = {},
): BillSourceDetail {
  const o = (options.__typename ? options : cache["BillSourceDetail"] = {}) as BillSourceDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BillSourceDetail";
  o.code = options.code ?? BillSource.Manual;
  o.name = options.name ?? "Manual";
  return o;
}

factories["BillSourceDetail"] = newBillSourceDetail;

export interface BillStatusDetailOptions {
  __typename?: "BillStatusDetail";
  code?: BillStatusDetail["code"];
  name?: BillStatusDetail["name"];
}

export function newBillStatusDetail(
  options: BillStatusDetailOptions = {},
  cache: Record<string, any> = {},
): BillStatusDetail {
  const o = (options.__typename ? options : cache["BillStatusDetail"] = {}) as BillStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BillStatusDetail";
  o.code = options.code ?? BillStatus.Draft;
  o.name = options.name ?? "Draft";
  return o;
}

factories["BillStatusDetail"] = newBillStatusDetail;

export interface BillTypeDetailOptions {
  __typename?: "BillTypeDetail";
  code?: BillTypeDetail["code"];
  name?: BillTypeDetail["name"];
}

export function newBillTypeDetail(
  options: BillTypeDetailOptions = {},
  cache: Record<string, any> = {},
): BillTypeDetail {
  const o = (options.__typename ? options : cache["BillTypeDetail"] = {}) as BillTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BillTypeDetail";
  o.code = options.code ?? BillType.Standard;
  o.name = options.name ?? "Standard";
  return o;
}

factories["BillTypeDetail"] = newBillTypeDetail;

export interface BusinessFunctionTypeDetailOptions {
  __typename?: "BusinessFunctionTypeDetail";
  code?: BusinessFunctionTypeDetail["code"];
  name?: BusinessFunctionTypeDetail["name"];
}

export function newBusinessFunctionTypeDetail(
  options: BusinessFunctionTypeDetailOptions = {},
  cache: Record<string, any> = {},
): BusinessFunctionTypeDetail {
  const o = (options.__typename ? options : cache["BusinessFunctionTypeDetail"] = {}) as BusinessFunctionTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BusinessFunctionTypeDetail";
  o.code = options.code ?? BusinessFunctionType.Architecture;
  o.name = options.name ?? "Architecture";
  return o;
}

factories["BusinessFunctionTypeDetail"] = newBusinessFunctionTypeDetail;

export interface BuyoutStatusDetailOptions {
  __typename?: "BuyoutStatusDetail";
  code?: BuyoutStatusDetail["code"];
  name?: BuyoutStatusDetail["name"];
  shortName?: BuyoutStatusDetail["shortName"];
}

export function newBuyoutStatusDetail(
  options: BuyoutStatusDetailOptions = {},
  cache: Record<string, any> = {},
): BuyoutStatusDetail {
  const o = (options.__typename ? options : cache["BuyoutStatusDetail"] = {}) as BuyoutStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BuyoutStatusDetail";
  o.code = options.code ?? BuyoutStatus.NotBoughtOut;
  o.name = options.name ?? "Not bought out";
  o.shortName = options.shortName ?? "Not bought out";
  return o;
}

factories["BuyoutStatusDetail"] = newBuyoutStatusDetail;

export interface ChangeEventBudgetPhaseDetailOptions {
  __typename?: "ChangeEventBudgetPhaseDetail";
  code?: ChangeEventBudgetPhaseDetail["code"];
  name?: ChangeEventBudgetPhaseDetail["name"];
  sortOrder?: ChangeEventBudgetPhaseDetail["sortOrder"];
}

export function newChangeEventBudgetPhaseDetail(
  options: ChangeEventBudgetPhaseDetailOptions = {},
  cache: Record<string, any> = {},
): ChangeEventBudgetPhaseDetail {
  const o = (options.__typename ? options : cache["ChangeEventBudgetPhaseDetail"] = {}) as ChangeEventBudgetPhaseDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeEventBudgetPhaseDetail";
  o.code = options.code ?? ChangeEventBudgetPhase.Prebid;
  o.name = options.name ?? "Prebid";
  o.sortOrder = options.sortOrder ?? 0;
  return o;
}

factories["ChangeEventBudgetPhaseDetail"] = newChangeEventBudgetPhaseDetail;

export interface ChangeEventLineItemTypeDetailOptions {
  __typename?: "ChangeEventLineItemTypeDetail";
  code?: ChangeEventLineItemTypeDetail["code"];
  name?: ChangeEventLineItemTypeDetail["name"];
}

export function newChangeEventLineItemTypeDetail(
  options: ChangeEventLineItemTypeDetailOptions = {},
  cache: Record<string, any> = {},
): ChangeEventLineItemTypeDetail {
  const o =
    (options.__typename ? options : cache["ChangeEventLineItemTypeDetail"] = {}) as ChangeEventLineItemTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeEventLineItemTypeDetail";
  o.code = options.code ?? ChangeEventLineItemType.Add;
  o.name = options.name ?? "Add";
  return o;
}

factories["ChangeEventLineItemTypeDetail"] = newChangeEventLineItemTypeDetail;

export interface ChangeEventStatusDetailOptions {
  __typename?: "ChangeEventStatusDetail";
  code?: ChangeEventStatusDetail["code"];
  name?: ChangeEventStatusDetail["name"];
}

export function newChangeEventStatusDetail(
  options: ChangeEventStatusDetailOptions = {},
  cache: Record<string, any> = {},
): ChangeEventStatusDetail {
  const o = (options.__typename ? options : cache["ChangeEventStatusDetail"] = {}) as ChangeEventStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeEventStatusDetail";
  o.code = options.code ?? ChangeEventStatus.Draft;
  o.name = options.name ?? "Draft";
  return o;
}

factories["ChangeEventStatusDetail"] = newChangeEventStatusDetail;

export interface ChangeEventTypeDetailOptions {
  __typename?: "ChangeEventTypeDetail";
  code?: ChangeEventTypeDetail["code"];
  name?: ChangeEventTypeDetail["name"];
}

export function newChangeEventTypeDetail(
  options: ChangeEventTypeDetailOptions = {},
  cache: Record<string, any> = {},
): ChangeEventTypeDetail {
  const o = (options.__typename ? options : cache["ChangeEventTypeDetail"] = {}) as ChangeEventTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeEventTypeDetail";
  o.code = options.code ?? ChangeEventType.Internal;
  o.name = options.name ?? "Internal";
  return o;
}

factories["ChangeEventTypeDetail"] = newChangeEventTypeDetail;

export interface ChangeRequestAssetPlatformDetailOptions {
  __typename?: "ChangeRequestAssetPlatformDetail";
  code?: ChangeRequestAssetPlatformDetail["code"];
  name?: ChangeRequestAssetPlatformDetail["name"];
}

export function newChangeRequestAssetPlatformDetail(
  options: ChangeRequestAssetPlatformDetailOptions = {},
  cache: Record<string, any> = {},
): ChangeRequestAssetPlatformDetail {
  const o =
    (options.__typename ? options : cache["ChangeRequestAssetPlatformDetail"] = {}) as ChangeRequestAssetPlatformDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeRequestAssetPlatformDetail";
  o.code = options.code ?? ChangeRequestAssetPlatform.Blueprint;
  o.name = options.name ?? "Blueprint";
  return o;
}

factories["ChangeRequestAssetPlatformDetail"] = newChangeRequestAssetPlatformDetail;

export interface ChangeRequestAssetScopeDetailOptions {
  __typename?: "ChangeRequestAssetScopeDetail";
  code?: ChangeRequestAssetScopeDetail["code"];
  name?: ChangeRequestAssetScopeDetail["name"];
}

export function newChangeRequestAssetScopeDetail(
  options: ChangeRequestAssetScopeDetailOptions = {},
  cache: Record<string, any> = {},
): ChangeRequestAssetScopeDetail {
  const o =
    (options.__typename ? options : cache["ChangeRequestAssetScopeDetail"] = {}) as ChangeRequestAssetScopeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeRequestAssetScopeDetail";
  o.code = options.code ?? ChangeRequestAssetScope.Project;
  o.name = options.name ?? "Project";
  return o;
}

factories["ChangeRequestAssetScopeDetail"] = newChangeRequestAssetScopeDetail;

export interface ChangeRequestPriorityDetailOptions {
  __typename?: "ChangeRequestPriorityDetail";
  code?: ChangeRequestPriorityDetail["code"];
  name?: ChangeRequestPriorityDetail["name"];
}

export function newChangeRequestPriorityDetail(
  options: ChangeRequestPriorityDetailOptions = {},
  cache: Record<string, any> = {},
): ChangeRequestPriorityDetail {
  const o = (options.__typename ? options : cache["ChangeRequestPriorityDetail"] = {}) as ChangeRequestPriorityDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeRequestPriorityDetail";
  o.code = options.code ?? ChangeRequestPriority.Low;
  o.name = options.name ?? "Low";
  return o;
}

factories["ChangeRequestPriorityDetail"] = newChangeRequestPriorityDetail;

export interface ChangeRequestSourceDetailOptions {
  __typename?: "ChangeRequestSourceDetail";
  code?: ChangeRequestSourceDetail["code"];
  name?: ChangeRequestSourceDetail["name"];
}

export function newChangeRequestSourceDetail(
  options: ChangeRequestSourceDetailOptions = {},
  cache: Record<string, any> = {},
): ChangeRequestSourceDetail {
  const o = (options.__typename ? options : cache["ChangeRequestSourceDetail"] = {}) as ChangeRequestSourceDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeRequestSourceDetail";
  o.code = options.code ?? ChangeRequestSource.Na;
  o.name = options.name ?? "Na";
  return o;
}

factories["ChangeRequestSourceDetail"] = newChangeRequestSourceDetail;

export interface ChangeRequestStatusDetailOptions {
  __typename?: "ChangeRequestStatusDetail";
  code?: ChangeRequestStatusDetail["code"];
  name?: ChangeRequestStatusDetail["name"];
}

export function newChangeRequestStatusDetail(
  options: ChangeRequestStatusDetailOptions = {},
  cache: Record<string, any> = {},
): ChangeRequestStatusDetail {
  const o = (options.__typename ? options : cache["ChangeRequestStatusDetail"] = {}) as ChangeRequestStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeRequestStatusDetail";
  o.code = options.code ?? ChangeRequestStatus.NeedsReview;
  o.name = options.name ?? "Needs review";
  return o;
}

factories["ChangeRequestStatusDetail"] = newChangeRequestStatusDetail;

export interface ChangeRequestToDoTypeDetailOptions {
  __typename?: "ChangeRequestToDoTypeDetail";
  code?: ChangeRequestToDoTypeDetail["code"];
  name?: ChangeRequestToDoTypeDetail["name"];
}

export function newChangeRequestToDoTypeDetail(
  options: ChangeRequestToDoTypeDetailOptions = {},
  cache: Record<string, any> = {},
): ChangeRequestToDoTypeDetail {
  const o = (options.__typename ? options : cache["ChangeRequestToDoTypeDetail"] = {}) as ChangeRequestToDoTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeRequestToDoTypeDetail";
  o.code = options.code ?? ChangeRequestToDoType.InitialReview;
  o.name = options.name ?? "Initial review";
  return o;
}

factories["ChangeRequestToDoTypeDetail"] = newChangeRequestToDoTypeDetail;

export interface ChangeTypeDetailOptions {
  __typename?: "ChangeTypeDetail";
  code?: ChangeTypeDetail["code"];
  name?: ChangeTypeDetail["name"];
  sortOrder?: ChangeTypeDetail["sortOrder"];
}

export function newChangeTypeDetail(
  options: ChangeTypeDetailOptions = {},
  cache: Record<string, any> = {},
): ChangeTypeDetail {
  const o = (options.__typename ? options : cache["ChangeTypeDetail"] = {}) as ChangeTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ChangeTypeDetail";
  o.code = options.code ?? ChangeType.Na;
  o.name = options.name ?? "Na";
  o.sortOrder = options.sortOrder ?? 0;
  return o;
}

factories["ChangeTypeDetail"] = newChangeTypeDetail;

export interface CheckoutConfigOptionGroupStepDetailOptions {
  __typename?: "CheckoutConfigOptionGroupStepDetail";
  code?: CheckoutConfigOptionGroupStepDetail["code"];
  name?: CheckoutConfigOptionGroupStepDetail["name"];
}

export function newCheckoutConfigOptionGroupStepDetail(
  options: CheckoutConfigOptionGroupStepDetailOptions = {},
  cache: Record<string, any> = {},
): CheckoutConfigOptionGroupStepDetail {
  const o =
    (options.__typename
      ? options
      : cache["CheckoutConfigOptionGroupStepDetail"] = {}) as CheckoutConfigOptionGroupStepDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CheckoutConfigOptionGroupStepDetail";
  o.code = options.code ?? CheckoutConfigOptionGroupStep.ExteriorElevation;
  o.name = options.name ?? "Exterior elevation";
  return o;
}

factories["CheckoutConfigOptionGroupStepDetail"] = newCheckoutConfigOptionGroupStepDetail;

export interface CheckoutConfigStatusDetailOptions {
  __typename?: "CheckoutConfigStatusDetail";
  code?: CheckoutConfigStatusDetail["code"];
  name?: CheckoutConfigStatusDetail["name"];
}

export function newCheckoutConfigStatusDetail(
  options: CheckoutConfigStatusDetailOptions = {},
  cache: Record<string, any> = {},
): CheckoutConfigStatusDetail {
  const o = (options.__typename ? options : cache["CheckoutConfigStatusDetail"] = {}) as CheckoutConfigStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CheckoutConfigStatusDetail";
  o.code = options.code ?? CheckoutConfigStatus.Draft;
  o.name = options.name ?? "Draft";
  return o;
}

factories["CheckoutConfigStatusDetail"] = newCheckoutConfigStatusDetail;

export interface ClientPlatformDetailOptions {
  __typename?: "ClientPlatformDetail";
  code?: ClientPlatformDetail["code"];
  name?: ClientPlatformDetail["name"];
}

export function newClientPlatformDetail(
  options: ClientPlatformDetailOptions = {},
  cache: Record<string, any> = {},
): ClientPlatformDetail {
  const o = (options.__typename ? options : cache["ClientPlatformDetail"] = {}) as ClientPlatformDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ClientPlatformDetail";
  o.code = options.code ?? ClientPlatform.Web;
  o.name = options.name ?? "Web";
  return o;
}

factories["ClientPlatformDetail"] = newClientPlatformDetail;

export interface CommentStreamVisibilityDetailOptions {
  __typename?: "CommentStreamVisibilityDetail";
  code?: CommentStreamVisibilityDetail["code"];
  name?: CommentStreamVisibilityDetail["name"];
}

export function newCommentStreamVisibilityDetail(
  options: CommentStreamVisibilityDetailOptions = {},
  cache: Record<string, any> = {},
): CommentStreamVisibilityDetail {
  const o =
    (options.__typename ? options : cache["CommentStreamVisibilityDetail"] = {}) as CommentStreamVisibilityDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CommentStreamVisibilityDetail";
  o.code = options.code ?? CommentStreamVisibility.Internal;
  o.name = options.name ?? "Internal";
  return o;
}

factories["CommentStreamVisibilityDetail"] = newCommentStreamVisibilityDetail;

export interface CommitmentStatusDetailOptions {
  __typename?: "CommitmentStatusDetail";
  code?: CommitmentStatusDetail["code"];
  name?: CommitmentStatusDetail["name"];
}

export function newCommitmentStatusDetail(
  options: CommitmentStatusDetailOptions = {},
  cache: Record<string, any> = {},
): CommitmentStatusDetail {
  const o = (options.__typename ? options : cache["CommitmentStatusDetail"] = {}) as CommitmentStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CommitmentStatusDetail";
  o.code = options.code ?? CommitmentStatus.Draft;
  o.name = options.name ?? "Draft";
  return o;
}

factories["CommitmentStatusDetail"] = newCommitmentStatusDetail;

export interface CommitmentTypeDetailOptions {
  __typename?: "CommitmentTypeDetail";
  code?: CommitmentTypeDetail["code"];
  name?: CommitmentTypeDetail["name"];
}

export function newCommitmentTypeDetail(
  options: CommitmentTypeDetailOptions = {},
  cache: Record<string, any> = {},
): CommitmentTypeDetail {
  const o = (options.__typename ? options : cache["CommitmentTypeDetail"] = {}) as CommitmentTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CommitmentTypeDetail";
  o.code = options.code ?? CommitmentType.PurchaseOrder;
  o.name = options.name ?? "Purchase order";
  return o;
}

factories["CommitmentTypeDetail"] = newCommitmentTypeDetail;

export interface CommunicationChannelDetailOptions {
  __typename?: "CommunicationChannelDetail";
  code?: CommunicationChannelDetail["code"];
  name?: CommunicationChannelDetail["name"];
}

export function newCommunicationChannelDetail(
  options: CommunicationChannelDetailOptions = {},
  cache: Record<string, any> = {},
): CommunicationChannelDetail {
  const o = (options.__typename ? options : cache["CommunicationChannelDetail"] = {}) as CommunicationChannelDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CommunicationChannelDetail";
  o.code = options.code ?? CommunicationChannel.Email;
  o.name = options.name ?? "Email";
  return o;
}

factories["CommunicationChannelDetail"] = newCommunicationChannelDetail;

export interface CommunityTypeDetailOptions {
  __typename?: "CommunityTypeDetail";
  code?: CommunityTypeDetail["code"];
  name?: CommunityTypeDetail["name"];
}

export function newCommunityTypeDetail(
  options: CommunityTypeDetailOptions = {},
  cache: Record<string, any> = {},
): CommunityTypeDetail {
  const o = (options.__typename ? options : cache["CommunityTypeDetail"] = {}) as CommunityTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CommunityTypeDetail";
  o.code = options.code ?? CommunityType.Infill;
  o.name = options.name ?? "Infill";
  return o;
}

factories["CommunityTypeDetail"] = newCommunityTypeDetail;

export interface ConstructionTypeDetailOptions {
  __typename?: "ConstructionTypeDetail";
  code?: ConstructionTypeDetail["code"];
  name?: ConstructionTypeDetail["name"];
}

export function newConstructionTypeDetail(
  options: ConstructionTypeDetailOptions = {},
  cache: Record<string, any> = {},
): ConstructionTypeDetail {
  const o = (options.__typename ? options : cache["ConstructionTypeDetail"] = {}) as ConstructionTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ConstructionTypeDetail";
  o.code = options.code ?? ConstructionType.TypeIii;
  o.name = options.name ?? "Type iii";
  return o;
}

factories["ConstructionTypeDetail"] = newConstructionTypeDetail;

export interface ContractTypeDetailOptions {
  __typename?: "ContractTypeDetail";
  code?: ContractTypeDetail["code"];
  name?: ContractTypeDetail["name"];
}

export function newContractTypeDetail(
  options: ContractTypeDetailOptions = {},
  cache: Record<string, any> = {},
): ContractTypeDetail {
  const o = (options.__typename ? options : cache["ContractTypeDetail"] = {}) as ContractTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ContractTypeDetail";
  o.code = options.code ?? ContractType.Fixed;
  o.name = options.name ?? "Fixed";
  return o;
}

factories["ContractTypeDetail"] = newContractTypeDetail;

export interface CostClassificationTypeDetailOptions {
  __typename?: "CostClassificationTypeDetail";
  code?: CostClassificationTypeDetail["code"];
  name?: CostClassificationTypeDetail["name"];
}

export function newCostClassificationTypeDetail(
  options: CostClassificationTypeDetailOptions = {},
  cache: Record<string, any> = {},
): CostClassificationTypeDetail {
  const o = (options.__typename ? options : cache["CostClassificationTypeDetail"] = {}) as CostClassificationTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CostClassificationTypeDetail";
  o.code = options.code ?? CostClassificationType.Soft;
  o.name = options.name ?? "Soft";
  return o;
}

factories["CostClassificationTypeDetail"] = newCostClassificationTypeDetail;

export interface CostCodeInvoiceCategoryDetailOptions {
  __typename?: "CostCodeInvoiceCategoryDetail";
  code?: CostCodeInvoiceCategoryDetail["code"];
  name?: CostCodeInvoiceCategoryDetail["name"];
  includeInInvoiceScheduleProration?: CostCodeInvoiceCategoryDetail["includeInInvoiceScheduleProration"];
  sortOrder?: CostCodeInvoiceCategoryDetail["sortOrder"];
}

export function newCostCodeInvoiceCategoryDetail(
  options: CostCodeInvoiceCategoryDetailOptions = {},
  cache: Record<string, any> = {},
): CostCodeInvoiceCategoryDetail {
  const o =
    (options.__typename ? options : cache["CostCodeInvoiceCategoryDetail"] = {}) as CostCodeInvoiceCategoryDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CostCodeInvoiceCategoryDetail";
  o.code = options.code ?? CostCodeInvoiceCategory.PreCon;
  o.name = options.name ?? "Pre con";
  o.includeInInvoiceScheduleProration = options.includeInInvoiceScheduleProration ?? false;
  o.sortOrder = options.sortOrder ?? 0;
  return o;
}

factories["CostCodeInvoiceCategoryDetail"] = newCostCodeInvoiceCategoryDetail;

export interface CostConfidenceDetailOptions {
  __typename?: "CostConfidenceDetail";
  code?: CostConfidenceDetail["code"];
  name?: CostConfidenceDetail["name"];
}

export function newCostConfidenceDetail(
  options: CostConfidenceDetailOptions = {},
  cache: Record<string, any> = {},
): CostConfidenceDetail {
  const o = (options.__typename ? options : cache["CostConfidenceDetail"] = {}) as CostConfidenceDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CostConfidenceDetail";
  o.code = options.code ?? CostConfidence.Low;
  o.name = options.name ?? "Low";
  return o;
}

factories["CostConfidenceDetail"] = newCostConfidenceDetail;

export interface CostSubClassificationTypeDetailOptions {
  __typename?: "CostSubClassificationTypeDetail";
  code?: CostSubClassificationTypeDetail["code"];
  name?: CostSubClassificationTypeDetail["name"];
}

export function newCostSubClassificationTypeDetail(
  options: CostSubClassificationTypeDetailOptions = {},
  cache: Record<string, any> = {},
): CostSubClassificationTypeDetail {
  const o =
    (options.__typename ? options : cache["CostSubClassificationTypeDetail"] = {}) as CostSubClassificationTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CostSubClassificationTypeDetail";
  o.code = options.code ?? CostSubClassificationType.Indirect;
  o.name = options.name ?? "Indirect";
  return o;
}

factories["CostSubClassificationTypeDetail"] = newCostSubClassificationTypeDetail;

export interface CostTypeDetailOptions {
  __typename?: "CostTypeDetail";
  code?: CostTypeDetail["code"];
  name?: CostTypeDetail["name"];
  tradePartnerName?: CostTypeDetail["tradePartnerName"];
}

export function newCostTypeDetail(
  options: CostTypeDetailOptions = {},
  cache: Record<string, any> = {},
): CostTypeDetail {
  const o = (options.__typename ? options : cache["CostTypeDetail"] = {}) as CostTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CostTypeDetail";
  o.code = options.code ?? CostType.Labor;
  o.name = options.name ?? "Labor";
  o.tradePartnerName = options.tradePartnerName ?? "Labor";
  return o;
}

factories["CostTypeDetail"] = newCostTypeDetail;

export interface DayOfWeekDetailOptions {
  __typename?: "DayOfWeekDetail";
  code?: DayOfWeekDetail["code"];
  name?: DayOfWeekDetail["name"];
  isBusinessDay?: DayOfWeekDetail["isBusinessDay"];
}

export function newDayOfWeekDetail(
  options: DayOfWeekDetailOptions = {},
  cache: Record<string, any> = {},
): DayOfWeekDetail {
  const o = (options.__typename ? options : cache["DayOfWeekDetail"] = {}) as DayOfWeekDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DayOfWeekDetail";
  o.code = options.code ?? DayOfWeek.Saturday;
  o.name = options.name ?? "Saturday";
  o.isBusinessDay = options.isBusinessDay ?? false;
  return o;
}

factories["DayOfWeekDetail"] = newDayOfWeekDetail;

export interface DesignPackageLocationDetailOptions {
  __typename?: "DesignPackageLocationDetail";
  code?: DesignPackageLocationDetail["code"];
  name?: DesignPackageLocationDetail["name"];
}

export function newDesignPackageLocationDetail(
  options: DesignPackageLocationDetailOptions = {},
  cache: Record<string, any> = {},
): DesignPackageLocationDetail {
  const o = (options.__typename ? options : cache["DesignPackageLocationDetail"] = {}) as DesignPackageLocationDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DesignPackageLocationDetail";
  o.code = options.code ?? DesignPackageLocation.Interior;
  o.name = options.name ?? "Interior";
  return o;
}

factories["DesignPackageLocationDetail"] = newDesignPackageLocationDetail;

export interface DevelopmentCommitmentTypeDetailOptions {
  __typename?: "DevelopmentCommitmentTypeDetail";
  code?: DevelopmentCommitmentTypeDetail["code"];
  name?: DevelopmentCommitmentTypeDetail["name"];
}

export function newDevelopmentCommitmentTypeDetail(
  options: DevelopmentCommitmentTypeDetailOptions = {},
  cache: Record<string, any> = {},
): DevelopmentCommitmentTypeDetail {
  const o =
    (options.__typename ? options : cache["DevelopmentCommitmentTypeDetail"] = {}) as DevelopmentCommitmentTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DevelopmentCommitmentTypeDetail";
  o.code = options.code ?? DevelopmentCommitmentType.Materials;
  o.name = options.name ?? "Materials";
  return o;
}

factories["DevelopmentCommitmentTypeDetail"] = newDevelopmentCommitmentTypeDetail;

export interface DocumentAttachmentPlaceDetailOptions {
  __typename?: "DocumentAttachmentPlaceDetail";
  code?: DocumentAttachmentPlaceDetail["code"];
  name?: DocumentAttachmentPlaceDetail["name"];
}

export function newDocumentAttachmentPlaceDetail(
  options: DocumentAttachmentPlaceDetailOptions = {},
  cache: Record<string, any> = {},
): DocumentAttachmentPlaceDetail {
  const o =
    (options.__typename ? options : cache["DocumentAttachmentPlaceDetail"] = {}) as DocumentAttachmentPlaceDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DocumentAttachmentPlaceDetail";
  o.code = options.code ?? DocumentAttachmentPlace.PurchaseOrder;
  o.name = options.name ?? "Purchase order";
  return o;
}

factories["DocumentAttachmentPlaceDetail"] = newDocumentAttachmentPlaceDetail;

export interface DocumentCategoryDetailOptions {
  __typename?: "DocumentCategoryDetail";
  code?: DocumentCategoryDetail["code"];
  name?: DocumentCategoryDetail["name"];
}

export function newDocumentCategoryDetail(
  options: DocumentCategoryDetailOptions = {},
  cache: Record<string, any> = {},
): DocumentCategoryDetail {
  const o = (options.__typename ? options : cache["DocumentCategoryDetail"] = {}) as DocumentCategoryDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DocumentCategoryDetail";
  o.code = options.code ?? DocumentCategory.Contractual;
  o.name = options.name ?? "Contractual";
  return o;
}

factories["DocumentCategoryDetail"] = newDocumentCategoryDetail;

export interface DocumentTypeDetailOptions {
  __typename?: "DocumentTypeDetail";
  code?: DocumentTypeDetail["code"];
  name?: DocumentTypeDetail["name"];
  systemControlled?: DocumentTypeDetail["systemControlled"];
  defaultHomeownerVisible?: DocumentTypeDetail["defaultHomeownerVisible"];
  boolDefaultHomeownerVisible?: DocumentTypeDetail["boolDefaultHomeownerVisible"];
}

export function newDocumentTypeDetail(
  options: DocumentTypeDetailOptions = {},
  cache: Record<string, any> = {},
): DocumentTypeDetail {
  const o = (options.__typename ? options : cache["DocumentTypeDetail"] = {}) as DocumentTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DocumentTypeDetail";
  o.code = options.code ?? DocumentType.PreconAgreement;
  o.name = options.name ?? "Precon agreement";
  o.systemControlled = options.systemControlled ?? false;
  o.defaultHomeownerVisible = options.defaultHomeownerVisible ?? false;
  o.boolDefaultHomeownerVisible = options.boolDefaultHomeownerVisible ?? false;
  return o;
}

factories["DocumentTypeDetail"] = newDocumentTypeDetail;

export interface ErpAccrualTypeDetailOptions {
  __typename?: "ErpAccrualTypeDetail";
  code?: ErpAccrualTypeDetail["code"];
  name?: ErpAccrualTypeDetail["name"];
}

export function newErpAccrualTypeDetail(
  options: ErpAccrualTypeDetailOptions = {},
  cache: Record<string, any> = {},
): ErpAccrualTypeDetail {
  const o = (options.__typename ? options : cache["ErpAccrualTypeDetail"] = {}) as ErpAccrualTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ErpAccrualTypeDetail";
  o.code = options.code ?? ErpAccrualType.TaskCompletion;
  o.name = options.name ?? "Task completion";
  return o;
}

factories["ErpAccrualTypeDetail"] = newErpAccrualTypeDetail;

export interface ErpRevenueLineItemSourceEventDetailOptions {
  __typename?: "ErpRevenueLineItemSourceEventDetail";
  code?: ErpRevenueLineItemSourceEventDetail["code"];
  name?: ErpRevenueLineItemSourceEventDetail["name"];
}

export function newErpRevenueLineItemSourceEventDetail(
  options: ErpRevenueLineItemSourceEventDetailOptions = {},
  cache: Record<string, any> = {},
): ErpRevenueLineItemSourceEventDetail {
  const o =
    (options.__typename
      ? options
      : cache["ErpRevenueLineItemSourceEventDetail"] = {}) as ErpRevenueLineItemSourceEventDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ErpRevenueLineItemSourceEventDetail";
  o.code = options.code ?? ErpRevenueLineItemSourceEvent.ContractPriceChange;
  o.name = options.name ?? "Contract price change";
  return o;
}

factories["ErpRevenueLineItemSourceEventDetail"] = newErpRevenueLineItemSourceEventDetail;

export interface ErpTransactionGroupEventDetailOptions {
  __typename?: "ErpTransactionGroupEventDetail";
  code?: ErpTransactionGroupEventDetail["code"];
  name?: ErpTransactionGroupEventDetail["name"];
}

export function newErpTransactionGroupEventDetail(
  options: ErpTransactionGroupEventDetailOptions = {},
  cache: Record<string, any> = {},
): ErpTransactionGroupEventDetail {
  const o =
    (options.__typename ? options : cache["ErpTransactionGroupEventDetail"] = {}) as ErpTransactionGroupEventDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ErpTransactionGroupEventDetail";
  o.code = options.code ?? ErpTransactionGroupEvent.TaskCompletion;
  o.name = options.name ?? "Task completion";
  return o;
}

factories["ErpTransactionGroupEventDetail"] = newErpTransactionGroupEventDetail;

export interface ErpTransactionGroupStatusDetailOptions {
  __typename?: "ErpTransactionGroupStatusDetail";
  code?: ErpTransactionGroupStatusDetail["code"];
  name?: ErpTransactionGroupStatusDetail["name"];
}

export function newErpTransactionGroupStatusDetail(
  options: ErpTransactionGroupStatusDetailOptions = {},
  cache: Record<string, any> = {},
): ErpTransactionGroupStatusDetail {
  const o =
    (options.__typename ? options : cache["ErpTransactionGroupStatusDetail"] = {}) as ErpTransactionGroupStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ErpTransactionGroupStatusDetail";
  o.code = options.code ?? ErpTransactionGroupStatus.Pending;
  o.name = options.name ?? "Pending";
  return o;
}

factories["ErpTransactionGroupStatusDetail"] = newErpTransactionGroupStatusDetail;

export interface ErpTransactionStatusDetailOptions {
  __typename?: "ErpTransactionStatusDetail";
  code?: ErpTransactionStatusDetail["code"];
  name?: ErpTransactionStatusDetail["name"];
}

export function newErpTransactionStatusDetail(
  options: ErpTransactionStatusDetailOptions = {},
  cache: Record<string, any> = {},
): ErpTransactionStatusDetail {
  const o = (options.__typename ? options : cache["ErpTransactionStatusDetail"] = {}) as ErpTransactionStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ErpTransactionStatusDetail";
  o.code = options.code ?? ErpTransactionStatus.Pending;
  o.name = options.name ?? "Pending";
  return o;
}

factories["ErpTransactionStatusDetail"] = newErpTransactionStatusDetail;

export interface EstimateStatusDetailOptions {
  __typename?: "EstimateStatusDetail";
  code?: EstimateStatusDetail["code"];
  name?: EstimateStatusDetail["name"];
}

export function newEstimateStatusDetail(
  options: EstimateStatusDetailOptions = {},
  cache: Record<string, any> = {},
): EstimateStatusDetail {
  const o = (options.__typename ? options : cache["EstimateStatusDetail"] = {}) as EstimateStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "EstimateStatusDetail";
  o.code = options.code ?? EstimateStatus.Draft;
  o.name = options.name ?? "Draft";
  return o;
}

factories["EstimateStatusDetail"] = newEstimateStatusDetail;

export interface EstimateTypeDetailOptions {
  __typename?: "EstimateTypeDetail";
  code?: EstimateTypeDetail["code"];
  name?: EstimateTypeDetail["name"];
}

export function newEstimateTypeDetail(
  options: EstimateTypeDetailOptions = {},
  cache: Record<string, any> = {},
): EstimateTypeDetail {
  const o = (options.__typename ? options : cache["EstimateTypeDetail"] = {}) as EstimateTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "EstimateTypeDetail";
  o.code = options.code ?? EstimateType.Preliminary;
  o.name = options.name ?? "Preliminary";
  return o;
}

factories["EstimateTypeDetail"] = newEstimateTypeDetail;

export interface FeatureFlagStatusDetailOptions {
  __typename?: "FeatureFlagStatusDetail";
  code?: FeatureFlagStatusDetail["code"];
  name?: FeatureFlagStatusDetail["name"];
}

export function newFeatureFlagStatusDetail(
  options: FeatureFlagStatusDetailOptions = {},
  cache: Record<string, any> = {},
): FeatureFlagStatusDetail {
  const o = (options.__typename ? options : cache["FeatureFlagStatusDetail"] = {}) as FeatureFlagStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "FeatureFlagStatusDetail";
  o.code = options.code ?? FeatureFlagStatus.Active;
  o.name = options.name ?? "Active";
  return o;
}

factories["FeatureFlagStatusDetail"] = newFeatureFlagStatusDetail;

export interface FeatureFlagTypeDetailOptions {
  __typename?: "FeatureFlagTypeDetail";
  code?: FeatureFlagTypeDetail["code"];
  name?: FeatureFlagTypeDetail["name"];
  description?: FeatureFlagTypeDetail["description"];
  presentational?: FeatureFlagTypeDetail["presentational"];
}

export function newFeatureFlagTypeDetail(
  options: FeatureFlagTypeDetailOptions = {},
  cache: Record<string, any> = {},
): FeatureFlagTypeDetail {
  const o = (options.__typename ? options : cache["FeatureFlagTypeDetail"] = {}) as FeatureFlagTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "FeatureFlagTypeDetail";
  o.code = options.code ?? FeatureFlagType.TestFeature;
  o.name = options.name ?? "Test feature";
  o.description = options.description ?? "Test feature";
  o.presentational = options.presentational ?? false;
  return o;
}

factories["FeatureFlagTypeDetail"] = newFeatureFlagTypeDetail;

export interface FloodPlainDetailOptions {
  __typename?: "FloodPlainDetail";
  code?: FloodPlainDetail["code"];
  name?: FloodPlainDetail["name"];
}

export function newFloodPlainDetail(
  options: FloodPlainDetailOptions = {},
  cache: Record<string, any> = {},
): FloodPlainDetail {
  const o = (options.__typename ? options : cache["FloodPlainDetail"] = {}) as FloodPlainDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "FloodPlainDetail";
  o.code = options.code ?? FloodPlain.Fp_0;
  o.name = options.name ?? "Fp 0";
  return o;
}

factories["FloodPlainDetail"] = newFloodPlainDetail;

export interface FloodZoneDetailOptions {
  __typename?: "FloodZoneDetail";
  code?: FloodZoneDetail["code"];
  name?: FloodZoneDetail["name"];
}

export function newFloodZoneDetail(
  options: FloodZoneDetailOptions = {},
  cache: Record<string, any> = {},
): FloodZoneDetail {
  const o = (options.__typename ? options : cache["FloodZoneDetail"] = {}) as FloodZoneDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "FloodZoneDetail";
  o.code = options.code ?? FloodZone.FzNone;
  o.name = options.name ?? "Fz none";
  return o;
}

factories["FloodZoneDetail"] = newFloodZoneDetail;

export interface FoundationTypeDetailOptions {
  __typename?: "FoundationTypeDetail";
  code?: FoundationTypeDetail["code"];
  name?: FoundationTypeDetail["name"];
}

export function newFoundationTypeDetail(
  options: FoundationTypeDetailOptions = {},
  cache: Record<string, any> = {},
): FoundationTypeDetail {
  const o = (options.__typename ? options : cache["FoundationTypeDetail"] = {}) as FoundationTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "FoundationTypeDetail";
  o.code = options.code ?? FoundationType.Slab;
  o.name = options.name ?? "Slab";
  return o;
}

factories["FoundationTypeDetail"] = newFoundationTypeDetail;

export interface GlobalOptionStatusDetailOptions {
  __typename?: "GlobalOptionStatusDetail";
  code?: GlobalOptionStatusDetail["code"];
  name?: GlobalOptionStatusDetail["name"];
}

export function newGlobalOptionStatusDetail(
  options: GlobalOptionStatusDetailOptions = {},
  cache: Record<string, any> = {},
): GlobalOptionStatusDetail {
  const o = (options.__typename ? options : cache["GlobalOptionStatusDetail"] = {}) as GlobalOptionStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalOptionStatusDetail";
  o.code = options.code ?? GlobalOptionStatus.Active;
  o.name = options.name ?? "Active";
  return o;
}

factories["GlobalOptionStatusDetail"] = newGlobalOptionStatusDetail;

export interface GlobalOptionTypeStatusDetailOptions {
  __typename?: "GlobalOptionTypeStatusDetail";
  code?: GlobalOptionTypeStatusDetail["code"];
  name?: GlobalOptionTypeStatusDetail["name"];
}

export function newGlobalOptionTypeStatusDetail(
  options: GlobalOptionTypeStatusDetailOptions = {},
  cache: Record<string, any> = {},
): GlobalOptionTypeStatusDetail {
  const o = (options.__typename ? options : cache["GlobalOptionTypeStatusDetail"] = {}) as GlobalOptionTypeStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalOptionTypeStatusDetail";
  o.code = options.code ?? GlobalOptionTypeStatus.Active;
  o.name = options.name ?? "Active";
  return o;
}

factories["GlobalOptionTypeStatusDetail"] = newGlobalOptionTypeStatusDetail;

export interface HomeownerSelectionOptionPricingTypeDetailOptions {
  __typename?: "HomeownerSelectionOptionPricingTypeDetail";
  code?: HomeownerSelectionOptionPricingTypeDetail["code"];
  name?: HomeownerSelectionOptionPricingTypeDetail["name"];
}

export function newHomeownerSelectionOptionPricingTypeDetail(
  options: HomeownerSelectionOptionPricingTypeDetailOptions = {},
  cache: Record<string, any> = {},
): HomeownerSelectionOptionPricingTypeDetail {
  const o =
    (options.__typename
      ? options
      : cache["HomeownerSelectionOptionPricingTypeDetail"] = {}) as HomeownerSelectionOptionPricingTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "HomeownerSelectionOptionPricingTypeDetail";
  o.code = options.code ?? HomeownerSelectionOptionPricingType.None;
  o.name = options.name ?? "None";
  return o;
}

factories["HomeownerSelectionOptionPricingTypeDetail"] = newHomeownerSelectionOptionPricingTypeDetail;

export interface HomeownerSelectionStatusDetailOptions {
  __typename?: "HomeownerSelectionStatusDetail";
  code?: HomeownerSelectionStatusDetail["code"];
  name?: HomeownerSelectionStatusDetail["name"];
}

export function newHomeownerSelectionStatusDetail(
  options: HomeownerSelectionStatusDetailOptions = {},
  cache: Record<string, any> = {},
): HomeownerSelectionStatusDetail {
  const o =
    (options.__typename ? options : cache["HomeownerSelectionStatusDetail"] = {}) as HomeownerSelectionStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "HomeownerSelectionStatusDetail";
  o.code = options.code ?? HomeownerSelectionStatus.Declined;
  o.name = options.name ?? "Declined";
  return o;
}

factories["HomeownerSelectionStatusDetail"] = newHomeownerSelectionStatusDetail;

export interface InboxItemStatusDetailOptions {
  __typename?: "InboxItemStatusDetail";
  code?: InboxItemStatusDetail["code"];
  name?: InboxItemStatusDetail["name"];
}

export function newInboxItemStatusDetail(
  options: InboxItemStatusDetailOptions = {},
  cache: Record<string, any> = {},
): InboxItemStatusDetail {
  const o = (options.__typename ? options : cache["InboxItemStatusDetail"] = {}) as InboxItemStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InboxItemStatusDetail";
  o.code = options.code ?? InboxItemStatus.Read;
  o.name = options.name ?? "Read";
  return o;
}

factories["InboxItemStatusDetail"] = newInboxItemStatusDetail;

export interface InvoiceDocumentSourceDetailOptions {
  __typename?: "InvoiceDocumentSourceDetail";
  code?: InvoiceDocumentSourceDetail["code"];
  name?: InvoiceDocumentSourceDetail["name"];
}

export function newInvoiceDocumentSourceDetail(
  options: InvoiceDocumentSourceDetailOptions = {},
  cache: Record<string, any> = {},
): InvoiceDocumentSourceDetail {
  const o = (options.__typename ? options : cache["InvoiceDocumentSourceDetail"] = {}) as InvoiceDocumentSourceDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InvoiceDocumentSourceDetail";
  o.code = options.code ?? InvoiceDocumentSource.Quickbooks;
  o.name = options.name ?? "Quickbooks";
  return o;
}

factories["InvoiceDocumentSourceDetail"] = newInvoiceDocumentSourceDetail;

export interface InvoiceScheduleAmountTypeDetailOptions {
  __typename?: "InvoiceScheduleAmountTypeDetail";
  code?: InvoiceScheduleAmountTypeDetail["code"];
  name?: InvoiceScheduleAmountTypeDetail["name"];
}

export function newInvoiceScheduleAmountTypeDetail(
  options: InvoiceScheduleAmountTypeDetailOptions = {},
  cache: Record<string, any> = {},
): InvoiceScheduleAmountTypeDetail {
  const o =
    (options.__typename ? options : cache["InvoiceScheduleAmountTypeDetail"] = {}) as InvoiceScheduleAmountTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InvoiceScheduleAmountTypeDetail";
  o.code = options.code ?? InvoiceScheduleAmountType.Cost;
  o.name = options.name ?? "Cost";
  return o;
}

factories["InvoiceScheduleAmountTypeDetail"] = newInvoiceScheduleAmountTypeDetail;

export interface InvoiceScheduleItemFrequencyDetailOptions {
  __typename?: "InvoiceScheduleItemFrequencyDetail";
  code?: InvoiceScheduleItemFrequencyDetail["code"];
  name?: InvoiceScheduleItemFrequencyDetail["name"];
}

export function newInvoiceScheduleItemFrequencyDetail(
  options: InvoiceScheduleItemFrequencyDetailOptions = {},
  cache: Record<string, any> = {},
): InvoiceScheduleItemFrequencyDetail {
  const o =
    (options.__typename
      ? options
      : cache["InvoiceScheduleItemFrequencyDetail"] = {}) as InvoiceScheduleItemFrequencyDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InvoiceScheduleItemFrequencyDetail";
  o.code = options.code ?? InvoiceScheduleItemFrequency.Once;
  o.name = options.name ?? "Once";
  return o;
}

factories["InvoiceScheduleItemFrequencyDetail"] = newInvoiceScheduleItemFrequencyDetail;

export interface InvoiceScheduleTriggerTypeDetailOptions {
  __typename?: "InvoiceScheduleTriggerTypeDetail";
  code?: InvoiceScheduleTriggerTypeDetail["code"];
  name?: InvoiceScheduleTriggerTypeDetail["name"];
}

export function newInvoiceScheduleTriggerTypeDetail(
  options: InvoiceScheduleTriggerTypeDetailOptions = {},
  cache: Record<string, any> = {},
): InvoiceScheduleTriggerTypeDetail {
  const o =
    (options.__typename ? options : cache["InvoiceScheduleTriggerTypeDetail"] = {}) as InvoiceScheduleTriggerTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InvoiceScheduleTriggerTypeDetail";
  o.code = options.code ?? InvoiceScheduleTriggerType.Date;
  o.name = options.name ?? "Date";
  return o;
}

factories["InvoiceScheduleTriggerTypeDetail"] = newInvoiceScheduleTriggerTypeDetail;

export interface InvoiceSourceDetailOptions {
  __typename?: "InvoiceSourceDetail";
  code?: InvoiceSourceDetail["code"];
  name?: InvoiceSourceDetail["name"];
}

export function newInvoiceSourceDetail(
  options: InvoiceSourceDetailOptions = {},
  cache: Record<string, any> = {},
): InvoiceSourceDetail {
  const o = (options.__typename ? options : cache["InvoiceSourceDetail"] = {}) as InvoiceSourceDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InvoiceSourceDetail";
  o.code = options.code ?? InvoiceSource.Auto;
  o.name = options.name ?? "Auto";
  return o;
}

factories["InvoiceSourceDetail"] = newInvoiceSourceDetail;

export interface InvoiceStatusDetailOptions {
  __typename?: "InvoiceStatusDetail";
  code?: InvoiceStatusDetail["code"];
  name?: InvoiceStatusDetail["name"];
}

export function newInvoiceStatusDetail(
  options: InvoiceStatusDetailOptions = {},
  cache: Record<string, any> = {},
): InvoiceStatusDetail {
  const o = (options.__typename ? options : cache["InvoiceStatusDetail"] = {}) as InvoiceStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InvoiceStatusDetail";
  o.code = options.code ?? InvoiceStatus.Draft;
  o.name = options.name ?? "Draft";
  return o;
}

factories["InvoiceStatusDetail"] = newInvoiceStatusDetail;

export interface InvoiceTypeDetailOptions {
  __typename?: "InvoiceTypeDetail";
  code?: InvoiceTypeDetail["code"];
  name?: InvoiceTypeDetail["name"];
}

export function newInvoiceTypeDetail(
  options: InvoiceTypeDetailOptions = {},
  cache: Record<string, any> = {},
): InvoiceTypeDetail {
  const o = (options.__typename ? options : cache["InvoiceTypeDetail"] = {}) as InvoiceTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InvoiceTypeDetail";
  o.code = options.code ?? InvoiceType.PercentageOfCompletion;
  o.name = options.name ?? "Percentage of completion";
  return o;
}

factories["InvoiceTypeDetail"] = newInvoiceTypeDetail;

export interface ItemStatusDetailOptions {
  __typename?: "ItemStatusDetail";
  code?: ItemStatusDetail["code"];
  name?: ItemStatusDetail["name"];
}

export function newItemStatusDetail(
  options: ItemStatusDetailOptions = {},
  cache: Record<string, any> = {},
): ItemStatusDetail {
  const o = (options.__typename ? options : cache["ItemStatusDetail"] = {}) as ItemStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ItemStatusDetail";
  o.code = options.code ?? ItemStatus.Draft;
  o.name = options.name ?? "Draft";
  return o;
}

factories["ItemStatusDetail"] = newItemStatusDetail;

export interface ItemTemplateItemCostStatusDetailOptions {
  __typename?: "ItemTemplateItemCostStatusDetail";
  code?: ItemTemplateItemCostStatusDetail["code"];
  name?: ItemTemplateItemCostStatusDetail["name"];
}

export function newItemTemplateItemCostStatusDetail(
  options: ItemTemplateItemCostStatusDetailOptions = {},
  cache: Record<string, any> = {},
): ItemTemplateItemCostStatusDetail {
  const o =
    (options.__typename ? options : cache["ItemTemplateItemCostStatusDetail"] = {}) as ItemTemplateItemCostStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ItemTemplateItemCostStatusDetail";
  o.code = options.code ?? ItemTemplateItemCostStatus.InternalEstimate;
  o.name = options.name ?? "Internal estimate";
  return o;
}

factories["ItemTemplateItemCostStatusDetail"] = newItemTemplateItemCostStatusDetail;

export interface ItemTemplateStatusDetailOptions {
  __typename?: "ItemTemplateStatusDetail";
  code?: ItemTemplateStatusDetail["code"];
  name?: ItemTemplateStatusDetail["name"];
}

export function newItemTemplateStatusDetail(
  options: ItemTemplateStatusDetailOptions = {},
  cache: Record<string, any> = {},
): ItemTemplateStatusDetail {
  const o = (options.__typename ? options : cache["ItemTemplateStatusDetail"] = {}) as ItemTemplateStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ItemTemplateStatusDetail";
  o.code = options.code ?? ItemTemplateStatus.Draft;
  o.name = options.name ?? "Draft";
  return o;
}

factories["ItemTemplateStatusDetail"] = newItemTemplateStatusDetail;

export interface JobLogFlagDetailOptions {
  __typename?: "JobLogFlagDetail";
  code?: JobLogFlagDetail["code"];
  name?: JobLogFlagDetail["name"];
}

export function newJobLogFlagDetail(
  options: JobLogFlagDetailOptions = {},
  cache: Record<string, any> = {},
): JobLogFlagDetail {
  const o = (options.__typename ? options : cache["JobLogFlagDetail"] = {}) as JobLogFlagDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "JobLogFlagDetail";
  o.code = options.code ?? JobLogFlag.ChangeOrderDelay;
  o.name = options.name ?? "Change order delay";
  return o;
}

factories["JobLogFlagDetail"] = newJobLogFlagDetail;

export interface JobLogNoteTypeDetailOptions {
  __typename?: "JobLogNoteTypeDetail";
  code?: JobLogNoteTypeDetail["code"];
  name?: JobLogNoteTypeDetail["name"];
}

export function newJobLogNoteTypeDetail(
  options: JobLogNoteTypeDetailOptions = {},
  cache: Record<string, any> = {},
): JobLogNoteTypeDetail {
  const o = (options.__typename ? options : cache["JobLogNoteTypeDetail"] = {}) as JobLogNoteTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "JobLogNoteTypeDetail";
  o.code = options.code ?? JobLogNoteType.Delay;
  o.name = options.name ?? "Delay";
  return o;
}

factories["JobLogNoteTypeDetail"] = newJobLogNoteTypeDetail;

export interface LienWaiverConditionDetailOptions {
  __typename?: "LienWaiverConditionDetail";
  code?: LienWaiverConditionDetail["code"];
  name?: LienWaiverConditionDetail["name"];
}

export function newLienWaiverConditionDetail(
  options: LienWaiverConditionDetailOptions = {},
  cache: Record<string, any> = {},
): LienWaiverConditionDetail {
  const o = (options.__typename ? options : cache["LienWaiverConditionDetail"] = {}) as LienWaiverConditionDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "LienWaiverConditionDetail";
  o.code = options.code ?? LienWaiverCondition.Unconditional;
  o.name = options.name ?? "Unconditional";
  return o;
}

factories["LienWaiverConditionDetail"] = newLienWaiverConditionDetail;

export interface LienWaiverStatusDetailOptions {
  __typename?: "LienWaiverStatusDetail";
  code?: LienWaiverStatusDetail["code"];
  name?: LienWaiverStatusDetail["name"];
}

export function newLienWaiverStatusDetail(
  options: LienWaiverStatusDetailOptions = {},
  cache: Record<string, any> = {},
): LienWaiverStatusDetail {
  const o = (options.__typename ? options : cache["LienWaiverStatusDetail"] = {}) as LienWaiverStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "LienWaiverStatusDetail";
  o.code = options.code ?? LienWaiverStatus.Draft;
  o.name = options.name ?? "Draft";
  return o;
}

factories["LienWaiverStatusDetail"] = newLienWaiverStatusDetail;

export interface LienWaiverTypeDetailOptions {
  __typename?: "LienWaiverTypeDetail";
  code?: LienWaiverTypeDetail["code"];
  name?: LienWaiverTypeDetail["name"];
}

export function newLienWaiverTypeDetail(
  options: LienWaiverTypeDetailOptions = {},
  cache: Record<string, any> = {},
): LienWaiverTypeDetail {
  const o = (options.__typename ? options : cache["LienWaiverTypeDetail"] = {}) as LienWaiverTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "LienWaiverTypeDetail";
  o.code = options.code ?? LienWaiverType.Progress;
  o.name = options.name ?? "Progress";
  return o;
}

factories["LienWaiverTypeDetail"] = newLienWaiverTypeDetail;

export interface LocationTypeDetailOptions {
  __typename?: "LocationTypeDetail";
  code?: LocationTypeDetail["code"];
  name?: LocationTypeDetail["name"];
  sortOrder?: LocationTypeDetail["sortOrder"];
}

export function newLocationTypeDetail(
  options: LocationTypeDetailOptions = {},
  cache: Record<string, any> = {},
): LocationTypeDetail {
  const o = (options.__typename ? options : cache["LocationTypeDetail"] = {}) as LocationTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "LocationTypeDetail";
  o.code = options.code ?? LocationType.Group;
  o.name = options.name ?? "Group";
  o.sortOrder = options.sortOrder ?? 0;
  return o;
}

factories["LocationTypeDetail"] = newLocationTypeDetail;

export interface LotSalesStatusDetailOptions {
  __typename?: "LotSalesStatusDetail";
  code?: LotSalesStatusDetail["code"];
  name?: LotSalesStatusDetail["name"];
}

export function newLotSalesStatusDetail(
  options: LotSalesStatusDetailOptions = {},
  cache: Record<string, any> = {},
): LotSalesStatusDetail {
  const o = (options.__typename ? options : cache["LotSalesStatusDetail"] = {}) as LotSalesStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "LotSalesStatusDetail";
  o.code = options.code ?? LotSalesStatus.NotAvailable;
  o.name = options.name ?? "Not available";
  return o;
}

factories["LotSalesStatusDetail"] = newLotSalesStatusDetail;

export interface LotTypeDetailOptions {
  __typename?: "LotTypeDetail";
  code?: LotTypeDetail["code"];
  name?: LotTypeDetail["name"];
  clientContract?: LotTypeDetail["clientContract"];
  clientNoun?: LotTypeDetail["clientNoun"];
  initialBudget?: LotTypeDetail["initialBudget"];
  shortClientNoun?: LotTypeDetail["shortClientNoun"];
  clientInvoice?: LotTypeDetail["clientInvoice"];
  description?: LotTypeDetail["description"];
}

export function newLotTypeDetail(options: LotTypeDetailOptions = {}, cache: Record<string, any> = {}): LotTypeDetail {
  const o = (options.__typename ? options : cache["LotTypeDetail"] = {}) as LotTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "LotTypeDetail";
  o.code = options.code ?? LotType.Boyl;
  o.name = options.name ?? "Boyl";
  o.clientContract = options.clientContract ?? "Boyl";
  o.clientNoun = options.clientNoun ?? "Boyl";
  o.initialBudget = options.initialBudget ?? "Boyl";
  o.shortClientNoun = options.shortClientNoun ?? "Boyl";
  o.clientInvoice = options.clientInvoice ?? "Boyl";
  o.description = options.description ?? "Boyl";
  return o;
}

factories["LotTypeDetail"] = newLotTypeDetail;

export interface MarkupApplicationMethodDetailOptions {
  __typename?: "MarkupApplicationMethodDetail";
  code?: MarkupApplicationMethodDetail["code"];
  name?: MarkupApplicationMethodDetail["name"];
}

export function newMarkupApplicationMethodDetail(
  options: MarkupApplicationMethodDetailOptions = {},
  cache: Record<string, any> = {},
): MarkupApplicationMethodDetail {
  const o =
    (options.__typename ? options : cache["MarkupApplicationMethodDetail"] = {}) as MarkupApplicationMethodDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MarkupApplicationMethodDetail";
  o.code = options.code ?? MarkupApplicationMethod.PerLineItem;
  o.name = options.name ?? "Per line item";
  return o;
}

factories["MarkupApplicationMethodDetail"] = newMarkupApplicationMethodDetail;

export interface MaterialAttributeDimensionTypeDetailOptions {
  __typename?: "MaterialAttributeDimensionTypeDetail";
  code?: MaterialAttributeDimensionTypeDetail["code"];
  name?: MaterialAttributeDimensionTypeDetail["name"];
}

export function newMaterialAttributeDimensionTypeDetail(
  options: MaterialAttributeDimensionTypeDetailOptions = {},
  cache: Record<string, any> = {},
): MaterialAttributeDimensionTypeDetail {
  const o =
    (options.__typename
      ? options
      : cache["MaterialAttributeDimensionTypeDetail"] = {}) as MaterialAttributeDimensionTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MaterialAttributeDimensionTypeDetail";
  o.code = options.code ?? MaterialAttributeDimensionType.Number;
  o.name = options.name ?? "Number";
  return o;
}

factories["MaterialAttributeDimensionTypeDetail"] = newMaterialAttributeDimensionTypeDetail;

export interface MaterialAttributeValueTypeDetailOptions {
  __typename?: "MaterialAttributeValueTypeDetail";
  code?: MaterialAttributeValueTypeDetail["code"];
  name?: MaterialAttributeValueTypeDetail["name"];
}

export function newMaterialAttributeValueTypeDetail(
  options: MaterialAttributeValueTypeDetailOptions = {},
  cache: Record<string, any> = {},
): MaterialAttributeValueTypeDetail {
  const o =
    (options.__typename ? options : cache["MaterialAttributeValueTypeDetail"] = {}) as MaterialAttributeValueTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MaterialAttributeValueTypeDetail";
  o.code = options.code ?? MaterialAttributeValueType.Exact;
  o.name = options.name ?? "Exact";
  return o;
}

factories["MaterialAttributeValueTypeDetail"] = newMaterialAttributeValueTypeDetail;

export interface MaterialTypeDetailOptions {
  __typename?: "MaterialTypeDetail";
  code?: MaterialTypeDetail["code"];
  name?: MaterialTypeDetail["name"];
}

export function newMaterialTypeDetail(
  options: MaterialTypeDetailOptions = {},
  cache: Record<string, any> = {},
): MaterialTypeDetail {
  const o = (options.__typename ? options : cache["MaterialTypeDetail"] = {}) as MaterialTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MaterialTypeDetail";
  o.code = options.code ?? MaterialType.Placeholder;
  o.name = options.name ?? "Placeholder";
  return o;
}

factories["MaterialTypeDetail"] = newMaterialTypeDetail;

export interface MobileSyncUpdateTypeDetailOptions {
  __typename?: "MobileSyncUpdateTypeDetail";
  code?: MobileSyncUpdateTypeDetail["code"];
  name?: MobileSyncUpdateTypeDetail["name"];
}

export function newMobileSyncUpdateTypeDetail(
  options: MobileSyncUpdateTypeDetailOptions = {},
  cache: Record<string, any> = {},
): MobileSyncUpdateTypeDetail {
  const o = (options.__typename ? options : cache["MobileSyncUpdateTypeDetail"] = {}) as MobileSyncUpdateTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MobileSyncUpdateTypeDetail";
  o.code = options.code ?? MobileSyncUpdateType.Created;
  o.name = options.name ?? "Created";
  return o;
}

factories["MobileSyncUpdateTypeDetail"] = newMobileSyncUpdateTypeDetail;

export interface PandaDocRoleDetailOptions {
  __typename?: "PandaDocRoleDetail";
  code?: PandaDocRoleDetail["code"];
  name?: PandaDocRoleDetail["name"];
  shortName?: PandaDocRoleDetail["shortName"];
}

export function newPandaDocRoleDetail(
  options: PandaDocRoleDetailOptions = {},
  cache: Record<string, any> = {},
): PandaDocRoleDetail {
  const o = (options.__typename ? options : cache["PandaDocRoleDetail"] = {}) as PandaDocRoleDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PandaDocRoleDetail";
  o.code = options.code ?? PandaDocRole.User;
  o.name = options.name ?? "User";
  o.shortName = options.shortName ?? "User";
  return o;
}

factories["PandaDocRoleDetail"] = newPandaDocRoleDetail;

export interface PandaDocStatusDetailOptions {
  __typename?: "PandaDocStatusDetail";
  code?: PandaDocStatusDetail["code"];
  name?: PandaDocStatusDetail["name"];
  externalCode?: PandaDocStatusDetail["externalCode"];
  externalNumber?: PandaDocStatusDetail["externalNumber"];
}

export function newPandaDocStatusDetail(
  options: PandaDocStatusDetailOptions = {},
  cache: Record<string, any> = {},
): PandaDocStatusDetail {
  const o = (options.__typename ? options : cache["PandaDocStatusDetail"] = {}) as PandaDocStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PandaDocStatusDetail";
  o.code = options.code ?? PandaDocStatus.Pending;
  o.name = options.name ?? "Pending";
  o.externalCode = options.externalCode ?? "Pending";
  o.externalNumber = options.externalNumber ?? 0;
  return o;
}

factories["PandaDocStatusDetail"] = newPandaDocStatusDetail;

export interface PandaDocWorkspaceDetailOptions {
  __typename?: "PandaDocWorkspaceDetail";
  code?: PandaDocWorkspaceDetail["code"];
  name?: PandaDocWorkspaceDetail["name"];
}

export function newPandaDocWorkspaceDetail(
  options: PandaDocWorkspaceDetailOptions = {},
  cache: Record<string, any> = {},
): PandaDocWorkspaceDetail {
  const o = (options.__typename ? options : cache["PandaDocWorkspaceDetail"] = {}) as PandaDocWorkspaceDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PandaDocWorkspaceDetail";
  o.code = options.code ?? PandaDocWorkspace.Homebound;
  o.name = options.name ?? "Homebound";
  return o;
}

factories["PandaDocWorkspaceDetail"] = newPandaDocWorkspaceDetail;

export interface PaymentTermDueFromDetailOptions {
  __typename?: "PaymentTermDueFromDetail";
  code?: PaymentTermDueFromDetail["code"];
  name?: PaymentTermDueFromDetail["name"];
}

export function newPaymentTermDueFromDetail(
  options: PaymentTermDueFromDetailOptions = {},
  cache: Record<string, any> = {},
): PaymentTermDueFromDetail {
  const o = (options.__typename ? options : cache["PaymentTermDueFromDetail"] = {}) as PaymentTermDueFromDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PaymentTermDueFromDetail";
  o.code = options.code ?? PaymentTermDueFrom.FromInvoiceBillDate;
  o.name = options.name ?? "From invoice bill date";
  return o;
}

factories["PaymentTermDueFromDetail"] = newPaymentTermDueFromDetail;

export interface PermitDetailOptions {
  __typename?: "PermitDetail";
  code?: PermitDetail["code"];
  name?: PermitDetail["name"];
}

export function newPermitDetail(options: PermitDetailOptions = {}, cache: Record<string, any> = {}): PermitDetail {
  const o = (options.__typename ? options : cache["PermitDetail"] = {}) as PermitDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PermitDetail";
  o.code = options.code ?? Permit.Zoning;
  o.name = options.name ?? "Zoning";
  return o;
}

factories["PermitDetail"] = newPermitDetail;

export interface ProductAttributeTypeDetailOptions {
  __typename?: "ProductAttributeTypeDetail";
  code?: ProductAttributeTypeDetail["code"];
  name?: ProductAttributeTypeDetail["name"];
}

export function newProductAttributeTypeDetail(
  options: ProductAttributeTypeDetailOptions = {},
  cache: Record<string, any> = {},
): ProductAttributeTypeDetail {
  const o = (options.__typename ? options : cache["ProductAttributeTypeDetail"] = {}) as ProductAttributeTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProductAttributeTypeDetail";
  o.code = options.code ?? ProductAttributeType.Finish;
  o.name = options.name ?? "Finish";
  return o;
}

factories["ProductAttributeTypeDetail"] = newProductAttributeTypeDetail;

export interface ProductDimensionTypeDetailOptions {
  __typename?: "ProductDimensionTypeDetail";
  code?: ProductDimensionTypeDetail["code"];
  name?: ProductDimensionTypeDetail["name"];
  sortOrder?: ProductDimensionTypeDetail["sortOrder"];
  abbreviation?: ProductDimensionTypeDetail["abbreviation"];
}

export function newProductDimensionTypeDetail(
  options: ProductDimensionTypeDetailOptions = {},
  cache: Record<string, any> = {},
): ProductDimensionTypeDetail {
  const o = (options.__typename ? options : cache["ProductDimensionTypeDetail"] = {}) as ProductDimensionTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProductDimensionTypeDetail";
  o.code = options.code ?? ProductDimensionType.Width;
  o.name = options.name ?? "Width";
  o.sortOrder = options.sortOrder ?? 0;
  o.abbreviation = options.abbreviation ?? "Width";
  return o;
}

factories["ProductDimensionTypeDetail"] = newProductDimensionTypeDetail;

export interface ProductStatusDetailOptions {
  __typename?: "ProductStatusDetail";
  code?: ProductStatusDetail["code"];
  name?: ProductStatusDetail["name"];
}

export function newProductStatusDetail(
  options: ProductStatusDetailOptions = {},
  cache: Record<string, any> = {},
): ProductStatusDetail {
  const o = (options.__typename ? options : cache["ProductStatusDetail"] = {}) as ProductStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProductStatusDetail";
  o.code = options.code ?? ProductStatus.Draft;
  o.name = options.name ?? "Draft";
  return o;
}

factories["ProductStatusDetail"] = newProductStatusDetail;

export interface ProgramDataBasementConfigDetailOptions {
  __typename?: "ProgramDataBasementConfigDetail";
  code?: ProgramDataBasementConfigDetail["code"];
  name?: ProgramDataBasementConfigDetail["name"];
}

export function newProgramDataBasementConfigDetail(
  options: ProgramDataBasementConfigDetailOptions = {},
  cache: Record<string, any> = {},
): ProgramDataBasementConfigDetail {
  const o =
    (options.__typename ? options : cache["ProgramDataBasementConfigDetail"] = {}) as ProgramDataBasementConfigDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProgramDataBasementConfigDetail";
  o.code = options.code ?? ProgramDataBasementConfig.No;
  o.name = options.name ?? "No";
  return o;
}

factories["ProgramDataBasementConfigDetail"] = newProgramDataBasementConfigDetail;

export interface ProgramDataGarageConfigDetailOptions {
  __typename?: "ProgramDataGarageConfigDetail";
  code?: ProgramDataGarageConfigDetail["code"];
  name?: ProgramDataGarageConfigDetail["name"];
}

export function newProgramDataGarageConfigDetail(
  options: ProgramDataGarageConfigDetailOptions = {},
  cache: Record<string, any> = {},
): ProgramDataGarageConfigDetail {
  const o =
    (options.__typename ? options : cache["ProgramDataGarageConfigDetail"] = {}) as ProgramDataGarageConfigDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProgramDataGarageConfigDetail";
  o.code = options.code ?? ProgramDataGarageConfig.FrontLoad;
  o.name = options.name ?? "Front load";
  return o;
}

factories["ProgramDataGarageConfigDetail"] = newProgramDataGarageConfigDetail;

export interface ProgramDataMatchStateDetailOptions {
  __typename?: "ProgramDataMatchStateDetail";
  code?: ProgramDataMatchStateDetail["code"];
  name?: ProgramDataMatchStateDetail["name"];
}

export function newProgramDataMatchStateDetail(
  options: ProgramDataMatchStateDetailOptions = {},
  cache: Record<string, any> = {},
): ProgramDataMatchStateDetail {
  const o = (options.__typename ? options : cache["ProgramDataMatchStateDetail"] = {}) as ProgramDataMatchStateDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProgramDataMatchStateDetail";
  o.code = options.code ?? ProgramDataMatchState.Matches;
  o.name = options.name ?? "Matches";
  return o;
}

factories["ProgramDataMatchStateDetail"] = newProgramDataMatchStateDetail;

export interface ProgramDataPrimaryBedroomConfigDetailOptions {
  __typename?: "ProgramDataPrimaryBedroomConfigDetail";
  code?: ProgramDataPrimaryBedroomConfigDetail["code"];
  name?: ProgramDataPrimaryBedroomConfigDetail["name"];
}

export function newProgramDataPrimaryBedroomConfigDetail(
  options: ProgramDataPrimaryBedroomConfigDetailOptions = {},
  cache: Record<string, any> = {},
): ProgramDataPrimaryBedroomConfigDetail {
  const o =
    (options.__typename
      ? options
      : cache["ProgramDataPrimaryBedroomConfigDetail"] = {}) as ProgramDataPrimaryBedroomConfigDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProgramDataPrimaryBedroomConfigDetail";
  o.code = options.code ?? ProgramDataPrimaryBedroomConfig.Up;
  o.name = options.name ?? "Up";
  return o;
}

factories["ProgramDataPrimaryBedroomConfigDetail"] = newProgramDataPrimaryBedroomConfigDetail;

export interface ProgramDataWindowColorDetailOptions {
  __typename?: "ProgramDataWindowColorDetail";
  code?: ProgramDataWindowColorDetail["code"];
  name?: ProgramDataWindowColorDetail["name"];
}

export function newProgramDataWindowColorDetail(
  options: ProgramDataWindowColorDetailOptions = {},
  cache: Record<string, any> = {},
): ProgramDataWindowColorDetail {
  const o = (options.__typename ? options : cache["ProgramDataWindowColorDetail"] = {}) as ProgramDataWindowColorDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProgramDataWindowColorDetail";
  o.code = options.code ?? ProgramDataWindowColor.White;
  o.name = options.name ?? "White";
  return o;
}

factories["ProgramDataWindowColorDetail"] = newProgramDataWindowColorDetail;

export interface ProjectCollaboratorRoleDetailOptions {
  __typename?: "ProjectCollaboratorRoleDetail";
  code?: ProjectCollaboratorRoleDetail["code"];
  name?: ProjectCollaboratorRoleDetail["name"];
}

export function newProjectCollaboratorRoleDetail(
  options: ProjectCollaboratorRoleDetailOptions = {},
  cache: Record<string, any> = {},
): ProjectCollaboratorRoleDetail {
  const o =
    (options.__typename ? options : cache["ProjectCollaboratorRoleDetail"] = {}) as ProjectCollaboratorRoleDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectCollaboratorRoleDetail";
  o.code = options.code ?? ProjectCollaboratorRole.Homeowner;
  o.name = options.name ?? "Homeowner";
  return o;
}

factories["ProjectCollaboratorRoleDetail"] = newProjectCollaboratorRoleDetail;

export interface ProjectFeatureDetailOptions {
  __typename?: "ProjectFeatureDetail";
  code?: ProjectFeatureDetail["code"];
  name?: ProjectFeatureDetail["name"];
}

export function newProjectFeatureDetail(
  options: ProjectFeatureDetailOptions = {},
  cache: Record<string, any> = {},
): ProjectFeatureDetail {
  const o = (options.__typename ? options : cache["ProjectFeatureDetail"] = {}) as ProjectFeatureDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectFeatureDetail";
  o.code = options.code ?? ProjectFeature.SelectionsV1;
  o.name = options.name ?? "Selections v1";
  return o;
}

factories["ProjectFeatureDetail"] = newProjectFeatureDetail;

export interface ProjectReadyPlanConfigOrientationDetailOptions {
  __typename?: "ProjectReadyPlanConfigOrientationDetail";
  code?: ProjectReadyPlanConfigOrientationDetail["code"];
  name?: ProjectReadyPlanConfigOrientationDetail["name"];
}

export function newProjectReadyPlanConfigOrientationDetail(
  options: ProjectReadyPlanConfigOrientationDetailOptions = {},
  cache: Record<string, any> = {},
): ProjectReadyPlanConfigOrientationDetail {
  const o =
    (options.__typename
      ? options
      : cache["ProjectReadyPlanConfigOrientationDetail"] = {}) as ProjectReadyPlanConfigOrientationDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectReadyPlanConfigOrientationDetail";
  o.code = options.code ?? ProjectReadyPlanConfigOrientation.Left;
  o.name = options.name ?? "Left";
  return o;
}

factories["ProjectReadyPlanConfigOrientationDetail"] = newProjectReadyPlanConfigOrientationDetail;

export interface ProjectRoleDetailOptions {
  __typename?: "ProjectRoleDetail";
  code?: ProjectRoleDetail["code"];
  name?: ProjectRoleDetail["name"];
  sortOrder?: ProjectRoleDetail["sortOrder"];
  description?: ProjectRoleDetail["description"];
}

export function newProjectRoleDetail(
  options: ProjectRoleDetailOptions = {},
  cache: Record<string, any> = {},
): ProjectRoleDetail {
  const o = (options.__typename ? options : cache["ProjectRoleDetail"] = {}) as ProjectRoleDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectRoleDetail";
  o.code = options.code ?? ProjectRole.HeadOfConstruction;
  o.name = options.name ?? "Head of construction";
  o.sortOrder = options.sortOrder ?? 0;
  o.description = options.description ?? "Head of construction";
  return o;
}

factories["ProjectRoleDetail"] = newProjectRoleDetail;

export interface ProjectStageStatusDetailOptions {
  __typename?: "ProjectStageStatusDetail";
  code?: ProjectStageStatusDetail["code"];
  name?: ProjectStageStatusDetail["name"];
}

export function newProjectStageStatusDetail(
  options: ProjectStageStatusDetailOptions = {},
  cache: Record<string, any> = {},
): ProjectStageStatusDetail {
  const o = (options.__typename ? options : cache["ProjectStageStatusDetail"] = {}) as ProjectStageStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectStageStatusDetail";
  o.code = options.code ?? ProjectStageStatus.Active;
  o.name = options.name ?? "Active";
  return o;
}

factories["ProjectStageStatusDetail"] = newProjectStageStatusDetail;

export interface ProjectStatusDetailOptions {
  __typename?: "ProjectStatusDetail";
  code?: ProjectStatusDetail["code"];
  name?: ProjectStatusDetail["name"];
}

export function newProjectStatusDetail(
  options: ProjectStatusDetailOptions = {},
  cache: Record<string, any> = {},
): ProjectStatusDetail {
  const o = (options.__typename ? options : cache["ProjectStatusDetail"] = {}) as ProjectStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectStatusDetail";
  o.code = options.code ?? ProjectStatus.Active;
  o.name = options.name ?? "Active";
  return o;
}

factories["ProjectStatusDetail"] = newProjectStatusDetail;

export interface ProjectUpdateActionTypeDetailOptions {
  __typename?: "ProjectUpdateActionTypeDetail";
  code?: ProjectUpdateActionTypeDetail["code"];
  name?: ProjectUpdateActionTypeDetail["name"];
}

export function newProjectUpdateActionTypeDetail(
  options: ProjectUpdateActionTypeDetailOptions = {},
  cache: Record<string, any> = {},
): ProjectUpdateActionTypeDetail {
  const o =
    (options.__typename ? options : cache["ProjectUpdateActionTypeDetail"] = {}) as ProjectUpdateActionTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectUpdateActionTypeDetail";
  o.code = options.code ?? ProjectUpdateActionType.ActivityComplete;
  o.name = options.name ?? "Activity complete";
  return o;
}

factories["ProjectUpdateActionTypeDetail"] = newProjectUpdateActionTypeDetail;

export interface PromotionStatusDetailOptions {
  __typename?: "PromotionStatusDetail";
  code?: PromotionStatusDetail["code"];
  name?: PromotionStatusDetail["name"];
}

export function newPromotionStatusDetail(
  options: PromotionStatusDetailOptions = {},
  cache: Record<string, any> = {},
): PromotionStatusDetail {
  const o = (options.__typename ? options : cache["PromotionStatusDetail"] = {}) as PromotionStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PromotionStatusDetail";
  o.code = options.code ?? PromotionStatus.Requested;
  o.name = options.name ?? "Requested";
  return o;
}

factories["PromotionStatusDetail"] = newPromotionStatusDetail;

export interface PushNotificationEnvironmentDetailOptions {
  __typename?: "PushNotificationEnvironmentDetail";
  code?: PushNotificationEnvironmentDetail["code"];
  name?: PushNotificationEnvironmentDetail["name"];
}

export function newPushNotificationEnvironmentDetail(
  options: PushNotificationEnvironmentDetailOptions = {},
  cache: Record<string, any> = {},
): PushNotificationEnvironmentDetail {
  const o =
    (options.__typename
      ? options
      : cache["PushNotificationEnvironmentDetail"] = {}) as PushNotificationEnvironmentDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PushNotificationEnvironmentDetail";
  o.code = options.code ?? PushNotificationEnvironment.Sandbox;
  o.name = options.name ?? "Sandbox";
  return o;
}

factories["PushNotificationEnvironmentDetail"] = newPushNotificationEnvironmentDetail;

export interface PushNotificationPlatformDetailOptions {
  __typename?: "PushNotificationPlatformDetail";
  code?: PushNotificationPlatformDetail["code"];
  name?: PushNotificationPlatformDetail["name"];
}

export function newPushNotificationPlatformDetail(
  options: PushNotificationPlatformDetailOptions = {},
  cache: Record<string, any> = {},
): PushNotificationPlatformDetail {
  const o =
    (options.__typename ? options : cache["PushNotificationPlatformDetail"] = {}) as PushNotificationPlatformDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PushNotificationPlatformDetail";
  o.code = options.code ?? PushNotificationPlatform.Ios;
  o.name = options.name ?? "Ios";
  return o;
}

factories["PushNotificationPlatformDetail"] = newPushNotificationPlatformDetail;

export interface ReadyPlanAssetTypeDetailOptions {
  __typename?: "ReadyPlanAssetTypeDetail";
  code?: ReadyPlanAssetTypeDetail["code"];
  name?: ReadyPlanAssetTypeDetail["name"];
}

export function newReadyPlanAssetTypeDetail(
  options: ReadyPlanAssetTypeDetailOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanAssetTypeDetail {
  const o = (options.__typename ? options : cache["ReadyPlanAssetTypeDetail"] = {}) as ReadyPlanAssetTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanAssetTypeDetail";
  o.code = options.code ?? ReadyPlanAssetType.CoverPhoto;
  o.name = options.name ?? "Cover photo";
  return o;
}

factories["ReadyPlanAssetTypeDetail"] = newReadyPlanAssetTypeDetail;

export interface ReadyPlanOptionGroupPersonalizationTypeDetailOptions {
  __typename?: "ReadyPlanOptionGroupPersonalizationTypeDetail";
  code?: ReadyPlanOptionGroupPersonalizationTypeDetail["code"];
  name?: ReadyPlanOptionGroupPersonalizationTypeDetail["name"];
}

export function newReadyPlanOptionGroupPersonalizationTypeDetail(
  options: ReadyPlanOptionGroupPersonalizationTypeDetailOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanOptionGroupPersonalizationTypeDetail {
  const o =
    (options.__typename
      ? options
      : cache["ReadyPlanOptionGroupPersonalizationTypeDetail"] = {}) as ReadyPlanOptionGroupPersonalizationTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanOptionGroupPersonalizationTypeDetail";
  o.code = options.code ?? ReadyPlanOptionGroupPersonalizationType.SingleProduct;
  o.name = options.name ?? "Single product";
  return o;
}

factories["ReadyPlanOptionGroupPersonalizationTypeDetail"] = newReadyPlanOptionGroupPersonalizationTypeDetail;

export interface ReadyPlanStatusDetailOptions {
  __typename?: "ReadyPlanStatusDetail";
  code?: ReadyPlanStatusDetail["code"];
  name?: ReadyPlanStatusDetail["name"];
}

export function newReadyPlanStatusDetail(
  options: ReadyPlanStatusDetailOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanStatusDetail {
  const o = (options.__typename ? options : cache["ReadyPlanStatusDetail"] = {}) as ReadyPlanStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanStatusDetail";
  o.code = options.code ?? ReadyPlanStatus.Draft;
  o.name = options.name ?? "Draft";
  return o;
}

factories["ReadyPlanStatusDetail"] = newReadyPlanStatusDetail;

export interface ReadyPlanTypeDetailOptions {
  __typename?: "ReadyPlanTypeDetail";
  code?: ReadyPlanTypeDetail["code"];
  name?: ReadyPlanTypeDetail["name"];
}

export function newReadyPlanTypeDetail(
  options: ReadyPlanTypeDetailOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanTypeDetail {
  const o = (options.__typename ? options : cache["ReadyPlanTypeDetail"] = {}) as ReadyPlanTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanTypeDetail";
  o.code = options.code ?? ReadyPlanType.Sfh;
  o.name = options.name ?? "Sfh";
  return o;
}

factories["ReadyPlanTypeDetail"] = newReadyPlanTypeDetail;

export interface ScheduleFlagReasonTypeDetailOptions {
  __typename?: "ScheduleFlagReasonTypeDetail";
  code?: ScheduleFlagReasonTypeDetail["code"];
  name?: ScheduleFlagReasonTypeDetail["name"];
}

export function newScheduleFlagReasonTypeDetail(
  options: ScheduleFlagReasonTypeDetailOptions = {},
  cache: Record<string, any> = {},
): ScheduleFlagReasonTypeDetail {
  const o = (options.__typename ? options : cache["ScheduleFlagReasonTypeDetail"] = {}) as ScheduleFlagReasonTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ScheduleFlagReasonTypeDetail";
  o.code = options.code ?? ScheduleFlagReasonType.Client;
  o.name = options.name ?? "Client";
  return o;
}

factories["ScheduleFlagReasonTypeDetail"] = newScheduleFlagReasonTypeDetail;

export interface ScheduleStatusDetailOptions {
  __typename?: "ScheduleStatusDetail";
  code?: ScheduleStatusDetail["code"];
  name?: ScheduleStatusDetail["name"];
}

export function newScheduleStatusDetail(
  options: ScheduleStatusDetailOptions = {},
  cache: Record<string, any> = {},
): ScheduleStatusDetail {
  const o = (options.__typename ? options : cache["ScheduleStatusDetail"] = {}) as ScheduleStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ScheduleStatusDetail";
  o.code = options.code ?? ScheduleStatus.Active;
  o.name = options.name ?? "Active";
  return o;
}

factories["ScheduleStatusDetail"] = newScheduleStatusDetail;

export interface ScheduleTemplateStatusDetailOptions {
  __typename?: "ScheduleTemplateStatusDetail";
  code?: ScheduleTemplateStatusDetail["code"];
  name?: ScheduleTemplateStatusDetail["name"];
}

export function newScheduleTemplateStatusDetail(
  options: ScheduleTemplateStatusDetailOptions = {},
  cache: Record<string, any> = {},
): ScheduleTemplateStatusDetail {
  const o = (options.__typename ? options : cache["ScheduleTemplateStatusDetail"] = {}) as ScheduleTemplateStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ScheduleTemplateStatusDetail";
  o.code = options.code ?? ScheduleTemplateStatus.Draft;
  o.name = options.name ?? "Draft";
  return o;
}

factories["ScheduleTemplateStatusDetail"] = newScheduleTemplateStatusDetail;

export interface ScopeChangeTypeDetailOptions {
  __typename?: "ScopeChangeTypeDetail";
  code?: ScopeChangeTypeDetail["code"];
  name?: ScopeChangeTypeDetail["name"];
}

export function newScopeChangeTypeDetail(
  options: ScopeChangeTypeDetailOptions = {},
  cache: Record<string, any> = {},
): ScopeChangeTypeDetail {
  const o = (options.__typename ? options : cache["ScopeChangeTypeDetail"] = {}) as ScopeChangeTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ScopeChangeTypeDetail";
  o.code = options.code ?? ScopeChangeType.None;
  o.name = options.name ?? "None";
  return o;
}

factories["ScopeChangeTypeDetail"] = newScopeChangeTypeDetail;

export interface ScopeModeDetailOptions {
  __typename?: "ScopeModeDetail";
  code?: ScopeModeDetail["code"];
  name?: ScopeModeDetail["name"];
}

export function newScopeModeDetail(
  options: ScopeModeDetailOptions = {},
  cache: Record<string, any> = {},
): ScopeModeDetail {
  const o = (options.__typename ? options : cache["ScopeModeDetail"] = {}) as ScopeModeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ScopeModeDetail";
  o.code = options.code ?? ScopeMode.None;
  o.name = options.name ?? "None";
  return o;
}

factories["ScopeModeDetail"] = newScopeModeDetail;

export interface SelectionCutoffDetailOptions {
  __typename?: "SelectionCutoffDetail";
  code?: SelectionCutoffDetail["code"];
  name?: SelectionCutoffDetail["name"];
}

export function newSelectionCutoffDetail(
  options: SelectionCutoffDetailOptions = {},
  cache: Record<string, any> = {},
): SelectionCutoffDetail {
  const o = (options.__typename ? options : cache["SelectionCutoffDetail"] = {}) as SelectionCutoffDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SelectionCutoffDetail";
  o.code = options.code ?? SelectionCutoff.Cutoff_1;
  o.name = options.name ?? "Cutoff 1";
  return o;
}

factories["SelectionCutoffDetail"] = newSelectionCutoffDetail;

export interface SelectionPricingModeDetailOptions {
  __typename?: "SelectionPricingModeDetail";
  code?: SelectionPricingModeDetail["code"];
  name?: SelectionPricingModeDetail["name"];
}

export function newSelectionPricingModeDetail(
  options: SelectionPricingModeDetailOptions = {},
  cache: Record<string, any> = {},
): SelectionPricingModeDetail {
  const o = (options.__typename ? options : cache["SelectionPricingModeDetail"] = {}) as SelectionPricingModeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SelectionPricingModeDetail";
  o.code = options.code ?? SelectionPricingMode.None;
  o.name = options.name ?? "None";
  return o;
}

factories["SelectionPricingModeDetail"] = newSelectionPricingModeDetail;

export interface StageDetailOptions {
  __typename?: "StageDetail";
  code?: StageDetail["code"];
  name?: StageDetail["name"];
  sortOrder?: StageDetail["sortOrder"];
  slug?: StageDetail["slug"];
  forDevelopment?: StageDetail["forDevelopment"];
  forProject?: StageDetail["forProject"];
  isDeprecated?: StageDetail["isDeprecated"];
}

export function newStageDetail(options: StageDetailOptions = {}, cache: Record<string, any> = {}): StageDetail {
  const o = (options.__typename ? options : cache["StageDetail"] = {}) as StageDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "StageDetail";
  o.code = options.code ?? Stage.PreConPlanning;
  o.name = options.name ?? "Pre con planning";
  o.sortOrder = options.sortOrder ?? 0;
  o.slug = options.slug ?? "Pre con planning";
  o.forDevelopment = options.forDevelopment ?? false;
  o.forProject = options.forProject ?? false;
  o.isDeprecated = options.isDeprecated ?? false;
  return o;
}

factories["StageDetail"] = newStageDetail;

export interface SuburbanAssetCategoryDetailOptions {
  __typename?: "SuburbanAssetCategoryDetail";
  code?: SuburbanAssetCategoryDetail["code"];
  name?: SuburbanAssetCategoryDetail["name"];
}

export function newSuburbanAssetCategoryDetail(
  options: SuburbanAssetCategoryDetailOptions = {},
  cache: Record<string, any> = {},
): SuburbanAssetCategoryDetail {
  const o = (options.__typename ? options : cache["SuburbanAssetCategoryDetail"] = {}) as SuburbanAssetCategoryDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SuburbanAssetCategoryDetail";
  o.code = options.code ?? SuburbanAssetCategory.Inventory;
  o.name = options.name ?? "Inventory";
  return o;
}

factories["SuburbanAssetCategoryDetail"] = newSuburbanAssetCategoryDetail;

export interface SystemChangeRequestAssetDetailOptions {
  __typename?: "SystemChangeRequestAssetDetail";
  code?: SystemChangeRequestAssetDetail["code"];
  name?: SystemChangeRequestAssetDetail["name"];
}

export function newSystemChangeRequestAssetDetail(
  options: SystemChangeRequestAssetDetailOptions = {},
  cache: Record<string, any> = {},
): SystemChangeRequestAssetDetail {
  const o =
    (options.__typename ? options : cache["SystemChangeRequestAssetDetail"] = {}) as SystemChangeRequestAssetDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SystemChangeRequestAssetDetail";
  o.code = options.code ?? SystemChangeRequestAsset.PandaDoc;
  o.name = options.name ?? "Panda doc";
  return o;
}

factories["SystemChangeRequestAssetDetail"] = newSystemChangeRequestAssetDetail;

export interface SystemPlanMilestoneDetailOptions {
  __typename?: "SystemPlanMilestoneDetail";
  code?: SystemPlanMilestoneDetail["code"];
  name?: SystemPlanMilestoneDetail["name"];
}

export function newSystemPlanMilestoneDetail(
  options: SystemPlanMilestoneDetailOptions = {},
  cache: Record<string, any> = {},
): SystemPlanMilestoneDetail {
  const o = (options.__typename ? options : cache["SystemPlanMilestoneDetail"] = {}) as SystemPlanMilestoneDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SystemPlanMilestoneDetail";
  o.code = options.code ?? SystemPlanMilestone.MobilizationStart;
  o.name = options.name ?? "Mobilization start";
  return o;
}

factories["SystemPlanMilestoneDetail"] = newSystemPlanMilestoneDetail;

export interface SystemTaskDetailOptions {
  __typename?: "SystemTaskDetail";
  code?: SystemTaskDetail["code"];
  name?: SystemTaskDetail["name"];
}

export function newSystemTaskDetail(
  options: SystemTaskDetailOptions = {},
  cache: Record<string, any> = {},
): SystemTaskDetail {
  const o = (options.__typename ? options : cache["SystemTaskDetail"] = {}) as SystemTaskDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SystemTaskDetail";
  o.code = options.code ?? SystemTask.ConstructionRts;
  o.name = options.name ?? "Construction rts";
  return o;
}

factories["SystemTaskDetail"] = newSystemTaskDetail;

export interface TakeoffLineItemDesignPackageTypeDetailOptions {
  __typename?: "TakeoffLineItemDesignPackageTypeDetail";
  code?: TakeoffLineItemDesignPackageTypeDetail["code"];
  name?: TakeoffLineItemDesignPackageTypeDetail["name"];
}

export function newTakeoffLineItemDesignPackageTypeDetail(
  options: TakeoffLineItemDesignPackageTypeDetailOptions = {},
  cache: Record<string, any> = {},
): TakeoffLineItemDesignPackageTypeDetail {
  const o =
    (options.__typename
      ? options
      : cache["TakeoffLineItemDesignPackageTypeDetail"] = {}) as TakeoffLineItemDesignPackageTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TakeoffLineItemDesignPackageTypeDetail";
  o.code = options.code ?? TakeoffLineItemDesignPackageType.RegularPlaceholder;
  o.name = options.name ?? "Regular placeholder";
  return o;
}

factories["TakeoffLineItemDesignPackageTypeDetail"] = newTakeoffLineItemDesignPackageTypeDetail;

export interface TakeoffLineItemTypeDetailOptions {
  __typename?: "TakeoffLineItemTypeDetail";
  code?: TakeoffLineItemTypeDetail["code"];
  name?: TakeoffLineItemTypeDetail["name"];
}

export function newTakeoffLineItemTypeDetail(
  options: TakeoffLineItemTypeDetailOptions = {},
  cache: Record<string, any> = {},
): TakeoffLineItemTypeDetail {
  const o = (options.__typename ? options : cache["TakeoffLineItemTypeDetail"] = {}) as TakeoffLineItemTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TakeoffLineItemTypeDetail";
  o.code = options.code ?? TakeoffLineItemType.Iti;
  o.name = options.name ?? "Iti";
  return o;
}

factories["TakeoffLineItemTypeDetail"] = newTakeoffLineItemTypeDetail;

export interface TaskDeadlineTypeDetailOptions {
  __typename?: "TaskDeadlineTypeDetail";
  code?: TaskDeadlineTypeDetail["code"];
  name?: TaskDeadlineTypeDetail["name"];
}

export function newTaskDeadlineTypeDetail(
  options: TaskDeadlineTypeDetailOptions = {},
  cache: Record<string, any> = {},
): TaskDeadlineTypeDetail {
  const o = (options.__typename ? options : cache["TaskDeadlineTypeDetail"] = {}) as TaskDeadlineTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TaskDeadlineTypeDetail";
  o.code = options.code ?? TaskDeadlineType.Cutoff;
  o.name = options.name ?? "Cutoff";
  return o;
}

factories["TaskDeadlineTypeDetail"] = newTaskDeadlineTypeDetail;

export interface TaskDependencyTypeDetailOptions {
  __typename?: "TaskDependencyTypeDetail";
  code?: TaskDependencyTypeDetail["code"];
  name?: TaskDependencyTypeDetail["name"];
  shorthand?: TaskDependencyTypeDetail["shorthand"];
}

export function newTaskDependencyTypeDetail(
  options: TaskDependencyTypeDetailOptions = {},
  cache: Record<string, any> = {},
): TaskDependencyTypeDetail {
  const o = (options.__typename ? options : cache["TaskDependencyTypeDetail"] = {}) as TaskDependencyTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TaskDependencyTypeDetail";
  o.code = options.code ?? TaskDependencyType.FinishStart;
  o.name = options.name ?? "Finish start";
  o.shorthand = options.shorthand ?? "Finish start";
  return o;
}

factories["TaskDependencyTypeDetail"] = newTaskDependencyTypeDetail;

export interface TaskStatusDetailOptions {
  __typename?: "TaskStatusDetail";
  code?: TaskStatusDetail["code"];
  name?: TaskStatusDetail["name"];
  sortOrder?: TaskStatusDetail["sortOrder"];
}

export function newTaskStatusDetail(
  options: TaskStatusDetailOptions = {},
  cache: Record<string, any> = {},
): TaskStatusDetail {
  const o = (options.__typename ? options : cache["TaskStatusDetail"] = {}) as TaskStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TaskStatusDetail";
  o.code = options.code ?? TaskStatus.NotStarted;
  o.name = options.name ?? "Not started";
  o.sortOrder = options.sortOrder ?? 0;
  return o;
}

factories["TaskStatusDetail"] = newTaskStatusDetail;

export interface TaskTypeDetailOptions {
  __typename?: "TaskTypeDetail";
  code?: TaskTypeDetail["code"];
  name?: TaskTypeDetail["name"];
}

export function newTaskTypeDetail(
  options: TaskTypeDetailOptions = {},
  cache: Record<string, any> = {},
): TaskTypeDetail {
  const o = (options.__typename ? options : cache["TaskTypeDetail"] = {}) as TaskTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TaskTypeDetail";
  o.code = options.code ?? TaskType.ScheduleTask;
  o.name = options.name ?? "Schedule task";
  return o;
}

factories["TaskTypeDetail"] = newTaskTypeDetail;

export interface TimeFrequencyDetailOptions {
  __typename?: "TimeFrequencyDetail";
  code?: TimeFrequencyDetail["code"];
  name?: TimeFrequencyDetail["name"];
}

export function newTimeFrequencyDetail(
  options: TimeFrequencyDetailOptions = {},
  cache: Record<string, any> = {},
): TimeFrequencyDetail {
  const o = (options.__typename ? options : cache["TimeFrequencyDetail"] = {}) as TimeFrequencyDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TimeFrequencyDetail";
  o.code = options.code ?? TimeFrequency.Days;
  o.name = options.name ?? "Days";
  return o;
}

factories["TimeFrequencyDetail"] = newTimeFrequencyDetail;

export interface TimeOfDayDetailOptions {
  __typename?: "TimeOfDayDetail";
  code?: TimeOfDayDetail["code"];
  name?: TimeOfDayDetail["name"];
}

export function newTimeOfDayDetail(
  options: TimeOfDayDetailOptions = {},
  cache: Record<string, any> = {},
): TimeOfDayDetail {
  const o = (options.__typename ? options : cache["TimeOfDayDetail"] = {}) as TimeOfDayDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TimeOfDayDetail";
  o.code = options.code ?? TimeOfDay.Morning;
  o.name = options.name ?? "Morning";
  return o;
}

factories["TimeOfDayDetail"] = newTimeOfDayDetail;

export interface ToDoStatusDetailOptions {
  __typename?: "ToDoStatusDetail";
  code?: ToDoStatusDetail["code"];
  name?: ToDoStatusDetail["name"];
  sortOrder?: ToDoStatusDetail["sortOrder"];
}

export function newToDoStatusDetail(
  options: ToDoStatusDetailOptions = {},
  cache: Record<string, any> = {},
): ToDoStatusDetail {
  const o = (options.__typename ? options : cache["ToDoStatusDetail"] = {}) as ToDoStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ToDoStatusDetail";
  o.code = options.code ?? ToDoStatus.Backlog;
  o.name = options.name ?? "Backlog";
  o.sortOrder = options.sortOrder ?? 0;
  return o;
}

factories["ToDoStatusDetail"] = newToDoStatusDetail;

export interface ToDoTypeDetailOptions {
  __typename?: "ToDoTypeDetail";
  code?: ToDoTypeDetail["code"];
  name?: ToDoTypeDetail["name"];
}

export function newToDoTypeDetail(
  options: ToDoTypeDetailOptions = {},
  cache: Record<string, any> = {},
): ToDoTypeDetail {
  const o = (options.__typename ? options : cache["ToDoTypeDetail"] = {}) as ToDoTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ToDoTypeDetail";
  o.code = options.code ?? ToDoType.Submittals;
  o.name = options.name ?? "Submittals";
  return o;
}

factories["ToDoTypeDetail"] = newToDoTypeDetail;

export interface TrackedJobStatusDetailOptions {
  __typename?: "TrackedJobStatusDetail";
  code?: TrackedJobStatusDetail["code"];
  name?: TrackedJobStatusDetail["name"];
}

export function newTrackedJobStatusDetail(
  options: TrackedJobStatusDetailOptions = {},
  cache: Record<string, any> = {},
): TrackedJobStatusDetail {
  const o = (options.__typename ? options : cache["TrackedJobStatusDetail"] = {}) as TrackedJobStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TrackedJobStatusDetail";
  o.code = options.code ?? TrackedJobStatus.Pending;
  o.name = options.name ?? "Pending";
  return o;
}

factories["TrackedJobStatusDetail"] = newTrackedJobStatusDetail;

export interface TradePartnerAvailabilityRequestStatusDetailOptions {
  __typename?: "TradePartnerAvailabilityRequestStatusDetail";
  code?: TradePartnerAvailabilityRequestStatusDetail["code"];
  name?: TradePartnerAvailabilityRequestStatusDetail["name"];
}

export function newTradePartnerAvailabilityRequestStatusDetail(
  options: TradePartnerAvailabilityRequestStatusDetailOptions = {},
  cache: Record<string, any> = {},
): TradePartnerAvailabilityRequestStatusDetail {
  const o =
    (options.__typename
      ? options
      : cache["TradePartnerAvailabilityRequestStatusDetail"] = {}) as TradePartnerAvailabilityRequestStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TradePartnerAvailabilityRequestStatusDetail";
  o.code = options.code ?? TradePartnerAvailabilityRequestStatus.Waiting;
  o.name = options.name ?? "Waiting";
  return o;
}

factories["TradePartnerAvailabilityRequestStatusDetail"] = newTradePartnerAvailabilityRequestStatusDetail;

export interface TradePartnerMarketRoleDetailOptions {
  __typename?: "TradePartnerMarketRoleDetail";
  code?: TradePartnerMarketRoleDetail["code"];
  name?: TradePartnerMarketRoleDetail["name"];
  sortOrder?: TradePartnerMarketRoleDetail["sortOrder"];
  description?: TradePartnerMarketRoleDetail["description"];
}

export function newTradePartnerMarketRoleDetail(
  options: TradePartnerMarketRoleDetailOptions = {},
  cache: Record<string, any> = {},
): TradePartnerMarketRoleDetail {
  const o = (options.__typename ? options : cache["TradePartnerMarketRoleDetail"] = {}) as TradePartnerMarketRoleDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TradePartnerMarketRoleDetail";
  o.code = options.code ?? TradePartnerMarketRole.BillApprover;
  o.name = options.name ?? "Bill approver";
  o.sortOrder = options.sortOrder ?? 0;
  o.description = options.description ?? "Bill approver";
  return o;
}

factories["TradePartnerMarketRoleDetail"] = newTradePartnerMarketRoleDetail;

export interface TradePartnerOnboardingStatusDetailOptions {
  __typename?: "TradePartnerOnboardingStatusDetail";
  code?: TradePartnerOnboardingStatusDetail["code"];
  name?: TradePartnerOnboardingStatusDetail["name"];
}

export function newTradePartnerOnboardingStatusDetail(
  options: TradePartnerOnboardingStatusDetailOptions = {},
  cache: Record<string, any> = {},
): TradePartnerOnboardingStatusDetail {
  const o =
    (options.__typename
      ? options
      : cache["TradePartnerOnboardingStatusDetail"] = {}) as TradePartnerOnboardingStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TradePartnerOnboardingStatusDetail";
  o.code = options.code ?? TradePartnerOnboardingStatus.InProgress;
  o.name = options.name ?? "In progress";
  return o;
}

factories["TradePartnerOnboardingStatusDetail"] = newTradePartnerOnboardingStatusDetail;

export interface TradePartnerRequirementStatusDetailOptions {
  __typename?: "TradePartnerRequirementStatusDetail";
  code?: TradePartnerRequirementStatusDetail["code"];
  name?: TradePartnerRequirementStatusDetail["name"];
}

export function newTradePartnerRequirementStatusDetail(
  options: TradePartnerRequirementStatusDetailOptions = {},
  cache: Record<string, any> = {},
): TradePartnerRequirementStatusDetail {
  const o =
    (options.__typename
      ? options
      : cache["TradePartnerRequirementStatusDetail"] = {}) as TradePartnerRequirementStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TradePartnerRequirementStatusDetail";
  o.code = options.code ?? TradePartnerRequirementStatus.Meets;
  o.name = options.name ?? "Meets";
  return o;
}

factories["TradePartnerRequirementStatusDetail"] = newTradePartnerRequirementStatusDetail;

export interface TradePartnerRequirementTypeDetailOptions {
  __typename?: "TradePartnerRequirementTypeDetail";
  code?: TradePartnerRequirementTypeDetail["code"];
  name?: TradePartnerRequirementTypeDetail["name"];
  hasExpirationDate?: TradePartnerRequirementTypeDetail["hasExpirationDate"];
  hasCoverageAmount?: TradePartnerRequirementTypeDetail["hasCoverageAmount"];
  hasLicenseNumber?: TradePartnerRequirementTypeDetail["hasLicenseNumber"];
  hasSignedDate?: TradePartnerRequirementTypeDetail["hasSignedDate"];
  isTsa?: TradePartnerRequirementTypeDetail["isTsa"];
}

export function newTradePartnerRequirementTypeDetail(
  options: TradePartnerRequirementTypeDetailOptions = {},
  cache: Record<string, any> = {},
): TradePartnerRequirementTypeDetail {
  const o =
    (options.__typename
      ? options
      : cache["TradePartnerRequirementTypeDetail"] = {}) as TradePartnerRequirementTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TradePartnerRequirementTypeDetail";
  o.code = options.code ?? TradePartnerRequirementType.W9;
  o.name = options.name ?? "W9";
  o.hasExpirationDate = options.hasExpirationDate ?? false;
  o.hasCoverageAmount = options.hasCoverageAmount ?? false;
  o.hasLicenseNumber = options.hasLicenseNumber ?? false;
  o.hasSignedDate = options.hasSignedDate ?? false;
  o.isTsa = options.isTsa ?? false;
  return o;
}

factories["TradePartnerRequirementTypeDetail"] = newTradePartnerRequirementTypeDetail;

export interface TradePartnerTaskStatusDetailOptions {
  __typename?: "TradePartnerTaskStatusDetail";
  code?: TradePartnerTaskStatusDetail["code"];
  name?: TradePartnerTaskStatusDetail["name"];
}

export function newTradePartnerTaskStatusDetail(
  options: TradePartnerTaskStatusDetailOptions = {},
  cache: Record<string, any> = {},
): TradePartnerTaskStatusDetail {
  const o = (options.__typename ? options : cache["TradePartnerTaskStatusDetail"] = {}) as TradePartnerTaskStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TradePartnerTaskStatusDetail";
  o.code = options.code ?? TradePartnerTaskStatus.NeedsConfirmation;
  o.name = options.name ?? "Needs confirmation";
  return o;
}

factories["TradePartnerTaskStatusDetail"] = newTradePartnerTaskStatusDetail;

export interface UserEventTypeDetailOptions {
  __typename?: "UserEventTypeDetail";
  code?: UserEventTypeDetail["code"];
  name?: UserEventTypeDetail["name"];
  allowedEntities?: UserEventTypeDetail["allowedEntities"];
}

export function newUserEventTypeDetail(
  options: UserEventTypeDetailOptions = {},
  cache: Record<string, any> = {},
): UserEventTypeDetail {
  const o = (options.__typename ? options : cache["UserEventTypeDetail"] = {}) as UserEventTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "UserEventTypeDetail";
  o.code = options.code ?? UserEventType.Created;
  o.name = options.name ?? "Created";
  o.allowedEntities = options.allowedEntities ?? "Created";
  return o;
}

factories["UserEventTypeDetail"] = newUserEventTypeDetail;

export interface UserTypeDetailOptions {
  __typename?: "UserTypeDetail";
  code?: UserTypeDetail["code"];
  name?: UserTypeDetail["name"];
}

export function newUserTypeDetail(
  options: UserTypeDetailOptions = {},
  cache: Record<string, any> = {},
): UserTypeDetail {
  const o = (options.__typename ? options : cache["UserTypeDetail"] = {}) as UserTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "UserTypeDetail";
  o.code = options.code ?? UserType.Anonymous;
  o.name = options.name ?? "Anonymous";
  return o;
}

factories["UserTypeDetail"] = newUserTypeDetail;

export interface WarrantyTicketItemStatusDetailOptions {
  __typename?: "WarrantyTicketItemStatusDetail";
  code?: WarrantyTicketItemStatusDetail["code"];
  name?: WarrantyTicketItemStatusDetail["name"];
  sortOrder?: WarrantyTicketItemStatusDetail["sortOrder"];
}

export function newWarrantyTicketItemStatusDetail(
  options: WarrantyTicketItemStatusDetailOptions = {},
  cache: Record<string, any> = {},
): WarrantyTicketItemStatusDetail {
  const o =
    (options.__typename ? options : cache["WarrantyTicketItemStatusDetail"] = {}) as WarrantyTicketItemStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "WarrantyTicketItemStatusDetail";
  o.code = options.code ?? WarrantyTicketItemStatus.Submitted;
  o.name = options.name ?? "Submitted";
  o.sortOrder = options.sortOrder ?? 0;
  return o;
}

factories["WarrantyTicketItemStatusDetail"] = newWarrantyTicketItemStatusDetail;

export interface WarrantyTicketItemTypeDetailOptions {
  __typename?: "WarrantyTicketItemTypeDetail";
  code?: WarrantyTicketItemTypeDetail["code"];
  name?: WarrantyTicketItemTypeDetail["name"];
}

export function newWarrantyTicketItemTypeDetail(
  options: WarrantyTicketItemTypeDetailOptions = {},
  cache: Record<string, any> = {},
): WarrantyTicketItemTypeDetail {
  const o = (options.__typename ? options : cache["WarrantyTicketItemTypeDetail"] = {}) as WarrantyTicketItemTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "WarrantyTicketItemTypeDetail";
  o.code = options.code ?? WarrantyTicketItemType.Mechanical;
  o.name = options.name ?? "Mechanical";
  return o;
}

factories["WarrantyTicketItemTypeDetail"] = newWarrantyTicketItemTypeDetail;

export interface WarrantyTicketStatusDetailOptions {
  __typename?: "WarrantyTicketStatusDetail";
  code?: WarrantyTicketStatusDetail["code"];
  name?: WarrantyTicketStatusDetail["name"];
}

export function newWarrantyTicketStatusDetail(
  options: WarrantyTicketStatusDetailOptions = {},
  cache: Record<string, any> = {},
): WarrantyTicketStatusDetail {
  const o = (options.__typename ? options : cache["WarrantyTicketStatusDetail"] = {}) as WarrantyTicketStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "WarrantyTicketStatusDetail";
  o.code = options.code ?? WarrantyTicketStatus.NotStarted;
  o.name = options.name ?? "Not started";
  return o;
}

factories["WarrantyTicketStatusDetail"] = newWarrantyTicketStatusDetail;

export interface WarrantyTicketTypeDetailOptions {
  __typename?: "WarrantyTicketTypeDetail";
  code?: WarrantyTicketTypeDetail["code"];
  name?: WarrantyTicketTypeDetail["name"];
}

export function newWarrantyTicketTypeDetail(
  options: WarrantyTicketTypeDetailOptions = {},
  cache: Record<string, any> = {},
): WarrantyTicketTypeDetail {
  const o = (options.__typename ? options : cache["WarrantyTicketTypeDetail"] = {}) as WarrantyTicketTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "WarrantyTicketTypeDetail";
  o.code = options.code ?? WarrantyTicketType.ItemsOfContinuance;
  o.name = options.name ?? "Items of continuance";
  return o;
}

factories["WarrantyTicketTypeDetail"] = newWarrantyTicketTypeDetail;

export interface WeatherTypeDetailOptions {
  __typename?: "WeatherTypeDetail";
  code?: WeatherTypeDetail["code"];
  name?: WeatherTypeDetail["name"];
}

export function newWeatherTypeDetail(
  options: WeatherTypeDetailOptions = {},
  cache: Record<string, any> = {},
): WeatherTypeDetail {
  const o = (options.__typename ? options : cache["WeatherTypeDetail"] = {}) as WeatherTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "WeatherTypeDetail";
  o.code = options.code ?? WeatherType.ClearDay;
  o.name = options.name ?? "Clear day";
  return o;
}

factories["WeatherTypeDetail"] = newWeatherTypeDetail;

export interface AllEnumDetailsOptions {
  __typename?: "AllEnumDetails";
  activityPlanningState?: Array<ActivityPlanningStateDetail | ActivityPlanningStateDetailOptions>;
  activityResponsibility?: Array<ActivityResponsibilityDetail | ActivityResponsibilityDetailOptions>;
  activityType?: Array<ActivityTypeDetail | ActivityTypeDetailOptions>;
  aggregateVersionStatus?: Array<AggregateVersionStatusDetail | AggregateVersionStatusDetailOptions>;
  allocationStrategy?: Array<AllocationStrategyDetail | AllocationStrategyDetailOptions>;
  approvalStatus?: Array<ApprovalStatusDetail | ApprovalStatusDetailOptions>;
  approverStatus?: Array<ApproverStatusDetail | ApproverStatusDetailOptions>;
  bidContractRevisionStatus?: Array<BidContractRevisionStatusDetail | BidContractRevisionStatusDetailOptions>;
  bidContractType?: Array<BidContractTypeDetail | BidContractTypeDetailOptions>;
  bidPackageStatus?: Array<BidPackageStatusDetail | BidPackageStatusDetailOptions>;
  bidScopeSource?: Array<BidScopeSourceDetail | BidScopeSourceDetailOptions>;
  billGmailAttachmentResult?: Array<BillGmailAttachmentResultDetail | BillGmailAttachmentResultDetailOptions>;
  billGmailMessageResult?: Array<BillGmailMessageResultDetail | BillGmailMessageResultDetailOptions>;
  billReviewReason?: Array<BillReviewReasonDetail | BillReviewReasonDetailOptions>;
  billSource?: Array<BillSourceDetail | BillSourceDetailOptions>;
  billStatus?: Array<BillStatusDetail | BillStatusDetailOptions>;
  billType?: Array<BillTypeDetail | BillTypeDetailOptions>;
  businessFunctionType?: Array<BusinessFunctionTypeDetail | BusinessFunctionTypeDetailOptions>;
  buyoutStatus?: Array<BuyoutStatusDetail | BuyoutStatusDetailOptions>;
  changeEventBudgetPhase?: Array<ChangeEventBudgetPhaseDetail | ChangeEventBudgetPhaseDetailOptions>;
  changeEventLineItemType?: Array<ChangeEventLineItemTypeDetail | ChangeEventLineItemTypeDetailOptions>;
  changeEventStatus?: Array<ChangeEventStatusDetail | ChangeEventStatusDetailOptions>;
  changeEventType?: Array<ChangeEventTypeDetail | ChangeEventTypeDetailOptions>;
  changeRequestAssetPlatform?: Array<ChangeRequestAssetPlatformDetail | ChangeRequestAssetPlatformDetailOptions>;
  changeRequestAssetScope?: Array<ChangeRequestAssetScopeDetail | ChangeRequestAssetScopeDetailOptions>;
  changeRequestPriority?: Array<ChangeRequestPriorityDetail | ChangeRequestPriorityDetailOptions>;
  changeRequestSource?: Array<ChangeRequestSourceDetail | ChangeRequestSourceDetailOptions>;
  changeRequestStatus?: Array<ChangeRequestStatusDetail | ChangeRequestStatusDetailOptions>;
  changeRequestToDoType?: Array<ChangeRequestToDoTypeDetail | ChangeRequestToDoTypeDetailOptions>;
  changeType?: Array<ChangeTypeDetail | ChangeTypeDetailOptions>;
  checkoutConfigOptionGroupStep?: Array<
    CheckoutConfigOptionGroupStepDetail | CheckoutConfigOptionGroupStepDetailOptions
  >;
  checkoutConfigStatus?: Array<CheckoutConfigStatusDetail | CheckoutConfigStatusDetailOptions>;
  clientPlatform?: Array<ClientPlatformDetail | ClientPlatformDetailOptions>;
  commentStreamVisibility?: Array<CommentStreamVisibilityDetail | CommentStreamVisibilityDetailOptions>;
  commitmentStatus?: Array<CommitmentStatusDetail | CommitmentStatusDetailOptions>;
  commitmentType?: Array<CommitmentTypeDetail | CommitmentTypeDetailOptions>;
  communicationChannel?: Array<CommunicationChannelDetail | CommunicationChannelDetailOptions>;
  communityType?: Array<CommunityTypeDetail | CommunityTypeDetailOptions>;
  constructionType?: Array<ConstructionTypeDetail | ConstructionTypeDetailOptions>;
  contractType?: Array<ContractTypeDetail | ContractTypeDetailOptions>;
  costClassificationType?: Array<CostClassificationTypeDetail | CostClassificationTypeDetailOptions>;
  costCodeInvoiceCategory?: Array<CostCodeInvoiceCategoryDetail | CostCodeInvoiceCategoryDetailOptions>;
  costConfidence?: Array<CostConfidenceDetail | CostConfidenceDetailOptions>;
  costSubClassificationType?: Array<CostSubClassificationTypeDetail | CostSubClassificationTypeDetailOptions>;
  costType?: Array<CostTypeDetail | CostTypeDetailOptions>;
  dayOfWeek?: Array<DayOfWeekDetail | DayOfWeekDetailOptions>;
  designPackageLocation?: Array<DesignPackageLocationDetail | DesignPackageLocationDetailOptions>;
  developmentCommitmentType?: Array<DevelopmentCommitmentTypeDetail | DevelopmentCommitmentTypeDetailOptions>;
  documentAttachmentPlace?: Array<DocumentAttachmentPlaceDetail | DocumentAttachmentPlaceDetailOptions>;
  documentCategory?: Array<DocumentCategoryDetail | DocumentCategoryDetailOptions>;
  documentType?: Array<DocumentTypeDetail | DocumentTypeDetailOptions>;
  erpAccrualType?: Array<ErpAccrualTypeDetail | ErpAccrualTypeDetailOptions>;
  erpRevenueLineItemSourceEvent?: Array<
    ErpRevenueLineItemSourceEventDetail | ErpRevenueLineItemSourceEventDetailOptions
  >;
  erpTransactionGroupEvent?: Array<ErpTransactionGroupEventDetail | ErpTransactionGroupEventDetailOptions>;
  erpTransactionGroupStatus?: Array<ErpTransactionGroupStatusDetail | ErpTransactionGroupStatusDetailOptions>;
  erpTransactionStatus?: Array<ErpTransactionStatusDetail | ErpTransactionStatusDetailOptions>;
  estimateStatus?: Array<EstimateStatusDetail | EstimateStatusDetailOptions>;
  estimateType?: Array<EstimateTypeDetail | EstimateTypeDetailOptions>;
  featureFlagStatus?: Array<FeatureFlagStatusDetail | FeatureFlagStatusDetailOptions>;
  featureFlagType?: Array<FeatureFlagTypeDetail | FeatureFlagTypeDetailOptions>;
  floodPlain?: Array<FloodPlainDetail | FloodPlainDetailOptions>;
  floodZone?: Array<FloodZoneDetail | FloodZoneDetailOptions>;
  foundationType?: Array<FoundationTypeDetail | FoundationTypeDetailOptions>;
  globalOptionStatus?: Array<GlobalOptionStatusDetail | GlobalOptionStatusDetailOptions>;
  globalOptionTypeStatus?: Array<GlobalOptionTypeStatusDetail | GlobalOptionTypeStatusDetailOptions>;
  homeownerSelectionOptionPricingType?: Array<
    HomeownerSelectionOptionPricingTypeDetail | HomeownerSelectionOptionPricingTypeDetailOptions
  >;
  homeownerSelectionStatus?: Array<HomeownerSelectionStatusDetail | HomeownerSelectionStatusDetailOptions>;
  inboxItemStatus?: Array<InboxItemStatusDetail | InboxItemStatusDetailOptions>;
  invoiceDocumentSource?: Array<InvoiceDocumentSourceDetail | InvoiceDocumentSourceDetailOptions>;
  invoiceScheduleAmountType?: Array<InvoiceScheduleAmountTypeDetail | InvoiceScheduleAmountTypeDetailOptions>;
  invoiceScheduleItemFrequency?: Array<InvoiceScheduleItemFrequencyDetail | InvoiceScheduleItemFrequencyDetailOptions>;
  invoiceScheduleTriggerType?: Array<InvoiceScheduleTriggerTypeDetail | InvoiceScheduleTriggerTypeDetailOptions>;
  invoiceSource?: Array<InvoiceSourceDetail | InvoiceSourceDetailOptions>;
  invoiceStatus?: Array<InvoiceStatusDetail | InvoiceStatusDetailOptions>;
  invoiceType?: Array<InvoiceTypeDetail | InvoiceTypeDetailOptions>;
  itemStatus?: Array<ItemStatusDetail | ItemStatusDetailOptions>;
  itemTemplateItemCostStatus?: Array<ItemTemplateItemCostStatusDetail | ItemTemplateItemCostStatusDetailOptions>;
  itemTemplateStatus?: Array<ItemTemplateStatusDetail | ItemTemplateStatusDetailOptions>;
  jobLogFlag?: Array<JobLogFlagDetail | JobLogFlagDetailOptions>;
  jobLogNoteType?: Array<JobLogNoteTypeDetail | JobLogNoteTypeDetailOptions>;
  lienWaiverCondition?: Array<LienWaiverConditionDetail | LienWaiverConditionDetailOptions>;
  lienWaiverStatus?: Array<LienWaiverStatusDetail | LienWaiverStatusDetailOptions>;
  lienWaiverType?: Array<LienWaiverTypeDetail | LienWaiverTypeDetailOptions>;
  locationType?: Array<LocationTypeDetail | LocationTypeDetailOptions>;
  lotSalesStatus?: Array<LotSalesStatusDetail | LotSalesStatusDetailOptions>;
  lotType?: Array<LotTypeDetail | LotTypeDetailOptions>;
  markupApplicationMethod?: Array<MarkupApplicationMethodDetail | MarkupApplicationMethodDetailOptions>;
  materialAttributeDimensionType?: Array<
    MaterialAttributeDimensionTypeDetail | MaterialAttributeDimensionTypeDetailOptions
  >;
  materialAttributeValueType?: Array<MaterialAttributeValueTypeDetail | MaterialAttributeValueTypeDetailOptions>;
  materialType?: Array<MaterialTypeDetail | MaterialTypeDetailOptions>;
  mobileSyncUpdateType?: Array<MobileSyncUpdateTypeDetail | MobileSyncUpdateTypeDetailOptions>;
  pandaDocRole?: Array<PandaDocRoleDetail | PandaDocRoleDetailOptions>;
  pandaDocStatus?: Array<PandaDocStatusDetail | PandaDocStatusDetailOptions>;
  pandaDocWorkspace?: Array<PandaDocWorkspaceDetail | PandaDocWorkspaceDetailOptions>;
  paymentTermDueFrom?: Array<PaymentTermDueFromDetail | PaymentTermDueFromDetailOptions>;
  permit?: Array<PermitDetail | PermitDetailOptions>;
  productAttributeType?: Array<ProductAttributeTypeDetail | ProductAttributeTypeDetailOptions>;
  productDimensionType?: Array<ProductDimensionTypeDetail | ProductDimensionTypeDetailOptions>;
  productStatus?: Array<ProductStatusDetail | ProductStatusDetailOptions>;
  programDataBasementConfig?: Array<ProgramDataBasementConfigDetail | ProgramDataBasementConfigDetailOptions>;
  programDataGarageConfig?: Array<ProgramDataGarageConfigDetail | ProgramDataGarageConfigDetailOptions>;
  programDataMatchState?: Array<ProgramDataMatchStateDetail | ProgramDataMatchStateDetailOptions>;
  programDataPrimaryBedroomConfig?: Array<
    ProgramDataPrimaryBedroomConfigDetail | ProgramDataPrimaryBedroomConfigDetailOptions
  >;
  programDataWindowColor?: Array<ProgramDataWindowColorDetail | ProgramDataWindowColorDetailOptions>;
  projectCollaboratorRole?: Array<ProjectCollaboratorRoleDetail | ProjectCollaboratorRoleDetailOptions>;
  projectFeature?: Array<ProjectFeatureDetail | ProjectFeatureDetailOptions>;
  projectReadyPlanConfigOrientation?: Array<
    ProjectReadyPlanConfigOrientationDetail | ProjectReadyPlanConfigOrientationDetailOptions
  >;
  projectRole?: Array<ProjectRoleDetail | ProjectRoleDetailOptions>;
  projectStageStatus?: Array<ProjectStageStatusDetail | ProjectStageStatusDetailOptions>;
  projectStatus?: Array<ProjectStatusDetail | ProjectStatusDetailOptions>;
  projectUpdateActionType?: Array<ProjectUpdateActionTypeDetail | ProjectUpdateActionTypeDetailOptions>;
  promotionStatus?: Array<PromotionStatusDetail | PromotionStatusDetailOptions>;
  pushNotificationEnvironment?: Array<PushNotificationEnvironmentDetail | PushNotificationEnvironmentDetailOptions>;
  pushNotificationPlatform?: Array<PushNotificationPlatformDetail | PushNotificationPlatformDetailOptions>;
  readyPlanAssetType?: Array<ReadyPlanAssetTypeDetail | ReadyPlanAssetTypeDetailOptions>;
  readyPlanOptionGroupPersonalizationType?: Array<
    ReadyPlanOptionGroupPersonalizationTypeDetail | ReadyPlanOptionGroupPersonalizationTypeDetailOptions
  >;
  readyPlanStatus?: Array<ReadyPlanStatusDetail | ReadyPlanStatusDetailOptions>;
  readyPlanType?: Array<ReadyPlanTypeDetail | ReadyPlanTypeDetailOptions>;
  scheduleFlagReasonType?: Array<ScheduleFlagReasonTypeDetail | ScheduleFlagReasonTypeDetailOptions>;
  scheduleStatus?: Array<ScheduleStatusDetail | ScheduleStatusDetailOptions>;
  scheduleTemplateStatus?: Array<ScheduleTemplateStatusDetail | ScheduleTemplateStatusDetailOptions>;
  scopeChangeType?: Array<ScopeChangeTypeDetail | ScopeChangeTypeDetailOptions>;
  scopeMode?: Array<ScopeModeDetail | ScopeModeDetailOptions>;
  selectionCutoff?: Array<SelectionCutoffDetail | SelectionCutoffDetailOptions>;
  selectionPricingMode?: Array<SelectionPricingModeDetail | SelectionPricingModeDetailOptions>;
  stage?: Array<StageDetail | StageDetailOptions>;
  suburbanAssetCategory?: Array<SuburbanAssetCategoryDetail | SuburbanAssetCategoryDetailOptions>;
  systemChangeRequestAsset?: Array<SystemChangeRequestAssetDetail | SystemChangeRequestAssetDetailOptions>;
  systemPlanMilestone?: Array<SystemPlanMilestoneDetail | SystemPlanMilestoneDetailOptions>;
  systemTask?: Array<SystemTaskDetail | SystemTaskDetailOptions>;
  takeoffLineItemDesignPackageType?: Array<
    TakeoffLineItemDesignPackageTypeDetail | TakeoffLineItemDesignPackageTypeDetailOptions
  >;
  takeoffLineItemType?: Array<TakeoffLineItemTypeDetail | TakeoffLineItemTypeDetailOptions>;
  taskDeadlineType?: Array<TaskDeadlineTypeDetail | TaskDeadlineTypeDetailOptions>;
  taskDependencyType?: Array<TaskDependencyTypeDetail | TaskDependencyTypeDetailOptions>;
  taskStatus?: Array<TaskStatusDetail | TaskStatusDetailOptions>;
  taskType?: Array<TaskTypeDetail | TaskTypeDetailOptions>;
  timeFrequency?: Array<TimeFrequencyDetail | TimeFrequencyDetailOptions>;
  timeOfDay?: Array<TimeOfDayDetail | TimeOfDayDetailOptions>;
  toDoStatus?: Array<ToDoStatusDetail | ToDoStatusDetailOptions>;
  toDoType?: Array<ToDoTypeDetail | ToDoTypeDetailOptions>;
  trackedJobStatus?: Array<TrackedJobStatusDetail | TrackedJobStatusDetailOptions>;
  tradePartnerAvailabilityRequestStatus?: Array<
    TradePartnerAvailabilityRequestStatusDetail | TradePartnerAvailabilityRequestStatusDetailOptions
  >;
  tradePartnerMarketRole?: Array<TradePartnerMarketRoleDetail | TradePartnerMarketRoleDetailOptions>;
  tradePartnerOnboardingStatus?: Array<TradePartnerOnboardingStatusDetail | TradePartnerOnboardingStatusDetailOptions>;
  tradePartnerRequirementStatus?: Array<
    TradePartnerRequirementStatusDetail | TradePartnerRequirementStatusDetailOptions
  >;
  tradePartnerRequirementType?: Array<TradePartnerRequirementTypeDetail | TradePartnerRequirementTypeDetailOptions>;
  tradePartnerTaskStatus?: Array<TradePartnerTaskStatusDetail | TradePartnerTaskStatusDetailOptions>;
  userEventType?: Array<UserEventTypeDetail | UserEventTypeDetailOptions>;
  userType?: Array<UserTypeDetail | UserTypeDetailOptions>;
  warrantyTicketItemStatus?: Array<WarrantyTicketItemStatusDetail | WarrantyTicketItemStatusDetailOptions>;
  warrantyTicketItemType?: Array<WarrantyTicketItemTypeDetail | WarrantyTicketItemTypeDetailOptions>;
  warrantyTicketStatus?: Array<WarrantyTicketStatusDetail | WarrantyTicketStatusDetailOptions>;
  warrantyTicketType?: Array<WarrantyTicketTypeDetail | WarrantyTicketTypeDetailOptions>;
  weatherType?: Array<WeatherTypeDetail | WeatherTypeDetailOptions>;
}

export function newAllEnumDetails(
  options: AllEnumDetailsOptions = {},
  cache: Record<string, any> = {},
): AllEnumDetails {
  const o = (options.__typename ? options : cache["AllEnumDetails"] = {}) as AllEnumDetails;
  (cache.all ??= new Set()).add(o);
  o.__typename = "AllEnumDetails";
  o.activityPlanningState = (options.activityPlanningState ?? []).map((i) => enumOrDetailOfActivityPlanningState(i));
  o.activityResponsibility = (options.activityResponsibility ?? []).map((i) => enumOrDetailOfActivityResponsibility(i));
  o.activityType = (options.activityType ?? []).map((i) => enumOrDetailOfActivityType(i));
  o.aggregateVersionStatus = (options.aggregateVersionStatus ?? []).map((i) => enumOrDetailOfAggregateVersionStatus(i));
  o.allocationStrategy = (options.allocationStrategy ?? []).map((i) => enumOrDetailOfAllocationStrategy(i));
  o.approvalStatus = (options.approvalStatus ?? []).map((i) => enumOrDetailOfApprovalStatus(i));
  o.approverStatus = (options.approverStatus ?? []).map((i) => enumOrDetailOfApproverStatus(i));
  o.bidContractRevisionStatus = (options.bidContractRevisionStatus ?? []).map((i) =>
    enumOrDetailOfBidContractRevisionStatus(i)
  );
  o.bidContractType = (options.bidContractType ?? []).map((i) => enumOrDetailOfBidContractType(i));
  o.bidPackageStatus = (options.bidPackageStatus ?? []).map((i) => enumOrDetailOfBidPackageStatus(i));
  o.bidScopeSource = (options.bidScopeSource ?? []).map((i) => enumOrDetailOfBidScopeSource(i));
  o.billGmailAttachmentResult = (options.billGmailAttachmentResult ?? []).map((i) =>
    enumOrDetailOfBillGmailAttachmentResult(i)
  );
  o.billGmailMessageResult = (options.billGmailMessageResult ?? []).map((i) => enumOrDetailOfBillGmailMessageResult(i));
  o.billReviewReason = (options.billReviewReason ?? []).map((i) => enumOrDetailOfBillReviewReason(i));
  o.billSource = (options.billSource ?? []).map((i) => enumOrDetailOfBillSource(i));
  o.billStatus = (options.billStatus ?? []).map((i) => enumOrDetailOfBillStatus(i));
  o.billType = (options.billType ?? []).map((i) => enumOrDetailOfBillType(i));
  o.businessFunctionType = (options.businessFunctionType ?? []).map((i) => enumOrDetailOfBusinessFunctionType(i));
  o.buyoutStatus = (options.buyoutStatus ?? []).map((i) => enumOrDetailOfBuyoutStatus(i));
  o.changeEventBudgetPhase = (options.changeEventBudgetPhase ?? []).map((i) => enumOrDetailOfChangeEventBudgetPhase(i));
  o.changeEventLineItemType = (options.changeEventLineItemType ?? []).map((i) =>
    enumOrDetailOfChangeEventLineItemType(i)
  );
  o.changeEventStatus = (options.changeEventStatus ?? []).map((i) => enumOrDetailOfChangeEventStatus(i));
  o.changeEventType = (options.changeEventType ?? []).map((i) => enumOrDetailOfChangeEventType(i));
  o.changeRequestAssetPlatform = (options.changeRequestAssetPlatform ?? []).map((i) =>
    enumOrDetailOfChangeRequestAssetPlatform(i)
  );
  o.changeRequestAssetScope = (options.changeRequestAssetScope ?? []).map((i) =>
    enumOrDetailOfChangeRequestAssetScope(i)
  );
  o.changeRequestPriority = (options.changeRequestPriority ?? []).map((i) => enumOrDetailOfChangeRequestPriority(i));
  o.changeRequestSource = (options.changeRequestSource ?? []).map((i) => enumOrDetailOfChangeRequestSource(i));
  o.changeRequestStatus = (options.changeRequestStatus ?? []).map((i) => enumOrDetailOfChangeRequestStatus(i));
  o.changeRequestToDoType = (options.changeRequestToDoType ?? []).map((i) => enumOrDetailOfChangeRequestToDoType(i));
  o.changeType = (options.changeType ?? []).map((i) => enumOrDetailOfChangeType(i));
  o.checkoutConfigOptionGroupStep = (options.checkoutConfigOptionGroupStep ?? []).map((i) =>
    enumOrDetailOfCheckoutConfigOptionGroupStep(i)
  );
  o.checkoutConfigStatus = (options.checkoutConfigStatus ?? []).map((i) => enumOrDetailOfCheckoutConfigStatus(i));
  o.clientPlatform = (options.clientPlatform ?? []).map((i) => enumOrDetailOfClientPlatform(i));
  o.commentStreamVisibility = (options.commentStreamVisibility ?? []).map((i) =>
    enumOrDetailOfCommentStreamVisibility(i)
  );
  o.commitmentStatus = (options.commitmentStatus ?? []).map((i) => enumOrDetailOfCommitmentStatus(i));
  o.commitmentType = (options.commitmentType ?? []).map((i) => enumOrDetailOfCommitmentType(i));
  o.communicationChannel = (options.communicationChannel ?? []).map((i) => enumOrDetailOfCommunicationChannel(i));
  o.communityType = (options.communityType ?? []).map((i) => enumOrDetailOfCommunityType(i));
  o.constructionType = (options.constructionType ?? []).map((i) => enumOrDetailOfConstructionType(i));
  o.contractType = (options.contractType ?? []).map((i) => enumOrDetailOfContractType(i));
  o.costClassificationType = (options.costClassificationType ?? []).map((i) => enumOrDetailOfCostClassificationType(i));
  o.costCodeInvoiceCategory = (options.costCodeInvoiceCategory ?? []).map((i) =>
    enumOrDetailOfCostCodeInvoiceCategory(i)
  );
  o.costConfidence = (options.costConfidence ?? []).map((i) => enumOrDetailOfCostConfidence(i));
  o.costSubClassificationType = (options.costSubClassificationType ?? []).map((i) =>
    enumOrDetailOfCostSubClassificationType(i)
  );
  o.costType = (options.costType ?? []).map((i) => enumOrDetailOfCostType(i));
  o.dayOfWeek = (options.dayOfWeek ?? []).map((i) => enumOrDetailOfDayOfWeek(i));
  o.designPackageLocation = (options.designPackageLocation ?? []).map((i) => enumOrDetailOfDesignPackageLocation(i));
  o.developmentCommitmentType = (options.developmentCommitmentType ?? []).map((i) =>
    enumOrDetailOfDevelopmentCommitmentType(i)
  );
  o.documentAttachmentPlace = (options.documentAttachmentPlace ?? []).map((i) =>
    enumOrDetailOfDocumentAttachmentPlace(i)
  );
  o.documentCategory = (options.documentCategory ?? []).map((i) => enumOrDetailOfDocumentCategory(i));
  o.documentType = (options.documentType ?? []).map((i) => enumOrDetailOfDocumentType(i));
  o.erpAccrualType = (options.erpAccrualType ?? []).map((i) => enumOrDetailOfErpAccrualType(i));
  o.erpRevenueLineItemSourceEvent = (options.erpRevenueLineItemSourceEvent ?? []).map((i) =>
    enumOrDetailOfErpRevenueLineItemSourceEvent(i)
  );
  o.erpTransactionGroupEvent = (options.erpTransactionGroupEvent ?? []).map((i) =>
    enumOrDetailOfErpTransactionGroupEvent(i)
  );
  o.erpTransactionGroupStatus = (options.erpTransactionGroupStatus ?? []).map((i) =>
    enumOrDetailOfErpTransactionGroupStatus(i)
  );
  o.erpTransactionStatus = (options.erpTransactionStatus ?? []).map((i) => enumOrDetailOfErpTransactionStatus(i));
  o.estimateStatus = (options.estimateStatus ?? []).map((i) => enumOrDetailOfEstimateStatus(i));
  o.estimateType = (options.estimateType ?? []).map((i) => enumOrDetailOfEstimateType(i));
  o.featureFlagStatus = (options.featureFlagStatus ?? []).map((i) => enumOrDetailOfFeatureFlagStatus(i));
  o.featureFlagType = (options.featureFlagType ?? []).map((i) => enumOrDetailOfFeatureFlagType(i));
  o.floodPlain = (options.floodPlain ?? []).map((i) => enumOrDetailOfFloodPlain(i));
  o.floodZone = (options.floodZone ?? []).map((i) => enumOrDetailOfFloodZone(i));
  o.foundationType = (options.foundationType ?? []).map((i) => enumOrDetailOfFoundationType(i));
  o.globalOptionStatus = (options.globalOptionStatus ?? []).map((i) => enumOrDetailOfGlobalOptionStatus(i));
  o.globalOptionTypeStatus = (options.globalOptionTypeStatus ?? []).map((i) => enumOrDetailOfGlobalOptionTypeStatus(i));
  o.homeownerSelectionOptionPricingType = (options.homeownerSelectionOptionPricingType ?? []).map((i) =>
    enumOrDetailOfHomeownerSelectionOptionPricingType(i)
  );
  o.homeownerSelectionStatus = (options.homeownerSelectionStatus ?? []).map((i) =>
    enumOrDetailOfHomeownerSelectionStatus(i)
  );
  o.inboxItemStatus = (options.inboxItemStatus ?? []).map((i) => enumOrDetailOfInboxItemStatus(i));
  o.invoiceDocumentSource = (options.invoiceDocumentSource ?? []).map((i) => enumOrDetailOfInvoiceDocumentSource(i));
  o.invoiceScheduleAmountType = (options.invoiceScheduleAmountType ?? []).map((i) =>
    enumOrDetailOfInvoiceScheduleAmountType(i)
  );
  o.invoiceScheduleItemFrequency = (options.invoiceScheduleItemFrequency ?? []).map((i) =>
    enumOrDetailOfInvoiceScheduleItemFrequency(i)
  );
  o.invoiceScheduleTriggerType = (options.invoiceScheduleTriggerType ?? []).map((i) =>
    enumOrDetailOfInvoiceScheduleTriggerType(i)
  );
  o.invoiceSource = (options.invoiceSource ?? []).map((i) => enumOrDetailOfInvoiceSource(i));
  o.invoiceStatus = (options.invoiceStatus ?? []).map((i) => enumOrDetailOfInvoiceStatus(i));
  o.invoiceType = (options.invoiceType ?? []).map((i) => enumOrDetailOfInvoiceType(i));
  o.itemStatus = (options.itemStatus ?? []).map((i) => enumOrDetailOfItemStatus(i));
  o.itemTemplateItemCostStatus = (options.itemTemplateItemCostStatus ?? []).map((i) =>
    enumOrDetailOfItemTemplateItemCostStatus(i)
  );
  o.itemTemplateStatus = (options.itemTemplateStatus ?? []).map((i) => enumOrDetailOfItemTemplateStatus(i));
  o.jobLogFlag = (options.jobLogFlag ?? []).map((i) => enumOrDetailOfJobLogFlag(i));
  o.jobLogNoteType = (options.jobLogNoteType ?? []).map((i) => enumOrDetailOfJobLogNoteType(i));
  o.lienWaiverCondition = (options.lienWaiverCondition ?? []).map((i) => enumOrDetailOfLienWaiverCondition(i));
  o.lienWaiverStatus = (options.lienWaiverStatus ?? []).map((i) => enumOrDetailOfLienWaiverStatus(i));
  o.lienWaiverType = (options.lienWaiverType ?? []).map((i) => enumOrDetailOfLienWaiverType(i));
  o.locationType = (options.locationType ?? []).map((i) => enumOrDetailOfLocationType(i));
  o.lotSalesStatus = (options.lotSalesStatus ?? []).map((i) => enumOrDetailOfLotSalesStatus(i));
  o.lotType = (options.lotType ?? []).map((i) => enumOrDetailOfLotType(i));
  o.markupApplicationMethod = (options.markupApplicationMethod ?? []).map((i) =>
    enumOrDetailOfMarkupApplicationMethod(i)
  );
  o.materialAttributeDimensionType = (options.materialAttributeDimensionType ?? []).map((i) =>
    enumOrDetailOfMaterialAttributeDimensionType(i)
  );
  o.materialAttributeValueType = (options.materialAttributeValueType ?? []).map((i) =>
    enumOrDetailOfMaterialAttributeValueType(i)
  );
  o.materialType = (options.materialType ?? []).map((i) => enumOrDetailOfMaterialType(i));
  o.mobileSyncUpdateType = (options.mobileSyncUpdateType ?? []).map((i) => enumOrDetailOfMobileSyncUpdateType(i));
  o.pandaDocRole = (options.pandaDocRole ?? []).map((i) => enumOrDetailOfPandaDocRole(i));
  o.pandaDocStatus = (options.pandaDocStatus ?? []).map((i) => enumOrDetailOfPandaDocStatus(i));
  o.pandaDocWorkspace = (options.pandaDocWorkspace ?? []).map((i) => enumOrDetailOfPandaDocWorkspace(i));
  o.paymentTermDueFrom = (options.paymentTermDueFrom ?? []).map((i) => enumOrDetailOfPaymentTermDueFrom(i));
  o.permit = (options.permit ?? []).map((i) => enumOrDetailOfPermit(i));
  o.productAttributeType = (options.productAttributeType ?? []).map((i) => enumOrDetailOfProductAttributeType(i));
  o.productDimensionType = (options.productDimensionType ?? []).map((i) => enumOrDetailOfProductDimensionType(i));
  o.productStatus = (options.productStatus ?? []).map((i) => enumOrDetailOfProductStatus(i));
  o.programDataBasementConfig = (options.programDataBasementConfig ?? []).map((i) =>
    enumOrDetailOfProgramDataBasementConfig(i)
  );
  o.programDataGarageConfig = (options.programDataGarageConfig ?? []).map((i) =>
    enumOrDetailOfProgramDataGarageConfig(i)
  );
  o.programDataMatchState = (options.programDataMatchState ?? []).map((i) => enumOrDetailOfProgramDataMatchState(i));
  o.programDataPrimaryBedroomConfig = (options.programDataPrimaryBedroomConfig ?? []).map((i) =>
    enumOrDetailOfProgramDataPrimaryBedroomConfig(i)
  );
  o.programDataWindowColor = (options.programDataWindowColor ?? []).map((i) => enumOrDetailOfProgramDataWindowColor(i));
  o.projectCollaboratorRole = (options.projectCollaboratorRole ?? []).map((i) =>
    enumOrDetailOfProjectCollaboratorRole(i)
  );
  o.projectFeature = (options.projectFeature ?? []).map((i) => enumOrDetailOfProjectFeature(i));
  o.projectReadyPlanConfigOrientation = (options.projectReadyPlanConfigOrientation ?? []).map((i) =>
    enumOrDetailOfProjectReadyPlanConfigOrientation(i)
  );
  o.projectRole = (options.projectRole ?? []).map((i) => enumOrDetailOfProjectRole(i));
  o.projectStageStatus = (options.projectStageStatus ?? []).map((i) => enumOrDetailOfProjectStageStatus(i));
  o.projectStatus = (options.projectStatus ?? []).map((i) => enumOrDetailOfProjectStatus(i));
  o.projectUpdateActionType = (options.projectUpdateActionType ?? []).map((i) =>
    enumOrDetailOfProjectUpdateActionType(i)
  );
  o.promotionStatus = (options.promotionStatus ?? []).map((i) => enumOrDetailOfPromotionStatus(i));
  o.pushNotificationEnvironment = (options.pushNotificationEnvironment ?? []).map((i) =>
    enumOrDetailOfPushNotificationEnvironment(i)
  );
  o.pushNotificationPlatform = (options.pushNotificationPlatform ?? []).map((i) =>
    enumOrDetailOfPushNotificationPlatform(i)
  );
  o.readyPlanAssetType = (options.readyPlanAssetType ?? []).map((i) => enumOrDetailOfReadyPlanAssetType(i));
  o.readyPlanOptionGroupPersonalizationType = (options.readyPlanOptionGroupPersonalizationType ?? []).map((i) =>
    enumOrDetailOfReadyPlanOptionGroupPersonalizationType(i)
  );
  o.readyPlanStatus = (options.readyPlanStatus ?? []).map((i) => enumOrDetailOfReadyPlanStatus(i));
  o.readyPlanType = (options.readyPlanType ?? []).map((i) => enumOrDetailOfReadyPlanType(i));
  o.scheduleFlagReasonType = (options.scheduleFlagReasonType ?? []).map((i) => enumOrDetailOfScheduleFlagReasonType(i));
  o.scheduleStatus = (options.scheduleStatus ?? []).map((i) => enumOrDetailOfScheduleStatus(i));
  o.scheduleTemplateStatus = (options.scheduleTemplateStatus ?? []).map((i) => enumOrDetailOfScheduleTemplateStatus(i));
  o.scopeChangeType = (options.scopeChangeType ?? []).map((i) => enumOrDetailOfScopeChangeType(i));
  o.scopeMode = (options.scopeMode ?? []).map((i) => enumOrDetailOfScopeMode(i));
  o.selectionCutoff = (options.selectionCutoff ?? []).map((i) => enumOrDetailOfSelectionCutoff(i));
  o.selectionPricingMode = (options.selectionPricingMode ?? []).map((i) => enumOrDetailOfSelectionPricingMode(i));
  o.stage = (options.stage ?? []).map((i) => enumOrDetailOfStage(i));
  o.suburbanAssetCategory = (options.suburbanAssetCategory ?? []).map((i) => enumOrDetailOfSuburbanAssetCategory(i));
  o.systemChangeRequestAsset = (options.systemChangeRequestAsset ?? []).map((i) =>
    enumOrDetailOfSystemChangeRequestAsset(i)
  );
  o.systemPlanMilestone = (options.systemPlanMilestone ?? []).map((i) => enumOrDetailOfSystemPlanMilestone(i));
  o.systemTask = (options.systemTask ?? []).map((i) => enumOrDetailOfSystemTask(i));
  o.takeoffLineItemDesignPackageType = (options.takeoffLineItemDesignPackageType ?? []).map((i) =>
    enumOrDetailOfTakeoffLineItemDesignPackageType(i)
  );
  o.takeoffLineItemType = (options.takeoffLineItemType ?? []).map((i) => enumOrDetailOfTakeoffLineItemType(i));
  o.taskDeadlineType = (options.taskDeadlineType ?? []).map((i) => enumOrDetailOfTaskDeadlineType(i));
  o.taskDependencyType = (options.taskDependencyType ?? []).map((i) => enumOrDetailOfTaskDependencyType(i));
  o.taskStatus = (options.taskStatus ?? []).map((i) => enumOrDetailOfTaskStatus(i));
  o.taskType = (options.taskType ?? []).map((i) => enumOrDetailOfTaskType(i));
  o.timeFrequency = (options.timeFrequency ?? []).map((i) => enumOrDetailOfTimeFrequency(i));
  o.timeOfDay = (options.timeOfDay ?? []).map((i) => enumOrDetailOfTimeOfDay(i));
  o.toDoStatus = (options.toDoStatus ?? []).map((i) => enumOrDetailOfToDoStatus(i));
  o.toDoType = (options.toDoType ?? []).map((i) => enumOrDetailOfToDoType(i));
  o.trackedJobStatus = (options.trackedJobStatus ?? []).map((i) => enumOrDetailOfTrackedJobStatus(i));
  o.tradePartnerAvailabilityRequestStatus = (options.tradePartnerAvailabilityRequestStatus ?? []).map((i) =>
    enumOrDetailOfTradePartnerAvailabilityRequestStatus(i)
  );
  o.tradePartnerMarketRole = (options.tradePartnerMarketRole ?? []).map((i) => enumOrDetailOfTradePartnerMarketRole(i));
  o.tradePartnerOnboardingStatus = (options.tradePartnerOnboardingStatus ?? []).map((i) =>
    enumOrDetailOfTradePartnerOnboardingStatus(i)
  );
  o.tradePartnerRequirementStatus = (options.tradePartnerRequirementStatus ?? []).map((i) =>
    enumOrDetailOfTradePartnerRequirementStatus(i)
  );
  o.tradePartnerRequirementType = (options.tradePartnerRequirementType ?? []).map((i) =>
    enumOrDetailOfTradePartnerRequirementType(i)
  );
  o.tradePartnerTaskStatus = (options.tradePartnerTaskStatus ?? []).map((i) => enumOrDetailOfTradePartnerTaskStatus(i));
  o.userEventType = (options.userEventType ?? []).map((i) => enumOrDetailOfUserEventType(i));
  o.userType = (options.userType ?? []).map((i) => enumOrDetailOfUserType(i));
  o.warrantyTicketItemStatus = (options.warrantyTicketItemStatus ?? []).map((i) =>
    enumOrDetailOfWarrantyTicketItemStatus(i)
  );
  o.warrantyTicketItemType = (options.warrantyTicketItemType ?? []).map((i) => enumOrDetailOfWarrantyTicketItemType(i));
  o.warrantyTicketStatus = (options.warrantyTicketStatus ?? []).map((i) => enumOrDetailOfWarrantyTicketStatus(i));
  o.warrantyTicketType = (options.warrantyTicketType ?? []).map((i) => enumOrDetailOfWarrantyTicketType(i));
  o.weatherType = (options.weatherType ?? []).map((i) => enumOrDetailOfWeatherType(i));
  return o;
}

factories["AllEnumDetails"] = newAllEnumDetails;

export interface IdentifyProjectAccrualAdjustmentsResultOptions {
  __typename?: "IdentifyProjectAccrualAdjustmentsResult";
  type?: IdentifyProjectAccrualAdjustmentsResult["type"];
  commitmentLineItem?: CommitmentLineItem | CommitmentLineItemOptions;
  commitmentLikeReference?: IdentifyProjectAccrualAdjustmentsResult["commitmentLikeReference"];
  adjustInCents?: IdentifyProjectAccrualAdjustmentsResult["adjustInCents"];
  intacctVendorId?: IdentifyProjectAccrualAdjustmentsResult["intacctVendorId"];
  intacctGLAccountNo?: IdentifyProjectAccrualAdjustmentsResult["intacctGLAccountNo"];
  intacctProjectId?: IdentifyProjectAccrualAdjustmentsResult["intacctProjectId"];
  intacctItemId?: IdentifyProjectAccrualAdjustmentsResult["intacctItemId"];
  intacctCustomerId?: IdentifyProjectAccrualAdjustmentsResult["intacctCustomerId"];
  intacctLocationId?: IdentifyProjectAccrualAdjustmentsResult["intacctLocationId"];
}

export function newIdentifyProjectAccrualAdjustmentsResult(
  options: IdentifyProjectAccrualAdjustmentsResultOptions = {},
  cache: Record<string, any> = {},
): IdentifyProjectAccrualAdjustmentsResult {
  const o =
    (options.__typename
      ? options
      : cache["IdentifyProjectAccrualAdjustmentsResult"] = {}) as IdentifyProjectAccrualAdjustmentsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "IdentifyProjectAccrualAdjustmentsResult";
  o.type = options.type ?? CostAccrualAdjustmentType.TaskWithOverbilled;
  o.commitmentLineItem = maybeNew(
    "CommitmentLineItem",
    options.commitmentLineItem,
    cache,
    options.hasOwnProperty("commitmentLineItem"),
  );
  o.commitmentLikeReference = options.commitmentLikeReference ?? "commitmentLikeReference";
  o.adjustInCents = options.adjustInCents ?? 0;
  o.intacctVendorId = options.intacctVendorId ?? "intacctVendorId";
  o.intacctGLAccountNo = options.intacctGLAccountNo ?? "intacctGLAccountNo";
  o.intacctProjectId = options.intacctProjectId ?? "intacctProjectId";
  o.intacctItemId = options.intacctItemId ?? "intacctItemId";
  o.intacctCustomerId = options.intacctCustomerId ?? "intacctCustomerId";
  o.intacctLocationId = options.intacctLocationId ?? "intacctLocationId";
  return o;
}

factories["IdentifyProjectAccrualAdjustmentsResult"] = newIdentifyProjectAccrualAdjustmentsResult;

export interface SaveEstimateResultOptions {
  __typename?: "SaveEstimateResult";
  estimate?: Estimate | EstimateOptions;
}

export function newSaveEstimateResult(
  options: SaveEstimateResultOptions = {},
  cache: Record<string, any> = {},
): SaveEstimateResult {
  const o = (options.__typename ? options : cache["SaveEstimateResult"] = {}) as SaveEstimateResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveEstimateResult";
  o.estimate = maybeNew("Estimate", options.estimate, cache, options.hasOwnProperty("estimate"));
  return o;
}

factories["SaveEstimateResult"] = newSaveEstimateResult;

export interface AnnotatedCostOptions {
  __typename?: "AnnotatedCost";
  item?: Item | ItemOptions;
  totalPriceInCents?: AnnotatedCost["totalPriceInCents"];
}

export function newAnnotatedCost(options: AnnotatedCostOptions = {}, cache: Record<string, any> = {}): AnnotatedCost {
  const o = (options.__typename ? options : cache["AnnotatedCost"] = {}) as AnnotatedCost;
  (cache.all ??= new Set()).add(o);
  o.__typename = "AnnotatedCost";
  o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
  o.totalPriceInCents = options.totalPriceInCents ?? 0;
  return o;
}

factories["AnnotatedCost"] = newAnnotatedCost;

export interface EstimateLineItemOptions {
  __typename?: "EstimateLineItem";
  id?: EstimateLineItem["id"];
  quantity?: EstimateLineItem["quantity"];
  estimate?: Estimate | EstimateOptions;
  projectItem?: ProjectItem | ProjectItemOptions;
  projectItemHasDiverged?: EstimateLineItem["projectItemHasDiverged"];
  isPlaceholder?: EstimateLineItem["isPlaceholder"];
  unitCostInCents?: EstimateLineItem["unitCostInCents"];
  unitPriceInCents?: EstimateLineItem["unitPriceInCents"];
  totalCostInCents?: EstimateLineItem["totalCostInCents"];
  totalPriceInCents?: EstimateLineItem["totalPriceInCents"];
  changeEventLineItem?: ChangeEventLineItem | ChangeEventLineItemOptions | null;
  unitOfMeasure?: UnitOfMeasure | UnitOfMeasureOptions;
  displayName?: EstimateLineItem["displayName"];
}

export function newEstimateLineItem(
  options: EstimateLineItemOptions = {},
  cache: Record<string, any> = {},
): EstimateLineItem {
  const o = (options.__typename ? options : cache["EstimateLineItem"] = {}) as EstimateLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "EstimateLineItem";
  o.id = options.id ?? nextFactoryId("EstimateLineItem");
  o.quantity = options.quantity ?? null;
  o.estimate = maybeNew("Estimate", options.estimate, cache, options.hasOwnProperty("estimate"));
  o.projectItem = maybeNew("ProjectItem", options.projectItem, cache, options.hasOwnProperty("projectItem"));
  o.projectItemHasDiverged = options.projectItemHasDiverged ?? false;
  o.isPlaceholder = options.isPlaceholder ?? false;
  o.unitCostInCents = options.unitCostInCents ?? 0;
  o.unitPriceInCents = options.unitPriceInCents ?? 0;
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.totalPriceInCents = options.totalPriceInCents ?? 0;
  o.changeEventLineItem = maybeNewOrNull("ChangeEventLineItem", options.changeEventLineItem, cache);
  o.unitOfMeasure = maybeNew("UnitOfMeasure", options.unitOfMeasure, cache, options.hasOwnProperty("unitOfMeasure"));
  o.displayName = options.displayName ?? "displayName";
  return o;
}

factories["EstimateLineItem"] = newEstimateLineItem;

export interface ExpenseOptions {
  __typename?: "Expense";
  id?: Expense["id"];
  amountInCents?: Expense["amountInCents"];
  unallocatedAmountInCents?: Expense["unallocatedAmountInCents"];
  expenseDate?: Expense["expenseDate"];
  dueDate?: Expense["dueDate"];
  description?: Expense["description"];
  createdAt?: Expense["createdAt"];
  updatedAt?: Expense["updatedAt"];
  costCode?: CostCode | CostCodeOptions | null;
  intacctApBillId?: Expense["intacctApBillId"];
  intacctApBillLineId?: Expense["intacctApBillLineId"];
  intacctItemId?: Expense["intacctItemId"];
  intacctVendorName?: Expense["intacctVendorName"];
  intacctVendorBlueprintId?: Expense["intacctVendorBlueprintId"];
  amountPaidInCents?: Expense["amountPaidInCents"];
  stage?: StageDetailOptions | Stage;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  potentialProjectItems?: Array<ProjectItem | ProjectItemOptions>;
  intacctVendorId?: Expense["intacctVendorId"];
  document?: Document | DocumentOptions | null;
  allocations?: Array<ExpenseAllocation | ExpenseAllocationOptions>;
  changeEvents?: Array<ChangeEvent | ChangeEventOptions>;
  documents?: Array<Document | DocumentOptions>;
  tradeNumber?: Expense["tradeNumber"];
  allLineItemsAreExpenses?: Expense["allLineItemsAreExpenses"];
  canBeConvertedToBill?: PotentialOperation2 | PotentialOperation2Options;
  isBrex?: Expense["isBrex"];
}

export function newExpense(options: ExpenseOptions = {}, cache: Record<string, any> = {}): Expense {
  const o = (options.__typename ? options : cache["Expense"] = {}) as Expense;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Expense";
  o.id = options.id ?? nextFactoryId("Expense");
  o.amountInCents = options.amountInCents ?? 0;
  o.unallocatedAmountInCents = options.unallocatedAmountInCents ?? 0;
  o.expenseDate = options.expenseDate ?? newDate();
  o.dueDate = options.dueDate ?? null;
  o.description = options.description ?? "description";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.costCode = maybeNewOrNull("CostCode", options.costCode, cache);
  o.intacctApBillId = options.intacctApBillId ?? "intacctApBillId";
  o.intacctApBillLineId = options.intacctApBillLineId ?? "intacctApBillLineId";
  o.intacctItemId = options.intacctItemId ?? "intacctItemId";
  o.intacctVendorName = options.intacctVendorName ?? "intacctVendorName";
  o.intacctVendorBlueprintId = options.intacctVendorBlueprintId ?? null;
  o.amountPaidInCents = options.amountPaidInCents ?? 0;
  o.stage = enumOrDetailOfStage(options.stage);
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.potentialProjectItems = (options.potentialProjectItems ?? []).map((i) =>
    maybeNew("ProjectItem", i, cache, options.hasOwnProperty("potentialProjectItems"))
  );
  o.intacctVendorId = options.intacctVendorId ?? "intacctVendorId";
  o.document = maybeNewOrNull("Document", options.document, cache);
  o.allocations = (options.allocations ?? []).map((i) =>
    maybeNew("ExpenseAllocation", i, cache, options.hasOwnProperty("allocations"))
  );
  o.changeEvents = (options.changeEvents ?? []).map((i) =>
    maybeNew("ChangeEvent", i, cache, options.hasOwnProperty("changeEvents"))
  );
  o.documents = (options.documents ?? []).map((i) =>
    maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
  );
  o.tradeNumber = options.tradeNumber ?? null;
  o.allLineItemsAreExpenses = options.allLineItemsAreExpenses ?? false;
  o.canBeConvertedToBill = maybeNew(
    "PotentialOperation2",
    options.canBeConvertedToBill,
    cache,
    options.hasOwnProperty("canBeConvertedToBill"),
  );
  o.isBrex = options.isBrex ?? false;
  return o;
}

factories["Expense"] = newExpense;

export interface SaveExpensesResultOptions {
  __typename?: "SaveExpensesResult";
  expenses?: Array<Expense | ExpenseOptions>;
}

export function newSaveExpensesResult(
  options: SaveExpensesResultOptions = {},
  cache: Record<string, any> = {},
): SaveExpensesResult {
  const o = (options.__typename ? options : cache["SaveExpensesResult"] = {}) as SaveExpensesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveExpensesResult";
  o.expenses = (options.expenses ?? []).map((i) => maybeNew("Expense", i, cache, options.hasOwnProperty("expenses")));
  return o;
}

factories["SaveExpensesResult"] = newSaveExpensesResult;

export interface ConvertExpenseToBillResultOptions {
  __typename?: "ConvertExpenseToBillResult";
  bill?: Bill | BillOptions;
}

export function newConvertExpenseToBillResult(
  options: ConvertExpenseToBillResultOptions = {},
  cache: Record<string, any> = {},
): ConvertExpenseToBillResult {
  const o = (options.__typename ? options : cache["ConvertExpenseToBillResult"] = {}) as ConvertExpenseToBillResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ConvertExpenseToBillResult";
  o.bill = maybeNew("Bill", options.bill, cache, options.hasOwnProperty("bill"));
  return o;
}

factories["ConvertExpenseToBillResult"] = newConvertExpenseToBillResult;

export interface ExpensesPageOptions {
  __typename?: "ExpensesPage";
  entities?: Array<Expense | ExpenseOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newExpensesPage(options: ExpensesPageOptions = {}, cache: Record<string, any> = {}): ExpensesPage {
  const o = (options.__typename ? options : cache["ExpensesPage"] = {}) as ExpensesPage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ExpensesPage";
  o.entities = (options.entities ?? []).map((i) => maybeNew("Expense", i, cache, options.hasOwnProperty("entities")));
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["ExpensesPage"] = newExpensesPage;

export interface ExpenseAllocationOptions {
  __typename?: "ExpenseAllocation";
  id?: ExpenseAllocation["id"];
  amountInCents?: ExpenseAllocation["amountInCents"];
  paidAmountInCents?: ExpenseAllocation["paidAmountInCents"];
  createdAt?: ExpenseAllocation["createdAt"];
  updatedAt?: ExpenseAllocation["updatedAt"];
  expense?: Expense | ExpenseOptions;
  projectItem?: ProjectItem | ProjectItemOptions;
  historicExpenseAmountInvoiced?: ExpenseAllocation["historicExpenseAmountInvoiced"];
  costLineItemAllocations?: Array<CostLineItemAllocation | CostLineItemAllocationOptions>;
  commitmentLineItem?: CommitmentLineItem | CommitmentLineItemOptions | null;
  invoiceAccruedLineItems?: Array<InvoiceAccruedLineItem | InvoiceAccruedLineItemOptions>;
  allocations?: Array<ExpenseAllocationAllocation | ExpenseAllocationAllocationOptions>;
}

export function newExpenseAllocation(
  options: ExpenseAllocationOptions = {},
  cache: Record<string, any> = {},
): ExpenseAllocation {
  const o = (options.__typename ? options : cache["ExpenseAllocation"] = {}) as ExpenseAllocation;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ExpenseAllocation";
  o.id = options.id ?? nextFactoryId("ExpenseAllocation");
  o.amountInCents = options.amountInCents ?? 0;
  o.paidAmountInCents = options.paidAmountInCents ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.expense = maybeNew("Expense", options.expense, cache, options.hasOwnProperty("expense"));
  o.projectItem = maybeNew("ProjectItem", options.projectItem, cache, options.hasOwnProperty("projectItem"));
  o.historicExpenseAmountInvoiced = options.historicExpenseAmountInvoiced ?? null;
  o.costLineItemAllocations = (options.costLineItemAllocations ?? []).map((i) =>
    maybeNew("CostLineItemAllocation", i, cache, options.hasOwnProperty("costLineItemAllocations"))
  );
  o.commitmentLineItem = maybeNewOrNull("CommitmentLineItem", options.commitmentLineItem, cache);
  o.invoiceAccruedLineItems = (options.invoiceAccruedLineItems ?? []).map((i) =>
    maybeNew("InvoiceAccruedLineItem", i, cache, options.hasOwnProperty("invoiceAccruedLineItems"))
  );
  o.allocations = (options.allocations ?? []).map((i) =>
    maybeNew("ExpenseAllocationAllocation", i, cache, options.hasOwnProperty("allocations"))
  );
  return o;
}

factories["ExpenseAllocation"] = newExpenseAllocation;

export interface SaveExpenseAllocationsResultOptions {
  __typename?: "SaveExpenseAllocationsResult";
  expenseAllocations?: Array<ExpenseAllocation | ExpenseAllocationOptions>;
}

export function newSaveExpenseAllocationsResult(
  options: SaveExpenseAllocationsResultOptions = {},
  cache: Record<string, any> = {},
): SaveExpenseAllocationsResult {
  const o = (options.__typename ? options : cache["SaveExpenseAllocationsResult"] = {}) as SaveExpenseAllocationsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveExpenseAllocationsResult";
  o.expenseAllocations = (options.expenseAllocations ?? []).map((i) =>
    maybeNew("ExpenseAllocation", i, cache, options.hasOwnProperty("expenseAllocations"))
  );
  return o;
}

factories["SaveExpenseAllocationsResult"] = newSaveExpenseAllocationsResult;

export interface ExpenseAllocationAllocationOptions {
  __typename?: "ExpenseAllocationAllocation";
  id?: ExpenseAllocationAllocation["id"];
  costInCents?: ExpenseAllocationAllocation["costInCents"];
  createdAt?: ExpenseAllocationAllocation["createdAt"];
  updatedAt?: ExpenseAllocationAllocation["updatedAt"];
  expenseAllocation?: ExpenseAllocation | ExpenseAllocationOptions;
  projectItemAllocation?: ProjectItemAllocation | ProjectItemAllocationOptions;
}

export function newExpenseAllocationAllocation(
  options: ExpenseAllocationAllocationOptions = {},
  cache: Record<string, any> = {},
): ExpenseAllocationAllocation {
  const o = (options.__typename ? options : cache["ExpenseAllocationAllocation"] = {}) as ExpenseAllocationAllocation;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ExpenseAllocationAllocation";
  o.id = options.id ?? nextFactoryId("ExpenseAllocationAllocation");
  o.costInCents = options.costInCents ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.expenseAllocation = maybeNew(
    "ExpenseAllocation",
    options.expenseAllocation,
    cache,
    options.hasOwnProperty("expenseAllocation"),
  );
  o.projectItemAllocation = maybeNew(
    "ProjectItemAllocation",
    options.projectItemAllocation,
    cache,
    options.hasOwnProperty("projectItemAllocation"),
  );
  return o;
}

factories["ExpenseAllocationAllocation"] = newExpenseAllocationAllocation;

export interface FeatureFlagOptions {
  __typename?: "FeatureFlag";
  id?: FeatureFlag["id"];
  type?: FeatureFlagTypeDetailOptions | FeatureFlagType;
  status?: FeatureFlagStatusDetailOptions | FeatureFlagStatus;
  targets?: Array<FeatureFlagTarget | FeatureFlagTargetOptions>;
  name?: FeatureFlag["name"];
  description?: FeatureFlag["description"];
  isPresentational?: FeatureFlag["isPresentational"];
  createdAt?: FeatureFlag["createdAt"];
  updatedAt?: FeatureFlag["updatedAt"];
  releaseVersion?: FeatureFlag["releaseVersion"];
}

export function newFeatureFlag(options: FeatureFlagOptions = {}, cache: Record<string, any> = {}): FeatureFlag {
  const o = (options.__typename ? options : cache["FeatureFlag"] = {}) as FeatureFlag;
  (cache.all ??= new Set()).add(o);
  o.__typename = "FeatureFlag";
  o.id = options.id ?? nextFactoryId("FeatureFlag");
  o.type = enumOrDetailOfFeatureFlagType(options.type);
  o.status = enumOrDetailOfFeatureFlagStatus(options.status);
  o.targets = (options.targets ?? []).map((i) =>
    maybeNew("FeatureFlagTarget", i, cache, options.hasOwnProperty("targets"))
  );
  o.name = options.name ?? "name";
  o.description = options.description ?? "description";
  o.isPresentational = options.isPresentational ?? false;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.releaseVersion = options.releaseVersion ?? 0;
  return o;
}

factories["FeatureFlag"] = newFeatureFlag;

export interface SaveFeatureFlagResultOptions {
  __typename?: "SaveFeatureFlagResult";
  featureFlag?: FeatureFlag | FeatureFlagOptions;
}

export function newSaveFeatureFlagResult(
  options: SaveFeatureFlagResultOptions = {},
  cache: Record<string, any> = {},
): SaveFeatureFlagResult {
  const o = (options.__typename ? options : cache["SaveFeatureFlagResult"] = {}) as SaveFeatureFlagResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveFeatureFlagResult";
  o.featureFlag = maybeNew("FeatureFlag", options.featureFlag, cache, options.hasOwnProperty("featureFlag"));
  return o;
}

factories["SaveFeatureFlagResult"] = newSaveFeatureFlagResult;

export interface FeatureFlagTargetOptions {
  __typename?: "FeatureFlagTarget";
  id?: FeatureFlagTarget["id"];
  createdAt?: FeatureFlagTarget["createdAt"];
  updatedAt?: FeatureFlagTarget["updatedAt"];
  featureFlag?: FeatureFlag | FeatureFlagOptions;
  target?:
    | FeatureFlagTargetTarget
    | DevelopmentOptions
    | RequireTypename<StandaloneProjectOptions>
    | RequireTypename<RegionOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>
    | RequireTypename<UserOptions>
    | RequireTypename<UserGroupOptions>
    | null;
}

export function newFeatureFlagTarget(
  options: FeatureFlagTargetOptions = {},
  cache: Record<string, any> = {},
): FeatureFlagTarget {
  const o = (options.__typename ? options : cache["FeatureFlagTarget"] = {}) as FeatureFlagTarget;
  (cache.all ??= new Set()).add(o);
  o.__typename = "FeatureFlagTarget";
  o.id = options.id ?? nextFactoryId("FeatureFlagTarget");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.featureFlag = maybeNew("FeatureFlag", options.featureFlag, cache, options.hasOwnProperty("featureFlag"));
  o.target = maybeNewOrNull(options.target?.__typename ?? "Development", options.target, cache);
  return o;
}

factories["FeatureFlagTarget"] = newFeatureFlagTarget;

export interface SaveFeatureFlagTargetResultOptions {
  __typename?: "SaveFeatureFlagTargetResult";
  featureFlagTarget?: FeatureFlagTarget | FeatureFlagTargetOptions;
}

export function newSaveFeatureFlagTargetResult(
  options: SaveFeatureFlagTargetResultOptions = {},
  cache: Record<string, any> = {},
): SaveFeatureFlagTargetResult {
  const o = (options.__typename ? options : cache["SaveFeatureFlagTargetResult"] = {}) as SaveFeatureFlagTargetResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveFeatureFlagTargetResult";
  o.featureFlagTarget = maybeNew(
    "FeatureFlagTarget",
    options.featureFlagTarget,
    cache,
    options.hasOwnProperty("featureFlagTarget"),
  );
  return o;
}

factories["SaveFeatureFlagTargetResult"] = newSaveFeatureFlagTargetResult;

export interface FollowSequenceSheetResultOptions {
  __typename?: "FollowSequenceSheetResult";
  developments?: Array<Development | DevelopmentOptions>;
  internalUsers?: Array<InternalUser | InternalUserOptions>;
}

export function newFollowSequenceSheetResult(
  options: FollowSequenceSheetResultOptions = {},
  cache: Record<string, any> = {},
): FollowSequenceSheetResult {
  const o = (options.__typename ? options : cache["FollowSequenceSheetResult"] = {}) as FollowSequenceSheetResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "FollowSequenceSheetResult";
  o.developments = (options.developments ?? []).map((i) =>
    maybeNew("Development", i, cache, options.hasOwnProperty("developments"))
  );
  o.internalUsers = (options.internalUsers ?? []).map((i) =>
    maybeNew("InternalUser", i, cache, options.hasOwnProperty("internalUsers"))
  );
  return o;
}

factories["FollowSequenceSheetResult"] = newFollowSequenceSheetResult;

export interface SaveFollowersResultOptions {
  __typename?: "SaveFollowersResult";
  emptyResult?: SaveFollowersResult["emptyResult"];
  commentable?:
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Commentable
    | CommentableOptions;
  followable?:
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Followable
    | FollowableOptions;
}

export function newSaveFollowersResult(
  options: SaveFollowersResultOptions = {},
  cache: Record<string, any> = {},
): SaveFollowersResult {
  const o = (options.__typename ? options : cache["SaveFollowersResult"] = {}) as SaveFollowersResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveFollowersResult";
  o.emptyResult = options.emptyResult ?? null;
  o.commentable = maybeNew("Commentable", options.commentable, cache, options.hasOwnProperty("commentable"));
  o.followable = maybeNew("Followable", options.followable, cache, options.hasOwnProperty("followable"));
  return o;
}

factories["SaveFollowersResult"] = newSaveFollowersResult;

export interface SaveGlobalOptionsResultOptions {
  __typename?: "SaveGlobalOptionsResult";
  globalOptions?: Array<GlobalOption | GlobalOptionOptions>;
}

export function newSaveGlobalOptionsResult(
  options: SaveGlobalOptionsResultOptions = {},
  cache: Record<string, any> = {},
): SaveGlobalOptionsResult {
  const o = (options.__typename ? options : cache["SaveGlobalOptionsResult"] = {}) as SaveGlobalOptionsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveGlobalOptionsResult";
  o.globalOptions = (options.globalOptions ?? []).map((i) =>
    maybeNew("GlobalOption", i, cache, options.hasOwnProperty("globalOptions"))
  );
  return o;
}

factories["SaveGlobalOptionsResult"] = newSaveGlobalOptionsResult;

export interface BackfillGlobalOptionNamesResultOptions {
  __typename?: "BackfillGlobalOptionNamesResult";
  globalOptions?: Array<GlobalOption | GlobalOptionOptions>;
}

export function newBackfillGlobalOptionNamesResult(
  options: BackfillGlobalOptionNamesResultOptions = {},
  cache: Record<string, any> = {},
): BackfillGlobalOptionNamesResult {
  const o =
    (options.__typename ? options : cache["BackfillGlobalOptionNamesResult"] = {}) as BackfillGlobalOptionNamesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BackfillGlobalOptionNamesResult";
  o.globalOptions = (options.globalOptions ?? []).map((i) =>
    maybeNew("GlobalOption", i, cache, options.hasOwnProperty("globalOptions"))
  );
  return o;
}

factories["BackfillGlobalOptionNamesResult"] = newBackfillGlobalOptionNamesResult;

export interface GlobalOptionGroupOptions {
  __typename?: "GlobalOptionGroup";
  id?: GlobalOptionGroup["id"];
  name?: GlobalOptionGroup["name"];
  createdAt?: GlobalOptionGroup["createdAt"];
  updatedAt?: GlobalOptionGroup["updatedAt"];
  globalOptions?: Array<GlobalOption | GlobalOptionOptions>;
  type?: GlobalOptionType | GlobalOptionTypeOptions;
  isSingleOptionGroup?: GlobalOptionGroup["isSingleOptionGroup"];
  isMultiOptionGroup?: GlobalOptionGroup["isMultiOptionGroup"];
  salesforceFieldName?: GlobalOptionGroup["salesforceFieldName"];
  forDesignPackage?: GlobalOptionGroup["forDesignPackage"];
  forDesignInterior?: GlobalOptionGroup["forDesignInterior"];
  forDesignUpgrade?: GlobalOptionGroup["forDesignUpgrade"];
  forExteriors?: GlobalOptionGroup["forExteriors"];
  forDesignExterior?: GlobalOptionGroup["forDesignExterior"];
  forDesignPackages?: GlobalOptionGroup["forDesignPackages"];
  defaultRequired?: GlobalOptionGroup["defaultRequired"];
  designPackageTagColor?: GlobalOptionGroup["designPackageTagColor"];
  version?: GlobalOptionGroup["version"];
  canEditType?: PotentialOperation2 | PotentialOperation2Options;
  readyPlan?: ReadyPlan | PlanPackage | DesignPackage | ProductOffering | ReadyPlanLike | ReadyPlanLikeOptions | null;
}

export function newGlobalOptionGroup(
  options: GlobalOptionGroupOptions = {},
  cache: Record<string, any> = {},
): GlobalOptionGroup {
  const o = (options.__typename ? options : cache["GlobalOptionGroup"] = {}) as GlobalOptionGroup;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalOptionGroup";
  o.id = options.id ?? nextFactoryId("GlobalOptionGroup");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.globalOptions = (options.globalOptions ?? []).map((i) =>
    maybeNew("GlobalOption", i, cache, options.hasOwnProperty("globalOptions"))
  );
  o.type = maybeNew("GlobalOptionType", options.type, cache, options.hasOwnProperty("type"));
  o.isSingleOptionGroup = options.isSingleOptionGroup ?? false;
  o.isMultiOptionGroup = options.isMultiOptionGroup ?? false;
  o.salesforceFieldName = options.salesforceFieldName ?? null;
  o.forDesignPackage = options.forDesignPackage ?? false;
  o.forDesignInterior = options.forDesignInterior ?? false;
  o.forDesignUpgrade = options.forDesignUpgrade ?? false;
  o.forExteriors = options.forExteriors ?? false;
  o.forDesignExterior = options.forDesignExterior ?? false;
  o.forDesignPackages = options.forDesignPackages ?? false;
  o.defaultRequired = options.defaultRequired ?? false;
  o.designPackageTagColor = options.designPackageTagColor ?? null;
  o.version = options.version ?? 0;
  o.canEditType = maybeNew("PotentialOperation2", options.canEditType, cache, options.hasOwnProperty("canEditType"));
  o.readyPlan = maybeNewOrNull("ReadyPlanLike", options.readyPlan, cache);
  return o;
}

factories["GlobalOptionGroup"] = newGlobalOptionGroup;

export interface SaveGlobalOptionGroupResultOptions {
  __typename?: "SaveGlobalOptionGroupResult";
  entity?: GlobalOptionGroup | GlobalOptionGroupOptions;
}

export function newSaveGlobalOptionGroupResult(
  options: SaveGlobalOptionGroupResultOptions = {},
  cache: Record<string, any> = {},
): SaveGlobalOptionGroupResult {
  const o = (options.__typename ? options : cache["SaveGlobalOptionGroupResult"] = {}) as SaveGlobalOptionGroupResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveGlobalOptionGroupResult";
  o.entity = maybeNew("GlobalOptionGroup", options.entity, cache, options.hasOwnProperty("entity"));
  return o;
}

factories["SaveGlobalOptionGroupResult"] = newSaveGlobalOptionGroupResult;

export interface GlobalOptionTagOptions {
  __typename?: "GlobalOptionTag";
  id?: GlobalOptionTag["id"];
  name?: GlobalOptionTag["name"];
  globalOptions?: Array<GlobalOption | GlobalOptionOptions>;
  globalOptionTypes?: Array<GlobalOptionType | GlobalOptionTypeOptions>;
}

export function newGlobalOptionTag(
  options: GlobalOptionTagOptions = {},
  cache: Record<string, any> = {},
): GlobalOptionTag {
  const o = (options.__typename ? options : cache["GlobalOptionTag"] = {}) as GlobalOptionTag;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalOptionTag";
  o.id = options.id ?? nextFactoryId("GlobalOptionTag");
  o.name = options.name ?? "name";
  o.globalOptions = (options.globalOptions ?? []).map((i) =>
    maybeNew("GlobalOption", i, cache, options.hasOwnProperty("globalOptions"))
  );
  o.globalOptionTypes = (options.globalOptionTypes ?? []).map((i) =>
    maybeNew("GlobalOptionType", i, cache, options.hasOwnProperty("globalOptionTypes"))
  );
  return o;
}

factories["GlobalOptionTag"] = newGlobalOptionTag;

export interface SaveGlobalOptionTagsResultOptions {
  __typename?: "SaveGlobalOptionTagsResult";
  globalOptionTags?: Array<GlobalOptionTag | GlobalOptionTagOptions>;
}

export function newSaveGlobalOptionTagsResult(
  options: SaveGlobalOptionTagsResultOptions = {},
  cache: Record<string, any> = {},
): SaveGlobalOptionTagsResult {
  const o = (options.__typename ? options : cache["SaveGlobalOptionTagsResult"] = {}) as SaveGlobalOptionTagsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveGlobalOptionTagsResult";
  o.globalOptionTags = (options.globalOptionTags ?? []).map((i) =>
    maybeNew("GlobalOptionTag", i, cache, options.hasOwnProperty("globalOptionTags"))
  );
  return o;
}

factories["SaveGlobalOptionTagsResult"] = newSaveGlobalOptionTagsResult;

export interface GlobalOptionTypeOptions {
  __typename?: "GlobalOptionType";
  id?: GlobalOptionType["id"];
  name?: GlobalOptionType["name"];
  description?: GlobalOptionType["description"];
  changesProgramData?: GlobalOptionType["changesProgramData"];
  changesSpecsAndSelections?: GlobalOptionType["changesSpecsAndSelections"];
  status?: GlobalOptionType["status"];
  statusDetail?: GlobalOptionTypeStatusDetailOptions | GlobalOptionTypeStatus;
  isElevation?: GlobalOptionType["isElevation"];
  isExteriorPalette?: GlobalOptionType["isExteriorPalette"];
  isSpecLevel?: GlobalOptionType["isSpecLevel"];
  isInteriorScheme?: GlobalOptionType["isInteriorScheme"];
  isExteriorScheme?: GlobalOptionType["isExteriorScheme"];
  isPlanPackage?: GlobalOptionType["isPlanPackage"];
  isInterior?: GlobalOptionType["isInterior"];
  isFloorPlan?: GlobalOptionType["isFloorPlan"];
  tags?: Array<GlobalOptionTag | GlobalOptionTagOptions>;
  globalOptionsCount?: GlobalOptionType["globalOptionsCount"];
  allowsLocations?: GlobalOptionType["allowsLocations"];
  order?: GlobalOptionType["order"];
  forDesignInterior?: GlobalOptionType["forDesignInterior"];
  forDesignExterior?: GlobalOptionType["forDesignExterior"];
  forDesignUpgrade?: GlobalOptionType["forDesignUpgrade"];
  forDesignPackage?: GlobalOptionType["forDesignPackage"];
  forExteriors?: GlobalOptionType["forExteriors"];
  globalOptions?: Array<GlobalOption | GlobalOptionOptions>;
  isAddOnV2?: GlobalOptionType["isAddOnV2"];
  isStructuralV2?: GlobalOptionType["isStructuralV2"];
  isCatalogV2?: GlobalOptionType["isCatalogV2"];
  isProductOptionV2?: GlobalOptionType["isProductOptionV2"];
  isPackageOptionV2?: GlobalOptionType["isPackageOptionV2"];
  version?: GlobalOptionType["version"];
}

export function newGlobalOptionType(
  options: GlobalOptionTypeOptions = {},
  cache: Record<string, any> = {},
): GlobalOptionType {
  const o = (options.__typename ? options : cache["GlobalOptionType"] = {}) as GlobalOptionType;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalOptionType";
  o.id = options.id ?? nextFactoryId("GlobalOptionType");
  o.name = options.name ?? "name";
  o.description = options.description ?? null;
  o.changesProgramData = options.changesProgramData ?? null;
  o.changesSpecsAndSelections = options.changesSpecsAndSelections ?? null;
  o.status = options.status ?? GlobalOptionTypeStatus.Active;
  o.statusDetail = enumOrDetailOfGlobalOptionTypeStatus(options.statusDetail);
  o.isElevation = options.isElevation ?? false;
  o.isExteriorPalette = options.isExteriorPalette ?? false;
  o.isSpecLevel = options.isSpecLevel ?? false;
  o.isInteriorScheme = options.isInteriorScheme ?? false;
  o.isExteriorScheme = options.isExteriorScheme ?? false;
  o.isPlanPackage = options.isPlanPackage ?? false;
  o.isInterior = options.isInterior ?? false;
  o.isFloorPlan = options.isFloorPlan ?? false;
  o.tags = (options.tags ?? []).map((i) => maybeNew("GlobalOptionTag", i, cache, options.hasOwnProperty("tags")));
  o.globalOptionsCount = options.globalOptionsCount ?? 0;
  o.allowsLocations = options.allowsLocations ?? false;
  o.order = options.order ?? 0;
  o.forDesignInterior = options.forDesignInterior ?? false;
  o.forDesignExterior = options.forDesignExterior ?? false;
  o.forDesignUpgrade = options.forDesignUpgrade ?? false;
  o.forDesignPackage = options.forDesignPackage ?? false;
  o.forExteriors = options.forExteriors ?? false;
  o.globalOptions = (options.globalOptions ?? []).map((i) =>
    maybeNew("GlobalOption", i, cache, options.hasOwnProperty("globalOptions"))
  );
  o.isAddOnV2 = options.isAddOnV2 ?? null;
  o.isStructuralV2 = options.isStructuralV2 ?? null;
  o.isCatalogV2 = options.isCatalogV2 ?? null;
  o.isProductOptionV2 = options.isProductOptionV2 ?? false;
  o.isPackageOptionV2 = options.isPackageOptionV2 ?? false;
  o.version = options.version ?? 0;
  return o;
}

factories["GlobalOptionType"] = newGlobalOptionType;

export interface SaveGlobalOptionTypesResultOptions {
  __typename?: "SaveGlobalOptionTypesResult";
  globalOptionTypes?: Array<GlobalOptionType | GlobalOptionTypeOptions>;
}

export function newSaveGlobalOptionTypesResult(
  options: SaveGlobalOptionTypesResultOptions = {},
  cache: Record<string, any> = {},
): SaveGlobalOptionTypesResult {
  const o = (options.__typename ? options : cache["SaveGlobalOptionTypesResult"] = {}) as SaveGlobalOptionTypesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveGlobalOptionTypesResult";
  o.globalOptionTypes = (options.globalOptionTypes ?? []).map((i) =>
    maybeNew("GlobalOptionType", i, cache, options.hasOwnProperty("globalOptionTypes"))
  );
  return o;
}

factories["SaveGlobalOptionTypesResult"] = newSaveGlobalOptionTypesResult;

export interface GlobalPhaseOptions {
  __typename?: "GlobalPhase";
  id?: GlobalPhase["id"];
  active?: GlobalPhase["active"];
  cmsId?: GlobalPhase["cmsId"];
  name?: GlobalPhase["name"];
  stage?: GlobalPhase["stage"];
  stageDetail?: StageDetailOptions | Stage;
  displayOrder?: GlobalPhase["displayOrder"];
  globalSubPhases?: Array<GlobalSubPhase | GlobalSubPhaseOptions>;
  globalTasks?: Array<GlobalTask | GlobalTaskOptions>;
}

export function newGlobalPhase(options: GlobalPhaseOptions = {}, cache: Record<string, any> = {}): GlobalPhase {
  const o = (options.__typename ? options : cache["GlobalPhase"] = {}) as GlobalPhase;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalPhase";
  o.id = options.id ?? nextFactoryId("GlobalPhase");
  o.active = options.active ?? false;
  o.cmsId = options.cmsId ?? null;
  o.name = options.name ?? "name";
  o.stage = options.stage ?? Stage.PreConPlanning;
  o.stageDetail = enumOrDetailOfStage(options.stageDetail);
  o.displayOrder = options.displayOrder ?? null;
  o.globalSubPhases = (options.globalSubPhases ?? []).map((i) =>
    maybeNew("GlobalSubPhase", i, cache, options.hasOwnProperty("globalSubPhases"))
  );
  o.globalTasks = (options.globalTasks ?? []).map((i) =>
    maybeNew("GlobalTask", i, cache, options.hasOwnProperty("globalTasks"))
  );
  return o;
}

factories["GlobalPhase"] = newGlobalPhase;

export interface SaveGlobalPhasesResultOptions {
  __typename?: "SaveGlobalPhasesResult";
  globalPhases?: Array<GlobalPhase | GlobalPhaseOptions>;
}

export function newSaveGlobalPhasesResult(
  options: SaveGlobalPhasesResultOptions = {},
  cache: Record<string, any> = {},
): SaveGlobalPhasesResult {
  const o = (options.__typename ? options : cache["SaveGlobalPhasesResult"] = {}) as SaveGlobalPhasesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveGlobalPhasesResult";
  o.globalPhases = (options.globalPhases ?? []).map((i) =>
    maybeNew("GlobalPhase", i, cache, options.hasOwnProperty("globalPhases"))
  );
  return o;
}

factories["SaveGlobalPhasesResult"] = newSaveGlobalPhasesResult;

export interface GlobalPlanAllowanceOptions {
  __typename?: "GlobalPlanAllowance";
  id?: GlobalPlanAllowance["id"];
  createdAt?: GlobalPlanAllowance["createdAt"];
  updatedAt?: GlobalPlanAllowance["updatedAt"];
  constraintItem?: GlobalPlanConstraintItem | GlobalPlanConstraintItemOptions;
  task?: GlobalPlanTask | GlobalPlanTaskOptions;
}

export function newGlobalPlanAllowance(
  options: GlobalPlanAllowanceOptions = {},
  cache: Record<string, any> = {},
): GlobalPlanAllowance {
  const o = (options.__typename ? options : cache["GlobalPlanAllowance"] = {}) as GlobalPlanAllowance;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalPlanAllowance";
  o.id = options.id ?? nextFactoryId("GlobalPlanAllowance");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.constraintItem = maybeNew(
    "GlobalPlanConstraintItem",
    options.constraintItem,
    cache,
    options.hasOwnProperty("constraintItem"),
  );
  o.task = maybeNew("GlobalPlanTask", options.task, cache, options.hasOwnProperty("task"));
  return o;
}

factories["GlobalPlanAllowance"] = newGlobalPlanAllowance;

export interface GlobalPlanConstraintOptions {
  __typename?: "GlobalPlanConstraint";
  id?: GlobalPlanConstraint["id"];
  createdAt?: GlobalPlanConstraint["createdAt"];
  updatedAt?: GlobalPlanConstraint["updatedAt"];
  task?: GlobalPlanTask | GlobalPlanTaskOptions;
  constraintItem?: GlobalPlanConstraintItem | GlobalPlanConstraintItemOptions;
}

export function newGlobalPlanConstraint(
  options: GlobalPlanConstraintOptions = {},
  cache: Record<string, any> = {},
): GlobalPlanConstraint {
  const o = (options.__typename ? options : cache["GlobalPlanConstraint"] = {}) as GlobalPlanConstraint;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalPlanConstraint";
  o.id = options.id ?? nextFactoryId("GlobalPlanConstraint");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.task = maybeNew("GlobalPlanTask", options.task, cache, options.hasOwnProperty("task"));
  o.constraintItem = maybeNew(
    "GlobalPlanConstraintItem",
    options.constraintItem,
    cache,
    options.hasOwnProperty("constraintItem"),
  );
  return o;
}

factories["GlobalPlanConstraint"] = newGlobalPlanConstraint;

export interface GlobalPlanConstraintItemOptions {
  __typename?: "GlobalPlanConstraintItem";
  id?: GlobalPlanConstraintItem["id"];
  name?: GlobalPlanConstraintItem["name"];
  createdAt?: GlobalPlanConstraintItem["createdAt"];
  updatedAt?: GlobalPlanConstraintItem["updatedAt"];
  allowances?: Array<GlobalPlanAllowance | GlobalPlanAllowanceOptions>;
  constraints?: Array<GlobalPlanConstraint | GlobalPlanConstraintOptions>;
  numberOfTimesUsed?: GlobalPlanConstraintItem["numberOfTimesUsed"];
  constrainedPlanTasks?: Array<PlanTask | PlanTaskOptions>;
  allowingPlanTasks?: Array<PlanTask | PlanTaskOptions>;
  lagInDays?: GlobalPlanConstraintItem["lagInDays"];
  deletedAt?: GlobalPlanConstraintItem["deletedAt"];
}

export function newGlobalPlanConstraintItem(
  options: GlobalPlanConstraintItemOptions = {},
  cache: Record<string, any> = {},
): GlobalPlanConstraintItem {
  const o = (options.__typename ? options : cache["GlobalPlanConstraintItem"] = {}) as GlobalPlanConstraintItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalPlanConstraintItem";
  o.id = options.id ?? nextFactoryId("GlobalPlanConstraintItem");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.allowances = (options.allowances ?? []).map((i) =>
    maybeNew("GlobalPlanAllowance", i, cache, options.hasOwnProperty("allowances"))
  );
  o.constraints = (options.constraints ?? []).map((i) =>
    maybeNew("GlobalPlanConstraint", i, cache, options.hasOwnProperty("constraints"))
  );
  o.numberOfTimesUsed = options.numberOfTimesUsed ?? 0;
  o.constrainedPlanTasks = (options.constrainedPlanTasks ?? []).map((i) =>
    maybeNew("PlanTask", i, cache, options.hasOwnProperty("constrainedPlanTasks"))
  );
  o.allowingPlanTasks = (options.allowingPlanTasks ?? []).map((i) =>
    maybeNew("PlanTask", i, cache, options.hasOwnProperty("allowingPlanTasks"))
  );
  o.lagInDays = options.lagInDays ?? 0;
  o.deletedAt = options.deletedAt ?? null;
  return o;
}

factories["GlobalPlanConstraintItem"] = newGlobalPlanConstraintItem;

export interface SaveGlobalPlanConstraintItemResultOptions {
  __typename?: "SaveGlobalPlanConstraintItemResult";
  globalPlanConstraintItem?: GlobalPlanConstraintItem | GlobalPlanConstraintItemOptions;
}

export function newSaveGlobalPlanConstraintItemResult(
  options: SaveGlobalPlanConstraintItemResultOptions = {},
  cache: Record<string, any> = {},
): SaveGlobalPlanConstraintItemResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveGlobalPlanConstraintItemResult"] = {}) as SaveGlobalPlanConstraintItemResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveGlobalPlanConstraintItemResult";
  o.globalPlanConstraintItem = maybeNew(
    "GlobalPlanConstraintItem",
    options.globalPlanConstraintItem,
    cache,
    options.hasOwnProperty("globalPlanConstraintItem"),
  );
  return o;
}

factories["SaveGlobalPlanConstraintItemResult"] = newSaveGlobalPlanConstraintItemResult;

export interface SaveGlobalPlanConstraintItemsResultOptions {
  __typename?: "SaveGlobalPlanConstraintItemsResult";
  globalPlanConstraintItems?: Array<GlobalPlanConstraintItem | GlobalPlanConstraintItemOptions>;
}

export function newSaveGlobalPlanConstraintItemsResult(
  options: SaveGlobalPlanConstraintItemsResultOptions = {},
  cache: Record<string, any> = {},
): SaveGlobalPlanConstraintItemsResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveGlobalPlanConstraintItemsResult"] = {}) as SaveGlobalPlanConstraintItemsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveGlobalPlanConstraintItemsResult";
  o.globalPlanConstraintItems = (options.globalPlanConstraintItems ?? []).map((i) =>
    maybeNew("GlobalPlanConstraintItem", i, cache, options.hasOwnProperty("globalPlanConstraintItems"))
  );
  return o;
}

factories["SaveGlobalPlanConstraintItemsResult"] = newSaveGlobalPlanConstraintItemsResult;

export interface GlobalPlanMilestoneOptions {
  __typename?: "GlobalPlanMilestone";
  id?: GlobalPlanMilestone["id"];
  name?: GlobalPlanMilestone["name"];
  isDefault?: GlobalPlanMilestone["isDefault"];
  archived?: GlobalPlanMilestone["archived"];
  createdAt?: GlobalPlanMilestone["createdAt"];
  updatedAt?: GlobalPlanMilestone["updatedAt"];
  planMilestones?: Array<PlanMilestone | PlanMilestoneOptions>;
  groups?: Array<GlobalPlanMilestoneGroup | GlobalPlanMilestoneGroupOptions>;
  constraints?: Array<GlobalPlanConstraintItem | GlobalPlanConstraintItemOptions>;
  systemPlanMilestone?: SystemPlanMilestoneDetailOptions | SystemPlanMilestone | null;
  isHomeownerVisible?: GlobalPlanMilestone["isHomeownerVisible"];
  homeownerName?: GlobalPlanMilestone["homeownerName"];
  homeownerDescription?: GlobalPlanMilestone["homeownerDescription"];
  homeownerIcon?: Asset | AssetOptions | null;
  description?: GlobalPlanMilestone["description"];
}

export function newGlobalPlanMilestone(
  options: GlobalPlanMilestoneOptions = {},
  cache: Record<string, any> = {},
): GlobalPlanMilestone {
  const o = (options.__typename ? options : cache["GlobalPlanMilestone"] = {}) as GlobalPlanMilestone;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalPlanMilestone";
  o.id = options.id ?? nextFactoryId("GlobalPlanMilestone");
  o.name = options.name ?? "name";
  o.isDefault = options.isDefault ?? false;
  o.archived = options.archived ?? false;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.planMilestones = (options.planMilestones ?? []).map((i) =>
    maybeNew("PlanMilestone", i, cache, options.hasOwnProperty("planMilestones"))
  );
  o.groups = (options.groups ?? []).map((i) =>
    maybeNew("GlobalPlanMilestoneGroup", i, cache, options.hasOwnProperty("groups"))
  );
  o.constraints = (options.constraints ?? []).map((i) =>
    maybeNew("GlobalPlanConstraintItem", i, cache, options.hasOwnProperty("constraints"))
  );
  o.systemPlanMilestone = enumOrDetailOrNullOfSystemPlanMilestone(options.systemPlanMilestone);
  o.isHomeownerVisible = options.isHomeownerVisible ?? false;
  o.homeownerName = options.homeownerName ?? null;
  o.homeownerDescription = options.homeownerDescription ?? null;
  o.homeownerIcon = maybeNewOrNull("Asset", options.homeownerIcon, cache);
  o.description = options.description ?? null;
  return o;
}

factories["GlobalPlanMilestone"] = newGlobalPlanMilestone;

export interface SaveGlobalPlanMilestoneResultOptions {
  __typename?: "SaveGlobalPlanMilestoneResult";
  globalPlanMilestone?: GlobalPlanMilestone | GlobalPlanMilestoneOptions;
}

export function newSaveGlobalPlanMilestoneResult(
  options: SaveGlobalPlanMilestoneResultOptions = {},
  cache: Record<string, any> = {},
): SaveGlobalPlanMilestoneResult {
  const o =
    (options.__typename ? options : cache["SaveGlobalPlanMilestoneResult"] = {}) as SaveGlobalPlanMilestoneResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveGlobalPlanMilestoneResult";
  o.globalPlanMilestone = maybeNew(
    "GlobalPlanMilestone",
    options.globalPlanMilestone,
    cache,
    options.hasOwnProperty("globalPlanMilestone"),
  );
  return o;
}

factories["SaveGlobalPlanMilestoneResult"] = newSaveGlobalPlanMilestoneResult;

export interface GlobalPlanMilestonesPageResultOptions {
  __typename?: "GlobalPlanMilestonesPageResult";
  entities?: Array<GlobalPlanMilestone | GlobalPlanMilestoneOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newGlobalPlanMilestonesPageResult(
  options: GlobalPlanMilestonesPageResultOptions = {},
  cache: Record<string, any> = {},
): GlobalPlanMilestonesPageResult {
  const o =
    (options.__typename ? options : cache["GlobalPlanMilestonesPageResult"] = {}) as GlobalPlanMilestonesPageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalPlanMilestonesPageResult";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("GlobalPlanMilestone", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["GlobalPlanMilestonesPageResult"] = newGlobalPlanMilestonesPageResult;

export interface SaveGlobalPlanMilestonesResultOptions {
  __typename?: "SaveGlobalPlanMilestonesResult";
  globalPlanMilestones?: Array<GlobalPlanMilestone | GlobalPlanMilestoneOptions>;
}

export function newSaveGlobalPlanMilestonesResult(
  options: SaveGlobalPlanMilestonesResultOptions = {},
  cache: Record<string, any> = {},
): SaveGlobalPlanMilestonesResult {
  const o =
    (options.__typename ? options : cache["SaveGlobalPlanMilestonesResult"] = {}) as SaveGlobalPlanMilestonesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveGlobalPlanMilestonesResult";
  o.globalPlanMilestones = (options.globalPlanMilestones ?? []).map((i) =>
    maybeNew("GlobalPlanMilestone", i, cache, options.hasOwnProperty("globalPlanMilestones"))
  );
  return o;
}

factories["SaveGlobalPlanMilestonesResult"] = newSaveGlobalPlanMilestonesResult;

export interface GlobalPlanMilestoneGroupOptions {
  __typename?: "GlobalPlanMilestoneGroup";
  id?: GlobalPlanMilestoneGroup["id"];
  name?: GlobalPlanMilestoneGroup["name"];
  createdAt?: GlobalPlanMilestoneGroup["createdAt"];
  updatedAt?: GlobalPlanMilestoneGroup["updatedAt"];
  businessFunctionType?: BusinessFunctionTypeDetailOptions | BusinessFunctionType;
  globalPlanMilestones?: Array<GlobalPlanMilestone | GlobalPlanMilestoneOptions>;
}

export function newGlobalPlanMilestoneGroup(
  options: GlobalPlanMilestoneGroupOptions = {},
  cache: Record<string, any> = {},
): GlobalPlanMilestoneGroup {
  const o = (options.__typename ? options : cache["GlobalPlanMilestoneGroup"] = {}) as GlobalPlanMilestoneGroup;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalPlanMilestoneGroup";
  o.id = options.id ?? nextFactoryId("GlobalPlanMilestoneGroup");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.businessFunctionType = enumOrDetailOfBusinessFunctionType(options.businessFunctionType);
  o.globalPlanMilestones = (options.globalPlanMilestones ?? []).map((i) =>
    maybeNew("GlobalPlanMilestone", i, cache, options.hasOwnProperty("globalPlanMilestones"))
  );
  return o;
}

factories["GlobalPlanMilestoneGroup"] = newGlobalPlanMilestoneGroup;

export interface SaveGlobalPlanMilestoneGroupResultOptions {
  __typename?: "SaveGlobalPlanMilestoneGroupResult";
  globalPlanMilestoneGroup?: GlobalPlanMilestoneGroup | GlobalPlanMilestoneGroupOptions;
}

export function newSaveGlobalPlanMilestoneGroupResult(
  options: SaveGlobalPlanMilestoneGroupResultOptions = {},
  cache: Record<string, any> = {},
): SaveGlobalPlanMilestoneGroupResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveGlobalPlanMilestoneGroupResult"] = {}) as SaveGlobalPlanMilestoneGroupResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveGlobalPlanMilestoneGroupResult";
  o.globalPlanMilestoneGroup = maybeNew(
    "GlobalPlanMilestoneGroup",
    options.globalPlanMilestoneGroup,
    cache,
    options.hasOwnProperty("globalPlanMilestoneGroup"),
  );
  return o;
}

factories["SaveGlobalPlanMilestoneGroupResult"] = newSaveGlobalPlanMilestoneGroupResult;

export interface GlobalPlanStageOptions {
  __typename?: "GlobalPlanStage";
  id?: GlobalPlanStage["id"];
  name?: GlobalPlanStage["name"];
  createdAt?: GlobalPlanStage["createdAt"];
  updatedAt?: GlobalPlanStage["updatedAt"];
  globalPlanTasks?: Array<GlobalPlanTask | GlobalPlanTaskOptions>;
  globalPlanTaskVariants?: Array<GlobalPlanTaskVariant | GlobalPlanTaskVariantOptions>;
  variants?: Array<GlobalPlanStageVariant | GlobalPlanStageVariantOptions>;
  orderForProject?: GlobalPlanStage["orderForProject"];
}

export function newGlobalPlanStage(
  options: GlobalPlanStageOptions = {},
  cache: Record<string, any> = {},
): GlobalPlanStage {
  const o = (options.__typename ? options : cache["GlobalPlanStage"] = {}) as GlobalPlanStage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalPlanStage";
  o.id = options.id ?? nextFactoryId("GlobalPlanStage");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.globalPlanTasks = (options.globalPlanTasks ?? []).map((i) =>
    maybeNew("GlobalPlanTask", i, cache, options.hasOwnProperty("globalPlanTasks"))
  );
  o.globalPlanTaskVariants = (options.globalPlanTaskVariants ?? []).map((i) =>
    maybeNew("GlobalPlanTaskVariant", i, cache, options.hasOwnProperty("globalPlanTaskVariants"))
  );
  o.variants = (options.variants ?? []).map((i) =>
    maybeNew("GlobalPlanStageVariant", i, cache, options.hasOwnProperty("variants"))
  );
  o.orderForProject = options.orderForProject ?? null;
  return o;
}

factories["GlobalPlanStage"] = newGlobalPlanStage;

export interface SaveGlobalPlanStageResultOptions {
  __typename?: "SaveGlobalPlanStageResult";
  globalPlanStage?: GlobalPlanStage | GlobalPlanStageOptions;
}

export function newSaveGlobalPlanStageResult(
  options: SaveGlobalPlanStageResultOptions = {},
  cache: Record<string, any> = {},
): SaveGlobalPlanStageResult {
  const o = (options.__typename ? options : cache["SaveGlobalPlanStageResult"] = {}) as SaveGlobalPlanStageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveGlobalPlanStageResult";
  o.globalPlanStage = maybeNew(
    "GlobalPlanStage",
    options.globalPlanStage,
    cache,
    options.hasOwnProperty("globalPlanStage"),
  );
  return o;
}

factories["SaveGlobalPlanStageResult"] = newSaveGlobalPlanStageResult;

export interface GlobalPlanStageVariantOptions {
  __typename?: "GlobalPlanStageVariant";
  id?: GlobalPlanStageVariant["id"];
  order?: GlobalPlanStageVariant["order"];
  createdAt?: GlobalPlanStageVariant["createdAt"];
  updatedAt?: GlobalPlanStageVariant["updatedAt"];
  globalPlanStage?: GlobalPlanStage | GlobalPlanStageOptions;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
}

export function newGlobalPlanStageVariant(
  options: GlobalPlanStageVariantOptions = {},
  cache: Record<string, any> = {},
): GlobalPlanStageVariant {
  const o = (options.__typename ? options : cache["GlobalPlanStageVariant"] = {}) as GlobalPlanStageVariant;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalPlanStageVariant";
  o.id = options.id ?? nextFactoryId("GlobalPlanStageVariant");
  o.order = options.order ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.globalPlanStage = maybeNew(
    "GlobalPlanStage",
    options.globalPlanStage,
    cache,
    options.hasOwnProperty("globalPlanStage"),
  );
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  return o;
}

factories["GlobalPlanStageVariant"] = newGlobalPlanStageVariant;

export interface SaveGlobalPlanStageVariantsResultOptions {
  __typename?: "SaveGlobalPlanStageVariantsResult";
  globalPlanStageVariants?: Array<GlobalPlanStageVariant | GlobalPlanStageVariantOptions>;
}

export function newSaveGlobalPlanStageVariantsResult(
  options: SaveGlobalPlanStageVariantsResultOptions = {},
  cache: Record<string, any> = {},
): SaveGlobalPlanStageVariantsResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveGlobalPlanStageVariantsResult"] = {}) as SaveGlobalPlanStageVariantsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveGlobalPlanStageVariantsResult";
  o.globalPlanStageVariants = (options.globalPlanStageVariants ?? []).map((i) =>
    maybeNew("GlobalPlanStageVariant", i, cache, options.hasOwnProperty("globalPlanStageVariants"))
  );
  return o;
}

factories["SaveGlobalPlanStageVariantsResult"] = newSaveGlobalPlanStageVariantsResult;

export interface GlobalPlanTagOptions {
  __typename?: "GlobalPlanTag";
  id?: GlobalPlanTag["id"];
  name?: GlobalPlanTag["name"];
  createdAt?: GlobalPlanTag["createdAt"];
  updatedAt?: GlobalPlanTag["updatedAt"];
  tasks?: Array<GlobalPlanTask | GlobalPlanTaskOptions>;
  isHiddenFromSchedule?: GlobalPlanTag["isHiddenFromSchedule"];
}

export function newGlobalPlanTag(options: GlobalPlanTagOptions = {}, cache: Record<string, any> = {}): GlobalPlanTag {
  const o = (options.__typename ? options : cache["GlobalPlanTag"] = {}) as GlobalPlanTag;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalPlanTag";
  o.id = options.id ?? nextFactoryId("GlobalPlanTag");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.tasks = (options.tasks ?? []).map((i) => maybeNew("GlobalPlanTask", i, cache, options.hasOwnProperty("tasks")));
  o.isHiddenFromSchedule = options.isHiddenFromSchedule ?? false;
  return o;
}

factories["GlobalPlanTag"] = newGlobalPlanTag;

export interface SaveGlobalPlanTagResultOptions {
  __typename?: "SaveGlobalPlanTagResult";
  globalPlanTag?: GlobalPlanTag | GlobalPlanTagOptions;
}

export function newSaveGlobalPlanTagResult(
  options: SaveGlobalPlanTagResultOptions = {},
  cache: Record<string, any> = {},
): SaveGlobalPlanTagResult {
  const o = (options.__typename ? options : cache["SaveGlobalPlanTagResult"] = {}) as SaveGlobalPlanTagResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveGlobalPlanTagResult";
  o.globalPlanTag = maybeNew("GlobalPlanTag", options.globalPlanTag, cache, options.hasOwnProperty("globalPlanTag"));
  return o;
}

factories["SaveGlobalPlanTagResult"] = newSaveGlobalPlanTagResult;

export interface BulkSaveGlobalPlanTagsResultOptions {
  __typename?: "BulkSaveGlobalPlanTagsResult";
  globalPlanTags?: Array<GlobalPlanTag | GlobalPlanTagOptions>;
}

export function newBulkSaveGlobalPlanTagsResult(
  options: BulkSaveGlobalPlanTagsResultOptions = {},
  cache: Record<string, any> = {},
): BulkSaveGlobalPlanTagsResult {
  const o = (options.__typename ? options : cache["BulkSaveGlobalPlanTagsResult"] = {}) as BulkSaveGlobalPlanTagsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BulkSaveGlobalPlanTagsResult";
  o.globalPlanTags = (options.globalPlanTags ?? []).map((i) =>
    maybeNew("GlobalPlanTag", i, cache, options.hasOwnProperty("globalPlanTags"))
  );
  return o;
}

factories["BulkSaveGlobalPlanTagsResult"] = newBulkSaveGlobalPlanTagsResult;

export interface GlobalPlanTaskOptions {
  __typename?: "GlobalPlanTask";
  id?: GlobalPlanTask["id"];
  name?: GlobalPlanTask["name"];
  nameForEntity?: GlobalPlanTask["nameForEntity"];
  externalName?: GlobalPlanTask["externalName"];
  description?: GlobalPlanTask["description"];
  archived?: GlobalPlanTask["archived"];
  optimisticDurationInDays?: GlobalPlanTask["optimisticDurationInDays"];
  expectedDurationInDays?: GlobalPlanTask["expectedDurationInDays"];
  pessimisticDurationInDays?: GlobalPlanTask["pessimisticDurationInDays"];
  createdAt?: GlobalPlanTask["createdAt"];
  updatedAt?: GlobalPlanTask["updatedAt"];
  businessFunctionType?: BusinessFunctionTypeDetailOptions | BusinessFunctionType;
  projectRole?: ProjectRoleDetailOptions | ProjectRole | null;
  tradeCategory?: TradeCategory | TradeCategoryOptions | null;
  allowances?: Array<GlobalPlanAllowance | GlobalPlanAllowanceOptions>;
  constraints?: Array<GlobalPlanConstraint | GlobalPlanConstraintOptions>;
  tags?: Array<GlobalPlanTag | GlobalPlanTagOptions>;
  scopes?: Array<GlobalPlanTaskScope | GlobalPlanTaskScopeOptions>;
  applyToAllSchedules?: GlobalPlanTask["applyToAllSchedules"];
  budgetItem?: Item | ItemOptions;
  itemPlanTaskMappings?: Array<ItemPlanTaskMapping | ItemPlanTaskMappingOptions>;
  planTasks?: Array<PlanTask | PlanTaskOptions>;
  numberOfTimesUsed?: GlobalPlanTask["numberOfTimesUsed"];
  checklistItems?: Array<GlobalPlanTaskChecklistItem | GlobalPlanTaskChecklistItemOptions>;
  globalRequiredTaskDocuments?: Array<GlobalRequiredTaskDocument | GlobalRequiredTaskDocumentOptions>;
  canEditBudgetItem?: PotentialOperation2 | PotentialOperation2Options;
  bidContractRevisionDraws?: Array<BidContractRevisionDraw | BidContractRevisionDrawOptions>;
  stage?: GlobalPlanStage | GlobalPlanStageOptions | null;
  variants?: Array<GlobalPlanTaskVariant | GlobalPlanTaskVariantOptions>;
  drops?: Array<Drop | DropOptions>;
  parent?: GlobalPlanTask | GlobalPlanTaskOptions | null;
  children?: Array<GlobalPlanTask | GlobalPlanTaskOptions>;
}

export function newGlobalPlanTask(
  options: GlobalPlanTaskOptions = {},
  cache: Record<string, any> = {},
): GlobalPlanTask {
  const o = (options.__typename ? options : cache["GlobalPlanTask"] = {}) as GlobalPlanTask;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalPlanTask";
  o.id = options.id ?? nextFactoryId("GlobalPlanTask");
  o.name = options.name ?? "name";
  o.nameForEntity = options.nameForEntity ?? "nameForEntity";
  o.externalName = options.externalName ?? null;
  o.description = options.description ?? "description";
  o.archived = options.archived ?? false;
  o.optimisticDurationInDays = options.optimisticDurationInDays ?? 0;
  o.expectedDurationInDays = options.expectedDurationInDays ?? 0;
  o.pessimisticDurationInDays = options.pessimisticDurationInDays ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.businessFunctionType = enumOrDetailOfBusinessFunctionType(options.businessFunctionType);
  o.projectRole = enumOrDetailOrNullOfProjectRole(options.projectRole);
  o.tradeCategory = maybeNewOrNull("TradeCategory", options.tradeCategory, cache);
  o.allowances = (options.allowances ?? []).map((i) =>
    maybeNew("GlobalPlanAllowance", i, cache, options.hasOwnProperty("allowances"))
  );
  o.constraints = (options.constraints ?? []).map((i) =>
    maybeNew("GlobalPlanConstraint", i, cache, options.hasOwnProperty("constraints"))
  );
  o.tags = (options.tags ?? []).map((i) => maybeNew("GlobalPlanTag", i, cache, options.hasOwnProperty("tags")));
  o.scopes = (options.scopes ?? []).map((i) =>
    maybeNew("GlobalPlanTaskScope", i, cache, options.hasOwnProperty("scopes"))
  );
  o.applyToAllSchedules = options.applyToAllSchedules ?? false;
  o.budgetItem = maybeNew("Item", options.budgetItem, cache, options.hasOwnProperty("budgetItem"));
  o.itemPlanTaskMappings = (options.itemPlanTaskMappings ?? []).map((i) =>
    maybeNew("ItemPlanTaskMapping", i, cache, options.hasOwnProperty("itemPlanTaskMappings"))
  );
  o.planTasks = (options.planTasks ?? []).map((i) =>
    maybeNew("PlanTask", i, cache, options.hasOwnProperty("planTasks"))
  );
  o.numberOfTimesUsed = options.numberOfTimesUsed ?? 0;
  o.checklistItems = (options.checklistItems ?? []).map((i) =>
    maybeNew("GlobalPlanTaskChecklistItem", i, cache, options.hasOwnProperty("checklistItems"))
  );
  o.globalRequiredTaskDocuments = (options.globalRequiredTaskDocuments ?? []).map((i) =>
    maybeNew("GlobalRequiredTaskDocument", i, cache, options.hasOwnProperty("globalRequiredTaskDocuments"))
  );
  o.canEditBudgetItem = maybeNew(
    "PotentialOperation2",
    options.canEditBudgetItem,
    cache,
    options.hasOwnProperty("canEditBudgetItem"),
  );
  o.bidContractRevisionDraws = (options.bidContractRevisionDraws ?? []).map((i) =>
    maybeNew("BidContractRevisionDraw", i, cache, options.hasOwnProperty("bidContractRevisionDraws"))
  );
  o.stage = maybeNewOrNull("GlobalPlanStage", options.stage, cache);
  o.variants = (options.variants ?? []).map((i) =>
    maybeNew("GlobalPlanTaskVariant", i, cache, options.hasOwnProperty("variants"))
  );
  o.drops = (options.drops ?? []).map((i) => maybeNew("Drop", i, cache, options.hasOwnProperty("drops")));
  o.parent = maybeNewOrNull("GlobalPlanTask", options.parent, cache);
  o.children = (options.children ?? []).map((i) =>
    maybeNew("GlobalPlanTask", i, cache, options.hasOwnProperty("children"))
  );
  return o;
}

factories["GlobalPlanTask"] = newGlobalPlanTask;

export interface SaveGlobalPlanTaskResultOptions {
  __typename?: "SaveGlobalPlanTaskResult";
  globalPlanTask?: GlobalPlanTask | GlobalPlanTaskOptions;
}

export function newSaveGlobalPlanTaskResult(
  options: SaveGlobalPlanTaskResultOptions = {},
  cache: Record<string, any> = {},
): SaveGlobalPlanTaskResult {
  const o = (options.__typename ? options : cache["SaveGlobalPlanTaskResult"] = {}) as SaveGlobalPlanTaskResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveGlobalPlanTaskResult";
  o.globalPlanTask = maybeNew(
    "GlobalPlanTask",
    options.globalPlanTask,
    cache,
    options.hasOwnProperty("globalPlanTask"),
  );
  return o;
}

factories["SaveGlobalPlanTaskResult"] = newSaveGlobalPlanTaskResult;

export interface SaveGlobalPlanTasksResultOptions {
  __typename?: "SaveGlobalPlanTasksResult";
  globalPlanTasks?: Array<GlobalPlanTask | GlobalPlanTaskOptions>;
}

export function newSaveGlobalPlanTasksResult(
  options: SaveGlobalPlanTasksResultOptions = {},
  cache: Record<string, any> = {},
): SaveGlobalPlanTasksResult {
  const o = (options.__typename ? options : cache["SaveGlobalPlanTasksResult"] = {}) as SaveGlobalPlanTasksResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveGlobalPlanTasksResult";
  o.globalPlanTasks = (options.globalPlanTasks ?? []).map((i) =>
    maybeNew("GlobalPlanTask", i, cache, options.hasOwnProperty("globalPlanTasks"))
  );
  return o;
}

factories["SaveGlobalPlanTasksResult"] = newSaveGlobalPlanTasksResult;

export interface GlobalPlanTasksPageResultOptions {
  __typename?: "GlobalPlanTasksPageResult";
  entities?: Array<GlobalPlanTask | GlobalPlanTaskOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newGlobalPlanTasksPageResult(
  options: GlobalPlanTasksPageResultOptions = {},
  cache: Record<string, any> = {},
): GlobalPlanTasksPageResult {
  const o = (options.__typename ? options : cache["GlobalPlanTasksPageResult"] = {}) as GlobalPlanTasksPageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalPlanTasksPageResult";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("GlobalPlanTask", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["GlobalPlanTasksPageResult"] = newGlobalPlanTasksPageResult;

export interface GlobalPlanTaskChecklistItemOptions {
  __typename?: "GlobalPlanTaskChecklistItem";
  id?: GlobalPlanTaskChecklistItem["id"];
  name?: GlobalPlanTaskChecklistItem["name"];
  deletedAt?: GlobalPlanTaskChecklistItem["deletedAt"];
  createdAt?: GlobalPlanTaskChecklistItem["createdAt"];
  updatedAt?: GlobalPlanTaskChecklistItem["updatedAt"];
  globalPlanTask?: GlobalPlanTask | GlobalPlanTaskOptions;
}

export function newGlobalPlanTaskChecklistItem(
  options: GlobalPlanTaskChecklistItemOptions = {},
  cache: Record<string, any> = {},
): GlobalPlanTaskChecklistItem {
  const o = (options.__typename ? options : cache["GlobalPlanTaskChecklistItem"] = {}) as GlobalPlanTaskChecklistItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalPlanTaskChecklistItem";
  o.id = options.id ?? nextFactoryId("GlobalPlanTaskChecklistItem");
  o.name = options.name ?? "name";
  o.deletedAt = options.deletedAt ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.globalPlanTask = maybeNew(
    "GlobalPlanTask",
    options.globalPlanTask,
    cache,
    options.hasOwnProperty("globalPlanTask"),
  );
  return o;
}

factories["GlobalPlanTaskChecklistItem"] = newGlobalPlanTaskChecklistItem;

export interface GlobalPlanTaskScopeOptions {
  __typename?: "GlobalPlanTaskScope";
  id?: GlobalPlanTaskScope["id"];
  createdAt?: GlobalPlanTaskScope["createdAt"];
  updatedAt?: GlobalPlanTaskScope["updatedAt"];
  globalPlanTask?: GlobalPlanTask | GlobalPlanTaskOptions;
  target?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
}

export function newGlobalPlanTaskScope(
  options: GlobalPlanTaskScopeOptions = {},
  cache: Record<string, any> = {},
): GlobalPlanTaskScope {
  const o = (options.__typename ? options : cache["GlobalPlanTaskScope"] = {}) as GlobalPlanTaskScope;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalPlanTaskScope";
  o.id = options.id ?? nextFactoryId("GlobalPlanTaskScope");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.globalPlanTask = maybeNew(
    "GlobalPlanTask",
    options.globalPlanTask,
    cache,
    options.hasOwnProperty("globalPlanTask"),
  );
  o.target = maybeNew("Project", options.target, cache, options.hasOwnProperty("target"));
  return o;
}

factories["GlobalPlanTaskScope"] = newGlobalPlanTaskScope;

export interface GlobalPlanTaskVariantOptions {
  __typename?: "GlobalPlanTaskVariant";
  id?: GlobalPlanTaskVariant["id"];
  name?: GlobalPlanTaskVariant["name"];
  optimisticDurationInDays?: GlobalPlanTaskVariant["optimisticDurationInDays"];
  expectedDurationInDays?: GlobalPlanTaskVariant["expectedDurationInDays"];
  pessimisticDurationInDays?: GlobalPlanTaskVariant["pessimisticDurationInDays"];
  createdAt?: GlobalPlanTaskVariant["createdAt"];
  updatedAt?: GlobalPlanTaskVariant["updatedAt"];
  globalPlanTask?: GlobalPlanTask | GlobalPlanTaskOptions;
  allowances?: Array<GlobalPlanConstraintItem | GlobalPlanConstraintItemOptions>;
  constraints?: Array<GlobalPlanConstraintItem | GlobalPlanConstraintItemOptions>;
  stage?: GlobalPlanStage | GlobalPlanStageOptions | null;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
}

export function newGlobalPlanTaskVariant(
  options: GlobalPlanTaskVariantOptions = {},
  cache: Record<string, any> = {},
): GlobalPlanTaskVariant {
  const o = (options.__typename ? options : cache["GlobalPlanTaskVariant"] = {}) as GlobalPlanTaskVariant;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalPlanTaskVariant";
  o.id = options.id ?? nextFactoryId("GlobalPlanTaskVariant");
  o.name = options.name ?? null;
  o.optimisticDurationInDays = options.optimisticDurationInDays ?? null;
  o.expectedDurationInDays = options.expectedDurationInDays ?? null;
  o.pessimisticDurationInDays = options.pessimisticDurationInDays ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.globalPlanTask = maybeNew(
    "GlobalPlanTask",
    options.globalPlanTask,
    cache,
    options.hasOwnProperty("globalPlanTask"),
  );
  o.allowances = (options.allowances ?? []).map((i) =>
    maybeNew("GlobalPlanConstraintItem", i, cache, options.hasOwnProperty("allowances"))
  );
  o.constraints = (options.constraints ?? []).map((i) =>
    maybeNew("GlobalPlanConstraintItem", i, cache, options.hasOwnProperty("constraints"))
  );
  o.stage = maybeNewOrNull("GlobalPlanStage", options.stage, cache);
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  return o;
}

factories["GlobalPlanTaskVariant"] = newGlobalPlanTaskVariant;

export interface GlobalRequiredTaskDocumentOptions {
  __typename?: "GlobalRequiredTaskDocument";
  id?: GlobalRequiredTaskDocument["id"];
  name?: GlobalRequiredTaskDocument["name"];
  createdAt?: GlobalRequiredTaskDocument["createdAt"];
  updatedAt?: GlobalRequiredTaskDocument["updatedAt"];
  documentType?: DocumentTypeDetailOptions | DocumentType;
  watchers?: GlobalRequiredTaskDocument["watchers"];
  canEditDocumentType?: PotentialOperation2 | PotentialOperation2Options;
}

export function newGlobalRequiredTaskDocument(
  options: GlobalRequiredTaskDocumentOptions = {},
  cache: Record<string, any> = {},
): GlobalRequiredTaskDocument {
  const o = (options.__typename ? options : cache["GlobalRequiredTaskDocument"] = {}) as GlobalRequiredTaskDocument;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalRequiredTaskDocument";
  o.id = options.id ?? nextFactoryId("GlobalRequiredTaskDocument");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.documentType = enumOrDetailOfDocumentType(options.documentType);
  o.watchers = options.watchers ?? [];
  o.canEditDocumentType = maybeNew(
    "PotentialOperation2",
    options.canEditDocumentType,
    cache,
    options.hasOwnProperty("canEditDocumentType"),
  );
  return o;
}

factories["GlobalRequiredTaskDocument"] = newGlobalRequiredTaskDocument;

export interface SaveGlobalRequiredTaskDocumentResultOptions {
  __typename?: "SaveGlobalRequiredTaskDocumentResult";
  globalRequiredTaskDocument?: GlobalRequiredTaskDocument | GlobalRequiredTaskDocumentOptions;
}

export function newSaveGlobalRequiredTaskDocumentResult(
  options: SaveGlobalRequiredTaskDocumentResultOptions = {},
  cache: Record<string, any> = {},
): SaveGlobalRequiredTaskDocumentResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveGlobalRequiredTaskDocumentResult"] = {}) as SaveGlobalRequiredTaskDocumentResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveGlobalRequiredTaskDocumentResult";
  o.globalRequiredTaskDocument = maybeNew(
    "GlobalRequiredTaskDocument",
    options.globalRequiredTaskDocument,
    cache,
    options.hasOwnProperty("globalRequiredTaskDocument"),
  );
  return o;
}

factories["SaveGlobalRequiredTaskDocumentResult"] = newSaveGlobalRequiredTaskDocumentResult;

export interface GlobalSearchResultOptions {
  __typename?: "GlobalSearchResult";
  record?: GlobalSearchRecord | GlobalSearchRecordOptions;
}

export function newGlobalSearchResult(
  options: GlobalSearchResultOptions = {},
  cache: Record<string, any> = {},
): GlobalSearchResult {
  const o = (options.__typename ? options : cache["GlobalSearchResult"] = {}) as GlobalSearchResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalSearchResult";
  o.record = maybeNew("GlobalSearchRecord", options.record, cache, options.hasOwnProperty("record"));
  return o;
}

factories["GlobalSearchResult"] = newGlobalSearchResult;

export interface GlobalSearchRecordOptions {
  __typename?: "GlobalSearchRecord";
  id?: GlobalSearchRecord["id"];
  search?: GlobalSearchRecord["search"];
  parent?:
    | GlobalSearchRecordParent
    | BillOptions
    | RequireTypename<CommitmentOptions>
    | RequireTypename<CommitmentChangeOrderOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<DesignPackageOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<PlanPackageOptions>
    | RequireTypename<ProductOfferingOptions>
    | RequireTypename<RegionOptions>
    | RequireTypename<StandaloneProjectOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<TradePartnerOptions>;
}

export function newGlobalSearchRecord(
  options: GlobalSearchRecordOptions = {},
  cache: Record<string, any> = {},
): GlobalSearchRecord {
  const o = (options.__typename ? options : cache["GlobalSearchRecord"] = {}) as GlobalSearchRecord;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalSearchRecord";
  o.id = options.id ?? nextFactoryId("GlobalSearchRecord");
  o.search = options.search ?? null;
  o.parent = maybeNew(options.parent?.__typename ?? "Bill", options.parent, cache);
  return o;
}

factories["GlobalSearchRecord"] = newGlobalSearchRecord;

export interface GlobalSubPhaseOptions {
  __typename?: "GlobalSubPhase";
  id?: GlobalSubPhase["id"];
  name?: GlobalSubPhase["name"];
  globalPhase?: GlobalPhase | GlobalPhaseOptions;
  displayOrder?: GlobalSubPhase["displayOrder"];
  stage?: GlobalSubPhase["stage"];
  stageDetail?: StageDetailOptions | Stage;
  cmsId?: GlobalSubPhase["cmsId"];
}

export function newGlobalSubPhase(
  options: GlobalSubPhaseOptions = {},
  cache: Record<string, any> = {},
): GlobalSubPhase {
  const o = (options.__typename ? options : cache["GlobalSubPhase"] = {}) as GlobalSubPhase;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalSubPhase";
  o.id = options.id ?? nextFactoryId("GlobalSubPhase");
  o.name = options.name ?? "name";
  o.globalPhase = maybeNew("GlobalPhase", options.globalPhase, cache, options.hasOwnProperty("globalPhase"));
  o.displayOrder = options.displayOrder ?? null;
  o.stage = options.stage ?? Stage.PreConPlanning;
  o.stageDetail = enumOrDetailOfStage(options.stageDetail);
  o.cmsId = options.cmsId ?? null;
  return o;
}

factories["GlobalSubPhase"] = newGlobalSubPhase;

export interface SaveGlobalSubPhasesResultOptions {
  __typename?: "SaveGlobalSubPhasesResult";
  globalSubPhases?: Array<GlobalSubPhase | GlobalSubPhaseOptions>;
}

export function newSaveGlobalSubPhasesResult(
  options: SaveGlobalSubPhasesResultOptions = {},
  cache: Record<string, any> = {},
): SaveGlobalSubPhasesResult {
  const o = (options.__typename ? options : cache["SaveGlobalSubPhasesResult"] = {}) as SaveGlobalSubPhasesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveGlobalSubPhasesResult";
  o.globalSubPhases = (options.globalSubPhases ?? []).map((i) =>
    maybeNew("GlobalSubPhase", i, cache, options.hasOwnProperty("globalSubPhases"))
  );
  return o;
}

factories["SaveGlobalSubPhasesResult"] = newSaveGlobalSubPhasesResult;

export interface ReplaceGlobalSubPhaseResultOptions {
  __typename?: "ReplaceGlobalSubPhaseResult";
  replaced?: GlobalSubPhase | GlobalSubPhaseOptions;
  with?: GlobalSubPhase | GlobalSubPhaseOptions;
  impactedCount?: ReplaceGlobalSubPhaseResult["impactedCount"];
  impacted?: Array<ScheduleSubPhase | ScheduleSubPhaseOptions>;
}

export function newReplaceGlobalSubPhaseResult(
  options: ReplaceGlobalSubPhaseResultOptions = {},
  cache: Record<string, any> = {},
): ReplaceGlobalSubPhaseResult {
  const o = (options.__typename ? options : cache["ReplaceGlobalSubPhaseResult"] = {}) as ReplaceGlobalSubPhaseResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReplaceGlobalSubPhaseResult";
  o.replaced = maybeNew("GlobalSubPhase", options.replaced, cache, options.hasOwnProperty("replaced"));
  o.with = maybeNew("GlobalSubPhase", options.with, cache, options.hasOwnProperty("with"));
  o.impactedCount = options.impactedCount ?? 0;
  o.impacted = (options.impacted ?? []).map((i) =>
    maybeNew("ScheduleSubPhase", i, cache, options.hasOwnProperty("impacted"))
  );
  return o;
}

factories["ReplaceGlobalSubPhaseResult"] = newReplaceGlobalSubPhaseResult;

export interface GlobalTaskOptions {
  __typename?: "GlobalTask";
  id?: GlobalTask["id"];
  name?: GlobalTask["name"];
  isMilestone?: GlobalTask["isMilestone"];
  createdAt?: GlobalTask["createdAt"];
  updatedAt?: GlobalTask["updatedAt"];
  globalPhase?: GlobalPhase | GlobalPhaseOptions;
  determinesStartDateForStage?: GlobalTask["determinesStartDateForStage"];
  beginsStage?: GlobalTask["beginsStage"];
  systemTask?: GlobalTask["systemTask"];
  sendEvent?: GlobalTask["sendEvent"];
  globalPlanMilestone?: GlobalPlanMilestone | GlobalPlanMilestoneOptions | null;
}

export function newGlobalTask(options: GlobalTaskOptions = {}, cache: Record<string, any> = {}): GlobalTask {
  const o = (options.__typename ? options : cache["GlobalTask"] = {}) as GlobalTask;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GlobalTask";
  o.id = options.id ?? nextFactoryId("GlobalTask");
  o.name = options.name ?? "name";
  o.isMilestone = options.isMilestone ?? false;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.globalPhase = maybeNew("GlobalPhase", options.globalPhase, cache, options.hasOwnProperty("globalPhase"));
  o.determinesStartDateForStage = options.determinesStartDateForStage ?? null;
  o.beginsStage = options.beginsStage ?? null;
  o.systemTask = options.systemTask ?? null;
  o.sendEvent = options.sendEvent ?? false;
  o.globalPlanMilestone = maybeNewOrNull("GlobalPlanMilestone", options.globalPlanMilestone, cache);
  return o;
}

factories["GlobalTask"] = newGlobalTask;

export interface SaveGlobalTasksResultOptions {
  __typename?: "SaveGlobalTasksResult";
  globalTasks?: Array<GlobalTask | GlobalTaskOptions>;
}

export function newSaveGlobalTasksResult(
  options: SaveGlobalTasksResultOptions = {},
  cache: Record<string, any> = {},
): SaveGlobalTasksResult {
  const o = (options.__typename ? options : cache["SaveGlobalTasksResult"] = {}) as SaveGlobalTasksResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveGlobalTasksResult";
  o.globalTasks = (options.globalTasks ?? []).map((i) =>
    maybeNew("GlobalTask", i, cache, options.hasOwnProperty("globalTasks"))
  );
  return o;
}

factories["SaveGlobalTasksResult"] = newSaveGlobalTasksResult;

export interface HistoryOptions {
  __typename?: "History";
  recordedAt?: History["recordedAt"];
  avatar?: History["avatar"];
  title?: History["title"];
  subtitle?: History["subtitle"];
  userName?: History["userName"];
}

export function newHistory(options: HistoryOptions = {}, cache: Record<string, any> = {}): History {
  const o = (options.__typename ? options : cache["History"] = {}) as History;
  (cache.all ??= new Set()).add(o);
  o.__typename = "History";
  o.recordedAt = options.recordedAt ?? newDateTime();
  o.avatar = options.avatar ?? "avatar";
  o.title = options.title ?? "title";
  o.subtitle = options.subtitle ?? null;
  o.userName = options.userName ?? null;
  return o;
}

factories["History"] = newHistory;

export interface HomeboundHolidayOptions {
  __typename?: "HomeboundHoliday";
  id?: HomeboundHoliday["id"];
  date?: HomeboundHoliday["date"];
  name?: HomeboundHoliday["name"];
  createdAt?: HomeboundHoliday["createdAt"];
  updatedAt?: HomeboundHoliday["updatedAt"];
}

export function newHomeboundHoliday(
  options: HomeboundHolidayOptions = {},
  cache: Record<string, any> = {},
): HomeboundHoliday {
  const o = (options.__typename ? options : cache["HomeboundHoliday"] = {}) as HomeboundHoliday;
  (cache.all ??= new Set()).add(o);
  o.__typename = "HomeboundHoliday";
  o.id = options.id ?? nextFactoryId("HomeboundHoliday");
  o.date = options.date ?? newDate();
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  return o;
}

factories["HomeboundHoliday"] = newHomeboundHoliday;

export interface SaveHomeboundHolidayResultOptions {
  __typename?: "SaveHomeboundHolidayResult";
  homeboundHoliday?: HomeboundHoliday | HomeboundHolidayOptions;
}

export function newSaveHomeboundHolidayResult(
  options: SaveHomeboundHolidayResultOptions = {},
  cache: Record<string, any> = {},
): SaveHomeboundHolidayResult {
  const o = (options.__typename ? options : cache["SaveHomeboundHolidayResult"] = {}) as SaveHomeboundHolidayResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveHomeboundHolidayResult";
  o.homeboundHoliday = maybeNew(
    "HomeboundHoliday",
    options.homeboundHoliday,
    cache,
    options.hasOwnProperty("homeboundHoliday"),
  );
  return o;
}

factories["SaveHomeboundHolidayResult"] = newSaveHomeboundHolidayResult;

export interface HomeownerOptions {
  __typename?: "Homeowner";
  id?: Homeowner["id"];
  firstName?: Homeowner["firstName"];
  lastName?: Homeowner["lastName"];
  email?: Homeowner["email"];
  phone?: Homeowner["phone"];
  createdAt?: Homeowner["createdAt"];
  createdBy?: User | UserOptions | null;
  canViewCheckout?: Homeowner["canViewCheckout"];
  checkoutConfigs?: Array<CheckoutConfig | CheckoutConfigOptions>;
}

export function newHomeowner(options: HomeownerOptions = {}, cache: Record<string, any> = {}): Homeowner {
  const o = (options.__typename ? options : cache["Homeowner"] = {}) as Homeowner;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Homeowner";
  o.id = options.id ?? nextFactoryId("Homeowner");
  o.firstName = options.firstName ?? "firstName";
  o.lastName = options.lastName ?? "lastName";
  o.email = options.email ?? "email";
  o.phone = options.phone ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.createdBy = maybeNewOrNull("User", options.createdBy, cache);
  o.canViewCheckout = options.canViewCheckout ?? false;
  o.checkoutConfigs = (options.checkoutConfigs ?? []).map((i) =>
    maybeNew("CheckoutConfig", i, cache, options.hasOwnProperty("checkoutConfigs"))
  );
  return o;
}

factories["Homeowner"] = newHomeowner;

export interface HomeownersPageOptions {
  __typename?: "HomeownersPage";
  entities?: Array<Homeowner | HomeownerOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newHomeownersPage(
  options: HomeownersPageOptions = {},
  cache: Record<string, any> = {},
): HomeownersPage {
  const o = (options.__typename ? options : cache["HomeownersPage"] = {}) as HomeownersPage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "HomeownersPage";
  o.entities = (options.entities ?? []).map((i) => maybeNew("Homeowner", i, cache, options.hasOwnProperty("entities")));
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["HomeownersPage"] = newHomeownersPage;

export interface SaveHomeownerResultOptions {
  __typename?: "SaveHomeownerResult";
  homeowner?: Homeowner | HomeownerOptions;
}

export function newSaveHomeownerResult(
  options: SaveHomeownerResultOptions = {},
  cache: Record<string, any> = {},
): SaveHomeownerResult {
  const o = (options.__typename ? options : cache["SaveHomeownerResult"] = {}) as SaveHomeownerResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveHomeownerResult";
  o.homeowner = maybeNew("Homeowner", options.homeowner, cache, options.hasOwnProperty("homeowner"));
  return o;
}

factories["SaveHomeownerResult"] = newSaveHomeownerResult;

export interface HomeownerContractLineItemsByProjectItemOptions {
  __typename?: "HomeownerContractLineItemsByProjectItem";
  projectItem?: ProjectItem | ProjectItemOptions;
  lineItems?: Array<HomeownerContractLineItem | HomeownerContractLineItemOptions>;
}

export function newHomeownerContractLineItemsByProjectItem(
  options: HomeownerContractLineItemsByProjectItemOptions = {},
  cache: Record<string, any> = {},
): HomeownerContractLineItemsByProjectItem {
  const o =
    (options.__typename
      ? options
      : cache["HomeownerContractLineItemsByProjectItem"] = {}) as HomeownerContractLineItemsByProjectItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "HomeownerContractLineItemsByProjectItem";
  o.projectItem = maybeNew("ProjectItem", options.projectItem, cache, options.hasOwnProperty("projectItem"));
  o.lineItems = (options.lineItems ?? []).map((i) =>
    maybeNew("HomeownerContractLineItem", i, cache, options.hasOwnProperty("lineItems"))
  );
  return o;
}

factories["HomeownerContractLineItemsByProjectItem"] = newHomeownerContractLineItemsByProjectItem;

export interface SaveHomeownerContractResultOptions {
  __typename?: "SaveHomeownerContractResult";
  homeownerContract?: HomeownerContract | HomeownerContractOptions;
}

export function newSaveHomeownerContractResult(
  options: SaveHomeownerContractResultOptions = {},
  cache: Record<string, any> = {},
): SaveHomeownerContractResult {
  const o = (options.__typename ? options : cache["SaveHomeownerContractResult"] = {}) as SaveHomeownerContractResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveHomeownerContractResult";
  o.homeownerContract = maybeNew(
    "HomeownerContract",
    options.homeownerContract,
    cache,
    options.hasOwnProperty("homeownerContract"),
  );
  return o;
}

factories["SaveHomeownerContractResult"] = newSaveHomeownerContractResult;

export interface SaveHomeownerContractChangeOrderResultOptions {
  __typename?: "SaveHomeownerContractChangeOrderResult";
  homeownerContractChangeOrder?: HomeownerContractChangeOrder | HomeownerContractChangeOrderOptions;
}

export function newSaveHomeownerContractChangeOrderResult(
  options: SaveHomeownerContractChangeOrderResultOptions = {},
  cache: Record<string, any> = {},
): SaveHomeownerContractChangeOrderResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveHomeownerContractChangeOrderResult"] = {}) as SaveHomeownerContractChangeOrderResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveHomeownerContractChangeOrderResult";
  o.homeownerContractChangeOrder = maybeNew(
    "HomeownerContractChangeOrder",
    options.homeownerContractChangeOrder,
    cache,
    options.hasOwnProperty("homeownerContractChangeOrder"),
  );
  return o;
}

factories["SaveHomeownerContractChangeOrderResult"] = newSaveHomeownerContractChangeOrderResult;

export interface ContractProjectFinancialsOptions {
  __typename?: "ContractProjectFinancials";
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  softCostBudgetInCents?: ContractProjectFinancials["softCostBudgetInCents"];
  directHardCostBudgetInCents?: ContractProjectFinancials["directHardCostBudgetInCents"];
  indirectHardCostBudgetInCents?: ContractProjectFinancials["indirectHardCostBudgetInCents"];
  totalMarkupInCents?: ContractProjectFinancials["totalMarkupInCents"];
}

export function newContractProjectFinancials(
  options: ContractProjectFinancialsOptions = {},
  cache: Record<string, any> = {},
): ContractProjectFinancials {
  const o = (options.__typename ? options : cache["ContractProjectFinancials"] = {}) as ContractProjectFinancials;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ContractProjectFinancials";
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.softCostBudgetInCents = options.softCostBudgetInCents ?? 0;
  o.directHardCostBudgetInCents = options.directHardCostBudgetInCents ?? 0;
  o.indirectHardCostBudgetInCents = options.indirectHardCostBudgetInCents ?? 0;
  o.totalMarkupInCents = options.totalMarkupInCents ?? 0;
  return o;
}

factories["ContractProjectFinancials"] = newContractProjectFinancials;

export interface HomeownerContractDrawOptions {
  __typename?: "HomeownerContractDraw";
  id?: HomeownerContractDraw["id"];
  parent?: HomeownerContract | HomeownerContractChangeOrder | HomeownerContractLike | HomeownerContractLikeOptions;
  task?: Task | TaskOptions;
  percent?: HomeownerContractDraw["percent"];
  amountInCents?: HomeownerContractDraw["amountInCents"];
  order?: HomeownerContractDraw["order"];
  isDrawn?: HomeownerContractDraw["isDrawn"];
  name?: HomeownerContractDraw["name"];
  description?: HomeownerContractDraw["description"];
  invoiceDrawLineItem?: InvoiceDrawLineItem | InvoiceDrawLineItemOptions | null;
}

export function newHomeownerContractDraw(
  options: HomeownerContractDrawOptions = {},
  cache: Record<string, any> = {},
): HomeownerContractDraw {
  const o = (options.__typename ? options : cache["HomeownerContractDraw"] = {}) as HomeownerContractDraw;
  (cache.all ??= new Set()).add(o);
  o.__typename = "HomeownerContractDraw";
  o.id = options.id ?? nextFactoryId("HomeownerContractDraw");
  o.parent = maybeNew("HomeownerContractLike", options.parent, cache, options.hasOwnProperty("parent"));
  o.task = maybeNew("Task", options.task, cache, options.hasOwnProperty("task"));
  o.percent = options.percent ?? 0;
  o.amountInCents = options.amountInCents ?? 0;
  o.order = options.order ?? 0;
  o.isDrawn = options.isDrawn ?? false;
  o.name = options.name ?? "name";
  o.description = options.description ?? "description";
  o.invoiceDrawLineItem = maybeNewOrNull("InvoiceDrawLineItem", options.invoiceDrawLineItem, cache);
  return o;
}

factories["HomeownerContractDraw"] = newHomeownerContractDraw;

export interface HomeownerContractLineItemAllocationOptions {
  __typename?: "HomeownerContractLineItemAllocation";
  id?: HomeownerContractLineItemAllocation["id"];
  costInCents?: HomeownerContractLineItemAllocation["costInCents"];
  priceInCents?: HomeownerContractLineItemAllocation["priceInCents"];
  createdAt?: HomeownerContractLineItemAllocation["createdAt"];
  updatedAt?: HomeownerContractLineItemAllocation["updatedAt"];
  homeownerContractLineItem?: HomeownerContractLineItem | HomeownerContractLineItemOptions;
  projectItemAllocation?: ProjectItemAllocation | ProjectItemAllocationOptions;
  changeEventLineItemAllocation?: ChangeEventLineItemAllocation | ChangeEventLineItemAllocationOptions | null;
}

export function newHomeownerContractLineItemAllocation(
  options: HomeownerContractLineItemAllocationOptions = {},
  cache: Record<string, any> = {},
): HomeownerContractLineItemAllocation {
  const o =
    (options.__typename
      ? options
      : cache["HomeownerContractLineItemAllocation"] = {}) as HomeownerContractLineItemAllocation;
  (cache.all ??= new Set()).add(o);
  o.__typename = "HomeownerContractLineItemAllocation";
  o.id = options.id ?? nextFactoryId("HomeownerContractLineItemAllocation");
  o.costInCents = options.costInCents ?? 0;
  o.priceInCents = options.priceInCents ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.homeownerContractLineItem = maybeNew(
    "HomeownerContractLineItem",
    options.homeownerContractLineItem,
    cache,
    options.hasOwnProperty("homeownerContractLineItem"),
  );
  o.projectItemAllocation = maybeNew(
    "ProjectItemAllocation",
    options.projectItemAllocation,
    cache,
    options.hasOwnProperty("projectItemAllocation"),
  );
  o.changeEventLineItemAllocation = maybeNewOrNull(
    "ChangeEventLineItemAllocation",
    options.changeEventLineItemAllocation,
    cache,
  );
  return o;
}

factories["HomeownerContractLineItemAllocation"] = newHomeownerContractLineItemAllocation;

export interface HomeownerNoteOptions {
  __typename?: "HomeownerNote";
  id?: HomeownerNote["id"];
  title?: HomeownerNote["title"];
  description?: HomeownerNote["description"];
  jobLogImages?: Array<JobLogImage | JobLogImageOptions>;
  scheduleTasks?: Array<ScheduleTask | ScheduleTaskOptions>;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  createdAt?: HomeownerNote["createdAt"];
  createdBy?: User | UserOptions;
  schedulePhases?: Array<SchedulePhase | SchedulePhaseOptions>;
}

export function newHomeownerNote(options: HomeownerNoteOptions = {}, cache: Record<string, any> = {}): HomeownerNote {
  const o = (options.__typename ? options : cache["HomeownerNote"] = {}) as HomeownerNote;
  (cache.all ??= new Set()).add(o);
  o.__typename = "HomeownerNote";
  o.id = options.id ?? nextFactoryId("HomeownerNote");
  o.title = options.title ?? "title";
  o.description = options.description ?? "description";
  o.jobLogImages = (options.jobLogImages ?? []).map((i) =>
    maybeNew("JobLogImage", i, cache, options.hasOwnProperty("jobLogImages"))
  );
  o.scheduleTasks = (options.scheduleTasks ?? []).map((i) =>
    maybeNew("ScheduleTask", i, cache, options.hasOwnProperty("scheduleTasks"))
  );
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.createdAt = options.createdAt ?? newDateTime();
  o.createdBy = maybeNew("User", options.createdBy, cache, options.hasOwnProperty("createdBy"));
  o.schedulePhases = (options.schedulePhases ?? []).map((i) =>
    maybeNew("SchedulePhase", i, cache, options.hasOwnProperty("schedulePhases"))
  );
  return o;
}

factories["HomeownerNote"] = newHomeownerNote;

export interface SaveHomeownerNoteResultOptions {
  __typename?: "SaveHomeownerNoteResult";
  homeownerNote?: HomeownerNote | HomeownerNoteOptions;
}

export function newSaveHomeownerNoteResult(
  options: SaveHomeownerNoteResultOptions = {},
  cache: Record<string, any> = {},
): SaveHomeownerNoteResult {
  const o = (options.__typename ? options : cache["SaveHomeownerNoteResult"] = {}) as SaveHomeownerNoteResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveHomeownerNoteResult";
  o.homeownerNote = maybeNew("HomeownerNote", options.homeownerNote, cache, options.hasOwnProperty("homeownerNote"));
  return o;
}

factories["SaveHomeownerNoteResult"] = newSaveHomeownerNoteResult;

export interface HomeownerSelectionOptions {
  __typename?: "HomeownerSelection";
  id?: HomeownerSelection["id"];
  isDeclinable?: HomeownerSelection["isDeclinable"];
  canEdit?: PotentialOperation2 | PotentialOperation2Options;
  canPublish?: PotentialOperation2 | PotentialOperation2Options;
  potentialCustomProducts?: Array<Product | ProductOptions>;
  status?: HomeownerSelectionStatusDetailOptions | HomeownerSelectionStatus;
  isPublished?: HomeownerSelection["isPublished"];
  options?: Array<HomeownerSelectionOption | HomeownerSelectionOptionOptions>;
  projectItem?: ProjectItem | ProjectItemOptions;
  relatedSelections?: Array<HomeownerSelection | HomeownerSelectionOptions>;
  selectedOption?: HomeownerSelectionOption | HomeownerSelectionOptionOptions | null;
  recommendedOption?: HomeownerSelectionOption | HomeownerSelectionOptionOptions | null;
  baseOption?: HomeownerSelectionOption | HomeownerSelectionOptionOptions | null;
  publishedDate?: HomeownerSelection["publishedDate"];
  publishedAt?: HomeownerSelection["publishedAt"];
  productOptions?: Array<
    | HomeownerSelectionOption
    | HomeownerSelectionProductOption
    | HomeownerSelectionOptionLike
    | HomeownerSelectionOptionLikeOptions
  >;
  selectionPricingMode?: HomeownerSelection["selectionPricingMode"];
  selectionPricingModeDetail?: SelectionPricingModeDetailOptions | SelectionPricingMode;
  projectCutoff?: ProjectCutoff | ProjectCutoffOptions | null;
  undecidedUnitCostInCents?: HomeownerSelection["undecidedUnitCostInCents"];
  undecidedUnitPriceInCents?: HomeownerSelection["undecidedUnitPriceInCents"];
  changeEventLineItem?: ChangeEventLineItem | ChangeEventLineItemOptions | null;
  isProposedSelection?: HomeownerSelection["isProposedSelection"];
}

export function newHomeownerSelection(
  options: HomeownerSelectionOptions = {},
  cache: Record<string, any> = {},
): HomeownerSelection {
  const o = (options.__typename ? options : cache["HomeownerSelection"] = {}) as HomeownerSelection;
  (cache.all ??= new Set()).add(o);
  o.__typename = "HomeownerSelection";
  o.id = options.id ?? nextFactoryId("HomeownerSelection");
  o.isDeclinable = options.isDeclinable ?? false;
  o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
  o.canPublish = maybeNew("PotentialOperation2", options.canPublish, cache, options.hasOwnProperty("canPublish"));
  o.potentialCustomProducts = (options.potentialCustomProducts ?? []).map((i) =>
    maybeNew("Product", i, cache, options.hasOwnProperty("potentialCustomProducts"))
  );
  o.status = enumOrDetailOfHomeownerSelectionStatus(options.status);
  o.isPublished = options.isPublished ?? false;
  o.options = (options.options ?? []).map((i) =>
    maybeNew("HomeownerSelectionOption", i, cache, options.hasOwnProperty("options"))
  );
  o.projectItem = maybeNew("ProjectItem", options.projectItem, cache, options.hasOwnProperty("projectItem"));
  o.relatedSelections = (options.relatedSelections ?? []).map((i) =>
    maybeNew("HomeownerSelection", i, cache, options.hasOwnProperty("relatedSelections"))
  );
  o.selectedOption = maybeNewOrNull("HomeownerSelectionOption", options.selectedOption, cache);
  o.recommendedOption = maybeNewOrNull("HomeownerSelectionOption", options.recommendedOption, cache);
  o.baseOption = maybeNewOrNull("HomeownerSelectionOption", options.baseOption, cache);
  o.publishedDate = options.publishedDate ?? null;
  o.publishedAt = options.publishedAt ?? null;
  o.productOptions = (options.productOptions ?? []).map((i) =>
    maybeNew("HomeownerSelectionOptionLike", i, cache, options.hasOwnProperty("productOptions"))
  );
  o.selectionPricingMode = options.selectionPricingMode ?? SelectionPricingMode.None;
  o.selectionPricingModeDetail = enumOrDetailOfSelectionPricingMode(options.selectionPricingModeDetail);
  o.projectCutoff = maybeNewOrNull("ProjectCutoff", options.projectCutoff, cache);
  o.undecidedUnitCostInCents = options.undecidedUnitCostInCents ?? null;
  o.undecidedUnitPriceInCents = options.undecidedUnitPriceInCents ?? null;
  o.changeEventLineItem = maybeNewOrNull("ChangeEventLineItem", options.changeEventLineItem, cache);
  o.isProposedSelection = options.isProposedSelection ?? false;
  return o;
}

factories["HomeownerSelection"] = newHomeownerSelection;

export interface HomeownerLocationSelectionOptions {
  __typename?: "HomeownerLocationSelection";
  location?: Location | LocationOptions;
  finalizedSelectionCount?: HomeownerLocationSelection["finalizedSelectionCount"];
  totalSelectionCount?: HomeownerLocationSelection["totalSelectionCount"];
  selections?: Array<HomeownerSelection | HomeownerSelectionOptions>;
}

export function newHomeownerLocationSelection(
  options: HomeownerLocationSelectionOptions = {},
  cache: Record<string, any> = {},
): HomeownerLocationSelection {
  const o = (options.__typename ? options : cache["HomeownerLocationSelection"] = {}) as HomeownerLocationSelection;
  (cache.all ??= new Set()).add(o);
  o.__typename = "HomeownerLocationSelection";
  o.location = maybeNew("Location", options.location, cache, options.hasOwnProperty("location"));
  o.finalizedSelectionCount = options.finalizedSelectionCount ?? 0;
  o.totalSelectionCount = options.totalSelectionCount ?? 0;
  o.selections = (options.selections ?? []).map((i) =>
    maybeNew("HomeownerSelection", i, cache, options.hasOwnProperty("selections"))
  );
  return o;
}

factories["HomeownerLocationSelection"] = newHomeownerLocationSelection;

export interface SaveHomeownerSelectionResultOptions {
  __typename?: "SaveHomeownerSelectionResult";
  homeownerSelection?: HomeownerSelection | HomeownerSelectionOptions;
}

export function newSaveHomeownerSelectionResult(
  options: SaveHomeownerSelectionResultOptions = {},
  cache: Record<string, any> = {},
): SaveHomeownerSelectionResult {
  const o = (options.__typename ? options : cache["SaveHomeownerSelectionResult"] = {}) as SaveHomeownerSelectionResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveHomeownerSelectionResult";
  o.homeownerSelection = maybeNew(
    "HomeownerSelection",
    options.homeownerSelection,
    cache,
    options.hasOwnProperty("homeownerSelection"),
  );
  return o;
}

factories["SaveHomeownerSelectionResult"] = newSaveHomeownerSelectionResult;

export interface MakeHomeownerSelectionResultOptions {
  __typename?: "MakeHomeownerSelectionResult";
  homeownerSelectionOption?: HomeownerSelectionOption | HomeownerSelectionOptionOptions;
}

export function newMakeHomeownerSelectionResult(
  options: MakeHomeownerSelectionResultOptions = {},
  cache: Record<string, any> = {},
): MakeHomeownerSelectionResult {
  const o = (options.__typename ? options : cache["MakeHomeownerSelectionResult"] = {}) as MakeHomeownerSelectionResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MakeHomeownerSelectionResult";
  o.homeownerSelectionOption = maybeNew(
    "HomeownerSelectionOption",
    options.homeownerSelectionOption,
    cache,
    options.hasOwnProperty("homeownerSelectionOption"),
  );
  return o;
}

factories["MakeHomeownerSelectionResult"] = newMakeHomeownerSelectionResult;

export interface HomeownerSelectionOptionOptions {
  __typename?: "HomeownerSelectionOption";
  id?: HomeownerSelectionOption["id"];
  isHomeownerVisible?: HomeownerSelectionOption["isHomeownerVisible"];
  name?: HomeownerSelectionOption["name"];
  description?: HomeownerSelectionOption["description"];
  unitCostInCents?: HomeownerSelectionOption["unitCostInCents"];
  unitPriceInCents?: HomeownerSelectionOption["unitPriceInCents"];
  markupInCents?: HomeownerSelectionOption["markupInCents"];
  markupBasisPoints?: HomeownerSelectionOption["markupBasisPoints"];
  product?: Product | ProductOptions;
  homeownerSelection?: HomeownerSelection | HomeownerSelectionOptions;
  isBaseOption?: HomeownerSelectionOption["isBaseOption"];
  isRecommendedOption?: HomeownerSelectionOption["isRecommendedOption"];
  isSelectedOption?: HomeownerSelectionOption["isSelectedOption"];
  canEditPrice?: PotentialOperation2 | PotentialOperation2Options;
  priceDeltaInCents?: HomeownerSelectionOption["priceDeltaInCents"];
  pricingType?: HomeownerSelectionOption["pricingType"];
  pricingTypeDetail?: HomeownerSelectionOptionPricingTypeDetailOptions | HomeownerSelectionOptionPricingType;
  specifications?: HomeownerSelectionOption["specifications"];
  bidContractLineItem?: BidContractLineItem | BidContractLineItemOptions | null;
}

export function newHomeownerSelectionOption(
  options: HomeownerSelectionOptionOptions = {},
  cache: Record<string, any> = {},
): HomeownerSelectionOption {
  const o = (options.__typename ? options : cache["HomeownerSelectionOption"] = {}) as HomeownerSelectionOption;
  (cache.all ??= new Set()).add(o);
  o.__typename = "HomeownerSelectionOption";
  o.id = options.id ?? nextFactoryId("HomeownerSelectionOption");
  o.isHomeownerVisible = options.isHomeownerVisible ?? false;
  o.name = options.name ?? "name";
  o.description = options.description ?? null;
  o.unitCostInCents = options.unitCostInCents ?? null;
  o.unitPriceInCents = options.unitPriceInCents ?? null;
  o.markupInCents = options.markupInCents ?? null;
  o.markupBasisPoints = options.markupBasisPoints ?? null;
  o.product = maybeNew("Product", options.product, cache, options.hasOwnProperty("product"));
  o.homeownerSelection = maybeNew(
    "HomeownerSelection",
    options.homeownerSelection,
    cache,
    options.hasOwnProperty("homeownerSelection"),
  );
  o.isBaseOption = options.isBaseOption ?? false;
  o.isRecommendedOption = options.isRecommendedOption ?? false;
  o.isSelectedOption = options.isSelectedOption ?? false;
  o.canEditPrice = maybeNew("PotentialOperation2", options.canEditPrice, cache, options.hasOwnProperty("canEditPrice"));
  o.priceDeltaInCents = options.priceDeltaInCents ?? null;
  o.pricingType = options.pricingType ?? HomeownerSelectionOptionPricingType.None;
  o.pricingTypeDetail = enumOrDetailOfHomeownerSelectionOptionPricingType(options.pricingTypeDetail);
  o.specifications = options.specifications ?? null;
  o.bidContractLineItem = maybeNewOrNull("BidContractLineItem", options.bidContractLineItem, cache);
  return o;
}

factories["HomeownerSelectionOption"] = newHomeownerSelectionOption;

export interface HomeownerSelectionProductOptionOptions {
  __typename?: "HomeownerSelectionProductOption";
  id?: HomeownerSelectionProductOption["id"];
  isHomeownerVisible?: HomeownerSelectionProductOption["isHomeownerVisible"];
  name?: HomeownerSelectionProductOption["name"];
  description?: HomeownerSelectionProductOption["description"];
  unitCostInCents?: HomeownerSelectionProductOption["unitCostInCents"];
  unitPriceInCents?: HomeownerSelectionProductOption["unitPriceInCents"];
  markupInCents?: HomeownerSelectionProductOption["markupInCents"];
  markupBasisPoints?: HomeownerSelectionProductOption["markupBasisPoints"];
  product?: Product | ProductOptions;
  homeownerSelection?: HomeownerSelection | HomeownerSelectionOptions;
  isBaseOption?: HomeownerSelectionProductOption["isBaseOption"];
  isRecommendedOption?: HomeownerSelectionProductOption["isRecommendedOption"];
  isSelectedOption?: HomeownerSelectionProductOption["isSelectedOption"];
  canEditPrice?: PotentialOperation2 | PotentialOperation2Options;
  priceDeltaInCents?: HomeownerSelectionProductOption["priceDeltaInCents"];
  pricingType?: HomeownerSelectionProductOption["pricingType"];
  pricingTypeDetail?: HomeownerSelectionOptionPricingTypeDetailOptions | HomeownerSelectionOptionPricingType;
  specifications?: HomeownerSelectionProductOption["specifications"];
  bidContractLineItem?: BidContractLineItem | BidContractLineItemOptions | null;
}

export function newHomeownerSelectionProductOption(
  options: HomeownerSelectionProductOptionOptions = {},
  cache: Record<string, any> = {},
): HomeownerSelectionProductOption {
  const o =
    (options.__typename ? options : cache["HomeownerSelectionProductOption"] = {}) as HomeownerSelectionProductOption;
  (cache.all ??= new Set()).add(o);
  o.__typename = "HomeownerSelectionProductOption";
  o.id = options.id ?? nextFactoryId("HomeownerSelectionProductOption");
  o.isHomeownerVisible = options.isHomeownerVisible ?? false;
  o.name = options.name ?? "name";
  o.description = options.description ?? null;
  o.unitCostInCents = options.unitCostInCents ?? null;
  o.unitPriceInCents = options.unitPriceInCents ?? null;
  o.markupInCents = options.markupInCents ?? null;
  o.markupBasisPoints = options.markupBasisPoints ?? null;
  o.product = maybeNew("Product", options.product, cache, options.hasOwnProperty("product"));
  o.homeownerSelection = maybeNew(
    "HomeownerSelection",
    options.homeownerSelection,
    cache,
    options.hasOwnProperty("homeownerSelection"),
  );
  o.isBaseOption = options.isBaseOption ?? false;
  o.isRecommendedOption = options.isRecommendedOption ?? false;
  o.isSelectedOption = options.isSelectedOption ?? false;
  o.canEditPrice = maybeNew("PotentialOperation2", options.canEditPrice, cache, options.hasOwnProperty("canEditPrice"));
  o.priceDeltaInCents = options.priceDeltaInCents ?? null;
  o.pricingType = options.pricingType ?? HomeownerSelectionOptionPricingType.None;
  o.pricingTypeDetail = enumOrDetailOfHomeownerSelectionOptionPricingType(options.pricingTypeDetail);
  o.specifications = options.specifications ?? null;
  o.bidContractLineItem = maybeNewOrNull("BidContractLineItem", options.bidContractLineItem, cache);
  return o;
}

factories["HomeownerSelectionProductOption"] = newHomeownerSelectionProductOption;

export interface SaveHomeownerSelectionOptionResultOptions {
  __typename?: "SaveHomeownerSelectionOptionResult";
  homeownerSelectionOption?: HomeownerSelectionOption | HomeownerSelectionOptionOptions;
}

export function newSaveHomeownerSelectionOptionResult(
  options: SaveHomeownerSelectionOptionResultOptions = {},
  cache: Record<string, any> = {},
): SaveHomeownerSelectionOptionResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveHomeownerSelectionOptionResult"] = {}) as SaveHomeownerSelectionOptionResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveHomeownerSelectionOptionResult";
  o.homeownerSelectionOption = maybeNew(
    "HomeownerSelectionOption",
    options.homeownerSelectionOption,
    cache,
    options.hasOwnProperty("homeownerSelectionOption"),
  );
  return o;
}

factories["SaveHomeownerSelectionOptionResult"] = newSaveHomeownerSelectionOptionResult;

export interface SyncCostsForHomeownerSelectionOptionsResultOptions {
  __typename?: "SyncCostsForHomeownerSelectionOptionsResult";
  homeownerSelectionOptions?: Array<HomeownerSelectionOption | HomeownerSelectionOptionOptions>;
}

export function newSyncCostsForHomeownerSelectionOptionsResult(
  options: SyncCostsForHomeownerSelectionOptionsResultOptions = {},
  cache: Record<string, any> = {},
): SyncCostsForHomeownerSelectionOptionsResult {
  const o =
    (options.__typename
      ? options
      : cache["SyncCostsForHomeownerSelectionOptionsResult"] = {}) as SyncCostsForHomeownerSelectionOptionsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SyncCostsForHomeownerSelectionOptionsResult";
  o.homeownerSelectionOptions = (options.homeownerSelectionOptions ?? []).map((i) =>
    maybeNew("HomeownerSelectionOption", i, cache, options.hasOwnProperty("homeownerSelectionOptions"))
  );
  return o;
}

factories["SyncCostsForHomeownerSelectionOptionsResult"] = newSyncCostsForHomeownerSelectionOptionsResult;

export interface InsideMapsRoomRenderingOptions {
  __typename?: "InsideMapsRoomRendering";
  id?: InsideMapsRoomRendering["id"];
  createdAt?: InsideMapsRoomRendering["createdAt"];
  updatedAt?: InsideMapsRoomRendering["updatedAt"];
  asset?: Asset | AssetOptions | null;
  readyPlanLocation?: ReadyPlanLocation | ReadyPlanLocationOptions;
}

export function newInsideMapsRoomRendering(
  options: InsideMapsRoomRenderingOptions = {},
  cache: Record<string, any> = {},
): InsideMapsRoomRendering {
  const o = (options.__typename ? options : cache["InsideMapsRoomRendering"] = {}) as InsideMapsRoomRendering;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InsideMapsRoomRendering";
  o.id = options.id ?? nextFactoryId("InsideMapsRoomRendering");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.asset = maybeNewOrNull("Asset", options.asset, cache);
  o.readyPlanLocation = maybeNew(
    "ReadyPlanLocation",
    options.readyPlanLocation,
    cache,
    options.hasOwnProperty("readyPlanLocation"),
  );
  return o;
}

factories["InsideMapsRoomRendering"] = newInsideMapsRoomRendering;

export interface InternalUserOptions {
  __typename?: "InternalUser";
  id?: InternalUser["id"];
  name?: InternalUser["name"];
  email?: InternalUser["email"];
  avatar?: InternalUser["avatar"];
  projectRole?: InternalUser["projectRole"];
  projectRoleDetail?: ProjectRoleDetailOptions | ProjectRole | null;
  user?: User | UserOptions;
  approvals?: Array<Approval | ApprovalOptions>;
  approvers?: Array<Approver | ApproverOptions>;
  projectDashboardConfig?: DashboardConfig | DashboardConfigOptions | null;
  warrantyTickets?: Array<WarrantyTicket | WarrantyTicketOptions>;
}

export function newInternalUser(options: InternalUserOptions = {}, cache: Record<string, any> = {}): InternalUser {
  const o = (options.__typename ? options : cache["InternalUser"] = {}) as InternalUser;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InternalUser";
  o.id = options.id ?? nextFactoryId("InternalUser");
  o.name = options.name ?? "name";
  o.email = options.email ?? "email";
  o.avatar = options.avatar ?? "avatar";
  o.projectRole = options.projectRole ?? null;
  o.projectRoleDetail = enumOrDetailOrNullOfProjectRole(options.projectRoleDetail);
  o.user = maybeNew("User", options.user, cache, options.hasOwnProperty("user"));
  o.approvals = (options.approvals ?? []).map((i) =>
    maybeNew("Approval", i, cache, options.hasOwnProperty("approvals"))
  );
  o.approvers = (options.approvers ?? []).map((i) =>
    maybeNew("Approver", i, cache, options.hasOwnProperty("approvers"))
  );
  o.projectDashboardConfig = maybeNewOrNull("DashboardConfig", options.projectDashboardConfig, cache);
  o.warrantyTickets = (options.warrantyTickets ?? []).map((i) =>
    maybeNew("WarrantyTicket", i, cache, options.hasOwnProperty("warrantyTickets"))
  );
  return o;
}

factories["InternalUser"] = newInternalUser;

export interface SaveInternalUserResultOptions {
  __typename?: "SaveInternalUserResult";
  internalUser?: InternalUser | InternalUserOptions;
}

export function newSaveInternalUserResult(
  options: SaveInternalUserResultOptions = {},
  cache: Record<string, any> = {},
): SaveInternalUserResult {
  const o = (options.__typename ? options : cache["SaveInternalUserResult"] = {}) as SaveInternalUserResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveInternalUserResult";
  o.internalUser = maybeNew("InternalUser", options.internalUser, cache, options.hasOwnProperty("internalUser"));
  return o;
}

factories["SaveInternalUserResult"] = newSaveInternalUserResult;

export interface DashboardConfigOptions {
  __typename?: "DashboardConfig";
  tileConfigs?: Array<DashboardTileConfig | DashboardTileConfigOptions> | null;
}

export function newDashboardConfig(
  options: DashboardConfigOptions = {},
  cache: Record<string, any> = {},
): DashboardConfig {
  const o = (options.__typename ? options : cache["DashboardConfig"] = {}) as DashboardConfig;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DashboardConfig";
  o.tileConfigs = (options.tileConfigs ?? []).map((i) =>
    maybeNew("DashboardTileConfig", i, cache, options.hasOwnProperty("tileConfigs"))
  );
  return o;
}

factories["DashboardConfig"] = newDashboardConfig;

export interface DashboardTileConfigOptions {
  __typename?: "DashboardTileConfig";
  tile?: DashboardTileConfig["tile"];
  size?: DashboardTileConfig["size"];
}

export function newDashboardTileConfig(
  options: DashboardTileConfigOptions = {},
  cache: Record<string, any> = {},
): DashboardTileConfig {
  const o = (options.__typename ? options : cache["DashboardTileConfig"] = {}) as DashboardTileConfig;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DashboardTileConfig";
  o.tile = options.tile ?? DashboardTile.ProjectSchedule;
  o.size = options.size ?? DashboardTileSize.Small;
  return o;
}

factories["DashboardTileConfig"] = newDashboardTileConfig;

export interface SaveInvoiceResultOptions {
  __typename?: "SaveInvoiceResult";
  invoice?: Invoice | InvoiceOptions;
}

export function newSaveInvoiceResult(
  options: SaveInvoiceResultOptions = {},
  cache: Record<string, any> = {},
): SaveInvoiceResult {
  const o = (options.__typename ? options : cache["SaveInvoiceResult"] = {}) as SaveInvoiceResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveInvoiceResult";
  o.invoice = maybeNew("Invoice", options.invoice, cache, options.hasOwnProperty("invoice"));
  return o;
}

factories["SaveInvoiceResult"] = newSaveInvoiceResult;

export interface SaveInvoicesResultOptions {
  __typename?: "SaveInvoicesResult";
  invoices?: Array<Invoice | InvoiceOptions>;
}

export function newSaveInvoicesResult(
  options: SaveInvoicesResultOptions = {},
  cache: Record<string, any> = {},
): SaveInvoicesResult {
  const o = (options.__typename ? options : cache["SaveInvoicesResult"] = {}) as SaveInvoicesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveInvoicesResult";
  o.invoices = (options.invoices ?? []).map((i) => maybeNew("Invoice", i, cache, options.hasOwnProperty("invoices")));
  return o;
}

factories["SaveInvoicesResult"] = newSaveInvoicesResult;

export interface InvoiceLineItemsByCostCodeOptions {
  __typename?: "InvoiceLineItemsByCostCode";
  costCode?: CostCode | CostCodeOptions;
  totalAmountInCents?: InvoiceLineItemsByCostCode["totalAmountInCents"];
  lineItems?: Array<InvoiceLineItem | InvoiceLineItemOptions>;
}

export function newInvoiceLineItemsByCostCode(
  options: InvoiceLineItemsByCostCodeOptions = {},
  cache: Record<string, any> = {},
): InvoiceLineItemsByCostCode {
  const o = (options.__typename ? options : cache["InvoiceLineItemsByCostCode"] = {}) as InvoiceLineItemsByCostCode;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InvoiceLineItemsByCostCode";
  o.costCode = maybeNew("CostCode", options.costCode, cache, options.hasOwnProperty("costCode"));
  o.totalAmountInCents = options.totalAmountInCents ?? 0;
  o.lineItems = (options.lineItems ?? []).map((i) =>
    maybeNew("InvoiceLineItem", i, cache, options.hasOwnProperty("lineItems"))
  );
  return o;
}

factories["InvoiceLineItemsByCostCode"] = newInvoiceLineItemsByCostCode;

export interface InvoiceLineItemOptions {
  __typename?: "InvoiceLineItem";
  id?: InvoiceLineItem["id"];
  amountInCents?: InvoiceLineItem["amountInCents"];
  marginInCents?: InvoiceLineItem["marginInCents"];
  homeownerContractLineItem?: HomeownerContractLineItem | HomeownerContractLineItemOptions;
  invoice?: Invoice | InvoiceOptions;
  costLineItemAllocations?: Array<CostLineItemAllocation | CostLineItemAllocationOptions>;
  downPaymentInvoice?: Invoice | InvoiceOptions | null;
}

export function newInvoiceLineItem(
  options: InvoiceLineItemOptions = {},
  cache: Record<string, any> = {},
): InvoiceLineItem {
  const o = (options.__typename ? options : cache["InvoiceLineItem"] = {}) as InvoiceLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InvoiceLineItem";
  o.id = options.id ?? nextFactoryId("InvoiceLineItem");
  o.amountInCents = options.amountInCents ?? 0;
  o.marginInCents = options.marginInCents ?? null;
  o.homeownerContractLineItem = maybeNew(
    "HomeownerContractLineItem",
    options.homeownerContractLineItem,
    cache,
    options.hasOwnProperty("homeownerContractLineItem"),
  );
  o.invoice = maybeNew("Invoice", options.invoice, cache, options.hasOwnProperty("invoice"));
  o.costLineItemAllocations = (options.costLineItemAllocations ?? []).map((i) =>
    maybeNew("CostLineItemAllocation", i, cache, options.hasOwnProperty("costLineItemAllocations"))
  );
  o.downPaymentInvoice = maybeNewOrNull("Invoice", options.downPaymentInvoice, cache);
  return o;
}

factories["InvoiceLineItem"] = newInvoiceLineItem;

export interface InvoiceDrawLineItemOptions {
  __typename?: "InvoiceDrawLineItem";
  id?: InvoiceDrawLineItem["id"];
  draw?: HomeownerContractDraw | HomeownerContractDrawOptions;
  invoice?: Invoice | InvoiceOptions;
}

export function newInvoiceDrawLineItem(
  options: InvoiceDrawLineItemOptions = {},
  cache: Record<string, any> = {},
): InvoiceDrawLineItem {
  const o = (options.__typename ? options : cache["InvoiceDrawLineItem"] = {}) as InvoiceDrawLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InvoiceDrawLineItem";
  o.id = options.id ?? nextFactoryId("InvoiceDrawLineItem");
  o.draw = maybeNew("HomeownerContractDraw", options.draw, cache, options.hasOwnProperty("draw"));
  o.invoice = maybeNew("Invoice", options.invoice, cache, options.hasOwnProperty("invoice"));
  return o;
}

factories["InvoiceDrawLineItem"] = newInvoiceDrawLineItem;

export interface InvoiceScheduledLineItemOptions {
  __typename?: "InvoiceScheduledLineItem";
  id?: InvoiceScheduledLineItem["id"];
  amountInCents?: InvoiceScheduledLineItem["amountInCents"];
  amountInBasisPoints?: InvoiceScheduledLineItem["amountInBasisPoints"];
  marginInCents?: InvoiceScheduledLineItem["marginInCents"];
  invoice?: Invoice | InvoiceOptions;
  invoiceScheduleItem?: InvoiceScheduleItem | InvoiceScheduleItemOptions;
  invoiceLineItems?: Array<InvoiceLineItem | InvoiceLineItemOptions>;
}

export function newInvoiceScheduledLineItem(
  options: InvoiceScheduledLineItemOptions = {},
  cache: Record<string, any> = {},
): InvoiceScheduledLineItem {
  const o = (options.__typename ? options : cache["InvoiceScheduledLineItem"] = {}) as InvoiceScheduledLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InvoiceScheduledLineItem";
  o.id = options.id ?? nextFactoryId("InvoiceScheduledLineItem");
  o.amountInCents = options.amountInCents ?? 0;
  o.amountInBasisPoints = options.amountInBasisPoints ?? 0;
  o.marginInCents = options.marginInCents ?? 0;
  o.invoice = maybeNew("Invoice", options.invoice, cache, options.hasOwnProperty("invoice"));
  o.invoiceScheduleItem = maybeNew(
    "InvoiceScheduleItem",
    options.invoiceScheduleItem,
    cache,
    options.hasOwnProperty("invoiceScheduleItem"),
  );
  o.invoiceLineItems = (options.invoiceLineItems ?? []).map((i) =>
    maybeNew("InvoiceLineItem", i, cache, options.hasOwnProperty("invoiceLineItems"))
  );
  return o;
}

factories["InvoiceScheduledLineItem"] = newInvoiceScheduledLineItem;

export interface InvoiceAccruedLineItemOptions {
  __typename?: "InvoiceAccruedLineItem";
  id?: InvoiceAccruedLineItem["id"];
  amountInCents?: InvoiceAccruedLineItem["amountInCents"];
  marginInCents?: InvoiceAccruedLineItem["marginInCents"];
  createdAt?: InvoiceAccruedLineItem["createdAt"];
  updatedAt?: InvoiceAccruedLineItem["updatedAt"];
  costClassificationType?: CostClassificationTypeDetailOptions | CostClassificationType;
  invoice?: Invoice | InvoiceOptions;
  invoiceCategory?: CostCodeInvoiceCategoryDetailOptions | CostCodeInvoiceCategory | null;
}

export function newInvoiceAccruedLineItem(
  options: InvoiceAccruedLineItemOptions = {},
  cache: Record<string, any> = {},
): InvoiceAccruedLineItem {
  const o = (options.__typename ? options : cache["InvoiceAccruedLineItem"] = {}) as InvoiceAccruedLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InvoiceAccruedLineItem";
  o.id = options.id ?? nextFactoryId("InvoiceAccruedLineItem");
  o.amountInCents = options.amountInCents ?? 0;
  o.marginInCents = options.marginInCents ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.costClassificationType = enumOrDetailOfCostClassificationType(options.costClassificationType);
  o.invoice = maybeNew("Invoice", options.invoice, cache, options.hasOwnProperty("invoice"));
  o.invoiceCategory = enumOrDetailOrNullOfCostCodeInvoiceCategory(options.invoiceCategory);
  return o;
}

factories["InvoiceAccruedLineItem"] = newInvoiceAccruedLineItem;

export interface InvoiceDisplayLineItemOptions {
  __typename?: "InvoiceDisplayLineItem";
  id?: InvoiceDisplayLineItem["id"];
  name?: InvoiceDisplayLineItem["name"];
  costClassificationType?: CostClassificationTypeDetailOptions | CostClassificationType | null;
  amountInCents?: InvoiceDisplayLineItem["amountInCents"];
  marginInCents?: InvoiceDisplayLineItem["marginInCents"];
}

export function newInvoiceDisplayLineItem(
  options: InvoiceDisplayLineItemOptions = {},
  cache: Record<string, any> = {},
): InvoiceDisplayLineItem {
  const o = (options.__typename ? options : cache["InvoiceDisplayLineItem"] = {}) as InvoiceDisplayLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InvoiceDisplayLineItem";
  o.id = options.id ?? nextFactoryId("InvoiceDisplayLineItem");
  o.name = options.name ?? "name";
  o.costClassificationType = enumOrDetailOrNullOfCostClassificationType(options.costClassificationType);
  o.amountInCents = options.amountInCents ?? 0;
  o.marginInCents = options.marginInCents ?? null;
  return o;
}

factories["InvoiceDisplayLineItem"] = newInvoiceDisplayLineItem;

export interface InvoicesPageOptions {
  __typename?: "InvoicesPage";
  entities?: Array<Invoice | InvoiceOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newInvoicesPage(options: InvoicesPageOptions = {}, cache: Record<string, any> = {}): InvoicesPage {
  const o = (options.__typename ? options : cache["InvoicesPage"] = {}) as InvoicesPage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InvoicesPage";
  o.entities = (options.entities ?? []).map((i) => maybeNew("Invoice", i, cache, options.hasOwnProperty("entities")));
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["InvoicesPage"] = newInvoicesPage;

export interface InvoiceDocumentOptions {
  __typename?: "InvoiceDocument";
  id?: InvoiceDocument["id"];
  createdAt?: InvoiceDocument["createdAt"];
  updatedAt?: InvoiceDocument["updatedAt"];
  documentSource?: InvoiceDocumentSourceDetailOptions | InvoiceDocumentSource;
  document?: Document | DocumentOptions;
  invoice?: Invoice | InvoiceOptions;
}

export function newInvoiceDocument(
  options: InvoiceDocumentOptions = {},
  cache: Record<string, any> = {},
): InvoiceDocument {
  const o = (options.__typename ? options : cache["InvoiceDocument"] = {}) as InvoiceDocument;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InvoiceDocument";
  o.id = options.id ?? nextFactoryId("InvoiceDocument");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.documentSource = enumOrDetailOfInvoiceDocumentSource(options.documentSource);
  o.document = maybeNew("Document", options.document, cache, options.hasOwnProperty("document"));
  o.invoice = maybeNew("Invoice", options.invoice, cache, options.hasOwnProperty("invoice"));
  return o;
}

factories["InvoiceDocument"] = newInvoiceDocument;

export interface SaveInvoiceDocumentResultOptions {
  __typename?: "SaveInvoiceDocumentResult";
  invoiceDocument?: InvoiceDocument | InvoiceDocumentOptions;
}

export function newSaveInvoiceDocumentResult(
  options: SaveInvoiceDocumentResultOptions = {},
  cache: Record<string, any> = {},
): SaveInvoiceDocumentResult {
  const o = (options.__typename ? options : cache["SaveInvoiceDocumentResult"] = {}) as SaveInvoiceDocumentResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveInvoiceDocumentResult";
  o.invoiceDocument = maybeNew(
    "InvoiceDocument",
    options.invoiceDocument,
    cache,
    options.hasOwnProperty("invoiceDocument"),
  );
  return o;
}

factories["SaveInvoiceDocumentResult"] = newSaveInvoiceDocumentResult;

export interface DeleteInvoiceScheduleResultOptions {
  __typename?: "DeleteInvoiceScheduleResult";
  projects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
}

export function newDeleteInvoiceScheduleResult(
  options: DeleteInvoiceScheduleResultOptions = {},
  cache: Record<string, any> = {},
): DeleteInvoiceScheduleResult {
  const o = (options.__typename ? options : cache["DeleteInvoiceScheduleResult"] = {}) as DeleteInvoiceScheduleResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeleteInvoiceScheduleResult";
  o.projects = (options.projects ?? []).map((i) => maybeNew("Project", i, cache, options.hasOwnProperty("projects")));
  return o;
}

factories["DeleteInvoiceScheduleResult"] = newDeleteInvoiceScheduleResult;

export interface InvoiceScheduleOptions {
  __typename?: "InvoiceSchedule";
  id?: InvoiceSchedule["id"];
  softCostDayOfMonth?: InvoiceSchedule["softCostDayOfMonth"];
  hardCostDayOfMonth?: InvoiceSchedule["hardCostDayOfMonth"];
  hardCostAmountType?: InvoiceScheduleAmountTypeDetailOptions | InvoiceScheduleAmountType;
  softCostAmountType?: InvoiceScheduleAmountTypeDetailOptions | InvoiceScheduleAmountType;
  hardCostTriggerType?: InvoiceScheduleTriggerTypeDetailOptions | InvoiceScheduleTriggerType;
  softCostTriggerType?: InvoiceScheduleTriggerTypeDetailOptions | InvoiceScheduleTriggerType;
  invoiceScheduleTemplate?: InvoiceScheduleTemplate | InvoiceScheduleTemplateOptions;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  items?: Array<InvoiceScheduleItem | InvoiceScheduleItemOptions>;
}

export function newInvoiceSchedule(
  options: InvoiceScheduleOptions = {},
  cache: Record<string, any> = {},
): InvoiceSchedule {
  const o = (options.__typename ? options : cache["InvoiceSchedule"] = {}) as InvoiceSchedule;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InvoiceSchedule";
  o.id = options.id ?? nextFactoryId("InvoiceSchedule");
  o.softCostDayOfMonth = options.softCostDayOfMonth ?? null;
  o.hardCostDayOfMonth = options.hardCostDayOfMonth ?? null;
  o.hardCostAmountType = enumOrDetailOfInvoiceScheduleAmountType(options.hardCostAmountType);
  o.softCostAmountType = enumOrDetailOfInvoiceScheduleAmountType(options.softCostAmountType);
  o.hardCostTriggerType = enumOrDetailOfInvoiceScheduleTriggerType(options.hardCostTriggerType);
  o.softCostTriggerType = enumOrDetailOfInvoiceScheduleTriggerType(options.softCostTriggerType);
  o.invoiceScheduleTemplate = maybeNew(
    "InvoiceScheduleTemplate",
    options.invoiceScheduleTemplate,
    cache,
    options.hasOwnProperty("invoiceScheduleTemplate"),
  );
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.items = (options.items ?? []).map((i) =>
    maybeNew("InvoiceScheduleItem", i, cache, options.hasOwnProperty("items"))
  );
  return o;
}

factories["InvoiceSchedule"] = newInvoiceSchedule;

export interface InvoiceScheduleItemOptions {
  __typename?: "InvoiceScheduleItem";
  id?: InvoiceScheduleItem["id"];
  order?: InvoiceScheduleItem["order"];
  iteration?: InvoiceScheduleItem["iteration"];
  invoiceDate?: InvoiceScheduleItem["invoiceDate"];
  amountInBasisPoints?: InvoiceScheduleItem["amountInBasisPoints"];
  originalAmountInCents?: InvoiceScheduleItem["originalAmountInCents"];
  changeOrderAmountInCents?: InvoiceScheduleItem["changeOrderAmountInCents"];
  revisedAmountInCents?: InvoiceScheduleItem["revisedAmountInCents"];
  costClassificationType?: CostClassificationTypeDetailOptions | CostClassificationType;
  invoiceScheduleItemFrequency?: InvoiceScheduleItemFrequencyDetailOptions | InvoiceScheduleItemFrequency;
  invoiceSchedule?: InvoiceSchedule | InvoiceScheduleOptions;
  parent?: InvoiceScheduleItemParent | PlanMilestoneOptions | RequireTypename<ScheduleTaskOptions> | null;
  globalParent?: InvoiceScheduleItemGlobalParent | GlobalPlanMilestoneOptions | RequireTypename<GlobalTaskOptions>;
  invoiceScheduledLineItems?: Array<InvoiceScheduledLineItem | InvoiceScheduledLineItemOptions>;
  changeOrders?: Array<HomeownerContractChangeOrder | HomeownerContractChangeOrderOptions>;
  invoiceDelayInDays?: InvoiceScheduleItem["invoiceDelayInDays"];
}

export function newInvoiceScheduleItem(
  options: InvoiceScheduleItemOptions = {},
  cache: Record<string, any> = {},
): InvoiceScheduleItem {
  const o = (options.__typename ? options : cache["InvoiceScheduleItem"] = {}) as InvoiceScheduleItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InvoiceScheduleItem";
  o.id = options.id ?? nextFactoryId("InvoiceScheduleItem");
  o.order = options.order ?? 0;
  o.iteration = options.iteration ?? 0;
  o.invoiceDate = options.invoiceDate ?? null;
  o.amountInBasisPoints = options.amountInBasisPoints ?? 0;
  o.originalAmountInCents = options.originalAmountInCents ?? 0;
  o.changeOrderAmountInCents = options.changeOrderAmountInCents ?? 0;
  o.revisedAmountInCents = options.revisedAmountInCents ?? 0;
  o.costClassificationType = enumOrDetailOfCostClassificationType(options.costClassificationType);
  o.invoiceScheduleItemFrequency = enumOrDetailOfInvoiceScheduleItemFrequency(options.invoiceScheduleItemFrequency);
  o.invoiceSchedule = maybeNew(
    "InvoiceSchedule",
    options.invoiceSchedule,
    cache,
    options.hasOwnProperty("invoiceSchedule"),
  );
  o.parent = maybeNewOrNull(options.parent?.__typename ?? "PlanMilestone", options.parent, cache);
  o.globalParent = maybeNew(options.globalParent?.__typename ?? "GlobalPlanMilestone", options.globalParent, cache);
  o.invoiceScheduledLineItems = (options.invoiceScheduledLineItems ?? []).map((i) =>
    maybeNew("InvoiceScheduledLineItem", i, cache, options.hasOwnProperty("invoiceScheduledLineItems"))
  );
  o.changeOrders = (options.changeOrders ?? []).map((i) =>
    maybeNew("HomeownerContractChangeOrder", i, cache, options.hasOwnProperty("changeOrders"))
  );
  o.invoiceDelayInDays = options.invoiceDelayInDays ?? 0;
  return o;
}

factories["InvoiceScheduleItem"] = newInvoiceScheduleItem;

export interface InvoiceScheduleTemplateOptions {
  __typename?: "InvoiceScheduleTemplate";
  id?: InvoiceScheduleTemplate["id"];
  name?: InvoiceScheduleTemplate["name"];
  softCostDayOfMonth?: InvoiceScheduleTemplate["softCostDayOfMonth"];
  hardCostDayOfMonth?: InvoiceScheduleTemplate["hardCostDayOfMonth"];
  createdAt?: InvoiceScheduleTemplate["createdAt"];
  updatedAt?: InvoiceScheduleTemplate["updatedAt"];
  hardCostAmountType?: InvoiceScheduleAmountTypeDetailOptions | InvoiceScheduleAmountType;
  softCostAmountType?: InvoiceScheduleAmountTypeDetailOptions | InvoiceScheduleAmountType;
  hardCostTriggerType?: InvoiceScheduleTriggerTypeDetailOptions | InvoiceScheduleTriggerType;
  softCostTriggerType?: InvoiceScheduleTriggerTypeDetailOptions | InvoiceScheduleTriggerType;
  lotType?: LotTypeDetailOptions | LotType;
  communityType?: CommunityTypeDetailOptions | CommunityType | null;
  customer?: Customer | CustomerOptions | null;
  items?: Array<InvoiceScheduleTemplateItem | InvoiceScheduleTemplateItemOptions>;
  invoiceSchedules?: Array<InvoiceSchedule | InvoiceScheduleOptions>;
  region?: Region | RegionOptions | null;
}

export function newInvoiceScheduleTemplate(
  options: InvoiceScheduleTemplateOptions = {},
  cache: Record<string, any> = {},
): InvoiceScheduleTemplate {
  const o = (options.__typename ? options : cache["InvoiceScheduleTemplate"] = {}) as InvoiceScheduleTemplate;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InvoiceScheduleTemplate";
  o.id = options.id ?? nextFactoryId("InvoiceScheduleTemplate");
  o.name = options.name ?? "name";
  o.softCostDayOfMonth = options.softCostDayOfMonth ?? null;
  o.hardCostDayOfMonth = options.hardCostDayOfMonth ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.hardCostAmountType = enumOrDetailOfInvoiceScheduleAmountType(options.hardCostAmountType);
  o.softCostAmountType = enumOrDetailOfInvoiceScheduleAmountType(options.softCostAmountType);
  o.hardCostTriggerType = enumOrDetailOfInvoiceScheduleTriggerType(options.hardCostTriggerType);
  o.softCostTriggerType = enumOrDetailOfInvoiceScheduleTriggerType(options.softCostTriggerType);
  o.lotType = enumOrDetailOfLotType(options.lotType);
  o.communityType = enumOrDetailOrNullOfCommunityType(options.communityType);
  o.customer = maybeNewOrNull("Customer", options.customer, cache);
  o.items = (options.items ?? []).map((i) =>
    maybeNew("InvoiceScheduleTemplateItem", i, cache, options.hasOwnProperty("items"))
  );
  o.invoiceSchedules = (options.invoiceSchedules ?? []).map((i) =>
    maybeNew("InvoiceSchedule", i, cache, options.hasOwnProperty("invoiceSchedules"))
  );
  o.region = maybeNewOrNull("Region", options.region, cache);
  return o;
}

factories["InvoiceScheduleTemplate"] = newInvoiceScheduleTemplate;

export interface SaveInvoiceScheduleTemplateResultOptions {
  __typename?: "SaveInvoiceScheduleTemplateResult";
  invoiceScheduleTemplate?: InvoiceScheduleTemplate | InvoiceScheduleTemplateOptions;
}

export function newSaveInvoiceScheduleTemplateResult(
  options: SaveInvoiceScheduleTemplateResultOptions = {},
  cache: Record<string, any> = {},
): SaveInvoiceScheduleTemplateResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveInvoiceScheduleTemplateResult"] = {}) as SaveInvoiceScheduleTemplateResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveInvoiceScheduleTemplateResult";
  o.invoiceScheduleTemplate = maybeNew(
    "InvoiceScheduleTemplate",
    options.invoiceScheduleTemplate,
    cache,
    options.hasOwnProperty("invoiceScheduleTemplate"),
  );
  return o;
}

factories["SaveInvoiceScheduleTemplateResult"] = newSaveInvoiceScheduleTemplateResult;

export interface InvoiceScheduleTemplateItemOptions {
  __typename?: "InvoiceScheduleTemplateItem";
  id?: InvoiceScheduleTemplateItem["id"];
  iterations?: InvoiceScheduleTemplateItem["iterations"];
  amountInBasisPoints?: InvoiceScheduleTemplateItem["amountInBasisPoints"];
  createdAt?: InvoiceScheduleTemplateItem["createdAt"];
  updatedAt?: InvoiceScheduleTemplateItem["updatedAt"];
  costClassificationType?: CostClassificationTypeDetailOptions | CostClassificationType;
  frequency?: InvoiceScheduleItemFrequencyDetailOptions | InvoiceScheduleItemFrequency;
  globalTask?: GlobalTask | GlobalTaskOptions | null;
  invoiceScheduleTemplate?: InvoiceScheduleTemplate | InvoiceScheduleTemplateOptions;
  globalPlanMilestone?: GlobalPlanMilestone | GlobalPlanMilestoneOptions;
  invoiceDelayInDays?: InvoiceScheduleTemplateItem["invoiceDelayInDays"];
}

export function newInvoiceScheduleTemplateItem(
  options: InvoiceScheduleTemplateItemOptions = {},
  cache: Record<string, any> = {},
): InvoiceScheduleTemplateItem {
  const o = (options.__typename ? options : cache["InvoiceScheduleTemplateItem"] = {}) as InvoiceScheduleTemplateItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InvoiceScheduleTemplateItem";
  o.id = options.id ?? nextFactoryId("InvoiceScheduleTemplateItem");
  o.iterations = options.iterations ?? 0;
  o.amountInBasisPoints = options.amountInBasisPoints ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.costClassificationType = enumOrDetailOfCostClassificationType(options.costClassificationType);
  o.frequency = enumOrDetailOfInvoiceScheduleItemFrequency(options.frequency);
  o.globalTask = maybeNewOrNull("GlobalTask", options.globalTask, cache);
  o.invoiceScheduleTemplate = maybeNew(
    "InvoiceScheduleTemplate",
    options.invoiceScheduleTemplate,
    cache,
    options.hasOwnProperty("invoiceScheduleTemplate"),
  );
  o.globalPlanMilestone = maybeNew(
    "GlobalPlanMilestone",
    options.globalPlanMilestone,
    cache,
    options.hasOwnProperty("globalPlanMilestone"),
  );
  o.invoiceDelayInDays = options.invoiceDelayInDays ?? 0;
  return o;
}

factories["InvoiceScheduleTemplateItem"] = newInvoiceScheduleTemplateItem;

export interface ItemOptions {
  __typename?: "Item";
  id?: Item["id"];
  name?: Item["name"];
  displayName?: Item["displayName"];
  shortName?: Item["shortName"];
  costCode?: CostCode | CostCodeOptions;
  itemCode?: Item["itemCode"];
  fullCode?: Item["fullCode"];
  isSelection?: Item["isSelection"];
  status?: ItemStatusDetailOptions | ItemStatus;
  internalNote?: Item["internalNote"];
  specifications?: Item["specifications"];
  tradePartnerNote?: Item["tradePartnerNote"];
  unitOfMeasure?: UnitOfMeasure | UnitOfMeasureOptions;
  tradeCategory?: TradeCategory | TradeCategoryOptions | null;
  cutoff?: Cutoff | CutoffOptions | null;
  bidItems?: Array<BidItem | BidItemOptions>;
  isContingency?: Item["isContingency"];
  materialAttributeDimensions?: Array<MaterialAttributeDimension | MaterialAttributeDimensionOptions>;
  materialListings?: Array<MaterialListing | MaterialListingOptions>;
  materialBrands?: Array<MaterialBrand | MaterialBrandOptions>;
  materialCodePrefix?: Item["materialCodePrefix"];
  placeholderMaterialListing?: MaterialListing | MaterialListingOptions | null;
  isAnnotated?: Item["isAnnotated"];
  planTaskMappings?: Array<ItemPlanTaskMapping | ItemPlanTaskMappingOptions>;
  version?: Item["version"];
  materialNameFormat?: Item["materialNameFormat"];
  designPackageLocation?: DesignPackageLocationDetailOptions | DesignPackageLocation;
  isMaterialModifier?: Item["isMaterialModifier"];
  isAssemblyRelated?: Item["isAssemblyRelated"];
  parentModifierItems?: Array<Item | ItemOptions>;
  childModifierItems?: Array<Item | ItemOptions>;
  canBecomeMaterialModifier?: PotentialOperation2 | PotentialOperation2Options;
  optionPricingConfig?: OptionPricingConfig | OptionPricingConfigOptions | null;
  materialLeadTimeConfig?: MaterialLeadTimeConfig | MaterialLeadTimeConfigOptions | null;
  minLeadTimeInDays?: Item["minLeadTimeInDays"];
  expectedLeadTimeInDays?: Item["expectedLeadTimeInDays"];
  maxLeadTimeInDays?: Item["maxLeadTimeInDays"];
  history?: Array<History | HistoryOptions>;
}

export function newItem(options: ItemOptions = {}, cache: Record<string, any> = {}): Item {
  const o = (options.__typename ? options : cache["Item"] = {}) as Item;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Item";
  o.id = options.id ?? nextFactoryId("Item");
  o.name = options.name ?? "name";
  o.displayName = options.displayName ?? "displayName";
  o.shortName = options.shortName ?? "shortName";
  o.costCode = maybeNew("CostCode", options.costCode, cache, options.hasOwnProperty("costCode"));
  o.itemCode = options.itemCode ?? 0;
  o.fullCode = options.fullCode ?? "fullCode";
  o.isSelection = options.isSelection ?? false;
  o.status = enumOrDetailOfItemStatus(options.status);
  o.internalNote = options.internalNote ?? null;
  o.specifications = options.specifications ?? null;
  o.tradePartnerNote = options.tradePartnerNote ?? null;
  o.unitOfMeasure = maybeNew("UnitOfMeasure", options.unitOfMeasure, cache, options.hasOwnProperty("unitOfMeasure"));
  o.tradeCategory = maybeNewOrNull("TradeCategory", options.tradeCategory, cache);
  o.cutoff = maybeNewOrNull("Cutoff", options.cutoff, cache);
  o.bidItems = (options.bidItems ?? []).map((i) => maybeNew("BidItem", i, cache, options.hasOwnProperty("bidItems")));
  o.isContingency = options.isContingency ?? null;
  o.materialAttributeDimensions = (options.materialAttributeDimensions ?? []).map((i) =>
    maybeNew("MaterialAttributeDimension", i, cache, options.hasOwnProperty("materialAttributeDimensions"))
  );
  o.materialListings = (options.materialListings ?? []).map((i) =>
    maybeNew("MaterialListing", i, cache, options.hasOwnProperty("materialListings"))
  );
  o.materialBrands = (options.materialBrands ?? []).map((i) =>
    maybeNew("MaterialBrand", i, cache, options.hasOwnProperty("materialBrands"))
  );
  o.materialCodePrefix = options.materialCodePrefix ?? null;
  o.placeholderMaterialListing = maybeNewOrNull("MaterialListing", options.placeholderMaterialListing, cache);
  o.isAnnotated = options.isAnnotated ?? false;
  o.planTaskMappings = (options.planTaskMappings ?? []).map((i) =>
    maybeNew("ItemPlanTaskMapping", i, cache, options.hasOwnProperty("planTaskMappings"))
  );
  o.version = options.version ?? 0;
  o.materialNameFormat = options.materialNameFormat ?? null;
  o.designPackageLocation = enumOrDetailOfDesignPackageLocation(options.designPackageLocation);
  o.isMaterialModifier = options.isMaterialModifier ?? false;
  o.isAssemblyRelated = options.isAssemblyRelated ?? false;
  o.parentModifierItems = (options.parentModifierItems ?? []).map((i) =>
    maybeNew("Item", i, cache, options.hasOwnProperty("parentModifierItems"))
  );
  o.childModifierItems = (options.childModifierItems ?? []).map((i) =>
    maybeNew("Item", i, cache, options.hasOwnProperty("childModifierItems"))
  );
  o.canBecomeMaterialModifier = maybeNew(
    "PotentialOperation2",
    options.canBecomeMaterialModifier,
    cache,
    options.hasOwnProperty("canBecomeMaterialModifier"),
  );
  o.optionPricingConfig = maybeNewOrNull("OptionPricingConfig", options.optionPricingConfig, cache);
  o.materialLeadTimeConfig = maybeNewOrNull("MaterialLeadTimeConfig", options.materialLeadTimeConfig, cache);
  o.minLeadTimeInDays = options.minLeadTimeInDays ?? 0;
  o.expectedLeadTimeInDays = options.expectedLeadTimeInDays ?? 0;
  o.maxLeadTimeInDays = options.maxLeadTimeInDays ?? 0;
  o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
  return o;
}

factories["Item"] = newItem;

export interface ItemPlanTaskMappingOptions {
  __typename?: "ItemPlanTaskMapping";
  id?: ItemPlanTaskMapping["id"];
  createdAt?: ItemPlanTaskMapping["createdAt"];
  updatedAt?: ItemPlanTaskMapping["updatedAt"];
  item?: Item | ItemOptions;
  location?: Location | LocationOptions | null;
  task?: GlobalPlanTask | GlobalPlanTaskOptions;
  estimatedLaborCostInCents?: ItemPlanTaskMapping["estimatedLaborCostInCents"];
  unitOfMeasure?: UnitOfMeasure | UnitOfMeasureOptions | null;
}

export function newItemPlanTaskMapping(
  options: ItemPlanTaskMappingOptions = {},
  cache: Record<string, any> = {},
): ItemPlanTaskMapping {
  const o = (options.__typename ? options : cache["ItemPlanTaskMapping"] = {}) as ItemPlanTaskMapping;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ItemPlanTaskMapping";
  o.id = options.id ?? nextFactoryId("ItemPlanTaskMapping");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
  o.location = maybeNewOrNull("Location", options.location, cache);
  o.task = maybeNew("GlobalPlanTask", options.task, cache, options.hasOwnProperty("task"));
  o.estimatedLaborCostInCents = options.estimatedLaborCostInCents ?? null;
  o.unitOfMeasure = maybeNewOrNull("UnitOfMeasure", options.unitOfMeasure, cache);
  return o;
}

factories["ItemPlanTaskMapping"] = newItemPlanTaskMapping;

export interface SaveItemPlanTaskMappingResultOptions {
  __typename?: "SaveItemPlanTaskMappingResult";
  itemPlanTaskMapping?: ItemPlanTaskMapping | ItemPlanTaskMappingOptions;
}

export function newSaveItemPlanTaskMappingResult(
  options: SaveItemPlanTaskMappingResultOptions = {},
  cache: Record<string, any> = {},
): SaveItemPlanTaskMappingResult {
  const o =
    (options.__typename ? options : cache["SaveItemPlanTaskMappingResult"] = {}) as SaveItemPlanTaskMappingResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveItemPlanTaskMappingResult";
  o.itemPlanTaskMapping = maybeNew(
    "ItemPlanTaskMapping",
    options.itemPlanTaskMapping,
    cache,
    options.hasOwnProperty("itemPlanTaskMapping"),
  );
  return o;
}

factories["SaveItemPlanTaskMappingResult"] = newSaveItemPlanTaskMappingResult;

export interface ItemPlanTaskMappingPageOptions {
  __typename?: "ItemPlanTaskMappingPage";
  entities?: Array<ItemPlanTaskMapping | ItemPlanTaskMappingOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newItemPlanTaskMappingPage(
  options: ItemPlanTaskMappingPageOptions = {},
  cache: Record<string, any> = {},
): ItemPlanTaskMappingPage {
  const o = (options.__typename ? options : cache["ItemPlanTaskMappingPage"] = {}) as ItemPlanTaskMappingPage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ItemPlanTaskMappingPage";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("ItemPlanTaskMapping", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["ItemPlanTaskMappingPage"] = newItemPlanTaskMappingPage;

export interface ItemSlotOptions {
  __typename?: "ItemSlot";
  id?: ItemSlot["id"];
  name?: ItemSlot["name"];
  createdAt?: ItemSlot["createdAt"];
  updatedAt?: ItemSlot["updatedAt"];
  costType?: ItemSlot["costType"];
  costTypeDetail?: CostTypeDetailOptions | CostType;
  item?: Item | ItemOptions;
  location?: Location | LocationOptions;
  unitOfMeasure?: UnitOfMeasure | UnitOfMeasureOptions;
  isSelection?: ItemSlot["isSelection"];
}

export function newItemSlot(options: ItemSlotOptions = {}, cache: Record<string, any> = {}): ItemSlot {
  const o = (options.__typename ? options : cache["ItemSlot"] = {}) as ItemSlot;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ItemSlot";
  o.id = options.id ?? nextFactoryId("ItemSlot");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.costType = options.costType ?? CostType.Labor;
  o.costTypeDetail = enumOrDetailOfCostType(options.costTypeDetail);
  o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
  o.location = maybeNew("Location", options.location, cache, options.hasOwnProperty("location"));
  o.unitOfMeasure = maybeNew("UnitOfMeasure", options.unitOfMeasure, cache, options.hasOwnProperty("unitOfMeasure"));
  o.isSelection = options.isSelection ?? false;
  return o;
}

factories["ItemSlot"] = newItemSlot;

export interface SaveItemSlotResultOptions {
  __typename?: "SaveItemSlotResult";
  itemSlot?: ItemSlot | ItemSlotOptions;
}

export function newSaveItemSlotResult(
  options: SaveItemSlotResultOptions = {},
  cache: Record<string, any> = {},
): SaveItemSlotResult {
  const o = (options.__typename ? options : cache["SaveItemSlotResult"] = {}) as SaveItemSlotResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveItemSlotResult";
  o.itemSlot = maybeNew("ItemSlot", options.itemSlot, cache, options.hasOwnProperty("itemSlot"));
  return o;
}

factories["SaveItemSlotResult"] = newSaveItemSlotResult;

export interface ItemTemplateOptions {
  __typename?: "ItemTemplate";
  id?: ItemTemplate["id"];
  name?: ItemTemplate["name"];
  createdAt?: ItemTemplate["createdAt"];
  updatedAt?: ItemTemplate["updatedAt"];
  items?: Array<ItemTemplateItem | ItemTemplateItemOptions>;
  status?: ItemTemplate["status"];
  statusDetail?: ItemTemplateStatusDetailOptions | ItemTemplateStatus;
  isPlanTemplate?: ItemTemplate["isPlanTemplate"];
  stage?: ItemTemplate["stage"];
  stageDetail?: StageDetailOptions | Stage;
  description?: ItemTemplate["description"];
  applyTemplatePlan?: Array<ItemTemplateItemPlan | ItemTemplateItemPlanOptions>;
  applyTemplatePlanChangeEvent?: Array<ItemTemplateItemPlan | ItemTemplateItemPlanOptions>;
  development?: Development | DevelopmentOptions | null;
  specOptions?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  totalCostInCents?: ItemTemplate["totalCostInCents"];
  isReadyHomeTemplate?: ItemTemplate["isReadyHomeTemplate"];
  canCopyItemsToTemplate?: PotentialOperation2 | PotentialOperation2Options;
  canApplyTo?: PotentialOperation2 | PotentialOperation2Options;
  canUnlock?: PotentialOperation2 | PotentialOperation2Options;
  canActivate?: PotentialOperation2 | PotentialOperation2Options;
  canCreateNewVersion?: PotentialOperation2 | PotentialOperation2Options;
  canEditLineItems?: PotentialOperation2 | PotentialOperation2Options;
  canDelete?: PotentialOperation2 | PotentialOperation2Options;
  readyPlan?: ReadyPlan | ReadyPlanOptions | null;
  displayName?: ItemTemplate["displayName"];
  hasCloneToTargets?: PotentialOperation2 | PotentialOperation2Options;
  cloneToTargets?: Array<ItemTemplate | ItemTemplateOptions>;
  activatedAt?: ItemTemplate["activatedAt"];
  archivedAt?: ItemTemplate["archivedAt"];
  collection?: ItemTemplateCollection | ItemTemplateCollectionOptions | null;
  itemVersions?: Array<ItemTemplateItemVersion | ItemTemplateItemVersionOptions>;
  major?: ItemTemplate["major"];
  minor?: ItemTemplate["minor"];
  scopeChangeType?: ItemTemplate["scopeChangeType"];
  scopeChangeTypeDetail?: ScopeChangeTypeDetailOptions | ScopeChangeType;
  scopeChangeReason?: ScopeChangeReason | ScopeChangeReasonOptions | null;
  basedOn?: ItemTemplate | ItemTemplateOptions | null;
  templatesBasedOn?: Array<ItemTemplate | ItemTemplateOptions>;
  isVersioned?: ItemTemplate["isVersioned"];
  isLocked?: ItemTemplate["isLocked"];
  appliedToCount?: ItemTemplate["appliedToCount"];
  isLatest?: ItemTemplate["isLatest"];
  isLatestActive?: ItemTemplate["isLatestActive"];
  scopeChangeReasonNote?: ItemTemplate["scopeChangeReasonNote"];
  options?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  version?: ItemTemplate["version"];
  displayVersion?: ItemTemplate["displayVersion"];
  anomalies?: Array<ItemTemplateAnomaly | ItemTemplateAnomalyOptions>;
  contingencyMarkupPercentage?: ItemTemplate["contingencyMarkupPercentage"];
  hasContingencyLineItem?: ItemTemplate["hasContingencyLineItem"];
  sourceForApprovals?: Array<Approval | ApprovalOptions>;
  isUnderwritingTemplate?: ItemTemplate["isUnderwritingTemplate"];
  lastUsedAsUnderwritingTemplate?: ItemTemplate["lastUsedAsUnderwritingTemplate"];
  itemLocations?: Array<Location | LocationOptions>;
  tradeCategories?: Array<TradeCategory | TradeCategoryOptions>;
  costCodes?: Array<CostCode | CostCodeOptions>;
}

export function newItemTemplate(options: ItemTemplateOptions = {}, cache: Record<string, any> = {}): ItemTemplate {
  const o = (options.__typename ? options : cache["ItemTemplate"] = {}) as ItemTemplate;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ItemTemplate";
  o.id = options.id ?? nextFactoryId("ItemTemplate");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.items = (options.items ?? []).map((i) => maybeNew("ItemTemplateItem", i, cache, options.hasOwnProperty("items")));
  o.status = options.status ?? ItemTemplateStatus.Draft;
  o.statusDetail = enumOrDetailOfItemTemplateStatus(options.statusDetail);
  o.isPlanTemplate = options.isPlanTemplate ?? false;
  o.stage = options.stage ?? Stage.PreConPlanning;
  o.stageDetail = enumOrDetailOfStage(options.stageDetail);
  o.description = options.description ?? null;
  o.applyTemplatePlan = (options.applyTemplatePlan ?? []).map((i) =>
    maybeNew("ItemTemplateItemPlan", i, cache, options.hasOwnProperty("applyTemplatePlan"))
  );
  o.applyTemplatePlanChangeEvent = (options.applyTemplatePlanChangeEvent ?? []).map((i) =>
    maybeNew("ItemTemplateItemPlan", i, cache, options.hasOwnProperty("applyTemplatePlanChangeEvent"))
  );
  o.development = maybeNewOrNull("Development", options.development, cache);
  o.specOptions = (options.specOptions ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("specOptions"))
  );
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.isReadyHomeTemplate = options.isReadyHomeTemplate ?? false;
  o.canCopyItemsToTemplate = maybeNew(
    "PotentialOperation2",
    options.canCopyItemsToTemplate,
    cache,
    options.hasOwnProperty("canCopyItemsToTemplate"),
  );
  o.canApplyTo = maybeNew("PotentialOperation2", options.canApplyTo, cache, options.hasOwnProperty("canApplyTo"));
  o.canUnlock = maybeNew("PotentialOperation2", options.canUnlock, cache, options.hasOwnProperty("canUnlock"));
  o.canActivate = maybeNew("PotentialOperation2", options.canActivate, cache, options.hasOwnProperty("canActivate"));
  o.canCreateNewVersion = maybeNew(
    "PotentialOperation2",
    options.canCreateNewVersion,
    cache,
    options.hasOwnProperty("canCreateNewVersion"),
  );
  o.canEditLineItems = maybeNew(
    "PotentialOperation2",
    options.canEditLineItems,
    cache,
    options.hasOwnProperty("canEditLineItems"),
  );
  o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
  o.readyPlan = maybeNewOrNull("ReadyPlan", options.readyPlan, cache);
  o.displayName = options.displayName ?? "displayName";
  o.hasCloneToTargets = maybeNew(
    "PotentialOperation2",
    options.hasCloneToTargets,
    cache,
    options.hasOwnProperty("hasCloneToTargets"),
  );
  o.cloneToTargets = (options.cloneToTargets ?? []).map((i) =>
    maybeNew("ItemTemplate", i, cache, options.hasOwnProperty("cloneToTargets"))
  );
  o.activatedAt = options.activatedAt ?? null;
  o.archivedAt = options.archivedAt ?? null;
  o.collection = maybeNewOrNull("ItemTemplateCollection", options.collection, cache);
  o.itemVersions = (options.itemVersions ?? []).map((i) =>
    maybeNew("ItemTemplateItemVersion", i, cache, options.hasOwnProperty("itemVersions"))
  );
  o.major = options.major ?? 0;
  o.minor = options.minor ?? 0;
  o.scopeChangeType = options.scopeChangeType ?? ScopeChangeType.None;
  o.scopeChangeTypeDetail = enumOrDetailOfScopeChangeType(options.scopeChangeTypeDetail);
  o.scopeChangeReason = maybeNewOrNull("ScopeChangeReason", options.scopeChangeReason, cache);
  o.basedOn = maybeNewOrNull("ItemTemplate", options.basedOn, cache);
  o.templatesBasedOn = (options.templatesBasedOn ?? []).map((i) =>
    maybeNew("ItemTemplate", i, cache, options.hasOwnProperty("templatesBasedOn"))
  );
  o.isVersioned = options.isVersioned ?? false;
  o.isLocked = options.isLocked ?? false;
  o.appliedToCount = options.appliedToCount ?? 0;
  o.isLatest = options.isLatest ?? false;
  o.isLatestActive = options.isLatestActive ?? false;
  o.scopeChangeReasonNote = options.scopeChangeReasonNote ?? null;
  o.options = (options.options ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("options"))
  );
  o.version = options.version ?? "version";
  o.displayVersion = options.displayVersion ?? "displayVersion";
  o.anomalies = (options.anomalies ?? []).map((i) =>
    maybeNew("ItemTemplateAnomaly", i, cache, options.hasOwnProperty("anomalies"))
  );
  o.contingencyMarkupPercentage = options.contingencyMarkupPercentage ?? null;
  o.hasContingencyLineItem = options.hasContingencyLineItem ?? false;
  o.sourceForApprovals = (options.sourceForApprovals ?? []).map((i) =>
    maybeNew("Approval", i, cache, options.hasOwnProperty("sourceForApprovals"))
  );
  o.isUnderwritingTemplate = options.isUnderwritingTemplate ?? false;
  o.lastUsedAsUnderwritingTemplate = options.lastUsedAsUnderwritingTemplate ?? null;
  o.itemLocations = (options.itemLocations ?? []).map((i) =>
    maybeNew("Location", i, cache, options.hasOwnProperty("itemLocations"))
  );
  o.tradeCategories = (options.tradeCategories ?? []).map((i) =>
    maybeNew("TradeCategory", i, cache, options.hasOwnProperty("tradeCategories"))
  );
  o.costCodes = (options.costCodes ?? []).map((i) =>
    maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
  );
  return o;
}

factories["ItemTemplate"] = newItemTemplate;

export interface ItemTemplateItemPlanOptions {
  __typename?: "ItemTemplateItemPlan";
  itemTemplateItem?: ItemTemplateItem | ItemTemplateItemOptions;
  projectItem?: ProjectItem | ProjectItemOptions | null;
}

export function newItemTemplateItemPlan(
  options: ItemTemplateItemPlanOptions = {},
  cache: Record<string, any> = {},
): ItemTemplateItemPlan {
  const o = (options.__typename ? options : cache["ItemTemplateItemPlan"] = {}) as ItemTemplateItemPlan;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ItemTemplateItemPlan";
  o.itemTemplateItem = maybeNew(
    "ItemTemplateItem",
    options.itemTemplateItem,
    cache,
    options.hasOwnProperty("itemTemplateItem"),
  );
  o.projectItem = maybeNewOrNull("ProjectItem", options.projectItem, cache);
  return o;
}

factories["ItemTemplateItemPlan"] = newItemTemplateItemPlan;

export interface SaveItemTemplateResultOptions {
  __typename?: "SaveItemTemplateResult";
  itemTemplate?: ItemTemplate | ItemTemplateOptions;
}

export function newSaveItemTemplateResult(
  options: SaveItemTemplateResultOptions = {},
  cache: Record<string, any> = {},
): SaveItemTemplateResult {
  const o = (options.__typename ? options : cache["SaveItemTemplateResult"] = {}) as SaveItemTemplateResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveItemTemplateResult";
  o.itemTemplate = maybeNew("ItemTemplate", options.itemTemplate, cache, options.hasOwnProperty("itemTemplate"));
  return o;
}

factories["SaveItemTemplateResult"] = newSaveItemTemplateResult;

export interface SaveItemTemplatesResultOptions {
  __typename?: "SaveItemTemplatesResult";
  itemTemplates?: Array<Maybe<ItemTemplate | ItemTemplateOptions>> | null;
}

export function newSaveItemTemplatesResult(
  options: SaveItemTemplatesResultOptions = {},
  cache: Record<string, any> = {},
): SaveItemTemplatesResult {
  const o = (options.__typename ? options : cache["SaveItemTemplatesResult"] = {}) as SaveItemTemplatesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveItemTemplatesResult";
  o.itemTemplates = (options.itemTemplates ?? []).map((i) => maybeNewOrNull("ItemTemplate", i, cache));
  return o;
}

factories["SaveItemTemplatesResult"] = newSaveItemTemplatesResult;

export interface ApplyItemTemplateResultOptions {
  __typename?: "ApplyItemTemplateResult";
  projectItems?: Array<ProjectItem | ProjectItemOptions>;
  projectStage?: ProjectStage | ProjectStageOptions;
  userErrors?: Array<UserError | UserErrorOptions> | null;
}

export function newApplyItemTemplateResult(
  options: ApplyItemTemplateResultOptions = {},
  cache: Record<string, any> = {},
): ApplyItemTemplateResult {
  const o = (options.__typename ? options : cache["ApplyItemTemplateResult"] = {}) as ApplyItemTemplateResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ApplyItemTemplateResult";
  o.projectItems = (options.projectItems ?? []).map((i) =>
    maybeNew("ProjectItem", i, cache, options.hasOwnProperty("projectItems"))
  );
  o.projectStage = maybeNew("ProjectStage", options.projectStage, cache, options.hasOwnProperty("projectStage"));
  o.userErrors = (options.userErrors ?? []).map((i) =>
    maybeNew("UserError", i, cache, options.hasOwnProperty("userErrors"))
  );
  return o;
}

factories["ApplyItemTemplateResult"] = newApplyItemTemplateResult;

export interface ApplyItemTemplateToChangeEventResultOptions {
  __typename?: "ApplyItemTemplateToChangeEventResult";
  lineItems?: Array<ChangeEventLineItem | ChangeEventLineItemOptions>;
  changeEvent?: ChangeEvent | ChangeEventOptions;
}

export function newApplyItemTemplateToChangeEventResult(
  options: ApplyItemTemplateToChangeEventResultOptions = {},
  cache: Record<string, any> = {},
): ApplyItemTemplateToChangeEventResult {
  const o =
    (options.__typename
      ? options
      : cache["ApplyItemTemplateToChangeEventResult"] = {}) as ApplyItemTemplateToChangeEventResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ApplyItemTemplateToChangeEventResult";
  o.lineItems = (options.lineItems ?? []).map((i) =>
    maybeNew("ChangeEventLineItem", i, cache, options.hasOwnProperty("lineItems"))
  );
  o.changeEvent = maybeNew("ChangeEvent", options.changeEvent, cache, options.hasOwnProperty("changeEvent"));
  return o;
}

factories["ApplyItemTemplateToChangeEventResult"] = newApplyItemTemplateToChangeEventResult;

export interface CloneItemTemplateResultOptions {
  __typename?: "CloneItemTemplateResult";
  original?: ItemTemplate | ItemTemplateOptions;
  clone?: ItemTemplate | ItemTemplateOptions;
}

export function newCloneItemTemplateResult(
  options: CloneItemTemplateResultOptions = {},
  cache: Record<string, any> = {},
): CloneItemTemplateResult {
  const o = (options.__typename ? options : cache["CloneItemTemplateResult"] = {}) as CloneItemTemplateResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CloneItemTemplateResult";
  o.original = maybeNew("ItemTemplate", options.original, cache, options.hasOwnProperty("original"));
  o.clone = maybeNew("ItemTemplate", options.clone, cache, options.hasOwnProperty("clone"));
  return o;
}

factories["CloneItemTemplateResult"] = newCloneItemTemplateResult;

export interface CopyItemTemplateItemsResultOptions {
  __typename?: "CopyItemTemplateItemsResult";
  targetTemplate?: ItemTemplate | ItemTemplateOptions;
  sourceTemplates?: Array<ItemTemplate | ItemTemplateOptions>;
  sourceItemVersions?: Array<ItemTemplateItemVersion | ItemTemplateItemVersionOptions>;
  copiedItems?: Array<ItemTemplateItem | ItemTemplateItemOptions>;
  copiedItemVersions?: Array<ItemTemplateItemVersion | ItemTemplateItemVersionOptions>;
}

export function newCopyItemTemplateItemsResult(
  options: CopyItemTemplateItemsResultOptions = {},
  cache: Record<string, any> = {},
): CopyItemTemplateItemsResult {
  const o = (options.__typename ? options : cache["CopyItemTemplateItemsResult"] = {}) as CopyItemTemplateItemsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CopyItemTemplateItemsResult";
  o.targetTemplate = maybeNew("ItemTemplate", options.targetTemplate, cache, options.hasOwnProperty("targetTemplate"));
  o.sourceTemplates = (options.sourceTemplates ?? []).map((i) =>
    maybeNew("ItemTemplate", i, cache, options.hasOwnProperty("sourceTemplates"))
  );
  o.sourceItemVersions = (options.sourceItemVersions ?? []).map((i) =>
    maybeNew("ItemTemplateItemVersion", i, cache, options.hasOwnProperty("sourceItemVersions"))
  );
  o.copiedItems = (options.copiedItems ?? []).map((i) =>
    maybeNew("ItemTemplateItem", i, cache, options.hasOwnProperty("copiedItems"))
  );
  o.copiedItemVersions = (options.copiedItemVersions ?? []).map((i) =>
    maybeNew("ItemTemplateItemVersion", i, cache, options.hasOwnProperty("copiedItemVersions"))
  );
  return o;
}

factories["CopyItemTemplateItemsResult"] = newCopyItemTemplateItemsResult;

export interface CreateNewItemTemplateVersionsResultOptions {
  __typename?: "CreateNewItemTemplateVersionsResult";
  newTemplates?: Array<ItemTemplate | ItemTemplateOptions>;
}

export function newCreateNewItemTemplateVersionsResult(
  options: CreateNewItemTemplateVersionsResultOptions = {},
  cache: Record<string, any> = {},
): CreateNewItemTemplateVersionsResult {
  const o =
    (options.__typename
      ? options
      : cache["CreateNewItemTemplateVersionsResult"] = {}) as CreateNewItemTemplateVersionsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CreateNewItemTemplateVersionsResult";
  o.newTemplates = (options.newTemplates ?? []).map((i) =>
    maybeNew("ItemTemplate", i, cache, options.hasOwnProperty("newTemplates"))
  );
  return o;
}

factories["CreateNewItemTemplateVersionsResult"] = newCreateNewItemTemplateVersionsResult;

export interface ActivateItemTemplateVersionsResultOptions {
  __typename?: "ActivateItemTemplateVersionsResult";
  activatedTemplates?: Array<ItemTemplate | ItemTemplateOptions>;
}

export function newActivateItemTemplateVersionsResult(
  options: ActivateItemTemplateVersionsResultOptions = {},
  cache: Record<string, any> = {},
): ActivateItemTemplateVersionsResult {
  const o =
    (options.__typename
      ? options
      : cache["ActivateItemTemplateVersionsResult"] = {}) as ActivateItemTemplateVersionsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ActivateItemTemplateVersionsResult";
  o.activatedTemplates = (options.activatedTemplates ?? []).map((i) =>
    maybeNew("ItemTemplate", i, cache, options.hasOwnProperty("activatedTemplates"))
  );
  return o;
}

factories["ActivateItemTemplateVersionsResult"] = newActivateItemTemplateVersionsResult;

export interface ItemTemplateAnomalyOptions {
  __typename?: "ItemTemplateAnomaly";
  id?: ItemTemplateAnomaly["id"];
  type?: ItemTemplateAnomaly["type"];
  parent?: ItemTemplateAnomalyParent | ItemTemplateOptions | RequireTypename<ItemTemplateItemVersionOptions>;
  description?: ItemTemplateAnomaly["description"];
}

export function newItemTemplateAnomaly(
  options: ItemTemplateAnomalyOptions = {},
  cache: Record<string, any> = {},
): ItemTemplateAnomaly {
  const o = (options.__typename ? options : cache["ItemTemplateAnomaly"] = {}) as ItemTemplateAnomaly;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ItemTemplateAnomaly";
  o.id = options.id ?? nextFactoryId("ItemTemplateAnomaly");
  o.type = options.type ?? ItemTemplateAnomalyType.TemplateMissingScopeForOption;
  o.parent = maybeNew(options.parent?.__typename ?? "ItemTemplate", options.parent, cache);
  o.description = options.description ?? "description";
  return o;
}

factories["ItemTemplateAnomaly"] = newItemTemplateAnomaly;

export interface ItemTemplateCollectionOptions {
  __typename?: "ItemTemplateCollection";
  id?: ItemTemplateCollection["id"];
  createdAt?: ItemTemplateCollection["createdAt"];
  updatedAt?: ItemTemplateCollection["updatedAt"];
  templates?: Array<ItemTemplate | ItemTemplateOptions>;
  latest?: ItemTemplate | ItemTemplateOptions | null;
}

export function newItemTemplateCollection(
  options: ItemTemplateCollectionOptions = {},
  cache: Record<string, any> = {},
): ItemTemplateCollection {
  const o = (options.__typename ? options : cache["ItemTemplateCollection"] = {}) as ItemTemplateCollection;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ItemTemplateCollection";
  o.id = options.id ?? nextFactoryId("ItemTemplateCollection");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.templates = (options.templates ?? []).map((i) =>
    maybeNew("ItemTemplate", i, cache, options.hasOwnProperty("templates"))
  );
  o.latest = maybeNewOrNull("ItemTemplate", options.latest, cache);
  return o;
}

factories["ItemTemplateCollection"] = newItemTemplateCollection;

export interface ItemTemplateCostUpdateOptions {
  __typename?: "ItemTemplateCostUpdate";
  id?: ItemTemplateCostUpdate["id"];
  completed?: ItemTemplateCostUpdate["completed"];
  createdAt?: ItemTemplateCostUpdate["createdAt"];
  updatedAt?: ItemTemplateCostUpdate["updatedAt"];
  bidContractRevision?: BidContractRevision | BidContractRevisionOptions;
  itemTemplate?: ItemTemplate | ItemTemplateOptions;
}

export function newItemTemplateCostUpdate(
  options: ItemTemplateCostUpdateOptions = {},
  cache: Record<string, any> = {},
): ItemTemplateCostUpdate {
  const o = (options.__typename ? options : cache["ItemTemplateCostUpdate"] = {}) as ItemTemplateCostUpdate;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ItemTemplateCostUpdate";
  o.id = options.id ?? nextFactoryId("ItemTemplateCostUpdate");
  o.completed = options.completed ?? false;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.bidContractRevision = maybeNew(
    "BidContractRevision",
    options.bidContractRevision,
    cache,
    options.hasOwnProperty("bidContractRevision"),
  );
  o.itemTemplate = maybeNew("ItemTemplate", options.itemTemplate, cache, options.hasOwnProperty("itemTemplate"));
  return o;
}

factories["ItemTemplateCostUpdate"] = newItemTemplateCostUpdate;

export interface ItemTemplateItemOptions {
  __typename?: "ItemTemplateItem";
  id?: ItemTemplateItem["id"];
  identityId?: ItemTemplateItem["identityId"];
  slot?: ItemSlot | ItemSlotOptions;
  item?: Item | ItemOptions;
  template?: ItemTemplate | ItemTemplateOptions;
  location?: Location | LocationOptions;
  quantity?: ItemTemplateItem["quantity"];
  createdAt?: ItemTemplateItem["createdAt"];
  updatedAt?: ItemTemplateItem["updatedAt"];
  baseProduct?: Product | ProductOptions | null;
  costType?: ItemTemplateItem["costType"];
  costTypeDetail?: CostTypeDetailOptions | CostType;
  isSelection?: ItemTemplateItem["isSelection"];
  specifications?: ItemTemplateItem["specifications"];
  unitOfMeasure?: UnitOfMeasure | UnitOfMeasureOptions;
  tradePartnerNote?: ItemTemplateItem["tradePartnerNote"];
  internalNote?: ItemTemplateItem["internalNote"];
  name?: ItemTemplateItem["name"];
  displayName?: ItemTemplateItem["displayName"];
  parent?: ItemTemplate | ItemTemplateOptions;
  readyPlan?: ReadyPlan | PlanPackage | DesignPackage | ProductOffering | ReadyPlanLike | ReadyPlanLikeOptions | null;
  first?: ItemTemplate | ItemTemplateOptions;
  totalCostInCents?: ItemTemplateItem["totalCostInCents"];
  unitCostInCents?: ItemTemplateItem["unitCostInCents"];
  canDeleteItem?: PotentialOperation2 | PotentialOperation2Options;
  canEdit?: PotentialOperation2 | PotentialOperation2Options;
  preferredBidContractLineItem?: BidContractLineItem | BidContractLineItemOptions | null;
  identityHash?: ItemTemplateItem["identityHash"];
  majorHash?: ItemTemplateItem["majorHash"];
  minorHash?: ItemTemplateItem["minorHash"];
  versions?: Array<ItemTemplateItemVersion | ItemTemplateItemVersionOptions>;
  basedOn?: ItemTemplateItem | ItemTemplateItemOptions | null;
  itemsBasedOn?: Array<ItemTemplateItem | ItemTemplateItemOptions>;
  original?: ItemTemplateItem | ItemTemplateItemOptions | null;
  bidItem?: BidItem | BidItemOptions | null;
  isDisabledMaterialVariant?: ItemTemplateItem["isDisabledMaterialVariant"];
  potentialBidItems?: Array<BidItem | BidItemOptions>;
  elevationIds?: ItemTemplateItem["elevationIds"];
  specOptionIds?: ItemTemplateItem["specOptionIds"];
  otherOptionIds?: ItemTemplateItem["otherOptionIds"];
  options?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  blueprintUrl?: Url | UrlOptions;
  bidItemTemplateItem?: ItemTemplateItem | ItemTemplateItemOptions | null;
  task?: GlobalPlanTask | GlobalPlanTaskOptions | null;
  costStatus?: ItemTemplateItemCostStatusDetailOptions | ItemTemplateItemCostStatus;
  laborIti?: ItemTemplateItem | ItemTemplateItemOptions | null;
  laborLine?: ItemTemplateItem | ItemTemplateItemOptions | null;
  materialVariant?: MaterialVariant | MaterialVariantOptions | null;
  development?: Development | DevelopmentOptions | null;
  costEstimate?: CostEstimate | CostEstimateOptions;
  customPlaceholderName?: ItemTemplateItem["customPlaceholderName"];
}

export function newItemTemplateItem(
  options: ItemTemplateItemOptions = {},
  cache: Record<string, any> = {},
): ItemTemplateItem {
  const o = (options.__typename ? options : cache["ItemTemplateItem"] = {}) as ItemTemplateItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ItemTemplateItem";
  o.id = options.id ?? nextFactoryId("ItemTemplateItem");
  o.identityId = options.identityId ?? "identityId";
  o.slot = maybeNew("ItemSlot", options.slot, cache, options.hasOwnProperty("slot"));
  o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
  o.template = maybeNew("ItemTemplate", options.template, cache, options.hasOwnProperty("template"));
  o.location = maybeNew("Location", options.location, cache, options.hasOwnProperty("location"));
  o.quantity = options.quantity ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.baseProduct = maybeNewOrNull("Product", options.baseProduct, cache);
  o.costType = options.costType ?? CostType.Labor;
  o.costTypeDetail = enumOrDetailOfCostType(options.costTypeDetail);
  o.isSelection = options.isSelection ?? false;
  o.specifications = options.specifications ?? null;
  o.unitOfMeasure = maybeNew("UnitOfMeasure", options.unitOfMeasure, cache, options.hasOwnProperty("unitOfMeasure"));
  o.tradePartnerNote = options.tradePartnerNote ?? null;
  o.internalNote = options.internalNote ?? null;
  o.name = options.name ?? "name";
  o.displayName = options.displayName ?? "displayName";
  o.parent = maybeNew("ItemTemplate", options.parent, cache, options.hasOwnProperty("parent"));
  o.readyPlan = maybeNewOrNull("ReadyPlanLike", options.readyPlan, cache);
  o.first = maybeNew("ItemTemplate", options.first, cache, options.hasOwnProperty("first"));
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.unitCostInCents = options.unitCostInCents ?? 0;
  o.canDeleteItem = maybeNew(
    "PotentialOperation2",
    options.canDeleteItem,
    cache,
    options.hasOwnProperty("canDeleteItem"),
  );
  o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
  o.preferredBidContractLineItem = maybeNewOrNull("BidContractLineItem", options.preferredBidContractLineItem, cache);
  o.identityHash = options.identityHash ?? null;
  o.majorHash = options.majorHash ?? null;
  o.minorHash = options.minorHash ?? null;
  o.versions = (options.versions ?? []).map((i) =>
    maybeNew("ItemTemplateItemVersion", i, cache, options.hasOwnProperty("versions"))
  );
  o.basedOn = maybeNewOrNull("ItemTemplateItem", options.basedOn, cache);
  o.itemsBasedOn = (options.itemsBasedOn ?? []).map((i) =>
    maybeNew("ItemTemplateItem", i, cache, options.hasOwnProperty("itemsBasedOn"))
  );
  o.original = maybeNewOrNull("ItemTemplateItem", options.original, cache);
  o.bidItem = maybeNewOrNull("BidItem", options.bidItem, cache);
  o.isDisabledMaterialVariant = options.isDisabledMaterialVariant ?? false;
  o.potentialBidItems = (options.potentialBidItems ?? []).map((i) =>
    maybeNew("BidItem", i, cache, options.hasOwnProperty("potentialBidItems"))
  );
  o.elevationIds = options.elevationIds ?? [];
  o.specOptionIds = options.specOptionIds ?? [];
  o.otherOptionIds = options.otherOptionIds ?? [];
  o.options = (options.options ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("options"))
  );
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.bidItemTemplateItem = maybeNewOrNull("ItemTemplateItem", options.bidItemTemplateItem, cache);
  o.task = maybeNewOrNull("GlobalPlanTask", options.task, cache);
  o.costStatus = enumOrDetailOfItemTemplateItemCostStatus(options.costStatus);
  o.laborIti = maybeNewOrNull("ItemTemplateItem", options.laborIti, cache);
  o.laborLine = maybeNewOrNull("ItemTemplateItem", options.laborLine, cache);
  o.materialVariant = maybeNewOrNull("MaterialVariant", options.materialVariant, cache);
  o.development = maybeNewOrNull("Development", options.development, cache);
  o.costEstimate = maybeNew("CostEstimate", options.costEstimate, cache, options.hasOwnProperty("costEstimate"));
  o.customPlaceholderName = options.customPlaceholderName ?? null;
  return o;
}

factories["ItemTemplateItem"] = newItemTemplateItem;

export interface CostEstimateOptions {
  __typename?: "CostEstimate";
  costInCents?: CostEstimate["costInCents"];
}

export function newCostEstimate(options: CostEstimateOptions = {}, cache: Record<string, any> = {}): CostEstimate {
  const o = (options.__typename ? options : cache["CostEstimate"] = {}) as CostEstimate;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CostEstimate";
  o.costInCents = options.costInCents ?? 0;
  return o;
}

factories["CostEstimate"] = newCostEstimate;

export interface ItemTemplateItemVersionsPageOptions {
  __typename?: "ItemTemplateItemVersionsPage";
  items?: Array<ItemTemplateItemVersion | ItemTemplateItemVersionOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
  groupTotals?: Array<ItemTemplateItemVersionGroupTotal | ItemTemplateItemVersionGroupTotalOptions>;
}

export function newItemTemplateItemVersionsPage(
  options: ItemTemplateItemVersionsPageOptions = {},
  cache: Record<string, any> = {},
): ItemTemplateItemVersionsPage {
  const o = (options.__typename ? options : cache["ItemTemplateItemVersionsPage"] = {}) as ItemTemplateItemVersionsPage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ItemTemplateItemVersionsPage";
  o.items = (options.items ?? []).map((i) =>
    maybeNew("ItemTemplateItemVersion", i, cache, options.hasOwnProperty("items"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  o.groupTotals = (options.groupTotals ?? []).map((i) =>
    maybeNew("ItemTemplateItemVersionGroupTotal", i, cache, options.hasOwnProperty("groupTotals"))
  );
  return o;
}

factories["ItemTemplateItemVersionsPage"] = newItemTemplateItemVersionsPage;

export interface ItemTemplateItemVersionGroupTotalOptions {
  __typename?: "ItemTemplateItemVersionGroupTotal";
  groupId?: ItemTemplateItemVersionGroupTotal["groupId"];
  totalCostInCents?: ItemTemplateItemVersionGroupTotal["totalCostInCents"];
  itivsInGroup?: ItemTemplateItemVersionGroupTotal["itivsInGroup"];
  itivIdsInGroup?: ItemTemplateItemVersionGroupTotal["itivIdsInGroup"];
  displayName?: ItemTemplateItemVersionGroupTotal["displayName"];
  materialsInGroup?: ItemTemplateItemVersionGroupTotal["materialsInGroup"];
  tasksInGroup?: ItemTemplateItemVersionGroupTotal["tasksInGroup"];
}

export function newItemTemplateItemVersionGroupTotal(
  options: ItemTemplateItemVersionGroupTotalOptions = {},
  cache: Record<string, any> = {},
): ItemTemplateItemVersionGroupTotal {
  const o =
    (options.__typename
      ? options
      : cache["ItemTemplateItemVersionGroupTotal"] = {}) as ItemTemplateItemVersionGroupTotal;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ItemTemplateItemVersionGroupTotal";
  o.groupId = options.groupId ?? "groupId";
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.itivsInGroup = options.itivsInGroup ?? 0;
  o.itivIdsInGroup = options.itivIdsInGroup ?? [];
  o.displayName = options.displayName ?? "displayName";
  o.materialsInGroup = options.materialsInGroup ?? 0;
  o.tasksInGroup = options.tasksInGroup ?? 0;
  return o;
}

factories["ItemTemplateItemVersionGroupTotal"] = newItemTemplateItemVersionGroupTotal;

export interface ItiAnomalyOptions {
  __typename?: "ItiAnomaly";
  description?: ItiAnomaly["description"];
}

export function newItiAnomaly(options: ItiAnomalyOptions = {}, cache: Record<string, any> = {}): ItiAnomaly {
  const o = (options.__typename ? options : cache["ItiAnomaly"] = {}) as ItiAnomaly;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ItiAnomaly";
  o.description = options.description ?? "description";
  return o;
}

factories["ItiAnomaly"] = newItiAnomaly;

export interface SaveItemTemplateItemVersionsResultOptions {
  __typename?: "SaveItemTemplateItemVersionsResult";
  itemTemplateItemVersions?: Array<ItemTemplateItemVersion | ItemTemplateItemVersionOptions>;
  removed?: Array<ItemTemplateItemVersion | ItemTemplateItemVersionOptions>;
  deleted?: SaveItemTemplateItemVersionsResult["deleted"];
  groupTotals?: Array<ItemTemplateItemVersionGroupTotal | ItemTemplateItemVersionGroupTotalOptions>;
}

export function newSaveItemTemplateItemVersionsResult(
  options: SaveItemTemplateItemVersionsResultOptions = {},
  cache: Record<string, any> = {},
): SaveItemTemplateItemVersionsResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveItemTemplateItemVersionsResult"] = {}) as SaveItemTemplateItemVersionsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveItemTemplateItemVersionsResult";
  o.itemTemplateItemVersions = (options.itemTemplateItemVersions ?? []).map((i) =>
    maybeNew("ItemTemplateItemVersion", i, cache, options.hasOwnProperty("itemTemplateItemVersions"))
  );
  o.removed = (options.removed ?? []).map((i) =>
    maybeNew("ItemTemplateItemVersion", i, cache, options.hasOwnProperty("removed"))
  );
  o.deleted = options.deleted ?? [];
  o.groupTotals = (options.groupTotals ?? []).map((i) =>
    maybeNew("ItemTemplateItemVersionGroupTotal", i, cache, options.hasOwnProperty("groupTotals"))
  );
  return o;
}

factories["SaveItemTemplateItemVersionsResult"] = newSaveItemTemplateItemVersionsResult;

export interface DedupeReadyPlanItemTemplateItemVersionsResultOptions {
  __typename?: "DedupeReadyPlanItemTemplateItemVersionsResult";
  dedupedItemTemplateItemVersions?: Array<DedupedItemTemplateItemVersion | DedupedItemTemplateItemVersionOptions>;
  affectedTemplates?: Array<ItemTemplate | ItemTemplateOptions>;
  affectedDevelopments?: Array<Development | DevelopmentOptions>;
  affectedReadyPlans?: Array<ReadyPlan | ReadyPlanOptions>;
}

export function newDedupeReadyPlanItemTemplateItemVersionsResult(
  options: DedupeReadyPlanItemTemplateItemVersionsResultOptions = {},
  cache: Record<string, any> = {},
): DedupeReadyPlanItemTemplateItemVersionsResult {
  const o =
    (options.__typename
      ? options
      : cache["DedupeReadyPlanItemTemplateItemVersionsResult"] = {}) as DedupeReadyPlanItemTemplateItemVersionsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DedupeReadyPlanItemTemplateItemVersionsResult";
  o.dedupedItemTemplateItemVersions = (options.dedupedItemTemplateItemVersions ?? []).map((i) =>
    maybeNew("DedupedItemTemplateItemVersion", i, cache, options.hasOwnProperty("dedupedItemTemplateItemVersions"))
  );
  o.affectedTemplates = (options.affectedTemplates ?? []).map((i) =>
    maybeNew("ItemTemplate", i, cache, options.hasOwnProperty("affectedTemplates"))
  );
  o.affectedDevelopments = (options.affectedDevelopments ?? []).map((i) =>
    maybeNew("Development", i, cache, options.hasOwnProperty("affectedDevelopments"))
  );
  o.affectedReadyPlans = (options.affectedReadyPlans ?? []).map((i) =>
    maybeNew("ReadyPlan", i, cache, options.hasOwnProperty("affectedReadyPlans"))
  );
  return o;
}

factories["DedupeReadyPlanItemTemplateItemVersionsResult"] = newDedupeReadyPlanItemTemplateItemVersionsResult;

export interface DedupedItemTemplateItemVersionOptions {
  __typename?: "DedupedItemTemplateItemVersion";
  primary?: ItemTemplateItemVersion | ItemTemplateItemVersionOptions;
  removes?: Array<ItemTemplateItemVersion | ItemTemplateItemVersionOptions>;
}

export function newDedupedItemTemplateItemVersion(
  options: DedupedItemTemplateItemVersionOptions = {},
  cache: Record<string, any> = {},
): DedupedItemTemplateItemVersion {
  const o =
    (options.__typename ? options : cache["DedupedItemTemplateItemVersion"] = {}) as DedupedItemTemplateItemVersion;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DedupedItemTemplateItemVersion";
  o.primary = maybeNew("ItemTemplateItemVersion", options.primary, cache, options.hasOwnProperty("primary"));
  o.removes = (options.removes ?? []).map((i) =>
    maybeNew("ItemTemplateItemVersion", i, cache, options.hasOwnProperty("removes"))
  );
  return o;
}

factories["DedupedItemTemplateItemVersion"] = newDedupedItemTemplateItemVersion;

export interface JobLogOptions {
  __typename?: "JobLog";
  id?: JobLog["id"];
  logDate?: JobLog["logDate"];
  createdAt?: JobLog["createdAt"];
  updatedAt?: JobLog["updatedAt"];
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  notes?: Array<JobLogNote | JobLogNoteOptions>;
  images?: Array<JobLogImage | JobLogImageOptions>;
  minTemperature?: JobLog["minTemperature"];
  maxTemperature?: JobLog["maxTemperature"];
  humidity?: JobLog["humidity"];
  wind?: JobLog["wind"];
  weatherType?: JobLog["weatherType"];
  weatherTypeDetail?: WeatherTypeDetailOptions | WeatherType | null;
  weatherTypeChanged?: JobLog["weatherTypeChanged"];
}

export function newJobLog(options: JobLogOptions = {}, cache: Record<string, any> = {}): JobLog {
  const o = (options.__typename ? options : cache["JobLog"] = {}) as JobLog;
  (cache.all ??= new Set()).add(o);
  o.__typename = "JobLog";
  o.id = options.id ?? nextFactoryId("JobLog");
  o.logDate = options.logDate ?? newDate();
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.notes = (options.notes ?? []).map((i) => maybeNew("JobLogNote", i, cache, options.hasOwnProperty("notes")));
  o.images = (options.images ?? []).map((i) => maybeNew("JobLogImage", i, cache, options.hasOwnProperty("images")));
  o.minTemperature = options.minTemperature ?? null;
  o.maxTemperature = options.maxTemperature ?? null;
  o.humidity = options.humidity ?? null;
  o.wind = options.wind ?? null;
  o.weatherType = options.weatherType ?? null;
  o.weatherTypeDetail = enumOrDetailOrNullOfWeatherType(options.weatherTypeDetail);
  o.weatherTypeChanged = options.weatherTypeChanged ?? null;
  return o;
}

factories["JobLog"] = newJobLog;

export interface SaveJobLogResultOptions {
  __typename?: "SaveJobLogResult";
  jobLog?: JobLog | JobLogOptions;
}

export function newSaveJobLogResult(
  options: SaveJobLogResultOptions = {},
  cache: Record<string, any> = {},
): SaveJobLogResult {
  const o = (options.__typename ? options : cache["SaveJobLogResult"] = {}) as SaveJobLogResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveJobLogResult";
  o.jobLog = maybeNew("JobLog", options.jobLog, cache, options.hasOwnProperty("jobLog"));
  return o;
}

factories["SaveJobLogResult"] = newSaveJobLogResult;

export interface DuplicateJobLogsResultOptions {
  __typename?: "DuplicateJobLogsResult";
  jobLog?: JobLog | JobLogOptions;
  clonedJobLogs?: Array<JobLog | JobLogOptions>;
  copiedJobLogs?: Array<JobLog | JobLogOptions>;
}

export function newDuplicateJobLogsResult(
  options: DuplicateJobLogsResultOptions = {},
  cache: Record<string, any> = {},
): DuplicateJobLogsResult {
  const o = (options.__typename ? options : cache["DuplicateJobLogsResult"] = {}) as DuplicateJobLogsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DuplicateJobLogsResult";
  o.jobLog = maybeNew("JobLog", options.jobLog, cache, options.hasOwnProperty("jobLog"));
  o.clonedJobLogs = (options.clonedJobLogs ?? []).map((i) =>
    maybeNew("JobLog", i, cache, options.hasOwnProperty("clonedJobLogs"))
  );
  o.copiedJobLogs = (options.copiedJobLogs ?? []).map((i) =>
    maybeNew("JobLog", i, cache, options.hasOwnProperty("copiedJobLogs"))
  );
  return o;
}

factories["DuplicateJobLogsResult"] = newDuplicateJobLogsResult;

export interface JobLogsPageResultOptions {
  __typename?: "JobLogsPageResult";
  entities?: Array<JobLog | JobLogOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
  logDates?: JobLogsPageResult["logDates"];
}

export function newJobLogsPageResult(
  options: JobLogsPageResultOptions = {},
  cache: Record<string, any> = {},
): JobLogsPageResult {
  const o = (options.__typename ? options : cache["JobLogsPageResult"] = {}) as JobLogsPageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "JobLogsPageResult";
  o.entities = (options.entities ?? []).map((i) => maybeNew("JobLog", i, cache, options.hasOwnProperty("entities")));
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  o.logDates = options.logDates ?? [];
  return o;
}

factories["JobLogsPageResult"] = newJobLogsPageResult;

export interface JobLogImageOptions {
  __typename?: "JobLogImage";
  id?: JobLogImage["id"];
  createdAt?: JobLogImage["createdAt"];
  updatedAt?: JobLogImage["updatedAt"];
  asset?: Asset | AssetOptions;
  jobLog?: JobLog | JobLogOptions;
  parent?: JobLogImageParent | JobLogOptions | RequireTypename<JobLogNoteOptions> | null;
  sightlineJobId?: JobLogImage["sightlineJobId"];
  sightlineUrl?: JobLogImage["sightlineUrl"];
}

export function newJobLogImage(options: JobLogImageOptions = {}, cache: Record<string, any> = {}): JobLogImage {
  const o = (options.__typename ? options : cache["JobLogImage"] = {}) as JobLogImage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "JobLogImage";
  o.id = options.id ?? nextFactoryId("JobLogImage");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.asset = maybeNew("Asset", options.asset, cache, options.hasOwnProperty("asset"));
  o.jobLog = maybeNew("JobLog", options.jobLog, cache, options.hasOwnProperty("jobLog"));
  o.parent = maybeNewOrNull(options.parent?.__typename ?? "JobLog", options.parent, cache);
  o.sightlineJobId = options.sightlineJobId ?? null;
  o.sightlineUrl = options.sightlineUrl ?? null;
  return o;
}

factories["JobLogImage"] = newJobLogImage;

export interface SaveJobLogImageResultOptions {
  __typename?: "SaveJobLogImageResult";
  jobLogImage?: JobLogImage | JobLogImageOptions;
}

export function newSaveJobLogImageResult(
  options: SaveJobLogImageResultOptions = {},
  cache: Record<string, any> = {},
): SaveJobLogImageResult {
  const o = (options.__typename ? options : cache["SaveJobLogImageResult"] = {}) as SaveJobLogImageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveJobLogImageResult";
  o.jobLogImage = maybeNew("JobLogImage", options.jobLogImage, cache, options.hasOwnProperty("jobLogImage"));
  return o;
}

factories["SaveJobLogImageResult"] = newSaveJobLogImageResult;

export interface DeleteJobLogImageResultOptions {
  __typename?: "DeleteJobLogImageResult";
  jobLog?: JobLog | JobLogOptions;
  parent?: JobLogImageParent | JobLogOptions | RequireTypename<JobLogNoteOptions> | null;
}

export function newDeleteJobLogImageResult(
  options: DeleteJobLogImageResultOptions = {},
  cache: Record<string, any> = {},
): DeleteJobLogImageResult {
  const o = (options.__typename ? options : cache["DeleteJobLogImageResult"] = {}) as DeleteJobLogImageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeleteJobLogImageResult";
  o.jobLog = maybeNew("JobLog", options.jobLog, cache, options.hasOwnProperty("jobLog"));
  o.parent = maybeNewOrNull(options.parent?.__typename ?? "JobLog", options.parent, cache);
  return o;
}

factories["DeleteJobLogImageResult"] = newDeleteJobLogImageResult;

export interface SaveJobLogNoteResultOptions {
  __typename?: "SaveJobLogNoteResult";
  jobLogNote?: JobLogNote | JobLogNoteOptions;
}

export function newSaveJobLogNoteResult(
  options: SaveJobLogNoteResultOptions = {},
  cache: Record<string, any> = {},
): SaveJobLogNoteResult {
  const o = (options.__typename ? options : cache["SaveJobLogNoteResult"] = {}) as SaveJobLogNoteResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveJobLogNoteResult";
  o.jobLogNote = maybeNew("JobLogNote", options.jobLogNote, cache, options.hasOwnProperty("jobLogNote"));
  return o;
}

factories["SaveJobLogNoteResult"] = newSaveJobLogNoteResult;

export interface DeleteJobLogNoteResultOptions {
  __typename?: "DeleteJobLogNoteResult";
  jobLog?: JobLog | JobLogOptions;
}

export function newDeleteJobLogNoteResult(
  options: DeleteJobLogNoteResultOptions = {},
  cache: Record<string, any> = {},
): DeleteJobLogNoteResult {
  const o = (options.__typename ? options : cache["DeleteJobLogNoteResult"] = {}) as DeleteJobLogNoteResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeleteJobLogNoteResult";
  o.jobLog = maybeNew("JobLog", options.jobLog, cache, options.hasOwnProperty("jobLog"));
  return o;
}

factories["DeleteJobLogNoteResult"] = newDeleteJobLogNoteResult;

export interface LienWaiverOptions {
  __typename?: "LienWaiver";
  id?: LienWaiver["id"];
  amountInCents?: LienWaiver["amountInCents"];
  createdAt?: LienWaiver["createdAt"];
  updatedAt?: LienWaiver["updatedAt"];
  condition?: LienWaiverConditionDetailOptions | LienWaiverCondition;
  type?: LienWaiverTypeDetailOptions | LienWaiverType;
  pandaDoc?: PandaDoc | PandaDocOptions | null;
  status?: LienWaiverStatusDetailOptions | LienWaiverStatus;
  document?: Document | DocumentOptions | null;
  parent?:
    | LienWaiverParent
    | StandaloneProjectOptions
    | RequireTypename<RegionOptions>
    | RequireTypename<BillOptions>
    | RequireTypename<InvoiceOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  throughDate?: LienWaiver["throughDate"];
  claimant?: LienWaiverClaimant | BuilderOptions | RequireTypename<TradePartnerOptions>;
  payer?: LienWaiverPayer | BuilderOptions | RequireTypename<ClientOptions>;
  payerName?: LienWaiver["payerName"];
  owner?: LienWaiverOwner | CustomerOptions | RequireTypename<ClientOptions>;
  signatory?: LienWaiverSignatory | InternalUserOptions | RequireTypename<TradePartnerContactOptions> | null;
  canCreatePandaDoc?: PotentialOperation2 | PotentialOperation2Options;
}

export function newLienWaiver(options: LienWaiverOptions = {}, cache: Record<string, any> = {}): LienWaiver {
  const o = (options.__typename ? options : cache["LienWaiver"] = {}) as LienWaiver;
  (cache.all ??= new Set()).add(o);
  o.__typename = "LienWaiver";
  o.id = options.id ?? nextFactoryId("LienWaiver");
  o.amountInCents = options.amountInCents ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.condition = enumOrDetailOfLienWaiverCondition(options.condition);
  o.type = enumOrDetailOfLienWaiverType(options.type);
  o.pandaDoc = maybeNewOrNull("PandaDoc", options.pandaDoc, cache);
  o.status = enumOrDetailOfLienWaiverStatus(options.status);
  o.document = maybeNewOrNull("Document", options.document, cache);
  o.parent = maybeNew(options.parent?.__typename ?? "StandaloneProject", options.parent, cache);
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.throughDate = options.throughDate ?? null;
  o.claimant = maybeNew(options.claimant?.__typename ?? "Builder", options.claimant, cache);
  o.payer = maybeNew(options.payer?.__typename ?? "Builder", options.payer, cache);
  o.payerName = options.payerName ?? "payerName";
  o.owner = maybeNew(options.owner?.__typename ?? "Customer", options.owner, cache);
  o.signatory = maybeNewOrNull(options.signatory?.__typename ?? "InternalUser", options.signatory, cache);
  o.canCreatePandaDoc = maybeNew(
    "PotentialOperation2",
    options.canCreatePandaDoc,
    cache,
    options.hasOwnProperty("canCreatePandaDoc"),
  );
  return o;
}

factories["LienWaiver"] = newLienWaiver;

export interface SaveLienWaiverResultOptions {
  __typename?: "SaveLienWaiverResult";
  lienWaiver?: LienWaiver | LienWaiverOptions;
}

export function newSaveLienWaiverResult(
  options: SaveLienWaiverResultOptions = {},
  cache: Record<string, any> = {},
): SaveLienWaiverResult {
  const o = (options.__typename ? options : cache["SaveLienWaiverResult"] = {}) as SaveLienWaiverResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveLienWaiverResult";
  o.lienWaiver = maybeNew("LienWaiver", options.lienWaiver, cache, options.hasOwnProperty("lienWaiver"));
  return o;
}

factories["SaveLienWaiverResult"] = newSaveLienWaiverResult;

export interface LienWaiversPageOptions {
  __typename?: "LienWaiversPage";
  entities?: Array<LienWaiver | LienWaiverOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newLienWaiversPage(
  options: LienWaiversPageOptions = {},
  cache: Record<string, any> = {},
): LienWaiversPage {
  const o = (options.__typename ? options : cache["LienWaiversPage"] = {}) as LienWaiversPage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "LienWaiversPage";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("LienWaiver", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["LienWaiversPage"] = newLienWaiversPage;

export interface SaveLocationsResultOptions {
  __typename?: "SaveLocationsResult";
  locations?: Array<Location | LocationOptions>;
}

export function newSaveLocationsResult(
  options: SaveLocationsResultOptions = {},
  cache: Record<string, any> = {},
): SaveLocationsResult {
  const o = (options.__typename ? options : cache["SaveLocationsResult"] = {}) as SaveLocationsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveLocationsResult";
  o.locations = (options.locations ?? []).map((i) =>
    maybeNew("Location", i, cache, options.hasOwnProperty("locations"))
  );
  return o;
}

factories["SaveLocationsResult"] = newSaveLocationsResult;

export interface LocationOptions {
  __typename?: "Location";
  id?: Location["id"];
  name?: Location["name"];
  image?: Asset | AssetOptions | null;
  isWholeHouse?: Location["isWholeHouse"];
  supportsRendering?: Location["supportsRendering"];
  code?: Location["code"];
  effectiveCode?: Location["effectiveCode"];
  version?: Location["version"];
  type?: LocationTypeDetailOptions | LocationType;
  parent?: Location | LocationOptions | null;
  parents?: Array<Location | LocationOptions>;
  path?: Location["path"];
  pathAsCode?: Location["pathAsCode"];
  pathArray?: Location["pathArray"];
  pathIds?: Location["pathIds"];
  group?: Location | LocationOptions | null;
  level?: Location | LocationOptions | null;
  room?: Location | LocationOptions | null;
  displayLocationPath?: Location["displayLocationPath"];
  locations?: Array<Location | LocationOptions>;
  roomTypes?: Array<RoomType | RoomTypeOptions>;
  feature?: Location | LocationOptions | null;
  effectiveLocation?: Location | LocationOptions;
  nonScopeLocation?: Location | LocationOptions;
  isNonStructural?: Location["isNonStructural"];
  materialVariant?: MaterialVariant | MaterialVariantOptions | null;
  isModifiedRoom?: Location["isModifiedRoom"];
}

export function newLocation(options: LocationOptions = {}, cache: Record<string, any> = {}): Location {
  const o = (options.__typename ? options : cache["Location"] = {}) as Location;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Location";
  o.id = options.id ?? nextFactoryId("Location");
  o.name = options.name ?? "name";
  o.image = maybeNewOrNull("Asset", options.image, cache);
  o.isWholeHouse = options.isWholeHouse ?? false;
  o.supportsRendering = options.supportsRendering ?? false;
  o.code = options.code ?? null;
  o.effectiveCode = options.effectiveCode ?? "effectiveCode";
  o.version = options.version ?? 0;
  o.type = enumOrDetailOfLocationType(options.type);
  o.parent = maybeNewOrNull("Location", options.parent, cache);
  o.parents = (options.parents ?? []).map((i) => maybeNew("Location", i, cache, options.hasOwnProperty("parents")));
  o.path = options.path ?? null;
  o.pathAsCode = options.pathAsCode ?? null;
  o.pathArray = options.pathArray ?? [];
  o.pathIds = options.pathIds ?? [];
  o.group = maybeNewOrNull("Location", options.group, cache);
  o.level = maybeNewOrNull("Location", options.level, cache);
  o.room = maybeNewOrNull("Location", options.room, cache);
  o.displayLocationPath = options.displayLocationPath ?? "displayLocationPath";
  o.locations = (options.locations ?? []).map((i) =>
    maybeNew("Location", i, cache, options.hasOwnProperty("locations"))
  );
  o.roomTypes = (options.roomTypes ?? []).map((i) =>
    maybeNew("RoomType", i, cache, options.hasOwnProperty("roomTypes"))
  );
  o.feature = maybeNewOrNull("Location", options.feature, cache);
  o.effectiveLocation = maybeNew(
    "Location",
    options.effectiveLocation,
    cache,
    options.hasOwnProperty("effectiveLocation"),
  );
  o.nonScopeLocation = maybeNew(
    "Location",
    options.nonScopeLocation,
    cache,
    options.hasOwnProperty("nonScopeLocation"),
  );
  o.isNonStructural = options.isNonStructural ?? null;
  o.materialVariant = maybeNewOrNull("MaterialVariant", options.materialVariant, cache);
  o.isModifiedRoom = options.isModifiedRoom ?? false;
  return o;
}

factories["Location"] = newLocation;

export interface SaveLotResultOptions {
  __typename?: "SaveLotResult";
  lot?: Lot | LotOptions;
}

export function newSaveLotResult(options: SaveLotResultOptions = {}, cache: Record<string, any> = {}): SaveLotResult {
  const o = (options.__typename ? options : cache["SaveLotResult"] = {}) as SaveLotResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveLotResult";
  o.lot = maybeNew("Lot", options.lot, cache, options.hasOwnProperty("lot"));
  return o;
}

factories["SaveLotResult"] = newSaveLotResult;

export interface LotRatingOptions {
  __typename?: "LotRating";
  id?: LotRating["id"];
  grade?: LotRating["grade"];
  description?: LotRating["description"];
  createdAt?: LotRating["createdAt"];
  updatedAt?: LotRating["updatedAt"];
  projects?: Array<StandaloneProject | StandaloneProjectOptions>;
}

export function newLotRating(options: LotRatingOptions = {}, cache: Record<string, any> = {}): LotRating {
  const o = (options.__typename ? options : cache["LotRating"] = {}) as LotRating;
  (cache.all ??= new Set()).add(o);
  o.__typename = "LotRating";
  o.id = options.id ?? nextFactoryId("LotRating");
  o.grade = options.grade ?? "grade";
  o.description = options.description ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.projects = (options.projects ?? []).map((i) =>
    maybeNew("StandaloneProject", i, cache, options.hasOwnProperty("projects"))
  );
  return o;
}

factories["LotRating"] = newLotRating;

export interface SaveLotRatingResultOptions {
  __typename?: "SaveLotRatingResult";
  lotRating?: LotRating | LotRatingOptions;
}

export function newSaveLotRatingResult(
  options: SaveLotRatingResultOptions = {},
  cache: Record<string, any> = {},
): SaveLotRatingResult {
  const o = (options.__typename ? options : cache["SaveLotRatingResult"] = {}) as SaveLotRatingResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveLotRatingResult";
  o.lotRating = maybeNew("LotRating", options.lotRating, cache, options.hasOwnProperty("lotRating"));
  return o;
}

factories["SaveLotRatingResult"] = newSaveLotRatingResult;

export interface SaveMarketResultOptions {
  __typename?: "SaveMarketResult";
  market?: Market | MarketOptions;
}

export function newSaveMarketResult(
  options: SaveMarketResultOptions = {},
  cache: Record<string, any> = {},
): SaveMarketResult {
  const o = (options.__typename ? options : cache["SaveMarketResult"] = {}) as SaveMarketResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveMarketResult";
  o.market = maybeNew("Market", options.market, cache, options.hasOwnProperty("market"));
  return o;
}

factories["SaveMarketResult"] = newSaveMarketResult;

export interface MaterialAssemblyComponentOptions {
  __typename?: "MaterialAssemblyComponent";
  id?: MaterialAssemblyComponent["id"];
  createdAt?: MaterialAssemblyComponent["createdAt"];
  updatedAt?: MaterialAssemblyComponent["updatedAt"];
  assembly?: MaterialVariant | MaterialVariantOptions;
  component?: MaterialVariant | MaterialVariantOptions;
  name?: MaterialAssemblyComponent["name"];
  qualifier?: MaterialAssemblyComponent["qualifier"];
}

export function newMaterialAssemblyComponent(
  options: MaterialAssemblyComponentOptions = {},
  cache: Record<string, any> = {},
): MaterialAssemblyComponent {
  const o = (options.__typename ? options : cache["MaterialAssemblyComponent"] = {}) as MaterialAssemblyComponent;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MaterialAssemblyComponent";
  o.id = options.id ?? nextFactoryId("MaterialAssemblyComponent");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.assembly = maybeNew("MaterialVariant", options.assembly, cache, options.hasOwnProperty("assembly"));
  o.component = maybeNew("MaterialVariant", options.component, cache, options.hasOwnProperty("component"));
  o.name = options.name ?? null;
  o.qualifier = options.qualifier ?? null;
  return o;
}

factories["MaterialAssemblyComponent"] = newMaterialAssemblyComponent;

export interface SaveMaterialAssemblyComponentResultOptions {
  __typename?: "SaveMaterialAssemblyComponentResult";
  materialAssemblyComponent?: MaterialAssemblyComponent | MaterialAssemblyComponentOptions;
}

export function newSaveMaterialAssemblyComponentResult(
  options: SaveMaterialAssemblyComponentResultOptions = {},
  cache: Record<string, any> = {},
): SaveMaterialAssemblyComponentResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveMaterialAssemblyComponentResult"] = {}) as SaveMaterialAssemblyComponentResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveMaterialAssemblyComponentResult";
  o.materialAssemblyComponent = maybeNew(
    "MaterialAssemblyComponent",
    options.materialAssemblyComponent,
    cache,
    options.hasOwnProperty("materialAssemblyComponent"),
  );
  return o;
}

factories["SaveMaterialAssemblyComponentResult"] = newSaveMaterialAssemblyComponentResult;

export interface MaterialAttributeDimensionOptions {
  __typename?: "MaterialAttributeDimension";
  id?: MaterialAttributeDimension["id"];
  name?: MaterialAttributeDimension["name"];
  createdAt?: MaterialAttributeDimension["createdAt"];
  updatedAt?: MaterialAttributeDimension["updatedAt"];
  item?: Item | ItemOptions;
  values?: Array<MaterialAttributeValue | MaterialAttributeValueOptions>;
  isAdminManaged?: MaterialAttributeDimension["isAdminManaged"];
  unitOfMeasure?: UnitOfMeasure | UnitOfMeasureOptions | null;
  sortOrder?: MaterialAttributeDimension["sortOrder"];
  type?: MaterialAttributeDimensionTypeDetailOptions | MaterialAttributeDimensionType;
  useInTakeoff?: MaterialAttributeDimension["useInTakeoff"];
  useInVisualModePdf?: MaterialAttributeDimension["useInVisualModePdf"];
  showInFinishSchedule?: MaterialAttributeDimension["showInFinishSchedule"];
  showInCabinetsInfo?: MaterialAttributeDimension["showInCabinetsInfo"];
  copiedFromChildModifier?: MaterialAttributeDimension | MaterialAttributeDimensionOptions | null;
}

export function newMaterialAttributeDimension(
  options: MaterialAttributeDimensionOptions = {},
  cache: Record<string, any> = {},
): MaterialAttributeDimension {
  const o = (options.__typename ? options : cache["MaterialAttributeDimension"] = {}) as MaterialAttributeDimension;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MaterialAttributeDimension";
  o.id = options.id ?? nextFactoryId("MaterialAttributeDimension");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
  o.values = (options.values ?? []).map((i) =>
    maybeNew("MaterialAttributeValue", i, cache, options.hasOwnProperty("values"))
  );
  o.isAdminManaged = options.isAdminManaged ?? false;
  o.unitOfMeasure = maybeNewOrNull("UnitOfMeasure", options.unitOfMeasure, cache);
  o.sortOrder = options.sortOrder ?? 0;
  o.type = enumOrDetailOfMaterialAttributeDimensionType(options.type);
  o.useInTakeoff = options.useInTakeoff ?? false;
  o.useInVisualModePdf = options.useInVisualModePdf ?? false;
  o.showInFinishSchedule = options.showInFinishSchedule ?? false;
  o.showInCabinetsInfo = options.showInCabinetsInfo ?? false;
  o.copiedFromChildModifier = maybeNewOrNull("MaterialAttributeDimension", options.copiedFromChildModifier, cache);
  return o;
}

factories["MaterialAttributeDimension"] = newMaterialAttributeDimension;

export interface SaveMaterialAttributeDimensionResultOptions {
  __typename?: "SaveMaterialAttributeDimensionResult";
  materialAttributeDimension?: MaterialAttributeDimension | MaterialAttributeDimensionOptions;
}

export function newSaveMaterialAttributeDimensionResult(
  options: SaveMaterialAttributeDimensionResultOptions = {},
  cache: Record<string, any> = {},
): SaveMaterialAttributeDimensionResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveMaterialAttributeDimensionResult"] = {}) as SaveMaterialAttributeDimensionResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveMaterialAttributeDimensionResult";
  o.materialAttributeDimension = maybeNew(
    "MaterialAttributeDimension",
    options.materialAttributeDimension,
    cache,
    options.hasOwnProperty("materialAttributeDimension"),
  );
  return o;
}

factories["SaveMaterialAttributeDimensionResult"] = newSaveMaterialAttributeDimensionResult;

export interface SaveMaterialAttributeDimensionResultsOptions {
  __typename?: "SaveMaterialAttributeDimensionResults";
  materialAttributeDimensions?: Array<MaterialAttributeDimension | MaterialAttributeDimensionOptions>;
}

export function newSaveMaterialAttributeDimensionResults(
  options: SaveMaterialAttributeDimensionResultsOptions = {},
  cache: Record<string, any> = {},
): SaveMaterialAttributeDimensionResults {
  const o =
    (options.__typename
      ? options
      : cache["SaveMaterialAttributeDimensionResults"] = {}) as SaveMaterialAttributeDimensionResults;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveMaterialAttributeDimensionResults";
  o.materialAttributeDimensions = (options.materialAttributeDimensions ?? []).map((i) =>
    maybeNew("MaterialAttributeDimension", i, cache, options.hasOwnProperty("materialAttributeDimensions"))
  );
  return o;
}

factories["SaveMaterialAttributeDimensionResults"] = newSaveMaterialAttributeDimensionResults;

export interface MaterialAttributeValueOptions {
  __typename?: "MaterialAttributeValue";
  id?: MaterialAttributeValue["id"];
  value?: MaterialAttributeValue["value"];
  textValue?: MaterialAttributeValue["textValue"];
  valueWithUom?: MaterialAttributeValue["valueWithUom"];
  createdAt?: MaterialAttributeValue["createdAt"];
  updatedAt?: MaterialAttributeValue["updatedAt"];
  dimension?: MaterialAttributeDimension | MaterialAttributeDimensionOptions;
  materialVariants?: Array<MaterialVariant | MaterialVariantOptions>;
  code?: MaterialAttributeValue["code"];
  type?: MaterialAttributeValueTypeDetailOptions | MaterialAttributeValueType;
  min?: MaterialAttributeValue["min"];
  max?: MaterialAttributeValue["max"];
}

export function newMaterialAttributeValue(
  options: MaterialAttributeValueOptions = {},
  cache: Record<string, any> = {},
): MaterialAttributeValue {
  const o = (options.__typename ? options : cache["MaterialAttributeValue"] = {}) as MaterialAttributeValue;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MaterialAttributeValue";
  o.id = options.id ?? nextFactoryId("MaterialAttributeValue");
  o.value = options.value ?? "value";
  o.textValue = options.textValue ?? "textValue";
  o.valueWithUom = options.valueWithUom ?? "valueWithUom";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.dimension = maybeNew("MaterialAttributeDimension", options.dimension, cache, options.hasOwnProperty("dimension"));
  o.materialVariants = (options.materialVariants ?? []).map((i) =>
    maybeNew("MaterialVariant", i, cache, options.hasOwnProperty("materialVariants"))
  );
  o.code = options.code ?? null;
  o.type = enumOrDetailOfMaterialAttributeValueType(options.type);
  o.min = options.min ?? null;
  o.max = options.max ?? null;
  return o;
}

factories["MaterialAttributeValue"] = newMaterialAttributeValue;

export interface SaveMaterialAttributeValueResultOptions {
  __typename?: "SaveMaterialAttributeValueResult";
  materialAttributeValue?: MaterialAttributeValue | MaterialAttributeValueOptions;
}

export function newSaveMaterialAttributeValueResult(
  options: SaveMaterialAttributeValueResultOptions = {},
  cache: Record<string, any> = {},
): SaveMaterialAttributeValueResult {
  const o =
    (options.__typename ? options : cache["SaveMaterialAttributeValueResult"] = {}) as SaveMaterialAttributeValueResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveMaterialAttributeValueResult";
  o.materialAttributeValue = maybeNew(
    "MaterialAttributeValue",
    options.materialAttributeValue,
    cache,
    options.hasOwnProperty("materialAttributeValue"),
  );
  return o;
}

factories["SaveMaterialAttributeValueResult"] = newSaveMaterialAttributeValueResult;

export interface BackfillResponseOptions {
  __typename?: "BackfillResponse";
  processed?: BackfillResponse["processed"];
  skipped?: BackfillResponse["skipped"];
}

export function newBackfillResponse(
  options: BackfillResponseOptions = {},
  cache: Record<string, any> = {},
): BackfillResponse {
  const o = (options.__typename ? options : cache["BackfillResponse"] = {}) as BackfillResponse;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BackfillResponse";
  o.processed = options.processed ?? 0;
  o.skipped = options.skipped ?? 0;
  return o;
}

factories["BackfillResponse"] = newBackfillResponse;

export interface MaterialBrandOptions {
  __typename?: "MaterialBrand";
  id?: MaterialBrand["id"];
  name?: MaterialBrand["name"];
  abbreviation?: MaterialBrand["abbreviation"];
  shortName?: MaterialBrand["shortName"];
  createdAt?: MaterialBrand["createdAt"];
  updatedAt?: MaterialBrand["updatedAt"];
  materialListings?: Array<MaterialListing | MaterialListingOptions>;
}

export function newMaterialBrand(options: MaterialBrandOptions = {}, cache: Record<string, any> = {}): MaterialBrand {
  const o = (options.__typename ? options : cache["MaterialBrand"] = {}) as MaterialBrand;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MaterialBrand";
  o.id = options.id ?? nextFactoryId("MaterialBrand");
  o.name = options.name ?? "name";
  o.abbreviation = options.abbreviation ?? null;
  o.shortName = options.shortName ?? "shortName";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.materialListings = (options.materialListings ?? []).map((i) =>
    maybeNew("MaterialListing", i, cache, options.hasOwnProperty("materialListings"))
  );
  return o;
}

factories["MaterialBrand"] = newMaterialBrand;

export interface SaveMaterialBrandResultOptions {
  __typename?: "SaveMaterialBrandResult";
  materialBrand?: MaterialBrand | MaterialBrandOptions;
}

export function newSaveMaterialBrandResult(
  options: SaveMaterialBrandResultOptions = {},
  cache: Record<string, any> = {},
): SaveMaterialBrandResult {
  const o = (options.__typename ? options : cache["SaveMaterialBrandResult"] = {}) as SaveMaterialBrandResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveMaterialBrandResult";
  o.materialBrand = maybeNew("MaterialBrand", options.materialBrand, cache, options.hasOwnProperty("materialBrand"));
  return o;
}

factories["SaveMaterialBrandResult"] = newSaveMaterialBrandResult;

export interface MaterialLeadTimeConfigOptions {
  __typename?: "MaterialLeadTimeConfig";
  id?: MaterialLeadTimeConfig["id"];
  minLeadTimeInDays?: MaterialLeadTimeConfig["minLeadTimeInDays"];
  expectedLeadTimeInDays?: MaterialLeadTimeConfig["expectedLeadTimeInDays"];
  maxLeadTimeInDays?: MaterialLeadTimeConfig["maxLeadTimeInDays"];
  reasonNote?: MaterialLeadTimeConfig["reasonNote"];
  createdAt?: MaterialLeadTimeConfig["createdAt"];
  updatedAt?: MaterialLeadTimeConfig["updatedAt"];
  variants?: Array<MaterialLeadTimeConfigVariant | MaterialLeadTimeConfigVariantOptions>;
  parent?:
    | MaterialLeadTimeConfigParent
    | CostCodeOptions
    | RequireTypename<ItemOptions>
    | RequireTypename<MaterialListingOptions>
    | null;
}

export function newMaterialLeadTimeConfig(
  options: MaterialLeadTimeConfigOptions = {},
  cache: Record<string, any> = {},
): MaterialLeadTimeConfig {
  const o = (options.__typename ? options : cache["MaterialLeadTimeConfig"] = {}) as MaterialLeadTimeConfig;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MaterialLeadTimeConfig";
  o.id = options.id ?? nextFactoryId("MaterialLeadTimeConfig");
  o.minLeadTimeInDays = options.minLeadTimeInDays ?? 0;
  o.expectedLeadTimeInDays = options.expectedLeadTimeInDays ?? 0;
  o.maxLeadTimeInDays = options.maxLeadTimeInDays ?? 0;
  o.reasonNote = options.reasonNote ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.variants = (options.variants ?? []).map((i) =>
    maybeNew("MaterialLeadTimeConfigVariant", i, cache, options.hasOwnProperty("variants"))
  );
  o.parent = maybeNewOrNull(options.parent?.__typename ?? "CostCode", options.parent, cache);
  return o;
}

factories["MaterialLeadTimeConfig"] = newMaterialLeadTimeConfig;

export interface SaveMaterialLeadTimeConfigResultOptions {
  __typename?: "SaveMaterialLeadTimeConfigResult";
  materialLeadTimeConfig?: MaterialLeadTimeConfig | MaterialLeadTimeConfigOptions;
}

export function newSaveMaterialLeadTimeConfigResult(
  options: SaveMaterialLeadTimeConfigResultOptions = {},
  cache: Record<string, any> = {},
): SaveMaterialLeadTimeConfigResult {
  const o =
    (options.__typename ? options : cache["SaveMaterialLeadTimeConfigResult"] = {}) as SaveMaterialLeadTimeConfigResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveMaterialLeadTimeConfigResult";
  o.materialLeadTimeConfig = maybeNew(
    "MaterialLeadTimeConfig",
    options.materialLeadTimeConfig,
    cache,
    options.hasOwnProperty("materialLeadTimeConfig"),
  );
  return o;
}

factories["SaveMaterialLeadTimeConfigResult"] = newSaveMaterialLeadTimeConfigResult;

export interface MaterialLeadTimeConfigVariantOptions {
  __typename?: "MaterialLeadTimeConfigVariant";
  id?: MaterialLeadTimeConfigVariant["id"];
  minLeadTimeInDays?: MaterialLeadTimeConfigVariant["minLeadTimeInDays"];
  expectedLeadTimeInDays?: MaterialLeadTimeConfigVariant["expectedLeadTimeInDays"];
  maxLeadTimeInDays?: MaterialLeadTimeConfigVariant["maxLeadTimeInDays"];
  reasonNote?: MaterialLeadTimeConfigVariant["reasonNote"];
  createdAt?: MaterialLeadTimeConfigVariant["createdAt"];
  updatedAt?: MaterialLeadTimeConfigVariant["updatedAt"];
  market?: Market | MarketOptions | null;
  materialLeadTimeConfig?: MaterialLeadTimeConfig | MaterialLeadTimeConfigOptions;
}

export function newMaterialLeadTimeConfigVariant(
  options: MaterialLeadTimeConfigVariantOptions = {},
  cache: Record<string, any> = {},
): MaterialLeadTimeConfigVariant {
  const o =
    (options.__typename ? options : cache["MaterialLeadTimeConfigVariant"] = {}) as MaterialLeadTimeConfigVariant;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MaterialLeadTimeConfigVariant";
  o.id = options.id ?? nextFactoryId("MaterialLeadTimeConfigVariant");
  o.minLeadTimeInDays = options.minLeadTimeInDays ?? null;
  o.expectedLeadTimeInDays = options.expectedLeadTimeInDays ?? null;
  o.maxLeadTimeInDays = options.maxLeadTimeInDays ?? null;
  o.reasonNote = options.reasonNote ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.market = maybeNewOrNull("Market", options.market, cache);
  o.materialLeadTimeConfig = maybeNew(
    "MaterialLeadTimeConfig",
    options.materialLeadTimeConfig,
    cache,
    options.hasOwnProperty("materialLeadTimeConfig"),
  );
  return o;
}

factories["MaterialLeadTimeConfigVariant"] = newMaterialLeadTimeConfigVariant;

export interface MaterialListingOptions {
  __typename?: "MaterialListing";
  id?: MaterialListing["id"];
  name?: MaterialListing["name"];
  createdAt?: MaterialListing["createdAt"];
  updatedAt?: MaterialListing["updatedAt"];
  item?: Item | ItemOptions;
  brand?: MaterialBrand | MaterialBrandOptions | null;
  materialVariants?: Array<MaterialVariant | MaterialVariantOptions>;
  type?: MaterialTypeDetailOptions | MaterialType;
  manufacturerUrl?: MaterialListing["manufacturerUrl"];
  description?: MaterialListing["description"];
  canEditItem?: PotentialOperation2 | PotentialOperation2Options;
  optionPricingConfig?: OptionPricingConfig | OptionPricingConfigOptions | null;
  preCutoffDesiredMarginInBasisPoints?: MaterialListing["preCutoffDesiredMarginInBasisPoints"];
  postCutoffDesiredMarginInBasisPoints?: MaterialListing["postCutoffDesiredMarginInBasisPoints"];
  selectionFeeInCents?: MaterialListing["selectionFeeInCents"];
  minimumPriceInCents?: MaterialListing["minimumPriceInCents"];
  materialLeadTimeConfig?: MaterialLeadTimeConfig | MaterialLeadTimeConfigOptions | null;
  minLeadTimeInDays?: MaterialListing["minLeadTimeInDays"];
  expectedLeadTimeInDays?: MaterialListing["expectedLeadTimeInDays"];
  maxLeadTimeInDays?: MaterialListing["maxLeadTimeInDays"];
  history?: Array<History | HistoryOptions>;
  designNote?: MaterialListing["designNote"];
}

export function newMaterialListing(
  options: MaterialListingOptions = {},
  cache: Record<string, any> = {},
): MaterialListing {
  const o = (options.__typename ? options : cache["MaterialListing"] = {}) as MaterialListing;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MaterialListing";
  o.id = options.id ?? nextFactoryId("MaterialListing");
  o.name = options.name ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
  o.brand = maybeNewOrNull("MaterialBrand", options.brand, cache);
  o.materialVariants = (options.materialVariants ?? []).map((i) =>
    maybeNew("MaterialVariant", i, cache, options.hasOwnProperty("materialVariants"))
  );
  o.type = enumOrDetailOfMaterialType(options.type);
  o.manufacturerUrl = options.manufacturerUrl ?? null;
  o.description = options.description ?? null;
  o.canEditItem = maybeNew("PotentialOperation2", options.canEditItem, cache, options.hasOwnProperty("canEditItem"));
  o.optionPricingConfig = maybeNewOrNull("OptionPricingConfig", options.optionPricingConfig, cache);
  o.preCutoffDesiredMarginInBasisPoints = options.preCutoffDesiredMarginInBasisPoints ?? 0;
  o.postCutoffDesiredMarginInBasisPoints = options.postCutoffDesiredMarginInBasisPoints ?? null;
  o.selectionFeeInCents = options.selectionFeeInCents ?? null;
  o.minimumPriceInCents = options.minimumPriceInCents ?? 0;
  o.materialLeadTimeConfig = maybeNewOrNull("MaterialLeadTimeConfig", options.materialLeadTimeConfig, cache);
  o.minLeadTimeInDays = options.minLeadTimeInDays ?? 0;
  o.expectedLeadTimeInDays = options.expectedLeadTimeInDays ?? 0;
  o.maxLeadTimeInDays = options.maxLeadTimeInDays ?? 0;
  o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
  o.designNote = options.designNote ?? null;
  return o;
}

factories["MaterialListing"] = newMaterialListing;

export interface MaterialListingsPageOptions {
  __typename?: "MaterialListingsPage";
  entities?: Array<MaterialListing | MaterialListingOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newMaterialListingsPage(
  options: MaterialListingsPageOptions = {},
  cache: Record<string, any> = {},
): MaterialListingsPage {
  const o = (options.__typename ? options : cache["MaterialListingsPage"] = {}) as MaterialListingsPage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MaterialListingsPage";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("MaterialListing", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["MaterialListingsPage"] = newMaterialListingsPage;

export interface MigrateMaterialListingItemResultOptions {
  __typename?: "MigrateMaterialListingItemResult";
  listings?: Array<MaterialListing | MaterialListingOptions>;
}

export function newMigrateMaterialListingItemResult(
  options: MigrateMaterialListingItemResultOptions = {},
  cache: Record<string, any> = {},
): MigrateMaterialListingItemResult {
  const o =
    (options.__typename ? options : cache["MigrateMaterialListingItemResult"] = {}) as MigrateMaterialListingItemResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MigrateMaterialListingItemResult";
  o.listings = (options.listings ?? []).map((i) =>
    maybeNew("MaterialListing", i, cache, options.hasOwnProperty("listings"))
  );
  return o;
}

factories["MigrateMaterialListingItemResult"] = newMigrateMaterialListingItemResult;

export interface MergeMaterialListingsResultOptions {
  __typename?: "MergeMaterialListingsResult";
  target?: MaterialListing | MaterialListingOptions;
}

export function newMergeMaterialListingsResult(
  options: MergeMaterialListingsResultOptions = {},
  cache: Record<string, any> = {},
): MergeMaterialListingsResult {
  const o = (options.__typename ? options : cache["MergeMaterialListingsResult"] = {}) as MergeMaterialListingsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MergeMaterialListingsResult";
  o.target = maybeNew("MaterialListing", options.target, cache, options.hasOwnProperty("target"));
  return o;
}

factories["MergeMaterialListingsResult"] = newMergeMaterialListingsResult;

export interface UploadMaterialVariantsResultOptions {
  __typename?: "UploadMaterialVariantsResult";
  results?: Array<UploadMaterialVariantResult | UploadMaterialVariantResultOptions>;
}

export function newUploadMaterialVariantsResult(
  options: UploadMaterialVariantsResultOptions = {},
  cache: Record<string, any> = {},
): UploadMaterialVariantsResult {
  const o = (options.__typename ? options : cache["UploadMaterialVariantsResult"] = {}) as UploadMaterialVariantsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "UploadMaterialVariantsResult";
  o.results = (options.results ?? []).map((i) =>
    maybeNew("UploadMaterialVariantResult", i, cache, options.hasOwnProperty("results"))
  );
  return o;
}

factories["UploadMaterialVariantsResult"] = newUploadMaterialVariantsResult;

export interface UploadMaterialVariantResultOptions {
  __typename?: "UploadMaterialVariantResult";
  data?: UploadMaterialVariantResult["data"];
  operation?: UploadMaterialVariantResult["operation"];
  newMaterialVariant?: MaterialVariant | MaterialVariantOptions | null;
  updatedMaterialVariant?: MaterialVariant | MaterialVariantOptions | null;
}

export function newUploadMaterialVariantResult(
  options: UploadMaterialVariantResultOptions = {},
  cache: Record<string, any> = {},
): UploadMaterialVariantResult {
  const o = (options.__typename ? options : cache["UploadMaterialVariantResult"] = {}) as UploadMaterialVariantResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "UploadMaterialVariantResult";
  o.data = options.data ?? "" as any;
  o.operation = options.operation ?? "operation";
  o.newMaterialVariant = maybeNewOrNull("MaterialVariant", options.newMaterialVariant, cache);
  o.updatedMaterialVariant = maybeNewOrNull("MaterialVariant", options.updatedMaterialVariant, cache);
  return o;
}

factories["UploadMaterialVariantResult"] = newUploadMaterialVariantResult;

export interface MaterialVariantOptions {
  __typename?: "MaterialVariant";
  id?: MaterialVariant["id"];
  code?: MaterialVariant["code"];
  displayName?: MaterialVariant["displayName"];
  modelNumber?: MaterialVariant["modelNumber"];
  createdAt?: MaterialVariant["createdAt"];
  updatedAt?: MaterialVariant["updatedAt"];
  listing?: MaterialListing | MaterialListingOptions;
  materialAttributeValues?: Array<MaterialAttributeValue | MaterialAttributeValueOptions>;
  bidItems?: Array<BidItem | BidItemOptions>;
  codeOverride?: MaterialVariant["codeOverride"];
  defaultBidItem?: BidItem | BidItemOptions;
  isArchived?: MaterialVariant["isArchived"];
  featuredImage?: MaterialVariantImage | MaterialVariantImageOptions | null;
  images?: Array<MaterialVariantImage | MaterialVariantImageOptions>;
  components?: Array<MaterialAssemblyComponent | MaterialAssemblyComponentOptions>;
  componentOf?: Array<MaterialAssemblyComponent | MaterialAssemblyComponentOptions>;
  lastUsedAt?: MaterialVariant["lastUsedAt"];
  effectiveMADs?: Array<MaterialAttributeDimension | MaterialAttributeDimensionOptions>;
  designFeedback?: MaterialVariant["designFeedback"];
  minCostInMills?: MaterialVariant["minCostInMills"];
  maxCostInMills?: MaterialVariant["maxCostInMills"];
  canEdit?: PotentialOperation2 | PotentialOperation2Options;
  tags?: Array<MaterialVariantTag | MaterialVariantTagOptions>;
  manufacturerUrl?: MaterialVariant["manufacturerUrl"];
  blueprintUrl?: Url | UrlOptions;
  sources?: Array<MaterialVariant | MaterialVariantOptions>;
}

export function newMaterialVariant(
  options: MaterialVariantOptions = {},
  cache: Record<string, any> = {},
): MaterialVariant {
  const o = (options.__typename ? options : cache["MaterialVariant"] = {}) as MaterialVariant;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MaterialVariant";
  o.id = options.id ?? nextFactoryId("MaterialVariant");
  o.code = options.code ?? "code";
  o.displayName = options.displayName ?? "displayName";
  o.modelNumber = options.modelNumber ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.listing = maybeNew("MaterialListing", options.listing, cache, options.hasOwnProperty("listing"));
  o.materialAttributeValues = (options.materialAttributeValues ?? []).map((i) =>
    maybeNew("MaterialAttributeValue", i, cache, options.hasOwnProperty("materialAttributeValues"))
  );
  o.bidItems = (options.bidItems ?? []).map((i) => maybeNew("BidItem", i, cache, options.hasOwnProperty("bidItems")));
  o.codeOverride = options.codeOverride ?? null;
  o.defaultBidItem = maybeNew("BidItem", options.defaultBidItem, cache, options.hasOwnProperty("defaultBidItem"));
  o.isArchived = options.isArchived ?? false;
  o.featuredImage = maybeNewOrNull("MaterialVariantImage", options.featuredImage, cache);
  o.images = (options.images ?? []).map((i) =>
    maybeNew("MaterialVariantImage", i, cache, options.hasOwnProperty("images"))
  );
  o.components = (options.components ?? []).map((i) =>
    maybeNew("MaterialAssemblyComponent", i, cache, options.hasOwnProperty("components"))
  );
  o.componentOf = (options.componentOf ?? []).map((i) =>
    maybeNew("MaterialAssemblyComponent", i, cache, options.hasOwnProperty("componentOf"))
  );
  o.lastUsedAt = options.lastUsedAt ?? null;
  o.effectiveMADs = (options.effectiveMADs ?? []).map((i) =>
    maybeNew("MaterialAttributeDimension", i, cache, options.hasOwnProperty("effectiveMADs"))
  );
  o.designFeedback = options.designFeedback ?? null;
  o.minCostInMills = options.minCostInMills ?? null;
  o.maxCostInMills = options.maxCostInMills ?? null;
  o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
  o.tags = (options.tags ?? []).map((i) => maybeNew("MaterialVariantTag", i, cache, options.hasOwnProperty("tags")));
  o.manufacturerUrl = options.manufacturerUrl ?? null;
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.sources = (options.sources ?? []).map((i) =>
    maybeNew("MaterialVariant", i, cache, options.hasOwnProperty("sources"))
  );
  return o;
}

factories["MaterialVariant"] = newMaterialVariant;

export interface SaveMaterialVariantResultOptions {
  __typename?: "SaveMaterialVariantResult";
  materialVariant?: MaterialVariant | MaterialVariantOptions;
}

export function newSaveMaterialVariantResult(
  options: SaveMaterialVariantResultOptions = {},
  cache: Record<string, any> = {},
): SaveMaterialVariantResult {
  const o = (options.__typename ? options : cache["SaveMaterialVariantResult"] = {}) as SaveMaterialVariantResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveMaterialVariantResult";
  o.materialVariant = maybeNew(
    "MaterialVariant",
    options.materialVariant,
    cache,
    options.hasOwnProperty("materialVariant"),
  );
  return o;
}

factories["SaveMaterialVariantResult"] = newSaveMaterialVariantResult;

export interface MaterialVariantsPageOptions {
  __typename?: "MaterialVariantsPage";
  entities?: Array<MaterialVariant | MaterialVariantOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newMaterialVariantsPage(
  options: MaterialVariantsPageOptions = {},
  cache: Record<string, any> = {},
): MaterialVariantsPage {
  const o = (options.__typename ? options : cache["MaterialVariantsPage"] = {}) as MaterialVariantsPage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MaterialVariantsPage";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("MaterialVariant", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["MaterialVariantsPage"] = newMaterialVariantsPage;

export interface MaterialVariantCostSourcesPageOptions {
  __typename?: "MaterialVariantCostSourcesPage";
  entities?: Array<MaterialCostSource | BidItemEstimateOptions | RequireTypename<BidContractLineItemOptions>>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newMaterialVariantCostSourcesPage(
  options: MaterialVariantCostSourcesPageOptions = {},
  cache: Record<string, any> = {},
): MaterialVariantCostSourcesPage {
  const o =
    (options.__typename ? options : cache["MaterialVariantCostSourcesPage"] = {}) as MaterialVariantCostSourcesPage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MaterialVariantCostSourcesPage";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew(i?.__typename ?? "{BidItemEstimate", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["MaterialVariantCostSourcesPage"] = newMaterialVariantCostSourcesPage;

export interface MaterialVariantImageOptions {
  __typename?: "MaterialVariantImage";
  id?: MaterialVariantImage["id"];
  sortOrder?: MaterialVariantImage["sortOrder"];
  createdAt?: MaterialVariantImage["createdAt"];
  updatedAt?: MaterialVariantImage["updatedAt"];
  variant?: MaterialVariant | MaterialVariantOptions;
  asset?: Asset | AssetOptions | null;
}

export function newMaterialVariantImage(
  options: MaterialVariantImageOptions = {},
  cache: Record<string, any> = {},
): MaterialVariantImage {
  const o = (options.__typename ? options : cache["MaterialVariantImage"] = {}) as MaterialVariantImage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MaterialVariantImage";
  o.id = options.id ?? nextFactoryId("MaterialVariantImage");
  o.sortOrder = options.sortOrder ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.variant = maybeNew("MaterialVariant", options.variant, cache, options.hasOwnProperty("variant"));
  o.asset = maybeNewOrNull("Asset", options.asset, cache);
  return o;
}

factories["MaterialVariantImage"] = newMaterialVariantImage;

export interface MaterialVariantTagOptions {
  __typename?: "MaterialVariantTag";
  id?: MaterialVariantTag["id"];
  name?: MaterialVariantTag["name"];
  createdAt?: MaterialVariantTag["createdAt"];
  updatedAt?: MaterialVariantTag["updatedAt"];
  materialVariants?: Array<MaterialVariant | MaterialVariantOptions>;
}

export function newMaterialVariantTag(
  options: MaterialVariantTagOptions = {},
  cache: Record<string, any> = {},
): MaterialVariantTag {
  const o = (options.__typename ? options : cache["MaterialVariantTag"] = {}) as MaterialVariantTag;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MaterialVariantTag";
  o.id = options.id ?? nextFactoryId("MaterialVariantTag");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.materialVariants = (options.materialVariants ?? []).map((i) =>
    maybeNew("MaterialVariant", i, cache, options.hasOwnProperty("materialVariants"))
  );
  return o;
}

factories["MaterialVariantTag"] = newMaterialVariantTag;

export interface SaveMaterialVariantTagResultOptions {
  __typename?: "SaveMaterialVariantTagResult";
  materialVariantTag?: MaterialVariantTag | MaterialVariantTagOptions;
}

export function newSaveMaterialVariantTagResult(
  options: SaveMaterialVariantTagResultOptions = {},
  cache: Record<string, any> = {},
): SaveMaterialVariantTagResult {
  const o = (options.__typename ? options : cache["SaveMaterialVariantTagResult"] = {}) as SaveMaterialVariantTagResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveMaterialVariantTagResult";
  o.materialVariantTag = maybeNew(
    "MaterialVariantTag",
    options.materialVariantTag,
    cache,
    options.hasOwnProperty("materialVariantTag"),
  );
  return o;
}

factories["SaveMaterialVariantTagResult"] = newSaveMaterialVariantTagResult;

export interface MermaidResultOptions {
  __typename?: "MermaidResult";
  url?: MermaidResult["url"];
  code?: MermaidResult["code"];
}

export function newMermaidResult(options: MermaidResultOptions = {}, cache: Record<string, any> = {}): MermaidResult {
  const o = (options.__typename ? options : cache["MermaidResult"] = {}) as MermaidResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MermaidResult";
  o.url = options.url ?? "url";
  o.code = options.code ?? "code";
  return o;
}

factories["MermaidResult"] = newMermaidResult;

export interface MobileSyncUpdatesPageResultOptions {
  __typename?: "MobileSyncUpdatesPageResult";
  entities?: Array<MobileSyncUpdate | MobileSyncUpdateOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newMobileSyncUpdatesPageResult(
  options: MobileSyncUpdatesPageResultOptions = {},
  cache: Record<string, any> = {},
): MobileSyncUpdatesPageResult {
  const o = (options.__typename ? options : cache["MobileSyncUpdatesPageResult"] = {}) as MobileSyncUpdatesPageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MobileSyncUpdatesPageResult";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("MobileSyncUpdate", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["MobileSyncUpdatesPageResult"] = newMobileSyncUpdatesPageResult;

export interface MobileSyncUpdateOptions {
  __typename?: "MobileSyncUpdate";
  id?: MobileSyncUpdate["id"];
  type?: MobileSyncUpdate["type"];
  createdAt?: MobileSyncUpdate["createdAt"];
  updatedAt?: MobileSyncUpdate["updatedAt"];
  entityId?: MobileSyncUpdate["entityId"];
  entity?:
    | ScheduleTask
    | Asset
    | TradePartner
    | Bill
    | PlanTask
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Document
    | JobLogNote
    | PunchlistItemTodo
    | Comment
    | CommitmentDraw
    | FeatureFlag
    | JobLog
    | JobLogImage
    | Location
    | MobileSyncUpdate
    | ScheduleFlag
    | ScheduleFlagReason
    | ScheduleTaskChecklistItem
    | TaskWorkDay
    | TradePartnerContact
    | TradePartnerUser
    | Entity
    | EntityOptions
    | null;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
}

export function newMobileSyncUpdate(
  options: MobileSyncUpdateOptions = {},
  cache: Record<string, any> = {},
): MobileSyncUpdate {
  const o = (options.__typename ? options : cache["MobileSyncUpdate"] = {}) as MobileSyncUpdate;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MobileSyncUpdate";
  o.id = options.id ?? nextFactoryId("MobileSyncUpdate");
  o.type = options.type ?? MobileSyncUpdateType.Created;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.entityId = options.entityId ?? "entityId";
  o.entity = maybeNewOrNull("Entity", options.entity, cache);
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  return o;
}

factories["MobileSyncUpdate"] = newMobileSyncUpdate;

export interface OptionPricingConfigOptions {
  __typename?: "OptionPricingConfig";
  id?: OptionPricingConfig["id"];
  selectionFeeInCents?: OptionPricingConfig["selectionFeeInCents"];
  createdAt?: OptionPricingConfig["createdAt"];
  updatedAt?: OptionPricingConfig["updatedAt"];
  variants?: Array<OptionPricingConfigVariant | OptionPricingConfigVariantOptions>;
  parent?:
    | OptionPricingConfigParent
    | CostCodeOptions
    | RequireTypename<GlobalOptionOptions>
    | RequireTypename<ItemOptions>
    | RequireTypename<MaterialListingOptions>
    | null;
  preCutoffDesiredMarginInBasisPoints?: OptionPricingConfig["preCutoffDesiredMarginInBasisPoints"];
  postCutoffDesiredMarginInBasisPoints?: OptionPricingConfig["postCutoffDesiredMarginInBasisPoints"];
  reasonNote?: OptionPricingConfig["reasonNote"];
  minimumPriceInCents?: OptionPricingConfig["minimumPriceInCents"];
}

export function newOptionPricingConfig(
  options: OptionPricingConfigOptions = {},
  cache: Record<string, any> = {},
): OptionPricingConfig {
  const o = (options.__typename ? options : cache["OptionPricingConfig"] = {}) as OptionPricingConfig;
  (cache.all ??= new Set()).add(o);
  o.__typename = "OptionPricingConfig";
  o.id = options.id ?? nextFactoryId("OptionPricingConfig");
  o.selectionFeeInCents = options.selectionFeeInCents ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.variants = (options.variants ?? []).map((i) =>
    maybeNew("OptionPricingConfigVariant", i, cache, options.hasOwnProperty("variants"))
  );
  o.parent = maybeNewOrNull(options.parent?.__typename ?? "CostCode", options.parent, cache);
  o.preCutoffDesiredMarginInBasisPoints = options.preCutoffDesiredMarginInBasisPoints ?? 0;
  o.postCutoffDesiredMarginInBasisPoints = options.postCutoffDesiredMarginInBasisPoints ?? null;
  o.reasonNote = options.reasonNote ?? null;
  o.minimumPriceInCents = options.minimumPriceInCents ?? 0;
  return o;
}

factories["OptionPricingConfig"] = newOptionPricingConfig;

export interface SaveOptionPricingConfigsResultOptions {
  __typename?: "SaveOptionPricingConfigsResult";
  optionPricingConfigs?: Array<OptionPricingConfig | OptionPricingConfigOptions>;
}

export function newSaveOptionPricingConfigsResult(
  options: SaveOptionPricingConfigsResultOptions = {},
  cache: Record<string, any> = {},
): SaveOptionPricingConfigsResult {
  const o =
    (options.__typename ? options : cache["SaveOptionPricingConfigsResult"] = {}) as SaveOptionPricingConfigsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveOptionPricingConfigsResult";
  o.optionPricingConfigs = (options.optionPricingConfigs ?? []).map((i) =>
    maybeNew("OptionPricingConfig", i, cache, options.hasOwnProperty("optionPricingConfigs"))
  );
  return o;
}

factories["SaveOptionPricingConfigsResult"] = newSaveOptionPricingConfigsResult;

export interface OptionPricingConfigVariantOptions {
  __typename?: "OptionPricingConfigVariant";
  id?: OptionPricingConfigVariant["id"];
  createdAt?: OptionPricingConfigVariant["createdAt"];
  updatedAt?: OptionPricingConfigVariant["updatedAt"];
  optionPricingConfig?: OptionPricingConfig | OptionPricingConfigOptions;
  preCutoffDesiredMarginInBasisPoints?: OptionPricingConfigVariant["preCutoffDesiredMarginInBasisPoints"];
  postCutoffDesiredMarginInBasisPoints?: OptionPricingConfigVariant["postCutoffDesiredMarginInBasisPoints"];
  selectionFeeInCents?: OptionPricingConfigVariant["selectionFeeInCents"];
  reasonNote?: OptionPricingConfigVariant["reasonNote"];
  projects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  minimumPriceInCents?: OptionPricingConfigVariant["minimumPriceInCents"];
}

export function newOptionPricingConfigVariant(
  options: OptionPricingConfigVariantOptions = {},
  cache: Record<string, any> = {},
): OptionPricingConfigVariant {
  const o = (options.__typename ? options : cache["OptionPricingConfigVariant"] = {}) as OptionPricingConfigVariant;
  (cache.all ??= new Set()).add(o);
  o.__typename = "OptionPricingConfigVariant";
  o.id = options.id ?? nextFactoryId("OptionPricingConfigVariant");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.optionPricingConfig = maybeNew(
    "OptionPricingConfig",
    options.optionPricingConfig,
    cache,
    options.hasOwnProperty("optionPricingConfig"),
  );
  o.preCutoffDesiredMarginInBasisPoints = options.preCutoffDesiredMarginInBasisPoints ?? 0;
  o.postCutoffDesiredMarginInBasisPoints = options.postCutoffDesiredMarginInBasisPoints ?? null;
  o.selectionFeeInCents = options.selectionFeeInCents ?? null;
  o.reasonNote = options.reasonNote ?? null;
  o.projects = (options.projects ?? []).map((i) => maybeNew("Project", i, cache, options.hasOwnProperty("projects")));
  o.minimumPriceInCents = options.minimumPriceInCents ?? null;
  return o;
}

factories["OptionPricingConfigVariant"] = newOptionPricingConfigVariant;

export interface PageInfoOptions {
  __typename?: "PageInfo";
  hasNextPage?: PageInfo["hasNextPage"];
  totalCount?: PageInfo["totalCount"];
  nextPage?: Page | PageOptions | null;
}

export function newPageInfo(options: PageInfoOptions = {}, cache: Record<string, any> = {}): PageInfo {
  const o = (options.__typename ? options : cache["PageInfo"] = {}) as PageInfo;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PageInfo";
  o.hasNextPage = options.hasNextPage ?? false;
  o.totalCount = options.totalCount ?? 0;
  o.nextPage = maybeNewOrNull("Page", options.nextPage, cache);
  return o;
}

factories["PageInfo"] = newPageInfo;

export interface PageOptions {
  __typename?: "Page";
  limit?: Page["limit"];
  offset?: Page["offset"];
}

export function newPage(options: PageOptions = {}, cache: Record<string, any> = {}): Page {
  const o = (options.__typename ? options : cache["Page"] = {}) as Page;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Page";
  o.limit = options.limit ?? 0;
  o.offset = options.offset ?? 0;
  return o;
}

factories["Page"] = newPage;

export interface PandaDocSessionOptions {
  __typename?: "PandaDocSession";
  sessionId?: PandaDocSession["sessionId"];
}

export function newPandaDocSession(
  options: PandaDocSessionOptions = {},
  cache: Record<string, any> = {},
): PandaDocSession {
  const o = (options.__typename ? options : cache["PandaDocSession"] = {}) as PandaDocSession;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PandaDocSession";
  o.sessionId = options.sessionId ?? "sessionId";
  return o;
}

factories["PandaDocSession"] = newPandaDocSession;

export interface PandaDocOptions {
  __typename?: "PandaDoc";
  id?: PandaDoc["id"];
  name?: PandaDoc["name"];
  externalPandaDocId?: PandaDoc["externalPandaDocId"];
  externalPandaDocUrl?: PandaDoc["externalPandaDocUrl"];
  status?: PandaDoc["status"];
  statusDetail?: PandaDocStatusDetailOptions | PandaDocStatus;
  recipients?: Array<PandaDocRecipient | PandaDocRecipientOptions>;
  commitment?: Commitment | CommitmentOptions | null;
  developmentCommitment?: DevelopmentCommitment | DevelopmentCommitmentOptions | null;
  commitmentChangeOrder?: CommitmentChangeOrder | CommitmentChangeOrderOptions | null;
  tags?: PandaDoc["tags"];
  document?: Document | DocumentOptions | null;
  owner?:
    | PandaDocOwner
    | BidContractRevisionOptions
    | RequireTypename<ChangeEventOptions>
    | RequireTypename<CommitmentOptions>
    | RequireTypename<CommitmentChangeOrderOptions>
    | RequireTypename<DevelopmentCommitmentOptions>
    | RequireTypename<InvoiceOptions>
    | RequireTypename<LienWaiverOptions>
    | null;
  externalError?: PandaDoc["externalError"];
  canUpload?: PotentialOperation2 | PotentialOperation2Options | null;
  canCreatePandaDocSession?: PotentialOperation2 | PotentialOperation2Options | null;
}

export function newPandaDoc(options: PandaDocOptions = {}, cache: Record<string, any> = {}): PandaDoc {
  const o = (options.__typename ? options : cache["PandaDoc"] = {}) as PandaDoc;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PandaDoc";
  o.id = options.id ?? nextFactoryId("PandaDoc");
  o.name = options.name ?? "name";
  o.externalPandaDocId = options.externalPandaDocId ?? null;
  o.externalPandaDocUrl = options.externalPandaDocUrl ?? null;
  o.status = options.status ?? PandaDocStatus.Pending;
  o.statusDetail = enumOrDetailOfPandaDocStatus(options.statusDetail);
  o.recipients = (options.recipients ?? []).map((i) =>
    maybeNew("PandaDocRecipient", i, cache, options.hasOwnProperty("recipients"))
  );
  o.commitment = maybeNewOrNull("Commitment", options.commitment, cache);
  o.developmentCommitment = maybeNewOrNull("DevelopmentCommitment", options.developmentCommitment, cache);
  o.commitmentChangeOrder = maybeNewOrNull("CommitmentChangeOrder", options.commitmentChangeOrder, cache);
  o.tags = options.tags ?? [];
  o.document = maybeNewOrNull("Document", options.document, cache);
  o.owner = maybeNewOrNull(options.owner?.__typename ?? "BidContractRevision", options.owner, cache);
  o.externalError = options.externalError ?? null;
  o.canUpload = maybeNewOrNull("PotentialOperation2", options.canUpload, cache);
  o.canCreatePandaDocSession = maybeNewOrNull("PotentialOperation2", options.canCreatePandaDocSession, cache);
  return o;
}

factories["PandaDoc"] = newPandaDoc;

export interface SavePandaDocResultOptions {
  __typename?: "SavePandaDocResult";
  pandaDoc?: PandaDoc | PandaDocOptions;
}

export function newSavePandaDocResult(
  options: SavePandaDocResultOptions = {},
  cache: Record<string, any> = {},
): SavePandaDocResult {
  const o = (options.__typename ? options : cache["SavePandaDocResult"] = {}) as SavePandaDocResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SavePandaDocResult";
  o.pandaDoc = maybeNew("PandaDoc", options.pandaDoc, cache, options.hasOwnProperty("pandaDoc"));
  return o;
}

factories["SavePandaDocResult"] = newSavePandaDocResult;

export interface DeletePandaDocResultOptions {
  __typename?: "DeletePandaDocResult";
  owner?:
    | PandaDocOwner
    | BidContractRevisionOptions
    | RequireTypename<ChangeEventOptions>
    | RequireTypename<CommitmentOptions>
    | RequireTypename<CommitmentChangeOrderOptions>
    | RequireTypename<DevelopmentCommitmentOptions>
    | RequireTypename<InvoiceOptions>
    | RequireTypename<LienWaiverOptions>;
}

export function newDeletePandaDocResult(
  options: DeletePandaDocResultOptions = {},
  cache: Record<string, any> = {},
): DeletePandaDocResult {
  const o = (options.__typename ? options : cache["DeletePandaDocResult"] = {}) as DeletePandaDocResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeletePandaDocResult";
  o.owner = maybeNew(options.owner?.__typename ?? "BidContractRevision", options.owner, cache);
  return o;
}

factories["DeletePandaDocResult"] = newDeletePandaDocResult;

export interface UploadPandaDocResultOptions {
  __typename?: "UploadPandaDocResult";
  pandaDoc?: PandaDoc | PandaDocOptions;
}

export function newUploadPandaDocResult(
  options: UploadPandaDocResultOptions = {},
  cache: Record<string, any> = {},
): UploadPandaDocResult {
  const o = (options.__typename ? options : cache["UploadPandaDocResult"] = {}) as UploadPandaDocResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "UploadPandaDocResult";
  o.pandaDoc = maybeNew("PandaDoc", options.pandaDoc, cache, options.hasOwnProperty("pandaDoc"));
  return o;
}

factories["UploadPandaDocResult"] = newUploadPandaDocResult;

export interface PandaDocRecipientOptions {
  __typename?: "PandaDocRecipient";
  id?: PandaDocRecipient["id"];
  name?: PandaDocRecipient["name"];
  firstName?: PandaDocRecipient["firstName"];
  lastName?: PandaDocRecipient["lastName"];
  email?: PandaDocRecipient["email"];
  role?: PandaDocRecipient["role"];
  roleDetail?: PandaDocRoleDetailOptions | PandaDocRole;
  pandaDoc?: PandaDoc | PandaDocOptions;
  signingOrder?: PandaDocRecipient["signingOrder"];
  hasCompleted?: PandaDocRecipient["hasCompleted"];
}

export function newPandaDocRecipient(
  options: PandaDocRecipientOptions = {},
  cache: Record<string, any> = {},
): PandaDocRecipient {
  const o = (options.__typename ? options : cache["PandaDocRecipient"] = {}) as PandaDocRecipient;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PandaDocRecipient";
  o.id = options.id ?? nextFactoryId("PandaDocRecipient");
  o.name = options.name ?? "name";
  o.firstName = options.firstName ?? "firstName";
  o.lastName = options.lastName ?? "lastName";
  o.email = options.email ?? "email";
  o.role = options.role ?? PandaDocRole.User;
  o.roleDetail = enumOrDetailOfPandaDocRole(options.roleDetail);
  o.pandaDoc = maybeNew("PandaDoc", options.pandaDoc, cache, options.hasOwnProperty("pandaDoc"));
  o.signingOrder = options.signingOrder ?? null;
  o.hasCompleted = options.hasCompleted ?? false;
  return o;
}

factories["PandaDocRecipient"] = newPandaDocRecipient;

export interface PaymentTermOptions {
  __typename?: "PaymentTerm";
  id?: PaymentTerm["id"];
  name?: PaymentTerm["name"];
  description?: PaymentTerm["description"];
  active?: PaymentTerm["active"];
  intacctId?: PaymentTerm["intacctId"];
  createdAt?: PaymentTerm["createdAt"];
  updatedAt?: PaymentTerm["updatedAt"];
  alignWithPaymentCycle?: PaymentTerm["alignWithPaymentCycle"];
  dueDay?: PaymentTerm["dueDay"];
  dueFrom?: PaymentTermDueFromDetailOptions | PaymentTermDueFrom;
}

export function newPaymentTerm(options: PaymentTermOptions = {}, cache: Record<string, any> = {}): PaymentTerm {
  const o = (options.__typename ? options : cache["PaymentTerm"] = {}) as PaymentTerm;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PaymentTerm";
  o.id = options.id ?? nextFactoryId("PaymentTerm");
  o.name = options.name ?? "name";
  o.description = options.description ?? null;
  o.active = options.active ?? false;
  o.intacctId = options.intacctId ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.alignWithPaymentCycle = options.alignWithPaymentCycle ?? false;
  o.dueDay = options.dueDay ?? 0;
  o.dueFrom = enumOrDetailOfPaymentTermDueFrom(options.dueFrom);
  return o;
}

factories["PaymentTerm"] = newPaymentTerm;

export interface SavePaymentTermResultOptions {
  __typename?: "SavePaymentTermResult";
  paymentTerm?: PaymentTerm | PaymentTermOptions;
}

export function newSavePaymentTermResult(
  options: SavePaymentTermResultOptions = {},
  cache: Record<string, any> = {},
): SavePaymentTermResult {
  const o = (options.__typename ? options : cache["SavePaymentTermResult"] = {}) as SavePaymentTermResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SavePaymentTermResult";
  o.paymentTerm = maybeNew("PaymentTerm", options.paymentTerm, cache, options.hasOwnProperty("paymentTerm"));
  return o;
}

factories["SavePaymentTermResult"] = newSavePaymentTermResult;

export interface PermissionsOptions {
  __typename?: "Permissions";
  canEdit?: Permissions["canEdit"];
  canDelete?: Permissions["canDelete"];
}

export function newPermissions(options: PermissionsOptions = {}, cache: Record<string, any> = {}): Permissions {
  const o = (options.__typename ? options : cache["Permissions"] = {}) as Permissions;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Permissions";
  o.canEdit = options.canEdit ?? false;
  o.canDelete = options.canDelete ?? false;
  return o;
}

factories["Permissions"] = newPermissions;

export interface PlanMilestoneOptions {
  __typename?: "PlanMilestone";
  id?: PlanMilestone["id"];
  name?: PlanMilestone["name"];
  estStartDate?: PlanMilestone["estStartDate"];
  estEndDate?: PlanMilestone["estEndDate"];
  totalDays?: PlanMilestone["totalDays"];
  progress?: PlanMilestone["progress"];
  confidence?: PlanMilestone["confidence"];
  durationInDays?: PlanMilestone["durationInDays"];
  createdAt?: PlanMilestone["createdAt"];
  updatedAt?: PlanMilestone["updatedAt"];
  globalPlanMilestone?: GlobalPlanMilestone | GlobalPlanMilestoneOptions;
  planSchedule?: PlanSchedule | PlanScheduleOptions;
  allowingPlanTasks?: Array<PlanTask | PlanTaskOptions>;
  taskStatusRollup?: TaskStatusDetailOptions | TaskStatus;
  completedAt?: PlanMilestone["completedAt"];
}

export function newPlanMilestone(options: PlanMilestoneOptions = {}, cache: Record<string, any> = {}): PlanMilestone {
  const o = (options.__typename ? options : cache["PlanMilestone"] = {}) as PlanMilestone;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PlanMilestone";
  o.id = options.id ?? nextFactoryId("PlanMilestone");
  o.name = options.name ?? "name";
  o.estStartDate = options.estStartDate ?? null;
  o.estEndDate = options.estEndDate ?? null;
  o.totalDays = options.totalDays ?? 0;
  o.progress = options.progress ?? 0;
  o.confidence = options.confidence ?? 0;
  o.durationInDays = options.durationInDays ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.globalPlanMilestone = maybeNew(
    "GlobalPlanMilestone",
    options.globalPlanMilestone,
    cache,
    options.hasOwnProperty("globalPlanMilestone"),
  );
  o.planSchedule = maybeNew("PlanSchedule", options.planSchedule, cache, options.hasOwnProperty("planSchedule"));
  o.allowingPlanTasks = (options.allowingPlanTasks ?? []).map((i) =>
    maybeNew("PlanTask", i, cache, options.hasOwnProperty("allowingPlanTasks"))
  );
  o.taskStatusRollup = enumOrDetailOfTaskStatus(options.taskStatusRollup);
  o.completedAt = options.completedAt ?? null;
  return o;
}

factories["PlanMilestone"] = newPlanMilestone;

export interface PlanMilestonesResultOptions {
  __typename?: "PlanMilestonesResult";
  entities?: Array<PlanMilestone | PlanMilestoneOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newPlanMilestonesResult(
  options: PlanMilestonesResultOptions = {},
  cache: Record<string, any> = {},
): PlanMilestonesResult {
  const o = (options.__typename ? options : cache["PlanMilestonesResult"] = {}) as PlanMilestonesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PlanMilestonesResult";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("PlanMilestone", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["PlanMilestonesResult"] = newPlanMilestonesResult;

export interface PlanMilestoneSnapshotOptions {
  __typename?: "PlanMilestoneSnapshot";
  id?: PlanMilestoneSnapshot["id"];
  range?: PlanMilestoneSnapshot["range"];
  estStartDate?: PlanMilestoneSnapshot["estStartDate"];
  estEndDate?: PlanMilestoneSnapshot["estEndDate"];
  durationInDays?: PlanMilestoneSnapshot["durationInDays"];
  createdAt?: PlanMilestoneSnapshot["createdAt"];
  updatedAt?: PlanMilestoneSnapshot["updatedAt"];
  planMilestone?: PlanMilestone | PlanMilestoneOptions;
}

export function newPlanMilestoneSnapshot(
  options: PlanMilestoneSnapshotOptions = {},
  cache: Record<string, any> = {},
): PlanMilestoneSnapshot {
  const o = (options.__typename ? options : cache["PlanMilestoneSnapshot"] = {}) as PlanMilestoneSnapshot;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PlanMilestoneSnapshot";
  o.id = options.id ?? nextFactoryId("PlanMilestoneSnapshot");
  o.range = options.range ?? "range";
  o.estStartDate = options.estStartDate ?? null;
  o.estEndDate = options.estEndDate ?? null;
  o.durationInDays = options.durationInDays ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.planMilestone = maybeNew("PlanMilestone", options.planMilestone, cache, options.hasOwnProperty("planMilestone"));
  return o;
}

factories["PlanMilestoneSnapshot"] = newPlanMilestoneSnapshot;

export interface SavePlanPackageResultOptions {
  __typename?: "SavePlanPackageResult";
  planPackage?: PlanPackage | PlanPackageOptions;
}

export function newSavePlanPackageResult(
  options: SavePlanPackageResultOptions = {},
  cache: Record<string, any> = {},
): SavePlanPackageResult {
  const o = (options.__typename ? options : cache["SavePlanPackageResult"] = {}) as SavePlanPackageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SavePlanPackageResult";
  o.planPackage = maybeNew("PlanPackage", options.planPackage, cache, options.hasOwnProperty("planPackage"));
  return o;
}

factories["SavePlanPackageResult"] = newSavePlanPackageResult;

export interface PlanPackagesPageResultOptions {
  __typename?: "PlanPackagesPageResult";
  entities?: Array<PlanPackage | PlanPackageOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newPlanPackagesPageResult(
  options: PlanPackagesPageResultOptions = {},
  cache: Record<string, any> = {},
): PlanPackagesPageResult {
  const o = (options.__typename ? options : cache["PlanPackagesPageResult"] = {}) as PlanPackagesPageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PlanPackagesPageResult";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("PlanPackage", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["PlanPackagesPageResult"] = newPlanPackagesPageResult;

export interface PlanPackageVersionOptions {
  __typename?: "PlanPackageVersion";
  id?: PlanPackageVersion["id"];
  name?: PlanPackageVersion["name"];
  createdAt?: PlanPackageVersion["createdAt"];
  updatedAt?: PlanPackageVersion["updatedAt"];
  code?: PlanPackageVersion["code"];
  contingencyMarkupPercentage?: PlanPackageVersion["contingencyMarkupPercentage"];
  description?: PlanPackageVersion["description"];
  type?: ReadyPlanTypeDetailOptions | ReadyPlanType;
  lotTypes?: PlanPackageVersion["lotTypes"];
  identity?: ReadyPlan | ReadyPlanOptions;
  final?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  first?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  markets?: Array<Market | MarketOptions>;
  insideMapsProjectId?: PlanPackageVersion["insideMapsProjectId"];
  owner?: InternalUser | InternalUserOptions | null;
}

export function newPlanPackageVersion(
  options: PlanPackageVersionOptions = {},
  cache: Record<string, any> = {},
): PlanPackageVersion {
  const o = (options.__typename ? options : cache["PlanPackageVersion"] = {}) as PlanPackageVersion;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PlanPackageVersion";
  o.id = options.id ?? nextFactoryId("PlanPackageVersion");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.code = options.code ?? null;
  o.contingencyMarkupPercentage = options.contingencyMarkupPercentage ?? null;
  o.description = options.description ?? null;
  o.type = enumOrDetailOfReadyPlanType(options.type);
  o.lotTypes = options.lotTypes ?? [];
  o.identity = maybeNew("ReadyPlan", options.identity, cache, options.hasOwnProperty("identity"));
  o.final = maybeNewOrNull("ReadyPlanAggregateVersion", options.final, cache);
  o.first = maybeNew("ReadyPlanAggregateVersion", options.first, cache, options.hasOwnProperty("first"));
  o.markets = (options.markets ?? []).map((i) => maybeNew("Market", i, cache, options.hasOwnProperty("markets")));
  o.insideMapsProjectId = options.insideMapsProjectId ?? null;
  o.owner = maybeNewOrNull("InternalUser", options.owner, cache);
  return o;
}

factories["PlanPackageVersion"] = newPlanPackageVersion;

export interface PlanScheduleOptions {
  __typename?: "PlanSchedule";
  id?: PlanSchedule["id"];
  createdAt?: PlanSchedule["createdAt"];
  updatedAt?: PlanSchedule["updatedAt"];
  tasks?: Array<PlanTask | PlanTaskOptions>;
  parent?:
    | PlanScheduleParent
    | StandaloneProjectOptions
    | RequireTypename<RegionOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>;
  planMilestones?: Array<PlanMilestone | PlanMilestoneOptions>;
  recalculatedAt?: PlanSchedule["recalculatedAt"];
  recalculatedBy?: User | UserOptions | null;
  targetStartDate?: PlanSchedule["targetStartDate"];
  targetEndDate?: PlanSchedule["targetEndDate"];
  currentBaselineDate?: PlanSchedule["currentBaselineDate"];
  targetCycleTimeInDays?: PlanSchedule["targetCycleTimeInDays"];
  targetCycleTimeInCalendarDays?: PlanSchedule["targetCycleTimeInCalendarDays"];
  cycleTimeInWorkingDays?: PlanSchedule["cycleTimeInWorkingDays"];
  cycleTimeInCalendarDays?: PlanSchedule["cycleTimeInCalendarDays"];
  verticalCompleteDate?: PlanSchedule["verticalCompleteDate"];
  readyToStartDate?: PlanSchedule["readyToStartDate"];
  targetEndDateProbability?: PlanSchedule["targetEndDateProbability"];
  schedulingExclusionDates?: Array<SchedulingExclusionDate | SchedulingExclusionDateOptions>;
  canSendTradePartnerAvailabilityRequestEmail?: PotentialOperation2 | PotentialOperation2Options;
}

export function newPlanSchedule(options: PlanScheduleOptions = {}, cache: Record<string, any> = {}): PlanSchedule {
  const o = (options.__typename ? options : cache["PlanSchedule"] = {}) as PlanSchedule;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PlanSchedule";
  o.id = options.id ?? nextFactoryId("PlanSchedule");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.tasks = (options.tasks ?? []).map((i) => maybeNew("PlanTask", i, cache, options.hasOwnProperty("tasks")));
  o.parent = maybeNew(options.parent?.__typename ?? "StandaloneProject", options.parent, cache);
  o.planMilestones = (options.planMilestones ?? []).map((i) =>
    maybeNew("PlanMilestone", i, cache, options.hasOwnProperty("planMilestones"))
  );
  o.recalculatedAt = options.recalculatedAt ?? null;
  o.recalculatedBy = maybeNewOrNull("User", options.recalculatedBy, cache);
  o.targetStartDate = options.targetStartDate ?? newDate();
  o.targetEndDate = options.targetEndDate ?? newDate();
  o.currentBaselineDate = options.currentBaselineDate ?? newDate();
  o.targetCycleTimeInDays = options.targetCycleTimeInDays ?? 0;
  o.targetCycleTimeInCalendarDays = options.targetCycleTimeInCalendarDays ?? 0;
  o.cycleTimeInWorkingDays = options.cycleTimeInWorkingDays ?? null;
  o.cycleTimeInCalendarDays = options.cycleTimeInCalendarDays ?? null;
  o.verticalCompleteDate = options.verticalCompleteDate ?? null;
  o.readyToStartDate = options.readyToStartDate ?? null;
  o.targetEndDateProbability = options.targetEndDateProbability ?? null;
  o.schedulingExclusionDates = (options.schedulingExclusionDates ?? []).map((i) =>
    maybeNew("SchedulingExclusionDate", i, cache, options.hasOwnProperty("schedulingExclusionDates"))
  );
  o.canSendTradePartnerAvailabilityRequestEmail = maybeNew(
    "PotentialOperation2",
    options.canSendTradePartnerAvailabilityRequestEmail,
    cache,
    options.hasOwnProperty("canSendTradePartnerAvailabilityRequestEmail"),
  );
  return o;
}

factories["PlanSchedule"] = newPlanSchedule;

export interface SavePlanScheduleResultOptions {
  __typename?: "SavePlanScheduleResult";
  planSchedule?: PlanSchedule | PlanScheduleOptions;
}

export function newSavePlanScheduleResult(
  options: SavePlanScheduleResultOptions = {},
  cache: Record<string, any> = {},
): SavePlanScheduleResult {
  const o = (options.__typename ? options : cache["SavePlanScheduleResult"] = {}) as SavePlanScheduleResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SavePlanScheduleResult";
  o.planSchedule = maybeNew("PlanSchedule", options.planSchedule, cache, options.hasOwnProperty("planSchedule"));
  return o;
}

factories["SavePlanScheduleResult"] = newSavePlanScheduleResult;

export interface DraftScheduleResultOptions {
  __typename?: "DraftScheduleResult";
  planTasks?: Array<PlanTask | PlanTaskOptions>;
  newlyCompletedPlanTasks?: Array<PlanTask | PlanTaskOptions>;
  tradeConfirmPlanTasks?: Array<PlanTask | PlanTaskOptions>;
  planSchedule?: PlanSchedule | PlanScheduleOptions;
  bills?: Array<Bill | BillOptions> | null;
  planTaskDetail?: PlanTask | PlanTaskOptions | null;
}

export function newDraftScheduleResult(
  options: DraftScheduleResultOptions = {},
  cache: Record<string, any> = {},
): DraftScheduleResult {
  const o = (options.__typename ? options : cache["DraftScheduleResult"] = {}) as DraftScheduleResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DraftScheduleResult";
  o.planTasks = (options.planTasks ?? []).map((i) =>
    maybeNew("PlanTask", i, cache, options.hasOwnProperty("planTasks"))
  );
  o.newlyCompletedPlanTasks = (options.newlyCompletedPlanTasks ?? []).map((i) =>
    maybeNew("PlanTask", i, cache, options.hasOwnProperty("newlyCompletedPlanTasks"))
  );
  o.tradeConfirmPlanTasks = (options.tradeConfirmPlanTasks ?? []).map((i) =>
    maybeNew("PlanTask", i, cache, options.hasOwnProperty("tradeConfirmPlanTasks"))
  );
  o.planSchedule = maybeNew("PlanSchedule", options.planSchedule, cache, options.hasOwnProperty("planSchedule"));
  o.bills = (options.bills ?? []).map((i) => maybeNew("Bill", i, cache, options.hasOwnProperty("bills")));
  o.planTaskDetail = maybeNewOrNull("PlanTask", options.planTaskDetail, cache);
  return o;
}

factories["DraftScheduleResult"] = newDraftScheduleResult;

export interface PlanScheduleSnapshotsResultOptions {
  __typename?: "PlanScheduleSnapshotsResult";
  taskSnapshots?: Array<TaskSnapshot | TaskSnapshotOptions>;
  planMilestoneSnapshots?: Array<PlanMilestoneSnapshot | PlanMilestoneSnapshotOptions>;
}

export function newPlanScheduleSnapshotsResult(
  options: PlanScheduleSnapshotsResultOptions = {},
  cache: Record<string, any> = {},
): PlanScheduleSnapshotsResult {
  const o = (options.__typename ? options : cache["PlanScheduleSnapshotsResult"] = {}) as PlanScheduleSnapshotsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PlanScheduleSnapshotsResult";
  o.taskSnapshots = (options.taskSnapshots ?? []).map((i) =>
    maybeNew("TaskSnapshot", i, cache, options.hasOwnProperty("taskSnapshots"))
  );
  o.planMilestoneSnapshots = (options.planMilestoneSnapshots ?? []).map((i) =>
    maybeNew("PlanMilestoneSnapshot", i, cache, options.hasOwnProperty("planMilestoneSnapshots"))
  );
  return o;
}

factories["PlanScheduleSnapshotsResult"] = newPlanScheduleSnapshotsResult;

export interface SavePlanTaskResultOptions {
  __typename?: "SavePlanTaskResult";
  planTask?: PlanTask | PlanTaskOptions;
}

export function newSavePlanTaskResult(
  options: SavePlanTaskResultOptions = {},
  cache: Record<string, any> = {},
): SavePlanTaskResult {
  const o = (options.__typename ? options : cache["SavePlanTaskResult"] = {}) as SavePlanTaskResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SavePlanTaskResult";
  o.planTask = maybeNew("PlanTask", options.planTask, cache, options.hasOwnProperty("planTask"));
  return o;
}

factories["SavePlanTaskResult"] = newSavePlanTaskResult;

export interface PlanTasksResultOptions {
  __typename?: "PlanTasksResult";
  entities?: Array<PlanTask | PlanTaskOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newPlanTasksResult(
  options: PlanTasksResultOptions = {},
  cache: Record<string, any> = {},
): PlanTasksResult {
  const o = (options.__typename ? options : cache["PlanTasksResult"] = {}) as PlanTasksResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PlanTasksResult";
  o.entities = (options.entities ?? []).map((i) => maybeNew("PlanTask", i, cache, options.hasOwnProperty("entities")));
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["PlanTasksResult"] = newPlanTasksResult;

export interface SimulationProbabilityOptions {
  __typename?: "SimulationProbability";
  startDateBasisPoints?: SimulationProbability["startDateBasisPoints"];
  endDateBasisPoints?: SimulationProbability["endDateBasisPoints"];
  potentialStartDateBasisPoints?: Array<PotentialDateBasisPoints | PotentialDateBasisPointsOptions> | null;
  potentialEndDateBasisPoints?: Array<PotentialDateBasisPoints | PotentialDateBasisPointsOptions> | null;
}

export function newSimulationProbability(
  options: SimulationProbabilityOptions = {},
  cache: Record<string, any> = {},
): SimulationProbability {
  const o = (options.__typename ? options : cache["SimulationProbability"] = {}) as SimulationProbability;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SimulationProbability";
  o.startDateBasisPoints = options.startDateBasisPoints ?? null;
  o.endDateBasisPoints = options.endDateBasisPoints ?? null;
  o.potentialStartDateBasisPoints = (options.potentialStartDateBasisPoints ?? []).map((i) =>
    maybeNew("PotentialDateBasisPoints", i, cache, options.hasOwnProperty("potentialStartDateBasisPoints"))
  );
  o.potentialEndDateBasisPoints = (options.potentialEndDateBasisPoints ?? []).map((i) =>
    maybeNew("PotentialDateBasisPoints", i, cache, options.hasOwnProperty("potentialEndDateBasisPoints"))
  );
  return o;
}

factories["SimulationProbability"] = newSimulationProbability;

export interface PotentialDateBasisPointsOptions {
  __typename?: "PotentialDateBasisPoints";
  date?: PotentialDateBasisPoints["date"];
  basisPoints?: PotentialDateBasisPoints["basisPoints"];
}

export function newPotentialDateBasisPoints(
  options: PotentialDateBasisPointsOptions = {},
  cache: Record<string, any> = {},
): PotentialDateBasisPoints {
  const o = (options.__typename ? options : cache["PotentialDateBasisPoints"] = {}) as PotentialDateBasisPoints;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PotentialDateBasisPoints";
  o.date = options.date ?? newDate();
  o.basisPoints = options.basisPoints ?? 0;
  return o;
}

factories["PotentialDateBasisPoints"] = newPotentialDateBasisPoints;

export interface PlanTaskChecklistItemOptions {
  __typename?: "PlanTaskChecklistItem";
  id?: PlanTaskChecklistItem["id"];
  name?: PlanTaskChecklistItem["name"];
  completedAt?: PlanTaskChecklistItem["completedAt"];
  createdAt?: PlanTaskChecklistItem["createdAt"];
  updatedAt?: PlanTaskChecklistItem["updatedAt"];
  planTask?: PlanTask | PlanTaskOptions;
  completedBy?: User | UserOptions | null;
  globalItem?: GlobalPlanTaskChecklistItem | GlobalPlanTaskChecklistItemOptions;
}

export function newPlanTaskChecklistItem(
  options: PlanTaskChecklistItemOptions = {},
  cache: Record<string, any> = {},
): PlanTaskChecklistItem {
  const o = (options.__typename ? options : cache["PlanTaskChecklistItem"] = {}) as PlanTaskChecklistItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PlanTaskChecklistItem";
  o.id = options.id ?? nextFactoryId("PlanTaskChecklistItem");
  o.name = options.name ?? "name";
  o.completedAt = options.completedAt ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.planTask = maybeNew("PlanTask", options.planTask, cache, options.hasOwnProperty("planTask"));
  o.completedBy = maybeNewOrNull("User", options.completedBy, cache);
  o.globalItem = maybeNew(
    "GlobalPlanTaskChecklistItem",
    options.globalItem,
    cache,
    options.hasOwnProperty("globalItem"),
  );
  return o;
}

factories["PlanTaskChecklistItem"] = newPlanTaskChecklistItem;

export interface SavePlanTaskChecklistItemResultOptions {
  __typename?: "SavePlanTaskChecklistItemResult";
  planTaskChecklistItem?: PlanTaskChecklistItem | PlanTaskChecklistItemOptions;
}

export function newSavePlanTaskChecklistItemResult(
  options: SavePlanTaskChecklistItemResultOptions = {},
  cache: Record<string, any> = {},
): SavePlanTaskChecklistItemResult {
  const o =
    (options.__typename ? options : cache["SavePlanTaskChecklistItemResult"] = {}) as SavePlanTaskChecklistItemResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SavePlanTaskChecklistItemResult";
  o.planTaskChecklistItem = maybeNew(
    "PlanTaskChecklistItem",
    options.planTaskChecklistItem,
    cache,
    options.hasOwnProperty("planTaskChecklistItem"),
  );
  return o;
}

factories["SavePlanTaskChecklistItemResult"] = newSavePlanTaskChecklistItemResult;

export interface PreconContractTypeOptions {
  __typename?: "PreconContractType";
  id?: PreconContractType["id"];
  name?: PreconContractType["name"];
  createdAt?: PreconContractType["createdAt"];
  updatedAt?: PreconContractType["updatedAt"];
  projects?: Array<StandaloneProject | StandaloneProjectOptions>;
  inviteHomeowners?: PreconContractType["inviteHomeowners"];
  needsWeeklyUpdate?: PreconContractType["needsWeeklyUpdate"];
}

export function newPreconContractType(
  options: PreconContractTypeOptions = {},
  cache: Record<string, any> = {},
): PreconContractType {
  const o = (options.__typename ? options : cache["PreconContractType"] = {}) as PreconContractType;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PreconContractType";
  o.id = options.id ?? nextFactoryId("PreconContractType");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.projects = (options.projects ?? []).map((i) =>
    maybeNew("StandaloneProject", i, cache, options.hasOwnProperty("projects"))
  );
  o.inviteHomeowners = options.inviteHomeowners ?? false;
  o.needsWeeklyUpdate = options.needsWeeklyUpdate ?? false;
  return o;
}

factories["PreconContractType"] = newPreconContractType;

export interface SavePreconContractTypeResultOptions {
  __typename?: "SavePreconContractTypeResult";
  preconContractType?: PreconContractType | PreconContractTypeOptions;
}

export function newSavePreconContractTypeResult(
  options: SavePreconContractTypeResultOptions = {},
  cache: Record<string, any> = {},
): SavePreconContractTypeResult {
  const o = (options.__typename ? options : cache["SavePreconContractTypeResult"] = {}) as SavePreconContractTypeResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SavePreconContractTypeResult";
  o.preconContractType = maybeNew(
    "PreconContractType",
    options.preconContractType,
    cache,
    options.hasOwnProperty("preconContractType"),
  );
  return o;
}

factories["SavePreconContractTypeResult"] = newSavePreconContractTypeResult;

export interface ProductsPageOptions {
  __typename?: "ProductsPage";
  products?: Array<Product | ProductOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newProductsPage(options: ProductsPageOptions = {}, cache: Record<string, any> = {}): ProductsPage {
  const o = (options.__typename ? options : cache["ProductsPage"] = {}) as ProductsPage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProductsPage";
  o.products = (options.products ?? []).map((i) => maybeNew("Product", i, cache, options.hasOwnProperty("products")));
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["ProductsPage"] = newProductsPage;

export interface SaveProductsResultOptions {
  __typename?: "SaveProductsResult";
  products?: Array<Product | ProductOptions>;
}

export function newSaveProductsResult(
  options: SaveProductsResultOptions = {},
  cache: Record<string, any> = {},
): SaveProductsResult {
  const o = (options.__typename ? options : cache["SaveProductsResult"] = {}) as SaveProductsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveProductsResult";
  o.products = (options.products ?? []).map((i) => maybeNew("Product", i, cache, options.hasOwnProperty("products")));
  return o;
}

factories["SaveProductsResult"] = newSaveProductsResult;

export interface ProductAttributeOptions {
  __typename?: "ProductAttribute";
  id?: ProductAttribute["id"];
  type?: ProductAttribute["type"];
  value?: ProductAttribute["value"];
}

export function newProductAttribute(
  options: ProductAttributeOptions = {},
  cache: Record<string, any> = {},
): ProductAttribute {
  const o = (options.__typename ? options : cache["ProductAttribute"] = {}) as ProductAttribute;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProductAttribute";
  o.id = options.id ?? nextFactoryId("ProductAttribute");
  o.type = options.type ?? ProductAttributeType.Finish;
  o.value = options.value ?? "value";
  return o;
}

factories["ProductAttribute"] = newProductAttribute;

export interface SaveProductAttributesResultOptions {
  __typename?: "SaveProductAttributesResult";
  attributes?: Array<ProductAttribute | ProductAttributeOptions>;
}

export function newSaveProductAttributesResult(
  options: SaveProductAttributesResultOptions = {},
  cache: Record<string, any> = {},
): SaveProductAttributesResult {
  const o = (options.__typename ? options : cache["SaveProductAttributesResult"] = {}) as SaveProductAttributesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveProductAttributesResult";
  o.attributes = (options.attributes ?? []).map((i) =>
    maybeNew("ProductAttribute", i, cache, options.hasOwnProperty("attributes"))
  );
  return o;
}

factories["SaveProductAttributesResult"] = newSaveProductAttributesResult;

export interface ProductDimensionOptions {
  __typename?: "ProductDimension";
  id?: ProductDimension["id"];
  rawValue?: ProductDimension["rawValue"];
  dimensionType?: ProductDimensionTypeDetailOptions | ProductDimensionType;
  product?: Product | ProductOptions;
}

export function newProductDimension(
  options: ProductDimensionOptions = {},
  cache: Record<string, any> = {},
): ProductDimension {
  const o = (options.__typename ? options : cache["ProductDimension"] = {}) as ProductDimension;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProductDimension";
  o.id = options.id ?? nextFactoryId("ProductDimension");
  o.rawValue = options.rawValue ?? "rawValue";
  o.dimensionType = enumOrDetailOfProductDimensionType(options.dimensionType);
  o.product = maybeNew("Product", options.product, cache, options.hasOwnProperty("product"));
  return o;
}

factories["ProductDimension"] = newProductDimension;

export interface ProductImageOptions {
  __typename?: "ProductImage";
  id?: ProductImage["id"];
  product?: Product | ProductOptions;
  asset?: Asset | AssetOptions;
}

export function newProductImage(options: ProductImageOptions = {}, cache: Record<string, any> = {}): ProductImage {
  const o = (options.__typename ? options : cache["ProductImage"] = {}) as ProductImage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProductImage";
  o.id = options.id ?? nextFactoryId("ProductImage");
  o.product = maybeNew("Product", options.product, cache, options.hasOwnProperty("product"));
  o.asset = maybeNew("Asset", options.asset, cache, options.hasOwnProperty("asset"));
  return o;
}

factories["ProductImage"] = newProductImage;

export interface ProductOfferingOptions {
  __typename?: "ProductOffering";
  id?: ProductOffering["id"];
  name?: ProductOffering["name"];
  displayName?: ProductOffering["displayName"];
  description?: ProductOffering["description"];
  createdAt?: ProductOffering["createdAt"];
  updatedAt?: ProductOffering["updatedAt"];
  type?: ReadyPlanTypeDetailOptions | ReadyPlanType;
  code?: ProductOffering["code"];
  displayCode?: ProductOffering["displayCode"];
  blueprintUrl?: Url | UrlOptions;
  constructionDocumentCompletePercentage?: ProductOffering["constructionDocumentCompletePercentage"];
  status?: ReadyPlanStatusDetailOptions | ReadyPlanStatus;
  effectiveStatus?: ReadyPlanStatusDetailOptions | ReadyPlanStatus;
  development?: Development | DevelopmentOptions | null;
  underwritingTemplate?: ItemTemplate | ItemTemplateOptions | null;
  maxProgramData?: ProgramData | ProgramDataOptions;
  minProgramData?: ProgramData | ProgramDataOptions;
  programData?: ProgramData | ProgramDataOptions;
  itemTemplates?: Array<ItemTemplate | ItemTemplateOptions>;
  options?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  optionGroups?: Array<ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions>;
  userEvents?: Array<UserEvent | UserEventOptions>;
  planPackage?: PlanPackage | PlanPackageOptions;
  programDatas?: Array<ReadyPlanProgramData | ReadyPlanProgramDataOptions>;
  copyInProgress?: ProductOffering["copyInProgress"];
  bidPackages?: Array<BidPackage | BidPackageOptions>;
  assets?: Array<ReadyPlanAsset | ReadyPlanAssetOptions>;
  lotTypes?: ProductOffering["lotTypes"];
  baseConfig?: ProductOfferingConfig | ProductOfferingConfigOptions | null;
  configs?: Array<ProductOfferingConfig | ProductOfferingConfigOptions>;
  projectConfigs?: Array<ProjectReadyPlanConfig | ProjectReadyPlanConfigOptions>;
  bidOutPercentage?: ProductOffering["bidOutPercentage"];
  coverAsset?: Asset | AssetOptions | null;
  floorPlanAsset?: Asset | AssetOptions | null;
  floorPlanAssets?: Array<ReadyPlanAsset | ReadyPlanAssetOptions>;
  interiorDesignPackage?: DesignPackage | DesignPackageOptions;
  exteriorDesignPackage?: DesignPackage | DesignPackageOptions;
  designPackageCombinations?: Array<DesignPackageCombination | DesignPackageCombinationOptions>;
  aggregateActive?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  aggregateDraft?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  aggregateLatest?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  aggregateCheckout?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  aggregateVersions?: Array<ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions>;
  version?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  availableUpdates?: Array<ProductOfferingIncomingUpdate | ProductOfferingIncomingUpdateOptions>;
  itemLocations?: Array<Location | LocationOptions>;
  costCodes?: Array<CostCode | CostCodeOptions>;
  canEditLineItems?: PotentialOperation2 | PotentialOperation2Options;
  contingencyMarkupPercentage?: ProductOffering["contingencyMarkupPercentage"];
  canEdit?: PotentialOperation2 | PotentialOperation2Options;
  canEditOptions?: PotentialOperation2 | PotentialOperation2Options;
  publishToUnderwriting?: ProductOffering["publishToUnderwriting"];
  tourUrl?: ProductOffering["tourUrl"];
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  checkoutConfigs?: Array<CheckoutConfig | CheckoutConfigOptions>;
  showInCheckout?: ProductOffering["showInCheckout"];
  documents?: Array<Document | DocumentOptions>;
  rendering?: Asset | AssetOptions | null;
  interiorRenderings?: Array<InteriorRoomRendering | InteriorRoomRenderingOptions>;
  renderings?: Array<RenderingAsset | RenderingAssetOptions>;
  requiredOptions?: Array<ReadyPlanRequiredOption | ReadyPlanRequiredOptionOptions>;
  owner?: InternalUser | InternalUserOptions | null;
  cloneInProgress?: ProductOffering["cloneInProgress"];
  insideMapsMissingLocations?: ProductOffering["insideMapsMissingLocations"];
  promoteInProgress?: ProductOffering["promoteInProgress"];
  buildableLots?: Array<Lot | LotOptions>;
  insideMapsPacket?: ProductOffering["insideMapsPacket"];
  architectureFeePriceInCents?: ProductOffering["architectureFeePriceInCents"];
  preconServicesPriceInCents?: ProductOffering["preconServicesPriceInCents"];
}

export function newProductOffering(
  options: ProductOfferingOptions = {},
  cache: Record<string, any> = {},
): ProductOffering {
  const o = (options.__typename ? options : cache["ProductOffering"] = {}) as ProductOffering;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProductOffering";
  o.id = options.id ?? nextFactoryId("ProductOffering");
  o.name = options.name ?? "name";
  o.displayName = options.displayName ?? "displayName";
  o.description = options.description ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.type = enumOrDetailOfReadyPlanType(options.type);
  o.code = options.code ?? null;
  o.displayCode = options.displayCode ?? null;
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.constructionDocumentCompletePercentage = options.constructionDocumentCompletePercentage ?? 0;
  o.status = enumOrDetailOfReadyPlanStatus(options.status);
  o.effectiveStatus = enumOrDetailOfReadyPlanStatus(options.effectiveStatus);
  o.development = maybeNewOrNull("Development", options.development, cache);
  o.underwritingTemplate = maybeNewOrNull("ItemTemplate", options.underwritingTemplate, cache);
  o.maxProgramData = maybeNew("ProgramData", options.maxProgramData, cache, options.hasOwnProperty("maxProgramData"));
  o.minProgramData = maybeNew("ProgramData", options.minProgramData, cache, options.hasOwnProperty("minProgramData"));
  o.programData = maybeNew("ProgramData", options.programData, cache, options.hasOwnProperty("programData"));
  o.itemTemplates = (options.itemTemplates ?? []).map((i) =>
    maybeNew("ItemTemplate", i, cache, options.hasOwnProperty("itemTemplates"))
  );
  o.options = (options.options ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("options"))
  );
  o.optionGroups = (options.optionGroups ?? []).map((i) =>
    maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("optionGroups"))
  );
  o.userEvents = (options.userEvents ?? []).map((i) =>
    maybeNew("UserEvent", i, cache, options.hasOwnProperty("userEvents"))
  );
  o.planPackage = maybeNew("PlanPackage", options.planPackage, cache, options.hasOwnProperty("planPackage"));
  o.programDatas = (options.programDatas ?? []).map((i) =>
    maybeNew("ReadyPlanProgramData", i, cache, options.hasOwnProperty("programDatas"))
  );
  o.copyInProgress = options.copyInProgress ?? false;
  o.bidPackages = (options.bidPackages ?? []).map((i) =>
    maybeNew("BidPackage", i, cache, options.hasOwnProperty("bidPackages"))
  );
  o.assets = (options.assets ?? []).map((i) => maybeNew("ReadyPlanAsset", i, cache, options.hasOwnProperty("assets")));
  o.lotTypes = options.lotTypes ?? [];
  o.baseConfig = maybeNewOrNull("ProductOfferingConfig", options.baseConfig, cache);
  o.configs = (options.configs ?? []).map((i) =>
    maybeNew("ProductOfferingConfig", i, cache, options.hasOwnProperty("configs"))
  );
  o.projectConfigs = (options.projectConfigs ?? []).map((i) =>
    maybeNew("ProjectReadyPlanConfig", i, cache, options.hasOwnProperty("projectConfigs"))
  );
  o.bidOutPercentage = options.bidOutPercentage ?? 0;
  o.coverAsset = maybeNewOrNull("Asset", options.coverAsset, cache);
  o.floorPlanAsset = maybeNewOrNull("Asset", options.floorPlanAsset, cache);
  o.floorPlanAssets = (options.floorPlanAssets ?? []).map((i) =>
    maybeNew("ReadyPlanAsset", i, cache, options.hasOwnProperty("floorPlanAssets"))
  );
  o.interiorDesignPackage = maybeNew(
    "DesignPackage",
    options.interiorDesignPackage,
    cache,
    options.hasOwnProperty("interiorDesignPackage"),
  );
  o.exteriorDesignPackage = maybeNew(
    "DesignPackage",
    options.exteriorDesignPackage,
    cache,
    options.hasOwnProperty("exteriorDesignPackage"),
  );
  o.designPackageCombinations = (options.designPackageCombinations ?? []).map((i) =>
    maybeNew("DesignPackageCombination", i, cache, options.hasOwnProperty("designPackageCombinations"))
  );
  o.aggregateActive = maybeNewOrNull("ReadyPlanAggregateVersion", options.aggregateActive, cache);
  o.aggregateDraft = maybeNewOrNull("ReadyPlanAggregateVersion", options.aggregateDraft, cache);
  o.aggregateLatest = maybeNew(
    "ReadyPlanAggregateVersion",
    options.aggregateLatest,
    cache,
    options.hasOwnProperty("aggregateLatest"),
  );
  o.aggregateCheckout = maybeNewOrNull("ReadyPlanAggregateVersion", options.aggregateCheckout, cache);
  o.aggregateVersions = (options.aggregateVersions ?? []).map((i) =>
    maybeNew("ReadyPlanAggregateVersion", i, cache, options.hasOwnProperty("aggregateVersions"))
  );
  o.version = maybeNew("ReadyPlanAggregateVersion", options.version, cache, options.hasOwnProperty("version"));
  o.availableUpdates = (options.availableUpdates ?? []).map((i) =>
    maybeNew("ProductOfferingIncomingUpdate", i, cache, options.hasOwnProperty("availableUpdates"))
  );
  o.itemLocations = (options.itemLocations ?? []).map((i) =>
    maybeNew("Location", i, cache, options.hasOwnProperty("itemLocations"))
  );
  o.costCodes = (options.costCodes ?? []).map((i) =>
    maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
  );
  o.canEditLineItems = maybeNew(
    "PotentialOperation2",
    options.canEditLineItems,
    cache,
    options.hasOwnProperty("canEditLineItems"),
  );
  o.contingencyMarkupPercentage = options.contingencyMarkupPercentage ?? null;
  o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
  o.canEditOptions = maybeNew(
    "PotentialOperation2",
    options.canEditOptions,
    cache,
    options.hasOwnProperty("canEditOptions"),
  );
  o.publishToUnderwriting = options.publishToUnderwriting ?? false;
  o.tourUrl = options.tourUrl ?? null;
  o.project = maybeNewOrNull("Project", options.project, cache);
  o.checkoutConfigs = (options.checkoutConfigs ?? []).map((i) =>
    maybeNew("CheckoutConfig", i, cache, options.hasOwnProperty("checkoutConfigs"))
  );
  o.showInCheckout = options.showInCheckout ?? false;
  o.documents = (options.documents ?? []).map((i) =>
    maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
  );
  o.rendering = maybeNewOrNull("Asset", options.rendering, cache);
  o.interiorRenderings = (options.interiorRenderings ?? []).map((i) =>
    maybeNew("InteriorRoomRendering", i, cache, options.hasOwnProperty("interiorRenderings"))
  );
  o.renderings = (options.renderings ?? []).map((i) =>
    maybeNew("RenderingAsset", i, cache, options.hasOwnProperty("renderings"))
  );
  o.requiredOptions = (options.requiredOptions ?? []).map((i) =>
    maybeNew("ReadyPlanRequiredOption", i, cache, options.hasOwnProperty("requiredOptions"))
  );
  o.owner = maybeNewOrNull("InternalUser", options.owner, cache);
  o.cloneInProgress = options.cloneInProgress ?? false;
  o.insideMapsMissingLocations = options.insideMapsMissingLocations ?? [];
  o.promoteInProgress = options.promoteInProgress ?? false;
  o.buildableLots = (options.buildableLots ?? []).map((i) =>
    maybeNew("Lot", i, cache, options.hasOwnProperty("buildableLots"))
  );
  o.insideMapsPacket = options.insideMapsPacket ?? null;
  o.architectureFeePriceInCents = options.architectureFeePriceInCents ?? null;
  o.preconServicesPriceInCents = options.preconServicesPriceInCents ?? null;
  return o;
}

factories["ProductOffering"] = newProductOffering;

export interface ProductOfferingsPageResultOptions {
  __typename?: "ProductOfferingsPageResult";
  entities?: Array<ProductOffering | ProductOfferingOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newProductOfferingsPageResult(
  options: ProductOfferingsPageResultOptions = {},
  cache: Record<string, any> = {},
): ProductOfferingsPageResult {
  const o = (options.__typename ? options : cache["ProductOfferingsPageResult"] = {}) as ProductOfferingsPageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProductOfferingsPageResult";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("ProductOffering", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["ProductOfferingsPageResult"] = newProductOfferingsPageResult;

export interface SaveProductOfferingResultOptions {
  __typename?: "SaveProductOfferingResult";
  productOffering?: ProductOffering | ProductOfferingOptions;
}

export function newSaveProductOfferingResult(
  options: SaveProductOfferingResultOptions = {},
  cache: Record<string, any> = {},
): SaveProductOfferingResult {
  const o = (options.__typename ? options : cache["SaveProductOfferingResult"] = {}) as SaveProductOfferingResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveProductOfferingResult";
  o.productOffering = maybeNew(
    "ProductOffering",
    options.productOffering,
    cache,
    options.hasOwnProperty("productOffering"),
  );
  return o;
}

factories["SaveProductOfferingResult"] = newSaveProductOfferingResult;

export interface DesignPackageCombinationOptions {
  __typename?: "DesignPackageCombination";
  readyPlanOptions?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  bidOutPercentage?: DesignPackageCombination["bidOutPercentage"];
}

export function newDesignPackageCombination(
  options: DesignPackageCombinationOptions = {},
  cache: Record<string, any> = {},
): DesignPackageCombination {
  const o = (options.__typename ? options : cache["DesignPackageCombination"] = {}) as DesignPackageCombination;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DesignPackageCombination";
  o.readyPlanOptions = (options.readyPlanOptions ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("readyPlanOptions"))
  );
  o.bidOutPercentage = options.bidOutPercentage ?? 0;
  return o;
}

factories["DesignPackageCombination"] = newDesignPackageCombination;

export interface ReadyPlanOptionCostAndPriceDeltaOptions {
  __typename?: "ReadyPlanOptionCostAndPriceDelta";
  readyPlanOption?: ReadyPlanOption | ReadyPlanOptionOptions;
  totalCostInCents?: ReadyPlanOptionCostAndPriceDelta["totalCostInCents"];
  totalPriceInCents?: ReadyPlanOptionCostAndPriceDelta["totalPriceInCents"];
  preCutoffTotalPriceInCents?: ReadyPlanOptionCostAndPriceDelta["preCutoffTotalPriceInCents"];
  preCutoffDesiredMarginInBasisPoints?: ReadyPlanOptionCostAndPriceDelta["preCutoffDesiredMarginInBasisPoints"];
  postCutoffTotalPriceInCents?: ReadyPlanOptionCostAndPriceDelta["postCutoffTotalPriceInCents"];
  postCutoffDesiredMarginInBasisPoints?: ReadyPlanOptionCostAndPriceDelta["postCutoffDesiredMarginInBasisPoints"];
  selectionFeeInCents?: ReadyPlanOptionCostAndPriceDelta["selectionFeeInCents"];
  minimumPriceInCents?: ReadyPlanOptionCostAndPriceDelta["minimumPriceInCents"];
}

export function newReadyPlanOptionCostAndPriceDelta(
  options: ReadyPlanOptionCostAndPriceDeltaOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanOptionCostAndPriceDelta {
  const o =
    (options.__typename ? options : cache["ReadyPlanOptionCostAndPriceDelta"] = {}) as ReadyPlanOptionCostAndPriceDelta;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanOptionCostAndPriceDelta";
  o.readyPlanOption = maybeNew(
    "ReadyPlanOption",
    options.readyPlanOption,
    cache,
    options.hasOwnProperty("readyPlanOption"),
  );
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.totalPriceInCents = options.totalPriceInCents ?? 0;
  o.preCutoffTotalPriceInCents = options.preCutoffTotalPriceInCents ?? 0;
  o.preCutoffDesiredMarginInBasisPoints = options.preCutoffDesiredMarginInBasisPoints ?? 0;
  o.postCutoffTotalPriceInCents = options.postCutoffTotalPriceInCents ?? null;
  o.postCutoffDesiredMarginInBasisPoints = options.postCutoffDesiredMarginInBasisPoints ?? null;
  o.selectionFeeInCents = options.selectionFeeInCents ?? 0;
  o.minimumPriceInCents = options.minimumPriceInCents ?? 0;
  return o;
}

factories["ReadyPlanOptionCostAndPriceDelta"] = newReadyPlanOptionCostAndPriceDelta;

export interface ComputeProductOfferingCostsAndPricesResponseOptions {
  __typename?: "ComputeProductOfferingCostsAndPricesResponse";
  productOffering?: ProductOffering | ProductOfferingOptions;
  baseCostInCents?: ComputeProductOfferingCostsAndPricesResponse["baseCostInCents"];
  basePriceInCents?: ComputeProductOfferingCostsAndPricesResponse["basePriceInCents"];
  totalCostInCents?: ComputeProductOfferingCostsAndPricesResponse["totalCostInCents"];
  preCutoffTotalPriceInCents?: ComputeProductOfferingCostsAndPricesResponse["preCutoffTotalPriceInCents"];
  postCutoffTotalPriceInCents?: ComputeProductOfferingCostsAndPricesResponse["postCutoffTotalPriceInCents"];
  selectedOptions?: Array<ReadyPlanOptionCostAndPriceDelta | ReadyPlanOptionCostAndPriceDeltaOptions>;
  unselectedOptions?: Array<ReadyPlanOptionCostAndPriceDelta | ReadyPlanOptionCostAndPriceDeltaOptions>;
  allOptions?: Array<ReadyPlanOptionCostAndPriceDelta | ReadyPlanOptionCostAndPriceDeltaOptions>;
}

export function newComputeProductOfferingCostsAndPricesResponse(
  options: ComputeProductOfferingCostsAndPricesResponseOptions = {},
  cache: Record<string, any> = {},
): ComputeProductOfferingCostsAndPricesResponse {
  const o =
    (options.__typename
      ? options
      : cache["ComputeProductOfferingCostsAndPricesResponse"] = {}) as ComputeProductOfferingCostsAndPricesResponse;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ComputeProductOfferingCostsAndPricesResponse";
  o.productOffering = maybeNew(
    "ProductOffering",
    options.productOffering,
    cache,
    options.hasOwnProperty("productOffering"),
  );
  o.baseCostInCents = options.baseCostInCents ?? 0;
  o.basePriceInCents = options.basePriceInCents ?? 0;
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.preCutoffTotalPriceInCents = options.preCutoffTotalPriceInCents ?? 0;
  o.postCutoffTotalPriceInCents = options.postCutoffTotalPriceInCents ?? 0;
  o.selectedOptions = (options.selectedOptions ?? []).map((i) =>
    maybeNew("ReadyPlanOptionCostAndPriceDelta", i, cache, options.hasOwnProperty("selectedOptions"))
  );
  o.unselectedOptions = (options.unselectedOptions ?? []).map((i) =>
    maybeNew("ReadyPlanOptionCostAndPriceDelta", i, cache, options.hasOwnProperty("unselectedOptions"))
  );
  o.allOptions = (options.allOptions ?? []).map((i) =>
    maybeNew("ReadyPlanOptionCostAndPriceDelta", i, cache, options.hasOwnProperty("allOptions"))
  );
  return o;
}

factories["ComputeProductOfferingCostsAndPricesResponse"] = newComputeProductOfferingCostsAndPricesResponse;

export interface CalculateScopeChangeResultOptions {
  __typename?: "CalculateScopeChangeResult";
  added?: Array<TakeoffLineItemVersion | TakeoffLineItemVersionOptions>;
  removed?: Array<TakeoffLineItemVersion | TakeoffLineItemVersionOptions>;
}

export function newCalculateScopeChangeResult(
  options: CalculateScopeChangeResultOptions = {},
  cache: Record<string, any> = {},
): CalculateScopeChangeResult {
  const o = (options.__typename ? options : cache["CalculateScopeChangeResult"] = {}) as CalculateScopeChangeResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CalculateScopeChangeResult";
  o.added = (options.added ?? []).map((i) =>
    maybeNew("TakeoffLineItemVersion", i, cache, options.hasOwnProperty("added"))
  );
  o.removed = (options.removed ?? []).map((i) =>
    maybeNew("TakeoffLineItemVersion", i, cache, options.hasOwnProperty("removed"))
  );
  return o;
}

factories["CalculateScopeChangeResult"] = newCalculateScopeChangeResult;

export interface InteriorRoomRenderingOptions {
  __typename?: "InteriorRoomRendering";
  roomName?: InteriorRoomRendering["roomName"];
  interiorScheme?: InteriorRoomRendering["interiorScheme"];
  asset?: Asset | AssetOptions | null;
}

export function newInteriorRoomRendering(
  options: InteriorRoomRenderingOptions = {},
  cache: Record<string, any> = {},
): InteriorRoomRendering {
  const o = (options.__typename ? options : cache["InteriorRoomRendering"] = {}) as InteriorRoomRendering;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InteriorRoomRendering";
  o.roomName = options.roomName ?? "roomName";
  o.interiorScheme = options.interiorScheme ?? "interiorScheme";
  o.asset = maybeNewOrNull("Asset", options.asset, cache);
  return o;
}

factories["InteriorRoomRendering"] = newInteriorRoomRendering;

export interface RenderingAssetOptions {
  __typename?: "RenderingAsset";
  type?: ReadyPlanAssetTypeDetailOptions | ReadyPlanAssetType;
  asset?: Asset | AssetOptions;
}

export function newRenderingAsset(
  options: RenderingAssetOptions = {},
  cache: Record<string, any> = {},
): RenderingAsset {
  const o = (options.__typename ? options : cache["RenderingAsset"] = {}) as RenderingAsset;
  (cache.all ??= new Set()).add(o);
  o.__typename = "RenderingAsset";
  o.type = enumOrDetailOfReadyPlanAssetType(options.type);
  o.asset = maybeNew("Asset", options.asset, cache, options.hasOwnProperty("asset"));
  return o;
}

factories["RenderingAsset"] = newRenderingAsset;

export interface ProductOfferingConfigOptions {
  __typename?: "ProductOfferingConfig";
  id?: ProductOfferingConfig["id"];
  name?: ProductOfferingConfig["name"];
  createdAt?: ProductOfferingConfig["createdAt"];
  updatedAt?: ProductOfferingConfig["updatedAt"];
  createdBy?: User | UserOptions;
  productOffering?: ProductOffering | ProductOfferingOptions;
  readyPlan?: ReadyPlan | PlanPackage | DesignPackage | ProductOffering | ReadyPlanLike | ReadyPlanLikeOptions;
  readyPlanOptions?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  baseConfigProductOffering?: ProductOffering | ProductOfferingOptions | null;
  archive?: ProductOfferingConfig["archive"];
  isBaseConfig?: ProductOfferingConfig["isBaseConfig"];
  programData?: ProgramData | ProgramDataOptions;
  totalCostInCents?: ProductOfferingConfig["totalCostInCents"];
  totalPriceInCents?: ProductOfferingConfig["totalPriceInCents"];
  hasCompleteCost?: ProductOfferingConfig["hasCompleteCost"];
  publishToUnderwriting?: ProductOfferingConfig["publishToUnderwriting"];
  salesPriceInCents?: ProductOfferingConfig["salesPriceInCents"];
  insideMapsTextureSwaps?: InsideMapsTextureSwaps | InsideMapsTextureSwapsOptions | null;
}

export function newProductOfferingConfig(
  options: ProductOfferingConfigOptions = {},
  cache: Record<string, any> = {},
): ProductOfferingConfig {
  const o = (options.__typename ? options : cache["ProductOfferingConfig"] = {}) as ProductOfferingConfig;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProductOfferingConfig";
  o.id = options.id ?? nextFactoryId("ProductOfferingConfig");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.createdBy = maybeNew("User", options.createdBy, cache, options.hasOwnProperty("createdBy"));
  o.productOffering = maybeNew(
    "ProductOffering",
    options.productOffering,
    cache,
    options.hasOwnProperty("productOffering"),
  );
  o.readyPlan = maybeNew("ReadyPlanLike", options.readyPlan, cache, options.hasOwnProperty("readyPlan"));
  o.readyPlanOptions = (options.readyPlanOptions ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("readyPlanOptions"))
  );
  o.baseConfigProductOffering = maybeNewOrNull("ProductOffering", options.baseConfigProductOffering, cache);
  o.archive = options.archive ?? false;
  o.isBaseConfig = options.isBaseConfig ?? false;
  o.programData = maybeNew("ProgramData", options.programData, cache, options.hasOwnProperty("programData"));
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.totalPriceInCents = options.totalPriceInCents ?? 0;
  o.hasCompleteCost = options.hasCompleteCost ?? false;
  o.publishToUnderwriting = options.publishToUnderwriting ?? false;
  o.salesPriceInCents = options.salesPriceInCents ?? null;
  o.insideMapsTextureSwaps = maybeNewOrNull("InsideMapsTextureSwaps", options.insideMapsTextureSwaps, cache);
  return o;
}

factories["ProductOfferingConfig"] = newProductOfferingConfig;

export interface SaveProductOfferingConfigResultOptions {
  __typename?: "SaveProductOfferingConfigResult";
  productOfferingConfig?: ProductOfferingConfig | ProductOfferingConfigOptions;
}

export function newSaveProductOfferingConfigResult(
  options: SaveProductOfferingConfigResultOptions = {},
  cache: Record<string, any> = {},
): SaveProductOfferingConfigResult {
  const o =
    (options.__typename ? options : cache["SaveProductOfferingConfigResult"] = {}) as SaveProductOfferingConfigResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveProductOfferingConfigResult";
  o.productOfferingConfig = maybeNew(
    "ProductOfferingConfig",
    options.productOfferingConfig,
    cache,
    options.hasOwnProperty("productOfferingConfig"),
  );
  return o;
}

factories["SaveProductOfferingConfigResult"] = newSaveProductOfferingConfigResult;

export interface ProductOfferingConfigsPageOptions {
  __typename?: "ProductOfferingConfigsPage";
  entities?: Array<ProductOfferingConfig | ProductOfferingConfigOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newProductOfferingConfigsPage(
  options: ProductOfferingConfigsPageOptions = {},
  cache: Record<string, any> = {},
): ProductOfferingConfigsPage {
  const o = (options.__typename ? options : cache["ProductOfferingConfigsPage"] = {}) as ProductOfferingConfigsPage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProductOfferingConfigsPage";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("ProductOfferingConfig", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["ProductOfferingConfigsPage"] = newProductOfferingConfigsPage;

export interface ComputeProductOfferingConfigCostsResultOptions {
  __typename?: "ComputeProductOfferingConfigCostsResult";
  configCosts?: Array<ConfigCostsResult | ConfigCostsResultOptions>;
}

export function newComputeProductOfferingConfigCostsResult(
  options: ComputeProductOfferingConfigCostsResultOptions = {},
  cache: Record<string, any> = {},
): ComputeProductOfferingConfigCostsResult {
  const o =
    (options.__typename
      ? options
      : cache["ComputeProductOfferingConfigCostsResult"] = {}) as ComputeProductOfferingConfigCostsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ComputeProductOfferingConfigCostsResult";
  o.configCosts = (options.configCosts ?? []).map((i) =>
    maybeNew("ConfigCostsResult", i, cache, options.hasOwnProperty("configCosts"))
  );
  return o;
}

factories["ComputeProductOfferingConfigCostsResult"] = newComputeProductOfferingConfigCostsResult;

export interface ConfigCostsResultOptions {
  __typename?: "ConfigCostsResult";
  productOfferingConfig?: ProductOfferingConfig | ProductOfferingConfigOptions;
  computedBaseCost?: ConfigCostsResult["computedBaseCost"];
  baseHouseCostInCents?: ConfigCostsResult["baseHouseCostInCents"];
  baseHouseHasCompleteCost?: ConfigCostsResult["baseHouseHasCompleteCost"];
  computedOptionCosts?: Array<ReadyPlanOptionConfigCosts | ReadyPlanOptionConfigCostsOptions>;
}

export function newConfigCostsResult(
  options: ConfigCostsResultOptions = {},
  cache: Record<string, any> = {},
): ConfigCostsResult {
  const o = (options.__typename ? options : cache["ConfigCostsResult"] = {}) as ConfigCostsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ConfigCostsResult";
  o.productOfferingConfig = maybeNew(
    "ProductOfferingConfig",
    options.productOfferingConfig,
    cache,
    options.hasOwnProperty("productOfferingConfig"),
  );
  o.computedBaseCost = options.computedBaseCost ?? 0;
  o.baseHouseCostInCents = options.baseHouseCostInCents ?? 0;
  o.baseHouseHasCompleteCost = options.baseHouseHasCompleteCost ?? false;
  o.computedOptionCosts = (options.computedOptionCosts ?? []).map((i) =>
    maybeNew("ReadyPlanOptionConfigCosts", i, cache, options.hasOwnProperty("computedOptionCosts"))
  );
  return o;
}

factories["ConfigCostsResult"] = newConfigCostsResult;

export interface ReadyPlanOptionConfigCostsOptions {
  __typename?: "ReadyPlanOptionConfigCosts";
  readyPlanOption?: ReadyPlanOption | ReadyPlanOptionOptions;
  totalCostInCents?: ReadyPlanOptionConfigCosts["totalCostInCents"];
  hasCompleteCost?: ReadyPlanOptionConfigCosts["hasCompleteCost"];
}

export function newReadyPlanOptionConfigCosts(
  options: ReadyPlanOptionConfigCostsOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanOptionConfigCosts {
  const o = (options.__typename ? options : cache["ReadyPlanOptionConfigCosts"] = {}) as ReadyPlanOptionConfigCosts;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanOptionConfigCosts";
  o.readyPlanOption = maybeNew(
    "ReadyPlanOption",
    options.readyPlanOption,
    cache,
    options.hasOwnProperty("readyPlanOption"),
  );
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.hasCompleteCost = options.hasCompleteCost ?? false;
  return o;
}

factories["ReadyPlanOptionConfigCosts"] = newReadyPlanOptionConfigCosts;

export interface ProductOfferingIncomingUpdateOptions {
  __typename?: "ProductOfferingIncomingUpdate";
  id?: ProductOfferingIncomingUpdate["id"];
  accepted?: ProductOfferingIncomingUpdate["accepted"];
  createdAt?: ProductOfferingIncomingUpdate["createdAt"];
  updatedAt?: ProductOfferingIncomingUpdate["updatedAt"];
  offering?: ProductOffering | ProductOfferingOptions;
  forDesignPackageUpdate?: ProductOfferingIncomingUpdate["forDesignPackageUpdate"];
  forPlanPackageUpdate?: ProductOfferingIncomingUpdate["forPlanPackageUpdate"];
  source?: ProductOfferingIncomingUpdateSource | DropOptions | RequireTypename<ReadyPlanAggregateVersionOptions>;
}

export function newProductOfferingIncomingUpdate(
  options: ProductOfferingIncomingUpdateOptions = {},
  cache: Record<string, any> = {},
): ProductOfferingIncomingUpdate {
  const o =
    (options.__typename ? options : cache["ProductOfferingIncomingUpdate"] = {}) as ProductOfferingIncomingUpdate;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProductOfferingIncomingUpdate";
  o.id = options.id ?? nextFactoryId("ProductOfferingIncomingUpdate");
  o.accepted = options.accepted ?? false;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.offering = maybeNew("ProductOffering", options.offering, cache, options.hasOwnProperty("offering"));
  o.forDesignPackageUpdate = options.forDesignPackageUpdate ?? false;
  o.forPlanPackageUpdate = options.forPlanPackageUpdate ?? false;
  o.source = maybeNew(options.source?.__typename ?? "Drop", options.source, cache);
  return o;
}

factories["ProductOfferingIncomingUpdate"] = newProductOfferingIncomingUpdate;

export interface ProductOfferingVersionOptions {
  __typename?: "ProductOfferingVersion";
  id?: ProductOfferingVersion["id"];
  identity?: ReadyPlan | ReadyPlanOptions;
  name?: ProductOfferingVersion["name"];
  code?: ProductOfferingVersion["code"];
  type?: ProductOfferingVersion["type"];
  lotTypes?: ProductOfferingVersion["lotTypes"] | null;
  exteriorDesignPackageVersion?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  interiorDesignPackageVersion?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  planPackageVersion?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  contingencyMarkupPercentage?: ProductOfferingVersion["contingencyMarkupPercentage"];
  description?: ProductOfferingVersion["description"];
  markets?: Array<Market | MarketOptions>;
  owner?: InternalUser | InternalUserOptions | null;
}

export function newProductOfferingVersion(
  options: ProductOfferingVersionOptions = {},
  cache: Record<string, any> = {},
): ProductOfferingVersion {
  const o = (options.__typename ? options : cache["ProductOfferingVersion"] = {}) as ProductOfferingVersion;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProductOfferingVersion";
  o.id = options.id ?? nextFactoryId("ProductOfferingVersion");
  o.identity = maybeNew("ReadyPlan", options.identity, cache, options.hasOwnProperty("identity"));
  o.name = options.name ?? "name";
  o.code = options.code ?? null;
  o.type = options.type ?? null;
  o.lotTypes = options.lotTypes ?? [];
  o.exteriorDesignPackageVersion = maybeNew(
    "ReadyPlanAggregateVersion",
    options.exteriorDesignPackageVersion,
    cache,
    options.hasOwnProperty("exteriorDesignPackageVersion"),
  );
  o.interiorDesignPackageVersion = maybeNew(
    "ReadyPlanAggregateVersion",
    options.interiorDesignPackageVersion,
    cache,
    options.hasOwnProperty("interiorDesignPackageVersion"),
  );
  o.planPackageVersion = maybeNew(
    "ReadyPlanAggregateVersion",
    options.planPackageVersion,
    cache,
    options.hasOwnProperty("planPackageVersion"),
  );
  o.contingencyMarkupPercentage = options.contingencyMarkupPercentage ?? null;
  o.description = options.description ?? null;
  o.markets = (options.markets ?? []).map((i) => maybeNew("Market", i, cache, options.hasOwnProperty("markets")));
  o.owner = maybeNewOrNull("InternalUser", options.owner, cache);
  return o;
}

factories["ProductOfferingVersion"] = newProductOfferingVersion;

export interface ProductTypeOptions {
  __typename?: "ProductType";
  id?: ProductType["id"];
  name?: ProductType["name"];
  createdAt?: ProductType["createdAt"];
  updatedAt?: ProductType["updatedAt"];
  projects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
}

export function newProductType(options: ProductTypeOptions = {}, cache: Record<string, any> = {}): ProductType {
  const o = (options.__typename ? options : cache["ProductType"] = {}) as ProductType;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProductType";
  o.id = options.id ?? nextFactoryId("ProductType");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.projects = (options.projects ?? []).map((i) => maybeNew("Project", i, cache, options.hasOwnProperty("projects")));
  return o;
}

factories["ProductType"] = newProductType;

export interface SaveProductTypeResultOptions {
  __typename?: "SaveProductTypeResult";
  productType?: ProductType | ProductTypeOptions;
}

export function newSaveProductTypeResult(
  options: SaveProductTypeResultOptions = {},
  cache: Record<string, any> = {},
): SaveProductTypeResult {
  const o = (options.__typename ? options : cache["SaveProductTypeResult"] = {}) as SaveProductTypeResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveProductTypeResult";
  o.productType = maybeNew("ProductType", options.productType, cache, options.hasOwnProperty("productType"));
  return o;
}

factories["SaveProductTypeResult"] = newSaveProductTypeResult;

export interface ProgramDataOptions {
  __typename?: "ProgramData";
  id?: ProgramData["id"];
  createdAt?: ProgramData["createdAt"];
  updatedAt?: ProgramData["updatedAt"];
  stories?: ProgramData["stories"];
  bedrooms?: ProgramData["bedrooms"];
  closetsInPrimarySuite?: ProgramData["closetsInPrimarySuite"];
  fullBaths?: ProgramData["fullBaths"];
  halfBaths?: ProgramData["halfBaths"];
  depthInInches?: ProgramData["depthInInches"];
  depthInFeet?: ProgramData["depthInFeet"];
  widthInInches?: ProgramData["widthInInches"];
  widthInFeet?: ProgramData["widthInFeet"];
  minLotWidthInInches?: ProgramData["minLotWidthInInches"];
  minLotWidthInFeet?: ProgramData["minLotWidthInFeet"];
  minLotDepthInInches?: ProgramData["minLotDepthInInches"];
  minLotDepthInFeet?: ProgramData["minLotDepthInFeet"];
  minLotSizeInSqft?: ProgramData["minLotSizeInSqft"];
  garageAttached?: ProgramData["garageAttached"];
  garageDetached?: ProgramData["garageDetached"];
  garagePort?: ProgramData["garagePort"];
  garageConfiguration?: ProgramDataGarageConfigDetailOptions | ProgramDataGarageConfig | null;
  basementConfig?: ProgramDataBasementConfigDetailOptions | ProgramDataBasementConfig | null;
  sellableBasementSqft?: ProgramData["sellableBasementSqft"];
  permittableSqft?: ProgramData["permittableSqft"];
  sellableSqft?: ProgramData["sellableSqft"];
  netBuildableSqft?: ProgramData["netBuildableSqft"];
  grossBuildableSqft?: ProgramData["grossBuildableSqft"];
  aboveGroundSqft?: ProgramData["aboveGroundSqft"];
  belowGroundSqft?: ProgramData["belowGroundSqft"];
  sellableAboveGroundSqft?: ProgramData["sellableAboveGroundSqft"];
  sellableBelowGroundSqft?: ProgramData["sellableBelowGroundSqft"];
  unfinishedBelowGroundSqft?: ProgramData["unfinishedBelowGroundSqft"];
  grossBelowGroundSqft?: ProgramData["grossBelowGroundSqft"];
  imperviousSqft?: ProgramData["imperviousSqft"];
  windowColor?: ProgramDataWindowColorDetailOptions | ProgramDataWindowColor | null;
  firstFloorBedrooms?: ProgramData["firstFloorBedrooms"];
  diningRoom?: ProgramData["diningRoom"];
  casualDining?: ProgramData["casualDining"];
  mediaRooms?: ProgramData["mediaRooms"];
  loftGameFlexRooms?: ProgramData["loftGameFlexRooms"];
  offices?: ProgramData["offices"];
  workspaces?: ProgramData["workspaces"];
  primaryBedroom?: ProgramDataPrimaryBedroomConfigDetailOptions | ProgramDataPrimaryBedroomConfig | null;
  multiUseBedrooms?: ProgramData["multiUseBedrooms"];
  primarySuiteDown?: ProgramData["primarySuiteDown"];
  buildingHeightInFeet?: ProgramData["buildingHeightInFeet"];
  readyPlanProgramData?: ReadyPlanProgramData | ReadyPlanProgramDataOptions | null;
}

export function newProgramData(options: ProgramDataOptions = {}, cache: Record<string, any> = {}): ProgramData {
  const o = (options.__typename ? options : cache["ProgramData"] = {}) as ProgramData;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProgramData";
  o.id = options.id ?? nextFactoryId("ProgramData");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.stories = options.stories ?? null;
  o.bedrooms = options.bedrooms ?? null;
  o.closetsInPrimarySuite = options.closetsInPrimarySuite ?? null;
  o.fullBaths = options.fullBaths ?? null;
  o.halfBaths = options.halfBaths ?? null;
  o.depthInInches = options.depthInInches ?? null;
  o.depthInFeet = options.depthInFeet ?? null;
  o.widthInInches = options.widthInInches ?? null;
  o.widthInFeet = options.widthInFeet ?? null;
  o.minLotWidthInInches = options.minLotWidthInInches ?? null;
  o.minLotWidthInFeet = options.minLotWidthInFeet ?? null;
  o.minLotDepthInInches = options.minLotDepthInInches ?? null;
  o.minLotDepthInFeet = options.minLotDepthInFeet ?? null;
  o.minLotSizeInSqft = options.minLotSizeInSqft ?? null;
  o.garageAttached = options.garageAttached ?? null;
  o.garageDetached = options.garageDetached ?? null;
  o.garagePort = options.garagePort ?? null;
  o.garageConfiguration = enumOrDetailOrNullOfProgramDataGarageConfig(options.garageConfiguration);
  o.basementConfig = enumOrDetailOrNullOfProgramDataBasementConfig(options.basementConfig);
  o.sellableBasementSqft = options.sellableBasementSqft ?? null;
  o.permittableSqft = options.permittableSqft ?? null;
  o.sellableSqft = options.sellableSqft ?? null;
  o.netBuildableSqft = options.netBuildableSqft ?? null;
  o.grossBuildableSqft = options.grossBuildableSqft ?? null;
  o.aboveGroundSqft = options.aboveGroundSqft ?? null;
  o.belowGroundSqft = options.belowGroundSqft ?? null;
  o.sellableAboveGroundSqft = options.sellableAboveGroundSqft ?? null;
  o.sellableBelowGroundSqft = options.sellableBelowGroundSqft ?? null;
  o.unfinishedBelowGroundSqft = options.unfinishedBelowGroundSqft ?? null;
  o.grossBelowGroundSqft = options.grossBelowGroundSqft ?? null;
  o.imperviousSqft = options.imperviousSqft ?? null;
  o.windowColor = enumOrDetailOrNullOfProgramDataWindowColor(options.windowColor);
  o.firstFloorBedrooms = options.firstFloorBedrooms ?? null;
  o.diningRoom = options.diningRoom ?? null;
  o.casualDining = options.casualDining ?? null;
  o.mediaRooms = options.mediaRooms ?? null;
  o.loftGameFlexRooms = options.loftGameFlexRooms ?? null;
  o.offices = options.offices ?? null;
  o.workspaces = options.workspaces ?? null;
  o.primaryBedroom = enumOrDetailOrNullOfProgramDataPrimaryBedroomConfig(options.primaryBedroom);
  o.multiUseBedrooms = options.multiUseBedrooms ?? null;
  o.primarySuiteDown = options.primarySuiteDown ?? null;
  o.buildingHeightInFeet = options.buildingHeightInFeet ?? null;
  o.readyPlanProgramData = maybeNewOrNull("ReadyPlanProgramData", options.readyPlanProgramData, cache);
  return o;
}

factories["ProgramData"] = newProgramData;

export interface NewProgramDataOptions {
  __typename?: "NewProgramData";
  createdAt?: NewProgramData["createdAt"];
  updatedAt?: NewProgramData["updatedAt"];
  stories?: NewProgramData["stories"];
  bedrooms?: NewProgramData["bedrooms"];
  closetsInPrimarySuite?: NewProgramData["closetsInPrimarySuite"];
  fullBaths?: NewProgramData["fullBaths"];
  halfBaths?: NewProgramData["halfBaths"];
  depthInInches?: NewProgramData["depthInInches"];
  depthInFeet?: NewProgramData["depthInFeet"];
  widthInInches?: NewProgramData["widthInInches"];
  widthInFeet?: NewProgramData["widthInFeet"];
  minLotWidthInInches?: NewProgramData["minLotWidthInInches"];
  minLotWidthInFeet?: NewProgramData["minLotWidthInFeet"];
  minLotDepthInInches?: NewProgramData["minLotDepthInInches"];
  minLotDepthInFeet?: NewProgramData["minLotDepthInFeet"];
  minLotSizeInSqft?: NewProgramData["minLotSizeInSqft"];
  garageAttached?: NewProgramData["garageAttached"];
  garageDetached?: NewProgramData["garageDetached"];
  garagePort?: NewProgramData["garagePort"];
  garageConfiguration?: ProgramDataGarageConfigDetailOptions | ProgramDataGarageConfig | null;
  basementConfig?: ProgramDataBasementConfigDetailOptions | ProgramDataBasementConfig | null;
  sellableBasementSqft?: NewProgramData["sellableBasementSqft"];
  permittableSqft?: NewProgramData["permittableSqft"];
  sellableSqft?: NewProgramData["sellableSqft"];
  netBuildableSqft?: NewProgramData["netBuildableSqft"];
  grossBuildableSqft?: NewProgramData["grossBuildableSqft"];
  aboveGroundSqft?: NewProgramData["aboveGroundSqft"];
  belowGroundSqft?: NewProgramData["belowGroundSqft"];
  sellableAboveGroundSqft?: NewProgramData["sellableAboveGroundSqft"];
  sellableBelowGroundSqft?: NewProgramData["sellableBelowGroundSqft"];
  unfinishedBelowGroundSqft?: NewProgramData["unfinishedBelowGroundSqft"];
  grossBelowGroundSqft?: NewProgramData["grossBelowGroundSqft"];
  imperviousSqft?: NewProgramData["imperviousSqft"];
  windowColor?: ProgramDataWindowColorDetailOptions | ProgramDataWindowColor | null;
  firstFloorBedrooms?: NewProgramData["firstFloorBedrooms"];
  diningRoom?: NewProgramData["diningRoom"];
  casualDining?: NewProgramData["casualDining"];
  mediaRooms?: NewProgramData["mediaRooms"];
  loftGameFlexRooms?: NewProgramData["loftGameFlexRooms"];
  offices?: NewProgramData["offices"];
  workspaces?: NewProgramData["workspaces"];
  primaryBedroom?: ProgramDataPrimaryBedroomConfigDetailOptions | ProgramDataPrimaryBedroomConfig | null;
  multiUseBedrooms?: NewProgramData["multiUseBedrooms"];
  primarySuiteDown?: NewProgramData["primarySuiteDown"];
  buildingHeightInFeet?: NewProgramData["buildingHeightInFeet"];
}

export function newNewProgramData(
  options: NewProgramDataOptions = {},
  cache: Record<string, any> = {},
): NewProgramData {
  const o = (options.__typename ? options : cache["NewProgramData"] = {}) as NewProgramData;
  (cache.all ??= new Set()).add(o);
  o.__typename = "NewProgramData";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.stories = options.stories ?? null;
  o.bedrooms = options.bedrooms ?? null;
  o.closetsInPrimarySuite = options.closetsInPrimarySuite ?? null;
  o.fullBaths = options.fullBaths ?? null;
  o.halfBaths = options.halfBaths ?? null;
  o.depthInInches = options.depthInInches ?? null;
  o.depthInFeet = options.depthInFeet ?? null;
  o.widthInInches = options.widthInInches ?? null;
  o.widthInFeet = options.widthInFeet ?? null;
  o.minLotWidthInInches = options.minLotWidthInInches ?? null;
  o.minLotWidthInFeet = options.minLotWidthInFeet ?? null;
  o.minLotDepthInInches = options.minLotDepthInInches ?? null;
  o.minLotDepthInFeet = options.minLotDepthInFeet ?? null;
  o.minLotSizeInSqft = options.minLotSizeInSqft ?? null;
  o.garageAttached = options.garageAttached ?? null;
  o.garageDetached = options.garageDetached ?? null;
  o.garagePort = options.garagePort ?? null;
  o.garageConfiguration = enumOrDetailOrNullOfProgramDataGarageConfig(options.garageConfiguration);
  o.basementConfig = enumOrDetailOrNullOfProgramDataBasementConfig(options.basementConfig);
  o.sellableBasementSqft = options.sellableBasementSqft ?? null;
  o.permittableSqft = options.permittableSqft ?? null;
  o.sellableSqft = options.sellableSqft ?? null;
  o.netBuildableSqft = options.netBuildableSqft ?? null;
  o.grossBuildableSqft = options.grossBuildableSqft ?? null;
  o.aboveGroundSqft = options.aboveGroundSqft ?? null;
  o.belowGroundSqft = options.belowGroundSqft ?? null;
  o.sellableAboveGroundSqft = options.sellableAboveGroundSqft ?? null;
  o.sellableBelowGroundSqft = options.sellableBelowGroundSqft ?? null;
  o.unfinishedBelowGroundSqft = options.unfinishedBelowGroundSqft ?? null;
  o.grossBelowGroundSqft = options.grossBelowGroundSqft ?? null;
  o.imperviousSqft = options.imperviousSqft ?? null;
  o.windowColor = enumOrDetailOrNullOfProgramDataWindowColor(options.windowColor);
  o.firstFloorBedrooms = options.firstFloorBedrooms ?? null;
  o.diningRoom = options.diningRoom ?? null;
  o.casualDining = options.casualDining ?? null;
  o.mediaRooms = options.mediaRooms ?? null;
  o.loftGameFlexRooms = options.loftGameFlexRooms ?? null;
  o.offices = options.offices ?? null;
  o.workspaces = options.workspaces ?? null;
  o.primaryBedroom = enumOrDetailOrNullOfProgramDataPrimaryBedroomConfig(options.primaryBedroom);
  o.multiUseBedrooms = options.multiUseBedrooms ?? null;
  o.primarySuiteDown = options.primarySuiteDown ?? null;
  o.buildingHeightInFeet = options.buildingHeightInFeet ?? null;
  return o;
}

factories["NewProgramData"] = newNewProgramData;

export interface ProjectJobLogInsightsOptions {
  __typename?: "ProjectJobLogInsights";
  delayFlagCount?: ProjectJobLogInsights["delayFlagCount"];
  popularFlagReason?: ScheduleFlagReason | ScheduleFlagReasonOptions | null;
  partnerWithMostDelays?: TradePartner | TradePartnerOptions | null;
  topJobLogCreator?: InternalUser | InternalUserOptions | null;
  notesToday?: ProjectJobLogInsights["notesToday"];
  weekJobLogs?: ProjectJobLogInsights["weekJobLogs"];
}

export function newProjectJobLogInsights(
  options: ProjectJobLogInsightsOptions = {},
  cache: Record<string, any> = {},
): ProjectJobLogInsights {
  const o = (options.__typename ? options : cache["ProjectJobLogInsights"] = {}) as ProjectJobLogInsights;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectJobLogInsights";
  o.delayFlagCount = options.delayFlagCount ?? 0;
  o.popularFlagReason = maybeNewOrNull("ScheduleFlagReason", options.popularFlagReason, cache);
  o.partnerWithMostDelays = maybeNewOrNull("TradePartner", options.partnerWithMostDelays, cache);
  o.topJobLogCreator = maybeNewOrNull("InternalUser", options.topJobLogCreator, cache);
  o.notesToday = options.notesToday ?? 0;
  o.weekJobLogs = options.weekJobLogs ?? 0;
  return o;
}

factories["ProjectJobLogInsights"] = newProjectJobLogInsights;

export interface ProjectDictionaryOptions {
  __typename?: "ProjectDictionary";
  clientContract?: ProjectDictionary["clientContract"];
  clientNoun?: ProjectDictionary["clientNoun"];
  initialBudget?: ProjectDictionary["initialBudget"];
  shortClientNoun?: ProjectDictionary["shortClientNoun"];
}

export function newProjectDictionary(
  options: ProjectDictionaryOptions = {},
  cache: Record<string, any> = {},
): ProjectDictionary {
  const o = (options.__typename ? options : cache["ProjectDictionary"] = {}) as ProjectDictionary;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectDictionary";
  o.clientContract = options.clientContract ?? "clientContract";
  o.clientNoun = options.clientNoun ?? "clientNoun";
  o.initialBudget = options.initialBudget ?? "initialBudget";
  o.shortClientNoun = options.shortClientNoun ?? "shortClientNoun";
  return o;
}

factories["ProjectDictionary"] = newProjectDictionary;

export interface SaveProjectResultOptions {
  __typename?: "SaveProjectResult";
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
}

export function newSaveProjectResult(
  options: SaveProjectResultOptions = {},
  cache: Record<string, any> = {},
): SaveProjectResult {
  const o = (options.__typename ? options : cache["SaveProjectResult"] = {}) as SaveProjectResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveProjectResult";
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  return o;
}

factories["SaveProjectResult"] = newSaveProjectResult;

export interface ProgressSummaryOptions {
  __typename?: "ProgressSummary";
  inProgress?: ProgressSummary["inProgress"];
  notStarted?: ProgressSummary["notStarted"];
  completed?: ProgressSummary["completed"];
  total?: ProgressSummary["total"];
  status?: ProgressSummary["status"];
}

export function newProgressSummary(
  options: ProgressSummaryOptions = {},
  cache: Record<string, any> = {},
): ProgressSummary {
  const o = (options.__typename ? options : cache["ProgressSummary"] = {}) as ProgressSummary;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProgressSummary";
  o.inProgress = options.inProgress ?? 0;
  o.notStarted = options.notStarted ?? 0;
  o.completed = options.completed ?? 0;
  o.total = options.total ?? 0;
  o.status = options.status ?? ProgressSummaryStatus.InProgress;
  return o;
}

factories["ProgressSummary"] = newProgressSummary;

export interface ResyncPreconProjectItemCostResultOptions {
  __typename?: "ResyncPreconProjectItemCostResult";
  projects?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  projectItems?: Array<ProjectItem | ProjectItemOptions>;
}

export function newResyncPreconProjectItemCostResult(
  options: ResyncPreconProjectItemCostResultOptions = {},
  cache: Record<string, any> = {},
): ResyncPreconProjectItemCostResult {
  const o =
    (options.__typename
      ? options
      : cache["ResyncPreconProjectItemCostResult"] = {}) as ResyncPreconProjectItemCostResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ResyncPreconProjectItemCostResult";
  o.projects = (options.projects ?? []).map((i) => maybeNew("Project", i, cache, options.hasOwnProperty("projects")));
  o.projectItems = (options.projectItems ?? []).map((i) =>
    maybeNew("ProjectItem", i, cache, options.hasOwnProperty("projectItems"))
  );
  return o;
}

factories["ResyncPreconProjectItemCostResult"] = newResyncPreconProjectItemCostResult;

export interface CloneProjectCostAllocationsResultOptions {
  __typename?: "CloneProjectCostAllocationsResult";
  source?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  targets?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
}

export function newCloneProjectCostAllocationsResult(
  options: CloneProjectCostAllocationsResultOptions = {},
  cache: Record<string, any> = {},
): CloneProjectCostAllocationsResult {
  const o =
    (options.__typename
      ? options
      : cache["CloneProjectCostAllocationsResult"] = {}) as CloneProjectCostAllocationsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CloneProjectCostAllocationsResult";
  o.source = maybeNew("Project", options.source, cache, options.hasOwnProperty("source"));
  o.targets = (options.targets ?? []).map((i) => maybeNew("Project", i, cache, options.hasOwnProperty("targets")));
  return o;
}

factories["CloneProjectCostAllocationsResult"] = newCloneProjectCostAllocationsResult;

export interface ProjectsPageResultOptions {
  __typename?: "ProjectsPageResult";
  entities?: Array<
    StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit | Project | ProjectOptions
  >;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newProjectsPageResult(
  options: ProjectsPageResultOptions = {},
  cache: Record<string, any> = {},
): ProjectsPageResult {
  const o = (options.__typename ? options : cache["ProjectsPageResult"] = {}) as ProjectsPageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectsPageResult";
  o.entities = (options.entities ?? []).map((i) => maybeNew("Project", i, cache, options.hasOwnProperty("entities")));
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["ProjectsPageResult"] = newProjectsPageResult;

export interface EarnedValueCurveOptions {
  __typename?: "EarnedValueCurve";
  label?: EarnedValueCurve["label"];
  data?: Array<EarnedValueDataPoint | EarnedValueDataPointOptions>;
}

export function newEarnedValueCurve(
  options: EarnedValueCurveOptions = {},
  cache: Record<string, any> = {},
): EarnedValueCurve {
  const o = (options.__typename ? options : cache["EarnedValueCurve"] = {}) as EarnedValueCurve;
  (cache.all ??= new Set()).add(o);
  o.__typename = "EarnedValueCurve";
  o.label = options.label ?? "label";
  o.data = (options.data ?? []).map((i) => maybeNew("EarnedValueDataPoint", i, cache, options.hasOwnProperty("data")));
  return o;
}

factories["EarnedValueCurve"] = newEarnedValueCurve;

export interface EarnedValueDataPointOptions {
  __typename?: "EarnedValueDataPoint";
  date?: EarnedValueDataPoint["date"];
  value?: EarnedValueDataPoint["value"];
}

export function newEarnedValueDataPoint(
  options: EarnedValueDataPointOptions = {},
  cache: Record<string, any> = {},
): EarnedValueDataPoint {
  const o = (options.__typename ? options : cache["EarnedValueDataPoint"] = {}) as EarnedValueDataPoint;
  (cache.all ??= new Set()).add(o);
  o.__typename = "EarnedValueDataPoint";
  o.date = options.date ?? newDate();
  o.value = options.value ?? 0;
  return o;
}

factories["EarnedValueDataPoint"] = newEarnedValueDataPoint;

export interface ProjectsToUpdateByTemplatesResultOptions {
  __typename?: "ProjectsToUpdateByTemplatesResult";
  projectsToUpdate?: Array<ProjectToUpdate | ProjectToUpdateOptions>;
}

export function newProjectsToUpdateByTemplatesResult(
  options: ProjectsToUpdateByTemplatesResultOptions = {},
  cache: Record<string, any> = {},
): ProjectsToUpdateByTemplatesResult {
  const o =
    (options.__typename
      ? options
      : cache["ProjectsToUpdateByTemplatesResult"] = {}) as ProjectsToUpdateByTemplatesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectsToUpdateByTemplatesResult";
  o.projectsToUpdate = (options.projectsToUpdate ?? []).map((i) =>
    maybeNew("ProjectToUpdate", i, cache, options.hasOwnProperty("projectsToUpdate"))
  );
  return o;
}

factories["ProjectsToUpdateByTemplatesResult"] = newProjectsToUpdateByTemplatesResult;

export interface ProjectToUpdateOptions {
  __typename?: "ProjectToUpdate";
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  optionsToUpdate?: Array<OptionToUpdate | OptionToUpdateOptions>;
  currentTemplate?: ItemTemplate | ItemTemplateOptions | null;
  proposedTemplate?: ItemTemplate | ItemTemplateOptions;
}

export function newProjectToUpdate(
  options: ProjectToUpdateOptions = {},
  cache: Record<string, any> = {},
): ProjectToUpdate {
  const o = (options.__typename ? options : cache["ProjectToUpdate"] = {}) as ProjectToUpdate;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectToUpdate";
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.optionsToUpdate = (options.optionsToUpdate ?? []).map((i) =>
    maybeNew("OptionToUpdate", i, cache, options.hasOwnProperty("optionsToUpdate"))
  );
  o.currentTemplate = maybeNewOrNull("ItemTemplate", options.currentTemplate, cache);
  o.proposedTemplate = maybeNew(
    "ItemTemplate",
    options.proposedTemplate,
    cache,
    options.hasOwnProperty("proposedTemplate"),
  );
  return o;
}

factories["ProjectToUpdate"] = newProjectToUpdate;

export interface OptionToUpdateOptions {
  __typename?: "OptionToUpdate";
  affectedPOs?: Array<Commitment | CommitmentOptions>;
  affectedPOsCount?: OptionToUpdate["affectedPOsCount"];
  optionOrReadyPlan?:
    | BidItem
    | ChangeEventLineItem
    | ProjectItem
    | Commitment
    | Document
    | ItemTemplateItemVersion
    | ReadyPlan
    | PlanPackage
    | CommitmentChangeOrder
    | CostCode
    | CostDivision
    | DesignPackage
    | Item
    | ItemTemplate
    | ItemTemplateItem
    | ProductOffering
    | ReadyPlanAggregateVersion
    | ReadyPlanOption
    | TakeoffLineItem
    | TakeoffLineItemVersion
    | TradeCategory
    | HasDisplayName
    | HasDisplayNameOptions;
}

export function newOptionToUpdate(
  options: OptionToUpdateOptions = {},
  cache: Record<string, any> = {},
): OptionToUpdate {
  const o = (options.__typename ? options : cache["OptionToUpdate"] = {}) as OptionToUpdate;
  (cache.all ??= new Set()).add(o);
  o.__typename = "OptionToUpdate";
  o.affectedPOs = (options.affectedPOs ?? []).map((i) =>
    maybeNew("Commitment", i, cache, options.hasOwnProperty("affectedPOs"))
  );
  o.affectedPOsCount = options.affectedPOsCount ?? 0;
  o.optionOrReadyPlan = maybeNew(
    "HasDisplayName",
    options.optionOrReadyPlan,
    cache,
    options.hasOwnProperty("optionOrReadyPlan"),
  );
  return o;
}

factories["OptionToUpdate"] = newOptionToUpdate;

export interface ProjectBudgetFinancialsOptions {
  __typename?: "ProjectBudgetFinancials";
  originalBudgetInCents?: ProjectBudgetFinancials["originalBudgetInCents"];
  currentBudgetInCents?: ProjectBudgetFinancials["currentBudgetInCents"];
  originalRevenueInCents?: ProjectBudgetFinancials["originalRevenueInCents"];
  currentRevenueInCents?: ProjectBudgetFinancials["currentRevenueInCents"];
}

export function newProjectBudgetFinancials(
  options: ProjectBudgetFinancialsOptions = {},
  cache: Record<string, any> = {},
): ProjectBudgetFinancials {
  const o = (options.__typename ? options : cache["ProjectBudgetFinancials"] = {}) as ProjectBudgetFinancials;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectBudgetFinancials";
  o.originalBudgetInCents = options.originalBudgetInCents ?? 0;
  o.currentBudgetInCents = options.currentBudgetInCents ?? 0;
  o.originalRevenueInCents = options.originalRevenueInCents ?? 0;
  o.currentRevenueInCents = options.currentRevenueInCents ?? 0;
  return o;
}

factories["ProjectBudgetFinancials"] = newProjectBudgetFinancials;

export interface ApplyInvoiceScheduleResultOptions {
  __typename?: "ApplyInvoiceScheduleResult";
  invoiceSchedule?: InvoiceSchedule | InvoiceScheduleOptions | null;
}

export function newApplyInvoiceScheduleResult(
  options: ApplyInvoiceScheduleResultOptions = {},
  cache: Record<string, any> = {},
): ApplyInvoiceScheduleResult {
  const o = (options.__typename ? options : cache["ApplyInvoiceScheduleResult"] = {}) as ApplyInvoiceScheduleResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ApplyInvoiceScheduleResult";
  o.invoiceSchedule = maybeNewOrNull("InvoiceSchedule", options.invoiceSchedule, cache);
  return o;
}

factories["ApplyInvoiceScheduleResult"] = newApplyInvoiceScheduleResult;

export interface ExportProjectBillsResultOptions {
  __typename?: "ExportProjectBillsResult";
  googleDriveFolderId?: ExportProjectBillsResult["googleDriveFolderId"];
}

export function newExportProjectBillsResult(
  options: ExportProjectBillsResultOptions = {},
  cache: Record<string, any> = {},
): ExportProjectBillsResult {
  const o = (options.__typename ? options : cache["ExportProjectBillsResult"] = {}) as ExportProjectBillsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ExportProjectBillsResult";
  o.googleDriveFolderId = options.googleDriveFolderId ?? "googleDriveFolderId";
  return o;
}

factories["ExportProjectBillsResult"] = newExportProjectBillsResult;

export interface OptionWithCutoffDateOptions {
  __typename?: "OptionWithCutoffDate";
  option?: ReadyPlanOption | ReadyPlanOptionOptions;
  cutoffDate?: OptionWithCutoffDate["cutoffDate"];
}

export function newOptionWithCutoffDate(
  options: OptionWithCutoffDateOptions = {},
  cache: Record<string, any> = {},
): OptionWithCutoffDate {
  const o = (options.__typename ? options : cache["OptionWithCutoffDate"] = {}) as OptionWithCutoffDate;
  (cache.all ??= new Set()).add(o);
  o.__typename = "OptionWithCutoffDate";
  o.option = maybeNew("ReadyPlanOption", options.option, cache, options.hasOwnProperty("option"));
  o.cutoffDate = options.cutoffDate ?? null;
  return o;
}

factories["OptionWithCutoffDate"] = newOptionWithCutoffDate;

export interface ProjectCompletedTaskBudgetReviewOptions {
  __typename?: "ProjectCompletedTaskBudgetReview";
  bucket?: ProjectCompletedTaskBudgetReview["bucket"];
  costInCents?: ProjectCompletedTaskBudgetReview["costInCents"];
}

export function newProjectCompletedTaskBudgetReview(
  options: ProjectCompletedTaskBudgetReviewOptions = {},
  cache: Record<string, any> = {},
): ProjectCompletedTaskBudgetReview {
  const o =
    (options.__typename ? options : cache["ProjectCompletedTaskBudgetReview"] = {}) as ProjectCompletedTaskBudgetReview;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectCompletedTaskBudgetReview";
  o.bucket = options.bucket ?? "bucket";
  o.costInCents = options.costInCents ?? 0;
  return o;
}

factories["ProjectCompletedTaskBudgetReview"] = newProjectCompletedTaskBudgetReview;

export interface ProjectDirectMarginGraphOptions {
  __typename?: "ProjectDirectMarginGraph";
  resolution?: ProjectDirectMarginGraph["resolution"];
  data?: Array<ProjectDirectMarginGraphData | ProjectDirectMarginGraphDataOptions>;
}

export function newProjectDirectMarginGraph(
  options: ProjectDirectMarginGraphOptions = {},
  cache: Record<string, any> = {},
): ProjectDirectMarginGraph {
  const o = (options.__typename ? options : cache["ProjectDirectMarginGraph"] = {}) as ProjectDirectMarginGraph;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectDirectMarginGraph";
  o.resolution = options.resolution ?? ProjectDirectMarginGraphResolution.Daily;
  o.data = (options.data ?? []).map((i) =>
    maybeNew("ProjectDirectMarginGraphData", i, cache, options.hasOwnProperty("data"))
  );
  return o;
}

factories["ProjectDirectMarginGraph"] = newProjectDirectMarginGraph;

export interface ProjectDirectMarginGraphDataOptions {
  __typename?: "ProjectDirectMarginGraphData";
  date?: ProjectDirectMarginGraphData["date"];
  directMarginInBasisPoints?: ProjectDirectMarginGraphData["directMarginInBasisPoints"];
}

export function newProjectDirectMarginGraphData(
  options: ProjectDirectMarginGraphDataOptions = {},
  cache: Record<string, any> = {},
): ProjectDirectMarginGraphData {
  const o = (options.__typename ? options : cache["ProjectDirectMarginGraphData"] = {}) as ProjectDirectMarginGraphData;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectDirectMarginGraphData";
  o.date = options.date ?? newDate();
  o.directMarginInBasisPoints = options.directMarginInBasisPoints ?? null;
  return o;
}

factories["ProjectDirectMarginGraphData"] = newProjectDirectMarginGraphData;

export interface ProjectChangeEventGraphsResultOptions {
  __typename?: "ProjectChangeEventGraphsResult";
  graphs?: Array<ProjectChangeEventGraph | ProjectChangeEventGraphOptions>;
}

export function newProjectChangeEventGraphsResult(
  options: ProjectChangeEventGraphsResultOptions = {},
  cache: Record<string, any> = {},
): ProjectChangeEventGraphsResult {
  const o =
    (options.__typename ? options : cache["ProjectChangeEventGraphsResult"] = {}) as ProjectChangeEventGraphsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectChangeEventGraphsResult";
  o.graphs = (options.graphs ?? []).map((i) =>
    maybeNew("ProjectChangeEventGraph", i, cache, options.hasOwnProperty("graphs"))
  );
  return o;
}

factories["ProjectChangeEventGraphsResult"] = newProjectChangeEventGraphsResult;

export interface ProjectChangeEventGraphOptions {
  __typename?: "ProjectChangeEventGraph";
  type?: ProjectChangeEventGraph["type"];
  data?: Array<ProjectChangeEventGraphData | ProjectChangeEventGraphDataOptions>;
}

export function newProjectChangeEventGraph(
  options: ProjectChangeEventGraphOptions = {},
  cache: Record<string, any> = {},
): ProjectChangeEventGraph {
  const o = (options.__typename ? options : cache["ProjectChangeEventGraph"] = {}) as ProjectChangeEventGraph;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectChangeEventGraph";
  o.type = options.type ?? ProjectChangeEventGraphType.Reason;
  o.data = (options.data ?? []).map((i) =>
    maybeNew("ProjectChangeEventGraphData", i, cache, options.hasOwnProperty("data"))
  );
  return o;
}

factories["ProjectChangeEventGraph"] = newProjectChangeEventGraph;

export interface ProjectChangeEventGraphDataOptions {
  __typename?: "ProjectChangeEventGraphData";
  name?: ProjectChangeEventGraphData["name"];
  totalCostInCents?: ProjectChangeEventGraphData["totalCostInCents"];
  timesUsed?: ProjectChangeEventGraphData["timesUsed"];
}

export function newProjectChangeEventGraphData(
  options: ProjectChangeEventGraphDataOptions = {},
  cache: Record<string, any> = {},
): ProjectChangeEventGraphData {
  const o = (options.__typename ? options : cache["ProjectChangeEventGraphData"] = {}) as ProjectChangeEventGraphData;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectChangeEventGraphData";
  o.name = options.name ?? "name";
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.timesUsed = options.timesUsed ?? null;
  return o;
}

factories["ProjectChangeEventGraphData"] = newProjectChangeEventGraphData;

export interface CompanyInfoOptions {
  __typename?: "CompanyInfo";
  name?: CompanyInfo["name"];
  licenseNumber?: CompanyInfo["licenseNumber"];
  phoneNumber?: CompanyInfo["phoneNumber"];
  email?: CompanyInfo["email"];
  accountNumber?: CompanyInfo["accountNumber"];
  federalId?: CompanyInfo["federalId"];
}

export function newCompanyInfo(options: CompanyInfoOptions = {}, cache: Record<string, any> = {}): CompanyInfo {
  const o = (options.__typename ? options : cache["CompanyInfo"] = {}) as CompanyInfo;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CompanyInfo";
  o.name = options.name ?? "name";
  o.licenseNumber = options.licenseNumber ?? "licenseNumber";
  o.phoneNumber = options.phoneNumber ?? "phoneNumber";
  o.email = options.email ?? "email";
  o.accountNumber = options.accountNumber ?? "accountNumber";
  o.federalId = options.federalId ?? "federalId";
  return o;
}

factories["CompanyInfo"] = newCompanyInfo;

export interface ProjectAllocationRuleOptions {
  __typename?: "ProjectAllocationRule";
  id?: ProjectAllocationRule["id"];
  isDefault?: ProjectAllocationRule["isDefault"];
  createdAt?: ProjectAllocationRule["createdAt"];
  updatedAt?: ProjectAllocationRule["updatedAt"];
  allocationStrategy?: AllocationStrategyDetailOptions | AllocationStrategy;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  costCodes?: Array<CostCode | CostCodeOptions>;
  canDelete?: PotentialOperation2 | PotentialOperation2Options;
}

export function newProjectAllocationRule(
  options: ProjectAllocationRuleOptions = {},
  cache: Record<string, any> = {},
): ProjectAllocationRule {
  const o = (options.__typename ? options : cache["ProjectAllocationRule"] = {}) as ProjectAllocationRule;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectAllocationRule";
  o.id = options.id ?? nextFactoryId("ProjectAllocationRule");
  o.isDefault = options.isDefault ?? false;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.allocationStrategy = enumOrDetailOfAllocationStrategy(options.allocationStrategy);
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.costCodes = (options.costCodes ?? []).map((i) =>
    maybeNew("CostCode", i, cache, options.hasOwnProperty("costCodes"))
  );
  o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
  return o;
}

factories["ProjectAllocationRule"] = newProjectAllocationRule;

export interface SaveProjectAllocationRuleResultOptions {
  __typename?: "SaveProjectAllocationRuleResult";
  projectAllocationRule?: ProjectAllocationRule | ProjectAllocationRuleOptions;
}

export function newSaveProjectAllocationRuleResult(
  options: SaveProjectAllocationRuleResultOptions = {},
  cache: Record<string, any> = {},
): SaveProjectAllocationRuleResult {
  const o =
    (options.__typename ? options : cache["SaveProjectAllocationRuleResult"] = {}) as SaveProjectAllocationRuleResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveProjectAllocationRuleResult";
  o.projectAllocationRule = maybeNew(
    "ProjectAllocationRule",
    options.projectAllocationRule,
    cache,
    options.hasOwnProperty("projectAllocationRule"),
  );
  return o;
}

factories["SaveProjectAllocationRuleResult"] = newSaveProjectAllocationRuleResult;

export interface ProjectCollaboratorOptions {
  __typename?: "ProjectCollaborator";
  id?: ProjectCollaborator["id"];
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  collaborator?: Client | ClientOptions;
  role?: ProjectCollaborator["role"];
  roleDetail?: ProjectCollaboratorRoleDetailOptions | ProjectCollaboratorRole;
  inviteSent?: ProjectCollaborator["inviteSent"];
  inviteSentAt?: ProjectCollaborator["inviteSentAt"];
}

export function newProjectCollaborator(
  options: ProjectCollaboratorOptions = {},
  cache: Record<string, any> = {},
): ProjectCollaborator {
  const o = (options.__typename ? options : cache["ProjectCollaborator"] = {}) as ProjectCollaborator;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectCollaborator";
  o.id = options.id ?? nextFactoryId("ProjectCollaborator");
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.collaborator = maybeNew("Client", options.collaborator, cache, options.hasOwnProperty("collaborator"));
  o.role = options.role ?? ProjectCollaboratorRole.Homeowner;
  o.roleDetail = enumOrDetailOfProjectCollaboratorRole(options.roleDetail);
  o.inviteSent = options.inviteSent ?? null;
  o.inviteSentAt = options.inviteSentAt ?? null;
  return o;
}

factories["ProjectCollaborator"] = newProjectCollaborator;

export interface SendInviteEmailResultOptions {
  __typename?: "SendInviteEmailResult";
  projectCollaborator?: ProjectCollaborator | ProjectCollaboratorOptions;
}

export function newSendInviteEmailResult(
  options: SendInviteEmailResultOptions = {},
  cache: Record<string, any> = {},
): SendInviteEmailResult {
  const o = (options.__typename ? options : cache["SendInviteEmailResult"] = {}) as SendInviteEmailResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SendInviteEmailResult";
  o.projectCollaborator = maybeNew(
    "ProjectCollaborator",
    options.projectCollaborator,
    cache,
    options.hasOwnProperty("projectCollaborator"),
  );
  return o;
}

factories["SendInviteEmailResult"] = newSendInviteEmailResult;

export interface ProjectContactOptions {
  __typename?: "ProjectContact";
  id?: ProjectContact["id"];
  fullName?: ProjectContact["fullName"];
  phoneNumber?: ProjectContact["phoneNumber"];
  email?: ProjectContact["email"];
  createdAt?: ProjectContact["createdAt"];
  updatedAt?: ProjectContact["updatedAt"];
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  warrantyTickets?: Array<WarrantyTicket | WarrantyTicketOptions>;
}

export function newProjectContact(
  options: ProjectContactOptions = {},
  cache: Record<string, any> = {},
): ProjectContact {
  const o = (options.__typename ? options : cache["ProjectContact"] = {}) as ProjectContact;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectContact";
  o.id = options.id ?? nextFactoryId("ProjectContact");
  o.fullName = options.fullName ?? "fullName";
  o.phoneNumber = options.phoneNumber ?? "phoneNumber";
  o.email = options.email ?? "email";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.warrantyTickets = (options.warrantyTickets ?? []).map((i) =>
    maybeNew("WarrantyTicket", i, cache, options.hasOwnProperty("warrantyTickets"))
  );
  return o;
}

factories["ProjectContact"] = newProjectContact;

export interface SaveProjectContactResultOptions {
  __typename?: "SaveProjectContactResult";
  projectContact?: ProjectContact | ProjectContactOptions;
}

export function newSaveProjectContactResult(
  options: SaveProjectContactResultOptions = {},
  cache: Record<string, any> = {},
): SaveProjectContactResult {
  const o = (options.__typename ? options : cache["SaveProjectContactResult"] = {}) as SaveProjectContactResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveProjectContactResult";
  o.projectContact = maybeNew(
    "ProjectContact",
    options.projectContact,
    cache,
    options.hasOwnProperty("projectContact"),
  );
  return o;
}

factories["SaveProjectContactResult"] = newSaveProjectContactResult;

export interface ProjectCostCodesPageResultOptions {
  __typename?: "ProjectCostCodesPageResult";
  entities?: Array<ProjectCostCode | ProjectCostCodeOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newProjectCostCodesPageResult(
  options: ProjectCostCodesPageResultOptions = {},
  cache: Record<string, any> = {},
): ProjectCostCodesPageResult {
  const o = (options.__typename ? options : cache["ProjectCostCodesPageResult"] = {}) as ProjectCostCodesPageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectCostCodesPageResult";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("ProjectCostCode", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["ProjectCostCodesPageResult"] = newProjectCostCodesPageResult;

export interface ProjectCutoffOptions {
  __typename?: "ProjectCutoff";
  id?: ProjectCutoff["id"];
  name?: ProjectCutoff["name"];
  description?: ProjectCutoff["description"];
  createdAt?: ProjectCutoff["createdAt"];
  updatedAt?: ProjectCutoff["updatedAt"];
  cutoff?: Cutoff | CutoffOptions | null;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  homeownerSelections?: Array<HomeownerSelection | HomeownerSelectionOptions>;
  task?: Task | TaskOptions | null;
  scheduleTask?: ScheduleTask | ScheduleTaskOptions | null;
  canChangeScope?: ProjectCutoff["canChangeScope"];
  canEditScope?: ProjectCutoff["canEditScope"];
  date?: ProjectCutoff["date"];
  history?: Array<History | HistoryOptions>;
  changeEvent?: ChangeEvent | ChangeEventOptions | null;
}

export function newProjectCutoff(options: ProjectCutoffOptions = {}, cache: Record<string, any> = {}): ProjectCutoff {
  const o = (options.__typename ? options : cache["ProjectCutoff"] = {}) as ProjectCutoff;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectCutoff";
  o.id = options.id ?? nextFactoryId("ProjectCutoff");
  o.name = options.name ?? "name";
  o.description = options.description ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.cutoff = maybeNewOrNull("Cutoff", options.cutoff, cache);
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.homeownerSelections = (options.homeownerSelections ?? []).map((i) =>
    maybeNew("HomeownerSelection", i, cache, options.hasOwnProperty("homeownerSelections"))
  );
  o.task = maybeNewOrNull("Task", options.task, cache);
  o.scheduleTask = maybeNewOrNull("ScheduleTask", options.scheduleTask, cache);
  o.canChangeScope = options.canChangeScope ?? false;
  o.canEditScope = options.canEditScope ?? false;
  o.date = options.date ?? null;
  o.history = (options.history ?? []).map((i) => maybeNew("History", i, cache, options.hasOwnProperty("history")));
  o.changeEvent = maybeNewOrNull("ChangeEvent", options.changeEvent, cache);
  return o;
}

factories["ProjectCutoff"] = newProjectCutoff;

export interface SaveProjectCutoffResultOptions {
  __typename?: "SaveProjectCutoffResult";
  projectCutoff?: ProjectCutoff | ProjectCutoffOptions;
}

export function newSaveProjectCutoffResult(
  options: SaveProjectCutoffResultOptions = {},
  cache: Record<string, any> = {},
): SaveProjectCutoffResult {
  const o = (options.__typename ? options : cache["SaveProjectCutoffResult"] = {}) as SaveProjectCutoffResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveProjectCutoffResult";
  o.projectCutoff = maybeNew("ProjectCutoff", options.projectCutoff, cache, options.hasOwnProperty("projectCutoff"));
  return o;
}

factories["SaveProjectCutoffResult"] = newSaveProjectCutoffResult;

export interface ProjectDocumentAssociationOptions {
  __typename?: "ProjectDocumentAssociation";
  id?: ProjectDocumentAssociation["id"];
  createdAt?: ProjectDocumentAssociation["createdAt"];
  updatedAt?: ProjectDocumentAssociation["updatedAt"];
  document?: Document | DocumentOptions;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
}

export function newProjectDocumentAssociation(
  options: ProjectDocumentAssociationOptions = {},
  cache: Record<string, any> = {},
): ProjectDocumentAssociation {
  const o = (options.__typename ? options : cache["ProjectDocumentAssociation"] = {}) as ProjectDocumentAssociation;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectDocumentAssociation";
  o.id = options.id ?? nextFactoryId("ProjectDocumentAssociation");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.document = maybeNew("Document", options.document, cache, options.hasOwnProperty("document"));
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  return o;
}

factories["ProjectDocumentAssociation"] = newProjectDocumentAssociation;

export interface ProjectInvoiceSettingOptions {
  __typename?: "ProjectInvoiceSetting";
  id?: ProjectInvoiceSetting["id"];
  markupValuePercent?: ProjectInvoiceSetting["markupValuePercent"];
  insuranceCostInCents?: ProjectInvoiceSetting["insuranceCostInCents"];
  insuranceMarkupPercent?: ProjectInvoiceSetting["insuranceMarkupPercent"];
  requireWorkAuthorization?: ProjectInvoiceSetting["requireWorkAuthorization"];
  includesContractIncludesRetainage?: ProjectInvoiceSetting["includesContractIncludesRetainage"];
  retainageAmountPercent?: ProjectInvoiceSetting["retainageAmountPercent"];
  requireGFormat?: ProjectInvoiceSetting["requireGFormat"];
  requireTpCopiesBills?: ProjectInvoiceSetting["requireTpCopiesBills"];
  requireTpSummaryListBills?: ProjectInvoiceSetting["requireTpSummaryListBills"];
  requireTpConditionalLw?: ProjectInvoiceSetting["requireTpConditionalLw"];
  requireTpUnconditionalLw?: ProjectInvoiceSetting["requireTpUnconditionalLw"];
  requireHbConditionalLw?: ProjectInvoiceSetting["requireHbConditionalLw"];
  requireHbUnconditionalLw?: ProjectInvoiceSetting["requireHbUnconditionalLw"];
  createdAt?: ProjectInvoiceSetting["createdAt"];
  updatedAt?: ProjectInvoiceSetting["updatedAt"];
  markupApplicationMethod?: MarkupApplicationMethodDetailOptions | MarkupApplicationMethod | null;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
}

export function newProjectInvoiceSetting(
  options: ProjectInvoiceSettingOptions = {},
  cache: Record<string, any> = {},
): ProjectInvoiceSetting {
  const o = (options.__typename ? options : cache["ProjectInvoiceSetting"] = {}) as ProjectInvoiceSetting;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectInvoiceSetting";
  o.id = options.id ?? nextFactoryId("ProjectInvoiceSetting");
  o.markupValuePercent = options.markupValuePercent ?? null;
  o.insuranceCostInCents = options.insuranceCostInCents ?? null;
  o.insuranceMarkupPercent = options.insuranceMarkupPercent ?? null;
  o.requireWorkAuthorization = options.requireWorkAuthorization ?? null;
  o.includesContractIncludesRetainage = options.includesContractIncludesRetainage ?? null;
  o.retainageAmountPercent = options.retainageAmountPercent ?? null;
  o.requireGFormat = options.requireGFormat ?? null;
  o.requireTpCopiesBills = options.requireTpCopiesBills ?? null;
  o.requireTpSummaryListBills = options.requireTpSummaryListBills ?? null;
  o.requireTpConditionalLw = options.requireTpConditionalLw ?? null;
  o.requireTpUnconditionalLw = options.requireTpUnconditionalLw ?? null;
  o.requireHbConditionalLw = options.requireHbConditionalLw ?? null;
  o.requireHbUnconditionalLw = options.requireHbUnconditionalLw ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.markupApplicationMethod = enumOrDetailOrNullOfMarkupApplicationMethod(options.markupApplicationMethod);
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  return o;
}

factories["ProjectInvoiceSetting"] = newProjectInvoiceSetting;

export interface SaveProjectInvoiceSettingResultOptions {
  __typename?: "SaveProjectInvoiceSettingResult";
  projectInvoiceSetting?: ProjectInvoiceSetting | ProjectInvoiceSettingOptions;
}

export function newSaveProjectInvoiceSettingResult(
  options: SaveProjectInvoiceSettingResultOptions = {},
  cache: Record<string, any> = {},
): SaveProjectInvoiceSettingResult {
  const o =
    (options.__typename ? options : cache["SaveProjectInvoiceSettingResult"] = {}) as SaveProjectInvoiceSettingResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveProjectInvoiceSettingResult";
  o.projectInvoiceSetting = maybeNew(
    "ProjectInvoiceSetting",
    options.projectInvoiceSetting,
    cache,
    options.hasOwnProperty("projectInvoiceSetting"),
  );
  return o;
}

factories["SaveProjectInvoiceSettingResult"] = newSaveProjectInvoiceSettingResult;

export interface PotentialBidContractLineItemOptions {
  __typename?: "PotentialBidContractLineItem";
  bidContractLineItem?: BidContractLineItem | BidContractLineItemOptions;
  bidContractLineItems?: Array<BidContractLineItem | BidContractLineItemOptions>;
  totalCostInCents?: PotentialBidContractLineItem["totalCostInCents"];
}

export function newPotentialBidContractLineItem(
  options: PotentialBidContractLineItemOptions = {},
  cache: Record<string, any> = {},
): PotentialBidContractLineItem {
  const o = (options.__typename ? options : cache["PotentialBidContractLineItem"] = {}) as PotentialBidContractLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PotentialBidContractLineItem";
  o.bidContractLineItem = maybeNew(
    "BidContractLineItem",
    options.bidContractLineItem,
    cache,
    options.hasOwnProperty("bidContractLineItem"),
  );
  o.bidContractLineItems = (options.bidContractLineItems ?? []).map((i) =>
    maybeNew("BidContractLineItem", i, cache, options.hasOwnProperty("bidContractLineItems"))
  );
  o.totalCostInCents = options.totalCostInCents ?? 0;
  return o;
}

factories["PotentialBidContractLineItem"] = newPotentialBidContractLineItem;

export interface ProjectItemScopeChangeOptions {
  __typename?: "ProjectItemScopeChange";
  quantity?: ProjectItemScopeChange["quantity"];
  costInCents?: ProjectItemScopeChange["costInCents"];
  priceInCents?: ProjectItemScopeChange["priceInCents"];
  tradePartnerNote?: ProjectItemScopeChange["tradePartnerNote"];
  specifications?: ProjectItemScopeChange["specifications"];
  shortName?: ProjectItemScopeChange["shortName"];
}

export function newProjectItemScopeChange(
  options: ProjectItemScopeChangeOptions = {},
  cache: Record<string, any> = {},
): ProjectItemScopeChange {
  const o = (options.__typename ? options : cache["ProjectItemScopeChange"] = {}) as ProjectItemScopeChange;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectItemScopeChange";
  o.quantity = options.quantity ?? null;
  o.costInCents = options.costInCents ?? 0;
  o.priceInCents = options.priceInCents ?? 0;
  o.tradePartnerNote = options.tradePartnerNote ?? null;
  o.specifications = options.specifications ?? null;
  o.shortName = options.shortName ?? "shortName";
  return o;
}

factories["ProjectItemScopeChange"] = newProjectItemScopeChange;

export interface BudgetPhaseRollupOptions {
  __typename?: "BudgetPhaseRollup";
  original?: BudgetPhaseRollup["original"];
  prebid?: BudgetPhaseRollup["prebid"];
  prebidChange?: BudgetPhaseRollup["prebidChange"];
  awarded?: BudgetPhaseRollup["awarded"];
  awardedChange?: BudgetPhaseRollup["awardedChange"];
  revised?: BudgetPhaseRollup["revised"];
  revisedChange?: BudgetPhaseRollup["revisedChange"];
}

export function newBudgetPhaseRollup(
  options: BudgetPhaseRollupOptions = {},
  cache: Record<string, any> = {},
): BudgetPhaseRollup {
  const o = (options.__typename ? options : cache["BudgetPhaseRollup"] = {}) as BudgetPhaseRollup;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BudgetPhaseRollup";
  o.original = options.original ?? 0;
  o.prebid = options.prebid ?? 0;
  o.prebidChange = options.prebidChange ?? 0;
  o.awarded = options.awarded ?? 0;
  o.awardedChange = options.awardedChange ?? 0;
  o.revised = options.revised ?? 0;
  o.revisedChange = options.revisedChange ?? 0;
  return o;
}

factories["BudgetPhaseRollup"] = newBudgetPhaseRollup;

export interface DuplicateProjectItemsResultOptions {
  __typename?: "DuplicateProjectItemsResult";
  projectItems?: Array<ProjectItem | ProjectItemOptions>;
}

export function newDuplicateProjectItemsResult(
  options: DuplicateProjectItemsResultOptions = {},
  cache: Record<string, any> = {},
): DuplicateProjectItemsResult {
  const o = (options.__typename ? options : cache["DuplicateProjectItemsResult"] = {}) as DuplicateProjectItemsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DuplicateProjectItemsResult";
  o.projectItems = (options.projectItems ?? []).map((i) =>
    maybeNew("ProjectItem", i, cache, options.hasOwnProperty("projectItems"))
  );
  return o;
}

factories["DuplicateProjectItemsResult"] = newDuplicateProjectItemsResult;

export interface SaveProjectItemsResultOptions {
  __typename?: "SaveProjectItemsResult";
  projectItems?: Array<ProjectItem | ProjectItemOptions> | null;
  userErrors?: Array<UserError | UserErrorOptions> | null;
}

export function newSaveProjectItemsResult(
  options: SaveProjectItemsResultOptions = {},
  cache: Record<string, any> = {},
): SaveProjectItemsResult {
  const o = (options.__typename ? options : cache["SaveProjectItemsResult"] = {}) as SaveProjectItemsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveProjectItemsResult";
  o.projectItems = (options.projectItems ?? []).map((i) =>
    maybeNew("ProjectItem", i, cache, options.hasOwnProperty("projectItems"))
  );
  o.userErrors = (options.userErrors ?? []).map((i) =>
    maybeNew("UserError", i, cache, options.hasOwnProperty("userErrors"))
  );
  return o;
}

factories["SaveProjectItemsResult"] = newSaveProjectItemsResult;

export interface CostLineItemOptions {
  __typename?: "CostLineItem";
  id?: CostLineItem["id"];
  amountInCents?: CostLineItem["amountInCents"];
  historicAmountInvoiced?: CostLineItem["historicAmountInvoiced"];
  costDate?: CostLineItem["costDate"];
  isTradePartnerCredit?: CostLineItem["isTradePartnerCredit"];
  entity?: CostLineItemEntity | BillOptions | RequireTypename<ExpenseOptions>;
  tradePartnerNumber?: CostLineItem["tradePartnerNumber"];
}

export function newCostLineItem(options: CostLineItemOptions = {}, cache: Record<string, any> = {}): CostLineItem {
  const o = (options.__typename ? options : cache["CostLineItem"] = {}) as CostLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CostLineItem";
  o.id = options.id ?? nextFactoryId("CostLineItem");
  o.amountInCents = options.amountInCents ?? 0;
  o.historicAmountInvoiced = options.historicAmountInvoiced ?? 0;
  o.costDate = options.costDate ?? newDate();
  o.isTradePartnerCredit = options.isTradePartnerCredit ?? false;
  o.entity = maybeNew(options.entity?.__typename ?? "Bill", options.entity, cache);
  o.tradePartnerNumber = options.tradePartnerNumber ?? "tradePartnerNumber";
  return o;
}

factories["CostLineItem"] = newCostLineItem;

export interface ProjectItemBudgetFinancialsOptions {
  __typename?: "ProjectItemBudgetFinancials";
  original?: ProjectItemBudgetFinancials["original"];
  awarded?: ProjectItemBudgetFinancials["awarded"];
  changeEvents?: ProjectItemBudgetFinancials["changeEvents"];
  nonChargeableChangeEvents?: ProjectItemBudgetFinancials["nonChargeableChangeEvents"];
  chargeableChangeEvents?: ProjectItemBudgetFinancials["chargeableChangeEvents"];
  proposedChangeEvents?: ProjectItemBudgetFinancials["proposedChangeEvents"];
  reallocations?: ProjectItemBudgetFinancials["reallocations"];
  revisedInternalBudget?: ProjectItemBudgetFinancials["revisedInternalBudget"];
  revisedExternalBudget?: ProjectItemBudgetFinancials["revisedExternalBudget"];
  committed?: ProjectItemBudgetFinancials["committed"];
  uncommitted?: ProjectItemBudgetFinancials["uncommitted"];
  tradeBilled?: ProjectItemBudgetFinancials["tradeBilled"];
  tradePaidToDate?: ProjectItemBudgetFinancials["tradePaidToDate"];
  unpaidCommitments?: ProjectItemBudgetFinancials["unpaidCommitments"];
  projected?: ProjectItemBudgetFinancials["projected"];
}

export function newProjectItemBudgetFinancials(
  options: ProjectItemBudgetFinancialsOptions = {},
  cache: Record<string, any> = {},
): ProjectItemBudgetFinancials {
  const o = (options.__typename ? options : cache["ProjectItemBudgetFinancials"] = {}) as ProjectItemBudgetFinancials;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectItemBudgetFinancials";
  o.original = options.original ?? 0;
  o.awarded = options.awarded ?? 0;
  o.changeEvents = options.changeEvents ?? 0;
  o.nonChargeableChangeEvents = options.nonChargeableChangeEvents ?? 0;
  o.chargeableChangeEvents = options.chargeableChangeEvents ?? 0;
  o.proposedChangeEvents = options.proposedChangeEvents ?? 0;
  o.reallocations = options.reallocations ?? 0;
  o.revisedInternalBudget = options.revisedInternalBudget ?? 0;
  o.revisedExternalBudget = options.revisedExternalBudget ?? 0;
  o.committed = options.committed ?? 0;
  o.uncommitted = options.uncommitted ?? 0;
  o.tradeBilled = options.tradeBilled ?? 0;
  o.tradePaidToDate = options.tradePaidToDate ?? 0;
  o.unpaidCommitments = options.unpaidCommitments ?? 0;
  o.projected = options.projected ?? 0;
  return o;
}

factories["ProjectItemBudgetFinancials"] = newProjectItemBudgetFinancials;

export interface ProjectItemsPageOptions {
  __typename?: "ProjectItemsPage";
  projectItems?: Array<ProjectItem | ProjectItemOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newProjectItemsPage(
  options: ProjectItemsPageOptions = {},
  cache: Record<string, any> = {},
): ProjectItemsPage {
  const o = (options.__typename ? options : cache["ProjectItemsPage"] = {}) as ProjectItemsPage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectItemsPage";
  o.projectItems = (options.projectItems ?? []).map((i) =>
    maybeNew("ProjectItem", i, cache, options.hasOwnProperty("projectItems"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["ProjectItemsPage"] = newProjectItemsPage;

export interface ProjectItemAllocationOptions {
  __typename?: "ProjectItemAllocation";
  id?: ProjectItemAllocation["id"];
  createdAt?: ProjectItemAllocation["createdAt"];
  updatedAt?: ProjectItemAllocation["updatedAt"];
  childProject?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  parentProjectItem?: ProjectItem | ProjectItemOptions;
  commitmentLineItemAllocations?: Array<CommitmentLineItemAllocation | CommitmentLineItemAllocationOptions>;
  homeownerContractLineItemAllocations?: Array<
    HomeownerContractLineItemAllocation | HomeownerContractLineItemAllocationOptions
  >;
  changeEventLineItemAllocations?: Array<ChangeEventLineItemAllocation | ChangeEventLineItemAllocationOptions>;
  billLineItemAllocations?: Array<BillLineItemAllocation | BillLineItemAllocationOptions>;
  expenseAllocationAllocations?: Array<ExpenseAllocationAllocation | ExpenseAllocationAllocationOptions>;
  isActive?: ProjectItemAllocation["isActive"];
  revisedPriceInCents?: ProjectItemAllocation["revisedPriceInCents"];
  originalCostInCents?: ProjectItemAllocation["originalCostInCents"];
  startCostInCents?: ProjectItemAllocation["startCostInCents"];
  changeEventCostInCents?: ProjectItemAllocation["changeEventCostInCents"];
  revisedCostInCents?: ProjectItemAllocation["revisedCostInCents"];
  projectedCostInCents?: ProjectItemAllocation["projectedCostInCents"];
  committedCostInCents?: ProjectItemAllocation["committedCostInCents"];
  availableCostInCents?: ProjectItemAllocation["availableCostInCents"];
  billedCostInCents?: ProjectItemAllocation["billedCostInCents"];
  unbilledCostInCents?: ProjectItemAllocation["unbilledCostInCents"];
  revisedApprovedBudgetInCents?: ProjectItemAllocation["revisedApprovedBudgetInCents"];
}

export function newProjectItemAllocation(
  options: ProjectItemAllocationOptions = {},
  cache: Record<string, any> = {},
): ProjectItemAllocation {
  const o = (options.__typename ? options : cache["ProjectItemAllocation"] = {}) as ProjectItemAllocation;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectItemAllocation";
  o.id = options.id ?? nextFactoryId("ProjectItemAllocation");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.childProject = maybeNew("Project", options.childProject, cache, options.hasOwnProperty("childProject"));
  o.parentProjectItem = maybeNew(
    "ProjectItem",
    options.parentProjectItem,
    cache,
    options.hasOwnProperty("parentProjectItem"),
  );
  o.commitmentLineItemAllocations = (options.commitmentLineItemAllocations ?? []).map((i) =>
    maybeNew("CommitmentLineItemAllocation", i, cache, options.hasOwnProperty("commitmentLineItemAllocations"))
  );
  o.homeownerContractLineItemAllocations = (options.homeownerContractLineItemAllocations ?? []).map((i) =>
    maybeNew(
      "HomeownerContractLineItemAllocation",
      i,
      cache,
      options.hasOwnProperty("homeownerContractLineItemAllocations"),
    )
  );
  o.changeEventLineItemAllocations = (options.changeEventLineItemAllocations ?? []).map((i) =>
    maybeNew("ChangeEventLineItemAllocation", i, cache, options.hasOwnProperty("changeEventLineItemAllocations"))
  );
  o.billLineItemAllocations = (options.billLineItemAllocations ?? []).map((i) =>
    maybeNew("BillLineItemAllocation", i, cache, options.hasOwnProperty("billLineItemAllocations"))
  );
  o.expenseAllocationAllocations = (options.expenseAllocationAllocations ?? []).map((i) =>
    maybeNew("ExpenseAllocationAllocation", i, cache, options.hasOwnProperty("expenseAllocationAllocations"))
  );
  o.isActive = options.isActive ?? false;
  o.revisedPriceInCents = options.revisedPriceInCents ?? 0;
  o.originalCostInCents = options.originalCostInCents ?? 0;
  o.startCostInCents = options.startCostInCents ?? 0;
  o.changeEventCostInCents = options.changeEventCostInCents ?? 0;
  o.revisedCostInCents = options.revisedCostInCents ?? 0;
  o.projectedCostInCents = options.projectedCostInCents ?? 0;
  o.committedCostInCents = options.committedCostInCents ?? 0;
  o.availableCostInCents = options.availableCostInCents ?? 0;
  o.billedCostInCents = options.billedCostInCents ?? 0;
  o.unbilledCostInCents = options.unbilledCostInCents ?? 0;
  o.revisedApprovedBudgetInCents = options.revisedApprovedBudgetInCents ?? 0;
  return o;
}

factories["ProjectItemAllocation"] = newProjectItemAllocation;

export interface ProjectLotDetailOptions {
  __typename?: "ProjectLotDetail";
  id?: ProjectLotDetail["id"];
  lotNumber?: ProjectLotDetail["lotNumber"];
  block?: ProjectLotDetail["block"];
  section?: ProjectLotDetail["section"];
  lotSquareFootage?: ProjectLotDetail["lotSquareFootage"];
  elevationCertificateDocumentRequired?: ProjectLotDetail["elevationCertificateDocumentRequired"];
  setBackFront?: ProjectLotDetail["setBackFront"];
  setBackRight?: ProjectLotDetail["setBackRight"];
  setBackLeft?: ProjectLotDetail["setBackLeft"];
  setBackRear?: ProjectLotDetail["setBackRear"];
  hoa?: ProjectLotDetail["hoa"];
  hoaSpecificModifications?: ProjectLotDetail["hoaSpecificModifications"];
  siteSpecificModifications?: ProjectLotDetail["siteSpecificModifications"];
  fireSprinklersRequired?: ProjectLotDetail["fireSprinklersRequired"];
  createdAt?: ProjectLotDetail["createdAt"];
  updatedAt?: ProjectLotDetail["updatedAt"];
  constructionType?: ConstructionTypeDetailOptions | ConstructionType | null;
  floodPlain?: FloodPlainDetailOptions | FloodPlain | null;
  foundationType?: FoundationTypeDetailOptions | FoundationType | null;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  userEvents?: Array<UserEvent | UserEventOptions>;
  floodZone?: FloodZoneDetailOptions | FloodZone | null;
  setBackFrontInFeet?: ProjectLotDetail["setBackFrontInFeet"];
  setBackLeftInFeet?: ProjectLotDetail["setBackLeftInFeet"];
  setBackRightInFeet?: ProjectLotDetail["setBackRightInFeet"];
  setBackRearInFeet?: ProjectLotDetail["setBackRearInFeet"];
}

export function newProjectLotDetail(
  options: ProjectLotDetailOptions = {},
  cache: Record<string, any> = {},
): ProjectLotDetail {
  const o = (options.__typename ? options : cache["ProjectLotDetail"] = {}) as ProjectLotDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectLotDetail";
  o.id = options.id ?? nextFactoryId("ProjectLotDetail");
  o.lotNumber = options.lotNumber ?? null;
  o.block = options.block ?? null;
  o.section = options.section ?? null;
  o.lotSquareFootage = options.lotSquareFootage ?? null;
  o.elevationCertificateDocumentRequired = options.elevationCertificateDocumentRequired ?? null;
  o.setBackFront = options.setBackFront ?? null;
  o.setBackRight = options.setBackRight ?? null;
  o.setBackLeft = options.setBackLeft ?? null;
  o.setBackRear = options.setBackRear ?? null;
  o.hoa = options.hoa ?? null;
  o.hoaSpecificModifications = options.hoaSpecificModifications ?? null;
  o.siteSpecificModifications = options.siteSpecificModifications ?? null;
  o.fireSprinklersRequired = options.fireSprinklersRequired ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.constructionType = enumOrDetailOrNullOfConstructionType(options.constructionType);
  o.floodPlain = enumOrDetailOrNullOfFloodPlain(options.floodPlain);
  o.foundationType = enumOrDetailOrNullOfFoundationType(options.foundationType);
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.userEvents = (options.userEvents ?? []).map((i) =>
    maybeNew("UserEvent", i, cache, options.hasOwnProperty("userEvents"))
  );
  o.floodZone = enumOrDetailOrNullOfFloodZone(options.floodZone);
  o.setBackFrontInFeet = options.setBackFrontInFeet ?? null;
  o.setBackLeftInFeet = options.setBackLeftInFeet ?? null;
  o.setBackRightInFeet = options.setBackRightInFeet ?? null;
  o.setBackRearInFeet = options.setBackRearInFeet ?? null;
  return o;
}

factories["ProjectLotDetail"] = newProjectLotDetail;

export interface SaveProjectLotDetailsResultOptions {
  __typename?: "SaveProjectLotDetailsResult";
  projectLotDetails?: Array<ProjectLotDetail | ProjectLotDetailOptions>;
}

export function newSaveProjectLotDetailsResult(
  options: SaveProjectLotDetailsResultOptions = {},
  cache: Record<string, any> = {},
): SaveProjectLotDetailsResult {
  const o = (options.__typename ? options : cache["SaveProjectLotDetailsResult"] = {}) as SaveProjectLotDetailsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveProjectLotDetailsResult";
  o.projectLotDetails = (options.projectLotDetails ?? []).map((i) =>
    maybeNew("ProjectLotDetail", i, cache, options.hasOwnProperty("projectLotDetails"))
  );
  return o;
}

factories["SaveProjectLotDetailsResult"] = newSaveProjectLotDetailsResult;

export interface ProjectReadyPlanConfigOptions {
  __typename?: "ProjectReadyPlanConfig";
  id?: ProjectReadyPlanConfig["id"];
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  readyPlan?: ReadyPlan | PlanPackage | DesignPackage | ProductOffering | ReadyPlanLike | ReadyPlanLikeOptions | null;
  productOffering?: ProductOffering | ProductOfferingOptions | null;
  blueprintUrl?: Url | UrlOptions;
  createdAt?: ProjectReadyPlanConfig["createdAt"];
  updatedAt?: ProjectReadyPlanConfig["updatedAt"];
  orientation?: ProjectReadyPlanConfig["orientation"];
  orientationDetail?: ProjectReadyPlanConfigOrientationDetailOptions | ProjectReadyPlanConfigOrientation;
  constructionStartDate?: ProjectReadyPlanConfig["constructionStartDate"];
  internalNote?: ProjectReadyPlanConfig["internalNote"];
  specOption?: ProjectReadyPlanConfigOption | ProjectReadyPlanConfigOptionOptions | null;
  elevationOption?: ProjectReadyPlanConfigOption | ProjectReadyPlanConfigOptionOptions | null;
  exteriorPaletteOption?: ProjectReadyPlanConfigOption | ProjectReadyPlanConfigOptionOptions | null;
  interiorOption?: ProjectReadyPlanConfigOption | ProjectReadyPlanConfigOptionOptions | null;
  options?: Array<ProjectReadyPlanConfigOption | ProjectReadyPlanConfigOptionOptions>;
  readyPlanOptions?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  supportedSpecOptions?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  applied?: ProjectReadyPlanConfig["applied"];
  lastAppliedAt?: ProjectReadyPlanConfig["lastAppliedAt"];
  canApply?: PotentialOperation2 | PotentialOperation2Options;
  canRelease?: PotentialOperation2 | PotentialOperation2Options;
  canEdit?: PotentialOperation2 | PotentialOperation2Options;
  programData?: ProgramData | ProgramDataOptions | null;
  deliveryDate?: ProjectReadyPlanConfig["deliveryDate"];
  configurationUpdatedAt?: ProjectReadyPlanConfig["configurationUpdatedAt"];
  programDataMatchState?: ProgramDataMatchStateDetailOptions | ProgramDataMatchState;
  computedProgramData?: ProgramData | ProgramDataOptions;
  autoPopulateWithComputedProgramData?: ProjectReadyPlanConfig["autoPopulateWithComputedProgramData"];
  insideMapsRoomRenderings?: Array<InsideMapsRoomRendering | InsideMapsRoomRenderingOptions>;
  includedPriceInCents?: ProjectReadyPlanConfig["includedPriceInCents"];
  insideMapsTextureSwaps?: InsideMapsTextureSwaps | InsideMapsTextureSwapsOptions | null;
  includedOptions?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  exteriorRendering?: Asset | AssetOptions | null;
}

export function newProjectReadyPlanConfig(
  options: ProjectReadyPlanConfigOptions = {},
  cache: Record<string, any> = {},
): ProjectReadyPlanConfig {
  const o = (options.__typename ? options : cache["ProjectReadyPlanConfig"] = {}) as ProjectReadyPlanConfig;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectReadyPlanConfig";
  o.id = options.id ?? nextFactoryId("ProjectReadyPlanConfig");
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.readyPlan = maybeNewOrNull("ReadyPlanLike", options.readyPlan, cache);
  o.productOffering = maybeNewOrNull("ProductOffering", options.productOffering, cache);
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.orientation = options.orientation ?? ProjectReadyPlanConfigOrientation.Left;
  o.orientationDetail = enumOrDetailOfProjectReadyPlanConfigOrientation(options.orientationDetail);
  o.constructionStartDate = options.constructionStartDate ?? null;
  o.internalNote = options.internalNote ?? null;
  o.specOption = maybeNewOrNull("ProjectReadyPlanConfigOption", options.specOption, cache);
  o.elevationOption = maybeNewOrNull("ProjectReadyPlanConfigOption", options.elevationOption, cache);
  o.exteriorPaletteOption = maybeNewOrNull("ProjectReadyPlanConfigOption", options.exteriorPaletteOption, cache);
  o.interiorOption = maybeNewOrNull("ProjectReadyPlanConfigOption", options.interiorOption, cache);
  o.options = (options.options ?? []).map((i) =>
    maybeNew("ProjectReadyPlanConfigOption", i, cache, options.hasOwnProperty("options"))
  );
  o.readyPlanOptions = (options.readyPlanOptions ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("readyPlanOptions"))
  );
  o.supportedSpecOptions = (options.supportedSpecOptions ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("supportedSpecOptions"))
  );
  o.applied = options.applied ?? false;
  o.lastAppliedAt = options.lastAppliedAt ?? null;
  o.canApply = maybeNew("PotentialOperation2", options.canApply, cache, options.hasOwnProperty("canApply"));
  o.canRelease = maybeNew("PotentialOperation2", options.canRelease, cache, options.hasOwnProperty("canRelease"));
  o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
  o.programData = maybeNewOrNull("ProgramData", options.programData, cache);
  o.deliveryDate = options.deliveryDate ?? null;
  o.configurationUpdatedAt = options.configurationUpdatedAt ?? newDateTime();
  o.programDataMatchState = enumOrDetailOfProgramDataMatchState(options.programDataMatchState);
  o.computedProgramData = maybeNew(
    "ProgramData",
    options.computedProgramData,
    cache,
    options.hasOwnProperty("computedProgramData"),
  );
  o.autoPopulateWithComputedProgramData = options.autoPopulateWithComputedProgramData ?? false;
  o.insideMapsRoomRenderings = (options.insideMapsRoomRenderings ?? []).map((i) =>
    maybeNew("InsideMapsRoomRendering", i, cache, options.hasOwnProperty("insideMapsRoomRenderings"))
  );
  o.includedPriceInCents = options.includedPriceInCents ?? null;
  o.insideMapsTextureSwaps = maybeNewOrNull("InsideMapsTextureSwaps", options.insideMapsTextureSwaps, cache);
  o.includedOptions = (options.includedOptions ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("includedOptions"))
  );
  o.exteriorRendering = maybeNewOrNull("Asset", options.exteriorRendering, cache);
  return o;
}

factories["ProjectReadyPlanConfig"] = newProjectReadyPlanConfig;

export interface SaveProjectReadyPlanConfigsResultOptions {
  __typename?: "SaveProjectReadyPlanConfigsResult";
  projectReadyPlanConfigs?: Array<ProjectReadyPlanConfig | ProjectReadyPlanConfigOptions>;
}

export function newSaveProjectReadyPlanConfigsResult(
  options: SaveProjectReadyPlanConfigsResultOptions = {},
  cache: Record<string, any> = {},
): SaveProjectReadyPlanConfigsResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveProjectReadyPlanConfigsResult"] = {}) as SaveProjectReadyPlanConfigsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveProjectReadyPlanConfigsResult";
  o.projectReadyPlanConfigs = (options.projectReadyPlanConfigs ?? []).map((i) =>
    maybeNew("ProjectReadyPlanConfig", i, cache, options.hasOwnProperty("projectReadyPlanConfigs"))
  );
  return o;
}

factories["SaveProjectReadyPlanConfigsResult"] = newSaveProjectReadyPlanConfigsResult;

export interface ApplyProjectReadyPlanConfigsResultOptions {
  __typename?: "ApplyProjectReadyPlanConfigsResult";
  projectReadyPlanConfigs?: Array<ProjectReadyPlanConfig | ProjectReadyPlanConfigOptions>;
}

export function newApplyProjectReadyPlanConfigsResult(
  options: ApplyProjectReadyPlanConfigsResultOptions = {},
  cache: Record<string, any> = {},
): ApplyProjectReadyPlanConfigsResult {
  const o =
    (options.__typename
      ? options
      : cache["ApplyProjectReadyPlanConfigsResult"] = {}) as ApplyProjectReadyPlanConfigsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ApplyProjectReadyPlanConfigsResult";
  o.projectReadyPlanConfigs = (options.projectReadyPlanConfigs ?? []).map((i) =>
    maybeNew("ProjectReadyPlanConfig", i, cache, options.hasOwnProperty("projectReadyPlanConfigs"))
  );
  return o;
}

factories["ApplyProjectReadyPlanConfigsResult"] = newApplyProjectReadyPlanConfigsResult;

export interface SaveProjectReadyPlanConfigOptionsResultOptions {
  __typename?: "SaveProjectReadyPlanConfigOptionsResult";
  projectReadyPlanConfigOptions?: Array<ProjectReadyPlanConfigOption | ProjectReadyPlanConfigOptionOptions>;
}

export function newSaveProjectReadyPlanConfigOptionsResult(
  options: SaveProjectReadyPlanConfigOptionsResultOptions = {},
  cache: Record<string, any> = {},
): SaveProjectReadyPlanConfigOptionsResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveProjectReadyPlanConfigOptionsResult"] = {}) as SaveProjectReadyPlanConfigOptionsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveProjectReadyPlanConfigOptionsResult";
  o.projectReadyPlanConfigOptions = (options.projectReadyPlanConfigOptions ?? []).map((i) =>
    maybeNew("ProjectReadyPlanConfigOption", i, cache, options.hasOwnProperty("projectReadyPlanConfigOptions"))
  );
  return o;
}

factories["SaveProjectReadyPlanConfigOptionsResult"] = newSaveProjectReadyPlanConfigOptionsResult;

export interface ProjectReadyPlanConfigOptionOptions {
  __typename?: "ProjectReadyPlanConfigOption";
  id?: ProjectReadyPlanConfigOption["id"];
  createdAt?: ProjectReadyPlanConfigOption["createdAt"];
  updatedAt?: ProjectReadyPlanConfigOption["updatedAt"];
  projectRpConfig?: ProjectReadyPlanConfig | ProjectReadyPlanConfigOptions;
  readyPlanOption?: ReadyPlanOption | ReadyPlanOptionOptions;
  priceInCents?: ProjectReadyPlanConfigOption["priceInCents"];
}

export function newProjectReadyPlanConfigOption(
  options: ProjectReadyPlanConfigOptionOptions = {},
  cache: Record<string, any> = {},
): ProjectReadyPlanConfigOption {
  const o = (options.__typename ? options : cache["ProjectReadyPlanConfigOption"] = {}) as ProjectReadyPlanConfigOption;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectReadyPlanConfigOption";
  o.id = options.id ?? nextFactoryId("ProjectReadyPlanConfigOption");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.projectRpConfig = maybeNew(
    "ProjectReadyPlanConfig",
    options.projectRpConfig,
    cache,
    options.hasOwnProperty("projectRpConfig"),
  );
  o.readyPlanOption = maybeNew(
    "ReadyPlanOption",
    options.readyPlanOption,
    cache,
    options.hasOwnProperty("readyPlanOption"),
  );
  o.priceInCents = options.priceInCents ?? 0;
  return o;
}

factories["ProjectReadyPlanConfigOption"] = newProjectReadyPlanConfigOption;

export interface ProjectSalesforceOpportunityOptions {
  __typename?: "ProjectSalesforceOpportunity";
  id?: ProjectSalesforceOpportunity["id"];
  salesforceOpportunityId?: ProjectSalesforceOpportunity["salesforceOpportunityId"];
  salesforceOpportunityRecordType?: ProjectSalesforceOpportunity["salesforceOpportunityRecordType"];
  active?: ProjectSalesforceOpportunity["active"];
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  createdAt?: ProjectSalesforceOpportunity["createdAt"];
  updatedAt?: ProjectSalesforceOpportunity["updatedAt"];
}

export function newProjectSalesforceOpportunity(
  options: ProjectSalesforceOpportunityOptions = {},
  cache: Record<string, any> = {},
): ProjectSalesforceOpportunity {
  const o = (options.__typename ? options : cache["ProjectSalesforceOpportunity"] = {}) as ProjectSalesforceOpportunity;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectSalesforceOpportunity";
  o.id = options.id ?? nextFactoryId("ProjectSalesforceOpportunity");
  o.salesforceOpportunityId = options.salesforceOpportunityId ?? "salesforceOpportunityId";
  o.salesforceOpportunityRecordType = options.salesforceOpportunityRecordType ?? "salesforceOpportunityRecordType";
  o.active = options.active ?? false;
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  return o;
}

factories["ProjectSalesforceOpportunity"] = newProjectSalesforceOpportunity;

export interface ProjectSiteConditionOptions {
  __typename?: "ProjectSiteCondition";
  id?: ProjectSiteCondition["id"];
  expectedSlabPourDate?: ProjectSiteCondition["expectedSlabPourDate"];
  blueprintUrl?: Url | UrlOptions;
  drivewaySwing?: ProjectSiteCondition["drivewaySwing"];
  gasLocation?: ProjectSiteCondition["gasLocation"];
  electricLocation?: ProjectSiteCondition["electricLocation"];
  waterLocation?: ProjectSiteCondition["waterLocation"];
  curbGutterLinearFoot?: ProjectSiteCondition["curbGutterLinearFoot"];
  createdAt?: ProjectSiteCondition["createdAt"];
  updatedAt?: ProjectSiteCondition["updatedAt"];
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  additionalNotes?: ProjectSiteCondition["additionalNotes"];
  attachments?: Array<Attachment | AttachmentOptions>;
}

export function newProjectSiteCondition(
  options: ProjectSiteConditionOptions = {},
  cache: Record<string, any> = {},
): ProjectSiteCondition {
  const o = (options.__typename ? options : cache["ProjectSiteCondition"] = {}) as ProjectSiteCondition;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectSiteCondition";
  o.id = options.id ?? nextFactoryId("ProjectSiteCondition");
  o.expectedSlabPourDate = options.expectedSlabPourDate ?? null;
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.drivewaySwing = options.drivewaySwing ?? null;
  o.gasLocation = options.gasLocation ?? null;
  o.electricLocation = options.electricLocation ?? null;
  o.waterLocation = options.waterLocation ?? null;
  o.curbGutterLinearFoot = options.curbGutterLinearFoot ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.additionalNotes = options.additionalNotes ?? null;
  o.attachments = (options.attachments ?? []).map((i) =>
    maybeNew("Attachment", i, cache, options.hasOwnProperty("attachments"))
  );
  return o;
}

factories["ProjectSiteCondition"] = newProjectSiteCondition;

export interface SaveProjectSiteConditionResultOptions {
  __typename?: "SaveProjectSiteConditionResult";
  projectSiteCondition?: ProjectSiteCondition | ProjectSiteConditionOptions;
}

export function newSaveProjectSiteConditionResult(
  options: SaveProjectSiteConditionResultOptions = {},
  cache: Record<string, any> = {},
): SaveProjectSiteConditionResult {
  const o =
    (options.__typename ? options : cache["SaveProjectSiteConditionResult"] = {}) as SaveProjectSiteConditionResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveProjectSiteConditionResult";
  o.projectSiteCondition = maybeNew(
    "ProjectSiteCondition",
    options.projectSiteCondition,
    cache,
    options.hasOwnProperty("projectSiteCondition"),
  );
  return o;
}

factories["SaveProjectSiteConditionResult"] = newSaveProjectSiteConditionResult;

export interface ProjectSiteSpecificInfoOptions {
  __typename?: "ProjectSiteSpecificInfo";
  id?: ProjectSiteSpecificInfo["id"];
  perSiteBudgetInCents?: ProjectSiteSpecificInfo["perSiteBudgetInCents"];
  notes?: ProjectSiteSpecificInfo["notes"];
  createdAt?: ProjectSiteSpecificInfo["createdAt"];
  updatedAt?: ProjectSiteSpecificInfo["updatedAt"];
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  siteSpecificInfo?: SiteSpecificInfo | SiteSpecificInfoOptions;
}

export function newProjectSiteSpecificInfo(
  options: ProjectSiteSpecificInfoOptions = {},
  cache: Record<string, any> = {},
): ProjectSiteSpecificInfo {
  const o = (options.__typename ? options : cache["ProjectSiteSpecificInfo"] = {}) as ProjectSiteSpecificInfo;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectSiteSpecificInfo";
  o.id = options.id ?? nextFactoryId("ProjectSiteSpecificInfo");
  o.perSiteBudgetInCents = options.perSiteBudgetInCents ?? null;
  o.notes = options.notes ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.siteSpecificInfo = maybeNew(
    "SiteSpecificInfo",
    options.siteSpecificInfo,
    cache,
    options.hasOwnProperty("siteSpecificInfo"),
  );
  return o;
}

factories["ProjectSiteSpecificInfo"] = newProjectSiteSpecificInfo;

export interface SaveProjectSiteSpecificInfoResultOptions {
  __typename?: "SaveProjectSiteSpecificInfoResult";
  projectSiteSpecificInfo?: ProjectSiteSpecificInfo | ProjectSiteSpecificInfoOptions;
}

export function newSaveProjectSiteSpecificInfoResult(
  options: SaveProjectSiteSpecificInfoResultOptions = {},
  cache: Record<string, any> = {},
): SaveProjectSiteSpecificInfoResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveProjectSiteSpecificInfoResult"] = {}) as SaveProjectSiteSpecificInfoResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveProjectSiteSpecificInfoResult";
  o.projectSiteSpecificInfo = maybeNew(
    "ProjectSiteSpecificInfo",
    options.projectSiteSpecificInfo,
    cache,
    options.hasOwnProperty("projectSiteSpecificInfo"),
  );
  return o;
}

factories["SaveProjectSiteSpecificInfoResult"] = newSaveProjectSiteSpecificInfoResult;

export interface ProjectSnapshotOptions {
  __typename?: "ProjectSnapshot";
  id?: ProjectSnapshot["id"];
  grossSalesPriceInCents?: ProjectSnapshot["grossSalesPriceInCents"];
  closingCostsForDirectMarginInCents?: ProjectSnapshot["closingCostsForDirectMarginInCents"];
  totalCostInCents?: ProjectSnapshot["totalCostInCents"];
  totalHardCostInCents?: ProjectSnapshot["totalHardCostInCents"];
  totalSoftCostInCents?: ProjectSnapshot["totalSoftCostInCents"];
  directMarginInBasisPoints?: ProjectSnapshot["directMarginInBasisPoints"];
  purchaseCostInCents?: ProjectSnapshot["purchaseCostInCents"];
  startDate?: ProjectSnapshot["startDate"];
  endDate?: ProjectSnapshot["endDate"];
}

export function newProjectSnapshot(
  options: ProjectSnapshotOptions = {},
  cache: Record<string, any> = {},
): ProjectSnapshot {
  const o = (options.__typename ? options : cache["ProjectSnapshot"] = {}) as ProjectSnapshot;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectSnapshot";
  o.id = options.id ?? nextFactoryId("ProjectSnapshot");
  o.grossSalesPriceInCents = options.grossSalesPriceInCents ?? null;
  o.closingCostsForDirectMarginInCents = options.closingCostsForDirectMarginInCents ?? null;
  o.totalCostInCents = options.totalCostInCents ?? null;
  o.totalHardCostInCents = options.totalHardCostInCents ?? null;
  o.totalSoftCostInCents = options.totalSoftCostInCents ?? null;
  o.directMarginInBasisPoints = options.directMarginInBasisPoints ?? null;
  o.purchaseCostInCents = options.purchaseCostInCents ?? null;
  o.startDate = options.startDate ?? newDate();
  o.endDate = options.endDate ?? null;
  return o;
}

factories["ProjectSnapshot"] = newProjectSnapshot;

export interface StageProgressOptions {
  __typename?: "StageProgress";
  id?: StageProgress["id"];
  taskProgress?: ProgressSummary | ProgressSummaryOptions;
  selectionProgress?: Array<HomeownerSelectionStatusProgress | HomeownerSelectionStatusProgressOptions>;
}

export function newStageProgress(options: StageProgressOptions = {}, cache: Record<string, any> = {}): StageProgress {
  const o = (options.__typename ? options : cache["StageProgress"] = {}) as StageProgress;
  (cache.all ??= new Set()).add(o);
  o.__typename = "StageProgress";
  o.id = options.id ?? nextFactoryId("StageProgress");
  o.taskProgress = maybeNew("ProgressSummary", options.taskProgress, cache, options.hasOwnProperty("taskProgress"));
  o.selectionProgress = (options.selectionProgress ?? []).map((i) =>
    maybeNew("HomeownerSelectionStatusProgress", i, cache, options.hasOwnProperty("selectionProgress"))
  );
  return o;
}

factories["StageProgress"] = newStageProgress;

export interface HomeownerSelectionStatusProgressOptions {
  __typename?: "HomeownerSelectionStatusProgress";
  status?: HomeownerSelectionStatusDetailOptions | HomeownerSelectionStatus;
  count?: HomeownerSelectionStatusProgress["count"];
}

export function newHomeownerSelectionStatusProgress(
  options: HomeownerSelectionStatusProgressOptions = {},
  cache: Record<string, any> = {},
): HomeownerSelectionStatusProgress {
  const o =
    (options.__typename ? options : cache["HomeownerSelectionStatusProgress"] = {}) as HomeownerSelectionStatusProgress;
  (cache.all ??= new Set()).add(o);
  o.__typename = "HomeownerSelectionStatusProgress";
  o.status = enumOrDetailOfHomeownerSelectionStatus(options.status);
  o.count = options.count ?? 0;
  return o;
}

factories["HomeownerSelectionStatusProgress"] = newHomeownerSelectionStatusProgress;

export interface ProjectStageHomeownerFinancialsOptions {
  __typename?: "ProjectStageHomeownerFinancials";
  homeownerPriceInCents?: ProjectStageHomeownerFinancials["homeownerPriceInCents"];
  amountInvoicedInCents?: ProjectStageHomeownerFinancials["amountInvoicedInCents"];
  amountPaidInCents?: ProjectStageHomeownerFinancials["amountPaidInCents"];
  balanceInCents?: ProjectStageHomeownerFinancials["balanceInCents"];
  financialsLastUpdate?: ProjectStageHomeownerFinancials["financialsLastUpdate"];
}

export function newProjectStageHomeownerFinancials(
  options: ProjectStageHomeownerFinancialsOptions = {},
  cache: Record<string, any> = {},
): ProjectStageHomeownerFinancials {
  const o =
    (options.__typename ? options : cache["ProjectStageHomeownerFinancials"] = {}) as ProjectStageHomeownerFinancials;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectStageHomeownerFinancials";
  o.homeownerPriceInCents = options.homeownerPriceInCents ?? 0;
  o.amountInvoicedInCents = options.amountInvoicedInCents ?? 0;
  o.amountPaidInCents = options.amountPaidInCents ?? 0;
  o.balanceInCents = options.balanceInCents ?? 0;
  o.financialsLastUpdate = options.financialsLastUpdate ?? newDate();
  return o;
}

factories["ProjectStageHomeownerFinancials"] = newProjectStageHomeownerFinancials;

export interface ProjectStageHocFinancialsOptions {
  __typename?: "ProjectStageHocFinancials";
  originalContractValueInCents?: ProjectStageHocFinancials["originalContractValueInCents"];
  originalBudgetedCostInCents?: ProjectStageHocFinancials["originalBudgetedCostInCents"];
  originalGrossMarginBasisPoints?: ProjectStageHocFinancials["originalGrossMarginBasisPoints"];
  valueInCents?: ProjectStageHocFinancials["valueInCents"];
  costInCents?: ProjectStageHocFinancials["costInCents"];
  grossMarginBasisPoints?: ProjectStageHocFinancials["grossMarginBasisPoints"];
  paidFromHomeownerInCents?: ProjectStageHocFinancials["paidFromHomeownerInCents"];
  paidToTradesInCents?: ProjectStageHocFinancials["paidToTradesInCents"];
  paidNetInCents?: ProjectStageHocFinancials["paidNetInCents"];
  marginErosionBasisPoints?: ProjectStageHocFinancials["marginErosionBasisPoints"];
}

export function newProjectStageHocFinancials(
  options: ProjectStageHocFinancialsOptions = {},
  cache: Record<string, any> = {},
): ProjectStageHocFinancials {
  const o = (options.__typename ? options : cache["ProjectStageHocFinancials"] = {}) as ProjectStageHocFinancials;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectStageHocFinancials";
  o.originalContractValueInCents = options.originalContractValueInCents ?? 0;
  o.originalBudgetedCostInCents = options.originalBudgetedCostInCents ?? 0;
  o.originalGrossMarginBasisPoints = options.originalGrossMarginBasisPoints ?? 0;
  o.valueInCents = options.valueInCents ?? 0;
  o.costInCents = options.costInCents ?? 0;
  o.grossMarginBasisPoints = options.grossMarginBasisPoints ?? 0;
  o.paidFromHomeownerInCents = options.paidFromHomeownerInCents ?? 0;
  o.paidToTradesInCents = options.paidToTradesInCents ?? 0;
  o.paidNetInCents = options.paidNetInCents ?? 0;
  o.marginErosionBasisPoints = options.marginErosionBasisPoints ?? 0;
  return o;
}

factories["ProjectStageHocFinancials"] = newProjectStageHocFinancials;

export interface ProjectStageTemplateConfigOptions {
  __typename?: "ProjectStageTemplateConfig";
  id?: ProjectStageTemplateConfig["id"];
  itemTemplate?: ItemTemplate | ItemTemplateOptions;
  parent?: ItemTemplate | ReadyPlanAggregateVersion | BaseItemParentVersion | BaseItemParentVersionOptions;
  projectStage?: ProjectStage | ProjectStageOptions;
  canEdit?: PotentialOperation2 | PotentialOperation2Options;
  createdAt?: ProjectStageTemplateConfig["createdAt"];
  updatedAt?: ProjectStageTemplateConfig["updatedAt"];
  name?: ProjectStageTemplateConfig["name"];
  totalCostInCents?: ProjectStageTemplateConfig["totalCostInCents"];
  onlyChangedInVersion?: ProjectStageTemplateConfig["onlyChangedInVersion"];
  changeEvent?: ChangeEvent | ChangeEventOptions | null;
}

export function newProjectStageTemplateConfig(
  options: ProjectStageTemplateConfigOptions = {},
  cache: Record<string, any> = {},
): ProjectStageTemplateConfig {
  const o = (options.__typename ? options : cache["ProjectStageTemplateConfig"] = {}) as ProjectStageTemplateConfig;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectStageTemplateConfig";
  o.id = options.id ?? nextFactoryId("ProjectStageTemplateConfig");
  o.itemTemplate = maybeNew("ItemTemplate", options.itemTemplate, cache, options.hasOwnProperty("itemTemplate"));
  o.parent = maybeNew("BaseItemParentVersion", options.parent, cache, options.hasOwnProperty("parent"));
  o.projectStage = maybeNew("ProjectStage", options.projectStage, cache, options.hasOwnProperty("projectStage"));
  o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.name = options.name ?? "name";
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.onlyChangedInVersion = options.onlyChangedInVersion ?? null;
  o.changeEvent = maybeNewOrNull("ChangeEvent", options.changeEvent, cache);
  return o;
}

factories["ProjectStageTemplateConfig"] = newProjectStageTemplateConfig;

export interface ProjectStatusChangeOptions {
  __typename?: "ProjectStatusChange";
  id?: ProjectStatusChange["id"];
  internalNote?: ProjectStatusChange["internalNote"];
  createdAt?: ProjectStatusChange["createdAt"];
  updatedAt?: ProjectStatusChange["updatedAt"];
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  reason?: ProjectStatusChangeReason | ProjectStatusChangeReasonOptions | null;
  date?: ProjectStatusChange["date"];
}

export function newProjectStatusChange(
  options: ProjectStatusChangeOptions = {},
  cache: Record<string, any> = {},
): ProjectStatusChange {
  const o = (options.__typename ? options : cache["ProjectStatusChange"] = {}) as ProjectStatusChange;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectStatusChange";
  o.id = options.id ?? nextFactoryId("ProjectStatusChange");
  o.internalNote = options.internalNote ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.reason = maybeNewOrNull("ProjectStatusChangeReason", options.reason, cache);
  o.date = options.date ?? null;
  return o;
}

factories["ProjectStatusChange"] = newProjectStatusChange;

export interface ProjectStatusChangeReasonOptions {
  __typename?: "ProjectStatusChangeReason";
  id?: ProjectStatusChangeReason["id"];
  code?: ProjectStatusChangeReason["code"];
  name?: ProjectStatusChangeReason["name"];
  projectStatus?: ProjectStatusChangeReason["projectStatus"];
  projectStatusDetail?: ProjectStatusDetailOptions | ProjectStatus;
  projectStage?: ProjectStatusChangeReason["projectStage"];
  projectStageDetail?: StageDetailOptions | Stage;
}

export function newProjectStatusChangeReason(
  options: ProjectStatusChangeReasonOptions = {},
  cache: Record<string, any> = {},
): ProjectStatusChangeReason {
  const o = (options.__typename ? options : cache["ProjectStatusChangeReason"] = {}) as ProjectStatusChangeReason;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectStatusChangeReason";
  o.id = options.id ?? nextFactoryId("ProjectStatusChangeReason");
  o.code = options.code ?? "code";
  o.name = options.name ?? "name";
  o.projectStatus = options.projectStatus ?? ProjectStatus.Active;
  o.projectStatusDetail = enumOrDetailOfProjectStatus(options.projectStatusDetail);
  o.projectStage = options.projectStage ?? Stage.PreConPlanning;
  o.projectStageDetail = enumOrDetailOfStage(options.projectStageDetail);
  return o;
}

factories["ProjectStatusChangeReason"] = newProjectStatusChangeReason;

export interface SaveProjectStatusChangeReasonsResultOptions {
  __typename?: "SaveProjectStatusChangeReasonsResult";
  projectStatusChangeReasons?: Array<ProjectStatusChangeReason | ProjectStatusChangeReasonOptions>;
  userErrors?: Array<Maybe<UserError | UserErrorOptions>>;
}

export function newSaveProjectStatusChangeReasonsResult(
  options: SaveProjectStatusChangeReasonsResultOptions = {},
  cache: Record<string, any> = {},
): SaveProjectStatusChangeReasonsResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveProjectStatusChangeReasonsResult"] = {}) as SaveProjectStatusChangeReasonsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveProjectStatusChangeReasonsResult";
  o.projectStatusChangeReasons = (options.projectStatusChangeReasons ?? []).map((i) =>
    maybeNew("ProjectStatusChangeReason", i, cache, options.hasOwnProperty("projectStatusChangeReasons"))
  );
  o.userErrors = (options.userErrors ?? []).map((i) => maybeNewOrNull("UserError", i, cache));
  return o;
}

factories["SaveProjectStatusChangeReasonsResult"] = newSaveProjectStatusChangeReasonsResult;

export interface ProjectTeamMemberOptions {
  __typename?: "ProjectTeamMember";
  user?: InternalUser | InternalUserOptions | null;
  role?: ProjectRoleDetailOptions | ProjectRole;
}

export function newProjectTeamMember(
  options: ProjectTeamMemberOptions = {},
  cache: Record<string, any> = {},
): ProjectTeamMember {
  const o = (options.__typename ? options : cache["ProjectTeamMember"] = {}) as ProjectTeamMember;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectTeamMember";
  o.user = maybeNewOrNull("InternalUser", options.user, cache);
  o.role = enumOrDetailOfProjectRole(options.role);
  return o;
}

factories["ProjectTeamMember"] = newProjectTeamMember;

export interface UpdateProjectRoleResultOptions {
  __typename?: "UpdateProjectRoleResult";
  teamMember?: ProjectTeamMember | ProjectTeamMemberOptions;
  tasks?: Array<Task | TaskOptions>;
}

export function newUpdateProjectRoleResult(
  options: UpdateProjectRoleResultOptions = {},
  cache: Record<string, any> = {},
): UpdateProjectRoleResult {
  const o = (options.__typename ? options : cache["UpdateProjectRoleResult"] = {}) as UpdateProjectRoleResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "UpdateProjectRoleResult";
  o.teamMember = maybeNew("ProjectTeamMember", options.teamMember, cache, options.hasOwnProperty("teamMember"));
  o.tasks = (options.tasks ?? []).map((i) => maybeNew("Task", i, cache, options.hasOwnProperty("tasks")));
  return o;
}

factories["UpdateProjectRoleResult"] = newUpdateProjectRoleResult;

export interface BulkUpdateProjectRoleResultOptions {
  __typename?: "BulkUpdateProjectRoleResult";
  teamMember?: ProjectTeamMember | ProjectTeamMemberOptions;
  tasks?: Array<Task | TaskOptions>;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
}

export function newBulkUpdateProjectRoleResult(
  options: BulkUpdateProjectRoleResultOptions = {},
  cache: Record<string, any> = {},
): BulkUpdateProjectRoleResult {
  const o = (options.__typename ? options : cache["BulkUpdateProjectRoleResult"] = {}) as BulkUpdateProjectRoleResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BulkUpdateProjectRoleResult";
  o.teamMember = maybeNew("ProjectTeamMember", options.teamMember, cache, options.hasOwnProperty("teamMember"));
  o.tasks = (options.tasks ?? []).map((i) => maybeNew("Task", i, cache, options.hasOwnProperty("tasks")));
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  return o;
}

factories["BulkUpdateProjectRoleResult"] = newBulkUpdateProjectRoleResult;

export interface ProjectUpdateOptions {
  __typename?: "ProjectUpdate";
  id?: ProjectUpdate["id"];
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  createdAt?: ProjectUpdate["createdAt"];
  eventTime?: ProjectUpdate["eventTime"];
  actionType?: ProjectUpdate["actionType"];
  actionTypeDetail?: ProjectUpdateActionTypeDetailOptions | ProjectUpdateActionType;
  schedulePhase?: SchedulePhase | SchedulePhaseOptions | null;
  document?: Document | DocumentOptions | null;
  scheduleSubPhase?: ScheduleSubPhase | ScheduleSubPhaseOptions | null;
  homeownerNote?: HomeownerNote | HomeownerNoteOptions | null;
}

export function newProjectUpdate(options: ProjectUpdateOptions = {}, cache: Record<string, any> = {}): ProjectUpdate {
  const o = (options.__typename ? options : cache["ProjectUpdate"] = {}) as ProjectUpdate;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProjectUpdate";
  o.id = options.id ?? nextFactoryId("ProjectUpdate");
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.createdAt = options.createdAt ?? newDateTime();
  o.eventTime = options.eventTime ?? newDateTime();
  o.actionType = options.actionType ?? ProjectUpdateActionType.ActivityComplete;
  o.actionTypeDetail = enumOrDetailOfProjectUpdateActionType(options.actionTypeDetail);
  o.schedulePhase = maybeNewOrNull("SchedulePhase", options.schedulePhase, cache);
  o.document = maybeNewOrNull("Document", options.document, cache);
  o.scheduleSubPhase = maybeNewOrNull("ScheduleSubPhase", options.scheduleSubPhase, cache);
  o.homeownerNote = maybeNewOrNull("HomeownerNote", options.homeownerNote, cache);
  return o;
}

factories["ProjectUpdate"] = newProjectUpdate;

export interface SavePunchlistItemTodosResultOptions {
  __typename?: "SavePunchlistItemTodosResult";
  punchlistItemTodos?: Array<PunchlistItemTodo | PunchlistItemTodoOptions>;
}

export function newSavePunchlistItemTodosResult(
  options: SavePunchlistItemTodosResultOptions = {},
  cache: Record<string, any> = {},
): SavePunchlistItemTodosResult {
  const o = (options.__typename ? options : cache["SavePunchlistItemTodosResult"] = {}) as SavePunchlistItemTodosResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SavePunchlistItemTodosResult";
  o.punchlistItemTodos = (options.punchlistItemTodos ?? []).map((i) =>
    maybeNew("PunchlistItemTodo", i, cache, options.hasOwnProperty("punchlistItemTodos"))
  );
  return o;
}

factories["SavePunchlistItemTodosResult"] = newSavePunchlistItemTodosResult;

export interface SavePunchlistItemTodoResultOptions {
  __typename?: "SavePunchlistItemTodoResult";
  punchlistItemTodo?: PunchlistItemTodo | PunchlistItemTodoOptions;
}

export function newSavePunchlistItemTodoResult(
  options: SavePunchlistItemTodoResultOptions = {},
  cache: Record<string, any> = {},
): SavePunchlistItemTodoResult {
  const o = (options.__typename ? options : cache["SavePunchlistItemTodoResult"] = {}) as SavePunchlistItemTodoResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SavePunchlistItemTodoResult";
  o.punchlistItemTodo = maybeNew(
    "PunchlistItemTodo",
    options.punchlistItemTodo,
    cache,
    options.hasOwnProperty("punchlistItemTodo"),
  );
  return o;
}

factories["SavePunchlistItemTodoResult"] = newSavePunchlistItemTodoResult;

export interface SendTradePartnerPunchlistEmailResultsOptions {
  __typename?: "SendTradePartnerPunchlistEmailResults";
  results?:
    | Array<
      | SendTradePartnerPunchlistEmailResult
      | SendTradePartnerPunchlistEmailSuccessOptions
      | RequireTypename<SendTradePartnerPunchlistEmailFailureOptions>
    >
    | null;
}

export function newSendTradePartnerPunchlistEmailResults(
  options: SendTradePartnerPunchlistEmailResultsOptions = {},
  cache: Record<string, any> = {},
): SendTradePartnerPunchlistEmailResults {
  const o =
    (options.__typename
      ? options
      : cache["SendTradePartnerPunchlistEmailResults"] = {}) as SendTradePartnerPunchlistEmailResults;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SendTradePartnerPunchlistEmailResults";
  o.results = (options.results ?? []).map((i) =>
    maybeNew(i?.__typename ?? "{SendTradePartnerPunchlistEmailSuccess", i, cache, options.hasOwnProperty("results"))
  );
  return o;
}

factories["SendTradePartnerPunchlistEmailResults"] = newSendTradePartnerPunchlistEmailResults;

export interface SendTradePartnerPunchlistEmailSuccessOptions {
  __typename?: "SendTradePartnerPunchlistEmailSuccess";
  punchlistItemTodo?: PunchlistItemTodo | PunchlistItemTodoOptions;
  emails?: SendTradePartnerPunchlistEmailSuccess["emails"];
}

export function newSendTradePartnerPunchlistEmailSuccess(
  options: SendTradePartnerPunchlistEmailSuccessOptions = {},
  cache: Record<string, any> = {},
): SendTradePartnerPunchlistEmailSuccess {
  const o =
    (options.__typename
      ? options
      : cache["SendTradePartnerPunchlistEmailSuccess"] = {}) as SendTradePartnerPunchlistEmailSuccess;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SendTradePartnerPunchlistEmailSuccess";
  o.punchlistItemTodo = maybeNew(
    "PunchlistItemTodo",
    options.punchlistItemTodo,
    cache,
    options.hasOwnProperty("punchlistItemTodo"),
  );
  o.emails = options.emails ?? [];
  return o;
}

factories["SendTradePartnerPunchlistEmailSuccess"] = newSendTradePartnerPunchlistEmailSuccess;

export interface SendTradePartnerPunchlistEmailFailureOptions {
  __typename?: "SendTradePartnerPunchlistEmailFailure";
  punchlistItemTodoId?: SendTradePartnerPunchlistEmailFailure["punchlistItemTodoId"];
  error?: SendTradePartnerPunchlistEmailFailure["error"];
}

export function newSendTradePartnerPunchlistEmailFailure(
  options: SendTradePartnerPunchlistEmailFailureOptions = {},
  cache: Record<string, any> = {},
): SendTradePartnerPunchlistEmailFailure {
  const o =
    (options.__typename
      ? options
      : cache["SendTradePartnerPunchlistEmailFailure"] = {}) as SendTradePartnerPunchlistEmailFailure;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SendTradePartnerPunchlistEmailFailure";
  o.punchlistItemTodoId = options.punchlistItemTodoId ?? "punchlistItemTodoId";
  o.error = options.error ?? "error";
  return o;
}

factories["SendTradePartnerPunchlistEmailFailure"] = newSendTradePartnerPunchlistEmailFailure;

export interface SendPunchlistExportEmailResultsOptions {
  __typename?: "SendPunchlistExportEmailResults";
  results?:
    | Array<
      | SendPunchlistExportEmailResult
      | SendPunchlistExportEmailSuccessOptions
      | RequireTypename<SendPunchlistExportEmailFailureOptions>
    >
    | null;
}

export function newSendPunchlistExportEmailResults(
  options: SendPunchlistExportEmailResultsOptions = {},
  cache: Record<string, any> = {},
): SendPunchlistExportEmailResults {
  const o =
    (options.__typename ? options : cache["SendPunchlistExportEmailResults"] = {}) as SendPunchlistExportEmailResults;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SendPunchlistExportEmailResults";
  o.results = (options.results ?? []).map((i) =>
    maybeNew(i?.__typename ?? "{SendPunchlistExportEmailSuccess", i, cache, options.hasOwnProperty("results"))
  );
  return o;
}

factories["SendPunchlistExportEmailResults"] = newSendPunchlistExportEmailResults;

export interface SendPunchlistExportEmailSuccessOptions {
  __typename?: "SendPunchlistExportEmailSuccess";
  punchlistItemTodo?: PunchlistItemTodo | PunchlistItemTodoOptions;
}

export function newSendPunchlistExportEmailSuccess(
  options: SendPunchlistExportEmailSuccessOptions = {},
  cache: Record<string, any> = {},
): SendPunchlistExportEmailSuccess {
  const o =
    (options.__typename ? options : cache["SendPunchlistExportEmailSuccess"] = {}) as SendPunchlistExportEmailSuccess;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SendPunchlistExportEmailSuccess";
  o.punchlistItemTodo = maybeNew(
    "PunchlistItemTodo",
    options.punchlistItemTodo,
    cache,
    options.hasOwnProperty("punchlistItemTodo"),
  );
  return o;
}

factories["SendPunchlistExportEmailSuccess"] = newSendPunchlistExportEmailSuccess;

export interface SendPunchlistExportEmailFailureOptions {
  __typename?: "SendPunchlistExportEmailFailure";
  punchlistItemTodoId?: SendPunchlistExportEmailFailure["punchlistItemTodoId"];
  error?: SendPunchlistExportEmailFailure["error"];
}

export function newSendPunchlistExportEmailFailure(
  options: SendPunchlistExportEmailFailureOptions = {},
  cache: Record<string, any> = {},
): SendPunchlistExportEmailFailure {
  const o =
    (options.__typename ? options : cache["SendPunchlistExportEmailFailure"] = {}) as SendPunchlistExportEmailFailure;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SendPunchlistExportEmailFailure";
  o.punchlistItemTodoId = options.punchlistItemTodoId ?? "punchlistItemTodoId";
  o.error = options.error ?? "error";
  return o;
}

factories["SendPunchlistExportEmailFailure"] = newSendPunchlistExportEmailFailure;

export interface RegisterPushNotificationTokenResultOptions {
  __typename?: "RegisterPushNotificationTokenResult";
  pushNotificationToken?: PushNotificationToken | PushNotificationTokenOptions;
}

export function newRegisterPushNotificationTokenResult(
  options: RegisterPushNotificationTokenResultOptions = {},
  cache: Record<string, any> = {},
): RegisterPushNotificationTokenResult {
  const o =
    (options.__typename
      ? options
      : cache["RegisterPushNotificationTokenResult"] = {}) as RegisterPushNotificationTokenResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "RegisterPushNotificationTokenResult";
  o.pushNotificationToken = maybeNew(
    "PushNotificationToken",
    options.pushNotificationToken,
    cache,
    options.hasOwnProperty("pushNotificationToken"),
  );
  return o;
}

factories["RegisterPushNotificationTokenResult"] = newRegisterPushNotificationTokenResult;

export interface PushNotificationTokenOptions {
  __typename?: "PushNotificationToken";
  id?: PushNotificationToken["id"];
  token?: PushNotificationToken["token"];
  lastSeenAt?: PushNotificationToken["lastSeenAt"];
  createdAt?: PushNotificationToken["createdAt"];
  updatedAt?: PushNotificationToken["updatedAt"];
  platform?: PushNotificationPlatformDetailOptions | PushNotificationPlatform;
  user?: User | UserOptions;
  environment?: PushNotificationEnvironmentDetailOptions | PushNotificationEnvironment;
  snsEndpointArn?: PushNotificationToken["snsEndpointArn"];
}

export function newPushNotificationToken(
  options: PushNotificationTokenOptions = {},
  cache: Record<string, any> = {},
): PushNotificationToken {
  const o = (options.__typename ? options : cache["PushNotificationToken"] = {}) as PushNotificationToken;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PushNotificationToken";
  o.id = options.id ?? nextFactoryId("PushNotificationToken");
  o.token = options.token ?? "token";
  o.lastSeenAt = options.lastSeenAt ?? newDateTime();
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.platform = enumOrDetailOfPushNotificationPlatform(options.platform);
  o.user = maybeNew("User", options.user, cache, options.hasOwnProperty("user"));
  o.environment = enumOrDetailOfPushNotificationEnvironment(options.environment);
  o.snsEndpointArn = options.snsEndpointArn ?? null;
  return o;
}

factories["PushNotificationToken"] = newPushNotificationToken;

export interface SaveReadyPlansResultOptions {
  __typename?: "SaveReadyPlansResult";
  readyPlans?: Array<ReadyPlan | ReadyPlanOptions>;
}

export function newSaveReadyPlansResult(
  options: SaveReadyPlansResultOptions = {},
  cache: Record<string, any> = {},
): SaveReadyPlansResult {
  const o = (options.__typename ? options : cache["SaveReadyPlansResult"] = {}) as SaveReadyPlansResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveReadyPlansResult";
  o.readyPlans = (options.readyPlans ?? []).map((i) =>
    maybeNew("ReadyPlan", i, cache, options.hasOwnProperty("readyPlans"))
  );
  return o;
}

factories["SaveReadyPlansResult"] = newSaveReadyPlansResult;

export interface SaveReadyPlanResultOptions {
  __typename?: "SaveReadyPlanResult";
  readyPlan?: ReadyPlan | ReadyPlanOptions;
}

export function newSaveReadyPlanResult(
  options: SaveReadyPlanResultOptions = {},
  cache: Record<string, any> = {},
): SaveReadyPlanResult {
  const o = (options.__typename ? options : cache["SaveReadyPlanResult"] = {}) as SaveReadyPlanResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveReadyPlanResult";
  o.readyPlan = maybeNew("ReadyPlan", options.readyPlan, cache, options.hasOwnProperty("readyPlan"));
  return o;
}

factories["SaveReadyPlanResult"] = newSaveReadyPlanResult;

export interface ComputeReadyPlanCostResultOptions {
  __typename?: "ComputeReadyPlanCostResult";
  readyPlan?: ReadyPlan | ReadyPlanOptions;
  readyPlanOptions?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  totalCostInCents?: ComputeReadyPlanCostResult["totalCostInCents"];
  softCostInCents?: ComputeReadyPlanCostResult["softCostInCents"];
  directHardCostInCents?: ComputeReadyPlanCostResult["directHardCostInCents"];
  indirectHardCostInCents?: ComputeReadyPlanCostResult["indirectHardCostInCents"];
  contingencyCostInCents?: ComputeReadyPlanCostResult["contingencyCostInCents"];
  contingencyComputed?: ComputeReadyPlanCostResult["contingencyComputed"];
  deltas?: Array<ReadyPlanOptionCostDelta | ReadyPlanOptionCostDeltaOptions>;
  protoProjectItems?: Array<ProtoProjectItem | ProtoProjectItemOptions>;
  configurationErrors?: ComputeReadyPlanCostResult["configurationErrors"];
}

export function newComputeReadyPlanCostResult(
  options: ComputeReadyPlanCostResultOptions = {},
  cache: Record<string, any> = {},
): ComputeReadyPlanCostResult {
  const o = (options.__typename ? options : cache["ComputeReadyPlanCostResult"] = {}) as ComputeReadyPlanCostResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ComputeReadyPlanCostResult";
  o.readyPlan = maybeNew("ReadyPlan", options.readyPlan, cache, options.hasOwnProperty("readyPlan"));
  o.readyPlanOptions = (options.readyPlanOptions ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("readyPlanOptions"))
  );
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.softCostInCents = options.softCostInCents ?? 0;
  o.directHardCostInCents = options.directHardCostInCents ?? 0;
  o.indirectHardCostInCents = options.indirectHardCostInCents ?? 0;
  o.contingencyCostInCents = options.contingencyCostInCents ?? 0;
  o.contingencyComputed = options.contingencyComputed ?? false;
  o.deltas = (options.deltas ?? []).map((i) =>
    maybeNew("ReadyPlanOptionCostDelta", i, cache, options.hasOwnProperty("deltas"))
  );
  o.protoProjectItems = (options.protoProjectItems ?? []).map((i) =>
    maybeNew("ProtoProjectItem", i, cache, options.hasOwnProperty("protoProjectItems"))
  );
  o.configurationErrors = options.configurationErrors ?? [];
  return o;
}

factories["ComputeReadyPlanCostResult"] = newComputeReadyPlanCostResult;

export interface ReadyPlanOptionCostDeltaOptions {
  __typename?: "ReadyPlanOptionCostDelta";
  readyPlanOption?: ReadyPlanOption | ReadyPlanOptionOptions;
  totalCostInCents?: ReadyPlanOptionCostDelta["totalCostInCents"];
  softCostInCents?: ReadyPlanOptionCostDelta["softCostInCents"];
  directHardCostInCents?: ReadyPlanOptionCostDelta["directHardCostInCents"];
  indirectHardCostInCents?: ReadyPlanOptionCostDelta["indirectHardCostInCents"];
  contingencyCostInCents?: ReadyPlanOptionCostDelta["contingencyCostInCents"];
  contingencyComputed?: ReadyPlanOptionCostDelta["contingencyComputed"];
}

export function newReadyPlanOptionCostDelta(
  options: ReadyPlanOptionCostDeltaOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanOptionCostDelta {
  const o = (options.__typename ? options : cache["ReadyPlanOptionCostDelta"] = {}) as ReadyPlanOptionCostDelta;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanOptionCostDelta";
  o.readyPlanOption = maybeNew(
    "ReadyPlanOption",
    options.readyPlanOption,
    cache,
    options.hasOwnProperty("readyPlanOption"),
  );
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.softCostInCents = options.softCostInCents ?? 0;
  o.directHardCostInCents = options.directHardCostInCents ?? 0;
  o.indirectHardCostInCents = options.indirectHardCostInCents ?? 0;
  o.contingencyCostInCents = options.contingencyCostInCents ?? 0;
  o.contingencyComputed = options.contingencyComputed ?? false;
  return o;
}

factories["ReadyPlanOptionCostDelta"] = newReadyPlanOptionCostDelta;

export interface ProtoProjectItemOptions {
  __typename?: "ProtoProjectItem";
  name?: ProtoProjectItem["name"];
  specifications?: ProtoProjectItem["specifications"];
  tradePartnerNote?: ProtoProjectItem["tradePartnerNote"];
  slot?: ItemSlot | ItemSlotOptions;
  item?: Item | ItemOptions;
  quantity?: ProtoProjectItem["quantity"];
  totalPriceInCents?: ProtoProjectItem["totalPriceInCents"];
  totalCostInCents?: ProtoProjectItem["totalCostInCents"];
  location?: Location | LocationOptions;
  unitOfMeasure?: UnitOfMeasure | UnitOfMeasureOptions;
  costType?: ProtoProjectItem["costType"];
  preferredPotentialBidContractLineItem?: PotentialBidContractLineItem | PotentialBidContractLineItemOptions | null;
  itemTemplateItem?:
    | ItemTemplateItemVersion
    | ItemTemplateItem
    | TakeoffLineItem
    | TakeoffLineItemVersion
    | BaseItemLike
    | BaseItemLikeOptions
    | null;
  modifyingTemplateItems?: Array<
    | ItemTemplateItemVersion
    | ItemTemplateItem
    | TakeoffLineItem
    | TakeoffLineItemVersion
    | BaseItemLike
    | BaseItemLikeOptions
  >;
  bidItem?: BidItem | BidItemOptions | null;
  product?: Product | ProductOptions | null;
}

export function newProtoProjectItem(
  options: ProtoProjectItemOptions = {},
  cache: Record<string, any> = {},
): ProtoProjectItem {
  const o = (options.__typename ? options : cache["ProtoProjectItem"] = {}) as ProtoProjectItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ProtoProjectItem";
  o.name = options.name ?? "name";
  o.specifications = options.specifications ?? null;
  o.tradePartnerNote = options.tradePartnerNote ?? null;
  o.slot = maybeNew("ItemSlot", options.slot, cache, options.hasOwnProperty("slot"));
  o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
  o.quantity = options.quantity ?? null;
  o.totalPriceInCents = options.totalPriceInCents ?? 0;
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.location = maybeNew("Location", options.location, cache, options.hasOwnProperty("location"));
  o.unitOfMeasure = maybeNew("UnitOfMeasure", options.unitOfMeasure, cache, options.hasOwnProperty("unitOfMeasure"));
  o.costType = options.costType ?? CostType.Labor;
  o.preferredPotentialBidContractLineItem = maybeNewOrNull(
    "PotentialBidContractLineItem",
    options.preferredPotentialBidContractLineItem,
    cache,
  );
  o.itemTemplateItem = maybeNewOrNull("BaseItemLike", options.itemTemplateItem, cache);
  o.modifyingTemplateItems = (options.modifyingTemplateItems ?? []).map((i) =>
    maybeNew("BaseItemLike", i, cache, options.hasOwnProperty("modifyingTemplateItems"))
  );
  o.bidItem = maybeNewOrNull("BidItem", options.bidItem, cache);
  o.product = maybeNewOrNull("Product", options.product, cache);
  return o;
}

factories["ProtoProjectItem"] = newProtoProjectItem;

export interface ScopeGlobalOptionGroupsToReadyPlansResultOptions {
  __typename?: "ScopeGlobalOptionGroupsToReadyPlansResult";
  globalOptionGroups?: Array<GlobalOptionGroup | GlobalOptionGroupOptions>;
}

export function newScopeGlobalOptionGroupsToReadyPlansResult(
  options: ScopeGlobalOptionGroupsToReadyPlansResultOptions = {},
  cache: Record<string, any> = {},
): ScopeGlobalOptionGroupsToReadyPlansResult {
  const o =
    (options.__typename
      ? options
      : cache["ScopeGlobalOptionGroupsToReadyPlansResult"] = {}) as ScopeGlobalOptionGroupsToReadyPlansResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ScopeGlobalOptionGroupsToReadyPlansResult";
  o.globalOptionGroups = (options.globalOptionGroups ?? []).map((i) =>
    maybeNew("GlobalOptionGroup", i, cache, options.hasOwnProperty("globalOptionGroups"))
  );
  return o;
}

factories["ScopeGlobalOptionGroupsToReadyPlansResult"] = newScopeGlobalOptionGroupsToReadyPlansResult;

export interface ReadyPlanAggregateVersionOptions {
  __typename?: "ReadyPlanAggregateVersion";
  id?: ReadyPlanAggregateVersion["id"];
  version?: ReadyPlanAggregateVersion["version"];
  name?: ReadyPlanAggregateVersion["name"];
  displayName?: ReadyPlanAggregateVersion["displayName"];
  displayVersion?: ReadyPlanAggregateVersion["displayVersion"];
  createdAt?: ReadyPlanAggregateVersion["createdAt"];
  updatedAt?: ReadyPlanAggregateVersion["updatedAt"];
  status?: AggregateVersionStatusDetailOptions | AggregateVersionStatus;
  readyPlan?: ReadyPlan | PlanPackage | DesignPackage | ProductOffering | ReadyPlanLike | ReadyPlanLikeOptions;
  optionGroupVersions?: Array<ReadyPlanOptionGroupVersion | ReadyPlanOptionGroupVersionOptions>;
  optionVersions?: Array<ReadyPlanOptionVersion | ReadyPlanOptionVersionOptions>;
  finalReadyPlanOptionVersions?: Array<ReadyPlanOptionVersion | ReadyPlanOptionVersionOptions>;
  versions?: Array<ReadyPlanVersion | ReadyPlanVersionOptions>;
  removedTliVersions?: Array<TakeoffLineItemVersion | TakeoffLineItemVersionOptions>;
  tliVersions?: Array<TakeoffLineItemVersion | TakeoffLineItemVersionOptions>;
  versionNotes?: ReadyPlanAggregateVersion["versionNotes"];
  designPackagePlanUpdates?: Array<DesignPackagePlanUpdate | DesignPackagePlanUpdateOptions>;
  productOfferingIncomingUpdates?: Array<ProductOfferingIncomingUpdate | ProductOfferingIncomingUpdateOptions>;
  programDataVersions?: Array<ReadyPlanProgramDataVersion | ReadyPlanProgramDataVersionOptions>;
  removedProgramDataVersions?: Array<ReadyPlanProgramDataVersion | ReadyPlanProgramDataVersionOptions>;
  assetVersions?: Array<ReadyPlanAssetVersion | ReadyPlanAssetVersionOptions>;
  designPackageSourceVersions?: Array<DesignPackageSourceVersion | DesignPackageSourceVersionOptions>;
  tliVersionsCount?: ReadyPlanAggregateVersion["tliVersionsCount"];
  rplVersions?: Array<ReadyPlanLocationVersion | ReadyPlanLocationVersionOptions>;
  canDelete?: PotentialOperation2 | PotentialOperation2Options;
  canPublish?: PotentialOperation2 | PotentialOperation2Options;
  acceptedDesignPackageUpdates?: Array<DesignPackagePlanUpdate | DesignPackagePlanUpdateOptions>;
  outgoingDesignPackageUpdates?: Array<DesignPackagePlanUpdate | DesignPackagePlanUpdateOptions>;
  publishedAt?: ReadyPlanAggregateVersion["publishedAt"];
  finalReadyPlanRequiredOptionVersions?: Array<ReadyPlanRequiredOptionVersion | ReadyPlanRequiredOptionVersionOptions>;
  requiredOptionVersions?: Array<ReadyPlanRequiredOptionVersion | ReadyPlanRequiredOptionVersionOptions>;
  designNoteVersions?: Array<ReadyPlanDesignNoteVersion | ReadyPlanDesignNoteVersionOptions>;
  designPackageSources?: Array<DesignPackageSource | DesignPackageSourceOptions>;
  promotedAt?: ReadyPlanAggregateVersion["promotedAt"];
  promotedBy?: User | UserOptions | null;
  createdByPromotion?: ReadyPlanAggregateVersion["createdByPromotion"];
}

export function newReadyPlanAggregateVersion(
  options: ReadyPlanAggregateVersionOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanAggregateVersion {
  const o = (options.__typename ? options : cache["ReadyPlanAggregateVersion"] = {}) as ReadyPlanAggregateVersion;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanAggregateVersion";
  o.id = options.id ?? nextFactoryId("ReadyPlanAggregateVersion");
  o.version = options.version ?? null;
  o.name = options.name ?? "name";
  o.displayName = options.displayName ?? "displayName";
  o.displayVersion = options.displayVersion ?? "displayVersion";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.status = enumOrDetailOfAggregateVersionStatus(options.status);
  o.readyPlan = maybeNew("ReadyPlanLike", options.readyPlan, cache, options.hasOwnProperty("readyPlan"));
  o.optionGroupVersions = (options.optionGroupVersions ?? []).map((i) =>
    maybeNew("ReadyPlanOptionGroupVersion", i, cache, options.hasOwnProperty("optionGroupVersions"))
  );
  o.optionVersions = (options.optionVersions ?? []).map((i) =>
    maybeNew("ReadyPlanOptionVersion", i, cache, options.hasOwnProperty("optionVersions"))
  );
  o.finalReadyPlanOptionVersions = (options.finalReadyPlanOptionVersions ?? []).map((i) =>
    maybeNew("ReadyPlanOptionVersion", i, cache, options.hasOwnProperty("finalReadyPlanOptionVersions"))
  );
  o.versions = (options.versions ?? []).map((i) =>
    maybeNew("ReadyPlanVersion", i, cache, options.hasOwnProperty("versions"))
  );
  o.removedTliVersions = (options.removedTliVersions ?? []).map((i) =>
    maybeNew("TakeoffLineItemVersion", i, cache, options.hasOwnProperty("removedTliVersions"))
  );
  o.tliVersions = (options.tliVersions ?? []).map((i) =>
    maybeNew("TakeoffLineItemVersion", i, cache, options.hasOwnProperty("tliVersions"))
  );
  o.versionNotes = options.versionNotes ?? null;
  o.designPackagePlanUpdates = (options.designPackagePlanUpdates ?? []).map((i) =>
    maybeNew("DesignPackagePlanUpdate", i, cache, options.hasOwnProperty("designPackagePlanUpdates"))
  );
  o.productOfferingIncomingUpdates = (options.productOfferingIncomingUpdates ?? []).map((i) =>
    maybeNew("ProductOfferingIncomingUpdate", i, cache, options.hasOwnProperty("productOfferingIncomingUpdates"))
  );
  o.programDataVersions = (options.programDataVersions ?? []).map((i) =>
    maybeNew("ReadyPlanProgramDataVersion", i, cache, options.hasOwnProperty("programDataVersions"))
  );
  o.removedProgramDataVersions = (options.removedProgramDataVersions ?? []).map((i) =>
    maybeNew("ReadyPlanProgramDataVersion", i, cache, options.hasOwnProperty("removedProgramDataVersions"))
  );
  o.assetVersions = (options.assetVersions ?? []).map((i) =>
    maybeNew("ReadyPlanAssetVersion", i, cache, options.hasOwnProperty("assetVersions"))
  );
  o.designPackageSourceVersions = (options.designPackageSourceVersions ?? []).map((i) =>
    maybeNew("DesignPackageSourceVersion", i, cache, options.hasOwnProperty("designPackageSourceVersions"))
  );
  o.tliVersionsCount = options.tliVersionsCount ?? 0;
  o.rplVersions = (options.rplVersions ?? []).map((i) =>
    maybeNew("ReadyPlanLocationVersion", i, cache, options.hasOwnProperty("rplVersions"))
  );
  o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
  o.canPublish = maybeNew("PotentialOperation2", options.canPublish, cache, options.hasOwnProperty("canPublish"));
  o.acceptedDesignPackageUpdates = (options.acceptedDesignPackageUpdates ?? []).map((i) =>
    maybeNew("DesignPackagePlanUpdate", i, cache, options.hasOwnProperty("acceptedDesignPackageUpdates"))
  );
  o.outgoingDesignPackageUpdates = (options.outgoingDesignPackageUpdates ?? []).map((i) =>
    maybeNew("DesignPackagePlanUpdate", i, cache, options.hasOwnProperty("outgoingDesignPackageUpdates"))
  );
  o.publishedAt = options.publishedAt ?? null;
  o.finalReadyPlanRequiredOptionVersions = (options.finalReadyPlanRequiredOptionVersions ?? []).map((i) =>
    maybeNew("ReadyPlanRequiredOptionVersion", i, cache, options.hasOwnProperty("finalReadyPlanRequiredOptionVersions"))
  );
  o.requiredOptionVersions = (options.requiredOptionVersions ?? []).map((i) =>
    maybeNew("ReadyPlanRequiredOptionVersion", i, cache, options.hasOwnProperty("requiredOptionVersions"))
  );
  o.designNoteVersions = (options.designNoteVersions ?? []).map((i) =>
    maybeNew("ReadyPlanDesignNoteVersion", i, cache, options.hasOwnProperty("designNoteVersions"))
  );
  o.designPackageSources = (options.designPackageSources ?? []).map((i) =>
    maybeNew("DesignPackageSource", i, cache, options.hasOwnProperty("designPackageSources"))
  );
  o.promotedAt = options.promotedAt ?? null;
  o.promotedBy = maybeNewOrNull("User", options.promotedBy, cache);
  o.createdByPromotion = options.createdByPromotion ?? false;
  return o;
}

factories["ReadyPlanAggregateVersion"] = newReadyPlanAggregateVersion;

export interface SaveReadyPlanAggregateVersionResultOptions {
  __typename?: "SaveReadyPlanAggregateVersionResult";
  readyPlanAggregateVersion?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
}

export function newSaveReadyPlanAggregateVersionResult(
  options: SaveReadyPlanAggregateVersionResultOptions = {},
  cache: Record<string, any> = {},
): SaveReadyPlanAggregateVersionResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveReadyPlanAggregateVersionResult"] = {}) as SaveReadyPlanAggregateVersionResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveReadyPlanAggregateVersionResult";
  o.readyPlanAggregateVersion = maybeNew(
    "ReadyPlanAggregateVersion",
    options.readyPlanAggregateVersion,
    cache,
    options.hasOwnProperty("readyPlanAggregateVersion"),
  );
  return o;
}

factories["SaveReadyPlanAggregateVersionResult"] = newSaveReadyPlanAggregateVersionResult;

export interface DeleteReadyPlanAggregateVersionResultOptions {
  __typename?: "DeleteReadyPlanAggregateVersionResult";
  latestReadyPlanAggregateVersion?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
}

export function newDeleteReadyPlanAggregateVersionResult(
  options: DeleteReadyPlanAggregateVersionResultOptions = {},
  cache: Record<string, any> = {},
): DeleteReadyPlanAggregateVersionResult {
  const o =
    (options.__typename
      ? options
      : cache["DeleteReadyPlanAggregateVersionResult"] = {}) as DeleteReadyPlanAggregateVersionResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeleteReadyPlanAggregateVersionResult";
  o.latestReadyPlanAggregateVersion = maybeNewOrNull(
    "ReadyPlanAggregateVersion",
    options.latestReadyPlanAggregateVersion,
    cache,
  );
  return o;
}

factories["DeleteReadyPlanAggregateVersionResult"] = newDeleteReadyPlanAggregateVersionResult;

export interface ReadyPlanAggregateVersionsPageResultOptions {
  __typename?: "ReadyPlanAggregateVersionsPageResult";
  entities?: Array<ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newReadyPlanAggregateVersionsPageResult(
  options: ReadyPlanAggregateVersionsPageResultOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanAggregateVersionsPageResult {
  const o =
    (options.__typename
      ? options
      : cache["ReadyPlanAggregateVersionsPageResult"] = {}) as ReadyPlanAggregateVersionsPageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanAggregateVersionsPageResult";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("ReadyPlanAggregateVersion", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["ReadyPlanAggregateVersionsPageResult"] = newReadyPlanAggregateVersionsPageResult;

export interface ReadyPlanAssetOptions {
  __typename?: "ReadyPlanAsset";
  id?: ReadyPlanAsset["id"];
  createdAt?: ReadyPlanAsset["createdAt"];
  updatedAt?: ReadyPlanAsset["updatedAt"];
  type?: ReadyPlanAssetTypeDetailOptions | ReadyPlanAssetType;
  asset?: Asset | AssetOptions;
  parent?:
    | ReadyPlanAssetParent
    | ReadyPlanOptions
    | RequireTypename<ReadyPlanLocationOptions>
    | RequireTypename<ReadyPlanOptionOptions>
    | RequireTypename<PlanPackageOptions>
    | RequireTypename<DesignPackageOptions>
    | RequireTypename<ProductOfferingOptions>
    | null;
  isCoverPhoto?: ReadyPlanAsset["isCoverPhoto"];
  versions?: Array<ReadyPlanAssetVersion | ReadyPlanAssetVersionOptions>;
  active?: ReadyPlanAsset["active"];
  options?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
}

export function newReadyPlanAsset(
  options: ReadyPlanAssetOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanAsset {
  const o = (options.__typename ? options : cache["ReadyPlanAsset"] = {}) as ReadyPlanAsset;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanAsset";
  o.id = options.id ?? nextFactoryId("ReadyPlanAsset");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.type = enumOrDetailOfReadyPlanAssetType(options.type);
  o.asset = maybeNew("Asset", options.asset, cache, options.hasOwnProperty("asset"));
  o.parent = maybeNewOrNull(options.parent?.__typename ?? "ReadyPlan", options.parent, cache);
  o.isCoverPhoto = options.isCoverPhoto ?? false;
  o.versions = (options.versions ?? []).map((i) =>
    maybeNew("ReadyPlanAssetVersion", i, cache, options.hasOwnProperty("versions"))
  );
  o.active = options.active ?? false;
  o.options = (options.options ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("options"))
  );
  return o;
}

factories["ReadyPlanAsset"] = newReadyPlanAsset;

export interface ReadyPlanAssetVersionOptions {
  __typename?: "ReadyPlanAssetVersion";
  id?: ReadyPlanAssetVersion["id"];
  active?: ReadyPlanAssetVersion["active"];
  createdAt?: ReadyPlanAssetVersion["createdAt"];
  updatedAt?: ReadyPlanAssetVersion["updatedAt"];
  final?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  first?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  identity?: ReadyPlanAsset | ReadyPlanAssetOptions;
  asset?: Asset | AssetOptions;
}

export function newReadyPlanAssetVersion(
  options: ReadyPlanAssetVersionOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanAssetVersion {
  const o = (options.__typename ? options : cache["ReadyPlanAssetVersion"] = {}) as ReadyPlanAssetVersion;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanAssetVersion";
  o.id = options.id ?? nextFactoryId("ReadyPlanAssetVersion");
  o.active = options.active ?? false;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.final = maybeNewOrNull("ReadyPlanAggregateVersion", options.final, cache);
  o.first = maybeNew("ReadyPlanAggregateVersion", options.first, cache, options.hasOwnProperty("first"));
  o.identity = maybeNew("ReadyPlanAsset", options.identity, cache, options.hasOwnProperty("identity"));
  o.asset = maybeNew("Asset", options.asset, cache, options.hasOwnProperty("asset"));
  return o;
}

factories["ReadyPlanAssetVersion"] = newReadyPlanAssetVersion;

export interface ReadyPlanDesignNoteOptions {
  __typename?: "ReadyPlanDesignNote";
  id?: ReadyPlanDesignNote["id"];
  active?: ReadyPlanDesignNote["active"];
  content?: ReadyPlanDesignNote["content"];
  createdAt?: ReadyPlanDesignNote["createdAt"];
  updatedAt?: ReadyPlanDesignNote["updatedAt"];
  readyPlan?: ReadyPlan | PlanPackage | DesignPackage | ProductOffering | ReadyPlanLike | ReadyPlanLikeOptions;
  takeoffLineItem?: TakeoffLineItem | TakeoffLineItemOptions;
  targetGroups?: Array<ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions>;
  targetCombinations?: Array<DesignPackageOptionCombination | DesignPackageOptionCombinationOptions>;
}

export function newReadyPlanDesignNote(
  options: ReadyPlanDesignNoteOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanDesignNote {
  const o = (options.__typename ? options : cache["ReadyPlanDesignNote"] = {}) as ReadyPlanDesignNote;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanDesignNote";
  o.id = options.id ?? nextFactoryId("ReadyPlanDesignNote");
  o.active = options.active ?? false;
  o.content = options.content ?? "content";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.readyPlan = maybeNew("ReadyPlanLike", options.readyPlan, cache, options.hasOwnProperty("readyPlan"));
  o.takeoffLineItem = maybeNew(
    "TakeoffLineItem",
    options.takeoffLineItem,
    cache,
    options.hasOwnProperty("takeoffLineItem"),
  );
  o.targetGroups = (options.targetGroups ?? []).map((i) =>
    maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("targetGroups"))
  );
  o.targetCombinations = (options.targetCombinations ?? []).map((i) =>
    maybeNew("DesignPackageOptionCombination", i, cache, options.hasOwnProperty("targetCombinations"))
  );
  return o;
}

factories["ReadyPlanDesignNote"] = newReadyPlanDesignNote;

export interface SaveReadyPlanDesignNoteResultOptions {
  __typename?: "SaveReadyPlanDesignNoteResult";
  readyPlanDesignNote?: ReadyPlanDesignNote | ReadyPlanDesignNoteOptions;
}

export function newSaveReadyPlanDesignNoteResult(
  options: SaveReadyPlanDesignNoteResultOptions = {},
  cache: Record<string, any> = {},
): SaveReadyPlanDesignNoteResult {
  const o =
    (options.__typename ? options : cache["SaveReadyPlanDesignNoteResult"] = {}) as SaveReadyPlanDesignNoteResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveReadyPlanDesignNoteResult";
  o.readyPlanDesignNote = maybeNew(
    "ReadyPlanDesignNote",
    options.readyPlanDesignNote,
    cache,
    options.hasOwnProperty("readyPlanDesignNote"),
  );
  return o;
}

factories["SaveReadyPlanDesignNoteResult"] = newSaveReadyPlanDesignNoteResult;

export interface ReadyPlanDesignNoteVersionOptions {
  __typename?: "ReadyPlanDesignNoteVersion";
  id?: ReadyPlanDesignNoteVersion["id"];
  active?: ReadyPlanDesignNoteVersion["active"];
  content?: ReadyPlanDesignNoteVersion["content"];
  createdAt?: ReadyPlanDesignNoteVersion["createdAt"];
  updatedAt?: ReadyPlanDesignNoteVersion["updatedAt"];
  final?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  first?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  identity?: ReadyPlanDesignNote | ReadyPlanDesignNoteOptions;
  targetGroups?: Array<ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions>;
  targetCombinations?: Array<DesignPackageOptionCombination | DesignPackageOptionCombinationOptions>;
}

export function newReadyPlanDesignNoteVersion(
  options: ReadyPlanDesignNoteVersionOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanDesignNoteVersion {
  const o = (options.__typename ? options : cache["ReadyPlanDesignNoteVersion"] = {}) as ReadyPlanDesignNoteVersion;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanDesignNoteVersion";
  o.id = options.id ?? nextFactoryId("ReadyPlanDesignNoteVersion");
  o.active = options.active ?? false;
  o.content = options.content ?? "content";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.final = maybeNewOrNull("ReadyPlanAggregateVersion", options.final, cache);
  o.first = maybeNew("ReadyPlanAggregateVersion", options.first, cache, options.hasOwnProperty("first"));
  o.identity = maybeNew("ReadyPlanDesignNote", options.identity, cache, options.hasOwnProperty("identity"));
  o.targetGroups = (options.targetGroups ?? []).map((i) =>
    maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("targetGroups"))
  );
  o.targetCombinations = (options.targetCombinations ?? []).map((i) =>
    maybeNew("DesignPackageOptionCombination", i, cache, options.hasOwnProperty("targetCombinations"))
  );
  return o;
}

factories["ReadyPlanDesignNoteVersion"] = newReadyPlanDesignNoteVersion;

export interface ReadyPlanDesignPackageOptions {
  __typename?: "ReadyPlanDesignPackage";
  id?: ReadyPlanDesignPackage["id"];
  active?: ReadyPlanDesignPackage["active"];
  name?: ReadyPlanDesignPackage["name"];
  createdAt?: ReadyPlanDesignPackage["createdAt"];
  updatedAt?: ReadyPlanDesignPackage["updatedAt"];
  readyPlan?: ReadyPlan | PlanPackage | DesignPackage | ProductOffering | ReadyPlanLike | ReadyPlanLikeOptions;
  options?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  optionDefaultsIfChildren?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  optionVersionDefaultsIfChildren?: Array<ReadyPlanOptionVersion | ReadyPlanOptionVersionOptions>;
}

export function newReadyPlanDesignPackage(
  options: ReadyPlanDesignPackageOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanDesignPackage {
  const o = (options.__typename ? options : cache["ReadyPlanDesignPackage"] = {}) as ReadyPlanDesignPackage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanDesignPackage";
  o.id = options.id ?? nextFactoryId("ReadyPlanDesignPackage");
  o.active = options.active ?? false;
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.readyPlan = maybeNew("ReadyPlanLike", options.readyPlan, cache, options.hasOwnProperty("readyPlan"));
  o.options = (options.options ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("options"))
  );
  o.optionDefaultsIfChildren = (options.optionDefaultsIfChildren ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("optionDefaultsIfChildren"))
  );
  o.optionVersionDefaultsIfChildren = (options.optionVersionDefaultsIfChildren ?? []).map((i) =>
    maybeNew("ReadyPlanOptionVersion", i, cache, options.hasOwnProperty("optionVersionDefaultsIfChildren"))
  );
  return o;
}

factories["ReadyPlanDesignPackage"] = newReadyPlanDesignPackage;

export interface ReadyPlanDesignPackageVersionOptions {
  __typename?: "ReadyPlanDesignPackageVersion";
  id?: ReadyPlanDesignPackageVersion["id"];
  active?: ReadyPlanDesignPackageVersion["active"];
  createdAt?: ReadyPlanDesignPackageVersion["createdAt"];
  updatedAt?: ReadyPlanDesignPackageVersion["updatedAt"];
  final?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  first?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  identity?: ReadyPlanDesignPackage | ReadyPlanDesignPackageOptions;
}

export function newReadyPlanDesignPackageVersion(
  options: ReadyPlanDesignPackageVersionOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanDesignPackageVersion {
  const o =
    (options.__typename ? options : cache["ReadyPlanDesignPackageVersion"] = {}) as ReadyPlanDesignPackageVersion;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanDesignPackageVersion";
  o.id = options.id ?? nextFactoryId("ReadyPlanDesignPackageVersion");
  o.active = options.active ?? false;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.final = maybeNewOrNull("ReadyPlanAggregateVersion", options.final, cache);
  o.first = maybeNew("ReadyPlanAggregateVersion", options.first, cache, options.hasOwnProperty("first"));
  o.identity = maybeNew("ReadyPlanDesignPackage", options.identity, cache, options.hasOwnProperty("identity"));
  return o;
}

factories["ReadyPlanDesignPackageVersion"] = newReadyPlanDesignPackageVersion;

export interface ReadyPlanDocumentVersionOptions {
  __typename?: "ReadyPlanDocumentVersion";
  id?: ReadyPlanDocumentVersion["id"];
  asset?: Asset | AssetOptions;
  identity?: Document | DocumentOptions;
  final?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  first?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  active?: ReadyPlanDocumentVersion["active"];
  name?: ReadyPlanDocumentVersion["name"];
  uploaded?: ReadyPlanDocumentVersion["uploaded"];
  sizeInBytes?: ReadyPlanDocumentVersion["sizeInBytes"];
  documentType?: DocumentTypeDetailOptions | DocumentType;
  category?: DocumentCategoryDetailOptions | DocumentCategory;
}

export function newReadyPlanDocumentVersion(
  options: ReadyPlanDocumentVersionOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanDocumentVersion {
  const o = (options.__typename ? options : cache["ReadyPlanDocumentVersion"] = {}) as ReadyPlanDocumentVersion;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanDocumentVersion";
  o.id = options.id ?? nextFactoryId("ReadyPlanDocumentVersion");
  o.asset = maybeNew("Asset", options.asset, cache, options.hasOwnProperty("asset"));
  o.identity = maybeNew("Document", options.identity, cache, options.hasOwnProperty("identity"));
  o.final = maybeNewOrNull("ReadyPlanAggregateVersion", options.final, cache);
  o.first = maybeNew("ReadyPlanAggregateVersion", options.first, cache, options.hasOwnProperty("first"));
  o.active = options.active ?? false;
  o.name = options.name ?? "name";
  o.uploaded = options.uploaded ?? false;
  o.sizeInBytes = options.sizeInBytes ?? 0;
  o.documentType = enumOrDetailOfDocumentType(options.documentType);
  o.category = enumOrDetailOfDocumentCategory(options.category);
  return o;
}

factories["ReadyPlanDocumentVersion"] = newReadyPlanDocumentVersion;

export interface ReadyPlanLocationOptions {
  __typename?: "ReadyPlanLocation";
  id?: ReadyPlanLocation["id"];
  createdAt?: ReadyPlanLocation["createdAt"];
  updatedAt?: ReadyPlanLocation["updatedAt"];
  location?: Location | LocationOptions;
  readyPlan?: ReadyPlan | ReadyPlanOptions;
  roomNumber?: ReadyPlanLocation["roomNumber"];
  fullRoomNumber?: ReadyPlanLocation["fullRoomNumber"];
  level?: Location | LocationOptions | null;
  roomType?: RoomType | RoomTypeOptions | null;
  versions?: Array<ReadyPlanLocationVersion | ReadyPlanLocationVersionOptions>;
  active?: ReadyPlanLocation["active"];
  relatedTakeoffLineItemsCount?: ReadyPlanLocation["relatedTakeoffLineItemsCount"];
  readyPlanAssets?: Array<ReadyPlanAsset | ReadyPlanAssetOptions>;
  readyPlanOptions?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  designPackageLocations?: Array<ReadyPlanLocation | ReadyPlanLocationOptions>;
  planLocations?: Array<ReadyPlanLocation | ReadyPlanLocationOptions>;
  name?: ReadyPlanLocation["name"];
  isInsideMapsRoom?: ReadyPlanLocation["isInsideMapsRoom"];
  insideMapsRoomOrder?: ReadyPlanLocation["insideMapsRoomOrder"];
  canDelete?: PotentialOperation2 | PotentialOperation2Options;
  marketingName?: ReadyPlanLocation["marketingName"];
}

export function newReadyPlanLocation(
  options: ReadyPlanLocationOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanLocation {
  const o = (options.__typename ? options : cache["ReadyPlanLocation"] = {}) as ReadyPlanLocation;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanLocation";
  o.id = options.id ?? nextFactoryId("ReadyPlanLocation");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.location = maybeNew("Location", options.location, cache, options.hasOwnProperty("location"));
  o.readyPlan = maybeNew("ReadyPlan", options.readyPlan, cache, options.hasOwnProperty("readyPlan"));
  o.roomNumber = options.roomNumber ?? null;
  o.fullRoomNumber = options.fullRoomNumber ?? null;
  o.level = maybeNewOrNull("Location", options.level, cache);
  o.roomType = maybeNewOrNull("RoomType", options.roomType, cache);
  o.versions = (options.versions ?? []).map((i) =>
    maybeNew("ReadyPlanLocationVersion", i, cache, options.hasOwnProperty("versions"))
  );
  o.active = options.active ?? false;
  o.relatedTakeoffLineItemsCount = options.relatedTakeoffLineItemsCount ?? 0;
  o.readyPlanAssets = (options.readyPlanAssets ?? []).map((i) =>
    maybeNew("ReadyPlanAsset", i, cache, options.hasOwnProperty("readyPlanAssets"))
  );
  o.readyPlanOptions = (options.readyPlanOptions ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("readyPlanOptions"))
  );
  o.designPackageLocations = (options.designPackageLocations ?? []).map((i) =>
    maybeNew("ReadyPlanLocation", i, cache, options.hasOwnProperty("designPackageLocations"))
  );
  o.planLocations = (options.planLocations ?? []).map((i) =>
    maybeNew("ReadyPlanLocation", i, cache, options.hasOwnProperty("planLocations"))
  );
  o.name = options.name ?? "name";
  o.isInsideMapsRoom = options.isInsideMapsRoom ?? null;
  o.insideMapsRoomOrder = options.insideMapsRoomOrder ?? null;
  o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
  o.marketingName = options.marketingName ?? "marketingName";
  return o;
}

factories["ReadyPlanLocation"] = newReadyPlanLocation;

export interface SaveReadyPlanLocationBulkResultOptions {
  __typename?: "SaveReadyPlanLocationBulkResult";
  readyPlanLocations?: Array<ReadyPlanLocation | ReadyPlanLocationOptions>;
  affectedTlis?: Array<TakeoffLineItem | TakeoffLineItemOptions>;
}

export function newSaveReadyPlanLocationBulkResult(
  options: SaveReadyPlanLocationBulkResultOptions = {},
  cache: Record<string, any> = {},
): SaveReadyPlanLocationBulkResult {
  const o =
    (options.__typename ? options : cache["SaveReadyPlanLocationBulkResult"] = {}) as SaveReadyPlanLocationBulkResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveReadyPlanLocationBulkResult";
  o.readyPlanLocations = (options.readyPlanLocations ?? []).map((i) =>
    maybeNew("ReadyPlanLocation", i, cache, options.hasOwnProperty("readyPlanLocations"))
  );
  o.affectedTlis = (options.affectedTlis ?? []).map((i) =>
    maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("affectedTlis"))
  );
  return o;
}

factories["SaveReadyPlanLocationBulkResult"] = newSaveReadyPlanLocationBulkResult;

export interface SaveDesignPackageLocationPlanMappingsResultOptions {
  __typename?: "SaveDesignPackageLocationPlanMappingsResult";
  readyPlanLocations?: Array<ReadyPlanLocation | ReadyPlanLocationOptions>;
  affectedPlaceholders?: Array<TakeoffLineItem | TakeoffLineItemOptions>;
}

export function newSaveDesignPackageLocationPlanMappingsResult(
  options: SaveDesignPackageLocationPlanMappingsResultOptions = {},
  cache: Record<string, any> = {},
): SaveDesignPackageLocationPlanMappingsResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveDesignPackageLocationPlanMappingsResult"] = {}) as SaveDesignPackageLocationPlanMappingsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveDesignPackageLocationPlanMappingsResult";
  o.readyPlanLocations = (options.readyPlanLocations ?? []).map((i) =>
    maybeNew("ReadyPlanLocation", i, cache, options.hasOwnProperty("readyPlanLocations"))
  );
  o.affectedPlaceholders = (options.affectedPlaceholders ?? []).map((i) =>
    maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("affectedPlaceholders"))
  );
  return o;
}

factories["SaveDesignPackageLocationPlanMappingsResult"] = newSaveDesignPackageLocationPlanMappingsResult;

export interface CreateDesignPackageAlternateLocationResultOptions {
  __typename?: "CreateDesignPackageAlternateLocationResult";
  readyPlanLocation?: ReadyPlanLocation | ReadyPlanLocationOptions;
}

export function newCreateDesignPackageAlternateLocationResult(
  options: CreateDesignPackageAlternateLocationResultOptions = {},
  cache: Record<string, any> = {},
): CreateDesignPackageAlternateLocationResult {
  const o =
    (options.__typename
      ? options
      : cache["CreateDesignPackageAlternateLocationResult"] = {}) as CreateDesignPackageAlternateLocationResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CreateDesignPackageAlternateLocationResult";
  o.readyPlanLocation = maybeNew(
    "ReadyPlanLocation",
    options.readyPlanLocation,
    cache,
    options.hasOwnProperty("readyPlanLocation"),
  );
  return o;
}

factories["CreateDesignPackageAlternateLocationResult"] = newCreateDesignPackageAlternateLocationResult;

export interface ReadyPlanLocationVersionOptions {
  __typename?: "ReadyPlanLocationVersion";
  id?: ReadyPlanLocationVersion["id"];
  active?: ReadyPlanLocationVersion["active"];
  createdAt?: ReadyPlanLocationVersion["createdAt"];
  updatedAt?: ReadyPlanLocationVersion["updatedAt"];
  final?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  first?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  identity?: ReadyPlanLocation | ReadyPlanLocationOptions;
  roomNumber?: ReadyPlanLocationVersion["roomNumber"];
  location?: Location | LocationOptions;
  changeType?: ReadyPlanLocationVersion["changeType"];
  previous?: ReadyPlanLocationVersion | ReadyPlanLocationVersionOptions | null;
  fullRoomNumber?: ReadyPlanLocationVersion["fullRoomNumber"];
  planLocations?: Array<ReadyPlanLocation | ReadyPlanLocationOptions>;
}

export function newReadyPlanLocationVersion(
  options: ReadyPlanLocationVersionOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanLocationVersion {
  const o = (options.__typename ? options : cache["ReadyPlanLocationVersion"] = {}) as ReadyPlanLocationVersion;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanLocationVersion";
  o.id = options.id ?? nextFactoryId("ReadyPlanLocationVersion");
  o.active = options.active ?? false;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.final = maybeNewOrNull("ReadyPlanAggregateVersion", options.final, cache);
  o.first = maybeNew("ReadyPlanAggregateVersion", options.first, cache, options.hasOwnProperty("first"));
  o.identity = maybeNew("ReadyPlanLocation", options.identity, cache, options.hasOwnProperty("identity"));
  o.roomNumber = options.roomNumber ?? null;
  o.location = maybeNew("Location", options.location, cache, options.hasOwnProperty("location"));
  o.changeType = options.changeType ?? "changeType";
  o.previous = maybeNewOrNull("ReadyPlanLocationVersion", options.previous, cache);
  o.fullRoomNumber = options.fullRoomNumber ?? null;
  o.planLocations = (options.planLocations ?? []).map((i) =>
    maybeNew("ReadyPlanLocation", i, cache, options.hasOwnProperty("planLocations"))
  );
  return o;
}

factories["ReadyPlanLocationVersion"] = newReadyPlanLocationVersion;

export interface ReadyPlanOptionOptions {
  __typename?: "ReadyPlanOption";
  id?: ReadyPlanOption["id"];
  code?: ReadyPlanOption["code"];
  name?: ReadyPlanOption["name"];
  displayName?: ReadyPlanOption["displayName"];
  homeownerChoice?: ReadyPlanOption["homeownerChoice"];
  createdAt?: ReadyPlanOption["createdAt"];
  updatedAt?: ReadyPlanOption["updatedAt"];
  isChildOption?: ReadyPlanOption["isChildOption"];
  parentOption?: ReadyPlanOption | ReadyPlanOptionOptions | null;
  isParentOption?: ReadyPlanOption["isParentOption"];
  childOptions?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  globalOption?: GlobalOption | GlobalOptionOptions;
  type?: GlobalOptionType | GlobalOptionTypeOptions;
  readyPlan?: ReadyPlan | ReadyPlanOptions;
  readyPlanLocation?: ReadyPlanLocation | ReadyPlanLocationOptions | null;
  location?: Location | LocationOptions | null;
  description?: ReadyPlanOption["description"];
  active?: ReadyPlanOption["active"];
  shortName?: ReadyPlanOption["shortName"];
  maybeShortName?: ReadyPlanOption["maybeShortName"];
  programData?: ProgramData | ProgramDataOptions;
  optionGroup?: ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions;
  userEvents?: Array<UserEvent | UserEventOptions>;
  blueprintUrl?: Url | UrlOptions;
  programDataModifiedBy?: Array<ReadyPlanOptionProgramDataModification | ReadyPlanOptionProgramDataModificationOptions>;
  modifiesProgramDataFor?: Array<
    ReadyPlanOptionProgramDataModification | ReadyPlanOptionProgramDataModificationOptions
  >;
  optionPrereqChildren?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  optionPrerequisites?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  optionConflictChildren?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  optionConflicts?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  optionDefaultChildren?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  optionDefaultsIf?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  optionRequiredIf?: Array<ReadyPlanRequiredOption | ReadyPlanRequiredOptionOptions>;
  personalizationTargetCombinations?: Array<DesignPackageOptionCombination | DesignPackageOptionCombinationOptions>;
  order?: ReadyPlanOption["order"];
  programDatas?: Array<ReadyPlanProgramData | ReadyPlanProgramDataOptions>;
  assets?: Array<ReadyPlanAsset | ReadyPlanAssetOptions>;
  bidOutPercentage?: ReadyPlanOption["bidOutPercentage"];
  latestVersion?: ReadyPlanOptionVersion | ReadyPlanOptionVersionOptions | null;
  draftVersion?: ReadyPlanOptionVersion | ReadyPlanOptionVersionOptions | null;
  publishToUnderwriting?: ReadyPlanOption["publishToUnderwriting"];
  optionImages?: Array<Asset | AssetOptions>;
  optionImage?: Asset | AssetOptions | null;
  materialVariant?: MaterialVariant | MaterialVariantOptions | null;
  materialVariants?: Array<MaterialVariant | MaterialVariantOptions>;
  preCutoffDesiredMarginInBasisPoints?: ReadyPlanOption["preCutoffDesiredMarginInBasisPoints"];
  postCutoffDesiredMarginInBasisPoints?: ReadyPlanOption["postCutoffDesiredMarginInBasisPoints"];
  selectionFeeInCents?: ReadyPlanOption["selectionFeeInCents"];
  minimumPriceInCents?: ReadyPlanOption["minimumPriceInCents"];
  showInCheckout?: ReadyPlanOption["showInCheckout"];
  canDelete?: PotentialOperation2 | PotentialOperation2Options;
  packageOptionMaterial?: MaterialVariant | MaterialVariantOptions | null;
  isNewFromUpstream?: ReadyPlanOption["isNewFromUpstream"];
  isUpstreamInactive?: ReadyPlanOption["isUpstreamInactive"];
  checkoutOrder?: ReadyPlanOption["checkoutOrder"];
}

export function newReadyPlanOption(
  options: ReadyPlanOptionOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanOption {
  const o = (options.__typename ? options : cache["ReadyPlanOption"] = {}) as ReadyPlanOption;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanOption";
  o.id = options.id ?? nextFactoryId("ReadyPlanOption");
  o.code = options.code ?? "code";
  o.name = options.name ?? "name";
  o.displayName = options.displayName ?? "displayName";
  o.homeownerChoice = options.homeownerChoice ?? false;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.isChildOption = options.isChildOption ?? false;
  o.parentOption = maybeNewOrNull("ReadyPlanOption", options.parentOption, cache);
  o.isParentOption = options.isParentOption ?? false;
  o.childOptions = (options.childOptions ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("childOptions"))
  );
  o.globalOption = maybeNew("GlobalOption", options.globalOption, cache, options.hasOwnProperty("globalOption"));
  o.type = maybeNew("GlobalOptionType", options.type, cache, options.hasOwnProperty("type"));
  o.readyPlan = maybeNew("ReadyPlan", options.readyPlan, cache, options.hasOwnProperty("readyPlan"));
  o.readyPlanLocation = maybeNewOrNull("ReadyPlanLocation", options.readyPlanLocation, cache);
  o.location = maybeNewOrNull("Location", options.location, cache);
  o.description = options.description ?? null;
  o.active = options.active ?? false;
  o.shortName = options.shortName ?? null;
  o.maybeShortName = options.maybeShortName ?? "maybeShortName";
  o.programData = maybeNew("ProgramData", options.programData, cache, options.hasOwnProperty("programData"));
  o.optionGroup = maybeNew("ReadyPlanOptionGroup", options.optionGroup, cache, options.hasOwnProperty("optionGroup"));
  o.userEvents = (options.userEvents ?? []).map((i) =>
    maybeNew("UserEvent", i, cache, options.hasOwnProperty("userEvents"))
  );
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.programDataModifiedBy = (options.programDataModifiedBy ?? []).map((i) =>
    maybeNew("ReadyPlanOptionProgramDataModification", i, cache, options.hasOwnProperty("programDataModifiedBy"))
  );
  o.modifiesProgramDataFor = (options.modifiesProgramDataFor ?? []).map((i) =>
    maybeNew("ReadyPlanOptionProgramDataModification", i, cache, options.hasOwnProperty("modifiesProgramDataFor"))
  );
  o.optionPrereqChildren = (options.optionPrereqChildren ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("optionPrereqChildren"))
  );
  o.optionPrerequisites = (options.optionPrerequisites ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("optionPrerequisites"))
  );
  o.optionConflictChildren = (options.optionConflictChildren ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("optionConflictChildren"))
  );
  o.optionConflicts = (options.optionConflicts ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("optionConflicts"))
  );
  o.optionDefaultChildren = (options.optionDefaultChildren ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("optionDefaultChildren"))
  );
  o.optionDefaultsIf = (options.optionDefaultsIf ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("optionDefaultsIf"))
  );
  o.optionRequiredIf = (options.optionRequiredIf ?? []).map((i) =>
    maybeNew("ReadyPlanRequiredOption", i, cache, options.hasOwnProperty("optionRequiredIf"))
  );
  o.personalizationTargetCombinations = (options.personalizationTargetCombinations ?? []).map((i) =>
    maybeNew("DesignPackageOptionCombination", i, cache, options.hasOwnProperty("personalizationTargetCombinations"))
  );
  o.order = options.order ?? 0;
  o.programDatas = (options.programDatas ?? []).map((i) =>
    maybeNew("ReadyPlanProgramData", i, cache, options.hasOwnProperty("programDatas"))
  );
  o.assets = (options.assets ?? []).map((i) => maybeNew("ReadyPlanAsset", i, cache, options.hasOwnProperty("assets")));
  o.bidOutPercentage = options.bidOutPercentage ?? 0;
  o.latestVersion = maybeNewOrNull("ReadyPlanOptionVersion", options.latestVersion, cache);
  o.draftVersion = maybeNewOrNull("ReadyPlanOptionVersion", options.draftVersion, cache);
  o.publishToUnderwriting = options.publishToUnderwriting ?? false;
  o.optionImages = (options.optionImages ?? []).map((i) =>
    maybeNew("Asset", i, cache, options.hasOwnProperty("optionImages"))
  );
  o.optionImage = maybeNewOrNull("Asset", options.optionImage, cache);
  o.materialVariant = maybeNewOrNull("MaterialVariant", options.materialVariant, cache);
  o.materialVariants = (options.materialVariants ?? []).map((i) =>
    maybeNew("MaterialVariant", i, cache, options.hasOwnProperty("materialVariants"))
  );
  o.preCutoffDesiredMarginInBasisPoints = options.preCutoffDesiredMarginInBasisPoints ?? 0;
  o.postCutoffDesiredMarginInBasisPoints = options.postCutoffDesiredMarginInBasisPoints ?? null;
  o.selectionFeeInCents = options.selectionFeeInCents ?? null;
  o.minimumPriceInCents = options.minimumPriceInCents ?? 0;
  o.showInCheckout = options.showInCheckout ?? false;
  o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
  o.packageOptionMaterial = maybeNewOrNull("MaterialVariant", options.packageOptionMaterial, cache);
  o.isNewFromUpstream = options.isNewFromUpstream ?? false;
  o.isUpstreamInactive = options.isUpstreamInactive ?? false;
  o.checkoutOrder = options.checkoutOrder ?? null;
  return o;
}

factories["ReadyPlanOption"] = newReadyPlanOption;

export interface SaveReadyPlanOptionsResultOptions {
  __typename?: "SaveReadyPlanOptionsResult";
  readyPlanOptions?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
}

export function newSaveReadyPlanOptionsResult(
  options: SaveReadyPlanOptionsResultOptions = {},
  cache: Record<string, any> = {},
): SaveReadyPlanOptionsResult {
  const o = (options.__typename ? options : cache["SaveReadyPlanOptionsResult"] = {}) as SaveReadyPlanOptionsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveReadyPlanOptionsResult";
  o.readyPlanOptions = (options.readyPlanOptions ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("readyPlanOptions"))
  );
  return o;
}

factories["SaveReadyPlanOptionsResult"] = newSaveReadyPlanOptionsResult;

export interface MergeReadyPlanOptionsResultOptions {
  __typename?: "MergeReadyPlanOptionsResult";
  readyPlanOption?: ReadyPlanOption | ReadyPlanOptionOptions;
}

export function newMergeReadyPlanOptionsResult(
  options: MergeReadyPlanOptionsResultOptions = {},
  cache: Record<string, any> = {},
): MergeReadyPlanOptionsResult {
  const o = (options.__typename ? options : cache["MergeReadyPlanOptionsResult"] = {}) as MergeReadyPlanOptionsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MergeReadyPlanOptionsResult";
  o.readyPlanOption = maybeNew(
    "ReadyPlanOption",
    options.readyPlanOption,
    cache,
    options.hasOwnProperty("readyPlanOption"),
  );
  return o;
}

factories["MergeReadyPlanOptionsResult"] = newMergeReadyPlanOptionsResult;

export interface ReadyPlanOptionGroupOptions {
  __typename?: "ReadyPlanOptionGroup";
  id?: ReadyPlanOptionGroup["id"];
  name?: ReadyPlanOptionGroup["name"];
  marketingDescription?: ReadyPlanOptionGroup["marketingDescription"];
  required?: ReadyPlanOptionGroup["required"];
  order?: ReadyPlanOptionGroup["order"];
  active?: ReadyPlanOptionGroup["active"];
  createdAt?: ReadyPlanOptionGroup["createdAt"];
  updatedAt?: ReadyPlanOptionGroup["updatedAt"];
  group?: GlobalOptionGroup | GlobalOptionGroupOptions;
  location?: Location | LocationOptions | null;
  readyPlan?: ReadyPlan | ReadyPlanOptions;
  options?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  isSingleOptionGroup?: ReadyPlanOptionGroup["isSingleOptionGroup"];
  isMultiOptionGroup?: ReadyPlanOptionGroup["isMultiOptionGroup"];
  forDesignUpgrade?: ReadyPlanOptionGroup["forDesignUpgrade"];
  forDesignPackage?: ReadyPlanOptionGroup["forDesignPackage"];
  forDesignInterior?: ReadyPlanOptionGroup["forDesignInterior"];
  forDesignExterior?: ReadyPlanOptionGroup["forDesignExterior"];
  forDesignPackages?: ReadyPlanOptionGroup["forDesignPackages"];
  isPlanPackage?: ReadyPlanOptionGroup["isPlanPackage"];
  personalizationType?:
    | ReadyPlanOptionGroupPersonalizationTypeDetailOptions
    | ReadyPlanOptionGroupPersonalizationType
    | null;
  groupByFeature?: ReadyPlanOptionGroup["groupByFeature"];
  personalizationPlaceholders?: Array<TakeoffLineItem | TakeoffLineItemOptions>;
  personalizationMaterialVariants?: Array<MaterialVariant | MaterialVariantOptions>;
  groupPrerequisites?: Array<ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions>;
  groupPrereqChildren?: Array<ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions>;
  levels?: ReadyPlanOptionGroup["levels"];
  personalizationTargetGroups?: Array<ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions>;
  readyPlanLocation?: ReadyPlanLocation | ReadyPlanLocationOptions | null;
  displayPackageOptionsAsSingleProduct?: ReadyPlanOptionGroup["displayPackageOptionsAsSingleProduct"];
  checkoutOrder?: ReadyPlanOptionGroup["checkoutOrder"];
  step?: CheckoutConfigOptionGroupStepDetailOptions | CheckoutConfigOptionGroupStep | null;
  substepNumber?: ReadyPlanOptionGroup["substepNumber"];
  hasDynamicProducts?: ReadyPlanOptionGroup["hasDynamicProducts"];
  overrideStep?: CheckoutConfigOptionGroupStepDetailOptions | CheckoutConfigOptionGroupStep | null;
  overrideSubstepNumber?: ReadyPlanOptionGroup["overrideSubstepNumber"];
}

export function newReadyPlanOptionGroup(
  options: ReadyPlanOptionGroupOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanOptionGroup {
  const o = (options.__typename ? options : cache["ReadyPlanOptionGroup"] = {}) as ReadyPlanOptionGroup;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanOptionGroup";
  o.id = options.id ?? nextFactoryId("ReadyPlanOptionGroup");
  o.name = options.name ?? "name";
  o.marketingDescription = options.marketingDescription ?? null;
  o.required = options.required ?? false;
  o.order = options.order ?? 0;
  o.active = options.active ?? false;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.group = maybeNew("GlobalOptionGroup", options.group, cache, options.hasOwnProperty("group"));
  o.location = maybeNewOrNull("Location", options.location, cache);
  o.readyPlan = maybeNew("ReadyPlan", options.readyPlan, cache, options.hasOwnProperty("readyPlan"));
  o.options = (options.options ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("options"))
  );
  o.isSingleOptionGroup = options.isSingleOptionGroup ?? false;
  o.isMultiOptionGroup = options.isMultiOptionGroup ?? false;
  o.forDesignUpgrade = options.forDesignUpgrade ?? false;
  o.forDesignPackage = options.forDesignPackage ?? false;
  o.forDesignInterior = options.forDesignInterior ?? false;
  o.forDesignExterior = options.forDesignExterior ?? false;
  o.forDesignPackages = options.forDesignPackages ?? false;
  o.isPlanPackage = options.isPlanPackage ?? false;
  o.personalizationType = enumOrDetailOrNullOfReadyPlanOptionGroupPersonalizationType(options.personalizationType);
  o.groupByFeature = options.groupByFeature ?? false;
  o.personalizationPlaceholders = (options.personalizationPlaceholders ?? []).map((i) =>
    maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("personalizationPlaceholders"))
  );
  o.personalizationMaterialVariants = (options.personalizationMaterialVariants ?? []).map((i) =>
    maybeNew("MaterialVariant", i, cache, options.hasOwnProperty("personalizationMaterialVariants"))
  );
  o.groupPrerequisites = (options.groupPrerequisites ?? []).map((i) =>
    maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("groupPrerequisites"))
  );
  o.groupPrereqChildren = (options.groupPrereqChildren ?? []).map((i) =>
    maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("groupPrereqChildren"))
  );
  o.levels = options.levels ?? null;
  o.personalizationTargetGroups = (options.personalizationTargetGroups ?? []).map((i) =>
    maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("personalizationTargetGroups"))
  );
  o.readyPlanLocation = maybeNewOrNull("ReadyPlanLocation", options.readyPlanLocation, cache);
  o.displayPackageOptionsAsSingleProduct = options.displayPackageOptionsAsSingleProduct ?? null;
  o.checkoutOrder = options.checkoutOrder ?? null;
  o.step = enumOrDetailOrNullOfCheckoutConfigOptionGroupStep(options.step);
  o.substepNumber = options.substepNumber ?? null;
  o.hasDynamicProducts = options.hasDynamicProducts ?? false;
  o.overrideStep = enumOrDetailOrNullOfCheckoutConfigOptionGroupStep(options.overrideStep);
  o.overrideSubstepNumber = options.overrideSubstepNumber ?? null;
  return o;
}

factories["ReadyPlanOptionGroup"] = newReadyPlanOptionGroup;

export interface SaveReadyPlanOptionGroupResultOptions {
  __typename?: "SaveReadyPlanOptionGroupResult";
  optionGroup?: ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions;
}

export function newSaveReadyPlanOptionGroupResult(
  options: SaveReadyPlanOptionGroupResultOptions = {},
  cache: Record<string, any> = {},
): SaveReadyPlanOptionGroupResult {
  const o =
    (options.__typename ? options : cache["SaveReadyPlanOptionGroupResult"] = {}) as SaveReadyPlanOptionGroupResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveReadyPlanOptionGroupResult";
  o.optionGroup = maybeNew("ReadyPlanOptionGroup", options.optionGroup, cache, options.hasOwnProperty("optionGroup"));
  return o;
}

factories["SaveReadyPlanOptionGroupResult"] = newSaveReadyPlanOptionGroupResult;

export interface SaveReadyPlanOptionGroupsResultOptions {
  __typename?: "SaveReadyPlanOptionGroupsResult";
  entities?: Array<ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions>;
}

export function newSaveReadyPlanOptionGroupsResult(
  options: SaveReadyPlanOptionGroupsResultOptions = {},
  cache: Record<string, any> = {},
): SaveReadyPlanOptionGroupsResult {
  const o =
    (options.__typename ? options : cache["SaveReadyPlanOptionGroupsResult"] = {}) as SaveReadyPlanOptionGroupsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveReadyPlanOptionGroupsResult";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("entities"))
  );
  return o;
}

factories["SaveReadyPlanOptionGroupsResult"] = newSaveReadyPlanOptionGroupsResult;

export interface ReadyPlanOptionGroupVersionOptions {
  __typename?: "ReadyPlanOptionGroupVersion";
  id?: ReadyPlanOptionGroupVersion["id"];
  identity?: ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions;
  first?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  final?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  required?: ReadyPlanOptionGroupVersion["required"];
  order?: ReadyPlanOptionGroupVersion["order"];
  active?: ReadyPlanOptionGroupVersion["active"];
  name?: ReadyPlanOptionGroupVersion["name"];
  marketingDescription?: ReadyPlanOptionGroupVersion["marketingDescription"];
  levels?: ReadyPlanOptionGroupVersion["levels"];
  personalizationTargetGroups?: Array<ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions>;
  location?: Location | LocationOptions | null;
  readyPlanLocation?: ReadyPlanLocation | ReadyPlanLocationOptions | null;
  displayPackageOptionsAsSingleProduct?: ReadyPlanOptionGroupVersion["displayPackageOptionsAsSingleProduct"];
  substepNumber?: ReadyPlanOptionGroupVersion["substepNumber"];
  step?: CheckoutConfigOptionGroupStepDetailOptions | CheckoutConfigOptionGroupStep | null;
  overrideStep?: CheckoutConfigOptionGroupStepDetailOptions | CheckoutConfigOptionGroupStep | null;
  overrideSubstepNumber?: ReadyPlanOptionGroupVersion["overrideSubstepNumber"];
}

export function newReadyPlanOptionGroupVersion(
  options: ReadyPlanOptionGroupVersionOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanOptionGroupVersion {
  const o = (options.__typename ? options : cache["ReadyPlanOptionGroupVersion"] = {}) as ReadyPlanOptionGroupVersion;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanOptionGroupVersion";
  o.id = options.id ?? nextFactoryId("ReadyPlanOptionGroupVersion");
  o.identity = maybeNew("ReadyPlanOptionGroup", options.identity, cache, options.hasOwnProperty("identity"));
  o.first = maybeNew("ReadyPlanAggregateVersion", options.first, cache, options.hasOwnProperty("first"));
  o.final = maybeNewOrNull("ReadyPlanAggregateVersion", options.final, cache);
  o.required = options.required ?? false;
  o.order = options.order ?? 0;
  o.active = options.active ?? false;
  o.name = options.name ?? "name";
  o.marketingDescription = options.marketingDescription ?? null;
  o.levels = options.levels ?? null;
  o.personalizationTargetGroups = (options.personalizationTargetGroups ?? []).map((i) =>
    maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("personalizationTargetGroups"))
  );
  o.location = maybeNewOrNull("Location", options.location, cache);
  o.readyPlanLocation = maybeNewOrNull("ReadyPlanLocation", options.readyPlanLocation, cache);
  o.displayPackageOptionsAsSingleProduct = options.displayPackageOptionsAsSingleProduct ?? null;
  o.substepNumber = options.substepNumber ?? null;
  o.step = enumOrDetailOrNullOfCheckoutConfigOptionGroupStep(options.step);
  o.overrideStep = enumOrDetailOrNullOfCheckoutConfigOptionGroupStep(options.overrideStep);
  o.overrideSubstepNumber = options.overrideSubstepNumber ?? null;
  return o;
}

factories["ReadyPlanOptionGroupVersion"] = newReadyPlanOptionGroupVersion;

export interface ReadyPlanOptionProgramDataModificationOptions {
  __typename?: "ReadyPlanOptionProgramDataModification";
  id?: ReadyPlanOptionProgramDataModification["id"];
  createdAt?: ReadyPlanOptionProgramDataModification["createdAt"];
  updatedAt?: ReadyPlanOptionProgramDataModification["updatedAt"];
  programData?: ProgramData | ProgramDataOptions;
  modifiedOption?: ReadyPlanOption | ReadyPlanOptionOptions;
  matchesOption?: ReadyPlanOption | ReadyPlanOptionOptions;
  userEvents?: Array<UserEvent | UserEventOptions>;
  name?: ReadyPlanOptionProgramDataModification["name"];
}

export function newReadyPlanOptionProgramDataModification(
  options: ReadyPlanOptionProgramDataModificationOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanOptionProgramDataModification {
  const o =
    (options.__typename
      ? options
      : cache["ReadyPlanOptionProgramDataModification"] = {}) as ReadyPlanOptionProgramDataModification;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanOptionProgramDataModification";
  o.id = options.id ?? nextFactoryId("ReadyPlanOptionProgramDataModification");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.programData = maybeNew("ProgramData", options.programData, cache, options.hasOwnProperty("programData"));
  o.modifiedOption = maybeNew(
    "ReadyPlanOption",
    options.modifiedOption,
    cache,
    options.hasOwnProperty("modifiedOption"),
  );
  o.matchesOption = maybeNew("ReadyPlanOption", options.matchesOption, cache, options.hasOwnProperty("matchesOption"));
  o.userEvents = (options.userEvents ?? []).map((i) =>
    maybeNew("UserEvent", i, cache, options.hasOwnProperty("userEvents"))
  );
  o.name = options.name ?? "name";
  return o;
}

factories["ReadyPlanOptionProgramDataModification"] = newReadyPlanOptionProgramDataModification;

export interface SaveReadyPlanOptionProgramDataModificationsResultOptions {
  __typename?: "SaveReadyPlanOptionProgramDataModificationsResult";
  entities?: Array<ReadyPlanOptionProgramDataModification | ReadyPlanOptionProgramDataModificationOptions>;
}

export function newSaveReadyPlanOptionProgramDataModificationsResult(
  options: SaveReadyPlanOptionProgramDataModificationsResultOptions = {},
  cache: Record<string, any> = {},
): SaveReadyPlanOptionProgramDataModificationsResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveReadyPlanOptionProgramDataModificationsResult"] =
        {}) as SaveReadyPlanOptionProgramDataModificationsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveReadyPlanOptionProgramDataModificationsResult";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("ReadyPlanOptionProgramDataModification", i, cache, options.hasOwnProperty("entities"))
  );
  return o;
}

factories["SaveReadyPlanOptionProgramDataModificationsResult"] = newSaveReadyPlanOptionProgramDataModificationsResult;

export interface DeleteReadyPlanOptionProgramDataModificationsResultOptions {
  __typename?: "DeleteReadyPlanOptionProgramDataModificationsResult";
  id?: DeleteReadyPlanOptionProgramDataModificationsResult["id"];
  modifiedOptionId?: DeleteReadyPlanOptionProgramDataModificationsResult["modifiedOptionId"];
}

export function newDeleteReadyPlanOptionProgramDataModificationsResult(
  options: DeleteReadyPlanOptionProgramDataModificationsResultOptions = {},
  cache: Record<string, any> = {},
): DeleteReadyPlanOptionProgramDataModificationsResult {
  const o =
    (options.__typename
      ? options
      : cache["DeleteReadyPlanOptionProgramDataModificationsResult"] =
        {}) as DeleteReadyPlanOptionProgramDataModificationsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeleteReadyPlanOptionProgramDataModificationsResult";
  o.id = options.id ?? nextFactoryId("DeleteReadyPlanOptionProgramDataModificationsResult");
  o.modifiedOptionId = options.modifiedOptionId ?? "modifiedOptionId";
  return o;
}

factories["DeleteReadyPlanOptionProgramDataModificationsResult"] =
  newDeleteReadyPlanOptionProgramDataModificationsResult;

export interface ReadyPlanOptionVersionOptions {
  __typename?: "ReadyPlanOptionVersion";
  id?: ReadyPlanOptionVersion["id"];
  identity?: ReadyPlanOption | ReadyPlanOptionOptions;
  first?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  final?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  active?: ReadyPlanOptionVersion["active"];
  createdAt?: ReadyPlanOptionVersion["createdAt"];
  updatedAt?: ReadyPlanOptionVersion["updatedAt"];
  customName?: ReadyPlanOptionVersion["customName"];
  isNewFromUpstream?: ReadyPlanOptionVersion["isNewFromUpstream"];
  isUpstreamInactive?: ReadyPlanOptionVersion["isUpstreamInactive"];
  isOfferingInactive?: ReadyPlanOptionVersion["isOfferingInactive"];
  optionConflicts?: Array<ReadyPlanOption | ReadyPlanOptionOptions> | null;
  optionPrerequisites?: Array<ReadyPlanOption | ReadyPlanOptionOptions> | null;
  optionDefaultsIf?: Array<ReadyPlanOption | ReadyPlanOptionOptions> | null;
  publishToUnderwriting?: ReadyPlanOptionVersion["publishToUnderwriting"];
  location?: Location | LocationOptions | null;
  showInCheckout?: ReadyPlanOptionVersion["showInCheckout"];
}

export function newReadyPlanOptionVersion(
  options: ReadyPlanOptionVersionOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanOptionVersion {
  const o = (options.__typename ? options : cache["ReadyPlanOptionVersion"] = {}) as ReadyPlanOptionVersion;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanOptionVersion";
  o.id = options.id ?? nextFactoryId("ReadyPlanOptionVersion");
  o.identity = maybeNew("ReadyPlanOption", options.identity, cache, options.hasOwnProperty("identity"));
  o.first = maybeNew("ReadyPlanAggregateVersion", options.first, cache, options.hasOwnProperty("first"));
  o.final = maybeNewOrNull("ReadyPlanAggregateVersion", options.final, cache);
  o.active = options.active ?? false;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.customName = options.customName ?? null;
  o.isNewFromUpstream = options.isNewFromUpstream ?? false;
  o.isUpstreamInactive = options.isUpstreamInactive ?? false;
  o.isOfferingInactive = options.isOfferingInactive ?? null;
  o.optionConflicts = (options.optionConflicts ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("optionConflicts"))
  );
  o.optionPrerequisites = (options.optionPrerequisites ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("optionPrerequisites"))
  );
  o.optionDefaultsIf = (options.optionDefaultsIf ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("optionDefaultsIf"))
  );
  o.publishToUnderwriting = options.publishToUnderwriting ?? false;
  o.location = maybeNewOrNull("Location", options.location, cache);
  o.showInCheckout = options.showInCheckout ?? false;
  return o;
}

factories["ReadyPlanOptionVersion"] = newReadyPlanOptionVersion;

export interface ReadyPlanProgramDataOptions {
  __typename?: "ReadyPlanProgramData";
  id?: ReadyPlanProgramData["id"];
  createdAt?: ReadyPlanProgramData["createdAt"];
  updatedAt?: ReadyPlanProgramData["updatedAt"];
  readyPlan?: ReadyPlan | ReadyPlanOptions;
  readyPlanOptions?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  programData?: ProgramData | ProgramDataOptions;
  versions?: Array<ReadyPlanProgramDataVersion | ReadyPlanProgramDataVersionOptions>;
  active?: ReadyPlanProgramData["active"];
}

export function newReadyPlanProgramData(
  options: ReadyPlanProgramDataOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanProgramData {
  const o = (options.__typename ? options : cache["ReadyPlanProgramData"] = {}) as ReadyPlanProgramData;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanProgramData";
  o.id = options.id ?? nextFactoryId("ReadyPlanProgramData");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.readyPlan = maybeNew("ReadyPlan", options.readyPlan, cache, options.hasOwnProperty("readyPlan"));
  o.readyPlanOptions = (options.readyPlanOptions ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("readyPlanOptions"))
  );
  o.programData = maybeNew("ProgramData", options.programData, cache, options.hasOwnProperty("programData"));
  o.versions = (options.versions ?? []).map((i) =>
    maybeNew("ReadyPlanProgramDataVersion", i, cache, options.hasOwnProperty("versions"))
  );
  o.active = options.active ?? false;
  return o;
}

factories["ReadyPlanProgramData"] = newReadyPlanProgramData;

export interface ReadyPlanProgramDataVersionOptions {
  __typename?: "ReadyPlanProgramDataVersion";
  id?: ReadyPlanProgramDataVersion["id"];
  active?: ReadyPlanProgramDataVersion["active"];
  createdAt?: ReadyPlanProgramDataVersion["createdAt"];
  updatedAt?: ReadyPlanProgramDataVersion["updatedAt"];
  final?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  first?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  identity?: ReadyPlanProgramData | ReadyPlanProgramDataOptions;
  programData?: ProgramData | ProgramDataOptions;
}

export function newReadyPlanProgramDataVersion(
  options: ReadyPlanProgramDataVersionOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanProgramDataVersion {
  const o = (options.__typename ? options : cache["ReadyPlanProgramDataVersion"] = {}) as ReadyPlanProgramDataVersion;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanProgramDataVersion";
  o.id = options.id ?? nextFactoryId("ReadyPlanProgramDataVersion");
  o.active = options.active ?? false;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.final = maybeNewOrNull("ReadyPlanAggregateVersion", options.final, cache);
  o.first = maybeNew("ReadyPlanAggregateVersion", options.first, cache, options.hasOwnProperty("first"));
  o.identity = maybeNew("ReadyPlanProgramData", options.identity, cache, options.hasOwnProperty("identity"));
  o.programData = maybeNew("ProgramData", options.programData, cache, options.hasOwnProperty("programData"));
  return o;
}

factories["ReadyPlanProgramDataVersion"] = newReadyPlanProgramDataVersion;

export interface ReadyPlanRequiredOptionOptions {
  __typename?: "ReadyPlanRequiredOption";
  id?: ReadyPlanRequiredOption["id"];
  createdAt?: ReadyPlanRequiredOption["createdAt"];
  updatedAt?: ReadyPlanRequiredOption["updatedAt"];
  readyPlan?: ReadyPlan | PlanPackage | DesignPackage | ProductOffering | ReadyPlanLike | ReadyPlanLikeOptions;
  planAddOns?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  targetGroups?: Array<ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions>;
  targetCombinations?: Array<DesignPackageOptionCombination | DesignPackageOptionCombinationOptions>;
  active?: ReadyPlanRequiredOption["active"];
  usePersonalizationGroups?: ReadyPlanRequiredOption["usePersonalizationGroups"];
}

export function newReadyPlanRequiredOption(
  options: ReadyPlanRequiredOptionOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanRequiredOption {
  const o = (options.__typename ? options : cache["ReadyPlanRequiredOption"] = {}) as ReadyPlanRequiredOption;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanRequiredOption";
  o.id = options.id ?? nextFactoryId("ReadyPlanRequiredOption");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.readyPlan = maybeNew("ReadyPlanLike", options.readyPlan, cache, options.hasOwnProperty("readyPlan"));
  o.planAddOns = (options.planAddOns ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("planAddOns"))
  );
  o.targetGroups = (options.targetGroups ?? []).map((i) =>
    maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("targetGroups"))
  );
  o.targetCombinations = (options.targetCombinations ?? []).map((i) =>
    maybeNew("DesignPackageOptionCombination", i, cache, options.hasOwnProperty("targetCombinations"))
  );
  o.active = options.active ?? false;
  o.usePersonalizationGroups = options.usePersonalizationGroups ?? false;
  return o;
}

factories["ReadyPlanRequiredOption"] = newReadyPlanRequiredOption;

export interface SaveReadyPlanRequiredOptionsResultOptions {
  __typename?: "SaveReadyPlanRequiredOptionsResult";
  readyPlanRequiredOptions?: Array<ReadyPlanRequiredOption | ReadyPlanRequiredOptionOptions>;
}

export function newSaveReadyPlanRequiredOptionsResult(
  options: SaveReadyPlanRequiredOptionsResultOptions = {},
  cache: Record<string, any> = {},
): SaveReadyPlanRequiredOptionsResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveReadyPlanRequiredOptionsResult"] = {}) as SaveReadyPlanRequiredOptionsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveReadyPlanRequiredOptionsResult";
  o.readyPlanRequiredOptions = (options.readyPlanRequiredOptions ?? []).map((i) =>
    maybeNew("ReadyPlanRequiredOption", i, cache, options.hasOwnProperty("readyPlanRequiredOptions"))
  );
  return o;
}

factories["SaveReadyPlanRequiredOptionsResult"] = newSaveReadyPlanRequiredOptionsResult;

export interface ReadyPlanRequiredOptionVersionOptions {
  __typename?: "ReadyPlanRequiredOptionVersion";
  id?: ReadyPlanRequiredOptionVersion["id"];
  active?: ReadyPlanRequiredOptionVersion["active"];
  createdAt?: ReadyPlanRequiredOptionVersion["createdAt"];
  updatedAt?: ReadyPlanRequiredOptionVersion["updatedAt"];
  final?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  first?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  identity?: ReadyPlanRequiredOption | ReadyPlanRequiredOptionOptions;
  targetGroups?: Array<ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions>;
  targetCombinations?: Array<DesignPackageOptionCombination | DesignPackageOptionCombinationOptions>;
}

export function newReadyPlanRequiredOptionVersion(
  options: ReadyPlanRequiredOptionVersionOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanRequiredOptionVersion {
  const o =
    (options.__typename ? options : cache["ReadyPlanRequiredOptionVersion"] = {}) as ReadyPlanRequiredOptionVersion;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanRequiredOptionVersion";
  o.id = options.id ?? nextFactoryId("ReadyPlanRequiredOptionVersion");
  o.active = options.active ?? false;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.final = maybeNewOrNull("ReadyPlanAggregateVersion", options.final, cache);
  o.first = maybeNew("ReadyPlanAggregateVersion", options.first, cache, options.hasOwnProperty("first"));
  o.identity = maybeNew("ReadyPlanRequiredOption", options.identity, cache, options.hasOwnProperty("identity"));
  o.targetGroups = (options.targetGroups ?? []).map((i) =>
    maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("targetGroups"))
  );
  o.targetCombinations = (options.targetCombinations ?? []).map((i) =>
    maybeNew("DesignPackageOptionCombination", i, cache, options.hasOwnProperty("targetCombinations"))
  );
  return o;
}

factories["ReadyPlanRequiredOptionVersion"] = newReadyPlanRequiredOptionVersion;

export interface ReadyPlanVersionOptions {
  __typename?: "ReadyPlanVersion";
  id?: ReadyPlanVersion["id"];
  identity?: ReadyPlan | ReadyPlanOptions;
  name?: ReadyPlanVersion["name"];
  code?: ReadyPlanVersion["code"];
  type?: ReadyPlanTypeDetailOptions | ReadyPlanType;
  lotTypes?: ReadyPlanVersion["lotTypes"];
  contingencyMarkupPercentage?: ReadyPlanVersion["contingencyMarkupPercentage"];
  description?: ReadyPlanVersion["description"];
  markets?: Array<Market | MarketOptions>;
  owner?: InternalUser | InternalUserOptions | null;
}

export function newReadyPlanVersion(
  options: ReadyPlanVersionOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanVersion {
  const o = (options.__typename ? options : cache["ReadyPlanVersion"] = {}) as ReadyPlanVersion;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ReadyPlanVersion";
  o.id = options.id ?? nextFactoryId("ReadyPlanVersion");
  o.identity = maybeNew("ReadyPlan", options.identity, cache, options.hasOwnProperty("identity"));
  o.name = options.name ?? "name";
  o.code = options.code ?? null;
  o.type = enumOrDetailOfReadyPlanType(options.type);
  o.lotTypes = options.lotTypes ?? [];
  o.contingencyMarkupPercentage = options.contingencyMarkupPercentage ?? null;
  o.description = options.description ?? null;
  o.markets = (options.markets ?? []).map((i) => maybeNew("Market", i, cache, options.hasOwnProperty("markets")));
  o.owner = maybeNewOrNull("InternalUser", options.owner, cache);
  return o;
}

factories["ReadyPlanVersion"] = newReadyPlanVersion;

export interface SaveReferencesResultOptions {
  __typename?: "SaveReferencesResult";
  references?: Array<Reference | ReferenceOptions>;
}

export function newSaveReferencesResult(
  options: SaveReferencesResultOptions = {},
  cache: Record<string, any> = {},
): SaveReferencesResult {
  const o = (options.__typename ? options : cache["SaveReferencesResult"] = {}) as SaveReferencesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveReferencesResult";
  o.references = (options.references ?? []).map((i) =>
    maybeNew("Reference", i, cache, options.hasOwnProperty("references"))
  );
  return o;
}

factories["SaveReferencesResult"] = newSaveReferencesResult;

export interface ReferenceOptions {
  __typename?: "Reference";
  source?:
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions;
  target?:
    | ScheduleTask
    | Approval
    | BidContract
    | BidItem
    | BidPackageRequest
    | Bill
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | Referencable
    | ReferencableOptions;
}

export function newReference(options: ReferenceOptions = {}, cache: Record<string, any> = {}): Reference {
  const o = (options.__typename ? options : cache["Reference"] = {}) as Reference;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Reference";
  o.source = maybeNew("Referencable", options.source, cache, options.hasOwnProperty("source"));
  o.target = maybeNew("Referencable", options.target, cache, options.hasOwnProperty("target"));
  return o;
}

factories["Reference"] = newReference;

export interface SaveRegionResultOptions {
  __typename?: "SaveRegionResult";
  region?: Region | RegionOptions;
}

export function newSaveRegionResult(
  options: SaveRegionResultOptions = {},
  cache: Record<string, any> = {},
): SaveRegionResult {
  const o = (options.__typename ? options : cache["SaveRegionResult"] = {}) as SaveRegionResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveRegionResult";
  o.region = maybeNew("Region", options.region, cache, options.hasOwnProperty("region"));
  return o;
}

factories["SaveRegionResult"] = newSaveRegionResult;

export interface RequiredTaskDocumentOptions {
  __typename?: "RequiredTaskDocument";
  id?: RequiredTaskDocument["id"];
  name?: RequiredTaskDocument["name"];
  createdAt?: RequiredTaskDocument["createdAt"];
  updatedAt?: RequiredTaskDocument["updatedAt"];
  watchers?: RequiredTaskDocument["watchers"];
  documentType?: DocumentTypeDetailOptions | DocumentType;
  sampleAsset?: Asset | AssetOptions | null;
  task?: Task | TaskOptions;
  document?: Document | DocumentOptions | null;
  globalRequiredTaskDocument?: GlobalRequiredTaskDocument | GlobalRequiredTaskDocumentOptions | null;
}

export function newRequiredTaskDocument(
  options: RequiredTaskDocumentOptions = {},
  cache: Record<string, any> = {},
): RequiredTaskDocument {
  const o = (options.__typename ? options : cache["RequiredTaskDocument"] = {}) as RequiredTaskDocument;
  (cache.all ??= new Set()).add(o);
  o.__typename = "RequiredTaskDocument";
  o.id = options.id ?? nextFactoryId("RequiredTaskDocument");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.watchers = options.watchers ?? [];
  o.documentType = enumOrDetailOfDocumentType(options.documentType);
  o.sampleAsset = maybeNewOrNull("Asset", options.sampleAsset, cache);
  o.task = maybeNew("Task", options.task, cache, options.hasOwnProperty("task"));
  o.document = maybeNewOrNull("Document", options.document, cache);
  o.globalRequiredTaskDocument = maybeNewOrNull(
    "GlobalRequiredTaskDocument",
    options.globalRequiredTaskDocument,
    cache,
  );
  return o;
}

factories["RequiredTaskDocument"] = newRequiredTaskDocument;

export interface SaveRequiredTaskDocumentResultOptions {
  __typename?: "SaveRequiredTaskDocumentResult";
  requiredTaskDocument?: RequiredTaskDocument | RequiredTaskDocumentOptions;
}

export function newSaveRequiredTaskDocumentResult(
  options: SaveRequiredTaskDocumentResultOptions = {},
  cache: Record<string, any> = {},
): SaveRequiredTaskDocumentResult {
  const o =
    (options.__typename ? options : cache["SaveRequiredTaskDocumentResult"] = {}) as SaveRequiredTaskDocumentResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveRequiredTaskDocumentResult";
  o.requiredTaskDocument = maybeNew(
    "RequiredTaskDocument",
    options.requiredTaskDocument,
    cache,
    options.hasOwnProperty("requiredTaskDocument"),
  );
  return o;
}

factories["SaveRequiredTaskDocumentResult"] = newSaveRequiredTaskDocumentResult;

export interface DeleteRequiredTaskDocumentResultOptions {
  __typename?: "DeleteRequiredTaskDocumentResult";
  task?: Task | TaskOptions;
}

export function newDeleteRequiredTaskDocumentResult(
  options: DeleteRequiredTaskDocumentResultOptions = {},
  cache: Record<string, any> = {},
): DeleteRequiredTaskDocumentResult {
  const o =
    (options.__typename ? options : cache["DeleteRequiredTaskDocumentResult"] = {}) as DeleteRequiredTaskDocumentResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeleteRequiredTaskDocumentResult";
  o.task = maybeNew("Task", options.task, cache, options.hasOwnProperty("task"));
  return o;
}

factories["DeleteRequiredTaskDocumentResult"] = newDeleteRequiredTaskDocumentResult;

export interface RoomTypeOptions {
  __typename?: "RoomType";
  id?: RoomType["id"];
  name?: RoomType["name"];
  createdAt?: RoomType["createdAt"];
  updatedAt?: RoomType["updatedAt"];
  locations?: Array<Location | LocationOptions>;
  canDesignPackageRemap?: RoomType["canDesignPackageRemap"];
}

export function newRoomType(options: RoomTypeOptions = {}, cache: Record<string, any> = {}): RoomType {
  const o = (options.__typename ? options : cache["RoomType"] = {}) as RoomType;
  (cache.all ??= new Set()).add(o);
  o.__typename = "RoomType";
  o.id = options.id ?? nextFactoryId("RoomType");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.locations = (options.locations ?? []).map((i) =>
    maybeNew("Location", i, cache, options.hasOwnProperty("locations"))
  );
  o.canDesignPackageRemap = options.canDesignPackageRemap ?? null;
  return o;
}

factories["RoomType"] = newRoomType;

export interface SaveRoomTypeResultOptions {
  __typename?: "SaveRoomTypeResult";
  roomType?: RoomType | RoomTypeOptions;
}

export function newSaveRoomTypeResult(
  options: SaveRoomTypeResultOptions = {},
  cache: Record<string, any> = {},
): SaveRoomTypeResult {
  const o = (options.__typename ? options : cache["SaveRoomTypeResult"] = {}) as SaveRoomTypeResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveRoomTypeResult";
  o.roomType = maybeNew("RoomType", options.roomType, cache, options.hasOwnProperty("roomType"));
  return o;
}

factories["SaveRoomTypeResult"] = newSaveRoomTypeResult;

export interface TestMutationResultOptions {
  __typename?: "TestMutationResult";
  datetime?: TestMutationResult["datetime"];
  date?: TestMutationResult["date"];
}

export function newTestMutationResult(
  options: TestMutationResultOptions = {},
  cache: Record<string, any> = {},
): TestMutationResult {
  const o = (options.__typename ? options : cache["TestMutationResult"] = {}) as TestMutationResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TestMutationResult";
  o.datetime = options.datetime ?? newDateTime();
  o.date = options.date ?? newDate();
  return o;
}

factories["TestMutationResult"] = newTestMutationResult;

export interface UserErrorOptions {
  __typename?: "UserError";
  message?: UserError["message"];
}

export function newUserError(options: UserErrorOptions = {}, cache: Record<string, any> = {}): UserError {
  const o = (options.__typename ? options : cache["UserError"] = {}) as UserError;
  (cache.all ??= new Set()).add(o);
  o.__typename = "UserError";
  o.message = options.message ?? "message";
  return o;
}

factories["UserError"] = newUserError;

export interface EmptyResultOptions {
  __typename?: "EmptyResult";
  emptyResult?: EmptyResult["emptyResult"];
  dummyString?: EmptyResult["dummyString"];
}

export function newEmptyResult(options: EmptyResultOptions = {}, cache: Record<string, any> = {}): EmptyResult {
  const o = (options.__typename ? options : cache["EmptyResult"] = {}) as EmptyResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "EmptyResult";
  o.emptyResult = options.emptyResult ?? null;
  o.dummyString = options.dummyString ?? null;
  return o;
}

factories["EmptyResult"] = newEmptyResult;

export interface UrlOptions {
  __typename?: "Url";
  path?: Url["path"];
  url?: Url["url"];
}

export function newUrl(options: UrlOptions = {}, cache: Record<string, any> = {}): Url {
  const o = (options.__typename ? options : cache["Url"] = {}) as Url;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Url";
  o.path = options.path ?? "path";
  o.url = options.url ?? "url";
  return o;
}

factories["Url"] = newUrl;

export interface PotentialOperationOptions {
  __typename?: "PotentialOperation";
  shown?: PotentialOperation["shown"];
  hiddenReasons?: PotentialOperation["hiddenReasons"];
  enabled?: PotentialOperation["enabled"];
  disabledReasons?: PotentialOperation["disabledReasons"];
}

export function newPotentialOperation(
  options: PotentialOperationOptions = {},
  cache: Record<string, any> = {},
): PotentialOperation {
  const o = (options.__typename ? options : cache["PotentialOperation"] = {}) as PotentialOperation;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PotentialOperation";
  o.shown = options.shown ?? false;
  o.hiddenReasons = options.hiddenReasons ?? [];
  o.enabled = options.enabled ?? false;
  o.disabledReasons = options.disabledReasons ?? [];
  return o;
}

factories["PotentialOperation"] = newPotentialOperation;

export interface PotentialOperation2Options {
  __typename?: "PotentialOperation2";
  allowed?: PotentialOperation2["allowed"];
  disabledReasons?: Array<Reason | ReasonOptions>;
}

export function newPotentialOperation2(
  options: PotentialOperation2Options = {},
  cache: Record<string, any> = {},
): PotentialOperation2 {
  const o = (options.__typename ? options : cache["PotentialOperation2"] = {}) as PotentialOperation2;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PotentialOperation2";
  o.allowed = options.allowed ?? false;
  o.disabledReasons = (options.disabledReasons ?? []).map((i) =>
    maybeNew("Reason", i, cache, options.hasOwnProperty("disabledReasons"))
  );
  return o;
}

factories["PotentialOperation2"] = newPotentialOperation2;

export interface ReasonOptions {
  __typename?: "Reason";
  message?: Reason["message"];
  entity?:
    | ScheduleTask
    | Approval
    | BidContract
    | BidContractRevision
    | BidItem
    | BidPackageRequest
    | Bill
    | BusinessFunction
    | ChangeEvent
    | ChangeRequest
    | ChangeRequestToDo
    | SchedulePhase
    | ScheduleSubPhase
    | Task
    | PlanTask
    | ToDo
    | Invoice
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | ProjectItem
    | Estimate
    | DevelopmentCommitment
    | Commitment
    | Document
    | Product
    | ItemTemplateItemVersion
    | JobLogNote
    | TradePartnerAvailabilityRequest
    | PunchlistItemTodo
    | WarrantyTicket
    | HomeownerContract
    | HomeownerContractChangeOrder
    | ReadyPlan
    | PlanPackage
    | GlobalOption
    | ProjectCostCode
    | CommitmentChangeOrder
    | DesignPackage
    | Development
    | ItemTemplateItem
    | MaterialVariant
    | ProductOffering
    | ProjectReadyPlanConfig
    | ProjectSiteCondition
    | ReadyPlanOption
    | TakeoffLineItem
    | TakeoffLineItemVersion
    | HasBlueprintUrl
    | HasBlueprintUrlOptions
    | null;
}

export function newReason(options: ReasonOptions = {}, cache: Record<string, any> = {}): Reason {
  const o = (options.__typename ? options : cache["Reason"] = {}) as Reason;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Reason";
  o.message = options.message ?? "message";
  o.entity = maybeNewOrNull("HasBlueprintUrl", options.entity, cache);
  return o;
}

factories["Reason"] = newReason;

export interface ScheduleOptions {
  __typename?: "Schedule";
  id?: Schedule["id"];
  name?: Schedule["name"];
  interval?: CalendarInterval | CalendarIntervalOptions | null;
  baselineInterval?: CalendarInterval | CalendarIntervalOptions | null;
  createdAt?: Schedule["createdAt"];
  updatedAt?: Schedule["updatedAt"];
  status?: Schedule["status"];
  statusDetail?: ScheduleStatusDetailOptions | ScheduleStatus;
  stage?: Schedule["stage"];
  stageDetail?: StageDetailOptions | Stage;
  parent?:
    | ScheduleParent
    | StandaloneProjectOptions
    | RequireTypename<RegionOptions>
    | RequireTypename<DevelopmentOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>
    | RequireTypename<ScheduleTemplateOptions>;
  scheduleSetting?: ScheduleSetting | ScheduleSettingOptions | null;
  canPublishSchedule?: PotentialOperation2 | PotentialOperation2Options;
  canCompleteSchedule?: PotentialOperation2 | PotentialOperation2Options;
  duration?: Schedule["duration"];
  baselineDuration?: Schedule["baselineDuration"];
  phases?: Array<SchedulePhase | SchedulePhaseOptions>;
  isLocked?: Schedule["isLocked"];
  flagCount?: Schedule["flagCount"];
  templateSchedule?: Schedule | ScheduleOptions | null;
  enableReviewReminders?: Schedule["enableReviewReminders"];
  reviewReminderDays?: Schedule["reviewReminderDays"];
  market?: Market | MarketOptions | null;
}

export function newSchedule(options: ScheduleOptions = {}, cache: Record<string, any> = {}): Schedule {
  const o = (options.__typename ? options : cache["Schedule"] = {}) as Schedule;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Schedule";
  o.id = options.id ?? nextFactoryId("Schedule");
  o.name = options.name ?? "name";
  o.interval = maybeNewOrNull("CalendarInterval", options.interval, cache);
  o.baselineInterval = maybeNewOrNull("CalendarInterval", options.baselineInterval, cache);
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.status = options.status ?? ScheduleStatus.Active;
  o.statusDetail = enumOrDetailOfScheduleStatus(options.statusDetail);
  o.stage = options.stage ?? Stage.PreConPlanning;
  o.stageDetail = enumOrDetailOfStage(options.stageDetail);
  o.parent = maybeNew(options.parent?.__typename ?? "StandaloneProject", options.parent, cache);
  o.scheduleSetting = maybeNewOrNull("ScheduleSetting", options.scheduleSetting, cache);
  o.canPublishSchedule = maybeNew(
    "PotentialOperation2",
    options.canPublishSchedule,
    cache,
    options.hasOwnProperty("canPublishSchedule"),
  );
  o.canCompleteSchedule = maybeNew(
    "PotentialOperation2",
    options.canCompleteSchedule,
    cache,
    options.hasOwnProperty("canCompleteSchedule"),
  );
  o.duration = options.duration ?? null;
  o.baselineDuration = options.baselineDuration ?? null;
  o.phases = (options.phases ?? []).map((i) => maybeNew("SchedulePhase", i, cache, options.hasOwnProperty("phases")));
  o.isLocked = options.isLocked ?? false;
  o.flagCount = options.flagCount ?? 0;
  o.templateSchedule = maybeNewOrNull("Schedule", options.templateSchedule, cache);
  o.enableReviewReminders = options.enableReviewReminders ?? false;
  o.reviewReminderDays = options.reviewReminderDays ?? [];
  o.market = maybeNewOrNull("Market", options.market, cache);
  return o;
}

factories["Schedule"] = newSchedule;

export interface SchedulesResultOptions {
  __typename?: "SchedulesResult";
  schedules?: Array<Schedule | ScheduleOptions>;
}

export function newSchedulesResult(
  options: SchedulesResultOptions = {},
  cache: Record<string, any> = {},
): SchedulesResult {
  const o = (options.__typename ? options : cache["SchedulesResult"] = {}) as SchedulesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SchedulesResult";
  o.schedules = (options.schedules ?? []).map((i) =>
    maybeNew("Schedule", i, cache, options.hasOwnProperty("schedules"))
  );
  return o;
}

factories["SchedulesResult"] = newSchedulesResult;

export interface SaveScheduleResultOptions {
  __typename?: "SaveScheduleResult";
  schedule?: Schedule | ScheduleOptions;
}

export function newSaveScheduleResult(
  options: SaveScheduleResultOptions = {},
  cache: Record<string, any> = {},
): SaveScheduleResult {
  const o = (options.__typename ? options : cache["SaveScheduleResult"] = {}) as SaveScheduleResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveScheduleResult";
  o.schedule = maybeNew("Schedule", options.schedule, cache, options.hasOwnProperty("schedule"));
  return o;
}

factories["SaveScheduleResult"] = newSaveScheduleResult;

export interface ResetScheduleBaselinesResultOptions {
  __typename?: "ResetScheduleBaselinesResult";
  projectIds?: ResetScheduleBaselinesResult["projectIds"];
}

export function newResetScheduleBaselinesResult(
  options: ResetScheduleBaselinesResultOptions = {},
  cache: Record<string, any> = {},
): ResetScheduleBaselinesResult {
  const o = (options.__typename ? options : cache["ResetScheduleBaselinesResult"] = {}) as ResetScheduleBaselinesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ResetScheduleBaselinesResult";
  o.projectIds = options.projectIds ?? [];
  return o;
}

factories["ResetScheduleBaselinesResult"] = newResetScheduleBaselinesResult;

export interface ScheduleFlagOptions {
  __typename?: "ScheduleFlag";
  id?: ScheduleFlag["id"];
  durationInDays?: ScheduleFlag["durationInDays"];
  description?: ScheduleFlag["description"];
  createdAt?: ScheduleFlag["createdAt"];
  updatedAt?: ScheduleFlag["updatedAt"];
  reason?: ScheduleFlagReason | ScheduleFlagReasonOptions | null;
  scheduleTask?: ScheduleTask | ScheduleTaskOptions | null;
  task?: Task | TaskOptions;
  attachments?: Array<Attachment | AttachmentOptions>;
}

export function newScheduleFlag(options: ScheduleFlagOptions = {}, cache: Record<string, any> = {}): ScheduleFlag {
  const o = (options.__typename ? options : cache["ScheduleFlag"] = {}) as ScheduleFlag;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ScheduleFlag";
  o.id = options.id ?? nextFactoryId("ScheduleFlag");
  o.durationInDays = options.durationInDays ?? null;
  o.description = options.description ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.reason = maybeNewOrNull("ScheduleFlagReason", options.reason, cache);
  o.scheduleTask = maybeNewOrNull("ScheduleTask", options.scheduleTask, cache);
  o.task = maybeNew("Task", options.task, cache, options.hasOwnProperty("task"));
  o.attachments = (options.attachments ?? []).map((i) =>
    maybeNew("Attachment", i, cache, options.hasOwnProperty("attachments"))
  );
  return o;
}

factories["ScheduleFlag"] = newScheduleFlag;

export interface SaveScheduleFlagResultOptions {
  __typename?: "SaveScheduleFlagResult";
  scheduleFlag?: ScheduleFlag | ScheduleFlagOptions;
}

export function newSaveScheduleFlagResult(
  options: SaveScheduleFlagResultOptions = {},
  cache: Record<string, any> = {},
): SaveScheduleFlagResult {
  const o = (options.__typename ? options : cache["SaveScheduleFlagResult"] = {}) as SaveScheduleFlagResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveScheduleFlagResult";
  o.scheduleFlag = maybeNew("ScheduleFlag", options.scheduleFlag, cache, options.hasOwnProperty("scheduleFlag"));
  return o;
}

factories["SaveScheduleFlagResult"] = newSaveScheduleFlagResult;

export interface DeleteScheduleFlagResultOptions {
  __typename?: "DeleteScheduleFlagResult";
  scheduleTask?: ScheduleTask | ScheduleTaskOptions | null;
  task?: Task | TaskOptions;
}

export function newDeleteScheduleFlagResult(
  options: DeleteScheduleFlagResultOptions = {},
  cache: Record<string, any> = {},
): DeleteScheduleFlagResult {
  const o = (options.__typename ? options : cache["DeleteScheduleFlagResult"] = {}) as DeleteScheduleFlagResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeleteScheduleFlagResult";
  o.scheduleTask = maybeNewOrNull("ScheduleTask", options.scheduleTask, cache);
  o.task = maybeNew("Task", options.task, cache, options.hasOwnProperty("task"));
  return o;
}

factories["DeleteScheduleFlagResult"] = newDeleteScheduleFlagResult;

export interface ScheduleFlagImpactOptions {
  __typename?: "ScheduleFlagImpact";
  id?: ScheduleFlagImpact["id"];
  oldStartDate?: ScheduleFlagImpact["oldStartDate"];
  newStartDate?: ScheduleFlagImpact["newStartDate"];
  oldEndDate?: ScheduleFlagImpact["oldEndDate"];
  newEndDate?: ScheduleFlagImpact["newEndDate"];
  oldDurationInDays?: ScheduleFlagImpact["oldDurationInDays"];
  newDurationInDays?: ScheduleFlagImpact["newDurationInDays"];
  oldSlackInDays?: ScheduleFlagImpact["oldSlackInDays"];
  newSlackInDays?: ScheduleFlagImpact["newSlackInDays"];
  createdAt?: ScheduleFlagImpact["createdAt"];
  updatedAt?: ScheduleFlagImpact["updatedAt"];
  scheduleFlag?: ScheduleFlag | ScheduleFlagOptions;
  impacted?: ScheduleFlagImpactImpacted | PlanMilestoneOptions | RequireTypename<TaskOptions> | null;
}

export function newScheduleFlagImpact(
  options: ScheduleFlagImpactOptions = {},
  cache: Record<string, any> = {},
): ScheduleFlagImpact {
  const o = (options.__typename ? options : cache["ScheduleFlagImpact"] = {}) as ScheduleFlagImpact;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ScheduleFlagImpact";
  o.id = options.id ?? nextFactoryId("ScheduleFlagImpact");
  o.oldStartDate = options.oldStartDate ?? null;
  o.newStartDate = options.newStartDate ?? newDate();
  o.oldEndDate = options.oldEndDate ?? null;
  o.newEndDate = options.newEndDate ?? newDate();
  o.oldDurationInDays = options.oldDurationInDays ?? null;
  o.newDurationInDays = options.newDurationInDays ?? 0;
  o.oldSlackInDays = options.oldSlackInDays ?? null;
  o.newSlackInDays = options.newSlackInDays ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.scheduleFlag = maybeNew("ScheduleFlag", options.scheduleFlag, cache, options.hasOwnProperty("scheduleFlag"));
  o.impacted = maybeNewOrNull(options.impacted?.__typename ?? "PlanMilestone", options.impacted, cache);
  return o;
}

factories["ScheduleFlagImpact"] = newScheduleFlagImpact;

export interface ScheduleFlagReasonOptions {
  __typename?: "ScheduleFlagReason";
  id?: ScheduleFlagReason["id"];
  createdAt?: ScheduleFlagReason["createdAt"];
  updatedAt?: ScheduleFlagReason["updatedAt"];
  scheduleFlagReasonType?: ScheduleFlagReasonTypeDetailOptions | ScheduleFlagReasonType;
  stages?: ScheduleFlagReason["stages"];
  scheduleFlags?: Array<ScheduleFlag | ScheduleFlagOptions>;
  title?: ScheduleFlagReason["title"];
  attachmentIsRequired?: ScheduleFlagReason["attachmentIsRequired"];
  descriptionIsRequired?: ScheduleFlagReason["descriptionIsRequired"];
}

export function newScheduleFlagReason(
  options: ScheduleFlagReasonOptions = {},
  cache: Record<string, any> = {},
): ScheduleFlagReason {
  const o = (options.__typename ? options : cache["ScheduleFlagReason"] = {}) as ScheduleFlagReason;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ScheduleFlagReason";
  o.id = options.id ?? nextFactoryId("ScheduleFlagReason");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.scheduleFlagReasonType = enumOrDetailOfScheduleFlagReasonType(options.scheduleFlagReasonType);
  o.stages = options.stages ?? [];
  o.scheduleFlags = (options.scheduleFlags ?? []).map((i) =>
    maybeNew("ScheduleFlag", i, cache, options.hasOwnProperty("scheduleFlags"))
  );
  o.title = options.title ?? "title";
  o.attachmentIsRequired = options.attachmentIsRequired ?? false;
  o.descriptionIsRequired = options.descriptionIsRequired ?? false;
  return o;
}

factories["ScheduleFlagReason"] = newScheduleFlagReason;

export interface SaveScheduleFlagReasonsResultOptions {
  __typename?: "SaveScheduleFlagReasonsResult";
  scheduleFlagReasons?: Array<ScheduleFlagReason | ScheduleFlagReasonOptions>;
}

export function newSaveScheduleFlagReasonsResult(
  options: SaveScheduleFlagReasonsResultOptions = {},
  cache: Record<string, any> = {},
): SaveScheduleFlagReasonsResult {
  const o =
    (options.__typename ? options : cache["SaveScheduleFlagReasonsResult"] = {}) as SaveScheduleFlagReasonsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveScheduleFlagReasonsResult";
  o.scheduleFlagReasons = (options.scheduleFlagReasons ?? []).map((i) =>
    maybeNew("ScheduleFlagReason", i, cache, options.hasOwnProperty("scheduleFlagReasons"))
  );
  return o;
}

factories["SaveScheduleFlagReasonsResult"] = newSaveScheduleFlagReasonsResult;

export interface SchedulePhaseProgressOptions {
  __typename?: "SchedulePhaseProgress";
  scheduleSubPhaseProgress?: ProgressSummary | ProgressSummaryOptions;
  taskProgress?: ProgressSummary | ProgressSummaryOptions;
}

export function newSchedulePhaseProgress(
  options: SchedulePhaseProgressOptions = {},
  cache: Record<string, any> = {},
): SchedulePhaseProgress {
  const o = (options.__typename ? options : cache["SchedulePhaseProgress"] = {}) as SchedulePhaseProgress;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SchedulePhaseProgress";
  o.scheduleSubPhaseProgress = maybeNew(
    "ProgressSummary",
    options.scheduleSubPhaseProgress,
    cache,
    options.hasOwnProperty("scheduleSubPhaseProgress"),
  );
  o.taskProgress = maybeNew("ProgressSummary", options.taskProgress, cache, options.hasOwnProperty("taskProgress"));
  return o;
}

factories["SchedulePhaseProgress"] = newSchedulePhaseProgress;

export interface SaveSchedulePhasesResultOptions {
  __typename?: "SaveSchedulePhasesResult";
  schedulePhases?: Array<SchedulePhase | SchedulePhaseOptions>;
}

export function newSaveSchedulePhasesResult(
  options: SaveSchedulePhasesResultOptions = {},
  cache: Record<string, any> = {},
): SaveSchedulePhasesResult {
  const o = (options.__typename ? options : cache["SaveSchedulePhasesResult"] = {}) as SaveSchedulePhasesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveSchedulePhasesResult";
  o.schedulePhases = (options.schedulePhases ?? []).map((i) =>
    maybeNew("SchedulePhase", i, cache, options.hasOwnProperty("schedulePhases"))
  );
  return o;
}

factories["SaveSchedulePhasesResult"] = newSaveSchedulePhasesResult;

export interface DeleteSchedulePhasesResultOptions {
  __typename?: "DeleteSchedulePhasesResult";
  impactedScheduleTasks?: Array<ScheduleTask | ScheduleTaskOptions>;
  impactedScheduleSubPhases?: Array<ScheduleSubPhase | ScheduleSubPhaseOptions>;
  impactedSchedulePhases?: Array<SchedulePhase | SchedulePhaseOptions>;
  impactedSchedules?: Array<Schedule | ScheduleOptions>;
  impacted?: Array<ScheduleTask | SchedulePhase | ScheduleSubPhase | Schedule | ScheduleEntity | ScheduleEntityOptions>;
}

export function newDeleteSchedulePhasesResult(
  options: DeleteSchedulePhasesResultOptions = {},
  cache: Record<string, any> = {},
): DeleteSchedulePhasesResult {
  const o = (options.__typename ? options : cache["DeleteSchedulePhasesResult"] = {}) as DeleteSchedulePhasesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeleteSchedulePhasesResult";
  o.impactedScheduleTasks = (options.impactedScheduleTasks ?? []).map((i) =>
    maybeNew("ScheduleTask", i, cache, options.hasOwnProperty("impactedScheduleTasks"))
  );
  o.impactedScheduleSubPhases = (options.impactedScheduleSubPhases ?? []).map((i) =>
    maybeNew("ScheduleSubPhase", i, cache, options.hasOwnProperty("impactedScheduleSubPhases"))
  );
  o.impactedSchedulePhases = (options.impactedSchedulePhases ?? []).map((i) =>
    maybeNew("SchedulePhase", i, cache, options.hasOwnProperty("impactedSchedulePhases"))
  );
  o.impactedSchedules = (options.impactedSchedules ?? []).map((i) =>
    maybeNew("Schedule", i, cache, options.hasOwnProperty("impactedSchedules"))
  );
  o.impacted = (options.impacted ?? []).map((i) =>
    maybeNew("ScheduleEntity", i, cache, options.hasOwnProperty("impacted"))
  );
  return o;
}

factories["DeleteSchedulePhasesResult"] = newDeleteSchedulePhasesResult;

export interface ScheduleSettingOptions {
  __typename?: "ScheduleSetting";
  id?: ScheduleSetting["id"];
  workingDays?: ScheduleSetting["workingDays"];
  createdAt?: ScheduleSetting["createdAt"];
  updatedAt?: ScheduleSetting["updatedAt"];
  schedule?: Schedule | ScheduleOptions;
  exceptions?: ScheduleSetting["exceptions"];
}

export function newScheduleSetting(
  options: ScheduleSettingOptions = {},
  cache: Record<string, any> = {},
): ScheduleSetting {
  const o = (options.__typename ? options : cache["ScheduleSetting"] = {}) as ScheduleSetting;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ScheduleSetting";
  o.id = options.id ?? nextFactoryId("ScheduleSetting");
  o.workingDays = options.workingDays ?? [];
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.schedule = maybeNew("Schedule", options.schedule, cache, options.hasOwnProperty("schedule"));
  o.exceptions = options.exceptions ?? null;
  return o;
}

factories["ScheduleSetting"] = newScheduleSetting;

export interface SaveScheduleSettingsResultOptions {
  __typename?: "SaveScheduleSettingsResult";
  scheduleSettings?: Array<ScheduleSetting | ScheduleSettingOptions>;
}

export function newSaveScheduleSettingsResult(
  options: SaveScheduleSettingsResultOptions = {},
  cache: Record<string, any> = {},
): SaveScheduleSettingsResult {
  const o = (options.__typename ? options : cache["SaveScheduleSettingsResult"] = {}) as SaveScheduleSettingsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveScheduleSettingsResult";
  o.scheduleSettings = (options.scheduleSettings ?? []).map((i) =>
    maybeNew("ScheduleSetting", i, cache, options.hasOwnProperty("scheduleSettings"))
  );
  return o;
}

factories["SaveScheduleSettingsResult"] = newSaveScheduleSettingsResult;

export interface ScheduleSubPhaseProgressOptions {
  __typename?: "ScheduleSubPhaseProgress";
  taskProgress?: ProgressSummary | ProgressSummaryOptions;
}

export function newScheduleSubPhaseProgress(
  options: ScheduleSubPhaseProgressOptions = {},
  cache: Record<string, any> = {},
): ScheduleSubPhaseProgress {
  const o = (options.__typename ? options : cache["ScheduleSubPhaseProgress"] = {}) as ScheduleSubPhaseProgress;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ScheduleSubPhaseProgress";
  o.taskProgress = maybeNew("ProgressSummary", options.taskProgress, cache, options.hasOwnProperty("taskProgress"));
  return o;
}

factories["ScheduleSubPhaseProgress"] = newScheduleSubPhaseProgress;

export interface SaveScheduleSubPhasesResultOptions {
  __typename?: "SaveScheduleSubPhasesResult";
  scheduleSubPhases?: Array<ScheduleSubPhase | ScheduleSubPhaseOptions>;
}

export function newSaveScheduleSubPhasesResult(
  options: SaveScheduleSubPhasesResultOptions = {},
  cache: Record<string, any> = {},
): SaveScheduleSubPhasesResult {
  const o = (options.__typename ? options : cache["SaveScheduleSubPhasesResult"] = {}) as SaveScheduleSubPhasesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveScheduleSubPhasesResult";
  o.scheduleSubPhases = (options.scheduleSubPhases ?? []).map((i) =>
    maybeNew("ScheduleSubPhase", i, cache, options.hasOwnProperty("scheduleSubPhases"))
  );
  return o;
}

factories["SaveScheduleSubPhasesResult"] = newSaveScheduleSubPhasesResult;

export interface DeleteScheduleSubPhasesResultOptions {
  __typename?: "DeleteScheduleSubPhasesResult";
  impactedScheduleTasks?: Array<ScheduleTask | ScheduleTaskOptions>;
  impactedScheduleSubPhases?: Array<ScheduleSubPhase | ScheduleSubPhaseOptions>;
  impactedSchedulePhases?: Array<SchedulePhase | SchedulePhaseOptions>;
  impactedSchedules?: Array<Schedule | ScheduleOptions>;
  impacted?: Array<ScheduleTask | SchedulePhase | ScheduleSubPhase | Schedule | ScheduleEntity | ScheduleEntityOptions>;
}

export function newDeleteScheduleSubPhasesResult(
  options: DeleteScheduleSubPhasesResultOptions = {},
  cache: Record<string, any> = {},
): DeleteScheduleSubPhasesResult {
  const o =
    (options.__typename ? options : cache["DeleteScheduleSubPhasesResult"] = {}) as DeleteScheduleSubPhasesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeleteScheduleSubPhasesResult";
  o.impactedScheduleTasks = (options.impactedScheduleTasks ?? []).map((i) =>
    maybeNew("ScheduleTask", i, cache, options.hasOwnProperty("impactedScheduleTasks"))
  );
  o.impactedScheduleSubPhases = (options.impactedScheduleSubPhases ?? []).map((i) =>
    maybeNew("ScheduleSubPhase", i, cache, options.hasOwnProperty("impactedScheduleSubPhases"))
  );
  o.impactedSchedulePhases = (options.impactedSchedulePhases ?? []).map((i) =>
    maybeNew("SchedulePhase", i, cache, options.hasOwnProperty("impactedSchedulePhases"))
  );
  o.impactedSchedules = (options.impactedSchedules ?? []).map((i) =>
    maybeNew("Schedule", i, cache, options.hasOwnProperty("impactedSchedules"))
  );
  o.impacted = (options.impacted ?? []).map((i) =>
    maybeNew("ScheduleEntity", i, cache, options.hasOwnProperty("impacted"))
  );
  return o;
}

factories["DeleteScheduleSubPhasesResult"] = newDeleteScheduleSubPhasesResult;

export interface MoveScheduleSubPhasesResultOptions {
  __typename?: "MoveScheduleSubPhasesResult";
  impactedScheduleTasks?: Array<ScheduleTask | ScheduleTaskOptions>;
  impactedScheduleSubPhases?: Array<ScheduleSubPhase | ScheduleSubPhaseOptions>;
  impactedSchedulePhases?: Array<SchedulePhase | SchedulePhaseOptions>;
  impactedSchedules?: Array<Schedule | ScheduleOptions>;
  impacted?: Array<ScheduleTask | SchedulePhase | ScheduleSubPhase | Schedule | ScheduleEntity | ScheduleEntityOptions>;
}

export function newMoveScheduleSubPhasesResult(
  options: MoveScheduleSubPhasesResultOptions = {},
  cache: Record<string, any> = {},
): MoveScheduleSubPhasesResult {
  const o = (options.__typename ? options : cache["MoveScheduleSubPhasesResult"] = {}) as MoveScheduleSubPhasesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MoveScheduleSubPhasesResult";
  o.impactedScheduleTasks = (options.impactedScheduleTasks ?? []).map((i) =>
    maybeNew("ScheduleTask", i, cache, options.hasOwnProperty("impactedScheduleTasks"))
  );
  o.impactedScheduleSubPhases = (options.impactedScheduleSubPhases ?? []).map((i) =>
    maybeNew("ScheduleSubPhase", i, cache, options.hasOwnProperty("impactedScheduleSubPhases"))
  );
  o.impactedSchedulePhases = (options.impactedSchedulePhases ?? []).map((i) =>
    maybeNew("SchedulePhase", i, cache, options.hasOwnProperty("impactedSchedulePhases"))
  );
  o.impactedSchedules = (options.impactedSchedules ?? []).map((i) =>
    maybeNew("Schedule", i, cache, options.hasOwnProperty("impactedSchedules"))
  );
  o.impacted = (options.impacted ?? []).map((i) =>
    maybeNew("ScheduleEntity", i, cache, options.hasOwnProperty("impacted"))
  );
  return o;
}

factories["MoveScheduleSubPhasesResult"] = newMoveScheduleSubPhasesResult;

export interface SaveScheduleTasksResultOptions {
  __typename?: "SaveScheduleTasksResult";
  scheduleTasks?: Array<ScheduleTask | ScheduleTaskOptions>;
  impactedScheduleTasks?: Array<ScheduleTask | ScheduleTaskOptions>;
  impactedScheduleSubPhases?: Array<ScheduleSubPhase | ScheduleSubPhaseOptions>;
  impactedSchedulePhases?: Array<SchedulePhase | SchedulePhaseOptions>;
  impactedSchedules?: Array<Schedule | ScheduleOptions>;
  impacted?: Array<ScheduleTask | SchedulePhase | ScheduleSubPhase | Schedule | ScheduleEntity | ScheduleEntityOptions>;
  resultingDelays?: Array<ResultingDelay | ResultingDelayOptions>;
  generatedInvoices?: Array<Invoice | InvoiceOptions>;
  generatedDepositBills?: Array<Bill | BillOptions>;
}

export function newSaveScheduleTasksResult(
  options: SaveScheduleTasksResultOptions = {},
  cache: Record<string, any> = {},
): SaveScheduleTasksResult {
  const o = (options.__typename ? options : cache["SaveScheduleTasksResult"] = {}) as SaveScheduleTasksResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveScheduleTasksResult";
  o.scheduleTasks = (options.scheduleTasks ?? []).map((i) =>
    maybeNew("ScheduleTask", i, cache, options.hasOwnProperty("scheduleTasks"))
  );
  o.impactedScheduleTasks = (options.impactedScheduleTasks ?? []).map((i) =>
    maybeNew("ScheduleTask", i, cache, options.hasOwnProperty("impactedScheduleTasks"))
  );
  o.impactedScheduleSubPhases = (options.impactedScheduleSubPhases ?? []).map((i) =>
    maybeNew("ScheduleSubPhase", i, cache, options.hasOwnProperty("impactedScheduleSubPhases"))
  );
  o.impactedSchedulePhases = (options.impactedSchedulePhases ?? []).map((i) =>
    maybeNew("SchedulePhase", i, cache, options.hasOwnProperty("impactedSchedulePhases"))
  );
  o.impactedSchedules = (options.impactedSchedules ?? []).map((i) =>
    maybeNew("Schedule", i, cache, options.hasOwnProperty("impactedSchedules"))
  );
  o.impacted = (options.impacted ?? []).map((i) =>
    maybeNew("ScheduleEntity", i, cache, options.hasOwnProperty("impacted"))
  );
  o.resultingDelays = (options.resultingDelays ?? []).map((i) =>
    maybeNew("ResultingDelay", i, cache, options.hasOwnProperty("resultingDelays"))
  );
  o.generatedInvoices = (options.generatedInvoices ?? []).map((i) =>
    maybeNew("Invoice", i, cache, options.hasOwnProperty("generatedInvoices"))
  );
  o.generatedDepositBills = (options.generatedDepositBills ?? []).map((i) =>
    maybeNew("Bill", i, cache, options.hasOwnProperty("generatedDepositBills"))
  );
  return o;
}

factories["SaveScheduleTasksResult"] = newSaveScheduleTasksResult;

export interface ResultingDelayOptions {
  __typename?: "ResultingDelay";
  scheduleTask?: ScheduleTask | ScheduleTaskOptions;
  durationInDays?: ResultingDelay["durationInDays"];
  oldTaskStart?: ResultingDelay["oldTaskStart"];
  oldTaskEnd?: ResultingDelay["oldTaskEnd"];
}

export function newResultingDelay(
  options: ResultingDelayOptions = {},
  cache: Record<string, any> = {},
): ResultingDelay {
  const o = (options.__typename ? options : cache["ResultingDelay"] = {}) as ResultingDelay;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ResultingDelay";
  o.scheduleTask = maybeNew("ScheduleTask", options.scheduleTask, cache, options.hasOwnProperty("scheduleTask"));
  o.durationInDays = options.durationInDays ?? 0;
  o.oldTaskStart = options.oldTaskStart ?? newDate();
  o.oldTaskEnd = options.oldTaskEnd ?? newDate();
  return o;
}

factories["ResultingDelay"] = newResultingDelay;

export interface ScheduleTaskChecklistItemOptions {
  __typename?: "ScheduleTaskChecklistItem";
  id?: ScheduleTaskChecklistItem["id"];
  description?: ScheduleTaskChecklistItem["description"];
  completedAt?: ScheduleTaskChecklistItem["completedAt"];
  createdAt?: ScheduleTaskChecklistItem["createdAt"];
  updatedAt?: ScheduleTaskChecklistItem["updatedAt"];
  completedBy?: InternalUser | InternalUserOptions | null;
  isCompleted?: ScheduleTaskChecklistItem["isCompleted"];
  task?: ScheduleTask | ScheduleTaskOptions;
  templateChecklistItem?: ScheduleTaskChecklistItem | ScheduleTaskChecklistItemOptions | null;
  scheduleTaskChecklistItems?: Array<ScheduleTaskChecklistItem | ScheduleTaskChecklistItemOptions>;
  canDelete?: PotentialOperation2 | PotentialOperation2Options;
}

export function newScheduleTaskChecklistItem(
  options: ScheduleTaskChecklistItemOptions = {},
  cache: Record<string, any> = {},
): ScheduleTaskChecklistItem {
  const o = (options.__typename ? options : cache["ScheduleTaskChecklistItem"] = {}) as ScheduleTaskChecklistItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ScheduleTaskChecklistItem";
  o.id = options.id ?? nextFactoryId("ScheduleTaskChecklistItem");
  o.description = options.description ?? "description";
  o.completedAt = options.completedAt ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.completedBy = maybeNewOrNull("InternalUser", options.completedBy, cache);
  o.isCompleted = options.isCompleted ?? false;
  o.task = maybeNew("ScheduleTask", options.task, cache, options.hasOwnProperty("task"));
  o.templateChecklistItem = maybeNewOrNull("ScheduleTaskChecklistItem", options.templateChecklistItem, cache);
  o.scheduleTaskChecklistItems = (options.scheduleTaskChecklistItems ?? []).map((i) =>
    maybeNew("ScheduleTaskChecklistItem", i, cache, options.hasOwnProperty("scheduleTaskChecklistItems"))
  );
  o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
  return o;
}

factories["ScheduleTaskChecklistItem"] = newScheduleTaskChecklistItem;

export interface SaveScheduleTaskChecklistItemResultOptions {
  __typename?: "SaveScheduleTaskChecklistItemResult";
  scheduleTaskChecklistItem?: ScheduleTaskChecklistItem | ScheduleTaskChecklistItemOptions;
}

export function newSaveScheduleTaskChecklistItemResult(
  options: SaveScheduleTaskChecklistItemResultOptions = {},
  cache: Record<string, any> = {},
): SaveScheduleTaskChecklistItemResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveScheduleTaskChecklistItemResult"] = {}) as SaveScheduleTaskChecklistItemResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveScheduleTaskChecklistItemResult";
  o.scheduleTaskChecklistItem = maybeNew(
    "ScheduleTaskChecklistItem",
    options.scheduleTaskChecklistItem,
    cache,
    options.hasOwnProperty("scheduleTaskChecklistItem"),
  );
  return o;
}

factories["SaveScheduleTaskChecklistItemResult"] = newSaveScheduleTaskChecklistItemResult;

export interface ScheduleTaskDependencyOptions {
  __typename?: "ScheduleTaskDependency";
  type?: ScheduleTaskDependency["type"];
  lagInDays?: ScheduleTaskDependency["lagInDays"];
  predecessor?: ScheduleTask | ScheduleTaskOptions;
  successor?: ScheduleTask | ScheduleTaskOptions;
  id?: ScheduleTaskDependency["id"];
}

export function newScheduleTaskDependency(
  options: ScheduleTaskDependencyOptions = {},
  cache: Record<string, any> = {},
): ScheduleTaskDependency {
  const o = (options.__typename ? options : cache["ScheduleTaskDependency"] = {}) as ScheduleTaskDependency;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ScheduleTaskDependency";
  o.type = options.type ?? TaskDependencyType.FinishStart;
  o.lagInDays = options.lagInDays ?? 0;
  o.predecessor = maybeNew("ScheduleTask", options.predecessor, cache, options.hasOwnProperty("predecessor"));
  o.successor = maybeNew("ScheduleTask", options.successor, cache, options.hasOwnProperty("successor"));
  o.id = options.id ?? nextFactoryId("ScheduleTaskDependency");
  return o;
}

factories["ScheduleTaskDependency"] = newScheduleTaskDependency;

export interface ScheduleTemplateOptions {
  __typename?: "ScheduleTemplate";
  id?: ScheduleTemplate["id"];
  name?: ScheduleTemplate["name"];
  createdAt?: ScheduleTemplate["createdAt"];
  updatedAt?: ScheduleTemplate["updatedAt"];
  status?: ScheduleTemplate["status"];
  statusDetail?: ScheduleTemplateStatusDetailOptions | ScheduleTemplateStatus;
  stage?: ScheduleTemplate["stage"];
  stageDetail?: StageDetailOptions | Stage;
  market?: Market | MarketOptions | null;
  schedules?: Array<Schedule | ScheduleOptions>;
  developments?: Array<Development | DevelopmentOptions>;
  itemMappings?: Array<ScheduleTemplateItemMapping | ScheduleTemplateItemMappingOptions>;
}

export function newScheduleTemplate(
  options: ScheduleTemplateOptions = {},
  cache: Record<string, any> = {},
): ScheduleTemplate {
  const o = (options.__typename ? options : cache["ScheduleTemplate"] = {}) as ScheduleTemplate;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ScheduleTemplate";
  o.id = options.id ?? nextFactoryId("ScheduleTemplate");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.status = options.status ?? ScheduleTemplateStatus.Draft;
  o.statusDetail = enumOrDetailOfScheduleTemplateStatus(options.statusDetail);
  o.stage = options.stage ?? Stage.PreConPlanning;
  o.stageDetail = enumOrDetailOfStage(options.stageDetail);
  o.market = maybeNewOrNull("Market", options.market, cache);
  o.schedules = (options.schedules ?? []).map((i) =>
    maybeNew("Schedule", i, cache, options.hasOwnProperty("schedules"))
  );
  o.developments = (options.developments ?? []).map((i) =>
    maybeNew("Development", i, cache, options.hasOwnProperty("developments"))
  );
  o.itemMappings = (options.itemMappings ?? []).map((i) =>
    maybeNew("ScheduleTemplateItemMapping", i, cache, options.hasOwnProperty("itemMappings"))
  );
  return o;
}

factories["ScheduleTemplate"] = newScheduleTemplate;

export interface SaveScheduleTemplatesResultOptions {
  __typename?: "SaveScheduleTemplatesResult";
  scheduleTemplates?: Array<ScheduleTemplate | ScheduleTemplateOptions>;
  userErrors?: Array<UserError | UserErrorOptions> | null;
}

export function newSaveScheduleTemplatesResult(
  options: SaveScheduleTemplatesResultOptions = {},
  cache: Record<string, any> = {},
): SaveScheduleTemplatesResult {
  const o = (options.__typename ? options : cache["SaveScheduleTemplatesResult"] = {}) as SaveScheduleTemplatesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveScheduleTemplatesResult";
  o.scheduleTemplates = (options.scheduleTemplates ?? []).map((i) =>
    maybeNew("ScheduleTemplate", i, cache, options.hasOwnProperty("scheduleTemplates"))
  );
  o.userErrors = (options.userErrors ?? []).map((i) =>
    maybeNew("UserError", i, cache, options.hasOwnProperty("userErrors"))
  );
  return o;
}

factories["SaveScheduleTemplatesResult"] = newSaveScheduleTemplatesResult;

export interface DuplicateScheduleTemplateResultOptions {
  __typename?: "DuplicateScheduleTemplateResult";
  scheduleTemplate?: ScheduleTemplate | ScheduleTemplateOptions | null;
  userErrors?: Array<UserError | UserErrorOptions> | null;
}

export function newDuplicateScheduleTemplateResult(
  options: DuplicateScheduleTemplateResultOptions = {},
  cache: Record<string, any> = {},
): DuplicateScheduleTemplateResult {
  const o =
    (options.__typename ? options : cache["DuplicateScheduleTemplateResult"] = {}) as DuplicateScheduleTemplateResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DuplicateScheduleTemplateResult";
  o.scheduleTemplate = maybeNewOrNull("ScheduleTemplate", options.scheduleTemplate, cache);
  o.userErrors = (options.userErrors ?? []).map((i) =>
    maybeNew("UserError", i, cache, options.hasOwnProperty("userErrors"))
  );
  return o;
}

factories["DuplicateScheduleTemplateResult"] = newDuplicateScheduleTemplateResult;

export interface ApplyScheduleTemplatesResultOptions {
  __typename?: "ApplyScheduleTemplatesResult";
  scheduleParents?: Array<
    | ScheduleParent
    | StandaloneProjectOptions
    | RequireTypename<RegionOptions>
    | RequireTypename<DevelopmentOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>
    | RequireTypename<ScheduleTemplateOptions>
  >;
  schedules?: Array<Schedule | ScheduleOptions>;
}

export function newApplyScheduleTemplatesResult(
  options: ApplyScheduleTemplatesResultOptions = {},
  cache: Record<string, any> = {},
): ApplyScheduleTemplatesResult {
  const o = (options.__typename ? options : cache["ApplyScheduleTemplatesResult"] = {}) as ApplyScheduleTemplatesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ApplyScheduleTemplatesResult";
  o.scheduleParents = (options.scheduleParents ?? []).map((i) =>
    maybeNew(i?.__typename ?? "{StandaloneProject", i, cache, options.hasOwnProperty("scheduleParents"))
  );
  o.schedules = (options.schedules ?? []).map((i) =>
    maybeNew("Schedule", i, cache, options.hasOwnProperty("schedules"))
  );
  return o;
}

factories["ApplyScheduleTemplatesResult"] = newApplyScheduleTemplatesResult;

export interface ScheduleTemplateItemMappingOptions {
  __typename?: "ScheduleTemplateItemMapping";
  id?: ScheduleTemplateItemMapping["id"];
  createdAt?: ScheduleTemplateItemMapping["createdAt"];
  updatedAt?: ScheduleTemplateItemMapping["updatedAt"];
  costType?: CostTypeDetailOptions | CostType;
  item?: Item | ItemOptions;
  location?: Location | LocationOptions;
  scheduleTemplate?: ScheduleTemplate | ScheduleTemplateOptions;
  task?: Task | TaskOptions;
}

export function newScheduleTemplateItemMapping(
  options: ScheduleTemplateItemMappingOptions = {},
  cache: Record<string, any> = {},
): ScheduleTemplateItemMapping {
  const o = (options.__typename ? options : cache["ScheduleTemplateItemMapping"] = {}) as ScheduleTemplateItemMapping;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ScheduleTemplateItemMapping";
  o.id = options.id ?? nextFactoryId("ScheduleTemplateItemMapping");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.costType = enumOrDetailOfCostType(options.costType);
  o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
  o.location = maybeNew("Location", options.location, cache, options.hasOwnProperty("location"));
  o.scheduleTemplate = maybeNew(
    "ScheduleTemplate",
    options.scheduleTemplate,
    cache,
    options.hasOwnProperty("scheduleTemplate"),
  );
  o.task = maybeNew("Task", options.task, cache, options.hasOwnProperty("task"));
  return o;
}

factories["ScheduleTemplateItemMapping"] = newScheduleTemplateItemMapping;

export interface SaveScheduleTemplateItemMappingsResultOptions {
  __typename?: "SaveScheduleTemplateItemMappingsResult";
  scheduleTemplateItemMappings?: Array<ScheduleTemplateItemMapping | ScheduleTemplateItemMappingOptions>;
}

export function newSaveScheduleTemplateItemMappingsResult(
  options: SaveScheduleTemplateItemMappingsResultOptions = {},
  cache: Record<string, any> = {},
): SaveScheduleTemplateItemMappingsResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveScheduleTemplateItemMappingsResult"] = {}) as SaveScheduleTemplateItemMappingsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveScheduleTemplateItemMappingsResult";
  o.scheduleTemplateItemMappings = (options.scheduleTemplateItemMappings ?? []).map((i) =>
    maybeNew("ScheduleTemplateItemMapping", i, cache, options.hasOwnProperty("scheduleTemplateItemMappings"))
  );
  return o;
}

factories["SaveScheduleTemplateItemMappingsResult"] = newSaveScheduleTemplateItemMappingsResult;

export interface SchedulingExclusionDateOptions {
  __typename?: "SchedulingExclusionDate";
  id?: SchedulingExclusionDate["id"];
  date?: SchedulingExclusionDate["date"];
  name?: SchedulingExclusionDate["name"];
  createdAt?: SchedulingExclusionDate["createdAt"];
  updatedAt?: SchedulingExclusionDate["updatedAt"];
  parent?:
    | SchedulingExclusionDateParent
    | StandaloneProjectOptions
    | RequireTypename<RegionOptions>
    | RequireTypename<DevelopmentOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>;
}

export function newSchedulingExclusionDate(
  options: SchedulingExclusionDateOptions = {},
  cache: Record<string, any> = {},
): SchedulingExclusionDate {
  const o = (options.__typename ? options : cache["SchedulingExclusionDate"] = {}) as SchedulingExclusionDate;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SchedulingExclusionDate";
  o.id = options.id ?? nextFactoryId("SchedulingExclusionDate");
  o.date = options.date ?? newDate();
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.parent = maybeNew(options.parent?.__typename ?? "StandaloneProject", options.parent, cache);
  return o;
}

factories["SchedulingExclusionDate"] = newSchedulingExclusionDate;

export interface ScopeChangeReasonOptions {
  __typename?: "ScopeChangeReason";
  id?: ScopeChangeReason["id"];
  name?: ScopeChangeReason["name"];
  createdAt?: ScopeChangeReason["createdAt"];
  updatedAt?: ScopeChangeReason["updatedAt"];
}

export function newScopeChangeReason(
  options: ScopeChangeReasonOptions = {},
  cache: Record<string, any> = {},
): ScopeChangeReason {
  const o = (options.__typename ? options : cache["ScopeChangeReason"] = {}) as ScopeChangeReason;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ScopeChangeReason";
  o.id = options.id ?? nextFactoryId("ScopeChangeReason");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  return o;
}

factories["ScopeChangeReason"] = newScopeChangeReason;

export interface SaveScopeChangeReasonResultOptions {
  __typename?: "SaveScopeChangeReasonResult";
  scopeChangeReason?: ScopeChangeReason | ScopeChangeReasonOptions;
}

export function newSaveScopeChangeReasonResult(
  options: SaveScopeChangeReasonResultOptions = {},
  cache: Record<string, any> = {},
): SaveScopeChangeReasonResult {
  const o = (options.__typename ? options : cache["SaveScopeChangeReasonResult"] = {}) as SaveScopeChangeReasonResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveScopeChangeReasonResult";
  o.scopeChangeReason = maybeNew(
    "ScopeChangeReason",
    options.scopeChangeReason,
    cache,
    options.hasOwnProperty("scopeChangeReason"),
  );
  return o;
}

factories["SaveScopeChangeReasonResult"] = newSaveScopeChangeReasonResult;

export interface SiteSpecificInfoOptions {
  __typename?: "SiteSpecificInfo";
  id?: SiteSpecificInfo["id"];
  description?: SiteSpecificInfo["description"];
  createdAt?: SiteSpecificInfo["createdAt"];
  updatedAt?: SiteSpecificInfo["updatedAt"];
}

export function newSiteSpecificInfo(
  options: SiteSpecificInfoOptions = {},
  cache: Record<string, any> = {},
): SiteSpecificInfo {
  const o = (options.__typename ? options : cache["SiteSpecificInfo"] = {}) as SiteSpecificInfo;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SiteSpecificInfo";
  o.id = options.id ?? nextFactoryId("SiteSpecificInfo");
  o.description = options.description ?? "description";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  return o;
}

factories["SiteSpecificInfo"] = newSiteSpecificInfo;

export interface SaveSiteSpecificInfoResultOptions {
  __typename?: "SaveSiteSpecificInfoResult";
  siteSpecificInfo?: SiteSpecificInfo | SiteSpecificInfoOptions;
}

export function newSaveSiteSpecificInfoResult(
  options: SaveSiteSpecificInfoResultOptions = {},
  cache: Record<string, any> = {},
): SaveSiteSpecificInfoResult {
  const o = (options.__typename ? options : cache["SaveSiteSpecificInfoResult"] = {}) as SaveSiteSpecificInfoResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveSiteSpecificInfoResult";
  o.siteSpecificInfo = maybeNew(
    "SiteSpecificInfo",
    options.siteSpecificInfo,
    cache,
    options.hasOwnProperty("siteSpecificInfo"),
  );
  return o;
}

factories["SaveSiteSpecificInfoResult"] = newSaveSiteSpecificInfoResult;

export interface SaveStructureResultOptions {
  __typename?: "SaveStructureResult";
  structure?: Structure | StructureOptions;
}

export function newSaveStructureResult(
  options: SaveStructureResultOptions = {},
  cache: Record<string, any> = {},
): SaveStructureResult {
  const o = (options.__typename ? options : cache["SaveStructureResult"] = {}) as SaveStructureResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveStructureResult";
  o.structure = maybeNew("Structure", options.structure, cache, options.hasOwnProperty("structure"));
  return o;
}

factories["SaveStructureResult"] = newSaveStructureResult;

export interface StructuresPageResultOptions {
  __typename?: "StructuresPageResult";
  entities?: Array<Structure | StructureOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newStructuresPageResult(
  options: StructuresPageResultOptions = {},
  cache: Record<string, any> = {},
): StructuresPageResult {
  const o = (options.__typename ? options : cache["StructuresPageResult"] = {}) as StructuresPageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "StructuresPageResult";
  o.entities = (options.entities ?? []).map((i) => maybeNew("Structure", i, cache, options.hasOwnProperty("entities")));
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["StructuresPageResult"] = newStructuresPageResult;

export interface SaveSubdivisionResultOptions {
  __typename?: "SaveSubdivisionResult";
  subdivision?: Subdivision | SubdivisionOptions;
}

export function newSaveSubdivisionResult(
  options: SaveSubdivisionResultOptions = {},
  cache: Record<string, any> = {},
): SaveSubdivisionResult {
  const o = (options.__typename ? options : cache["SaveSubdivisionResult"] = {}) as SaveSubdivisionResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveSubdivisionResult";
  o.subdivision = maybeNew("Subdivision", options.subdivision, cache, options.hasOwnProperty("subdivision"));
  return o;
}

factories["SaveSubdivisionResult"] = newSaveSubdivisionResult;

export interface SubmarketOptions {
  __typename?: "Submarket";
  id?: Submarket["id"];
  name?: Submarket["name"];
  createdAt?: Submarket["createdAt"];
  updatedAt?: Submarket["updatedAt"];
  market?: Market | MarketOptions;
}

export function newSubmarket(options: SubmarketOptions = {}, cache: Record<string, any> = {}): Submarket {
  const o = (options.__typename ? options : cache["Submarket"] = {}) as Submarket;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Submarket";
  o.id = options.id ?? nextFactoryId("Submarket");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.market = maybeNew("Market", options.market, cache, options.hasOwnProperty("market"));
  return o;
}

factories["Submarket"] = newSubmarket;

export interface SaveSubmarketResultOptions {
  __typename?: "SaveSubmarketResult";
  submarket?: Submarket | SubmarketOptions;
}

export function newSaveSubmarketResult(
  options: SaveSubmarketResultOptions = {},
  cache: Record<string, any> = {},
): SaveSubmarketResult {
  const o = (options.__typename ? options : cache["SaveSubmarketResult"] = {}) as SaveSubmarketResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveSubmarketResult";
  o.submarket = maybeNew("Submarket", options.submarket, cache, options.hasOwnProperty("submarket"));
  return o;
}

factories["SaveSubmarketResult"] = newSaveSubmarketResult;

export interface CopyTakeoffLineItemsResultOptions {
  __typename?: "CopyTakeoffLineItemsResult";
  targetReadyPlan?: ReadyPlan | ReadyPlanOptions;
  sourceReadyPlans?: Array<ReadyPlan | ReadyPlanOptions>;
  sourceItems?: Array<TakeoffLineItem | TakeoffLineItemOptions>;
  copiedItems?: Array<TakeoffLineItem | TakeoffLineItemOptions>;
}

export function newCopyTakeoffLineItemsResult(
  options: CopyTakeoffLineItemsResultOptions = {},
  cache: Record<string, any> = {},
): CopyTakeoffLineItemsResult {
  const o = (options.__typename ? options : cache["CopyTakeoffLineItemsResult"] = {}) as CopyTakeoffLineItemsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CopyTakeoffLineItemsResult";
  o.targetReadyPlan = maybeNew("ReadyPlan", options.targetReadyPlan, cache, options.hasOwnProperty("targetReadyPlan"));
  o.sourceReadyPlans = (options.sourceReadyPlans ?? []).map((i) =>
    maybeNew("ReadyPlan", i, cache, options.hasOwnProperty("sourceReadyPlans"))
  );
  o.sourceItems = (options.sourceItems ?? []).map((i) =>
    maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("sourceItems"))
  );
  o.copiedItems = (options.copiedItems ?? []).map((i) =>
    maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("copiedItems"))
  );
  return o;
}

factories["CopyTakeoffLineItemsResult"] = newCopyTakeoffLineItemsResult;

export interface TakeoffLineItemsPageOptions {
  __typename?: "TakeoffLineItemsPage";
  items?: Array<TakeoffLineItem | TakeoffLineItemOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
  groupTotals?: Array<TakeoffLineItemGroupTotal | TakeoffLineItemGroupTotalOptions>;
}

export function newTakeoffLineItemsPage(
  options: TakeoffLineItemsPageOptions = {},
  cache: Record<string, any> = {},
): TakeoffLineItemsPage {
  const o = (options.__typename ? options : cache["TakeoffLineItemsPage"] = {}) as TakeoffLineItemsPage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TakeoffLineItemsPage";
  o.items = (options.items ?? []).map((i) => maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("items")));
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  o.groupTotals = (options.groupTotals ?? []).map((i) =>
    maybeNew("TakeoffLineItemGroupTotal", i, cache, options.hasOwnProperty("groupTotals"))
  );
  return o;
}

factories["TakeoffLineItemsPage"] = newTakeoffLineItemsPage;

export interface TakeoffLineItemGroupTotalOptions {
  __typename?: "TakeoffLineItemGroupTotal";
  groupId?: TakeoffLineItemGroupTotal["groupId"];
  totalCostInCents?: TakeoffLineItemGroupTotal["totalCostInCents"];
  tlisInGroup?: TakeoffLineItemGroupTotal["tlisInGroup"];
  tliIdsInGroup?: TakeoffLineItemGroupTotal["tliIdsInGroup"];
  activeTliIdsInGroup?: TakeoffLineItemGroupTotal["activeTliIdsInGroup"];
  displayName?: TakeoffLineItemGroupTotal["displayName"];
  materialsInGroup?: TakeoffLineItemGroupTotal["materialsInGroup"];
  tasksInGroup?: TakeoffLineItemGroupTotal["tasksInGroup"];
}

export function newTakeoffLineItemGroupTotal(
  options: TakeoffLineItemGroupTotalOptions = {},
  cache: Record<string, any> = {},
): TakeoffLineItemGroupTotal {
  const o = (options.__typename ? options : cache["TakeoffLineItemGroupTotal"] = {}) as TakeoffLineItemGroupTotal;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TakeoffLineItemGroupTotal";
  o.groupId = options.groupId ?? "groupId";
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.tlisInGroup = options.tlisInGroup ?? 0;
  o.tliIdsInGroup = options.tliIdsInGroup ?? [];
  o.activeTliIdsInGroup = options.activeTliIdsInGroup ?? [];
  o.displayName = options.displayName ?? "displayName";
  o.materialsInGroup = options.materialsInGroup ?? 0;
  o.tasksInGroup = options.tasksInGroup ?? 0;
  return o;
}

factories["TakeoffLineItemGroupTotal"] = newTakeoffLineItemGroupTotal;

export interface TakeoffLineItemOptions {
  __typename?: "TakeoffLineItem";
  id?: TakeoffLineItem["id"];
  identityId?: TakeoffLineItem["identityId"];
  active?: TakeoffLineItem["active"];
  name?: TakeoffLineItem["name"];
  displayName?: TakeoffLineItem["displayName"];
  parent?: ReadyPlan | PlanPackage | DesignPackage | ProductOffering | ReadyPlanLike | ReadyPlanLikeOptions;
  readyPlan?: ReadyPlan | PlanPackage | DesignPackage | ProductOffering | ReadyPlanLike | ReadyPlanLikeOptions;
  first?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  customPlaceholderName?: TakeoffLineItem["customPlaceholderName"];
  quantity?: TakeoffLineItem["quantity"];
  totalCostInCents?: TakeoffLineItem["totalCostInCents"];
  unitCostInCents?: TakeoffLineItem["unitCostInCents"];
  isDisabledMaterialVariant?: TakeoffLineItem["isDisabledMaterialVariant"];
  tradePartnerNote?: TakeoffLineItem["tradePartnerNote"];
  internalNote?: TakeoffLineItem["internalNote"];
  specifications?: TakeoffLineItem["specifications"];
  createdAt?: TakeoffLineItem["createdAt"];
  updatedAt?: TakeoffLineItem["updatedAt"];
  costType?: TakeoffLineItem["costType"];
  costTypeDetail?: CostTypeDetailOptions | CostType;
  costStatus?: ItemTemplateItemCostStatusDetailOptions | ItemTemplateItemCostStatus;
  placeholder?: TakeoffLineItem | TakeoffLineItemOptions | null;
  preferredBidContractLineItem?: BidContractLineItem | BidContractLineItemOptions | null;
  bidItem?: BidItem | BidItemOptions | null;
  bidItemTemplateItem?: TakeoffLineItem | TakeoffLineItemOptions | null;
  baseProduct?: Product | ProductOptions | null;
  development?: Development | DevelopmentOptions | null;
  drop?: Drop | DropOptions | null;
  item?: Item | ItemOptions;
  slot?: ItemSlot | ItemSlotOptions;
  location?: Location | LocationOptions;
  materialVariant?: MaterialVariant | MaterialVariantOptions | null;
  task?: GlobalPlanTask | GlobalPlanTaskOptions | null;
  unitOfMeasure?: UnitOfMeasure | UnitOfMeasureOptions;
  products?: Array<TakeoffLineItem | TakeoffLineItemOptions>;
  options?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  rootAssemblyItem?: TakeoffLineItem | TakeoffLineItemOptions | null;
  assemblyRootItem?: TakeoffLineItem | TakeoffLineItemOptions | null;
  childItems?: Array<TakeoffLineItem | TakeoffLineItemOptions>;
  canEdit?: PotentialOperation2 | PotentialOperation2Options;
  canEditLocation?: PotentialOperation2 | PotentialOperation2Options;
  canEditOptions?: PotentialOperation2 | PotentialOperation2Options;
  canEditQuantity?: PotentialOperation2 | PotentialOperation2Options;
  canEditMaterial?: PotentialOperation2 | PotentialOperation2Options;
  canDuplicate?: PotentialOperation2 | PotentialOperation2Options;
  canDeleteFromDesignPackage?: PotentialOperation2 | PotentialOperation2Options;
  dpSignature?: TakeoffLineItem["dpSignature"];
  blueprintUrl?: Url | UrlOptions;
  elevationIds?: TakeoffLineItem["elevationIds"];
  specOptionIds?: TakeoffLineItem["specOptionIds"];
  otherOptionIds?: TakeoffLineItem["otherOptionIds"];
  laborLine?: TakeoffLineItem | TakeoffLineItemOptions | null;
  costEstimate?: CostEstimate | CostEstimateOptions;
  isPlaceholderMaterial?: TakeoffLineItem["isPlaceholderMaterial"];
  isProductMaterial?: TakeoffLineItem["isProductMaterial"];
  changeType?: TakeoffLineItem["changeType"];
  previous?: TakeoffLineItemVersion | TakeoffLineItemVersionOptions | null;
  planLines?: Array<TakeoffLineItem | TakeoffLineItemOptions>;
  personalizationOptionGroup?: ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions | null;
  personalizationPlaceholderControlledSlots?: Array<TakeoffLineItem | TakeoffLineItemOptions>;
  personalizationShadowPlaceholder?: TakeoffLineItem | TakeoffLineItemOptions | null;
  personalizationIdpShadowPlaceholder?: TakeoffLineItem | TakeoffLineItemOptions | null;
  personalizationRpoShadowPlaceholder?: TakeoffLineItem | TakeoffLineItemOptions | null;
  designPackageType?: TakeoffLineItemDesignPackageTypeDetailOptions | TakeoffLineItemDesignPackageType | null;
  targetGroups?: Array<ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions>;
  targetCombinations?: Array<DesignPackageOptionCombination | DesignPackageOptionCombinationOptions>;
  missingCombinations?: Array<DesignPackageOptionCombination | DesignPackageOptionCombinationOptions>;
  designNotes?: Array<ReadyPlanDesignNote | ReadyPlanDesignNoteOptions>;
  packageDesignNotes?: TakeoffLineItem["packageDesignNotes"];
  targetPlan?: PlanPackage | PlanPackageOptions | null;
  personalizationSlotOrder?: TakeoffLineItem["personalizationSlotOrder"];
  isTaxExempt?: TakeoffLineItem["isTaxExempt"];
  taxableCostInCents?: TakeoffLineItem["taxableCostInCents"];
  taxInCents?: TakeoffLineItem["taxInCents"];
}

export function newTakeoffLineItem(
  options: TakeoffLineItemOptions = {},
  cache: Record<string, any> = {},
): TakeoffLineItem {
  const o = (options.__typename ? options : cache["TakeoffLineItem"] = {}) as TakeoffLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TakeoffLineItem";
  o.id = options.id ?? nextFactoryId("TakeoffLineItem");
  o.identityId = options.identityId ?? "identityId";
  o.active = options.active ?? false;
  o.name = options.name ?? "name";
  o.displayName = options.displayName ?? "displayName";
  o.parent = maybeNew("ReadyPlanLike", options.parent, cache, options.hasOwnProperty("parent"));
  o.readyPlan = maybeNew("ReadyPlanLike", options.readyPlan, cache, options.hasOwnProperty("readyPlan"));
  o.first = maybeNew("ReadyPlanAggregateVersion", options.first, cache, options.hasOwnProperty("first"));
  o.customPlaceholderName = options.customPlaceholderName ?? null;
  o.quantity = options.quantity ?? null;
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.unitCostInCents = options.unitCostInCents ?? 0;
  o.isDisabledMaterialVariant = options.isDisabledMaterialVariant ?? false;
  o.tradePartnerNote = options.tradePartnerNote ?? null;
  o.internalNote = options.internalNote ?? null;
  o.specifications = options.specifications ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.costType = options.costType ?? CostType.Labor;
  o.costTypeDetail = enumOrDetailOfCostType(options.costTypeDetail);
  o.costStatus = enumOrDetailOfItemTemplateItemCostStatus(options.costStatus);
  o.placeholder = maybeNewOrNull("TakeoffLineItem", options.placeholder, cache);
  o.preferredBidContractLineItem = maybeNewOrNull("BidContractLineItem", options.preferredBidContractLineItem, cache);
  o.bidItem = maybeNewOrNull("BidItem", options.bidItem, cache);
  o.bidItemTemplateItem = maybeNewOrNull("TakeoffLineItem", options.bidItemTemplateItem, cache);
  o.baseProduct = maybeNewOrNull("Product", options.baseProduct, cache);
  o.development = maybeNewOrNull("Development", options.development, cache);
  o.drop = maybeNewOrNull("Drop", options.drop, cache);
  o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
  o.slot = maybeNew("ItemSlot", options.slot, cache, options.hasOwnProperty("slot"));
  o.location = maybeNew("Location", options.location, cache, options.hasOwnProperty("location"));
  o.materialVariant = maybeNewOrNull("MaterialVariant", options.materialVariant, cache);
  o.task = maybeNewOrNull("GlobalPlanTask", options.task, cache);
  o.unitOfMeasure = maybeNew("UnitOfMeasure", options.unitOfMeasure, cache, options.hasOwnProperty("unitOfMeasure"));
  o.products = (options.products ?? []).map((i) =>
    maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("products"))
  );
  o.options = (options.options ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("options"))
  );
  o.rootAssemblyItem = maybeNewOrNull("TakeoffLineItem", options.rootAssemblyItem, cache);
  o.assemblyRootItem = maybeNewOrNull("TakeoffLineItem", options.assemblyRootItem, cache);
  o.childItems = (options.childItems ?? []).map((i) =>
    maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("childItems"))
  );
  o.canEdit = maybeNew("PotentialOperation2", options.canEdit, cache, options.hasOwnProperty("canEdit"));
  o.canEditLocation = maybeNew(
    "PotentialOperation2",
    options.canEditLocation,
    cache,
    options.hasOwnProperty("canEditLocation"),
  );
  o.canEditOptions = maybeNew(
    "PotentialOperation2",
    options.canEditOptions,
    cache,
    options.hasOwnProperty("canEditOptions"),
  );
  o.canEditQuantity = maybeNew(
    "PotentialOperation2",
    options.canEditQuantity,
    cache,
    options.hasOwnProperty("canEditQuantity"),
  );
  o.canEditMaterial = maybeNew(
    "PotentialOperation2",
    options.canEditMaterial,
    cache,
    options.hasOwnProperty("canEditMaterial"),
  );
  o.canDuplicate = maybeNew("PotentialOperation2", options.canDuplicate, cache, options.hasOwnProperty("canDuplicate"));
  o.canDeleteFromDesignPackage = maybeNew(
    "PotentialOperation2",
    options.canDeleteFromDesignPackage,
    cache,
    options.hasOwnProperty("canDeleteFromDesignPackage"),
  );
  o.dpSignature = options.dpSignature ?? "dpSignature";
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.elevationIds = options.elevationIds ?? [];
  o.specOptionIds = options.specOptionIds ?? [];
  o.otherOptionIds = options.otherOptionIds ?? [];
  o.laborLine = maybeNewOrNull("TakeoffLineItem", options.laborLine, cache);
  o.costEstimate = maybeNew("CostEstimate", options.costEstimate, cache, options.hasOwnProperty("costEstimate"));
  o.isPlaceholderMaterial = options.isPlaceholderMaterial ?? false;
  o.isProductMaterial = options.isProductMaterial ?? false;
  o.changeType = options.changeType ?? "changeType";
  o.previous = maybeNewOrNull("TakeoffLineItemVersion", options.previous, cache);
  o.planLines = (options.planLines ?? []).map((i) =>
    maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("planLines"))
  );
  o.personalizationOptionGroup = maybeNewOrNull("ReadyPlanOptionGroup", options.personalizationOptionGroup, cache);
  o.personalizationPlaceholderControlledSlots = (options.personalizationPlaceholderControlledSlots ?? []).map((i) =>
    maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("personalizationPlaceholderControlledSlots"))
  );
  o.personalizationShadowPlaceholder = maybeNewOrNull(
    "TakeoffLineItem",
    options.personalizationShadowPlaceholder,
    cache,
  );
  o.personalizationIdpShadowPlaceholder = maybeNewOrNull(
    "TakeoffLineItem",
    options.personalizationIdpShadowPlaceholder,
    cache,
  );
  o.personalizationRpoShadowPlaceholder = maybeNewOrNull(
    "TakeoffLineItem",
    options.personalizationRpoShadowPlaceholder,
    cache,
  );
  o.designPackageType = enumOrDetailOrNullOfTakeoffLineItemDesignPackageType(options.designPackageType);
  o.targetGroups = (options.targetGroups ?? []).map((i) =>
    maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("targetGroups"))
  );
  o.targetCombinations = (options.targetCombinations ?? []).map((i) =>
    maybeNew("DesignPackageOptionCombination", i, cache, options.hasOwnProperty("targetCombinations"))
  );
  o.missingCombinations = (options.missingCombinations ?? []).map((i) =>
    maybeNew("DesignPackageOptionCombination", i, cache, options.hasOwnProperty("missingCombinations"))
  );
  o.designNotes = (options.designNotes ?? []).map((i) =>
    maybeNew("ReadyPlanDesignNote", i, cache, options.hasOwnProperty("designNotes"))
  );
  o.packageDesignNotes = options.packageDesignNotes ?? null;
  o.targetPlan = maybeNewOrNull("PlanPackage", options.targetPlan, cache);
  o.personalizationSlotOrder = options.personalizationSlotOrder ?? null;
  o.isTaxExempt = options.isTaxExempt ?? false;
  o.taxableCostInCents = options.taxableCostInCents ?? 0;
  o.taxInCents = options.taxInCents ?? 0;
  return o;
}

factories["TakeoffLineItem"] = newTakeoffLineItem;

export interface SaveTakeoffLineItemResultOptions {
  __typename?: "SaveTakeoffLineItemResult";
  version?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  takeoffLineItems?: Array<TakeoffLineItem | TakeoffLineItemOptions>;
  autoAddedLaborLines?: Array<TakeoffLineItem | TakeoffLineItemOptions>;
  removed?: Array<TakeoffLineItem | TakeoffLineItemOptions>;
  deleted?: SaveTakeoffLineItemResult["deleted"];
  groupTotals?: Array<TakeoffLineItemGroupTotal | TakeoffLineItemGroupTotalOptions>;
}

export function newSaveTakeoffLineItemResult(
  options: SaveTakeoffLineItemResultOptions = {},
  cache: Record<string, any> = {},
): SaveTakeoffLineItemResult {
  const o = (options.__typename ? options : cache["SaveTakeoffLineItemResult"] = {}) as SaveTakeoffLineItemResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveTakeoffLineItemResult";
  o.version = maybeNew("ReadyPlanAggregateVersion", options.version, cache, options.hasOwnProperty("version"));
  o.takeoffLineItems = (options.takeoffLineItems ?? []).map((i) =>
    maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("takeoffLineItems"))
  );
  o.autoAddedLaborLines = (options.autoAddedLaborLines ?? []).map((i) =>
    maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("autoAddedLaborLines"))
  );
  o.removed = (options.removed ?? []).map((i) =>
    maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("removed"))
  );
  o.deleted = options.deleted ?? [];
  o.groupTotals = (options.groupTotals ?? []).map((i) =>
    maybeNew("TakeoffLineItemGroupTotal", i, cache, options.hasOwnProperty("groupTotals"))
  );
  return o;
}

factories["SaveTakeoffLineItemResult"] = newSaveTakeoffLineItemResult;

export interface TakeoffLineItemVersionOptions {
  __typename?: "TakeoffLineItemVersion";
  id?: TakeoffLineItemVersion["id"];
  identityId?: TakeoffLineItemVersion["identityId"];
  quantity?: TakeoffLineItemVersion["quantity"];
  createdAt?: TakeoffLineItemVersion["createdAt"];
  updatedAt?: TakeoffLineItemVersion["updatedAt"];
  specifications?: TakeoffLineItemVersion["specifications"];
  totalCostInCents?: TakeoffLineItemVersion["totalCostInCents"];
  unitCostInCents?: TakeoffLineItemVersion["unitCostInCents"];
  tradePartnerNote?: TakeoffLineItemVersion["tradePartnerNote"];
  internalNote?: TakeoffLineItemVersion["internalNote"];
  name?: TakeoffLineItemVersion["name"];
  displayName?: TakeoffLineItemVersion["displayName"];
  parent?: ReadyPlan | PlanPackage | DesignPackage | ProductOffering | ReadyPlanLike | ReadyPlanLikeOptions;
  readyPlan?: ReadyPlan | PlanPackage | DesignPackage | ProductOffering | ReadyPlanLike | ReadyPlanLikeOptions;
  isDisabledMaterialVariant?: TakeoffLineItemVersion["isDisabledMaterialVariant"];
  placeholder?: TakeoffLineItem | TakeoffLineItemOptions | null;
  customPlaceholderName?: TakeoffLineItemVersion["customPlaceholderName"];
  costType?: TakeoffLineItemVersion["costType"];
  costTypeDetail?: CostTypeDetailOptions | CostType;
  type?: TakeoffLineItemTypeDetailOptions | TakeoffLineItemType;
  preferredBidContractLineItem?: BidContractLineItem | BidContractLineItemOptions | null;
  bidItem?: BidItem | BidItemOptions | null;
  bidItemTemplateItem?: TakeoffLineItemVersion | TakeoffLineItemVersionOptions | null;
  baseProduct?: Product | ProductOptions | null;
  item?: Item | ItemOptions;
  slot?: ItemSlot | ItemSlotOptions;
  location?: Location | LocationOptions;
  unitOfMeasure?: UnitOfMeasure | UnitOfMeasureOptions;
  dpSignature?: TakeoffLineItemVersion["dpSignature"];
  canDeleteFromDesignPackage?: PotentialOperation2 | PotentialOperation2Options;
  options?: Array<ReadyPlanOption | ReadyPlanOptionOptions>;
  costStatus?: ItemTemplateItemCostStatusDetailOptions | ItemTemplateItemCostStatus | null;
  development?: Development | DevelopmentOptions | null;
  drop?: Drop | DropOptions | null;
  task?: GlobalPlanTask | GlobalPlanTaskOptions | null;
  materialVariant?: MaterialVariant | MaterialVariantOptions | null;
  final?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions | null;
  first?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  identity?: TakeoffLineItem | TakeoffLineItemOptions;
  active?: TakeoffLineItemVersion["active"];
  blueprintUrl?: Url | UrlOptions;
  elevationIds?: TakeoffLineItemVersion["elevationIds"];
  specOptionIds?: TakeoffLineItemVersion["specOptionIds"];
  otherOptionIds?: TakeoffLineItemVersion["otherOptionIds"];
  laborLine?: TakeoffLineItem | TakeoffLineItemOptions | null;
  costEstimate?: CostEstimate | CostEstimateOptions;
  changeType?: TakeoffLineItemVersion["changeType"];
  planLines?: Array<TakeoffLineItem | TakeoffLineItemOptions>;
  targetGroups?: Array<ReadyPlanOptionGroup | ReadyPlanOptionGroupOptions>;
  targetCombinations?: Array<DesignPackageOptionCombination | DesignPackageOptionCombinationOptions>;
  missingCombinations?: Array<DesignPackageOptionCombination | DesignPackageOptionCombinationOptions>;
  packageDesignNotes?: TakeoffLineItemVersion["packageDesignNotes"];
  isTaxExempt?: TakeoffLineItemVersion["isTaxExempt"];
  taxableCostInCents?: TakeoffLineItemVersion["taxableCostInCents"];
  taxInCents?: TakeoffLineItemVersion["taxInCents"];
}

export function newTakeoffLineItemVersion(
  options: TakeoffLineItemVersionOptions = {},
  cache: Record<string, any> = {},
): TakeoffLineItemVersion {
  const o = (options.__typename ? options : cache["TakeoffLineItemVersion"] = {}) as TakeoffLineItemVersion;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TakeoffLineItemVersion";
  o.id = options.id ?? nextFactoryId("TakeoffLineItemVersion");
  o.identityId = options.identityId ?? "identityId";
  o.quantity = options.quantity ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.specifications = options.specifications ?? null;
  o.totalCostInCents = options.totalCostInCents ?? 0;
  o.unitCostInCents = options.unitCostInCents ?? 0;
  o.tradePartnerNote = options.tradePartnerNote ?? null;
  o.internalNote = options.internalNote ?? null;
  o.name = options.name ?? "name";
  o.displayName = options.displayName ?? "displayName";
  o.parent = maybeNew("ReadyPlanLike", options.parent, cache, options.hasOwnProperty("parent"));
  o.readyPlan = maybeNew("ReadyPlanLike", options.readyPlan, cache, options.hasOwnProperty("readyPlan"));
  o.isDisabledMaterialVariant = options.isDisabledMaterialVariant ?? false;
  o.placeholder = maybeNewOrNull("TakeoffLineItem", options.placeholder, cache);
  o.customPlaceholderName = options.customPlaceholderName ?? null;
  o.costType = options.costType ?? CostType.Labor;
  o.costTypeDetail = enumOrDetailOfCostType(options.costTypeDetail);
  o.type = enumOrDetailOfTakeoffLineItemType(options.type);
  o.preferredBidContractLineItem = maybeNewOrNull("BidContractLineItem", options.preferredBidContractLineItem, cache);
  o.bidItem = maybeNewOrNull("BidItem", options.bidItem, cache);
  o.bidItemTemplateItem = maybeNewOrNull("TakeoffLineItemVersion", options.bidItemTemplateItem, cache);
  o.baseProduct = maybeNewOrNull("Product", options.baseProduct, cache);
  o.item = maybeNew("Item", options.item, cache, options.hasOwnProperty("item"));
  o.slot = maybeNew("ItemSlot", options.slot, cache, options.hasOwnProperty("slot"));
  o.location = maybeNew("Location", options.location, cache, options.hasOwnProperty("location"));
  o.unitOfMeasure = maybeNew("UnitOfMeasure", options.unitOfMeasure, cache, options.hasOwnProperty("unitOfMeasure"));
  o.dpSignature = options.dpSignature ?? "dpSignature";
  o.canDeleteFromDesignPackage = maybeNew(
    "PotentialOperation2",
    options.canDeleteFromDesignPackage,
    cache,
    options.hasOwnProperty("canDeleteFromDesignPackage"),
  );
  o.options = (options.options ?? []).map((i) =>
    maybeNew("ReadyPlanOption", i, cache, options.hasOwnProperty("options"))
  );
  o.costStatus = enumOrDetailOrNullOfItemTemplateItemCostStatus(options.costStatus);
  o.development = maybeNewOrNull("Development", options.development, cache);
  o.drop = maybeNewOrNull("Drop", options.drop, cache);
  o.task = maybeNewOrNull("GlobalPlanTask", options.task, cache);
  o.materialVariant = maybeNewOrNull("MaterialVariant", options.materialVariant, cache);
  o.final = maybeNewOrNull("ReadyPlanAggregateVersion", options.final, cache);
  o.first = maybeNew("ReadyPlanAggregateVersion", options.first, cache, options.hasOwnProperty("first"));
  o.identity = maybeNew("TakeoffLineItem", options.identity, cache, options.hasOwnProperty("identity"));
  o.active = options.active ?? false;
  o.blueprintUrl = maybeNew("Url", options.blueprintUrl, cache, options.hasOwnProperty("blueprintUrl"));
  o.elevationIds = options.elevationIds ?? [];
  o.specOptionIds = options.specOptionIds ?? [];
  o.otherOptionIds = options.otherOptionIds ?? [];
  o.laborLine = maybeNewOrNull("TakeoffLineItem", options.laborLine, cache);
  o.costEstimate = maybeNew("CostEstimate", options.costEstimate, cache, options.hasOwnProperty("costEstimate"));
  o.changeType = options.changeType ?? "changeType";
  o.planLines = (options.planLines ?? []).map((i) =>
    maybeNew("TakeoffLineItem", i, cache, options.hasOwnProperty("planLines"))
  );
  o.targetGroups = (options.targetGroups ?? []).map((i) =>
    maybeNew("ReadyPlanOptionGroup", i, cache, options.hasOwnProperty("targetGroups"))
  );
  o.targetCombinations = (options.targetCombinations ?? []).map((i) =>
    maybeNew("DesignPackageOptionCombination", i, cache, options.hasOwnProperty("targetCombinations"))
  );
  o.missingCombinations = (options.missingCombinations ?? []).map((i) =>
    maybeNew("DesignPackageOptionCombination", i, cache, options.hasOwnProperty("missingCombinations"))
  );
  o.packageDesignNotes = options.packageDesignNotes ?? null;
  o.isTaxExempt = options.isTaxExempt ?? false;
  o.taxableCostInCents = options.taxableCostInCents ?? 0;
  o.taxInCents = options.taxInCents ?? 0;
  return o;
}

factories["TakeoffLineItemVersion"] = newTakeoffLineItemVersion;

export interface TaskPageOptions {
  __typename?: "TaskPage";
  tasks?: Array<Task | TaskOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newTaskPage(options: TaskPageOptions = {}, cache: Record<string, any> = {}): TaskPage {
  const o = (options.__typename ? options : cache["TaskPage"] = {}) as TaskPage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TaskPage";
  o.tasks = (options.tasks ?? []).map((i) => maybeNew("Task", i, cache, options.hasOwnProperty("tasks")));
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["TaskPage"] = newTaskPage;

export interface TaskDependencyOptions {
  __typename?: "TaskDependency";
  type?: TaskDependency["type"];
  typeDetail?: TaskDependencyTypeDetailOptions | TaskDependencyType;
  lagInDays?: TaskDependency["lagInDays"];
  predecessor?: Task | TaskOptions;
  successor?: Task | TaskOptions;
}

export function newTaskDependency(
  options: TaskDependencyOptions = {},
  cache: Record<string, any> = {},
): TaskDependency {
  const o = (options.__typename ? options : cache["TaskDependency"] = {}) as TaskDependency;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TaskDependency";
  o.type = options.type ?? TaskDependencyType.FinishStart;
  o.typeDetail = enumOrDetailOfTaskDependencyType(options.typeDetail);
  o.lagInDays = options.lagInDays ?? 0;
  o.predecessor = maybeNew("Task", options.predecessor, cache, options.hasOwnProperty("predecessor"));
  o.successor = maybeNew("Task", options.successor, cache, options.hasOwnProperty("successor"));
  return o;
}

factories["TaskDependency"] = newTaskDependency;

export interface TaskSnapshotOptions {
  __typename?: "TaskSnapshot";
  id?: TaskSnapshot["id"];
  range?: TaskSnapshot["range"];
  startDate?: TaskSnapshot["startDate"];
  endDate?: TaskSnapshot["endDate"];
  durationInDays?: TaskSnapshot["durationInDays"];
  createdAt?: TaskSnapshot["createdAt"];
  updatedAt?: TaskSnapshot["updatedAt"];
  task?: Task | TaskOptions;
}

export function newTaskSnapshot(options: TaskSnapshotOptions = {}, cache: Record<string, any> = {}): TaskSnapshot {
  const o = (options.__typename ? options : cache["TaskSnapshot"] = {}) as TaskSnapshot;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TaskSnapshot";
  o.id = options.id ?? nextFactoryId("TaskSnapshot");
  o.range = options.range ?? "range";
  o.startDate = options.startDate ?? newDate();
  o.endDate = options.endDate ?? newDate();
  o.durationInDays = options.durationInDays ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.task = maybeNew("Task", options.task, cache, options.hasOwnProperty("task"));
  return o;
}

factories["TaskSnapshot"] = newTaskSnapshot;

export interface TaskWorkDayOptions {
  __typename?: "TaskWorkDay";
  id?: TaskWorkDay["id"];
  workDay?: TaskWorkDay["workDay"];
  createdAt?: TaskWorkDay["createdAt"];
  updatedAt?: TaskWorkDay["updatedAt"];
  task?: Task | TaskOptions;
}

export function newTaskWorkDay(options: TaskWorkDayOptions = {}, cache: Record<string, any> = {}): TaskWorkDay {
  const o = (options.__typename ? options : cache["TaskWorkDay"] = {}) as TaskWorkDay;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TaskWorkDay";
  o.id = options.id ?? nextFactoryId("TaskWorkDay");
  o.workDay = options.workDay ?? newDate();
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.task = maybeNew("Task", options.task, cache, options.hasOwnProperty("task"));
  return o;
}

factories["TaskWorkDay"] = newTaskWorkDay;

export interface SaveTaskWorkDayResultOptions {
  __typename?: "SaveTaskWorkDayResult";
  taskWorkDay?: TaskWorkDay | TaskWorkDayOptions;
}

export function newSaveTaskWorkDayResult(
  options: SaveTaskWorkDayResultOptions = {},
  cache: Record<string, any> = {},
): SaveTaskWorkDayResult {
  const o = (options.__typename ? options : cache["SaveTaskWorkDayResult"] = {}) as SaveTaskWorkDayResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveTaskWorkDayResult";
  o.taskWorkDay = maybeNew("TaskWorkDay", options.taskWorkDay, cache, options.hasOwnProperty("taskWorkDay"));
  return o;
}

factories["SaveTaskWorkDayResult"] = newSaveTaskWorkDayResult;

export interface SaveToDosResultOptions {
  __typename?: "SaveToDosResult";
  toDos?: Array<ToDo | ToDoOptions>;
}

export function newSaveToDosResult(
  options: SaveToDosResultOptions = {},
  cache: Record<string, any> = {},
): SaveToDosResult {
  const o = (options.__typename ? options : cache["SaveToDosResult"] = {}) as SaveToDosResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveToDosResult";
  o.toDos = (options.toDos ?? []).map((i) => maybeNew("ToDo", i, cache, options.hasOwnProperty("toDos")));
  return o;
}

factories["SaveToDosResult"] = newSaveToDosResult;

export interface ToDoChecklistProgressOptions {
  __typename?: "ToDoChecklistProgress";
  total?: ToDoChecklistProgress["total"];
  completed?: ToDoChecklistProgress["completed"];
}

export function newToDoChecklistProgress(
  options: ToDoChecklistProgressOptions = {},
  cache: Record<string, any> = {},
): ToDoChecklistProgress {
  const o = (options.__typename ? options : cache["ToDoChecklistProgress"] = {}) as ToDoChecklistProgress;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ToDoChecklistProgress";
  o.total = options.total ?? 0;
  o.completed = options.completed ?? 0;
  return o;
}

factories["ToDoChecklistProgress"] = newToDoChecklistProgress;

export interface ToDoChecklistItemOptions {
  __typename?: "ToDoChecklistItem";
  id?: ToDoChecklistItem["id"];
  description?: ToDoChecklistItem["description"];
  createdAt?: ToDoChecklistItem["createdAt"];
  updatedAt?: ToDoChecklistItem["updatedAt"];
  toDo?: ToDo | ToDoOptions;
  isComplete?: ToDoChecklistItem["isComplete"];
}

export function newToDoChecklistItem(
  options: ToDoChecklistItemOptions = {},
  cache: Record<string, any> = {},
): ToDoChecklistItem {
  const o = (options.__typename ? options : cache["ToDoChecklistItem"] = {}) as ToDoChecklistItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ToDoChecklistItem";
  o.id = options.id ?? nextFactoryId("ToDoChecklistItem");
  o.description = options.description ?? "description";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.toDo = maybeNew("ToDo", options.toDo, cache, options.hasOwnProperty("toDo"));
  o.isComplete = options.isComplete ?? false;
  return o;
}

factories["ToDoChecklistItem"] = newToDoChecklistItem;

export interface SaveToDoChecklistItemResultOptions {
  __typename?: "SaveToDoChecklistItemResult";
  toDoChecklistItem?: ToDoChecklistItem | ToDoChecklistItemOptions;
}

export function newSaveToDoChecklistItemResult(
  options: SaveToDoChecklistItemResultOptions = {},
  cache: Record<string, any> = {},
): SaveToDoChecklistItemResult {
  const o = (options.__typename ? options : cache["SaveToDoChecklistItemResult"] = {}) as SaveToDoChecklistItemResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveToDoChecklistItemResult";
  o.toDoChecklistItem = maybeNew(
    "ToDoChecklistItem",
    options.toDoChecklistItem,
    cache,
    options.hasOwnProperty("toDoChecklistItem"),
  );
  return o;
}

factories["SaveToDoChecklistItemResult"] = newSaveToDoChecklistItemResult;

export interface TrackedJobOptions {
  __typename?: "TrackedJob";
  id?: TrackedJob["id"];
  pollIntervalInMs?: TrackedJob["pollIntervalInMs"];
  progressCurrent?: TrackedJob["progressCurrent"];
  progressTotal?: TrackedJob["progressTotal"];
  progressMessage?: TrackedJob["progressMessage"];
  startedAt?: TrackedJob["startedAt"];
  completedAt?: TrackedJob["completedAt"];
  createdAt?: TrackedJob["createdAt"];
  updatedAt?: TrackedJob["updatedAt"];
  status?: TrackedJobStatusDetailOptions | TrackedJobStatus;
  user?: User | UserOptions;
  result?: TrackedJobResult | AssetOptions | null;
}

export function newTrackedJob(options: TrackedJobOptions = {}, cache: Record<string, any> = {}): TrackedJob {
  const o = (options.__typename ? options : cache["TrackedJob"] = {}) as TrackedJob;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TrackedJob";
  o.id = options.id ?? nextFactoryId("TrackedJob");
  o.pollIntervalInMs = options.pollIntervalInMs ?? 0;
  o.progressCurrent = options.progressCurrent ?? null;
  o.progressTotal = options.progressTotal ?? null;
  o.progressMessage = options.progressMessage ?? null;
  o.startedAt = options.startedAt ?? null;
  o.completedAt = options.completedAt ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.status = enumOrDetailOfTrackedJobStatus(options.status);
  o.user = maybeNew("User", options.user, cache, options.hasOwnProperty("user"));
  o.result = maybeNewOrNull(options.result?.__typename ?? "Asset", options.result, cache);
  return o;
}

factories["TrackedJob"] = newTrackedJob;

export interface TradeCategoryOptions {
  __typename?: "TradeCategory";
  id?: TradeCategory["id"];
  number?: TradeCategory["number"];
  name?: TradeCategory["name"];
  displayName?: TradeCategory["displayName"];
  createdAt?: TradeCategory["createdAt"];
  updatedAt?: TradeCategory["updatedAt"];
  items?: Array<Item | ItemOptions>;
  tradePartners?: Array<TradePartner | TradePartnerOptions>;
  developmentCommitments?: Array<DevelopmentCommitment | DevelopmentCommitmentOptions>;
  leadTimes?: Array<TradeCategoryLeadTime | TradeCategoryLeadTimeOptions>;
}

export function newTradeCategory(options: TradeCategoryOptions = {}, cache: Record<string, any> = {}): TradeCategory {
  const o = (options.__typename ? options : cache["TradeCategory"] = {}) as TradeCategory;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TradeCategory";
  o.id = options.id ?? nextFactoryId("TradeCategory");
  o.number = options.number ?? "number";
  o.name = options.name ?? "name";
  o.displayName = options.displayName ?? "displayName";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.items = (options.items ?? []).map((i) => maybeNew("Item", i, cache, options.hasOwnProperty("items")));
  o.tradePartners = (options.tradePartners ?? []).map((i) =>
    maybeNew("TradePartner", i, cache, options.hasOwnProperty("tradePartners"))
  );
  o.developmentCommitments = (options.developmentCommitments ?? []).map((i) =>
    maybeNew("DevelopmentCommitment", i, cache, options.hasOwnProperty("developmentCommitments"))
  );
  o.leadTimes = (options.leadTimes ?? []).map((i) =>
    maybeNew("TradeCategoryLeadTime", i, cache, options.hasOwnProperty("leadTimes"))
  );
  return o;
}

factories["TradeCategory"] = newTradeCategory;

export interface SaveTradeCategoryResultOptions {
  __typename?: "SaveTradeCategoryResult";
  tradeCategory?: TradeCategory | TradeCategoryOptions;
}

export function newSaveTradeCategoryResult(
  options: SaveTradeCategoryResultOptions = {},
  cache: Record<string, any> = {},
): SaveTradeCategoryResult {
  const o = (options.__typename ? options : cache["SaveTradeCategoryResult"] = {}) as SaveTradeCategoryResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveTradeCategoryResult";
  o.tradeCategory = maybeNew("TradeCategory", options.tradeCategory, cache, options.hasOwnProperty("tradeCategory"));
  return o;
}

factories["SaveTradeCategoryResult"] = newSaveTradeCategoryResult;

export interface TradeCategoryLeadTimeDefaultOptions {
  __typename?: "TradeCategoryLeadTimeDefault";
  leadTimeInDays?: TradeCategoryLeadTimeDefault["leadTimeInDays"];
  market?: Market | MarketOptions;
  tradeCategory?: TradeCategory | TradeCategoryOptions;
  leadTimeFrequency?: TimeFrequencyDetailOptions | TimeFrequency;
}

export function newTradeCategoryLeadTimeDefault(
  options: TradeCategoryLeadTimeDefaultOptions = {},
  cache: Record<string, any> = {},
): TradeCategoryLeadTimeDefault {
  const o = (options.__typename ? options : cache["TradeCategoryLeadTimeDefault"] = {}) as TradeCategoryLeadTimeDefault;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TradeCategoryLeadTimeDefault";
  o.leadTimeInDays = options.leadTimeInDays ?? 0;
  o.market = maybeNew("Market", options.market, cache, options.hasOwnProperty("market"));
  o.tradeCategory = maybeNew("TradeCategory", options.tradeCategory, cache, options.hasOwnProperty("tradeCategory"));
  o.leadTimeFrequency = enumOrDetailOfTimeFrequency(options.leadTimeFrequency);
  return o;
}

factories["TradeCategoryLeadTimeDefault"] = newTradeCategoryLeadTimeDefault;

export interface TradeCategoryLeadTimeOptions {
  __typename?: "TradeCategoryLeadTime";
  id?: TradeCategoryLeadTime["id"];
  leadTimeInDays?: TradeCategoryLeadTime["leadTimeInDays"];
  createdAt?: TradeCategoryLeadTime["createdAt"];
  updatedAt?: TradeCategoryLeadTime["updatedAt"];
  leadTimeFrequency?: TimeFrequencyDetailOptions | TimeFrequency;
  market?: Market | MarketOptions;
  tradeCategory?: TradeCategory | TradeCategoryOptions;
}

export function newTradeCategoryLeadTime(
  options: TradeCategoryLeadTimeOptions = {},
  cache: Record<string, any> = {},
): TradeCategoryLeadTime {
  const o = (options.__typename ? options : cache["TradeCategoryLeadTime"] = {}) as TradeCategoryLeadTime;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TradeCategoryLeadTime";
  o.id = options.id ?? nextFactoryId("TradeCategoryLeadTime");
  o.leadTimeInDays = options.leadTimeInDays ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.leadTimeFrequency = enumOrDetailOfTimeFrequency(options.leadTimeFrequency);
  o.market = maybeNew("Market", options.market, cache, options.hasOwnProperty("market"));
  o.tradeCategory = maybeNew("TradeCategory", options.tradeCategory, cache, options.hasOwnProperty("tradeCategory"));
  return o;
}

factories["TradeCategoryLeadTime"] = newTradeCategoryLeadTime;

export interface SaveTradeCategoryLeadTimesResultOptions {
  __typename?: "SaveTradeCategoryLeadTimesResult";
  tradeCategoryLeadTimes?: Array<TradeCategoryLeadTime | TradeCategoryLeadTimeOptions>;
}

export function newSaveTradeCategoryLeadTimesResult(
  options: SaveTradeCategoryLeadTimesResultOptions = {},
  cache: Record<string, any> = {},
): SaveTradeCategoryLeadTimesResult {
  const o =
    (options.__typename ? options : cache["SaveTradeCategoryLeadTimesResult"] = {}) as SaveTradeCategoryLeadTimesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveTradeCategoryLeadTimesResult";
  o.tradeCategoryLeadTimes = (options.tradeCategoryLeadTimes ?? []).map((i) =>
    maybeNew("TradeCategoryLeadTime", i, cache, options.hasOwnProperty("tradeCategoryLeadTimes"))
  );
  return o;
}

factories["SaveTradeCategoryLeadTimesResult"] = newSaveTradeCategoryLeadTimesResult;

export interface SaveTradePartnerResultOptions {
  __typename?: "SaveTradePartnerResult";
  tradePartner?: TradePartner | TradePartnerOptions;
}

export function newSaveTradePartnerResult(
  options: SaveTradePartnerResultOptions = {},
  cache: Record<string, any> = {},
): SaveTradePartnerResult {
  const o = (options.__typename ? options : cache["SaveTradePartnerResult"] = {}) as SaveTradePartnerResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveTradePartnerResult";
  o.tradePartner = maybeNew("TradePartner", options.tradePartner, cache, options.hasOwnProperty("tradePartner"));
  return o;
}

factories["SaveTradePartnerResult"] = newSaveTradePartnerResult;

export interface SaveTradePartnersResultOptions {
  __typename?: "SaveTradePartnersResult";
  tradePartners?: Array<TradePartner | TradePartnerOptions>;
}

export function newSaveTradePartnersResult(
  options: SaveTradePartnersResultOptions = {},
  cache: Record<string, any> = {},
): SaveTradePartnersResult {
  const o = (options.__typename ? options : cache["SaveTradePartnersResult"] = {}) as SaveTradePartnersResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveTradePartnersResult";
  o.tradePartners = (options.tradePartners ?? []).map((i) =>
    maybeNew("TradePartner", i, cache, options.hasOwnProperty("tradePartners"))
  );
  return o;
}

factories["SaveTradePartnersResult"] = newSaveTradePartnersResult;

export interface TradePartnersPageOptions {
  __typename?: "TradePartnersPage";
  entities?: Array<TradePartner | TradePartnerOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newTradePartnersPage(
  options: TradePartnersPageOptions = {},
  cache: Record<string, any> = {},
): TradePartnersPage {
  const o = (options.__typename ? options : cache["TradePartnersPage"] = {}) as TradePartnersPage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TradePartnersPage";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("TradePartner", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["TradePartnersPage"] = newTradePartnersPage;

export interface TradePartnerAgreementOptions {
  __typename?: "TradePartnerAgreement";
  id?: TradePartnerAgreement["id"];
  isNationalAgreement?: TradePartnerAgreement["isNationalAgreement"];
  internalNote?: TradePartnerAgreement["internalNote"];
  createdAt?: TradePartnerAgreement["createdAt"];
  updatedAt?: TradePartnerAgreement["updatedAt"];
  costDivision?: CostDivision | CostDivisionOptions;
  tradePartner?: TradePartner | TradePartnerOptions;
}

export function newTradePartnerAgreement(
  options: TradePartnerAgreementOptions = {},
  cache: Record<string, any> = {},
): TradePartnerAgreement {
  const o = (options.__typename ? options : cache["TradePartnerAgreement"] = {}) as TradePartnerAgreement;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TradePartnerAgreement";
  o.id = options.id ?? nextFactoryId("TradePartnerAgreement");
  o.isNationalAgreement = options.isNationalAgreement ?? false;
  o.internalNote = options.internalNote ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.costDivision = maybeNew("CostDivision", options.costDivision, cache, options.hasOwnProperty("costDivision"));
  o.tradePartner = maybeNew("TradePartner", options.tradePartner, cache, options.hasOwnProperty("tradePartner"));
  return o;
}

factories["TradePartnerAgreement"] = newTradePartnerAgreement;

export interface SaveTradePartnerAgreementResultOptions {
  __typename?: "SaveTradePartnerAgreementResult";
  tradePartnerAgreement?: TradePartnerAgreement | TradePartnerAgreementOptions;
}

export function newSaveTradePartnerAgreementResult(
  options: SaveTradePartnerAgreementResultOptions = {},
  cache: Record<string, any> = {},
): SaveTradePartnerAgreementResult {
  const o =
    (options.__typename ? options : cache["SaveTradePartnerAgreementResult"] = {}) as SaveTradePartnerAgreementResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveTradePartnerAgreementResult";
  o.tradePartnerAgreement = maybeNew(
    "TradePartnerAgreement",
    options.tradePartnerAgreement,
    cache,
    options.hasOwnProperty("tradePartnerAgreement"),
  );
  return o;
}

factories["SaveTradePartnerAgreementResult"] = newSaveTradePartnerAgreementResult;

export interface DeleteTradePartnerAgreementResultOptions {
  __typename?: "DeleteTradePartnerAgreementResult";
  tradePartner?: TradePartner | TradePartnerOptions;
}

export function newDeleteTradePartnerAgreementResult(
  options: DeleteTradePartnerAgreementResultOptions = {},
  cache: Record<string, any> = {},
): DeleteTradePartnerAgreementResult {
  const o =
    (options.__typename
      ? options
      : cache["DeleteTradePartnerAgreementResult"] = {}) as DeleteTradePartnerAgreementResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeleteTradePartnerAgreementResult";
  o.tradePartner = maybeNew("TradePartner", options.tradePartner, cache, options.hasOwnProperty("tradePartner"));
  return o;
}

factories["DeleteTradePartnerAgreementResult"] = newDeleteTradePartnerAgreementResult;

export interface SaveTradePartnerAvailabilityRequestResultOptions {
  __typename?: "SaveTradePartnerAvailabilityRequestResult";
  tradePartnerAvailabilityRequest?: TradePartnerAvailabilityRequest | TradePartnerAvailabilityRequestOptions;
}

export function newSaveTradePartnerAvailabilityRequestResult(
  options: SaveTradePartnerAvailabilityRequestResultOptions = {},
  cache: Record<string, any> = {},
): SaveTradePartnerAvailabilityRequestResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveTradePartnerAvailabilityRequestResult"] = {}) as SaveTradePartnerAvailabilityRequestResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveTradePartnerAvailabilityRequestResult";
  o.tradePartnerAvailabilityRequest = maybeNew(
    "TradePartnerAvailabilityRequest",
    options.tradePartnerAvailabilityRequest,
    cache,
    options.hasOwnProperty("tradePartnerAvailabilityRequest"),
  );
  return o;
}

factories["SaveTradePartnerAvailabilityRequestResult"] = newSaveTradePartnerAvailabilityRequestResult;

export interface SaveTradePartnerAvailabilityRequestsResultOptions {
  __typename?: "SaveTradePartnerAvailabilityRequestsResult";
  tradePartnerAvailabilityRequests?: Array<TradePartnerAvailabilityRequest | TradePartnerAvailabilityRequestOptions>;
}

export function newSaveTradePartnerAvailabilityRequestsResult(
  options: SaveTradePartnerAvailabilityRequestsResultOptions = {},
  cache: Record<string, any> = {},
): SaveTradePartnerAvailabilityRequestsResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveTradePartnerAvailabilityRequestsResult"] = {}) as SaveTradePartnerAvailabilityRequestsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveTradePartnerAvailabilityRequestsResult";
  o.tradePartnerAvailabilityRequests = (options.tradePartnerAvailabilityRequests ?? []).map((i) =>
    maybeNew("TradePartnerAvailabilityRequest", i, cache, options.hasOwnProperty("tradePartnerAvailabilityRequests"))
  );
  return o;
}

factories["SaveTradePartnerAvailabilityRequestsResult"] = newSaveTradePartnerAvailabilityRequestsResult;

export interface TradePartnerAvailabilityRequestEmailOptions {
  __typename?: "TradePartnerAvailabilityRequestEmail";
  id?: TradePartnerAvailabilityRequestEmail["id"];
  subject?: TradePartnerAvailabilityRequestEmail["subject"];
  message?: TradePartnerAvailabilityRequestEmail["message"];
  createdAt?: TradePartnerAvailabilityRequestEmail["createdAt"];
  updatedAt?: TradePartnerAvailabilityRequestEmail["updatedAt"];
  tradePartnerAvailabilityRequest?: TradePartnerAvailabilityRequest | TradePartnerAvailabilityRequestOptions;
  attachments?: Array<Attachment | AttachmentOptions>;
}

export function newTradePartnerAvailabilityRequestEmail(
  options: TradePartnerAvailabilityRequestEmailOptions = {},
  cache: Record<string, any> = {},
): TradePartnerAvailabilityRequestEmail {
  const o =
    (options.__typename
      ? options
      : cache["TradePartnerAvailabilityRequestEmail"] = {}) as TradePartnerAvailabilityRequestEmail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TradePartnerAvailabilityRequestEmail";
  o.id = options.id ?? nextFactoryId("TradePartnerAvailabilityRequestEmail");
  o.subject = options.subject ?? "subject";
  o.message = options.message ?? "message";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.tradePartnerAvailabilityRequest = maybeNew(
    "TradePartnerAvailabilityRequest",
    options.tradePartnerAvailabilityRequest,
    cache,
    options.hasOwnProperty("tradePartnerAvailabilityRequest"),
  );
  o.attachments = (options.attachments ?? []).map((i) =>
    maybeNew("Attachment", i, cache, options.hasOwnProperty("attachments"))
  );
  return o;
}

factories["TradePartnerAvailabilityRequestEmail"] = newTradePartnerAvailabilityRequestEmail;

export interface TradePartnerAvailabilityRequestTextMessageOptions {
  __typename?: "TradePartnerAvailabilityRequestTextMessage";
  id?: TradePartnerAvailabilityRequestTextMessage["id"];
  body?: TradePartnerAvailabilityRequestTextMessage["body"];
  createdAt?: TradePartnerAvailabilityRequestTextMessage["createdAt"];
  updatedAt?: TradePartnerAvailabilityRequestTextMessage["updatedAt"];
  tradePartnerAvailabilityRequest?: TradePartnerAvailabilityRequest | TradePartnerAvailabilityRequestOptions;
}

export function newTradePartnerAvailabilityRequestTextMessage(
  options: TradePartnerAvailabilityRequestTextMessageOptions = {},
  cache: Record<string, any> = {},
): TradePartnerAvailabilityRequestTextMessage {
  const o =
    (options.__typename
      ? options
      : cache["TradePartnerAvailabilityRequestTextMessage"] = {}) as TradePartnerAvailabilityRequestTextMessage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TradePartnerAvailabilityRequestTextMessage";
  o.id = options.id ?? nextFactoryId("TradePartnerAvailabilityRequestTextMessage");
  o.body = options.body ?? "body";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.tradePartnerAvailabilityRequest = maybeNew(
    "TradePartnerAvailabilityRequest",
    options.tradePartnerAvailabilityRequest,
    cache,
    options.hasOwnProperty("tradePartnerAvailabilityRequest"),
  );
  return o;
}

factories["TradePartnerAvailabilityRequestTextMessage"] = newTradePartnerAvailabilityRequestTextMessage;

export interface TradePartnerContactOptions {
  __typename?: "TradePartnerContact";
  id?: TradePartnerContact["id"];
  isPrimary?: TradePartnerContact["isPrimary"];
  isBillingSignatory?: TradePartnerContact["isBillingSignatory"];
  name?: TradePartnerContact["name"];
  email?: TradePartnerContact["email"];
  officePhone?: TradePartnerContact["officePhone"];
  mobilePhone?: TradePartnerContact["mobilePhone"];
  canDelete?: PotentialOperation2 | PotentialOperation2Options;
  canDeactivate?: PotentialOperation2 | PotentialOperation2Options;
  createdAt?: TradePartnerContact["createdAt"];
  updatedAt?: TradePartnerContact["updatedAt"];
  tradePartner?: TradePartner | TradePartnerOptions;
  title?: TradePartnerContact["title"];
  maybeBillingSignatory?: TradePartnerContact["maybeBillingSignatory"];
  address?: Address | AddressOptions | null;
  markets?: Array<Market | MarketOptions>;
  tradePartnerMailingLists?: Array<TradePartnerMailingList | TradePartnerMailingListOptions>;
  mailingLists?: Array<TradePartnerMailingList | TradePartnerMailingListOptions>;
  tradePartnerUser?: TradePartnerUser | TradePartnerUserOptions | null;
  tradePartnerMarketContacts?: Array<TradePartnerMarketContact | TradePartnerMarketContactOptions>;
  canLoginToPortal?: TradePartnerContact["canLoginToPortal"];
  isActive?: TradePartnerContact["isActive"];
}

export function newTradePartnerContact(
  options: TradePartnerContactOptions = {},
  cache: Record<string, any> = {},
): TradePartnerContact {
  const o = (options.__typename ? options : cache["TradePartnerContact"] = {}) as TradePartnerContact;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TradePartnerContact";
  o.id = options.id ?? nextFactoryId("TradePartnerContact");
  o.isPrimary = options.isPrimary ?? false;
  o.isBillingSignatory = options.isBillingSignatory ?? false;
  o.name = options.name ?? "name";
  o.email = options.email ?? null;
  o.officePhone = options.officePhone ?? null;
  o.mobilePhone = options.mobilePhone ?? null;
  o.canDelete = maybeNew("PotentialOperation2", options.canDelete, cache, options.hasOwnProperty("canDelete"));
  o.canDeactivate = maybeNew(
    "PotentialOperation2",
    options.canDeactivate,
    cache,
    options.hasOwnProperty("canDeactivate"),
  );
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.tradePartner = maybeNew("TradePartner", options.tradePartner, cache, options.hasOwnProperty("tradePartner"));
  o.title = options.title ?? null;
  o.maybeBillingSignatory = options.maybeBillingSignatory ?? false;
  o.address = maybeNewOrNull("Address", options.address, cache);
  o.markets = (options.markets ?? []).map((i) => maybeNew("Market", i, cache, options.hasOwnProperty("markets")));
  o.tradePartnerMailingLists = (options.tradePartnerMailingLists ?? []).map((i) =>
    maybeNew("TradePartnerMailingList", i, cache, options.hasOwnProperty("tradePartnerMailingLists"))
  );
  o.mailingLists = (options.mailingLists ?? []).map((i) =>
    maybeNew("TradePartnerMailingList", i, cache, options.hasOwnProperty("mailingLists"))
  );
  o.tradePartnerUser = maybeNewOrNull("TradePartnerUser", options.tradePartnerUser, cache);
  o.tradePartnerMarketContacts = (options.tradePartnerMarketContacts ?? []).map((i) =>
    maybeNew("TradePartnerMarketContact", i, cache, options.hasOwnProperty("tradePartnerMarketContacts"))
  );
  o.canLoginToPortal = options.canLoginToPortal ?? false;
  o.isActive = options.isActive ?? false;
  return o;
}

factories["TradePartnerContact"] = newTradePartnerContact;

export interface SaveTradePartnerContactResultOptions {
  __typename?: "SaveTradePartnerContactResult";
  tradePartnerContact?: TradePartnerContact | TradePartnerContactOptions;
}

export function newSaveTradePartnerContactResult(
  options: SaveTradePartnerContactResultOptions = {},
  cache: Record<string, any> = {},
): SaveTradePartnerContactResult {
  const o =
    (options.__typename ? options : cache["SaveTradePartnerContactResult"] = {}) as SaveTradePartnerContactResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveTradePartnerContactResult";
  o.tradePartnerContact = maybeNew(
    "TradePartnerContact",
    options.tradePartnerContact,
    cache,
    options.hasOwnProperty("tradePartnerContact"),
  );
  return o;
}

factories["SaveTradePartnerContactResult"] = newSaveTradePartnerContactResult;

export interface DeleteTradePartnerContactResultOptions {
  __typename?: "DeleteTradePartnerContactResult";
  tradePartner?: TradePartner | TradePartnerOptions;
  tradePartnerContact?: TradePartnerContact | TradePartnerContactOptions | null;
}

export function newDeleteTradePartnerContactResult(
  options: DeleteTradePartnerContactResultOptions = {},
  cache: Record<string, any> = {},
): DeleteTradePartnerContactResult {
  const o =
    (options.__typename ? options : cache["DeleteTradePartnerContactResult"] = {}) as DeleteTradePartnerContactResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeleteTradePartnerContactResult";
  o.tradePartner = maybeNew("TradePartner", options.tradePartner, cache, options.hasOwnProperty("tradePartner"));
  o.tradePartnerContact = maybeNewOrNull("TradePartnerContact", options.tradePartnerContact, cache);
  return o;
}

factories["DeleteTradePartnerContactResult"] = newDeleteTradePartnerContactResult;

export interface MarketContactWithRolesOptions {
  __typename?: "MarketContactWithRoles";
  contact?: TradePartnerContact | TradePartnerContactOptions;
  roles?: MarketContactWithRoles["roles"];
}

export function newMarketContactWithRoles(
  options: MarketContactWithRolesOptions = {},
  cache: Record<string, any> = {},
): MarketContactWithRoles {
  const o = (options.__typename ? options : cache["MarketContactWithRoles"] = {}) as MarketContactWithRoles;
  (cache.all ??= new Set()).add(o);
  o.__typename = "MarketContactWithRoles";
  o.contact = maybeNew("TradePartnerContact", options.contact, cache, options.hasOwnProperty("contact"));
  o.roles = options.roles ?? [];
  return o;
}

factories["MarketContactWithRoles"] = newMarketContactWithRoles;

export interface TradePartnerMailingListOptions {
  __typename?: "TradePartnerMailingList";
  id?: TradePartnerMailingList["id"];
  name?: TradePartnerMailingList["name"];
  createdAt?: TradePartnerMailingList["createdAt"];
  updatedAt?: TradePartnerMailingList["updatedAt"];
  tradePartnerContacts?: Array<TradePartnerContact | TradePartnerContactOptions>;
}

export function newTradePartnerMailingList(
  options: TradePartnerMailingListOptions = {},
  cache: Record<string, any> = {},
): TradePartnerMailingList {
  const o = (options.__typename ? options : cache["TradePartnerMailingList"] = {}) as TradePartnerMailingList;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TradePartnerMailingList";
  o.id = options.id ?? nextFactoryId("TradePartnerMailingList");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.tradePartnerContacts = (options.tradePartnerContacts ?? []).map((i) =>
    maybeNew("TradePartnerContact", i, cache, options.hasOwnProperty("tradePartnerContacts"))
  );
  return o;
}

factories["TradePartnerMailingList"] = newTradePartnerMailingList;

export interface TradePartnerMarketContactOptions {
  __typename?: "TradePartnerMarketContact";
  id?: TradePartnerMarketContact["id"];
  createdAt?: TradePartnerMarketContact["createdAt"];
  updatedAt?: TradePartnerMarketContact["updatedAt"];
  role?: TradePartnerMarketRoleDetailOptions | TradePartnerMarketRole;
  market?: Market | MarketOptions;
  tradePartner?: TradePartner | TradePartnerOptions;
  contact?: TradePartnerContact | TradePartnerContactOptions;
}

export function newTradePartnerMarketContact(
  options: TradePartnerMarketContactOptions = {},
  cache: Record<string, any> = {},
): TradePartnerMarketContact {
  const o = (options.__typename ? options : cache["TradePartnerMarketContact"] = {}) as TradePartnerMarketContact;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TradePartnerMarketContact";
  o.id = options.id ?? nextFactoryId("TradePartnerMarketContact");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.role = enumOrDetailOfTradePartnerMarketRole(options.role);
  o.market = maybeNew("Market", options.market, cache, options.hasOwnProperty("market"));
  o.tradePartner = maybeNew("TradePartner", options.tradePartner, cache, options.hasOwnProperty("tradePartner"));
  o.contact = maybeNew("TradePartnerContact", options.contact, cache, options.hasOwnProperty("contact"));
  return o;
}

factories["TradePartnerMarketContact"] = newTradePartnerMarketContact;

export interface SaveTradePartnerMarketContactResultOptions {
  __typename?: "SaveTradePartnerMarketContactResult";
  tradePartnerMarketContact?: TradePartnerMarketContact | TradePartnerMarketContactOptions;
}

export function newSaveTradePartnerMarketContactResult(
  options: SaveTradePartnerMarketContactResultOptions = {},
  cache: Record<string, any> = {},
): SaveTradePartnerMarketContactResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveTradePartnerMarketContactResult"] = {}) as SaveTradePartnerMarketContactResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveTradePartnerMarketContactResult";
  o.tradePartnerMarketContact = maybeNew(
    "TradePartnerMarketContact",
    options.tradePartnerMarketContact,
    cache,
    options.hasOwnProperty("tradePartnerMarketContact"),
  );
  return o;
}

factories["SaveTradePartnerMarketContactResult"] = newSaveTradePartnerMarketContactResult;

export interface DeleteTradePartnerMarketContactResultOptions {
  __typename?: "DeleteTradePartnerMarketContactResult";
  tradePartner?: TradePartner | TradePartnerOptions;
}

export function newDeleteTradePartnerMarketContactResult(
  options: DeleteTradePartnerMarketContactResultOptions = {},
  cache: Record<string, any> = {},
): DeleteTradePartnerMarketContactResult {
  const o =
    (options.__typename
      ? options
      : cache["DeleteTradePartnerMarketContactResult"] = {}) as DeleteTradePartnerMarketContactResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeleteTradePartnerMarketContactResult";
  o.tradePartner = maybeNew("TradePartner", options.tradePartner, cache, options.hasOwnProperty("tradePartner"));
  return o;
}

factories["DeleteTradePartnerMarketContactResult"] = newDeleteTradePartnerMarketContactResult;

export interface TradePartnerRequirementOptions {
  __typename?: "TradePartnerRequirement";
  id?: TradePartnerRequirement["id"];
  signedDate?: TradePartnerRequirement["signedDate"];
  expirationDate?: TradePartnerRequirement["expirationDate"];
  licenseNumber?: TradePartnerRequirement["licenseNumber"];
  coverageAmountInCents?: TradePartnerRequirement["coverageAmountInCents"];
  createdAt?: TradePartnerRequirement["createdAt"];
  updatedAt?: TradePartnerRequirement["updatedAt"];
  type?: TradePartnerRequirementTypeDetailOptions | TradePartnerRequirementType;
  tradePartner?: TradePartner | TradePartnerOptions;
  status?: TradePartnerRequirementStatusDetailOptions | TradePartnerRequirementStatus;
  internalNote?: TradePartnerRequirement["internalNote"];
  attachments?: Array<Attachment | AttachmentOptions>;
}

export function newTradePartnerRequirement(
  options: TradePartnerRequirementOptions = {},
  cache: Record<string, any> = {},
): TradePartnerRequirement {
  const o = (options.__typename ? options : cache["TradePartnerRequirement"] = {}) as TradePartnerRequirement;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TradePartnerRequirement";
  o.id = options.id ?? nextFactoryId("TradePartnerRequirement");
  o.signedDate = options.signedDate ?? null;
  o.expirationDate = options.expirationDate ?? null;
  o.licenseNumber = options.licenseNumber ?? null;
  o.coverageAmountInCents = options.coverageAmountInCents ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.type = enumOrDetailOfTradePartnerRequirementType(options.type);
  o.tradePartner = maybeNew("TradePartner", options.tradePartner, cache, options.hasOwnProperty("tradePartner"));
  o.status = enumOrDetailOfTradePartnerRequirementStatus(options.status);
  o.internalNote = options.internalNote ?? null;
  o.attachments = (options.attachments ?? []).map((i) =>
    maybeNew("Attachment", i, cache, options.hasOwnProperty("attachments"))
  );
  return o;
}

factories["TradePartnerRequirement"] = newTradePartnerRequirement;

export interface SaveTradePartnerRequirementResultOptions {
  __typename?: "SaveTradePartnerRequirementResult";
  tradePartnerRequirement?: TradePartnerRequirement | TradePartnerRequirementOptions;
}

export function newSaveTradePartnerRequirementResult(
  options: SaveTradePartnerRequirementResultOptions = {},
  cache: Record<string, any> = {},
): SaveTradePartnerRequirementResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveTradePartnerRequirementResult"] = {}) as SaveTradePartnerRequirementResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveTradePartnerRequirementResult";
  o.tradePartnerRequirement = maybeNew(
    "TradePartnerRequirement",
    options.tradePartnerRequirement,
    cache,
    options.hasOwnProperty("tradePartnerRequirement"),
  );
  return o;
}

factories["SaveTradePartnerRequirementResult"] = newSaveTradePartnerRequirementResult;

export interface TradePartnerReviewOptions {
  __typename?: "TradePartnerReview";
  id?: TradePartnerReview["id"];
  recommended?: TradePartnerReview["recommended"];
  score?: TradePartnerReview["score"];
  createdAt?: TradePartnerReview["createdAt"];
  internalUser?: InternalUser | InternalUserOptions;
  tradePartner?: TradePartner | TradePartnerOptions;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions;
  internalNote?: TradePartnerReview["internalNote"];
}

export function newTradePartnerReview(
  options: TradePartnerReviewOptions = {},
  cache: Record<string, any> = {},
): TradePartnerReview {
  const o = (options.__typename ? options : cache["TradePartnerReview"] = {}) as TradePartnerReview;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TradePartnerReview";
  o.id = options.id ?? nextFactoryId("TradePartnerReview");
  o.recommended = options.recommended ?? null;
  o.score = options.score ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.internalUser = maybeNew("InternalUser", options.internalUser, cache, options.hasOwnProperty("internalUser"));
  o.tradePartner = maybeNew("TradePartner", options.tradePartner, cache, options.hasOwnProperty("tradePartner"));
  o.project = maybeNew("Project", options.project, cache, options.hasOwnProperty("project"));
  o.internalNote = options.internalNote ?? null;
  return o;
}

factories["TradePartnerReview"] = newTradePartnerReview;

export interface SaveTradePartnerReviewResultOptions {
  __typename?: "SaveTradePartnerReviewResult";
  tradePartnerReview?: TradePartnerReview | TradePartnerReviewOptions;
}

export function newSaveTradePartnerReviewResult(
  options: SaveTradePartnerReviewResultOptions = {},
  cache: Record<string, any> = {},
): SaveTradePartnerReviewResult {
  const o = (options.__typename ? options : cache["SaveTradePartnerReviewResult"] = {}) as SaveTradePartnerReviewResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveTradePartnerReviewResult";
  o.tradePartnerReview = maybeNew(
    "TradePartnerReview",
    options.tradePartnerReview,
    cache,
    options.hasOwnProperty("tradePartnerReview"),
  );
  return o;
}

factories["SaveTradePartnerReviewResult"] = newSaveTradePartnerReviewResult;

export interface TradePartnerUserOptions {
  __typename?: "TradePartnerUser";
  id?: TradePartnerUser["id"];
  user?: User | UserOptions;
  tradePartner?: TradePartner | TradePartnerOptions;
  name?: TradePartnerUser["name"];
  createdAt?: TradePartnerUser["createdAt"];
  updatedAt?: TradePartnerUser["updatedAt"];
  commentStreams?: Array<CommentStream | CommentStreamOptions>;
  tradePartnerContact?: TradePartnerContact | TradePartnerContactOptions | null;
  approvers?: Array<Approver | ApproverOptions>;
  lastActive?: TradePartnerUser["lastActive"];
  lastActiveAt?: TradePartnerUser["lastActiveAt"];
}

export function newTradePartnerUser(
  options: TradePartnerUserOptions = {},
  cache: Record<string, any> = {},
): TradePartnerUser {
  const o = (options.__typename ? options : cache["TradePartnerUser"] = {}) as TradePartnerUser;
  (cache.all ??= new Set()).add(o);
  o.__typename = "TradePartnerUser";
  o.id = options.id ?? nextFactoryId("TradePartnerUser");
  o.user = maybeNew("User", options.user, cache, options.hasOwnProperty("user"));
  o.tradePartner = maybeNew("TradePartner", options.tradePartner, cache, options.hasOwnProperty("tradePartner"));
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.commentStreams = (options.commentStreams ?? []).map((i) =>
    maybeNew("CommentStream", i, cache, options.hasOwnProperty("commentStreams"))
  );
  o.tradePartnerContact = maybeNewOrNull("TradePartnerContact", options.tradePartnerContact, cache);
  o.approvers = (options.approvers ?? []).map((i) =>
    maybeNew("Approver", i, cache, options.hasOwnProperty("approvers"))
  );
  o.lastActive = options.lastActive ?? null;
  o.lastActiveAt = options.lastActiveAt ?? null;
  return o;
}

factories["TradePartnerUser"] = newTradePartnerUser;

export interface SaveUnitResultOptions {
  __typename?: "SaveUnitResult";
  unit?: Unit | UnitOptions;
}

export function newSaveUnitResult(
  options: SaveUnitResultOptions = {},
  cache: Record<string, any> = {},
): SaveUnitResult {
  const o = (options.__typename ? options : cache["SaveUnitResult"] = {}) as SaveUnitResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveUnitResult";
  o.unit = maybeNew("Unit", options.unit, cache, options.hasOwnProperty("unit"));
  return o;
}

factories["SaveUnitResult"] = newSaveUnitResult;

export interface SaveUnitsOfMeasureResultOptions {
  __typename?: "SaveUnitsOfMeasureResult";
  unitsOfMeasure?: Array<UnitOfMeasure | UnitOfMeasureOptions>;
}

export function newSaveUnitsOfMeasureResult(
  options: SaveUnitsOfMeasureResultOptions = {},
  cache: Record<string, any> = {},
): SaveUnitsOfMeasureResult {
  const o = (options.__typename ? options : cache["SaveUnitsOfMeasureResult"] = {}) as SaveUnitsOfMeasureResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveUnitsOfMeasureResult";
  o.unitsOfMeasure = (options.unitsOfMeasure ?? []).map((i) =>
    maybeNew("UnitOfMeasure", i, cache, options.hasOwnProperty("unitsOfMeasure"))
  );
  return o;
}

factories["SaveUnitsOfMeasureResult"] = newSaveUnitsOfMeasureResult;

export interface UnitOfMeasureOptions {
  __typename?: "UnitOfMeasure";
  id?: UnitOfMeasure["id"];
  name?: UnitOfMeasure["name"];
  useQuantity?: UnitOfMeasure["useQuantity"];
  sageName?: UnitOfMeasure["sageName"];
  abbreviation?: UnitOfMeasure["abbreviation"];
  shortName?: UnitOfMeasure["shortName"];
  shouldMultiplySelectionFee?: UnitOfMeasure["shouldMultiplySelectionFee"];
}

export function newUnitOfMeasure(options: UnitOfMeasureOptions = {}, cache: Record<string, any> = {}): UnitOfMeasure {
  const o = (options.__typename ? options : cache["UnitOfMeasure"] = {}) as UnitOfMeasure;
  (cache.all ??= new Set()).add(o);
  o.__typename = "UnitOfMeasure";
  o.id = options.id ?? nextFactoryId("UnitOfMeasure");
  o.name = options.name ?? "name";
  o.useQuantity = options.useQuantity ?? false;
  o.sageName = options.sageName ?? null;
  o.abbreviation = options.abbreviation ?? "abbreviation";
  o.shortName = options.shortName ?? "shortName";
  o.shouldMultiplySelectionFee = options.shouldMultiplySelectionFee ?? false;
  return o;
}

factories["UnitOfMeasure"] = newUnitOfMeasure;

export interface UserOptions {
  __typename?: "User";
  id?: User["id"];
  userId?: User["userId"];
  userType?: User["userType"];
  name?: User["name"];
  email?: User["email"];
  avatarUrl?: User["avatarUrl"];
  avatar?: User["avatar"];
  internalUser?: InternalUser | InternalUserOptions | null;
  type?: User["type"];
  typeDetail?: UserTypeDetailOptions | UserType;
  isActive?: User["isActive"];
  tradePartnerUser?: TradePartnerUser | TradePartnerUserOptions | null;
  tradePartnerUsers?: Array<TradePartnerUser | TradePartnerUserOptions>;
  zendeskJwt?: User["zendeskJwt"];
  userCommunicationPreference?: UserCommunicationPreference | UserCommunicationPreferenceOptions | null;
  isBeingImpersonated?: User["isBeingImpersonated"];
  hasCheckoutAccess?: User["hasCheckoutAccess"];
  pushNotificationTokens?: Array<PushNotificationToken | PushNotificationTokenOptions>;
}

export function newUser(options: UserOptions = {}, cache: Record<string, any> = {}): User {
  const o = (options.__typename ? options : cache["User"] = {}) as User;
  (cache.all ??= new Set()).add(o);
  o.__typename = "User";
  o.id = options.id ?? nextFactoryId("User");
  o.userId = options.userId ?? "userId";
  o.userType = options.userType ?? UserType.Anonymous;
  o.name = options.name ?? "name";
  o.email = options.email ?? "email";
  o.avatarUrl = options.avatarUrl ?? "avatarUrl";
  o.avatar = options.avatar ?? "avatar";
  o.internalUser = maybeNewOrNull("InternalUser", options.internalUser, cache);
  o.type = options.type ?? UserType.Anonymous;
  o.typeDetail = enumOrDetailOfUserType(options.typeDetail);
  o.isActive = options.isActive ?? false;
  o.tradePartnerUser = maybeNewOrNull("TradePartnerUser", options.tradePartnerUser, cache);
  o.tradePartnerUsers = (options.tradePartnerUsers ?? []).map((i) =>
    maybeNew("TradePartnerUser", i, cache, options.hasOwnProperty("tradePartnerUsers"))
  );
  o.zendeskJwt = options.zendeskJwt ?? "zendeskJwt";
  o.userCommunicationPreference = maybeNewOrNull(
    "UserCommunicationPreference",
    options.userCommunicationPreference,
    cache,
  );
  o.isBeingImpersonated = options.isBeingImpersonated ?? false;
  o.hasCheckoutAccess = options.hasCheckoutAccess ?? false;
  o.pushNotificationTokens = (options.pushNotificationTokens ?? []).map((i) =>
    maybeNew("PushNotificationToken", i, cache, options.hasOwnProperty("pushNotificationTokens"))
  );
  return o;
}

factories["User"] = newUser;

export interface SaveUserResultOptions {
  __typename?: "SaveUserResult";
  userErrors?: Array<UserError | UserErrorOptions>;
}

export function newSaveUserResult(
  options: SaveUserResultOptions = {},
  cache: Record<string, any> = {},
): SaveUserResult {
  const o = (options.__typename ? options : cache["SaveUserResult"] = {}) as SaveUserResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveUserResult";
  o.userErrors = (options.userErrors ?? []).map((i) =>
    maybeNew("UserError", i, cache, options.hasOwnProperty("userErrors"))
  );
  return o;
}

factories["SaveUserResult"] = newSaveUserResult;

export interface DeactivateUserResultOptions {
  __typename?: "DeactivateUserResult";
  userErrors?: Array<UserError | UserErrorOptions>;
}

export function newDeactivateUserResult(
  options: DeactivateUserResultOptions = {},
  cache: Record<string, any> = {},
): DeactivateUserResult {
  const o = (options.__typename ? options : cache["DeactivateUserResult"] = {}) as DeactivateUserResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeactivateUserResult";
  o.userErrors = (options.userErrors ?? []).map((i) =>
    maybeNew("UserError", i, cache, options.hasOwnProperty("userErrors"))
  );
  return o;
}

factories["DeactivateUserResult"] = newDeactivateUserResult;

export interface ActivateUserResultOptions {
  __typename?: "ActivateUserResult";
  userErrors?: Array<UserError | UserErrorOptions>;
}

export function newActivateUserResult(
  options: ActivateUserResultOptions = {},
  cache: Record<string, any> = {},
): ActivateUserResult {
  const o = (options.__typename ? options : cache["ActivateUserResult"] = {}) as ActivateUserResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ActivateUserResult";
  o.userErrors = (options.userErrors ?? []).map((i) =>
    maybeNew("UserError", i, cache, options.hasOwnProperty("userErrors"))
  );
  return o;
}

factories["ActivateUserResult"] = newActivateUserResult;

export interface DeactivateUsersResultOptions {
  __typename?: "DeactivateUsersResult";
  users?: Array<User | UserOptions>;
}

export function newDeactivateUsersResult(
  options: DeactivateUsersResultOptions = {},
  cache: Record<string, any> = {},
): DeactivateUsersResult {
  const o = (options.__typename ? options : cache["DeactivateUsersResult"] = {}) as DeactivateUsersResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeactivateUsersResult";
  o.users = (options.users ?? []).map((i) => maybeNew("User", i, cache, options.hasOwnProperty("users")));
  return o;
}

factories["DeactivateUsersResult"] = newDeactivateUsersResult;

export interface ActivateUsersResultOptions {
  __typename?: "ActivateUsersResult";
  users?: Array<User | UserOptions>;
}

export function newActivateUsersResult(
  options: ActivateUsersResultOptions = {},
  cache: Record<string, any> = {},
): ActivateUsersResult {
  const o = (options.__typename ? options : cache["ActivateUsersResult"] = {}) as ActivateUsersResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ActivateUsersResult";
  o.users = (options.users ?? []).map((i) => maybeNew("User", i, cache, options.hasOwnProperty("users")));
  return o;
}

factories["ActivateUsersResult"] = newActivateUsersResult;

export interface UserCommunicationPreferenceOptions {
  __typename?: "UserCommunicationPreference";
  id?: UserCommunicationPreference["id"];
  user?: User | UserOptions;
  createdAt?: UserCommunicationPreference["createdAt"];
  updatedAt?: UserCommunicationPreference["updatedAt"];
  tpAvailabilityRequestPreference?: UserCommunicationPreference["tpAvailabilityRequestPreference"] | null;
  commentPreference?: UserCommunicationPreference["commentPreference"] | null;
}

export function newUserCommunicationPreference(
  options: UserCommunicationPreferenceOptions = {},
  cache: Record<string, any> = {},
): UserCommunicationPreference {
  const o = (options.__typename ? options : cache["UserCommunicationPreference"] = {}) as UserCommunicationPreference;
  (cache.all ??= new Set()).add(o);
  o.__typename = "UserCommunicationPreference";
  o.id = options.id ?? nextFactoryId("UserCommunicationPreference");
  o.user = maybeNew("User", options.user, cache, options.hasOwnProperty("user"));
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.tpAvailabilityRequestPreference = options.tpAvailabilityRequestPreference ?? [];
  o.commentPreference = options.commentPreference ?? [];
  return o;
}

factories["UserCommunicationPreference"] = newUserCommunicationPreference;

export interface SaveUserCommunicationPreferenceResultOptions {
  __typename?: "SaveUserCommunicationPreferenceResult";
  userCommunicationPreference?: UserCommunicationPreference | UserCommunicationPreferenceOptions;
}

export function newSaveUserCommunicationPreferenceResult(
  options: SaveUserCommunicationPreferenceResultOptions = {},
  cache: Record<string, any> = {},
): SaveUserCommunicationPreferenceResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveUserCommunicationPreferenceResult"] = {}) as SaveUserCommunicationPreferenceResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveUserCommunicationPreferenceResult";
  o.userCommunicationPreference = maybeNew(
    "UserCommunicationPreference",
    options.userCommunicationPreference,
    cache,
    options.hasOwnProperty("userCommunicationPreference"),
  );
  return o;
}

factories["SaveUserCommunicationPreferenceResult"] = newSaveUserCommunicationPreferenceResult;

export interface UserEventOptions {
  __typename?: "UserEvent";
  id?: UserEvent["id"];
  parent?:
    | UserEventParent
    | ApprovalOptions
    | RequireTypename<BillOptions>
    | RequireTypename<ChangeEventOptions>
    | RequireTypename<CommitmentOptions>
    | RequireTypename<CommitmentChangeOrderOptions>
    | RequireTypename<DocumentOptions>
    | RequireTypename<EstimateOptions>
    | RequireTypename<HomeownerContractChangeOrderOptions>
    | RequireTypename<InvoiceOptions>
    | RequireTypename<ItemTemplateOptions>
    | RequireTypename<JobLogOptions>
    | RequireTypename<JobLogImageOptions>
    | RequireTypename<JobLogNoteOptions>
    | RequireTypename<StandaloneProjectOptions>
    | RequireTypename<RegionOptions>
    | RequireTypename<MarketOptions>
    | RequireTypename<CommunityOptions>
    | RequireTypename<SubdivisionOptions>
    | RequireTypename<LotOptions>
    | RequireTypename<StructureOptions>
    | RequireTypename<UnitOptions>
    | RequireTypename<ProjectItemOptions>
    | RequireTypename<ProjectLotDetailOptions>
    | RequireTypename<ProjectReadyPlanConfigOptions>
    | RequireTypename<ReadyPlanOptions>
    | RequireTypename<PlanPackageOptions>
    | RequireTypename<DesignPackageOptions>
    | RequireTypename<ProductOfferingOptions>
    | RequireTypename<ReadyPlanOptionOptions>
    | RequireTypename<ToDoOptions>
    | RequireTypename<ChangeRequestToDoOptions>
    | RequireTypename<PunchlistItemTodoOptions>
    | RequireTypename<TaskOptions>
    | RequireTypename<ScheduleTaskOptions>
    | RequireTypename<PlanTaskOptions>
    | RequireTypename<WarrantyTicketOptions>;
  parentTypeName?: UserEvent["parentTypeName"];
  createdAt?: UserEvent["createdAt"];
  createdBy?: User | UserOptions;
  createdFor?: User | UserOptions | null;
  type?: UserEvent["type"];
  typeDetail?: UserEventTypeDetailOptions | UserEventType;
  development?: Development | DevelopmentOptions | null;
  cohort?: Cohort | CohortOptions | null;
  project?:
    | StandaloneProject
    | Region
    | Market
    | Community
    | Subdivision
    | Lot
    | Structure
    | Unit
    | Project
    | ProjectOptions
    | null;
  notifiedAt?: UserEvent["notifiedAt"];
  comment?: Comment | CommentOptions | null;
  payload?: UserEvent["payload"];
  attachment?: Attachment | AttachmentOptions | null;
}

export function newUserEvent(options: UserEventOptions = {}, cache: Record<string, any> = {}): UserEvent {
  const o = (options.__typename ? options : cache["UserEvent"] = {}) as UserEvent;
  (cache.all ??= new Set()).add(o);
  o.__typename = "UserEvent";
  o.id = options.id ?? nextFactoryId("UserEvent");
  o.parent = maybeNew(options.parent?.__typename ?? "Approval", options.parent, cache);
  o.parentTypeName = options.parentTypeName ?? "parentTypeName";
  o.createdAt = options.createdAt ?? newDateTime();
  o.createdBy = maybeNew("User", options.createdBy, cache, options.hasOwnProperty("createdBy"));
  o.createdFor = maybeNewOrNull("User", options.createdFor, cache);
  o.type = options.type ?? UserEventType.Created;
  o.typeDetail = enumOrDetailOfUserEventType(options.typeDetail);
  o.development = maybeNewOrNull("Development", options.development, cache);
  o.cohort = maybeNewOrNull("Cohort", options.cohort, cache);
  o.project = maybeNewOrNull("Project", options.project, cache);
  o.notifiedAt = options.notifiedAt ?? null;
  o.comment = maybeNewOrNull("Comment", options.comment, cache);
  o.payload = options.payload ?? null;
  o.attachment = maybeNewOrNull("Attachment", options.attachment, cache);
  return o;
}

factories["UserEvent"] = newUserEvent;

export interface UserEventParentTypeOptions {
  __typename?: "UserEventParentType";
  id?: UserEventParentType["id"];
  name?: UserEventParentType["name"];
}

export function newUserEventParentType(
  options: UserEventParentTypeOptions = {},
  cache: Record<string, any> = {},
): UserEventParentType {
  const o = (options.__typename ? options : cache["UserEventParentType"] = {}) as UserEventParentType;
  (cache.all ??= new Set()).add(o);
  o.__typename = "UserEventParentType";
  o.id = options.id ?? nextFactoryId("UserEventParentType");
  o.name = options.name ?? "name";
  return o;
}

factories["UserEventParentType"] = newUserEventParentType;

export interface UserGroupOptions {
  __typename?: "UserGroup";
  id?: UserGroup["id"];
  name?: UserGroup["name"];
  createdAt?: UserGroup["createdAt"];
  updatedAt?: UserGroup["updatedAt"];
  featureFlagTargets?: Array<FeatureFlagTarget | FeatureFlagTargetOptions>;
  users?: Array<User | UserOptions>;
}

export function newUserGroup(options: UserGroupOptions = {}, cache: Record<string, any> = {}): UserGroup {
  const o = (options.__typename ? options : cache["UserGroup"] = {}) as UserGroup;
  (cache.all ??= new Set()).add(o);
  o.__typename = "UserGroup";
  o.id = options.id ?? nextFactoryId("UserGroup");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.featureFlagTargets = (options.featureFlagTargets ?? []).map((i) =>
    maybeNew("FeatureFlagTarget", i, cache, options.hasOwnProperty("featureFlagTargets"))
  );
  o.users = (options.users ?? []).map((i) => maybeNew("User", i, cache, options.hasOwnProperty("users")));
  return o;
}

factories["UserGroup"] = newUserGroup;

export interface SaveUserGroupResultOptions {
  __typename?: "SaveUserGroupResult";
  userGroup?: UserGroup | UserGroupOptions;
}

export function newSaveUserGroupResult(
  options: SaveUserGroupResultOptions = {},
  cache: Record<string, any> = {},
): SaveUserGroupResult {
  const o = (options.__typename ? options : cache["SaveUserGroupResult"] = {}) as SaveUserGroupResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveUserGroupResult";
  o.userGroup = maybeNew("UserGroup", options.userGroup, cache, options.hasOwnProperty("userGroup"));
  return o;
}

factories["SaveUserGroupResult"] = newSaveUserGroupResult;

export interface SaveWarrantyTicketResultOptions {
  __typename?: "SaveWarrantyTicketResult";
  warrantyTicket?: WarrantyTicket | WarrantyTicketOptions;
}

export function newSaveWarrantyTicketResult(
  options: SaveWarrantyTicketResultOptions = {},
  cache: Record<string, any> = {},
): SaveWarrantyTicketResult {
  const o = (options.__typename ? options : cache["SaveWarrantyTicketResult"] = {}) as SaveWarrantyTicketResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveWarrantyTicketResult";
  o.warrantyTicket = maybeNew(
    "WarrantyTicket",
    options.warrantyTicket,
    cache,
    options.hasOwnProperty("warrantyTicket"),
  );
  return o;
}

factories["SaveWarrantyTicketResult"] = newSaveWarrantyTicketResult;

export interface WarrantyTicketsPageOptions {
  __typename?: "WarrantyTicketsPage";
  entities?: Array<WarrantyTicket | WarrantyTicketOptions>;
  pageInfo?: PageInfo | PageInfoOptions;
}

export function newWarrantyTicketsPage(
  options: WarrantyTicketsPageOptions = {},
  cache: Record<string, any> = {},
): WarrantyTicketsPage {
  const o = (options.__typename ? options : cache["WarrantyTicketsPage"] = {}) as WarrantyTicketsPage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "WarrantyTicketsPage";
  o.entities = (options.entities ?? []).map((i) =>
    maybeNew("WarrantyTicket", i, cache, options.hasOwnProperty("entities"))
  );
  o.pageInfo = maybeNew("PageInfo", options.pageInfo, cache, options.hasOwnProperty("pageInfo"));
  return o;
}

factories["WarrantyTicketsPage"] = newWarrantyTicketsPage;

export interface WarrantyTicketAvailabilityOptions {
  __typename?: "WarrantyTicketAvailability";
  id?: WarrantyTicketAvailability["id"];
  createdAt?: WarrantyTicketAvailability["createdAt"];
  updatedAt?: WarrantyTicketAvailability["updatedAt"];
  dayOfWeek?: DayOfWeekDetailOptions | DayOfWeek;
  timeOfDay?: TimeOfDayDetailOptions | TimeOfDay;
  warrantyTicket?: WarrantyTicket | WarrantyTicketOptions;
}

export function newWarrantyTicketAvailability(
  options: WarrantyTicketAvailabilityOptions = {},
  cache: Record<string, any> = {},
): WarrantyTicketAvailability {
  const o = (options.__typename ? options : cache["WarrantyTicketAvailability"] = {}) as WarrantyTicketAvailability;
  (cache.all ??= new Set()).add(o);
  o.__typename = "WarrantyTicketAvailability";
  o.id = options.id ?? nextFactoryId("WarrantyTicketAvailability");
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.dayOfWeek = enumOrDetailOfDayOfWeek(options.dayOfWeek);
  o.timeOfDay = enumOrDetailOfTimeOfDay(options.timeOfDay);
  o.warrantyTicket = maybeNew(
    "WarrantyTicket",
    options.warrantyTicket,
    cache,
    options.hasOwnProperty("warrantyTicket"),
  );
  return o;
}

factories["WarrantyTicketAvailability"] = newWarrantyTicketAvailability;

export interface WarrantyTicketItemOptions {
  __typename?: "WarrantyTicketItem";
  id?: WarrantyTicketItem["id"];
  product?: WarrantyTicketItem["product"];
  description?: WarrantyTicketItem["description"];
  createdAt?: WarrantyTicketItem["createdAt"];
  updatedAt?: WarrantyTicketItem["updatedAt"];
  status?: WarrantyTicketItemStatusDetailOptions | WarrantyTicketItemStatus;
  warrantyTicket?: WarrantyTicket | WarrantyTicketOptions;
  attachments?: Array<Attachment | AttachmentOptions>;
  type?: WarrantyTicketItemTypeDetailOptions | WarrantyTicketItemType;
  homeownerVisible?: WarrantyTicketItem["homeownerVisible"];
  statusUpdatedAt?: WarrantyTicketItem["statusUpdatedAt"];
}

export function newWarrantyTicketItem(
  options: WarrantyTicketItemOptions = {},
  cache: Record<string, any> = {},
): WarrantyTicketItem {
  const o = (options.__typename ? options : cache["WarrantyTicketItem"] = {}) as WarrantyTicketItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "WarrantyTicketItem";
  o.id = options.id ?? nextFactoryId("WarrantyTicketItem");
  o.product = options.product ?? null;
  o.description = options.description ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.status = enumOrDetailOfWarrantyTicketItemStatus(options.status);
  o.warrantyTicket = maybeNew(
    "WarrantyTicket",
    options.warrantyTicket,
    cache,
    options.hasOwnProperty("warrantyTicket"),
  );
  o.attachments = (options.attachments ?? []).map((i) =>
    maybeNew("Attachment", i, cache, options.hasOwnProperty("attachments"))
  );
  o.type = enumOrDetailOfWarrantyTicketItemType(options.type);
  o.homeownerVisible = options.homeownerVisible ?? false;
  o.statusUpdatedAt = options.statusUpdatedAt ?? newDateTime();
  return o;
}

factories["WarrantyTicketItem"] = newWarrantyTicketItem;

export interface SaveWarrantyTicketItemResultOptions {
  __typename?: "SaveWarrantyTicketItemResult";
  warrantyTicketItem?: WarrantyTicketItem | WarrantyTicketItemOptions;
}

export function newSaveWarrantyTicketItemResult(
  options: SaveWarrantyTicketItemResultOptions = {},
  cache: Record<string, any> = {},
): SaveWarrantyTicketItemResult {
  const o = (options.__typename ? options : cache["SaveWarrantyTicketItemResult"] = {}) as SaveWarrantyTicketItemResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveWarrantyTicketItemResult";
  o.warrantyTicketItem = maybeNew(
    "WarrantyTicketItem",
    options.warrantyTicketItem,
    cache,
    options.hasOwnProperty("warrantyTicketItem"),
  );
  return o;
}

factories["SaveWarrantyTicketItemResult"] = newSaveWarrantyTicketItemResult;

export interface SaveWarrantyTicketItemsResultOptions {
  __typename?: "SaveWarrantyTicketItemsResult";
  warrantyTicketItems?: Array<WarrantyTicketItem | WarrantyTicketItemOptions>;
}

export function newSaveWarrantyTicketItemsResult(
  options: SaveWarrantyTicketItemsResultOptions = {},
  cache: Record<string, any> = {},
): SaveWarrantyTicketItemsResult {
  const o =
    (options.__typename ? options : cache["SaveWarrantyTicketItemsResult"] = {}) as SaveWarrantyTicketItemsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveWarrantyTicketItemsResult";
  o.warrantyTicketItems = (options.warrantyTicketItems ?? []).map((i) =>
    maybeNew("WarrantyTicketItem", i, cache, options.hasOwnProperty("warrantyTicketItems"))
  );
  return o;
}

factories["SaveWarrantyTicketItemsResult"] = newSaveWarrantyTicketItemsResult;

export interface WorkAuthorizationOptions {
  __typename?: "WorkAuthorization";
  id?: WorkAuthorization["id"];
  name?: WorkAuthorization["name"];
  createdAt?: WorkAuthorization["createdAt"];
  updatedAt?: WorkAuthorization["updatedAt"];
  projectStage?: ProjectStage | ProjectStageOptions;
  documents?: Array<Document | DocumentOptions>;
  projectItems?: Array<ProjectItem | ProjectItemOptions>;
}

export function newWorkAuthorization(
  options: WorkAuthorizationOptions = {},
  cache: Record<string, any> = {},
): WorkAuthorization {
  const o = (options.__typename ? options : cache["WorkAuthorization"] = {}) as WorkAuthorization;
  (cache.all ??= new Set()).add(o);
  o.__typename = "WorkAuthorization";
  o.id = options.id ?? nextFactoryId("WorkAuthorization");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.projectStage = maybeNew("ProjectStage", options.projectStage, cache, options.hasOwnProperty("projectStage"));
  o.documents = (options.documents ?? []).map((i) =>
    maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
  );
  o.projectItems = (options.projectItems ?? []).map((i) =>
    maybeNew("ProjectItem", i, cache, options.hasOwnProperty("projectItems"))
  );
  return o;
}

factories["WorkAuthorization"] = newWorkAuthorization;

export interface SaveWorkAuthorizationResultOptions {
  __typename?: "SaveWorkAuthorizationResult";
  workAuthorization?: WorkAuthorization | WorkAuthorizationOptions;
}

export function newSaveWorkAuthorizationResult(
  options: SaveWorkAuthorizationResultOptions = {},
  cache: Record<string, any> = {},
): SaveWorkAuthorizationResult {
  const o = (options.__typename ? options : cache["SaveWorkAuthorizationResult"] = {}) as SaveWorkAuthorizationResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveWorkAuthorizationResult";
  o.workAuthorization = maybeNew(
    "WorkAuthorization",
    options.workAuthorization,
    cache,
    options.hasOwnProperty("workAuthorization"),
  );
  return o;
}

factories["SaveWorkAuthorizationResult"] = newSaveWorkAuthorizationResult;

export type CanCollaborateOptions =
  | ScheduleTaskOptions
  | RequireTypename<ApprovalOptions>
  | RequireTypename<BidContractOptions>
  | RequireTypename<BidItemOptions>
  | RequireTypename<BidPackageRequestOptions>
  | RequireTypename<BillOptions>
  | RequireTypename<ChangeEventOptions>
  | RequireTypename<ChangeRequestOptions>
  | RequireTypename<ChangeRequestToDoOptions>
  | RequireTypename<SchedulePhaseOptions>
  | RequireTypename<ScheduleSubPhaseOptions>
  | RequireTypename<TaskOptions>
  | RequireTypename<PlanTaskOptions>
  | RequireTypename<ToDoOptions>
  | RequireTypename<InvoiceOptions>
  | RequireTypename<StandaloneProjectOptions>
  | RequireTypename<RegionOptions>
  | RequireTypename<MarketOptions>
  | RequireTypename<CommunityOptions>
  | RequireTypename<SubdivisionOptions>
  | RequireTypename<LotOptions>
  | RequireTypename<StructureOptions>
  | RequireTypename<UnitOptions>
  | RequireTypename<ProjectItemOptions>
  | RequireTypename<EstimateOptions>
  | RequireTypename<DevelopmentCommitmentOptions>
  | RequireTypename<CommitmentOptions>
  | RequireTypename<DocumentOptions>
  | RequireTypename<ProductOptions>
  | RequireTypename<ItemTemplateItemVersionOptions>
  | RequireTypename<JobLogNoteOptions>
  | RequireTypename<TradePartnerAvailabilityRequestOptions>
  | RequireTypename<PunchlistItemTodoOptions>
  | RequireTypename<WarrantyTicketOptions>
  | RequireTypename<HomeownerContractOptions>
  | RequireTypename<HomeownerContractChangeOrderOptions>
  | RequireTypename<ReadyPlanOptions>
  | RequireTypename<PlanPackageOptions>
  | RequireTypename<GlobalOptionOptions>
  | RequireTypename<ProjectCostCodeOptions>;

export type CanCollaborateType =
  | ScheduleTask
  | Approval
  | BidContract
  | BidItem
  | BidPackageRequest
  | Bill
  | ChangeEvent
  | ChangeRequest
  | ChangeRequestToDo
  | SchedulePhase
  | ScheduleSubPhase
  | Task
  | PlanTask
  | ToDo
  | Invoice
  | StandaloneProject
  | Region
  | Market
  | Community
  | Subdivision
  | Lot
  | Structure
  | Unit
  | ProjectItem
  | Estimate
  | DevelopmentCommitment
  | Commitment
  | Document
  | Product
  | ItemTemplateItemVersion
  | JobLogNote
  | TradePartnerAvailabilityRequest
  | PunchlistItemTodo
  | WarrantyTicket
  | HomeownerContract
  | HomeownerContractChangeOrder
  | ReadyPlan
  | PlanPackage
  | GlobalOption
  | ProjectCostCode;

export type CanCollaborateTypeName =
  | "ScheduleTask"
  | "Approval"
  | "BidContract"
  | "BidItem"
  | "BidPackageRequest"
  | "Bill"
  | "ChangeEvent"
  | "ChangeRequest"
  | "ChangeRequestToDo"
  | "SchedulePhase"
  | "ScheduleSubPhase"
  | "Task"
  | "PlanTask"
  | "ToDo"
  | "Invoice"
  | "StandaloneProject"
  | "Region"
  | "Market"
  | "Community"
  | "Subdivision"
  | "Lot"
  | "Structure"
  | "Unit"
  | "ProjectItem"
  | "Estimate"
  | "DevelopmentCommitment"
  | "Commitment"
  | "Document"
  | "Product"
  | "ItemTemplateItemVersion"
  | "JobLogNote"
  | "TradePartnerAvailabilityRequest"
  | "PunchlistItemTodo"
  | "WarrantyTicket"
  | "HomeownerContract"
  | "HomeownerContractChangeOrder"
  | "ReadyPlan"
  | "PlanPackage"
  | "GlobalOption"
  | "ProjectCostCode";

export function newCanCollaborate(): ScheduleTask;
export function newCanCollaborate(options: ScheduleTaskOptions, cache?: Record<string, any>): ScheduleTask;
export function newCanCollaborate(options: RequireTypename<ApprovalOptions>, cache?: Record<string, any>): Approval;
export function newCanCollaborate(
  options: RequireTypename<BidContractOptions>,
  cache?: Record<string, any>,
): BidContract;
export function newCanCollaborate(options: RequireTypename<BidItemOptions>, cache?: Record<string, any>): BidItem;
export function newCanCollaborate(
  options: RequireTypename<BidPackageRequestOptions>,
  cache?: Record<string, any>,
): BidPackageRequest;
export function newCanCollaborate(options: RequireTypename<BillOptions>, cache?: Record<string, any>): Bill;
export function newCanCollaborate(
  options: RequireTypename<ChangeEventOptions>,
  cache?: Record<string, any>,
): ChangeEvent;
export function newCanCollaborate(
  options: RequireTypename<ChangeRequestOptions>,
  cache?: Record<string, any>,
): ChangeRequest;
export function newCanCollaborate(
  options: RequireTypename<ChangeRequestToDoOptions>,
  cache?: Record<string, any>,
): ChangeRequestToDo;
export function newCanCollaborate(
  options: RequireTypename<SchedulePhaseOptions>,
  cache?: Record<string, any>,
): SchedulePhase;
export function newCanCollaborate(
  options: RequireTypename<ScheduleSubPhaseOptions>,
  cache?: Record<string, any>,
): ScheduleSubPhase;
export function newCanCollaborate(options: RequireTypename<TaskOptions>, cache?: Record<string, any>): Task;
export function newCanCollaborate(options: RequireTypename<PlanTaskOptions>, cache?: Record<string, any>): PlanTask;
export function newCanCollaborate(options: RequireTypename<ToDoOptions>, cache?: Record<string, any>): ToDo;
export function newCanCollaborate(options: RequireTypename<InvoiceOptions>, cache?: Record<string, any>): Invoice;
export function newCanCollaborate(
  options: RequireTypename<StandaloneProjectOptions>,
  cache?: Record<string, any>,
): StandaloneProject;
export function newCanCollaborate(options: RequireTypename<RegionOptions>, cache?: Record<string, any>): Region;
export function newCanCollaborate(options: RequireTypename<MarketOptions>, cache?: Record<string, any>): Market;
export function newCanCollaborate(options: RequireTypename<CommunityOptions>, cache?: Record<string, any>): Community;
export function newCanCollaborate(
  options: RequireTypename<SubdivisionOptions>,
  cache?: Record<string, any>,
): Subdivision;
export function newCanCollaborate(options: RequireTypename<LotOptions>, cache?: Record<string, any>): Lot;
export function newCanCollaborate(options: RequireTypename<StructureOptions>, cache?: Record<string, any>): Structure;
export function newCanCollaborate(options: RequireTypename<UnitOptions>, cache?: Record<string, any>): Unit;
export function newCanCollaborate(
  options: RequireTypename<ProjectItemOptions>,
  cache?: Record<string, any>,
): ProjectItem;
export function newCanCollaborate(options: RequireTypename<EstimateOptions>, cache?: Record<string, any>): Estimate;
export function newCanCollaborate(
  options: RequireTypename<DevelopmentCommitmentOptions>,
  cache?: Record<string, any>,
): DevelopmentCommitment;
export function newCanCollaborate(options: RequireTypename<CommitmentOptions>, cache?: Record<string, any>): Commitment;
export function newCanCollaborate(options: RequireTypename<DocumentOptions>, cache?: Record<string, any>): Document;
export function newCanCollaborate(options: RequireTypename<ProductOptions>, cache?: Record<string, any>): Product;
export function newCanCollaborate(
  options: RequireTypename<ItemTemplateItemVersionOptions>,
  cache?: Record<string, any>,
): ItemTemplateItemVersion;
export function newCanCollaborate(options: RequireTypename<JobLogNoteOptions>, cache?: Record<string, any>): JobLogNote;
export function newCanCollaborate(
  options: RequireTypename<TradePartnerAvailabilityRequestOptions>,
  cache?: Record<string, any>,
): TradePartnerAvailabilityRequest;
export function newCanCollaborate(
  options: RequireTypename<PunchlistItemTodoOptions>,
  cache?: Record<string, any>,
): PunchlistItemTodo;
export function newCanCollaborate(
  options: RequireTypename<WarrantyTicketOptions>,
  cache?: Record<string, any>,
): WarrantyTicket;
export function newCanCollaborate(
  options: RequireTypename<HomeownerContractOptions>,
  cache?: Record<string, any>,
): HomeownerContract;
export function newCanCollaborate(
  options: RequireTypename<HomeownerContractChangeOrderOptions>,
  cache?: Record<string, any>,
): HomeownerContractChangeOrder;
export function newCanCollaborate(options: RequireTypename<ReadyPlanOptions>, cache?: Record<string, any>): ReadyPlan;
export function newCanCollaborate(
  options: RequireTypename<PlanPackageOptions>,
  cache?: Record<string, any>,
): PlanPackage;
export function newCanCollaborate(
  options: RequireTypename<GlobalOptionOptions>,
  cache?: Record<string, any>,
): GlobalOption;
export function newCanCollaborate(
  options: RequireTypename<ProjectCostCodeOptions>,
  cache?: Record<string, any>,
): ProjectCostCode;
export function newCanCollaborate(
  options: CanCollaborateOptions = {},
  cache: Record<string, any> = {},
): CanCollaborateType {
  const { __typename = "ScheduleTask" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["CanCollaborate"] = newCanCollaborate;

export type CommentableOptions =
  | ScheduleTaskOptions
  | RequireTypename<ApprovalOptions>
  | RequireTypename<BidContractOptions>
  | RequireTypename<BidItemOptions>
  | RequireTypename<BidPackageRequestOptions>
  | RequireTypename<BillOptions>
  | RequireTypename<ChangeEventOptions>
  | RequireTypename<ChangeRequestOptions>
  | RequireTypename<ChangeRequestToDoOptions>
  | RequireTypename<SchedulePhaseOptions>
  | RequireTypename<ScheduleSubPhaseOptions>
  | RequireTypename<TaskOptions>
  | RequireTypename<PlanTaskOptions>
  | RequireTypename<ToDoOptions>
  | RequireTypename<InvoiceOptions>
  | RequireTypename<StandaloneProjectOptions>
  | RequireTypename<RegionOptions>
  | RequireTypename<MarketOptions>
  | RequireTypename<CommunityOptions>
  | RequireTypename<SubdivisionOptions>
  | RequireTypename<LotOptions>
  | RequireTypename<StructureOptions>
  | RequireTypename<UnitOptions>
  | RequireTypename<ProjectItemOptions>
  | RequireTypename<EstimateOptions>
  | RequireTypename<DevelopmentCommitmentOptions>
  | RequireTypename<CommitmentOptions>
  | RequireTypename<DocumentOptions>
  | RequireTypename<ProductOptions>
  | RequireTypename<ItemTemplateItemVersionOptions>
  | RequireTypename<JobLogNoteOptions>
  | RequireTypename<TradePartnerAvailabilityRequestOptions>
  | RequireTypename<PunchlistItemTodoOptions>
  | RequireTypename<WarrantyTicketOptions>
  | RequireTypename<HomeownerContractOptions>
  | RequireTypename<HomeownerContractChangeOrderOptions>
  | RequireTypename<ReadyPlanOptions>
  | RequireTypename<PlanPackageOptions>
  | RequireTypename<GlobalOptionOptions>
  | RequireTypename<ProjectCostCodeOptions>;

export type CommentableType =
  | ScheduleTask
  | Approval
  | BidContract
  | BidItem
  | BidPackageRequest
  | Bill
  | ChangeEvent
  | ChangeRequest
  | ChangeRequestToDo
  | SchedulePhase
  | ScheduleSubPhase
  | Task
  | PlanTask
  | ToDo
  | Invoice
  | StandaloneProject
  | Region
  | Market
  | Community
  | Subdivision
  | Lot
  | Structure
  | Unit
  | ProjectItem
  | Estimate
  | DevelopmentCommitment
  | Commitment
  | Document
  | Product
  | ItemTemplateItemVersion
  | JobLogNote
  | TradePartnerAvailabilityRequest
  | PunchlistItemTodo
  | WarrantyTicket
  | HomeownerContract
  | HomeownerContractChangeOrder
  | ReadyPlan
  | PlanPackage
  | GlobalOption
  | ProjectCostCode;

export type CommentableTypeName =
  | "ScheduleTask"
  | "Approval"
  | "BidContract"
  | "BidItem"
  | "BidPackageRequest"
  | "Bill"
  | "ChangeEvent"
  | "ChangeRequest"
  | "ChangeRequestToDo"
  | "SchedulePhase"
  | "ScheduleSubPhase"
  | "Task"
  | "PlanTask"
  | "ToDo"
  | "Invoice"
  | "StandaloneProject"
  | "Region"
  | "Market"
  | "Community"
  | "Subdivision"
  | "Lot"
  | "Structure"
  | "Unit"
  | "ProjectItem"
  | "Estimate"
  | "DevelopmentCommitment"
  | "Commitment"
  | "Document"
  | "Product"
  | "ItemTemplateItemVersion"
  | "JobLogNote"
  | "TradePartnerAvailabilityRequest"
  | "PunchlistItemTodo"
  | "WarrantyTicket"
  | "HomeownerContract"
  | "HomeownerContractChangeOrder"
  | "ReadyPlan"
  | "PlanPackage"
  | "GlobalOption"
  | "ProjectCostCode";

export function newCommentable(): ScheduleTask;
export function newCommentable(options: ScheduleTaskOptions, cache?: Record<string, any>): ScheduleTask;
export function newCommentable(options: RequireTypename<ApprovalOptions>, cache?: Record<string, any>): Approval;
export function newCommentable(options: RequireTypename<BidContractOptions>, cache?: Record<string, any>): BidContract;
export function newCommentable(options: RequireTypename<BidItemOptions>, cache?: Record<string, any>): BidItem;
export function newCommentable(
  options: RequireTypename<BidPackageRequestOptions>,
  cache?: Record<string, any>,
): BidPackageRequest;
export function newCommentable(options: RequireTypename<BillOptions>, cache?: Record<string, any>): Bill;
export function newCommentable(options: RequireTypename<ChangeEventOptions>, cache?: Record<string, any>): ChangeEvent;
export function newCommentable(
  options: RequireTypename<ChangeRequestOptions>,
  cache?: Record<string, any>,
): ChangeRequest;
export function newCommentable(
  options: RequireTypename<ChangeRequestToDoOptions>,
  cache?: Record<string, any>,
): ChangeRequestToDo;
export function newCommentable(
  options: RequireTypename<SchedulePhaseOptions>,
  cache?: Record<string, any>,
): SchedulePhase;
export function newCommentable(
  options: RequireTypename<ScheduleSubPhaseOptions>,
  cache?: Record<string, any>,
): ScheduleSubPhase;
export function newCommentable(options: RequireTypename<TaskOptions>, cache?: Record<string, any>): Task;
export function newCommentable(options: RequireTypename<PlanTaskOptions>, cache?: Record<string, any>): PlanTask;
export function newCommentable(options: RequireTypename<ToDoOptions>, cache?: Record<string, any>): ToDo;
export function newCommentable(options: RequireTypename<InvoiceOptions>, cache?: Record<string, any>): Invoice;
export function newCommentable(
  options: RequireTypename<StandaloneProjectOptions>,
  cache?: Record<string, any>,
): StandaloneProject;
export function newCommentable(options: RequireTypename<RegionOptions>, cache?: Record<string, any>): Region;
export function newCommentable(options: RequireTypename<MarketOptions>, cache?: Record<string, any>): Market;
export function newCommentable(options: RequireTypename<CommunityOptions>, cache?: Record<string, any>): Community;
export function newCommentable(options: RequireTypename<SubdivisionOptions>, cache?: Record<string, any>): Subdivision;
export function newCommentable(options: RequireTypename<LotOptions>, cache?: Record<string, any>): Lot;
export function newCommentable(options: RequireTypename<StructureOptions>, cache?: Record<string, any>): Structure;
export function newCommentable(options: RequireTypename<UnitOptions>, cache?: Record<string, any>): Unit;
export function newCommentable(options: RequireTypename<ProjectItemOptions>, cache?: Record<string, any>): ProjectItem;
export function newCommentable(options: RequireTypename<EstimateOptions>, cache?: Record<string, any>): Estimate;
export function newCommentable(
  options: RequireTypename<DevelopmentCommitmentOptions>,
  cache?: Record<string, any>,
): DevelopmentCommitment;
export function newCommentable(options: RequireTypename<CommitmentOptions>, cache?: Record<string, any>): Commitment;
export function newCommentable(options: RequireTypename<DocumentOptions>, cache?: Record<string, any>): Document;
export function newCommentable(options: RequireTypename<ProductOptions>, cache?: Record<string, any>): Product;
export function newCommentable(
  options: RequireTypename<ItemTemplateItemVersionOptions>,
  cache?: Record<string, any>,
): ItemTemplateItemVersion;
export function newCommentable(options: RequireTypename<JobLogNoteOptions>, cache?: Record<string, any>): JobLogNote;
export function newCommentable(
  options: RequireTypename<TradePartnerAvailabilityRequestOptions>,
  cache?: Record<string, any>,
): TradePartnerAvailabilityRequest;
export function newCommentable(
  options: RequireTypename<PunchlistItemTodoOptions>,
  cache?: Record<string, any>,
): PunchlistItemTodo;
export function newCommentable(
  options: RequireTypename<WarrantyTicketOptions>,
  cache?: Record<string, any>,
): WarrantyTicket;
export function newCommentable(
  options: RequireTypename<HomeownerContractOptions>,
  cache?: Record<string, any>,
): HomeownerContract;
export function newCommentable(
  options: RequireTypename<HomeownerContractChangeOrderOptions>,
  cache?: Record<string, any>,
): HomeownerContractChangeOrder;
export function newCommentable(options: RequireTypename<ReadyPlanOptions>, cache?: Record<string, any>): ReadyPlan;
export function newCommentable(options: RequireTypename<PlanPackageOptions>, cache?: Record<string, any>): PlanPackage;
export function newCommentable(
  options: RequireTypename<GlobalOptionOptions>,
  cache?: Record<string, any>,
): GlobalOption;
export function newCommentable(
  options: RequireTypename<ProjectCostCodeOptions>,
  cache?: Record<string, any>,
): ProjectCostCode;
export function newCommentable(options: CommentableOptions = {}, cache: Record<string, any> = {}): CommentableType {
  const { __typename = "ScheduleTask" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["Commentable"] = newCommentable;

export type ReferencableOptions =
  | ScheduleTaskOptions
  | RequireTypename<ApprovalOptions>
  | RequireTypename<BidContractOptions>
  | RequireTypename<BidItemOptions>
  | RequireTypename<BidPackageRequestOptions>
  | RequireTypename<BillOptions>
  | RequireTypename<ChangeEventOptions>
  | RequireTypename<ChangeRequestOptions>
  | RequireTypename<ChangeRequestToDoOptions>
  | RequireTypename<SchedulePhaseOptions>
  | RequireTypename<ScheduleSubPhaseOptions>
  | RequireTypename<TaskOptions>
  | RequireTypename<PlanTaskOptions>
  | RequireTypename<ToDoOptions>
  | RequireTypename<InvoiceOptions>
  | RequireTypename<StandaloneProjectOptions>
  | RequireTypename<RegionOptions>
  | RequireTypename<MarketOptions>
  | RequireTypename<CommunityOptions>
  | RequireTypename<SubdivisionOptions>
  | RequireTypename<LotOptions>
  | RequireTypename<StructureOptions>
  | RequireTypename<UnitOptions>
  | RequireTypename<ProjectItemOptions>
  | RequireTypename<EstimateOptions>
  | RequireTypename<DevelopmentCommitmentOptions>
  | RequireTypename<CommitmentOptions>
  | RequireTypename<DocumentOptions>
  | RequireTypename<ProductOptions>
  | RequireTypename<ItemTemplateItemVersionOptions>
  | RequireTypename<JobLogNoteOptions>
  | RequireTypename<TradePartnerAvailabilityRequestOptions>
  | RequireTypename<PunchlistItemTodoOptions>
  | RequireTypename<WarrantyTicketOptions>
  | RequireTypename<HomeownerContractOptions>
  | RequireTypename<HomeownerContractChangeOrderOptions>
  | RequireTypename<ReadyPlanOptions>
  | RequireTypename<PlanPackageOptions>
  | RequireTypename<GlobalOptionOptions>
  | RequireTypename<ProjectCostCodeOptions>;

export type ReferencableType =
  | ScheduleTask
  | Approval
  | BidContract
  | BidItem
  | BidPackageRequest
  | Bill
  | ChangeEvent
  | ChangeRequest
  | ChangeRequestToDo
  | SchedulePhase
  | ScheduleSubPhase
  | Task
  | PlanTask
  | ToDo
  | Invoice
  | StandaloneProject
  | Region
  | Market
  | Community
  | Subdivision
  | Lot
  | Structure
  | Unit
  | ProjectItem
  | Estimate
  | DevelopmentCommitment
  | Commitment
  | Document
  | Product
  | ItemTemplateItemVersion
  | JobLogNote
  | TradePartnerAvailabilityRequest
  | PunchlistItemTodo
  | WarrantyTicket
  | HomeownerContract
  | HomeownerContractChangeOrder
  | ReadyPlan
  | PlanPackage
  | GlobalOption
  | ProjectCostCode;

export type ReferencableTypeName =
  | "ScheduleTask"
  | "Approval"
  | "BidContract"
  | "BidItem"
  | "BidPackageRequest"
  | "Bill"
  | "ChangeEvent"
  | "ChangeRequest"
  | "ChangeRequestToDo"
  | "SchedulePhase"
  | "ScheduleSubPhase"
  | "Task"
  | "PlanTask"
  | "ToDo"
  | "Invoice"
  | "StandaloneProject"
  | "Region"
  | "Market"
  | "Community"
  | "Subdivision"
  | "Lot"
  | "Structure"
  | "Unit"
  | "ProjectItem"
  | "Estimate"
  | "DevelopmentCommitment"
  | "Commitment"
  | "Document"
  | "Product"
  | "ItemTemplateItemVersion"
  | "JobLogNote"
  | "TradePartnerAvailabilityRequest"
  | "PunchlistItemTodo"
  | "WarrantyTicket"
  | "HomeownerContract"
  | "HomeownerContractChangeOrder"
  | "ReadyPlan"
  | "PlanPackage"
  | "GlobalOption"
  | "ProjectCostCode";

export function newReferencable(): ScheduleTask;
export function newReferencable(options: ScheduleTaskOptions, cache?: Record<string, any>): ScheduleTask;
export function newReferencable(options: RequireTypename<ApprovalOptions>, cache?: Record<string, any>): Approval;
export function newReferencable(options: RequireTypename<BidContractOptions>, cache?: Record<string, any>): BidContract;
export function newReferencable(options: RequireTypename<BidItemOptions>, cache?: Record<string, any>): BidItem;
export function newReferencable(
  options: RequireTypename<BidPackageRequestOptions>,
  cache?: Record<string, any>,
): BidPackageRequest;
export function newReferencable(options: RequireTypename<BillOptions>, cache?: Record<string, any>): Bill;
export function newReferencable(options: RequireTypename<ChangeEventOptions>, cache?: Record<string, any>): ChangeEvent;
export function newReferencable(
  options: RequireTypename<ChangeRequestOptions>,
  cache?: Record<string, any>,
): ChangeRequest;
export function newReferencable(
  options: RequireTypename<ChangeRequestToDoOptions>,
  cache?: Record<string, any>,
): ChangeRequestToDo;
export function newReferencable(
  options: RequireTypename<SchedulePhaseOptions>,
  cache?: Record<string, any>,
): SchedulePhase;
export function newReferencable(
  options: RequireTypename<ScheduleSubPhaseOptions>,
  cache?: Record<string, any>,
): ScheduleSubPhase;
export function newReferencable(options: RequireTypename<TaskOptions>, cache?: Record<string, any>): Task;
export function newReferencable(options: RequireTypename<PlanTaskOptions>, cache?: Record<string, any>): PlanTask;
export function newReferencable(options: RequireTypename<ToDoOptions>, cache?: Record<string, any>): ToDo;
export function newReferencable(options: RequireTypename<InvoiceOptions>, cache?: Record<string, any>): Invoice;
export function newReferencable(
  options: RequireTypename<StandaloneProjectOptions>,
  cache?: Record<string, any>,
): StandaloneProject;
export function newReferencable(options: RequireTypename<RegionOptions>, cache?: Record<string, any>): Region;
export function newReferencable(options: RequireTypename<MarketOptions>, cache?: Record<string, any>): Market;
export function newReferencable(options: RequireTypename<CommunityOptions>, cache?: Record<string, any>): Community;
export function newReferencable(options: RequireTypename<SubdivisionOptions>, cache?: Record<string, any>): Subdivision;
export function newReferencable(options: RequireTypename<LotOptions>, cache?: Record<string, any>): Lot;
export function newReferencable(options: RequireTypename<StructureOptions>, cache?: Record<string, any>): Structure;
export function newReferencable(options: RequireTypename<UnitOptions>, cache?: Record<string, any>): Unit;
export function newReferencable(options: RequireTypename<ProjectItemOptions>, cache?: Record<string, any>): ProjectItem;
export function newReferencable(options: RequireTypename<EstimateOptions>, cache?: Record<string, any>): Estimate;
export function newReferencable(
  options: RequireTypename<DevelopmentCommitmentOptions>,
  cache?: Record<string, any>,
): DevelopmentCommitment;
export function newReferencable(options: RequireTypename<CommitmentOptions>, cache?: Record<string, any>): Commitment;
export function newReferencable(options: RequireTypename<DocumentOptions>, cache?: Record<string, any>): Document;
export function newReferencable(options: RequireTypename<ProductOptions>, cache?: Record<string, any>): Product;
export function newReferencable(
  options: RequireTypename<ItemTemplateItemVersionOptions>,
  cache?: Record<string, any>,
): ItemTemplateItemVersion;
export function newReferencable(options: RequireTypename<JobLogNoteOptions>, cache?: Record<string, any>): JobLogNote;
export function newReferencable(
  options: RequireTypename<TradePartnerAvailabilityRequestOptions>,
  cache?: Record<string, any>,
): TradePartnerAvailabilityRequest;
export function newReferencable(
  options: RequireTypename<PunchlistItemTodoOptions>,
  cache?: Record<string, any>,
): PunchlistItemTodo;
export function newReferencable(
  options: RequireTypename<WarrantyTicketOptions>,
  cache?: Record<string, any>,
): WarrantyTicket;
export function newReferencable(
  options: RequireTypename<HomeownerContractOptions>,
  cache?: Record<string, any>,
): HomeownerContract;
export function newReferencable(
  options: RequireTypename<HomeownerContractChangeOrderOptions>,
  cache?: Record<string, any>,
): HomeownerContractChangeOrder;
export function newReferencable(options: RequireTypename<ReadyPlanOptions>, cache?: Record<string, any>): ReadyPlan;
export function newReferencable(options: RequireTypename<PlanPackageOptions>, cache?: Record<string, any>): PlanPackage;
export function newReferencable(
  options: RequireTypename<GlobalOptionOptions>,
  cache?: Record<string, any>,
): GlobalOption;
export function newReferencable(
  options: RequireTypename<ProjectCostCodeOptions>,
  cache?: Record<string, any>,
): ProjectCostCode;
export function newReferencable(options: ReferencableOptions = {}, cache: Record<string, any> = {}): ReferencableType {
  const { __typename = "ScheduleTask" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["Referencable"] = newReferencable;

export type FollowableOptions =
  | ScheduleTaskOptions
  | RequireTypename<ApprovalOptions>
  | RequireTypename<BidContractOptions>
  | RequireTypename<BidItemOptions>
  | RequireTypename<BidPackageRequestOptions>
  | RequireTypename<BillOptions>
  | RequireTypename<ChangeEventOptions>
  | RequireTypename<ChangeRequestOptions>
  | RequireTypename<ChangeRequestToDoOptions>
  | RequireTypename<SchedulePhaseOptions>
  | RequireTypename<ScheduleSubPhaseOptions>
  | RequireTypename<TaskOptions>
  | RequireTypename<PlanTaskOptions>
  | RequireTypename<ToDoOptions>
  | RequireTypename<InvoiceOptions>
  | RequireTypename<StandaloneProjectOptions>
  | RequireTypename<RegionOptions>
  | RequireTypename<MarketOptions>
  | RequireTypename<CommunityOptions>
  | RequireTypename<SubdivisionOptions>
  | RequireTypename<LotOptions>
  | RequireTypename<StructureOptions>
  | RequireTypename<UnitOptions>
  | RequireTypename<ProjectItemOptions>
  | RequireTypename<EstimateOptions>
  | RequireTypename<DevelopmentCommitmentOptions>
  | RequireTypename<CommitmentOptions>
  | RequireTypename<DocumentOptions>
  | RequireTypename<ProductOptions>
  | RequireTypename<ItemTemplateItemVersionOptions>
  | RequireTypename<JobLogNoteOptions>
  | RequireTypename<TradePartnerAvailabilityRequestOptions>
  | RequireTypename<PunchlistItemTodoOptions>
  | RequireTypename<WarrantyTicketOptions>
  | RequireTypename<HomeownerContractOptions>
  | RequireTypename<HomeownerContractChangeOrderOptions>
  | RequireTypename<ReadyPlanOptions>
  | RequireTypename<PlanPackageOptions>
  | RequireTypename<GlobalOptionOptions>
  | RequireTypename<ProjectCostCodeOptions>;

export type FollowableType =
  | ScheduleTask
  | Approval
  | BidContract
  | BidItem
  | BidPackageRequest
  | Bill
  | ChangeEvent
  | ChangeRequest
  | ChangeRequestToDo
  | SchedulePhase
  | ScheduleSubPhase
  | Task
  | PlanTask
  | ToDo
  | Invoice
  | StandaloneProject
  | Region
  | Market
  | Community
  | Subdivision
  | Lot
  | Structure
  | Unit
  | ProjectItem
  | Estimate
  | DevelopmentCommitment
  | Commitment
  | Document
  | Product
  | ItemTemplateItemVersion
  | JobLogNote
  | TradePartnerAvailabilityRequest
  | PunchlistItemTodo
  | WarrantyTicket
  | HomeownerContract
  | HomeownerContractChangeOrder
  | ReadyPlan
  | PlanPackage
  | GlobalOption
  | ProjectCostCode;

export type FollowableTypeName =
  | "ScheduleTask"
  | "Approval"
  | "BidContract"
  | "BidItem"
  | "BidPackageRequest"
  | "Bill"
  | "ChangeEvent"
  | "ChangeRequest"
  | "ChangeRequestToDo"
  | "SchedulePhase"
  | "ScheduleSubPhase"
  | "Task"
  | "PlanTask"
  | "ToDo"
  | "Invoice"
  | "StandaloneProject"
  | "Region"
  | "Market"
  | "Community"
  | "Subdivision"
  | "Lot"
  | "Structure"
  | "Unit"
  | "ProjectItem"
  | "Estimate"
  | "DevelopmentCommitment"
  | "Commitment"
  | "Document"
  | "Product"
  | "ItemTemplateItemVersion"
  | "JobLogNote"
  | "TradePartnerAvailabilityRequest"
  | "PunchlistItemTodo"
  | "WarrantyTicket"
  | "HomeownerContract"
  | "HomeownerContractChangeOrder"
  | "ReadyPlan"
  | "PlanPackage"
  | "GlobalOption"
  | "ProjectCostCode";

export function newFollowable(): ScheduleTask;
export function newFollowable(options: ScheduleTaskOptions, cache?: Record<string, any>): ScheduleTask;
export function newFollowable(options: RequireTypename<ApprovalOptions>, cache?: Record<string, any>): Approval;
export function newFollowable(options: RequireTypename<BidContractOptions>, cache?: Record<string, any>): BidContract;
export function newFollowable(options: RequireTypename<BidItemOptions>, cache?: Record<string, any>): BidItem;
export function newFollowable(
  options: RequireTypename<BidPackageRequestOptions>,
  cache?: Record<string, any>,
): BidPackageRequest;
export function newFollowable(options: RequireTypename<BillOptions>, cache?: Record<string, any>): Bill;
export function newFollowable(options: RequireTypename<ChangeEventOptions>, cache?: Record<string, any>): ChangeEvent;
export function newFollowable(
  options: RequireTypename<ChangeRequestOptions>,
  cache?: Record<string, any>,
): ChangeRequest;
export function newFollowable(
  options: RequireTypename<ChangeRequestToDoOptions>,
  cache?: Record<string, any>,
): ChangeRequestToDo;
export function newFollowable(
  options: RequireTypename<SchedulePhaseOptions>,
  cache?: Record<string, any>,
): SchedulePhase;
export function newFollowable(
  options: RequireTypename<ScheduleSubPhaseOptions>,
  cache?: Record<string, any>,
): ScheduleSubPhase;
export function newFollowable(options: RequireTypename<TaskOptions>, cache?: Record<string, any>): Task;
export function newFollowable(options: RequireTypename<PlanTaskOptions>, cache?: Record<string, any>): PlanTask;
export function newFollowable(options: RequireTypename<ToDoOptions>, cache?: Record<string, any>): ToDo;
export function newFollowable(options: RequireTypename<InvoiceOptions>, cache?: Record<string, any>): Invoice;
export function newFollowable(
  options: RequireTypename<StandaloneProjectOptions>,
  cache?: Record<string, any>,
): StandaloneProject;
export function newFollowable(options: RequireTypename<RegionOptions>, cache?: Record<string, any>): Region;
export function newFollowable(options: RequireTypename<MarketOptions>, cache?: Record<string, any>): Market;
export function newFollowable(options: RequireTypename<CommunityOptions>, cache?: Record<string, any>): Community;
export function newFollowable(options: RequireTypename<SubdivisionOptions>, cache?: Record<string, any>): Subdivision;
export function newFollowable(options: RequireTypename<LotOptions>, cache?: Record<string, any>): Lot;
export function newFollowable(options: RequireTypename<StructureOptions>, cache?: Record<string, any>): Structure;
export function newFollowable(options: RequireTypename<UnitOptions>, cache?: Record<string, any>): Unit;
export function newFollowable(options: RequireTypename<ProjectItemOptions>, cache?: Record<string, any>): ProjectItem;
export function newFollowable(options: RequireTypename<EstimateOptions>, cache?: Record<string, any>): Estimate;
export function newFollowable(
  options: RequireTypename<DevelopmentCommitmentOptions>,
  cache?: Record<string, any>,
): DevelopmentCommitment;
export function newFollowable(options: RequireTypename<CommitmentOptions>, cache?: Record<string, any>): Commitment;
export function newFollowable(options: RequireTypename<DocumentOptions>, cache?: Record<string, any>): Document;
export function newFollowable(options: RequireTypename<ProductOptions>, cache?: Record<string, any>): Product;
export function newFollowable(
  options: RequireTypename<ItemTemplateItemVersionOptions>,
  cache?: Record<string, any>,
): ItemTemplateItemVersion;
export function newFollowable(options: RequireTypename<JobLogNoteOptions>, cache?: Record<string, any>): JobLogNote;
export function newFollowable(
  options: RequireTypename<TradePartnerAvailabilityRequestOptions>,
  cache?: Record<string, any>,
): TradePartnerAvailabilityRequest;
export function newFollowable(
  options: RequireTypename<PunchlistItemTodoOptions>,
  cache?: Record<string, any>,
): PunchlistItemTodo;
export function newFollowable(
  options: RequireTypename<WarrantyTicketOptions>,
  cache?: Record<string, any>,
): WarrantyTicket;
export function newFollowable(
  options: RequireTypename<HomeownerContractOptions>,
  cache?: Record<string, any>,
): HomeownerContract;
export function newFollowable(
  options: RequireTypename<HomeownerContractChangeOrderOptions>,
  cache?: Record<string, any>,
): HomeownerContractChangeOrder;
export function newFollowable(options: RequireTypename<ReadyPlanOptions>, cache?: Record<string, any>): ReadyPlan;
export function newFollowable(options: RequireTypename<PlanPackageOptions>, cache?: Record<string, any>): PlanPackage;
export function newFollowable(options: RequireTypename<GlobalOptionOptions>, cache?: Record<string, any>): GlobalOption;
export function newFollowable(
  options: RequireTypename<ProjectCostCodeOptions>,
  cache?: Record<string, any>,
): ProjectCostCode;
export function newFollowable(options: FollowableOptions = {}, cache: Record<string, any> = {}): FollowableType {
  const { __typename = "ScheduleTask" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["Followable"] = newFollowable;

export type EntityOptions =
  | ScheduleTaskOptions
  | RequireTypename<AssetOptions>
  | RequireTypename<TradePartnerOptions>
  | RequireTypename<BillOptions>
  | RequireTypename<PlanTaskOptions>
  | RequireTypename<StandaloneProjectOptions>
  | RequireTypename<RegionOptions>
  | RequireTypename<MarketOptions>
  | RequireTypename<CommunityOptions>
  | RequireTypename<SubdivisionOptions>
  | RequireTypename<LotOptions>
  | RequireTypename<StructureOptions>
  | RequireTypename<UnitOptions>
  | RequireTypename<DocumentOptions>
  | RequireTypename<JobLogNoteOptions>
  | RequireTypename<PunchlistItemTodoOptions>
  | RequireTypename<CommentOptions>
  | RequireTypename<CommitmentDrawOptions>
  | RequireTypename<FeatureFlagOptions>
  | RequireTypename<JobLogOptions>
  | RequireTypename<JobLogImageOptions>
  | RequireTypename<LocationOptions>
  | RequireTypename<MobileSyncUpdateOptions>
  | RequireTypename<ScheduleFlagOptions>
  | RequireTypename<ScheduleFlagReasonOptions>
  | RequireTypename<ScheduleTaskChecklistItemOptions>
  | RequireTypename<TaskWorkDayOptions>
  | RequireTypename<TradePartnerContactOptions>
  | RequireTypename<TradePartnerUserOptions>;

export type EntityType =
  | ScheduleTask
  | Asset
  | TradePartner
  | Bill
  | PlanTask
  | StandaloneProject
  | Region
  | Market
  | Community
  | Subdivision
  | Lot
  | Structure
  | Unit
  | Document
  | JobLogNote
  | PunchlistItemTodo
  | Comment
  | CommitmentDraw
  | FeatureFlag
  | JobLog
  | JobLogImage
  | Location
  | MobileSyncUpdate
  | ScheduleFlag
  | ScheduleFlagReason
  | ScheduleTaskChecklistItem
  | TaskWorkDay
  | TradePartnerContact
  | TradePartnerUser;

export type EntityTypeName =
  | "ScheduleTask"
  | "Asset"
  | "TradePartner"
  | "Bill"
  | "PlanTask"
  | "StandaloneProject"
  | "Region"
  | "Market"
  | "Community"
  | "Subdivision"
  | "Lot"
  | "Structure"
  | "Unit"
  | "Document"
  | "JobLogNote"
  | "PunchlistItemTodo"
  | "Comment"
  | "CommitmentDraw"
  | "FeatureFlag"
  | "JobLog"
  | "JobLogImage"
  | "Location"
  | "MobileSyncUpdate"
  | "ScheduleFlag"
  | "ScheduleFlagReason"
  | "ScheduleTaskChecklistItem"
  | "TaskWorkDay"
  | "TradePartnerContact"
  | "TradePartnerUser";

export function newEntity(): ScheduleTask;
export function newEntity(options: ScheduleTaskOptions, cache?: Record<string, any>): ScheduleTask;
export function newEntity(options: RequireTypename<AssetOptions>, cache?: Record<string, any>): Asset;
export function newEntity(options: RequireTypename<TradePartnerOptions>, cache?: Record<string, any>): TradePartner;
export function newEntity(options: RequireTypename<BillOptions>, cache?: Record<string, any>): Bill;
export function newEntity(options: RequireTypename<PlanTaskOptions>, cache?: Record<string, any>): PlanTask;
export function newEntity(
  options: RequireTypename<StandaloneProjectOptions>,
  cache?: Record<string, any>,
): StandaloneProject;
export function newEntity(options: RequireTypename<RegionOptions>, cache?: Record<string, any>): Region;
export function newEntity(options: RequireTypename<MarketOptions>, cache?: Record<string, any>): Market;
export function newEntity(options: RequireTypename<CommunityOptions>, cache?: Record<string, any>): Community;
export function newEntity(options: RequireTypename<SubdivisionOptions>, cache?: Record<string, any>): Subdivision;
export function newEntity(options: RequireTypename<LotOptions>, cache?: Record<string, any>): Lot;
export function newEntity(options: RequireTypename<StructureOptions>, cache?: Record<string, any>): Structure;
export function newEntity(options: RequireTypename<UnitOptions>, cache?: Record<string, any>): Unit;
export function newEntity(options: RequireTypename<DocumentOptions>, cache?: Record<string, any>): Document;
export function newEntity(options: RequireTypename<JobLogNoteOptions>, cache?: Record<string, any>): JobLogNote;
export function newEntity(
  options: RequireTypename<PunchlistItemTodoOptions>,
  cache?: Record<string, any>,
): PunchlistItemTodo;
export function newEntity(options: RequireTypename<CommentOptions>, cache?: Record<string, any>): Comment;
export function newEntity(options: RequireTypename<CommitmentDrawOptions>, cache?: Record<string, any>): CommitmentDraw;
export function newEntity(options: RequireTypename<FeatureFlagOptions>, cache?: Record<string, any>): FeatureFlag;
export function newEntity(options: RequireTypename<JobLogOptions>, cache?: Record<string, any>): JobLog;
export function newEntity(options: RequireTypename<JobLogImageOptions>, cache?: Record<string, any>): JobLogImage;
export function newEntity(options: RequireTypename<LocationOptions>, cache?: Record<string, any>): Location;
export function newEntity(
  options: RequireTypename<MobileSyncUpdateOptions>,
  cache?: Record<string, any>,
): MobileSyncUpdate;
export function newEntity(options: RequireTypename<ScheduleFlagOptions>, cache?: Record<string, any>): ScheduleFlag;
export function newEntity(
  options: RequireTypename<ScheduleFlagReasonOptions>,
  cache?: Record<string, any>,
): ScheduleFlagReason;
export function newEntity(
  options: RequireTypename<ScheduleTaskChecklistItemOptions>,
  cache?: Record<string, any>,
): ScheduleTaskChecklistItem;
export function newEntity(options: RequireTypename<TaskWorkDayOptions>, cache?: Record<string, any>): TaskWorkDay;
export function newEntity(
  options: RequireTypename<TradePartnerContactOptions>,
  cache?: Record<string, any>,
): TradePartnerContact;
export function newEntity(
  options: RequireTypename<TradePartnerUserOptions>,
  cache?: Record<string, any>,
): TradePartnerUser;
export function newEntity(options: EntityOptions = {}, cache: Record<string, any> = {}): EntityType {
  const { __typename = "ScheduleTask" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["Entity"] = newEntity;

export type HasBlueprintUrlOptions =
  | ScheduleTaskOptions
  | RequireTypename<ApprovalOptions>
  | RequireTypename<BidContractOptions>
  | RequireTypename<BidContractRevisionOptions>
  | RequireTypename<BidItemOptions>
  | RequireTypename<BidPackageRequestOptions>
  | RequireTypename<BillOptions>
  | RequireTypename<BusinessFunctionOptions>
  | RequireTypename<ChangeEventOptions>
  | RequireTypename<ChangeRequestOptions>
  | RequireTypename<ChangeRequestToDoOptions>
  | RequireTypename<SchedulePhaseOptions>
  | RequireTypename<ScheduleSubPhaseOptions>
  | RequireTypename<TaskOptions>
  | RequireTypename<PlanTaskOptions>
  | RequireTypename<ToDoOptions>
  | RequireTypename<InvoiceOptions>
  | RequireTypename<StandaloneProjectOptions>
  | RequireTypename<RegionOptions>
  | RequireTypename<MarketOptions>
  | RequireTypename<CommunityOptions>
  | RequireTypename<SubdivisionOptions>
  | RequireTypename<LotOptions>
  | RequireTypename<StructureOptions>
  | RequireTypename<UnitOptions>
  | RequireTypename<ProjectItemOptions>
  | RequireTypename<EstimateOptions>
  | RequireTypename<DevelopmentCommitmentOptions>
  | RequireTypename<CommitmentOptions>
  | RequireTypename<DocumentOptions>
  | RequireTypename<ProductOptions>
  | RequireTypename<ItemTemplateItemVersionOptions>
  | RequireTypename<JobLogNoteOptions>
  | RequireTypename<TradePartnerAvailabilityRequestOptions>
  | RequireTypename<PunchlistItemTodoOptions>
  | RequireTypename<WarrantyTicketOptions>
  | RequireTypename<HomeownerContractOptions>
  | RequireTypename<HomeownerContractChangeOrderOptions>
  | RequireTypename<ReadyPlanOptions>
  | RequireTypename<PlanPackageOptions>
  | RequireTypename<GlobalOptionOptions>
  | RequireTypename<ProjectCostCodeOptions>
  | RequireTypename<CommitmentChangeOrderOptions>
  | RequireTypename<DesignPackageOptions>
  | RequireTypename<DevelopmentOptions>
  | RequireTypename<ItemTemplateItemOptions>
  | RequireTypename<MaterialVariantOptions>
  | RequireTypename<ProductOfferingOptions>
  | RequireTypename<ProjectReadyPlanConfigOptions>
  | RequireTypename<ProjectSiteConditionOptions>
  | RequireTypename<ReadyPlanOptionOptions>
  | RequireTypename<TakeoffLineItemOptions>
  | RequireTypename<TakeoffLineItemVersionOptions>;

export type HasBlueprintUrlType =
  | ScheduleTask
  | Approval
  | BidContract
  | BidContractRevision
  | BidItem
  | BidPackageRequest
  | Bill
  | BusinessFunction
  | ChangeEvent
  | ChangeRequest
  | ChangeRequestToDo
  | SchedulePhase
  | ScheduleSubPhase
  | Task
  | PlanTask
  | ToDo
  | Invoice
  | StandaloneProject
  | Region
  | Market
  | Community
  | Subdivision
  | Lot
  | Structure
  | Unit
  | ProjectItem
  | Estimate
  | DevelopmentCommitment
  | Commitment
  | Document
  | Product
  | ItemTemplateItemVersion
  | JobLogNote
  | TradePartnerAvailabilityRequest
  | PunchlistItemTodo
  | WarrantyTicket
  | HomeownerContract
  | HomeownerContractChangeOrder
  | ReadyPlan
  | PlanPackage
  | GlobalOption
  | ProjectCostCode
  | CommitmentChangeOrder
  | DesignPackage
  | Development
  | ItemTemplateItem
  | MaterialVariant
  | ProductOffering
  | ProjectReadyPlanConfig
  | ProjectSiteCondition
  | ReadyPlanOption
  | TakeoffLineItem
  | TakeoffLineItemVersion;

export type HasBlueprintUrlTypeName =
  | "ScheduleTask"
  | "Approval"
  | "BidContract"
  | "BidContractRevision"
  | "BidItem"
  | "BidPackageRequest"
  | "Bill"
  | "BusinessFunction"
  | "ChangeEvent"
  | "ChangeRequest"
  | "ChangeRequestToDo"
  | "SchedulePhase"
  | "ScheduleSubPhase"
  | "Task"
  | "PlanTask"
  | "ToDo"
  | "Invoice"
  | "StandaloneProject"
  | "Region"
  | "Market"
  | "Community"
  | "Subdivision"
  | "Lot"
  | "Structure"
  | "Unit"
  | "ProjectItem"
  | "Estimate"
  | "DevelopmentCommitment"
  | "Commitment"
  | "Document"
  | "Product"
  | "ItemTemplateItemVersion"
  | "JobLogNote"
  | "TradePartnerAvailabilityRequest"
  | "PunchlistItemTodo"
  | "WarrantyTicket"
  | "HomeownerContract"
  | "HomeownerContractChangeOrder"
  | "ReadyPlan"
  | "PlanPackage"
  | "GlobalOption"
  | "ProjectCostCode"
  | "CommitmentChangeOrder"
  | "DesignPackage"
  | "Development"
  | "ItemTemplateItem"
  | "MaterialVariant"
  | "ProductOffering"
  | "ProjectReadyPlanConfig"
  | "ProjectSiteCondition"
  | "ReadyPlanOption"
  | "TakeoffLineItem"
  | "TakeoffLineItemVersion";

export function newHasBlueprintUrl(): ScheduleTask;
export function newHasBlueprintUrl(options: ScheduleTaskOptions, cache?: Record<string, any>): ScheduleTask;
export function newHasBlueprintUrl(options: RequireTypename<ApprovalOptions>, cache?: Record<string, any>): Approval;
export function newHasBlueprintUrl(
  options: RequireTypename<BidContractOptions>,
  cache?: Record<string, any>,
): BidContract;
export function newHasBlueprintUrl(
  options: RequireTypename<BidContractRevisionOptions>,
  cache?: Record<string, any>,
): BidContractRevision;
export function newHasBlueprintUrl(options: RequireTypename<BidItemOptions>, cache?: Record<string, any>): BidItem;
export function newHasBlueprintUrl(
  options: RequireTypename<BidPackageRequestOptions>,
  cache?: Record<string, any>,
): BidPackageRequest;
export function newHasBlueprintUrl(options: RequireTypename<BillOptions>, cache?: Record<string, any>): Bill;
export function newHasBlueprintUrl(
  options: RequireTypename<BusinessFunctionOptions>,
  cache?: Record<string, any>,
): BusinessFunction;
export function newHasBlueprintUrl(
  options: RequireTypename<ChangeEventOptions>,
  cache?: Record<string, any>,
): ChangeEvent;
export function newHasBlueprintUrl(
  options: RequireTypename<ChangeRequestOptions>,
  cache?: Record<string, any>,
): ChangeRequest;
export function newHasBlueprintUrl(
  options: RequireTypename<ChangeRequestToDoOptions>,
  cache?: Record<string, any>,
): ChangeRequestToDo;
export function newHasBlueprintUrl(
  options: RequireTypename<SchedulePhaseOptions>,
  cache?: Record<string, any>,
): SchedulePhase;
export function newHasBlueprintUrl(
  options: RequireTypename<ScheduleSubPhaseOptions>,
  cache?: Record<string, any>,
): ScheduleSubPhase;
export function newHasBlueprintUrl(options: RequireTypename<TaskOptions>, cache?: Record<string, any>): Task;
export function newHasBlueprintUrl(options: RequireTypename<PlanTaskOptions>, cache?: Record<string, any>): PlanTask;
export function newHasBlueprintUrl(options: RequireTypename<ToDoOptions>, cache?: Record<string, any>): ToDo;
export function newHasBlueprintUrl(options: RequireTypename<InvoiceOptions>, cache?: Record<string, any>): Invoice;
export function newHasBlueprintUrl(
  options: RequireTypename<StandaloneProjectOptions>,
  cache?: Record<string, any>,
): StandaloneProject;
export function newHasBlueprintUrl(options: RequireTypename<RegionOptions>, cache?: Record<string, any>): Region;
export function newHasBlueprintUrl(options: RequireTypename<MarketOptions>, cache?: Record<string, any>): Market;
export function newHasBlueprintUrl(options: RequireTypename<CommunityOptions>, cache?: Record<string, any>): Community;
export function newHasBlueprintUrl(
  options: RequireTypename<SubdivisionOptions>,
  cache?: Record<string, any>,
): Subdivision;
export function newHasBlueprintUrl(options: RequireTypename<LotOptions>, cache?: Record<string, any>): Lot;
export function newHasBlueprintUrl(options: RequireTypename<StructureOptions>, cache?: Record<string, any>): Structure;
export function newHasBlueprintUrl(options: RequireTypename<UnitOptions>, cache?: Record<string, any>): Unit;
export function newHasBlueprintUrl(
  options: RequireTypename<ProjectItemOptions>,
  cache?: Record<string, any>,
): ProjectItem;
export function newHasBlueprintUrl(options: RequireTypename<EstimateOptions>, cache?: Record<string, any>): Estimate;
export function newHasBlueprintUrl(
  options: RequireTypename<DevelopmentCommitmentOptions>,
  cache?: Record<string, any>,
): DevelopmentCommitment;
export function newHasBlueprintUrl(
  options: RequireTypename<CommitmentOptions>,
  cache?: Record<string, any>,
): Commitment;
export function newHasBlueprintUrl(options: RequireTypename<DocumentOptions>, cache?: Record<string, any>): Document;
export function newHasBlueprintUrl(options: RequireTypename<ProductOptions>, cache?: Record<string, any>): Product;
export function newHasBlueprintUrl(
  options: RequireTypename<ItemTemplateItemVersionOptions>,
  cache?: Record<string, any>,
): ItemTemplateItemVersion;
export function newHasBlueprintUrl(
  options: RequireTypename<JobLogNoteOptions>,
  cache?: Record<string, any>,
): JobLogNote;
export function newHasBlueprintUrl(
  options: RequireTypename<TradePartnerAvailabilityRequestOptions>,
  cache?: Record<string, any>,
): TradePartnerAvailabilityRequest;
export function newHasBlueprintUrl(
  options: RequireTypename<PunchlistItemTodoOptions>,
  cache?: Record<string, any>,
): PunchlistItemTodo;
export function newHasBlueprintUrl(
  options: RequireTypename<WarrantyTicketOptions>,
  cache?: Record<string, any>,
): WarrantyTicket;
export function newHasBlueprintUrl(
  options: RequireTypename<HomeownerContractOptions>,
  cache?: Record<string, any>,
): HomeownerContract;
export function newHasBlueprintUrl(
  options: RequireTypename<HomeownerContractChangeOrderOptions>,
  cache?: Record<string, any>,
): HomeownerContractChangeOrder;
export function newHasBlueprintUrl(options: RequireTypename<ReadyPlanOptions>, cache?: Record<string, any>): ReadyPlan;
export function newHasBlueprintUrl(
  options: RequireTypename<PlanPackageOptions>,
  cache?: Record<string, any>,
): PlanPackage;
export function newHasBlueprintUrl(
  options: RequireTypename<GlobalOptionOptions>,
  cache?: Record<string, any>,
): GlobalOption;
export function newHasBlueprintUrl(
  options: RequireTypename<ProjectCostCodeOptions>,
  cache?: Record<string, any>,
): ProjectCostCode;
export function newHasBlueprintUrl(
  options: RequireTypename<CommitmentChangeOrderOptions>,
  cache?: Record<string, any>,
): CommitmentChangeOrder;
export function newHasBlueprintUrl(
  options: RequireTypename<DesignPackageOptions>,
  cache?: Record<string, any>,
): DesignPackage;
export function newHasBlueprintUrl(
  options: RequireTypename<DevelopmentOptions>,
  cache?: Record<string, any>,
): Development;
export function newHasBlueprintUrl(
  options: RequireTypename<ItemTemplateItemOptions>,
  cache?: Record<string, any>,
): ItemTemplateItem;
export function newHasBlueprintUrl(
  options: RequireTypename<MaterialVariantOptions>,
  cache?: Record<string, any>,
): MaterialVariant;
export function newHasBlueprintUrl(
  options: RequireTypename<ProductOfferingOptions>,
  cache?: Record<string, any>,
): ProductOffering;
export function newHasBlueprintUrl(
  options: RequireTypename<ProjectReadyPlanConfigOptions>,
  cache?: Record<string, any>,
): ProjectReadyPlanConfig;
export function newHasBlueprintUrl(
  options: RequireTypename<ProjectSiteConditionOptions>,
  cache?: Record<string, any>,
): ProjectSiteCondition;
export function newHasBlueprintUrl(
  options: RequireTypename<ReadyPlanOptionOptions>,
  cache?: Record<string, any>,
): ReadyPlanOption;
export function newHasBlueprintUrl(
  options: RequireTypename<TakeoffLineItemOptions>,
  cache?: Record<string, any>,
): TakeoffLineItem;
export function newHasBlueprintUrl(
  options: RequireTypename<TakeoffLineItemVersionOptions>,
  cache?: Record<string, any>,
): TakeoffLineItemVersion;
export function newHasBlueprintUrl(
  options: HasBlueprintUrlOptions = {},
  cache: Record<string, any> = {},
): HasBlueprintUrlType {
  const { __typename = "ScheduleTask" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["HasBlueprintUrl"] = newHasBlueprintUrl;

export type ScheduleEntityOptions =
  | ScheduleTaskOptions
  | RequireTypename<SchedulePhaseOptions>
  | RequireTypename<ScheduleSubPhaseOptions>
  | RequireTypename<ScheduleOptions>;

export type ScheduleEntityType = ScheduleTask | SchedulePhase | ScheduleSubPhase | Schedule;

export type ScheduleEntityTypeName = "ScheduleTask" | "SchedulePhase" | "ScheduleSubPhase" | "Schedule";

export function newScheduleEntity(): ScheduleTask;
export function newScheduleEntity(options: ScheduleTaskOptions, cache?: Record<string, any>): ScheduleTask;
export function newScheduleEntity(
  options: RequireTypename<SchedulePhaseOptions>,
  cache?: Record<string, any>,
): SchedulePhase;
export function newScheduleEntity(
  options: RequireTypename<ScheduleSubPhaseOptions>,
  cache?: Record<string, any>,
): ScheduleSubPhase;
export function newScheduleEntity(options: RequireTypename<ScheduleOptions>, cache?: Record<string, any>): Schedule;
export function newScheduleEntity(
  options: ScheduleEntityOptions = {},
  cache: Record<string, any> = {},
): ScheduleEntityType {
  const { __typename = "ScheduleTask" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["ScheduleEntity"] = newScheduleEntity;

export type NamedOptions =
  | ScheduleTaskOptions
  | RequireTypename<ApprovalOptions>
  | RequireTypename<BidContractOptions>
  | RequireTypename<BidContractLineItemOptions>
  | RequireTypename<BidItemOptions>
  | RequireTypename<BidPackageOptions>
  | RequireTypename<BidPackageRequestOptions>
  | RequireTypename<TradePartnerOptions>
  | RequireTypename<BillOptions>
  | RequireTypename<BusinessFunctionOptions>
  | RequireTypename<ChangeEventOptions>
  | RequireTypename<ChangeEventLineItemOptions>
  | RequireTypename<ChangeEventReasonOptions>
  | RequireTypename<ChangeEventTemplateConfigOptions>
  | RequireTypename<ChangeRequestOptions>
  | RequireTypename<ChangeRequestAssetOptions>
  | RequireTypename<ChangeRequestToDoOptions>
  | RequireTypename<ClientOptions>
  | RequireTypename<CohortOptions>
  | RequireTypename<SchedulePhaseOptions>
  | RequireTypename<ScheduleSubPhaseOptions>
  | RequireTypename<TaskOptions>
  | RequireTypename<PlanTaskOptions>
  | RequireTypename<ToDoOptions>
  | RequireTypename<InvoiceOptions>
  | RequireTypename<StandaloneProjectOptions>
  | RequireTypename<RegionOptions>
  | RequireTypename<MarketOptions>
  | RequireTypename<CommunityOptions>
  | RequireTypename<SubdivisionOptions>
  | RequireTypename<LotOptions>
  | RequireTypename<StructureOptions>
  | RequireTypename<UnitOptions>
  | RequireTypename<ProjectItemOptions>
  | RequireTypename<EstimateOptions>
  | RequireTypename<DevelopmentCommitmentOptions>
  | RequireTypename<CommitmentOptions>
  | RequireTypename<DocumentOptions>
  | RequireTypename<ProductOptions>
  | RequireTypename<ItemTemplateItemVersionOptions>
  | RequireTypename<JobLogNoteOptions>
  | RequireTypename<TradePartnerAvailabilityRequestOptions>
  | RequireTypename<PunchlistItemTodoOptions>
  | RequireTypename<WarrantyTicketOptions>
  | RequireTypename<HomeownerContractOptions>
  | RequireTypename<HomeownerContractChangeOrderOptions>
  | RequireTypename<ReadyPlanOptions>
  | RequireTypename<PlanPackageOptions>
  | RequireTypename<GlobalOptionOptions>
  | RequireTypename<ProjectCostCodeOptions>
  | RequireTypename<CommitmentChangeOrderOptions>
  | RequireTypename<CostCodeOptions>
  | RequireTypename<CostDivisionOptions>
  | RequireTypename<CustomerOptions>
  | RequireTypename<CustomerOwnerEntityOptions>
  | RequireTypename<DesignPackageOptions>
  | RequireTypename<DevelopmentOptions>
  | RequireTypename<GlobalOptionTagOptions>
  | RequireTypename<GlobalOptionTypeOptions>
  | RequireTypename<GlobalPlanConstraintItemOptions>
  | RequireTypename<GlobalPlanMilestoneOptions>
  | RequireTypename<GlobalPlanTaskOptions>
  | RequireTypename<GlobalTaskOptions>
  | RequireTypename<HomeownerContractDrawOptions>
  | RequireTypename<HomeownerSelectionOptionOptions>
  | RequireTypename<HomeownerSelectionProductOptionOptions>
  | RequireTypename<InternalUserOptions>
  | RequireTypename<InvoiceScheduleTemplateOptions>
  | RequireTypename<ItemOptions>
  | RequireTypename<ItemSlotOptions>
  | RequireTypename<ItemTemplateOptions>
  | RequireTypename<ItemTemplateItemOptions>
  | RequireTypename<LocationOptions>
  | RequireTypename<MaterialVariantTagOptions>
  | RequireTypename<PandaDocOptions>
  | RequireTypename<PandaDocRecipientOptions>
  | RequireTypename<PlanMilestoneOptions>
  | RequireTypename<ProductOfferingOptions>
  | RequireTypename<ProjectStageTemplateConfigOptions>
  | RequireTypename<ProjectStatusChangeReasonOptions>
  | RequireTypename<ReadyPlanAggregateVersionOptions>
  | RequireTypename<ReadyPlanLocationOptions>
  | RequireTypename<ReadyPlanOptionOptions>
  | RequireTypename<ReadyPlanOptionProgramDataModificationOptions>
  | RequireTypename<ScheduleOptions>
  | RequireTypename<ScheduleTemplateOptions>
  | RequireTypename<SubmarketOptions>
  | RequireTypename<TakeoffLineItemOptions>
  | RequireTypename<TakeoffLineItemVersionOptions>
  | RequireTypename<TradeCategoryOptions>
  | RequireTypename<TradePartnerContactOptions>
  | RequireTypename<TradePartnerMailingListOptions>
  | RequireTypename<TradePartnerUserOptions>
  | RequireTypename<UnitOfMeasureOptions>
  | RequireTypename<UserOptions>;

export type NamedType =
  | ScheduleTask
  | Approval
  | BidContract
  | BidContractLineItem
  | BidItem
  | BidPackage
  | BidPackageRequest
  | TradePartner
  | Bill
  | BusinessFunction
  | ChangeEvent
  | ChangeEventLineItem
  | ChangeEventReason
  | ChangeEventTemplateConfig
  | ChangeRequest
  | ChangeRequestAsset
  | ChangeRequestToDo
  | Client
  | Cohort
  | SchedulePhase
  | ScheduleSubPhase
  | Task
  | PlanTask
  | ToDo
  | Invoice
  | StandaloneProject
  | Region
  | Market
  | Community
  | Subdivision
  | Lot
  | Structure
  | Unit
  | ProjectItem
  | Estimate
  | DevelopmentCommitment
  | Commitment
  | Document
  | Product
  | ItemTemplateItemVersion
  | JobLogNote
  | TradePartnerAvailabilityRequest
  | PunchlistItemTodo
  | WarrantyTicket
  | HomeownerContract
  | HomeownerContractChangeOrder
  | ReadyPlan
  | PlanPackage
  | GlobalOption
  | ProjectCostCode
  | CommitmentChangeOrder
  | CostCode
  | CostDivision
  | Customer
  | CustomerOwnerEntity
  | DesignPackage
  | Development
  | GlobalOptionTag
  | GlobalOptionType
  | GlobalPlanConstraintItem
  | GlobalPlanMilestone
  | GlobalPlanTask
  | GlobalTask
  | HomeownerContractDraw
  | HomeownerSelectionOption
  | HomeownerSelectionProductOption
  | InternalUser
  | InvoiceScheduleTemplate
  | Item
  | ItemSlot
  | ItemTemplate
  | ItemTemplateItem
  | Location
  | MaterialVariantTag
  | PandaDoc
  | PandaDocRecipient
  | PlanMilestone
  | ProductOffering
  | ProjectStageTemplateConfig
  | ProjectStatusChangeReason
  | ReadyPlanAggregateVersion
  | ReadyPlanLocation
  | ReadyPlanOption
  | ReadyPlanOptionProgramDataModification
  | Schedule
  | ScheduleTemplate
  | Submarket
  | TakeoffLineItem
  | TakeoffLineItemVersion
  | TradeCategory
  | TradePartnerContact
  | TradePartnerMailingList
  | TradePartnerUser
  | UnitOfMeasure
  | User;

export type NamedTypeName =
  | "ScheduleTask"
  | "Approval"
  | "BidContract"
  | "BidContractLineItem"
  | "BidItem"
  | "BidPackage"
  | "BidPackageRequest"
  | "TradePartner"
  | "Bill"
  | "BusinessFunction"
  | "ChangeEvent"
  | "ChangeEventLineItem"
  | "ChangeEventReason"
  | "ChangeEventTemplateConfig"
  | "ChangeRequest"
  | "ChangeRequestAsset"
  | "ChangeRequestToDo"
  | "Client"
  | "Cohort"
  | "SchedulePhase"
  | "ScheduleSubPhase"
  | "Task"
  | "PlanTask"
  | "ToDo"
  | "Invoice"
  | "StandaloneProject"
  | "Region"
  | "Market"
  | "Community"
  | "Subdivision"
  | "Lot"
  | "Structure"
  | "Unit"
  | "ProjectItem"
  | "Estimate"
  | "DevelopmentCommitment"
  | "Commitment"
  | "Document"
  | "Product"
  | "ItemTemplateItemVersion"
  | "JobLogNote"
  | "TradePartnerAvailabilityRequest"
  | "PunchlistItemTodo"
  | "WarrantyTicket"
  | "HomeownerContract"
  | "HomeownerContractChangeOrder"
  | "ReadyPlan"
  | "PlanPackage"
  | "GlobalOption"
  | "ProjectCostCode"
  | "CommitmentChangeOrder"
  | "CostCode"
  | "CostDivision"
  | "Customer"
  | "CustomerOwnerEntity"
  | "DesignPackage"
  | "Development"
  | "GlobalOptionTag"
  | "GlobalOptionType"
  | "GlobalPlanConstraintItem"
  | "GlobalPlanMilestone"
  | "GlobalPlanTask"
  | "GlobalTask"
  | "HomeownerContractDraw"
  | "HomeownerSelectionOption"
  | "HomeownerSelectionProductOption"
  | "InternalUser"
  | "InvoiceScheduleTemplate"
  | "Item"
  | "ItemSlot"
  | "ItemTemplate"
  | "ItemTemplateItem"
  | "Location"
  | "MaterialVariantTag"
  | "PandaDoc"
  | "PandaDocRecipient"
  | "PlanMilestone"
  | "ProductOffering"
  | "ProjectStageTemplateConfig"
  | "ProjectStatusChangeReason"
  | "ReadyPlanAggregateVersion"
  | "ReadyPlanLocation"
  | "ReadyPlanOption"
  | "ReadyPlanOptionProgramDataModification"
  | "Schedule"
  | "ScheduleTemplate"
  | "Submarket"
  | "TakeoffLineItem"
  | "TakeoffLineItemVersion"
  | "TradeCategory"
  | "TradePartnerContact"
  | "TradePartnerMailingList"
  | "TradePartnerUser"
  | "UnitOfMeasure"
  | "User";

export function newNamed(): ScheduleTask;
export function newNamed(options: ScheduleTaskOptions, cache?: Record<string, any>): ScheduleTask;
export function newNamed(options: RequireTypename<ApprovalOptions>, cache?: Record<string, any>): Approval;
export function newNamed(options: RequireTypename<BidContractOptions>, cache?: Record<string, any>): BidContract;
export function newNamed(
  options: RequireTypename<BidContractLineItemOptions>,
  cache?: Record<string, any>,
): BidContractLineItem;
export function newNamed(options: RequireTypename<BidItemOptions>, cache?: Record<string, any>): BidItem;
export function newNamed(options: RequireTypename<BidPackageOptions>, cache?: Record<string, any>): BidPackage;
export function newNamed(
  options: RequireTypename<BidPackageRequestOptions>,
  cache?: Record<string, any>,
): BidPackageRequest;
export function newNamed(options: RequireTypename<TradePartnerOptions>, cache?: Record<string, any>): TradePartner;
export function newNamed(options: RequireTypename<BillOptions>, cache?: Record<string, any>): Bill;
export function newNamed(
  options: RequireTypename<BusinessFunctionOptions>,
  cache?: Record<string, any>,
): BusinessFunction;
export function newNamed(options: RequireTypename<ChangeEventOptions>, cache?: Record<string, any>): ChangeEvent;
export function newNamed(
  options: RequireTypename<ChangeEventLineItemOptions>,
  cache?: Record<string, any>,
): ChangeEventLineItem;
export function newNamed(
  options: RequireTypename<ChangeEventReasonOptions>,
  cache?: Record<string, any>,
): ChangeEventReason;
export function newNamed(
  options: RequireTypename<ChangeEventTemplateConfigOptions>,
  cache?: Record<string, any>,
): ChangeEventTemplateConfig;
export function newNamed(options: RequireTypename<ChangeRequestOptions>, cache?: Record<string, any>): ChangeRequest;
export function newNamed(
  options: RequireTypename<ChangeRequestAssetOptions>,
  cache?: Record<string, any>,
): ChangeRequestAsset;
export function newNamed(
  options: RequireTypename<ChangeRequestToDoOptions>,
  cache?: Record<string, any>,
): ChangeRequestToDo;
export function newNamed(options: RequireTypename<ClientOptions>, cache?: Record<string, any>): Client;
export function newNamed(options: RequireTypename<CohortOptions>, cache?: Record<string, any>): Cohort;
export function newNamed(options: RequireTypename<SchedulePhaseOptions>, cache?: Record<string, any>): SchedulePhase;
export function newNamed(
  options: RequireTypename<ScheduleSubPhaseOptions>,
  cache?: Record<string, any>,
): ScheduleSubPhase;
export function newNamed(options: RequireTypename<TaskOptions>, cache?: Record<string, any>): Task;
export function newNamed(options: RequireTypename<PlanTaskOptions>, cache?: Record<string, any>): PlanTask;
export function newNamed(options: RequireTypename<ToDoOptions>, cache?: Record<string, any>): ToDo;
export function newNamed(options: RequireTypename<InvoiceOptions>, cache?: Record<string, any>): Invoice;
export function newNamed(
  options: RequireTypename<StandaloneProjectOptions>,
  cache?: Record<string, any>,
): StandaloneProject;
export function newNamed(options: RequireTypename<RegionOptions>, cache?: Record<string, any>): Region;
export function newNamed(options: RequireTypename<MarketOptions>, cache?: Record<string, any>): Market;
export function newNamed(options: RequireTypename<CommunityOptions>, cache?: Record<string, any>): Community;
export function newNamed(options: RequireTypename<SubdivisionOptions>, cache?: Record<string, any>): Subdivision;
export function newNamed(options: RequireTypename<LotOptions>, cache?: Record<string, any>): Lot;
export function newNamed(options: RequireTypename<StructureOptions>, cache?: Record<string, any>): Structure;
export function newNamed(options: RequireTypename<UnitOptions>, cache?: Record<string, any>): Unit;
export function newNamed(options: RequireTypename<ProjectItemOptions>, cache?: Record<string, any>): ProjectItem;
export function newNamed(options: RequireTypename<EstimateOptions>, cache?: Record<string, any>): Estimate;
export function newNamed(
  options: RequireTypename<DevelopmentCommitmentOptions>,
  cache?: Record<string, any>,
): DevelopmentCommitment;
export function newNamed(options: RequireTypename<CommitmentOptions>, cache?: Record<string, any>): Commitment;
export function newNamed(options: RequireTypename<DocumentOptions>, cache?: Record<string, any>): Document;
export function newNamed(options: RequireTypename<ProductOptions>, cache?: Record<string, any>): Product;
export function newNamed(
  options: RequireTypename<ItemTemplateItemVersionOptions>,
  cache?: Record<string, any>,
): ItemTemplateItemVersion;
export function newNamed(options: RequireTypename<JobLogNoteOptions>, cache?: Record<string, any>): JobLogNote;
export function newNamed(
  options: RequireTypename<TradePartnerAvailabilityRequestOptions>,
  cache?: Record<string, any>,
): TradePartnerAvailabilityRequest;
export function newNamed(
  options: RequireTypename<PunchlistItemTodoOptions>,
  cache?: Record<string, any>,
): PunchlistItemTodo;
export function newNamed(options: RequireTypename<WarrantyTicketOptions>, cache?: Record<string, any>): WarrantyTicket;
export function newNamed(
  options: RequireTypename<HomeownerContractOptions>,
  cache?: Record<string, any>,
): HomeownerContract;
export function newNamed(
  options: RequireTypename<HomeownerContractChangeOrderOptions>,
  cache?: Record<string, any>,
): HomeownerContractChangeOrder;
export function newNamed(options: RequireTypename<ReadyPlanOptions>, cache?: Record<string, any>): ReadyPlan;
export function newNamed(options: RequireTypename<PlanPackageOptions>, cache?: Record<string, any>): PlanPackage;
export function newNamed(options: RequireTypename<GlobalOptionOptions>, cache?: Record<string, any>): GlobalOption;
export function newNamed(
  options: RequireTypename<ProjectCostCodeOptions>,
  cache?: Record<string, any>,
): ProjectCostCode;
export function newNamed(
  options: RequireTypename<CommitmentChangeOrderOptions>,
  cache?: Record<string, any>,
): CommitmentChangeOrder;
export function newNamed(options: RequireTypename<CostCodeOptions>, cache?: Record<string, any>): CostCode;
export function newNamed(options: RequireTypename<CostDivisionOptions>, cache?: Record<string, any>): CostDivision;
export function newNamed(options: RequireTypename<CustomerOptions>, cache?: Record<string, any>): Customer;
export function newNamed(
  options: RequireTypename<CustomerOwnerEntityOptions>,
  cache?: Record<string, any>,
): CustomerOwnerEntity;
export function newNamed(options: RequireTypename<DesignPackageOptions>, cache?: Record<string, any>): DesignPackage;
export function newNamed(options: RequireTypename<DevelopmentOptions>, cache?: Record<string, any>): Development;
export function newNamed(
  options: RequireTypename<GlobalOptionTagOptions>,
  cache?: Record<string, any>,
): GlobalOptionTag;
export function newNamed(
  options: RequireTypename<GlobalOptionTypeOptions>,
  cache?: Record<string, any>,
): GlobalOptionType;
export function newNamed(
  options: RequireTypename<GlobalPlanConstraintItemOptions>,
  cache?: Record<string, any>,
): GlobalPlanConstraintItem;
export function newNamed(
  options: RequireTypename<GlobalPlanMilestoneOptions>,
  cache?: Record<string, any>,
): GlobalPlanMilestone;
export function newNamed(options: RequireTypename<GlobalPlanTaskOptions>, cache?: Record<string, any>): GlobalPlanTask;
export function newNamed(options: RequireTypename<GlobalTaskOptions>, cache?: Record<string, any>): GlobalTask;
export function newNamed(
  options: RequireTypename<HomeownerContractDrawOptions>,
  cache?: Record<string, any>,
): HomeownerContractDraw;
export function newNamed(
  options: RequireTypename<HomeownerSelectionOptionOptions>,
  cache?: Record<string, any>,
): HomeownerSelectionOption;
export function newNamed(
  options: RequireTypename<HomeownerSelectionProductOptionOptions>,
  cache?: Record<string, any>,
): HomeownerSelectionProductOption;
export function newNamed(options: RequireTypename<InternalUserOptions>, cache?: Record<string, any>): InternalUser;
export function newNamed(
  options: RequireTypename<InvoiceScheduleTemplateOptions>,
  cache?: Record<string, any>,
): InvoiceScheduleTemplate;
export function newNamed(options: RequireTypename<ItemOptions>, cache?: Record<string, any>): Item;
export function newNamed(options: RequireTypename<ItemSlotOptions>, cache?: Record<string, any>): ItemSlot;
export function newNamed(options: RequireTypename<ItemTemplateOptions>, cache?: Record<string, any>): ItemTemplate;
export function newNamed(
  options: RequireTypename<ItemTemplateItemOptions>,
  cache?: Record<string, any>,
): ItemTemplateItem;
export function newNamed(options: RequireTypename<LocationOptions>, cache?: Record<string, any>): Location;
export function newNamed(
  options: RequireTypename<MaterialVariantTagOptions>,
  cache?: Record<string, any>,
): MaterialVariantTag;
export function newNamed(options: RequireTypename<PandaDocOptions>, cache?: Record<string, any>): PandaDoc;
export function newNamed(
  options: RequireTypename<PandaDocRecipientOptions>,
  cache?: Record<string, any>,
): PandaDocRecipient;
export function newNamed(options: RequireTypename<PlanMilestoneOptions>, cache?: Record<string, any>): PlanMilestone;
export function newNamed(
  options: RequireTypename<ProductOfferingOptions>,
  cache?: Record<string, any>,
): ProductOffering;
export function newNamed(
  options: RequireTypename<ProjectStageTemplateConfigOptions>,
  cache?: Record<string, any>,
): ProjectStageTemplateConfig;
export function newNamed(
  options: RequireTypename<ProjectStatusChangeReasonOptions>,
  cache?: Record<string, any>,
): ProjectStatusChangeReason;
export function newNamed(
  options: RequireTypename<ReadyPlanAggregateVersionOptions>,
  cache?: Record<string, any>,
): ReadyPlanAggregateVersion;
export function newNamed(
  options: RequireTypename<ReadyPlanLocationOptions>,
  cache?: Record<string, any>,
): ReadyPlanLocation;
export function newNamed(
  options: RequireTypename<ReadyPlanOptionOptions>,
  cache?: Record<string, any>,
): ReadyPlanOption;
export function newNamed(
  options: RequireTypename<ReadyPlanOptionProgramDataModificationOptions>,
  cache?: Record<string, any>,
): ReadyPlanOptionProgramDataModification;
export function newNamed(options: RequireTypename<ScheduleOptions>, cache?: Record<string, any>): Schedule;
export function newNamed(
  options: RequireTypename<ScheduleTemplateOptions>,
  cache?: Record<string, any>,
): ScheduleTemplate;
export function newNamed(options: RequireTypename<SubmarketOptions>, cache?: Record<string, any>): Submarket;
export function newNamed(
  options: RequireTypename<TakeoffLineItemOptions>,
  cache?: Record<string, any>,
): TakeoffLineItem;
export function newNamed(
  options: RequireTypename<TakeoffLineItemVersionOptions>,
  cache?: Record<string, any>,
): TakeoffLineItemVersion;
export function newNamed(options: RequireTypename<TradeCategoryOptions>, cache?: Record<string, any>): TradeCategory;
export function newNamed(
  options: RequireTypename<TradePartnerContactOptions>,
  cache?: Record<string, any>,
): TradePartnerContact;
export function newNamed(
  options: RequireTypename<TradePartnerMailingListOptions>,
  cache?: Record<string, any>,
): TradePartnerMailingList;
export function newNamed(
  options: RequireTypename<TradePartnerUserOptions>,
  cache?: Record<string, any>,
): TradePartnerUser;
export function newNamed(options: RequireTypename<UnitOfMeasureOptions>, cache?: Record<string, any>): UnitOfMeasure;
export function newNamed(options: RequireTypename<UserOptions>, cache?: Record<string, any>): User;
export function newNamed(options: NamedOptions = {}, cache: Record<string, any> = {}): NamedType {
  const { __typename = "ScheduleTask" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["Named"] = newNamed;

export type MaybeHasIntervalOptions =
  | ScheduleTaskOptions
  | RequireTypename<SchedulePhaseOptions>
  | RequireTypename<ScheduleSubPhaseOptions>
  | RequireTypename<TaskOptions>
  | RequireTypename<ProjectStageOptions>
  | RequireTypename<ScheduleOptions>;

export type MaybeHasIntervalType = ScheduleTask | SchedulePhase | ScheduleSubPhase | Task | ProjectStage | Schedule;

export type MaybeHasIntervalTypeName =
  | "ScheduleTask"
  | "SchedulePhase"
  | "ScheduleSubPhase"
  | "Task"
  | "ProjectStage"
  | "Schedule";

export function newMaybeHasInterval(): ScheduleTask;
export function newMaybeHasInterval(options: ScheduleTaskOptions, cache?: Record<string, any>): ScheduleTask;
export function newMaybeHasInterval(
  options: RequireTypename<SchedulePhaseOptions>,
  cache?: Record<string, any>,
): SchedulePhase;
export function newMaybeHasInterval(
  options: RequireTypename<ScheduleSubPhaseOptions>,
  cache?: Record<string, any>,
): ScheduleSubPhase;
export function newMaybeHasInterval(options: RequireTypename<TaskOptions>, cache?: Record<string, any>): Task;
export function newMaybeHasInterval(
  options: RequireTypename<ProjectStageOptions>,
  cache?: Record<string, any>,
): ProjectStage;
export function newMaybeHasInterval(options: RequireTypename<ScheduleOptions>, cache?: Record<string, any>): Schedule;
export function newMaybeHasInterval(
  options: MaybeHasIntervalOptions = {},
  cache: Record<string, any> = {},
): MaybeHasIntervalType {
  const { __typename = "ScheduleTask" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["MaybeHasInterval"] = newMaybeHasInterval;

export type MaybeHasBaselineIntervalOptions =
  | ScheduleTaskOptions
  | RequireTypename<SchedulePhaseOptions>
  | RequireTypename<ScheduleSubPhaseOptions>
  | RequireTypename<ScheduleOptions>;

export type MaybeHasBaselineIntervalType = ScheduleTask | SchedulePhase | ScheduleSubPhase | Schedule;

export type MaybeHasBaselineIntervalTypeName = "ScheduleTask" | "SchedulePhase" | "ScheduleSubPhase" | "Schedule";

export function newMaybeHasBaselineInterval(): ScheduleTask;
export function newMaybeHasBaselineInterval(options: ScheduleTaskOptions, cache?: Record<string, any>): ScheduleTask;
export function newMaybeHasBaselineInterval(
  options: RequireTypename<SchedulePhaseOptions>,
  cache?: Record<string, any>,
): SchedulePhase;
export function newMaybeHasBaselineInterval(
  options: RequireTypename<ScheduleSubPhaseOptions>,
  cache?: Record<string, any>,
): ScheduleSubPhase;
export function newMaybeHasBaselineInterval(
  options: RequireTypename<ScheduleOptions>,
  cache?: Record<string, any>,
): Schedule;
export function newMaybeHasBaselineInterval(
  options: MaybeHasBaselineIntervalOptions = {},
  cache: Record<string, any> = {},
): MaybeHasBaselineIntervalType {
  const { __typename = "ScheduleTask" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["MaybeHasBaselineInterval"] = newMaybeHasBaselineInterval;

export type HasPandaDocOptions =
  | BidContractRevisionOptions
  | RequireTypename<DevelopmentCommitmentOptions>
  | RequireTypename<CommitmentOptions>
  | RequireTypename<CommitmentChangeOrderOptions>;

export type HasPandaDocType = BidContractRevision | DevelopmentCommitment | Commitment | CommitmentChangeOrder;

export type HasPandaDocTypeName =
  | "BidContractRevision"
  | "DevelopmentCommitment"
  | "Commitment"
  | "CommitmentChangeOrder";

export function newHasPandaDoc(): BidContractRevision;
export function newHasPandaDoc(options: BidContractRevisionOptions, cache?: Record<string, any>): BidContractRevision;
export function newHasPandaDoc(
  options: RequireTypename<DevelopmentCommitmentOptions>,
  cache?: Record<string, any>,
): DevelopmentCommitment;
export function newHasPandaDoc(options: RequireTypename<CommitmentOptions>, cache?: Record<string, any>): Commitment;
export function newHasPandaDoc(
  options: RequireTypename<CommitmentChangeOrderOptions>,
  cache?: Record<string, any>,
): CommitmentChangeOrder;
export function newHasPandaDoc(options: HasPandaDocOptions = {}, cache: Record<string, any> = {}): HasPandaDocType {
  const { __typename = "BidContractRevision" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["HasPandaDoc"] = newHasPandaDoc;

export type HasDisplayNameOptions =
  | BidItemOptions
  | RequireTypename<ChangeEventLineItemOptions>
  | RequireTypename<ProjectItemOptions>
  | RequireTypename<CommitmentOptions>
  | RequireTypename<DocumentOptions>
  | RequireTypename<ItemTemplateItemVersionOptions>
  | RequireTypename<ReadyPlanOptions>
  | RequireTypename<PlanPackageOptions>
  | RequireTypename<CommitmentChangeOrderOptions>
  | RequireTypename<CostCodeOptions>
  | RequireTypename<CostDivisionOptions>
  | RequireTypename<DesignPackageOptions>
  | RequireTypename<ItemOptions>
  | RequireTypename<ItemTemplateOptions>
  | RequireTypename<ItemTemplateItemOptions>
  | RequireTypename<ProductOfferingOptions>
  | RequireTypename<ReadyPlanAggregateVersionOptions>
  | RequireTypename<ReadyPlanOptionOptions>
  | RequireTypename<TakeoffLineItemOptions>
  | RequireTypename<TakeoffLineItemVersionOptions>
  | RequireTypename<TradeCategoryOptions>;

export type HasDisplayNameType =
  | BidItem
  | ChangeEventLineItem
  | ProjectItem
  | Commitment
  | Document
  | ItemTemplateItemVersion
  | ReadyPlan
  | PlanPackage
  | CommitmentChangeOrder
  | CostCode
  | CostDivision
  | DesignPackage
  | Item
  | ItemTemplate
  | ItemTemplateItem
  | ProductOffering
  | ReadyPlanAggregateVersion
  | ReadyPlanOption
  | TakeoffLineItem
  | TakeoffLineItemVersion
  | TradeCategory;

export type HasDisplayNameTypeName =
  | "BidItem"
  | "ChangeEventLineItem"
  | "ProjectItem"
  | "Commitment"
  | "Document"
  | "ItemTemplateItemVersion"
  | "ReadyPlan"
  | "PlanPackage"
  | "CommitmentChangeOrder"
  | "CostCode"
  | "CostDivision"
  | "DesignPackage"
  | "Item"
  | "ItemTemplate"
  | "ItemTemplateItem"
  | "ProductOffering"
  | "ReadyPlanAggregateVersion"
  | "ReadyPlanOption"
  | "TakeoffLineItem"
  | "TakeoffLineItemVersion"
  | "TradeCategory";

export function newHasDisplayName(): BidItem;
export function newHasDisplayName(options: BidItemOptions, cache?: Record<string, any>): BidItem;
export function newHasDisplayName(
  options: RequireTypename<ChangeEventLineItemOptions>,
  cache?: Record<string, any>,
): ChangeEventLineItem;
export function newHasDisplayName(
  options: RequireTypename<ProjectItemOptions>,
  cache?: Record<string, any>,
): ProjectItem;
export function newHasDisplayName(options: RequireTypename<CommitmentOptions>, cache?: Record<string, any>): Commitment;
export function newHasDisplayName(options: RequireTypename<DocumentOptions>, cache?: Record<string, any>): Document;
export function newHasDisplayName(
  options: RequireTypename<ItemTemplateItemVersionOptions>,
  cache?: Record<string, any>,
): ItemTemplateItemVersion;
export function newHasDisplayName(options: RequireTypename<ReadyPlanOptions>, cache?: Record<string, any>): ReadyPlan;
export function newHasDisplayName(
  options: RequireTypename<PlanPackageOptions>,
  cache?: Record<string, any>,
): PlanPackage;
export function newHasDisplayName(
  options: RequireTypename<CommitmentChangeOrderOptions>,
  cache?: Record<string, any>,
): CommitmentChangeOrder;
export function newHasDisplayName(options: RequireTypename<CostCodeOptions>, cache?: Record<string, any>): CostCode;
export function newHasDisplayName(
  options: RequireTypename<CostDivisionOptions>,
  cache?: Record<string, any>,
): CostDivision;
export function newHasDisplayName(
  options: RequireTypename<DesignPackageOptions>,
  cache?: Record<string, any>,
): DesignPackage;
export function newHasDisplayName(options: RequireTypename<ItemOptions>, cache?: Record<string, any>): Item;
export function newHasDisplayName(
  options: RequireTypename<ItemTemplateOptions>,
  cache?: Record<string, any>,
): ItemTemplate;
export function newHasDisplayName(
  options: RequireTypename<ItemTemplateItemOptions>,
  cache?: Record<string, any>,
): ItemTemplateItem;
export function newHasDisplayName(
  options: RequireTypename<ProductOfferingOptions>,
  cache?: Record<string, any>,
): ProductOffering;
export function newHasDisplayName(
  options: RequireTypename<ReadyPlanAggregateVersionOptions>,
  cache?: Record<string, any>,
): ReadyPlanAggregateVersion;
export function newHasDisplayName(
  options: RequireTypename<ReadyPlanOptionOptions>,
  cache?: Record<string, any>,
): ReadyPlanOption;
export function newHasDisplayName(
  options: RequireTypename<TakeoffLineItemOptions>,
  cache?: Record<string, any>,
): TakeoffLineItem;
export function newHasDisplayName(
  options: RequireTypename<TakeoffLineItemVersionOptions>,
  cache?: Record<string, any>,
): TakeoffLineItemVersion;
export function newHasDisplayName(
  options: RequireTypename<TradeCategoryOptions>,
  cache?: Record<string, any>,
): TradeCategory;
export function newHasDisplayName(
  options: HasDisplayNameOptions = {},
  cache: Record<string, any> = {},
): HasDisplayNameType {
  const { __typename = "BidItem" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["HasDisplayName"] = newHasDisplayName;

export type MaybeHasProjectOptions =
  | BillOptions
  | RequireTypename<ChangeEventOptions>
  | RequireTypename<TaskOptions>
  | RequireTypename<InvoiceOptions>
  | RequireTypename<StandaloneProjectOptions>
  | RequireTypename<RegionOptions>
  | RequireTypename<MarketOptions>
  | RequireTypename<CommunityOptions>
  | RequireTypename<SubdivisionOptions>
  | RequireTypename<LotOptions>
  | RequireTypename<StructureOptions>
  | RequireTypename<UnitOptions>
  | RequireTypename<ProjectItemOptions>
  | RequireTypename<EstimateOptions>
  | RequireTypename<CommitmentOptions>
  | RequireTypename<HomeownerContractOptions>
  | RequireTypename<ProjectStageOptions>
  | RequireTypename<ProjectCollaboratorOptions>
  | RequireTypename<ProjectUpdateOptions>;

export type MaybeHasProjectType =
  | Bill
  | ChangeEvent
  | Task
  | Invoice
  | StandaloneProject
  | Region
  | Market
  | Community
  | Subdivision
  | Lot
  | Structure
  | Unit
  | ProjectItem
  | Estimate
  | Commitment
  | HomeownerContract
  | ProjectStage
  | ProjectCollaborator
  | ProjectUpdate;

export type MaybeHasProjectTypeName =
  | "Bill"
  | "ChangeEvent"
  | "Task"
  | "Invoice"
  | "StandaloneProject"
  | "Region"
  | "Market"
  | "Community"
  | "Subdivision"
  | "Lot"
  | "Structure"
  | "Unit"
  | "ProjectItem"
  | "Estimate"
  | "Commitment"
  | "HomeownerContract"
  | "ProjectStage"
  | "ProjectCollaborator"
  | "ProjectUpdate";

export function newMaybeHasProject(): Bill;
export function newMaybeHasProject(options: BillOptions, cache?: Record<string, any>): Bill;
export function newMaybeHasProject(
  options: RequireTypename<ChangeEventOptions>,
  cache?: Record<string, any>,
): ChangeEvent;
export function newMaybeHasProject(options: RequireTypename<TaskOptions>, cache?: Record<string, any>): Task;
export function newMaybeHasProject(options: RequireTypename<InvoiceOptions>, cache?: Record<string, any>): Invoice;
export function newMaybeHasProject(
  options: RequireTypename<StandaloneProjectOptions>,
  cache?: Record<string, any>,
): StandaloneProject;
export function newMaybeHasProject(options: RequireTypename<RegionOptions>, cache?: Record<string, any>): Region;
export function newMaybeHasProject(options: RequireTypename<MarketOptions>, cache?: Record<string, any>): Market;
export function newMaybeHasProject(options: RequireTypename<CommunityOptions>, cache?: Record<string, any>): Community;
export function newMaybeHasProject(
  options: RequireTypename<SubdivisionOptions>,
  cache?: Record<string, any>,
): Subdivision;
export function newMaybeHasProject(options: RequireTypename<LotOptions>, cache?: Record<string, any>): Lot;
export function newMaybeHasProject(options: RequireTypename<StructureOptions>, cache?: Record<string, any>): Structure;
export function newMaybeHasProject(options: RequireTypename<UnitOptions>, cache?: Record<string, any>): Unit;
export function newMaybeHasProject(
  options: RequireTypename<ProjectItemOptions>,
  cache?: Record<string, any>,
): ProjectItem;
export function newMaybeHasProject(options: RequireTypename<EstimateOptions>, cache?: Record<string, any>): Estimate;
export function newMaybeHasProject(
  options: RequireTypename<CommitmentOptions>,
  cache?: Record<string, any>,
): Commitment;
export function newMaybeHasProject(
  options: RequireTypename<HomeownerContractOptions>,
  cache?: Record<string, any>,
): HomeownerContract;
export function newMaybeHasProject(
  options: RequireTypename<ProjectStageOptions>,
  cache?: Record<string, any>,
): ProjectStage;
export function newMaybeHasProject(
  options: RequireTypename<ProjectCollaboratorOptions>,
  cache?: Record<string, any>,
): ProjectCollaborator;
export function newMaybeHasProject(
  options: RequireTypename<ProjectUpdateOptions>,
  cache?: Record<string, any>,
): ProjectUpdate;
export function newMaybeHasProject(
  options: MaybeHasProjectOptions = {},
  cache: Record<string, any> = {},
): MaybeHasProjectType {
  const { __typename = "Bill" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["MaybeHasProject"] = newMaybeHasProject;

export type ProjectStageTemplateConfigLikeOptions =
  | ChangeEventTemplateConfigOptions
  | RequireTypename<ProjectStageTemplateConfigOptions>;

export type ProjectStageTemplateConfigLikeType = ChangeEventTemplateConfig | ProjectStageTemplateConfig;

export type ProjectStageTemplateConfigLikeTypeName = "ChangeEventTemplateConfig" | "ProjectStageTemplateConfig";

export function newProjectStageTemplateConfigLike(): ChangeEventTemplateConfig;
export function newProjectStageTemplateConfigLike(
  options: ChangeEventTemplateConfigOptions,
  cache?: Record<string, any>,
): ChangeEventTemplateConfig;
export function newProjectStageTemplateConfigLike(
  options: RequireTypename<ProjectStageTemplateConfigOptions>,
  cache?: Record<string, any>,
): ProjectStageTemplateConfig;
export function newProjectStageTemplateConfigLike(
  options: ProjectStageTemplateConfigLikeOptions = {},
  cache: Record<string, any> = {},
): ProjectStageTemplateConfigLikeType {
  const { __typename = "ChangeEventTemplateConfig" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["ProjectStageTemplateConfigLike"] = newProjectStageTemplateConfigLike;

export type HasCheckoutUrlOptions = CheckoutConfigOptions;

export type HasCheckoutUrlType = CheckoutConfig;

export type HasCheckoutUrlTypeName = "CheckoutConfig";

export function newHasCheckoutUrl(): CheckoutConfig;
export function newHasCheckoutUrl(options: CheckoutConfigOptions, cache?: Record<string, any>): CheckoutConfig;
export function newHasCheckoutUrl(
  options: HasCheckoutUrlOptions = {},
  cache: Record<string, any> = {},
): HasCheckoutUrlType {
  const { __typename = "CheckoutConfig" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["HasCheckoutUrl"] = newHasCheckoutUrl;

export type ReadyPlanConfigLikeOptions =
  | CheckoutConfigOptions
  | RequireTypename<ProductOfferingConfigOptions>
  | RequireTypename<ProjectReadyPlanConfigOptions>;

export type ReadyPlanConfigLikeType = CheckoutConfig | ProductOfferingConfig | ProjectReadyPlanConfig;

export type ReadyPlanConfigLikeTypeName = "CheckoutConfig" | "ProductOfferingConfig" | "ProjectReadyPlanConfig";

export function newReadyPlanConfigLike(): CheckoutConfig;
export function newReadyPlanConfigLike(options: CheckoutConfigOptions, cache?: Record<string, any>): CheckoutConfig;
export function newReadyPlanConfigLike(
  options: RequireTypename<ProductOfferingConfigOptions>,
  cache?: Record<string, any>,
): ProductOfferingConfig;
export function newReadyPlanConfigLike(
  options: RequireTypename<ProjectReadyPlanConfigOptions>,
  cache?: Record<string, any>,
): ProjectReadyPlanConfig;
export function newReadyPlanConfigLike(
  options: ReadyPlanConfigLikeOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanConfigLikeType {
  const { __typename = "CheckoutConfig" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["ReadyPlanConfigLike"] = newReadyPlanConfigLike;

export type ProjectOptions =
  | StandaloneProjectOptions
  | RequireTypename<RegionOptions>
  | RequireTypename<MarketOptions>
  | RequireTypename<CommunityOptions>
  | RequireTypename<SubdivisionOptions>
  | RequireTypename<LotOptions>
  | RequireTypename<StructureOptions>
  | RequireTypename<UnitOptions>;

export type ProjectType = StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit;

export type ProjectTypeName =
  | "StandaloneProject"
  | "Region"
  | "Market"
  | "Community"
  | "Subdivision"
  | "Lot"
  | "Structure"
  | "Unit";

export function newProject(): StandaloneProject;
export function newProject(options: StandaloneProjectOptions, cache?: Record<string, any>): StandaloneProject;
export function newProject(options: RequireTypename<RegionOptions>, cache?: Record<string, any>): Region;
export function newProject(options: RequireTypename<MarketOptions>, cache?: Record<string, any>): Market;
export function newProject(options: RequireTypename<CommunityOptions>, cache?: Record<string, any>): Community;
export function newProject(options: RequireTypename<SubdivisionOptions>, cache?: Record<string, any>): Subdivision;
export function newProject(options: RequireTypename<LotOptions>, cache?: Record<string, any>): Lot;
export function newProject(options: RequireTypename<StructureOptions>, cache?: Record<string, any>): Structure;
export function newProject(options: RequireTypename<UnitOptions>, cache?: Record<string, any>): Unit;
export function newProject(options: ProjectOptions = {}, cache: Record<string, any> = {}): ProjectType {
  const { __typename = "StandaloneProject" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["Project"] = newProject;

export type HasSchedulesOptions =
  | StandaloneProjectOptions
  | RequireTypename<RegionOptions>
  | RequireTypename<MarketOptions>
  | RequireTypename<CommunityOptions>
  | RequireTypename<SubdivisionOptions>
  | RequireTypename<LotOptions>
  | RequireTypename<StructureOptions>
  | RequireTypename<UnitOptions>
  | RequireTypename<DevelopmentOptions>
  | RequireTypename<ScheduleTemplateOptions>;

export type HasSchedulesType =
  | StandaloneProject
  | Region
  | Market
  | Community
  | Subdivision
  | Lot
  | Structure
  | Unit
  | Development
  | ScheduleTemplate;

export type HasSchedulesTypeName =
  | "StandaloneProject"
  | "Region"
  | "Market"
  | "Community"
  | "Subdivision"
  | "Lot"
  | "Structure"
  | "Unit"
  | "Development"
  | "ScheduleTemplate";

export function newHasSchedules(): StandaloneProject;
export function newHasSchedules(options: StandaloneProjectOptions, cache?: Record<string, any>): StandaloneProject;
export function newHasSchedules(options: RequireTypename<RegionOptions>, cache?: Record<string, any>): Region;
export function newHasSchedules(options: RequireTypename<MarketOptions>, cache?: Record<string, any>): Market;
export function newHasSchedules(options: RequireTypename<CommunityOptions>, cache?: Record<string, any>): Community;
export function newHasSchedules(options: RequireTypename<SubdivisionOptions>, cache?: Record<string, any>): Subdivision;
export function newHasSchedules(options: RequireTypename<LotOptions>, cache?: Record<string, any>): Lot;
export function newHasSchedules(options: RequireTypename<StructureOptions>, cache?: Record<string, any>): Structure;
export function newHasSchedules(options: RequireTypename<UnitOptions>, cache?: Record<string, any>): Unit;
export function newHasSchedules(options: RequireTypename<DevelopmentOptions>, cache?: Record<string, any>): Development;
export function newHasSchedules(
  options: RequireTypename<ScheduleTemplateOptions>,
  cache?: Record<string, any>,
): ScheduleTemplate;
export function newHasSchedules(options: HasSchedulesOptions = {}, cache: Record<string, any> = {}): HasSchedulesType {
  const { __typename = "StandaloneProject" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["HasSchedules"] = newHasSchedules;

export type HasHopUrlOptions =
  | StandaloneProjectOptions
  | RequireTypename<RegionOptions>
  | RequireTypename<MarketOptions>
  | RequireTypename<CommunityOptions>
  | RequireTypename<SubdivisionOptions>
  | RequireTypename<LotOptions>
  | RequireTypename<StructureOptions>
  | RequireTypename<UnitOptions>;

export type HasHopUrlType = StandaloneProject | Region | Market | Community | Subdivision | Lot | Structure | Unit;

export type HasHopUrlTypeName =
  | "StandaloneProject"
  | "Region"
  | "Market"
  | "Community"
  | "Subdivision"
  | "Lot"
  | "Structure"
  | "Unit";

export function newHasHopUrl(): StandaloneProject;
export function newHasHopUrl(options: StandaloneProjectOptions, cache?: Record<string, any>): StandaloneProject;
export function newHasHopUrl(options: RequireTypename<RegionOptions>, cache?: Record<string, any>): Region;
export function newHasHopUrl(options: RequireTypename<MarketOptions>, cache?: Record<string, any>): Market;
export function newHasHopUrl(options: RequireTypename<CommunityOptions>, cache?: Record<string, any>): Community;
export function newHasHopUrl(options: RequireTypename<SubdivisionOptions>, cache?: Record<string, any>): Subdivision;
export function newHasHopUrl(options: RequireTypename<LotOptions>, cache?: Record<string, any>): Lot;
export function newHasHopUrl(options: RequireTypename<StructureOptions>, cache?: Record<string, any>): Structure;
export function newHasHopUrl(options: RequireTypename<UnitOptions>, cache?: Record<string, any>): Unit;
export function newHasHopUrl(options: HasHopUrlOptions = {}, cache: Record<string, any> = {}): HasHopUrlType {
  const { __typename = "StandaloneProject" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["HasHopUrl"] = newHasHopUrl;

export type MaybeHasPropcoUrlOptions = StandaloneProjectOptions | RequireTypename<StructureOptions>;

export type MaybeHasPropcoUrlType = StandaloneProject | Structure;

export type MaybeHasPropcoUrlTypeName = "StandaloneProject" | "Structure";

export function newMaybeHasPropcoUrl(): StandaloneProject;
export function newMaybeHasPropcoUrl(options: StandaloneProjectOptions, cache?: Record<string, any>): StandaloneProject;
export function newMaybeHasPropcoUrl(
  options: RequireTypename<StructureOptions>,
  cache?: Record<string, any>,
): Structure;
export function newMaybeHasPropcoUrl(
  options: MaybeHasPropcoUrlOptions = {},
  cache: Record<string, any> = {},
): MaybeHasPropcoUrlType {
  const { __typename = "StandaloneProject" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["MaybeHasPropcoUrl"] = newMaybeHasPropcoUrl;

export type ProjectItemLikeOptions = ProjectItemOptions | RequireTypename<ProtoProjectItemOptions>;

export type ProjectItemLikeType = ProjectItem | ProtoProjectItem;

export type ProjectItemLikeTypeName = "ProjectItem" | "ProtoProjectItem";

export function newProjectItemLike(): ProjectItem;
export function newProjectItemLike(options: ProjectItemOptions, cache?: Record<string, any>): ProjectItem;
export function newProjectItemLike(
  options: RequireTypename<ProtoProjectItemOptions>,
  cache?: Record<string, any>,
): ProtoProjectItem;
export function newProjectItemLike(
  options: ProjectItemLikeOptions = {},
  cache: Record<string, any> = {},
): ProjectItemLikeType {
  const { __typename = "ProjectItem" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["ProjectItemLike"] = newProjectItemLike;

export type CommitmentLikeOptions = CommitmentOptions | RequireTypename<CommitmentChangeOrderOptions>;

export type CommitmentLikeType = Commitment | CommitmentChangeOrder;

export type CommitmentLikeTypeName = "Commitment" | "CommitmentChangeOrder";

export function newCommitmentLike(): Commitment;
export function newCommitmentLike(options: CommitmentOptions, cache?: Record<string, any>): Commitment;
export function newCommitmentLike(
  options: RequireTypename<CommitmentChangeOrderOptions>,
  cache?: Record<string, any>,
): CommitmentChangeOrder;
export function newCommitmentLike(
  options: CommitmentLikeOptions = {},
  cache: Record<string, any> = {},
): CommitmentLikeType {
  const { __typename = "Commitment" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["CommitmentLike"] = newCommitmentLike;

export type BaseItemLikeOptions =
  | ItemTemplateItemVersionOptions
  | RequireTypename<ItemTemplateItemOptions>
  | RequireTypename<TakeoffLineItemOptions>
  | RequireTypename<TakeoffLineItemVersionOptions>;

export type BaseItemLikeType = ItemTemplateItemVersion | ItemTemplateItem | TakeoffLineItem | TakeoffLineItemVersion;

export type BaseItemLikeTypeName =
  | "ItemTemplateItemVersion"
  | "ItemTemplateItem"
  | "TakeoffLineItem"
  | "TakeoffLineItemVersion";

export function newBaseItemLike(): ItemTemplateItemVersion;
export function newBaseItemLike(
  options: ItemTemplateItemVersionOptions,
  cache?: Record<string, any>,
): ItemTemplateItemVersion;
export function newBaseItemLike(
  options: RequireTypename<ItemTemplateItemOptions>,
  cache?: Record<string, any>,
): ItemTemplateItem;
export function newBaseItemLike(
  options: RequireTypename<TakeoffLineItemOptions>,
  cache?: Record<string, any>,
): TakeoffLineItem;
export function newBaseItemLike(
  options: RequireTypename<TakeoffLineItemVersionOptions>,
  cache?: Record<string, any>,
): TakeoffLineItemVersion;
export function newBaseItemLike(options: BaseItemLikeOptions = {}, cache: Record<string, any> = {}): BaseItemLikeType {
  const { __typename = "ItemTemplateItemVersion" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["BaseItemLike"] = newBaseItemLike;

export type HomeownerContractLikeOptions =
  | HomeownerContractOptions
  | RequireTypename<HomeownerContractChangeOrderOptions>;

export type HomeownerContractLikeType = HomeownerContract | HomeownerContractChangeOrder;

export type HomeownerContractLikeTypeName = "HomeownerContract" | "HomeownerContractChangeOrder";

export function newHomeownerContractLike(): HomeownerContract;
export function newHomeownerContractLike(
  options: HomeownerContractOptions,
  cache?: Record<string, any>,
): HomeownerContract;
export function newHomeownerContractLike(
  options: RequireTypename<HomeownerContractChangeOrderOptions>,
  cache?: Record<string, any>,
): HomeownerContractChangeOrder;
export function newHomeownerContractLike(
  options: HomeownerContractLikeOptions = {},
  cache: Record<string, any> = {},
): HomeownerContractLikeType {
  const { __typename = "HomeownerContract" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["HomeownerContractLike"] = newHomeownerContractLike;

export type ReadyPlanLikeOptions =
  | ReadyPlanOptions
  | RequireTypename<PlanPackageOptions>
  | RequireTypename<DesignPackageOptions>
  | RequireTypename<ProductOfferingOptions>;

export type ReadyPlanLikeType = ReadyPlan | PlanPackage | DesignPackage | ProductOffering;

export type ReadyPlanLikeTypeName = "ReadyPlan" | "PlanPackage" | "DesignPackage" | "ProductOffering";

export function newReadyPlanLike(): ReadyPlan;
export function newReadyPlanLike(options: ReadyPlanOptions, cache?: Record<string, any>): ReadyPlan;
export function newReadyPlanLike(
  options: RequireTypename<PlanPackageOptions>,
  cache?: Record<string, any>,
): PlanPackage;
export function newReadyPlanLike(
  options: RequireTypename<DesignPackageOptions>,
  cache?: Record<string, any>,
): DesignPackage;
export function newReadyPlanLike(
  options: RequireTypename<ProductOfferingOptions>,
  cache?: Record<string, any>,
): ProductOffering;
export function newReadyPlanLike(
  options: ReadyPlanLikeOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanLikeType {
  const { __typename = "ReadyPlan" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["ReadyPlanLike"] = newReadyPlanLike;

export type BaseItemParentOptions =
  | ReadyPlanOptions
  | RequireTypename<PlanPackageOptions>
  | RequireTypename<DesignPackageOptions>
  | RequireTypename<ItemTemplateOptions>
  | RequireTypename<ProductOfferingOptions>;

export type BaseItemParentType = ReadyPlan | PlanPackage | DesignPackage | ItemTemplate | ProductOffering;

export type BaseItemParentTypeName = "ReadyPlan" | "PlanPackage" | "DesignPackage" | "ItemTemplate" | "ProductOffering";

export function newBaseItemParent(): ReadyPlan;
export function newBaseItemParent(options: ReadyPlanOptions, cache?: Record<string, any>): ReadyPlan;
export function newBaseItemParent(
  options: RequireTypename<PlanPackageOptions>,
  cache?: Record<string, any>,
): PlanPackage;
export function newBaseItemParent(
  options: RequireTypename<DesignPackageOptions>,
  cache?: Record<string, any>,
): DesignPackage;
export function newBaseItemParent(
  options: RequireTypename<ItemTemplateOptions>,
  cache?: Record<string, any>,
): ItemTemplate;
export function newBaseItemParent(
  options: RequireTypename<ProductOfferingOptions>,
  cache?: Record<string, any>,
): ProductOffering;
export function newBaseItemParent(
  options: BaseItemParentOptions = {},
  cache: Record<string, any> = {},
): BaseItemParentType {
  const { __typename = "ReadyPlan" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["BaseItemParent"] = newBaseItemParent;

export type HasMaterialLeadTimeConfigDataOptions =
  | CostCodeOptions
  | RequireTypename<ItemOptions>
  | RequireTypename<MaterialListingOptions>;

export type HasMaterialLeadTimeConfigDataType = CostCode | Item | MaterialListing;

export type HasMaterialLeadTimeConfigDataTypeName = "CostCode" | "Item" | "MaterialListing";

export function newHasMaterialLeadTimeConfigData(): CostCode;
export function newHasMaterialLeadTimeConfigData(options: CostCodeOptions, cache?: Record<string, any>): CostCode;
export function newHasMaterialLeadTimeConfigData(
  options: RequireTypename<ItemOptions>,
  cache?: Record<string, any>,
): Item;
export function newHasMaterialLeadTimeConfigData(
  options: RequireTypename<MaterialListingOptions>,
  cache?: Record<string, any>,
): MaterialListing;
export function newHasMaterialLeadTimeConfigData(
  options: HasMaterialLeadTimeConfigDataOptions = {},
  cache: Record<string, any> = {},
): HasMaterialLeadTimeConfigDataType {
  const { __typename = "CostCode" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["HasMaterialLeadTimeConfigData"] = newHasMaterialLeadTimeConfigData;

export type MaybeHasMarketOptions = DevelopmentOptions | RequireTypename<ScheduleTemplateOptions>;

export type MaybeHasMarketType = Development | ScheduleTemplate;

export type MaybeHasMarketTypeName = "Development" | "ScheduleTemplate";

export function newMaybeHasMarket(): Development;
export function newMaybeHasMarket(options: DevelopmentOptions, cache?: Record<string, any>): Development;
export function newMaybeHasMarket(
  options: RequireTypename<ScheduleTemplateOptions>,
  cache?: Record<string, any>,
): ScheduleTemplate;
export function newMaybeHasMarket(
  options: MaybeHasMarketOptions = {},
  cache: Record<string, any> = {},
): MaybeHasMarketType {
  const { __typename = "Development" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["MaybeHasMarket"] = newMaybeHasMarket;

export type HasGlobalConstraintItemOptions = GlobalPlanAllowanceOptions | RequireTypename<GlobalPlanConstraintOptions>;

export type HasGlobalConstraintItemType = GlobalPlanAllowance | GlobalPlanConstraint;

export type HasGlobalConstraintItemTypeName = "GlobalPlanAllowance" | "GlobalPlanConstraint";

export function newHasGlobalConstraintItem(): GlobalPlanAllowance;
export function newHasGlobalConstraintItem(
  options: GlobalPlanAllowanceOptions,
  cache?: Record<string, any>,
): GlobalPlanAllowance;
export function newHasGlobalConstraintItem(
  options: RequireTypename<GlobalPlanConstraintOptions>,
  cache?: Record<string, any>,
): GlobalPlanConstraint;
export function newHasGlobalConstraintItem(
  options: HasGlobalConstraintItemOptions = {},
  cache: Record<string, any> = {},
): HasGlobalConstraintItemType {
  const { __typename = "GlobalPlanAllowance" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["HasGlobalConstraintItem"] = newHasGlobalConstraintItem;

export type HomeownerSelectionOptionLikeOptions =
  | HomeownerSelectionOptionOptions
  | RequireTypename<HomeownerSelectionProductOptionOptions>;

export type HomeownerSelectionOptionLikeType = HomeownerSelectionOption | HomeownerSelectionProductOption;

export type HomeownerSelectionOptionLikeTypeName = "HomeownerSelectionOption" | "HomeownerSelectionProductOption";

export function newHomeownerSelectionOptionLike(): HomeownerSelectionOption;
export function newHomeownerSelectionOptionLike(
  options: HomeownerSelectionOptionOptions,
  cache?: Record<string, any>,
): HomeownerSelectionOption;
export function newHomeownerSelectionOptionLike(
  options: RequireTypename<HomeownerSelectionProductOptionOptions>,
  cache?: Record<string, any>,
): HomeownerSelectionProductOption;
export function newHomeownerSelectionOptionLike(
  options: HomeownerSelectionOptionLikeOptions = {},
  cache: Record<string, any> = {},
): HomeownerSelectionOptionLikeType {
  const { __typename = "HomeownerSelectionOption" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["HomeownerSelectionOptionLike"] = newHomeownerSelectionOptionLike;

export type HasDisplayVersionOptions = ItemTemplateOptions | RequireTypename<ReadyPlanAggregateVersionOptions>;

export type HasDisplayVersionType = ItemTemplate | ReadyPlanAggregateVersion;

export type HasDisplayVersionTypeName = "ItemTemplate" | "ReadyPlanAggregateVersion";

export function newHasDisplayVersion(): ItemTemplate;
export function newHasDisplayVersion(options: ItemTemplateOptions, cache?: Record<string, any>): ItemTemplate;
export function newHasDisplayVersion(
  options: RequireTypename<ReadyPlanAggregateVersionOptions>,
  cache?: Record<string, any>,
): ReadyPlanAggregateVersion;
export function newHasDisplayVersion(
  options: HasDisplayVersionOptions = {},
  cache: Record<string, any> = {},
): HasDisplayVersionType {
  const { __typename = "ItemTemplate" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["HasDisplayVersion"] = newHasDisplayVersion;

export type BaseItemParentVersionOptions = ItemTemplateOptions | RequireTypename<ReadyPlanAggregateVersionOptions>;

export type BaseItemParentVersionType = ItemTemplate | ReadyPlanAggregateVersion;

export type BaseItemParentVersionTypeName = "ItemTemplate" | "ReadyPlanAggregateVersion";

export function newBaseItemParentVersion(): ItemTemplate;
export function newBaseItemParentVersion(options: ItemTemplateOptions, cache?: Record<string, any>): ItemTemplate;
export function newBaseItemParentVersion(
  options: RequireTypename<ReadyPlanAggregateVersionOptions>,
  cache?: Record<string, any>,
): ReadyPlanAggregateVersion;
export function newBaseItemParentVersion(
  options: BaseItemParentVersionOptions = {},
  cache: Record<string, any> = {},
): BaseItemParentVersionType {
  const { __typename = "ItemTemplate" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["BaseItemParentVersion"] = newBaseItemParentVersion;

export type HasOptionPricingDataOptions = MaterialListingOptions | RequireTypename<ReadyPlanOptionOptions>;

export type HasOptionPricingDataType = MaterialListing | ReadyPlanOption;

export type HasOptionPricingDataTypeName = "MaterialListing" | "ReadyPlanOption";

export function newHasOptionPricingData(): MaterialListing;
export function newHasOptionPricingData(options: MaterialListingOptions, cache?: Record<string, any>): MaterialListing;
export function newHasOptionPricingData(
  options: RequireTypename<ReadyPlanOptionOptions>,
  cache?: Record<string, any>,
): ReadyPlanOption;
export function newHasOptionPricingData(
  options: HasOptionPricingDataOptions = {},
  cache: Record<string, any> = {},
): HasOptionPricingDataType {
  const { __typename = "MaterialListing" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["HasOptionPricingData"] = newHasOptionPricingData;

export type ProgramDataLikeOptions = ProgramDataOptions | RequireTypename<NewProgramDataOptions>;

export type ProgramDataLikeType = ProgramData | NewProgramData;

export type ProgramDataLikeTypeName = "ProgramData" | "NewProgramData";

export function newProgramDataLike(): ProgramData;
export function newProgramDataLike(options: ProgramDataOptions, cache?: Record<string, any>): ProgramData;
export function newProgramDataLike(
  options: RequireTypename<NewProgramDataOptions>,
  cache?: Record<string, any>,
): NewProgramData;
export function newProgramDataLike(
  options: ProgramDataLikeOptions = {},
  cache: Record<string, any> = {},
): ProgramDataLikeType {
  const { __typename = "ProgramData" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["ProgramDataLike"] = newProgramDataLike;

export type HasUserErrorsOptions = SaveProjectItemsResultOptions;

export type HasUserErrorsType = SaveProjectItemsResult;

export type HasUserErrorsTypeName = "SaveProjectItemsResult";

export function newHasUserErrors(): SaveProjectItemsResult;
export function newHasUserErrors(
  options: SaveProjectItemsResultOptions,
  cache?: Record<string, any>,
): SaveProjectItemsResult;
export function newHasUserErrors(
  options: HasUserErrorsOptions = {},
  cache: Record<string, any> = {},
): HasUserErrorsType {
  const { __typename = "SaveProjectItemsResult" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["HasUserErrors"] = newHasUserErrors;

export type ReadyPlanCostDataOptions =
  | ComputeReadyPlanCostResultOptions
  | RequireTypename<ReadyPlanOptionCostDeltaOptions>;

export type ReadyPlanCostDataType = ComputeReadyPlanCostResult | ReadyPlanOptionCostDelta;

export type ReadyPlanCostDataTypeName = "ComputeReadyPlanCostResult" | "ReadyPlanOptionCostDelta";

export function newReadyPlanCostData(): ComputeReadyPlanCostResult;
export function newReadyPlanCostData(
  options: ComputeReadyPlanCostResultOptions,
  cache?: Record<string, any>,
): ComputeReadyPlanCostResult;
export function newReadyPlanCostData(
  options: RequireTypename<ReadyPlanOptionCostDeltaOptions>,
  cache?: Record<string, any>,
): ReadyPlanOptionCostDelta;
export function newReadyPlanCostData(
  options: ReadyPlanCostDataOptions = {},
  cache: Record<string, any> = {},
): ReadyPlanCostDataType {
  const { __typename = "ComputeReadyPlanCostResult" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["ReadyPlanCostData"] = newReadyPlanCostData;

export type HasScheduleImpactOptions =
  | DeleteSchedulePhasesResultOptions
  | RequireTypename<DeleteScheduleSubPhasesResultOptions>
  | RequireTypename<MoveScheduleSubPhasesResultOptions>
  | RequireTypename<SaveScheduleTasksResultOptions>;

export type HasScheduleImpactType =
  | DeleteSchedulePhasesResult
  | DeleteScheduleSubPhasesResult
  | MoveScheduleSubPhasesResult
  | SaveScheduleTasksResult;

export type HasScheduleImpactTypeName =
  | "DeleteSchedulePhasesResult"
  | "DeleteScheduleSubPhasesResult"
  | "MoveScheduleSubPhasesResult"
  | "SaveScheduleTasksResult";

export function newHasScheduleImpact(): DeleteSchedulePhasesResult;
export function newHasScheduleImpact(
  options: DeleteSchedulePhasesResultOptions,
  cache?: Record<string, any>,
): DeleteSchedulePhasesResult;
export function newHasScheduleImpact(
  options: RequireTypename<DeleteScheduleSubPhasesResultOptions>,
  cache?: Record<string, any>,
): DeleteScheduleSubPhasesResult;
export function newHasScheduleImpact(
  options: RequireTypename<MoveScheduleSubPhasesResultOptions>,
  cache?: Record<string, any>,
): MoveScheduleSubPhasesResult;
export function newHasScheduleImpact(
  options: RequireTypename<SaveScheduleTasksResultOptions>,
  cache?: Record<string, any>,
): SaveScheduleTasksResult;
export function newHasScheduleImpact(
  options: HasScheduleImpactOptions = {},
  cache: Record<string, any> = {},
): HasScheduleImpactType {
  const { __typename = "DeleteSchedulePhasesResult" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["HasScheduleImpact"] = newHasScheduleImpact;

export type TradeCategoryLeadTimeLikeOptions =
  | TradeCategoryLeadTimeDefaultOptions
  | RequireTypename<TradeCategoryLeadTimeOptions>;

export type TradeCategoryLeadTimeLikeType = TradeCategoryLeadTimeDefault | TradeCategoryLeadTime;

export type TradeCategoryLeadTimeLikeTypeName = "TradeCategoryLeadTimeDefault" | "TradeCategoryLeadTime";

export function newTradeCategoryLeadTimeLike(): TradeCategoryLeadTimeDefault;
export function newTradeCategoryLeadTimeLike(
  options: TradeCategoryLeadTimeDefaultOptions,
  cache?: Record<string, any>,
): TradeCategoryLeadTimeDefault;
export function newTradeCategoryLeadTimeLike(
  options: RequireTypename<TradeCategoryLeadTimeOptions>,
  cache?: Record<string, any>,
): TradeCategoryLeadTime;
export function newTradeCategoryLeadTimeLike(
  options: TradeCategoryLeadTimeLikeOptions = {},
  cache: Record<string, any> = {},
): TradeCategoryLeadTimeLikeType {
  const { __typename = "TradeCategoryLeadTimeDefault" } = options ?? {};
  const maybeCached = Object.keys(options).length === 0 ? cache[__typename] : undefined;
  return maybeCached ?? maybeNew(__typename, options ?? {}, cache);
}

factories["TradeCategoryLeadTimeLike"] = newTradeCategoryLeadTimeLike;

const enumDetailNameOfTaskStatus = {
  NOT_STARTED: "Not started",
  IN_PROGRESS: "In progress",
  COMPLETE: "Complete",
  ON_HOLD: "On hold",
  DELAYED: "Delayed",
};

function enumOrDetailOfTaskStatus(enumOrDetail: TaskStatusDetailOptions | TaskStatus | undefined): TaskStatusDetail {
  if (enumOrDetail === undefined) {
    return newTaskStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "TaskStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfTaskStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as TaskStatusDetail;
  } else {
    return newTaskStatusDetail({
      code: enumOrDetail as TaskStatus,
      name: enumDetailNameOfTaskStatus[enumOrDetail as TaskStatus],
    });
  }
}

function enumOrDetailOrNullOfTaskStatus(
  enumOrDetail: TaskStatusDetailOptions | TaskStatus | undefined | null,
): TaskStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfTaskStatus(enumOrDetail);
}

const enumDetailNameOfTradePartnerTaskStatus = {
  NEEDS_CONFIRMATION: "Needs confirmation",
  CONFIRMED: "Confirmed",
  UNAVAILABLE: "Unavailable",
  COMPLETED_JOB: "Completed job",
  NEEDS_RECONFIRMATION: "Needs reconfirmation",
  NOT_SENT: "Not sent",
};

function enumOrDetailOfTradePartnerTaskStatus(
  enumOrDetail: TradePartnerTaskStatusDetailOptions | TradePartnerTaskStatus | undefined,
): TradePartnerTaskStatusDetail {
  if (enumOrDetail === undefined) {
    return newTradePartnerTaskStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "TradePartnerTaskStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfTradePartnerTaskStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as TradePartnerTaskStatusDetail;
  } else {
    return newTradePartnerTaskStatusDetail({
      code: enumOrDetail as TradePartnerTaskStatus,
      name: enumDetailNameOfTradePartnerTaskStatus[enumOrDetail as TradePartnerTaskStatus],
    });
  }
}

function enumOrDetailOrNullOfTradePartnerTaskStatus(
  enumOrDetail: TradePartnerTaskStatusDetailOptions | TradePartnerTaskStatus | undefined | null,
): TradePartnerTaskStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfTradePartnerTaskStatus(enumOrDetail);
}

const enumDetailNameOfTaskType = { SCHEDULE_TASK: "Schedule task", PLAN_TASK: "Plan task" };

function enumOrDetailOfTaskType(enumOrDetail: TaskTypeDetailOptions | TaskType | undefined): TaskTypeDetail {
  if (enumOrDetail === undefined) {
    return newTaskTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "TaskTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfTaskType[enumOrDetail.code!],
      ...enumOrDetail,
    } as TaskTypeDetail;
  } else {
    return newTaskTypeDetail({
      code: enumOrDetail as TaskType,
      name: enumDetailNameOfTaskType[enumOrDetail as TaskType],
    });
  }
}

function enumOrDetailOrNullOfTaskType(
  enumOrDetail: TaskTypeDetailOptions | TaskType | undefined | null,
): TaskTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfTaskType(enumOrDetail);
}

const enumDetailNameOfApprovalStatus = {
  CHANGES_NEEDED: "Changes needed",
  REQUESTED: "Requested",
  APPROVED: "Approved",
  REJECTED: "Rejected",
};

function enumOrDetailOfApprovalStatus(
  enumOrDetail: ApprovalStatusDetailOptions | ApprovalStatus | undefined,
): ApprovalStatusDetail {
  if (enumOrDetail === undefined) {
    return newApprovalStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ApprovalStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfApprovalStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as ApprovalStatusDetail;
  } else {
    return newApprovalStatusDetail({
      code: enumOrDetail as ApprovalStatus,
      name: enumDetailNameOfApprovalStatus[enumOrDetail as ApprovalStatus],
    });
  }
}

function enumOrDetailOrNullOfApprovalStatus(
  enumOrDetail: ApprovalStatusDetailOptions | ApprovalStatus | undefined | null,
): ApprovalStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfApprovalStatus(enumOrDetail);
}

const enumDetailNameOfApproverStatus = {
  PENDING: "Pending",
  ACTION_REQUIRED: "Action required",
  CHANGES_REQUESTED: "Changes requested",
  APPROVED: "Approved",
  REJECTED: "Rejected",
};

function enumOrDetailOfApproverStatus(
  enumOrDetail: ApproverStatusDetailOptions | ApproverStatus | undefined,
): ApproverStatusDetail {
  if (enumOrDetail === undefined) {
    return newApproverStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ApproverStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfApproverStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as ApproverStatusDetail;
  } else {
    return newApproverStatusDetail({
      code: enumOrDetail as ApproverStatus,
      name: enumDetailNameOfApproverStatus[enumOrDetail as ApproverStatus],
    });
  }
}

function enumOrDetailOrNullOfApproverStatus(
  enumOrDetail: ApproverStatusDetailOptions | ApproverStatus | undefined | null,
): ApproverStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfApproverStatus(enumOrDetail);
}

const enumDetailNameOfBidContractType = {
  UNIT_BASED: "Unit based",
  ITEM_TEMPLATE_BASED: "Item template based",
  GROUPED_BY_PLAN_AND_OPTION: "Grouped by plan and option",
};

function enumOrDetailOfBidContractType(
  enumOrDetail: BidContractTypeDetailOptions | BidContractType | undefined,
): BidContractTypeDetail {
  if (enumOrDetail === undefined) {
    return newBidContractTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "BidContractTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfBidContractType[enumOrDetail.code!],
      ...enumOrDetail,
    } as BidContractTypeDetail;
  } else {
    return newBidContractTypeDetail({
      code: enumOrDetail as BidContractType,
      name: enumDetailNameOfBidContractType[enumOrDetail as BidContractType],
    });
  }
}

function enumOrDetailOrNullOfBidContractType(
  enumOrDetail: BidContractTypeDetailOptions | BidContractType | undefined | null,
): BidContractTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfBidContractType(enumOrDetail);
}

const enumDetailNameOfBidScopeSource = {
  COMMUNITY: "Community",
  SUBDIVISION: "Subdivision",
  LOT: "Lot",
  PRODUCT_OFFERING: "Product offering",
};

function enumOrDetailOfBidScopeSource(
  enumOrDetail: BidScopeSourceDetailOptions | BidScopeSource | undefined,
): BidScopeSourceDetail {
  if (enumOrDetail === undefined) {
    return newBidScopeSourceDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "BidScopeSourceDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfBidScopeSource[enumOrDetail.code!],
      ...enumOrDetail,
    } as BidScopeSourceDetail;
  } else {
    return newBidScopeSourceDetail({
      code: enumOrDetail as BidScopeSource,
      name: enumDetailNameOfBidScopeSource[enumOrDetail as BidScopeSource],
    });
  }
}

function enumOrDetailOrNullOfBidScopeSource(
  enumOrDetail: BidScopeSourceDetailOptions | BidScopeSource | undefined | null,
): BidScopeSourceDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfBidScopeSource(enumOrDetail);
}

const enumDetailNameOfBidContractRevisionStatus = {
  DRAFT: "Draft",
  UPLOADED: "Uploaded",
  SENT: "Sent",
  SIGNED: "Signed",
  PARTIALLY_SIGNED: "Partially signed",
  ARCHIVED: "Archived",
};

function enumOrDetailOfBidContractRevisionStatus(
  enumOrDetail: BidContractRevisionStatusDetailOptions | BidContractRevisionStatus | undefined,
): BidContractRevisionStatusDetail {
  if (enumOrDetail === undefined) {
    return newBidContractRevisionStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "BidContractRevisionStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfBidContractRevisionStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as BidContractRevisionStatusDetail;
  } else {
    return newBidContractRevisionStatusDetail({
      code: enumOrDetail as BidContractRevisionStatus,
      name: enumDetailNameOfBidContractRevisionStatus[enumOrDetail as BidContractRevisionStatus],
    });
  }
}

function enumOrDetailOrNullOfBidContractRevisionStatus(
  enumOrDetail: BidContractRevisionStatusDetailOptions | BidContractRevisionStatus | undefined | null,
): BidContractRevisionStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfBidContractRevisionStatus(enumOrDetail);
}

const enumDetailNameOfCostType = {
  LABOR: "Labor",
  MATERIALS: "Materials",
  SUBCONTRACTOR: "Subcontractor",
  EQUIPMENT: "Equipment",
  OTHER: "Other",
};

function enumOrDetailOfCostType(enumOrDetail: CostTypeDetailOptions | CostType | undefined): CostTypeDetail {
  if (enumOrDetail === undefined) {
    return newCostTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "CostTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfCostType[enumOrDetail.code!],
      ...enumOrDetail,
    } as CostTypeDetail;
  } else {
    return newCostTypeDetail({
      code: enumOrDetail as CostType,
      name: enumDetailNameOfCostType[enumOrDetail as CostType],
    });
  }
}

function enumOrDetailOrNullOfCostType(
  enumOrDetail: CostTypeDetailOptions | CostType | undefined | null,
): CostTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfCostType(enumOrDetail);
}

const enumDetailNameOfBidPackageStatus = { DRAFT: "Draft", OPEN: "Open", RECEIVED: "Received", AWARDED: "Awarded" };

function enumOrDetailOfBidPackageStatus(
  enumOrDetail: BidPackageStatusDetailOptions | BidPackageStatus | undefined,
): BidPackageStatusDetail {
  if (enumOrDetail === undefined) {
    return newBidPackageStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "BidPackageStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfBidPackageStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as BidPackageStatusDetail;
  } else {
    return newBidPackageStatusDetail({
      code: enumOrDetail as BidPackageStatus,
      name: enumDetailNameOfBidPackageStatus[enumOrDetail as BidPackageStatus],
    });
  }
}

function enumOrDetailOrNullOfBidPackageStatus(
  enumOrDetail: BidPackageStatusDetailOptions | BidPackageStatus | undefined | null,
): BidPackageStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfBidPackageStatus(enumOrDetail);
}

const enumDetailNameOfTradePartnerOnboardingStatus = {
  IN_PROGRESS: "In progress",
  COMPLETE: "Complete",
  DO_NOT_USE: "Do not use",
  INACTIVE: "Inactive",
};

function enumOrDetailOfTradePartnerOnboardingStatus(
  enumOrDetail: TradePartnerOnboardingStatusDetailOptions | TradePartnerOnboardingStatus | undefined,
): TradePartnerOnboardingStatusDetail {
  if (enumOrDetail === undefined) {
    return newTradePartnerOnboardingStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "TradePartnerOnboardingStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfTradePartnerOnboardingStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as TradePartnerOnboardingStatusDetail;
  } else {
    return newTradePartnerOnboardingStatusDetail({
      code: enumOrDetail as TradePartnerOnboardingStatus,
      name: enumDetailNameOfTradePartnerOnboardingStatus[enumOrDetail as TradePartnerOnboardingStatus],
    });
  }
}

function enumOrDetailOrNullOfTradePartnerOnboardingStatus(
  enumOrDetail: TradePartnerOnboardingStatusDetailOptions | TradePartnerOnboardingStatus | undefined | null,
): TradePartnerOnboardingStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfTradePartnerOnboardingStatus(enumOrDetail);
}

const enumDetailNameOfBillType = {
  STANDARD: "Standard",
  DEPOSIT: "Deposit",
  OVERHEAD: "Overhead",
  REPAIR_AND_MAINTENANCE: "Repair and maintenance",
  WARRANTY: "Warranty",
};

function enumOrDetailOfBillType(enumOrDetail: BillTypeDetailOptions | BillType | undefined): BillTypeDetail {
  if (enumOrDetail === undefined) {
    return newBillTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "BillTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfBillType[enumOrDetail.code!],
      ...enumOrDetail,
    } as BillTypeDetail;
  } else {
    return newBillTypeDetail({
      code: enumOrDetail as BillType,
      name: enumDetailNameOfBillType[enumOrDetail as BillType],
    });
  }
}

function enumOrDetailOrNullOfBillType(
  enumOrDetail: BillTypeDetailOptions | BillType | undefined | null,
): BillTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfBillType(enumOrDetail);
}

const enumDetailNameOfBillStatus = {
  DRAFT: "Draft",
  CHANGES_REQUESTED: "Changes requested",
  RELEASE_SCHEDULED: "Release scheduled",
  PENDING_APPROVAL: "Pending approval",
  READY_TO_PAY: "Ready to pay",
  REJECTED: "Rejected",
  PAID: "Paid",
  REVERSED: "Reversed",
  CANCELLED: "Cancelled",
  PENDING_CONDITIONAL_LIEN_WAIVER: "Pending conditional lien waiver",
  PENDING_UNCONDITIONAL_LIEN_WAIVER: "Pending unconditional lien waiver",
  UNRELEASED: "Unreleased",
  PARTIALLY_PAID: "Partially paid",
};

function enumOrDetailOfBillStatus(enumOrDetail: BillStatusDetailOptions | BillStatus | undefined): BillStatusDetail {
  if (enumOrDetail === undefined) {
    return newBillStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "BillStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfBillStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as BillStatusDetail;
  } else {
    return newBillStatusDetail({
      code: enumOrDetail as BillStatus,
      name: enumDetailNameOfBillStatus[enumOrDetail as BillStatus],
    });
  }
}

function enumOrDetailOrNullOfBillStatus(
  enumOrDetail: BillStatusDetailOptions | BillStatus | undefined | null,
): BillStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfBillStatus(enumOrDetail);
}

const enumDetailNameOfBillReviewReason = {
  MISSING_PO: "Missing po",
  UNSIGNED_PO: "Unsigned po",
  NEED_VPO: "Need vpo",
  INSUFFICIENT_BUDGET: "Insufficient budget",
  AUTO_PARSED: "Auto parsed",
  NEED_CLARIFICATION: "Need clarification",
};

function enumOrDetailOfBillReviewReason(
  enumOrDetail: BillReviewReasonDetailOptions | BillReviewReason | undefined,
): BillReviewReasonDetail {
  if (enumOrDetail === undefined) {
    return newBillReviewReasonDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "BillReviewReasonDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfBillReviewReason[enumOrDetail.code!],
      ...enumOrDetail,
    } as BillReviewReasonDetail;
  } else {
    return newBillReviewReasonDetail({
      code: enumOrDetail as BillReviewReason,
      name: enumDetailNameOfBillReviewReason[enumOrDetail as BillReviewReason],
    });
  }
}

function enumOrDetailOrNullOfBillReviewReason(
  enumOrDetail: BillReviewReasonDetailOptions | BillReviewReason | undefined | null,
): BillReviewReasonDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfBillReviewReason(enumOrDetail);
}

const enumDetailNameOfBillSource = { MANUAL: "Manual", CLICK_TO_PAY: "Click to pay", AUTO_PARSED: "Auto parsed" };

function enumOrDetailOfBillSource(enumOrDetail: BillSourceDetailOptions | BillSource | undefined): BillSourceDetail {
  if (enumOrDetail === undefined) {
    return newBillSourceDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "BillSourceDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfBillSource[enumOrDetail.code!],
      ...enumOrDetail,
    } as BillSourceDetail;
  } else {
    return newBillSourceDetail({
      code: enumOrDetail as BillSource,
      name: enumDetailNameOfBillSource[enumOrDetail as BillSource],
    });
  }
}

function enumOrDetailOrNullOfBillSource(
  enumOrDetail: BillSourceDetailOptions | BillSource | undefined | null,
): BillSourceDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfBillSource(enumOrDetail);
}

const enumDetailNameOfBillGmailMessageResult = {
  NOT_FOUND: "Not found",
  NO_ATTACHMENTS: "No attachments",
  NO_PDFS: "No pdfs",
  PARSED: "Parsed",
  PARSING: "Parsing",
};

function enumOrDetailOfBillGmailMessageResult(
  enumOrDetail: BillGmailMessageResultDetailOptions | BillGmailMessageResult | undefined,
): BillGmailMessageResultDetail {
  if (enumOrDetail === undefined) {
    return newBillGmailMessageResultDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "BillGmailMessageResultDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfBillGmailMessageResult[enumOrDetail.code!],
      ...enumOrDetail,
    } as BillGmailMessageResultDetail;
  } else {
    return newBillGmailMessageResultDetail({
      code: enumOrDetail as BillGmailMessageResult,
      name: enumDetailNameOfBillGmailMessageResult[enumOrDetail as BillGmailMessageResult],
    });
  }
}

function enumOrDetailOrNullOfBillGmailMessageResult(
  enumOrDetail: BillGmailMessageResultDetailOptions | BillGmailMessageResult | undefined | null,
): BillGmailMessageResultDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfBillGmailMessageResult(enumOrDetail);
}

const enumDetailNameOfProjectRole = {
  HEAD_OF_CONSTRUCTION: "Head of construction",
  ACCOUNT_EXECUTIVE: "Account executive",
  CON_OPS_PROJECT_MANAGER: "Con ops project manager",
  DESIGNER: "Designer",
  LEGAL: "Legal",
  AREA_MANAGER: "Area manager",
  ACCOUNTING: "Accounting",
  PURCHASING_ONE: "Purchasing one",
  CONSTRUCTION_COORDINATOR: "Construction coordinator",
  CX: "Cx",
  DESIGN_LEAD: "Design lead",
  HOMEBOUND_AUTHORIZED_SIGNATORY: "Homebound authorized signatory",
  A_AND_D_PROGRAM_MANAGER: "A and d program manager",
  WARRANTY_MANAGER: "Warranty manager",
  SUPERINTENDENT: "Superintendent",
  PRE_CON_PROJECT_MANAGER: "Pre con project manager",
  PRE_CON_LEAD: "Pre con lead",
  PURCHASING_TWO: "Purchasing two",
  HEAD_OF_ACCOUNTS_PAYABLE: "Head of accounts payable",
  AP_ACCOUNTANT: "Ap accountant",
  ARCHITECT_ASSOCIATE: "Architect associate",
  MARKET_LEAD: "Market lead",
  ARCHITECTURE_LEAD: "Architecture lead",
  OPTIONS_MANAGER: "Options manager",
  A_AND_D_OPERATIONS: "A and d operations",
  GRAPHIC_DESIGNER: "Graphic designer",
  PURCHASING_MANAGER: "Purchasing manager",
  SALES_LEAD: "Sales lead",
  RISK_MANAGER: "Risk manager",
  HEAD_OF_PURCHASING: "Head of purchasing",
  TRANSACTION_COORDINATOR: "Transaction coordinator",
  CON_OPS_PROJECT_MANAGER_TWO: "Con ops project manager two",
  SUPERINTENDENT_TWO: "Superintendent two",
  GENERAL_MANAGER: "General manager",
  UNDERWRITING_LEAD: "Underwriting lead",
  A_AND_D_STRATEGY: "A and d strategy",
  NATIONAL_NETWORK_MANAGER: "National network manager",
  PRODUCT_OPS: "Product ops",
  LW_INVOICE_SIGNATORY: "Lw invoice signatory",
  LAND_ACQUISITION_LEAD: "Land acquisition lead",
};

function enumOrDetailOfProjectRole(
  enumOrDetail: ProjectRoleDetailOptions | ProjectRole | undefined,
): ProjectRoleDetail {
  if (enumOrDetail === undefined) {
    return newProjectRoleDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ProjectRoleDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfProjectRole[enumOrDetail.code!],
      ...enumOrDetail,
    } as ProjectRoleDetail;
  } else {
    return newProjectRoleDetail({
      code: enumOrDetail as ProjectRole,
      name: enumDetailNameOfProjectRole[enumOrDetail as ProjectRole],
    });
  }
}

function enumOrDetailOrNullOfProjectRole(
  enumOrDetail: ProjectRoleDetailOptions | ProjectRole | undefined | null,
): ProjectRoleDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfProjectRole(enumOrDetail);
}

const enumDetailNameOfBusinessFunctionType = {
  ARCHITECTURE: "Architecture",
  CONSTRUCTION: "Construction",
  DESIGN: "Design",
  MARKETING: "Marketing",
  PURCHASING: "Purchasing",
  ACCOUNTING: "Accounting",
  SALES: "Sales",
  WARRANTY: "Warranty",
  CUSTOMER_EXPERIENCE: "Customer experience",
  UNDERWRITING: "Underwriting",
  PRECON: "Precon",
  MARKET_LAUNCH: "Market launch",
  LAND_ACQUISITION: "Land acquisition",
  LEGAL: "Legal",
};

function enumOrDetailOfBusinessFunctionType(
  enumOrDetail: BusinessFunctionTypeDetailOptions | BusinessFunctionType | undefined,
): BusinessFunctionTypeDetail {
  if (enumOrDetail === undefined) {
    return newBusinessFunctionTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "BusinessFunctionTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfBusinessFunctionType[enumOrDetail.code!],
      ...enumOrDetail,
    } as BusinessFunctionTypeDetail;
  } else {
    return newBusinessFunctionTypeDetail({
      code: enumOrDetail as BusinessFunctionType,
      name: enumDetailNameOfBusinessFunctionType[enumOrDetail as BusinessFunctionType],
    });
  }
}

function enumOrDetailOrNullOfBusinessFunctionType(
  enumOrDetail: BusinessFunctionTypeDetailOptions | BusinessFunctionType | undefined | null,
): BusinessFunctionTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfBusinessFunctionType(enumOrDetail);
}

const enumDetailNameOfChangeType = {
  NA: "Na",
  PROGRAM_CHANGE: "Program change",
  ARCHITECHTURAL_DESIGN: "Architechtural design",
  STRUCTURAL_DESIGN: "Structural design",
  MEP_DESIGN: "Mep design",
  ADD_REMOVE_MODIFY_PRODUCTS: "Add remove modify products",
  MODIFY_OPTIONS_PROGRAM: "Modify options program",
  NEW_DESIGN_PACKAGE: "New design package",
  UPDATE_EXISTING_DESIGN_PACKAGE: "Update existing design package",
  NEW_EXTERIOR_STYLE: "New exterior style",
  IMPLEMENTATION_ERROR: "Implementation error",
  PRODUCT_REFRESH: "Product refresh",
};

function enumOrDetailOfChangeType(enumOrDetail: ChangeTypeDetailOptions | ChangeType | undefined): ChangeTypeDetail {
  if (enumOrDetail === undefined) {
    return newChangeTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ChangeTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfChangeType[enumOrDetail.code!],
      ...enumOrDetail,
    } as ChangeTypeDetail;
  } else {
    return newChangeTypeDetail({
      code: enumOrDetail as ChangeType,
      name: enumDetailNameOfChangeType[enumOrDetail as ChangeType],
    });
  }
}

function enumOrDetailOrNullOfChangeType(
  enumOrDetail: ChangeTypeDetailOptions | ChangeType | undefined | null,
): ChangeTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfChangeType(enumOrDetail);
}

const enumDetailNameOfChangeEventStatus = {
  DRAFT: "Draft",
  ACCEPTED: "Accepted",
  REJECTED: "Rejected",
  PROPOSED: "Proposed",
  REQUESTED: "Requested",
  VOID: "Void",
  PENDING_SIGNATURE: "Pending signature",
};

function enumOrDetailOfChangeEventStatus(
  enumOrDetail: ChangeEventStatusDetailOptions | ChangeEventStatus | undefined,
): ChangeEventStatusDetail {
  if (enumOrDetail === undefined) {
    return newChangeEventStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ChangeEventStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfChangeEventStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as ChangeEventStatusDetail;
  } else {
    return newChangeEventStatusDetail({
      code: enumOrDetail as ChangeEventStatus,
      name: enumDetailNameOfChangeEventStatus[enumOrDetail as ChangeEventStatus],
    });
  }
}

function enumOrDetailOrNullOfChangeEventStatus(
  enumOrDetail: ChangeEventStatusDetailOptions | ChangeEventStatus | undefined | null,
): ChangeEventStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfChangeEventStatus(enumOrDetail);
}

const enumDetailNameOfChangeEventBudgetPhase = { PREBID: "Prebid", AWARDED: "Awarded", REVISED: "Revised" };

function enumOrDetailOfChangeEventBudgetPhase(
  enumOrDetail: ChangeEventBudgetPhaseDetailOptions | ChangeEventBudgetPhase | undefined,
): ChangeEventBudgetPhaseDetail {
  if (enumOrDetail === undefined) {
    return newChangeEventBudgetPhaseDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ChangeEventBudgetPhaseDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfChangeEventBudgetPhase[enumOrDetail.code!],
      ...enumOrDetail,
    } as ChangeEventBudgetPhaseDetail;
  } else {
    return newChangeEventBudgetPhaseDetail({
      code: enumOrDetail as ChangeEventBudgetPhase,
      name: enumDetailNameOfChangeEventBudgetPhase[enumOrDetail as ChangeEventBudgetPhase],
    });
  }
}

function enumOrDetailOrNullOfChangeEventBudgetPhase(
  enumOrDetail: ChangeEventBudgetPhaseDetailOptions | ChangeEventBudgetPhase | undefined | null,
): ChangeEventBudgetPhaseDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfChangeEventBudgetPhase(enumOrDetail);
}

const enumDetailNameOfChangeEventType = {
  INTERNAL: "Internal",
  EXTERNAL: "External",
  BUDGET_REALLOCATION: "Budget reallocation",
};

function enumOrDetailOfChangeEventType(
  enumOrDetail: ChangeEventTypeDetailOptions | ChangeEventType | undefined,
): ChangeEventTypeDetail {
  if (enumOrDetail === undefined) {
    return newChangeEventTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ChangeEventTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfChangeEventType[enumOrDetail.code!],
      ...enumOrDetail,
    } as ChangeEventTypeDetail;
  } else {
    return newChangeEventTypeDetail({
      code: enumOrDetail as ChangeEventType,
      name: enumDetailNameOfChangeEventType[enumOrDetail as ChangeEventType],
    });
  }
}

function enumOrDetailOrNullOfChangeEventType(
  enumOrDetail: ChangeEventTypeDetailOptions | ChangeEventType | undefined | null,
): ChangeEventTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfChangeEventType(enumOrDetail);
}

const enumDetailNameOfProjectReadyPlanConfigOrientation = { LEFT: "Left", RIGHT: "Right" };

function enumOrDetailOfProjectReadyPlanConfigOrientation(
  enumOrDetail: ProjectReadyPlanConfigOrientationDetailOptions | ProjectReadyPlanConfigOrientation | undefined,
): ProjectReadyPlanConfigOrientationDetail {
  if (enumOrDetail === undefined) {
    return newProjectReadyPlanConfigOrientationDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ProjectReadyPlanConfigOrientationDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfProjectReadyPlanConfigOrientation[enumOrDetail.code!],
      ...enumOrDetail,
    } as ProjectReadyPlanConfigOrientationDetail;
  } else {
    return newProjectReadyPlanConfigOrientationDetail({
      code: enumOrDetail as ProjectReadyPlanConfigOrientation,
      name: enumDetailNameOfProjectReadyPlanConfigOrientation[enumOrDetail as ProjectReadyPlanConfigOrientation],
    });
  }
}

function enumOrDetailOrNullOfProjectReadyPlanConfigOrientation(
  enumOrDetail: ProjectReadyPlanConfigOrientationDetailOptions | ProjectReadyPlanConfigOrientation | undefined | null,
): ProjectReadyPlanConfigOrientationDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfProjectReadyPlanConfigOrientation(enumOrDetail);
}

const enumDetailNameOfCostConfidence = { LOW: "Low", HIGH: "High", HARD_BID: "Hard bid" };

function enumOrDetailOfCostConfidence(
  enumOrDetail: CostConfidenceDetailOptions | CostConfidence | undefined,
): CostConfidenceDetail {
  if (enumOrDetail === undefined) {
    return newCostConfidenceDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "CostConfidenceDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfCostConfidence[enumOrDetail.code!],
      ...enumOrDetail,
    } as CostConfidenceDetail;
  } else {
    return newCostConfidenceDetail({
      code: enumOrDetail as CostConfidence,
      name: enumDetailNameOfCostConfidence[enumOrDetail as CostConfidence],
    });
  }
}

function enumOrDetailOrNullOfCostConfidence(
  enumOrDetail: CostConfidenceDetailOptions | CostConfidence | undefined | null,
): CostConfidenceDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfCostConfidence(enumOrDetail);
}

const enumDetailNameOfChangeEventLineItemType = { ADD: "Add", MODIFY: "Modify", CUTOFF: "Cutoff" };

function enumOrDetailOfChangeEventLineItemType(
  enumOrDetail: ChangeEventLineItemTypeDetailOptions | ChangeEventLineItemType | undefined,
): ChangeEventLineItemTypeDetail {
  if (enumOrDetail === undefined) {
    return newChangeEventLineItemTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ChangeEventLineItemTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfChangeEventLineItemType[enumOrDetail.code!],
      ...enumOrDetail,
    } as ChangeEventLineItemTypeDetail;
  } else {
    return newChangeEventLineItemTypeDetail({
      code: enumOrDetail as ChangeEventLineItemType,
      name: enumDetailNameOfChangeEventLineItemType[enumOrDetail as ChangeEventLineItemType],
    });
  }
}

function enumOrDetailOrNullOfChangeEventLineItemType(
  enumOrDetail: ChangeEventLineItemTypeDetailOptions | ChangeEventLineItemType | undefined | null,
): ChangeEventLineItemTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfChangeEventLineItemType(enumOrDetail);
}

const enumDetailNameOfChangeRequestPriority = {
  LOW: "Low",
  MEDIUM: "Medium",
  HIGH: "High",
  URGENT: "Urgent",
  EXPEDITED: "Expedited",
};

function enumOrDetailOfChangeRequestPriority(
  enumOrDetail: ChangeRequestPriorityDetailOptions | ChangeRequestPriority | undefined,
): ChangeRequestPriorityDetail {
  if (enumOrDetail === undefined) {
    return newChangeRequestPriorityDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ChangeRequestPriorityDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfChangeRequestPriority[enumOrDetail.code!],
      ...enumOrDetail,
    } as ChangeRequestPriorityDetail;
  } else {
    return newChangeRequestPriorityDetail({
      code: enumOrDetail as ChangeRequestPriority,
      name: enumDetailNameOfChangeRequestPriority[enumOrDetail as ChangeRequestPriority],
    });
  }
}

function enumOrDetailOrNullOfChangeRequestPriority(
  enumOrDetail: ChangeRequestPriorityDetailOptions | ChangeRequestPriority | undefined | null,
): ChangeRequestPriorityDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfChangeRequestPriority(enumOrDetail);
}

const enumDetailNameOfChangeRequestSource = {
  NA: "Na",
  VALUE_ENGINEERING: "Value engineering",
  UP_SPECING: "Up specing",
  CUSTOMER_REQUEST_PERSONALIZATION: "Customer request personalization",
  FIELD_DIRECTIVE: "Field directive",
  FRAME_WALK_ADJUSTMENTS: "Frame walk adjustments",
  PROVIDER_UPDATE: "Provider update",
  INTERNAL_SALES_FEEDBACK: "Internal sales feedback",
  BOYL_CUSTOMER_REQUEST_PERSONALIZATION: "Boyl customer request personalization",
  PRODUCT_REFRESH: "Product refresh",
  INTERNAL_DESIGN_FEEDBACK: "Internal design feedback",
  FEE_BUILD_PROJECT_CHANGE: "Fee build project change",
};

function enumOrDetailOfChangeRequestSource(
  enumOrDetail: ChangeRequestSourceDetailOptions | ChangeRequestSource | undefined,
): ChangeRequestSourceDetail {
  if (enumOrDetail === undefined) {
    return newChangeRequestSourceDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ChangeRequestSourceDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfChangeRequestSource[enumOrDetail.code!],
      ...enumOrDetail,
    } as ChangeRequestSourceDetail;
  } else {
    return newChangeRequestSourceDetail({
      code: enumOrDetail as ChangeRequestSource,
      name: enumDetailNameOfChangeRequestSource[enumOrDetail as ChangeRequestSource],
    });
  }
}

function enumOrDetailOrNullOfChangeRequestSource(
  enumOrDetail: ChangeRequestSourceDetailOptions | ChangeRequestSource | undefined | null,
): ChangeRequestSourceDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfChangeRequestSource(enumOrDetail);
}

const enumDetailNameOfChangeRequestStatus = {
  NEEDS_REVIEW: "Needs review",
  READY_FOR_REVIEW: "Ready for review",
  READY_FOR_APPROVAL: "Ready for approval",
  APPROVED: "Approved",
  DENIED: "Denied",
  COMPLETED: "Completed",
  REVERSED: "Reversed",
  BLOCKED: "Blocked",
};

function enumOrDetailOfChangeRequestStatus(
  enumOrDetail: ChangeRequestStatusDetailOptions | ChangeRequestStatus | undefined,
): ChangeRequestStatusDetail {
  if (enumOrDetail === undefined) {
    return newChangeRequestStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ChangeRequestStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfChangeRequestStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as ChangeRequestStatusDetail;
  } else {
    return newChangeRequestStatusDetail({
      code: enumOrDetail as ChangeRequestStatus,
      name: enumDetailNameOfChangeRequestStatus[enumOrDetail as ChangeRequestStatus],
    });
  }
}

function enumOrDetailOrNullOfChangeRequestStatus(
  enumOrDetail: ChangeRequestStatusDetailOptions | ChangeRequestStatus | undefined | null,
): ChangeRequestStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfChangeRequestStatus(enumOrDetail);
}

const enumDetailNameOfChangeRequestAssetPlatform = {
  BLUEPRINT: "Blueprint",
  SALESFORCE: "Salesforce",
  UNDERWRITING_APP: "Underwriting app",
  MLS: "Mls",
  ZILLOW: "Zillow",
  GDRIVE: "Gdrive",
  FIGMA: "Figma",
  PHYSICAL_COLATERAL: "Physical colateral",
  GOOGLE_SLIDES: "Google slides",
  GOOGLE_SHEET: "Google sheet",
  CHECKOUT: "Checkout",
  AIRTABLE: "Airtable",
  HOMEBOUND_COM: "Homebound com",
  LYONELANE_COM: "Lyonelane com",
  AIR: "Air",
};

function enumOrDetailOfChangeRequestAssetPlatform(
  enumOrDetail: ChangeRequestAssetPlatformDetailOptions | ChangeRequestAssetPlatform | undefined,
): ChangeRequestAssetPlatformDetail {
  if (enumOrDetail === undefined) {
    return newChangeRequestAssetPlatformDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ChangeRequestAssetPlatformDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfChangeRequestAssetPlatform[enumOrDetail.code!],
      ...enumOrDetail,
    } as ChangeRequestAssetPlatformDetail;
  } else {
    return newChangeRequestAssetPlatformDetail({
      code: enumOrDetail as ChangeRequestAssetPlatform,
      name: enumDetailNameOfChangeRequestAssetPlatform[enumOrDetail as ChangeRequestAssetPlatform],
    });
  }
}

function enumOrDetailOrNullOfChangeRequestAssetPlatform(
  enumOrDetail: ChangeRequestAssetPlatformDetailOptions | ChangeRequestAssetPlatform | undefined | null,
): ChangeRequestAssetPlatformDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfChangeRequestAssetPlatform(enumOrDetail);
}

const enumDetailNameOfSystemChangeRequestAsset = {
  PANDA_DOC: "Panda doc",
  UPDATE_CLIENT_AND_CONTRACT: "Update client and contract",
  CHANGE_EVENT: "Change event",
};

function enumOrDetailOfSystemChangeRequestAsset(
  enumOrDetail: SystemChangeRequestAssetDetailOptions | SystemChangeRequestAsset | undefined,
): SystemChangeRequestAssetDetail {
  if (enumOrDetail === undefined) {
    return newSystemChangeRequestAssetDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "SystemChangeRequestAssetDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfSystemChangeRequestAsset[enumOrDetail.code!],
      ...enumOrDetail,
    } as SystemChangeRequestAssetDetail;
  } else {
    return newSystemChangeRequestAssetDetail({
      code: enumOrDetail as SystemChangeRequestAsset,
      name: enumDetailNameOfSystemChangeRequestAsset[enumOrDetail as SystemChangeRequestAsset],
    });
  }
}

function enumOrDetailOrNullOfSystemChangeRequestAsset(
  enumOrDetail: SystemChangeRequestAssetDetailOptions | SystemChangeRequestAsset | undefined | null,
): SystemChangeRequestAssetDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfSystemChangeRequestAsset(enumOrDetail);
}

const enumDetailNameOfToDoStatus = {
  BACKLOG: "Backlog",
  UP_NEXT: "Up next",
  IN_PROGRESS: "In progress",
  COMPLETE: "Complete",
};

function enumOrDetailOfToDoStatus(enumOrDetail: ToDoStatusDetailOptions | ToDoStatus | undefined): ToDoStatusDetail {
  if (enumOrDetail === undefined) {
    return newToDoStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ToDoStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfToDoStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as ToDoStatusDetail;
  } else {
    return newToDoStatusDetail({
      code: enumOrDetail as ToDoStatus,
      name: enumDetailNameOfToDoStatus[enumOrDetail as ToDoStatus],
    });
  }
}

function enumOrDetailOrNullOfToDoStatus(
  enumOrDetail: ToDoStatusDetailOptions | ToDoStatus | undefined | null,
): ToDoStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfToDoStatus(enumOrDetail);
}

const enumDetailNameOfToDoType = {
  SUBMITTALS: "Submittals",
  JOB_LIST: "Job list",
  SK_ASI: "Sk asi",
  RFI_QUESTIONS: "Rfi questions",
  MEETING_NOTES: "Meeting notes",
  PURCHASING: "Purchasing",
  DESIGN: "Design",
  REVIEWS: "Reviews",
  FINANCE: "Finance",
  GENERAL: "General",
  PRODUCT_OPS: "Product ops",
  PUNCH_LIST: "Punch list",
  WARRANTY: "Warranty",
  INSPECTION: "Inspection",
  DELIVERY: "Delivery",
  PRODUCT_FEEDBACK: "Product feedback",
  SCHEDULE_REVIEW: "Schedule review",
};

function enumOrDetailOfToDoType(enumOrDetail: ToDoTypeDetailOptions | ToDoType | undefined): ToDoTypeDetail {
  if (enumOrDetail === undefined) {
    return newToDoTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ToDoTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfToDoType[enumOrDetail.code!],
      ...enumOrDetail,
    } as ToDoTypeDetail;
  } else {
    return newToDoTypeDetail({
      code: enumOrDetail as ToDoType,
      name: enumDetailNameOfToDoType[enumOrDetail as ToDoType],
    });
  }
}

function enumOrDetailOrNullOfToDoType(
  enumOrDetail: ToDoTypeDetailOptions | ToDoType | undefined | null,
): ToDoTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfToDoType(enumOrDetail);
}

const enumDetailNameOfChangeRequestToDoType = {
  INITIAL_REVIEW: "Initial review",
  IMPACT_ESTIMATE: "Impact estimate",
  IMPLEMENTATION: "Implementation",
  IMPLEMENTATION_REVIEW: "Implementation review",
};

function enumOrDetailOfChangeRequestToDoType(
  enumOrDetail: ChangeRequestToDoTypeDetailOptions | ChangeRequestToDoType | undefined,
): ChangeRequestToDoTypeDetail {
  if (enumOrDetail === undefined) {
    return newChangeRequestToDoTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ChangeRequestToDoTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfChangeRequestToDoType[enumOrDetail.code!],
      ...enumOrDetail,
    } as ChangeRequestToDoTypeDetail;
  } else {
    return newChangeRequestToDoTypeDetail({
      code: enumOrDetail as ChangeRequestToDoType,
      name: enumDetailNameOfChangeRequestToDoType[enumOrDetail as ChangeRequestToDoType],
    });
  }
}

function enumOrDetailOrNullOfChangeRequestToDoType(
  enumOrDetail: ChangeRequestToDoTypeDetailOptions | ChangeRequestToDoType | undefined | null,
): ChangeRequestToDoTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfChangeRequestToDoType(enumOrDetail);
}

const enumDetailNameOfScopeMode = {
  NONE: "None",
  RELEASE_TO_TRADES: "Release to trades",
  FULL: "Full",
  BUDGET_SAFE: "Budget safe",
};

function enumOrDetailOfScopeMode(enumOrDetail: ScopeModeDetailOptions | ScopeMode | undefined): ScopeModeDetail {
  if (enumOrDetail === undefined) {
    return newScopeModeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ScopeModeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfScopeMode[enumOrDetail.code!],
      ...enumOrDetail,
    } as ScopeModeDetail;
  } else {
    return newScopeModeDetail({
      code: enumOrDetail as ScopeMode,
      name: enumDetailNameOfScopeMode[enumOrDetail as ScopeMode],
    });
  }
}

function enumOrDetailOrNullOfScopeMode(
  enumOrDetail: ScopeModeDetailOptions | ScopeMode | undefined | null,
): ScopeModeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfScopeMode(enumOrDetail);
}

const enumDetailNameOfTaskDeadlineType = { CUTOFF: "Cutoff", KEY_MILESTONE: "Key milestone" };

function enumOrDetailOfTaskDeadlineType(
  enumOrDetail: TaskDeadlineTypeDetailOptions | TaskDeadlineType | undefined,
): TaskDeadlineTypeDetail {
  if (enumOrDetail === undefined) {
    return newTaskDeadlineTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "TaskDeadlineTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfTaskDeadlineType[enumOrDetail.code!],
      ...enumOrDetail,
    } as TaskDeadlineTypeDetail;
  } else {
    return newTaskDeadlineTypeDetail({
      code: enumOrDetail as TaskDeadlineType,
      name: enumDetailNameOfTaskDeadlineType[enumOrDetail as TaskDeadlineType],
    });
  }
}

function enumOrDetailOrNullOfTaskDeadlineType(
  enumOrDetail: TaskDeadlineTypeDetailOptions | TaskDeadlineType | undefined | null,
): TaskDeadlineTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfTaskDeadlineType(enumOrDetail);
}

const enumDetailNameOfInvoiceStatus = {
  DRAFT: "Draft",
  REQUESTED: "Requested",
  CHANGES_REQUESTED: "Changes requested",
  APPROVED: "Approved",
  PAID: "Paid",
  REJECTED: "Rejected",
  VOID: "Void",
};

function enumOrDetailOfInvoiceStatus(
  enumOrDetail: InvoiceStatusDetailOptions | InvoiceStatus | undefined,
): InvoiceStatusDetail {
  if (enumOrDetail === undefined) {
    return newInvoiceStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "InvoiceStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfInvoiceStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as InvoiceStatusDetail;
  } else {
    return newInvoiceStatusDetail({
      code: enumOrDetail as InvoiceStatus,
      name: enumDetailNameOfInvoiceStatus[enumOrDetail as InvoiceStatus],
    });
  }
}

function enumOrDetailOrNullOfInvoiceStatus(
  enumOrDetail: InvoiceStatusDetailOptions | InvoiceStatus | undefined | null,
): InvoiceStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfInvoiceStatus(enumOrDetail);
}

const enumDetailNameOfInvoiceType = {
  PERCENTAGE_OF_COMPLETION: "Percentage of completion",
  DOWN_PAYMENT: "Down payment",
  STANDARD: "Standard",
};

function enumOrDetailOfInvoiceType(
  enumOrDetail: InvoiceTypeDetailOptions | InvoiceType | undefined,
): InvoiceTypeDetail {
  if (enumOrDetail === undefined) {
    return newInvoiceTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "InvoiceTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfInvoiceType[enumOrDetail.code!],
      ...enumOrDetail,
    } as InvoiceTypeDetail;
  } else {
    return newInvoiceTypeDetail({
      code: enumOrDetail as InvoiceType,
      name: enumDetailNameOfInvoiceType[enumOrDetail as InvoiceType],
    });
  }
}

function enumOrDetailOrNullOfInvoiceType(
  enumOrDetail: InvoiceTypeDetailOptions | InvoiceType | undefined | null,
): InvoiceTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfInvoiceType(enumOrDetail);
}

const enumDetailNameOfInvoiceSource = { AUTO: "Auto", MANUAL: "Manual" };

function enumOrDetailOfInvoiceSource(
  enumOrDetail: InvoiceSourceDetailOptions | InvoiceSource | undefined,
): InvoiceSourceDetail {
  if (enumOrDetail === undefined) {
    return newInvoiceSourceDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "InvoiceSourceDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfInvoiceSource[enumOrDetail.code!],
      ...enumOrDetail,
    } as InvoiceSourceDetail;
  } else {
    return newInvoiceSourceDetail({
      code: enumOrDetail as InvoiceSource,
      name: enumDetailNameOfInvoiceSource[enumOrDetail as InvoiceSource],
    });
  }
}

function enumOrDetailOrNullOfInvoiceSource(
  enumOrDetail: InvoiceSourceDetailOptions | InvoiceSource | undefined | null,
): InvoiceSourceDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfInvoiceSource(enumOrDetail);
}

const enumDetailNameOfStage = {
  PRE_CON_PLANNING: "Pre con planning",
  PRE_CON_EXECUTION: "Pre con execution",
  CONSTRUCTION: "Construction",
  DEVELOPMENT: "Development",
};

function enumOrDetailOfStage(enumOrDetail: StageDetailOptions | Stage | undefined): StageDetail {
  if (enumOrDetail === undefined) {
    return newStageDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "StageDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfStage[enumOrDetail.code!],
      ...enumOrDetail,
    } as StageDetail;
  } else {
    return newStageDetail({ code: enumOrDetail as Stage, name: enumDetailNameOfStage[enumOrDetail as Stage] });
  }
}

function enumOrDetailOrNullOfStage(enumOrDetail: StageDetailOptions | Stage | undefined | null): StageDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfStage(enumOrDetail);
}

const enumDetailNameOfProjectStatus = {
  ACTIVE: "Active",
  COMPLETED: "Completed",
  CLOSED: "Closed",
  HOLD: "Hold",
  UNDER_WARRANTY: "Under warranty",
};

function enumOrDetailOfProjectStatus(
  enumOrDetail: ProjectStatusDetailOptions | ProjectStatus | undefined,
): ProjectStatusDetail {
  if (enumOrDetail === undefined) {
    return newProjectStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ProjectStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfProjectStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as ProjectStatusDetail;
  } else {
    return newProjectStatusDetail({
      code: enumOrDetail as ProjectStatus,
      name: enumDetailNameOfProjectStatus[enumOrDetail as ProjectStatus],
    });
  }
}

function enumOrDetailOrNullOfProjectStatus(
  enumOrDetail: ProjectStatusDetailOptions | ProjectStatus | undefined | null,
): ProjectStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfProjectStatus(enumOrDetail);
}

const enumDetailNameOfLotType = { BOYL: "Boyl", BOOL: "Bool", HBL: "Hbl", BTR: "Btr", FEE: "Fee" };

function enumOrDetailOfLotType(enumOrDetail: LotTypeDetailOptions | LotType | undefined): LotTypeDetail {
  if (enumOrDetail === undefined) {
    return newLotTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "LotTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfLotType[enumOrDetail.code!],
      ...enumOrDetail,
    } as LotTypeDetail;
  } else {
    return newLotTypeDetail({ code: enumOrDetail as LotType, name: enumDetailNameOfLotType[enumOrDetail as LotType] });
  }
}

function enumOrDetailOrNullOfLotType(
  enumOrDetail: LotTypeDetailOptions | LotType | undefined | null,
): LotTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfLotType(enumOrDetail);
}

const enumDetailNameOfCommunityType = { INFILL: "Infill", SUBURBAN: "Suburban" };

function enumOrDetailOfCommunityType(
  enumOrDetail: CommunityTypeDetailOptions | CommunityType | undefined,
): CommunityTypeDetail {
  if (enumOrDetail === undefined) {
    return newCommunityTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "CommunityTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfCommunityType[enumOrDetail.code!],
      ...enumOrDetail,
    } as CommunityTypeDetail;
  } else {
    return newCommunityTypeDetail({
      code: enumOrDetail as CommunityType,
      name: enumDetailNameOfCommunityType[enumOrDetail as CommunityType],
    });
  }
}

function enumOrDetailOrNullOfCommunityType(
  enumOrDetail: CommunityTypeDetailOptions | CommunityType | undefined | null,
): CommunityTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfCommunityType(enumOrDetail);
}

const enumDetailNameOfReadyPlanType = { SFH: "Sfh", ADU: "Adu", MFU: "Mfu" };

function enumOrDetailOfReadyPlanType(
  enumOrDetail: ReadyPlanTypeDetailOptions | ReadyPlanType | undefined,
): ReadyPlanTypeDetail {
  if (enumOrDetail === undefined) {
    return newReadyPlanTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ReadyPlanTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfReadyPlanType[enumOrDetail.code!],
      ...enumOrDetail,
    } as ReadyPlanTypeDetail;
  } else {
    return newReadyPlanTypeDetail({
      code: enumOrDetail as ReadyPlanType,
      name: enumDetailNameOfReadyPlanType[enumOrDetail as ReadyPlanType],
    });
  }
}

function enumOrDetailOrNullOfReadyPlanType(
  enumOrDetail: ReadyPlanTypeDetailOptions | ReadyPlanType | undefined | null,
): ReadyPlanTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfReadyPlanType(enumOrDetail);
}

const enumDetailNameOfSuburbanAssetCategory = {
  INVENTORY: "Inventory",
  MODEL_HOME: "Model home",
  BUILD_TO_ORDER: "Build to order",
};

function enumOrDetailOfSuburbanAssetCategory(
  enumOrDetail: SuburbanAssetCategoryDetailOptions | SuburbanAssetCategory | undefined,
): SuburbanAssetCategoryDetail {
  if (enumOrDetail === undefined) {
    return newSuburbanAssetCategoryDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "SuburbanAssetCategoryDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfSuburbanAssetCategory[enumOrDetail.code!],
      ...enumOrDetail,
    } as SuburbanAssetCategoryDetail;
  } else {
    return newSuburbanAssetCategoryDetail({
      code: enumOrDetail as SuburbanAssetCategory,
      name: enumDetailNameOfSuburbanAssetCategory[enumOrDetail as SuburbanAssetCategory],
    });
  }
}

function enumOrDetailOrNullOfSuburbanAssetCategory(
  enumOrDetail: SuburbanAssetCategoryDetailOptions | SuburbanAssetCategory | undefined | null,
): SuburbanAssetCategoryDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfSuburbanAssetCategory(enumOrDetail);
}

const enumDetailNameOfLotSalesStatus = {
  NOT_AVAILABLE: "Not available",
  AVAILABLE: "Available",
  MODEL_HOME: "Model home",
  RESERVED: "Reserved",
  SOLD: "Sold",
};

function enumOrDetailOfLotSalesStatus(
  enumOrDetail: LotSalesStatusDetailOptions | LotSalesStatus | undefined,
): LotSalesStatusDetail {
  if (enumOrDetail === undefined) {
    return newLotSalesStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "LotSalesStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfLotSalesStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as LotSalesStatusDetail;
  } else {
    return newLotSalesStatusDetail({
      code: enumOrDetail as LotSalesStatus,
      name: enumDetailNameOfLotSalesStatus[enumOrDetail as LotSalesStatus],
    });
  }
}

function enumOrDetailOrNullOfLotSalesStatus(
  enumOrDetail: LotSalesStatusDetailOptions | LotSalesStatus | undefined | null,
): LotSalesStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfLotSalesStatus(enumOrDetail);
}

const enumDetailNameOfBuyoutStatus = {
  NOT_BOUGHT_OUT: "Not bought out",
  BOUGHT_OUT: "Bought out",
  PARTIALLY_BOUGHT_OUT: "Partially bought out",
};

function enumOrDetailOfBuyoutStatus(
  enumOrDetail: BuyoutStatusDetailOptions | BuyoutStatus | undefined,
): BuyoutStatusDetail {
  if (enumOrDetail === undefined) {
    return newBuyoutStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "BuyoutStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfBuyoutStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as BuyoutStatusDetail;
  } else {
    return newBuyoutStatusDetail({
      code: enumOrDetail as BuyoutStatus,
      name: enumDetailNameOfBuyoutStatus[enumOrDetail as BuyoutStatus],
    });
  }
}

function enumOrDetailOrNullOfBuyoutStatus(
  enumOrDetail: BuyoutStatusDetailOptions | BuyoutStatus | undefined | null,
): BuyoutStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfBuyoutStatus(enumOrDetail);
}

const enumDetailNameOfEstimateStatus = { DRAFT: "Draft", ACCEPTED: "Accepted", REJECTED: "Rejected" };

function enumOrDetailOfEstimateStatus(
  enumOrDetail: EstimateStatusDetailOptions | EstimateStatus | undefined,
): EstimateStatusDetail {
  if (enumOrDetail === undefined) {
    return newEstimateStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "EstimateStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfEstimateStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as EstimateStatusDetail;
  } else {
    return newEstimateStatusDetail({
      code: enumOrDetail as EstimateStatus,
      name: enumDetailNameOfEstimateStatus[enumOrDetail as EstimateStatus],
    });
  }
}

function enumOrDetailOrNullOfEstimateStatus(
  enumOrDetail: EstimateStatusDetailOptions | EstimateStatus | undefined | null,
): EstimateStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfEstimateStatus(enumOrDetail);
}

const enumDetailNameOfEstimateType = { PRELIMINARY: "Preliminary", FINAL: "Final" };

function enumOrDetailOfEstimateType(
  enumOrDetail: EstimateTypeDetailOptions | EstimateType | undefined,
): EstimateTypeDetail {
  if (enumOrDetail === undefined) {
    return newEstimateTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "EstimateTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfEstimateType[enumOrDetail.code!],
      ...enumOrDetail,
    } as EstimateTypeDetail;
  } else {
    return newEstimateTypeDetail({
      code: enumOrDetail as EstimateType,
      name: enumDetailNameOfEstimateType[enumOrDetail as EstimateType],
    });
  }
}

function enumOrDetailOrNullOfEstimateType(
  enumOrDetail: EstimateTypeDetailOptions | EstimateType | undefined | null,
): EstimateTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfEstimateType(enumOrDetail);
}

const enumDetailNameOfCommitmentStatus = {
  DRAFT: "Draft",
  UPLOADED: "Uploaded",
  SENT: "Sent",
  SIGNED: "Signed",
  VOIDED: "Voided",
  PARTIALLY_SIGNED: "Partially signed",
};

function enumOrDetailOfCommitmentStatus(
  enumOrDetail: CommitmentStatusDetailOptions | CommitmentStatus | undefined,
): CommitmentStatusDetail {
  if (enumOrDetail === undefined) {
    return newCommitmentStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "CommitmentStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfCommitmentStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as CommitmentStatusDetail;
  } else {
    return newCommitmentStatusDetail({
      code: enumOrDetail as CommitmentStatus,
      name: enumDetailNameOfCommitmentStatus[enumOrDetail as CommitmentStatus],
    });
  }
}

function enumOrDetailOrNullOfCommitmentStatus(
  enumOrDetail: CommitmentStatusDetailOptions | CommitmentStatus | undefined | null,
): CommitmentStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfCommitmentStatus(enumOrDetail);
}

const enumDetailNameOfDevelopmentCommitmentType = {
  MATERIALS: "Materials",
  LABOR: "Labor",
  LABOR_AND_MATERIALS: "Labor and materials",
};

function enumOrDetailOfDevelopmentCommitmentType(
  enumOrDetail: DevelopmentCommitmentTypeDetailOptions | DevelopmentCommitmentType | undefined,
): DevelopmentCommitmentTypeDetail {
  if (enumOrDetail === undefined) {
    return newDevelopmentCommitmentTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "DevelopmentCommitmentTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfDevelopmentCommitmentType[enumOrDetail.code!],
      ...enumOrDetail,
    } as DevelopmentCommitmentTypeDetail;
  } else {
    return newDevelopmentCommitmentTypeDetail({
      code: enumOrDetail as DevelopmentCommitmentType,
      name: enumDetailNameOfDevelopmentCommitmentType[enumOrDetail as DevelopmentCommitmentType],
    });
  }
}

function enumOrDetailOrNullOfDevelopmentCommitmentType(
  enumOrDetail: DevelopmentCommitmentTypeDetailOptions | DevelopmentCommitmentType | undefined | null,
): DevelopmentCommitmentTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfDevelopmentCommitmentType(enumOrDetail);
}

const enumDetailNameOfCommitmentType = { PURCHASE_ORDER: "Purchase order", SUBCONTRACT: "Subcontract" };

function enumOrDetailOfCommitmentType(
  enumOrDetail: CommitmentTypeDetailOptions | CommitmentType | undefined,
): CommitmentTypeDetail {
  if (enumOrDetail === undefined) {
    return newCommitmentTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "CommitmentTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfCommitmentType[enumOrDetail.code!],
      ...enumOrDetail,
    } as CommitmentTypeDetail;
  } else {
    return newCommitmentTypeDetail({
      code: enumOrDetail as CommitmentType,
      name: enumDetailNameOfCommitmentType[enumOrDetail as CommitmentType],
    });
  }
}

function enumOrDetailOrNullOfCommitmentType(
  enumOrDetail: CommitmentTypeDetailOptions | CommitmentType | undefined | null,
): CommitmentTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfCommitmentType(enumOrDetail);
}

const enumDetailNameOfDocumentType = {
  PRECON_AGREEMENT: "Precon agreement",
  CONSTRUCTION_AGREEMENT: "Construction agreement",
  PURCHASE_ORDER: "Purchase order",
  SUBCONTRACT: "Subcontract",
  PRECON_AGREEMENT_CHANGE_ORDER: "Precon agreement change order",
  CONSTRUCTION_AGREEMENT_CHANGE_ORDER: "Construction agreement change order",
  PURCHASE_ORDER_CHANGE_ORDER: "Purchase order change order",
  SUBCONTRACT_CHANGE_ORDER: "Subcontract change order",
  BILL: "Bill",
  INVOICE: "Invoice",
  MEETING_NOTE: "Meeting note",
  INSURANCE: "Insurance",
  SALES: "Sales",
  ARCHITECTURE_AND_ENGINEERING: "Architecture and engineering",
  SITE_REPORT: "Site report",
  CORRESPONDENCE: "Correspondence",
  GENERAL: "General",
  PERMITTING: "Permitting",
  APPROVED_PLAN: "Approved plan",
  PHOTO: "Photo",
  DESIGN_STUDIO: "Design studio",
  DEVELOPMENT_COMMITMENT: "Development commitment",
  BID_CONTRACT: "Bid contract",
  EXPENSE: "Expense",
  WORK_AUTHORIZATION: "Work authorization",
  PRICE_AGREEMENT_CHANGE_ORDER: "Price agreement change order",
  PRICE_AGREEMENT_BID_CONTRACT_REVISION: "Price agreement bid contract revision",
  PRICE_AGREEMENT_DEVELOPMENT_COMMITMENT: "Price agreement development commitment",
  PRICE_AGREEMENT_COMMITMENT: "Price agreement commitment",
  PLAN: "Plan",
  DRAWING: "Drawing",
  FINISH_SCHEDULE: "Finish schedule",
  BOUNDARY_SURVEYS: "Boundary surveys",
  TOPO_SURVEYS: "Topo surveys",
  GEOTECH_REPORT_SOILS_REPORT: "Geotech report soils report",
  ELEVATION_CERTIFICATE: "Elevation certificate",
  MISCELLANEOUS_GENERAL: "Miscellaneous general",
  LEGAL: "Legal",
  CERTIFICATE_OF_OCCUPANCY: "Certificate of occupancy",
  FLOOD_INSURANCE_POLICY: "Flood insurance policy",
  PRE_BUILD_APPRAISAL: "Pre build appraisal",
  PURCHASE_AGREEMENT: "Purchase agreement",
  PURCHASE_AGREEMENT_AMENDMENT_LOT_ACQ: "Purchase agreement amendment lot acq",
  SETTLEMENT_STATEMENT_PRELIMINARY: "Settlement statement preliminary",
  SETTLEMENT_STATEMENT_FINAL: "Settlement statement final",
  DEED: "Deed",
  RECORDED_DEED: "Recorded deed",
  TITLE_INSURANCE_POLICY: "Title insurance policy",
  PROPERTY_SURVEY: "Property survey",
  EARNEST_MONEY_RECEIPT_LOT_ACQ: "Earnest money receipt lot acq",
  BUILDING_PERMIT: "Building permit",
  DEMO_PERMIT: "Demo permit",
  RETAINING_WALL_PERMIT: "Retaining wall permit",
  WATER_PERMIT: "Water permit",
  GRADING_PERMIT: "Grading permit",
  POOL_PERMIT: "Pool permit",
  VPO: "Vpo",
  PURCHASE_AGREEMENT_FINAL: "Purchase agreement final",
  PURCHASE_AGREEMENT_COUNTER_OFFER: "Purchase agreement counter offer",
  PURCHASE_AGREEMENT_AMENDMENT_SALES: "Purchase agreement amendment sales",
  PURCHASE_AGREEMENT_ADDENDUM: "Purchase agreement addendum",
  EARNEST_MONEY_RECEIPT_SALES: "Earnest money receipt sales",
  DISCLOSURES: "Disclosures",
  MISCELLANEOUS_SALES: "Miscellaneous sales",
  APPRAISAL_PRECON: "Appraisal precon",
  APPRAISAL_POST_COO: "Appraisal post coo",
  INSURANCE_HAZARD: "Insurance hazard",
  INSURANCE_BUILDERS_RISK: "Insurance builders risk",
  HOMEOWNER_ORIENTATION: "Homeowner orientation",
  LIEN_WAIVER: "Lien waiver",
  CHANGE_EVENT: "Change event",
  THIRD_PARTY_INSPECTION: "Third party inspection",
  CITY_INSPECTION: "City inspection",
  WARRANTY: "Warranty",
  RENDERING: "Rendering",
};

function enumOrDetailOfDocumentType(
  enumOrDetail: DocumentTypeDetailOptions | DocumentType | undefined,
): DocumentTypeDetail {
  if (enumOrDetail === undefined) {
    return newDocumentTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "DocumentTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfDocumentType[enumOrDetail.code!],
      ...enumOrDetail,
    } as DocumentTypeDetail;
  } else {
    return newDocumentTypeDetail({
      code: enumOrDetail as DocumentType,
      name: enumDetailNameOfDocumentType[enumOrDetail as DocumentType],
    });
  }
}

function enumOrDetailOrNullOfDocumentType(
  enumOrDetail: DocumentTypeDetailOptions | DocumentType | undefined | null,
): DocumentTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfDocumentType(enumOrDetail);
}

const enumDetailNameOfDocumentCategory = {
  CONTRACTUAL: "Contractual",
  PERMITS: "Permits",
  DESIGN: "Design",
  PROCUREMENT: "Procurement",
  ACCOUNTING: "Accounting",
  SALES_MARKETING: "Sales marketing",
  WARRANTY: "Warranty",
  ENGINEERING: "Engineering",
  GENERAL: "General",
  LOT_ACQUISITION: "Lot acquisition",
  VALUATION: "Valuation",
  INSURANCE: "Insurance",
  ASSET_MANAGEMENT: "Asset management",
};

function enumOrDetailOfDocumentCategory(
  enumOrDetail: DocumentCategoryDetailOptions | DocumentCategory | undefined,
): DocumentCategoryDetail {
  if (enumOrDetail === undefined) {
    return newDocumentCategoryDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "DocumentCategoryDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfDocumentCategory[enumOrDetail.code!],
      ...enumOrDetail,
    } as DocumentCategoryDetail;
  } else {
    return newDocumentCategoryDetail({
      code: enumOrDetail as DocumentCategory,
      name: enumDetailNameOfDocumentCategory[enumOrDetail as DocumentCategory],
    });
  }
}

function enumOrDetailOrNullOfDocumentCategory(
  enumOrDetail: DocumentCategoryDetailOptions | DocumentCategory | undefined | null,
): DocumentCategoryDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfDocumentCategory(enumOrDetail);
}

const enumDetailNameOfProductStatus = { DRAFT: "Draft", ACTIVE: "Active", ARCHIVED: "Archived" };

function enumOrDetailOfProductStatus(
  enumOrDetail: ProductStatusDetailOptions | ProductStatus | undefined,
): ProductStatusDetail {
  if (enumOrDetail === undefined) {
    return newProductStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ProductStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfProductStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as ProductStatusDetail;
  } else {
    return newProductStatusDetail({
      code: enumOrDetail as ProductStatus,
      name: enumDetailNameOfProductStatus[enumOrDetail as ProductStatus],
    });
  }
}

function enumOrDetailOrNullOfProductStatus(
  enumOrDetail: ProductStatusDetailOptions | ProductStatus | undefined | null,
): ProductStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfProductStatus(enumOrDetail);
}

const enumDetailNameOfPromotionStatus = { REQUESTED: "Requested", DENIED: "Denied", APPROVED: "Approved" };

function enumOrDetailOfPromotionStatus(
  enumOrDetail: PromotionStatusDetailOptions | PromotionStatus | undefined,
): PromotionStatusDetail {
  if (enumOrDetail === undefined) {
    return newPromotionStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "PromotionStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfPromotionStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as PromotionStatusDetail;
  } else {
    return newPromotionStatusDetail({
      code: enumOrDetail as PromotionStatus,
      name: enumDetailNameOfPromotionStatus[enumOrDetail as PromotionStatus],
    });
  }
}

function enumOrDetailOrNullOfPromotionStatus(
  enumOrDetail: PromotionStatusDetailOptions | PromotionStatus | undefined | null,
): PromotionStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfPromotionStatus(enumOrDetail);
}

const enumDetailNameOfScopeChangeType = {
  NONE: "None",
  ADD: "Add",
  REPLACE: "Replace",
  MINOR: "Minor",
  MAJOR: "Major",
  REMOVED: "Removed",
  SYSTEM: "System",
};

function enumOrDetailOfScopeChangeType(
  enumOrDetail: ScopeChangeTypeDetailOptions | ScopeChangeType | undefined,
): ScopeChangeTypeDetail {
  if (enumOrDetail === undefined) {
    return newScopeChangeTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ScopeChangeTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfScopeChangeType[enumOrDetail.code!],
      ...enumOrDetail,
    } as ScopeChangeTypeDetail;
  } else {
    return newScopeChangeTypeDetail({
      code: enumOrDetail as ScopeChangeType,
      name: enumDetailNameOfScopeChangeType[enumOrDetail as ScopeChangeType],
    });
  }
}

function enumOrDetailOrNullOfScopeChangeType(
  enumOrDetail: ScopeChangeTypeDetailOptions | ScopeChangeType | undefined | null,
): ScopeChangeTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfScopeChangeType(enumOrDetail);
}

const enumDetailNameOfJobLogNoteType = {
  DELAY: "Delay",
  DELIVERY: "Delivery",
  INCIDENT: "Incident",
  INJURY: "Injury",
  INSPECTION: "Inspection",
  ISSUE: "Issue",
  HOLIDAY: "Holiday",
  REQUEST_FOR_INFORMATION: "Request for information",
  TRADE_PARTNER_WORK: "Trade partner work",
  UPCOMING_ACTIVITY: "Upcoming activity",
  VISITOR: "Visitor",
  WARRANTY: "Warranty",
  WEATHER: "Weather",
  OTHER: "Other",
  CLIENT_COMMUNICATION: "Client communication",
  INTERNAL: "Internal",
  PRE_CON: "Pre con",
  AI_SUMMARY: "Ai summary",
};

function enumOrDetailOfJobLogNoteType(
  enumOrDetail: JobLogNoteTypeDetailOptions | JobLogNoteType | undefined,
): JobLogNoteTypeDetail {
  if (enumOrDetail === undefined) {
    return newJobLogNoteTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "JobLogNoteTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfJobLogNoteType[enumOrDetail.code!],
      ...enumOrDetail,
    } as JobLogNoteTypeDetail;
  } else {
    return newJobLogNoteTypeDetail({
      code: enumOrDetail as JobLogNoteType,
      name: enumDetailNameOfJobLogNoteType[enumOrDetail as JobLogNoteType],
    });
  }
}

function enumOrDetailOrNullOfJobLogNoteType(
  enumOrDetail: JobLogNoteTypeDetailOptions | JobLogNoteType | undefined | null,
): JobLogNoteTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfJobLogNoteType(enumOrDetail);
}

const enumDetailNameOfClientPlatform = { WEB: "Web", MOBILE: "Mobile" };

function enumOrDetailOfClientPlatform(
  enumOrDetail: ClientPlatformDetailOptions | ClientPlatform | undefined,
): ClientPlatformDetail {
  if (enumOrDetail === undefined) {
    return newClientPlatformDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ClientPlatformDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfClientPlatform[enumOrDetail.code!],
      ...enumOrDetail,
    } as ClientPlatformDetail;
  } else {
    return newClientPlatformDetail({
      code: enumOrDetail as ClientPlatform,
      name: enumDetailNameOfClientPlatform[enumOrDetail as ClientPlatform],
    });
  }
}

function enumOrDetailOrNullOfClientPlatform(
  enumOrDetail: ClientPlatformDetailOptions | ClientPlatform | undefined | null,
): ClientPlatformDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfClientPlatform(enumOrDetail);
}

const enumDetailNameOfTradePartnerAvailabilityRequestStatus = {
  WAITING: "Waiting",
  RESCHEDULE_NEEDED: "Reschedule needed",
  CONFIRMED: "Confirmed",
  CANCELED: "Canceled",
};

function enumOrDetailOfTradePartnerAvailabilityRequestStatus(
  enumOrDetail: TradePartnerAvailabilityRequestStatusDetailOptions | TradePartnerAvailabilityRequestStatus | undefined,
): TradePartnerAvailabilityRequestStatusDetail {
  if (enumOrDetail === undefined) {
    return newTradePartnerAvailabilityRequestStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "TradePartnerAvailabilityRequestStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfTradePartnerAvailabilityRequestStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as TradePartnerAvailabilityRequestStatusDetail;
  } else {
    return newTradePartnerAvailabilityRequestStatusDetail({
      code: enumOrDetail as TradePartnerAvailabilityRequestStatus,
      name:
        enumDetailNameOfTradePartnerAvailabilityRequestStatus[enumOrDetail as TradePartnerAvailabilityRequestStatus],
    });
  }
}

function enumOrDetailOrNullOfTradePartnerAvailabilityRequestStatus(
  enumOrDetail:
    | TradePartnerAvailabilityRequestStatusDetailOptions
    | TradePartnerAvailabilityRequestStatus
    | undefined
    | null,
): TradePartnerAvailabilityRequestStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfTradePartnerAvailabilityRequestStatus(enumOrDetail);
}

const enumDetailNameOfWarrantyTicketType = {
  ITEMS_OF_CONTINUANCE: "Items of continuance",
  THIRTY_DAY: "Thirty day",
  ONE_YEAR: "One year",
  TWO_YEAR: "Two year",
  TEN_YEAR: "Ten year",
};

function enumOrDetailOfWarrantyTicketType(
  enumOrDetail: WarrantyTicketTypeDetailOptions | WarrantyTicketType | undefined,
): WarrantyTicketTypeDetail {
  if (enumOrDetail === undefined) {
    return newWarrantyTicketTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "WarrantyTicketTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfWarrantyTicketType[enumOrDetail.code!],
      ...enumOrDetail,
    } as WarrantyTicketTypeDetail;
  } else {
    return newWarrantyTicketTypeDetail({
      code: enumOrDetail as WarrantyTicketType,
      name: enumDetailNameOfWarrantyTicketType[enumOrDetail as WarrantyTicketType],
    });
  }
}

function enumOrDetailOrNullOfWarrantyTicketType(
  enumOrDetail: WarrantyTicketTypeDetailOptions | WarrantyTicketType | undefined | null,
): WarrantyTicketTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfWarrantyTicketType(enumOrDetail);
}

const enumDetailNameOfWarrantyTicketStatus = {
  NOT_STARTED: "Not started",
  IN_PROGRESS: "In progress",
  CLOSED: "Closed",
};

function enumOrDetailOfWarrantyTicketStatus(
  enumOrDetail: WarrantyTicketStatusDetailOptions | WarrantyTicketStatus | undefined,
): WarrantyTicketStatusDetail {
  if (enumOrDetail === undefined) {
    return newWarrantyTicketStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "WarrantyTicketStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfWarrantyTicketStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as WarrantyTicketStatusDetail;
  } else {
    return newWarrantyTicketStatusDetail({
      code: enumOrDetail as WarrantyTicketStatus,
      name: enumDetailNameOfWarrantyTicketStatus[enumOrDetail as WarrantyTicketStatus],
    });
  }
}

function enumOrDetailOrNullOfWarrantyTicketStatus(
  enumOrDetail: WarrantyTicketStatusDetailOptions | WarrantyTicketStatus | undefined | null,
): WarrantyTicketStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfWarrantyTicketStatus(enumOrDetail);
}

const enumDetailNameOfContractType = {
  FIXED: "Fixed",
  COST_PLUS: "Cost plus",
  BUDGET_REALLOCATION: "Budget reallocation",
};

function enumOrDetailOfContractType(
  enumOrDetail: ContractTypeDetailOptions | ContractType | undefined,
): ContractTypeDetail {
  if (enumOrDetail === undefined) {
    return newContractTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ContractTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfContractType[enumOrDetail.code!],
      ...enumOrDetail,
    } as ContractTypeDetail;
  } else {
    return newContractTypeDetail({
      code: enumOrDetail as ContractType,
      name: enumDetailNameOfContractType[enumOrDetail as ContractType],
    });
  }
}

function enumOrDetailOrNullOfContractType(
  enumOrDetail: ContractTypeDetailOptions | ContractType | undefined | null,
): ContractTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfContractType(enumOrDetail);
}

const enumDetailNameOfReadyPlanStatus = { DRAFT: "Draft", ARCHIVED: "Archived", ACTIVE: "Active" };

function enumOrDetailOfReadyPlanStatus(
  enumOrDetail: ReadyPlanStatusDetailOptions | ReadyPlanStatus | undefined,
): ReadyPlanStatusDetail {
  if (enumOrDetail === undefined) {
    return newReadyPlanStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ReadyPlanStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfReadyPlanStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as ReadyPlanStatusDetail;
  } else {
    return newReadyPlanStatusDetail({
      code: enumOrDetail as ReadyPlanStatus,
      name: enumDetailNameOfReadyPlanStatus[enumOrDetail as ReadyPlanStatus],
    });
  }
}

function enumOrDetailOrNullOfReadyPlanStatus(
  enumOrDetail: ReadyPlanStatusDetailOptions | ReadyPlanStatus | undefined | null,
): ReadyPlanStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfReadyPlanStatus(enumOrDetail);
}

const enumDetailNameOfGlobalOptionStatus = {
  ACTIVE: "Active",
  ARCHIVED: "Archived",
  PENDING_APPROVAL: "Pending approval",
};

function enumOrDetailOfGlobalOptionStatus(
  enumOrDetail: GlobalOptionStatusDetailOptions | GlobalOptionStatus | undefined,
): GlobalOptionStatusDetail {
  if (enumOrDetail === undefined) {
    return newGlobalOptionStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "GlobalOptionStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfGlobalOptionStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as GlobalOptionStatusDetail;
  } else {
    return newGlobalOptionStatusDetail({
      code: enumOrDetail as GlobalOptionStatus,
      name: enumDetailNameOfGlobalOptionStatus[enumOrDetail as GlobalOptionStatus],
    });
  }
}

function enumOrDetailOrNullOfGlobalOptionStatus(
  enumOrDetail: GlobalOptionStatusDetailOptions | GlobalOptionStatus | undefined | null,
): GlobalOptionStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfGlobalOptionStatus(enumOrDetail);
}

const enumDetailNameOfCommentStreamVisibility = { INTERNAL: "Internal", HOMEOWNER: "Homeowner", TRADES: "Trades" };

function enumOrDetailOfCommentStreamVisibility(
  enumOrDetail: CommentStreamVisibilityDetailOptions | CommentStreamVisibility | undefined,
): CommentStreamVisibilityDetail {
  if (enumOrDetail === undefined) {
    return newCommentStreamVisibilityDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "CommentStreamVisibilityDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfCommentStreamVisibility[enumOrDetail.code!],
      ...enumOrDetail,
    } as CommentStreamVisibilityDetail;
  } else {
    return newCommentStreamVisibilityDetail({
      code: enumOrDetail as CommentStreamVisibility,
      name: enumDetailNameOfCommentStreamVisibility[enumOrDetail as CommentStreamVisibility],
    });
  }
}

function enumOrDetailOrNullOfCommentStreamVisibility(
  enumOrDetail: CommentStreamVisibilityDetailOptions | CommentStreamVisibility | undefined | null,
): CommentStreamVisibilityDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfCommentStreamVisibility(enumOrDetail);
}

const enumDetailNameOfProjectStageStatus = { ACTIVE: "Active", COMPLETED: "Completed", DRAFT: "Draft" };

function enumOrDetailOfProjectStageStatus(
  enumOrDetail: ProjectStageStatusDetailOptions | ProjectStageStatus | undefined,
): ProjectStageStatusDetail {
  if (enumOrDetail === undefined) {
    return newProjectStageStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ProjectStageStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfProjectStageStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as ProjectStageStatusDetail;
  } else {
    return newProjectStageStatusDetail({
      code: enumOrDetail as ProjectStageStatus,
      name: enumDetailNameOfProjectStageStatus[enumOrDetail as ProjectStageStatus],
    });
  }
}

function enumOrDetailOrNullOfProjectStageStatus(
  enumOrDetail: ProjectStageStatusDetailOptions | ProjectStageStatus | undefined | null,
): ProjectStageStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfProjectStageStatus(enumOrDetail);
}

const enumDetailNameOfCostClassificationType = { SOFT: "Soft", HARD: "Hard" };

function enumOrDetailOfCostClassificationType(
  enumOrDetail: CostClassificationTypeDetailOptions | CostClassificationType | undefined,
): CostClassificationTypeDetail {
  if (enumOrDetail === undefined) {
    return newCostClassificationTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "CostClassificationTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfCostClassificationType[enumOrDetail.code!],
      ...enumOrDetail,
    } as CostClassificationTypeDetail;
  } else {
    return newCostClassificationTypeDetail({
      code: enumOrDetail as CostClassificationType,
      name: enumDetailNameOfCostClassificationType[enumOrDetail as CostClassificationType],
    });
  }
}

function enumOrDetailOrNullOfCostClassificationType(
  enumOrDetail: CostClassificationTypeDetailOptions | CostClassificationType | undefined | null,
): CostClassificationTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfCostClassificationType(enumOrDetail);
}

const enumDetailNameOfCostSubClassificationType = { INDIRECT: "Indirect", DIRECT: "Direct" };

function enumOrDetailOfCostSubClassificationType(
  enumOrDetail: CostSubClassificationTypeDetailOptions | CostSubClassificationType | undefined,
): CostSubClassificationTypeDetail {
  if (enumOrDetail === undefined) {
    return newCostSubClassificationTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "CostSubClassificationTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfCostSubClassificationType[enumOrDetail.code!],
      ...enumOrDetail,
    } as CostSubClassificationTypeDetail;
  } else {
    return newCostSubClassificationTypeDetail({
      code: enumOrDetail as CostSubClassificationType,
      name: enumDetailNameOfCostSubClassificationType[enumOrDetail as CostSubClassificationType],
    });
  }
}

function enumOrDetailOrNullOfCostSubClassificationType(
  enumOrDetail: CostSubClassificationTypeDetailOptions | CostSubClassificationType | undefined | null,
): CostSubClassificationTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfCostSubClassificationType(enumOrDetail);
}

const enumDetailNameOfCostCodeInvoiceCategory = {
  PRE_CON: "Pre con",
  FOUNDATION: "Foundation",
  FRAMING: "Framing",
  HARDSCAPE: "Hardscape",
  INSULATION_DRYWALL: "Insulation drywall",
  INTERIOR_FINISHES: "Interior finishes",
  ROOFING: "Roofing",
  ROUGH_IN: "Rough in",
  SIDING: "Siding",
  SUBSTANTIAL_COMPLETION: "Substantial completion",
  ARCHITECTURE_PLAN: "Architecture plan",
  ARCHITECTURE_FEE: "Architecture fee",
  EXTERIOR: "Exterior",
  MECHANICAL_SYSTEMS: "Mechanical systems",
  GENERAL_CONDITIONS: "General conditions",
  CONTINGENCY: "Contingency",
  HOLD_BACK: "Hold back",
  DEPOSIT: "Deposit",
};

function enumOrDetailOfCostCodeInvoiceCategory(
  enumOrDetail: CostCodeInvoiceCategoryDetailOptions | CostCodeInvoiceCategory | undefined,
): CostCodeInvoiceCategoryDetail {
  if (enumOrDetail === undefined) {
    return newCostCodeInvoiceCategoryDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "CostCodeInvoiceCategoryDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfCostCodeInvoiceCategory[enumOrDetail.code!],
      ...enumOrDetail,
    } as CostCodeInvoiceCategoryDetail;
  } else {
    return newCostCodeInvoiceCategoryDetail({
      code: enumOrDetail as CostCodeInvoiceCategory,
      name: enumDetailNameOfCostCodeInvoiceCategory[enumOrDetail as CostCodeInvoiceCategory],
    });
  }
}

function enumOrDetailOrNullOfCostCodeInvoiceCategory(
  enumOrDetail: CostCodeInvoiceCategoryDetailOptions | CostCodeInvoiceCategory | undefined | null,
): CostCodeInvoiceCategoryDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfCostCodeInvoiceCategory(enumOrDetail);
}

const enumDetailNameOfSelectionCutoff = {
  CUTOFF_1: "Cutoff 1",
  CUTOFF_2A: "Cutoff 2 a",
  CUTOFF_2B: "Cutoff 2 b",
  CUTOFF_3: "Cutoff 3",
};

function enumOrDetailOfSelectionCutoff(
  enumOrDetail: SelectionCutoffDetailOptions | SelectionCutoff | undefined,
): SelectionCutoffDetail {
  if (enumOrDetail === undefined) {
    return newSelectionCutoffDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "SelectionCutoffDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfSelectionCutoff[enumOrDetail.code!],
      ...enumOrDetail,
    } as SelectionCutoffDetail;
  } else {
    return newSelectionCutoffDetail({
      code: enumOrDetail as SelectionCutoff,
      name: enumDetailNameOfSelectionCutoff[enumOrDetail as SelectionCutoff],
    });
  }
}

function enumOrDetailOrNullOfSelectionCutoff(
  enumOrDetail: SelectionCutoffDetailOptions | SelectionCutoff | undefined | null,
): SelectionCutoffDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfSelectionCutoff(enumOrDetail);
}

const enumDetailNameOfDesignPackageLocation = { INTERIOR: "Interior", EXTERIOR: "Exterior" };

function enumOrDetailOfDesignPackageLocation(
  enumOrDetail: DesignPackageLocationDetailOptions | DesignPackageLocation | undefined,
): DesignPackageLocationDetail {
  if (enumOrDetail === undefined) {
    return newDesignPackageLocationDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "DesignPackageLocationDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfDesignPackageLocation[enumOrDetail.code!],
      ...enumOrDetail,
    } as DesignPackageLocationDetail;
  } else {
    return newDesignPackageLocationDetail({
      code: enumOrDetail as DesignPackageLocation,
      name: enumDetailNameOfDesignPackageLocation[enumOrDetail as DesignPackageLocation],
    });
  }
}

function enumOrDetailOrNullOfDesignPackageLocation(
  enumOrDetail: DesignPackageLocationDetailOptions | DesignPackageLocation | undefined | null,
): DesignPackageLocationDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfDesignPackageLocation(enumOrDetail);
}

const enumDetailNameOfActivityPlanningState = {
  DRAFT: "Draft",
  READY_FOR_REVIEW: "Ready for review",
  IN_REVIEW: "In review",
  APPROVED: "Approved",
  REJECTED: "Rejected",
};

function enumOrDetailOfActivityPlanningState(
  enumOrDetail: ActivityPlanningStateDetailOptions | ActivityPlanningState | undefined,
): ActivityPlanningStateDetail {
  if (enumOrDetail === undefined) {
    return newActivityPlanningStateDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ActivityPlanningStateDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfActivityPlanningState[enumOrDetail.code!],
      ...enumOrDetail,
    } as ActivityPlanningStateDetail;
  } else {
    return newActivityPlanningStateDetail({
      code: enumOrDetail as ActivityPlanningState,
      name: enumDetailNameOfActivityPlanningState[enumOrDetail as ActivityPlanningState],
    });
  }
}

function enumOrDetailOrNullOfActivityPlanningState(
  enumOrDetail: ActivityPlanningStateDetailOptions | ActivityPlanningState | undefined | null,
): ActivityPlanningStateDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfActivityPlanningState(enumOrDetail);
}

const enumDetailNameOfActivityResponsibility = {
  HOMEBOUND: "Homebound",
  OWNERS_CONSULTANT: "Owners consultant",
  NOT_APPLICABLE: "Not applicable",
};

function enumOrDetailOfActivityResponsibility(
  enumOrDetail: ActivityResponsibilityDetailOptions | ActivityResponsibility | undefined,
): ActivityResponsibilityDetail {
  if (enumOrDetail === undefined) {
    return newActivityResponsibilityDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ActivityResponsibilityDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfActivityResponsibility[enumOrDetail.code!],
      ...enumOrDetail,
    } as ActivityResponsibilityDetail;
  } else {
    return newActivityResponsibilityDetail({
      code: enumOrDetail as ActivityResponsibility,
      name: enumDetailNameOfActivityResponsibility[enumOrDetail as ActivityResponsibility],
    });
  }
}

function enumOrDetailOrNullOfActivityResponsibility(
  enumOrDetail: ActivityResponsibilityDetailOptions | ActivityResponsibility | undefined | null,
): ActivityResponsibilityDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfActivityResponsibility(enumOrDetail);
}

const enumDetailNameOfActivityType = {
  PRECON_PLANNING: "Precon planning",
  PRECON_CONSTRUCTION_DOC: "Precon construction doc",
};

function enumOrDetailOfActivityType(
  enumOrDetail: ActivityTypeDetailOptions | ActivityType | undefined,
): ActivityTypeDetail {
  if (enumOrDetail === undefined) {
    return newActivityTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ActivityTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfActivityType[enumOrDetail.code!],
      ...enumOrDetail,
    } as ActivityTypeDetail;
  } else {
    return newActivityTypeDetail({
      code: enumOrDetail as ActivityType,
      name: enumDetailNameOfActivityType[enumOrDetail as ActivityType],
    });
  }
}

function enumOrDetailOrNullOfActivityType(
  enumOrDetail: ActivityTypeDetailOptions | ActivityType | undefined | null,
): ActivityTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfActivityType(enumOrDetail);
}

const enumDetailNameOfAggregateVersionStatus = { DRAFT: "Draft", ACTIVE: "Active", ARCHIVED: "Archived" };

function enumOrDetailOfAggregateVersionStatus(
  enumOrDetail: AggregateVersionStatusDetailOptions | AggregateVersionStatus | undefined,
): AggregateVersionStatusDetail {
  if (enumOrDetail === undefined) {
    return newAggregateVersionStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "AggregateVersionStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfAggregateVersionStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as AggregateVersionStatusDetail;
  } else {
    return newAggregateVersionStatusDetail({
      code: enumOrDetail as AggregateVersionStatus,
      name: enumDetailNameOfAggregateVersionStatus[enumOrDetail as AggregateVersionStatus],
    });
  }
}

function enumOrDetailOrNullOfAggregateVersionStatus(
  enumOrDetail: AggregateVersionStatusDetailOptions | AggregateVersionStatus | undefined | null,
): AggregateVersionStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfAggregateVersionStatus(enumOrDetail);
}

const enumDetailNameOfAllocationStrategy = {
  SIZE_BASED: "Size based",
  EQUAL_SHARE: "Equal share",
  MARKET_VALUE: "Market value",
};

function enumOrDetailOfAllocationStrategy(
  enumOrDetail: AllocationStrategyDetailOptions | AllocationStrategy | undefined,
): AllocationStrategyDetail {
  if (enumOrDetail === undefined) {
    return newAllocationStrategyDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "AllocationStrategyDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfAllocationStrategy[enumOrDetail.code!],
      ...enumOrDetail,
    } as AllocationStrategyDetail;
  } else {
    return newAllocationStrategyDetail({
      code: enumOrDetail as AllocationStrategy,
      name: enumDetailNameOfAllocationStrategy[enumOrDetail as AllocationStrategy],
    });
  }
}

function enumOrDetailOrNullOfAllocationStrategy(
  enumOrDetail: AllocationStrategyDetailOptions | AllocationStrategy | undefined | null,
): AllocationStrategyDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfAllocationStrategy(enumOrDetail);
}

const enumDetailNameOfBillGmailAttachmentResult = {
  NOT_PDF: "Not pdf",
  MISSING_PO: "Missing po",
  MISSING_TRADE: "Missing trade",
  MISSING_PROJECT: "Missing project",
  MISSING_INVOICE_NUMBER: "Missing invoice number",
  DUPLICATE: "Duplicate",
  CLICK_TO_PAY: "Click to pay",
  BILL_CREATED: "Bill created",
  MISSING_CONSTRUCTION_STAGE: "Missing construction stage",
  PROCESSING_ERROR: "Processing error",
  NOT_AN_INVOICE: "Not an invoice",
};

function enumOrDetailOfBillGmailAttachmentResult(
  enumOrDetail: BillGmailAttachmentResultDetailOptions | BillGmailAttachmentResult | undefined,
): BillGmailAttachmentResultDetail {
  if (enumOrDetail === undefined) {
    return newBillGmailAttachmentResultDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "BillGmailAttachmentResultDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfBillGmailAttachmentResult[enumOrDetail.code!],
      ...enumOrDetail,
    } as BillGmailAttachmentResultDetail;
  } else {
    return newBillGmailAttachmentResultDetail({
      code: enumOrDetail as BillGmailAttachmentResult,
      name: enumDetailNameOfBillGmailAttachmentResult[enumOrDetail as BillGmailAttachmentResult],
    });
  }
}

function enumOrDetailOrNullOfBillGmailAttachmentResult(
  enumOrDetail: BillGmailAttachmentResultDetailOptions | BillGmailAttachmentResult | undefined | null,
): BillGmailAttachmentResultDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfBillGmailAttachmentResult(enumOrDetail);
}

const enumDetailNameOfChangeRequestAssetScope = { PROJECT: "Project", DEVELOPMENT: "Development" };

function enumOrDetailOfChangeRequestAssetScope(
  enumOrDetail: ChangeRequestAssetScopeDetailOptions | ChangeRequestAssetScope | undefined,
): ChangeRequestAssetScopeDetail {
  if (enumOrDetail === undefined) {
    return newChangeRequestAssetScopeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ChangeRequestAssetScopeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfChangeRequestAssetScope[enumOrDetail.code!],
      ...enumOrDetail,
    } as ChangeRequestAssetScopeDetail;
  } else {
    return newChangeRequestAssetScopeDetail({
      code: enumOrDetail as ChangeRequestAssetScope,
      name: enumDetailNameOfChangeRequestAssetScope[enumOrDetail as ChangeRequestAssetScope],
    });
  }
}

function enumOrDetailOrNullOfChangeRequestAssetScope(
  enumOrDetail: ChangeRequestAssetScopeDetailOptions | ChangeRequestAssetScope | undefined | null,
): ChangeRequestAssetScopeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfChangeRequestAssetScope(enumOrDetail);
}

const enumDetailNameOfCheckoutConfigOptionGroupStep = {
  EXTERIOR_ELEVATION: "Exterior elevation",
  EXTERIOR_DESIGN_PACKAGE: "Exterior design package",
  OPTIONS_STRUCTURAL: "Options structural",
  OPTIONS_ADDON: "Options addon",
  INTERIOR_DESIGN_PACKAGE: "Interior design package",
  INTERIOR_PERSONALIZATION: "Interior personalization",
  ADU: "Adu",
};

function enumOrDetailOfCheckoutConfigOptionGroupStep(
  enumOrDetail: CheckoutConfigOptionGroupStepDetailOptions | CheckoutConfigOptionGroupStep | undefined,
): CheckoutConfigOptionGroupStepDetail {
  if (enumOrDetail === undefined) {
    return newCheckoutConfigOptionGroupStepDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "CheckoutConfigOptionGroupStepDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfCheckoutConfigOptionGroupStep[enumOrDetail.code!],
      ...enumOrDetail,
    } as CheckoutConfigOptionGroupStepDetail;
  } else {
    return newCheckoutConfigOptionGroupStepDetail({
      code: enumOrDetail as CheckoutConfigOptionGroupStep,
      name: enumDetailNameOfCheckoutConfigOptionGroupStep[enumOrDetail as CheckoutConfigOptionGroupStep],
    });
  }
}

function enumOrDetailOrNullOfCheckoutConfigOptionGroupStep(
  enumOrDetail: CheckoutConfigOptionGroupStepDetailOptions | CheckoutConfigOptionGroupStep | undefined | null,
): CheckoutConfigOptionGroupStepDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfCheckoutConfigOptionGroupStep(enumOrDetail);
}

const enumDetailNameOfCheckoutConfigStatus = { DRAFT: "Draft", RESERVED: "Reserved", EXPIRED: "Expired" };

function enumOrDetailOfCheckoutConfigStatus(
  enumOrDetail: CheckoutConfigStatusDetailOptions | CheckoutConfigStatus | undefined,
): CheckoutConfigStatusDetail {
  if (enumOrDetail === undefined) {
    return newCheckoutConfigStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "CheckoutConfigStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfCheckoutConfigStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as CheckoutConfigStatusDetail;
  } else {
    return newCheckoutConfigStatusDetail({
      code: enumOrDetail as CheckoutConfigStatus,
      name: enumDetailNameOfCheckoutConfigStatus[enumOrDetail as CheckoutConfigStatus],
    });
  }
}

function enumOrDetailOrNullOfCheckoutConfigStatus(
  enumOrDetail: CheckoutConfigStatusDetailOptions | CheckoutConfigStatus | undefined | null,
): CheckoutConfigStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfCheckoutConfigStatus(enumOrDetail);
}

const enumDetailNameOfCommunicationChannel = { EMAIL: "Email", TEXT: "Text" };

function enumOrDetailOfCommunicationChannel(
  enumOrDetail: CommunicationChannelDetailOptions | CommunicationChannel | undefined,
): CommunicationChannelDetail {
  if (enumOrDetail === undefined) {
    return newCommunicationChannelDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "CommunicationChannelDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfCommunicationChannel[enumOrDetail.code!],
      ...enumOrDetail,
    } as CommunicationChannelDetail;
  } else {
    return newCommunicationChannelDetail({
      code: enumOrDetail as CommunicationChannel,
      name: enumDetailNameOfCommunicationChannel[enumOrDetail as CommunicationChannel],
    });
  }
}

function enumOrDetailOrNullOfCommunicationChannel(
  enumOrDetail: CommunicationChannelDetailOptions | CommunicationChannel | undefined | null,
): CommunicationChannelDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfCommunicationChannel(enumOrDetail);
}

const enumDetailNameOfConstructionType = { TYPE_III: "Type iii", TYPE_IV: "Type iv", TYPE_V: "Type v" };

function enumOrDetailOfConstructionType(
  enumOrDetail: ConstructionTypeDetailOptions | ConstructionType | undefined,
): ConstructionTypeDetail {
  if (enumOrDetail === undefined) {
    return newConstructionTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ConstructionTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfConstructionType[enumOrDetail.code!],
      ...enumOrDetail,
    } as ConstructionTypeDetail;
  } else {
    return newConstructionTypeDetail({
      code: enumOrDetail as ConstructionType,
      name: enumDetailNameOfConstructionType[enumOrDetail as ConstructionType],
    });
  }
}

function enumOrDetailOrNullOfConstructionType(
  enumOrDetail: ConstructionTypeDetailOptions | ConstructionType | undefined | null,
): ConstructionTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfConstructionType(enumOrDetail);
}

const enumDetailNameOfDayOfWeek = {
  SATURDAY: "Saturday",
  SUNDAY: "Sunday",
  MONDAY: "Monday",
  TUESDAY: "Tuesday",
  WEDNESDAY: "Wednesday",
  THURSDAY: "Thursday",
  FRIDAY: "Friday",
};

function enumOrDetailOfDayOfWeek(enumOrDetail: DayOfWeekDetailOptions | DayOfWeek | undefined): DayOfWeekDetail {
  if (enumOrDetail === undefined) {
    return newDayOfWeekDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "DayOfWeekDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfDayOfWeek[enumOrDetail.code!],
      ...enumOrDetail,
    } as DayOfWeekDetail;
  } else {
    return newDayOfWeekDetail({
      code: enumOrDetail as DayOfWeek,
      name: enumDetailNameOfDayOfWeek[enumOrDetail as DayOfWeek],
    });
  }
}

function enumOrDetailOrNullOfDayOfWeek(
  enumOrDetail: DayOfWeekDetailOptions | DayOfWeek | undefined | null,
): DayOfWeekDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfDayOfWeek(enumOrDetail);
}

const enumDetailNameOfDocumentAttachmentPlace = { PURCHASE_ORDER: "Purchase order", BID_CONTRACT: "Bid contract" };

function enumOrDetailOfDocumentAttachmentPlace(
  enumOrDetail: DocumentAttachmentPlaceDetailOptions | DocumentAttachmentPlace | undefined,
): DocumentAttachmentPlaceDetail {
  if (enumOrDetail === undefined) {
    return newDocumentAttachmentPlaceDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "DocumentAttachmentPlaceDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfDocumentAttachmentPlace[enumOrDetail.code!],
      ...enumOrDetail,
    } as DocumentAttachmentPlaceDetail;
  } else {
    return newDocumentAttachmentPlaceDetail({
      code: enumOrDetail as DocumentAttachmentPlace,
      name: enumDetailNameOfDocumentAttachmentPlace[enumOrDetail as DocumentAttachmentPlace],
    });
  }
}

function enumOrDetailOrNullOfDocumentAttachmentPlace(
  enumOrDetail: DocumentAttachmentPlaceDetailOptions | DocumentAttachmentPlace | undefined | null,
): DocumentAttachmentPlaceDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfDocumentAttachmentPlace(enumOrDetail);
}

const enumDetailNameOfErpAccrualType = {
  TASK_COMPLETION: "Task completion",
  TASK_ALLOCATION_CHANGE: "Task allocation change",
  TASK_REVERSAL: "Task reversal",
  PURCHASE_ORDER_SIGNED: "Purchase order signed",
  PURCHASE_ORDER_VOID: "Purchase order void",
  CHANGE_ORDER_VOID: "Change order void",
  CHANGE_ORDER_SIGNED: "Change order signed",
  DEPOSIT_BILL_PAYMENT: "Deposit bill payment",
  DEPOSIT_BILL_PAYMENT_VOID: "Deposit bill payment void",
  AP_BILL_APPROVAL: "Ap bill approval",
  AP_BILL_REVERSAL: "Ap bill reversal",
  OVERHEAD_BILL_APPROVAL: "Overhead bill approval",
  OVERHEAD_BILL_REVERSAL: "Overhead bill reversal",
  EOM_ACCRUAL: "Eom accrual",
  BILL_LINE_ITEM_ALLOCATION: "Bill line item allocation",
  BILL_LINE_ITEM_ALLOCATION_REVERSAL: "Bill line item allocation reversal",
  EOM_ACCRUAL_REVERSAL: "Eom accrual reversal",
  EXPENSE_COST_ALLOCATION: "Expense cost allocation",
  EXPENSE_COST_ALLOCATION_REVERSAL: "Expense cost allocation reversal",
};

function enumOrDetailOfErpAccrualType(
  enumOrDetail: ErpAccrualTypeDetailOptions | ErpAccrualType | undefined,
): ErpAccrualTypeDetail {
  if (enumOrDetail === undefined) {
    return newErpAccrualTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ErpAccrualTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfErpAccrualType[enumOrDetail.code!],
      ...enumOrDetail,
    } as ErpAccrualTypeDetail;
  } else {
    return newErpAccrualTypeDetail({
      code: enumOrDetail as ErpAccrualType,
      name: enumDetailNameOfErpAccrualType[enumOrDetail as ErpAccrualType],
    });
  }
}

function enumOrDetailOrNullOfErpAccrualType(
  enumOrDetail: ErpAccrualTypeDetailOptions | ErpAccrualType | undefined | null,
): ErpAccrualTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfErpAccrualType(enumOrDetail);
}

const enumDetailNameOfErpRevenueLineItemSourceEvent = {
  CONTRACT_PRICE_CHANGE: "Contract price change",
  CONTRACT_PRICE_CHANGE_VOID: "Contract price change void",
  DIRECT_EXPENSE: "Direct expense",
  DIRECT_EXPENSE_VOID: "Direct expense void",
  COST_ACCRUAL: "Cost accrual",
  INITIAL_BALANCE: "Initial balance",
  OVERHEAD_BILL_APPROVAL: "Overhead bill approval",
  OVERHEAD_BILL_REVERSAL: "Overhead bill reversal",
  BUDGET_CHANGE: "Budget change",
  BUDGET_CHANGE_VOID: "Budget change void",
};

function enumOrDetailOfErpRevenueLineItemSourceEvent(
  enumOrDetail: ErpRevenueLineItemSourceEventDetailOptions | ErpRevenueLineItemSourceEvent | undefined,
): ErpRevenueLineItemSourceEventDetail {
  if (enumOrDetail === undefined) {
    return newErpRevenueLineItemSourceEventDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ErpRevenueLineItemSourceEventDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfErpRevenueLineItemSourceEvent[enumOrDetail.code!],
      ...enumOrDetail,
    } as ErpRevenueLineItemSourceEventDetail;
  } else {
    return newErpRevenueLineItemSourceEventDetail({
      code: enumOrDetail as ErpRevenueLineItemSourceEvent,
      name: enumDetailNameOfErpRevenueLineItemSourceEvent[enumOrDetail as ErpRevenueLineItemSourceEvent],
    });
  }
}

function enumOrDetailOrNullOfErpRevenueLineItemSourceEvent(
  enumOrDetail: ErpRevenueLineItemSourceEventDetailOptions | ErpRevenueLineItemSourceEvent | undefined | null,
): ErpRevenueLineItemSourceEventDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfErpRevenueLineItemSourceEvent(enumOrDetail);
}

const enumDetailNameOfErpTransactionGroupEvent = {
  TASK_COMPLETION: "Task completion",
  DEPOSIT_BILL: "Deposit bill",
  AP_BILL_APPROVAL: "Ap bill approval",
  EOM_ACCRUAL: "Eom accrual",
  REVENUE_RECOGNITION: "Revenue recognition",
  REVENUE_EOM_ACCRUAL: "Revenue eom accrual",
  COST_ALLOCATION: "Cost allocation",
};

function enumOrDetailOfErpTransactionGroupEvent(
  enumOrDetail: ErpTransactionGroupEventDetailOptions | ErpTransactionGroupEvent | undefined,
): ErpTransactionGroupEventDetail {
  if (enumOrDetail === undefined) {
    return newErpTransactionGroupEventDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ErpTransactionGroupEventDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfErpTransactionGroupEvent[enumOrDetail.code!],
      ...enumOrDetail,
    } as ErpTransactionGroupEventDetail;
  } else {
    return newErpTransactionGroupEventDetail({
      code: enumOrDetail as ErpTransactionGroupEvent,
      name: enumDetailNameOfErpTransactionGroupEvent[enumOrDetail as ErpTransactionGroupEvent],
    });
  }
}

function enumOrDetailOrNullOfErpTransactionGroupEvent(
  enumOrDetail: ErpTransactionGroupEventDetailOptions | ErpTransactionGroupEvent | undefined | null,
): ErpTransactionGroupEventDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfErpTransactionGroupEvent(enumOrDetail);
}

const enumDetailNameOfErpTransactionGroupStatus = { PENDING: "Pending", SUCCESS: "Success", DRAFT: "Draft" };

function enumOrDetailOfErpTransactionGroupStatus(
  enumOrDetail: ErpTransactionGroupStatusDetailOptions | ErpTransactionGroupStatus | undefined,
): ErpTransactionGroupStatusDetail {
  if (enumOrDetail === undefined) {
    return newErpTransactionGroupStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ErpTransactionGroupStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfErpTransactionGroupStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as ErpTransactionGroupStatusDetail;
  } else {
    return newErpTransactionGroupStatusDetail({
      code: enumOrDetail as ErpTransactionGroupStatus,
      name: enumDetailNameOfErpTransactionGroupStatus[enumOrDetail as ErpTransactionGroupStatus],
    });
  }
}

function enumOrDetailOrNullOfErpTransactionGroupStatus(
  enumOrDetail: ErpTransactionGroupStatusDetailOptions | ErpTransactionGroupStatus | undefined | null,
): ErpTransactionGroupStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfErpTransactionGroupStatus(enumOrDetail);
}

const enumDetailNameOfErpTransactionStatus = { PENDING: "Pending", MISMATCHING: "Mismatching", SYNCED: "Synced" };

function enumOrDetailOfErpTransactionStatus(
  enumOrDetail: ErpTransactionStatusDetailOptions | ErpTransactionStatus | undefined,
): ErpTransactionStatusDetail {
  if (enumOrDetail === undefined) {
    return newErpTransactionStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ErpTransactionStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfErpTransactionStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as ErpTransactionStatusDetail;
  } else {
    return newErpTransactionStatusDetail({
      code: enumOrDetail as ErpTransactionStatus,
      name: enumDetailNameOfErpTransactionStatus[enumOrDetail as ErpTransactionStatus],
    });
  }
}

function enumOrDetailOrNullOfErpTransactionStatus(
  enumOrDetail: ErpTransactionStatusDetailOptions | ErpTransactionStatus | undefined | null,
): ErpTransactionStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfErpTransactionStatus(enumOrDetail);
}

const enumDetailNameOfFeatureFlagStatus = { ACTIVE: "Active", RELEASED: "Released", ARCHIVED: "Archived" };

function enumOrDetailOfFeatureFlagStatus(
  enumOrDetail: FeatureFlagStatusDetailOptions | FeatureFlagStatus | undefined,
): FeatureFlagStatusDetail {
  if (enumOrDetail === undefined) {
    return newFeatureFlagStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "FeatureFlagStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfFeatureFlagStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as FeatureFlagStatusDetail;
  } else {
    return newFeatureFlagStatusDetail({
      code: enumOrDetail as FeatureFlagStatus,
      name: enumDetailNameOfFeatureFlagStatus[enumOrDetail as FeatureFlagStatus],
    });
  }
}

function enumOrDetailOrNullOfFeatureFlagStatus(
  enumOrDetail: FeatureFlagStatusDetailOptions | FeatureFlagStatus | undefined | null,
): FeatureFlagStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfFeatureFlagStatus(enumOrDetail);
}

const enumDetailNameOfFeatureFlagType = {
  TEST_FEATURE: "Test feature",
  TRADE_PARTNER_COMMUNICATIONS_SMS: "Trade partner communications sms",
  CHANGE_REQUEST_MVP: "Change request mvp",
  DIGITAL_BUILDING_EXPERIMENTS: "Digital building experiments",
  TRADE_PORTAL_ACCESS: "Trade portal access",
  MATERIAL_CATALOG: "Material catalog",
  DYNAMIC_SCHEDULES: "Dynamic schedules",
  COST_ACCRUALS: "Cost accruals",
  PRODUCT_CONFIG: "Product config",
  MOBILE_PUNCHLIST_POLLING: "Mobile punchlist polling",
  DYNAMIC_SCHEDULES_TRADE_COMMS: "Dynamic schedules trade comms",
  REVENUE_RECOGNITION: "Revenue recognition",
  MOBILE_PROJECT_GEOFENCE: "Mobile project geofence",
  OPTIONS_CATALOG_V2: "Options catalog v2",
  DESIGN_PACKAGE_PERSONALIZATION: "Design package personalization",
  PRODUCTION_WARNING_BANNER: "Production warning banner",
  MOBILE_LEADERBOARD: "Mobile leaderboard",
  MOBILE_SCHEDULE_SIM_DRAFT_MODE: "Mobile schedule sim draft mode",
  MOBILE_AI_CHATBOT_V2: "Mobile ai chatbot v2",
  VIDEO_SIGHTLINE_ANALYSIS: "Video sightline analysis",
};

function enumOrDetailOfFeatureFlagType(
  enumOrDetail: FeatureFlagTypeDetailOptions | FeatureFlagType | undefined,
): FeatureFlagTypeDetail {
  if (enumOrDetail === undefined) {
    return newFeatureFlagTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "FeatureFlagTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfFeatureFlagType[enumOrDetail.code!],
      ...enumOrDetail,
    } as FeatureFlagTypeDetail;
  } else {
    return newFeatureFlagTypeDetail({
      code: enumOrDetail as FeatureFlagType,
      name: enumDetailNameOfFeatureFlagType[enumOrDetail as FeatureFlagType],
    });
  }
}

function enumOrDetailOrNullOfFeatureFlagType(
  enumOrDetail: FeatureFlagTypeDetailOptions | FeatureFlagType | undefined | null,
): FeatureFlagTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfFeatureFlagType(enumOrDetail);
}

const enumDetailNameOfFloodPlain = { FP_0: "Fp 0", FP_100: "Fp 100", FP_500: "Fp 500" };

function enumOrDetailOfFloodPlain(enumOrDetail: FloodPlainDetailOptions | FloodPlain | undefined): FloodPlainDetail {
  if (enumOrDetail === undefined) {
    return newFloodPlainDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "FloodPlainDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfFloodPlain[enumOrDetail.code!],
      ...enumOrDetail,
    } as FloodPlainDetail;
  } else {
    return newFloodPlainDetail({
      code: enumOrDetail as FloodPlain,
      name: enumDetailNameOfFloodPlain[enumOrDetail as FloodPlain],
    });
  }
}

function enumOrDetailOrNullOfFloodPlain(
  enumOrDetail: FloodPlainDetailOptions | FloodPlain | undefined | null,
): FloodPlainDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfFloodPlain(enumOrDetail);
}

const enumDetailNameOfFloodZone = { FZ_NONE: "Fz none", FZ_AE: "Fz ae", FZ_COASTAL_A: "Fz coastal a", FZ_VE: "Fz ve" };

function enumOrDetailOfFloodZone(enumOrDetail: FloodZoneDetailOptions | FloodZone | undefined): FloodZoneDetail {
  if (enumOrDetail === undefined) {
    return newFloodZoneDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "FloodZoneDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfFloodZone[enumOrDetail.code!],
      ...enumOrDetail,
    } as FloodZoneDetail;
  } else {
    return newFloodZoneDetail({
      code: enumOrDetail as FloodZone,
      name: enumDetailNameOfFloodZone[enumOrDetail as FloodZone],
    });
  }
}

function enumOrDetailOrNullOfFloodZone(
  enumOrDetail: FloodZoneDetailOptions | FloodZone | undefined | null,
): FloodZoneDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfFloodZone(enumOrDetail);
}

const enumDetailNameOfFoundationType = { SLAB: "Slab", ELEVATED: "Elevated", PIERS: "Piers" };

function enumOrDetailOfFoundationType(
  enumOrDetail: FoundationTypeDetailOptions | FoundationType | undefined,
): FoundationTypeDetail {
  if (enumOrDetail === undefined) {
    return newFoundationTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "FoundationTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfFoundationType[enumOrDetail.code!],
      ...enumOrDetail,
    } as FoundationTypeDetail;
  } else {
    return newFoundationTypeDetail({
      code: enumOrDetail as FoundationType,
      name: enumDetailNameOfFoundationType[enumOrDetail as FoundationType],
    });
  }
}

function enumOrDetailOrNullOfFoundationType(
  enumOrDetail: FoundationTypeDetailOptions | FoundationType | undefined | null,
): FoundationTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfFoundationType(enumOrDetail);
}

const enumDetailNameOfGlobalOptionTypeStatus = { ACTIVE: "Active", ARCHIVED: "Archived" };

function enumOrDetailOfGlobalOptionTypeStatus(
  enumOrDetail: GlobalOptionTypeStatusDetailOptions | GlobalOptionTypeStatus | undefined,
): GlobalOptionTypeStatusDetail {
  if (enumOrDetail === undefined) {
    return newGlobalOptionTypeStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "GlobalOptionTypeStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfGlobalOptionTypeStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as GlobalOptionTypeStatusDetail;
  } else {
    return newGlobalOptionTypeStatusDetail({
      code: enumOrDetail as GlobalOptionTypeStatus,
      name: enumDetailNameOfGlobalOptionTypeStatus[enumOrDetail as GlobalOptionTypeStatus],
    });
  }
}

function enumOrDetailOrNullOfGlobalOptionTypeStatus(
  enumOrDetail: GlobalOptionTypeStatusDetailOptions | GlobalOptionTypeStatus | undefined | null,
): GlobalOptionTypeStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfGlobalOptionTypeStatus(enumOrDetail);
}

const enumDetailNameOfHomeownerSelectionOptionPricingType = {
  NONE: "None",
  INCLUDED: "Included",
  DOWNGRADE: "Downgrade",
  UPGRADE: "Upgrade",
};

function enumOrDetailOfHomeownerSelectionOptionPricingType(
  enumOrDetail: HomeownerSelectionOptionPricingTypeDetailOptions | HomeownerSelectionOptionPricingType | undefined,
): HomeownerSelectionOptionPricingTypeDetail {
  if (enumOrDetail === undefined) {
    return newHomeownerSelectionOptionPricingTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "HomeownerSelectionOptionPricingTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfHomeownerSelectionOptionPricingType[enumOrDetail.code!],
      ...enumOrDetail,
    } as HomeownerSelectionOptionPricingTypeDetail;
  } else {
    return newHomeownerSelectionOptionPricingTypeDetail({
      code: enumOrDetail as HomeownerSelectionOptionPricingType,
      name: enumDetailNameOfHomeownerSelectionOptionPricingType[enumOrDetail as HomeownerSelectionOptionPricingType],
    });
  }
}

function enumOrDetailOrNullOfHomeownerSelectionOptionPricingType(
  enumOrDetail:
    | HomeownerSelectionOptionPricingTypeDetailOptions
    | HomeownerSelectionOptionPricingType
    | undefined
    | null,
): HomeownerSelectionOptionPricingTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfHomeownerSelectionOptionPricingType(enumOrDetail);
}

const enumDetailNameOfHomeownerSelectionStatus = {
  DECLINED: "Declined",
  UNDECIDED: "Undecided",
  SELECTED: "Selected",
  FINALIZED: "Finalized",
};

function enumOrDetailOfHomeownerSelectionStatus(
  enumOrDetail: HomeownerSelectionStatusDetailOptions | HomeownerSelectionStatus | undefined,
): HomeownerSelectionStatusDetail {
  if (enumOrDetail === undefined) {
    return newHomeownerSelectionStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "HomeownerSelectionStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfHomeownerSelectionStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as HomeownerSelectionStatusDetail;
  } else {
    return newHomeownerSelectionStatusDetail({
      code: enumOrDetail as HomeownerSelectionStatus,
      name: enumDetailNameOfHomeownerSelectionStatus[enumOrDetail as HomeownerSelectionStatus],
    });
  }
}

function enumOrDetailOrNullOfHomeownerSelectionStatus(
  enumOrDetail: HomeownerSelectionStatusDetailOptions | HomeownerSelectionStatus | undefined | null,
): HomeownerSelectionStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfHomeownerSelectionStatus(enumOrDetail);
}

const enumDetailNameOfInboxItemStatus = { READ: "Read", UNREAD: "Unread", ARCHIVED: "Archived" };

function enumOrDetailOfInboxItemStatus(
  enumOrDetail: InboxItemStatusDetailOptions | InboxItemStatus | undefined,
): InboxItemStatusDetail {
  if (enumOrDetail === undefined) {
    return newInboxItemStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "InboxItemStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfInboxItemStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as InboxItemStatusDetail;
  } else {
    return newInboxItemStatusDetail({
      code: enumOrDetail as InboxItemStatus,
      name: enumDetailNameOfInboxItemStatus[enumOrDetail as InboxItemStatus],
    });
  }
}

function enumOrDetailOrNullOfInboxItemStatus(
  enumOrDetail: InboxItemStatusDetailOptions | InboxItemStatus | undefined | null,
): InboxItemStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfInboxItemStatus(enumOrDetail);
}

const enumDetailNameOfInvoiceDocumentSource = { QUICKBOOKS: "Quickbooks", INTACCT: "Intacct", BLUEPRINT: "Blueprint" };

function enumOrDetailOfInvoiceDocumentSource(
  enumOrDetail: InvoiceDocumentSourceDetailOptions | InvoiceDocumentSource | undefined,
): InvoiceDocumentSourceDetail {
  if (enumOrDetail === undefined) {
    return newInvoiceDocumentSourceDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "InvoiceDocumentSourceDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfInvoiceDocumentSource[enumOrDetail.code!],
      ...enumOrDetail,
    } as InvoiceDocumentSourceDetail;
  } else {
    return newInvoiceDocumentSourceDetail({
      code: enumOrDetail as InvoiceDocumentSource,
      name: enumDetailNameOfInvoiceDocumentSource[enumOrDetail as InvoiceDocumentSource],
    });
  }
}

function enumOrDetailOrNullOfInvoiceDocumentSource(
  enumOrDetail: InvoiceDocumentSourceDetailOptions | InvoiceDocumentSource | undefined | null,
): InvoiceDocumentSourceDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfInvoiceDocumentSource(enumOrDetail);
}

const enumDetailNameOfInvoiceScheduleAmountType = {
  COST: "Cost",
  MARGIN: "Margin",
  COST_AND_MARGIN: "Cost and margin",
};

function enumOrDetailOfInvoiceScheduleAmountType(
  enumOrDetail: InvoiceScheduleAmountTypeDetailOptions | InvoiceScheduleAmountType | undefined,
): InvoiceScheduleAmountTypeDetail {
  if (enumOrDetail === undefined) {
    return newInvoiceScheduleAmountTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "InvoiceScheduleAmountTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfInvoiceScheduleAmountType[enumOrDetail.code!],
      ...enumOrDetail,
    } as InvoiceScheduleAmountTypeDetail;
  } else {
    return newInvoiceScheduleAmountTypeDetail({
      code: enumOrDetail as InvoiceScheduleAmountType,
      name: enumDetailNameOfInvoiceScheduleAmountType[enumOrDetail as InvoiceScheduleAmountType],
    });
  }
}

function enumOrDetailOrNullOfInvoiceScheduleAmountType(
  enumOrDetail: InvoiceScheduleAmountTypeDetailOptions | InvoiceScheduleAmountType | undefined | null,
): InvoiceScheduleAmountTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfInvoiceScheduleAmountType(enumOrDetail);
}

const enumDetailNameOfInvoiceScheduleItemFrequency = { ONCE: "Once", MONTHLY: "Monthly", DYNAMIC: "Dynamic" };

function enumOrDetailOfInvoiceScheduleItemFrequency(
  enumOrDetail: InvoiceScheduleItemFrequencyDetailOptions | InvoiceScheduleItemFrequency | undefined,
): InvoiceScheduleItemFrequencyDetail {
  if (enumOrDetail === undefined) {
    return newInvoiceScheduleItemFrequencyDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "InvoiceScheduleItemFrequencyDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfInvoiceScheduleItemFrequency[enumOrDetail.code!],
      ...enumOrDetail,
    } as InvoiceScheduleItemFrequencyDetail;
  } else {
    return newInvoiceScheduleItemFrequencyDetail({
      code: enumOrDetail as InvoiceScheduleItemFrequency,
      name: enumDetailNameOfInvoiceScheduleItemFrequency[enumOrDetail as InvoiceScheduleItemFrequency],
    });
  }
}

function enumOrDetailOrNullOfInvoiceScheduleItemFrequency(
  enumOrDetail: InvoiceScheduleItemFrequencyDetailOptions | InvoiceScheduleItemFrequency | undefined | null,
): InvoiceScheduleItemFrequencyDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfInvoiceScheduleItemFrequency(enumOrDetail);
}

const enumDetailNameOfInvoiceScheduleTriggerType = {
  DATE: "Date",
  TASK: "Task",
  COST: "Cost",
  NONE: "None",
  END_OF_MONTH: "End of month",
  PERCENTAGE_OF_COMPLETION: "Percentage of completion",
};

function enumOrDetailOfInvoiceScheduleTriggerType(
  enumOrDetail: InvoiceScheduleTriggerTypeDetailOptions | InvoiceScheduleTriggerType | undefined,
): InvoiceScheduleTriggerTypeDetail {
  if (enumOrDetail === undefined) {
    return newInvoiceScheduleTriggerTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "InvoiceScheduleTriggerTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfInvoiceScheduleTriggerType[enumOrDetail.code!],
      ...enumOrDetail,
    } as InvoiceScheduleTriggerTypeDetail;
  } else {
    return newInvoiceScheduleTriggerTypeDetail({
      code: enumOrDetail as InvoiceScheduleTriggerType,
      name: enumDetailNameOfInvoiceScheduleTriggerType[enumOrDetail as InvoiceScheduleTriggerType],
    });
  }
}

function enumOrDetailOrNullOfInvoiceScheduleTriggerType(
  enumOrDetail: InvoiceScheduleTriggerTypeDetailOptions | InvoiceScheduleTriggerType | undefined | null,
): InvoiceScheduleTriggerTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfInvoiceScheduleTriggerType(enumOrDetail);
}

const enumDetailNameOfItemStatus = { DRAFT: "Draft", ACTIVE: "Active", ARCHIVED: "Archived" };

function enumOrDetailOfItemStatus(enumOrDetail: ItemStatusDetailOptions | ItemStatus | undefined): ItemStatusDetail {
  if (enumOrDetail === undefined) {
    return newItemStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ItemStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfItemStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as ItemStatusDetail;
  } else {
    return newItemStatusDetail({
      code: enumOrDetail as ItemStatus,
      name: enumDetailNameOfItemStatus[enumOrDetail as ItemStatus],
    });
  }
}

function enumOrDetailOrNullOfItemStatus(
  enumOrDetail: ItemStatusDetailOptions | ItemStatus | undefined | null,
): ItemStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfItemStatus(enumOrDetail);
}

const enumDetailNameOfItemTemplateItemCostStatus = {
  INTERNAL_ESTIMATE: "Internal estimate",
  CONTRACTED: "Contracted",
  NO_COST_SOURCE: "No cost source",
};

function enumOrDetailOfItemTemplateItemCostStatus(
  enumOrDetail: ItemTemplateItemCostStatusDetailOptions | ItemTemplateItemCostStatus | undefined,
): ItemTemplateItemCostStatusDetail {
  if (enumOrDetail === undefined) {
    return newItemTemplateItemCostStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ItemTemplateItemCostStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfItemTemplateItemCostStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as ItemTemplateItemCostStatusDetail;
  } else {
    return newItemTemplateItemCostStatusDetail({
      code: enumOrDetail as ItemTemplateItemCostStatus,
      name: enumDetailNameOfItemTemplateItemCostStatus[enumOrDetail as ItemTemplateItemCostStatus],
    });
  }
}

function enumOrDetailOrNullOfItemTemplateItemCostStatus(
  enumOrDetail: ItemTemplateItemCostStatusDetailOptions | ItemTemplateItemCostStatus | undefined | null,
): ItemTemplateItemCostStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfItemTemplateItemCostStatus(enumOrDetail);
}

const enumDetailNameOfItemTemplateStatus = {
  DRAFT: "Draft",
  ACTIVE: "Active",
  ARCHIVED: "Archived",
  SYSTEM_DRAFT: "System draft",
};

function enumOrDetailOfItemTemplateStatus(
  enumOrDetail: ItemTemplateStatusDetailOptions | ItemTemplateStatus | undefined,
): ItemTemplateStatusDetail {
  if (enumOrDetail === undefined) {
    return newItemTemplateStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ItemTemplateStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfItemTemplateStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as ItemTemplateStatusDetail;
  } else {
    return newItemTemplateStatusDetail({
      code: enumOrDetail as ItemTemplateStatus,
      name: enumDetailNameOfItemTemplateStatus[enumOrDetail as ItemTemplateStatus],
    });
  }
}

function enumOrDetailOrNullOfItemTemplateStatus(
  enumOrDetail: ItemTemplateStatusDetailOptions | ItemTemplateStatus | undefined | null,
): ItemTemplateStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfItemTemplateStatus(enumOrDetail);
}

const enumDetailNameOfJobLogFlag = {
  CHANGE_ORDER_DELAY: "Change order delay",
  CLIENT_DELAY: "Client delay",
  CONSULTANT_DELAY: "Consultant delay",
  DESIGN_DELAY: "Design delay",
  GROUND_WET: "Ground wet",
  HEALTH_DELAY: "Health delay",
  MATERIALS_DELAY: "Materials delay",
  QUALITY_CONTROL_DELAY: "Quality control delay",
  TRADE_PARTNER_DELAY: "Trade partner delay",
  WEATHER_DELAY: "Weather delay",
  DELIVERY_DELAY: "Delivery delay",
  INSPECTION_DELAY: "Inspection delay",
  INTERNAL_DELAY: "Internal delay",
};

function enumOrDetailOfJobLogFlag(enumOrDetail: JobLogFlagDetailOptions | JobLogFlag | undefined): JobLogFlagDetail {
  if (enumOrDetail === undefined) {
    return newJobLogFlagDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "JobLogFlagDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfJobLogFlag[enumOrDetail.code!],
      ...enumOrDetail,
    } as JobLogFlagDetail;
  } else {
    return newJobLogFlagDetail({
      code: enumOrDetail as JobLogFlag,
      name: enumDetailNameOfJobLogFlag[enumOrDetail as JobLogFlag],
    });
  }
}

function enumOrDetailOrNullOfJobLogFlag(
  enumOrDetail: JobLogFlagDetailOptions | JobLogFlag | undefined | null,
): JobLogFlagDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfJobLogFlag(enumOrDetail);
}

const enumDetailNameOfLienWaiverCondition = { UNCONDITIONAL: "Unconditional", CONDITIONAL: "Conditional" };

function enumOrDetailOfLienWaiverCondition(
  enumOrDetail: LienWaiverConditionDetailOptions | LienWaiverCondition | undefined,
): LienWaiverConditionDetail {
  if (enumOrDetail === undefined) {
    return newLienWaiverConditionDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "LienWaiverConditionDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfLienWaiverCondition[enumOrDetail.code!],
      ...enumOrDetail,
    } as LienWaiverConditionDetail;
  } else {
    return newLienWaiverConditionDetail({
      code: enumOrDetail as LienWaiverCondition,
      name: enumDetailNameOfLienWaiverCondition[enumOrDetail as LienWaiverCondition],
    });
  }
}

function enumOrDetailOrNullOfLienWaiverCondition(
  enumOrDetail: LienWaiverConditionDetailOptions | LienWaiverCondition | undefined | null,
): LienWaiverConditionDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfLienWaiverCondition(enumOrDetail);
}

const enumDetailNameOfLienWaiverStatus = {
  DRAFT: "Draft",
  UPLOADED: "Uploaded",
  SENT: "Sent",
  PARTIALLY_SIGNED: "Partially signed",
  SIGNED: "Signed",
  PENDING: "Pending",
};

function enumOrDetailOfLienWaiverStatus(
  enumOrDetail: LienWaiverStatusDetailOptions | LienWaiverStatus | undefined,
): LienWaiverStatusDetail {
  if (enumOrDetail === undefined) {
    return newLienWaiverStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "LienWaiverStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfLienWaiverStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as LienWaiverStatusDetail;
  } else {
    return newLienWaiverStatusDetail({
      code: enumOrDetail as LienWaiverStatus,
      name: enumDetailNameOfLienWaiverStatus[enumOrDetail as LienWaiverStatus],
    });
  }
}

function enumOrDetailOrNullOfLienWaiverStatus(
  enumOrDetail: LienWaiverStatusDetailOptions | LienWaiverStatus | undefined | null,
): LienWaiverStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfLienWaiverStatus(enumOrDetail);
}

const enumDetailNameOfLienWaiverType = { PROGRESS: "Progress", FINAL: "Final" };

function enumOrDetailOfLienWaiverType(
  enumOrDetail: LienWaiverTypeDetailOptions | LienWaiverType | undefined,
): LienWaiverTypeDetail {
  if (enumOrDetail === undefined) {
    return newLienWaiverTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "LienWaiverTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfLienWaiverType[enumOrDetail.code!],
      ...enumOrDetail,
    } as LienWaiverTypeDetail;
  } else {
    return newLienWaiverTypeDetail({
      code: enumOrDetail as LienWaiverType,
      name: enumDetailNameOfLienWaiverType[enumOrDetail as LienWaiverType],
    });
  }
}

function enumOrDetailOrNullOfLienWaiverType(
  enumOrDetail: LienWaiverTypeDetailOptions | LienWaiverType | undefined | null,
): LienWaiverTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfLienWaiverType(enumOrDetail);
}

const enumDetailNameOfLocationType = {
  GROUP: "Group",
  LEVEL: "Level",
  ROOM: "Room",
  FEATURE: "Feature",
  SCOPE: "Scope",
};

function enumOrDetailOfLocationType(
  enumOrDetail: LocationTypeDetailOptions | LocationType | undefined,
): LocationTypeDetail {
  if (enumOrDetail === undefined) {
    return newLocationTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "LocationTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfLocationType[enumOrDetail.code!],
      ...enumOrDetail,
    } as LocationTypeDetail;
  } else {
    return newLocationTypeDetail({
      code: enumOrDetail as LocationType,
      name: enumDetailNameOfLocationType[enumOrDetail as LocationType],
    });
  }
}

function enumOrDetailOrNullOfLocationType(
  enumOrDetail: LocationTypeDetailOptions | LocationType | undefined | null,
): LocationTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfLocationType(enumOrDetail);
}

const enumDetailNameOfMarkupApplicationMethod = { PER_LINE_ITEM: "Per line item", PER_TOTAL_COST: "Per total cost" };

function enumOrDetailOfMarkupApplicationMethod(
  enumOrDetail: MarkupApplicationMethodDetailOptions | MarkupApplicationMethod | undefined,
): MarkupApplicationMethodDetail {
  if (enumOrDetail === undefined) {
    return newMarkupApplicationMethodDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "MarkupApplicationMethodDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfMarkupApplicationMethod[enumOrDetail.code!],
      ...enumOrDetail,
    } as MarkupApplicationMethodDetail;
  } else {
    return newMarkupApplicationMethodDetail({
      code: enumOrDetail as MarkupApplicationMethod,
      name: enumDetailNameOfMarkupApplicationMethod[enumOrDetail as MarkupApplicationMethod],
    });
  }
}

function enumOrDetailOrNullOfMarkupApplicationMethod(
  enumOrDetail: MarkupApplicationMethodDetailOptions | MarkupApplicationMethod | undefined | null,
): MarkupApplicationMethodDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfMarkupApplicationMethod(enumOrDetail);
}

const enumDetailNameOfMaterialAttributeDimensionType = { NUMBER: "Number", SELECT: "Select", BOOLEAN: "Boolean" };

function enumOrDetailOfMaterialAttributeDimensionType(
  enumOrDetail: MaterialAttributeDimensionTypeDetailOptions | MaterialAttributeDimensionType | undefined,
): MaterialAttributeDimensionTypeDetail {
  if (enumOrDetail === undefined) {
    return newMaterialAttributeDimensionTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "MaterialAttributeDimensionTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfMaterialAttributeDimensionType[enumOrDetail.code!],
      ...enumOrDetail,
    } as MaterialAttributeDimensionTypeDetail;
  } else {
    return newMaterialAttributeDimensionTypeDetail({
      code: enumOrDetail as MaterialAttributeDimensionType,
      name: enumDetailNameOfMaterialAttributeDimensionType[enumOrDetail as MaterialAttributeDimensionType],
    });
  }
}

function enumOrDetailOrNullOfMaterialAttributeDimensionType(
  enumOrDetail: MaterialAttributeDimensionTypeDetailOptions | MaterialAttributeDimensionType | undefined | null,
): MaterialAttributeDimensionTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfMaterialAttributeDimensionType(enumOrDetail);
}

const enumDetailNameOfMaterialAttributeValueType = {
  EXACT: "Exact",
  GREATER_THAN: "Greater than",
  LESS_THAN: "Less than",
  BETWEEN: "Between",
};

function enumOrDetailOfMaterialAttributeValueType(
  enumOrDetail: MaterialAttributeValueTypeDetailOptions | MaterialAttributeValueType | undefined,
): MaterialAttributeValueTypeDetail {
  if (enumOrDetail === undefined) {
    return newMaterialAttributeValueTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "MaterialAttributeValueTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfMaterialAttributeValueType[enumOrDetail.code!],
      ...enumOrDetail,
    } as MaterialAttributeValueTypeDetail;
  } else {
    return newMaterialAttributeValueTypeDetail({
      code: enumOrDetail as MaterialAttributeValueType,
      name: enumDetailNameOfMaterialAttributeValueType[enumOrDetail as MaterialAttributeValueType],
    });
  }
}

function enumOrDetailOrNullOfMaterialAttributeValueType(
  enumOrDetail: MaterialAttributeValueTypeDetailOptions | MaterialAttributeValueType | undefined | null,
): MaterialAttributeValueTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfMaterialAttributeValueType(enumOrDetail);
}

const enumDetailNameOfMaterialType = { PLACEHOLDER: "Placeholder", PRODUCT: "Product", CONSTRUCTION: "Construction" };

function enumOrDetailOfMaterialType(
  enumOrDetail: MaterialTypeDetailOptions | MaterialType | undefined,
): MaterialTypeDetail {
  if (enumOrDetail === undefined) {
    return newMaterialTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "MaterialTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfMaterialType[enumOrDetail.code!],
      ...enumOrDetail,
    } as MaterialTypeDetail;
  } else {
    return newMaterialTypeDetail({
      code: enumOrDetail as MaterialType,
      name: enumDetailNameOfMaterialType[enumOrDetail as MaterialType],
    });
  }
}

function enumOrDetailOrNullOfMaterialType(
  enumOrDetail: MaterialTypeDetailOptions | MaterialType | undefined | null,
): MaterialTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfMaterialType(enumOrDetail);
}

const enumDetailNameOfMobileSyncUpdateType = { CREATED: "Created", UPDATED: "Updated", DELETED: "Deleted" };

function enumOrDetailOfMobileSyncUpdateType(
  enumOrDetail: MobileSyncUpdateTypeDetailOptions | MobileSyncUpdateType | undefined,
): MobileSyncUpdateTypeDetail {
  if (enumOrDetail === undefined) {
    return newMobileSyncUpdateTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "MobileSyncUpdateTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfMobileSyncUpdateType[enumOrDetail.code!],
      ...enumOrDetail,
    } as MobileSyncUpdateTypeDetail;
  } else {
    return newMobileSyncUpdateTypeDetail({
      code: enumOrDetail as MobileSyncUpdateType,
      name: enumDetailNameOfMobileSyncUpdateType[enumOrDetail as MobileSyncUpdateType],
    });
  }
}

function enumOrDetailOrNullOfMobileSyncUpdateType(
  enumOrDetail: MobileSyncUpdateTypeDetailOptions | MobileSyncUpdateType | undefined | null,
): MobileSyncUpdateTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfMobileSyncUpdateType(enumOrDetail);
}

const enumDetailNameOfPandaDocRole = {
  USER: "User",
  TRADE_PARTNER: "Trade partner",
  HEAD_OF_CONSTRUCTION: "Head of construction",
  PROJECT_MANAGER: "Project manager",
  HOMEBOUND_AUTHORIZED_SIGNATORY: "Homebound authorized signatory",
  AREA_MANAGER: "Area manager",
  LEAD_ESTIMATOR: "Lead estimator",
  HOMEOWNER: "Homeowner",
  SIGNATORY: "Signatory",
};

function enumOrDetailOfPandaDocRole(
  enumOrDetail: PandaDocRoleDetailOptions | PandaDocRole | undefined,
): PandaDocRoleDetail {
  if (enumOrDetail === undefined) {
    return newPandaDocRoleDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "PandaDocRoleDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfPandaDocRole[enumOrDetail.code!],
      ...enumOrDetail,
    } as PandaDocRoleDetail;
  } else {
    return newPandaDocRoleDetail({
      code: enumOrDetail as PandaDocRole,
      name: enumDetailNameOfPandaDocRole[enumOrDetail as PandaDocRole],
    });
  }
}

function enumOrDetailOrNullOfPandaDocRole(
  enumOrDetail: PandaDocRoleDetailOptions | PandaDocRole | undefined | null,
): PandaDocRoleDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfPandaDocRole(enumOrDetail);
}

const enumDetailNameOfPandaDocStatus = {
  PENDING: "Pending",
  UPLOADED: "Uploaded",
  SENT: "Sent",
  VIEWED: "Viewed",
  WAITING_APPROVAL: "Waiting approval",
  REJECTED: "Rejected",
  APPROVED: "Approved",
  WAITING_PAY: "Waiting pay",
  PAID: "Paid",
  COMPLETED: "Completed",
  VOIDED: "Voided",
  DECLINED: "Declined",
  AWAITING_DELETE: "Awaiting delete",
  UPLOAD_FAILED: "Upload failed",
  PARTIALLY_SIGNED: "Partially signed",
  DRAFT: "Draft",
};

function enumOrDetailOfPandaDocStatus(
  enumOrDetail: PandaDocStatusDetailOptions | PandaDocStatus | undefined,
): PandaDocStatusDetail {
  if (enumOrDetail === undefined) {
    return newPandaDocStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "PandaDocStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfPandaDocStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as PandaDocStatusDetail;
  } else {
    return newPandaDocStatusDetail({
      code: enumOrDetail as PandaDocStatus,
      name: enumDetailNameOfPandaDocStatus[enumOrDetail as PandaDocStatus],
    });
  }
}

function enumOrDetailOrNullOfPandaDocStatus(
  enumOrDetail: PandaDocStatusDetailOptions | PandaDocStatus | undefined | null,
): PandaDocStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfPandaDocStatus(enumOrDetail);
}

const enumDetailNameOfPandaDocWorkspace = {
  HOMEBOUND: "Homebound",
  HOMEBOUND_FINANCE: "Homebound finance",
  HOMEBOUND_CALIFORNIA: "Homebound california",
};

function enumOrDetailOfPandaDocWorkspace(
  enumOrDetail: PandaDocWorkspaceDetailOptions | PandaDocWorkspace | undefined,
): PandaDocWorkspaceDetail {
  if (enumOrDetail === undefined) {
    return newPandaDocWorkspaceDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "PandaDocWorkspaceDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfPandaDocWorkspace[enumOrDetail.code!],
      ...enumOrDetail,
    } as PandaDocWorkspaceDetail;
  } else {
    return newPandaDocWorkspaceDetail({
      code: enumOrDetail as PandaDocWorkspace,
      name: enumDetailNameOfPandaDocWorkspace[enumOrDetail as PandaDocWorkspace],
    });
  }
}

function enumOrDetailOrNullOfPandaDocWorkspace(
  enumOrDetail: PandaDocWorkspaceDetailOptions | PandaDocWorkspace | undefined | null,
): PandaDocWorkspaceDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfPandaDocWorkspace(enumOrDetail);
}

const enumDetailNameOfPaymentTermDueFrom = {
  FROM_INVOICE_BILL_DATE: "From invoice bill date",
  OF_THE_MONTH_OF_INVOICE_BILL_DATE: "Of the month of invoice bill date",
  OF_NEXT_MONTH_FROM_INVOICE_BILL_DATE: "Of next month from invoice bill date",
  OF_2ND_MONTH_FROM_INVOICE_BILL_DATE: "Of 2 nd month from invoice bill date",
  OF_3RD_MONTH_FROM_INVOICE_BILL_DATE: "Of 3 rd month from invoice bill date",
  OF_4TH_MONTH_FROM_INVOICE_BILL_DATE: "Of 4 th month from invoice bill date",
  OF_5TH_MONTH_FROM_INVOICE_BILL_DATE: "Of 5 th month from invoice bill date",
  OF_6TH_MONTH_FROM_INVOICE_BILL_DATE: "Of 6 th month from invoice bill date",
};

function enumOrDetailOfPaymentTermDueFrom(
  enumOrDetail: PaymentTermDueFromDetailOptions | PaymentTermDueFrom | undefined,
): PaymentTermDueFromDetail {
  if (enumOrDetail === undefined) {
    return newPaymentTermDueFromDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "PaymentTermDueFromDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfPaymentTermDueFrom[enumOrDetail.code!],
      ...enumOrDetail,
    } as PaymentTermDueFromDetail;
  } else {
    return newPaymentTermDueFromDetail({
      code: enumOrDetail as PaymentTermDueFrom,
      name: enumDetailNameOfPaymentTermDueFrom[enumOrDetail as PaymentTermDueFrom],
    });
  }
}

function enumOrDetailOrNullOfPaymentTermDueFrom(
  enumOrDetail: PaymentTermDueFromDetailOptions | PaymentTermDueFrom | undefined | null,
): PaymentTermDueFromDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfPaymentTermDueFrom(enumOrDetail);
}

const enumDetailNameOfPermit = {
  ZONING: "Zoning",
  STRUCTURAL: "Structural",
  ELECTRICAL: "Electrical",
  PLUMBING: "Plumbing",
  HVAC: "Hvac",
};

function enumOrDetailOfPermit(enumOrDetail: PermitDetailOptions | Permit | undefined): PermitDetail {
  if (enumOrDetail === undefined) {
    return newPermitDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "PermitDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfPermit[enumOrDetail.code!],
      ...enumOrDetail,
    } as PermitDetail;
  } else {
    return newPermitDetail({ code: enumOrDetail as Permit, name: enumDetailNameOfPermit[enumOrDetail as Permit] });
  }
}

function enumOrDetailOrNullOfPermit(
  enumOrDetail: PermitDetailOptions | Permit | undefined | null,
): PermitDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfPermit(enumOrDetail);
}

const enumDetailNameOfProductAttributeType = {
  FINISH: "Finish",
  BRAND: "Brand",
  VENDOR: "Vendor",
  MATERIAL: "Material",
  STYLE: "Style",
  FUEL: "Fuel",
  MARKET: "Market",
  STATUS: "Status",
  UNIT: "Unit",
  DESIGN_PACKAGE: "Design package",
  DESIGN_PACKAGE_ITEM: "Design package item",
  DESIGN_PACKAGE_LOCATION: "Design package location",
  LINE: "Line",
};

function enumOrDetailOfProductAttributeType(
  enumOrDetail: ProductAttributeTypeDetailOptions | ProductAttributeType | undefined,
): ProductAttributeTypeDetail {
  if (enumOrDetail === undefined) {
    return newProductAttributeTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ProductAttributeTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfProductAttributeType[enumOrDetail.code!],
      ...enumOrDetail,
    } as ProductAttributeTypeDetail;
  } else {
    return newProductAttributeTypeDetail({
      code: enumOrDetail as ProductAttributeType,
      name: enumDetailNameOfProductAttributeType[enumOrDetail as ProductAttributeType],
    });
  }
}

function enumOrDetailOrNullOfProductAttributeType(
  enumOrDetail: ProductAttributeTypeDetailOptions | ProductAttributeType | undefined | null,
): ProductAttributeTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfProductAttributeType(enumOrDetail);
}

const enumDetailNameOfProductDimensionType = {
  WIDTH: "Width",
  LENGTH: "Length",
  HEIGHT: "Height",
  MAX_HEIGHT: "Max height",
  DEPTH: "Depth",
  DIAMETER: "Diameter",
  VOLUME: "Volume",
  THICKNESS: "Thickness",
  NOTE: "Note",
};

function enumOrDetailOfProductDimensionType(
  enumOrDetail: ProductDimensionTypeDetailOptions | ProductDimensionType | undefined,
): ProductDimensionTypeDetail {
  if (enumOrDetail === undefined) {
    return newProductDimensionTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ProductDimensionTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfProductDimensionType[enumOrDetail.code!],
      ...enumOrDetail,
    } as ProductDimensionTypeDetail;
  } else {
    return newProductDimensionTypeDetail({
      code: enumOrDetail as ProductDimensionType,
      name: enumDetailNameOfProductDimensionType[enumOrDetail as ProductDimensionType],
    });
  }
}

function enumOrDetailOrNullOfProductDimensionType(
  enumOrDetail: ProductDimensionTypeDetailOptions | ProductDimensionType | undefined | null,
): ProductDimensionTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfProductDimensionType(enumOrDetail);
}

const enumDetailNameOfProgramDataBasementConfig = {
  NO: "No",
  PARTIAL_UNFINISHED: "Partial unfinished",
  FULL_FINISHED: "Full finished",
  FULL_UNFINISHED: "Full unfinished",
  WALKOUT_UNFINISHED: "Walkout unfinished",
  WALKOUT_FINISHED: "Walkout finished",
  GARDEN_LEVEL_UNFINISHED: "Garden level unfinished",
  GARDEN_LEVEL_FINISHED: "Garden level finished",
};

function enumOrDetailOfProgramDataBasementConfig(
  enumOrDetail: ProgramDataBasementConfigDetailOptions | ProgramDataBasementConfig | undefined,
): ProgramDataBasementConfigDetail {
  if (enumOrDetail === undefined) {
    return newProgramDataBasementConfigDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ProgramDataBasementConfigDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfProgramDataBasementConfig[enumOrDetail.code!],
      ...enumOrDetail,
    } as ProgramDataBasementConfigDetail;
  } else {
    return newProgramDataBasementConfigDetail({
      code: enumOrDetail as ProgramDataBasementConfig,
      name: enumDetailNameOfProgramDataBasementConfig[enumOrDetail as ProgramDataBasementConfig],
    });
  }
}

function enumOrDetailOrNullOfProgramDataBasementConfig(
  enumOrDetail: ProgramDataBasementConfigDetailOptions | ProgramDataBasementConfig | undefined | null,
): ProgramDataBasementConfigDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfProgramDataBasementConfig(enumOrDetail);
}

const enumDetailNameOfProgramDataGarageConfig = {
  FRONT_LOAD: "Front load",
  ALLEY_LOAD: "Alley load",
  SIDE_LOAD: "Side load",
  SPLIT_LOAD: "Split load",
};

function enumOrDetailOfProgramDataGarageConfig(
  enumOrDetail: ProgramDataGarageConfigDetailOptions | ProgramDataGarageConfig | undefined,
): ProgramDataGarageConfigDetail {
  if (enumOrDetail === undefined) {
    return newProgramDataGarageConfigDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ProgramDataGarageConfigDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfProgramDataGarageConfig[enumOrDetail.code!],
      ...enumOrDetail,
    } as ProgramDataGarageConfigDetail;
  } else {
    return newProgramDataGarageConfigDetail({
      code: enumOrDetail as ProgramDataGarageConfig,
      name: enumDetailNameOfProgramDataGarageConfig[enumOrDetail as ProgramDataGarageConfig],
    });
  }
}

function enumOrDetailOrNullOfProgramDataGarageConfig(
  enumOrDetail: ProgramDataGarageConfigDetailOptions | ProgramDataGarageConfig | undefined | null,
): ProgramDataGarageConfigDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfProgramDataGarageConfig(enumOrDetail);
}

const enumDetailNameOfProgramDataMatchState = {
  MATCHES: "Matches",
  DEVIATION_PENDING_REVIEW: "Deviation pending review",
  DEVIATION_ACKNOWLEDGED: "Deviation acknowledged",
};

function enumOrDetailOfProgramDataMatchState(
  enumOrDetail: ProgramDataMatchStateDetailOptions | ProgramDataMatchState | undefined,
): ProgramDataMatchStateDetail {
  if (enumOrDetail === undefined) {
    return newProgramDataMatchStateDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ProgramDataMatchStateDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfProgramDataMatchState[enumOrDetail.code!],
      ...enumOrDetail,
    } as ProgramDataMatchStateDetail;
  } else {
    return newProgramDataMatchStateDetail({
      code: enumOrDetail as ProgramDataMatchState,
      name: enumDetailNameOfProgramDataMatchState[enumOrDetail as ProgramDataMatchState],
    });
  }
}

function enumOrDetailOrNullOfProgramDataMatchState(
  enumOrDetail: ProgramDataMatchStateDetailOptions | ProgramDataMatchState | undefined | null,
): ProgramDataMatchStateDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfProgramDataMatchState(enumOrDetail);
}

const enumDetailNameOfProgramDataPrimaryBedroomConfig = { UP: "Up", DOWN: "Down" };

function enumOrDetailOfProgramDataPrimaryBedroomConfig(
  enumOrDetail: ProgramDataPrimaryBedroomConfigDetailOptions | ProgramDataPrimaryBedroomConfig | undefined,
): ProgramDataPrimaryBedroomConfigDetail {
  if (enumOrDetail === undefined) {
    return newProgramDataPrimaryBedroomConfigDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ProgramDataPrimaryBedroomConfigDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfProgramDataPrimaryBedroomConfig[enumOrDetail.code!],
      ...enumOrDetail,
    } as ProgramDataPrimaryBedroomConfigDetail;
  } else {
    return newProgramDataPrimaryBedroomConfigDetail({
      code: enumOrDetail as ProgramDataPrimaryBedroomConfig,
      name: enumDetailNameOfProgramDataPrimaryBedroomConfig[enumOrDetail as ProgramDataPrimaryBedroomConfig],
    });
  }
}

function enumOrDetailOrNullOfProgramDataPrimaryBedroomConfig(
  enumOrDetail: ProgramDataPrimaryBedroomConfigDetailOptions | ProgramDataPrimaryBedroomConfig | undefined | null,
): ProgramDataPrimaryBedroomConfigDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfProgramDataPrimaryBedroomConfig(enumOrDetail);
}

const enumDetailNameOfProgramDataWindowColor = { WHITE: "White", BLACK: "Black" };

function enumOrDetailOfProgramDataWindowColor(
  enumOrDetail: ProgramDataWindowColorDetailOptions | ProgramDataWindowColor | undefined,
): ProgramDataWindowColorDetail {
  if (enumOrDetail === undefined) {
    return newProgramDataWindowColorDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ProgramDataWindowColorDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfProgramDataWindowColor[enumOrDetail.code!],
      ...enumOrDetail,
    } as ProgramDataWindowColorDetail;
  } else {
    return newProgramDataWindowColorDetail({
      code: enumOrDetail as ProgramDataWindowColor,
      name: enumDetailNameOfProgramDataWindowColor[enumOrDetail as ProgramDataWindowColor],
    });
  }
}

function enumOrDetailOrNullOfProgramDataWindowColor(
  enumOrDetail: ProgramDataWindowColorDetailOptions | ProgramDataWindowColor | undefined | null,
): ProgramDataWindowColorDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfProgramDataWindowColor(enumOrDetail);
}

const enumDetailNameOfProjectCollaboratorRole = {
  HOMEOWNER: "Homeowner",
  FAMILY: "Family",
  DESIGNER: "Designer",
  LEGAL: "Legal",
  OTHER: "Other",
};

function enumOrDetailOfProjectCollaboratorRole(
  enumOrDetail: ProjectCollaboratorRoleDetailOptions | ProjectCollaboratorRole | undefined,
): ProjectCollaboratorRoleDetail {
  if (enumOrDetail === undefined) {
    return newProjectCollaboratorRoleDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ProjectCollaboratorRoleDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfProjectCollaboratorRole[enumOrDetail.code!],
      ...enumOrDetail,
    } as ProjectCollaboratorRoleDetail;
  } else {
    return newProjectCollaboratorRoleDetail({
      code: enumOrDetail as ProjectCollaboratorRole,
      name: enumDetailNameOfProjectCollaboratorRole[enumOrDetail as ProjectCollaboratorRole],
    });
  }
}

function enumOrDetailOrNullOfProjectCollaboratorRole(
  enumOrDetail: ProjectCollaboratorRoleDetailOptions | ProjectCollaboratorRole | undefined | null,
): ProjectCollaboratorRoleDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfProjectCollaboratorRole(enumOrDetail);
}

const enumDetailNameOfProjectFeature = {
  SELECTIONS_V1: "Selections v1",
  HOP_HIDE_FINANCIALS: "Hop hide financials",
  HOP_VIZ_WALKTHROUGH: "Hop viz walkthrough",
  BP_PROJECT_SETTINGS: "Bp project settings",
  HIDE_ALL_HOP_PRICING: "Hide all hop pricing",
  HOP_PRICING_MSRP_NO_HB: "Hop pricing msrp no hb",
  HOP_PRICING_HB_NO_MSRP: "Hop pricing hb no msrp",
  HOP_SELECTIONS_INCLUDED_UPGRADE_PRICING: "Hop selections included upgrade pricing",
  SCHEDULES_V2: "Schedules v2",
  SCHEDULES_V2_GANTT: "Schedules v2 gantt",
  SCHEDULES_CALENDAR: "Schedules calendar",
  INVOICE_V2: "Invoice v2",
  HOP_HIDE_PRECON_FINANCIALS: "Hop hide precon financials",
  DELAY_FLAGS: "Delay flags",
  HOMEOWNER_NOTES: "Homeowner notes",
  HOMEOWNER_JOURNEY_V2: "Homeowner journey v2",
  PRODUCT_CONFIG_PLAN: "Product config plan",
  CHANGE_EVENT_SIGNATURES: "Change event signatures",
};

function enumOrDetailOfProjectFeature(
  enumOrDetail: ProjectFeatureDetailOptions | ProjectFeature | undefined,
): ProjectFeatureDetail {
  if (enumOrDetail === undefined) {
    return newProjectFeatureDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ProjectFeatureDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfProjectFeature[enumOrDetail.code!],
      ...enumOrDetail,
    } as ProjectFeatureDetail;
  } else {
    return newProjectFeatureDetail({
      code: enumOrDetail as ProjectFeature,
      name: enumDetailNameOfProjectFeature[enumOrDetail as ProjectFeature],
    });
  }
}

function enumOrDetailOrNullOfProjectFeature(
  enumOrDetail: ProjectFeatureDetailOptions | ProjectFeature | undefined | null,
): ProjectFeatureDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfProjectFeature(enumOrDetail);
}

const enumDetailNameOfProjectUpdateActionType = {
  ACTIVITY_COMPLETE: "Activity complete",
  UNIT_COMPLETE: "Unit complete",
  DOCUMENT_AVAILABLE: "Document available",
  NEW_HOMEOWNER_NOTE: "New homeowner note",
};

function enumOrDetailOfProjectUpdateActionType(
  enumOrDetail: ProjectUpdateActionTypeDetailOptions | ProjectUpdateActionType | undefined,
): ProjectUpdateActionTypeDetail {
  if (enumOrDetail === undefined) {
    return newProjectUpdateActionTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ProjectUpdateActionTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfProjectUpdateActionType[enumOrDetail.code!],
      ...enumOrDetail,
    } as ProjectUpdateActionTypeDetail;
  } else {
    return newProjectUpdateActionTypeDetail({
      code: enumOrDetail as ProjectUpdateActionType,
      name: enumDetailNameOfProjectUpdateActionType[enumOrDetail as ProjectUpdateActionType],
    });
  }
}

function enumOrDetailOrNullOfProjectUpdateActionType(
  enumOrDetail: ProjectUpdateActionTypeDetailOptions | ProjectUpdateActionType | undefined | null,
): ProjectUpdateActionTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfProjectUpdateActionType(enumOrDetail);
}

const enumDetailNameOfPushNotificationEnvironment = { SANDBOX: "Sandbox", PRODUCTION: "Production" };

function enumOrDetailOfPushNotificationEnvironment(
  enumOrDetail: PushNotificationEnvironmentDetailOptions | PushNotificationEnvironment | undefined,
): PushNotificationEnvironmentDetail {
  if (enumOrDetail === undefined) {
    return newPushNotificationEnvironmentDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "PushNotificationEnvironmentDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfPushNotificationEnvironment[enumOrDetail.code!],
      ...enumOrDetail,
    } as PushNotificationEnvironmentDetail;
  } else {
    return newPushNotificationEnvironmentDetail({
      code: enumOrDetail as PushNotificationEnvironment,
      name: enumDetailNameOfPushNotificationEnvironment[enumOrDetail as PushNotificationEnvironment],
    });
  }
}

function enumOrDetailOrNullOfPushNotificationEnvironment(
  enumOrDetail: PushNotificationEnvironmentDetailOptions | PushNotificationEnvironment | undefined | null,
): PushNotificationEnvironmentDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfPushNotificationEnvironment(enumOrDetail);
}

const enumDetailNameOfPushNotificationPlatform = { IOS: "Ios", ANDROID: "Android", WEB: "Web" };

function enumOrDetailOfPushNotificationPlatform(
  enumOrDetail: PushNotificationPlatformDetailOptions | PushNotificationPlatform | undefined,
): PushNotificationPlatformDetail {
  if (enumOrDetail === undefined) {
    return newPushNotificationPlatformDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "PushNotificationPlatformDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfPushNotificationPlatform[enumOrDetail.code!],
      ...enumOrDetail,
    } as PushNotificationPlatformDetail;
  } else {
    return newPushNotificationPlatformDetail({
      code: enumOrDetail as PushNotificationPlatform,
      name: enumDetailNameOfPushNotificationPlatform[enumOrDetail as PushNotificationPlatform],
    });
  }
}

function enumOrDetailOrNullOfPushNotificationPlatform(
  enumOrDetail: PushNotificationPlatformDetailOptions | PushNotificationPlatform | undefined | null,
): PushNotificationPlatformDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfPushNotificationPlatform(enumOrDetail);
}

const enumDetailNameOfReadyPlanAssetType = {
  COVER_PHOTO: "Cover photo",
  PREVIEW: "Preview",
  FLOOR_PLAN: "Floor plan",
  MOOD_BOARD: "Mood board",
  GROUND_BASEMENT_FLOOR_PLAN: "Ground basement floor plan",
  FIRST_FLOOR_PLAN: "First floor plan",
  SECOND_FLOOR_PLAN: "Second floor plan",
  ADU_FIRST_FLOOR_PLAN: "Adu first floor plan",
  ADU_SECOND_FLOOR_PLAN: "Adu second floor plan",
  ADU_EXTERIOR: "Adu exterior",
  ADU_KITCHEN: "Adu kitchen",
  ADU_LIVING: "Adu living",
};

function enumOrDetailOfReadyPlanAssetType(
  enumOrDetail: ReadyPlanAssetTypeDetailOptions | ReadyPlanAssetType | undefined,
): ReadyPlanAssetTypeDetail {
  if (enumOrDetail === undefined) {
    return newReadyPlanAssetTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ReadyPlanAssetTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfReadyPlanAssetType[enumOrDetail.code!],
      ...enumOrDetail,
    } as ReadyPlanAssetTypeDetail;
  } else {
    return newReadyPlanAssetTypeDetail({
      code: enumOrDetail as ReadyPlanAssetType,
      name: enumDetailNameOfReadyPlanAssetType[enumOrDetail as ReadyPlanAssetType],
    });
  }
}

function enumOrDetailOrNullOfReadyPlanAssetType(
  enumOrDetail: ReadyPlanAssetTypeDetailOptions | ReadyPlanAssetType | undefined | null,
): ReadyPlanAssetTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfReadyPlanAssetType(enumOrDetail);
}

const enumDetailNameOfReadyPlanOptionGroupPersonalizationType = {
  SINGLE_PRODUCT: "Single product",
  LINKED_PRODUCT: "Linked product",
  PACKAGE: "Package",
};

function enumOrDetailOfReadyPlanOptionGroupPersonalizationType(
  enumOrDetail:
    | ReadyPlanOptionGroupPersonalizationTypeDetailOptions
    | ReadyPlanOptionGroupPersonalizationType
    | undefined,
): ReadyPlanOptionGroupPersonalizationTypeDetail {
  if (enumOrDetail === undefined) {
    return newReadyPlanOptionGroupPersonalizationTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ReadyPlanOptionGroupPersonalizationTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfReadyPlanOptionGroupPersonalizationType[enumOrDetail.code!],
      ...enumOrDetail,
    } as ReadyPlanOptionGroupPersonalizationTypeDetail;
  } else {
    return newReadyPlanOptionGroupPersonalizationTypeDetail({
      code: enumOrDetail as ReadyPlanOptionGroupPersonalizationType,
      name:
        enumDetailNameOfReadyPlanOptionGroupPersonalizationType[
          enumOrDetail as ReadyPlanOptionGroupPersonalizationType
        ],
    });
  }
}

function enumOrDetailOrNullOfReadyPlanOptionGroupPersonalizationType(
  enumOrDetail:
    | ReadyPlanOptionGroupPersonalizationTypeDetailOptions
    | ReadyPlanOptionGroupPersonalizationType
    | undefined
    | null,
): ReadyPlanOptionGroupPersonalizationTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfReadyPlanOptionGroupPersonalizationType(enumOrDetail);
}

const enumDetailNameOfScheduleFlagReasonType = {
  CLIENT: "Client",
  INTERNAL: "Internal",
  EXTERNAL: "External",
  PERMITTING: "Permitting",
  FIELD: "Field",
  INSPECTION: "Inspection",
  MATERIAL_SUPPLY: "Material supply",
  OTHER: "Other",
  TRADE_PARTNER: "Trade partner",
  WEATHER: "Weather",
};

function enumOrDetailOfScheduleFlagReasonType(
  enumOrDetail: ScheduleFlagReasonTypeDetailOptions | ScheduleFlagReasonType | undefined,
): ScheduleFlagReasonTypeDetail {
  if (enumOrDetail === undefined) {
    return newScheduleFlagReasonTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ScheduleFlagReasonTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfScheduleFlagReasonType[enumOrDetail.code!],
      ...enumOrDetail,
    } as ScheduleFlagReasonTypeDetail;
  } else {
    return newScheduleFlagReasonTypeDetail({
      code: enumOrDetail as ScheduleFlagReasonType,
      name: enumDetailNameOfScheduleFlagReasonType[enumOrDetail as ScheduleFlagReasonType],
    });
  }
}

function enumOrDetailOrNullOfScheduleFlagReasonType(
  enumOrDetail: ScheduleFlagReasonTypeDetailOptions | ScheduleFlagReasonType | undefined | null,
): ScheduleFlagReasonTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfScheduleFlagReasonType(enumOrDetail);
}

const enumDetailNameOfScheduleStatus = { ACTIVE: "Active", COMPLETED: "Completed", DRAFT: "Draft" };

function enumOrDetailOfScheduleStatus(
  enumOrDetail: ScheduleStatusDetailOptions | ScheduleStatus | undefined,
): ScheduleStatusDetail {
  if (enumOrDetail === undefined) {
    return newScheduleStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ScheduleStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfScheduleStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as ScheduleStatusDetail;
  } else {
    return newScheduleStatusDetail({
      code: enumOrDetail as ScheduleStatus,
      name: enumDetailNameOfScheduleStatus[enumOrDetail as ScheduleStatus],
    });
  }
}

function enumOrDetailOrNullOfScheduleStatus(
  enumOrDetail: ScheduleStatusDetailOptions | ScheduleStatus | undefined | null,
): ScheduleStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfScheduleStatus(enumOrDetail);
}

const enumDetailNameOfScheduleTemplateStatus = { DRAFT: "Draft", PUBLISHED: "Published", ARCHIVED: "Archived" };

function enumOrDetailOfScheduleTemplateStatus(
  enumOrDetail: ScheduleTemplateStatusDetailOptions | ScheduleTemplateStatus | undefined,
): ScheduleTemplateStatusDetail {
  if (enumOrDetail === undefined) {
    return newScheduleTemplateStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "ScheduleTemplateStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfScheduleTemplateStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as ScheduleTemplateStatusDetail;
  } else {
    return newScheduleTemplateStatusDetail({
      code: enumOrDetail as ScheduleTemplateStatus,
      name: enumDetailNameOfScheduleTemplateStatus[enumOrDetail as ScheduleTemplateStatus],
    });
  }
}

function enumOrDetailOrNullOfScheduleTemplateStatus(
  enumOrDetail: ScheduleTemplateStatusDetailOptions | ScheduleTemplateStatus | undefined | null,
): ScheduleTemplateStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfScheduleTemplateStatus(enumOrDetail);
}

const enumDetailNameOfSelectionPricingMode = {
  NONE: "None",
  MSRP_ONLY: "Msrp only",
  HB_PRICE_ONLY: "Hb price only",
  MSRP_AND_HB_PRICING: "Msrp and hb pricing",
  PRICE_DELTA: "Price delta",
};

function enumOrDetailOfSelectionPricingMode(
  enumOrDetail: SelectionPricingModeDetailOptions | SelectionPricingMode | undefined,
): SelectionPricingModeDetail {
  if (enumOrDetail === undefined) {
    return newSelectionPricingModeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "SelectionPricingModeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfSelectionPricingMode[enumOrDetail.code!],
      ...enumOrDetail,
    } as SelectionPricingModeDetail;
  } else {
    return newSelectionPricingModeDetail({
      code: enumOrDetail as SelectionPricingMode,
      name: enumDetailNameOfSelectionPricingMode[enumOrDetail as SelectionPricingMode],
    });
  }
}

function enumOrDetailOrNullOfSelectionPricingMode(
  enumOrDetail: SelectionPricingModeDetailOptions | SelectionPricingMode | undefined | null,
): SelectionPricingModeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfSelectionPricingMode(enumOrDetail);
}

const enumDetailNameOfSystemPlanMilestone = {
  MOBILIZATION_START: "Mobilization start",
  VERTICAL_COMPLETE: "Vertical complete",
  PRE_MOBILIZATION_COMPLETE: "Pre mobilization complete",
  CUSTOMER_CONTRACT_SIGNED: "Customer contract signed",
  BUILDING_PERMIT_ISSUED: "Building permit issued",
  FINAL_PUNCH_OUT: "Final punch out",
  MOBILIZATION_COMPLETE: "Mobilization complete",
  DELIVERY_COMPLETE: "Delivery complete",
  BUILDING_PERMIT_SUBMITTED: "Building permit submitted",
};

function enumOrDetailOfSystemPlanMilestone(
  enumOrDetail: SystemPlanMilestoneDetailOptions | SystemPlanMilestone | undefined,
): SystemPlanMilestoneDetail {
  if (enumOrDetail === undefined) {
    return newSystemPlanMilestoneDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "SystemPlanMilestoneDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfSystemPlanMilestone[enumOrDetail.code!],
      ...enumOrDetail,
    } as SystemPlanMilestoneDetail;
  } else {
    return newSystemPlanMilestoneDetail({
      code: enumOrDetail as SystemPlanMilestone,
      name: enumDetailNameOfSystemPlanMilestone[enumOrDetail as SystemPlanMilestone],
    });
  }
}

function enumOrDetailOrNullOfSystemPlanMilestone(
  enumOrDetail: SystemPlanMilestoneDetailOptions | SystemPlanMilestone | undefined | null,
): SystemPlanMilestoneDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfSystemPlanMilestone(enumOrDetail);
}

const enumDetailNameOfSystemTask = {
  CONSTRUCTION_RTS: "Construction rts",
  FRAMING_COMPLETE: "Framing complete",
  DRYWALL_COMPLETE: "Drywall complete",
  DELIVERY_COMPLETE: "Delivery complete",
  VERTICAL_COMPLETE: "Vertical complete",
  ACQUIRED: "Acquired",
  PERMIT_SUBMITTED: "Permit submitted",
  PERMIT_RECEIVED: "Permit received",
  MLS_DATE: "Mls date",
  SALES_READY: "Sales ready",
  BUYER_WALKTHROUGH: "Buyer walkthrough",
  PUNCH_LIST: "Punch list",
};

function enumOrDetailOfSystemTask(enumOrDetail: SystemTaskDetailOptions | SystemTask | undefined): SystemTaskDetail {
  if (enumOrDetail === undefined) {
    return newSystemTaskDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "SystemTaskDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfSystemTask[enumOrDetail.code!],
      ...enumOrDetail,
    } as SystemTaskDetail;
  } else {
    return newSystemTaskDetail({
      code: enumOrDetail as SystemTask,
      name: enumDetailNameOfSystemTask[enumOrDetail as SystemTask],
    });
  }
}

function enumOrDetailOrNullOfSystemTask(
  enumOrDetail: SystemTaskDetailOptions | SystemTask | undefined | null,
): SystemTaskDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfSystemTask(enumOrDetail);
}

const enumDetailNameOfTakeoffLineItemDesignPackageType = {
  REGULAR_PLACEHOLDER: "Regular placeholder",
  REGULAR_PRODUCT_CARD: "Regular product card",
  IDP_SHADOW_PLACEHOLDER: "Idp shadow placeholder",
  IDP_SHADOW_PRODUCT_CARD: "Idp shadow product card",
  RPO_SHADOW_PLACEHOLDER: "Rpo shadow placeholder",
  RPO_SHADOW_PRODUCT_CARD: "Rpo shadow product card",
};

function enumOrDetailOfTakeoffLineItemDesignPackageType(
  enumOrDetail: TakeoffLineItemDesignPackageTypeDetailOptions | TakeoffLineItemDesignPackageType | undefined,
): TakeoffLineItemDesignPackageTypeDetail {
  if (enumOrDetail === undefined) {
    return newTakeoffLineItemDesignPackageTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "TakeoffLineItemDesignPackageTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfTakeoffLineItemDesignPackageType[enumOrDetail.code!],
      ...enumOrDetail,
    } as TakeoffLineItemDesignPackageTypeDetail;
  } else {
    return newTakeoffLineItemDesignPackageTypeDetail({
      code: enumOrDetail as TakeoffLineItemDesignPackageType,
      name: enumDetailNameOfTakeoffLineItemDesignPackageType[enumOrDetail as TakeoffLineItemDesignPackageType],
    });
  }
}

function enumOrDetailOrNullOfTakeoffLineItemDesignPackageType(
  enumOrDetail: TakeoffLineItemDesignPackageTypeDetailOptions | TakeoffLineItemDesignPackageType | undefined | null,
): TakeoffLineItemDesignPackageTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfTakeoffLineItemDesignPackageType(enumOrDetail);
}

const enumDetailNameOfTakeoffLineItemType = { ITI: "Iti", TLIV: "Tliv" };

function enumOrDetailOfTakeoffLineItemType(
  enumOrDetail: TakeoffLineItemTypeDetailOptions | TakeoffLineItemType | undefined,
): TakeoffLineItemTypeDetail {
  if (enumOrDetail === undefined) {
    return newTakeoffLineItemTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "TakeoffLineItemTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfTakeoffLineItemType[enumOrDetail.code!],
      ...enumOrDetail,
    } as TakeoffLineItemTypeDetail;
  } else {
    return newTakeoffLineItemTypeDetail({
      code: enumOrDetail as TakeoffLineItemType,
      name: enumDetailNameOfTakeoffLineItemType[enumOrDetail as TakeoffLineItemType],
    });
  }
}

function enumOrDetailOrNullOfTakeoffLineItemType(
  enumOrDetail: TakeoffLineItemTypeDetailOptions | TakeoffLineItemType | undefined | null,
): TakeoffLineItemTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfTakeoffLineItemType(enumOrDetail);
}

const enumDetailNameOfTaskDependencyType = {
  FINISH_START: "Finish start",
  START_START: "Start start",
  START_FINISH: "Start finish",
  FINISH_FINISH: "Finish finish",
};

function enumOrDetailOfTaskDependencyType(
  enumOrDetail: TaskDependencyTypeDetailOptions | TaskDependencyType | undefined,
): TaskDependencyTypeDetail {
  if (enumOrDetail === undefined) {
    return newTaskDependencyTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "TaskDependencyTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfTaskDependencyType[enumOrDetail.code!],
      ...enumOrDetail,
    } as TaskDependencyTypeDetail;
  } else {
    return newTaskDependencyTypeDetail({
      code: enumOrDetail as TaskDependencyType,
      name: enumDetailNameOfTaskDependencyType[enumOrDetail as TaskDependencyType],
    });
  }
}

function enumOrDetailOrNullOfTaskDependencyType(
  enumOrDetail: TaskDependencyTypeDetailOptions | TaskDependencyType | undefined | null,
): TaskDependencyTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfTaskDependencyType(enumOrDetail);
}

const enumDetailNameOfTimeFrequency = { DAYS: "Days", WEEKS: "Weeks", MONTHS: "Months" };

function enumOrDetailOfTimeFrequency(
  enumOrDetail: TimeFrequencyDetailOptions | TimeFrequency | undefined,
): TimeFrequencyDetail {
  if (enumOrDetail === undefined) {
    return newTimeFrequencyDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "TimeFrequencyDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfTimeFrequency[enumOrDetail.code!],
      ...enumOrDetail,
    } as TimeFrequencyDetail;
  } else {
    return newTimeFrequencyDetail({
      code: enumOrDetail as TimeFrequency,
      name: enumDetailNameOfTimeFrequency[enumOrDetail as TimeFrequency],
    });
  }
}

function enumOrDetailOrNullOfTimeFrequency(
  enumOrDetail: TimeFrequencyDetailOptions | TimeFrequency | undefined | null,
): TimeFrequencyDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfTimeFrequency(enumOrDetail);
}

const enumDetailNameOfTimeOfDay = { MORNING: "Morning", AFTERNOON: "Afternoon", EVENING: "Evening" };

function enumOrDetailOfTimeOfDay(enumOrDetail: TimeOfDayDetailOptions | TimeOfDay | undefined): TimeOfDayDetail {
  if (enumOrDetail === undefined) {
    return newTimeOfDayDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "TimeOfDayDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfTimeOfDay[enumOrDetail.code!],
      ...enumOrDetail,
    } as TimeOfDayDetail;
  } else {
    return newTimeOfDayDetail({
      code: enumOrDetail as TimeOfDay,
      name: enumDetailNameOfTimeOfDay[enumOrDetail as TimeOfDay],
    });
  }
}

function enumOrDetailOrNullOfTimeOfDay(
  enumOrDetail: TimeOfDayDetailOptions | TimeOfDay | undefined | null,
): TimeOfDayDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfTimeOfDay(enumOrDetail);
}

const enumDetailNameOfTrackedJobStatus = {
  PENDING: "Pending",
  RUNNING: "Running",
  COMPLETED: "Completed",
  FAILED: "Failed",
};

function enumOrDetailOfTrackedJobStatus(
  enumOrDetail: TrackedJobStatusDetailOptions | TrackedJobStatus | undefined,
): TrackedJobStatusDetail {
  if (enumOrDetail === undefined) {
    return newTrackedJobStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "TrackedJobStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfTrackedJobStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as TrackedJobStatusDetail;
  } else {
    return newTrackedJobStatusDetail({
      code: enumOrDetail as TrackedJobStatus,
      name: enumDetailNameOfTrackedJobStatus[enumOrDetail as TrackedJobStatus],
    });
  }
}

function enumOrDetailOrNullOfTrackedJobStatus(
  enumOrDetail: TrackedJobStatusDetailOptions | TrackedJobStatus | undefined | null,
): TrackedJobStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfTrackedJobStatus(enumOrDetail);
}

const enumDetailNameOfTradePartnerMarketRole = {
  BILL_APPROVER: "Bill approver",
  CONTRACT_SIGNATORY: "Contract signatory",
  PO_SIGNATORY: "Po signatory",
  PO_RECIPIENT_1: "Po recipient 1",
  PO_RECIPIENT_2: "Po recipient 2",
  ESTIMATING: "Estimating",
  SCHEDULING: "Scheduling",
  LW_SIGNATORY: "Lw signatory",
  SCHEDULING_RECIPIENT_2: "Scheduling recipient 2",
};

function enumOrDetailOfTradePartnerMarketRole(
  enumOrDetail: TradePartnerMarketRoleDetailOptions | TradePartnerMarketRole | undefined,
): TradePartnerMarketRoleDetail {
  if (enumOrDetail === undefined) {
    return newTradePartnerMarketRoleDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "TradePartnerMarketRoleDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfTradePartnerMarketRole[enumOrDetail.code!],
      ...enumOrDetail,
    } as TradePartnerMarketRoleDetail;
  } else {
    return newTradePartnerMarketRoleDetail({
      code: enumOrDetail as TradePartnerMarketRole,
      name: enumDetailNameOfTradePartnerMarketRole[enumOrDetail as TradePartnerMarketRole],
    });
  }
}

function enumOrDetailOrNullOfTradePartnerMarketRole(
  enumOrDetail: TradePartnerMarketRoleDetailOptions | TradePartnerMarketRole | undefined | null,
): TradePartnerMarketRoleDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfTradePartnerMarketRole(enumOrDetail);
}

const enumDetailNameOfTradePartnerRequirementStatus = {
  MEETS: "Meets",
  DOES_NOT_MEET: "Does not meet",
  NA: "Na",
  WAIVER: "Waiver",
};

function enumOrDetailOfTradePartnerRequirementStatus(
  enumOrDetail: TradePartnerRequirementStatusDetailOptions | TradePartnerRequirementStatus | undefined,
): TradePartnerRequirementStatusDetail {
  if (enumOrDetail === undefined) {
    return newTradePartnerRequirementStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "TradePartnerRequirementStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfTradePartnerRequirementStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as TradePartnerRequirementStatusDetail;
  } else {
    return newTradePartnerRequirementStatusDetail({
      code: enumOrDetail as TradePartnerRequirementStatus,
      name: enumDetailNameOfTradePartnerRequirementStatus[enumOrDetail as TradePartnerRequirementStatus],
    });
  }
}

function enumOrDetailOrNullOfTradePartnerRequirementStatus(
  enumOrDetail: TradePartnerRequirementStatusDetailOptions | TradePartnerRequirementStatus | undefined | null,
): TradePartnerRequirementStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfTradePartnerRequirementStatus(enumOrDetail);
}

const enumDetailNameOfTradePartnerRequirementType = {
  W9: "W9",
  WORKERS_COMP: "Workers comp",
  MSA: "Msa",
  GENERAL_LIABILITY: "General liability",
  PROFESSIONAL_LIABILITY: "Professional liability",
  INDUSTRY_LICENSE: "Industry license",
  AUTOMOBILE_LIABILITY: "Automobile liability",
  UMBRELLA_LIABILITY: "Umbrella liability",
  TRADE_SPECIFIC_AGREEMENT: "Trade specific agreement",
  APPLIANCES: "Appliances",
  CABINETS_AND_CABINET_HARDWARE: "Cabinets and cabinet hardware",
  CMU_WALLS: "Cmu walls",
  CONCRETE: "Concrete",
  COUNTERTOPS: "Countertops",
  DRYWALL: "Drywall",
  ELECTRICAL: "Electrical",
  EXTERIOR_SHEATING_FINISH_WINDOWS_EXT_DOORS_WATERPROOFING: "Exterior sheating finish windows ext doors waterproofing",
  FENCES_AND_GATES: "Fences and gates",
  FIREPLACE_INSTALL: "Fireplace install",
  FIRE_SUPRESSION: "Fire supression",
  FLOORING_AND_WALL_SURFACES: "Flooring and wall surfaces",
  FRAMING: "Framing",
  GARAGE_DOORS: "Garage doors",
  GENERAL_CONDITIONS: "General conditions",
  GUTTERS: "Gutters",
  HVAC: "Hvac",
  INSULATION: "Insulation",
  INTERIOR_MILLWORK_DOORS_HARDWARE: "Interior millwork doors hardware",
  LOW_VOLTAGE: "Low voltage",
  MASONRY_WALL_CLADDING: "Masonry wall cladding",
  MIRROR_AND_SHOWER_ECLOSURES: "Mirror and shower eclosures",
  PAINT: "Paint",
  PLANTING_AND_IRRIGATION: "Planting and irrigation",
  PLUMBING: "Plumbing",
  PROGRESSINVE_CLEANUP: "Progressinve cleanup",
  ROOFING: "Roofing",
  SITEWORK: "Sitework",
  SOLAR_PANELS: "Solar panels",
  STAIR_RAILINGS: "Stair railings",
  STUCCO_AND_THIN_VENNER: "Stucco and thin venner",
  SWPP_AND_EROSION_CONTROL: "Swpp and erosion control",
  TERMITE: "Termite",
  WASTE_REMOVAL: "Waste removal",
};

function enumOrDetailOfTradePartnerRequirementType(
  enumOrDetail: TradePartnerRequirementTypeDetailOptions | TradePartnerRequirementType | undefined,
): TradePartnerRequirementTypeDetail {
  if (enumOrDetail === undefined) {
    return newTradePartnerRequirementTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "TradePartnerRequirementTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfTradePartnerRequirementType[enumOrDetail.code!],
      ...enumOrDetail,
    } as TradePartnerRequirementTypeDetail;
  } else {
    return newTradePartnerRequirementTypeDetail({
      code: enumOrDetail as TradePartnerRequirementType,
      name: enumDetailNameOfTradePartnerRequirementType[enumOrDetail as TradePartnerRequirementType],
    });
  }
}

function enumOrDetailOrNullOfTradePartnerRequirementType(
  enumOrDetail: TradePartnerRequirementTypeDetailOptions | TradePartnerRequirementType | undefined | null,
): TradePartnerRequirementTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfTradePartnerRequirementType(enumOrDetail);
}

const enumDetailNameOfUserEventType = {
  CREATED: "Created",
  UPDATED: "Updated",
  ASSIGNED: "Assigned",
  SCHEDULE_CHANGE: "Schedule change",
  COMPLETED: "Completed",
  TAGGED: "Tagged",
  FINALIZED: "Finalized",
  APPROVED: "Approved",
  COMMENTED: "Commented",
  ATTACHED: "Attached",
  PROJECT_COHORT_CHANGE: "Project cohort change",
  LOT_RELEASE: "Lot release",
  PRPC_APPLIED: "Prpc applied",
  PRPC_RESET: "Prpc reset",
  FLAGGED: "Flagged",
  REQUESTED_CHANGES: "Requested changes",
  REJECTED: "Rejected",
  ITEM_ADDED: "Item added",
  ITEM_REMOVED: "Item removed",
  PUBLISHED: "Published",
};

function enumOrDetailOfUserEventType(
  enumOrDetail: UserEventTypeDetailOptions | UserEventType | undefined,
): UserEventTypeDetail {
  if (enumOrDetail === undefined) {
    return newUserEventTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "UserEventTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfUserEventType[enumOrDetail.code!],
      ...enumOrDetail,
    } as UserEventTypeDetail;
  } else {
    return newUserEventTypeDetail({
      code: enumOrDetail as UserEventType,
      name: enumDetailNameOfUserEventType[enumOrDetail as UserEventType],
    });
  }
}

function enumOrDetailOrNullOfUserEventType(
  enumOrDetail: UserEventTypeDetailOptions | UserEventType | undefined | null,
): UserEventTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfUserEventType(enumOrDetail);
}

const enumDetailNameOfUserType = {
  ANONYMOUS: "Anonymous",
  SYSTEM: "System",
  INTERNAL: "Internal",
  HOMEOWNER: "Homeowner",
  TRADE_PARTNER: "Trade partner",
};

function enumOrDetailOfUserType(enumOrDetail: UserTypeDetailOptions | UserType | undefined): UserTypeDetail {
  if (enumOrDetail === undefined) {
    return newUserTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "UserTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfUserType[enumOrDetail.code!],
      ...enumOrDetail,
    } as UserTypeDetail;
  } else {
    return newUserTypeDetail({
      code: enumOrDetail as UserType,
      name: enumDetailNameOfUserType[enumOrDetail as UserType],
    });
  }
}

function enumOrDetailOrNullOfUserType(
  enumOrDetail: UserTypeDetailOptions | UserType | undefined | null,
): UserTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfUserType(enumOrDetail);
}

const enumDetailNameOfWarrantyTicketItemStatus = {
  SUBMITTED: "Submitted",
  REJECTED: "Rejected",
  ACCEPTED: "Accepted",
  ON_HOLD: "On hold",
  SCHEDULED: "Scheduled",
  COMPLETED: "Completed",
  MATERIALS_ORDERED: "Materials ordered",
  IN_PROGRESS: "In progress",
  TRADE_CONTACTED: "Trade contacted",
  PENDING_INFO_FROM_HOMEOWNER: "Pending info from homeowner",
};

function enumOrDetailOfWarrantyTicketItemStatus(
  enumOrDetail: WarrantyTicketItemStatusDetailOptions | WarrantyTicketItemStatus | undefined,
): WarrantyTicketItemStatusDetail {
  if (enumOrDetail === undefined) {
    return newWarrantyTicketItemStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "WarrantyTicketItemStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfWarrantyTicketItemStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as WarrantyTicketItemStatusDetail;
  } else {
    return newWarrantyTicketItemStatusDetail({
      code: enumOrDetail as WarrantyTicketItemStatus,
      name: enumDetailNameOfWarrantyTicketItemStatus[enumOrDetail as WarrantyTicketItemStatus],
    });
  }
}

function enumOrDetailOrNullOfWarrantyTicketItemStatus(
  enumOrDetail: WarrantyTicketItemStatusDetailOptions | WarrantyTicketItemStatus | undefined | null,
): WarrantyTicketItemStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfWarrantyTicketItemStatus(enumOrDetail);
}

const enumDetailNameOfWarrantyTicketItemType = {
  MECHANICAL: "Mechanical",
  ELECTRICAL: "Electrical",
  PLUMBING: "Plumbing",
  MISC_INTERIOR: "Misc interior",
  MISC_EXTERIOR: "Misc exterior",
};

function enumOrDetailOfWarrantyTicketItemType(
  enumOrDetail: WarrantyTicketItemTypeDetailOptions | WarrantyTicketItemType | undefined,
): WarrantyTicketItemTypeDetail {
  if (enumOrDetail === undefined) {
    return newWarrantyTicketItemTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "WarrantyTicketItemTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfWarrantyTicketItemType[enumOrDetail.code!],
      ...enumOrDetail,
    } as WarrantyTicketItemTypeDetail;
  } else {
    return newWarrantyTicketItemTypeDetail({
      code: enumOrDetail as WarrantyTicketItemType,
      name: enumDetailNameOfWarrantyTicketItemType[enumOrDetail as WarrantyTicketItemType],
    });
  }
}

function enumOrDetailOrNullOfWarrantyTicketItemType(
  enumOrDetail: WarrantyTicketItemTypeDetailOptions | WarrantyTicketItemType | undefined | null,
): WarrantyTicketItemTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfWarrantyTicketItemType(enumOrDetail);
}

const enumDetailNameOfWeatherType = {
  CLEAR_DAY: "Clear day",
  PARTLY_CLOUDY_DAY: "Partly cloudy day",
  CLOUDY: "Cloudy",
  WIND: "Wind",
  FOG: "Fog",
  SHOWERS_DAY: "Showers day",
  RAIN: "Rain",
  THUNDER_SHOWERS_DAY: "Thunder showers day",
  THUNDER_DAY: "Thunder day",
  SNOW_SHOWERS_DAY: "Snow showers day",
  SNOW: "Snow",
  SLEET: "Sleet",
  HAIL: "Hail",
  HAZE: "Haze",
  ICE: "Ice",
  SMOKE: "Smoke",
  DUST: "Dust",
};

function enumOrDetailOfWeatherType(
  enumOrDetail: WeatherTypeDetailOptions | WeatherType | undefined,
): WeatherTypeDetail {
  if (enumOrDetail === undefined) {
    return newWeatherTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "WeatherTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfWeatherType[enumOrDetail.code!],
      ...enumOrDetail,
    } as WeatherTypeDetail;
  } else {
    return newWeatherTypeDetail({
      code: enumOrDetail as WeatherType,
      name: enumDetailNameOfWeatherType[enumOrDetail as WeatherType],
    });
  }
}

function enumOrDetailOrNullOfWeatherType(
  enumOrDetail: WeatherTypeDetailOptions | WeatherType | undefined | null,
): WeatherTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfWeatherType(enumOrDetail);
}

const taggedIds: Record<string, string> = {
  "Community": "p",
  "DesignPackage": "rp",
  "Development": "dev",
  "GlobalOptionType": "gotype",
  "Invoice": "inv",
  "Lot": "p",
  "PlanPackage": "rp",
  "Product": "pr",
  "ProductOffering": "rp",
  "Subdivision": "p",
  "StandaloneProject": "p",
  "Structure": "p",
  "Unit": "p",
};
let nextFactoryIds: Record<string, number> = {};

export function resetFactoryIds() {
  nextFactoryIds = {};
}

function nextFactoryId(objectName: string): string {
  const nextId = nextFactoryIds[objectName] || 1;
  nextFactoryIds[objectName] = nextId + 1;
  const tag = taggedIds[objectName] ?? objectName.replace(/[a-z]/g, "").toLowerCase();
  return tag + ":" + nextId;
}

function maybeNew(
  type: string,
  value: { __typename?: string } | object | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): any {
  if (value === undefined) {
    return isSet ? undefined : cache[type] || factories[type]({}, cache);
  } else if ("__typename" in value && value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return factories[type](value, cache);
  }
}

function maybeNewOrNull(
  type: string,
  value: { __typename?: string } | object | undefined | null,
  cache: Record<string, any>,
): any {
  if (!value) {
    return null;
  } else if ("__typename" in value && value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return factories[type](value, cache);
  }
}

import {
  AllocateProjectItemsTaskModalDocument,
  AllocateProjectItemsTaskModalQuery,
  AllocateProjectItemsTaskModalQueryVariables,
} from "../components/AllocateItemsTaskModal.generated";
import {
  MyTasksTestDocument,
  MyTasksTestQuery,
  MyTasksTestQueryVariables,
} from "../components/QueryTable.stories.generated";
import {
  CurrentUserZenDeskJwtDocument,
  CurrentUserZenDeskJwtQuery,
  CurrentUserZenDeskJwtQueryVariables,
} from "../components/ZendeskWidget.generated";
import {
  CreateChangeEventApproval_ImpactedPosTableDocument,
  CreateChangeEventApproval_ImpactedPosTableQuery,
  CreateChangeEventApproval_ImpactedPosTableQueryVariables,
  OpenManyChangeEventApprovalsDocument,
  OpenManyChangeEventApprovalsMutation,
  OpenManyChangeEventApprovalsMutationVariables,
  SubmitChangesForApprovalStep_ChangeBreakdownTableDocument,
  SubmitChangesForApprovalStep_ChangeBreakdownTableQuery,
  SubmitChangesForApprovalStep_ChangeBreakdownTableQueryVariables,
  ToggleCommitmentReleaseDocument,
  ToggleCommitmentReleaseMutation,
  ToggleCommitmentReleaseMutationVariables,
} from "../components/approvals/SubmitChangeEventApprovalStepView.generated";
import {
  UseGlobalOptionTagsFilterDocument,
  UseGlobalOptionTagsFilterQuery,
  UseGlobalOptionTagsFilterQueryVariables,
} from "../components/autoPopulateFilters/useGlobalOptionTagsFilter.generated";
import {
  UseRoomTypeFilterDocument,
  UseRoomTypeFilterQuery,
  UseRoomTypeFilterQueryVariables,
} from "../components/autoPopulateFilters/useRoomTypeFilter.generated";
import {
  BidItemSelectDocument,
  BidItemSelectQuery,
  BidItemSelectQueryVariables,
} from "../components/autoPopulateSelects/BidItemSelect.generated";
import {
  ChangeEventReasonsDocument,
  ChangeEventReasonsQuery,
  ChangeEventReasonsQueryVariables,
} from "../components/autoPopulateSelects/ChangeEventReasonsSelectField.generated";
import {
  CostCodeSelectDocument,
  CostCodeSelectQuery,
  CostCodeSelectQueryVariables,
} from "../components/autoPopulateSelects/CostCodeSelectField.generated";
import {
  CostSourceSelectDocument,
  CostSourceSelectQuery,
  CostSourceSelectQueryVariables,
} from "../components/autoPopulateSelects/CostSourceSelectField.generated";
import {
  GlobalPlanTaskSelectDocument,
  GlobalPlanTaskSelectQuery,
  GlobalPlanTaskSelectQueryVariables,
} from "../components/autoPopulateSelects/GlobalPlanTaskSelectField.generated";
import {
  ItemsSelectDocument,
  ItemsSelectQuery,
  ItemsSelectQueryVariables,
} from "../components/autoPopulateSelects/ItemsSelectField.generated";
import {
  LocationsDocument,
  LocationsQuery,
  LocationsQueryVariables,
} from "../components/autoPopulateSelects/LocationsSelectField.generated";
import {
  MadTypesDocument,
  MadTypesQuery,
  MadTypesQueryVariables,
} from "../components/autoPopulateSelects/MADTypeBoundSelectField.generated";
import {
  ProductSelectDocument,
  ProductSelectQuery,
  ProductSelectQueryVariables,
} from "../components/autoPopulateSelects/ProductSelect.generated";
import {
  ProjectAutocompleteDocument,
  ProjectAutocompleteQuery,
  ProjectAutocompleteQueryVariables,
} from "../components/autoPopulateSelects/ProjectAutocompleteField.generated";
import {
  RoomTypeDocument,
  RoomTypeQuery,
  RoomTypeQueryVariables,
} from "../components/autoPopulateSelects/RoomTypeBoundMultiSelectFilter.generated";
import {
  TradePartnerAutocompleteDocument,
  TradePartnerAutocompleteQuery,
  TradePartnerAutocompleteQueryVariables,
} from "../components/autoPopulateSelects/TradePartnerAutocompleteField.generated";
import {
  TradePartnersSelectDocument,
  TradePartnersSelectQuery,
  TradePartnersSelectQueryVariables,
} from "../components/autoPopulateSelects/TradePartnerSelectField.generated";
import {
  UnitsOfMeasureDocument,
  UnitsOfMeasureQuery,
  UnitsOfMeasureQueryVariables,
} from "../components/autoPopulateSelects/UnitsOfMeasureSelectField.generated";
import {
  GlobalOptionTypesDocument,
  GlobalOptionTypesQuery,
  GlobalOptionTypesQueryVariables,
} from "../components/autoPopulateSelects/useGlobalOptionTypes.generated";
import {
  BidContractPlanPricing_RevisionDocument,
  BidContractPlanPricing_RevisionQuery,
  BidContractPlanPricing_RevisionQueryVariables,
  BidContractPlanPricing_ScopeLinesDocument,
  BidContractPlanPricing_ScopeLinesQuery,
  BidContractPlanPricing_ScopeLinesQueryVariables,
} from "../components/bid-contracts/BidContractPlanPricingPage.generated";
import {
  BidContractPurchaseOrdersPageDocument,
  BidContractPurchaseOrdersPageQuery,
  BidContractPurchaseOrdersPageQueryVariables,
} from "../components/bid-contracts/BidContractPurchaseOrdersPage.generated";
import {
  BidContractRevisionUnitPricingDocument,
  BidContractRevisionUnitPricingQuery,
  BidContractRevisionUnitPricingQueryVariables,
  SaveBidContractUnitPricingDocument,
  SaveBidContractUnitPricingMutation,
  SaveBidContractUnitPricingMutationVariables,
} from "../components/bid-contracts/BidContractUnitPricingPage.generated";
import {
  BidContractsTableV2Document,
  BidContractsTableV2Query,
  BidContractsTableV2QueryVariables,
} from "../components/bid-contracts/BidContractsTableV2.generated";
import {
  BidItemsModalDocument,
  BidItemsModalQuery,
  BidItemsModalQueryVariables,
} from "../components/bid-contracts/BidItemsModal.generated";
import {
  BusinessFunctionDetailsDocument,
  BusinessFunctionDetailsQuery,
  BusinessFunctionDetailsQueryVariables,
  BusinessFunctionsDocument,
  BusinessFunctionsQuery,
  BusinessFunctionsQueryVariables,
  ProjectRolesForBusinessFunctionDocument,
  ProjectRolesForBusinessFunctionQuery,
  ProjectRolesForBusinessFunctionQueryVariables,
  SaveBusinessFunctionDocument,
  SaveBusinessFunctionMutation,
  SaveBusinessFunctionMutationVariables,
} from "../components/change-log/BusinessFunctionsPage.generated";
import {
  ChangeLogMetadataDocument,
  ChangeLogMetadataQuery,
  ChangeLogMetadataQueryVariables,
  ChangeLogProjectFilterMetadataDocument,
  ChangeLogProjectFilterMetadataQuery,
  ChangeLogProjectFilterMetadataQueryVariables,
} from "../components/change-log/ChangeLog.generated";
import {
  ChangeLogRightPaneContentDetailsDocument,
  ChangeLogRightPaneContentDetailsQuery,
  ChangeLogRightPaneContentDetailsQueryVariables,
} from "../components/change-log/ChangeLogRightPaneContent.generated";
import {
  ChangeLogTableDocument,
  ChangeLogTableQuery,
  ChangeLogTableQueryVariables,
} from "../components/change-log/ChangeLogTable.generated";
import {
  ChangeTypesDocument,
  ChangeTypesQuery,
  ChangeTypesQueryVariables,
} from "../components/change-log/ChangeTypesPage.generated";
import {
  ChangeRequestDetailsDocument,
  ChangeRequestDetailsQuery,
  ChangeRequestDetailsQueryVariables,
  CreateChangeRequestMetadataDocument,
  CreateChangeRequestMetadataQuery,
  CreateChangeRequestMetadataQueryVariables,
  SaveChangeRequestDocument,
  SaveChangeRequestMutation,
  SaveChangeRequestMutationVariables,
  SaveChangeRequestsDocument,
  SaveChangeRequestsMutation,
  SaveChangeRequestsMutationVariables,
} from "../components/change-log/CreateChangeRequestDrawer.generated";
import {
  BusinessFunctionAssetsDocument,
  BusinessFunctionAssetsQuery,
  BusinessFunctionAssetsQueryVariables,
  SaveChangeRequestAssetsDocument,
  SaveChangeRequestAssetsMutation,
  SaveChangeRequestAssetsMutationVariables,
} from "../components/change-log/components/BusinessFunctionAssets.generated";
import {
  ChangeRequestGroupModalDocument,
  ChangeRequestGroupModalQuery,
  ChangeRequestGroupModalQueryVariables,
  DeleteChangeRequestGroupDocument,
  DeleteChangeRequestGroupMutation,
  DeleteChangeRequestGroupMutationVariables,
  SaveChangeRequestGroupDocument,
  SaveChangeRequestGroupMutation,
  SaveChangeRequestGroupMutationVariables,
} from "../components/change-log/components/ChangeRequestGroupModal.generated";
import {
  ChangeRequestGroupsForModalDocument,
  ChangeRequestGroupsForModalQuery,
  ChangeRequestGroupsForModalQueryVariables,
  ChangeRequestsDependencyModalDocument,
  ChangeRequestsDependencyModalQuery,
  ChangeRequestsDependencyModalQueryVariables,
  SaveChangeRequestDependencyBlockersDocument,
  SaveChangeRequestDependencyBlockersMutation,
  SaveChangeRequestDependencyBlockersMutationVariables,
  SaveChangeRequestDependencyBlockingDocument,
  SaveChangeRequestDependencyBlockingMutation,
  SaveChangeRequestDependencyBlockingMutationVariables,
  SaveChangeRequestRelatedToDocument,
  SaveChangeRequestRelatedToMutation,
  SaveChangeRequestRelatedToMutationVariables,
} from "../components/change-log/components/DependencyModal.generated";
import {
  ChangeRequestHistoryDocument,
  ChangeRequestHistoryQuery,
  ChangeRequestHistoryQueryVariables,
} from "../components/change-log/components/HistoryTab.generated";
import {
  CommentFeedTradePartnersDocument,
  CommentFeedTradePartnersQuery,
  CommentFeedTradePartnersQueryVariables,
  DeleteCommentDocument,
  DeleteCommentMutation,
  DeleteCommentMutationVariables,
  MarkCommentStreamAsReadDocument,
  MarkCommentStreamAsReadMutation,
  MarkCommentStreamAsReadMutationVariables,
  SaveCommentDocument,
  SaveCommentMutation,
  SaveCommentMutationVariables,
  SaveFollowersDocument,
  SaveFollowersMutation,
  SaveFollowersMutationVariables,
} from "../components/comments/CommentFeed.generated";
import {
  GetCommentsDocument,
  GetCommentsQuery,
  GetCommentsQueryVariables,
} from "../components/comments/CommentsSuperDrawer.generated";
import {
  CommunicationChannelsDocument,
  CommunicationChannelsQuery,
  CommunicationChannelsQueryVariables,
  SaveUserCommunicationPreferenceDocument,
  SaveUserCommunicationPreferenceMutation,
  SaveUserCommunicationPreferenceMutationVariables,
  UserCommunicationPreferencesDocument,
  UserCommunicationPreferencesQuery,
  UserCommunicationPreferencesQueryVariables,
} from "../components/communication-preferences/UserCommunicationPreferences.generated";
import {
  BillDetailPane_AdditionalCommitmentsDocument,
  BillDetailPane_AdditionalCommitmentsQuery,
  BillDetailPane_AdditionalCommitmentsQueryVariables,
  BillDetailPane_NewBillCommitmentLikeDataDocument,
  BillDetailPane_NewBillCommitmentLikeDataQuery,
  BillDetailPane_NewBillCommitmentLikeDataQueryVariables,
  BillDetailPane_SaveApprovalDocument,
  BillDetailPane_SaveApprovalMutation,
  BillDetailPane_SaveApprovalMutationVariables,
  BillDetailPaneDocument,
  BillDetailPaneQuery,
  BillDetailPaneQueryVariables,
  BillPaneDetail_SaveBillDocumentDocument,
  BillPaneDetail_SaveBillDocumentMutation,
  BillPaneDetail_SaveBillDocumentMutationVariables,
} from "../components/detailPane/bill/BillDetailPane.generated";
import {
  DropModalMetadataDocument,
  DropModalMetadataQuery,
  DropModalMetadataQueryVariables,
  SaveDropDocument,
  SaveDropMutation,
  SaveDropMutationVariables,
} from "../components/drops/DropModal.generated";
import {
  DeleteDropDocument,
  DeleteDropMutation,
  DeleteDropMutationVariables,
  DropsPageDocument,
  DropsPageQuery,
  DropsPageQueryVariables,
} from "../components/drops/DropsPage.generated";
import {
  PotentialInvoicesToCreditDocument,
  PotentialInvoicesToCreditQuery,
  PotentialInvoicesToCreditQueryVariables,
} from "../components/formFields/InvoiceNumber.generated";
import {
  UpdateProjectCoverImageDocument,
  UpdateProjectCoverImageMutation,
  UpdateProjectCoverImageMutationVariables,
} from "../components/navigation/CoverImage.generated";
import {
  DeleteToDoDocument,
  DeleteToDoMutation,
  DeleteToDoMutationVariables,
  SaveToDosDocument,
  SaveToDosMutation,
  SaveToDosMutationVariables,
  ToDoModalDataDocument,
  ToDoModalDataQuery,
  ToDoModalDataQueryVariables,
  ToDoModalDocument,
  ToDoModalQuery,
  ToDoModalQueryVariables,
} from "../components/to-dos/ToDoModal.generated";
import {
  MoveToDoDocument,
  MoveToDoMutation,
  MoveToDoMutationVariables,
  ToDosDocument,
  ToDosQuery,
  ToDosQueryVariables,
  ToDoStatusesDocument,
  ToDoStatusesQuery,
  ToDoStatusesQueryVariables,
  ToDoTypesDocument,
  ToDoTypesQuery,
  ToDoTypesQueryVariables,
} from "../components/to-dos/ToDosBoard.generated";
import {
  CreateAssetDocument,
  CreateAssetMutation,
  CreateAssetMutationVariables,
  CreateDocumentPendingUploadDocument,
  CreateDocumentPendingUploadMutation,
  CreateDocumentPendingUploadMutationVariables,
  MarkDocumentAsUploadedDocument,
  MarkDocumentAsUploadedMutation,
  MarkDocumentAsUploadedMutationVariables,
} from "../components/uploader/DocumentUploader.generated";
import {
  CreateAssetUploadUrlDocument,
  CreateAssetUploadUrlMutation,
  CreateAssetUploadUrlMutationVariables,
} from "../components/uploader/UppyUploader.generated";
import {
  DevelopmentFeatureFlagsDocument,
  DevelopmentFeatureFlagsQuery,
  DevelopmentFeatureFlagsQueryVariables,
  ProjectFeatureFlagsDocument,
  ProjectFeatureFlagsQuery,
  ProjectFeatureFlagsQueryVariables,
  UserFeatureFlagsDocument,
  UserFeatureFlagsQuery,
  UserFeatureFlagsQueryVariables,
} from "../contexts/FeatureFlags/FeatureFlagContext.generated";
import {
  MaterialTypesDocument,
  MaterialTypesQuery,
  MaterialTypesQueryVariables,
} from "../hooks/enums/useMaterialTypes.generated";
import {
  MarketFilterMetadataDocument,
  MarketFilterMetadataQuery,
  MarketFilterMetadataQueryVariables,
} from "../hooks/filters/markets/useMarketFilter.generated";
import {
  ReadyPlanStatusFilterMetadataDocument,
  ReadyPlanStatusFilterMetadataQuery,
  ReadyPlanStatusFilterMetadataQueryVariables,
} from "../hooks/filters/readyPlanStatus/useReadyPlanStatusFilter.generated";
import {
  InternalUsersDocument,
  InternalUsersQuery,
  InternalUsersQueryVariables,
} from "../hooks/useInternalUsers.generated";
import {
  UseLocationsTreeDocument,
  UseLocationsTreeQuery,
  UseLocationsTreeQueryVariables,
} from "../hooks/useLocationsTree.generated";
import {
  ProjectLocationsTreeDocument,
  ProjectLocationsTreeQuery,
  ProjectLocationsTreeQueryVariables,
} from "../hooks/useProjectLocationsTree.generated";
import {
  TrackedJobsPollDocument,
  TrackedJobsPollQuery,
  TrackedJobsPollQueryVariables,
} from "../hooks/useTrackedJobs.generated";
import {
  CompleteStageDocument,
  CompleteStageMutation,
  CompleteStageMutationVariables,
} from "../mutations/completeStage.generated";
import {
  SaveProjectStageDocument,
  SaveProjectStageMutation,
  SaveProjectStageMutationVariables,
} from "../mutations/saveProjectStage.generated";
import {
  CostConfidencesDocument,
  CostConfidencesQuery,
  CostConfidencesQueryVariables,
} from "../queries/CostConfidence.generated";
import {
  CurrentInternalUserDocument,
  CurrentInternalUserQuery,
  CurrentInternalUserQueryVariables,
} from "../queries/user.generated";
import {
  ToggleProjectFeatureDocument,
  ToggleProjectFeatureMutation,
  ToggleProjectFeatureMutationVariables,
} from "../routes/admin/components/ProjectFeaturesCell.generated";
import {
  SetProjectStatusDocument,
  SetProjectStatusMutation,
  SetProjectStatusMutationVariables,
} from "../routes/admin/components/ProjectStatusCell.generated";
import {
  CostCodeHistoryDocument,
  CostCodeHistoryQuery,
  CostCodeHistoryQueryVariables,
} from "../routes/admin/costCodes/CostCodeHistoryTab.generated";
import {
  CostCodeMaterialLeadTimesTabDocument,
  CostCodeMaterialLeadTimesTabQuery,
  CostCodeMaterialLeadTimesTabQueryVariables,
} from "../routes/admin/costCodes/CostCodeMaterialLeadTimesTab.generated";
import {
  CostCodeOverviewTabDocument,
  CostCodeOverviewTabMetadataDocument,
  CostCodeOverviewTabMetadataQuery,
  CostCodeOverviewTabMetadataQueryVariables,
  CostCodeOverviewTabQuery,
  CostCodeOverviewTabQueryVariables,
  SaveCostCodesDocument,
  SaveCostCodesMutation,
  SaveCostCodesMutationVariables,
} from "../routes/admin/costCodes/CostCodeOverviewTab.generated";
import {
  CostCodesDocument,
  CostCodesQuery,
  CostCodesQueryVariables,
  DeleteCostCodeDocument,
  DeleteCostCodeMutation,
  DeleteCostCodeMutationVariables,
} from "../routes/admin/costCodes/CostCodes.generated";
import {
  ItemsDrawerDocument,
  ItemsDrawerQuery,
  ItemsDrawerQueryVariables,
} from "../routes/admin/costCodes/ItemsDrawer.generated";
import {
  FeatureFlagsDocument,
  FeatureFlagsMetadataDocument,
  FeatureFlagsMetadataQuery,
  FeatureFlagsMetadataQueryVariables,
  FeatureFlagsQuery,
  FeatureFlagsQueryVariables,
  SaveFeatureFlagDocument,
  SaveFeatureFlagMutation,
  SaveFeatureFlagMutationVariables,
} from "../routes/admin/featureFlags/FeatureFlags.generated";
import {
  AdminItemsDrawerDocument,
  AdminItemsDrawerQuery,
  AdminItemsDrawerQueryVariables,
  SaveItemDimensionsDocument,
  SaveItemDimensionsMutation,
  SaveItemDimensionsMutationVariables,
} from "../routes/admin/items/AdminItemsDrawer.generated";
import {
  ItemEditorHistoryDocument,
  ItemEditorHistoryQuery,
  ItemEditorHistoryQueryVariables,
} from "../routes/admin/items/ItemEditorHistoryTab.generated";
import {
  ItemEditorTabMetadataDocument,
  ItemEditorTabMetadataQuery,
  ItemEditorTabMetadataQueryVariables,
} from "../routes/admin/items/ItemEditorTab.generated";
import {
  ItemsDocument,
  ItemsPageMetadataDocument,
  ItemsPageMetadataQuery,
  ItemsPageMetadataQueryVariables,
  ItemsQuery,
  ItemsQueryVariables,
  SaveItemDocument,
  SaveItemMutation,
  SaveItemMutationVariables,
} from "../routes/admin/items/ItemsPage.generated";
import {
  MaterialLeadTimesEditorTabDocument,
  MaterialLeadTimesEditorTabMetadataDocument,
  MaterialLeadTimesEditorTabMetadataQuery,
  MaterialLeadTimesEditorTabMetadataQueryVariables,
  MaterialLeadTimesEditorTabQuery,
  MaterialLeadTimesEditorTabQueryVariables,
} from "../routes/admin/items/MaterialLeadTimesEditorTab.generated";
import {
  AdminLocationsPageDocument,
  AdminLocationsPageQuery,
  AdminLocationsPageQueryVariables,
} from "../routes/admin/locations/LocationsPage.generated";
import {
  AdminLocationDrawerDocument,
  AdminLocationDrawerQuery,
  AdminLocationDrawerQueryVariables,
  SaveAdminLocationDrawerDocument,
  SaveAdminLocationDrawerMutation,
  SaveAdminLocationDrawerMutationVariables,
} from "../routes/admin/locations/components/LocationDrawer.generated";
import {
  AdminProjectsFilterDataDocument,
  AdminProjectsFilterDataQuery,
  AdminProjectsFilterDataQueryVariables,
  ProjectsDocument,
  ProjectsQuery,
  ProjectsQueryVariables,
  SetProjectIsTestDocument,
  SetProjectIsTestMutation,
  SetProjectIsTestMutationVariables,
  SetQbCustomerIdDocument,
  SetQbCustomerIdMutation,
  SetQbCustomerIdMutationVariables,
} from "../routes/admin/projects/Admin.generated";
import {
  RemoveUserGroupDocument,
  RemoveUserGroupMutation,
  RemoveUserGroupMutationVariables,
  SaveUserGroupDocument,
  SaveUserGroupMutation,
  SaveUserGroupMutationVariables,
  UserGroupsDocument,
  UserGroupsMetadataDocument,
  UserGroupsMetadataQuery,
  UserGroupsMetadataQueryVariables,
  UserGroupsQuery,
  UserGroupsQueryVariables,
} from "../routes/admin/userGroups/UserGroups.generated";
import {
  ActivateUsersDocument,
  ActivateUsersMutation,
  ActivateUsersMutationVariables,
  DeactivateUsersDocument,
  DeactivateUsersMutation,
  DeactivateUsersMutationVariables,
  UsersPageDocument,
  UsersPageQuery,
  UsersPageQueryVariables,
} from "../routes/admin/users/UsersPage.generated";
import {
  BidPackageDetailPageDocument,
  BidPackageDetailPageQuery,
  BidPackageDetailPageQueryVariables,
  BidPackageVersionDetailPageDocument,
  BidPackageVersionDetailPageQuery,
  BidPackageVersionDetailPageQueryVariables,
} from "../routes/bids/BidPackageDetailPage.generated";
import {
  BidPackageGroupsDocument,
  BidPackageGroupsQuery,
  BidPackageGroupsQueryVariables,
  BidPackagesPageMetadataDocument,
  BidPackagesPageMetadataQuery,
  BidPackagesPageMetadataQueryVariables,
  DeleteBidPackageDocument,
  DeleteBidPackageMutation,
  DeleteBidPackageMutationVariables,
} from "../routes/bids/BidPackagesPage.generated";
import {
  AddBidPackagePage_OriginatingProjectDocument,
  AddBidPackagePage_OriginatingProjectQuery,
  AddBidPackagePage_OriginatingProjectQueryVariables,
  AddBidPackagePageDocument,
  AddBidPackagePageQuery,
  AddBidPackagePageQueryVariables,
  OverlappingBidPackagesDocument,
  OverlappingBidPackagesQuery,
  OverlappingBidPackagesQueryVariables,
  SaveBidPackagesDocument,
  SaveBidPackagesMutation,
  SaveBidPackagesMutationVariables,
} from "../routes/bids/add-bid-package/AddBidPackagePage.generated";
import {
  BidPackageDetailsStepDocument,
  BidPackageDetailsStepQuery,
  BidPackageDetailsStepQueryVariables,
} from "../routes/bids/add-bid-package/components/1.BidPackageDetailsStep.generated";
import {
  ReviewScopeStep_BidPackageGroupDocument,
  ReviewScopeStep_BidPackageGroupQuery,
  ReviewScopeStep_BidPackageGroupQueryVariables,
} from "../routes/bids/add-bid-package/components/2.ReviewScopeStep.generated";
import {
  ReviewUnitBidScopeStep_BidPackageGroupDocument,
  ReviewUnitBidScopeStep_BidPackageGroupQuery,
  ReviewUnitBidScopeStep_BidPackageGroupQueryVariables,
} from "../routes/bids/add-bid-package/components/2.ReviewUnitBidScopeStep.generated";
import {
  SelectBiddersStepDocument,
  SelectBiddersStepQuery,
  SelectBiddersStepQueryVariables,
} from "../routes/bids/add-bid-package/components/3.SelectBiddersStep.generated";
import {
  ReviewAndSendStepDocument,
  ReviewAndSendStepQuery,
  ReviewAndSendStepQueryVariables,
} from "../routes/bids/add-bid-package/components/5.ReviewAndSendStep.generated";
import {
  BidMetaDocument,
  BidMetaQuery,
  BidMetaQueryVariables,
  BidPackageLineItemModalDocument,
  BidPackageLineItemModalQuery,
  BidPackageLineItemModalQueryVariables,
  EditBidMetaDocument,
  EditBidMetaQuery,
  EditBidMetaQueryVariables,
} from "../routes/bids/add-bid-package/components/BidPackageLineItemModal.generated";
import {
  BidScopeFieldsDocument,
  BidScopeFieldsQuery,
  BidScopeFieldsQueryVariables,
} from "../routes/bids/add-bid-package/components/BidScopeFields.generated";
import {
  AddTradePartnerModalDocument,
  AddTradePartnerModalQuery,
  AddTradePartnerModalQueryVariables,
} from "../routes/bids/components/AddTradePartnerModal.generated";
import {
  AwardBidModalDocument,
  AwardBidModalQuery,
  AwardBidModalQueryVariables,
  SaveBidPackageAwardsDocument,
  SaveBidPackageAwardsMutation,
  SaveBidPackageAwardsMutationVariables,
} from "../routes/bids/components/AwardBidModal.generated";
import {
  AcceptBidPackageUpdatesDocument,
  AcceptBidPackageUpdatesMutation,
  AcceptBidPackageUpdatesMutationVariables,
  BidUpdatesAvailable_BidPackageDocument,
  BidUpdatesAvailable_BidPackageQuery,
  BidUpdatesAvailable_BidPackageQueryVariables,
} from "../routes/bids/components/BidUpdatesAvailable.generated";
import {
  ResendBidPackageRequestNotificationDocument,
  ResendBidPackageRequestNotificationMutation,
  ResendBidPackageRequestNotificationMutationVariables,
  SaveBidPackageRequestDocument,
  SaveBidPackageRequestMutation,
  SaveBidPackageRequestMutationVariables,
} from "../routes/bids/components/BiddersTab.generated";
import {
  BillTermsTab_BasePlanGlobalPlanTasksDocument,
  BillTermsTab_BasePlanGlobalPlanTasksQuery,
  BillTermsTab_BasePlanGlobalPlanTasksQueryVariables,
  BillTermsTab_SaveBidContractRevisionDocument,
  BillTermsTab_SaveBidContractRevisionMutation,
  BillTermsTab_SaveBidContractRevisionMutationVariables,
} from "../routes/bids/components/BillTermsTab.generated";
import {
  EditBidPackageDetailsStepDocument,
  EditBidPackageDetailsStepQuery,
  EditBidPackageDetailsStepQueryVariables,
  SaveBidPackageDocument,
  SaveBidPackageMutation,
  SaveBidPackageMutationVariables,
} from "../routes/bids/components/EditBidPackageModal.generated";
import {
  EditBidLineItemDocument,
  EditBidLineItemMutation,
  EditBidLineItemMutationVariables,
  EditBidRightPane_SaveBidContractDocument,
  EditBidRightPane_SaveBidContractMutation,
  EditBidRightPane_SaveBidContractMutationVariables,
  EditBidRightPane_SaveBidContractRevisionDocument,
  EditBidRightPane_SaveBidContractRevisionMutation,
  EditBidRightPane_SaveBidContractRevisionMutationVariables,
} from "../routes/bids/components/EditBidRightPane.generated";
import {
  EditTradeContactsModalDocument,
  EditTradeContactsModalQuery,
  EditTradeContactsModalQueryVariables,
} from "../routes/bids/components/EditTradeContactsModal.generated";
import {
  PlanBasedBidsTable_AggregateVersionsDocument,
  PlanBasedBidsTable_AggregateVersionsQuery,
  PlanBasedBidsTable_AggregateVersionsQueryVariables,
  PlanBasedBidsTable_ScopeLinesDocument,
  PlanBasedBidsTable_ScopeLinesQuery,
  PlanBasedBidsTable_ScopeLinesQueryVariables,
} from "../routes/bids/components/PlanBasedBidsTable.generated";
import {
  AddProrationBidContractDocument,
  AddProrationBidContractMutation,
  AddProrationBidContractMutationVariables,
  AddProrationBidContractRevisionDocument,
  AddProrationBidContractRevisionMutation,
  AddProrationBidContractRevisionMutationVariables,
  EditProratedBidRevisionDocument,
  EditProratedBidRevisionQuery,
  EditProratedBidRevisionQueryVariables,
  SaveProrationTradeLineItemsDocument,
  SaveProrationTradeLineItemsMutation,
  SaveProrationTradeLineItemsMutationVariables,
} from "../routes/bids/components/ProrateBidModal.generated";
import {
  UnitBasedBidsTableDocument,
  UnitBasedBidsTableQuery,
  UnitBasedBidsTableQueryVariables,
} from "../routes/bids/components/UnitBasedBidsTable.generated";
import {
  FinancesPageSharedDocument,
  FinancesPageSharedQuery,
  FinancesPageSharedQueryVariables,
} from "../routes/billing/FinancesPage.generated";
import {
  CreateInvoiceTermsMetadataDocument,
  CreateInvoiceTermsMetadataQuery,
  CreateInvoiceTermsMetadataQueryVariables,
} from "../routes/billing/invoice-terms/components/CreateInvoiceTermsModal.generated";
import {
  InvoiceTermsFormDocument,
  InvoiceTermsFormMetadataDocument,
  InvoiceTermsFormMetadataQuery,
  InvoiceTermsFormMetadataQueryVariables,
  InvoiceTermsFormQuery,
  InvoiceTermsFormQueryVariables,
  SaveInvoiceTermsDocument,
  SaveInvoiceTermsMutation,
  SaveInvoiceTermsMutationVariables,
} from "../routes/billing/invoice-terms/components/InvoiceTermsForm.generated";
import {
  InvoiceTermsDocument,
  InvoiceTermsQuery,
  InvoiceTermsQueryVariables,
} from "../routes/billing/invoice-terms/components/InvoiceTermsTable.generated";
import {
  BillEditor_BillDocument,
  BillEditor_BillQuery,
  BillEditor_BillQueryVariables,
  BillEditor_CalculateDueDateDocument,
  BillEditor_CalculateDueDateQuery,
  BillEditor_CalculateDueDateQueryVariables,
  BillEditor_CommitmentLikesDocument,
  BillEditor_CommitmentLikesQuery,
  BillEditor_CommitmentLikesQueryVariables,
  BillEditor_CommitmentsDocument,
  BillEditor_CommitmentsQuery,
  BillEditor_CommitmentsQueryVariables,
  BillEditor_CreateBillOcrDocument,
  BillEditor_CreateBillOcrMutation,
  BillEditor_CreateBillOcrMutationVariables,
  BillEditor_CreateCommitmentDocument,
  BillEditor_CreateCommitmentMutation,
  BillEditor_CreateCommitmentMutationVariables,
  BillEditor_ProjectItemDocument,
  BillEditor_ProjectItemQuery,
  BillEditor_ProjectItemQueryVariables,
  BillEditor_ProjectItemsDocument,
  BillEditor_ProjectItemsQuery,
  BillEditor_ProjectItemsQueryVariables,
  BillEditor_ReviewReasonsDetailsDocument,
  BillEditor_ReviewReasonsDetailsQuery,
  BillEditor_ReviewReasonsDetailsQueryVariables,
  BillEditor_SaveBillDocument,
  BillEditor_SaveBillMutation,
  BillEditor_SaveBillMutationVariables,
  BillEditor_SaveChangeEventDocument,
  BillEditor_SaveChangeEventMutation,
  BillEditor_SaveChangeEventMutationVariables,
} from "../routes/bills/BillEditor.generated";
import {
  BillDocument,
  BillIntacctSyncErrorDocument,
  BillIntacctSyncErrorQuery,
  BillIntacctSyncErrorQueryVariables,
  BillPage_BillIntacctSyncErrorDocument,
  BillPage_BillIntacctSyncErrorQuery,
  BillPage_BillIntacctSyncErrorQueryVariables,
  BillPage_CommitmentIdByChangeOrderDocument,
  BillPage_CommitmentIdByChangeOrderQuery,
  BillPage_CommitmentIdByChangeOrderQueryVariables,
  BillPage_DeleteBillDocument,
  BillPage_DeleteBillMutation,
  BillPage_DeleteBillMutationVariables,
  BillPage_NewBillChangeOrderDataDocument,
  BillPage_NewBillChangeOrderDataQuery,
  BillPage_NewBillChangeOrderDataQueryVariables,
  BillPage_NewBillCommitmentDataDocument,
  BillPage_NewBillCommitmentDataQuery,
  BillPage_NewBillCommitmentDataQueryVariables,
  BillPage_SaveApproverDocument,
  BillPage_SaveApproverMutation,
  BillPage_SaveApproverMutationVariables,
  BillPage_SaveBillDocument,
  BillPage_SaveBillMutation,
  BillPage_SaveBillMutationVariables,
  BillPage_SyncBillToIntacctDocument,
  BillPage_SyncBillToIntacctMutation,
  BillPage_SyncBillToIntacctMutationVariables,
  BillPageDocument,
  BillPageQuery,
  BillPageQueryVariables,
  BillQuery,
  BillQueryVariables,
  DeleteBillDocument,
  DeleteBillMutation,
  DeleteBillMutationVariables,
  SaveBillDocument,
  SaveBillMutation,
  SaveBillMutationVariables,
  SyncBillToIntacctDocument,
  SyncBillToIntacctMutation,
  SyncBillToIntacctMutationVariables,
} from "../routes/bills/BillPage.generated";
import {
  BillsChartsDocument,
  BillsChartsQuery,
  BillsChartsQueryVariables,
} from "../routes/bills/BillsCharts.generated";
import { BillsDocument, BillsQuery, BillsQueryVariables } from "../routes/bills/BillsPage.generated";
import {
  OtherBillCellDocument,
  OtherBillCellQuery,
  OtherBillCellQueryVariables,
} from "../routes/bills/components/OtherBillCell.generated";
import {
  SaveLienWaiverDocumentDocument,
  SaveLienWaiverDocumentMutation,
  SaveLienWaiverDocumentMutationVariables,
} from "../routes/bills/components/UploadLienWaiver.generated";
import {
  ApprovalSuperDrawer_SaveApprovalDocument,
  ApprovalSuperDrawer_SaveApprovalMutation,
  ApprovalSuperDrawer_SaveApprovalMutationVariables,
  ApprovalSuperDrawerDocument,
  ApprovalSuperDrawerQuery,
  ApprovalSuperDrawerQueryVariables,
} from "../routes/components/Approval/ApprovalSuperDrawer.generated";
import {
  ApprovalChangeEventDocument,
  ApprovalChangeEventQuery,
  ApprovalChangeEventQueryVariables,
  SaveApprovalChangeEventDocument,
  SaveApprovalChangeEventMutation,
  SaveApprovalChangeEventMutationVariables,
} from "../routes/components/Approval/changeEvents/ApprovalChangeEvent.generated";
import {
  ApprovalChangeEventBreakDownTabDocument,
  ApprovalChangeEventBreakDownTabQuery,
  ApprovalChangeEventBreakDownTabQueryVariables,
} from "../routes/components/Approval/changeEvents/ApprovalChangeEventBreakDown.generated";
import {
  ApprovalChangeEventImpactedPosTableTabDocument,
  ApprovalChangeEventImpactedPosTableTabQuery,
  ApprovalChangeEventImpactedPosTableTabQueryVariables,
} from "../routes/components/Approval/changeEvents/ApprovalChangeEventImpactedPosTable.generated";
import {
  BulkAddItemCostCodesDocument,
  BulkAddItemCostCodesQuery,
  BulkAddItemCostCodesQueryVariables,
} from "../routes/components/BulkAddItemCostCodesModal.generated";
import {
  BulkAddProjectItemsDocument,
  BulkAddProjectItemsQuery,
  BulkAddProjectItemsQueryVariables,
} from "../routes/components/BulkAddProjectItemsModal.generated";
import {
  DeleteDevelopmentCommitmentDocument,
  DeleteDevelopmentCommitmentMutation,
  DeleteDevelopmentCommitmentMutationVariables,
  DevelopmentCommitmentDocument,
  DevelopmentCommitmentQuery,
  DevelopmentCommitmentQueryVariables,
  SavePandaDocDocument,
  SavePandaDocMutation,
  SavePandaDocMutationVariables,
} from "../routes/development-commitments/DevelopmentCommitmentPage.generated";
import {
  DevelopmentCommitmentsPageDocument,
  DevelopmentCommitmentsPageMetaDataDocument,
  DevelopmentCommitmentsPageMetaDataQuery,
  DevelopmentCommitmentsPageMetaDataQueryVariables,
  DevelopmentCommitmentsPageQuery,
  DevelopmentCommitmentsPageQueryVariables,
} from "../routes/development-commitments/DevelopmentCommitmentsPage.generated";
import {
  AddCommitmentPotentialLineItemsDocument,
  AddCommitmentPotentialLineItemsQuery,
  AddCommitmentPotentialLineItemsQueryVariables,
  UpdateDevelopmentCommitmentDocument,
  UpdateDevelopmentCommitmentMutation,
  UpdateDevelopmentCommitmentMutationVariables,
} from "../routes/development-commitments/components/AddItemsModal.generated";
import {
  CreateCommitmentDataDocument,
  CreateCommitmentDataQuery,
  CreateCommitmentDataQueryVariables,
  CreateCommitmentPotentialLineItemsDocument,
  CreateCommitmentPotentialLineItemsQuery,
  CreateCommitmentPotentialLineItemsQueryVariables,
  CreateDevelopmentCommitmentDocument,
  CreateDevelopmentCommitmentMutation,
  CreateDevelopmentCommitmentMutationVariables,
} from "../routes/development-commitments/components/CreateCommitmentModal.generated";
import {
  DevelopmentCommitmentHistoryTabDocument,
  DevelopmentCommitmentHistoryTabQuery,
  DevelopmentCommitmentHistoryTabQueryVariables,
} from "../routes/development-commitments/components/HistoryTab.generated";
import {
  DeleteCommitmentLineItemsDocument,
  DeleteCommitmentLineItemsMutation,
  DeleteCommitmentLineItemsMutationVariables,
  DevelopmentCommitmentLineItemsDocument,
  DevelopmentCommitmentLineItemsQuery,
  DevelopmentCommitmentLineItemsQueryVariables,
  SaveCommitmentLineItemsDocument,
  SaveCommitmentLineItemsMutation,
  SaveCommitmentLineItemsMutationVariables,
} from "../routes/development-commitments/components/LineItemsTab.generated";
import {
  DevelopmentCommitmentOverviewTabDocument,
  DevelopmentCommitmentOverviewTabQuery,
  DevelopmentCommitmentOverviewTabQueryVariables,
  SaveDevelopmentCommitmentDocument,
  SaveDevelopmentCommitmentMutation,
  SaveDevelopmentCommitmentMutationVariables,
} from "../routes/development-commitments/components/OverviewTab.generated";
import {
  DeleteDevelopmentCommitmentProjectsAndCommitmentsDocument,
  DeleteDevelopmentCommitmentProjectsAndCommitmentsMutation,
  DeleteDevelopmentCommitmentProjectsAndCommitmentsMutationVariables,
  DevelopmentCommitmentV2ProjectsTabDocument,
  DevelopmentCommitmentV2ProjectsTabQuery,
  DevelopmentCommitmentV2ProjectsTabQueryVariables,
} from "../routes/development-commitments/components/ProjectsTab.generated";
import {
  DevelopmentCommitmentScheduleAndScopeTabDocument,
  DevelopmentCommitmentScheduleAndScopeTabQuery,
  DevelopmentCommitmentScheduleAndScopeTabQueryVariables,
} from "../routes/development-commitments/components/ScheduleAndScopeTab.generated";
import {
  DevelopmentAllLotsDocument,
  DevelopmentAllLotsQuery,
  DevelopmentAllLotsQueryVariables,
} from "../routes/developments/DevelopmentAllLots.generated";
import {
  DevelopmentDetailDocument,
  DevelopmentDetailQuery,
  DevelopmentDetailQueryVariables,
  DevelopmentsDocument,
  DevelopmentsPageMetadataDocument,
  DevelopmentsPageMetadataQuery,
  DevelopmentsPageMetadataQueryVariables,
  DevelopmentsQuery,
  DevelopmentsQueryVariables,
  SaveDevelopmentsDocument,
  SaveDevelopmentsMutation,
  SaveDevelopmentsMutationVariables,
} from "../routes/developments/Developments.generated";
import {
  AssignElevationListDocument,
  AssignElevationListQuery,
  AssignElevationListQueryVariables,
  SaveElevationAssignmentDocument,
  SaveElevationAssignmentMutation,
  SaveElevationAssignmentMutationVariables,
} from "../routes/developments/components/AssignElevationsModalButton.generated";
import {
  ItemTemplateCostUpdatesDocument,
  ItemTemplateCostUpdatesQuery,
  ItemTemplateCostUpdatesQueryVariables,
} from "../routes/developments/components/DevelopmentContractHeader.generated";
import {
  SavePriceAgreementDocumentDocument,
  SavePriceAgreementDocumentMutation,
  SavePriceAgreementDocumentMutationVariables,
} from "../routes/developments/components/UploadPriceAgreement.generated";
import {
  CohortDetailsForFormDocument,
  CohortDetailsForFormQuery,
  CohortDetailsForFormQueryVariables,
  PopulateCohortFormOptionsDocument,
  PopulateCohortFormOptionsQuery,
  PopulateCohortFormOptionsQueryVariables,
  SaveCohortsDocument,
  SaveCohortsMutation,
  SaveCohortsMutationVariables,
} from "../routes/developments/components/cohorts/CreateOrUpdateCohortModal.generated";
import {
  AssignWorkToBidContractsDocument,
  AssignWorkToBidContractsMutation,
  AssignWorkToBidContractsMutationVariables,
  ManageProjectsBudgetsStepDocument,
  ManageProjectsBudgetsStepQuery,
  ManageProjectsBudgetsStepQueryVariables,
} from "../routes/developments/components/upload/manageProjectsBudgetStep/ManageProjectsBudgetsPage.generated";
import {
  DevelopmentScheduleItemMappingPageDocument,
  DevelopmentScheduleItemMappingPageQuery,
  DevelopmentScheduleItemMappingPageQueryVariables,
} from "../routes/developments/cost-mapping/DevelopmentScheduleCostMappingPage.generated";
import {
  CostMappingScheduleTasksDocument,
  CostMappingScheduleTasksQuery,
  CostMappingScheduleTasksQueryVariables,
  SaveMapItemsStepDocument,
  SaveMapItemsStepMutation,
  SaveMapItemsStepMutationVariables,
} from "../routes/developments/cost-mapping/mapping-steps/MapItemsStep.generated";
import {
  LotSummaryChartsDocument,
  LotSummaryChartsQuery,
  LotSummaryChartsQueryVariables,
} from "../routes/developments/lot-summary/LotSummaryCharts.generated";
import {
  LotSummaryMetaDataDocument,
  LotSummaryMetaDataQuery,
  LotSummaryMetaDataQueryVariables,
  SubscribeToSequenceSheetDocument,
  SubscribeToSequenceSheetMutation,
  SubscribeToSequenceSheetMutationVariables,
} from "../routes/developments/lot-summary/LotSummaryPage.generated";
import {
  AssignWorkToBidContractDocument,
  AssignWorkToBidContractMutation,
  AssignWorkToBidContractMutationVariables,
  ConfirmTrades_ProjectItemsDocument,
  ConfirmTrades_ProjectItemsQuery,
  ConfirmTrades_ProjectItemsQueryVariables,
  ConfirmTradesStepDocument,
  ConfirmTradesStepQuery,
  ConfirmTradesStepQueryVariables,
  UnassignWorkFromBidContractDocument,
  UnassignWorkFromBidContractMutation,
  UnassignWorkFromBidContractMutationVariables,
} from "../routes/developments/lot-summary/lot-release/ConfirmTradesStep.generated";
import {
  ReleaseToTradesPageDocument,
  ReleaseToTradesPageQuery,
  ReleaseToTradesPageQueryVariables,
} from "../routes/developments/lot-summary/lot-release/ReleaseToTradesPage.generated";
import {
  ApplyProjectReadyPlanConfigsDocument,
  ApplyProjectReadyPlanConfigsMutation,
  ApplyProjectReadyPlanConfigsMutationVariables,
  ReleaseToTradesTabDocument,
  ReleaseToTradesTabQuery,
  ReleaseToTradesTabQueryVariables,
} from "../routes/developments/lot-summary/lot-release/ReleaseToTradesTab.generated";
import {
  ReviewOrdersStepDocument,
  ReviewOrdersStepQuery,
  ReviewOrdersStepQueryVariables,
  ReviewOrdersStepReleaseCommitmentsDocument,
  ReviewOrdersStepReleaseCommitmentsMutation,
  ReviewOrdersStepReleaseCommitmentsMutationVariables,
} from "../routes/developments/lot-summary/lot-release/ReviewOrdersStep.generated";
import {
  LotSummaryDocument,
  LotSummaryQuery,
  LotSummaryQueryVariables,
} from "../routes/developments/lot-summary/lot-release/components/LotSummary.generated";
import {
  LotCheckFormDrawerDocument,
  LotCheckFormDrawerMetadataDocument,
  LotCheckFormDrawerMetadataQuery,
  LotCheckFormDrawerMetadataQueryVariables,
  LotCheckFormDrawerQuery,
  LotCheckFormDrawerQueryVariables,
  SaveProjectSiteConditionsDocument,
  SaveProjectSiteConditionsMutation,
  SaveProjectSiteConditionsMutationVariables,
  SendProjectSiteConditionsNotificationDocument,
  SendProjectSiteConditionsNotificationMutation,
  SendProjectSiteConditionsNotificationMutationVariables,
} from "../routes/developments/lot-summary/sequence-sheet/components/lot-check-form/LotCheckFormDrawer.generated";
import {
  LotCheckTableMetadataDocument,
  LotCheckTableMetadataQuery,
  LotCheckTableMetadataQueryVariables,
  SaveProjectSiteSpecificInfoDocument,
  SaveProjectSiteSpecificInfoMutation,
  SaveProjectSiteSpecificInfoMutationVariables,
} from "../routes/developments/lot-summary/sequence-sheet/components/lot-check-form/LotCheckTable.generated";
import {
  ComputedProgramDataPreviewDocument,
  ComputedProgramDataPreviewQuery,
  ComputedProgramDataPreviewQueryVariables,
  LotDetailDrawerDocument,
  LotDetailDrawerQuery,
  LotDetailDrawerQueryVariables,
  SaveProjectLotDetailDocument,
  SaveProjectLotDetailMutation,
  SaveProjectLotDetailMutationVariables,
  SaveProjectReadyPlanConfigDocument,
  SaveProjectReadyPlanConfigMutation,
  SaveProjectReadyPlanConfigMutationVariables,
} from "../routes/developments/lot-summary/sequence-sheet/components/lot-detail/LotDetailDrawer.generated";
import {
  CohortDevelopmentsDocument,
  CohortDevelopmentsQuery,
  CohortDevelopmentsQueryVariables,
} from "../routes/developments/lot-summary/sequence-sheet/components/move-project-button-menu/MoveProjectButtonMenu.generated";
import {
  UpdateProjectCohortDocument,
  UpdateProjectCohortMutation,
  UpdateProjectCohortMutationVariables,
} from "../routes/developments/lot-summary/sequence-sheet/components/move-project-modal/MoveProjectModal.generated";
import {
  LotSequenceSheetTableDocument,
  LotSequenceSheetTableMetadataDocument,
  LotSequenceSheetTableMetadataQuery,
  LotSequenceSheetTableMetadataQueryVariables,
  LotSequenceSheetTableQuery,
  LotSequenceSheetTableQueryVariables,
} from "../routes/developments/lot-summary/sequence-sheet/components/sequence-sheet-table/LotSequenceSheetTable.generated";
import {
  ReleasePOsStepDocument,
  ReleasePOsStepQuery,
  ReleasePOsStepQueryVariables,
  UpdateCommitmentAutoReleaseStatusDocument,
  UpdateCommitmentAutoReleaseStatusMutation,
  UpdateCommitmentAutoReleaseStatusMutationVariables,
} from "../routes/developments/manage-pos-wizard/ReleasePOsStep.generated";
import {
  VoidPOsStepDocument,
  VoidPOsStepQuery,
  VoidPOsStepQueryVariables,
} from "../routes/developments/manage-pos-wizard/VoidPOsStep.generated";
import {
  ReadyPlansListDocument,
  ReadyPlansListQuery,
  ReadyPlansListQueryVariables,
} from "../routes/developments/plan-and-options/PlanAndOptionsPage.generated";
import {
  AddOptionsMetadataDocument,
  AddOptionsMetadataQuery,
  AddOptionsMetadataQueryVariables,
  AddOptionsPageDocument,
  AddOptionsPageQuery,
  AddOptionsPageQueryVariables,
  DeleteReadyPlanOptionProgramDataModificationDocument,
  DeleteReadyPlanOptionProgramDataModificationMutation,
  DeleteReadyPlanOptionProgramDataModificationMutationVariables,
  ReadyPlanOptionsListDocument,
  ReadyPlanOptionsListQuery,
  ReadyPlanOptionsListQueryVariables,
  ReadyPlanPageMetadataDocument,
  ReadyPlanPageMetadataQuery,
  ReadyPlanPageMetadataQueryVariables,
  SaveReadyPlanDocument,
  SaveReadyPlanMutation,
  SaveReadyPlanMutationVariables,
  SaveReadyPlanOptionProgramDataModificationDocument,
  SaveReadyPlanOptionProgramDataModificationMutation,
  SaveReadyPlanOptionProgramDataModificationMutationVariables,
  SaveReadyPlanOptionsDocument,
  SaveReadyPlanOptionsModalDocument,
  SaveReadyPlanOptionsModalMutation,
  SaveReadyPlanOptionsModalMutationVariables,
  SaveReadyPlanOptionsMutation,
  SaveReadyPlanOptionsMutationVariables,
} from "../routes/developments/plan-and-options/PlanDetailsPage.generated";
import {
  SaveReadyPlansDocument,
  SaveReadyPlansMutation,
  SaveReadyPlansMutationVariables,
} from "../routes/developments/plan-and-options/components/CreateReadyPlanModalButton.generated";
import {
  PlanDetailsStepDocument,
  PlanDetailsStepMetadataDocument,
  PlanDetailsStepMetadataQuery,
  PlanDetailsStepMetadataQueryVariables,
  PlanDetailsStepQuery,
  PlanDetailsStepQueryVariables,
  SavePlanDetailsDocument,
  SavePlanDetailsMutation,
  SavePlanDetailsMutationVariables,
} from "../routes/developments/plan-and-options/options/1.PlanDetailsStep.generated";
import {
  SaveReadyPlanOptionGroupsDocument,
  SaveReadyPlanOptionGroupsMutation,
  SaveReadyPlanOptionGroupsMutationVariables,
} from "../routes/developments/plan-and-options/options/3.ConfigureOptionsStep.generated";
import {
  ChooseOptionsStepBodyV1_SaveReadyPlanChosenOptionsDocument,
  ChooseOptionsStepBodyV1_SaveReadyPlanChosenOptionsMutation,
  ChooseOptionsStepBodyV1_SaveReadyPlanChosenOptionsMutationVariables,
  ChooseOptionsStepBodyV1Document,
  ChooseOptionsStepBodyV1Query,
  ChooseOptionsStepBodyV1QueryVariables,
} from "../routes/developments/plan-and-options/options/components/ChooseOptionsStepBodyV1.generated";
import {
  EditOptionsHeaderDocument,
  EditOptionsHeaderQuery,
  EditOptionsHeaderQueryVariables,
} from "../routes/developments/plan-and-options/options/components/EditOptionsHeader.generated";
import {
  BidContractRevisionLineItemsPageDocument,
  BidContractRevisionLineItemsPageQuery,
  BidContractRevisionLineItemsPageQueryVariables,
  DeleteBidContractLineItemsDocument,
  DeleteBidContractLineItemsMutation,
  DeleteBidContractLineItemsMutationVariables,
  SaveBidContractLineItemDocument,
  SaveBidContractLineItemMutation,
  SaveBidContractLineItemMutationVariables,
  SaveBidContractLineItemsDocument,
  SaveBidContractLineItemsMutation,
  SaveBidContractLineItemsMutationVariables,
} from "../routes/developments/procurement/DevelopmentContractLineItemsPage.generated";
import {
  BidContractRevisionOverviewDocument,
  BidContractRevisionOverviewQuery,
  BidContractRevisionOverviewQueryVariables,
} from "../routes/developments/procurement/DevelopmentContractOverviewPage.generated";
import {
  BidContractDocument,
  BidContractQuery,
  BidContractQueryVariables,
  BidContractRevisionDocument,
  BidContractRevisionQuery,
  BidContractRevisionQueryVariables,
  DeleteBidContractRevisionDocument,
  DeleteBidContractRevisionMutation,
  DeleteBidContractRevisionMutationVariables,
  InternallySignBidContractRevisionDocument,
  InternallySignBidContractRevisionMutation,
  InternallySignBidContractRevisionMutationVariables,
  SaveBidContractDocument,
  SaveBidContractMutation,
  SaveBidContractMutationVariables,
  SaveBidContractRevisionDocument,
  SaveBidContractRevisionMutation,
  SaveBidContractRevisionMutationVariables,
} from "../routes/developments/procurement/DevelopmentContractPage.generated";
import {
  DevelopmentContractDocument,
  DevelopmentContractQuery,
  DevelopmentContractQueryVariables,
} from "../routes/developments/procurement/DevelopmentContractsTable.generated";
import {
  DevelopmentProcurementDocument,
  DevelopmentProcurementQuery,
  DevelopmentProcurementQueryVariables,
} from "../routes/developments/procurement/DevelopmentProcurementPage.generated";
import {
  CreateBidContractDocument,
  CreateBidContractMutation,
  CreateBidContractMutationVariables,
  DevelopmentTradePartnersDocument,
  DevelopmentTradePartnersQuery,
  DevelopmentTradePartnersQueryVariables,
} from "../routes/developments/procurement/components/CreateDevelopmentContractButton.generated";
import {
  DevelopmentTemplateItemsModalDocument,
  DevelopmentTemplateItemsModalMetadataDocument,
  DevelopmentTemplateItemsModalMetadataQuery,
  DevelopmentTemplateItemsModalMetadataQueryVariables,
  DevelopmentTemplateItemsModalQuery,
  DevelopmentTemplateItemsModalQueryVariables,
} from "../routes/developments/procurement/components/DevelopmentTemplateItemsModal.generated";
import {
  RecentlyActivatedItemTemplatesDocument,
  RecentlyActivatedItemTemplatesQuery,
  RecentlyActivatedItemTemplatesQueryVariables,
} from "../routes/developments/procurement/components/GenerateNewBidRequestNotice.generated";
import {
  ComputeProductOfferingConfigCostsDocument,
  ComputeProductOfferingConfigCostsQuery,
  ComputeProductOfferingConfigCostsQueryVariables,
} from "../routes/developments/product-offering-configs/ProductOfferingConfigsComparePage.generated";
import {
  ProductOfferingCardDocument,
  ProductOfferingCardQuery,
  ProductOfferingCardQueryVariables,
} from "../routes/developments/product-offering-configs/components/compare-product-configs/ProductOfferingCard.generated";
import {
  FilteredProjectsTableDocument,
  FilteredProjectsTableQuery,
  FilteredProjectsTableQueryVariables,
} from "../routes/developments/product-offerings/FilteredProjectsTable.generated";
import {
  ProductOfferingApplyToProjectDocument,
  ProductOfferingApplyToProjectMutation,
  ProductOfferingApplyToProjectMutationVariables,
} from "../routes/developments/product-offerings/ProductOfferingApplyToProjectsPage.generated";
import {
  ProductOffering_PromoteToCheckoutDocument,
  ProductOffering_PromoteToCheckoutMutation,
  ProductOffering_PromoteToCheckoutMutationVariables,
  ProductOffering_RunCheckoutPricingReportDocument,
  ProductOffering_RunCheckoutPricingReportMutation,
  ProductOffering_RunCheckoutPricingReportMutationVariables,
  ProductOffering_SaveProductOfferingDocument,
  ProductOffering_SaveProductOfferingMutation,
  ProductOffering_SaveProductOfferingMutationVariables,
  ProductOfferingPageDocument,
  ProductOfferingPageQuery,
  ProductOfferingPageQueryVariables,
} from "../routes/developments/product-offerings/ProductOfferingPage.generated";
import {
  ProductOfferingScopeMetaDocument,
  ProductOfferingScopeMetaQuery,
  ProductOfferingScopeMetaQueryVariables,
  ProductOfferingScopePageDocument,
  ProductOfferingScopePageQuery,
  ProductOfferingScopePageQueryVariables,
} from "../routes/developments/product-offerings/ProductOfferingScopePage.generated";
import {
  ProductOfferingScopePageSideBarDocument,
  ProductOfferingScopePageSideBarQuery,
  ProductOfferingScopePageSideBarQueryVariables,
} from "../routes/developments/product-offerings/ProductOfferingScopePageSideBar.generated";
import {
  ProductOfferingsPageDocument,
  ProductOfferingsPageQuery,
  ProductOfferingsPageQueryVariables,
} from "../routes/developments/product-offerings/ProductOfferingsPage.generated";
import {
  TestGroupDependenciesLineItemsDocument,
  TestGroupDependenciesLineItemsQuery,
  TestGroupDependenciesLineItemsQueryVariables,
} from "../routes/developments/product-offerings/components/TestGroupDependenciesModal.generated";
import {
  AcceptProductOfferingUpdatesDocument,
  AcceptProductOfferingUpdatesMutation,
  AcceptProductOfferingUpdatesMutationVariables,
  PofAvailableUpdatesDocument,
  PofAvailableUpdatesQuery,
  PofAvailableUpdatesQueryVariables,
} from "../routes/developments/product-offerings/components/UpdatesAvailable.generated";
import {
  ProductOfferingVersionHistoryDocument,
  ProductOfferingVersionHistoryQuery,
  ProductOfferingVersionHistoryQueryVariables,
} from "../routes/developments/product-offerings/version-history/ProductOfferingVersionHistory.generated";
import {
  DevelopmentPurchaseOrderDocument,
  DevelopmentPurchaseOrderFiltersDocument,
  DevelopmentPurchaseOrderFiltersQuery,
  DevelopmentPurchaseOrderFiltersQueryVariables,
  DevelopmentPurchaseOrderQuery,
  DevelopmentPurchaseOrderQueryVariables,
  SaveCommitmentsDocument,
  SaveCommitmentsMutation,
  SaveCommitmentsMutationVariables,
} from "../routes/developments/purchase-orders/PurchaseOrdersPage.generated";
import {
  ReassignPurchaseOrdersDocument,
  ReassignPurchaseOrdersQuery,
  ReassignPurchaseOrdersQueryVariables,
  SaveReassignPurchaseOrdersDocument,
  SaveReassignPurchaseOrdersMutation,
  SaveReassignPurchaseOrdersMutationVariables,
} from "../routes/developments/reassign-purchase-orders/ReassignPurchaseOrdersPage.generated";
import {
  TaskLookaheadDocument,
  TaskLookaheadQuery,
  TaskLookaheadQueryVariables,
  TaskLookaheadRightPaneDocument,
  TaskLookaheadRightPaneQuery,
  TaskLookaheadRightPaneQueryVariables,
} from "../routes/developments/reports/task-lookahead/TaskLookaheadPage.generated";
import {
  CompletedMilestonesByProjectDocument,
  CompletedMilestonesByProjectQuery,
  CompletedMilestonesByProjectQueryVariables,
  DevelopmentBulkScheduleDocument,
  DevelopmentBulkScheduleProjectsDocument,
  DevelopmentBulkScheduleProjectsQuery,
  DevelopmentBulkScheduleProjectsQueryVariables,
  DevelopmentBulkScheduleQuery,
  DevelopmentBulkScheduleQueryVariables,
  DevelopmentBulkScheduleSaveScheduleTaskDocument,
  DevelopmentBulkScheduleSaveScheduleTaskMutation,
  DevelopmentBulkScheduleSaveScheduleTaskMutationVariables,
  ScheduleTasksByPhasesDocument,
  ScheduleTasksByPhasesQuery,
  ScheduleTasksByPhasesQueryVariables,
} from "../routes/developments/schedule/DevelopmentBulkSchedulePage.generated";
import {
  PhaseTaskListPaneDocument,
  PhaseTaskListPaneQuery,
  PhaseTaskListPaneQueryVariables,
} from "../routes/developments/schedule/components/PhaseTaskListPane.generated";
import {
  StandaloneTaskDetailPaneDocument,
  StandaloneTaskDetailPaneQuery,
  StandaloneTaskDetailPaneQueryVariables,
} from "../routes/developments/schedule/components/StandaloneTaskDetailPane.generated";
import {
  DevelopmentScheduleDocument,
  DevelopmentScheduleQuery,
  DevelopmentScheduleQueryVariables,
} from "../routes/developments/schedule/development-level-schedule/DevelopmentSchedulePage.generated";
import {
  DevelopmentHolidayCard_AllProjectsDocument,
  DevelopmentHolidayCard_AllProjectsQuery,
  DevelopmentHolidayCard_AllProjectsQueryVariables,
} from "../routes/developments/settings/components/DevelopmentHolidayCard.generated";
import {
  DevelopmentTeamMembersDocument,
  DevelopmentTeamMembersQuery,
  DevelopmentTeamMembersQueryVariables,
  UpdateDevelopmentProjectRoleDocument,
  UpdateDevelopmentProjectRoleMutation,
  UpdateDevelopmentProjectRoleMutationVariables,
} from "../routes/developments/team-members/DevelopmentTeamMembers.generated";
import {
  CreateNewItemTemplateVersionsDocument,
  CreateNewItemTemplateVersionsMutation,
  CreateNewItemTemplateVersionsMutationVariables,
  DeleteItemTemplatesDocument,
  DeleteItemTemplatesMutation,
  DeleteItemTemplatesMutationVariables,
  DevelopmentScopeTemplatePageDocument,
  DevelopmentScopeTemplatePageQuery,
  DevelopmentScopeTemplatePageQueryVariables,
} from "../routes/developments/templates/DevelopmentScopeTemplatePage.generated";
import {
  DevelopmentScopeTemplatesDocument,
  DevelopmentScopeTemplatesMetadataDocument,
  DevelopmentScopeTemplatesMetadataQuery,
  DevelopmentScopeTemplatesMetadataQueryVariables,
  DevelopmentScopeTemplatesQuery,
  DevelopmentScopeTemplatesQueryVariables,
} from "../routes/developments/templates/DevelopmentScopeTemplates.generated";
import {
  ScopeTemplateCostCalculatorPage_ComputeDocument,
  ScopeTemplateCostCalculatorPage_ComputeQuery,
  ScopeTemplateCostCalculatorPage_ComputeQueryVariables,
  ScopeTemplateCostCalculatorPageDocument,
  ScopeTemplateCostCalculatorPageQuery,
  ScopeTemplateCostCalculatorPageQueryVariables,
} from "../routes/developments/templates/ScopeTemplateCostCalculatorPage.generated";
import {
  SaveItemTemplatesDocument,
  SaveItemTemplatesMutation,
  SaveItemTemplatesMutationVariables,
  ScopeReasonCodesDocument,
  ScopeReasonCodesQuery,
  ScopeReasonCodesQueryVariables,
} from "../routes/developments/templates/components/AddItemTemplatesReasonCodesModal.generated";
import {
  AddScopeTemplateItemsDocument,
  AddScopeTemplateItemsQuery,
  AddScopeTemplateItemsQueryVariables,
} from "../routes/developments/templates/components/AddScopeTemplateItems.generated";
import {
  ArchiveItemTemplateVersionsDocument,
  ArchiveItemTemplateVersionsMutation,
  ArchiveItemTemplateVersionsMutationVariables,
} from "../routes/developments/templates/components/ArchiveItemTemplatesModal.generated";
import {
  CopyItemTemplateDocument,
  CopyItemTemplateMutation,
  CopyItemTemplateMutationVariables,
  CopyLineItemsModalDocument,
  CopyLineItemsModalQuery,
  CopyLineItemsModalQueryVariables,
} from "../routes/developments/templates/components/CopyLineItemsModalButton.generated";
import {
  SaveItemTemplateHeaderDocument,
  SaveItemTemplateHeaderMutation,
  SaveItemTemplateHeaderMutationVariables,
  SaveScopeTemplateHeader_ReadyPlanDocument,
  SaveScopeTemplateHeader_ReadyPlanMutation,
  SaveScopeTemplateHeader_ReadyPlanMutationVariables,
} from "../routes/developments/templates/components/ScopeTemplateHeader.generated";
import {
  ScopeTemplateApplyStepApplyToProjectDocument,
  ScopeTemplateApplyStepApplyToProjectMutation,
  ScopeTemplateApplyStepApplyToProjectMutationVariables,
  ScopeTemplatesApplyStepDocument,
  ScopeTemplatesApplyStepMetadataDocument,
  ScopeTemplatesApplyStepMetadataQuery,
  ScopeTemplatesApplyStepMetadataQueryVariables,
  ScopeTemplatesApplyStepQuery,
  ScopeTemplatesApplyStepQueryVariables,
} from "../routes/developments/templates/review-and-publish/components/ApplyToProjectsStep.generated";
import {
  ActivateTemplateVersionsReviewStepDocument,
  ActivateTemplateVersionsReviewStepMutation,
  ActivateTemplateVersionsReviewStepMutationVariables,
  SaveScopeChangeReasonReviewStepDocument,
  SaveScopeChangeReasonReviewStepMutation,
  SaveScopeChangeReasonReviewStepMutationVariables,
  ScopeTemplateItemsReviewStepTableDocument,
  ScopeTemplateItemsReviewStepTableQuery,
  ScopeTemplateItemsReviewStepTableQueryVariables,
  ScopeTemplatesReviewStepDocument,
  ScopeTemplatesReviewStepQuery,
  ScopeTemplatesReviewStepQueryVariables,
  ScopeTemplatesReviewStepTableDocument,
  ScopeTemplatesReviewStepTableQuery,
  ScopeTemplatesReviewStepTableQueryVariables,
} from "../routes/developments/templates/review-and-publish/components/ReviewStep.generated";
import {
  ExpenseAdminTeamMemberProjectsDocument,
  ExpenseAdminTeamMemberProjectsQuery,
  ExpenseAdminTeamMemberProjectsQueryVariables,
} from "../routes/expenses/ExpensesAdmin.generated";
import {
  CommentStreamDocument,
  CommentStreamQuery,
  CommentStreamQueryVariables,
  InboxPageMetaDocument,
  InboxPageMetaQuery,
  InboxPageMetaQueryVariables,
  UserRelevantCommentStreamsDocument,
  UserRelevantCommentStreamsQuery,
  UserRelevantCommentStreamsQueryVariables,
} from "../routes/inbox/InboxPage.generated";
import {
  CommentableInboxDocument,
  CommentableInboxQuery,
  CommentableInboxQueryVariables,
} from "../routes/inbox/components/CommentableInbox.generated";
import {
  InboxBellDocument,
  InboxBellQuery,
  InboxBellQueryVariables,
} from "../routes/inbox/components/InboxBell.generated";
import {
  CommentStreamCommentsDocument,
  CommentStreamCommentsQuery,
  CommentStreamCommentsQueryVariables,
} from "../routes/inbox/components/InboxCommentStream.generated";
import {
  InvoicesPageDocument,
  InvoicesPageQuery,
  InvoicesPageQueryVariables,
} from "../routes/invoices/InvoicesPage.generated";
import {
  GlobalSearchModalDocument,
  GlobalSearchModalQuery,
  GlobalSearchModalQueryVariables,
} from "../routes/layout/GlobalSearchModal.generated";
import {
  TemplatesDocument,
  TemplatesQuery,
  TemplatesQueryVariables,
} from "../routes/libraries/TemplatesPage.generated";
import {
  CopyDesignPackage_CopyDesignPackageDocument,
  CopyDesignPackage_CopyDesignPackageMutation,
  CopyDesignPackage_CopyDesignPackageMutationVariables,
  CopyDesignPackage_ReadyPlanLikeDocument,
  CopyDesignPackage_ReadyPlanLikeQuery,
  CopyDesignPackage_ReadyPlanLikeQueryVariables,
} from "../routes/libraries/design-catalog/CopyDesignPackageModal.generated";
import {
  DesignCatalogsTableDocument,
  DesignCatalogsTableQuery,
  DesignCatalogsTableQueryVariables,
} from "../routes/libraries/design-catalog/DesignCatalogsPage.generated";
import {
  EditPersonalizationOptionPage_CombinationsDocument,
  EditPersonalizationOptionPage_CombinationsQuery,
  EditPersonalizationOptionPage_CombinationsQueryVariables,
  EditPersonalizationOptionPage_MaterialVariantDocument,
  EditPersonalizationOptionPage_MaterialVariantQuery,
  EditPersonalizationOptionPage_MaterialVariantQueryVariables,
  EditPersonalizationOptionPageDocument,
  EditPersonalizationOptionPageQuery,
  EditPersonalizationOptionPageQueryVariables,
  SavePersonalizationRpogDocument,
  SavePersonalizationRpogMutation,
  SavePersonalizationRpogMutationVariables,
} from "../routes/libraries/design-catalog/EditPersonalizationOptionPage.generated";
import {
  CompareModeDesignPackageDocument,
  CompareModeDesignPackageQuery,
  CompareModeDesignPackageQueryVariables,
  CompareModeDesignPackageTlisDocument,
  CompareModeDesignPackageTlisQuery,
  CompareModeDesignPackageTlisQueryVariables,
} from "../routes/libraries/design-catalog/compare-mode/DesignPackageCompareMode.generated";
import {
  AddSlotModal_PotentialPlaceholdersDocument,
  AddSlotModal_PotentialPlaceholdersQuery,
  AddSlotModal_PotentialPlaceholdersQueryVariables,
  AddSlotModal_SelectedPlaceholdersDocument,
  AddSlotModal_SelectedPlaceholdersQuery,
  AddSlotModal_SelectedPlaceholdersQueryVariables,
} from "../routes/libraries/design-catalog/components/AddSlotModal.generated";
import {
  PlaceholderProductSearch_PossibleMaterialsDocument,
  PlaceholderProductSearch_PossibleMaterialsQuery,
  PlaceholderProductSearch_PossibleMaterialsQueryVariables,
  PlaceholderProductSearch_RequirementsTliDocument,
  PlaceholderProductSearch_RequirementsTliQuery,
  PlaceholderProductSearch_RequirementsTliQueryVariables,
} from "../routes/libraries/design-catalog/components/PlaceholderProductSearch.generated";
import {
  DesignPackageConfiguratorDocument,
  DesignPackageConfiguratorQuery,
  DesignPackageConfiguratorQueryVariables,
} from "../routes/libraries/design-catalog/design-package-configurator/DesignPackageConfigurator.generated";
import {
  DesignPackageProductCardPage_MaterialVariantDocument,
  DesignPackageProductCardPage_MaterialVariantQuery,
  DesignPackageProductCardPage_MaterialVariantQueryVariables,
  DesignPackageProductCardPage_OptionCombinationsDocument,
  DesignPackageProductCardPage_OptionCombinationsQuery,
  DesignPackageProductCardPage_OptionCombinationsQueryVariables,
  DesignPackageProductCardPage_ProductTliDocument,
  DesignPackageProductCardPage_ProductTliQuery,
  DesignPackageProductCardPage_ProductTliQueryVariables,
  DesignPackageProductCardPage_SaveTakeoffLineItemDocument,
  DesignPackageProductCardPage_SaveTakeoffLineItemMutation,
  DesignPackageProductCardPage_SaveTakeoffLineItemMutationVariables,
} from "../routes/libraries/design-catalog/design-package-configurator/DesignPackageProductCardPage.generated";
import {
  AddProductTliPlaceholderDocument,
  AddProductTliPlaceholderQuery,
  AddProductTliPlaceholderQueryVariables,
  DesignPackageAddProductMetadataDocument,
  DesignPackageAddProductMetadataQuery,
  DesignPackageAddProductMetadataQueryVariables,
} from "../routes/libraries/design-catalog/design-package-configurator/components/AddProductPage.generated";
import {
  AddToOptionModal_PotentialOptionsDocument,
  AddToOptionModal_PotentialOptionsQuery,
  AddToOptionModal_PotentialOptionsQueryVariables,
} from "../routes/libraries/design-catalog/design-package-configurator/components/AddToOptionModal.generated";
import {
  CopyDesignPackageCardsDocument,
  CopyDesignPackageCardsModalDocument,
  CopyDesignPackageCardsModalQuery,
  CopyDesignPackageCardsModalQueryVariables,
  CopyDesignPackageCardsMutation,
  CopyDesignPackageCardsMutationVariables,
} from "../routes/libraries/design-catalog/design-package-configurator/components/CopyDesignPackageCardsModal.generated";
import {
  DeleteAltenratesConfirmationModalDocument,
  DeleteAltenratesConfirmationModalQuery,
  DeleteAltenratesConfirmationModalQueryVariables,
  DeleteDpAlternateRplDocument,
  DeleteDpAlternateRplMutation,
  DeleteDpAlternateRplMutationVariables,
} from "../routes/libraries/design-catalog/design-package-configurator/components/DesignPackageDeleteAlternatesConfirmationModal.generated";
import {
  DesignPackageDesignNotePane_MetadataDocument,
  DesignPackageDesignNotePane_MetadataQuery,
  DesignPackageDesignNotePane_MetadataQueryVariables,
  DesignPackageDesignNotePaneDocument,
  DesignPackageDesignNotePaneQuery,
  DesignPackageDesignNotePaneQueryVariables,
  SaveReadyPlanDesignNoteDocument,
  SaveReadyPlanDesignNoteMutation,
  SaveReadyPlanDesignNoteMutationVariables,
} from "../routes/libraries/design-catalog/design-package-configurator/components/DesignPackageDesignNotePane.generated";
import {
  DesignPackageItemSlotEditor_DeleteTliDocument,
  DesignPackageItemSlotEditor_DeleteTliMutation,
  DesignPackageItemSlotEditor_DeleteTliMutationVariables,
  DesignPackageItemSlotEditorDocument,
  DesignPackageItemSlotEditorQuery,
  DesignPackageItemSlotEditorQueryVariables,
} from "../routes/libraries/design-catalog/design-package-configurator/components/DesignPackageItemSlotEditor.generated";
import {
  DesignPackagePruneSlotsModal_DataDocument,
  DesignPackagePruneSlotsModal_DataQuery,
  DesignPackagePruneSlotsModal_DataQueryVariables,
  DesignPackagePruneSlotsModal_SaveDraftDocument,
  DesignPackagePruneSlotsModal_SaveDraftMutation,
  DesignPackagePruneSlotsModal_SaveDraftMutationVariables,
} from "../routes/libraries/design-catalog/design-package-configurator/components/DesignPackagePruneSlotsModal.generated";
import {
  DesignPackageRequiredOptionsPage_AddOnsDocument,
  DesignPackageRequiredOptionsPage_AddOnsQuery,
  DesignPackageRequiredOptionsPage_AddOnsQueryVariables,
  DesignPackageRequiredOptionsPage_CombinationsDocument,
  DesignPackageRequiredOptionsPage_CombinationsQuery,
  DesignPackageRequiredOptionsPage_CombinationsQueryVariables,
  DesignPackageRequiredOptionsPageDocument,
  DesignPackageRequiredOptionsPageQuery,
  DesignPackageRequiredOptionsPageQueryVariables,
  SaveDesignPackageRequiredOptionsDocument,
  SaveDesignPackageRequiredOptionsMutation,
  SaveDesignPackageRequiredOptionsMutationVariables,
} from "../routes/libraries/design-catalog/design-package-configurator/components/DesignPackageRequiredOptionsPage.generated";
import {
  DesignPackageRoomAlternatesDrawerDocument,
  DesignPackageRoomAlternatesDrawerQuery,
  DesignPackageRoomAlternatesDrawerQueryVariables,
  SaveDpRplAlternateLocationsDocument,
  SaveDpRplAlternateLocationsMutation,
  SaveDpRplAlternateLocationsMutationVariables,
} from "../routes/libraries/design-catalog/design-package-configurator/components/DesignPackageRoomAlternatesDrawer.generated";
import {
  CreateAlternateLocationDocument,
  CreateAlternateLocationMutation,
  CreateAlternateLocationMutationVariables,
  DesignPackageSlotsDocument,
  DesignPackageSlotsQuery,
  DesignPackageSlotsQueryVariables,
} from "../routes/libraries/design-catalog/design-package-configurator/components/DesignPackageSlotsLeftNav.generated";
import {
  AcceptDesignUpdatesDocument,
  AcceptDesignUpdatesMutation,
  AcceptDesignUpdatesMutationVariables,
} from "../routes/libraries/design-catalog/design-package-configurator/components/DesignUpdatesAvailableButton.generated";
import {
  CreateDesignPackagePlaceholderTliDocument,
  CreateDesignPackagePlaceholderTliMutation,
  CreateDesignPackagePlaceholderTliMutationVariables,
  MaterialAttributeDimensionsDocument,
  MaterialAttributeDimensionsQuery,
  MaterialAttributeDimensionsQueryVariables,
} from "../routes/libraries/design-catalog/design-package-configurator/routes/new/NewProductSlotPage.generated";
import {
  ProductSearchPage_CurrentMaterialDocument,
  ProductSearchPage_CurrentMaterialQuery,
  ProductSearchPage_CurrentMaterialQueryVariables,
} from "../routes/libraries/design-catalog/design-package-configurator/routes/search/ProductSearchPage.generated";
import {
  FinishScheduleDesignPackageDocument,
  FinishScheduleDesignPackageMetadataDocument,
  FinishScheduleDesignPackageMetadataQuery,
  FinishScheduleDesignPackageMetadataQueryVariables,
  FinishScheduleDesignPackageQuery,
  FinishScheduleDesignPackageQueryVariables,
  FinishScheduleDesignPackageTlisDocument,
  FinishScheduleDesignPackageTlisQuery,
  FinishScheduleDesignPackageTlisQueryVariables,
} from "../routes/libraries/design-catalog/finish-schedules/FinishSchedule.generated";
import {
  EditDesignPackageDocument,
  EditDesignPackageQuery,
  EditDesignPackageQueryVariables,
  MakeNewDesignPackageDocument,
  MakeNewDesignPackageMutation,
  MakeNewDesignPackageMutationVariables,
  NewDesignPackage_GlobalOptionGroupsDocument,
  NewDesignPackage_GlobalOptionGroupsQuery,
  NewDesignPackage_GlobalOptionGroupsQueryVariables,
  NewDesignPackagePlanPackagesDocument,
  NewDesignPackagePlanPackagesQuery,
  NewDesignPackagePlanPackagesQueryVariables,
  PreselectOptionsFromPlanPackagesDocument,
  PreselectOptionsFromPlanPackagesQuery,
  PreselectOptionsFromPlanPackagesQueryVariables,
} from "../routes/libraries/design-catalog/new-design-catalog-wizard/NewDesignPackage.generated";
import {
  DeactivatePersonalizationGroupDocument,
  DeactivatePersonalizationGroupMutation,
  DeactivatePersonalizationGroupMutationVariables,
  DesignPackagePersonalizationGroupsPageDocument,
  DesignPackagePersonalizationGroupsPageQuery,
  DesignPackagePersonalizationGroupsPageQueryVariables,
} from "../routes/libraries/design-catalog/personalization-groups/DesignPackagePersonalizationGroupsPage.generated";
import {
  DesignPackageVersionHistoryDocument,
  DesignPackageVersionHistoryQuery,
  DesignPackageVersionHistoryQueryVariables,
} from "../routes/libraries/design-catalog/version-history/DesignPackageVersionHistoryPage.generated";
import {
  GlobalOptionFormDocument,
  GlobalOptionFormQuery,
  GlobalOptionFormQueryVariables,
  GlobalOptionFormTypesDocument,
  GlobalOptionFormTypesQuery,
  GlobalOptionFormTypesQueryVariables,
  SaveGlobalOptionFormDocument,
  SaveGlobalOptionFormMutation,
  SaveGlobalOptionFormMutationVariables,
} from "../routes/libraries/global-options-v2/GlobalOptionForm.generated";
import {
  GlobalOptionsPageV2Document,
  GlobalOptionsPageV2MetadataDocument,
  GlobalOptionsPageV2MetadataQuery,
  GlobalOptionsPageV2MetadataQueryVariables,
  GlobalOptionsPageV2Query,
  GlobalOptionsPageV2QueryVariables,
  SaveGlobalOptionsPageV2Document,
  SaveGlobalOptionsPageV2Mutation,
  SaveGlobalOptionsPageV2MutationVariables,
} from "../routes/libraries/global-options-v2/GlobalOptionsPageV2.generated";
import {
  GlobalOptionDrawerDocument,
  GlobalOptionDrawerQuery,
  GlobalOptionDrawerQueryVariables,
  OptionDrawerMetadataDocument,
  OptionDrawerMetadataQuery,
  OptionDrawerMetadataQueryVariables,
  SaveGlobalOptionGroupDocument,
  SaveGlobalOptionGroupMutation,
  SaveGlobalOptionGroupMutationVariables,
  SaveGlobalOptionsDrawerDocument,
  SaveGlobalOptionsDrawerMutation,
  SaveGlobalOptionsDrawerMutationVariables,
} from "../routes/libraries/global-options/GlobalOptionDrawer.generated";
import {
  GlobalOptionsDocument,
  GlobalOptionsIdsDocument,
  GlobalOptionsIdsQuery,
  GlobalOptionsIdsQueryVariables,
  GlobalOptionsPageMetadataDocument,
  GlobalOptionsPageMetadataQuery,
  GlobalOptionsPageMetadataQueryVariables,
  GlobalOptionsQuery,
  GlobalOptionsQueryVariables,
  SaveGlobalOptionsDocument,
  SaveGlobalOptionsMutation,
  SaveGlobalOptionsMutationVariables,
} from "../routes/libraries/global-options/GlobalOptions.generated";
import {
  GlobalOptionsIconsDocument,
  GlobalOptionsIconsQuery,
  GlobalOptionsIconsQueryVariables,
} from "../routes/libraries/global-options/components/DesignUpgradeIconPickerModal.generated";
import {
  BidItemPageDocument,
  BidItemPageOptionsDocument,
  BidItemPageOptionsQuery,
  BidItemPageOptionsQueryVariables,
  BidItemPageQuery,
  BidItemPageQueryVariables,
  SaveBidItemDocument,
  SaveBidItemMutation,
  SaveBidItemMutationVariables,
} from "../routes/libraries/item-catalog/BidItemPage.generated";
import {
  ItemCatalogDocument,
  ItemCatalogQuery,
  ItemCatalogQueryVariables,
} from "../routes/libraries/item-catalog/ItemCatalogPage.generated";
import {
  BidItemSuperDrawerDetailsDocument,
  BidItemSuperDrawerDetailsQuery,
  BidItemSuperDrawerDetailsQueryVariables,
} from "../routes/libraries/item-catalog/components/BidItemSuperDrawer.generated";
import {
  BidItemAttributesDocument,
  BidItemAttributesQuery,
  BidItemAttributesQueryVariables,
} from "../routes/libraries/item-catalog/components/ItemCatalogFilter.generated";
import {
  BidItemCostHistoryDocument,
  BidItemCostHistoryQuery,
  BidItemCostHistoryQueryVariables,
} from "../routes/libraries/item-catalog/components/tabs/BidItemCostHistoryTab.generated";
import {
  BidEstimateModalOptionsDocument,
  BidEstimateModalOptionsQuery,
  BidEstimateModalOptionsQueryVariables,
  SaveBidItemEstimateDocument,
  SaveBidItemEstimateMutation,
  SaveBidItemEstimateMutationVariables,
} from "../routes/libraries/material-catalog/BidEstimateModal.generated";
import {
  MaterialCatalogDocument,
  MaterialCatalogMetadataDocument,
  MaterialCatalogMetadataQuery,
  MaterialCatalogMetadataQueryVariables,
  MaterialCatalogQuery,
  MaterialCatalogQueryVariables,
  SaveMaterialBrandDocument,
  SaveMaterialBrandMutation,
  SaveMaterialBrandMutationVariables,
  SaveMaterialVariantDocument,
  SaveMaterialVariantMutation,
  SaveMaterialVariantMutationVariables,
  SaveMavDocument,
  SaveMavMutation,
  SaveMavMutationVariables,
} from "../routes/libraries/material-catalog/MaterialCatalog.generated";
import {
  MaterialCostPageDocument,
  MaterialCostPageQuery,
  MaterialCostPageQueryVariables,
} from "../routes/libraries/material-catalog/MaterialCostPage.generated";
import {
  MaterialListingHistoryDocument,
  MaterialListingHistoryQuery,
  MaterialListingHistoryQueryVariables,
} from "../routes/libraries/material-catalog/components/MaterialListingFormHistoryTab.generated";
import {
  MaterialAssemblyForm_AssemblyComponentsDocument,
  MaterialAssemblyForm_AssemblyComponentsQuery,
  MaterialAssemblyForm_AssemblyComponentsQueryVariables,
  MaterialAssemblyForm_ItemsDocument,
  MaterialAssemblyForm_ItemsQuery,
  MaterialAssemblyForm_ItemsQueryVariables,
  MaterialAssemblyForm_MaterialVariantsDocument,
  MaterialAssemblyForm_MaterialVariantsQuery,
  MaterialAssemblyForm_MaterialVariantsQueryVariables,
} from "../routes/libraries/material-catalog/components/material-assembly-form/MaterialAssemblyForm.generated";
import {
  MaterialSuperDrawerDocument,
  MaterialSuperDrawerQuery,
  MaterialSuperDrawerQueryVariables,
  SaveMaterialListingDocument,
  SaveMaterialListingMutation,
  SaveMaterialListingMutationVariables,
} from "../routes/libraries/material-catalog/components/material-super-drawer/MaterialSuperDrawer.generated";
import {
  DeleteItemPlanTaskMappingDocument,
  DeleteItemPlanTaskMappingMutation,
  DeleteItemPlanTaskMappingMutationVariables,
  InstallTasksPageDocument,
  InstallTasksPageQuery,
  InstallTasksPageQueryVariables,
  ItemPlanTaskMappingsDocument,
  ItemPlanTaskMappingsQuery,
  ItemPlanTaskMappingsQueryVariables,
  SaveItemPlanTaskMappingDocument,
  SaveItemPlanTaskMappingMutation,
  SaveItemPlanTaskMappingMutationVariables,
} from "../routes/libraries/material-catalog/install-tasks/InstallTasksPage.generated";
import {
  MilestoneCatalogFormDocument,
  MilestoneCatalogFormDropdownDocument,
  MilestoneCatalogFormDropdownQuery,
  MilestoneCatalogFormDropdownQueryVariables,
  MilestoneCatalogFormQuery,
  MilestoneCatalogFormQueryVariables,
  SaveGlobalPlanMilestonesDocument,
  SaveGlobalPlanMilestonesMutation,
  SaveGlobalPlanMilestonesMutationVariables,
} from "../routes/libraries/milestone-catalog/MilestoneCatalogForm.generated";
import {
  MilestoneCatalogPageDocument,
  MilestoneCatalogPageMetaDataDocument,
  MilestoneCatalogPageMetaDataQuery,
  MilestoneCatalogPageMetaDataQueryVariables,
  MilestoneCatalogPageQuery,
  MilestoneCatalogPageQueryVariables,
} from "../routes/libraries/milestone-catalog/MilestoneCatalogPage.generated";
import {
  BusinessFunctionTypeDocument,
  BusinessFunctionTypeQuery,
  BusinessFunctionTypeQueryVariables,
  SaveGlobalPlanMilestoneGroupDocument,
  SaveGlobalPlanMilestoneGroupMutation,
  SaveGlobalPlanMilestoneGroupMutationVariables,
} from "../routes/libraries/milestone-catalog/components/AddGlobalPlanMilestoneGroupModal.generated";
import {
  CopyPlanPackageDocument,
  CopyPlanPackageMutation,
  CopyPlanPackageMutationVariables,
  PlanPackagePageMetadataDocument,
  PlanPackagePageMetadataQuery,
  PlanPackagePageMetadataQueryVariables,
  SavePlanPackageDocument,
  SavePlanPackageMutation,
  SavePlanPackageMutationVariables,
} from "../routes/libraries/plan-package/details/PlanPackagePage.generated";
import {
  ConfirmDiscardDraftVersionModal_ConfirmActionDocument,
  ConfirmDiscardDraftVersionModal_ConfirmActionMutation,
  ConfirmDiscardDraftVersionModal_ConfirmActionMutationVariables,
} from "../routes/libraries/plan-package/details/components/ConfirmDiscardDraftVersionModal.generated";
import {
  SaveReadyPlanAggregateVersionDocument,
  SaveReadyPlanAggregateVersionMutation,
  SaveReadyPlanAggregateVersionMutationVariables,
} from "../routes/libraries/plan-package/details/components/PublishAggregateVersionModal.generated";
import {
  PlanPackageOverviewDocument,
  PlanPackageOverviewQuery,
  PlanPackageOverviewQueryVariables,
  PlanSummaryAndOptionsDocument,
  PlanSummaryAndOptionsQuery,
  PlanSummaryAndOptionsQueryVariables,
} from "../routes/libraries/plan-package/details/plan-overview/OverviewTab.generated";
import {
  ElevationDetailsDocument,
  ElevationDetailsQuery,
  ElevationDetailsQueryVariables,
} from "../routes/libraries/plan-package/details/plan-overview/components/ElevationDetails.generated";
import {
  PlanPackageRecentActivityDocument,
  PlanPackageRecentActivityQuery,
  PlanPackageRecentActivityQueryVariables,
} from "../routes/libraries/plan-package/details/plan-overview/components/PlanPackageRecentActivity.generated";
import {
  PlanPackagesDocument,
  PlanPackagesQuery,
  PlanPackagesQueryVariables,
} from "../routes/libraries/plan-package/list/PlanPackagesPage.generated";
import {
  PlanPackageDetailsStepDocument,
  PlanPackageDetailsStepQuery,
  PlanPackageDetailsStepQueryVariables,
  SavePlanPackageDetailsDocument,
  SavePlanPackageDetailsMutation,
  SavePlanPackageDetailsMutationVariables,
} from "../routes/libraries/plan-package/stepper/1.PlanDetailsStep.generated";
import {
  BulkSaveRplsDocument,
  BulkSaveRplsMutation,
  BulkSaveRplsMutationVariables,
  PlanPackageLocationStepDocument,
  PlanPackageLocationStepQuery,
  PlanPackageLocationStepQueryVariables,
} from "../routes/libraries/plan-package/stepper/2.1.LocationStep.generated";
import {
  SaveElevationsDocument,
  SaveElevationsMutation,
  SaveElevationsMutationVariables,
  SaveReadyPlanOptionGroupDocument,
  SaveReadyPlanOptionGroupMutation,
  SaveReadyPlanOptionGroupMutationVariables,
} from "../routes/libraries/plan-package/stepper/2.ElevationsStep.generated";
import {
  PlanPackage_AddOptionsPageDocument,
  PlanPackage_AddOptionsPageQuery,
  PlanPackage_AddOptionsPageQueryVariables,
  PlanPackage_SaveReadyPlanOptionsDocument,
  PlanPackage_SaveReadyPlanOptionsMutation,
  PlanPackage_SaveReadyPlanOptionsMutationVariables,
} from "../routes/libraries/plan-package/stepper/4.ConfigureOptionsStep.generated";
import {
  ProgramDataStepMetadataDocument,
  ProgramDataStepMetadataQuery,
  ProgramDataStepMetadataQueryVariables,
} from "../routes/libraries/plan-package/stepper/5.ProgramDataStep.generated";
import {
  ChooseOptionsStepBody_GlobalOptionsDocument,
  ChooseOptionsStepBody_GlobalOptionsQuery,
  ChooseOptionsStepBody_GlobalOptionsQueryVariables,
  ChooseOptionsStepBody_PlanPackageDocument,
  ChooseOptionsStepBody_PlanPackageQuery,
  ChooseOptionsStepBody_PlanPackageQueryVariables,
} from "../routes/libraries/plan-package/stepper/components/ChooseOptionsStepBody.generated";
import {
  PlanPackageEditorHeaderDocument,
  PlanPackageEditorHeaderQuery,
  PlanPackageEditorHeaderQueryVariables,
} from "../routes/libraries/plan-package/stepper/components/PlanPackageEditorHeader.generated";
import {
  PlanPackageTakeoffPageDocument,
  PlanPackageTakeoffPageQuery,
  PlanPackageTakeoffPageQueryVariables,
} from "../routes/libraries/plan-package/takeoffs/PlanPackageTakeoffPage.generated";
import {
  PlanPackageTakeoffSideBarDocument,
  PlanPackageTakeoffSideBarQuery,
  PlanPackageTakeoffSideBarQueryVariables,
} from "../routes/libraries/plan-package/takeoffs/PlanPackageTakeoffSideBar.generated";
import {
  TakeoffsStore_CopyTakeoffLineItemsDocument,
  TakeoffsStore_CopyTakeoffLineItemsMutation,
  TakeoffsStore_CopyTakeoffLineItemsMutationVariables,
  TakeoffsStore_SaveTakeoffLineItemsDocument,
  TakeoffsStore_SaveTakeoffLineItemsMutation,
  TakeoffsStore_SaveTakeoffLineItemsMutationVariables,
} from "../routes/libraries/plan-package/takeoffs/TakeoffsManagerContext.generated";
import {
  AddEditItemModal_GetLocationsDocument,
  AddEditItemModal_GetLocationsQuery,
  AddEditItemModal_GetLocationsQueryVariables,
} from "../routes/libraries/plan-package/takeoffs/components/AddItems/AddEditItemLocationsField.generated";
import {
  AddEditItemModal_GetItemsDocument,
  AddEditItemModal_GetItemsQuery,
  AddEditItemModal_GetItemsQueryVariables,
  AddEditItemModal_GetMaterialVariantsDocument,
  AddEditItemModal_GetMaterialVariantsQuery,
  AddEditItemModal_GetMaterialVariantsQueryVariables,
  AddEditItemModal_GetReadyPlanDocument,
  AddEditItemModal_GetReadyPlanQuery,
  AddEditItemModal_GetReadyPlanQueryVariables,
  AddEditItemModal_GetTliDocument,
  AddEditItemModal_GetTliQuery,
  AddEditItemModal_GetTliQueryVariables,
  AddEditItemModal_GlobalPlanTasksDocument,
  AddEditItemModal_GlobalPlanTasksQuery,
  AddEditItemModal_GlobalPlanTasksQueryVariables,
} from "../routes/libraries/plan-package/takeoffs/components/AddItems/AddEditItemModal.generated";
import {
  AddEditPlaceholderItemModal_GetItemsDocument,
  AddEditPlaceholderItemModal_GetItemsQuery,
  AddEditPlaceholderItemModal_GetItemsQueryVariables,
} from "../routes/libraries/plan-package/takeoffs/components/AddItems/AddEditPlaceholderItemModal.generated";
import {
  BulkEditModal_GetTlisDocument,
  BulkEditModal_GetTlisQuery,
  BulkEditModal_GetTlisQueryVariables,
} from "../routes/libraries/plan-package/takeoffs/components/BulkEditModal.generated";
import {
  BulkTaskAllocationModal_GlobalPlanTasksDocument,
  BulkTaskAllocationModal_GlobalPlanTasksQuery,
  BulkTaskAllocationModal_GlobalPlanTasksQueryVariables,
} from "../routes/libraries/plan-package/takeoffs/components/BulkTaskAllocationModal/BulkTaskAllocationModal.generated";
import {
  DuplicateItemsConfirmationModal_GetTlisDocument,
  DuplicateItemsConfirmationModal_GetTlisQuery,
  DuplicateItemsConfirmationModal_GetTlisQueryVariables,
} from "../routes/libraries/plan-package/takeoffs/components/DuplicateItemsConfirmationModal.generated";
import {
  PlanPackageTakeoffTableDocument,
  PlanPackageTakeoffTableQuery,
  PlanPackageTakeoffTableQueryVariables,
} from "../routes/libraries/plan-package/takeoffs/components/TakeoffsTable/PlanPackageTakeoffTable.generated";
import {
  TakeoffUploader_ValidateTlisDocument,
  TakeoffUploader_ValidateTlisQuery,
  TakeoffUploader_ValidateTlisQueryVariables,
} from "../routes/libraries/plan-package/takeoffs/components/useTakeoffUploader.generated";
import {
  PlanPackageVersionHistoryDocument,
  PlanPackageVersionHistoryQuery,
  PlanPackageVersionHistoryQueryVariables,
} from "../routes/libraries/plan-package/version-history/PlanPackageVersionHistoryPage.generated";
import {
  ProductCatalogDocument,
  ProductCatalogQuery,
  ProductCatalogQueryVariables,
} from "../routes/libraries/product-catalog/ProductCatalogPage.generated";
import {
  ProductPageDocument,
  ProductPageOptionsDocument,
  ProductPageOptionsQuery,
  ProductPageOptionsQueryVariables,
  ProductPageQuery,
  ProductPageQueryVariables,
  SaveProductsDocument,
  SaveProductsMutation,
  SaveProductsMutationVariables,
} from "../routes/libraries/product-catalog/ProductPage.generated";
import {
  ProductAttributesDocument,
  ProductAttributesQuery,
  ProductAttributesQueryVariables,
} from "../routes/libraries/product-catalog/components/ProductCatalogFilter.generated";
import {
  SaveProductAttributesDocument,
  SaveProductAttributesMutation,
  SaveProductAttributesMutationVariables,
} from "../routes/libraries/product-catalog/components/product-attribute-modal/ProductAttributeModal.generated";
import {
  ProductSuperDrawerDetailsDocument,
  ProductSuperDrawerDetailsQuery,
  ProductSuperDrawerDetailsQueryVariables,
} from "../routes/libraries/product-catalog/components/product-super-drawer/ProductSuperDrawer.generated";
import {
  AddProductOfferingConfigMetaDocument,
  AddProductOfferingConfigMetaQuery,
  AddProductOfferingConfigMetaQueryVariables,
  AddProductOfferingConfigs_DeltasDocument,
  AddProductOfferingConfigs_DeltasQuery,
  AddProductOfferingConfigs_DeltasQueryVariables,
  CreateProjectFromConfigMetaDocument,
  CreateProjectFromConfigMetaQuery,
  CreateProjectFromConfigMetaQueryVariables,
  CreateProjectFromProductOfferingConfigDocument,
  CreateProjectFromProductOfferingConfigMutation,
  CreateProjectFromProductOfferingConfigMutationVariables,
  EditProductOfferingConfigDocument,
  EditProductOfferingConfigQuery,
  EditProductOfferingConfigQueryVariables,
  SaveProductOfferingConfigDocument,
  SaveProductOfferingConfigMutation,
  SaveProductOfferingConfigMutationVariables,
} from "../routes/libraries/product-offering-configs/AddProductOfferingConfigPage.generated";
import {
  ProductOfferingConfigsDocument,
  ProductOfferingConfigsPageMetadataDocument,
  ProductOfferingConfigsPageMetadataQuery,
  ProductOfferingConfigsPageMetadataQueryVariables,
  ProductOfferingConfigsQuery,
  ProductOfferingConfigsQueryVariables,
} from "../routes/libraries/product-offering-configs/ProductOfferingConfigsPage.generated";
import {
  GlobalProductOfferingsMetaDataDocument,
  GlobalProductOfferingsMetaDataQuery,
  GlobalProductOfferingsMetaDataQueryVariables,
  GlobalProductOfferingsPageDocument,
  GlobalProductOfferingsPageQuery,
  GlobalProductOfferingsPageQueryVariables,
} from "../routes/libraries/product-offerings/GlobalProductOfferings.generated";
import {
  OfferingDetailsStep_CommunitiesDocument,
  OfferingDetailsStep_CommunitiesQuery,
  OfferingDetailsStep_CommunitiesQueryVariables,
  OfferingDetailsStep_DevelopmentsDocument,
  OfferingDetailsStep_DevelopmentsQuery,
  OfferingDetailsStep_DevelopmentsQueryVariables,
} from "../routes/libraries/product-offerings/add-product-offering/components/1.OfferingDetailsStep.generated";
import {
  PlanPackageStepDocument,
  PlanPackageStepQuery,
  PlanPackageStepQueryVariables,
} from "../routes/libraries/product-offerings/add-product-offering/components/2.PlanPackageStep.generated";
import {
  DesignPackagesStepDocument,
  DesignPackagesStepQuery,
  DesignPackagesStepQueryVariables,
} from "../routes/libraries/product-offerings/add-product-offering/components/3.DesignPackagesStep.generated";
import {
  OptionsStepDocument,
  OptionsStepQuery,
  OptionsStepQueryVariables,
} from "../routes/libraries/product-offerings/add-product-offering/components/4.OptionsStep.generated";
import {
  ReviewStep_SaveProductOfferingDocument,
  ReviewStep_SaveProductOfferingMutation,
  ReviewStep_SaveProductOfferingMutationVariables,
  ReviewStepDocument,
  ReviewStepQuery,
  ReviewStepQueryVariables,
} from "../routes/libraries/product-offerings/add-product-offering/components/5.ReviewStep.generated";
import {
  CheckoutPricingTraceGroupDetailDocument,
  CheckoutPricingTraceGroupDetailQuery,
  CheckoutPricingTraceGroupDetailQueryVariables,
  CheckoutPricingTracePage_OverviewDocument,
  CheckoutPricingTracePage_OverviewQuery,
  CheckoutPricingTracePage_OverviewQueryVariables,
} from "../routes/libraries/product-offerings/checkout-pricing-trace/CheckoutPricingTracePage.generated";
import {
  EditProductOfferingPageDocument,
  EditProductOfferingPageQuery,
  EditProductOfferingPageQueryVariables,
} from "../routes/libraries/product-offerings/edit-product-offering/EditProductOfferingPage.generated";
import {
  DevelopmentsByMarketDocument,
  DevelopmentsByMarketQuery,
  DevelopmentsByMarketQueryVariables,
} from "../routes/libraries/schedules/CreateOrUpdateScheduleTemplateModal.generated";
import {
  DuplicateScheduleTemplateDocument,
  DuplicateScheduleTemplateMutation,
  DuplicateScheduleTemplateMutationVariables,
  SaveScheduleTemplatesDocument,
  SaveScheduleTemplatesMutation,
  SaveScheduleTemplatesMutationVariables,
  ScheduleTemplateDetailDocument,
  ScheduleTemplateDetailQuery,
  ScheduleTemplateDetailQueryVariables,
  ScheduleTemplateEditPageDocument,
  ScheduleTemplateEditPageQuery,
  ScheduleTemplateEditPageQueryVariables,
  ScheduleTemplateMetadataDocument,
  ScheduleTemplateMetadataQuery,
  ScheduleTemplateMetadataQueryVariables,
  ScheduleTemplatesDocument,
  ScheduleTemplatesPageMetadataDocument,
  ScheduleTemplatesPageMetadataQuery,
  ScheduleTemplatesPageMetadataQueryVariables,
  ScheduleTemplatesQuery,
  ScheduleTemplatesQueryVariables,
} from "../routes/libraries/schedules/ScheduleTemplatesPage.generated";
import {
  ConstraintAndAllowanceCatalogPageDocument,
  ConstraintAndAllowanceCatalogPageQuery,
  ConstraintAndAllowanceCatalogPageQueryVariables,
} from "../routes/libraries/task-catalog/ConstraintItemCatalogPage.generated";
import {
  TaskCatalogLaborCostsPageDocument,
  TaskCatalogLaborCostsPageQuery,
  TaskCatalogLaborCostsPageQueryVariables,
} from "../routes/libraries/task-catalog/TaskCatalogLaborCostsPage.generated";
import {
  TaskCatalogPageMetadataDocument,
  TaskCatalogPageMetadataQuery,
  TaskCatalogPageMetadataQueryVariables,
} from "../routes/libraries/task-catalog/TaskCatalogPage.generated";
import {
  TaskCatalogTableDocument,
  TaskCatalogTableMetadataDocument,
  TaskCatalogTableMetadataQuery,
  TaskCatalogTableMetadataQueryVariables,
  TaskCatalogTableQuery,
  TaskCatalogTableQueryVariables,
} from "../routes/libraries/task-catalog/TaskCatalogTable.generated";
import {
  SaveGlobalPlanConstraintItemDocument,
  SaveGlobalPlanConstraintItemMutation,
  SaveGlobalPlanConstraintItemMutationVariables,
} from "../routes/libraries/task-catalog/components/AddConstraintItemModal.generated";
import {
  SaveGlobalPlanTagDocument,
  SaveGlobalPlanTagMutation,
  SaveGlobalPlanTagMutationVariables,
} from "../routes/libraries/task-catalog/components/AddGlobalPlanTagModal.generated";
import {
  AddStageModalDocument,
  AddStageModalMutation,
  AddStageModalMutationVariables,
} from "../routes/libraries/task-catalog/components/AddStageModal.generated";
import {
  BulkGlobalPlanTagsDocument,
  BulkGlobalPlanTagsModalDocument,
  BulkGlobalPlanTagsModalQuery,
  BulkGlobalPlanTagsModalQueryVariables,
  BulkGlobalPlanTagsMutation,
  BulkGlobalPlanTagsMutationVariables,
} from "../routes/libraries/task-catalog/components/BulkGlobalPlanTagsModal.generated";
import {
  CatalogTaskIdsDocument,
  CatalogTaskIdsQuery,
  CatalogTaskIdsQueryVariables,
  MermaidDocument,
  MermaidQuery,
  MermaidQueryVariables,
} from "../routes/libraries/task-catalog/components/MermaidLinkModal.generated";
import {
  SaveGlobalPlanTaskDocument,
  SaveGlobalPlanTaskMutation,
  SaveGlobalPlanTaskMutationVariables,
  TaskCatalogFormDocument,
  TaskCatalogFormDocumentsDocument,
  TaskCatalogFormDocumentsQuery,
  TaskCatalogFormDocumentsQueryVariables,
  TaskCatalogFormDropdownDocument,
  TaskCatalogFormDropdownQuery,
  TaskCatalogFormDropdownQueryVariables,
  TaskCatalogFormParentDropdownDocument,
  TaskCatalogFormParentDropdownQuery,
  TaskCatalogFormParentDropdownQueryVariables,
  TaskCatalogFormQuery,
  TaskCatalogFormQueryVariables,
  TaskCatalogFormSchedulingDropdownDocument,
  TaskCatalogFormSchedulingDropdownQuery,
  TaskCatalogFormSchedulingDropdownQueryVariables,
} from "../routes/libraries/task-catalog/components/TaskCatalogForm.generated";
import {
  LienWaiversPageDocument,
  LienWaiversPageQuery,
  LienWaiversPageQueryVariables,
  SaveLienWaiverDocument,
  SaveLienWaiverMutation,
  SaveLienWaiverMutationVariables,
} from "../routes/lien-waivers/LienWaiversPage.generated";
import {
  UserEventsDocument,
  UserEventsQuery,
  UserEventsQueryVariables,
} from "../routes/my-blueprint/activity-feed/ActivityFeedPage.generated";
import {
  BillPdfDocument,
  BillPdfQuery,
  BillPdfQueryVariables,
  BillPdfTradePartnerContactDocument,
  BillPdfTradePartnerContactQuery,
  BillPdfTradePartnerContactQueryVariables,
} from "../routes/pdfs/BillPdf/BillPdf.generated";
import {
  CommitmentChangeOrderPdfDocument,
  CommitmentChangeOrderPdfQuery,
  CommitmentChangeOrderPdfQueryVariables,
  CommitmentPdfDocument,
  CommitmentPdfQuery,
  CommitmentPdfQueryVariables,
} from "../routes/pdfs/CommitmentOrChangeOrderPdf/CommitmentOrChangeOrderPdf.generated";
import {
  DevelopmentCommitmentPdfDocument,
  DevelopmentCommitmentPdfQuery,
  DevelopmentCommitmentPdfQueryVariables,
} from "../routes/pdfs/DevelopmentCommitmentPdf/DevelopmentCommitmentPdf.generated";
import {
  DevelopmentContractPdfDocument,
  DevelopmentContractPdfQuery,
  DevelopmentContractPdfQueryVariables,
} from "../routes/pdfs/DevelopmentContractPdf/DevelopmentContractPdf.generated";
import {
  EstimateExportPageDocument,
  EstimateExportPageQuery,
  EstimateExportPageQueryVariables,
} from "../routes/pdfs/EstimateExportPage.generated";
import {
  FinishScheduleVisualModePdfDocument,
  FinishScheduleVisualModePdfQuery,
  FinishScheduleVisualModePdfQueryVariables,
} from "../routes/pdfs/FinishSchedulePdf/FinishScheduleVisualModePdf.generated";
import {
  HomeownerChangeOrderDocument,
  HomeownerChangeOrderQuery,
  HomeownerChangeOrderQueryVariables,
} from "../routes/pdfs/HomeownerChangeOrderPdf.generated";
import {
  InvoicePandaDocPdfDocument,
  InvoicePandaDocPdfQuery,
  InvoicePandaDocPdfQueryVariables,
} from "../routes/pdfs/InvoicePdf/InvoicePandaDocPdf.generated";
import {
  LienWaiverLastPaidBillDocument,
  LienWaiverLastPaidBillQuery,
  LienWaiverLastPaidBillQueryVariables,
  LienWaiverPdfDocument,
  LienWaiverPdfQuery,
  LienWaiverPdfQueryVariables,
} from "../routes/pdfs/LienWaiverPdf/LienWaiverPdf.generated";
import {
  PdfProjectItemsDocument,
  PdfProjectItemsQuery,
  PdfProjectItemsQueryVariables,
} from "../routes/pdfs/PdfProjectItems.generated";
import {
  ProjectFinishSchedulePdfMetadataDocument,
  ProjectFinishSchedulePdfMetadataQuery,
  ProjectFinishSchedulePdfMetadataQueryVariables,
} from "../routes/pdfs/ProjectFinishSchedulePdf/ProjectFinishSchedulePdf.generated";
import {
  ProjectFinishScheduleVisualModePdfDocument,
  ProjectFinishScheduleVisualModePdfQuery,
  ProjectFinishScheduleVisualModePdfQueryVariables,
} from "../routes/pdfs/ProjectFinishSchedulePdf/ProjectFinishScheduleVisualModePdf.generated";
import {
  ScheduleExportPageDocument,
  ScheduleExportPageQuery,
  ScheduleExportPageQueryVariables,
} from "../routes/pdfs/ScheduleExportPdf/ScheduleExportPdf.generated";
import { ToDosPdfDocument, ToDosPdfQuery, ToDosPdfQueryVariables } from "../routes/pdfs/ToDosPdf/ToDosPdf.generated";
import {
  TradeScopeOfWorkDocument,
  TradeScopeOfWorkQuery,
  TradeScopeOfWorkQueryVariables,
} from "../routes/pdfs/TradeScopeOfWorkPdf.generated";
import {
  TradeSpecificAgreementDocument,
  TradeSpecificAgreementQuery,
  TradeSpecificAgreementQueryVariables,
} from "../routes/pdfs/TradeSpecificAgreement/TradeSpecificAgreement.generated";
import {
  TradesPunchlistPdfDocument,
  TradesPunchlistPdfQuery,
  TradesPunchlistPdfQueryVariables,
} from "../routes/pdfs/TradesPuchlistPdf/TradesPunchlistPdf.generated";
import {
  LotSequenceSheetPdfDocument,
  LotSequenceSheetPdfQuery,
  LotSequenceSheetPdfQueryVariables,
} from "../routes/pdfs/lot-sequence-sheet/LotSequenceSheetPdf.generated";
import {
  LotSummaryDetailsPdfDocument,
  LotSummaryDetailsPdfQuery,
  LotSummaryDetailsPdfQueryVariables,
} from "../routes/pdfs/lot-summary-details/LotSummaryDetailsPdf.generated";
import {
  AssignedToDosDocument,
  AssignedToDosQuery,
  AssignedToDosQueryVariables,
  PersonalDashboardsPageDocument,
  PersonalDashboardsPageQuery,
  PersonalDashboardsPageQueryVariables,
  TeamMembersProjectsDocument,
  TeamMembersProjectsQuery,
  TeamMembersProjectsQueryVariables,
} from "../routes/personal-dashboard/PersonalDashboard.generated";
import {
  ApprovalSummaryHeaderDocument,
  ApprovalSummaryHeaderQuery,
  ApprovalSummaryHeaderQueryVariables,
} from "../routes/personal-dashboard/components/ApprovalSummaryHeader.generated";
import {
  BillsSummaryHeaderDocument,
  BillsSummaryHeaderQuery,
  BillsSummaryHeaderQueryVariables,
} from "../routes/personal-dashboard/components/BillsSummaryHeader.generated";
import {
  DashboardCommentsDocument,
  DashboardCommentsQuery,
  DashboardCommentsQueryVariables,
} from "../routes/personal-dashboard/components/DashboardCommentsWidget.generated";
import {
  ProjectsWidgetFinancialsTabDocument,
  ProjectsWidgetFinancialsTableDocument,
  ProjectsWidgetFinancialsTableQuery,
  ProjectsWidgetFinancialsTableQueryVariables,
  ProjectsWidgetFinancialsTabQuery,
  ProjectsWidgetFinancialsTabQueryVariables,
} from "../routes/personal-dashboard/components/ProjectsWidgetFinancials.generated";
import {
  ProjectsWidgetScheduleTabDocument,
  ProjectsWidgetScheduleTabQuery,
  ProjectsWidgetScheduleTabQueryVariables,
} from "../routes/personal-dashboard/components/ProjectsWidgetSchedule.generated";
import {
  SchedulingModalDocument,
  SchedulingModalQuery,
  SchedulingModalQueryVariables,
} from "../routes/personal-dashboard/components/SchedulingModal.generated";
import {
  TasksSummaryHeaderDocument,
  TasksSummaryHeaderQuery,
  TasksSummaryHeaderQueryVariables,
} from "../routes/personal-dashboard/components/TasksSummaryHeader.generated";
import {
  SaveTradePartnerAvailabilityRequestDocument,
  SaveTradePartnerAvailabilityRequestMutation,
  SaveTradePartnerAvailabilityRequestMutationVariables,
} from "../routes/personal-dashboard/components/TradePartnerAvailabilityRequestDetailPane.generated";
import {
  ActionItemsApprovalsDocument,
  ActionItemsApprovalsQuery,
  ActionItemsApprovalsQueryVariables,
  ActionItemsBillsPendingReviewDocument,
  ActionItemsBillsPendingReviewQuery,
  ActionItemsBillsPendingReviewQueryVariables,
  ActionItemsDeferredBillsDocument,
  ActionItemsDeferredBillsQuery,
  ActionItemsDeferredBillsQueryVariables,
  ActionItemsDelayFlagsDocument,
  ActionItemsDelayFlagsQuery,
  ActionItemsDelayFlagsQueryVariables,
  ActionItemsSchedulingDocument,
  ActionItemsSchedulingQuery,
  ActionItemsSchedulingQueryVariables,
  ActionItemsStaleTasksDocument,
  ActionItemsStaleTasksQuery,
  ActionItemsStaleTasksQueryVariables,
} from "../routes/personal-dashboard/pages/action-items/ActionItemsPage.generated";
import {
  ApprovalsDashboardDocument,
  ApprovalsDashboardQuery,
  ApprovalsDashboardQueryVariables,
  CreatePandaDocSessionDocument,
  CreatePandaDocSessionMutation,
  CreatePandaDocSessionMutationVariables,
  UpdateApproversDocument,
  UpdateApproversMutation,
  UpdateApproversMutationVariables,
} from "../routes/personal-dashboard/pages/approvals-dashboard/ApprovalsDashboard.generated";
import {
  ToDosPageDataDocument,
  ToDosPageDataQuery,
  ToDosPageDataQueryVariables,
} from "../routes/personal-dashboard/pages/to-dos/ToDosPage.generated";
import {
  SaveUpcomingPlanTaskDocument,
  SaveUpcomingPlanTaskMutation,
  SaveUpcomingPlanTaskMutationVariables,
  UpcomingTasksDocument,
  UpcomingTasksQuery,
  UpcomingTasksQueryVariables,
} from "../routes/personal-dashboard/pages/upcoming/UpcomingPage.generated";
import {
  CurrentUserDocument,
  CurrentUserQuery,
  CurrentUserQueryVariables,
} from "../routes/profile/UserProfile.generated";
import {
  ProjectHeaderDocument,
  ProjectHeaderQuery,
  ProjectHeaderQueryVariables,
} from "../routes/projects/ProjectHeader.generated";
import {
  ProjectLayoutDocument,
  ProjectLayoutQuery,
  ProjectLayoutQueryVariables,
} from "../routes/projects/ProjectLayout.generated";
import {
  ProjectsPageMetadataDocument,
  ProjectsPageMetadataQuery,
  ProjectsPageMetadataQueryVariables,
  ProjectsPageProjectsDocument,
  ProjectsPageProjectsQuery,
  ProjectsPageProjectsQueryVariables,
} from "../routes/projects/ProjectsPage.generated";
import {
  SubmitApprovalDocument,
  SubmitApprovalMutation,
  SubmitApprovalMutationVariables,
} from "../routes/projects/approvals/Approvals.generated";
import {
  ProjectBidContractOverviewPageDocument,
  ProjectBidContractOverviewPageQuery,
  ProjectBidContractOverviewPageQueryVariables,
} from "../routes/projects/bid-contracts/ProjectBidContractOverviewPage.generated";
import {
  ProjectBidContractsPageDocument,
  ProjectBidContractsPageQuery,
  ProjectBidContractsPageQueryVariables,
} from "../routes/projects/bid-contracts/ProjectBidContractsPage.generated";
import {
  BudgetSummaryDocument,
  BudgetSummaryQuery,
  BudgetSummaryQueryVariables,
} from "../routes/projects/budget/BudgetPage.generated";
import {
  HierarchyBudgetPage_RollupViewDocument,
  HierarchyBudgetPage_RollupViewQuery,
  HierarchyBudgetPage_RollupViewQueryVariables,
  HierarchyBudgetPage_SharedCostsDocument,
  HierarchyBudgetPage_SharedCostsQuery,
  HierarchyBudgetPage_SharedCostsQueryVariables,
  HierarchyBudgetPageDocument,
  HierarchyBudgetPageQuery,
  HierarchyBudgetPageQueryVariables,
} from "../routes/projects/budget/HierarchyBudgetPage.generated";
import {
  BudgetActivityTabMetaDocument,
  BudgetActivityTabMetaQuery,
  BudgetActivityTabMetaQueryVariables,
  BudgetSuperDrawerDocument,
  BudgetSuperDrawerQuery,
  BudgetSuperDrawerQueryVariables,
} from "../routes/projects/budget/components/BudgetSuperDrawer.generated";
import {
  BudgetOverviewTabDocument,
  BudgetOverviewTabQuery,
  BudgetOverviewTabQueryVariables,
} from "../routes/projects/budget/components/reports/BudgetOverviewTab.generated";
import {
  CommittedAtStartTab_CommitmentsByProjectCostCodeDocument,
  CommittedAtStartTab_CommitmentsByProjectCostCodeQuery,
  CommittedAtStartTab_CommitmentsByProjectCostCodeQueryVariables,
  CommittedAtStartTabDocument,
  CommittedAtStartTabQuery,
  CommittedAtStartTabQueryVariables,
} from "../routes/projects/budget/components/reports/CommittedAtStartTab.generated";
import {
  DirectMarginTabDocument,
  DirectMarginTabQuery,
  DirectMarginTabQueryVariables,
} from "../routes/projects/budget/components/reports/DirectMarginTab.generated";
import {
  VarianceTabDocument,
  VarianceTabQuery,
  VarianceTabQueryVariables,
} from "../routes/projects/budget/components/reports/VarianceTab.generated";
import {
  CompletedTaskBudgetReviewWidgetDocument,
  CompletedTaskBudgetReviewWidgetQuery,
  CompletedTaskBudgetReviewWidgetQueryVariables,
} from "../routes/projects/budget/components/reports/widgets/CompletedTaskBudgetReviewWidget.generated";
import {
  CeliSelectionOverviewTabDocument,
  CeliSelectionOverviewTabQuery,
  CeliSelectionOverviewTabQueryVariables,
  CeliSelectionOverviewTabSaveCeliDocument,
  CeliSelectionOverviewTabSaveCeliMutation,
  CeliSelectionOverviewTabSaveCeliMutationVariables,
} from "../routes/projects/change-events/CeliSelectionOverviewTab.generated";
import {
  CeliSpecOverviewTabDocument,
  CeliSpecOverviewTabQuery,
  CeliSpecOverviewTabQueryVariables,
  CeliSpecOverviewTabSaveCeliDocument,
  CeliSpecOverviewTabSaveCeliMutation,
  CeliSpecOverviewTabSaveCeliMutationVariables,
} from "../routes/projects/change-events/CeliSpecOverviewTab.generated";
import {
  ChangeEventAssociationsDocument,
  ChangeEventAssociationsQuery,
  ChangeEventAssociationsQueryVariables,
} from "../routes/projects/change-events/ChangeEventAssociationsTable.generated";
import {
  CommitmentsForChangeEventDocument,
  CommitmentsForChangeEventQuery,
  CommitmentsForChangeEventQueryVariables,
} from "../routes/projects/change-events/ChangeEventCommitmentsTab.generated";
import {
  ChangeEventEstimatesTabDocument,
  ChangeEventEstimatesTabQuery,
  ChangeEventEstimatesTabQueryVariables,
} from "../routes/projects/change-events/ChangeEventEstimatesTab.generated";
import {
  ChangeEventHistoryDocument,
  ChangeEventHistoryQuery,
  ChangeEventHistoryQueryVariables,
} from "../routes/projects/change-events/ChangeEventHistoryTab.generated";
import {
  AddChangeEventLineItemsTabDocument,
  AddChangeEventLineItemsTabMutation,
  AddChangeEventLineItemsTabMutationVariables,
  ApplyItemTemplateToChangeEventLineItemsTabDocument,
  ApplyItemTemplateToChangeEventLineItemsTabMutation,
  ApplyItemTemplateToChangeEventLineItemsTabMutationVariables,
  ChangeEventLineItemsTabDocument,
  ChangeEventLineItemsTabQuery,
  ChangeEventLineItemsTabQueryVariables,
  CreateChangeEventLineItemsTabDocument,
  CreateChangeEventLineItemsTabMutation,
  CreateChangeEventLineItemsTabMutationVariables,
  DeleteChangeEventLineItemsTabDocument,
  DeleteChangeEventLineItemsTabMutation,
  DeleteChangeEventLineItemsTabMutationVariables,
  SaveChangeEventLineItemsTabDocument,
  SaveChangeEventLineItemsTabMutation,
  SaveChangeEventLineItemsTabMutationVariables,
  SaveHomeownerSelectionChangeEventLineItemsTabDocument,
  SaveHomeownerSelectionChangeEventLineItemsTabMutation,
  SaveHomeownerSelectionChangeEventLineItemsTabMutationVariables,
} from "../routes/projects/change-events/ChangeEventLineItemsTab.generated";
import {
  ChangeEventOverviewTabDocument,
  ChangeEventOverviewTabQuery,
  ChangeEventOverviewTabQueryVariables,
  SaveChangeEventOverviewTabDocument,
  SaveChangeEventOverviewTabMutation,
  SaveChangeEventOverviewTabMutationVariables,
} from "../routes/projects/change-events/ChangeEventOverviewTab.generated";
import {
  ChangeEventPageDocument,
  ChangeEventPageQuery,
  ChangeEventPageQueryVariables,
  DeleteChangeEventDocument,
  DeleteChangeEventMutation,
  DeleteChangeEventMutationVariables,
} from "../routes/projects/change-events/ChangeEventPage.generated";
import {
  ChangeEventRposTabDocument,
  ChangeEventRposTabQuery,
  ChangeEventRposTabQueryVariables,
  SaveChangeEventRposDocument,
  SaveChangeEventRposMutation,
  SaveChangeEventRposMutationVariables,
} from "../routes/projects/change-events/ChangeEventRposTab.generated";
import {
  ChangeEventsForProjectStageDocument,
  ChangeEventsForProjectStageQuery,
  ChangeEventsForProjectStageQueryVariables,
} from "../routes/projects/change-events/ChangeEventsPage.generated";
import {
  AcceptChangeEventModalDocument,
  AcceptChangeEventModalQuery,
  AcceptChangeEventModalQueryVariables,
} from "../routes/projects/change-events/components/AcceptChangeEventModal.generated";
import {
  ApplyTemplateChangeEventModalDocument,
  ApplyTemplateChangeEventModalQuery,
  ApplyTemplateChangeEventModalQueryVariables,
  ApplyTemplatePlanChangeEventModalDocument,
  ApplyTemplatePlanChangeEventModalQuery,
  ApplyTemplatePlanChangeEventModalQueryVariables,
} from "../routes/projects/change-events/components/ApplyTemplateModal.generated";
import {
  ChangeEventLineItemTradePartnerSelectDocument,
  ChangeEventLineItemTradePartnerSelectQuery,
  ChangeEventLineItemTradePartnerSelectQueryVariables,
} from "../routes/projects/change-events/components/ChangeEventLineItemTradePartnerSelect.generated";
import {
  CreateCeModalDocument,
  CreateCeModalQuery,
  CreateCeModalQueryVariables,
  CreateCeModalSaveCeDocument,
  CreateCeModalSaveCeMutation,
  CreateCeModalSaveCeMutationVariables,
} from "../routes/projects/change-events/components/CreateChangeEventModal.generated";
import {
  SaveChangeEventLineItemsDocument,
  SaveChangeEventLineItemsMutation,
  SaveChangeEventLineItemsMutationVariables,
} from "../routes/projects/change-events/components/EraseChangeEventPricesModal.generated";
import {
  CreateChangeEventLineItemsFromCommittedDocument,
  CreateChangeEventLineItemsFromCommittedMutation,
  CreateChangeEventLineItemsFromCommittedMutationVariables,
} from "../routes/projects/change-events/components/ImportFromCommittedModal.generated";
import {
  CommitmentChangeOrderPageDocument,
  CommitmentChangeOrderPageQuery,
  CommitmentChangeOrderPageQueryVariables,
  DeleteCommitmentChangeOrderDocument,
  DeleteCommitmentChangeOrderMutation,
  DeleteCommitmentChangeOrderMutationVariables,
  SaveCommitmentChangeOrderDocument,
  SaveCommitmentChangeOrderMutation,
  SaveCommitmentChangeOrderMutationVariables,
} from "../routes/projects/commitments/CommitmentChangeOrderPage.generated";
import {
  CommitmentHistoryDocument,
  CommitmentHistoryQuery,
  CommitmentHistoryQueryVariables,
  CommitmentWithProjectItemsDocument,
  CommitmentWithProjectItemsQuery,
  CommitmentWithProjectItemsQueryVariables,
  DeleteCommitmentDocument,
  DeleteCommitmentMutation,
  DeleteCommitmentMutationVariables,
  NewCommitmentWithProjectItemsDataDocument,
  NewCommitmentWithProjectItemsDataQuery,
  NewCommitmentWithProjectItemsDataQueryVariables,
  ReleaseBidCommitmentsDocument,
  ReleaseBidCommitmentsMutation,
  ReleaseBidCommitmentsMutationVariables,
  SaveCommitmentDocument,
  SaveCommitmentMutation,
  SaveCommitmentMutationVariables,
} from "../routes/projects/commitments/CommitmentPage.generated";
import {
  CommitmentsPageDocument,
  CommitmentsPageMetadataDocument,
  CommitmentsPageMetadataQuery,
  CommitmentsPageMetadataQueryVariables,
  CommitmentsPageQuery,
  CommitmentsPageQueryVariables,
} from "../routes/projects/commitments/CommitmentsPage.generated";
import {
  AddDepositModalDocument,
  AddDepositModalQuery,
  AddDepositModalQueryVariables,
} from "../routes/projects/commitments/components/AddDepositModal.generated";
import {
  CommitmentOverviewCommentDrawerDocument,
  CommitmentOverviewCommentDrawerQuery,
  CommitmentOverviewCommentDrawerQueryVariables,
} from "../routes/projects/commitments/components/CommitmentOverviewCommentDrawer.generated";
import {
  DeleteUploadedPandaDocDocument,
  DeleteUploadedPandaDocMutation,
  DeleteUploadedPandaDocMutationVariables,
} from "../routes/projects/commitments/components/DeletePandaDocModal.generated";
import {
  CreateNewCommitmentDataDocument,
  CreateNewCommitmentDataQuery,
  CreateNewCommitmentDataQueryVariables,
  SaveNewCommitmentDocument,
  SaveNewCommitmentMutation,
  SaveNewCommitmentMutationVariables,
} from "../routes/projects/commitments/components/NewCommitmentModal.generated";
import {
  SaveOwnerPandaDocDocument,
  SaveOwnerPandaDocMutation,
  SaveOwnerPandaDocMutationVariables,
} from "../routes/projects/commitments/components/PandaDocModalContent.generated";
import {
  PaymentScheduleTabDocument,
  PaymentScheduleTabQuery,
  PaymentScheduleTabQueryVariables,
} from "../routes/projects/commitments/components/PaymentScheduleTab.generated";
import {
  AddLaborItemModal_EffectiveLocationsDocument,
  AddLaborItemModal_EffectiveLocationsQuery,
  AddLaborItemModal_EffectiveLocationsQueryVariables,
  AddLaborItemModal_GlobalPlanTasksDocument,
  AddLaborItemModal_GlobalPlanTasksQuery,
  AddLaborItemModal_GlobalPlanTasksQueryVariables,
} from "../routes/projects/components/AddLaborItemModal.generated";
import {
  AddMaterialItemModalMetadataDocument,
  AddMaterialItemModalMetadataQuery,
  AddMaterialItemModalMetadataQueryVariables,
} from "../routes/projects/components/AddMaterialItemModal.generated";
import {
  LotConfigurationDetailsDocument,
  LotConfigurationDetailsQuery,
  LotConfigurationDetailsQueryVariables,
} from "../routes/projects/components/LotConfigurationDetailsStaticField.generated";
import {
  RedirectToActiveStageDocument,
  RedirectToActiveStageQuery,
  RedirectToActiveStageQueryVariables,
} from "../routes/projects/components/RedirectToActiveStage.generated";
import {
  HierarchyDashboardPage_FilterOptionsDocument,
  HierarchyDashboardPage_FilterOptionsQuery,
  HierarchyDashboardPage_FilterOptionsQueryVariables,
  HierarchyDashboardPage_ProjectsDocument,
  HierarchyDashboardPage_ProjectsQuery,
  HierarchyDashboardPage_ProjectsQueryVariables,
} from "../routes/projects/dashboard/HierarchyDashboardPage.generated";
import {
  ActivityTabDataDocument,
  ActivityTabDataQuery,
  ActivityTabDataQueryVariables,
} from "../routes/projects/dashboard/components/ActivityTab.generated";
import {
  ProjectDashboardTabDocument,
  ProjectDashboardTabQuery,
  ProjectDashboardTabQueryVariables,
  SaveProjectDashboardDocument,
  SaveProjectDashboardMutation,
  SaveProjectDashboardMutationVariables,
} from "../routes/projects/dashboard/components/DashboardTab.generated";
import {
  UserProjectDocumentsDocument,
  UserProjectDocumentsQuery,
  UserProjectDocumentsQueryVariables,
} from "../routes/projects/dashboard/components/DocumentsTile/DocumentsTile.generated";
import {
  ProjectDashboardFinancialsDocument,
  ProjectDashboardFinancialsQuery,
  ProjectDashboardFinancialsQueryVariables,
} from "../routes/projects/dashboard/components/Financials/ProjectDashboardFinancials.generated";
import {
  HomeownerNotesTileDocument,
  HomeownerNotesTileQuery,
  HomeownerNotesTileQueryVariables,
} from "../routes/projects/dashboard/components/HomeownerNotesTile/HomeownerNotesTile.generated";
import {
  JobLogsTileDocument,
  JobLogsTileQuery,
  JobLogsTileQueryVariables,
} from "../routes/projects/dashboard/components/JobLogsTile/JobLogsTile.generated";
import {
  PhotosTileDocument,
  PhotosTileQuery,
  PhotosTileQueryVariables,
} from "../routes/projects/dashboard/components/PhotosTile/PhotosTile.generated";
import {
  PreConExpectationsTabDocument,
  PreConExpectationsTabQuery,
  PreConExpectationsTabQueryVariables,
} from "../routes/projects/dashboard/components/PreConExpectationsTab.generated";
import {
  ProjectInfoTileDocument,
  ProjectInfoTileQuery,
  ProjectInfoTileQueryVariables,
} from "../routes/projects/dashboard/components/ProjectInfoTile/ProjectInfoTile.generated";
import {
  RecentActivityRailDocument,
  RecentActivityRailQuery,
  RecentActivityRailQueryVariables,
} from "../routes/projects/dashboard/components/RecentActivityRail/RecentActivityRail.generated";
import {
  ProjectScheduleTileDocument,
  ProjectScheduleTileQuery,
  ProjectScheduleTileQueryVariables,
} from "../routes/projects/dashboard/components/ScheduleTile/ScheduleTile.generated";
import {
  TeamMembersTileInternalUsersDocument,
  TeamMembersTileInternalUsersQuery,
  TeamMembersTileInternalUsersQueryVariables,
  TeamMembersTileTradePartnersDocument,
  TeamMembersTileTradePartnersQuery,
  TeamMembersTileTradePartnersQueryVariables,
} from "../routes/projects/dashboard/components/TeamMembersTile/TeamMembersTile.generated";
import {
  ProjectToDosTileDocument,
  ProjectToDosTileQuery,
  ProjectToDosTileQueryVariables,
} from "../routes/projects/dashboard/components/ToDosTile/ProjectToDosTile.generated";
import {
  DeleteDocumentsDocument,
  DeleteDocumentsMutation,
  DeleteDocumentsMutationVariables,
  DocumentCategoriesDocument,
  DocumentCategoriesQuery,
  DocumentCategoriesQueryVariables,
  DocumentEditorDocument,
  DocumentEditorQuery,
  DocumentEditorQueryVariables,
  DocumentsAssetDocument,
  DocumentsAssetQuery,
  DocumentsAssetQueryVariables,
  DocumentsForParentDocument,
  DocumentsForParentQuery,
  DocumentsForParentQueryVariables,
  DocumentsPageDocument,
  DocumentsPageMetadataDocument,
  DocumentsPageMetadataQuery,
  DocumentsPageMetadataQueryVariables,
  DocumentsPageQuery,
  DocumentsPageQueryVariables,
  SaveDocumentsDocument,
  SaveDocumentsMutation,
  SaveDocumentsMutationVariables,
  ScheduleTasksForDocumentParentDocument,
  ScheduleTasksForDocumentParentQuery,
  ScheduleTasksForDocumentParentQueryVariables,
  ToggleDocumentAsFavoritedDocument,
  ToggleDocumentAsFavoritedMutation,
  ToggleDocumentAsFavoritedMutationVariables,
} from "../routes/projects/documents/DocumentsPage.generated";
import {
  DraftScheduleSidePaneDocument,
  DraftScheduleSidePaneQuery,
  DraftScheduleSidePaneQueryVariables,
  DynamicScheduleSidePaneDocument,
  DynamicScheduleSidePaneQuery,
  DynamicScheduleSidePaneQueryVariables,
} from "../routes/projects/dynamic-schedules/components/DynamicScheduleSidePane.generated";
import {
  SaveTradePartnerAvailabilityRequestsDocument,
  SaveTradePartnerAvailabilityRequestsMutation,
  SaveTradePartnerAvailabilityRequestsMutationVariables,
  SendSingleTradePartnerAvailabilityRequestEmailDocument,
  SendSingleTradePartnerAvailabilityRequestEmailQuery,
  SendSingleTradePartnerAvailabilityRequestEmailQueryVariables,
  SendTradePartnerAvailabilityRequestEmailDocument,
  SendTradePartnerAvailabilityRequestEmailQuery,
  SendTradePartnerAvailabilityRequestEmailQueryVariables,
} from "../routes/projects/dynamic-schedules/components/SendTradePartnerAvailabilityRequestEmail.generated";
import {
  PlanTaskBillModal_ProtoBillsDocument,
  PlanTaskBillModal_ProtoBillsQuery,
  PlanTaskBillModal_ProtoBillsQueryVariables,
} from "../routes/projects/dynamic-schedules/components/bill-modal/PlanTaskBillModal.generated";
import {
  DynamicSchedulesSnapshotsDocument,
  DynamicSchedulesSnapshotsQuery,
  DynamicSchedulesSnapshotsQueryVariables,
} from "../routes/projects/dynamic-schedules/components/useScheduleSnapshots.generated";
import {
  PublishDraftScheduleStepperDocument,
  PublishDraftScheduleStepperQuery,
  PublishDraftScheduleStepperQueryVariables,
} from "../routes/projects/dynamic-schedules/draft-mode/PublishDraftScheduleStepper.generated";
import {
  DraftCatalogTasksDocument,
  DraftCatalogTasksQuery,
  DraftCatalogTasksQueryVariables,
  DraftPlanScheduleDocument,
  DraftPlanScheduleQuery,
  DraftPlanScheduleQueryVariables,
  SaveDraftPlanScheduleDocument,
  SaveDraftPlanScheduleMutation,
  SaveDraftPlanScheduleMutationVariables,
  ScheduleDraftModeScheduleFlagReasonsDocument,
  ScheduleDraftModeScheduleFlagReasonsQuery,
  ScheduleDraftModeScheduleFlagReasonsQueryVariables,
} from "../routes/projects/dynamic-schedules/draft-mode/ScheduleDraftMode.generated";
import {
  TradeConfirmPublishStepDocument,
  TradeConfirmPublishStepQuery,
  TradeConfirmPublishStepQueryVariables,
} from "../routes/projects/dynamic-schedules/draft-mode/TradeConfirmPublishStep.generated";
import {
  PlanMilestoneDetailsPageDocument,
  PlanMilestoneDetailsPageQuery,
  PlanMilestoneDetailsPageQueryVariables,
} from "../routes/projects/dynamic-schedules/milestone-view/MilestoneDetailsPage.generated";
import {
  TaskTradePartnerContentMetadataDocument,
  TaskTradePartnerContentMetadataQuery,
  TaskTradePartnerContentMetadataQueryVariables,
} from "../routes/projects/dynamic-schedules/task-details/SchedulingCard.generated";
import {
  DeletePlanTaskChecklistItemDocument,
  DeletePlanTaskChecklistItemMutation,
  DeletePlanTaskChecklistItemMutationVariables,
  PlanTaskDetailsDocumentsDocument,
  PlanTaskDetailsDocumentsQuery,
  PlanTaskDetailsDocumentsQueryVariables,
  PlanTaskDetailsPageDocument,
  PlanTaskDetailsPageQuery,
  PlanTaskDetailsPageQueryVariables,
  SavePlanTaskChecklistItemDocument,
  SavePlanTaskChecklistItemMutation,
  SavePlanTaskChecklistItemMutationVariables,
  SavePlanTaskDocument,
  SavePlanTaskMutation,
  SavePlanTaskMutationVariables,
  SaveRequiredTaskDocumentOnPlanTaskDocument,
  SaveRequiredTaskDocumentOnPlanTaskMutation,
  SaveRequiredTaskDocumentOnPlanTaskMutationVariables,
} from "../routes/projects/dynamic-schedules/task-details/TaskDetailsPage.generated";
import {
  PlanTaskMaterialsPageDocument,
  PlanTaskMaterialsPageQuery,
  PlanTaskMaterialsPageQueryVariables,
} from "../routes/projects/dynamic-schedules/task-details/TaskMaterialsPage.generated";
import {
  CreateEstimateDocument,
  CreateEstimateMutation,
  CreateEstimateMutationVariables,
  CreateEstimateStagesDocument,
  CreateEstimateStagesQuery,
  CreateEstimateStagesQueryVariables,
} from "../routes/projects/estimates/CreateEstimateModal.generated";
import {
  EstimateHistoryDocument,
  EstimateHistoryQuery,
  EstimateHistoryQueryVariables,
} from "../routes/projects/estimates/EstimateHistoryTab.generated";
import {
  EstimateLineItemTabDocument,
  EstimateLineItemTabQuery,
  EstimateLineItemTabQueryVariables,
} from "../routes/projects/estimates/EstimateLineItemsTab.generated";
import {
  EstimatePageDocument,
  EstimatePageQuery,
  EstimatePageQueryVariables,
  SaveEstimateDocument,
  SaveEstimateMutation,
  SaveEstimateMutationVariables,
} from "../routes/projects/estimates/EstimatePage.generated";
import {
  ProjectEstimatesPageDocument,
  ProjectEstimatesPageQuery,
  ProjectEstimatesPageQueryVariables,
} from "../routes/projects/estimates/ProjectEstimatesPage.generated";
import {
  ExpensesPageMetadataDocument,
  ExpensesPageMetadataQuery,
  ExpensesPageMetadataQueryVariables,
} from "../routes/projects/expenses/ExpensesPage.generated";
import {
  ChangeEventFormContentDocument,
  ChangeEventFormContentQuery,
  ChangeEventFormContentQueryVariables,
  SaveChangeEventExpenseLineItemDocument,
  SaveChangeEventExpenseLineItemMutation,
  SaveChangeEventExpenseLineItemMutationVariables,
} from "../routes/projects/expenses/components/ChangeEventForm.generated";
import {
  ConvertExpenseToBillDocument,
  ConvertExpenseToBillMutation,
  ConvertExpenseToBillMutationVariables,
  ExpensesTableByProjectIdDocument,
  ExpensesTableByProjectIdQuery,
  ExpensesTableByProjectIdQueryVariables,
  SaveDocumentsToExpenseDocument,
  SaveDocumentsToExpenseMutation,
  SaveDocumentsToExpenseMutationVariables,
  SaveExpenseAllocationsDocument,
  SaveExpenseAllocationsMutation,
  SaveExpenseAllocationsMutationVariables,
  SaveExpenseDocument,
  SaveExpenseMutation,
  SaveExpenseMutationVariables,
  SaveExpenseTableDocumentDocument,
  SaveExpenseTableDocumentMutation,
  SaveExpenseTableDocumentMutationVariables,
} from "../routes/projects/expenses/components/ExpensesTable.generated";
import {
  ProjectFinishScheduleDocument,
  ProjectFinishScheduleMetadataDocument,
  ProjectFinishScheduleMetadataQuery,
  ProjectFinishScheduleMetadataQueryVariables,
  ProjectFinishScheduleQuery,
  ProjectFinishScheduleQueryVariables,
} from "../routes/projects/finish-schedule/ProjectFinishSchedulePage.generated";
import {
  HomeownerContractLikeScheduleDocument,
  HomeownerContractLikeScheduleQuery,
  HomeownerContractLikeScheduleQueryVariables,
  SaveHomeownerContractChangeOrderDrawsDocument,
  SaveHomeownerContractChangeOrderDrawsMutation,
  SaveHomeownerContractChangeOrderDrawsMutationVariables,
  SaveHomeownerContractDrawsDocument,
  SaveHomeownerContractDrawsMutation,
  SaveHomeownerContractDrawsMutationVariables,
} from "../routes/projects/homeowner-contracts/DrawScheduleTab.generated";
import {
  HomeownerContractChangeOrder2Document,
  HomeownerContractChangeOrder2Query,
  HomeownerContractChangeOrder2QueryVariables,
  SaveHomeownerContractChangeOrderDocument,
  SaveHomeownerContractChangeOrderMutation,
  SaveHomeownerContractChangeOrderMutationVariables,
} from "../routes/projects/homeowner-contracts/HomeownerContractChangeOrderPage.generated";
import {
  HomeownerContractDocument,
  HomeownerContractQuery,
  HomeownerContractQueryVariables,
  SaveHomeownerContractDocument,
  SaveHomeownerContractMutation,
  SaveHomeownerContractMutationVariables,
} from "../routes/projects/homeowner-contracts/HomeownerContractPage.generated";
import {
  GeneratePocInvoiceDocument,
  GeneratePocInvoiceMutation,
  GeneratePocInvoiceMutationVariables,
  InvoiceScheduleDocument,
  InvoiceScheduleQuery,
  InvoiceScheduleQueryVariables,
} from "../routes/projects/homeowner-contracts/InvoiceScheduleTab.generated";
import {
  HomeownerContractSummariesDocument,
  HomeownerContractSummariesQuery,
  HomeownerContractSummariesQueryVariables,
} from "../routes/projects/homeowner-contracts/components/HomeownerContractsTable.generated";
import {
  HomeownerNotesForProjectDocument,
  HomeownerNotesForProjectQuery,
  HomeownerNotesForProjectQueryVariables,
} from "../routes/projects/homeowner-notes/HomeownerNotesPage.generated";
import {
  ContractLineItemsDocument,
  ContractLineItemsQuery,
  ContractLineItemsQueryVariables,
} from "../routes/projects/invoices/AddContractLineItemButton.generated";
import {
  DrawLineItemsDocument,
  DrawLineItemsQuery,
  DrawLineItemsQueryVariables,
} from "../routes/projects/invoices/AddDrawLineItemButton.generated";
import {
  ProjectItemBillDetailsDocument,
  ProjectItemBillDetailsQuery,
  ProjectItemBillDetailsQueryVariables,
} from "../routes/projects/invoices/BillsModal.generated";
import {
  DeleteInvoiceDocument,
  DeleteInvoiceMutation,
  DeleteInvoiceMutationVariables,
  InvoiceEditDocument,
  InvoiceEditQuery,
  InvoiceEditQueryVariables,
  NewInvoiceDataDocument,
  NewInvoiceDataQuery,
  NewInvoiceDataQueryVariables,
  SaveInvoiceDocument,
  SaveInvoiceMutation,
  SaveInvoiceMutationVariables,
} from "../routes/projects/invoices/InvoicePage.generated";
import {
  InvoiceProjectStageModalDetailsDocument,
  InvoiceProjectStageModalDetailsQuery,
  InvoiceProjectStageModalDetailsQueryVariables,
} from "../routes/projects/invoices/InvoiceProjectStageModal.generated";
import {
  ProjectInvoicesPageDocument,
  ProjectInvoicesPageQuery,
  ProjectInvoicesPageQueryVariables,
} from "../routes/projects/invoices/ProjectInvoicesPage.generated";
import {
  DeleteInvoiceV2Document,
  DeleteInvoiceV2Mutation,
  DeleteInvoiceV2MutationVariables,
  InvoiceIntacctSyncErrorDocument,
  InvoiceIntacctSyncErrorQuery,
  InvoiceIntacctSyncErrorQueryVariables,
  InvoicePageV2Document,
  InvoicePageV2Query,
  InvoicePageV2QueryVariables,
  InvoiceProjectDataDocument,
  InvoiceProjectDataQuery,
  InvoiceProjectDataQueryVariables,
  SaveInvoiceV2Document,
  SaveInvoiceV2Mutation,
  SaveInvoiceV2MutationVariables,
  SyncInvoiceToIntacctDocument,
  SyncInvoiceToIntacctMutation,
  SyncInvoiceToIntacctMutationVariables,
} from "../routes/projects/invoices/invoice-v2/InvoicePageV2.generated";
import {
  ConfirmDrawProjectStageDocument,
  ConfirmDrawProjectStageQuery,
  ConfirmDrawProjectStageQueryVariables,
} from "../routes/projects/invoices/invoice-v2/invoice-steps/ConfirmDrawAmount.generated";
import {
  ConfirmLineItemsDataDocument,
  ConfirmLineItemsDataQuery,
  ConfirmLineItemsDataQueryVariables,
} from "../routes/projects/invoices/invoice-v2/invoice-steps/ConfirmLineItems.generated";
import {
  SelectFixedItemsDataDocument,
  SelectFixedItemsDataQuery,
  SelectFixedItemsDataQueryVariables,
} from "../routes/projects/invoices/invoice-v2/invoice-steps/SelectFixedItems.generated";
import {
  ProjectItemsDocument,
  ProjectItemsQuery,
  ProjectItemsQueryVariables,
  SaveProjectItemDocument,
  SaveProjectItemMutation,
  SaveProjectItemMutationVariables,
} from "../routes/projects/items/ProjectItems.generated";
import {
  JobLogNoteHistoryTabDocument,
  JobLogNoteHistoryTabQuery,
  JobLogNoteHistoryTabQueryVariables,
} from "../routes/projects/job-logs/JobLogNoteRightPaneContent.generated";
import {
  DeleteJobLogImageDocument,
  DeleteJobLogImageMutation,
  DeleteJobLogImageMutationVariables,
  DeleteJobLogNoteDocument,
  DeleteJobLogNoteMutation,
  DeleteJobLogNoteMutationVariables,
  DuplicateJobLogsDocument,
  DuplicateJobLogsMutation,
  DuplicateJobLogsMutationVariables,
  JobLogDocument,
  JobLogQuery,
  JobLogQueryVariables,
  JobLogsDevelopmentProjectsDocument,
  JobLogsDevelopmentProjectsQuery,
  JobLogsDevelopmentProjectsQueryVariables,
  JobLogsDocument,
  JobLogsFilterDataDocument,
  JobLogsFilterDataQuery,
  JobLogsFilterDataQueryVariables,
  JobLogsForDatePickerDocument,
  JobLogsForDatePickerQuery,
  JobLogsForDatePickerQueryVariables,
  JobLogsForGivenDateAndProjectsForCopyDocument,
  JobLogsForGivenDateAndProjectsForCopyQuery,
  JobLogsForGivenDateAndProjectsForCopyQueryVariables,
  JobLogsProjectEditabilityDocument,
  JobLogsProjectEditabilityQuery,
  JobLogsProjectEditabilityQueryVariables,
  JobLogsQuery,
  JobLogsQueryVariables,
  SaveJobLogDocument,
  SaveJobLogImageDocument,
  SaveJobLogImageMutation,
  SaveJobLogImageMutationVariables,
  SaveJobLogMutation,
  SaveJobLogMutationVariables,
  SaveJobLogNoteDocument,
  SaveJobLogNoteMutation,
  SaveJobLogNoteMutationVariables,
  ScheduleFlagsOnJobLogNoteDocument,
  ScheduleFlagsOnJobLogNoteQuery,
  ScheduleFlagsOnJobLogNoteQueryVariables,
  ScheduleTasksForJobLogsDocument,
  ScheduleTasksForJobLogsQuery,
  ScheduleTasksForJobLogsQueryVariables,
  ScheduleTasksOnJobLogNoteDocument,
  ScheduleTasksOnJobLogNoteQuery,
  ScheduleTasksOnJobLogNoteQueryVariables,
} from "../routes/projects/job-logs/JobLogsPage.generated";
import {
  DeleteHomeownerNoteDocument,
  DeleteHomeownerNoteMutation,
  DeleteHomeownerNoteMutationVariables,
  EditHomeownerNoteDocument,
  EditHomeownerNoteQuery,
  EditHomeownerNoteQueryVariables,
  SaveHomeownerNoteDocument,
  SaveHomeownerNoteMutation,
  SaveHomeownerNoteMutationVariables,
  ScheduleTasksForHomeownerNoteDocument,
  ScheduleTasksForHomeownerNoteQuery,
  ScheduleTasksForHomeownerNoteQueryVariables,
} from "../routes/projects/job-logs/components/HomeownerNoteRightPane.generated";
import {
  ProjectLotSummaryPageDocument,
  ProjectLotSummaryPageQuery,
  ProjectLotSummaryPageQueryVariables,
  StructureLotSummaryPageDocument,
  StructureLotSummaryPageQuery,
  StructureLotSummaryPageQueryVariables,
} from "../routes/projects/lot-summary/ProjectLotSummaryPage.generated";
import {
  AppliableProductOfferingConfigsApplyWithoutChangesDocument,
  AppliableProductOfferingConfigsApplyWithoutChangesMutation,
  AppliableProductOfferingConfigsApplyWithoutChangesMutationVariables,
  AppliableProductOfferingConfigsDocument,
  AppliableProductOfferingConfigsQuery,
  AppliableProductOfferingConfigsQueryVariables,
  ApplicableProductOfferingConfigsPageStructureMetadataDocument,
  ApplicableProductOfferingConfigsPageStructureMetadataQuery,
  ApplicableProductOfferingConfigsPageStructureMetadataQueryVariables,
} from "../routes/projects/product-offering-configs-apply/AppliableProductOfferingConfigsPage.generated";
import {
  ApplyProductOfferingConfig_SelectedDocument,
  ApplyProductOfferingConfig_SelectedQuery,
  ApplyProductOfferingConfig_SelectedQueryVariables,
  ApplyProductOfferingConfigDefaultOptionsDocument,
  ApplyProductOfferingConfigDefaultOptionsQuery,
  ApplyProductOfferingConfigDefaultOptionsQueryVariables,
  ApplyProductOfferingConfigMetaDocument,
  ApplyProductOfferingConfigMetaQuery,
  ApplyProductOfferingConfigMetaQueryVariables,
  ApplyProductOfferingConfigPageMetaDocument,
  ApplyProductOfferingConfigPageMetaQuery,
  ApplyProductOfferingConfigPageMetaQueryVariables,
  ApplyProductOfferingConfigs_DeltasDocument,
  ApplyProductOfferingConfigs_DeltasQuery,
  ApplyProductOfferingConfigs_DeltasQueryVariables,
  ApplyProductOfferingConfigsDocument,
  ApplyProductOfferingConfigsMutation,
  ApplyProductOfferingConfigsMutationVariables,
  CreateProductOfferingConfigChangeEventDocument,
  CreateProductOfferingConfigChangeEventMutation,
  CreateProductOfferingConfigChangeEventMutationVariables,
} from "../routes/projects/product-offering-configs-apply/ApplyProductOfferingConfigPage.generated";
import {
  AvailableGlobalPhasesDocument,
  AvailableGlobalPhasesQuery,
  AvailableGlobalPhasesQueryVariables,
  ProjectSchedulePageV2Document,
  ProjectSchedulePageV2Query,
  ProjectSchedulePageV2QueryVariables,
  SaveScheduleStatusDocument,
  SaveScheduleStatusMutation,
  SaveScheduleStatusMutationVariables,
  SaveScheduleTasksDocument,
  SaveScheduleTasksMutation,
  SaveScheduleTasksMutationVariables,
  ScheduleParentGlobalMilestoneTasksDocument,
  ScheduleParentGlobalMilestoneTasksQuery,
  ScheduleParentGlobalMilestoneTasksQueryVariables,
  TaskStatusesDocument,
  TaskStatusesQuery,
  TaskStatusesQueryVariables,
} from "../routes/projects/schedule-v2/ProjectSchedulePageV2.generated";
import {
  ApplyScheduleTemplatesDocument,
  ApplyScheduleTemplatesMutation,
  ApplyScheduleTemplatesMutationVariables,
  ProjectScheduleTableTasksDocument,
  ProjectScheduleTableTasksQuery,
  ProjectScheduleTableTasksQueryVariables,
  SchedulePhasesDocument,
  SchedulePhasesQuery,
  SchedulePhasesQueryVariables,
} from "../routes/projects/schedule-v2/ProjectScheduleTableV2.generated";
import {
  ScheduleCalendarTasksDocument,
  ScheduleCalendarTasksQuery,
  ScheduleCalendarTasksQueryVariables,
} from "../routes/projects/schedule-v2/calendar/ScheduleCalendar.generated";
import {
  GlobalTasksHeaderDataDocument,
  GlobalTasksHeaderDataQuery,
  GlobalTasksHeaderDataQueryVariables,
} from "../routes/projects/schedule-v2/components/CondensedScheduleHeaderData.generated";
import {
  TaskBillModalContextDocument,
  TaskBillModalContextQuery,
  TaskBillModalContextQueryVariables,
} from "../routes/projects/schedule-v2/contexts/TaskBillModalContext.generated";
import {
  ScheduleHistoryTabDocument,
  ScheduleHistoryTabQuery,
  ScheduleHistoryTabQueryVariables,
} from "../routes/projects/schedule-v2/detail-pane/HistoryTab.generated";
import {
  DeleteRequiredTaskDocumentDocument,
  DeleteRequiredTaskDocumentMutation,
  DeleteRequiredTaskDocumentMutationVariables,
  DeleteScheduleTaskChecklistItemDocument,
  DeleteScheduleTaskChecklistItemMutation,
  DeleteScheduleTaskChecklistItemMutationVariables,
  ProjectRoleDetailsDocument,
  ProjectRoleDetailsQuery,
  ProjectRoleDetailsQueryVariables,
  SaveRequiredTaskDocumentDocument,
  SaveRequiredTaskDocumentMutation,
  SaveRequiredTaskDocumentMutationVariables,
  SaveScheduleTaskChecklistItemDocument,
  SaveScheduleTaskChecklistItemMutation,
  SaveScheduleTaskChecklistItemMutationVariables,
  SaveTaskDocumentsDocument,
  SaveTaskDocumentsMutation,
  SaveTaskDocumentsMutationVariables,
  TaskDetailPaneDocument,
  TaskDetailPaneDropdownOptionsDocument,
  TaskDetailPaneDropdownOptionsQuery,
  TaskDetailPaneDropdownOptionsQueryVariables,
  TaskDetailPaneQuery,
  TaskDetailPaneQueryVariables,
} from "../routes/projects/schedule-v2/detail-pane/TaskDetailPane.generated";
import {
  DeleteScheduleFlagDocument,
  DeleteScheduleFlagMutation,
  DeleteScheduleFlagMutationVariables,
  SaveScheduleFlagDocument,
  SaveScheduleFlagMutation,
  SaveScheduleFlagMutationVariables,
  ScheduleFlagReasonsDocument,
  ScheduleFlagReasonsQuery,
  ScheduleFlagReasonsQueryVariables,
} from "../routes/projects/schedule-v2/detail-pane/scheduleFlags/ScheduleFlags.generated";
import {
  TaskBillModal_ProtoBillsDocument,
  TaskBillModal_ProtoBillsQuery,
  TaskBillModal_ProtoBillsQueryVariables,
  TaskBillModal_SaveBillsDocument,
  TaskBillModal_SaveBillsMutation,
  TaskBillModal_SaveBillsMutationVariables,
} from "../routes/projects/schedule-v2/detail-pane/taskBills/TaskBillModal.generated";
import {
  SaveGanttScheduleTasksDocument,
  SaveGanttScheduleTasksMutation,
  SaveGanttScheduleTasksMutationVariables,
  ScheduleGanttDocument,
  ScheduleGanttQuery,
  ScheduleGanttQueryVariables,
} from "../routes/projects/schedule-v2/gantt/ScheduleGantt.generated";
import {
  AddScheduleTaskDocument,
  AddScheduleTaskQuery,
  AddScheduleTaskQueryVariables,
  ScheduleTaskPhasesDocument,
  ScheduleTaskPhasesQuery,
  ScheduleTaskPhasesQueryVariables,
} from "../routes/projects/schedule-v2/table/AddScheduleTaskPane.generated";
import {
  SaveScheduleSubPhasesDocument,
  SaveScheduleSubPhasesMutation,
  SaveScheduleSubPhasesMutationVariables,
} from "../routes/projects/schedule-v2/table/AddSubPhasePane.generated";
import {
  DeleteSchedulePhaseDocument,
  DeleteSchedulePhaseMutation,
  DeleteSchedulePhaseMutationVariables,
  DeleteScheduleSubPhaseDocument,
  DeleteScheduleSubPhaseMutation,
  DeleteScheduleSubPhaseMutationVariables,
} from "../routes/projects/schedule-v2/table/MoreOptionsMenuCell.generated";
import {
  SetDateViaPredecessorModalDocument,
  SetDateViaPredecessorModalQuery,
  SetDateViaPredecessorModalQueryVariables,
} from "../routes/projects/schedule-v2/table/SetDateViaPredecessor.generated";
import {
  AddItemModalDocument,
  AddItemModalQuery,
  AddItemModalQueryVariables,
} from "../routes/projects/selections/AddProjectItemModal.generated";
import {
  ApplyTemplateModalDocument,
  ApplyTemplateModalPlanDocument,
  ApplyTemplateModalPlanQuery,
  ApplyTemplateModalPlanQueryVariables,
  ApplyTemplateModalQuery,
  ApplyTemplateModalQueryVariables,
} from "../routes/projects/selections/ApplyTemplateModal.generated";
import {
  ToggleFinalizeForHomeownerDocument,
  ToggleFinalizeForHomeownerMutation,
  ToggleFinalizeForHomeownerMutationVariables,
} from "../routes/projects/selections/CurrentSelectionTable.generated";
import {
  ImportProjectItemsModalMetadataDocument,
  ImportProjectItemsModalMetadataQuery,
  ImportProjectItemsModalMetadataQueryVariables,
} from "../routes/projects/selections/ImportProjectItemsModal.generated";
import {
  OverviewTabDeleteProjectItemDocument,
  OverviewTabDeleteProjectItemMutation,
  OverviewTabDeleteProjectItemMutationVariables,
  OverviewTabDocument,
  OverviewTabQuery,
  OverviewTabQueryVariables,
  OverviewTabSaveProjectItemDocument,
  OverviewTabSaveProjectItemMutation,
  OverviewTabSaveProjectItemMutationVariables,
  OverviewTabScheduleTasksDocument,
  OverviewTabScheduleTasksQuery,
  OverviewTabScheduleTasksQueryVariables,
} from "../routes/projects/selections/OverviewTab.generated";
import {
  ProjectItemCommitmentTabDocument,
  ProjectItemCommitmentTabQuery,
  ProjectItemCommitmentTabQueryVariables,
} from "../routes/projects/selections/ProjectItemCommitmentsTable.generated";
import {
  ProjectItemHistoryDocument,
  ProjectItemHistoryQuery,
  ProjectItemHistoryQueryVariables,
} from "../routes/projects/selections/ProjectItemHistoryTab.generated";
import {
  SelectionsTabDocument,
  SelectionsTabQuery,
  SelectionsTabQueryVariables,
  SelectionsTabSaveCeliDocument,
  SelectionsTabSaveCeliMutation,
  SelectionsTabSaveCeliMutationVariables,
} from "../routes/projects/selections/SelectionsTab.generated";
import {
  DeleteProjectItemDocument,
  DeleteProjectItemMutation,
  DeleteProjectItemMutationVariables,
  SaveProjectItemDetailsDocument,
  SaveProjectItemDetailsMutation,
  SaveProjectItemDetailsMutationVariables,
  SpecTabDocument,
  SpecTabQuery,
  SpecTabQueryVariables,
} from "../routes/projects/selections/SpecTab.generated";
import {
  AddProjectItemDocument,
  AddProjectItemMutation,
  AddProjectItemMutationVariables,
  ApplyItemTemplateDocument,
  ApplyItemTemplateMutation,
  ApplyItemTemplateMutationVariables,
  DeleteProjectItemsDocument,
  DeleteProjectItemsMutation,
  DeleteProjectItemsMutationVariables,
  DuplicateProjectItemsDocument,
  DuplicateProjectItemsMutation,
  DuplicateProjectItemsMutationVariables,
  SaveProjectItemsDocument,
  SaveProjectItemsMutation,
  SaveProjectItemsMutationVariables,
  SpecsAndSelectionItemsDocument,
  SpecsAndSelectionItemsQuery,
  SpecsAndSelectionItemsQueryVariables,
  SpecsAndSelectionsRouteHandlerDocument,
  SpecsAndSelectionsRouteHandlerQuery,
  SpecsAndSelectionsRouteHandlerQueryVariables,
} from "../routes/projects/selections/SpecsAndSelectionsPage.generated";
import {
  CreateCommitmentModalProjectItemDocument,
  CreateCommitmentModalProjectItemQuery,
  CreateCommitmentModalProjectItemQueryVariables,
} from "../routes/projects/selections/bulkActions/CreateCommitmentModal.generated";
import {
  SaveHomeownerSelectionDocument,
  SaveHomeownerSelectionMutation,
  SaveHomeownerSelectionMutationVariables,
  SaveHomeownerSelectionOptionDocument,
  SaveHomeownerSelectionOptionMutation,
  SaveHomeownerSelectionOptionMutationVariables,
} from "../routes/projects/selections/options/SelectionOptions.generated";
import {
  SaveHomeownerUndecidedSelectionDocument,
  SaveHomeownerUndecidedSelectionMutation,
  SaveHomeownerUndecidedSelectionMutationVariables,
} from "../routes/projects/selections/options/SelectionOptionsTable.generated";
import {
  HomeownerSelectionOptionDocument,
  HomeownerSelectionOptionQuery,
  HomeownerSelectionOptionQueryVariables,
} from "../routes/projects/selections/options/homeownerSelectionOptionDetails/HomeownerSelectionOptionForm.generated";
import {
  CheckoutSettingsTab_CommunityDocument,
  CheckoutSettingsTab_CommunityQuery,
  CheckoutSettingsTab_CommunityQueryVariables,
  CheckoutSettingsTab_LotDocument,
  CheckoutSettingsTab_LotQuery,
  CheckoutSettingsTab_LotQueryVariables,
  CheckoutSettingsTab_ProductOfferingOptionsDocument,
  CheckoutSettingsTab_ProductOfferingOptionsQuery,
  CheckoutSettingsTab_ProductOfferingOptionsQueryVariables,
  CheckoutSettingsTab_StructureDocument,
  CheckoutSettingsTab_StructureQuery,
  CheckoutSettingsTab_StructureQueryVariables,
  SaveCommunitySettingsDocument,
  SaveCommunitySettingsMutation,
  SaveCommunitySettingsMutationVariables,
  SaveLotSettingsDocument,
  SaveLotSettingsMutation,
  SaveLotSettingsMutationVariables,
  SaveStructureSettingsDocument,
  SaveStructureSettingsMutation,
  SaveStructureSettingsMutationVariables,
} from "../routes/projects/settings/CheckoutSettingsTab.generated";
import {
  CommunityStageOrderDocument,
  CommunityStageOrderQuery,
  CommunityStageOrderQueryVariables,
  SaveGlobalPlanStageVariantsDocument,
  SaveGlobalPlanStageVariantsMutation,
  SaveGlobalPlanStageVariantsMutationVariables,
} from "../routes/projects/settings/CommunityStageOrder.generated";
import {
  SaveProjectCollaboratorDocument,
  SaveProjectCollaboratorMutation,
  SaveProjectCollaboratorMutationVariables,
} from "../routes/projects/settings/CreateHomeownerModal.generated";
import {
  DeleteProjectCollaboratorDocument,
  DeleteProjectCollaboratorMutation,
  DeleteProjectCollaboratorMutationVariables,
  HomeownersTabDocument,
  HomeownersTabQuery,
  HomeownersTabQueryVariables,
  SendInviteEmailDocument,
  SendInviteEmailMutation,
  SendInviteEmailMutationVariables,
} from "../routes/projects/settings/HomeownersTab.generated";
import {
  OverallTabDocument,
  OverallTabQuery,
  OverallTabQueryVariables,
  ProjectStatusChangeReasonsDocument,
  ProjectStatusChangeReasonsQuery,
  ProjectStatusChangeReasonsQueryVariables,
  SaveProjectOverallTabDocument,
  SaveProjectOverallTabMutation,
  SaveProjectOverallTabMutationVariables,
} from "../routes/projects/settings/OverallTab.generated";
import {
  PlanScheduleTabDocument,
  PlanScheduleTabQuery,
  PlanScheduleTabQueryVariables,
  SavePlanScheduleSettingsDocument,
  SavePlanScheduleSettingsMutation,
  SavePlanScheduleSettingsMutationVariables,
  SaveScheduleRemindersDocument,
  SaveScheduleRemindersMutation,
  SaveScheduleRemindersMutationVariables,
  SaveScheduleSettingsDocument,
  SaveScheduleSettingsMutation,
  SaveScheduleSettingsMutationVariables,
  ScheduleTabDocument,
  ScheduleTabQuery,
  ScheduleTabQueryVariables,
} from "../routes/projects/settings/ScheduleTab.generated";
import {
  SaveProjectSetUpTabDocument,
  SaveProjectSetUpTabMutation,
  SaveProjectSetUpTabMutationVariables,
  SaveStructureSetUpTabDocument,
  SaveStructureSetUpTabMutation,
  SaveStructureSetUpTabMutationVariables,
  SetUpTabDocument,
  SetUpTabQuery,
  SetUpTabQueryVariables,
} from "../routes/projects/settings/SetUpTab.generated";
import {
  AvailableAssigneesDocument,
  AvailableAssigneesQuery,
  AvailableAssigneesQueryVariables,
  TeamMembersDocument,
  TeamMembersQuery,
  TeamMembersQueryVariables,
  UpdateProjectRoleDocument,
  UpdateProjectRoleMutation,
  UpdateProjectRoleMutationVariables,
} from "../routes/projects/settings/TeamMembersTab.generated";
import {
  AddItemsFromExistingTemplateDocument,
  AddItemsFromExistingTemplateQuery,
  AddItemsFromExistingTemplateQueryVariables,
} from "../routes/settings/itemTemplates/AddItemsFromExistingItemTemplateModal.generated";
import {
  ItemTemplateImportModalDocument,
  ItemTemplateImportModalQuery,
  ItemTemplateImportModalQueryVariables,
} from "../routes/settings/itemTemplates/ImportItemTemplateItemsModal.generated";
import {
  ItemTemplateItemDetailDocument,
  ItemTemplateItemDetailQuery,
  ItemTemplateItemDetailQueryVariables,
  ItemTemplateItemProductsDocument,
  ItemTemplateItemProductsQuery,
  ItemTemplateItemProductsQueryVariables,
} from "../routes/settings/itemTemplates/ItemTemplateItemDetail.generated";
import {
  ItemTemplateItemVersionsPage_GroupsDocument,
  ItemTemplateItemVersionsPage_GroupsQuery,
  ItemTemplateItemVersionsPage_GroupsQueryVariables,
  ItemTemplateItemVersionsPageDocument,
  ItemTemplateItemVersionsPageQuery,
  ItemTemplateItemVersionsPageQueryVariables,
  ItemTemplateLineItemsTabDocument,
  ItemTemplateLineItemsTabQuery,
  ItemTemplateLineItemsTabQueryVariables,
} from "../routes/settings/itemTemplates/ItemTemplateLineItemsTab.generated";
import {
  ItemTemplatesDevelopmentsDocument,
  ItemTemplatesDevelopmentsQuery,
  ItemTemplatesDevelopmentsQueryVariables,
  ItemTemplatesDocument,
  ItemTemplatesQuery,
  ItemTemplatesQueryVariables,
  SaveItemTemplateDocument,
  SaveItemTemplateMutation,
  SaveItemTemplateMutationVariables,
} from "../routes/settings/itemTemplates/ItemTemplatesPage.generated";
import {
  ItemTemplateAnomaliesContextDocument,
  ItemTemplateAnomaliesContextQuery,
  ItemTemplateAnomaliesContextQueryVariables,
} from "../routes/settings/itemTemplates/anomalies/ItemTemplateAnomaliesContext.generated";
import {
  ItApi_CopyItemTemplateItemsDocument,
  ItApi_CopyItemTemplateItemsMutation,
  ItApi_CopyItemTemplateItemsMutationVariables,
  ItApi_SaveItemTemplateItemVersionsDocument,
  ItApi_SaveItemTemplateItemVersionsMutation,
  ItApi_SaveItemTemplateItemVersionsMutationVariables,
} from "../routes/settings/itemTemplates/api/ItemTemplateApi.generated";
import {
  GetTradeCategoriesDocument,
  GetTradeCategoriesQuery,
  GetTradeCategoriesQueryVariables,
  GetTradeCategoryDocument,
  GetTradeCategoryQuery,
  GetTradeCategoryQueryVariables,
  SaveTradeCategoryDocument,
  SaveTradeCategoryMutation,
  SaveTradeCategoryMutationVariables,
} from "../routes/trade-categories/TradeCategories.generated";
import {
  TradePartnerCommitmentsDocument,
  TradePartnerCommitmentsMetadataDocument,
  TradePartnerCommitmentsMetadataQuery,
  TradePartnerCommitmentsMetadataQueryVariables,
  TradePartnerCommitmentsQuery,
  TradePartnerCommitmentsQueryVariables,
} from "../routes/trade-partners/TradePartnerCommitmentsTab.generated";
import {
  SaveTradePartnerContactUserDocument,
  SaveTradePartnerContactUserMutation,
  SaveTradePartnerContactUserMutationVariables,
} from "../routes/trade-partners/TradePartnerContactCommunicationPreferences.generated";
import {
  DeleteTradePartnerContactDocument,
  DeleteTradePartnerContactMutation,
  DeleteTradePartnerContactMutationVariables,
  SaveTradePartnerContactDocument,
  SaveTradePartnerContactMutation,
  SaveTradePartnerContactMutationVariables,
  SaveTradePartnerMarketContactDocument,
  SaveTradePartnerMarketContactMutation,
  SaveTradePartnerMarketContactMutationVariables,
  TradePartnerContactsDocument,
  TradePartnerContactsQuery,
  TradePartnerContactsQueryVariables,
} from "../routes/trade-partners/TradePartnerContactsTab.generated";
import {
  TradePartnerDetailsTabDocument,
  TradePartnerDetailsTabQuery,
  TradePartnerDetailsTabQueryVariables,
} from "../routes/trade-partners/TradePartnerDetailsTab.generated";
import {
  TradePartnerDevelopmentContractsDocument,
  TradePartnerDevelopmentContractsQuery,
  TradePartnerDevelopmentContractsQueryVariables,
} from "../routes/trade-partners/TradePartnerDevelopmentContractsTab.generated";
import {
  DeleteTradePartnerDocument,
  DeleteTradePartnerMutation,
  DeleteTradePartnerMutationVariables,
  SaveTradePartnerDocument,
  SaveTradePartnerMutation,
  SaveTradePartnerMutationVariables,
  TradePartnerPageDocument,
  TradePartnerPageQuery,
  TradePartnerPageQueryVariables,
} from "../routes/trade-partners/TradePartnerPage.generated";
import {
  SaveTradePartnerRequirementDocument,
  SaveTradePartnerRequirementMutation,
  SaveTradePartnerRequirementMutationVariables,
  TradePartnerRequirementsDocument,
  TradePartnerRequirementsQuery,
  TradePartnerRequirementsQueryVariables,
} from "../routes/trade-partners/TradePartnerRequirementsTab.generated";
import {
  TradePartnersDocument,
  TradePartnersMetadataDocument,
  TradePartnersMetadataQuery,
  TradePartnersMetadataQueryVariables,
  TradePartnersPageDocument,
  TradePartnersPageQuery,
  TradePartnersPageQueryVariables,
  TradePartnersQuery,
  TradePartnersQueryVariables,
} from "../routes/trade-partners/TradePartnersPage.generated";
import {
  TradePartnerContactsRolesPanelMetadataDocument,
  TradePartnerContactsRolesPanelMetadataQuery,
  TradePartnerContactsRolesPanelMetadataQueryVariables,
} from "../routes/trade-partners/components/TradePartnerContactsRolesPanel.generated";
import {
  SaveTradePartnerReviewDocument,
  SaveTradePartnerReviewMutation,
  SaveTradePartnerReviewMutationVariables,
  TradePartnerReviewsDocument,
  TradePartnerReviewsQuery,
  TradePartnerReviewsQueryVariables,
} from "../routes/trade-partners/components/TradePartnerReviewsTab.generated";
import {
  PaymentTermsDocument,
  PaymentTermsQuery,
  PaymentTermsQueryVariables,
  SavePaymentTermDocument,
  SavePaymentTermMutation,
  SavePaymentTermMutationVariables,
} from "../routes/trade-partners/payment-terms/PaymentTermsPage.generated";
import {
  SaveTradeCategoryLeadTimesDocument,
  SaveTradeCategoryLeadTimesMutation,
  SaveTradeCategoryLeadTimesMutationVariables,
  TradeCategoryLeadTimesDocument,
  TradeCategoryLeadTimesMetaDataDocument,
  TradeCategoryLeadTimesMetaDataQuery,
  TradeCategoryLeadTimesMetaDataQueryVariables,
  TradeCategoryLeadTimesQuery,
  TradeCategoryLeadTimesQueryVariables,
} from "../routes/trade-partners/trade-category-lead-times/TradeCategoryLeadTimesPage.generated";
import {
  SaveWarrantyTicketDocument,
  SaveWarrantyTicketItemsDocument,
  SaveWarrantyTicketItemsMutation,
  SaveWarrantyTicketItemsMutationVariables,
  SaveWarrantyTicketMutation,
  SaveWarrantyTicketMutationVariables,
  WarrantyTicketFiltersDocument,
  WarrantyTicketFiltersQuery,
  WarrantyTicketFiltersQueryVariables,
  WarrantyTicketsDocument,
  WarrantyTicketsQuery,
  WarrantyTicketsQueryVariables,
} from "../routes/warranty/WarrantyPage.generated";
import {
  DeleteWarrantyTicketDocument,
  DeleteWarrantyTicketMutation,
  DeleteWarrantyTicketMutationVariables,
} from "../routes/warranty/WarrantySummaryView.generated";
import {
  DeleteWarrantyTicketItemDocument,
  DeleteWarrantyTicketItemMutation,
  DeleteWarrantyTicketItemMutationVariables,
  SaveWarrantyTicketPageDocument,
  SaveWarrantyTicketPageMutation,
  SaveWarrantyTicketPageMutationVariables,
  WarrantyTicketDocument,
  WarrantyTicketEnumsDocument,
  WarrantyTicketEnumsQuery,
  WarrantyTicketEnumsQueryVariables,
  WarrantyTicketQuery,
  WarrantyTicketQueryVariables,
} from "../routes/warranty/WarrantyTicketPage.generated";
import {
  WarrantyModalProjectsDocument,
  WarrantyModalProjectsQuery,
  WarrantyModalProjectsQueryVariables,
  WarrantyModalTicketTypesAndDevelopmentsDocument,
  WarrantyModalTicketTypesAndDevelopmentsQuery,
  WarrantyModalTicketTypesAndDevelopmentsQueryVariables,
} from "../routes/warranty/components/CreateWarrantyTicketModal.generated";
import {
  ProjectContactsDocument,
  ProjectContactsQuery,
  ProjectContactsQueryVariables,
  SaveProjectContactWarrantyDocument,
  SaveProjectContactWarrantyMutation,
  SaveProjectContactWarrantyMutationVariables,
} from "../routes/warranty/components/WarrantyContactSection.generated";

interface AllocateProjectItemsTaskModalDataOptions {
  scheduleTasks?: (ScheduleTask | ScheduleTaskOptions)[];
}

export function newAllocateProjectItemsTaskModalData(
  data: AllocateProjectItemsTaskModalDataOptions,
): AllocateProjectItemsTaskModalQuery {
  return {
    __typename: "Query" as const,
    scheduleTasks: data["scheduleTasks"]?.map((d) => newScheduleTask(d)) || [],
  } as any;
}

export function newAllocateProjectItemsTaskModalResponse(
  variables: AllocateProjectItemsTaskModalQueryVariables,
  data: AllocateProjectItemsTaskModalDataOptions | Error,
): MockedResponse<AllocateProjectItemsTaskModalQueryVariables, AllocateProjectItemsTaskModalQuery> {
  return {
    request: { query: AllocateProjectItemsTaskModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newAllocateProjectItemsTaskModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MyTasksTestDataOptions {
  tasks2?: TaskPage | TaskPageOptions;
}

export function newMyTasksTestData(data: MyTasksTestDataOptions): MyTasksTestQuery {
  return { __typename: "Query" as const, tasks2: maybeNew("TaskPage", data["tasks2"] || undefined, {}) } as any;
}

export function newMyTasksTestResponse(
  variables: MyTasksTestQueryVariables,
  data: MyTasksTestDataOptions | Error,
): MockedResponse<MyTasksTestQueryVariables, MyTasksTestQuery> {
  return {
    request: { query: MyTasksTestDocument, variables },
    result: { data: data instanceof Error ? undefined : newMyTasksTestData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CurrentUserZenDeskJwtDataOptions {
  currentUser?: User | UserOptions | null;
}

export function newCurrentUserZenDeskJwtData(data: CurrentUserZenDeskJwtDataOptions): CurrentUserZenDeskJwtQuery {
  return {
    __typename: "Query" as const,
    currentUser: maybeNewOrNull("User", data["currentUser"] || undefined, {}),
  } as any;
}

export function newCurrentUserZenDeskJwtResponse(
  data: CurrentUserZenDeskJwtDataOptions | Error,
): MockedResponse<CurrentUserZenDeskJwtQueryVariables, CurrentUserZenDeskJwtQuery> {
  return {
    request: { query: CurrentUserZenDeskJwtDocument },
    result: { data: data instanceof Error ? undefined : newCurrentUserZenDeskJwtData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface InternalUsersDataOptions {
  internalUsers?: (InternalUser | InternalUserOptions)[];
}

export function newInternalUsersData(data: InternalUsersDataOptions): InternalUsersQuery {
  return {
    __typename: "Query" as const,
    internalUsers: data["internalUsers"]?.map((d) => newInternalUser(d)) || [],
  } as any;
}

export function newInternalUsersResponse(
  data: InternalUsersDataOptions | Error,
): MockedResponse<InternalUsersQueryVariables, InternalUsersQuery> {
  return {
    request: { query: InternalUsersDocument },
    result: { data: data instanceof Error ? undefined : newInternalUsersData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface UseLocationsTreeDataOptions {
  locations?: (Location | LocationOptions)[];
}

export function newUseLocationsTreeData(data: UseLocationsTreeDataOptions): UseLocationsTreeQuery {
  return { __typename: "Query" as const, locations: data["locations"]?.map((d) => newLocation(d)) || [] } as any;
}

export function newUseLocationsTreeResponse(
  variables: UseLocationsTreeQueryVariables,
  data: UseLocationsTreeDataOptions | Error,
): MockedResponse<UseLocationsTreeQueryVariables, UseLocationsTreeQuery> {
  return {
    request: { query: UseLocationsTreeDocument, variables },
    result: { data: data instanceof Error ? undefined : newUseLocationsTreeData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectLocationsTreeDataOptions {
  project?: Project | ProjectOptions;
}

export function newProjectLocationsTreeData(data: ProjectLocationsTreeDataOptions): ProjectLocationsTreeQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newProjectLocationsTreeResponse(
  variables: ProjectLocationsTreeQueryVariables,
  data: ProjectLocationsTreeDataOptions | Error,
): MockedResponse<ProjectLocationsTreeQueryVariables, ProjectLocationsTreeQuery> {
  return {
    request: { query: ProjectLocationsTreeDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectLocationsTreeData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TrackedJobsPollDataOptions {
  trackedJobs?: (TrackedJob | TrackedJobOptions)[];
}

export function newTrackedJobsPollData(data: TrackedJobsPollDataOptions): TrackedJobsPollQuery {
  return { __typename: "Query" as const, trackedJobs: data["trackedJobs"]?.map((d) => newTrackedJob(d)) || [] } as any;
}

export function newTrackedJobsPollResponse(
  variables: TrackedJobsPollQueryVariables,
  data: TrackedJobsPollDataOptions | Error,
): MockedResponse<TrackedJobsPollQueryVariables, TrackedJobsPollQuery> {
  return {
    request: { query: TrackedJobsPollDocument, variables },
    result: { data: data instanceof Error ? undefined : newTrackedJobsPollData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CompleteStageDataOptions {
  completeStage?: EmptyResult | EmptyResultOptions;
}

export function newCompleteStageData(data: CompleteStageDataOptions): CompleteStageMutation {
  return {
    __typename: "Mutation" as const,
    completeStage: maybeNew("EmptyResult", data["completeStage"] || undefined, {}),
  } as any;
}

export function newCompleteStageResponse(
  variables: CompleteStageMutationVariables,
  data: CompleteStageDataOptions | Error,
): MockedResponse<CompleteStageMutationVariables, CompleteStageMutation> {
  return {
    request: { query: CompleteStageDocument, variables },
    result: { data: data instanceof Error ? undefined : newCompleteStageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveProjectStageDataOptions {
  saveProjectStage?: EmptyResult | EmptyResultOptions;
}

export function newSaveProjectStageData(data: SaveProjectStageDataOptions): SaveProjectStageMutation {
  return {
    __typename: "Mutation" as const,
    saveProjectStage: maybeNew("EmptyResult", data["saveProjectStage"] || undefined, {}),
  } as any;
}

export function newSaveProjectStageResponse(
  variables: SaveProjectStageMutationVariables,
  data: SaveProjectStageDataOptions | Error,
): MockedResponse<SaveProjectStageMutationVariables, SaveProjectStageMutation> {
  return {
    request: { query: SaveProjectStageDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveProjectStageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CostConfidencesDataOptions {
  costConfidences?: (CostConfidenceDetail | CostConfidenceDetailOptions)[];
}

export function newCostConfidencesData(data: CostConfidencesDataOptions): CostConfidencesQuery {
  return {
    __typename: "Query" as const,
    costConfidences: data["costConfidences"]?.map((d) => newCostConfidenceDetail(d)) || [],
  } as any;
}

export function newCostConfidencesResponse(
  data: CostConfidencesDataOptions | Error,
): MockedResponse<CostConfidencesQueryVariables, CostConfidencesQuery> {
  return {
    request: { query: CostConfidencesDocument },
    result: { data: data instanceof Error ? undefined : newCostConfidencesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CurrentInternalUserDataOptions {
  currentInternalUser?: InternalUser | InternalUserOptions | null;
}

export function newCurrentInternalUserData(data: CurrentInternalUserDataOptions): CurrentInternalUserQuery {
  return {
    __typename: "Query" as const,
    currentInternalUser: maybeNewOrNull("InternalUser", data["currentInternalUser"] || undefined, {}),
  } as any;
}

export function newCurrentInternalUserResponse(
  data: CurrentInternalUserDataOptions | Error,
): MockedResponse<CurrentInternalUserQueryVariables, CurrentInternalUserQuery> {
  return {
    request: { query: CurrentInternalUserDocument },
    result: { data: data instanceof Error ? undefined : newCurrentInternalUserData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface UserFeatureFlagsDataOptions {
  userFeatureFlags?: (FeatureFlag | FeatureFlagOptions)[];
}

export function newUserFeatureFlagsData(data: UserFeatureFlagsDataOptions): UserFeatureFlagsQuery {
  return {
    __typename: "Query" as const,
    userFeatureFlags: data["userFeatureFlags"]?.map((d) => newFeatureFlag(d)) || [],
  } as any;
}

export function newUserFeatureFlagsResponse(
  data: UserFeatureFlagsDataOptions | Error,
): MockedResponse<UserFeatureFlagsQueryVariables, UserFeatureFlagsQuery> {
  return {
    request: { query: UserFeatureFlagsDocument },
    result: { data: data instanceof Error ? undefined : newUserFeatureFlagsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectFeatureFlagsDataOptions {
  project?: Project | ProjectOptions;
}

export function newProjectFeatureFlagsData(data: ProjectFeatureFlagsDataOptions): ProjectFeatureFlagsQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newProjectFeatureFlagsResponse(
  variables: ProjectFeatureFlagsQueryVariables,
  data: ProjectFeatureFlagsDataOptions | Error,
): MockedResponse<ProjectFeatureFlagsQueryVariables, ProjectFeatureFlagsQuery> {
  return {
    request: { query: ProjectFeatureFlagsDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectFeatureFlagsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentFeatureFlagsDataOptions {
  development?: Development | DevelopmentOptions;
}

export function newDevelopmentFeatureFlagsData(data: DevelopmentFeatureFlagsDataOptions): DevelopmentFeatureFlagsQuery {
  return {
    __typename: "Query" as const,
    development: maybeNew("Development", data["development"] || undefined, {}),
  } as any;
}

export function newDevelopmentFeatureFlagsResponse(
  variables: DevelopmentFeatureFlagsQueryVariables,
  data: DevelopmentFeatureFlagsDataOptions | Error,
): MockedResponse<DevelopmentFeatureFlagsQueryVariables, DevelopmentFeatureFlagsQuery> {
  return {
    request: { query: DevelopmentFeatureFlagsDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentFeatureFlagsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface UseGlobalOptionTagsFilterDataOptions {
  globalOptionTags?: (GlobalOptionTag | GlobalOptionTagOptions)[];
}

export function newUseGlobalOptionTagsFilterData(
  data: UseGlobalOptionTagsFilterDataOptions,
): UseGlobalOptionTagsFilterQuery {
  return {
    __typename: "Query" as const,
    globalOptionTags: data["globalOptionTags"]?.map((d) => newGlobalOptionTag(d)) || [],
  } as any;
}

export function newUseGlobalOptionTagsFilterResponse(
  variables: UseGlobalOptionTagsFilterQueryVariables,
  data: UseGlobalOptionTagsFilterDataOptions | Error,
): MockedResponse<UseGlobalOptionTagsFilterQueryVariables, UseGlobalOptionTagsFilterQuery> {
  return {
    request: { query: UseGlobalOptionTagsFilterDocument, variables },
    result: { data: data instanceof Error ? undefined : newUseGlobalOptionTagsFilterData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface UseRoomTypeFilterDataOptions {
  roomTypes?: (RoomType | RoomTypeOptions)[];
}

export function newUseRoomTypeFilterData(data: UseRoomTypeFilterDataOptions): UseRoomTypeFilterQuery {
  return { __typename: "Query" as const, roomTypes: data["roomTypes"]?.map((d) => newRoomType(d)) || [] } as any;
}

export function newUseRoomTypeFilterResponse(
  data: UseRoomTypeFilterDataOptions | Error,
): MockedResponse<UseRoomTypeFilterQueryVariables, UseRoomTypeFilterQuery> {
  return {
    request: { query: UseRoomTypeFilterDocument },
    result: { data: data instanceof Error ? undefined : newUseRoomTypeFilterData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidItemSelectDataOptions {
  potentialBidItems?: (BidItem | BidItemOptions)[];
}

export function newBidItemSelectData(data: BidItemSelectDataOptions): BidItemSelectQuery {
  return {
    __typename: "Query" as const,
    potentialBidItems: data["potentialBidItems"]?.map((d) => newBidItem(d)) || [],
  } as any;
}

export function newBidItemSelectResponse(
  variables: BidItemSelectQueryVariables,
  data: BidItemSelectDataOptions | Error,
): MockedResponse<BidItemSelectQueryVariables, BidItemSelectQuery> {
  return {
    request: { query: BidItemSelectDocument, variables },
    result: { data: data instanceof Error ? undefined : newBidItemSelectData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SubmitChangesForApprovalStep_ChangeBreakdownTableDataOptions {
  changeEvents?: (ChangeEvent | ChangeEventOptions)[];
}

export function newSubmitChangesForApprovalStep_ChangeBreakdownTableData(
  data: SubmitChangesForApprovalStep_ChangeBreakdownTableDataOptions,
): SubmitChangesForApprovalStep_ChangeBreakdownTableQuery {
  return {
    __typename: "Query" as const,
    changeEvents: data["changeEvents"]?.map((d) => newChangeEvent(d)) || [],
  } as any;
}

export function newSubmitChangesForApprovalStep_ChangeBreakdownTableResponse(
  variables: SubmitChangesForApprovalStep_ChangeBreakdownTableQueryVariables,
  data: SubmitChangesForApprovalStep_ChangeBreakdownTableDataOptions | Error,
): MockedResponse<
  SubmitChangesForApprovalStep_ChangeBreakdownTableQueryVariables,
  SubmitChangesForApprovalStep_ChangeBreakdownTableQuery
> {
  return {
    request: { query: SubmitChangesForApprovalStep_ChangeBreakdownTableDocument, variables },
    result: {
      data: data instanceof Error ? undefined : newSubmitChangesForApprovalStep_ChangeBreakdownTableData(data),
    },
    error: data instanceof Error ? data : undefined,
  };
}
interface ToggleCommitmentReleaseDataOptions {
  saveCommitment?: SaveCommitmentResult | SaveCommitmentResultOptions;
}

export function newToggleCommitmentReleaseData(
  data: ToggleCommitmentReleaseDataOptions,
): ToggleCommitmentReleaseMutation {
  return {
    __typename: "Mutation" as const,
    saveCommitment: maybeNew("SaveCommitmentResult", data["saveCommitment"] || undefined, {}),
  } as any;
}

export function newToggleCommitmentReleaseResponse(
  variables: ToggleCommitmentReleaseMutationVariables,
  data: ToggleCommitmentReleaseDataOptions | Error,
): MockedResponse<ToggleCommitmentReleaseMutationVariables, ToggleCommitmentReleaseMutation> {
  return {
    request: { query: ToggleCommitmentReleaseDocument, variables },
    result: { data: data instanceof Error ? undefined : newToggleCommitmentReleaseData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface OpenManyChangeEventApprovalsDataOptions {
  saveChangeEvents?: SaveChangeEventsResult | SaveChangeEventsResultOptions;
  saveApprovals?: SaveApprovalsResult | SaveApprovalsResultOptions;
}

export function newOpenManyChangeEventApprovalsData(
  data: OpenManyChangeEventApprovalsDataOptions,
): OpenManyChangeEventApprovalsMutation {
  return {
    __typename: "Mutation" as const,
    saveChangeEvents: maybeNew("SaveChangeEventsResult", data["saveChangeEvents"] || undefined, {}),
    saveApprovals: maybeNew("SaveApprovalsResult", data["saveApprovals"] || undefined, {}),
  } as any;
}

export function newOpenManyChangeEventApprovalsResponse(
  variables: OpenManyChangeEventApprovalsMutationVariables,
  data: OpenManyChangeEventApprovalsDataOptions | Error,
): MockedResponse<OpenManyChangeEventApprovalsMutationVariables, OpenManyChangeEventApprovalsMutation> {
  return {
    request: { query: OpenManyChangeEventApprovalsDocument, variables },
    result: { data: data instanceof Error ? undefined : newOpenManyChangeEventApprovalsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateChangeEventApproval_ImpactedPosTableDataOptions {
  changeEvents?: (ChangeEvent | ChangeEventOptions)[];
}

export function newCreateChangeEventApproval_ImpactedPosTableData(
  data: CreateChangeEventApproval_ImpactedPosTableDataOptions,
): CreateChangeEventApproval_ImpactedPosTableQuery {
  return {
    __typename: "Query" as const,
    changeEvents: data["changeEvents"]?.map((d) => newChangeEvent(d)) || [],
  } as any;
}

export function newCreateChangeEventApproval_ImpactedPosTableResponse(
  variables: CreateChangeEventApproval_ImpactedPosTableQueryVariables,
  data: CreateChangeEventApproval_ImpactedPosTableDataOptions | Error,
): MockedResponse<
  CreateChangeEventApproval_ImpactedPosTableQueryVariables,
  CreateChangeEventApproval_ImpactedPosTableQuery
> {
  return {
    request: { query: CreateChangeEventApproval_ImpactedPosTableDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateChangeEventApproval_ImpactedPosTableData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChangeEventReasonsDataOptions {
  changeEventReasons?: (ChangeEventReason | ChangeEventReasonOptions)[];
}

export function newChangeEventReasonsData(data: ChangeEventReasonsDataOptions): ChangeEventReasonsQuery {
  return {
    __typename: "Query" as const,
    changeEventReasons: data["changeEventReasons"]?.map((d) => newChangeEventReason(d)) || [],
  } as any;
}

export function newChangeEventReasonsResponse(
  data: ChangeEventReasonsDataOptions | Error,
): MockedResponse<ChangeEventReasonsQueryVariables, ChangeEventReasonsQuery> {
  return {
    request: { query: ChangeEventReasonsDocument },
    result: { data: data instanceof Error ? undefined : newChangeEventReasonsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CostCodeSelectDataOptions {
  costCodes?: (CostCode | CostCodeOptions)[];
}

export function newCostCodeSelectData(data: CostCodeSelectDataOptions): CostCodeSelectQuery {
  return { __typename: "Query" as const, costCodes: data["costCodes"]?.map((d) => newCostCode(d)) || [] } as any;
}

export function newCostCodeSelectResponse(
  variables: CostCodeSelectQueryVariables,
  data: CostCodeSelectDataOptions | Error,
): MockedResponse<CostCodeSelectQueryVariables, CostCodeSelectQuery> {
  return {
    request: { query: CostCodeSelectDocument, variables },
    result: { data: data instanceof Error ? undefined : newCostCodeSelectData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CostSourceSelectDataOptions {
  bidContractLineItems?: (BidContractLineItem | BidContractLineItemOptions)[];
}

export function newCostSourceSelectData(data: CostSourceSelectDataOptions): CostSourceSelectQuery {
  return {
    __typename: "Query" as const,
    bidContractLineItems: data["bidContractLineItems"]?.map((d) => newBidContractLineItem(d)) || [],
  } as any;
}

export function newCostSourceSelectResponse(
  variables: CostSourceSelectQueryVariables,
  data: CostSourceSelectDataOptions | Error,
): MockedResponse<CostSourceSelectQueryVariables, CostSourceSelectQuery> {
  return {
    request: { query: CostSourceSelectDocument, variables },
    result: { data: data instanceof Error ? undefined : newCostSourceSelectData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface GlobalPlanTaskSelectDataOptions {
  globalPlanTasks?: GlobalPlanTasksPageResult | GlobalPlanTasksPageResultOptions;
}

export function newGlobalPlanTaskSelectData(data: GlobalPlanTaskSelectDataOptions): GlobalPlanTaskSelectQuery {
  return {
    __typename: "Query" as const,
    globalPlanTasks: maybeNew("GlobalPlanTasksPageResult", data["globalPlanTasks"] || undefined, {}),
  } as any;
}

export function newGlobalPlanTaskSelectResponse(
  variables: GlobalPlanTaskSelectQueryVariables,
  data: GlobalPlanTaskSelectDataOptions | Error,
): MockedResponse<GlobalPlanTaskSelectQueryVariables, GlobalPlanTaskSelectQuery> {
  return {
    request: { query: GlobalPlanTaskSelectDocument, variables },
    result: { data: data instanceof Error ? undefined : newGlobalPlanTaskSelectData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ItemsSelectDataOptions {
  items?: (Item | ItemOptions)[];
}

export function newItemsSelectData(data: ItemsSelectDataOptions): ItemsSelectQuery {
  return { __typename: "Query" as const, items: data["items"]?.map((d) => newItem(d)) || [] } as any;
}

export function newItemsSelectResponse(
  variables: ItemsSelectQueryVariables,
  data: ItemsSelectDataOptions | Error,
): MockedResponse<ItemsSelectQueryVariables, ItemsSelectQuery> {
  return {
    request: { query: ItemsSelectDocument, variables },
    result: { data: data instanceof Error ? undefined : newItemsSelectData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface LocationsDataOptions {
  locations?: (Location | LocationOptions)[];
}

export function newLocationsData(data: LocationsDataOptions): LocationsQuery {
  return { __typename: "Query" as const, locations: data["locations"]?.map((d) => newLocation(d)) || [] } as any;
}

export function newLocationsResponse(
  variables: LocationsQueryVariables,
  data: LocationsDataOptions | Error,
): MockedResponse<LocationsQueryVariables, LocationsQuery> {
  return {
    request: { query: LocationsDocument, variables },
    result: { data: data instanceof Error ? undefined : newLocationsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MadTypesDataOptions {
  enumDetails?: AllEnumDetails | AllEnumDetailsOptions;
}

export function newMadTypesData(data: MadTypesDataOptions): MadTypesQuery {
  return {
    __typename: "Query" as const,
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
  } as any;
}

export function newMadTypesResponse(
  data: MadTypesDataOptions | Error,
): MockedResponse<MadTypesQueryVariables, MadTypesQuery> {
  return {
    request: { query: MadTypesDocument },
    result: { data: data instanceof Error ? undefined : newMadTypesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProductSelectDataOptions {
  products?: (Product | ProductOptions)[];
}

export function newProductSelectData(data: ProductSelectDataOptions): ProductSelectQuery {
  return { __typename: "Query" as const, products: data["products"]?.map((d) => newProduct(d)) || [] } as any;
}

export function newProductSelectResponse(
  variables: ProductSelectQueryVariables,
  data: ProductSelectDataOptions | Error,
): MockedResponse<ProductSelectQueryVariables, ProductSelectQuery> {
  return {
    request: { query: ProductSelectDocument, variables },
    result: { data: data instanceof Error ? undefined : newProductSelectData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectAutocompleteDataOptions {
  projectsPage?: ProjectsPageResult | ProjectsPageResultOptions;
}

export function newProjectAutocompleteData(data: ProjectAutocompleteDataOptions): ProjectAutocompleteQuery {
  return {
    __typename: "Query" as const,
    projectsPage: maybeNew("ProjectsPageResult", data["projectsPage"] || undefined, {}),
  } as any;
}

export function newProjectAutocompleteResponse(
  variables: ProjectAutocompleteQueryVariables,
  data: ProjectAutocompleteDataOptions | Error,
): MockedResponse<ProjectAutocompleteQueryVariables, ProjectAutocompleteQuery> {
  return {
    request: { query: ProjectAutocompleteDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectAutocompleteData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface RoomTypeDataOptions {
  roomTypes?: (RoomType | RoomTypeOptions)[];
}

export function newRoomTypeData(data: RoomTypeDataOptions): RoomTypeQuery {
  return { __typename: "Query" as const, roomTypes: data["roomTypes"]?.map((d) => newRoomType(d)) || [] } as any;
}

export function newRoomTypeResponse(
  data: RoomTypeDataOptions | Error,
): MockedResponse<RoomTypeQueryVariables, RoomTypeQuery> {
  return {
    request: { query: RoomTypeDocument },
    result: { data: data instanceof Error ? undefined : newRoomTypeData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TradePartnerAutocompleteDataOptions {
  tradePartnersPage?: TradePartnersPage | TradePartnersPageOptions;
}

export function newTradePartnerAutocompleteData(
  data: TradePartnerAutocompleteDataOptions,
): TradePartnerAutocompleteQuery {
  return {
    __typename: "Query" as const,
    tradePartnersPage: maybeNew("TradePartnersPage", data["tradePartnersPage"] || undefined, {}),
  } as any;
}

export function newTradePartnerAutocompleteResponse(
  variables: TradePartnerAutocompleteQueryVariables,
  data: TradePartnerAutocompleteDataOptions | Error,
): MockedResponse<TradePartnerAutocompleteQueryVariables, TradePartnerAutocompleteQuery> {
  return {
    request: { query: TradePartnerAutocompleteDocument, variables },
    result: { data: data instanceof Error ? undefined : newTradePartnerAutocompleteData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TradePartnersSelectDataOptions {
  tradePartners?: (TradePartner | TradePartnerOptions)[];
}

export function newTradePartnersSelectData(data: TradePartnersSelectDataOptions): TradePartnersSelectQuery {
  return {
    __typename: "Query" as const,
    tradePartners: data["tradePartners"]?.map((d) => newTradePartner(d)) || [],
  } as any;
}

export function newTradePartnersSelectResponse(
  variables: TradePartnersSelectQueryVariables,
  data: TradePartnersSelectDataOptions | Error,
): MockedResponse<TradePartnersSelectQueryVariables, TradePartnersSelectQuery> {
  return {
    request: { query: TradePartnersSelectDocument, variables },
    result: { data: data instanceof Error ? undefined : newTradePartnersSelectData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface UnitsOfMeasureDataOptions {
  unitsOfMeasure?: (UnitOfMeasure | UnitOfMeasureOptions)[];
}

export function newUnitsOfMeasureData(data: UnitsOfMeasureDataOptions): UnitsOfMeasureQuery {
  return {
    __typename: "Query" as const,
    unitsOfMeasure: data["unitsOfMeasure"]?.map((d) => newUnitOfMeasure(d)) || [],
  } as any;
}

export function newUnitsOfMeasureResponse(
  data: UnitsOfMeasureDataOptions | Error,
): MockedResponse<UnitsOfMeasureQueryVariables, UnitsOfMeasureQuery> {
  return {
    request: { query: UnitsOfMeasureDocument },
    result: { data: data instanceof Error ? undefined : newUnitsOfMeasureData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidContractPlanPricing_RevisionDataOptions {
  bidContractRevision?: BidContractRevision | BidContractRevisionOptions;
}

export function newBidContractPlanPricing_RevisionData(
  data: BidContractPlanPricing_RevisionDataOptions,
): BidContractPlanPricing_RevisionQuery {
  return {
    __typename: "Query" as const,
    bidContractRevision: maybeNew("BidContractRevision", data["bidContractRevision"] || undefined, {}),
  } as any;
}

export function newBidContractPlanPricing_RevisionResponse(
  variables: BidContractPlanPricing_RevisionQueryVariables,
  data: BidContractPlanPricing_RevisionDataOptions | Error,
): MockedResponse<BidContractPlanPricing_RevisionQueryVariables, BidContractPlanPricing_RevisionQuery> {
  return {
    request: { query: BidContractPlanPricing_RevisionDocument, variables },
    result: { data: data instanceof Error ? undefined : newBidContractPlanPricing_RevisionData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidContractPlanPricing_ScopeLinesDataOptions {
  bidPackageVersionScopeLines?: (BidPackageScopeLine | BidPackageScopeLineOptions)[];
}

export function newBidContractPlanPricing_ScopeLinesData(
  data: BidContractPlanPricing_ScopeLinesDataOptions,
): BidContractPlanPricing_ScopeLinesQuery {
  return {
    __typename: "Query" as const,
    bidPackageVersionScopeLines: data["bidPackageVersionScopeLines"]?.map((d) => newBidPackageScopeLine(d)) || [],
  } as any;
}

export function newBidContractPlanPricing_ScopeLinesResponse(
  variables: BidContractPlanPricing_ScopeLinesQueryVariables,
  data: BidContractPlanPricing_ScopeLinesDataOptions | Error,
): MockedResponse<BidContractPlanPricing_ScopeLinesQueryVariables, BidContractPlanPricing_ScopeLinesQuery> {
  return {
    request: { query: BidContractPlanPricing_ScopeLinesDocument, variables },
    result: { data: data instanceof Error ? undefined : newBidContractPlanPricing_ScopeLinesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface GlobalOptionTypesDataOptions {
  globalOptionTypes?: (GlobalOptionType | GlobalOptionTypeOptions)[];
}

export function newGlobalOptionTypesData(data: GlobalOptionTypesDataOptions): GlobalOptionTypesQuery {
  return {
    __typename: "Query" as const,
    globalOptionTypes: data["globalOptionTypes"]?.map((d) => newGlobalOptionType(d)) || [],
  } as any;
}

export function newGlobalOptionTypesResponse(
  variables: GlobalOptionTypesQueryVariables,
  data: GlobalOptionTypesDataOptions | Error,
): MockedResponse<GlobalOptionTypesQueryVariables, GlobalOptionTypesQuery> {
  return {
    request: { query: GlobalOptionTypesDocument, variables },
    result: { data: data instanceof Error ? undefined : newGlobalOptionTypesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidContractPurchaseOrdersPageDataOptions {
  bidContractRevision?: BidContractRevision | BidContractRevisionOptions;
}

export function newBidContractPurchaseOrdersPageData(
  data: BidContractPurchaseOrdersPageDataOptions,
): BidContractPurchaseOrdersPageQuery {
  return {
    __typename: "Query" as const,
    bidContractRevision: maybeNew("BidContractRevision", data["bidContractRevision"] || undefined, {}),
  } as any;
}

export function newBidContractPurchaseOrdersPageResponse(
  variables: BidContractPurchaseOrdersPageQueryVariables,
  data: BidContractPurchaseOrdersPageDataOptions | Error,
): MockedResponse<BidContractPurchaseOrdersPageQueryVariables, BidContractPurchaseOrdersPageQuery> {
  return {
    request: { query: BidContractPurchaseOrdersPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newBidContractPurchaseOrdersPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidContractRevisionUnitPricingDataOptions {
  bidContractRevision?: BidContractRevision | BidContractRevisionOptions;
}

export function newBidContractRevisionUnitPricingData(
  data: BidContractRevisionUnitPricingDataOptions,
): BidContractRevisionUnitPricingQuery {
  return {
    __typename: "Query" as const,
    bidContractRevision: maybeNew("BidContractRevision", data["bidContractRevision"] || undefined, {}),
  } as any;
}

export function newBidContractRevisionUnitPricingResponse(
  variables: BidContractRevisionUnitPricingQueryVariables,
  data: BidContractRevisionUnitPricingDataOptions | Error,
): MockedResponse<BidContractRevisionUnitPricingQueryVariables, BidContractRevisionUnitPricingQuery> {
  return {
    request: { query: BidContractRevisionUnitPricingDocument, variables },
    result: { data: data instanceof Error ? undefined : newBidContractRevisionUnitPricingData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveBidContractUnitPricingDataOptions {
  saveBidContractLineItems?: SaveBidContractLineItemsResult | SaveBidContractLineItemsResultOptions;
}

export function newSaveBidContractUnitPricingData(
  data: SaveBidContractUnitPricingDataOptions,
): SaveBidContractUnitPricingMutation {
  return {
    __typename: "Mutation" as const,
    saveBidContractLineItems: maybeNew(
      "SaveBidContractLineItemsResult",
      data["saveBidContractLineItems"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveBidContractUnitPricingResponse(
  variables: SaveBidContractUnitPricingMutationVariables,
  data: SaveBidContractUnitPricingDataOptions | Error,
): MockedResponse<SaveBidContractUnitPricingMutationVariables, SaveBidContractUnitPricingMutation> {
  return {
    request: { query: SaveBidContractUnitPricingDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveBidContractUnitPricingData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidContractsTableV2DataOptions {
  bidContractsPage?: BidContractsPage | BidContractsPageOptions;
}

export function newBidContractsTableV2Data(data: BidContractsTableV2DataOptions): BidContractsTableV2Query {
  return {
    __typename: "Query" as const,
    bidContractsPage: maybeNew("BidContractsPage", data["bidContractsPage"] || undefined, {}),
  } as any;
}

export function newBidContractsTableV2Response(
  variables: BidContractsTableV2QueryVariables,
  data: BidContractsTableV2DataOptions | Error,
): MockedResponse<BidContractsTableV2QueryVariables, BidContractsTableV2Query> {
  return {
    request: { query: BidContractsTableV2Document, variables },
    result: { data: data instanceof Error ? undefined : newBidContractsTableV2Data(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidItemsModalDataOptions {
  bidItemsPage?: BidItemsPage | BidItemsPageOptions;
}

export function newBidItemsModalData(data: BidItemsModalDataOptions): BidItemsModalQuery {
  return {
    __typename: "Query" as const,
    bidItemsPage: maybeNew("BidItemsPage", data["bidItemsPage"] || undefined, {}),
  } as any;
}

export function newBidItemsModalResponse(
  variables: BidItemsModalQueryVariables,
  data: BidItemsModalDataOptions | Error,
): MockedResponse<BidItemsModalQueryVariables, BidItemsModalQuery> {
  return {
    request: { query: BidItemsModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newBidItemsModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BusinessFunctionsDataOptions {
  businessFunctions?: (BusinessFunction | BusinessFunctionOptions)[];
}

export function newBusinessFunctionsData(data: BusinessFunctionsDataOptions): BusinessFunctionsQuery {
  return {
    __typename: "Query" as const,
    businessFunctions: data["businessFunctions"]?.map((d) => newBusinessFunction(d)) || [],
  } as any;
}

export function newBusinessFunctionsResponse(
  data: BusinessFunctionsDataOptions | Error,
): MockedResponse<BusinessFunctionsQueryVariables, BusinessFunctionsQuery> {
  return {
    request: { query: BusinessFunctionsDocument },
    result: { data: data instanceof Error ? undefined : newBusinessFunctionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BusinessFunctionDetailsDataOptions {
  businessFunction?: BusinessFunction | BusinessFunctionOptions;
}

export function newBusinessFunctionDetailsData(data: BusinessFunctionDetailsDataOptions): BusinessFunctionDetailsQuery {
  return {
    __typename: "Query" as const,
    businessFunction: maybeNew("BusinessFunction", data["businessFunction"] || undefined, {}),
  } as any;
}

export function newBusinessFunctionDetailsResponse(
  variables: BusinessFunctionDetailsQueryVariables,
  data: BusinessFunctionDetailsDataOptions | Error,
): MockedResponse<BusinessFunctionDetailsQueryVariables, BusinessFunctionDetailsQuery> {
  return {
    request: { query: BusinessFunctionDetailsDocument, variables },
    result: { data: data instanceof Error ? undefined : newBusinessFunctionDetailsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectRolesForBusinessFunctionDataOptions {
  projectRolesForBusinessFunctionType?: (ProjectRoleDetail | ProjectRoleDetailOptions)[];
}

export function newProjectRolesForBusinessFunctionData(
  data: ProjectRolesForBusinessFunctionDataOptions,
): ProjectRolesForBusinessFunctionQuery {
  return {
    __typename: "Query" as const,
    projectRolesForBusinessFunctionType:
      data["projectRolesForBusinessFunctionType"]?.map((d) => newProjectRoleDetail(d)) || [],
  } as any;
}

export function newProjectRolesForBusinessFunctionResponse(
  variables: ProjectRolesForBusinessFunctionQueryVariables,
  data: ProjectRolesForBusinessFunctionDataOptions | Error,
): MockedResponse<ProjectRolesForBusinessFunctionQueryVariables, ProjectRolesForBusinessFunctionQuery> {
  return {
    request: { query: ProjectRolesForBusinessFunctionDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectRolesForBusinessFunctionData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveBusinessFunctionDataOptions {
  saveBusinessFunction?: SaveBusinessFunctionResult | SaveBusinessFunctionResultOptions;
}

export function newSaveBusinessFunctionData(data: SaveBusinessFunctionDataOptions): SaveBusinessFunctionMutation {
  return {
    __typename: "Mutation" as const,
    saveBusinessFunction: maybeNew("SaveBusinessFunctionResult", data["saveBusinessFunction"] || undefined, {}),
  } as any;
}

export function newSaveBusinessFunctionResponse(
  variables: SaveBusinessFunctionMutationVariables,
  data: SaveBusinessFunctionDataOptions | Error,
): MockedResponse<SaveBusinessFunctionMutationVariables, SaveBusinessFunctionMutation> {
  return {
    request: { query: SaveBusinessFunctionDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveBusinessFunctionData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChangeLogMetadataDataOptions {
  markets?: (Market | MarketOptions)[];
  developments?: (Development | DevelopmentOptions)[];
  changeRequestGroups?: (ChangeRequestGroup | ChangeRequestGroupOptions)[];
  enumDetails?: AllEnumDetails | AllEnumDetailsOptions;
}

export function newChangeLogMetadataData(data: ChangeLogMetadataDataOptions): ChangeLogMetadataQuery {
  return {
    __typename: "Query" as const,
    markets: data["markets"]?.map((d) => newMarket(d)) || [],
    developments: data["developments"]?.map((d) => newDevelopment(d)) || [],
    changeRequestGroups: data["changeRequestGroups"]?.map((d) => newChangeRequestGroup(d)) || [],
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
  } as any;
}

export function newChangeLogMetadataResponse(
  data: ChangeLogMetadataDataOptions | Error,
): MockedResponse<ChangeLogMetadataQueryVariables, ChangeLogMetadataQuery> {
  return {
    request: { query: ChangeLogMetadataDocument },
    result: { data: data instanceof Error ? undefined : newChangeLogMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChangeLogProjectFilterMetadataDataOptions {
  projectsPage?: ProjectsPageResult | ProjectsPageResultOptions;
}

export function newChangeLogProjectFilterMetadataData(
  data: ChangeLogProjectFilterMetadataDataOptions,
): ChangeLogProjectFilterMetadataQuery {
  return {
    __typename: "Query" as const,
    projectsPage: maybeNew("ProjectsPageResult", data["projectsPage"] || undefined, {}),
  } as any;
}

export function newChangeLogProjectFilterMetadataResponse(
  variables: ChangeLogProjectFilterMetadataQueryVariables,
  data: ChangeLogProjectFilterMetadataDataOptions | Error,
): MockedResponse<ChangeLogProjectFilterMetadataQueryVariables, ChangeLogProjectFilterMetadataQuery> {
  return {
    request: { query: ChangeLogProjectFilterMetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newChangeLogProjectFilterMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChangeLogRightPaneContentDetailsDataOptions {
  changeRequest?: ChangeRequest | ChangeRequestOptions;
  enumDetails?: AllEnumDetails | AllEnumDetailsOptions;
  regions?: (Region | RegionOptions)[];
  changeRequestAssets?: ChangeRequestAssetsPageResult | ChangeRequestAssetsPageResultOptions;
}

export function newChangeLogRightPaneContentDetailsData(
  data: ChangeLogRightPaneContentDetailsDataOptions,
): ChangeLogRightPaneContentDetailsQuery {
  return {
    __typename: "Query" as const,
    changeRequest: maybeNew("ChangeRequest", data["changeRequest"] || undefined, {}),
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
    regions: data["regions"]?.map((d) => newRegion(d)) || [],
    changeRequestAssets: maybeNew("ChangeRequestAssetsPageResult", data["changeRequestAssets"] || undefined, {}),
  } as any;
}

export function newChangeLogRightPaneContentDetailsResponse(
  variables: ChangeLogRightPaneContentDetailsQueryVariables,
  data: ChangeLogRightPaneContentDetailsDataOptions | Error,
): MockedResponse<ChangeLogRightPaneContentDetailsQueryVariables, ChangeLogRightPaneContentDetailsQuery> {
  return {
    request: { query: ChangeLogRightPaneContentDetailsDocument, variables },
    result: { data: data instanceof Error ? undefined : newChangeLogRightPaneContentDetailsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChangeLogTableDataOptions {
  changeRequests?: ChangeRequestsPageResult | ChangeRequestsPageResultOptions;
}

export function newChangeLogTableData(data: ChangeLogTableDataOptions): ChangeLogTableQuery {
  return {
    __typename: "Query" as const,
    changeRequests: maybeNew("ChangeRequestsPageResult", data["changeRequests"] || undefined, {}),
  } as any;
}

export function newChangeLogTableResponse(
  variables: ChangeLogTableQueryVariables,
  data: ChangeLogTableDataOptions | Error,
): MockedResponse<ChangeLogTableQueryVariables, ChangeLogTableQuery> {
  return {
    request: { query: ChangeLogTableDocument, variables },
    result: { data: data instanceof Error ? undefined : newChangeLogTableData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChangeTypesDataOptions {
  enumDetails?: AllEnumDetails | AllEnumDetailsOptions;
}

export function newChangeTypesData(data: ChangeTypesDataOptions): ChangeTypesQuery {
  return {
    __typename: "Query" as const,
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
  } as any;
}

export function newChangeTypesResponse(
  data: ChangeTypesDataOptions | Error,
): MockedResponse<ChangeTypesQueryVariables, ChangeTypesQuery> {
  return {
    request: { query: ChangeTypesDocument },
    result: { data: data instanceof Error ? undefined : newChangeTypesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveCommentDataOptions {
  saveComment?: SaveCommentResult | SaveCommentResultOptions;
}

export function newSaveCommentData(data: SaveCommentDataOptions): SaveCommentMutation {
  return {
    __typename: "Mutation" as const,
    saveComment: maybeNew("SaveCommentResult", data["saveComment"] || undefined, {}),
  } as any;
}

export function newSaveCommentResponse(
  variables: SaveCommentMutationVariables,
  data: SaveCommentDataOptions | Error,
): MockedResponse<SaveCommentMutationVariables, SaveCommentMutation> {
  return {
    request: { query: SaveCommentDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveCommentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteCommentDataOptions {
  deleteComment?: DeleteCommentResult | DeleteCommentResultOptions;
}

export function newDeleteCommentData(data: DeleteCommentDataOptions): DeleteCommentMutation {
  return {
    __typename: "Mutation" as const,
    deleteComment: maybeNew("DeleteCommentResult", data["deleteComment"] || undefined, {}),
  } as any;
}

export function newDeleteCommentResponse(
  variables: DeleteCommentMutationVariables,
  data: DeleteCommentDataOptions | Error,
): MockedResponse<DeleteCommentMutationVariables, DeleteCommentMutation> {
  return {
    request: { query: DeleteCommentDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteCommentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveFollowersDataOptions {
  saveFollowers?: SaveFollowersResult | SaveFollowersResultOptions;
}

export function newSaveFollowersData(data: SaveFollowersDataOptions): SaveFollowersMutation {
  return {
    __typename: "Mutation" as const,
    saveFollowers: maybeNew("SaveFollowersResult", data["saveFollowers"] || undefined, {}),
  } as any;
}

export function newSaveFollowersResponse(
  variables: SaveFollowersMutationVariables,
  data: SaveFollowersDataOptions | Error,
): MockedResponse<SaveFollowersMutationVariables, SaveFollowersMutation> {
  return {
    request: { query: SaveFollowersDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveFollowersData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MarkCommentStreamAsReadDataOptions {
  markCommentStreamAsRead?: CommentStream | CommentStreamOptions | null;
}

export function newMarkCommentStreamAsReadData(
  data: MarkCommentStreamAsReadDataOptions,
): MarkCommentStreamAsReadMutation {
  return {
    __typename: "Mutation" as const,
    markCommentStreamAsRead: maybeNewOrNull("CommentStream", data["markCommentStreamAsRead"] || undefined, {}),
  } as any;
}

export function newMarkCommentStreamAsReadResponse(
  variables: MarkCommentStreamAsReadMutationVariables,
  data: MarkCommentStreamAsReadDataOptions | Error,
): MockedResponse<MarkCommentStreamAsReadMutationVariables, MarkCommentStreamAsReadMutation> {
  return {
    request: { query: MarkCommentStreamAsReadDocument, variables },
    result: { data: data instanceof Error ? undefined : newMarkCommentStreamAsReadData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CommentFeedTradePartnersDataOptions {
  tradePartners?: (TradePartner | TradePartnerOptions)[];
}

export function newCommentFeedTradePartnersData(
  data: CommentFeedTradePartnersDataOptions,
): CommentFeedTradePartnersQuery {
  return {
    __typename: "Query" as const,
    tradePartners: data["tradePartners"]?.map((d) => newTradePartner(d)) || [],
  } as any;
}

export function newCommentFeedTradePartnersResponse(
  variables: CommentFeedTradePartnersQueryVariables,
  data: CommentFeedTradePartnersDataOptions | Error,
): MockedResponse<CommentFeedTradePartnersQueryVariables, CommentFeedTradePartnersQuery> {
  return {
    request: { query: CommentFeedTradePartnersDocument, variables },
    result: { data: data instanceof Error ? undefined : newCommentFeedTradePartnersData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateChangeRequestMetadataDataOptions {
  enumDetails?: AllEnumDetails | AllEnumDetailsOptions;
  regions?: (Region | RegionOptions)[];
  changeRequestAssets?: ChangeRequestAssetsPageResult | ChangeRequestAssetsPageResultOptions;
  changeRequestGroups?: (ChangeRequestGroup | ChangeRequestGroupOptions)[];
}

export function newCreateChangeRequestMetadataData(
  data: CreateChangeRequestMetadataDataOptions,
): CreateChangeRequestMetadataQuery {
  return {
    __typename: "Query" as const,
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
    regions: data["regions"]?.map((d) => newRegion(d)) || [],
    changeRequestAssets: maybeNew("ChangeRequestAssetsPageResult", data["changeRequestAssets"] || undefined, {}),
    changeRequestGroups: data["changeRequestGroups"]?.map((d) => newChangeRequestGroup(d)) || [],
  } as any;
}

export function newCreateChangeRequestMetadataResponse(
  data: CreateChangeRequestMetadataDataOptions | Error,
): MockedResponse<CreateChangeRequestMetadataQueryVariables, CreateChangeRequestMetadataQuery> {
  return {
    request: { query: CreateChangeRequestMetadataDocument },
    result: { data: data instanceof Error ? undefined : newCreateChangeRequestMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChangeRequestDetailsDataOptions {
  changeRequest?: ChangeRequest | ChangeRequestOptions;
}

export function newChangeRequestDetailsData(data: ChangeRequestDetailsDataOptions): ChangeRequestDetailsQuery {
  return {
    __typename: "Query" as const,
    changeRequest: maybeNew("ChangeRequest", data["changeRequest"] || undefined, {}),
  } as any;
}

export function newChangeRequestDetailsResponse(
  variables: ChangeRequestDetailsQueryVariables,
  data: ChangeRequestDetailsDataOptions | Error,
): MockedResponse<ChangeRequestDetailsQueryVariables, ChangeRequestDetailsQuery> {
  return {
    request: { query: ChangeRequestDetailsDocument, variables },
    result: { data: data instanceof Error ? undefined : newChangeRequestDetailsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveChangeRequestDataOptions {
  saveChangeRequest?: SaveChangeRequestResult | SaveChangeRequestResultOptions;
}

export function newSaveChangeRequestData(data: SaveChangeRequestDataOptions): SaveChangeRequestMutation {
  return {
    __typename: "Mutation" as const,
    saveChangeRequest: maybeNew("SaveChangeRequestResult", data["saveChangeRequest"] || undefined, {}),
  } as any;
}

export function newSaveChangeRequestResponse(
  variables: SaveChangeRequestMutationVariables,
  data: SaveChangeRequestDataOptions | Error,
): MockedResponse<SaveChangeRequestMutationVariables, SaveChangeRequestMutation> {
  return {
    request: { query: SaveChangeRequestDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveChangeRequestData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveChangeRequestsDataOptions {
  saveChangeRequests?: SaveChangeRequestsResult | SaveChangeRequestsResultOptions;
}

export function newSaveChangeRequestsData(data: SaveChangeRequestsDataOptions): SaveChangeRequestsMutation {
  return {
    __typename: "Mutation" as const,
    saveChangeRequests: maybeNew("SaveChangeRequestsResult", data["saveChangeRequests"] || undefined, {}),
  } as any;
}

export function newSaveChangeRequestsResponse(
  variables: SaveChangeRequestsMutationVariables,
  data: SaveChangeRequestsDataOptions | Error,
): MockedResponse<SaveChangeRequestsMutationVariables, SaveChangeRequestsMutation> {
  return {
    request: { query: SaveChangeRequestsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveChangeRequestsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface GetCommentsDataOptions {
  commentable?: Commentable | CommentableOptions;
}

export function newGetCommentsData(data: GetCommentsDataOptions): GetCommentsQuery {
  return {
    __typename: "Query" as const,
    commentable: maybeNew("Commentable", data["commentable"] || undefined, {}),
  } as any;
}

export function newGetCommentsResponse(
  variables: GetCommentsQueryVariables,
  data: GetCommentsDataOptions | Error,
): MockedResponse<GetCommentsQueryVariables, GetCommentsQuery> {
  return {
    request: { query: GetCommentsDocument, variables },
    result: { data: data instanceof Error ? undefined : newGetCommentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CommunicationChannelsDataOptions {
  communicationChannels?: (CommunicationChannelDetail | CommunicationChannelDetailOptions)[];
}

export function newCommunicationChannelsData(data: CommunicationChannelsDataOptions): CommunicationChannelsQuery {
  return {
    __typename: "Query" as const,
    communicationChannels: data["communicationChannels"]?.map((d) => newCommunicationChannelDetail(d)) || [],
  } as any;
}

export function newCommunicationChannelsResponse(
  data: CommunicationChannelsDataOptions | Error,
): MockedResponse<CommunicationChannelsQueryVariables, CommunicationChannelsQuery> {
  return {
    request: { query: CommunicationChannelsDocument },
    result: { data: data instanceof Error ? undefined : newCommunicationChannelsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface UserCommunicationPreferencesDataOptions {
  userCommunicationPreferences?: UserCommunicationPreference | UserCommunicationPreferenceOptions | null;
}

export function newUserCommunicationPreferencesData(
  data: UserCommunicationPreferencesDataOptions,
): UserCommunicationPreferencesQuery {
  return {
    __typename: "Query" as const,
    userCommunicationPreferences: maybeNewOrNull(
      "UserCommunicationPreference",
      data["userCommunicationPreferences"] || undefined,
      {},
    ),
  } as any;
}

export function newUserCommunicationPreferencesResponse(
  variables: UserCommunicationPreferencesQueryVariables,
  data: UserCommunicationPreferencesDataOptions | Error,
): MockedResponse<UserCommunicationPreferencesQueryVariables, UserCommunicationPreferencesQuery> {
  return {
    request: { query: UserCommunicationPreferencesDocument, variables },
    result: { data: data instanceof Error ? undefined : newUserCommunicationPreferencesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveUserCommunicationPreferenceDataOptions {
  saveUserCommunicationPreference?:
    | SaveUserCommunicationPreferenceResult
    | SaveUserCommunicationPreferenceResultOptions;
}

export function newSaveUserCommunicationPreferenceData(
  data: SaveUserCommunicationPreferenceDataOptions,
): SaveUserCommunicationPreferenceMutation {
  return {
    __typename: "Mutation" as const,
    saveUserCommunicationPreference: maybeNew(
      "SaveUserCommunicationPreferenceResult",
      data["saveUserCommunicationPreference"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveUserCommunicationPreferenceResponse(
  variables: SaveUserCommunicationPreferenceMutationVariables,
  data: SaveUserCommunicationPreferenceDataOptions | Error,
): MockedResponse<SaveUserCommunicationPreferenceMutationVariables, SaveUserCommunicationPreferenceMutation> {
  return {
    request: { query: SaveUserCommunicationPreferenceDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveUserCommunicationPreferenceData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DropModalMetadataDataOptions {
  costCodes?: (CostCode | CostCodeOptions)[];
  locations?: (Location | LocationOptions)[];
  globalPlanTasks?: GlobalPlanTasksPageResult | GlobalPlanTasksPageResultOptions;
  project?: Project | ProjectOptions;
  development?: Development | DevelopmentOptions;
}

export function newDropModalMetadataData(data: DropModalMetadataDataOptions): DropModalMetadataQuery {
  return {
    __typename: "Query" as const,
    costCodes: data["costCodes"]?.map((d) => newCostCode(d)) || [],
    locations: data["locations"]?.map((d) => newLocation(d)) || [],
    globalPlanTasks: maybeNew("GlobalPlanTasksPageResult", data["globalPlanTasks"] || undefined, {}),
    project: maybeNew("Project", data["project"] || undefined, {}),
    development: maybeNew("Development", data["development"] || undefined, {}),
  } as any;
}

export function newDropModalMetadataResponse(
  variables: DropModalMetadataQueryVariables,
  data: DropModalMetadataDataOptions | Error,
): MockedResponse<DropModalMetadataQueryVariables, DropModalMetadataQuery> {
  return {
    request: { query: DropModalMetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newDropModalMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveDropDataOptions {
  saveDrop?: SaveDropResult | SaveDropResultOptions;
}

export function newSaveDropData(data: SaveDropDataOptions): SaveDropMutation {
  return {
    __typename: "Mutation" as const,
    saveDrop: maybeNew("SaveDropResult", data["saveDrop"] || undefined, {}),
  } as any;
}

export function newSaveDropResponse(
  variables: SaveDropMutationVariables,
  data: SaveDropDataOptions | Error,
): MockedResponse<SaveDropMutationVariables, SaveDropMutation> {
  return {
    request: { query: SaveDropDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveDropData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PotentialInvoicesToCreditDataOptions {
  invoices?: (Invoice | InvoiceOptions)[];
}

export function newPotentialInvoicesToCreditData(
  data: PotentialInvoicesToCreditDataOptions,
): PotentialInvoicesToCreditQuery {
  return { __typename: "Query" as const, invoices: data["invoices"]?.map((d) => newInvoice(d)) || [] } as any;
}

export function newPotentialInvoicesToCreditResponse(
  variables: PotentialInvoicesToCreditQueryVariables,
  data: PotentialInvoicesToCreditDataOptions | Error,
): MockedResponse<PotentialInvoicesToCreditQueryVariables, PotentialInvoicesToCreditQuery> {
  return {
    request: { query: PotentialInvoicesToCreditDocument, variables },
    result: { data: data instanceof Error ? undefined : newPotentialInvoicesToCreditData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DropsPageDataOptions {
  drops?: (Drop | DropOptions)[];
}

export function newDropsPageData(data: DropsPageDataOptions): DropsPageQuery {
  return { __typename: "Query" as const, drops: data["drops"]?.map((d) => newDrop(d)) || [] } as any;
}

export function newDropsPageResponse(
  variables: DropsPageQueryVariables,
  data: DropsPageDataOptions | Error,
): MockedResponse<DropsPageQueryVariables, DropsPageQuery> {
  return {
    request: { query: DropsPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newDropsPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteDropDataOptions {
  deleteDrop?: EmptyResult | EmptyResultOptions;
}

export function newDeleteDropData(data: DeleteDropDataOptions): DeleteDropMutation {
  return {
    __typename: "Mutation" as const,
    deleteDrop: maybeNew("EmptyResult", data["deleteDrop"] || undefined, {}),
  } as any;
}

export function newDeleteDropResponse(
  variables: DeleteDropMutationVariables,
  data: DeleteDropDataOptions | Error,
): MockedResponse<DeleteDropMutationVariables, DeleteDropMutation> {
  return {
    request: { query: DeleteDropDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteDropData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface UpdateProjectCoverImageDataOptions {
  saveProject?: SaveProjectResult | SaveProjectResultOptions;
}

export function newUpdateProjectCoverImageData(
  data: UpdateProjectCoverImageDataOptions,
): UpdateProjectCoverImageMutation {
  return {
    __typename: "Mutation" as const,
    saveProject: maybeNew("SaveProjectResult", data["saveProject"] || undefined, {}),
  } as any;
}

export function newUpdateProjectCoverImageResponse(
  variables: UpdateProjectCoverImageMutationVariables,
  data: UpdateProjectCoverImageDataOptions | Error,
): MockedResponse<UpdateProjectCoverImageMutationVariables, UpdateProjectCoverImageMutation> {
  return {
    request: { query: UpdateProjectCoverImageDocument, variables },
    result: { data: data instanceof Error ? undefined : newUpdateProjectCoverImageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ToDoModalDataOptions {
  toDos?: (ToDo | ToDoOptions)[];
}

export function newToDoModalData(data: ToDoModalDataOptions): ToDoModalQuery {
  return { __typename: "Query" as const, toDos: data["toDos"]?.map((d) => newToDo(d)) || [] } as any;
}

export function newToDoModalResponse(
  variables: ToDoModalQueryVariables,
  data: ToDoModalDataOptions | Error,
): MockedResponse<ToDoModalQueryVariables, ToDoModalQuery> {
  return {
    request: { query: ToDoModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newToDoModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ToDoModalDataDataOptions {
  projects?: (Project | ProjectOptions)[];
  cohorts?: (Cohort | CohortOptions)[];
  developments?: (Development | DevelopmentOptions)[];
}

export function newToDoModalDataData(data: ToDoModalDataDataOptions): ToDoModalDataQuery {
  return {
    __typename: "Query" as const,
    projects: data["projects"]?.map((d) => maybeNew("Project", d, {})) || [],
    cohorts: data["cohorts"]?.map((d) => newCohort(d)) || [],
    developments: data["developments"]?.map((d) => newDevelopment(d)) || [],
  } as any;
}

export function newToDoModalDataResponse(
  data: ToDoModalDataDataOptions | Error,
): MockedResponse<ToDoModalDataQueryVariables, ToDoModalDataQuery> {
  return {
    request: { query: ToDoModalDataDocument },
    result: { data: data instanceof Error ? undefined : newToDoModalDataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveToDosDataOptions {
  saveToDos?: SaveToDosResult | SaveToDosResultOptions;
}

export function newSaveToDosData(data: SaveToDosDataOptions): SaveToDosMutation {
  return {
    __typename: "Mutation" as const,
    saveToDos: maybeNew("SaveToDosResult", data["saveToDos"] || undefined, {}),
  } as any;
}

export function newSaveToDosResponse(
  variables: SaveToDosMutationVariables,
  data: SaveToDosDataOptions | Error,
): MockedResponse<SaveToDosMutationVariables, SaveToDosMutation> {
  return {
    request: { query: SaveToDosDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveToDosData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteToDoDataOptions {
  deleteToDo?: EmptyResult | EmptyResultOptions;
}

export function newDeleteToDoData(data: DeleteToDoDataOptions): DeleteToDoMutation {
  return {
    __typename: "Mutation" as const,
    deleteToDo: maybeNew("EmptyResult", data["deleteToDo"] || undefined, {}),
  } as any;
}

export function newDeleteToDoResponse(
  variables: DeleteToDoMutationVariables,
  data: DeleteToDoDataOptions | Error,
): MockedResponse<DeleteToDoMutationVariables, DeleteToDoMutation> {
  return {
    request: { query: DeleteToDoDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteToDoData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ToDosDataOptions {
  toDos?: (ToDo | ToDoOptions)[];
}

export function newToDosData(data: ToDosDataOptions): ToDosQuery {
  return { __typename: "Query" as const, toDos: data["toDos"]?.map((d) => newToDo(d)) || [] } as any;
}

export function newToDosResponse(
  variables: ToDosQueryVariables,
  data: ToDosDataOptions | Error,
): MockedResponse<ToDosQueryVariables, ToDosQuery> {
  return {
    request: { query: ToDosDocument, variables },
    result: { data: data instanceof Error ? undefined : newToDosData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ToDoStatusesDataOptions {
  toDoStatuses?: (ToDoStatusDetail | ToDoStatusDetailOptions)[];
}

export function newToDoStatusesData(data: ToDoStatusesDataOptions): ToDoStatusesQuery {
  return {
    __typename: "Query" as const,
    toDoStatuses: data["toDoStatuses"]?.map((d) => newToDoStatusDetail(d)) || [],
  } as any;
}

export function newToDoStatusesResponse(
  data: ToDoStatusesDataOptions | Error,
): MockedResponse<ToDoStatusesQueryVariables, ToDoStatusesQuery> {
  return {
    request: { query: ToDoStatusesDocument },
    result: { data: data instanceof Error ? undefined : newToDoStatusesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ToDoTypesDataOptions {
  toDoTypes?: (ToDoTypeDetail | ToDoTypeDetailOptions)[];
}

export function newToDoTypesData(data: ToDoTypesDataOptions): ToDoTypesQuery {
  return { __typename: "Query" as const, toDoTypes: data["toDoTypes"]?.map((d) => newToDoTypeDetail(d)) || [] } as any;
}

export function newToDoTypesResponse(
  data: ToDoTypesDataOptions | Error,
): MockedResponse<ToDoTypesQueryVariables, ToDoTypesQuery> {
  return {
    request: { query: ToDoTypesDocument },
    result: { data: data instanceof Error ? undefined : newToDoTypesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MoveToDoDataOptions {
  saveToDos?: SaveToDosResult | SaveToDosResultOptions;
}

export function newMoveToDoData(data: MoveToDoDataOptions): MoveToDoMutation {
  return {
    __typename: "Mutation" as const,
    saveToDos: maybeNew("SaveToDosResult", data["saveToDos"] || undefined, {}),
  } as any;
}

export function newMoveToDoResponse(
  variables: MoveToDoMutationVariables,
  data: MoveToDoDataOptions | Error,
): MockedResponse<MoveToDoMutationVariables, MoveToDoMutation> {
  return {
    request: { query: MoveToDoDocument, variables },
    result: { data: data instanceof Error ? undefined : newMoveToDoData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateAssetUploadUrlDataOptions {
  createAssetUploadUrl?: CreateAssetUploadUrlResult | CreateAssetUploadUrlResultOptions;
}

export function newCreateAssetUploadUrlData(data: CreateAssetUploadUrlDataOptions): CreateAssetUploadUrlMutation {
  return {
    __typename: "Mutation" as const,
    createAssetUploadUrl: maybeNew("CreateAssetUploadUrlResult", data["createAssetUploadUrl"] || undefined, {}),
  } as any;
}

export function newCreateAssetUploadUrlResponse(
  variables: CreateAssetUploadUrlMutationVariables,
  data: CreateAssetUploadUrlDataOptions | Error,
): MockedResponse<CreateAssetUploadUrlMutationVariables, CreateAssetUploadUrlMutation> {
  return {
    request: { query: CreateAssetUploadUrlDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateAssetUploadUrlData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateDocumentPendingUploadDataOptions {
  createDocumentPendingUpload?: CreateDocumentPendingUploadResult | CreateDocumentPendingUploadResultOptions;
}

export function newCreateDocumentPendingUploadData(
  data: CreateDocumentPendingUploadDataOptions,
): CreateDocumentPendingUploadMutation {
  return {
    __typename: "Mutation" as const,
    createDocumentPendingUpload: maybeNew(
      "CreateDocumentPendingUploadResult",
      data["createDocumentPendingUpload"] || undefined,
      {},
    ),
  } as any;
}

export function newCreateDocumentPendingUploadResponse(
  variables: CreateDocumentPendingUploadMutationVariables,
  data: CreateDocumentPendingUploadDataOptions | Error,
): MockedResponse<CreateDocumentPendingUploadMutationVariables, CreateDocumentPendingUploadMutation> {
  return {
    request: { query: CreateDocumentPendingUploadDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateDocumentPendingUploadData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MarkDocumentAsUploadedDataOptions {
  markDocumentAsUploaded?: MarkDocumentAsUploadedResult | MarkDocumentAsUploadedResultOptions;
}

export function newMarkDocumentAsUploadedData(data: MarkDocumentAsUploadedDataOptions): MarkDocumentAsUploadedMutation {
  return {
    __typename: "Mutation" as const,
    markDocumentAsUploaded: maybeNew("MarkDocumentAsUploadedResult", data["markDocumentAsUploaded"] || undefined, {}),
  } as any;
}

export function newMarkDocumentAsUploadedResponse(
  variables: MarkDocumentAsUploadedMutationVariables,
  data: MarkDocumentAsUploadedDataOptions | Error,
): MockedResponse<MarkDocumentAsUploadedMutationVariables, MarkDocumentAsUploadedMutation> {
  return {
    request: { query: MarkDocumentAsUploadedDocument, variables },
    result: { data: data instanceof Error ? undefined : newMarkDocumentAsUploadedData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateAssetDataOptions {
  createAsset?: CreateAssetResult | CreateAssetResultOptions;
}

export function newCreateAssetData(data: CreateAssetDataOptions): CreateAssetMutation {
  return {
    __typename: "Mutation" as const,
    createAsset: maybeNew("CreateAssetResult", data["createAsset"] || undefined, {}),
  } as any;
}

export function newCreateAssetResponse(
  variables: CreateAssetMutationVariables,
  data: CreateAssetDataOptions | Error,
): MockedResponse<CreateAssetMutationVariables, CreateAssetMutation> {
  return {
    request: { query: CreateAssetDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateAssetData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidPackageDetailPageDataOptions {
  bidPackage?: BidPackage | BidPackageOptions;
}

export function newBidPackageDetailPageData(data: BidPackageDetailPageDataOptions): BidPackageDetailPageQuery {
  return {
    __typename: "Query" as const,
    bidPackage: maybeNew("BidPackage", data["bidPackage"] || undefined, {}),
  } as any;
}

export function newBidPackageDetailPageResponse(
  variables: BidPackageDetailPageQueryVariables,
  data: BidPackageDetailPageDataOptions | Error,
): MockedResponse<BidPackageDetailPageQueryVariables, BidPackageDetailPageQuery> {
  return {
    request: { query: BidPackageDetailPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newBidPackageDetailPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidPackageVersionDetailPageDataOptions {
  bidPackageVersion?: BidPackageVersion | BidPackageVersionOptions;
}

export function newBidPackageVersionDetailPageData(
  data: BidPackageVersionDetailPageDataOptions,
): BidPackageVersionDetailPageQuery {
  return {
    __typename: "Query" as const,
    bidPackageVersion: maybeNew("BidPackageVersion", data["bidPackageVersion"] || undefined, {}),
  } as any;
}

export function newBidPackageVersionDetailPageResponse(
  variables: BidPackageVersionDetailPageQueryVariables,
  data: BidPackageVersionDetailPageDataOptions | Error,
): MockedResponse<BidPackageVersionDetailPageQueryVariables, BidPackageVersionDetailPageQuery> {
  return {
    request: { query: BidPackageVersionDetailPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newBidPackageVersionDetailPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MaterialTypesDataOptions {
  materialTypes?: (MaterialTypeDetail | MaterialTypeDetailOptions)[];
}

export function newMaterialTypesData(data: MaterialTypesDataOptions): MaterialTypesQuery {
  return {
    __typename: "Query" as const,
    materialTypes: data["materialTypes"]?.map((d) => newMaterialTypeDetail(d)) || [],
  } as any;
}

export function newMaterialTypesResponse(
  data: MaterialTypesDataOptions | Error,
): MockedResponse<MaterialTypesQueryVariables, MaterialTypesQuery> {
  return {
    request: { query: MaterialTypesDocument },
    result: { data: data instanceof Error ? undefined : newMaterialTypesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillEditor_SaveBillDataOptions {
  saveBill?: SaveBillResult | SaveBillResultOptions;
}

export function newBillEditor_SaveBillData(data: BillEditor_SaveBillDataOptions): BillEditor_SaveBillMutation {
  return {
    __typename: "Mutation" as const,
    saveBill: maybeNew("SaveBillResult", data["saveBill"] || undefined, {}),
  } as any;
}

export function newBillEditor_SaveBillResponse(
  variables: BillEditor_SaveBillMutationVariables,
  data: BillEditor_SaveBillDataOptions | Error,
): MockedResponse<BillEditor_SaveBillMutationVariables, BillEditor_SaveBillMutation> {
  return {
    request: { query: BillEditor_SaveBillDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillEditor_SaveBillData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillEditor_CreateBillOcrDataOptions {
  createBillOcr?: CreateBillOcrResult | CreateBillOcrResultOptions;
}

export function newBillEditor_CreateBillOcrData(
  data: BillEditor_CreateBillOcrDataOptions,
): BillEditor_CreateBillOcrMutation {
  return {
    __typename: "Mutation" as const,
    createBillOcr: maybeNew("CreateBillOcrResult", data["createBillOcr"] || undefined, {}),
  } as any;
}

export function newBillEditor_CreateBillOcrResponse(
  variables: BillEditor_CreateBillOcrMutationVariables,
  data: BillEditor_CreateBillOcrDataOptions | Error,
): MockedResponse<BillEditor_CreateBillOcrMutationVariables, BillEditor_CreateBillOcrMutation> {
  return {
    request: { query: BillEditor_CreateBillOcrDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillEditor_CreateBillOcrData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillEditor_SaveChangeEventDataOptions {
  saveChangeEvent?: SaveChangeEventResult | SaveChangeEventResultOptions;
}

export function newBillEditor_SaveChangeEventData(
  data: BillEditor_SaveChangeEventDataOptions,
): BillEditor_SaveChangeEventMutation {
  return {
    __typename: "Mutation" as const,
    saveChangeEvent: maybeNew("SaveChangeEventResult", data["saveChangeEvent"] || undefined, {}),
  } as any;
}

export function newBillEditor_SaveChangeEventResponse(
  variables: BillEditor_SaveChangeEventMutationVariables,
  data: BillEditor_SaveChangeEventDataOptions | Error,
): MockedResponse<BillEditor_SaveChangeEventMutationVariables, BillEditor_SaveChangeEventMutation> {
  return {
    request: { query: BillEditor_SaveChangeEventDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillEditor_SaveChangeEventData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillEditor_CreateCommitmentDataOptions {
  createCommitmentFromBill?: CreateCommitmentFromBillResult | CreateCommitmentFromBillResultOptions;
}

export function newBillEditor_CreateCommitmentData(
  data: BillEditor_CreateCommitmentDataOptions,
): BillEditor_CreateCommitmentMutation {
  return {
    __typename: "Mutation" as const,
    createCommitmentFromBill: maybeNew(
      "CreateCommitmentFromBillResult",
      data["createCommitmentFromBill"] || undefined,
      {},
    ),
  } as any;
}

export function newBillEditor_CreateCommitmentResponse(
  variables: BillEditor_CreateCommitmentMutationVariables,
  data: BillEditor_CreateCommitmentDataOptions | Error,
): MockedResponse<BillEditor_CreateCommitmentMutationVariables, BillEditor_CreateCommitmentMutation> {
  return {
    request: { query: BillEditor_CreateCommitmentDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillEditor_CreateCommitmentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillEditor_CommitmentsDataOptions {
  commitments?: (Commitment | CommitmentOptions)[];
}

export function newBillEditor_CommitmentsData(data: BillEditor_CommitmentsDataOptions): BillEditor_CommitmentsQuery {
  return { __typename: "Query" as const, commitments: data["commitments"]?.map((d) => newCommitment(d)) || [] } as any;
}

export function newBillEditor_CommitmentsResponse(
  variables: BillEditor_CommitmentsQueryVariables,
  data: BillEditor_CommitmentsDataOptions | Error,
): MockedResponse<BillEditor_CommitmentsQueryVariables, BillEditor_CommitmentsQuery> {
  return {
    request: { query: BillEditor_CommitmentsDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillEditor_CommitmentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillEditor_ProjectItemsDataOptions {
  projectItems?: (ProjectItem | ProjectItemOptions)[];
}

export function newBillEditor_ProjectItemsData(data: BillEditor_ProjectItemsDataOptions): BillEditor_ProjectItemsQuery {
  return {
    __typename: "Query" as const,
    projectItems: data["projectItems"]?.map((d) => newProjectItem(d)) || [],
  } as any;
}

export function newBillEditor_ProjectItemsResponse(
  variables: BillEditor_ProjectItemsQueryVariables,
  data: BillEditor_ProjectItemsDataOptions | Error,
): MockedResponse<BillEditor_ProjectItemsQueryVariables, BillEditor_ProjectItemsQuery> {
  return {
    request: { query: BillEditor_ProjectItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillEditor_ProjectItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillEditor_CommitmentLikesDataOptions {
  commitment?: Commitment | CommitmentOptions;
  commitmentChangeOrder?: CommitmentChangeOrder | CommitmentChangeOrderOptions;
}

export function newBillEditor_CommitmentLikesData(
  data: BillEditor_CommitmentLikesDataOptions,
): BillEditor_CommitmentLikesQuery {
  return {
    __typename: "Query" as const,
    commitment: maybeNew("Commitment", data["commitment"] || undefined, {}),
    commitmentChangeOrder: maybeNew("CommitmentChangeOrder", data["commitmentChangeOrder"] || undefined, {}),
  } as any;
}

export function newBillEditor_CommitmentLikesResponse(
  variables: BillEditor_CommitmentLikesQueryVariables,
  data: BillEditor_CommitmentLikesDataOptions | Error,
): MockedResponse<BillEditor_CommitmentLikesQueryVariables, BillEditor_CommitmentLikesQuery> {
  return {
    request: { query: BillEditor_CommitmentLikesDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillEditor_CommitmentLikesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillEditor_BillDataOptions {
  bill?: Bill | BillOptions;
}

export function newBillEditor_BillData(data: BillEditor_BillDataOptions): BillEditor_BillQuery {
  return { __typename: "Query" as const, bill: maybeNew("Bill", data["bill"] || undefined, {}) } as any;
}

export function newBillEditor_BillResponse(
  variables: BillEditor_BillQueryVariables,
  data: BillEditor_BillDataOptions | Error,
): MockedResponse<BillEditor_BillQueryVariables, BillEditor_BillQuery> {
  return {
    request: { query: BillEditor_BillDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillEditor_BillData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillEditor_ReviewReasonsDetailsDataOptions {
  enumDetails?: AllEnumDetails | AllEnumDetailsOptions;
}

export function newBillEditor_ReviewReasonsDetailsData(
  data: BillEditor_ReviewReasonsDetailsDataOptions,
): BillEditor_ReviewReasonsDetailsQuery {
  return {
    __typename: "Query" as const,
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
  } as any;
}

export function newBillEditor_ReviewReasonsDetailsResponse(
  data: BillEditor_ReviewReasonsDetailsDataOptions | Error,
): MockedResponse<BillEditor_ReviewReasonsDetailsQueryVariables, BillEditor_ReviewReasonsDetailsQuery> {
  return {
    request: { query: BillEditor_ReviewReasonsDetailsDocument },
    result: { data: data instanceof Error ? undefined : newBillEditor_ReviewReasonsDetailsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillEditor_CalculateDueDateDataOptions {
  tradePartner?: TradePartner | TradePartnerOptions;
}

export function newBillEditor_CalculateDueDateData(
  data: BillEditor_CalculateDueDateDataOptions,
): BillEditor_CalculateDueDateQuery {
  return {
    __typename: "Query" as const,
    tradePartner: maybeNew("TradePartner", data["tradePartner"] || undefined, {}),
  } as any;
}

export function newBillEditor_CalculateDueDateResponse(
  variables: BillEditor_CalculateDueDateQueryVariables,
  data: BillEditor_CalculateDueDateDataOptions | Error,
): MockedResponse<BillEditor_CalculateDueDateQueryVariables, BillEditor_CalculateDueDateQuery> {
  return {
    request: { query: BillEditor_CalculateDueDateDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillEditor_CalculateDueDateData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillEditor_ProjectItemDataOptions {
  projectItem?: ProjectItem | ProjectItemOptions;
}

export function newBillEditor_ProjectItemData(data: BillEditor_ProjectItemDataOptions): BillEditor_ProjectItemQuery {
  return {
    __typename: "Query" as const,
    projectItem: maybeNew("ProjectItem", data["projectItem"] || undefined, {}),
  } as any;
}

export function newBillEditor_ProjectItemResponse(
  variables: BillEditor_ProjectItemQueryVariables,
  data: BillEditor_ProjectItemDataOptions | Error,
): MockedResponse<BillEditor_ProjectItemQueryVariables, BillEditor_ProjectItemQuery> {
  return {
    request: { query: BillEditor_ProjectItemDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillEditor_ProjectItemData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillDataOptions {
  currentInternalUser?: InternalUser | InternalUserOptions | null;
  bill?: Bill | BillOptions;
}

export function newBillData(data: BillDataOptions): BillQuery {
  return {
    __typename: "Query" as const,
    currentInternalUser: maybeNewOrNull("InternalUser", data["currentInternalUser"] || undefined, {}),
    bill: maybeNew("Bill", data["bill"] || undefined, {}),
  } as any;
}

export function newBillResponse(
  variables: BillQueryVariables,
  data: BillDataOptions | Error,
): MockedResponse<BillQueryVariables, BillQuery> {
  return {
    request: { query: BillDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillPageDataOptions {
  currentInternalUser?: InternalUser | InternalUserOptions | null;
  bill?: Bill | BillOptions;
}

export function newBillPageData(data: BillPageDataOptions): BillPageQuery {
  return {
    __typename: "Query" as const,
    currentInternalUser: maybeNewOrNull("InternalUser", data["currentInternalUser"] || undefined, {}),
    bill: maybeNew("Bill", data["bill"] || undefined, {}),
  } as any;
}

export function newBillPageResponse(
  variables: BillPageQueryVariables,
  data: BillPageDataOptions | Error,
): MockedResponse<BillPageQueryVariables, BillPageQuery> {
  return {
    request: { query: BillPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillPage_BillIntacctSyncErrorDataOptions {
  bill?: Bill | BillOptions;
}

export function newBillPage_BillIntacctSyncErrorData(
  data: BillPage_BillIntacctSyncErrorDataOptions,
): BillPage_BillIntacctSyncErrorQuery {
  return { __typename: "Query" as const, bill: maybeNew("Bill", data["bill"] || undefined, {}) } as any;
}

export function newBillPage_BillIntacctSyncErrorResponse(
  variables: BillPage_BillIntacctSyncErrorQueryVariables,
  data: BillPage_BillIntacctSyncErrorDataOptions | Error,
): MockedResponse<BillPage_BillIntacctSyncErrorQueryVariables, BillPage_BillIntacctSyncErrorQuery> {
  return {
    request: { query: BillPage_BillIntacctSyncErrorDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillPage_BillIntacctSyncErrorData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillPage_NewBillCommitmentDataDataOptions {
  commitment?: Commitment | CommitmentOptions;
}

export function newBillPage_NewBillCommitmentDataData(
  data: BillPage_NewBillCommitmentDataDataOptions,
): BillPage_NewBillCommitmentDataQuery {
  return {
    __typename: "Query" as const,
    commitment: maybeNew("Commitment", data["commitment"] || undefined, {}),
  } as any;
}

export function newBillPage_NewBillCommitmentDataResponse(
  variables: BillPage_NewBillCommitmentDataQueryVariables,
  data: BillPage_NewBillCommitmentDataDataOptions | Error,
): MockedResponse<BillPage_NewBillCommitmentDataQueryVariables, BillPage_NewBillCommitmentDataQuery> {
  return {
    request: { query: BillPage_NewBillCommitmentDataDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillPage_NewBillCommitmentDataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillPage_NewBillChangeOrderDataDataOptions {
  commitmentChangeOrder?: CommitmentChangeOrder | CommitmentChangeOrderOptions;
}

export function newBillPage_NewBillChangeOrderDataData(
  data: BillPage_NewBillChangeOrderDataDataOptions,
): BillPage_NewBillChangeOrderDataQuery {
  return {
    __typename: "Query" as const,
    commitmentChangeOrder: maybeNew("CommitmentChangeOrder", data["commitmentChangeOrder"] || undefined, {}),
  } as any;
}

export function newBillPage_NewBillChangeOrderDataResponse(
  variables: BillPage_NewBillChangeOrderDataQueryVariables,
  data: BillPage_NewBillChangeOrderDataDataOptions | Error,
): MockedResponse<BillPage_NewBillChangeOrderDataQueryVariables, BillPage_NewBillChangeOrderDataQuery> {
  return {
    request: { query: BillPage_NewBillChangeOrderDataDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillPage_NewBillChangeOrderDataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillPage_CommitmentIdByChangeOrderDataOptions {
  commitmentChangeOrder?: CommitmentChangeOrder | CommitmentChangeOrderOptions;
}

export function newBillPage_CommitmentIdByChangeOrderData(
  data: BillPage_CommitmentIdByChangeOrderDataOptions,
): BillPage_CommitmentIdByChangeOrderQuery {
  return {
    __typename: "Query" as const,
    commitmentChangeOrder: maybeNew("CommitmentChangeOrder", data["commitmentChangeOrder"] || undefined, {}),
  } as any;
}

export function newBillPage_CommitmentIdByChangeOrderResponse(
  variables: BillPage_CommitmentIdByChangeOrderQueryVariables,
  data: BillPage_CommitmentIdByChangeOrderDataOptions | Error,
): MockedResponse<BillPage_CommitmentIdByChangeOrderQueryVariables, BillPage_CommitmentIdByChangeOrderQuery> {
  return {
    request: { query: BillPage_CommitmentIdByChangeOrderDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillPage_CommitmentIdByChangeOrderData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillIntacctSyncErrorDataOptions {
  bill?: Bill | BillOptions;
}

export function newBillIntacctSyncErrorData(data: BillIntacctSyncErrorDataOptions): BillIntacctSyncErrorQuery {
  return { __typename: "Query" as const, bill: maybeNew("Bill", data["bill"] || undefined, {}) } as any;
}

export function newBillIntacctSyncErrorResponse(
  variables: BillIntacctSyncErrorQueryVariables,
  data: BillIntacctSyncErrorDataOptions | Error,
): MockedResponse<BillIntacctSyncErrorQueryVariables, BillIntacctSyncErrorQuery> {
  return {
    request: { query: BillIntacctSyncErrorDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillIntacctSyncErrorData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillPage_SaveBillDataOptions {
  saveBill?: SaveBillResult | SaveBillResultOptions;
}

export function newBillPage_SaveBillData(data: BillPage_SaveBillDataOptions): BillPage_SaveBillMutation {
  return {
    __typename: "Mutation" as const,
    saveBill: maybeNew("SaveBillResult", data["saveBill"] || undefined, {}),
  } as any;
}

export function newBillPage_SaveBillResponse(
  variables: BillPage_SaveBillMutationVariables,
  data: BillPage_SaveBillDataOptions | Error,
): MockedResponse<BillPage_SaveBillMutationVariables, BillPage_SaveBillMutation> {
  return {
    request: { query: BillPage_SaveBillDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillPage_SaveBillData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillPage_DeleteBillDataOptions {
  deleteBill?: EmptyResult | EmptyResultOptions;
}

export function newBillPage_DeleteBillData(data: BillPage_DeleteBillDataOptions): BillPage_DeleteBillMutation {
  return {
    __typename: "Mutation" as const,
    deleteBill: maybeNew("EmptyResult", data["deleteBill"] || undefined, {}),
  } as any;
}

export function newBillPage_DeleteBillResponse(
  variables: BillPage_DeleteBillMutationVariables,
  data: BillPage_DeleteBillDataOptions | Error,
): MockedResponse<BillPage_DeleteBillMutationVariables, BillPage_DeleteBillMutation> {
  return {
    request: { query: BillPage_DeleteBillDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillPage_DeleteBillData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillPage_SyncBillToIntacctDataOptions {
  syncBillToIntacct?: EmptyResult | EmptyResultOptions;
}

export function newBillPage_SyncBillToIntacctData(
  data: BillPage_SyncBillToIntacctDataOptions,
): BillPage_SyncBillToIntacctMutation {
  return {
    __typename: "Mutation" as const,
    syncBillToIntacct: maybeNew("EmptyResult", data["syncBillToIntacct"] || undefined, {}),
  } as any;
}

export function newBillPage_SyncBillToIntacctResponse(
  variables: BillPage_SyncBillToIntacctMutationVariables,
  data: BillPage_SyncBillToIntacctDataOptions | Error,
): MockedResponse<BillPage_SyncBillToIntacctMutationVariables, BillPage_SyncBillToIntacctMutation> {
  return {
    request: { query: BillPage_SyncBillToIntacctDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillPage_SyncBillToIntacctData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillPage_SaveApproverDataOptions {
  saveApprover?: SaveApproverResult | SaveApproverResultOptions;
}

export function newBillPage_SaveApproverData(data: BillPage_SaveApproverDataOptions): BillPage_SaveApproverMutation {
  return {
    __typename: "Mutation" as const,
    saveApprover: maybeNew("SaveApproverResult", data["saveApprover"] || undefined, {}),
  } as any;
}

export function newBillPage_SaveApproverResponse(
  variables: BillPage_SaveApproverMutationVariables,
  data: BillPage_SaveApproverDataOptions | Error,
): MockedResponse<BillPage_SaveApproverMutationVariables, BillPage_SaveApproverMutation> {
  return {
    request: { query: BillPage_SaveApproverDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillPage_SaveApproverData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveBillDataOptions {
  saveBill?: SaveBillResult | SaveBillResultOptions;
}

export function newSaveBillData(data: SaveBillDataOptions): SaveBillMutation {
  return {
    __typename: "Mutation" as const,
    saveBill: maybeNew("SaveBillResult", data["saveBill"] || undefined, {}),
  } as any;
}

export function newSaveBillResponse(
  variables: SaveBillMutationVariables,
  data: SaveBillDataOptions | Error,
): MockedResponse<SaveBillMutationVariables, SaveBillMutation> {
  return {
    request: { query: SaveBillDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveBillData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteBillDataOptions {
  deleteBill?: EmptyResult | EmptyResultOptions;
}

export function newDeleteBillData(data: DeleteBillDataOptions): DeleteBillMutation {
  return {
    __typename: "Mutation" as const,
    deleteBill: maybeNew("EmptyResult", data["deleteBill"] || undefined, {}),
  } as any;
}

export function newDeleteBillResponse(
  variables: DeleteBillMutationVariables,
  data: DeleteBillDataOptions | Error,
): MockedResponse<DeleteBillMutationVariables, DeleteBillMutation> {
  return {
    request: { query: DeleteBillDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteBillData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SyncBillToIntacctDataOptions {
  syncBillToIntacct?: EmptyResult | EmptyResultOptions;
}

export function newSyncBillToIntacctData(data: SyncBillToIntacctDataOptions): SyncBillToIntacctMutation {
  return {
    __typename: "Mutation" as const,
    syncBillToIntacct: maybeNew("EmptyResult", data["syncBillToIntacct"] || undefined, {}),
  } as any;
}

export function newSyncBillToIntacctResponse(
  variables: SyncBillToIntacctMutationVariables,
  data: SyncBillToIntacctDataOptions | Error,
): MockedResponse<SyncBillToIntacctMutationVariables, SyncBillToIntacctMutation> {
  return {
    request: { query: SyncBillToIntacctDocument, variables },
    result: { data: data instanceof Error ? undefined : newSyncBillToIntacctData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface FinancesPageSharedDataOptions {
  internalUsers?: (InternalUser | InternalUserOptions)[];
  markets?: (Market | MarketOptions)[];
  projects?: (Project | ProjectOptions)[];
  currentInternalUser?: InternalUser | InternalUserOptions | null;
  tradePartners?: (TradePartner | TradePartnerOptions)[];
  enumDetails?: AllEnumDetails | AllEnumDetailsOptions;
  customerOwnerEntities?: (CustomerOwnerEntity | CustomerOwnerEntityOptions)[];
}

export function newFinancesPageSharedData(data: FinancesPageSharedDataOptions): FinancesPageSharedQuery {
  return {
    __typename: "Query" as const,
    internalUsers: data["internalUsers"]?.map((d) => newInternalUser(d)) || [],
    markets: data["markets"]?.map((d) => newMarket(d)) || [],
    projects: data["projects"]?.map((d) => maybeNew("Project", d, {})) || [],
    currentInternalUser: maybeNewOrNull("InternalUser", data["currentInternalUser"] || undefined, {}),
    tradePartners: data["tradePartners"]?.map((d) => newTradePartner(d)) || [],
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
    customerOwnerEntities: data["customerOwnerEntities"]?.map((d) => newCustomerOwnerEntity(d)) || [],
  } as any;
}

export function newFinancesPageSharedResponse(
  data: FinancesPageSharedDataOptions | Error,
): MockedResponse<FinancesPageSharedQueryVariables, FinancesPageSharedQuery> {
  return {
    request: { query: FinancesPageSharedDocument },
    result: { data: data instanceof Error ? undefined : newFinancesPageSharedData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidPackagesPageMetadataDataOptions {
  projects?: (Project | ProjectOptions)[];
  costCodes?: (CostCode | CostCodeOptions)[];
}

export function newBidPackagesPageMetadataData(data: BidPackagesPageMetadataDataOptions): BidPackagesPageMetadataQuery {
  return {
    __typename: "Query" as const,
    projects: data["projects"]?.map((d) => maybeNew("Project", d, {})) || [],
    costCodes: data["costCodes"]?.map((d) => newCostCode(d)) || [],
  } as any;
}

export function newBidPackagesPageMetadataResponse(
  data: BidPackagesPageMetadataDataOptions | Error,
): MockedResponse<BidPackagesPageMetadataQueryVariables, BidPackagesPageMetadataQuery> {
  return {
    request: { query: BidPackagesPageMetadataDocument },
    result: { data: data instanceof Error ? undefined : newBidPackagesPageMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidPackageGroupsDataOptions {
  bidPackageGroups?: BidPackageGroupsPageResult | BidPackageGroupsPageResultOptions;
}

export function newBidPackageGroupsData(data: BidPackageGroupsDataOptions): BidPackageGroupsQuery {
  return {
    __typename: "Query" as const,
    bidPackageGroups: maybeNew("BidPackageGroupsPageResult", data["bidPackageGroups"] || undefined, {}),
  } as any;
}

export function newBidPackageGroupsResponse(
  variables: BidPackageGroupsQueryVariables,
  data: BidPackageGroupsDataOptions | Error,
): MockedResponse<BidPackageGroupsQueryVariables, BidPackageGroupsQuery> {
  return {
    request: { query: BidPackageGroupsDocument, variables },
    result: { data: data instanceof Error ? undefined : newBidPackageGroupsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteBidPackageDataOptions {
  deleteBidPackage?: EmptyResult | EmptyResultOptions;
}

export function newDeleteBidPackageData(data: DeleteBidPackageDataOptions): DeleteBidPackageMutation {
  return {
    __typename: "Mutation" as const,
    deleteBidPackage: maybeNew("EmptyResult", data["deleteBidPackage"] || undefined, {}),
  } as any;
}

export function newDeleteBidPackageResponse(
  variables: DeleteBidPackageMutationVariables,
  data: DeleteBidPackageDataOptions | Error,
): MockedResponse<DeleteBidPackageMutationVariables, DeleteBidPackageMutation> {
  return {
    request: { query: DeleteBidPackageDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteBidPackageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillsChartsDataOptions {
  billMetrics?: BillMetricsResult | BillMetricsResultOptions | null;
}

export function newBillsChartsData(data: BillsChartsDataOptions): BillsChartsQuery {
  return {
    __typename: "Query" as const,
    billMetrics: maybeNewOrNull("BillMetricsResult", data["billMetrics"] || undefined, {}),
  } as any;
}

export function newBillsChartsResponse(
  variables: BillsChartsQueryVariables,
  data: BillsChartsDataOptions | Error,
): MockedResponse<BillsChartsQueryVariables, BillsChartsQuery> {
  return {
    request: { query: BillsChartsDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillsChartsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillsDataOptions {
  billsPage?: BillsPage | BillsPageOptions;
  projects?: (Project | ProjectOptions)[];
  internalUsers?: (InternalUser | InternalUserOptions)[];
  markets?: (Market | MarketOptions)[];
  tradePartners?: (TradePartner | TradePartnerOptions)[];
}

export function newBillsData(data: BillsDataOptions): BillsQuery {
  return {
    __typename: "Query" as const,
    billsPage: maybeNew("BillsPage", data["billsPage"] || undefined, {}),
    projects: data["projects"]?.map((d) => maybeNew("Project", d, {})) || [],
    internalUsers: data["internalUsers"]?.map((d) => newInternalUser(d)) || [],
    markets: data["markets"]?.map((d) => newMarket(d)) || [],
    tradePartners: data["tradePartners"]?.map((d) => newTradePartner(d)) || [],
  } as any;
}

export function newBillsResponse(
  variables: BillsQueryVariables,
  data: BillsDataOptions | Error,
): MockedResponse<BillsQueryVariables, BillsQuery> {
  return {
    request: { query: BillsDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BulkAddItemCostCodesDataOptions {
  items?: (Item | ItemOptions)[];
}

export function newBulkAddItemCostCodesData(data: BulkAddItemCostCodesDataOptions): BulkAddItemCostCodesQuery {
  return { __typename: "Query" as const, items: data["items"]?.map((d) => newItem(d)) || [] } as any;
}

export function newBulkAddItemCostCodesResponse(
  data: BulkAddItemCostCodesDataOptions | Error,
): MockedResponse<BulkAddItemCostCodesQueryVariables, BulkAddItemCostCodesQuery> {
  return {
    request: { query: BulkAddItemCostCodesDocument },
    result: { data: data instanceof Error ? undefined : newBulkAddItemCostCodesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BulkAddProjectItemsDataOptions {
  project?: Project | ProjectOptions;
}

export function newBulkAddProjectItemsData(data: BulkAddProjectItemsDataOptions): BulkAddProjectItemsQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newBulkAddProjectItemsResponse(
  variables: BulkAddProjectItemsQueryVariables,
  data: BulkAddProjectItemsDataOptions | Error,
): MockedResponse<BulkAddProjectItemsQueryVariables, BulkAddProjectItemsQuery> {
  return {
    request: { query: BulkAddProjectItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newBulkAddProjectItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentCommitmentDataOptions {
  developmentCommitment?: DevelopmentCommitment | DevelopmentCommitmentOptions;
}

export function newDevelopmentCommitmentData(data: DevelopmentCommitmentDataOptions): DevelopmentCommitmentQuery {
  return {
    __typename: "Query" as const,
    developmentCommitment: maybeNew("DevelopmentCommitment", data["developmentCommitment"] || undefined, {}),
  } as any;
}

export function newDevelopmentCommitmentResponse(
  variables: DevelopmentCommitmentQueryVariables,
  data: DevelopmentCommitmentDataOptions | Error,
): MockedResponse<DevelopmentCommitmentQueryVariables, DevelopmentCommitmentQuery> {
  return {
    request: { query: DevelopmentCommitmentDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentCommitmentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SavePandaDocDataOptions {
  savePandaDoc?: SavePandaDocResult | SavePandaDocResultOptions;
}

export function newSavePandaDocData(data: SavePandaDocDataOptions): SavePandaDocMutation {
  return {
    __typename: "Mutation" as const,
    savePandaDoc: maybeNew("SavePandaDocResult", data["savePandaDoc"] || undefined, {}),
  } as any;
}

export function newSavePandaDocResponse(
  variables: SavePandaDocMutationVariables,
  data: SavePandaDocDataOptions | Error,
): MockedResponse<SavePandaDocMutationVariables, SavePandaDocMutation> {
  return {
    request: { query: SavePandaDocDocument, variables },
    result: { data: data instanceof Error ? undefined : newSavePandaDocData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteDevelopmentCommitmentDataOptions {
  deleteDevelopmentCommitment?: EmptyResult | EmptyResultOptions;
}

export function newDeleteDevelopmentCommitmentData(
  data: DeleteDevelopmentCommitmentDataOptions,
): DeleteDevelopmentCommitmentMutation {
  return {
    __typename: "Mutation" as const,
    deleteDevelopmentCommitment: maybeNew("EmptyResult", data["deleteDevelopmentCommitment"] || undefined, {}),
  } as any;
}

export function newDeleteDevelopmentCommitmentResponse(
  variables: DeleteDevelopmentCommitmentMutationVariables,
  data: DeleteDevelopmentCommitmentDataOptions | Error,
): MockedResponse<DeleteDevelopmentCommitmentMutationVariables, DeleteDevelopmentCommitmentMutation> {
  return {
    request: { query: DeleteDevelopmentCommitmentDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteDevelopmentCommitmentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentCommitmentsPageMetaDataDataOptions {
  commitmentStatuses?: (CommitmentStatusDetail | CommitmentStatusDetailOptions)[];
  markets?: (Market | MarketOptions)[];
}

export function newDevelopmentCommitmentsPageMetaDataData(
  data: DevelopmentCommitmentsPageMetaDataDataOptions,
): DevelopmentCommitmentsPageMetaDataQuery {
  return {
    __typename: "Query" as const,
    commitmentStatuses: data["commitmentStatuses"]?.map((d) => newCommitmentStatusDetail(d)) || [],
    markets: data["markets"]?.map((d) => newMarket(d)) || [],
  } as any;
}

export function newDevelopmentCommitmentsPageMetaDataResponse(
  data: DevelopmentCommitmentsPageMetaDataDataOptions | Error,
): MockedResponse<DevelopmentCommitmentsPageMetaDataQueryVariables, DevelopmentCommitmentsPageMetaDataQuery> {
  return {
    request: { query: DevelopmentCommitmentsPageMetaDataDocument },
    result: { data: data instanceof Error ? undefined : newDevelopmentCommitmentsPageMetaDataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentCommitmentsPageDataOptions {
  developmentCommitmentsPage?: DevelopmentCommitmentsPage | DevelopmentCommitmentsPageOptions;
}

export function newDevelopmentCommitmentsPageData(
  data: DevelopmentCommitmentsPageDataOptions,
): DevelopmentCommitmentsPageQuery {
  return {
    __typename: "Query" as const,
    developmentCommitmentsPage: maybeNew(
      "DevelopmentCommitmentsPage",
      data["developmentCommitmentsPage"] || undefined,
      {},
    ),
  } as any;
}

export function newDevelopmentCommitmentsPageResponse(
  variables: DevelopmentCommitmentsPageQueryVariables,
  data: DevelopmentCommitmentsPageDataOptions | Error,
): MockedResponse<DevelopmentCommitmentsPageQueryVariables, DevelopmentCommitmentsPageQuery> {
  return {
    request: { query: DevelopmentCommitmentsPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentCommitmentsPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ExpenseAdminTeamMemberProjectsDataOptions {
  myTeamMemberProjects?: (Project | ProjectOptions)[];
}

export function newExpenseAdminTeamMemberProjectsData(
  data: ExpenseAdminTeamMemberProjectsDataOptions,
): ExpenseAdminTeamMemberProjectsQuery {
  return {
    __typename: "Query" as const,
    myTeamMemberProjects: data["myTeamMemberProjects"]?.map((d) => maybeNew("Project", d, {})) || [],
  } as any;
}

export function newExpenseAdminTeamMemberProjectsResponse(
  data: ExpenseAdminTeamMemberProjectsDataOptions | Error,
): MockedResponse<ExpenseAdminTeamMemberProjectsQueryVariables, ExpenseAdminTeamMemberProjectsQuery> {
  return {
    request: { query: ExpenseAdminTeamMemberProjectsDocument },
    result: { data: data instanceof Error ? undefined : newExpenseAdminTeamMemberProjectsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentsPageMetadataDataOptions {
  markets?: (Market | MarketOptions)[];
}

export function newDevelopmentsPageMetadataData(
  data: DevelopmentsPageMetadataDataOptions,
): DevelopmentsPageMetadataQuery {
  return { __typename: "Query" as const, markets: data["markets"]?.map((d) => newMarket(d)) || [] } as any;
}

export function newDevelopmentsPageMetadataResponse(
  data: DevelopmentsPageMetadataDataOptions | Error,
): MockedResponse<DevelopmentsPageMetadataQueryVariables, DevelopmentsPageMetadataQuery> {
  return {
    request: { query: DevelopmentsPageMetadataDocument },
    result: { data: data instanceof Error ? undefined : newDevelopmentsPageMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentsDataOptions {
  developments?: (Development | DevelopmentOptions)[];
}

export function newDevelopmentsData(data: DevelopmentsDataOptions): DevelopmentsQuery {
  return {
    __typename: "Query" as const,
    developments: data["developments"]?.map((d) => newDevelopment(d)) || [],
  } as any;
}

export function newDevelopmentsResponse(
  variables: DevelopmentsQueryVariables,
  data: DevelopmentsDataOptions | Error,
): MockedResponse<DevelopmentsQueryVariables, DevelopmentsQuery> {
  return {
    request: { query: DevelopmentsDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentDetailDataOptions {
  development?: Development | DevelopmentOptions;
  internalUsers?: (InternalUser | InternalUserOptions)[];
  scheduleTasks?: (ScheduleTask | ScheduleTaskOptions)[];
  schedules?: (Schedule | ScheduleOptions)[];
}

export function newDevelopmentDetailData(data: DevelopmentDetailDataOptions): DevelopmentDetailQuery {
  return {
    __typename: "Query" as const,
    development: maybeNew("Development", data["development"] || undefined, {}),
    internalUsers: data["internalUsers"]?.map((d) => newInternalUser(d)) || [],
    scheduleTasks: data["scheduleTasks"]?.map((d) => newScheduleTask(d)) || [],
    schedules: data["schedules"]?.map((d) => newSchedule(d)) || [],
  } as any;
}

export function newDevelopmentDetailResponse(
  variables: DevelopmentDetailQueryVariables,
  data: DevelopmentDetailDataOptions | Error,
): MockedResponse<DevelopmentDetailQueryVariables, DevelopmentDetailQuery> {
  return {
    request: { query: DevelopmentDetailDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentDetailData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveDevelopmentsDataOptions {
  saveDevelopments?: SaveDevelopmentsResult | SaveDevelopmentsResultOptions;
}

export function newSaveDevelopmentsData(data: SaveDevelopmentsDataOptions): SaveDevelopmentsMutation {
  return {
    __typename: "Mutation" as const,
    saveDevelopments: maybeNew("SaveDevelopmentsResult", data["saveDevelopments"] || undefined, {}),
  } as any;
}

export function newSaveDevelopmentsResponse(
  variables: SaveDevelopmentsMutationVariables,
  data: SaveDevelopmentsDataOptions | Error,
): MockedResponse<SaveDevelopmentsMutationVariables, SaveDevelopmentsMutation> {
  return {
    request: { query: SaveDevelopmentsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveDevelopmentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentAllLotsDataOptions {
  development?: Development | DevelopmentOptions;
  cohorts?: (Cohort | CohortOptions)[];
}

export function newDevelopmentAllLotsData(data: DevelopmentAllLotsDataOptions): DevelopmentAllLotsQuery {
  return {
    __typename: "Query" as const,
    development: maybeNew("Development", data["development"] || undefined, {}),
    cohorts: data["cohorts"]?.map((d) => newCohort(d)) || [],
  } as any;
}

export function newDevelopmentAllLotsResponse(
  variables: DevelopmentAllLotsQueryVariables,
  data: DevelopmentAllLotsDataOptions | Error,
): MockedResponse<DevelopmentAllLotsQueryVariables, DevelopmentAllLotsQuery> {
  return {
    request: { query: DevelopmentAllLotsDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentAllLotsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface InboxPageMetaDataOptions {
  currentInternalUser?: InternalUser | InternalUserOptions | null;
  internalUsers?: (InternalUser | InternalUserOptions)[];
  developments?: (Development | DevelopmentOptions)[];
}

export function newInboxPageMetaData(data: InboxPageMetaDataOptions): InboxPageMetaQuery {
  return {
    __typename: "Query" as const,
    currentInternalUser: maybeNewOrNull("InternalUser", data["currentInternalUser"] || undefined, {}),
    internalUsers: data["internalUsers"]?.map((d) => newInternalUser(d)) || [],
    developments: data["developments"]?.map((d) => newDevelopment(d)) || [],
  } as any;
}

export function newInboxPageMetaResponse(
  data: InboxPageMetaDataOptions | Error,
): MockedResponse<InboxPageMetaQueryVariables, InboxPageMetaQuery> {
  return {
    request: { query: InboxPageMetaDocument },
    result: { data: data instanceof Error ? undefined : newInboxPageMetaData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CommentStreamDataOptions {
  commentStream?: CommentStream | CommentStreamOptions | null;
}

export function newCommentStreamData(data: CommentStreamDataOptions): CommentStreamQuery {
  return {
    __typename: "Query" as const,
    commentStream: maybeNewOrNull("CommentStream", data["commentStream"] || undefined, {}),
  } as any;
}

export function newCommentStreamResponse(
  variables: CommentStreamQueryVariables,
  data: CommentStreamDataOptions | Error,
): MockedResponse<CommentStreamQueryVariables, CommentStreamQuery> {
  return {
    request: { query: CommentStreamDocument, variables },
    result: { data: data instanceof Error ? undefined : newCommentStreamData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface UserRelevantCommentStreamsDataOptions {
  userRelevantCommentStreamsPaged?: UserRelevantCommentStreamsResult | UserRelevantCommentStreamsResultOptions;
}

export function newUserRelevantCommentStreamsData(
  data: UserRelevantCommentStreamsDataOptions,
): UserRelevantCommentStreamsQuery {
  return {
    __typename: "Query" as const,
    userRelevantCommentStreamsPaged: maybeNew(
      "UserRelevantCommentStreamsResult",
      data["userRelevantCommentStreamsPaged"] || undefined,
      {},
    ),
  } as any;
}

export function newUserRelevantCommentStreamsResponse(
  variables: UserRelevantCommentStreamsQueryVariables,
  data: UserRelevantCommentStreamsDataOptions | Error,
): MockedResponse<UserRelevantCommentStreamsQueryVariables, UserRelevantCommentStreamsQuery> {
  return {
    request: { query: UserRelevantCommentStreamsDocument, variables },
    result: { data: data instanceof Error ? undefined : newUserRelevantCommentStreamsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface InvoicesPageDataOptions {
  invoicesPage?: InvoicesPage | InvoicesPageOptions;
}

export function newInvoicesPageData(data: InvoicesPageDataOptions): InvoicesPageQuery {
  return {
    __typename: "Query" as const,
    invoicesPage: maybeNew("InvoicesPage", data["invoicesPage"] || undefined, {}),
  } as any;
}

export function newInvoicesPageResponse(
  variables: InvoicesPageQueryVariables,
  data: InvoicesPageDataOptions | Error,
): MockedResponse<InvoicesPageQueryVariables, InvoicesPageQuery> {
  return {
    request: { query: InvoicesPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newInvoicesPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface LienWaiversPageDataOptions {
  lienWaiversPage?: LienWaiversPage | LienWaiversPageOptions;
}

export function newLienWaiversPageData(data: LienWaiversPageDataOptions): LienWaiversPageQuery {
  return {
    __typename: "Query" as const,
    lienWaiversPage: maybeNew("LienWaiversPage", data["lienWaiversPage"] || undefined, {}),
  } as any;
}

export function newLienWaiversPageResponse(
  variables: LienWaiversPageQueryVariables,
  data: LienWaiversPageDataOptions | Error,
): MockedResponse<LienWaiversPageQueryVariables, LienWaiversPageQuery> {
  return {
    request: { query: LienWaiversPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newLienWaiversPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveLienWaiverDataOptions {
  saveLienWaiver?: SaveLienWaiverResult | SaveLienWaiverResultOptions;
}

export function newSaveLienWaiverData(data: SaveLienWaiverDataOptions): SaveLienWaiverMutation {
  return {
    __typename: "Mutation" as const,
    saveLienWaiver: maybeNew("SaveLienWaiverResult", data["saveLienWaiver"] || undefined, {}),
  } as any;
}

export function newSaveLienWaiverResponse(
  variables: SaveLienWaiverMutationVariables,
  data: SaveLienWaiverDataOptions | Error,
): MockedResponse<SaveLienWaiverMutationVariables, SaveLienWaiverMutation> {
  return {
    request: { query: SaveLienWaiverDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveLienWaiverData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TemplatesDataOptions {
  itemTemplates?: (ItemTemplate | ItemTemplateOptions)[];
}

export function newTemplatesData(data: TemplatesDataOptions): TemplatesQuery {
  return {
    __typename: "Query" as const,
    itemTemplates: data["itemTemplates"]?.map((d) => newItemTemplate(d)) || [],
  } as any;
}

export function newTemplatesResponse(
  data: TemplatesDataOptions | Error,
): MockedResponse<TemplatesQueryVariables, TemplatesQuery> {
  return {
    request: { query: TemplatesDocument },
    result: { data: data instanceof Error ? undefined : newTemplatesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface GlobalSearchModalDataOptions {
  globalSearch?: (GlobalSearchResult | GlobalSearchResultOptions)[];
}

export function newGlobalSearchModalData(data: GlobalSearchModalDataOptions): GlobalSearchModalQuery {
  return {
    __typename: "Query" as const,
    globalSearch: data["globalSearch"]?.map((d) => newGlobalSearchResult(d)) || [],
  } as any;
}

export function newGlobalSearchModalResponse(
  variables: GlobalSearchModalQueryVariables,
  data: GlobalSearchModalDataOptions | Error,
): MockedResponse<GlobalSearchModalQueryVariables, GlobalSearchModalQuery> {
  return {
    request: { query: GlobalSearchModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newGlobalSearchModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface EstimateExportPageDataOptions {
  projectEstimate?: Estimate | EstimateOptions;
}

export function newEstimateExportPageData(data: EstimateExportPageDataOptions): EstimateExportPageQuery {
  return {
    __typename: "Query" as const,
    projectEstimate: maybeNew("Estimate", data["projectEstimate"] || undefined, {}),
  } as any;
}

export function newEstimateExportPageResponse(
  variables: EstimateExportPageQueryVariables,
  data: EstimateExportPageDataOptions | Error,
): MockedResponse<EstimateExportPageQueryVariables, EstimateExportPageQuery> {
  return {
    request: { query: EstimateExportPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newEstimateExportPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface HomeownerChangeOrderDataOptions {
  projectEstimate?: Estimate | EstimateOptions;
}

export function newHomeownerChangeOrderData(data: HomeownerChangeOrderDataOptions): HomeownerChangeOrderQuery {
  return {
    __typename: "Query" as const,
    projectEstimate: maybeNew("Estimate", data["projectEstimate"] || undefined, {}),
  } as any;
}

export function newHomeownerChangeOrderResponse(
  variables: HomeownerChangeOrderQueryVariables,
  data: HomeownerChangeOrderDataOptions | Error,
): MockedResponse<HomeownerChangeOrderQueryVariables, HomeownerChangeOrderQuery> {
  return {
    request: { query: HomeownerChangeOrderDocument, variables },
    result: { data: data instanceof Error ? undefined : newHomeownerChangeOrderData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PersonalDashboardsPageDataOptions {
  internalUsers?: (InternalUser | InternalUserOptions)[];
  cohorts?: (Cohort | CohortOptions)[];
  developments?: (Development | DevelopmentOptions)[];
  markets?: (Market | MarketOptions)[];
  userEventParentTypes?: (UserEventParentType | UserEventParentTypeOptions)[];
  currentInternalUser?: InternalUser | InternalUserOptions | null;
}

export function newPersonalDashboardsPageData(data: PersonalDashboardsPageDataOptions): PersonalDashboardsPageQuery {
  return {
    __typename: "Query" as const,
    internalUsers: data["internalUsers"]?.map((d) => newInternalUser(d)) || [],
    cohorts: data["cohorts"]?.map((d) => newCohort(d)) || [],
    developments: data["developments"]?.map((d) => newDevelopment(d)) || [],
    markets: data["markets"]?.map((d) => newMarket(d)) || [],
    userEventParentTypes: data["userEventParentTypes"]?.map((d) => newUserEventParentType(d)) || [],
    currentInternalUser: maybeNewOrNull("InternalUser", data["currentInternalUser"] || undefined, {}),
  } as any;
}

export function newPersonalDashboardsPageResponse(
  data: PersonalDashboardsPageDataOptions | Error,
): MockedResponse<PersonalDashboardsPageQueryVariables, PersonalDashboardsPageQuery> {
  return {
    request: { query: PersonalDashboardsPageDocument },
    result: { data: data instanceof Error ? undefined : newPersonalDashboardsPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AssignedToDosDataOptions {
  toDos?: (ToDo | ToDoOptions)[];
}

export function newAssignedToDosData(data: AssignedToDosDataOptions): AssignedToDosQuery {
  return { __typename: "Query" as const, toDos: data["toDos"]?.map((d) => newToDo(d)) || [] } as any;
}

export function newAssignedToDosResponse(
  variables: AssignedToDosQueryVariables,
  data: AssignedToDosDataOptions | Error,
): MockedResponse<AssignedToDosQueryVariables, AssignedToDosQuery> {
  return {
    request: { query: AssignedToDosDocument, variables },
    result: { data: data instanceof Error ? undefined : newAssignedToDosData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TeamMembersProjectsDataOptions {
  projects?: (Project | ProjectOptions)[];
}

export function newTeamMembersProjectsData(data: TeamMembersProjectsDataOptions): TeamMembersProjectsQuery {
  return {
    __typename: "Query" as const,
    projects: data["projects"]?.map((d) => maybeNew("Project", d, {})) || [],
  } as any;
}

export function newTeamMembersProjectsResponse(
  variables: TeamMembersProjectsQueryVariables,
  data: TeamMembersProjectsDataOptions | Error,
): MockedResponse<TeamMembersProjectsQueryVariables, TeamMembersProjectsQuery> {
  return {
    request: { query: TeamMembersProjectsDocument, variables },
    result: { data: data instanceof Error ? undefined : newTeamMembersProjectsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PdfProjectItemsDataOptions {
  projectItems?: (ProjectItem | ProjectItemOptions)[];
}

export function newPdfProjectItemsData(data: PdfProjectItemsDataOptions): PdfProjectItemsQuery {
  return {
    __typename: "Query" as const,
    projectItems: data["projectItems"]?.map((d) => newProjectItem(d)) || [],
  } as any;
}

export function newPdfProjectItemsResponse(
  variables: PdfProjectItemsQueryVariables,
  data: PdfProjectItemsDataOptions | Error,
): MockedResponse<PdfProjectItemsQueryVariables, PdfProjectItemsQuery> {
  return {
    request: { query: PdfProjectItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newPdfProjectItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TradeScopeOfWorkDataOptions {
  changeEventLineItems?: (ChangeEventLineItem | ChangeEventLineItemOptions)[];
}

export function newTradeScopeOfWorkData(data: TradeScopeOfWorkDataOptions): TradeScopeOfWorkQuery {
  return {
    __typename: "Query" as const,
    changeEventLineItems: data["changeEventLineItems"]?.map((d) => newChangeEventLineItem(d)) || [],
  } as any;
}

export function newTradeScopeOfWorkResponse(
  variables: TradeScopeOfWorkQueryVariables,
  data: TradeScopeOfWorkDataOptions | Error,
): MockedResponse<TradeScopeOfWorkQueryVariables, TradeScopeOfWorkQuery> {
  return {
    request: { query: TradeScopeOfWorkDocument, variables },
    result: { data: data instanceof Error ? undefined : newTradeScopeOfWorkData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CurrentUserDataOptions {
  currentUser?: User | UserOptions | null;
}

export function newCurrentUserData(data: CurrentUserDataOptions): CurrentUserQuery {
  return {
    __typename: "Query" as const,
    currentUser: maybeNewOrNull("User", data["currentUser"] || undefined, {}),
  } as any;
}

export function newCurrentUserResponse(
  data: CurrentUserDataOptions | Error,
): MockedResponse<CurrentUserQueryVariables, CurrentUserQuery> {
  return {
    request: { query: CurrentUserDocument },
    result: { data: data instanceof Error ? undefined : newCurrentUserData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectHeaderDataOptions {
  project?: Project | ProjectOptions;
}

export function newProjectHeaderData(data: ProjectHeaderDataOptions): ProjectHeaderQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newProjectHeaderResponse(
  variables: ProjectHeaderQueryVariables,
  data: ProjectHeaderDataOptions | Error,
): MockedResponse<ProjectHeaderQueryVariables, ProjectHeaderQuery> {
  return {
    request: { query: ProjectHeaderDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectHeaderData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectLayoutDataOptions {
  project?: Project | ProjectOptions;
}

export function newProjectLayoutData(data: ProjectLayoutDataOptions): ProjectLayoutQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newProjectLayoutResponse(
  variables: ProjectLayoutQueryVariables,
  data: ProjectLayoutDataOptions | Error,
): MockedResponse<ProjectLayoutQueryVariables, ProjectLayoutQuery> {
  return {
    request: { query: ProjectLayoutDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectLayoutData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectsPageMetadataDataOptions {
  internalUsers?: (InternalUser | InternalUserOptions)[];
  markets?: (Market | MarketOptions)[];
  currentInternalUser?: InternalUser | InternalUserOptions | null;
  cohorts?: (Cohort | CohortOptions)[];
  developments?: (Development | DevelopmentOptions)[];
  communities?: (Project | ProjectOptions)[];
}

export function newProjectsPageMetadataData(data: ProjectsPageMetadataDataOptions): ProjectsPageMetadataQuery {
  return {
    __typename: "Query" as const,
    internalUsers: data["internalUsers"]?.map((d) => newInternalUser(d)) || [],
    markets: data["markets"]?.map((d) => newMarket(d)) || [],
    currentInternalUser: maybeNewOrNull("InternalUser", data["currentInternalUser"] || undefined, {}),
    cohorts: data["cohorts"]?.map((d) => newCohort(d)) || [],
    developments: data["developments"]?.map((d) => newDevelopment(d)) || [],
    communities: data["communities"]?.map((d) => maybeNew("Project", d, {})) || [],
  } as any;
}

export function newProjectsPageMetadataResponse(
  data: ProjectsPageMetadataDataOptions | Error,
): MockedResponse<ProjectsPageMetadataQueryVariables, ProjectsPageMetadataQuery> {
  return {
    request: { query: ProjectsPageMetadataDocument },
    result: { data: data instanceof Error ? undefined : newProjectsPageMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectsPageProjectsDataOptions {
  projectsPage?: ProjectsPageResult | ProjectsPageResultOptions;
}

export function newProjectsPageProjectsData(data: ProjectsPageProjectsDataOptions): ProjectsPageProjectsQuery {
  return {
    __typename: "Query" as const,
    projectsPage: maybeNew("ProjectsPageResult", data["projectsPage"] || undefined, {}),
  } as any;
}

export function newProjectsPageProjectsResponse(
  variables: ProjectsPageProjectsQueryVariables,
  data: ProjectsPageProjectsDataOptions | Error,
): MockedResponse<ProjectsPageProjectsQueryVariables, ProjectsPageProjectsQuery> {
  return {
    request: { query: ProjectsPageProjectsDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectsPageProjectsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface GetTradeCategoriesDataOptions {
  tradeCategories?: (TradeCategory | TradeCategoryOptions)[];
}

export function newGetTradeCategoriesData(data: GetTradeCategoriesDataOptions): GetTradeCategoriesQuery {
  return {
    __typename: "Query" as const,
    tradeCategories: data["tradeCategories"]?.map((d) => newTradeCategory(d)) || [],
  } as any;
}

export function newGetTradeCategoriesResponse(
  data: GetTradeCategoriesDataOptions | Error,
): MockedResponse<GetTradeCategoriesQueryVariables, GetTradeCategoriesQuery> {
  return {
    request: { query: GetTradeCategoriesDocument },
    result: { data: data instanceof Error ? undefined : newGetTradeCategoriesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface GetTradeCategoryDataOptions {
  tradeCategory?: TradeCategory | TradeCategoryOptions;
}

export function newGetTradeCategoryData(data: GetTradeCategoryDataOptions): GetTradeCategoryQuery {
  return {
    __typename: "Query" as const,
    tradeCategory: maybeNew("TradeCategory", data["tradeCategory"] || undefined, {}),
  } as any;
}

export function newGetTradeCategoryResponse(
  variables: GetTradeCategoryQueryVariables,
  data: GetTradeCategoryDataOptions | Error,
): MockedResponse<GetTradeCategoryQueryVariables, GetTradeCategoryQuery> {
  return {
    request: { query: GetTradeCategoryDocument, variables },
    result: { data: data instanceof Error ? undefined : newGetTradeCategoryData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveTradeCategoryDataOptions {
  saveTradeCategory?: SaveTradeCategoryResult | SaveTradeCategoryResultOptions;
}

export function newSaveTradeCategoryData(data: SaveTradeCategoryDataOptions): SaveTradeCategoryMutation {
  return {
    __typename: "Mutation" as const,
    saveTradeCategory: maybeNew("SaveTradeCategoryResult", data["saveTradeCategory"] || undefined, {}),
  } as any;
}

export function newSaveTradeCategoryResponse(
  variables: SaveTradeCategoryMutationVariables,
  data: SaveTradeCategoryDataOptions | Error,
): MockedResponse<SaveTradeCategoryMutationVariables, SaveTradeCategoryMutation> {
  return {
    request: { query: SaveTradeCategoryDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveTradeCategoryData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TradePartnerCommitmentsDataOptions {
  commitmentsPage?: CommitmentsPage | CommitmentsPageOptions;
}

export function newTradePartnerCommitmentsData(data: TradePartnerCommitmentsDataOptions): TradePartnerCommitmentsQuery {
  return {
    __typename: "Query" as const,
    commitmentsPage: maybeNew("CommitmentsPage", data["commitmentsPage"] || undefined, {}),
  } as any;
}

export function newTradePartnerCommitmentsResponse(
  variables: TradePartnerCommitmentsQueryVariables,
  data: TradePartnerCommitmentsDataOptions | Error,
): MockedResponse<TradePartnerCommitmentsQueryVariables, TradePartnerCommitmentsQuery> {
  return {
    request: { query: TradePartnerCommitmentsDocument, variables },
    result: { data: data instanceof Error ? undefined : newTradePartnerCommitmentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TradePartnerCommitmentsMetadataDataOptions {
  costCodes?: (CostCode | CostCodeOptions)[];
  projects?: (Project | ProjectOptions)[];
  commitmentStatuses?: (CommitmentStatusDetail | CommitmentStatusDetailOptions)[];
}

export function newTradePartnerCommitmentsMetadataData(
  data: TradePartnerCommitmentsMetadataDataOptions,
): TradePartnerCommitmentsMetadataQuery {
  return {
    __typename: "Query" as const,
    costCodes: data["costCodes"]?.map((d) => newCostCode(d)) || [],
    projects: data["projects"]?.map((d) => maybeNew("Project", d, {})) || [],
    commitmentStatuses: data["commitmentStatuses"]?.map((d) => newCommitmentStatusDetail(d)) || [],
  } as any;
}

export function newTradePartnerCommitmentsMetadataResponse(
  variables: TradePartnerCommitmentsMetadataQueryVariables,
  data: TradePartnerCommitmentsMetadataDataOptions | Error,
): MockedResponse<TradePartnerCommitmentsMetadataQueryVariables, TradePartnerCommitmentsMetadataQuery> {
  return {
    request: { query: TradePartnerCommitmentsMetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newTradePartnerCommitmentsMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TradePartnerDetailsTabDataOptions {
  tradePartner?: TradePartner | TradePartnerOptions;
  markets?: (Market | MarketOptions)[];
  internalUsers?: (InternalUser | InternalUserOptions)[];
  tradeCategories?: (TradeCategory | TradeCategoryOptions)[];
  costCodes?: (CostCode | CostCodeOptions)[];
  paymentTerms?: (PaymentTerm | PaymentTermOptions)[];
}

export function newTradePartnerDetailsTabData(data: TradePartnerDetailsTabDataOptions): TradePartnerDetailsTabQuery {
  return {
    __typename: "Query" as const,
    tradePartner: maybeNew("TradePartner", data["tradePartner"] || undefined, {}),
    markets: data["markets"]?.map((d) => newMarket(d)) || [],
    internalUsers: data["internalUsers"]?.map((d) => newInternalUser(d)) || [],
    tradeCategories: data["tradeCategories"]?.map((d) => newTradeCategory(d)) || [],
    costCodes: data["costCodes"]?.map((d) => newCostCode(d)) || [],
    paymentTerms: data["paymentTerms"]?.map((d) => newPaymentTerm(d)) || [],
  } as any;
}

export function newTradePartnerDetailsTabResponse(
  variables: TradePartnerDetailsTabQueryVariables,
  data: TradePartnerDetailsTabDataOptions | Error,
): MockedResponse<TradePartnerDetailsTabQueryVariables, TradePartnerDetailsTabQuery> {
  return {
    request: { query: TradePartnerDetailsTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newTradePartnerDetailsTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TradePartnerContactsDataOptions {
  tradePartners?: (TradePartner | TradePartnerOptions)[];
  markets?: (Market | MarketOptions)[];
}

export function newTradePartnerContactsData(data: TradePartnerContactsDataOptions): TradePartnerContactsQuery {
  return {
    __typename: "Query" as const,
    tradePartners: data["tradePartners"]?.map((d) => newTradePartner(d)) || [],
    markets: data["markets"]?.map((d) => newMarket(d)) || [],
  } as any;
}

export function newTradePartnerContactsResponse(
  variables: TradePartnerContactsQueryVariables,
  data: TradePartnerContactsDataOptions | Error,
): MockedResponse<TradePartnerContactsQueryVariables, TradePartnerContactsQuery> {
  return {
    request: { query: TradePartnerContactsDocument, variables },
    result: { data: data instanceof Error ? undefined : newTradePartnerContactsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveTradePartnerContactDataOptions {
  saveTradePartnerContact?: SaveTradePartnerContactResult | SaveTradePartnerContactResultOptions;
}

export function newSaveTradePartnerContactData(
  data: SaveTradePartnerContactDataOptions,
): SaveTradePartnerContactMutation {
  return {
    __typename: "Mutation" as const,
    saveTradePartnerContact: maybeNew(
      "SaveTradePartnerContactResult",
      data["saveTradePartnerContact"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveTradePartnerContactResponse(
  variables: SaveTradePartnerContactMutationVariables,
  data: SaveTradePartnerContactDataOptions | Error,
): MockedResponse<SaveTradePartnerContactMutationVariables, SaveTradePartnerContactMutation> {
  return {
    request: { query: SaveTradePartnerContactDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveTradePartnerContactData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteTradePartnerContactDataOptions {
  deleteTradePartnerContact?: DeleteTradePartnerContactResult | DeleteTradePartnerContactResultOptions;
}

export function newDeleteTradePartnerContactData(
  data: DeleteTradePartnerContactDataOptions,
): DeleteTradePartnerContactMutation {
  return {
    __typename: "Mutation" as const,
    deleteTradePartnerContact: maybeNew(
      "DeleteTradePartnerContactResult",
      data["deleteTradePartnerContact"] || undefined,
      {},
    ),
  } as any;
}

export function newDeleteTradePartnerContactResponse(
  variables: DeleteTradePartnerContactMutationVariables,
  data: DeleteTradePartnerContactDataOptions | Error,
): MockedResponse<DeleteTradePartnerContactMutationVariables, DeleteTradePartnerContactMutation> {
  return {
    request: { query: DeleteTradePartnerContactDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteTradePartnerContactData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveTradePartnerMarketContactDataOptions {
  saveTradePartnerMarketContact?: SaveTradePartnerMarketContactResult | SaveTradePartnerMarketContactResultOptions;
}

export function newSaveTradePartnerMarketContactData(
  data: SaveTradePartnerMarketContactDataOptions,
): SaveTradePartnerMarketContactMutation {
  return {
    __typename: "Mutation" as const,
    saveTradePartnerMarketContact: maybeNew(
      "SaveTradePartnerMarketContactResult",
      data["saveTradePartnerMarketContact"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveTradePartnerMarketContactResponse(
  variables: SaveTradePartnerMarketContactMutationVariables,
  data: SaveTradePartnerMarketContactDataOptions | Error,
): MockedResponse<SaveTradePartnerMarketContactMutationVariables, SaveTradePartnerMarketContactMutation> {
  return {
    request: { query: SaveTradePartnerMarketContactDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveTradePartnerMarketContactData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TradePartnerDevelopmentContractsDataOptions {
  tradePartners?: (TradePartner | TradePartnerOptions)[];
}

export function newTradePartnerDevelopmentContractsData(
  data: TradePartnerDevelopmentContractsDataOptions,
): TradePartnerDevelopmentContractsQuery {
  return {
    __typename: "Query" as const,
    tradePartners: data["tradePartners"]?.map((d) => newTradePartner(d)) || [],
  } as any;
}

export function newTradePartnerDevelopmentContractsResponse(
  variables: TradePartnerDevelopmentContractsQueryVariables,
  data: TradePartnerDevelopmentContractsDataOptions | Error,
): MockedResponse<TradePartnerDevelopmentContractsQueryVariables, TradePartnerDevelopmentContractsQuery> {
  return {
    request: { query: TradePartnerDevelopmentContractsDocument, variables },
    result: { data: data instanceof Error ? undefined : newTradePartnerDevelopmentContractsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveTradePartnerContactUserDataOptions {
  saveTradePartnerContact?: SaveTradePartnerContactResult | SaveTradePartnerContactResultOptions;
}

export function newSaveTradePartnerContactUserData(
  data: SaveTradePartnerContactUserDataOptions,
): SaveTradePartnerContactUserMutation {
  return {
    __typename: "Mutation" as const,
    saveTradePartnerContact: maybeNew(
      "SaveTradePartnerContactResult",
      data["saveTradePartnerContact"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveTradePartnerContactUserResponse(
  variables: SaveTradePartnerContactUserMutationVariables,
  data: SaveTradePartnerContactUserDataOptions | Error,
): MockedResponse<SaveTradePartnerContactUserMutationVariables, SaveTradePartnerContactUserMutation> {
  return {
    request: { query: SaveTradePartnerContactUserDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveTradePartnerContactUserData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TradePartnerPageDataOptions {
  tradePartner?: TradePartner | TradePartnerOptions;
}

export function newTradePartnerPageData(data: TradePartnerPageDataOptions): TradePartnerPageQuery {
  return {
    __typename: "Query" as const,
    tradePartner: maybeNew("TradePartner", data["tradePartner"] || undefined, {}),
  } as any;
}

export function newTradePartnerPageResponse(
  variables: TradePartnerPageQueryVariables,
  data: TradePartnerPageDataOptions | Error,
): MockedResponse<TradePartnerPageQueryVariables, TradePartnerPageQuery> {
  return {
    request: { query: TradePartnerPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newTradePartnerPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveTradePartnerDataOptions {
  saveTradePartner?: SaveTradePartnerResult | SaveTradePartnerResultOptions;
}

export function newSaveTradePartnerData(data: SaveTradePartnerDataOptions): SaveTradePartnerMutation {
  return {
    __typename: "Mutation" as const,
    saveTradePartner: maybeNew("SaveTradePartnerResult", data["saveTradePartner"] || undefined, {}),
  } as any;
}

export function newSaveTradePartnerResponse(
  variables: SaveTradePartnerMutationVariables,
  data: SaveTradePartnerDataOptions | Error,
): MockedResponse<SaveTradePartnerMutationVariables, SaveTradePartnerMutation> {
  return {
    request: { query: SaveTradePartnerDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveTradePartnerData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteTradePartnerDataOptions {
  deleteTradePartner?: EmptyResult | EmptyResultOptions;
}

export function newDeleteTradePartnerData(data: DeleteTradePartnerDataOptions): DeleteTradePartnerMutation {
  return {
    __typename: "Mutation" as const,
    deleteTradePartner: maybeNew("EmptyResult", data["deleteTradePartner"] || undefined, {}),
  } as any;
}

export function newDeleteTradePartnerResponse(
  variables: DeleteTradePartnerMutationVariables,
  data: DeleteTradePartnerDataOptions | Error,
): MockedResponse<DeleteTradePartnerMutationVariables, DeleteTradePartnerMutation> {
  return {
    request: { query: DeleteTradePartnerDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteTradePartnerData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TradePartnersMetadataDataOptions {
  markets?: (Market | MarketOptions)[];
  tradeCategories?: (TradeCategory | TradeCategoryOptions)[];
  developments?: (Development | DevelopmentOptions)[];
  cohorts?: (Cohort | CohortOptions)[];
}

export function newTradePartnersMetadataData(data: TradePartnersMetadataDataOptions): TradePartnersMetadataQuery {
  return {
    __typename: "Query" as const,
    markets: data["markets"]?.map((d) => newMarket(d)) || [],
    tradeCategories: data["tradeCategories"]?.map((d) => newTradeCategory(d)) || [],
    developments: data["developments"]?.map((d) => newDevelopment(d)) || [],
    cohorts: data["cohorts"]?.map((d) => newCohort(d)) || [],
  } as any;
}

export function newTradePartnersMetadataResponse(
  data: TradePartnersMetadataDataOptions | Error,
): MockedResponse<TradePartnersMetadataQueryVariables, TradePartnersMetadataQuery> {
  return {
    request: { query: TradePartnersMetadataDocument },
    result: { data: data instanceof Error ? undefined : newTradePartnersMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TradePartnersDataOptions {
  tradePartners?: (TradePartner | TradePartnerOptions)[];
}

export function newTradePartnersData(data: TradePartnersDataOptions): TradePartnersQuery {
  return {
    __typename: "Query" as const,
    tradePartners: data["tradePartners"]?.map((d) => newTradePartner(d)) || [],
  } as any;
}

export function newTradePartnersResponse(
  variables: TradePartnersQueryVariables,
  data: TradePartnersDataOptions | Error,
): MockedResponse<TradePartnersQueryVariables, TradePartnersQuery> {
  return {
    request: { query: TradePartnersDocument, variables },
    result: { data: data instanceof Error ? undefined : newTradePartnersData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TradePartnersPageDataOptions {
  tradePartnersPage?: TradePartnersPage | TradePartnersPageOptions;
}

export function newTradePartnersPageData(data: TradePartnersPageDataOptions): TradePartnersPageQuery {
  return {
    __typename: "Query" as const,
    tradePartnersPage: maybeNew("TradePartnersPage", data["tradePartnersPage"] || undefined, {}),
  } as any;
}

export function newTradePartnersPageResponse(
  variables: TradePartnersPageQueryVariables,
  data: TradePartnersPageDataOptions | Error,
): MockedResponse<TradePartnersPageQueryVariables, TradePartnersPageQuery> {
  return {
    request: { query: TradePartnersPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newTradePartnersPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TradePartnerRequirementsDataOptions {
  tradePartner?: TradePartner | TradePartnerOptions;
  tradePartnerRequirementTypes?: (TradePartnerRequirementTypeDetail | TradePartnerRequirementTypeDetailOptions)[];
  tradePartnerRequirementStatuses?:
    (TradePartnerRequirementStatusDetail | TradePartnerRequirementStatusDetailOptions)[];
}

export function newTradePartnerRequirementsData(
  data: TradePartnerRequirementsDataOptions,
): TradePartnerRequirementsQuery {
  return {
    __typename: "Query" as const,
    tradePartner: maybeNew("TradePartner", data["tradePartner"] || undefined, {}),
    tradePartnerRequirementTypes:
      data["tradePartnerRequirementTypes"]?.map((d) => newTradePartnerRequirementTypeDetail(d)) || [],
    tradePartnerRequirementStatuses:
      data["tradePartnerRequirementStatuses"]?.map((d) => newTradePartnerRequirementStatusDetail(d)) || [],
  } as any;
}

export function newTradePartnerRequirementsResponse(
  variables: TradePartnerRequirementsQueryVariables,
  data: TradePartnerRequirementsDataOptions | Error,
): MockedResponse<TradePartnerRequirementsQueryVariables, TradePartnerRequirementsQuery> {
  return {
    request: { query: TradePartnerRequirementsDocument, variables },
    result: { data: data instanceof Error ? undefined : newTradePartnerRequirementsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveTradePartnerRequirementDataOptions {
  saveTradePartnerRequirement?: SaveTradePartnerRequirementResult | SaveTradePartnerRequirementResultOptions;
}

export function newSaveTradePartnerRequirementData(
  data: SaveTradePartnerRequirementDataOptions,
): SaveTradePartnerRequirementMutation {
  return {
    __typename: "Mutation" as const,
    saveTradePartnerRequirement: maybeNew(
      "SaveTradePartnerRequirementResult",
      data["saveTradePartnerRequirement"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveTradePartnerRequirementResponse(
  variables: SaveTradePartnerRequirementMutationVariables,
  data: SaveTradePartnerRequirementDataOptions | Error,
): MockedResponse<SaveTradePartnerRequirementMutationVariables, SaveTradePartnerRequirementMutation> {
  return {
    request: { query: SaveTradePartnerRequirementDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveTradePartnerRequirementData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface WarrantyTicketFiltersDataOptions {
  warrantyTicketItemStatusesDetail?: (WarrantyTicketItemStatusDetail | WarrantyTicketItemStatusDetailOptions)[];
  warrantyTicketStatusesDetail?: (WarrantyTicketStatusDetail | WarrantyTicketStatusDetailOptions)[];
  markets?: (Market | MarketOptions)[];
  internalUsers?: (InternalUser | InternalUserOptions)[];
}

export function newWarrantyTicketFiltersData(data: WarrantyTicketFiltersDataOptions): WarrantyTicketFiltersQuery {
  return {
    __typename: "Query" as const,
    warrantyTicketItemStatusesDetail:
      data["warrantyTicketItemStatusesDetail"]?.map((d) => newWarrantyTicketItemStatusDetail(d)) || [],
    warrantyTicketStatusesDetail: data["warrantyTicketStatusesDetail"]?.map((d) => newWarrantyTicketStatusDetail(d)) ||
      [],
    markets: data["markets"]?.map((d) => newMarket(d)) || [],
    internalUsers: data["internalUsers"]?.map((d) => newInternalUser(d)) || [],
  } as any;
}

export function newWarrantyTicketFiltersResponse(
  data: WarrantyTicketFiltersDataOptions | Error,
): MockedResponse<WarrantyTicketFiltersQueryVariables, WarrantyTicketFiltersQuery> {
  return {
    request: { query: WarrantyTicketFiltersDocument },
    result: { data: data instanceof Error ? undefined : newWarrantyTicketFiltersData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface WarrantyTicketsDataOptions {
  warrantyTicketsPage?: WarrantyTicketsPage | WarrantyTicketsPageOptions;
}

export function newWarrantyTicketsData(data: WarrantyTicketsDataOptions): WarrantyTicketsQuery {
  return {
    __typename: "Query" as const,
    warrantyTicketsPage: maybeNew("WarrantyTicketsPage", data["warrantyTicketsPage"] || undefined, {}),
  } as any;
}

export function newWarrantyTicketsResponse(
  variables: WarrantyTicketsQueryVariables,
  data: WarrantyTicketsDataOptions | Error,
): MockedResponse<WarrantyTicketsQueryVariables, WarrantyTicketsQuery> {
  return {
    request: { query: WarrantyTicketsDocument, variables },
    result: { data: data instanceof Error ? undefined : newWarrantyTicketsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveWarrantyTicketDataOptions {
  saveWarrantyTicket?: SaveWarrantyTicketResult | SaveWarrantyTicketResultOptions;
}

export function newSaveWarrantyTicketData(data: SaveWarrantyTicketDataOptions): SaveWarrantyTicketMutation {
  return {
    __typename: "Mutation" as const,
    saveWarrantyTicket: maybeNew("SaveWarrantyTicketResult", data["saveWarrantyTicket"] || undefined, {}),
  } as any;
}

export function newSaveWarrantyTicketResponse(
  variables: SaveWarrantyTicketMutationVariables,
  data: SaveWarrantyTicketDataOptions | Error,
): MockedResponse<SaveWarrantyTicketMutationVariables, SaveWarrantyTicketMutation> {
  return {
    request: { query: SaveWarrantyTicketDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveWarrantyTicketData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveWarrantyTicketItemsDataOptions {
  saveWarrantyTicketItems?: SaveWarrantyTicketItemsResult | SaveWarrantyTicketItemsResultOptions;
}

export function newSaveWarrantyTicketItemsData(
  data: SaveWarrantyTicketItemsDataOptions,
): SaveWarrantyTicketItemsMutation {
  return {
    __typename: "Mutation" as const,
    saveWarrantyTicketItems: maybeNew(
      "SaveWarrantyTicketItemsResult",
      data["saveWarrantyTicketItems"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveWarrantyTicketItemsResponse(
  variables: SaveWarrantyTicketItemsMutationVariables,
  data: SaveWarrantyTicketItemsDataOptions | Error,
): MockedResponse<SaveWarrantyTicketItemsMutationVariables, SaveWarrantyTicketItemsMutation> {
  return {
    request: { query: SaveWarrantyTicketItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveWarrantyTicketItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteWarrantyTicketDataOptions {
  deleteWarrantyTicket?: EmptyResult | EmptyResultOptions;
}

export function newDeleteWarrantyTicketData(data: DeleteWarrantyTicketDataOptions): DeleteWarrantyTicketMutation {
  return {
    __typename: "Mutation" as const,
    deleteWarrantyTicket: maybeNew("EmptyResult", data["deleteWarrantyTicket"] || undefined, {}),
  } as any;
}

export function newDeleteWarrantyTicketResponse(
  variables: DeleteWarrantyTicketMutationVariables,
  data: DeleteWarrantyTicketDataOptions | Error,
): MockedResponse<DeleteWarrantyTicketMutationVariables, DeleteWarrantyTicketMutation> {
  return {
    request: { query: DeleteWarrantyTicketDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteWarrantyTicketData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface WarrantyTicketDataOptions {
  warrantyTicket?: WarrantyTicket | WarrantyTicketOptions;
  internalUsers?: (InternalUser | InternalUserOptions)[];
}

export function newWarrantyTicketData(data: WarrantyTicketDataOptions): WarrantyTicketQuery {
  return {
    __typename: "Query" as const,
    warrantyTicket: maybeNew("WarrantyTicket", data["warrantyTicket"] || undefined, {}),
    internalUsers: data["internalUsers"]?.map((d) => newInternalUser(d)) || [],
  } as any;
}

export function newWarrantyTicketResponse(
  variables: WarrantyTicketQueryVariables,
  data: WarrantyTicketDataOptions | Error,
): MockedResponse<WarrantyTicketQueryVariables, WarrantyTicketQuery> {
  return {
    request: { query: WarrantyTicketDocument, variables },
    result: { data: data instanceof Error ? undefined : newWarrantyTicketData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface WarrantyTicketEnumsDataOptions {
  warrantyTicketItemStatusesDetail?: (WarrantyTicketItemStatusDetail | WarrantyTicketItemStatusDetailOptions)[];
  warrantyTicketItemTypesDetail?: (WarrantyTicketItemTypeDetail | WarrantyTicketItemTypeDetailOptions)[];
  warrantyTicketTypesDetail?: (WarrantyTicketTypeDetail | WarrantyTicketTypeDetailOptions)[];
}

export function newWarrantyTicketEnumsData(data: WarrantyTicketEnumsDataOptions): WarrantyTicketEnumsQuery {
  return {
    __typename: "Query" as const,
    warrantyTicketItemStatusesDetail:
      data["warrantyTicketItemStatusesDetail"]?.map((d) => newWarrantyTicketItemStatusDetail(d)) || [],
    warrantyTicketItemTypesDetail:
      data["warrantyTicketItemTypesDetail"]?.map((d) => newWarrantyTicketItemTypeDetail(d)) || [],
    warrantyTicketTypesDetail: data["warrantyTicketTypesDetail"]?.map((d) => newWarrantyTicketTypeDetail(d)) || [],
  } as any;
}

export function newWarrantyTicketEnumsResponse(
  data: WarrantyTicketEnumsDataOptions | Error,
): MockedResponse<WarrantyTicketEnumsQueryVariables, WarrantyTicketEnumsQuery> {
  return {
    request: { query: WarrantyTicketEnumsDocument },
    result: { data: data instanceof Error ? undefined : newWarrantyTicketEnumsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveWarrantyTicketPageDataOptions {
  saveWarrantyTicket?: SaveWarrantyTicketResult | SaveWarrantyTicketResultOptions;
}

export function newSaveWarrantyTicketPageData(data: SaveWarrantyTicketPageDataOptions): SaveWarrantyTicketPageMutation {
  return {
    __typename: "Mutation" as const,
    saveWarrantyTicket: maybeNew("SaveWarrantyTicketResult", data["saveWarrantyTicket"] || undefined, {}),
  } as any;
}

export function newSaveWarrantyTicketPageResponse(
  variables: SaveWarrantyTicketPageMutationVariables,
  data: SaveWarrantyTicketPageDataOptions | Error,
): MockedResponse<SaveWarrantyTicketPageMutationVariables, SaveWarrantyTicketPageMutation> {
  return {
    request: { query: SaveWarrantyTicketPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveWarrantyTicketPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteWarrantyTicketItemDataOptions {
  deleteWarrantyTicketItem?: EmptyResult | EmptyResultOptions;
}

export function newDeleteWarrantyTicketItemData(
  data: DeleteWarrantyTicketItemDataOptions,
): DeleteWarrantyTicketItemMutation {
  return {
    __typename: "Mutation" as const,
    deleteWarrantyTicketItem: maybeNew("EmptyResult", data["deleteWarrantyTicketItem"] || undefined, {}),
  } as any;
}

export function newDeleteWarrantyTicketItemResponse(
  variables: DeleteWarrantyTicketItemMutationVariables,
  data: DeleteWarrantyTicketItemDataOptions | Error,
): MockedResponse<DeleteWarrantyTicketItemMutationVariables, DeleteWarrantyTicketItemMutation> {
  return {
    request: { query: DeleteWarrantyTicketItemDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteWarrantyTicketItemData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChangeRequestGroupModalDataOptions {
  changeRequestGroup?: ChangeRequestGroup | ChangeRequestGroupOptions;
}

export function newChangeRequestGroupModalData(data: ChangeRequestGroupModalDataOptions): ChangeRequestGroupModalQuery {
  return {
    __typename: "Query" as const,
    changeRequestGroup: maybeNew("ChangeRequestGroup", data["changeRequestGroup"] || undefined, {}),
  } as any;
}

export function newChangeRequestGroupModalResponse(
  variables: ChangeRequestGroupModalQueryVariables,
  data: ChangeRequestGroupModalDataOptions | Error,
): MockedResponse<ChangeRequestGroupModalQueryVariables, ChangeRequestGroupModalQuery> {
  return {
    request: { query: ChangeRequestGroupModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newChangeRequestGroupModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveChangeRequestGroupDataOptions {
  saveChangeRequestGroup?: SaveChangeRequestGroupResult | SaveChangeRequestGroupResultOptions;
}

export function newSaveChangeRequestGroupData(data: SaveChangeRequestGroupDataOptions): SaveChangeRequestGroupMutation {
  return {
    __typename: "Mutation" as const,
    saveChangeRequestGroup: maybeNew("SaveChangeRequestGroupResult", data["saveChangeRequestGroup"] || undefined, {}),
  } as any;
}

export function newSaveChangeRequestGroupResponse(
  variables: SaveChangeRequestGroupMutationVariables,
  data: SaveChangeRequestGroupDataOptions | Error,
): MockedResponse<SaveChangeRequestGroupMutationVariables, SaveChangeRequestGroupMutation> {
  return {
    request: { query: SaveChangeRequestGroupDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveChangeRequestGroupData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteChangeRequestGroupDataOptions {
  deleteChangeRequestGroup?: EmptyResult | EmptyResultOptions;
}

export function newDeleteChangeRequestGroupData(
  data: DeleteChangeRequestGroupDataOptions,
): DeleteChangeRequestGroupMutation {
  return {
    __typename: "Mutation" as const,
    deleteChangeRequestGroup: maybeNew("EmptyResult", data["deleteChangeRequestGroup"] || undefined, {}),
  } as any;
}

export function newDeleteChangeRequestGroupResponse(
  variables: DeleteChangeRequestGroupMutationVariables,
  data: DeleteChangeRequestGroupDataOptions | Error,
): MockedResponse<DeleteChangeRequestGroupMutationVariables, DeleteChangeRequestGroupMutation> {
  return {
    request: { query: DeleteChangeRequestGroupDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteChangeRequestGroupData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BusinessFunctionAssetsDataOptions {
  changeRequestAssets?: ChangeRequestAssetsPageResult | ChangeRequestAssetsPageResultOptions;
  enumDetails?: AllEnumDetails | AllEnumDetailsOptions;
}

export function newBusinessFunctionAssetsData(data: BusinessFunctionAssetsDataOptions): BusinessFunctionAssetsQuery {
  return {
    __typename: "Query" as const,
    changeRequestAssets: maybeNew("ChangeRequestAssetsPageResult", data["changeRequestAssets"] || undefined, {}),
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
  } as any;
}

export function newBusinessFunctionAssetsResponse(
  variables: BusinessFunctionAssetsQueryVariables,
  data: BusinessFunctionAssetsDataOptions | Error,
): MockedResponse<BusinessFunctionAssetsQueryVariables, BusinessFunctionAssetsQuery> {
  return {
    request: { query: BusinessFunctionAssetsDocument, variables },
    result: { data: data instanceof Error ? undefined : newBusinessFunctionAssetsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveChangeRequestAssetsDataOptions {
  saveChangeRequestAssets?: SaveChangeRequestAssetsResult | SaveChangeRequestAssetsResultOptions;
}

export function newSaveChangeRequestAssetsData(
  data: SaveChangeRequestAssetsDataOptions,
): SaveChangeRequestAssetsMutation {
  return {
    __typename: "Mutation" as const,
    saveChangeRequestAssets: maybeNew(
      "SaveChangeRequestAssetsResult",
      data["saveChangeRequestAssets"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveChangeRequestAssetsResponse(
  variables: SaveChangeRequestAssetsMutationVariables,
  data: SaveChangeRequestAssetsDataOptions | Error,
): MockedResponse<SaveChangeRequestAssetsMutationVariables, SaveChangeRequestAssetsMutation> {
  return {
    request: { query: SaveChangeRequestAssetsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveChangeRequestAssetsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChangeRequestsDependencyModalDataOptions {
  changeRequest?: ChangeRequest | ChangeRequestOptions;
  availableDependencyChangeRequests?: (ChangeRequest | ChangeRequestOptions)[];
}

export function newChangeRequestsDependencyModalData(
  data: ChangeRequestsDependencyModalDataOptions,
): ChangeRequestsDependencyModalQuery {
  return {
    __typename: "Query" as const,
    changeRequest: maybeNew("ChangeRequest", data["changeRequest"] || undefined, {}),
    availableDependencyChangeRequests: data["availableDependencyChangeRequests"]?.map((d) => newChangeRequest(d)) || [],
  } as any;
}

export function newChangeRequestsDependencyModalResponse(
  variables: ChangeRequestsDependencyModalQueryVariables,
  data: ChangeRequestsDependencyModalDataOptions | Error,
): MockedResponse<ChangeRequestsDependencyModalQueryVariables, ChangeRequestsDependencyModalQuery> {
  return {
    request: { query: ChangeRequestsDependencyModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newChangeRequestsDependencyModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChangeRequestGroupsForModalDataOptions {
  changeRequestGroups?: (ChangeRequestGroup | ChangeRequestGroupOptions)[];
}

export function newChangeRequestGroupsForModalData(
  data: ChangeRequestGroupsForModalDataOptions,
): ChangeRequestGroupsForModalQuery {
  return {
    __typename: "Query" as const,
    changeRequestGroups: data["changeRequestGroups"]?.map((d) => newChangeRequestGroup(d)) || [],
  } as any;
}

export function newChangeRequestGroupsForModalResponse(
  data: ChangeRequestGroupsForModalDataOptions | Error,
): MockedResponse<ChangeRequestGroupsForModalQueryVariables, ChangeRequestGroupsForModalQuery> {
  return {
    request: { query: ChangeRequestGroupsForModalDocument },
    result: { data: data instanceof Error ? undefined : newChangeRequestGroupsForModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveChangeRequestDependencyBlockingDataOptions {
  saveChangeRequest?: SaveChangeRequestResult | SaveChangeRequestResultOptions;
}

export function newSaveChangeRequestDependencyBlockingData(
  data: SaveChangeRequestDependencyBlockingDataOptions,
): SaveChangeRequestDependencyBlockingMutation {
  return {
    __typename: "Mutation" as const,
    saveChangeRequest: maybeNew("SaveChangeRequestResult", data["saveChangeRequest"] || undefined, {}),
  } as any;
}

export function newSaveChangeRequestDependencyBlockingResponse(
  variables: SaveChangeRequestDependencyBlockingMutationVariables,
  data: SaveChangeRequestDependencyBlockingDataOptions | Error,
): MockedResponse<SaveChangeRequestDependencyBlockingMutationVariables, SaveChangeRequestDependencyBlockingMutation> {
  return {
    request: { query: SaveChangeRequestDependencyBlockingDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveChangeRequestDependencyBlockingData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveChangeRequestDependencyBlockersDataOptions {
  saveChangeRequest?: SaveChangeRequestResult | SaveChangeRequestResultOptions;
}

export function newSaveChangeRequestDependencyBlockersData(
  data: SaveChangeRequestDependencyBlockersDataOptions,
): SaveChangeRequestDependencyBlockersMutation {
  return {
    __typename: "Mutation" as const,
    saveChangeRequest: maybeNew("SaveChangeRequestResult", data["saveChangeRequest"] || undefined, {}),
  } as any;
}

export function newSaveChangeRequestDependencyBlockersResponse(
  variables: SaveChangeRequestDependencyBlockersMutationVariables,
  data: SaveChangeRequestDependencyBlockersDataOptions | Error,
): MockedResponse<SaveChangeRequestDependencyBlockersMutationVariables, SaveChangeRequestDependencyBlockersMutation> {
  return {
    request: { query: SaveChangeRequestDependencyBlockersDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveChangeRequestDependencyBlockersData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveChangeRequestRelatedToDataOptions {
  saveChangeRequest?: SaveChangeRequestResult | SaveChangeRequestResultOptions;
  saveChangeRequestGroups?: SaveChangeRequestGroupsResult | SaveChangeRequestGroupsResultOptions;
}

export function newSaveChangeRequestRelatedToData(
  data: SaveChangeRequestRelatedToDataOptions,
): SaveChangeRequestRelatedToMutation {
  return {
    __typename: "Mutation" as const,
    saveChangeRequest: maybeNew("SaveChangeRequestResult", data["saveChangeRequest"] || undefined, {}),
    saveChangeRequestGroups: maybeNew(
      "SaveChangeRequestGroupsResult",
      data["saveChangeRequestGroups"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveChangeRequestRelatedToResponse(
  variables: SaveChangeRequestRelatedToMutationVariables,
  data: SaveChangeRequestRelatedToDataOptions | Error,
): MockedResponse<SaveChangeRequestRelatedToMutationVariables, SaveChangeRequestRelatedToMutation> {
  return {
    request: { query: SaveChangeRequestRelatedToDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveChangeRequestRelatedToData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChangeRequestHistoryDataOptions {
  changeRequest?: ChangeRequest | ChangeRequestOptions;
}

export function newChangeRequestHistoryData(data: ChangeRequestHistoryDataOptions): ChangeRequestHistoryQuery {
  return {
    __typename: "Query" as const,
    changeRequest: maybeNew("ChangeRequest", data["changeRequest"] || undefined, {}),
  } as any;
}

export function newChangeRequestHistoryResponse(
  variables: ChangeRequestHistoryQueryVariables,
  data: ChangeRequestHistoryDataOptions | Error,
): MockedResponse<ChangeRequestHistoryQueryVariables, ChangeRequestHistoryQuery> {
  return {
    request: { query: ChangeRequestHistoryDocument, variables },
    result: { data: data instanceof Error ? undefined : newChangeRequestHistoryData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ReadyPlanStatusFilterMetadataDataOptions {
  enumDetails?: AllEnumDetails | AllEnumDetailsOptions;
}

export function newReadyPlanStatusFilterMetadataData(
  data: ReadyPlanStatusFilterMetadataDataOptions,
): ReadyPlanStatusFilterMetadataQuery {
  return {
    __typename: "Query" as const,
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
  } as any;
}

export function newReadyPlanStatusFilterMetadataResponse(
  data: ReadyPlanStatusFilterMetadataDataOptions | Error,
): MockedResponse<ReadyPlanStatusFilterMetadataQueryVariables, ReadyPlanStatusFilterMetadataQuery> {
  return {
    request: { query: ReadyPlanStatusFilterMetadataDocument },
    result: { data: data instanceof Error ? undefined : newReadyPlanStatusFilterMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillDetailPaneDataOptions {
  bill?: Bill | BillOptions;
}

export function newBillDetailPaneData(data: BillDetailPaneDataOptions): BillDetailPaneQuery {
  return { __typename: "Query" as const, bill: maybeNew("Bill", data["bill"] || undefined, {}) } as any;
}

export function newBillDetailPaneResponse(
  variables: BillDetailPaneQueryVariables,
  data: BillDetailPaneDataOptions | Error,
): MockedResponse<BillDetailPaneQueryVariables, BillDetailPaneQuery> {
  return {
    request: { query: BillDetailPaneDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillDetailPaneData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillDetailPane_NewBillCommitmentLikeDataDataOptions {
  commitment?: Commitment | CommitmentOptions;
  commitmentChangeOrder?: CommitmentChangeOrder | CommitmentChangeOrderOptions;
}

export function newBillDetailPane_NewBillCommitmentLikeDataData(
  data: BillDetailPane_NewBillCommitmentLikeDataDataOptions,
): BillDetailPane_NewBillCommitmentLikeDataQuery {
  return {
    __typename: "Query" as const,
    commitment: maybeNew("Commitment", data["commitment"] || undefined, {}),
    commitmentChangeOrder: maybeNew("CommitmentChangeOrder", data["commitmentChangeOrder"] || undefined, {}),
  } as any;
}

export function newBillDetailPane_NewBillCommitmentLikeDataResponse(
  variables: BillDetailPane_NewBillCommitmentLikeDataQueryVariables,
  data: BillDetailPane_NewBillCommitmentLikeDataDataOptions | Error,
): MockedResponse<
  BillDetailPane_NewBillCommitmentLikeDataQueryVariables,
  BillDetailPane_NewBillCommitmentLikeDataQuery
> {
  return {
    request: { query: BillDetailPane_NewBillCommitmentLikeDataDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillDetailPane_NewBillCommitmentLikeDataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillDetailPane_AdditionalCommitmentsDataOptions {
  commitments?: (Commitment | CommitmentOptions)[];
}

export function newBillDetailPane_AdditionalCommitmentsData(
  data: BillDetailPane_AdditionalCommitmentsDataOptions,
): BillDetailPane_AdditionalCommitmentsQuery {
  return { __typename: "Query" as const, commitments: data["commitments"]?.map((d) => newCommitment(d)) || [] } as any;
}

export function newBillDetailPane_AdditionalCommitmentsResponse(
  variables: BillDetailPane_AdditionalCommitmentsQueryVariables,
  data: BillDetailPane_AdditionalCommitmentsDataOptions | Error,
): MockedResponse<BillDetailPane_AdditionalCommitmentsQueryVariables, BillDetailPane_AdditionalCommitmentsQuery> {
  return {
    request: { query: BillDetailPane_AdditionalCommitmentsDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillDetailPane_AdditionalCommitmentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillPaneDetail_SaveBillDocumentDataOptions {
  saveDocuments?: SaveDocumentsResult | SaveDocumentsResultOptions;
}

export function newBillPaneDetail_SaveBillDocumentData(
  data: BillPaneDetail_SaveBillDocumentDataOptions,
): BillPaneDetail_SaveBillDocumentMutation {
  return {
    __typename: "Mutation" as const,
    saveDocuments: maybeNew("SaveDocumentsResult", data["saveDocuments"] || undefined, {}),
  } as any;
}

export function newBillPaneDetail_SaveBillDocumentResponse(
  variables: BillPaneDetail_SaveBillDocumentMutationVariables,
  data: BillPaneDetail_SaveBillDocumentDataOptions | Error,
): MockedResponse<BillPaneDetail_SaveBillDocumentMutationVariables, BillPaneDetail_SaveBillDocumentMutation> {
  return {
    request: { query: BillPaneDetail_SaveBillDocumentDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillPaneDetail_SaveBillDocumentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillDetailPane_SaveApprovalDataOptions {
  saveApproval?: SaveApprovalResult | SaveApprovalResultOptions;
}

export function newBillDetailPane_SaveApprovalData(
  data: BillDetailPane_SaveApprovalDataOptions,
): BillDetailPane_SaveApprovalMutation {
  return {
    __typename: "Mutation" as const,
    saveApproval: maybeNew("SaveApprovalResult", data["saveApproval"] || undefined, {}),
  } as any;
}

export function newBillDetailPane_SaveApprovalResponse(
  variables: BillDetailPane_SaveApprovalMutationVariables,
  data: BillDetailPane_SaveApprovalDataOptions | Error,
): MockedResponse<BillDetailPane_SaveApprovalMutationVariables, BillDetailPane_SaveApprovalMutation> {
  return {
    request: { query: BillDetailPane_SaveApprovalDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillDetailPane_SaveApprovalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MarketFilterMetadataDataOptions {
  markets?: (Market | MarketOptions)[];
}

export function newMarketFilterMetadataData(data: MarketFilterMetadataDataOptions): MarketFilterMetadataQuery {
  return { __typename: "Query" as const, markets: data["markets"]?.map((d) => newMarket(d)) || [] } as any;
}

export function newMarketFilterMetadataResponse(
  data: MarketFilterMetadataDataOptions | Error,
): MockedResponse<MarketFilterMetadataQueryVariables, MarketFilterMetadataQuery> {
  return {
    request: { query: MarketFilterMetadataDocument },
    result: { data: data instanceof Error ? undefined : newMarketFilterMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CostCodeHistoryDataOptions {
  costCodes?: (CostCode | CostCodeOptions)[];
}

export function newCostCodeHistoryData(data: CostCodeHistoryDataOptions): CostCodeHistoryQuery {
  return { __typename: "Query" as const, costCodes: data["costCodes"]?.map((d) => newCostCode(d)) || [] } as any;
}

export function newCostCodeHistoryResponse(
  variables: CostCodeHistoryQueryVariables,
  data: CostCodeHistoryDataOptions | Error,
): MockedResponse<CostCodeHistoryQueryVariables, CostCodeHistoryQuery> {
  return {
    request: { query: CostCodeHistoryDocument, variables },
    result: { data: data instanceof Error ? undefined : newCostCodeHistoryData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SetProjectStatusDataOptions {
  saveProject?: SaveProjectResult | SaveProjectResultOptions;
}

export function newSetProjectStatusData(data: SetProjectStatusDataOptions): SetProjectStatusMutation {
  return {
    __typename: "Mutation" as const,
    saveProject: maybeNew("SaveProjectResult", data["saveProject"] || undefined, {}),
  } as any;
}

export function newSetProjectStatusResponse(
  variables: SetProjectStatusMutationVariables,
  data: SetProjectStatusDataOptions | Error,
): MockedResponse<SetProjectStatusMutationVariables, SetProjectStatusMutation> {
  return {
    request: { query: SetProjectStatusDocument, variables },
    result: { data: data instanceof Error ? undefined : newSetProjectStatusData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CostCodeOverviewTabDataOptions {
  costCodes?: (CostCode | CostCodeOptions)[];
}

export function newCostCodeOverviewTabData(data: CostCodeOverviewTabDataOptions): CostCodeOverviewTabQuery {
  return { __typename: "Query" as const, costCodes: data["costCodes"]?.map((d) => newCostCode(d)) || [] } as any;
}

export function newCostCodeOverviewTabResponse(
  variables: CostCodeOverviewTabQueryVariables,
  data: CostCodeOverviewTabDataOptions | Error,
): MockedResponse<CostCodeOverviewTabQueryVariables, CostCodeOverviewTabQuery> {
  return {
    request: { query: CostCodeOverviewTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newCostCodeOverviewTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CostCodeOverviewTabMetadataDataOptions {
  costDivisions?: (CostDivision | CostDivisionOptions)[];
  enumDetails?: AllEnumDetails | AllEnumDetailsOptions;
}

export function newCostCodeOverviewTabMetadataData(
  data: CostCodeOverviewTabMetadataDataOptions,
): CostCodeOverviewTabMetadataQuery {
  return {
    __typename: "Query" as const,
    costDivisions: data["costDivisions"]?.map((d) => newCostDivision(d)) || [],
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
  } as any;
}

export function newCostCodeOverviewTabMetadataResponse(
  data: CostCodeOverviewTabMetadataDataOptions | Error,
): MockedResponse<CostCodeOverviewTabMetadataQueryVariables, CostCodeOverviewTabMetadataQuery> {
  return {
    request: { query: CostCodeOverviewTabMetadataDocument },
    result: { data: data instanceof Error ? undefined : newCostCodeOverviewTabMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveCostCodesDataOptions {
  saveCostCodes?: SaveCostCodesResult | SaveCostCodesResultOptions;
}

export function newSaveCostCodesData(data: SaveCostCodesDataOptions): SaveCostCodesMutation {
  return {
    __typename: "Mutation" as const,
    saveCostCodes: maybeNew("SaveCostCodesResult", data["saveCostCodes"] || undefined, {}),
  } as any;
}

export function newSaveCostCodesResponse(
  variables: SaveCostCodesMutationVariables,
  data: SaveCostCodesDataOptions | Error,
): MockedResponse<SaveCostCodesMutationVariables, SaveCostCodesMutation> {
  return {
    request: { query: SaveCostCodesDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveCostCodesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CostCodesDataOptions {
  costCodes?: (CostCode | CostCodeOptions)[];
}

export function newCostCodesData(data: CostCodesDataOptions): CostCodesQuery {
  return { __typename: "Query" as const, costCodes: data["costCodes"]?.map((d) => newCostCode(d)) || [] } as any;
}

export function newCostCodesResponse(
  variables: CostCodesQueryVariables,
  data: CostCodesDataOptions | Error,
): MockedResponse<CostCodesQueryVariables, CostCodesQuery> {
  return {
    request: { query: CostCodesDocument, variables },
    result: { data: data instanceof Error ? undefined : newCostCodesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteCostCodeDataOptions {
  deleteCostCode?: EmptyResult | EmptyResultOptions;
}

export function newDeleteCostCodeData(data: DeleteCostCodeDataOptions): DeleteCostCodeMutation {
  return {
    __typename: "Mutation" as const,
    deleteCostCode: maybeNew("EmptyResult", data["deleteCostCode"] || undefined, {}),
  } as any;
}

export function newDeleteCostCodeResponse(
  variables: DeleteCostCodeMutationVariables,
  data: DeleteCostCodeDataOptions | Error,
): MockedResponse<DeleteCostCodeMutationVariables, DeleteCostCodeMutation> {
  return {
    request: { query: DeleteCostCodeDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteCostCodeData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CostCodeMaterialLeadTimesTabDataOptions {
  costCodes?: (CostCode | CostCodeOptions)[];
}

export function newCostCodeMaterialLeadTimesTabData(
  data: CostCodeMaterialLeadTimesTabDataOptions,
): CostCodeMaterialLeadTimesTabQuery {
  return { __typename: "Query" as const, costCodes: data["costCodes"]?.map((d) => newCostCode(d)) || [] } as any;
}

export function newCostCodeMaterialLeadTimesTabResponse(
  variables: CostCodeMaterialLeadTimesTabQueryVariables,
  data: CostCodeMaterialLeadTimesTabDataOptions | Error,
): MockedResponse<CostCodeMaterialLeadTimesTabQueryVariables, CostCodeMaterialLeadTimesTabQuery> {
  return {
    request: { query: CostCodeMaterialLeadTimesTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newCostCodeMaterialLeadTimesTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ItemsDrawerDataOptions {
  items?: (Item | ItemOptions)[];
}

export function newItemsDrawerData(data: ItemsDrawerDataOptions): ItemsDrawerQuery {
  return { __typename: "Query" as const, items: data["items"]?.map((d) => newItem(d)) || [] } as any;
}

export function newItemsDrawerResponse(
  variables: ItemsDrawerQueryVariables,
  data: ItemsDrawerDataOptions | Error,
): MockedResponse<ItemsDrawerQueryVariables, ItemsDrawerQuery> {
  return {
    request: { query: ItemsDrawerDocument, variables },
    result: { data: data instanceof Error ? undefined : newItemsDrawerData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ToggleProjectFeatureDataOptions {
  toggleProjectFeature?: SaveProjectResult | SaveProjectResultOptions;
}

export function newToggleProjectFeatureData(data: ToggleProjectFeatureDataOptions): ToggleProjectFeatureMutation {
  return {
    __typename: "Mutation" as const,
    toggleProjectFeature: maybeNew("SaveProjectResult", data["toggleProjectFeature"] || undefined, {}),
  } as any;
}

export function newToggleProjectFeatureResponse(
  variables: ToggleProjectFeatureMutationVariables,
  data: ToggleProjectFeatureDataOptions | Error,
): MockedResponse<ToggleProjectFeatureMutationVariables, ToggleProjectFeatureMutation> {
  return {
    request: { query: ToggleProjectFeatureDocument, variables },
    result: { data: data instanceof Error ? undefined : newToggleProjectFeatureData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface FeatureFlagsDataOptions {
  featureFlags?: (FeatureFlag | FeatureFlagOptions)[];
}

export function newFeatureFlagsData(data: FeatureFlagsDataOptions): FeatureFlagsQuery {
  return {
    __typename: "Query" as const,
    featureFlags: data["featureFlags"]?.map((d) => newFeatureFlag(d)) || [],
  } as any;
}

export function newFeatureFlagsResponse(
  variables: FeatureFlagsQueryVariables,
  data: FeatureFlagsDataOptions | Error,
): MockedResponse<FeatureFlagsQueryVariables, FeatureFlagsQuery> {
  return {
    request: { query: FeatureFlagsDocument, variables },
    result: { data: data instanceof Error ? undefined : newFeatureFlagsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface FeatureFlagsMetadataDataOptions {
  internalUsers?: (InternalUser | InternalUserOptions)[];
  userGroups?: (UserGroup | UserGroupOptions)[];
  developments?: (Development | DevelopmentOptions)[];
  projects?: (Project | ProjectOptions)[];
  availableFeatureFlagTypes?: (FeatureFlagTypeDetail | FeatureFlagTypeDetailOptions)[];
}

export function newFeatureFlagsMetadataData(data: FeatureFlagsMetadataDataOptions): FeatureFlagsMetadataQuery {
  return {
    __typename: "Query" as const,
    internalUsers: data["internalUsers"]?.map((d) => newInternalUser(d)) || [],
    userGroups: data["userGroups"]?.map((d) => newUserGroup(d)) || [],
    developments: data["developments"]?.map((d) => newDevelopment(d)) || [],
    projects: data["projects"]?.map((d) => maybeNew("Project", d, {})) || [],
    availableFeatureFlagTypes: data["availableFeatureFlagTypes"]?.map((d) => newFeatureFlagTypeDetail(d)) || [],
  } as any;
}

export function newFeatureFlagsMetadataResponse(
  variables: FeatureFlagsMetadataQueryVariables,
  data: FeatureFlagsMetadataDataOptions | Error,
): MockedResponse<FeatureFlagsMetadataQueryVariables, FeatureFlagsMetadataQuery> {
  return {
    request: { query: FeatureFlagsMetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newFeatureFlagsMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveFeatureFlagDataOptions {
  saveFeatureFlag?: SaveFeatureFlagResult | SaveFeatureFlagResultOptions;
}

export function newSaveFeatureFlagData(data: SaveFeatureFlagDataOptions): SaveFeatureFlagMutation {
  return {
    __typename: "Mutation" as const,
    saveFeatureFlag: maybeNew("SaveFeatureFlagResult", data["saveFeatureFlag"] || undefined, {}),
  } as any;
}

export function newSaveFeatureFlagResponse(
  variables: SaveFeatureFlagMutationVariables,
  data: SaveFeatureFlagDataOptions | Error,
): MockedResponse<SaveFeatureFlagMutationVariables, SaveFeatureFlagMutation> {
  return {
    request: { query: SaveFeatureFlagDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveFeatureFlagData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ItemEditorHistoryDataOptions {
  items?: (Item | ItemOptions)[];
}

export function newItemEditorHistoryData(data: ItemEditorHistoryDataOptions): ItemEditorHistoryQuery {
  return { __typename: "Query" as const, items: data["items"]?.map((d) => newItem(d)) || [] } as any;
}

export function newItemEditorHistoryResponse(
  variables: ItemEditorHistoryQueryVariables,
  data: ItemEditorHistoryDataOptions | Error,
): MockedResponse<ItemEditorHistoryQueryVariables, ItemEditorHistoryQuery> {
  return {
    request: { query: ItemEditorHistoryDocument, variables },
    result: { data: data instanceof Error ? undefined : newItemEditorHistoryData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ItemEditorTabMetadataDataOptions {
  enumDetails?: AllEnumDetails | AllEnumDetailsOptions;
}

export function newItemEditorTabMetadataData(data: ItemEditorTabMetadataDataOptions): ItemEditorTabMetadataQuery {
  return {
    __typename: "Query" as const,
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
  } as any;
}

export function newItemEditorTabMetadataResponse(
  data: ItemEditorTabMetadataDataOptions | Error,
): MockedResponse<ItemEditorTabMetadataQueryVariables, ItemEditorTabMetadataQuery> {
  return {
    request: { query: ItemEditorTabMetadataDocument },
    result: { data: data instanceof Error ? undefined : newItemEditorTabMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AdminItemsDrawerDataOptions {
  items?: (Item | ItemOptions)[];
  allItems?: (Item | ItemOptions)[];
}

export function newAdminItemsDrawerData(data: AdminItemsDrawerDataOptions): AdminItemsDrawerQuery {
  return {
    __typename: "Query" as const,
    items: data["items"]?.map((d) => newItem(d)) || [],
    allItems: data["allItems"]?.map((d) => newItem(d)) || [],
  } as any;
}

export function newAdminItemsDrawerResponse(
  variables: AdminItemsDrawerQueryVariables,
  data: AdminItemsDrawerDataOptions | Error,
): MockedResponse<AdminItemsDrawerQueryVariables, AdminItemsDrawerQuery> {
  return {
    request: { query: AdminItemsDrawerDocument, variables },
    result: { data: data instanceof Error ? undefined : newAdminItemsDrawerData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveItemDimensionsDataOptions {
  saveItems?: (Item | ItemOptions)[];
}

export function newSaveItemDimensionsData(data: SaveItemDimensionsDataOptions): SaveItemDimensionsMutation {
  return { __typename: "Mutation" as const, saveItems: data["saveItems"]?.map((d) => newItem(d)) || [] } as any;
}

export function newSaveItemDimensionsResponse(
  variables: SaveItemDimensionsMutationVariables,
  data: SaveItemDimensionsDataOptions | Error,
): MockedResponse<SaveItemDimensionsMutationVariables, SaveItemDimensionsMutation> {
  return {
    request: { query: SaveItemDimensionsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveItemDimensionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ItemsPageMetadataDataOptions {
  costCodes?: (CostCode | CostCodeOptions)[];
}

export function newItemsPageMetadataData(data: ItemsPageMetadataDataOptions): ItemsPageMetadataQuery {
  return { __typename: "Query" as const, costCodes: data["costCodes"]?.map((d) => newCostCode(d)) || [] } as any;
}

export function newItemsPageMetadataResponse(
  data: ItemsPageMetadataDataOptions | Error,
): MockedResponse<ItemsPageMetadataQueryVariables, ItemsPageMetadataQuery> {
  return {
    request: { query: ItemsPageMetadataDocument },
    result: { data: data instanceof Error ? undefined : newItemsPageMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ItemsDataOptions {
  items?: (Item | ItemOptions)[];
  unitsOfMeasure?: (UnitOfMeasure | UnitOfMeasureOptions)[];
}

export function newItemsData(data: ItemsDataOptions): ItemsQuery {
  return {
    __typename: "Query" as const,
    items: data["items"]?.map((d) => newItem(d)) || [],
    unitsOfMeasure: data["unitsOfMeasure"]?.map((d) => newUnitOfMeasure(d)) || [],
  } as any;
}

export function newItemsResponse(
  variables: ItemsQueryVariables,
  data: ItemsDataOptions | Error,
): MockedResponse<ItemsQueryVariables, ItemsQuery> {
  return {
    request: { query: ItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveItemDataOptions {
  saveItems?: (Item | ItemOptions)[];
}

export function newSaveItemData(data: SaveItemDataOptions): SaveItemMutation {
  return { __typename: "Mutation" as const, saveItems: data["saveItems"]?.map((d) => newItem(d)) || [] } as any;
}

export function newSaveItemResponse(
  variables: SaveItemMutationVariables,
  data: SaveItemDataOptions | Error,
): MockedResponse<SaveItemMutationVariables, SaveItemMutation> {
  return {
    request: { query: SaveItemDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveItemData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MaterialLeadTimesEditorTabMetadataDataOptions {
  markets?: (Market | MarketOptions)[];
}

export function newMaterialLeadTimesEditorTabMetadataData(
  data: MaterialLeadTimesEditorTabMetadataDataOptions,
): MaterialLeadTimesEditorTabMetadataQuery {
  return { __typename: "Query" as const, markets: data["markets"]?.map((d) => newMarket(d)) || [] } as any;
}

export function newMaterialLeadTimesEditorTabMetadataResponse(
  data: MaterialLeadTimesEditorTabMetadataDataOptions | Error,
): MockedResponse<MaterialLeadTimesEditorTabMetadataQueryVariables, MaterialLeadTimesEditorTabMetadataQuery> {
  return {
    request: { query: MaterialLeadTimesEditorTabMetadataDocument },
    result: { data: data instanceof Error ? undefined : newMaterialLeadTimesEditorTabMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MaterialLeadTimesEditorTabDataOptions {
  items?: (Item | ItemOptions)[];
}

export function newMaterialLeadTimesEditorTabData(
  data: MaterialLeadTimesEditorTabDataOptions,
): MaterialLeadTimesEditorTabQuery {
  return { __typename: "Query" as const, items: data["items"]?.map((d) => newItem(d)) || [] } as any;
}

export function newMaterialLeadTimesEditorTabResponse(
  variables: MaterialLeadTimesEditorTabQueryVariables,
  data: MaterialLeadTimesEditorTabDataOptions | Error,
): MockedResponse<MaterialLeadTimesEditorTabQueryVariables, MaterialLeadTimesEditorTabQuery> {
  return {
    request: { query: MaterialLeadTimesEditorTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newMaterialLeadTimesEditorTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AdminLocationsPageDataOptions {
  locations?: (Location | LocationOptions)[];
}

export function newAdminLocationsPageData(data: AdminLocationsPageDataOptions): AdminLocationsPageQuery {
  return { __typename: "Query" as const, locations: data["locations"]?.map((d) => newLocation(d)) || [] } as any;
}

export function newAdminLocationsPageResponse(
  variables: AdminLocationsPageQueryVariables,
  data: AdminLocationsPageDataOptions | Error,
): MockedResponse<AdminLocationsPageQueryVariables, AdminLocationsPageQuery> {
  return {
    request: { query: AdminLocationsPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newAdminLocationsPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface UserGroupsDataOptions {
  userGroups?: (UserGroup | UserGroupOptions)[];
}

export function newUserGroupsData(data: UserGroupsDataOptions): UserGroupsQuery {
  return { __typename: "Query" as const, userGroups: data["userGroups"]?.map((d) => newUserGroup(d)) || [] } as any;
}

export function newUserGroupsResponse(
  variables: UserGroupsQueryVariables,
  data: UserGroupsDataOptions | Error,
): MockedResponse<UserGroupsQueryVariables, UserGroupsQuery> {
  return {
    request: { query: UserGroupsDocument, variables },
    result: { data: data instanceof Error ? undefined : newUserGroupsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface UserGroupsMetadataDataOptions {
  internalUsers?: (InternalUser | InternalUserOptions)[];
}

export function newUserGroupsMetadataData(data: UserGroupsMetadataDataOptions): UserGroupsMetadataQuery {
  return {
    __typename: "Query" as const,
    internalUsers: data["internalUsers"]?.map((d) => newInternalUser(d)) || [],
  } as any;
}

export function newUserGroupsMetadataResponse(
  data: UserGroupsMetadataDataOptions | Error,
): MockedResponse<UserGroupsMetadataQueryVariables, UserGroupsMetadataQuery> {
  return {
    request: { query: UserGroupsMetadataDocument },
    result: { data: data instanceof Error ? undefined : newUserGroupsMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveUserGroupDataOptions {
  saveUserGroup?: SaveUserGroupResult | SaveUserGroupResultOptions;
}

export function newSaveUserGroupData(data: SaveUserGroupDataOptions): SaveUserGroupMutation {
  return {
    __typename: "Mutation" as const,
    saveUserGroup: maybeNew("SaveUserGroupResult", data["saveUserGroup"] || undefined, {}),
  } as any;
}

export function newSaveUserGroupResponse(
  variables: SaveUserGroupMutationVariables,
  data: SaveUserGroupDataOptions | Error,
): MockedResponse<SaveUserGroupMutationVariables, SaveUserGroupMutation> {
  return {
    request: { query: SaveUserGroupDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveUserGroupData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface RemoveUserGroupDataOptions {
  removeUserGroup?: EmptyResult | EmptyResultOptions;
}

export function newRemoveUserGroupData(data: RemoveUserGroupDataOptions): RemoveUserGroupMutation {
  return {
    __typename: "Mutation" as const,
    removeUserGroup: maybeNew("EmptyResult", data["removeUserGroup"] || undefined, {}),
  } as any;
}

export function newRemoveUserGroupResponse(
  variables: RemoveUserGroupMutationVariables,
  data: RemoveUserGroupDataOptions | Error,
): MockedResponse<RemoveUserGroupMutationVariables, RemoveUserGroupMutation> {
  return {
    request: { query: RemoveUserGroupDocument, variables },
    result: { data: data instanceof Error ? undefined : newRemoveUserGroupData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddBidPackagePage_OriginatingProjectDataOptions {
  project?: Project | ProjectOptions;
}

export function newAddBidPackagePage_OriginatingProjectData(
  data: AddBidPackagePage_OriginatingProjectDataOptions,
): AddBidPackagePage_OriginatingProjectQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newAddBidPackagePage_OriginatingProjectResponse(
  variables: AddBidPackagePage_OriginatingProjectQueryVariables,
  data: AddBidPackagePage_OriginatingProjectDataOptions | Error,
): MockedResponse<AddBidPackagePage_OriginatingProjectQueryVariables, AddBidPackagePage_OriginatingProjectQuery> {
  return {
    request: { query: AddBidPackagePage_OriginatingProjectDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddBidPackagePage_OriginatingProjectData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddBidPackagePageDataOptions {
  bidPackageGroup?: BidPackageGroup | BidPackageGroupOptions;
}

export function newAddBidPackagePageData(data: AddBidPackagePageDataOptions): AddBidPackagePageQuery {
  return {
    __typename: "Query" as const,
    bidPackageGroup: maybeNew("BidPackageGroup", data["bidPackageGroup"] || undefined, {}),
  } as any;
}

export function newAddBidPackagePageResponse(
  variables: AddBidPackagePageQueryVariables,
  data: AddBidPackagePageDataOptions | Error,
): MockedResponse<AddBidPackagePageQueryVariables, AddBidPackagePageQuery> {
  return {
    request: { query: AddBidPackagePageDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddBidPackagePageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface OverlappingBidPackagesDataOptions {
  overlappingBidPackages?: OverlappingBidPackagesResult | OverlappingBidPackagesResultOptions;
}

export function newOverlappingBidPackagesData(data: OverlappingBidPackagesDataOptions): OverlappingBidPackagesQuery {
  return {
    __typename: "Query" as const,
    overlappingBidPackages: maybeNew("OverlappingBidPackagesResult", data["overlappingBidPackages"] || undefined, {}),
  } as any;
}

export function newOverlappingBidPackagesResponse(
  variables: OverlappingBidPackagesQueryVariables,
  data: OverlappingBidPackagesDataOptions | Error,
): MockedResponse<OverlappingBidPackagesQueryVariables, OverlappingBidPackagesQuery> {
  return {
    request: { query: OverlappingBidPackagesDocument, variables },
    result: { data: data instanceof Error ? undefined : newOverlappingBidPackagesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveBidPackagesDataOptions {
  saveBidPackages?: SaveBidPackagesResult | SaveBidPackagesResultOptions;
}

export function newSaveBidPackagesData(data: SaveBidPackagesDataOptions): SaveBidPackagesMutation {
  return {
    __typename: "Mutation" as const,
    saveBidPackages: maybeNew("SaveBidPackagesResult", data["saveBidPackages"] || undefined, {}),
  } as any;
}

export function newSaveBidPackagesResponse(
  variables: SaveBidPackagesMutationVariables,
  data: SaveBidPackagesDataOptions | Error,
): MockedResponse<SaveBidPackagesMutationVariables, SaveBidPackagesMutation> {
  return {
    request: { query: SaveBidPackagesDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveBidPackagesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectsDataOptions {
  projectsPage?: ProjectsPageResult | ProjectsPageResultOptions;
}

export function newProjectsData(data: ProjectsDataOptions): ProjectsQuery {
  return {
    __typename: "Query" as const,
    projectsPage: maybeNew("ProjectsPageResult", data["projectsPage"] || undefined, {}),
  } as any;
}

export function newProjectsResponse(
  variables: ProjectsQueryVariables,
  data: ProjectsDataOptions | Error,
): MockedResponse<ProjectsQueryVariables, ProjectsQuery> {
  return {
    request: { query: ProjectsDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AdminProjectsFilterDataDataOptions {
  projectFeatures?: (ProjectFeatureDetail | ProjectFeatureDetailOptions)[];
  markets?: (Market | MarketOptions)[];
  cohorts?: (Cohort | CohortOptions)[];
  developments?: (Development | DevelopmentOptions)[];
}

export function newAdminProjectsFilterDataData(data: AdminProjectsFilterDataDataOptions): AdminProjectsFilterDataQuery {
  return {
    __typename: "Query" as const,
    projectFeatures: data["projectFeatures"]?.map((d) => newProjectFeatureDetail(d)) || [],
    markets: data["markets"]?.map((d) => newMarket(d)) || [],
    cohorts: data["cohorts"]?.map((d) => newCohort(d)) || [],
    developments: data["developments"]?.map((d) => newDevelopment(d)) || [],
  } as any;
}

export function newAdminProjectsFilterDataResponse(
  data: AdminProjectsFilterDataDataOptions | Error,
): MockedResponse<AdminProjectsFilterDataQueryVariables, AdminProjectsFilterDataQuery> {
  return {
    request: { query: AdminProjectsFilterDataDocument },
    result: { data: data instanceof Error ? undefined : newAdminProjectsFilterDataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SetProjectIsTestDataOptions {
  saveProject?: SaveProjectResult | SaveProjectResultOptions;
}

export function newSetProjectIsTestData(data: SetProjectIsTestDataOptions): SetProjectIsTestMutation {
  return {
    __typename: "Mutation" as const,
    saveProject: maybeNew("SaveProjectResult", data["saveProject"] || undefined, {}),
  } as any;
}

export function newSetProjectIsTestResponse(
  variables: SetProjectIsTestMutationVariables,
  data: SetProjectIsTestDataOptions | Error,
): MockedResponse<SetProjectIsTestMutationVariables, SetProjectIsTestMutation> {
  return {
    request: { query: SetProjectIsTestDocument, variables },
    result: { data: data instanceof Error ? undefined : newSetProjectIsTestData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SetQbCustomerIdDataOptions {
  saveProject?: SaveProjectResult | SaveProjectResultOptions;
}

export function newSetQbCustomerIdData(data: SetQbCustomerIdDataOptions): SetQbCustomerIdMutation {
  return {
    __typename: "Mutation" as const,
    saveProject: maybeNew("SaveProjectResult", data["saveProject"] || undefined, {}),
  } as any;
}

export function newSetQbCustomerIdResponse(
  variables: SetQbCustomerIdMutationVariables,
  data: SetQbCustomerIdDataOptions | Error,
): MockedResponse<SetQbCustomerIdMutationVariables, SetQbCustomerIdMutation> {
  return {
    request: { query: SetQbCustomerIdDocument, variables },
    result: { data: data instanceof Error ? undefined : newSetQbCustomerIdData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface UsersPageDataOptions {
  internalUsers?: (InternalUser | InternalUserOptions)[];
}

export function newUsersPageData(data: UsersPageDataOptions): UsersPageQuery {
  return {
    __typename: "Query" as const,
    internalUsers: data["internalUsers"]?.map((d) => newInternalUser(d)) || [],
  } as any;
}

export function newUsersPageResponse(
  data: UsersPageDataOptions | Error,
): MockedResponse<UsersPageQueryVariables, UsersPageQuery> {
  return {
    request: { query: UsersPageDocument },
    result: { data: data instanceof Error ? undefined : newUsersPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ActivateUsersDataOptions {
  activateUsers?: ActivateUsersResult | ActivateUsersResultOptions;
}

export function newActivateUsersData(data: ActivateUsersDataOptions): ActivateUsersMutation {
  return {
    __typename: "Mutation" as const,
    activateUsers: maybeNew("ActivateUsersResult", data["activateUsers"] || undefined, {}),
  } as any;
}

export function newActivateUsersResponse(
  variables: ActivateUsersMutationVariables,
  data: ActivateUsersDataOptions | Error,
): MockedResponse<ActivateUsersMutationVariables, ActivateUsersMutation> {
  return {
    request: { query: ActivateUsersDocument, variables },
    result: { data: data instanceof Error ? undefined : newActivateUsersData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeactivateUsersDataOptions {
  deactivateUsers?: DeactivateUsersResult | DeactivateUsersResultOptions;
}

export function newDeactivateUsersData(data: DeactivateUsersDataOptions): DeactivateUsersMutation {
  return {
    __typename: "Mutation" as const,
    deactivateUsers: maybeNew("DeactivateUsersResult", data["deactivateUsers"] || undefined, {}),
  } as any;
}

export function newDeactivateUsersResponse(
  variables: DeactivateUsersMutationVariables,
  data: DeactivateUsersDataOptions | Error,
): MockedResponse<DeactivateUsersMutationVariables, DeactivateUsersMutation> {
  return {
    request: { query: DeactivateUsersDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeactivateUsersData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddTradePartnerModalDataOptions {
  tradePartners?: (TradePartner | TradePartnerOptions)[];
}

export function newAddTradePartnerModalData(data: AddTradePartnerModalDataOptions): AddTradePartnerModalQuery {
  return {
    __typename: "Query" as const,
    tradePartners: data["tradePartners"]?.map((d) => newTradePartner(d)) || [],
  } as any;
}

export function newAddTradePartnerModalResponse(
  variables: AddTradePartnerModalQueryVariables,
  data: AddTradePartnerModalDataOptions | Error,
): MockedResponse<AddTradePartnerModalQueryVariables, AddTradePartnerModalQuery> {
  return {
    request: { query: AddTradePartnerModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddTradePartnerModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AwardBidModalDataOptions {
  bidPackage?: BidPackage | BidPackageOptions;
}

export function newAwardBidModalData(data: AwardBidModalDataOptions): AwardBidModalQuery {
  return {
    __typename: "Query" as const,
    bidPackage: maybeNew("BidPackage", data["bidPackage"] || undefined, {}),
  } as any;
}

export function newAwardBidModalResponse(
  variables: AwardBidModalQueryVariables,
  data: AwardBidModalDataOptions | Error,
): MockedResponse<AwardBidModalQueryVariables, AwardBidModalQuery> {
  return {
    request: { query: AwardBidModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newAwardBidModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveBidPackageAwardsDataOptions {
  saveBidPackageAwards?: SaveBidPackageAwardsResult | SaveBidPackageAwardsResultOptions;
}

export function newSaveBidPackageAwardsData(data: SaveBidPackageAwardsDataOptions): SaveBidPackageAwardsMutation {
  return {
    __typename: "Mutation" as const,
    saveBidPackageAwards: maybeNew("SaveBidPackageAwardsResult", data["saveBidPackageAwards"] || undefined, {}),
  } as any;
}

export function newSaveBidPackageAwardsResponse(
  variables: SaveBidPackageAwardsMutationVariables,
  data: SaveBidPackageAwardsDataOptions | Error,
): MockedResponse<SaveBidPackageAwardsMutationVariables, SaveBidPackageAwardsMutation> {
  return {
    request: { query: SaveBidPackageAwardsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveBidPackageAwardsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AcceptBidPackageUpdatesDataOptions {
  acceptBidPackageIncomingUpdates?: BidPackage | BidPackageOptions;
}

export function newAcceptBidPackageUpdatesData(
  data: AcceptBidPackageUpdatesDataOptions,
): AcceptBidPackageUpdatesMutation {
  return {
    __typename: "Mutation" as const,
    acceptBidPackageIncomingUpdates: maybeNew("BidPackage", data["acceptBidPackageIncomingUpdates"] || undefined, {}),
  } as any;
}

export function newAcceptBidPackageUpdatesResponse(
  variables: AcceptBidPackageUpdatesMutationVariables,
  data: AcceptBidPackageUpdatesDataOptions | Error,
): MockedResponse<AcceptBidPackageUpdatesMutationVariables, AcceptBidPackageUpdatesMutation> {
  return {
    request: { query: AcceptBidPackageUpdatesDocument, variables },
    result: { data: data instanceof Error ? undefined : newAcceptBidPackageUpdatesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidUpdatesAvailable_BidPackageDataOptions {
  bidPackage?: BidPackage | BidPackageOptions;
}

export function newBidUpdatesAvailable_BidPackageData(
  data: BidUpdatesAvailable_BidPackageDataOptions,
): BidUpdatesAvailable_BidPackageQuery {
  return {
    __typename: "Query" as const,
    bidPackage: maybeNew("BidPackage", data["bidPackage"] || undefined, {}),
  } as any;
}

export function newBidUpdatesAvailable_BidPackageResponse(
  variables: BidUpdatesAvailable_BidPackageQueryVariables,
  data: BidUpdatesAvailable_BidPackageDataOptions | Error,
): MockedResponse<BidUpdatesAvailable_BidPackageQueryVariables, BidUpdatesAvailable_BidPackageQuery> {
  return {
    request: { query: BidUpdatesAvailable_BidPackageDocument, variables },
    result: { data: data instanceof Error ? undefined : newBidUpdatesAvailable_BidPackageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveBidPackageRequestDataOptions {
  saveBidPackageRequest?: SaveBidPackageRequestResult | SaveBidPackageRequestResultOptions;
}

export function newSaveBidPackageRequestData(data: SaveBidPackageRequestDataOptions): SaveBidPackageRequestMutation {
  return {
    __typename: "Mutation" as const,
    saveBidPackageRequest: maybeNew("SaveBidPackageRequestResult", data["saveBidPackageRequest"] || undefined, {}),
  } as any;
}

export function newSaveBidPackageRequestResponse(
  variables: SaveBidPackageRequestMutationVariables,
  data: SaveBidPackageRequestDataOptions | Error,
): MockedResponse<SaveBidPackageRequestMutationVariables, SaveBidPackageRequestMutation> {
  return {
    request: { query: SaveBidPackageRequestDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveBidPackageRequestData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ResendBidPackageRequestNotificationDataOptions {
  addJob?: EmptyResult | EmptyResultOptions;
}

export function newResendBidPackageRequestNotificationData(
  data: ResendBidPackageRequestNotificationDataOptions,
): ResendBidPackageRequestNotificationMutation {
  return { __typename: "Mutation" as const, addJob: maybeNew("EmptyResult", data["addJob"] || undefined, {}) } as any;
}

export function newResendBidPackageRequestNotificationResponse(
  variables: ResendBidPackageRequestNotificationMutationVariables,
  data: ResendBidPackageRequestNotificationDataOptions | Error,
): MockedResponse<ResendBidPackageRequestNotificationMutationVariables, ResendBidPackageRequestNotificationMutation> {
  return {
    request: { query: ResendBidPackageRequestNotificationDocument, variables },
    result: { data: data instanceof Error ? undefined : newResendBidPackageRequestNotificationData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillTermsTab_SaveBidContractRevisionDataOptions {
  saveBidContractRevision?: SaveBidContractRevisionResult | SaveBidContractRevisionResultOptions;
}

export function newBillTermsTab_SaveBidContractRevisionData(
  data: BillTermsTab_SaveBidContractRevisionDataOptions,
): BillTermsTab_SaveBidContractRevisionMutation {
  return {
    __typename: "Mutation" as const,
    saveBidContractRevision: maybeNew(
      "SaveBidContractRevisionResult",
      data["saveBidContractRevision"] || undefined,
      {},
    ),
  } as any;
}

export function newBillTermsTab_SaveBidContractRevisionResponse(
  variables: BillTermsTab_SaveBidContractRevisionMutationVariables,
  data: BillTermsTab_SaveBidContractRevisionDataOptions | Error,
): MockedResponse<BillTermsTab_SaveBidContractRevisionMutationVariables, BillTermsTab_SaveBidContractRevisionMutation> {
  return {
    request: { query: BillTermsTab_SaveBidContractRevisionDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillTermsTab_SaveBidContractRevisionData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillTermsTab_BasePlanGlobalPlanTasksDataOptions {
  bidPackage?: BidPackage | BidPackageOptions;
}

export function newBillTermsTab_BasePlanGlobalPlanTasksData(
  data: BillTermsTab_BasePlanGlobalPlanTasksDataOptions,
): BillTermsTab_BasePlanGlobalPlanTasksQuery {
  return {
    __typename: "Query" as const,
    bidPackage: maybeNew("BidPackage", data["bidPackage"] || undefined, {}),
  } as any;
}

export function newBillTermsTab_BasePlanGlobalPlanTasksResponse(
  variables: BillTermsTab_BasePlanGlobalPlanTasksQueryVariables,
  data: BillTermsTab_BasePlanGlobalPlanTasksDataOptions | Error,
): MockedResponse<BillTermsTab_BasePlanGlobalPlanTasksQueryVariables, BillTermsTab_BasePlanGlobalPlanTasksQuery> {
  return {
    request: { query: BillTermsTab_BasePlanGlobalPlanTasksDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillTermsTab_BasePlanGlobalPlanTasksData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface EditBidPackageDetailsStepDataOptions {
  bidScopeSourceDetail?: (BidScopeSourceDetail | BidScopeSourceDetailOptions)[];
  markets?: (Market | MarketOptions)[];
  costCodes?: (CostCode | CostCodeOptions)[];
}

export function newEditBidPackageDetailsStepData(
  data: EditBidPackageDetailsStepDataOptions,
): EditBidPackageDetailsStepQuery {
  return {
    __typename: "Query" as const,
    bidScopeSourceDetail: data["bidScopeSourceDetail"]?.map((d) => newBidScopeSourceDetail(d)) || [],
    markets: data["markets"]?.map((d) => newMarket(d)) || [],
    costCodes: data["costCodes"]?.map((d) => newCostCode(d)) || [],
  } as any;
}

export function newEditBidPackageDetailsStepResponse(
  data: EditBidPackageDetailsStepDataOptions | Error,
): MockedResponse<EditBidPackageDetailsStepQueryVariables, EditBidPackageDetailsStepQuery> {
  return {
    request: { query: EditBidPackageDetailsStepDocument },
    result: { data: data instanceof Error ? undefined : newEditBidPackageDetailsStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveBidPackageDataOptions {
  saveBidPackage?: SaveBidPackageResult | SaveBidPackageResultOptions;
}

export function newSaveBidPackageData(data: SaveBidPackageDataOptions): SaveBidPackageMutation {
  return {
    __typename: "Mutation" as const,
    saveBidPackage: maybeNew("SaveBidPackageResult", data["saveBidPackage"] || undefined, {}),
  } as any;
}

export function newSaveBidPackageResponse(
  variables: SaveBidPackageMutationVariables,
  data: SaveBidPackageDataOptions | Error,
): MockedResponse<SaveBidPackageMutationVariables, SaveBidPackageMutation> {
  return {
    request: { query: SaveBidPackageDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveBidPackageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface EditTradeContactsModalDataOptions {
  tradePartner?: TradePartner | TradePartnerOptions;
}

export function newEditTradeContactsModalData(data: EditTradeContactsModalDataOptions): EditTradeContactsModalQuery {
  return {
    __typename: "Query" as const,
    tradePartner: maybeNew("TradePartner", data["tradePartner"] || undefined, {}),
  } as any;
}

export function newEditTradeContactsModalResponse(
  variables: EditTradeContactsModalQueryVariables,
  data: EditTradeContactsModalDataOptions | Error,
): MockedResponse<EditTradeContactsModalQueryVariables, EditTradeContactsModalQuery> {
  return {
    request: { query: EditTradeContactsModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newEditTradeContactsModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface EditBidLineItemDataOptions {
  saveBidContractLineItem?: SaveBidContractLineItemResult | SaveBidContractLineItemResultOptions;
}

export function newEditBidLineItemData(data: EditBidLineItemDataOptions): EditBidLineItemMutation {
  return {
    __typename: "Mutation" as const,
    saveBidContractLineItem: maybeNew(
      "SaveBidContractLineItemResult",
      data["saveBidContractLineItem"] || undefined,
      {},
    ),
  } as any;
}

export function newEditBidLineItemResponse(
  variables: EditBidLineItemMutationVariables,
  data: EditBidLineItemDataOptions | Error,
): MockedResponse<EditBidLineItemMutationVariables, EditBidLineItemMutation> {
  return {
    request: { query: EditBidLineItemDocument, variables },
    result: { data: data instanceof Error ? undefined : newEditBidLineItemData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface EditBidRightPane_SaveBidContractDataOptions {
  saveBidContract?: SaveBidContractResult | SaveBidContractResultOptions;
}

export function newEditBidRightPane_SaveBidContractData(
  data: EditBidRightPane_SaveBidContractDataOptions,
): EditBidRightPane_SaveBidContractMutation {
  return {
    __typename: "Mutation" as const,
    saveBidContract: maybeNew("SaveBidContractResult", data["saveBidContract"] || undefined, {}),
  } as any;
}

export function newEditBidRightPane_SaveBidContractResponse(
  variables: EditBidRightPane_SaveBidContractMutationVariables,
  data: EditBidRightPane_SaveBidContractDataOptions | Error,
): MockedResponse<EditBidRightPane_SaveBidContractMutationVariables, EditBidRightPane_SaveBidContractMutation> {
  return {
    request: { query: EditBidRightPane_SaveBidContractDocument, variables },
    result: { data: data instanceof Error ? undefined : newEditBidRightPane_SaveBidContractData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface EditBidRightPane_SaveBidContractRevisionDataOptions {
  saveBidContractRevision?: SaveBidContractRevisionResult | SaveBidContractRevisionResultOptions;
}

export function newEditBidRightPane_SaveBidContractRevisionData(
  data: EditBidRightPane_SaveBidContractRevisionDataOptions,
): EditBidRightPane_SaveBidContractRevisionMutation {
  return {
    __typename: "Mutation" as const,
    saveBidContractRevision: maybeNew(
      "SaveBidContractRevisionResult",
      data["saveBidContractRevision"] || undefined,
      {},
    ),
  } as any;
}

export function newEditBidRightPane_SaveBidContractRevisionResponse(
  variables: EditBidRightPane_SaveBidContractRevisionMutationVariables,
  data: EditBidRightPane_SaveBidContractRevisionDataOptions | Error,
): MockedResponse<
  EditBidRightPane_SaveBidContractRevisionMutationVariables,
  EditBidRightPane_SaveBidContractRevisionMutation
> {
  return {
    request: { query: EditBidRightPane_SaveBidContractRevisionDocument, variables },
    result: { data: data instanceof Error ? undefined : newEditBidRightPane_SaveBidContractRevisionData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddProrationBidContractRevisionDataOptions {
  saveBidContractRevision?: SaveBidContractRevisionResult | SaveBidContractRevisionResultOptions;
}

export function newAddProrationBidContractRevisionData(
  data: AddProrationBidContractRevisionDataOptions,
): AddProrationBidContractRevisionMutation {
  return {
    __typename: "Mutation" as const,
    saveBidContractRevision: maybeNew(
      "SaveBidContractRevisionResult",
      data["saveBidContractRevision"] || undefined,
      {},
    ),
  } as any;
}

export function newAddProrationBidContractRevisionResponse(
  variables: AddProrationBidContractRevisionMutationVariables,
  data: AddProrationBidContractRevisionDataOptions | Error,
): MockedResponse<AddProrationBidContractRevisionMutationVariables, AddProrationBidContractRevisionMutation> {
  return {
    request: { query: AddProrationBidContractRevisionDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddProrationBidContractRevisionData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddProrationBidContractDataOptions {
  saveBidContract?: SaveBidContractResult | SaveBidContractResultOptions;
}

export function newAddProrationBidContractData(
  data: AddProrationBidContractDataOptions,
): AddProrationBidContractMutation {
  return {
    __typename: "Mutation" as const,
    saveBidContract: maybeNew("SaveBidContractResult", data["saveBidContract"] || undefined, {}),
  } as any;
}

export function newAddProrationBidContractResponse(
  variables: AddProrationBidContractMutationVariables,
  data: AddProrationBidContractDataOptions | Error,
): MockedResponse<AddProrationBidContractMutationVariables, AddProrationBidContractMutation> {
  return {
    request: { query: AddProrationBidContractDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddProrationBidContractData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveProrationTradeLineItemsDataOptions {
  saveBidContractTradeLineItems?: SaveBidContractTradeLineItemsResult | SaveBidContractTradeLineItemsResultOptions;
}

export function newSaveProrationTradeLineItemsData(
  data: SaveProrationTradeLineItemsDataOptions,
): SaveProrationTradeLineItemsMutation {
  return {
    __typename: "Mutation" as const,
    saveBidContractTradeLineItems: maybeNew(
      "SaveBidContractTradeLineItemsResult",
      data["saveBidContractTradeLineItems"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveProrationTradeLineItemsResponse(
  variables: SaveProrationTradeLineItemsMutationVariables,
  data: SaveProrationTradeLineItemsDataOptions | Error,
): MockedResponse<SaveProrationTradeLineItemsMutationVariables, SaveProrationTradeLineItemsMutation> {
  return {
    request: { query: SaveProrationTradeLineItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveProrationTradeLineItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface EditProratedBidRevisionDataOptions {
  bidContractRevision?: BidContractRevision | BidContractRevisionOptions;
}

export function newEditProratedBidRevisionData(data: EditProratedBidRevisionDataOptions): EditProratedBidRevisionQuery {
  return {
    __typename: "Query" as const,
    bidContractRevision: maybeNew("BidContractRevision", data["bidContractRevision"] || undefined, {}),
  } as any;
}

export function newEditProratedBidRevisionResponse(
  variables: EditProratedBidRevisionQueryVariables,
  data: EditProratedBidRevisionDataOptions | Error,
): MockedResponse<EditProratedBidRevisionQueryVariables, EditProratedBidRevisionQuery> {
  return {
    request: { query: EditProratedBidRevisionDocument, variables },
    result: { data: data instanceof Error ? undefined : newEditProratedBidRevisionData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanBasedBidsTable_AggregateVersionsDataOptions {
  bidPackageVersion?: BidPackageVersion | BidPackageVersionOptions;
}

export function newPlanBasedBidsTable_AggregateVersionsData(
  data: PlanBasedBidsTable_AggregateVersionsDataOptions,
): PlanBasedBidsTable_AggregateVersionsQuery {
  return {
    __typename: "Query" as const,
    bidPackageVersion: maybeNew("BidPackageVersion", data["bidPackageVersion"] || undefined, {}),
  } as any;
}

export function newPlanBasedBidsTable_AggregateVersionsResponse(
  variables: PlanBasedBidsTable_AggregateVersionsQueryVariables,
  data: PlanBasedBidsTable_AggregateVersionsDataOptions | Error,
): MockedResponse<PlanBasedBidsTable_AggregateVersionsQueryVariables, PlanBasedBidsTable_AggregateVersionsQuery> {
  return {
    request: { query: PlanBasedBidsTable_AggregateVersionsDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanBasedBidsTable_AggregateVersionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanBasedBidsTable_ScopeLinesDataOptions {
  bidPackageVersion?: BidPackageVersion | BidPackageVersionOptions;
  bidPackageVersionScopeLines?: (BidPackageScopeLine | BidPackageScopeLineOptions)[];
}

export function newPlanBasedBidsTable_ScopeLinesData(
  data: PlanBasedBidsTable_ScopeLinesDataOptions,
): PlanBasedBidsTable_ScopeLinesQuery {
  return {
    __typename: "Query" as const,
    bidPackageVersion: maybeNew("BidPackageVersion", data["bidPackageVersion"] || undefined, {}),
    bidPackageVersionScopeLines: data["bidPackageVersionScopeLines"]?.map((d) => newBidPackageScopeLine(d)) || [],
  } as any;
}

export function newPlanBasedBidsTable_ScopeLinesResponse(
  variables: PlanBasedBidsTable_ScopeLinesQueryVariables,
  data: PlanBasedBidsTable_ScopeLinesDataOptions | Error,
): MockedResponse<PlanBasedBidsTable_ScopeLinesQueryVariables, PlanBasedBidsTable_ScopeLinesQuery> {
  return {
    request: { query: PlanBasedBidsTable_ScopeLinesDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanBasedBidsTable_ScopeLinesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface UnitBasedBidsTableDataOptions {
  bidPackageVersion?: BidPackageVersion | BidPackageVersionOptions;
}

export function newUnitBasedBidsTableData(data: UnitBasedBidsTableDataOptions): UnitBasedBidsTableQuery {
  return {
    __typename: "Query" as const,
    bidPackageVersion: maybeNew("BidPackageVersion", data["bidPackageVersion"] || undefined, {}),
  } as any;
}

export function newUnitBasedBidsTableResponse(
  variables: UnitBasedBidsTableQueryVariables,
  data: UnitBasedBidsTableDataOptions | Error,
): MockedResponse<UnitBasedBidsTableQueryVariables, UnitBasedBidsTableQuery> {
  return {
    request: { query: UnitBasedBidsTableDocument, variables },
    result: { data: data instanceof Error ? undefined : newUnitBasedBidsTableData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveLienWaiverDocumentDataOptions {
  saveDocuments?: SaveDocumentsResult | SaveDocumentsResultOptions;
}

export function newSaveLienWaiverDocumentData(data: SaveLienWaiverDocumentDataOptions): SaveLienWaiverDocumentMutation {
  return {
    __typename: "Mutation" as const,
    saveDocuments: maybeNew("SaveDocumentsResult", data["saveDocuments"] || undefined, {}),
  } as any;
}

export function newSaveLienWaiverDocumentResponse(
  variables: SaveLienWaiverDocumentMutationVariables,
  data: SaveLienWaiverDocumentDataOptions | Error,
): MockedResponse<SaveLienWaiverDocumentMutationVariables, SaveLienWaiverDocumentMutation> {
  return {
    request: { query: SaveLienWaiverDocumentDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveLienWaiverDocumentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface OtherBillCellDataOptions {
  projectItem?: ProjectItem | ProjectItemOptions;
}

export function newOtherBillCellData(data: OtherBillCellDataOptions): OtherBillCellQuery {
  return {
    __typename: "Query" as const,
    projectItem: maybeNew("ProjectItem", data["projectItem"] || undefined, {}),
  } as any;
}

export function newOtherBillCellResponse(
  variables: OtherBillCellQueryVariables,
  data: OtherBillCellDataOptions | Error,
): MockedResponse<OtherBillCellQueryVariables, OtherBillCellQuery> {
  return {
    request: { query: OtherBillCellDocument, variables },
    result: { data: data instanceof Error ? undefined : newOtherBillCellData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddCommitmentPotentialLineItemsDataOptions {
  developmentCommitmentPotentialLineItems?:
    (DevelopmentCommitmentPotentialLineItem | DevelopmentCommitmentPotentialLineItemOptions)[];
}

export function newAddCommitmentPotentialLineItemsData(
  data: AddCommitmentPotentialLineItemsDataOptions,
): AddCommitmentPotentialLineItemsQuery {
  return {
    __typename: "Query" as const,
    developmentCommitmentPotentialLineItems:
      data["developmentCommitmentPotentialLineItems"]?.map((d) => newDevelopmentCommitmentPotentialLineItem(d)) || [],
  } as any;
}

export function newAddCommitmentPotentialLineItemsResponse(
  variables: AddCommitmentPotentialLineItemsQueryVariables,
  data: AddCommitmentPotentialLineItemsDataOptions | Error,
): MockedResponse<AddCommitmentPotentialLineItemsQueryVariables, AddCommitmentPotentialLineItemsQuery> {
  return {
    request: { query: AddCommitmentPotentialLineItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddCommitmentPotentialLineItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface UpdateDevelopmentCommitmentDataOptions {
  saveDevelopmentCommitment?: SaveDevelopmentCommitmentResult | SaveDevelopmentCommitmentResultOptions;
}

export function newUpdateDevelopmentCommitmentData(
  data: UpdateDevelopmentCommitmentDataOptions,
): UpdateDevelopmentCommitmentMutation {
  return {
    __typename: "Mutation" as const,
    saveDevelopmentCommitment: maybeNew(
      "SaveDevelopmentCommitmentResult",
      data["saveDevelopmentCommitment"] || undefined,
      {},
    ),
  } as any;
}

export function newUpdateDevelopmentCommitmentResponse(
  variables: UpdateDevelopmentCommitmentMutationVariables,
  data: UpdateDevelopmentCommitmentDataOptions | Error,
): MockedResponse<UpdateDevelopmentCommitmentMutationVariables, UpdateDevelopmentCommitmentMutation> {
  return {
    request: { query: UpdateDevelopmentCommitmentDocument, variables },
    result: { data: data instanceof Error ? undefined : newUpdateDevelopmentCommitmentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ApprovalSuperDrawerDataOptions {
  approval?: Approval | ApprovalOptions;
  currentUser?: User | UserOptions | null;
}

export function newApprovalSuperDrawerData(data: ApprovalSuperDrawerDataOptions): ApprovalSuperDrawerQuery {
  return {
    __typename: "Query" as const,
    approval: maybeNew("Approval", data["approval"] || undefined, {}),
    currentUser: maybeNewOrNull("User", data["currentUser"] || undefined, {}),
  } as any;
}

export function newApprovalSuperDrawerResponse(
  variables: ApprovalSuperDrawerQueryVariables,
  data: ApprovalSuperDrawerDataOptions | Error,
): MockedResponse<ApprovalSuperDrawerQueryVariables, ApprovalSuperDrawerQuery> {
  return {
    request: { query: ApprovalSuperDrawerDocument, variables },
    result: { data: data instanceof Error ? undefined : newApprovalSuperDrawerData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ApprovalSuperDrawer_SaveApprovalDataOptions {
  saveApproval?: SaveApprovalResult | SaveApprovalResultOptions;
}

export function newApprovalSuperDrawer_SaveApprovalData(
  data: ApprovalSuperDrawer_SaveApprovalDataOptions,
): ApprovalSuperDrawer_SaveApprovalMutation {
  return {
    __typename: "Mutation" as const,
    saveApproval: maybeNew("SaveApprovalResult", data["saveApproval"] || undefined, {}),
  } as any;
}

export function newApprovalSuperDrawer_SaveApprovalResponse(
  variables: ApprovalSuperDrawer_SaveApprovalMutationVariables,
  data: ApprovalSuperDrawer_SaveApprovalDataOptions | Error,
): MockedResponse<ApprovalSuperDrawer_SaveApprovalMutationVariables, ApprovalSuperDrawer_SaveApprovalMutation> {
  return {
    request: { query: ApprovalSuperDrawer_SaveApprovalDocument, variables },
    result: { data: data instanceof Error ? undefined : newApprovalSuperDrawer_SaveApprovalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateCommitmentDataDataOptions {
  tradePartners?: (TradePartner | TradePartnerOptions)[];
  stages?: (StageDetail | StageDetailOptions)[];
  projects?: (Project | ProjectOptions)[];
  developments?: (Development | DevelopmentOptions)[];
}

export function newCreateCommitmentDataData(data: CreateCommitmentDataDataOptions): CreateCommitmentDataQuery {
  return {
    __typename: "Query" as const,
    tradePartners: data["tradePartners"]?.map((d) => newTradePartner(d)) || [],
    stages: data["stages"]?.map((d) => newStageDetail(d)) || [],
    projects: data["projects"]?.map((d) => maybeNew("Project", d, {})) || [],
    developments: data["developments"]?.map((d) => newDevelopment(d)) || [],
  } as any;
}

export function newCreateCommitmentDataResponse(
  data: CreateCommitmentDataDataOptions | Error,
): MockedResponse<CreateCommitmentDataQueryVariables, CreateCommitmentDataQuery> {
  return {
    request: { query: CreateCommitmentDataDocument },
    result: { data: data instanceof Error ? undefined : newCreateCommitmentDataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateCommitmentPotentialLineItemsDataOptions {
  developmentCommitmentPotentialLineItems?:
    (DevelopmentCommitmentPotentialLineItem | DevelopmentCommitmentPotentialLineItemOptions)[];
}

export function newCreateCommitmentPotentialLineItemsData(
  data: CreateCommitmentPotentialLineItemsDataOptions,
): CreateCommitmentPotentialLineItemsQuery {
  return {
    __typename: "Query" as const,
    developmentCommitmentPotentialLineItems:
      data["developmentCommitmentPotentialLineItems"]?.map((d) => newDevelopmentCommitmentPotentialLineItem(d)) || [],
  } as any;
}

export function newCreateCommitmentPotentialLineItemsResponse(
  variables: CreateCommitmentPotentialLineItemsQueryVariables,
  data: CreateCommitmentPotentialLineItemsDataOptions | Error,
): MockedResponse<CreateCommitmentPotentialLineItemsQueryVariables, CreateCommitmentPotentialLineItemsQuery> {
  return {
    request: { query: CreateCommitmentPotentialLineItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateCommitmentPotentialLineItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateDevelopmentCommitmentDataOptions {
  saveDevelopmentCommitment?: SaveDevelopmentCommitmentResult | SaveDevelopmentCommitmentResultOptions;
}

export function newCreateDevelopmentCommitmentData(
  data: CreateDevelopmentCommitmentDataOptions,
): CreateDevelopmentCommitmentMutation {
  return {
    __typename: "Mutation" as const,
    saveDevelopmentCommitment: maybeNew(
      "SaveDevelopmentCommitmentResult",
      data["saveDevelopmentCommitment"] || undefined,
      {},
    ),
  } as any;
}

export function newCreateDevelopmentCommitmentResponse(
  variables: CreateDevelopmentCommitmentMutationVariables,
  data: CreateDevelopmentCommitmentDataOptions | Error,
): MockedResponse<CreateDevelopmentCommitmentMutationVariables, CreateDevelopmentCommitmentMutation> {
  return {
    request: { query: CreateDevelopmentCommitmentDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateDevelopmentCommitmentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentCommitmentLineItemsDataOptions {
  developmentCommitment?: DevelopmentCommitment | DevelopmentCommitmentOptions;
}

export function newDevelopmentCommitmentLineItemsData(
  data: DevelopmentCommitmentLineItemsDataOptions,
): DevelopmentCommitmentLineItemsQuery {
  return {
    __typename: "Query" as const,
    developmentCommitment: maybeNew("DevelopmentCommitment", data["developmentCommitment"] || undefined, {}),
  } as any;
}

export function newDevelopmentCommitmentLineItemsResponse(
  variables: DevelopmentCommitmentLineItemsQueryVariables,
  data: DevelopmentCommitmentLineItemsDataOptions | Error,
): MockedResponse<DevelopmentCommitmentLineItemsQueryVariables, DevelopmentCommitmentLineItemsQuery> {
  return {
    request: { query: DevelopmentCommitmentLineItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentCommitmentLineItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteCommitmentLineItemsDataOptions {
  deleteCommitmentLineItems?: EmptyResult | EmptyResultOptions;
}

export function newDeleteCommitmentLineItemsData(
  data: DeleteCommitmentLineItemsDataOptions,
): DeleteCommitmentLineItemsMutation {
  return {
    __typename: "Mutation" as const,
    deleteCommitmentLineItems: maybeNew("EmptyResult", data["deleteCommitmentLineItems"] || undefined, {}),
  } as any;
}

export function newDeleteCommitmentLineItemsResponse(
  variables: DeleteCommitmentLineItemsMutationVariables,
  data: DeleteCommitmentLineItemsDataOptions | Error,
): MockedResponse<DeleteCommitmentLineItemsMutationVariables, DeleteCommitmentLineItemsMutation> {
  return {
    request: { query: DeleteCommitmentLineItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteCommitmentLineItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveCommitmentLineItemsDataOptions {
  saveCommitment?: SaveCommitmentResult | SaveCommitmentResultOptions;
}

export function newSaveCommitmentLineItemsData(
  data: SaveCommitmentLineItemsDataOptions,
): SaveCommitmentLineItemsMutation {
  return {
    __typename: "Mutation" as const,
    saveCommitment: maybeNew("SaveCommitmentResult", data["saveCommitment"] || undefined, {}),
  } as any;
}

export function newSaveCommitmentLineItemsResponse(
  variables: SaveCommitmentLineItemsMutationVariables,
  data: SaveCommitmentLineItemsDataOptions | Error,
): MockedResponse<SaveCommitmentLineItemsMutationVariables, SaveCommitmentLineItemsMutation> {
  return {
    request: { query: SaveCommitmentLineItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveCommitmentLineItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentCommitmentHistoryTabDataOptions {
  developmentCommitment?: DevelopmentCommitment | DevelopmentCommitmentOptions;
}

export function newDevelopmentCommitmentHistoryTabData(
  data: DevelopmentCommitmentHistoryTabDataOptions,
): DevelopmentCommitmentHistoryTabQuery {
  return {
    __typename: "Query" as const,
    developmentCommitment: maybeNew("DevelopmentCommitment", data["developmentCommitment"] || undefined, {}),
  } as any;
}

export function newDevelopmentCommitmentHistoryTabResponse(
  variables: DevelopmentCommitmentHistoryTabQueryVariables,
  data: DevelopmentCommitmentHistoryTabDataOptions | Error,
): MockedResponse<DevelopmentCommitmentHistoryTabQueryVariables, DevelopmentCommitmentHistoryTabQuery> {
  return {
    request: { query: DevelopmentCommitmentHistoryTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentCommitmentHistoryTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentCommitmentOverviewTabDataOptions {
  developmentCommitment?: DevelopmentCommitment | DevelopmentCommitmentOptions;
  tradePartners?: (TradePartner | TradePartnerOptions)[];
  developments?: (Development | DevelopmentOptions)[];
}

export function newDevelopmentCommitmentOverviewTabData(
  data: DevelopmentCommitmentOverviewTabDataOptions,
): DevelopmentCommitmentOverviewTabQuery {
  return {
    __typename: "Query" as const,
    developmentCommitment: maybeNew("DevelopmentCommitment", data["developmentCommitment"] || undefined, {}),
    tradePartners: data["tradePartners"]?.map((d) => newTradePartner(d)) || [],
    developments: data["developments"]?.map((d) => newDevelopment(d)) || [],
  } as any;
}

export function newDevelopmentCommitmentOverviewTabResponse(
  variables: DevelopmentCommitmentOverviewTabQueryVariables,
  data: DevelopmentCommitmentOverviewTabDataOptions | Error,
): MockedResponse<DevelopmentCommitmentOverviewTabQueryVariables, DevelopmentCommitmentOverviewTabQuery> {
  return {
    request: { query: DevelopmentCommitmentOverviewTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentCommitmentOverviewTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveDevelopmentCommitmentDataOptions {
  saveDevelopmentCommitment?: SaveDevelopmentCommitmentResult | SaveDevelopmentCommitmentResultOptions;
}

export function newSaveDevelopmentCommitmentData(
  data: SaveDevelopmentCommitmentDataOptions,
): SaveDevelopmentCommitmentMutation {
  return {
    __typename: "Mutation" as const,
    saveDevelopmentCommitment: maybeNew(
      "SaveDevelopmentCommitmentResult",
      data["saveDevelopmentCommitment"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveDevelopmentCommitmentResponse(
  variables: SaveDevelopmentCommitmentMutationVariables,
  data: SaveDevelopmentCommitmentDataOptions | Error,
): MockedResponse<SaveDevelopmentCommitmentMutationVariables, SaveDevelopmentCommitmentMutation> {
  return {
    request: { query: SaveDevelopmentCommitmentDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveDevelopmentCommitmentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentCommitmentV2ProjectsTabDataOptions {
  developmentCommitment?: DevelopmentCommitment | DevelopmentCommitmentOptions;
}

export function newDevelopmentCommitmentV2ProjectsTabData(
  data: DevelopmentCommitmentV2ProjectsTabDataOptions,
): DevelopmentCommitmentV2ProjectsTabQuery {
  return {
    __typename: "Query" as const,
    developmentCommitment: maybeNew("DevelopmentCommitment", data["developmentCommitment"] || undefined, {}),
  } as any;
}

export function newDevelopmentCommitmentV2ProjectsTabResponse(
  variables: DevelopmentCommitmentV2ProjectsTabQueryVariables,
  data: DevelopmentCommitmentV2ProjectsTabDataOptions | Error,
): MockedResponse<DevelopmentCommitmentV2ProjectsTabQueryVariables, DevelopmentCommitmentV2ProjectsTabQuery> {
  return {
    request: { query: DevelopmentCommitmentV2ProjectsTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentCommitmentV2ProjectsTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteDevelopmentCommitmentProjectsAndCommitmentsDataOptions {
  deleteDevelopmentCommitmentProjectsAndCommitments?:
    | DeleteDevelopmentCommitmentProjectsAndCommitmentsResult
    | DeleteDevelopmentCommitmentProjectsAndCommitmentsResultOptions;
}

export function newDeleteDevelopmentCommitmentProjectsAndCommitmentsData(
  data: DeleteDevelopmentCommitmentProjectsAndCommitmentsDataOptions,
): DeleteDevelopmentCommitmentProjectsAndCommitmentsMutation {
  return {
    __typename: "Mutation" as const,
    deleteDevelopmentCommitmentProjectsAndCommitments: maybeNew(
      "DeleteDevelopmentCommitmentProjectsAndCommitmentsResult",
      data["deleteDevelopmentCommitmentProjectsAndCommitments"] || undefined,
      {},
    ),
  } as any;
}

export function newDeleteDevelopmentCommitmentProjectsAndCommitmentsResponse(
  variables: DeleteDevelopmentCommitmentProjectsAndCommitmentsMutationVariables,
  data: DeleteDevelopmentCommitmentProjectsAndCommitmentsDataOptions | Error,
): MockedResponse<
  DeleteDevelopmentCommitmentProjectsAndCommitmentsMutationVariables,
  DeleteDevelopmentCommitmentProjectsAndCommitmentsMutation
> {
  return {
    request: { query: DeleteDevelopmentCommitmentProjectsAndCommitmentsDocument, variables },
    result: {
      data: data instanceof Error ? undefined : newDeleteDevelopmentCommitmentProjectsAndCommitmentsData(data),
    },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentCommitmentScheduleAndScopeTabDataOptions {
  developmentCommitment?: DevelopmentCommitment | DevelopmentCommitmentOptions;
}

export function newDevelopmentCommitmentScheduleAndScopeTabData(
  data: DevelopmentCommitmentScheduleAndScopeTabDataOptions,
): DevelopmentCommitmentScheduleAndScopeTabQuery {
  return {
    __typename: "Query" as const,
    developmentCommitment: maybeNew("DevelopmentCommitment", data["developmentCommitment"] || undefined, {}),
  } as any;
}

export function newDevelopmentCommitmentScheduleAndScopeTabResponse(
  variables: DevelopmentCommitmentScheduleAndScopeTabQueryVariables,
  data: DevelopmentCommitmentScheduleAndScopeTabDataOptions | Error,
): MockedResponse<
  DevelopmentCommitmentScheduleAndScopeTabQueryVariables,
  DevelopmentCommitmentScheduleAndScopeTabQuery
> {
  return {
    request: { query: DevelopmentCommitmentScheduleAndScopeTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentCommitmentScheduleAndScopeTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AssignElevationListDataOptions {
  development?: Development | DevelopmentOptions;
}

export function newAssignElevationListData(data: AssignElevationListDataOptions): AssignElevationListQuery {
  return {
    __typename: "Query" as const,
    development: maybeNew("Development", data["development"] || undefined, {}),
  } as any;
}

export function newAssignElevationListResponse(
  variables: AssignElevationListQueryVariables,
  data: AssignElevationListDataOptions | Error,
): MockedResponse<AssignElevationListQueryVariables, AssignElevationListQuery> {
  return {
    request: { query: AssignElevationListDocument, variables },
    result: { data: data instanceof Error ? undefined : newAssignElevationListData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveElevationAssignmentDataOptions {
  saveDevelopmentOptions?: SaveDevelopmentOptionsResult | SaveDevelopmentOptionsResultOptions;
}

export function newSaveElevationAssignmentData(
  data: SaveElevationAssignmentDataOptions,
): SaveElevationAssignmentMutation {
  return {
    __typename: "Mutation" as const,
    saveDevelopmentOptions: maybeNew("SaveDevelopmentOptionsResult", data["saveDevelopmentOptions"] || undefined, {}),
  } as any;
}

export function newSaveElevationAssignmentResponse(
  variables: SaveElevationAssignmentMutationVariables,
  data: SaveElevationAssignmentDataOptions | Error,
): MockedResponse<SaveElevationAssignmentMutationVariables, SaveElevationAssignmentMutation> {
  return {
    request: { query: SaveElevationAssignmentDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveElevationAssignmentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ItemTemplateCostUpdatesDataOptions {
  bidContractRevision?: BidContractRevision | BidContractRevisionOptions;
}

export function newItemTemplateCostUpdatesData(data: ItemTemplateCostUpdatesDataOptions): ItemTemplateCostUpdatesQuery {
  return {
    __typename: "Query" as const,
    bidContractRevision: maybeNew("BidContractRevision", data["bidContractRevision"] || undefined, {}),
  } as any;
}

export function newItemTemplateCostUpdatesResponse(
  variables: ItemTemplateCostUpdatesQueryVariables,
  data: ItemTemplateCostUpdatesDataOptions | Error,
): MockedResponse<ItemTemplateCostUpdatesQueryVariables, ItemTemplateCostUpdatesQuery> {
  return {
    request: { query: ItemTemplateCostUpdatesDocument, variables },
    result: { data: data instanceof Error ? undefined : newItemTemplateCostUpdatesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SavePriceAgreementDocumentDataOptions {
  saveDocuments?: SaveDocumentsResult | SaveDocumentsResultOptions;
}

export function newSavePriceAgreementDocumentData(
  data: SavePriceAgreementDocumentDataOptions,
): SavePriceAgreementDocumentMutation {
  return {
    __typename: "Mutation" as const,
    saveDocuments: maybeNew("SaveDocumentsResult", data["saveDocuments"] || undefined, {}),
  } as any;
}

export function newSavePriceAgreementDocumentResponse(
  variables: SavePriceAgreementDocumentMutationVariables,
  data: SavePriceAgreementDocumentDataOptions | Error,
): MockedResponse<SavePriceAgreementDocumentMutationVariables, SavePriceAgreementDocumentMutation> {
  return {
    request: { query: SavePriceAgreementDocumentDocument, variables },
    result: { data: data instanceof Error ? undefined : newSavePriceAgreementDocumentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentScheduleItemMappingPageDataOptions {
  development?: Development | DevelopmentOptions;
}

export function newDevelopmentScheduleItemMappingPageData(
  data: DevelopmentScheduleItemMappingPageDataOptions,
): DevelopmentScheduleItemMappingPageQuery {
  return {
    __typename: "Query" as const,
    development: maybeNew("Development", data["development"] || undefined, {}),
  } as any;
}

export function newDevelopmentScheduleItemMappingPageResponse(
  variables: DevelopmentScheduleItemMappingPageQueryVariables,
  data: DevelopmentScheduleItemMappingPageDataOptions | Error,
): MockedResponse<DevelopmentScheduleItemMappingPageQueryVariables, DevelopmentScheduleItemMappingPageQuery> {
  return {
    request: { query: DevelopmentScheduleItemMappingPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentScheduleItemMappingPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface LotSummaryMetaDataDataOptions {
  development?: Development | DevelopmentOptions;
}

export function newLotSummaryMetaDataData(data: LotSummaryMetaDataDataOptions): LotSummaryMetaDataQuery {
  return {
    __typename: "Query" as const,
    development: maybeNew("Development", data["development"] || undefined, {}),
  } as any;
}

export function newLotSummaryMetaDataResponse(
  variables: LotSummaryMetaDataQueryVariables,
  data: LotSummaryMetaDataDataOptions | Error,
): MockedResponse<LotSummaryMetaDataQueryVariables, LotSummaryMetaDataQuery> {
  return {
    request: { query: LotSummaryMetaDataDocument, variables },
    result: { data: data instanceof Error ? undefined : newLotSummaryMetaDataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SubscribeToSequenceSheetDataOptions {
  followSequenceSheet?: FollowSequenceSheetResult | FollowSequenceSheetResultOptions;
}

export function newSubscribeToSequenceSheetData(
  data: SubscribeToSequenceSheetDataOptions,
): SubscribeToSequenceSheetMutation {
  return {
    __typename: "Mutation" as const,
    followSequenceSheet: maybeNew("FollowSequenceSheetResult", data["followSequenceSheet"] || undefined, {}),
  } as any;
}

export function newSubscribeToSequenceSheetResponse(
  variables: SubscribeToSequenceSheetMutationVariables,
  data: SubscribeToSequenceSheetDataOptions | Error,
): MockedResponse<SubscribeToSequenceSheetMutationVariables, SubscribeToSequenceSheetMutation> {
  return {
    request: { query: SubscribeToSequenceSheetDocument, variables },
    result: { data: data instanceof Error ? undefined : newSubscribeToSequenceSheetData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface VoidPOsStepDataOptions {
  bidContractRevision?: BidContractRevision | BidContractRevisionOptions;
}

export function newVoidPOsStepData(data: VoidPOsStepDataOptions): VoidPOsStepQuery {
  return {
    __typename: "Query" as const,
    bidContractRevision: maybeNew("BidContractRevision", data["bidContractRevision"] || undefined, {}),
  } as any;
}

export function newVoidPOsStepResponse(
  variables: VoidPOsStepQueryVariables,
  data: VoidPOsStepDataOptions | Error,
): MockedResponse<VoidPOsStepQueryVariables, VoidPOsStepQuery> {
  return {
    request: { query: VoidPOsStepDocument, variables },
    result: { data: data instanceof Error ? undefined : newVoidPOsStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface LotSummaryChartsDataOptions {
  developmentLotSummaryCharts?: DevelopmentLotSummaryChartsResult | DevelopmentLotSummaryChartsResultOptions | null;
}

export function newLotSummaryChartsData(data: LotSummaryChartsDataOptions): LotSummaryChartsQuery {
  return {
    __typename: "Query" as const,
    developmentLotSummaryCharts: maybeNewOrNull(
      "DevelopmentLotSummaryChartsResult",
      data["developmentLotSummaryCharts"] || undefined,
      {},
    ),
  } as any;
}

export function newLotSummaryChartsResponse(
  variables: LotSummaryChartsQueryVariables,
  data: LotSummaryChartsDataOptions | Error,
): MockedResponse<LotSummaryChartsQueryVariables, LotSummaryChartsQuery> {
  return {
    request: { query: LotSummaryChartsDocument, variables },
    result: { data: data instanceof Error ? undefined : newLotSummaryChartsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ReleasePOsStepDataOptions {
  bidContractRevision?: BidContractRevision | BidContractRevisionOptions;
}

export function newReleasePOsStepData(data: ReleasePOsStepDataOptions): ReleasePOsStepQuery {
  return {
    __typename: "Query" as const,
    bidContractRevision: maybeNew("BidContractRevision", data["bidContractRevision"] || undefined, {}),
  } as any;
}

export function newReleasePOsStepResponse(
  variables: ReleasePOsStepQueryVariables,
  data: ReleasePOsStepDataOptions | Error,
): MockedResponse<ReleasePOsStepQueryVariables, ReleasePOsStepQuery> {
  return {
    request: { query: ReleasePOsStepDocument, variables },
    result: { data: data instanceof Error ? undefined : newReleasePOsStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface UpdateCommitmentAutoReleaseStatusDataOptions {
  saveCommitments?: SaveCommitmentsResult | SaveCommitmentsResultOptions;
  releaseBidCommitments?: (CommitmentLike | CommitmentLikeOptions)[];
}

export function newUpdateCommitmentAutoReleaseStatusData(
  data: UpdateCommitmentAutoReleaseStatusDataOptions,
): UpdateCommitmentAutoReleaseStatusMutation {
  return {
    __typename: "Mutation" as const,
    saveCommitments: maybeNew("SaveCommitmentsResult", data["saveCommitments"] || undefined, {}),
    releaseBidCommitments: data["releaseBidCommitments"]?.map((d) => maybeNew("CommitmentLike", d, {})) || [],
  } as any;
}

export function newUpdateCommitmentAutoReleaseStatusResponse(
  variables: UpdateCommitmentAutoReleaseStatusMutationVariables,
  data: UpdateCommitmentAutoReleaseStatusDataOptions | Error,
): MockedResponse<UpdateCommitmentAutoReleaseStatusMutationVariables, UpdateCommitmentAutoReleaseStatusMutation> {
  return {
    request: { query: UpdateCommitmentAutoReleaseStatusDocument, variables },
    result: { data: data instanceof Error ? undefined : newUpdateCommitmentAutoReleaseStatusData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ReadyPlansListDataOptions {
  readyPlans?: (ReadyPlan | ReadyPlanOptions)[];
}

export function newReadyPlansListData(data: ReadyPlansListDataOptions): ReadyPlansListQuery {
  return { __typename: "Query" as const, readyPlans: data["readyPlans"]?.map((d) => newReadyPlan(d)) || [] } as any;
}

export function newReadyPlansListResponse(
  variables: ReadyPlansListQueryVariables,
  data: ReadyPlansListDataOptions | Error,
): MockedResponse<ReadyPlansListQueryVariables, ReadyPlansListQuery> {
  return {
    request: { query: ReadyPlansListDocument, variables },
    result: { data: data instanceof Error ? undefined : newReadyPlansListData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ReadyPlanPageMetadataDataOptions {
  readyPlans?: (ReadyPlan | ReadyPlanOptions)[];
  globalOptionTypes?: (GlobalOptionType | GlobalOptionTypeOptions)[];
  locations?: (Location | LocationOptions)[];
  globalOptionTags?: (GlobalOptionTag | GlobalOptionTagOptions)[];
  readyPlanStatuses?: (ReadyPlanStatusDetail | ReadyPlanStatusDetailOptions)[];
  currentUser?: User | UserOptions | null;
}

export function newReadyPlanPageMetadataData(data: ReadyPlanPageMetadataDataOptions): ReadyPlanPageMetadataQuery {
  return {
    __typename: "Query" as const,
    readyPlans: data["readyPlans"]?.map((d) => newReadyPlan(d)) || [],
    globalOptionTypes: data["globalOptionTypes"]?.map((d) => newGlobalOptionType(d)) || [],
    locations: data["locations"]?.map((d) => newLocation(d)) || [],
    globalOptionTags: data["globalOptionTags"]?.map((d) => newGlobalOptionTag(d)) || [],
    readyPlanStatuses: data["readyPlanStatuses"]?.map((d) => newReadyPlanStatusDetail(d)) || [],
    currentUser: maybeNewOrNull("User", data["currentUser"] || undefined, {}),
  } as any;
}

export function newReadyPlanPageMetadataResponse(
  variables: ReadyPlanPageMetadataQueryVariables,
  data: ReadyPlanPageMetadataDataOptions | Error,
): MockedResponse<ReadyPlanPageMetadataQueryVariables, ReadyPlanPageMetadataQuery> {
  return {
    request: { query: ReadyPlanPageMetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newReadyPlanPageMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ReadyPlanOptionsListDataOptions {
  readyPlanOptions?: (ReadyPlanOption | ReadyPlanOptionOptions)[];
}

export function newReadyPlanOptionsListData(data: ReadyPlanOptionsListDataOptions): ReadyPlanOptionsListQuery {
  return {
    __typename: "Query" as const,
    readyPlanOptions: data["readyPlanOptions"]?.map((d) => newReadyPlanOption(d)) || [],
  } as any;
}

export function newReadyPlanOptionsListResponse(
  variables: ReadyPlanOptionsListQueryVariables,
  data: ReadyPlanOptionsListDataOptions | Error,
): MockedResponse<ReadyPlanOptionsListQueryVariables, ReadyPlanOptionsListQuery> {
  return {
    request: { query: ReadyPlanOptionsListDocument, variables },
    result: { data: data instanceof Error ? undefined : newReadyPlanOptionsListData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveReadyPlanDataOptions {
  saveReadyPlan?: SaveReadyPlanResult | SaveReadyPlanResultOptions;
}

export function newSaveReadyPlanData(data: SaveReadyPlanDataOptions): SaveReadyPlanMutation {
  return {
    __typename: "Mutation" as const,
    saveReadyPlan: maybeNew("SaveReadyPlanResult", data["saveReadyPlan"] || undefined, {}),
  } as any;
}

export function newSaveReadyPlanResponse(
  variables: SaveReadyPlanMutationVariables,
  data: SaveReadyPlanDataOptions | Error,
): MockedResponse<SaveReadyPlanMutationVariables, SaveReadyPlanMutation> {
  return {
    request: { query: SaveReadyPlanDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveReadyPlanData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveReadyPlanOptionsModalDataOptions {
  saveReadyPlanOptions?: SaveReadyPlanOptionsResult | SaveReadyPlanOptionsResultOptions;
}

export function newSaveReadyPlanOptionsModalData(
  data: SaveReadyPlanOptionsModalDataOptions,
): SaveReadyPlanOptionsModalMutation {
  return {
    __typename: "Mutation" as const,
    saveReadyPlanOptions: maybeNew("SaveReadyPlanOptionsResult", data["saveReadyPlanOptions"] || undefined, {}),
  } as any;
}

export function newSaveReadyPlanOptionsModalResponse(
  variables: SaveReadyPlanOptionsModalMutationVariables,
  data: SaveReadyPlanOptionsModalDataOptions | Error,
): MockedResponse<SaveReadyPlanOptionsModalMutationVariables, SaveReadyPlanOptionsModalMutation> {
  return {
    request: { query: SaveReadyPlanOptionsModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveReadyPlanOptionsModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddOptionsPageDataOptions {
  readyPlan?: ReadyPlan | ReadyPlanOptions;
  globalOptionTypes?: (GlobalOptionType | GlobalOptionTypeOptions)[];
}

export function newAddOptionsPageData(data: AddOptionsPageDataOptions): AddOptionsPageQuery {
  return {
    __typename: "Query" as const,
    readyPlan: maybeNew("ReadyPlan", data["readyPlan"] || undefined, {}),
    globalOptionTypes: data["globalOptionTypes"]?.map((d) => newGlobalOptionType(d)) || [],
  } as any;
}

export function newAddOptionsPageResponse(
  variables: AddOptionsPageQueryVariables,
  data: AddOptionsPageDataOptions | Error,
): MockedResponse<AddOptionsPageQueryVariables, AddOptionsPageQuery> {
  return {
    request: { query: AddOptionsPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddOptionsPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddOptionsMetadataDataOptions {
  enumDetails?: AllEnumDetails | AllEnumDetailsOptions;
}

export function newAddOptionsMetadataData(data: AddOptionsMetadataDataOptions): AddOptionsMetadataQuery {
  return {
    __typename: "Query" as const,
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
  } as any;
}

export function newAddOptionsMetadataResponse(
  data: AddOptionsMetadataDataOptions | Error,
): MockedResponse<AddOptionsMetadataQueryVariables, AddOptionsMetadataQuery> {
  return {
    request: { query: AddOptionsMetadataDocument },
    result: { data: data instanceof Error ? undefined : newAddOptionsMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveReadyPlanOptionsDataOptions {
  saveReadyPlanOptions?: SaveReadyPlanOptionsResult | SaveReadyPlanOptionsResultOptions;
}

export function newSaveReadyPlanOptionsData(data: SaveReadyPlanOptionsDataOptions): SaveReadyPlanOptionsMutation {
  return {
    __typename: "Mutation" as const,
    saveReadyPlanOptions: maybeNew("SaveReadyPlanOptionsResult", data["saveReadyPlanOptions"] || undefined, {}),
  } as any;
}

export function newSaveReadyPlanOptionsResponse(
  variables: SaveReadyPlanOptionsMutationVariables,
  data: SaveReadyPlanOptionsDataOptions | Error,
): MockedResponse<SaveReadyPlanOptionsMutationVariables, SaveReadyPlanOptionsMutation> {
  return {
    request: { query: SaveReadyPlanOptionsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveReadyPlanOptionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveReadyPlanOptionProgramDataModificationDataOptions {
  saveReadyPlanOptionProgramDataModifications?:
    | SaveReadyPlanOptionProgramDataModificationsResult
    | SaveReadyPlanOptionProgramDataModificationsResultOptions;
}

export function newSaveReadyPlanOptionProgramDataModificationData(
  data: SaveReadyPlanOptionProgramDataModificationDataOptions,
): SaveReadyPlanOptionProgramDataModificationMutation {
  return {
    __typename: "Mutation" as const,
    saveReadyPlanOptionProgramDataModifications: maybeNew(
      "SaveReadyPlanOptionProgramDataModificationsResult",
      data["saveReadyPlanOptionProgramDataModifications"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveReadyPlanOptionProgramDataModificationResponse(
  variables: SaveReadyPlanOptionProgramDataModificationMutationVariables,
  data: SaveReadyPlanOptionProgramDataModificationDataOptions | Error,
): MockedResponse<
  SaveReadyPlanOptionProgramDataModificationMutationVariables,
  SaveReadyPlanOptionProgramDataModificationMutation
> {
  return {
    request: { query: SaveReadyPlanOptionProgramDataModificationDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveReadyPlanOptionProgramDataModificationData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteReadyPlanOptionProgramDataModificationDataOptions {
  deleteReadyPlanOptionProgramDataModifications?:
    (
      | DeleteReadyPlanOptionProgramDataModificationsResult
      | DeleteReadyPlanOptionProgramDataModificationsResultOptions
    )[];
}

export function newDeleteReadyPlanOptionProgramDataModificationData(
  data: DeleteReadyPlanOptionProgramDataModificationDataOptions,
): DeleteReadyPlanOptionProgramDataModificationMutation {
  return {
    __typename: "Mutation" as const,
    deleteReadyPlanOptionProgramDataModifications: data["deleteReadyPlanOptionProgramDataModifications"]?.map((d) =>
      newDeleteReadyPlanOptionProgramDataModificationsResult(d)
    ) || [],
  } as any;
}

export function newDeleteReadyPlanOptionProgramDataModificationResponse(
  variables: DeleteReadyPlanOptionProgramDataModificationMutationVariables,
  data: DeleteReadyPlanOptionProgramDataModificationDataOptions | Error,
): MockedResponse<
  DeleteReadyPlanOptionProgramDataModificationMutationVariables,
  DeleteReadyPlanOptionProgramDataModificationMutation
> {
  return {
    request: { query: DeleteReadyPlanOptionProgramDataModificationDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteReadyPlanOptionProgramDataModificationData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidContractRevisionOverviewDataOptions {
  bidContractRevision?: BidContractRevision | BidContractRevisionOptions;
}

export function newBidContractRevisionOverviewData(
  data: BidContractRevisionOverviewDataOptions,
): BidContractRevisionOverviewQuery {
  return {
    __typename: "Query" as const,
    bidContractRevision: maybeNew("BidContractRevision", data["bidContractRevision"] || undefined, {}),
  } as any;
}

export function newBidContractRevisionOverviewResponse(
  variables: BidContractRevisionOverviewQueryVariables,
  data: BidContractRevisionOverviewDataOptions | Error,
): MockedResponse<BidContractRevisionOverviewQueryVariables, BidContractRevisionOverviewQuery> {
  return {
    request: { query: BidContractRevisionOverviewDocument, variables },
    result: { data: data instanceof Error ? undefined : newBidContractRevisionOverviewData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidContractDataOptions {
  bidContract?: BidContract | BidContractOptions;
}

export function newBidContractData(data: BidContractDataOptions): BidContractQuery {
  return {
    __typename: "Query" as const,
    bidContract: maybeNew("BidContract", data["bidContract"] || undefined, {}),
  } as any;
}

export function newBidContractResponse(
  variables: BidContractQueryVariables,
  data: BidContractDataOptions | Error,
): MockedResponse<BidContractQueryVariables, BidContractQuery> {
  return {
    request: { query: BidContractDocument, variables },
    result: { data: data instanceof Error ? undefined : newBidContractData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveBidContractDataOptions {
  saveBidContract?: SaveBidContractResult | SaveBidContractResultOptions;
}

export function newSaveBidContractData(data: SaveBidContractDataOptions): SaveBidContractMutation {
  return {
    __typename: "Mutation" as const,
    saveBidContract: maybeNew("SaveBidContractResult", data["saveBidContract"] || undefined, {}),
  } as any;
}

export function newSaveBidContractResponse(
  variables: SaveBidContractMutationVariables,
  data: SaveBidContractDataOptions | Error,
): MockedResponse<SaveBidContractMutationVariables, SaveBidContractMutation> {
  return {
    request: { query: SaveBidContractDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveBidContractData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidContractRevisionDataOptions {
  bidContractRevision?: BidContractRevision | BidContractRevisionOptions;
}

export function newBidContractRevisionData(data: BidContractRevisionDataOptions): BidContractRevisionQuery {
  return {
    __typename: "Query" as const,
    bidContractRevision: maybeNew("BidContractRevision", data["bidContractRevision"] || undefined, {}),
  } as any;
}

export function newBidContractRevisionResponse(
  variables: BidContractRevisionQueryVariables,
  data: BidContractRevisionDataOptions | Error,
): MockedResponse<BidContractRevisionQueryVariables, BidContractRevisionQuery> {
  return {
    request: { query: BidContractRevisionDocument, variables },
    result: { data: data instanceof Error ? undefined : newBidContractRevisionData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveBidContractRevisionDataOptions {
  saveBidContractRevision?: SaveBidContractRevisionResult | SaveBidContractRevisionResultOptions;
}

export function newSaveBidContractRevisionData(
  data: SaveBidContractRevisionDataOptions,
): SaveBidContractRevisionMutation {
  return {
    __typename: "Mutation" as const,
    saveBidContractRevision: maybeNew(
      "SaveBidContractRevisionResult",
      data["saveBidContractRevision"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveBidContractRevisionResponse(
  variables: SaveBidContractRevisionMutationVariables,
  data: SaveBidContractRevisionDataOptions | Error,
): MockedResponse<SaveBidContractRevisionMutationVariables, SaveBidContractRevisionMutation> {
  return {
    request: { query: SaveBidContractRevisionDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveBidContractRevisionData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface InternallySignBidContractRevisionDataOptions {
  internallySignBidContractRevision?: BidContractRevision | BidContractRevisionOptions;
}

export function newInternallySignBidContractRevisionData(
  data: InternallySignBidContractRevisionDataOptions,
): InternallySignBidContractRevisionMutation {
  return {
    __typename: "Mutation" as const,
    internallySignBidContractRevision: maybeNew(
      "BidContractRevision",
      data["internallySignBidContractRevision"] || undefined,
      {},
    ),
  } as any;
}

export function newInternallySignBidContractRevisionResponse(
  variables: InternallySignBidContractRevisionMutationVariables,
  data: InternallySignBidContractRevisionDataOptions | Error,
): MockedResponse<InternallySignBidContractRevisionMutationVariables, InternallySignBidContractRevisionMutation> {
  return {
    request: { query: InternallySignBidContractRevisionDocument, variables },
    result: { data: data instanceof Error ? undefined : newInternallySignBidContractRevisionData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteBidContractRevisionDataOptions {
  deleteBidContractRevision?: EmptyResult | EmptyResultOptions;
}

export function newDeleteBidContractRevisionData(
  data: DeleteBidContractRevisionDataOptions,
): DeleteBidContractRevisionMutation {
  return {
    __typename: "Mutation" as const,
    deleteBidContractRevision: maybeNew("EmptyResult", data["deleteBidContractRevision"] || undefined, {}),
  } as any;
}

export function newDeleteBidContractRevisionResponse(
  variables: DeleteBidContractRevisionMutationVariables,
  data: DeleteBidContractRevisionDataOptions | Error,
): MockedResponse<DeleteBidContractRevisionMutationVariables, DeleteBidContractRevisionMutation> {
  return {
    request: { query: DeleteBidContractRevisionDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteBidContractRevisionData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidContractRevisionLineItemsPageDataOptions {
  bidContractRevision?: BidContractRevision | BidContractRevisionOptions;
}

export function newBidContractRevisionLineItemsPageData(
  data: BidContractRevisionLineItemsPageDataOptions,
): BidContractRevisionLineItemsPageQuery {
  return {
    __typename: "Query" as const,
    bidContractRevision: maybeNew("BidContractRevision", data["bidContractRevision"] || undefined, {}),
  } as any;
}

export function newBidContractRevisionLineItemsPageResponse(
  variables: BidContractRevisionLineItemsPageQueryVariables,
  data: BidContractRevisionLineItemsPageDataOptions | Error,
): MockedResponse<BidContractRevisionLineItemsPageQueryVariables, BidContractRevisionLineItemsPageQuery> {
  return {
    request: { query: BidContractRevisionLineItemsPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newBidContractRevisionLineItemsPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveBidContractLineItemDataOptions {
  saveBidContractLineItem?: SaveBidContractLineItemResult | SaveBidContractLineItemResultOptions;
}

export function newSaveBidContractLineItemData(
  data: SaveBidContractLineItemDataOptions,
): SaveBidContractLineItemMutation {
  return {
    __typename: "Mutation" as const,
    saveBidContractLineItem: maybeNew(
      "SaveBidContractLineItemResult",
      data["saveBidContractLineItem"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveBidContractLineItemResponse(
  variables: SaveBidContractLineItemMutationVariables,
  data: SaveBidContractLineItemDataOptions | Error,
): MockedResponse<SaveBidContractLineItemMutationVariables, SaveBidContractLineItemMutation> {
  return {
    request: { query: SaveBidContractLineItemDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveBidContractLineItemData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteBidContractLineItemsDataOptions {
  deleteBidContractLineItems?: DeleteBidContractLineItemResult | DeleteBidContractLineItemResultOptions;
}

export function newDeleteBidContractLineItemsData(
  data: DeleteBidContractLineItemsDataOptions,
): DeleteBidContractLineItemsMutation {
  return {
    __typename: "Mutation" as const,
    deleteBidContractLineItems: maybeNew(
      "DeleteBidContractLineItemResult",
      data["deleteBidContractLineItems"] || undefined,
      {},
    ),
  } as any;
}

export function newDeleteBidContractLineItemsResponse(
  variables: DeleteBidContractLineItemsMutationVariables,
  data: DeleteBidContractLineItemsDataOptions | Error,
): MockedResponse<DeleteBidContractLineItemsMutationVariables, DeleteBidContractLineItemsMutation> {
  return {
    request: { query: DeleteBidContractLineItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteBidContractLineItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveBidContractLineItemsDataOptions {
  saveBidContractLineItems?: SaveBidContractLineItemsResult | SaveBidContractLineItemsResultOptions;
}

export function newSaveBidContractLineItemsData(
  data: SaveBidContractLineItemsDataOptions,
): SaveBidContractLineItemsMutation {
  return {
    __typename: "Mutation" as const,
    saveBidContractLineItems: maybeNew(
      "SaveBidContractLineItemsResult",
      data["saveBidContractLineItems"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveBidContractLineItemsResponse(
  variables: SaveBidContractLineItemsMutationVariables,
  data: SaveBidContractLineItemsDataOptions | Error,
): MockedResponse<SaveBidContractLineItemsMutationVariables, SaveBidContractLineItemsMutation> {
  return {
    request: { query: SaveBidContractLineItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveBidContractLineItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentContractDataOptions {
  development?: Development | DevelopmentOptions;
}

export function newDevelopmentContractData(data: DevelopmentContractDataOptions): DevelopmentContractQuery {
  return {
    __typename: "Query" as const,
    development: maybeNew("Development", data["development"] || undefined, {}),
  } as any;
}

export function newDevelopmentContractResponse(
  variables: DevelopmentContractQueryVariables,
  data: DevelopmentContractDataOptions | Error,
): MockedResponse<DevelopmentContractQueryVariables, DevelopmentContractQuery> {
  return {
    request: { query: DevelopmentContractDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentContractData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentProcurementDataOptions {
  development?: Development | DevelopmentOptions;
}

export function newDevelopmentProcurementData(data: DevelopmentProcurementDataOptions): DevelopmentProcurementQuery {
  return {
    __typename: "Query" as const,
    development: maybeNew("Development", data["development"] || undefined, {}),
  } as any;
}

export function newDevelopmentProcurementResponse(
  variables: DevelopmentProcurementQueryVariables,
  data: DevelopmentProcurementDataOptions | Error,
): MockedResponse<DevelopmentProcurementQueryVariables, DevelopmentProcurementQuery> {
  return {
    request: { query: DevelopmentProcurementDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentProcurementData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ComputeProductOfferingConfigCostsDataOptions {
  computeProductOfferingConfigCosts?:
    | ComputeProductOfferingConfigCostsResult
    | ComputeProductOfferingConfigCostsResultOptions;
}

export function newComputeProductOfferingConfigCostsData(
  data: ComputeProductOfferingConfigCostsDataOptions,
): ComputeProductOfferingConfigCostsQuery {
  return {
    __typename: "Query" as const,
    computeProductOfferingConfigCosts: maybeNew(
      "ComputeProductOfferingConfigCostsResult",
      data["computeProductOfferingConfigCosts"] || undefined,
      {},
    ),
  } as any;
}

export function newComputeProductOfferingConfigCostsResponse(
  variables: ComputeProductOfferingConfigCostsQueryVariables,
  data: ComputeProductOfferingConfigCostsDataOptions | Error,
): MockedResponse<ComputeProductOfferingConfigCostsQueryVariables, ComputeProductOfferingConfigCostsQuery> {
  return {
    request: { query: ComputeProductOfferingConfigCostsDocument, variables },
    result: { data: data instanceof Error ? undefined : newComputeProductOfferingConfigCostsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface FilteredProjectsTableDataOptions {
  projectsPage?: ProjectsPageResult | ProjectsPageResultOptions;
}

export function newFilteredProjectsTableData(data: FilteredProjectsTableDataOptions): FilteredProjectsTableQuery {
  return {
    __typename: "Query" as const,
    projectsPage: maybeNew("ProjectsPageResult", data["projectsPage"] || undefined, {}),
  } as any;
}

export function newFilteredProjectsTableResponse(
  variables: FilteredProjectsTableQueryVariables,
  data: FilteredProjectsTableDataOptions | Error,
): MockedResponse<FilteredProjectsTableQueryVariables, FilteredProjectsTableQuery> {
  return {
    request: { query: FilteredProjectsTableDocument, variables },
    result: { data: data instanceof Error ? undefined : newFilteredProjectsTableData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProductOfferingApplyToProjectDataOptions {
  applyProjectReadyPlanConfigs?: ApplyProjectReadyPlanConfigsResult | ApplyProjectReadyPlanConfigsResultOptions;
}

export function newProductOfferingApplyToProjectData(
  data: ProductOfferingApplyToProjectDataOptions,
): ProductOfferingApplyToProjectMutation {
  return {
    __typename: "Mutation" as const,
    applyProjectReadyPlanConfigs: maybeNew(
      "ApplyProjectReadyPlanConfigsResult",
      data["applyProjectReadyPlanConfigs"] || undefined,
      {},
    ),
  } as any;
}

export function newProductOfferingApplyToProjectResponse(
  variables: ProductOfferingApplyToProjectMutationVariables,
  data: ProductOfferingApplyToProjectDataOptions | Error,
): MockedResponse<ProductOfferingApplyToProjectMutationVariables, ProductOfferingApplyToProjectMutation> {
  return {
    request: { query: ProductOfferingApplyToProjectDocument, variables },
    result: { data: data instanceof Error ? undefined : newProductOfferingApplyToProjectData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProductOfferingPageDataOptions {
  productOffering?: ProductOffering | ProductOfferingOptions;
}

export function newProductOfferingPageData(data: ProductOfferingPageDataOptions): ProductOfferingPageQuery {
  return {
    __typename: "Query" as const,
    productOffering: maybeNew("ProductOffering", data["productOffering"] || undefined, {}),
  } as any;
}

export function newProductOfferingPageResponse(
  variables: ProductOfferingPageQueryVariables,
  data: ProductOfferingPageDataOptions | Error,
): MockedResponse<ProductOfferingPageQueryVariables, ProductOfferingPageQuery> {
  return {
    request: { query: ProductOfferingPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newProductOfferingPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProductOffering_SaveProductOfferingDataOptions {
  saveProductOffering?: SaveProductOfferingResult | SaveProductOfferingResultOptions;
}

export function newProductOffering_SaveProductOfferingData(
  data: ProductOffering_SaveProductOfferingDataOptions,
): ProductOffering_SaveProductOfferingMutation {
  return {
    __typename: "Mutation" as const,
    saveProductOffering: maybeNew("SaveProductOfferingResult", data["saveProductOffering"] || undefined, {}),
  } as any;
}

export function newProductOffering_SaveProductOfferingResponse(
  variables: ProductOffering_SaveProductOfferingMutationVariables,
  data: ProductOffering_SaveProductOfferingDataOptions | Error,
): MockedResponse<ProductOffering_SaveProductOfferingMutationVariables, ProductOffering_SaveProductOfferingMutation> {
  return {
    request: { query: ProductOffering_SaveProductOfferingDocument, variables },
    result: { data: data instanceof Error ? undefined : newProductOffering_SaveProductOfferingData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProductOffering_PromoteToCheckoutDataOptions {
  promoteToCheckout?: EmptyResult | EmptyResultOptions;
}

export function newProductOffering_PromoteToCheckoutData(
  data: ProductOffering_PromoteToCheckoutDataOptions,
): ProductOffering_PromoteToCheckoutMutation {
  return {
    __typename: "Mutation" as const,
    promoteToCheckout: maybeNew("EmptyResult", data["promoteToCheckout"] || undefined, {}),
  } as any;
}

export function newProductOffering_PromoteToCheckoutResponse(
  variables: ProductOffering_PromoteToCheckoutMutationVariables,
  data: ProductOffering_PromoteToCheckoutDataOptions | Error,
): MockedResponse<ProductOffering_PromoteToCheckoutMutationVariables, ProductOffering_PromoteToCheckoutMutation> {
  return {
    request: { query: ProductOffering_PromoteToCheckoutDocument, variables },
    result: { data: data instanceof Error ? undefined : newProductOffering_PromoteToCheckoutData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProductOffering_RunCheckoutPricingReportDataOptions {
  runCheckoutPricingReport?: RunCheckoutPricingReportResult | RunCheckoutPricingReportResultOptions;
}

export function newProductOffering_RunCheckoutPricingReportData(
  data: ProductOffering_RunCheckoutPricingReportDataOptions,
): ProductOffering_RunCheckoutPricingReportMutation {
  return {
    __typename: "Mutation" as const,
    runCheckoutPricingReport: maybeNew(
      "RunCheckoutPricingReportResult",
      data["runCheckoutPricingReport"] || undefined,
      {},
    ),
  } as any;
}

export function newProductOffering_RunCheckoutPricingReportResponse(
  variables: ProductOffering_RunCheckoutPricingReportMutationVariables,
  data: ProductOffering_RunCheckoutPricingReportDataOptions | Error,
): MockedResponse<
  ProductOffering_RunCheckoutPricingReportMutationVariables,
  ProductOffering_RunCheckoutPricingReportMutation
> {
  return {
    request: { query: ProductOffering_RunCheckoutPricingReportDocument, variables },
    result: { data: data instanceof Error ? undefined : newProductOffering_RunCheckoutPricingReportData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProductOfferingsPageDataOptions {
  productOfferings?: ProductOfferingsPageResult | ProductOfferingsPageResultOptions;
}

export function newProductOfferingsPageData(data: ProductOfferingsPageDataOptions): ProductOfferingsPageQuery {
  return {
    __typename: "Query" as const,
    productOfferings: maybeNew("ProductOfferingsPageResult", data["productOfferings"] || undefined, {}),
  } as any;
}

export function newProductOfferingsPageResponse(
  variables: ProductOfferingsPageQueryVariables,
  data: ProductOfferingsPageDataOptions | Error,
): MockedResponse<ProductOfferingsPageQueryVariables, ProductOfferingsPageQuery> {
  return {
    request: { query: ProductOfferingsPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newProductOfferingsPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentPurchaseOrderDataOptions {
  commitmentsPage?: CommitmentsPage | CommitmentsPageOptions;
}

export function newDevelopmentPurchaseOrderData(
  data: DevelopmentPurchaseOrderDataOptions,
): DevelopmentPurchaseOrderQuery {
  return {
    __typename: "Query" as const,
    commitmentsPage: maybeNew("CommitmentsPage", data["commitmentsPage"] || undefined, {}),
  } as any;
}

export function newDevelopmentPurchaseOrderResponse(
  variables: DevelopmentPurchaseOrderQueryVariables,
  data: DevelopmentPurchaseOrderDataOptions | Error,
): MockedResponse<DevelopmentPurchaseOrderQueryVariables, DevelopmentPurchaseOrderQuery> {
  return {
    request: { query: DevelopmentPurchaseOrderDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentPurchaseOrderData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentPurchaseOrderFiltersDataOptions {
  development?: Development | DevelopmentOptions;
}

export function newDevelopmentPurchaseOrderFiltersData(
  data: DevelopmentPurchaseOrderFiltersDataOptions,
): DevelopmentPurchaseOrderFiltersQuery {
  return {
    __typename: "Query" as const,
    development: maybeNew("Development", data["development"] || undefined, {}),
  } as any;
}

export function newDevelopmentPurchaseOrderFiltersResponse(
  variables: DevelopmentPurchaseOrderFiltersQueryVariables,
  data: DevelopmentPurchaseOrderFiltersDataOptions | Error,
): MockedResponse<DevelopmentPurchaseOrderFiltersQueryVariables, DevelopmentPurchaseOrderFiltersQuery> {
  return {
    request: { query: DevelopmentPurchaseOrderFiltersDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentPurchaseOrderFiltersData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveCommitmentsDataOptions {
  saveCommitments?: SaveCommitmentsResult | SaveCommitmentsResultOptions;
}

export function newSaveCommitmentsData(data: SaveCommitmentsDataOptions): SaveCommitmentsMutation {
  return {
    __typename: "Mutation" as const,
    saveCommitments: maybeNew("SaveCommitmentsResult", data["saveCommitments"] || undefined, {}),
  } as any;
}

export function newSaveCommitmentsResponse(
  variables: SaveCommitmentsMutationVariables,
  data: SaveCommitmentsDataOptions | Error,
): MockedResponse<SaveCommitmentsMutationVariables, SaveCommitmentsMutation> {
  return {
    request: { query: SaveCommitmentsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveCommitmentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProductOfferingScopeMetaDataOptions {
  productOffering?: ProductOffering | ProductOfferingOptions;
}

export function newProductOfferingScopeMetaData(
  data: ProductOfferingScopeMetaDataOptions,
): ProductOfferingScopeMetaQuery {
  return {
    __typename: "Query" as const,
    productOffering: maybeNew("ProductOffering", data["productOffering"] || undefined, {}),
  } as any;
}

export function newProductOfferingScopeMetaResponse(
  variables: ProductOfferingScopeMetaQueryVariables,
  data: ProductOfferingScopeMetaDataOptions | Error,
): MockedResponse<ProductOfferingScopeMetaQueryVariables, ProductOfferingScopeMetaQuery> {
  return {
    request: { query: ProductOfferingScopeMetaDocument, variables },
    result: { data: data instanceof Error ? undefined : newProductOfferingScopeMetaData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProductOfferingScopePageDataOptions {
  takeoffLineItemsPage?: TakeoffLineItemsPage | TakeoffLineItemsPageOptions;
}

export function newProductOfferingScopePageData(
  data: ProductOfferingScopePageDataOptions,
): ProductOfferingScopePageQuery {
  return {
    __typename: "Query" as const,
    takeoffLineItemsPage: maybeNew("TakeoffLineItemsPage", data["takeoffLineItemsPage"] || undefined, {}),
  } as any;
}

export function newProductOfferingScopePageResponse(
  variables: ProductOfferingScopePageQueryVariables,
  data: ProductOfferingScopePageDataOptions | Error,
): MockedResponse<ProductOfferingScopePageQueryVariables, ProductOfferingScopePageQuery> {
  return {
    request: { query: ProductOfferingScopePageDocument, variables },
    result: { data: data instanceof Error ? undefined : newProductOfferingScopePageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ReassignPurchaseOrdersDataOptions {
  commitments?: (Commitment | CommitmentOptions)[];
}

export function newReassignPurchaseOrdersData(data: ReassignPurchaseOrdersDataOptions): ReassignPurchaseOrdersQuery {
  return { __typename: "Query" as const, commitments: data["commitments"]?.map((d) => newCommitment(d)) || [] } as any;
}

export function newReassignPurchaseOrdersResponse(
  variables: ReassignPurchaseOrdersQueryVariables,
  data: ReassignPurchaseOrdersDataOptions | Error,
): MockedResponse<ReassignPurchaseOrdersQueryVariables, ReassignPurchaseOrdersQuery> {
  return {
    request: { query: ReassignPurchaseOrdersDocument, variables },
    result: { data: data instanceof Error ? undefined : newReassignPurchaseOrdersData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveReassignPurchaseOrdersDataOptions {
  saveBidToCommitments?: SaveCommitmentsResult | SaveCommitmentsResultOptions;
}

export function newSaveReassignPurchaseOrdersData(
  data: SaveReassignPurchaseOrdersDataOptions,
): SaveReassignPurchaseOrdersMutation {
  return {
    __typename: "Mutation" as const,
    saveBidToCommitments: maybeNew("SaveCommitmentsResult", data["saveBidToCommitments"] || undefined, {}),
  } as any;
}

export function newSaveReassignPurchaseOrdersResponse(
  variables: SaveReassignPurchaseOrdersMutationVariables,
  data: SaveReassignPurchaseOrdersDataOptions | Error,
): MockedResponse<SaveReassignPurchaseOrdersMutationVariables, SaveReassignPurchaseOrdersMutation> {
  return {
    request: { query: SaveReassignPurchaseOrdersDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveReassignPurchaseOrdersData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProductOfferingScopePageSideBarDataOptions {
  productOffering?: ProductOffering | ProductOfferingOptions;
}

export function newProductOfferingScopePageSideBarData(
  data: ProductOfferingScopePageSideBarDataOptions,
): ProductOfferingScopePageSideBarQuery {
  return {
    __typename: "Query" as const,
    productOffering: maybeNew("ProductOffering", data["productOffering"] || undefined, {}),
  } as any;
}

export function newProductOfferingScopePageSideBarResponse(
  variables: ProductOfferingScopePageSideBarQueryVariables,
  data: ProductOfferingScopePageSideBarDataOptions | Error,
): MockedResponse<ProductOfferingScopePageSideBarQueryVariables, ProductOfferingScopePageSideBarQuery> {
  return {
    request: { query: ProductOfferingScopePageSideBarDocument, variables },
    result: { data: data instanceof Error ? undefined : newProductOfferingScopePageSideBarData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentBulkScheduleDataOptions {
  development?: Development | DevelopmentOptions;
  globalPhases?: (GlobalPhase | GlobalPhaseOptions)[];
  projects?: (Project | ProjectOptions)[];
  taskStatuses?: (TaskStatusDetail | TaskStatusDetailOptions)[];
}

export function newDevelopmentBulkScheduleData(data: DevelopmentBulkScheduleDataOptions): DevelopmentBulkScheduleQuery {
  return {
    __typename: "Query" as const,
    development: maybeNew("Development", data["development"] || undefined, {}),
    globalPhases: data["globalPhases"]?.map((d) => newGlobalPhase(d)) || [],
    projects: data["projects"]?.map((d) => maybeNew("Project", d, {})) || [],
    taskStatuses: data["taskStatuses"]?.map((d) => newTaskStatusDetail(d)) || [],
  } as any;
}

export function newDevelopmentBulkScheduleResponse(
  variables: DevelopmentBulkScheduleQueryVariables,
  data: DevelopmentBulkScheduleDataOptions | Error,
): MockedResponse<DevelopmentBulkScheduleQueryVariables, DevelopmentBulkScheduleQuery> {
  return {
    request: { query: DevelopmentBulkScheduleDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentBulkScheduleData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentBulkScheduleProjectsDataOptions {
  projects?: (Project | ProjectOptions)[];
  globalPhases?: (GlobalPhase | GlobalPhaseOptions)[];
}

export function newDevelopmentBulkScheduleProjectsData(
  data: DevelopmentBulkScheduleProjectsDataOptions,
): DevelopmentBulkScheduleProjectsQuery {
  return {
    __typename: "Query" as const,
    projects: data["projects"]?.map((d) => maybeNew("Project", d, {})) || [],
    globalPhases: data["globalPhases"]?.map((d) => newGlobalPhase(d)) || [],
  } as any;
}

export function newDevelopmentBulkScheduleProjectsResponse(
  variables: DevelopmentBulkScheduleProjectsQueryVariables,
  data: DevelopmentBulkScheduleProjectsDataOptions | Error,
): MockedResponse<DevelopmentBulkScheduleProjectsQueryVariables, DevelopmentBulkScheduleProjectsQuery> {
  return {
    request: { query: DevelopmentBulkScheduleProjectsDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentBulkScheduleProjectsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScheduleTasksByPhasesDataOptions {
  scheduleTasks?: (ScheduleTask | ScheduleTaskOptions)[];
}

export function newScheduleTasksByPhasesData(data: ScheduleTasksByPhasesDataOptions): ScheduleTasksByPhasesQuery {
  return {
    __typename: "Query" as const,
    scheduleTasks: data["scheduleTasks"]?.map((d) => newScheduleTask(d)) || [],
  } as any;
}

export function newScheduleTasksByPhasesResponse(
  variables: ScheduleTasksByPhasesQueryVariables,
  data: ScheduleTasksByPhasesDataOptions | Error,
): MockedResponse<ScheduleTasksByPhasesQueryVariables, ScheduleTasksByPhasesQuery> {
  return {
    request: { query: ScheduleTasksByPhasesDocument, variables },
    result: { data: data instanceof Error ? undefined : newScheduleTasksByPhasesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentBulkScheduleSaveScheduleTaskDataOptions {
  saveScheduleTasks?: SaveScheduleTasksResult | SaveScheduleTasksResultOptions;
}

export function newDevelopmentBulkScheduleSaveScheduleTaskData(
  data: DevelopmentBulkScheduleSaveScheduleTaskDataOptions,
): DevelopmentBulkScheduleSaveScheduleTaskMutation {
  return {
    __typename: "Mutation" as const,
    saveScheduleTasks: maybeNew("SaveScheduleTasksResult", data["saveScheduleTasks"] || undefined, {}),
  } as any;
}

export function newDevelopmentBulkScheduleSaveScheduleTaskResponse(
  variables: DevelopmentBulkScheduleSaveScheduleTaskMutationVariables,
  data: DevelopmentBulkScheduleSaveScheduleTaskDataOptions | Error,
): MockedResponse<
  DevelopmentBulkScheduleSaveScheduleTaskMutationVariables,
  DevelopmentBulkScheduleSaveScheduleTaskMutation
> {
  return {
    request: { query: DevelopmentBulkScheduleSaveScheduleTaskDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentBulkScheduleSaveScheduleTaskData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CompletedMilestonesByProjectDataOptions {
  scheduleTasks?: (ScheduleTask | ScheduleTaskOptions)[];
}

export function newCompletedMilestonesByProjectData(
  data: CompletedMilestonesByProjectDataOptions,
): CompletedMilestonesByProjectQuery {
  return {
    __typename: "Query" as const,
    scheduleTasks: data["scheduleTasks"]?.map((d) => newScheduleTask(d)) || [],
  } as any;
}

export function newCompletedMilestonesByProjectResponse(
  variables: CompletedMilestonesByProjectQueryVariables,
  data: CompletedMilestonesByProjectDataOptions | Error,
): MockedResponse<CompletedMilestonesByProjectQueryVariables, CompletedMilestonesByProjectQuery> {
  return {
    request: { query: CompletedMilestonesByProjectDocument, variables },
    result: { data: data instanceof Error ? undefined : newCompletedMilestonesByProjectData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentScopeTemplatePageDataOptions {
  itemTemplate?: ItemTemplate | ItemTemplateOptions;
}

export function newDevelopmentScopeTemplatePageData(
  data: DevelopmentScopeTemplatePageDataOptions,
): DevelopmentScopeTemplatePageQuery {
  return {
    __typename: "Query" as const,
    itemTemplate: maybeNew("ItemTemplate", data["itemTemplate"] || undefined, {}),
  } as any;
}

export function newDevelopmentScopeTemplatePageResponse(
  variables: DevelopmentScopeTemplatePageQueryVariables,
  data: DevelopmentScopeTemplatePageDataOptions | Error,
): MockedResponse<DevelopmentScopeTemplatePageQueryVariables, DevelopmentScopeTemplatePageQuery> {
  return {
    request: { query: DevelopmentScopeTemplatePageDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentScopeTemplatePageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateNewItemTemplateVersionsDataOptions {
  createNewItemTemplateVersions?: CreateNewItemTemplateVersionsResult | CreateNewItemTemplateVersionsResultOptions;
}

export function newCreateNewItemTemplateVersionsData(
  data: CreateNewItemTemplateVersionsDataOptions,
): CreateNewItemTemplateVersionsMutation {
  return {
    __typename: "Mutation" as const,
    createNewItemTemplateVersions: maybeNew(
      "CreateNewItemTemplateVersionsResult",
      data["createNewItemTemplateVersions"] || undefined,
      {},
    ),
  } as any;
}

export function newCreateNewItemTemplateVersionsResponse(
  variables: CreateNewItemTemplateVersionsMutationVariables,
  data: CreateNewItemTemplateVersionsDataOptions | Error,
): MockedResponse<CreateNewItemTemplateVersionsMutationVariables, CreateNewItemTemplateVersionsMutation> {
  return {
    request: { query: CreateNewItemTemplateVersionsDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateNewItemTemplateVersionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteItemTemplatesDataOptions {
  deleteItemTemplates?: EmptyResult | EmptyResultOptions;
}

export function newDeleteItemTemplatesData(data: DeleteItemTemplatesDataOptions): DeleteItemTemplatesMutation {
  return {
    __typename: "Mutation" as const,
    deleteItemTemplates: maybeNew("EmptyResult", data["deleteItemTemplates"] || undefined, {}),
  } as any;
}

export function newDeleteItemTemplatesResponse(
  variables: DeleteItemTemplatesMutationVariables,
  data: DeleteItemTemplatesDataOptions | Error,
): MockedResponse<DeleteItemTemplatesMutationVariables, DeleteItemTemplatesMutation> {
  return {
    request: { query: DeleteItemTemplatesDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteItemTemplatesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentTeamMembersDataOptions {
  development?: Development | DevelopmentOptions;
  projectRoleDetails?: (ProjectRoleDetail | ProjectRoleDetailOptions)[];
  internalUsers?: (InternalUser | InternalUserOptions)[];
}

export function newDevelopmentTeamMembersData(data: DevelopmentTeamMembersDataOptions): DevelopmentTeamMembersQuery {
  return {
    __typename: "Query" as const,
    development: maybeNew("Development", data["development"] || undefined, {}),
    projectRoleDetails: data["projectRoleDetails"]?.map((d) => newProjectRoleDetail(d)) || [],
    internalUsers: data["internalUsers"]?.map((d) => newInternalUser(d)) || [],
  } as any;
}

export function newDevelopmentTeamMembersResponse(
  variables: DevelopmentTeamMembersQueryVariables,
  data: DevelopmentTeamMembersDataOptions | Error,
): MockedResponse<DevelopmentTeamMembersQueryVariables, DevelopmentTeamMembersQuery> {
  return {
    request: { query: DevelopmentTeamMembersDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentTeamMembersData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface UpdateDevelopmentProjectRoleDataOptions {
  saveDevelopmentTeamMember?: EmptyResult | EmptyResultOptions;
}

export function newUpdateDevelopmentProjectRoleData(
  data: UpdateDevelopmentProjectRoleDataOptions,
): UpdateDevelopmentProjectRoleMutation {
  return {
    __typename: "Mutation" as const,
    saveDevelopmentTeamMember: maybeNew("EmptyResult", data["saveDevelopmentTeamMember"] || undefined, {}),
  } as any;
}

export function newUpdateDevelopmentProjectRoleResponse(
  variables: UpdateDevelopmentProjectRoleMutationVariables,
  data: UpdateDevelopmentProjectRoleDataOptions | Error,
): MockedResponse<UpdateDevelopmentProjectRoleMutationVariables, UpdateDevelopmentProjectRoleMutation> {
  return {
    request: { query: UpdateDevelopmentProjectRoleDocument, variables },
    result: { data: data instanceof Error ? undefined : newUpdateDevelopmentProjectRoleData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentScopeTemplatesMetadataDataOptions {
  development?: Development | DevelopmentOptions;
}

export function newDevelopmentScopeTemplatesMetadataData(
  data: DevelopmentScopeTemplatesMetadataDataOptions,
): DevelopmentScopeTemplatesMetadataQuery {
  return {
    __typename: "Query" as const,
    development: maybeNew("Development", data["development"] || undefined, {}),
  } as any;
}

export function newDevelopmentScopeTemplatesMetadataResponse(
  variables: DevelopmentScopeTemplatesMetadataQueryVariables,
  data: DevelopmentScopeTemplatesMetadataDataOptions | Error,
): MockedResponse<DevelopmentScopeTemplatesMetadataQueryVariables, DevelopmentScopeTemplatesMetadataQuery> {
  return {
    request: { query: DevelopmentScopeTemplatesMetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentScopeTemplatesMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentScopeTemplatesDataOptions {
  itemTemplates?: (ItemTemplate | ItemTemplateOptions)[];
}

export function newDevelopmentScopeTemplatesData(
  data: DevelopmentScopeTemplatesDataOptions,
): DevelopmentScopeTemplatesQuery {
  return {
    __typename: "Query" as const,
    itemTemplates: data["itemTemplates"]?.map((d) => newItemTemplate(d)) || [],
  } as any;
}

export function newDevelopmentScopeTemplatesResponse(
  variables: DevelopmentScopeTemplatesQueryVariables,
  data: DevelopmentScopeTemplatesDataOptions | Error,
): MockedResponse<DevelopmentScopeTemplatesQueryVariables, DevelopmentScopeTemplatesQuery> {
  return {
    request: { query: DevelopmentScopeTemplatesDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentScopeTemplatesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScopeTemplateCostCalculatorPageDataOptions {
  itemTemplate?: ItemTemplate | ItemTemplateOptions;
}

export function newScopeTemplateCostCalculatorPageData(
  data: ScopeTemplateCostCalculatorPageDataOptions,
): ScopeTemplateCostCalculatorPageQuery {
  return {
    __typename: "Query" as const,
    itemTemplate: maybeNew("ItemTemplate", data["itemTemplate"] || undefined, {}),
  } as any;
}

export function newScopeTemplateCostCalculatorPageResponse(
  variables: ScopeTemplateCostCalculatorPageQueryVariables,
  data: ScopeTemplateCostCalculatorPageDataOptions | Error,
): MockedResponse<ScopeTemplateCostCalculatorPageQueryVariables, ScopeTemplateCostCalculatorPageQuery> {
  return {
    request: { query: ScopeTemplateCostCalculatorPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newScopeTemplateCostCalculatorPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScopeTemplateCostCalculatorPage_ComputeDataOptions {
  computeReadyPlanCost?: ComputeReadyPlanCostResult | ComputeReadyPlanCostResultOptions;
  computeProgramData?: NewProgramData | NewProgramDataOptions;
}

export function newScopeTemplateCostCalculatorPage_ComputeData(
  data: ScopeTemplateCostCalculatorPage_ComputeDataOptions,
): ScopeTemplateCostCalculatorPage_ComputeQuery {
  return {
    __typename: "Query" as const,
    computeReadyPlanCost: maybeNew("ComputeReadyPlanCostResult", data["computeReadyPlanCost"] || undefined, {}),
    computeProgramData: maybeNew("NewProgramData", data["computeProgramData"] || undefined, {}),
  } as any;
}

export function newScopeTemplateCostCalculatorPage_ComputeResponse(
  variables: ScopeTemplateCostCalculatorPage_ComputeQueryVariables,
  data: ScopeTemplateCostCalculatorPage_ComputeDataOptions | Error,
): MockedResponse<ScopeTemplateCostCalculatorPage_ComputeQueryVariables, ScopeTemplateCostCalculatorPage_ComputeQuery> {
  return {
    request: { query: ScopeTemplateCostCalculatorPage_ComputeDocument, variables },
    result: { data: data instanceof Error ? undefined : newScopeTemplateCostCalculatorPage_ComputeData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface InboxBellDataOptions {
  userRelevantCommentStreams?: (CommentStream | CommentStreamOptions)[];
}

export function newInboxBellData(data: InboxBellDataOptions): InboxBellQuery {
  return {
    __typename: "Query" as const,
    userRelevantCommentStreams: data["userRelevantCommentStreams"]?.map((d) => newCommentStream(d)) || [],
  } as any;
}

export function newInboxBellResponse(
  variables: InboxBellQueryVariables,
  data: InboxBellDataOptions | Error,
): MockedResponse<InboxBellQueryVariables, InboxBellQuery> {
  return {
    request: { query: InboxBellDocument, variables },
    result: { data: data instanceof Error ? undefined : newInboxBellData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CommentableInboxDataOptions {
  commentable?: Commentable | CommentableOptions;
}

export function newCommentableInboxData(data: CommentableInboxDataOptions): CommentableInboxQuery {
  return {
    __typename: "Query" as const,
    commentable: maybeNew("Commentable", data["commentable"] || undefined, {}),
  } as any;
}

export function newCommentableInboxResponse(
  variables: CommentableInboxQueryVariables,
  data: CommentableInboxDataOptions | Error,
): MockedResponse<CommentableInboxQueryVariables, CommentableInboxQuery> {
  return {
    request: { query: CommentableInboxDocument, variables },
    result: { data: data instanceof Error ? undefined : newCommentableInboxData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CopyDesignPackage_ReadyPlanLikeDataOptions {
  readyPlanLike2?: ReadyPlanLike | ReadyPlanLikeOptions;
}

export function newCopyDesignPackage_ReadyPlanLikeData(
  data: CopyDesignPackage_ReadyPlanLikeDataOptions,
): CopyDesignPackage_ReadyPlanLikeQuery {
  return {
    __typename: "Query" as const,
    readyPlanLike2: maybeNew("ReadyPlanLike", data["readyPlanLike2"] || undefined, {}),
  } as any;
}

export function newCopyDesignPackage_ReadyPlanLikeResponse(
  variables: CopyDesignPackage_ReadyPlanLikeQueryVariables,
  data: CopyDesignPackage_ReadyPlanLikeDataOptions | Error,
): MockedResponse<CopyDesignPackage_ReadyPlanLikeQueryVariables, CopyDesignPackage_ReadyPlanLikeQuery> {
  return {
    request: { query: CopyDesignPackage_ReadyPlanLikeDocument, variables },
    result: { data: data instanceof Error ? undefined : newCopyDesignPackage_ReadyPlanLikeData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CopyDesignPackage_CopyDesignPackageDataOptions {
  copyDesignPackage?: SaveDesignPackageResult | SaveDesignPackageResultOptions;
}

export function newCopyDesignPackage_CopyDesignPackageData(
  data: CopyDesignPackage_CopyDesignPackageDataOptions,
): CopyDesignPackage_CopyDesignPackageMutation {
  return {
    __typename: "Mutation" as const,
    copyDesignPackage: maybeNew("SaveDesignPackageResult", data["copyDesignPackage"] || undefined, {}),
  } as any;
}

export function newCopyDesignPackage_CopyDesignPackageResponse(
  variables: CopyDesignPackage_CopyDesignPackageMutationVariables,
  data: CopyDesignPackage_CopyDesignPackageDataOptions | Error,
): MockedResponse<CopyDesignPackage_CopyDesignPackageMutationVariables, CopyDesignPackage_CopyDesignPackageMutation> {
  return {
    request: { query: CopyDesignPackage_CopyDesignPackageDocument, variables },
    result: { data: data instanceof Error ? undefined : newCopyDesignPackage_CopyDesignPackageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CommentStreamCommentsDataOptions {
  commentStream?: CommentStream | CommentStreamOptions | null;
}

export function newCommentStreamCommentsData(data: CommentStreamCommentsDataOptions): CommentStreamCommentsQuery {
  return {
    __typename: "Query" as const,
    commentStream: maybeNewOrNull("CommentStream", data["commentStream"] || undefined, {}),
  } as any;
}

export function newCommentStreamCommentsResponse(
  variables: CommentStreamCommentsQueryVariables,
  data: CommentStreamCommentsDataOptions | Error,
): MockedResponse<CommentStreamCommentsQueryVariables, CommentStreamCommentsQuery> {
  return {
    request: { query: CommentStreamCommentsDocument, variables },
    result: { data: data instanceof Error ? undefined : newCommentStreamCommentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface OptionDrawerMetadataDataOptions {
  globalOptionTypes?: (GlobalOptionType | GlobalOptionTypeOptions)[];
  globalOptionGroups?: (GlobalOptionGroup | GlobalOptionGroupOptions)[];
}

export function newOptionDrawerMetadataData(data: OptionDrawerMetadataDataOptions): OptionDrawerMetadataQuery {
  return {
    __typename: "Query" as const,
    globalOptionTypes: data["globalOptionTypes"]?.map((d) => newGlobalOptionType(d)) || [],
    globalOptionGroups: data["globalOptionGroups"]?.map((d) => newGlobalOptionGroup(d)) || [],
  } as any;
}

export function newOptionDrawerMetadataResponse(
  data: OptionDrawerMetadataDataOptions | Error,
): MockedResponse<OptionDrawerMetadataQueryVariables, OptionDrawerMetadataQuery> {
  return {
    request: { query: OptionDrawerMetadataDocument },
    result: { data: data instanceof Error ? undefined : newOptionDrawerMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface GlobalOptionDrawerDataOptions {
  globalOption?: GlobalOption | GlobalOptionOptions;
}

export function newGlobalOptionDrawerData(data: GlobalOptionDrawerDataOptions): GlobalOptionDrawerQuery {
  return {
    __typename: "Query" as const,
    globalOption: maybeNew("GlobalOption", data["globalOption"] || undefined, {}),
  } as any;
}

export function newGlobalOptionDrawerResponse(
  variables: GlobalOptionDrawerQueryVariables,
  data: GlobalOptionDrawerDataOptions | Error,
): MockedResponse<GlobalOptionDrawerQueryVariables, GlobalOptionDrawerQuery> {
  return {
    request: { query: GlobalOptionDrawerDocument, variables },
    result: { data: data instanceof Error ? undefined : newGlobalOptionDrawerData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveGlobalOptionsDrawerDataOptions {
  saveGlobalOptions?: SaveGlobalOptionsResult | SaveGlobalOptionsResultOptions;
}

export function newSaveGlobalOptionsDrawerData(
  data: SaveGlobalOptionsDrawerDataOptions,
): SaveGlobalOptionsDrawerMutation {
  return {
    __typename: "Mutation" as const,
    saveGlobalOptions: maybeNew("SaveGlobalOptionsResult", data["saveGlobalOptions"] || undefined, {}),
  } as any;
}

export function newSaveGlobalOptionsDrawerResponse(
  variables: SaveGlobalOptionsDrawerMutationVariables,
  data: SaveGlobalOptionsDrawerDataOptions | Error,
): MockedResponse<SaveGlobalOptionsDrawerMutationVariables, SaveGlobalOptionsDrawerMutation> {
  return {
    request: { query: SaveGlobalOptionsDrawerDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveGlobalOptionsDrawerData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveGlobalOptionGroupDataOptions {
  saveGlobalOptionGroup?: SaveGlobalOptionGroupResult | SaveGlobalOptionGroupResultOptions;
}

export function newSaveGlobalOptionGroupData(data: SaveGlobalOptionGroupDataOptions): SaveGlobalOptionGroupMutation {
  return {
    __typename: "Mutation" as const,
    saveGlobalOptionGroup: maybeNew("SaveGlobalOptionGroupResult", data["saveGlobalOptionGroup"] || undefined, {}),
  } as any;
}

export function newSaveGlobalOptionGroupResponse(
  variables: SaveGlobalOptionGroupMutationVariables,
  data: SaveGlobalOptionGroupDataOptions | Error,
): MockedResponse<SaveGlobalOptionGroupMutationVariables, SaveGlobalOptionGroupMutation> {
  return {
    request: { query: SaveGlobalOptionGroupDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveGlobalOptionGroupData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface EditPersonalizationOptionPageDataOptions {
  enumDetails?: AllEnumDetails | AllEnumDetailsOptions;
  designPackage?: DesignPackage | DesignPackageOptions;
  takeoffLineItem?: TakeoffLineItem | TakeoffLineItemOptions;
  readyPlan?: ReadyPlan | ReadyPlanOptions;
}

export function newEditPersonalizationOptionPageData(
  data: EditPersonalizationOptionPageDataOptions,
): EditPersonalizationOptionPageQuery {
  return {
    __typename: "Query" as const,
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
    designPackage: maybeNew("DesignPackage", data["designPackage"] || undefined, {}),
    takeoffLineItem: maybeNew("TakeoffLineItem", data["takeoffLineItem"] || undefined, {}),
    readyPlan: maybeNew("ReadyPlan", data["readyPlan"] || undefined, {}),
  } as any;
}

export function newEditPersonalizationOptionPageResponse(
  variables: EditPersonalizationOptionPageQueryVariables,
  data: EditPersonalizationOptionPageDataOptions | Error,
): MockedResponse<EditPersonalizationOptionPageQueryVariables, EditPersonalizationOptionPageQuery> {
  return {
    request: { query: EditPersonalizationOptionPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newEditPersonalizationOptionPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface EditPersonalizationOptionPage_MaterialVariantDataOptions {
  materialVariant?: MaterialVariant | MaterialVariantOptions;
}

export function newEditPersonalizationOptionPage_MaterialVariantData(
  data: EditPersonalizationOptionPage_MaterialVariantDataOptions,
): EditPersonalizationOptionPage_MaterialVariantQuery {
  return {
    __typename: "Query" as const,
    materialVariant: maybeNew("MaterialVariant", data["materialVariant"] || undefined, {}),
  } as any;
}

export function newEditPersonalizationOptionPage_MaterialVariantResponse(
  variables: EditPersonalizationOptionPage_MaterialVariantQueryVariables,
  data: EditPersonalizationOptionPage_MaterialVariantDataOptions | Error,
): MockedResponse<
  EditPersonalizationOptionPage_MaterialVariantQueryVariables,
  EditPersonalizationOptionPage_MaterialVariantQuery
> {
  return {
    request: { query: EditPersonalizationOptionPage_MaterialVariantDocument, variables },
    result: { data: data instanceof Error ? undefined : newEditPersonalizationOptionPage_MaterialVariantData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface EditPersonalizationOptionPage_CombinationsDataOptions {
  designPackage?: DesignPackage | DesignPackageOptions;
}

export function newEditPersonalizationOptionPage_CombinationsData(
  data: EditPersonalizationOptionPage_CombinationsDataOptions,
): EditPersonalizationOptionPage_CombinationsQuery {
  return {
    __typename: "Query" as const,
    designPackage: maybeNew("DesignPackage", data["designPackage"] || undefined, {}),
  } as any;
}

export function newEditPersonalizationOptionPage_CombinationsResponse(
  variables: EditPersonalizationOptionPage_CombinationsQueryVariables,
  data: EditPersonalizationOptionPage_CombinationsDataOptions | Error,
): MockedResponse<
  EditPersonalizationOptionPage_CombinationsQueryVariables,
  EditPersonalizationOptionPage_CombinationsQuery
> {
  return {
    request: { query: EditPersonalizationOptionPage_CombinationsDocument, variables },
    result: { data: data instanceof Error ? undefined : newEditPersonalizationOptionPage_CombinationsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SavePersonalizationRpogDataOptions {
  savePersonalizationOptionGroup?: SavePersonalizationOptionGroupResult | SavePersonalizationOptionGroupResultOptions;
}

export function newSavePersonalizationRpogData(
  data: SavePersonalizationRpogDataOptions,
): SavePersonalizationRpogMutation {
  return {
    __typename: "Mutation" as const,
    savePersonalizationOptionGroup: maybeNew(
      "SavePersonalizationOptionGroupResult",
      data["savePersonalizationOptionGroup"] || undefined,
      {},
    ),
  } as any;
}

export function newSavePersonalizationRpogResponse(
  variables: SavePersonalizationRpogMutationVariables,
  data: SavePersonalizationRpogDataOptions | Error,
): MockedResponse<SavePersonalizationRpogMutationVariables, SavePersonalizationRpogMutation> {
  return {
    request: { query: SavePersonalizationRpogDocument, variables },
    result: { data: data instanceof Error ? undefined : newSavePersonalizationRpogData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface GlobalOptionsPageMetadataDataOptions {
  globalOptionTypes?: (GlobalOptionType | GlobalOptionTypeOptions)[];
  locations?: (Location | LocationOptions)[];
  developments?: (Development | DevelopmentOptions)[];
}

export function newGlobalOptionsPageMetadataData(
  data: GlobalOptionsPageMetadataDataOptions,
): GlobalOptionsPageMetadataQuery {
  return {
    __typename: "Query" as const,
    globalOptionTypes: data["globalOptionTypes"]?.map((d) => newGlobalOptionType(d)) || [],
    locations: data["locations"]?.map((d) => newLocation(d)) || [],
    developments: data["developments"]?.map((d) => newDevelopment(d)) || [],
  } as any;
}

export function newGlobalOptionsPageMetadataResponse(
  data: GlobalOptionsPageMetadataDataOptions | Error,
): MockedResponse<GlobalOptionsPageMetadataQueryVariables, GlobalOptionsPageMetadataQuery> {
  return {
    request: { query: GlobalOptionsPageMetadataDocument },
    result: { data: data instanceof Error ? undefined : newGlobalOptionsPageMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface GlobalOptionsDataOptions {
  globalOptions?: (GlobalOption | GlobalOptionOptions)[];
}

export function newGlobalOptionsData(data: GlobalOptionsDataOptions): GlobalOptionsQuery {
  return {
    __typename: "Query" as const,
    globalOptions: data["globalOptions"]?.map((d) => newGlobalOption(d)) || [],
  } as any;
}

export function newGlobalOptionsResponse(
  variables: GlobalOptionsQueryVariables,
  data: GlobalOptionsDataOptions | Error,
): MockedResponse<GlobalOptionsQueryVariables, GlobalOptionsQuery> {
  return {
    request: { query: GlobalOptionsDocument, variables },
    result: { data: data instanceof Error ? undefined : newGlobalOptionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface GlobalOptionsIdsDataOptions {
  globalOptions?: (GlobalOption | GlobalOptionOptions)[];
}

export function newGlobalOptionsIdsData(data: GlobalOptionsIdsDataOptions): GlobalOptionsIdsQuery {
  return {
    __typename: "Query" as const,
    globalOptions: data["globalOptions"]?.map((d) => newGlobalOption(d)) || [],
  } as any;
}

export function newGlobalOptionsIdsResponse(
  data: GlobalOptionsIdsDataOptions | Error,
): MockedResponse<GlobalOptionsIdsQueryVariables, GlobalOptionsIdsQuery> {
  return {
    request: { query: GlobalOptionsIdsDocument },
    result: { data: data instanceof Error ? undefined : newGlobalOptionsIdsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveGlobalOptionsDataOptions {
  saveGlobalOptions?: SaveGlobalOptionsResult | SaveGlobalOptionsResultOptions;
}

export function newSaveGlobalOptionsData(data: SaveGlobalOptionsDataOptions): SaveGlobalOptionsMutation {
  return {
    __typename: "Mutation" as const,
    saveGlobalOptions: maybeNew("SaveGlobalOptionsResult", data["saveGlobalOptions"] || undefined, {}),
  } as any;
}

export function newSaveGlobalOptionsResponse(
  variables: SaveGlobalOptionsMutationVariables,
  data: SaveGlobalOptionsDataOptions | Error,
): MockedResponse<SaveGlobalOptionsMutationVariables, SaveGlobalOptionsMutation> {
  return {
    request: { query: SaveGlobalOptionsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveGlobalOptionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface GlobalOptionFormDataOptions {
  globalOption?: GlobalOption | GlobalOptionOptions;
}

export function newGlobalOptionFormData(data: GlobalOptionFormDataOptions): GlobalOptionFormQuery {
  return {
    __typename: "Query" as const,
    globalOption: maybeNew("GlobalOption", data["globalOption"] || undefined, {}),
  } as any;
}

export function newGlobalOptionFormResponse(
  variables: GlobalOptionFormQueryVariables,
  data: GlobalOptionFormDataOptions | Error,
): MockedResponse<GlobalOptionFormQueryVariables, GlobalOptionFormQuery> {
  return {
    request: { query: GlobalOptionFormDocument, variables },
    result: { data: data instanceof Error ? undefined : newGlobalOptionFormData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface GlobalOptionFormTypesDataOptions {
  globalOptionTypes?: (GlobalOptionType | GlobalOptionTypeOptions)[];
  enumDetails?: AllEnumDetails | AllEnumDetailsOptions;
  markets?: (Market | MarketOptions)[];
}

export function newGlobalOptionFormTypesData(data: GlobalOptionFormTypesDataOptions): GlobalOptionFormTypesQuery {
  return {
    __typename: "Query" as const,
    globalOptionTypes: data["globalOptionTypes"]?.map((d) => newGlobalOptionType(d)) || [],
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
    markets: data["markets"]?.map((d) => newMarket(d)) || [],
  } as any;
}

export function newGlobalOptionFormTypesResponse(
  data: GlobalOptionFormTypesDataOptions | Error,
): MockedResponse<GlobalOptionFormTypesQueryVariables, GlobalOptionFormTypesQuery> {
  return {
    request: { query: GlobalOptionFormTypesDocument },
    result: { data: data instanceof Error ? undefined : newGlobalOptionFormTypesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveGlobalOptionFormDataOptions {
  saveGlobalOptions?: SaveGlobalOptionsResult | SaveGlobalOptionsResultOptions;
}

export function newSaveGlobalOptionFormData(data: SaveGlobalOptionFormDataOptions): SaveGlobalOptionFormMutation {
  return {
    __typename: "Mutation" as const,
    saveGlobalOptions: maybeNew("SaveGlobalOptionsResult", data["saveGlobalOptions"] || undefined, {}),
  } as any;
}

export function newSaveGlobalOptionFormResponse(
  variables: SaveGlobalOptionFormMutationVariables,
  data: SaveGlobalOptionFormDataOptions | Error,
): MockedResponse<SaveGlobalOptionFormMutationVariables, SaveGlobalOptionFormMutation> {
  return {
    request: { query: SaveGlobalOptionFormDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveGlobalOptionFormData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DesignCatalogsTableDataOptions {
  designPackages?: DesignPackagesPageResult | DesignPackagesPageResultOptions;
}

export function newDesignCatalogsTableData(data: DesignCatalogsTableDataOptions): DesignCatalogsTableQuery {
  return {
    __typename: "Query" as const,
    designPackages: maybeNew("DesignPackagesPageResult", data["designPackages"] || undefined, {}),
  } as any;
}

export function newDesignCatalogsTableResponse(
  variables: DesignCatalogsTableQueryVariables,
  data: DesignCatalogsTableDataOptions | Error,
): MockedResponse<DesignCatalogsTableQueryVariables, DesignCatalogsTableQuery> {
  return {
    request: { query: DesignCatalogsTableDocument, variables },
    result: { data: data instanceof Error ? undefined : newDesignCatalogsTableData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface GlobalOptionsPageV2MetadataDataOptions {
  globalOptionTypes?: (GlobalOptionType | GlobalOptionTypeOptions)[];
}

export function newGlobalOptionsPageV2MetadataData(
  data: GlobalOptionsPageV2MetadataDataOptions,
): GlobalOptionsPageV2MetadataQuery {
  return {
    __typename: "Query" as const,
    globalOptionTypes: data["globalOptionTypes"]?.map((d) => newGlobalOptionType(d)) || [],
  } as any;
}

export function newGlobalOptionsPageV2MetadataResponse(
  data: GlobalOptionsPageV2MetadataDataOptions | Error,
): MockedResponse<GlobalOptionsPageV2MetadataQueryVariables, GlobalOptionsPageV2MetadataQuery> {
  return {
    request: { query: GlobalOptionsPageV2MetadataDocument },
    result: { data: data instanceof Error ? undefined : newGlobalOptionsPageV2MetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface GlobalOptionsPageV2DataOptions {
  globalOptions?: (GlobalOption | GlobalOptionOptions)[];
}

export function newGlobalOptionsPageV2Data(data: GlobalOptionsPageV2DataOptions): GlobalOptionsPageV2Query {
  return {
    __typename: "Query" as const,
    globalOptions: data["globalOptions"]?.map((d) => newGlobalOption(d)) || [],
  } as any;
}

export function newGlobalOptionsPageV2Response(
  variables: GlobalOptionsPageV2QueryVariables,
  data: GlobalOptionsPageV2DataOptions | Error,
): MockedResponse<GlobalOptionsPageV2QueryVariables, GlobalOptionsPageV2Query> {
  return {
    request: { query: GlobalOptionsPageV2Document, variables },
    result: { data: data instanceof Error ? undefined : newGlobalOptionsPageV2Data(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveGlobalOptionsPageV2DataOptions {
  saveGlobalOptions?: SaveGlobalOptionsResult | SaveGlobalOptionsResultOptions;
}

export function newSaveGlobalOptionsPageV2Data(
  data: SaveGlobalOptionsPageV2DataOptions,
): SaveGlobalOptionsPageV2Mutation {
  return {
    __typename: "Mutation" as const,
    saveGlobalOptions: maybeNew("SaveGlobalOptionsResult", data["saveGlobalOptions"] || undefined, {}),
  } as any;
}

export function newSaveGlobalOptionsPageV2Response(
  variables: SaveGlobalOptionsPageV2MutationVariables,
  data: SaveGlobalOptionsPageV2DataOptions | Error,
): MockedResponse<SaveGlobalOptionsPageV2MutationVariables, SaveGlobalOptionsPageV2Mutation> {
  return {
    request: { query: SaveGlobalOptionsPageV2Document, variables },
    result: { data: data instanceof Error ? undefined : newSaveGlobalOptionsPageV2Data(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidItemPageDataOptions {
  bidItems?: (BidItem | BidItemOptions)[];
}

export function newBidItemPageData(data: BidItemPageDataOptions): BidItemPageQuery {
  return { __typename: "Query" as const, bidItems: data["bidItems"]?.map((d) => newBidItem(d)) || [] } as any;
}

export function newBidItemPageResponse(
  data: BidItemPageDataOptions | Error,
): MockedResponse<BidItemPageQueryVariables, BidItemPageQuery> {
  return {
    request: { query: BidItemPageDocument },
    result: { data: data instanceof Error ? undefined : newBidItemPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidItemPageOptionsDataOptions {
  attributes?: (ProductAttribute | ProductAttributeOptions)[];
  products?: (Product | ProductOptions)[];
  items?: (Item | ItemOptions)[];
  unitsOfMeasure?: (UnitOfMeasure | UnitOfMeasureOptions)[];
  costTypes?: (CostTypeDetail | CostTypeDetailOptions)[];
}

export function newBidItemPageOptionsData(data: BidItemPageOptionsDataOptions): BidItemPageOptionsQuery {
  return {
    __typename: "Query" as const,
    attributes: data["attributes"]?.map((d) => newProductAttribute(d)) || [],
    products: data["products"]?.map((d) => newProduct(d)) || [],
    items: data["items"]?.map((d) => newItem(d)) || [],
    unitsOfMeasure: data["unitsOfMeasure"]?.map((d) => newUnitOfMeasure(d)) || [],
    costTypes: data["costTypes"]?.map((d) => newCostTypeDetail(d)) || [],
  } as any;
}

export function newBidItemPageOptionsResponse(
  data: BidItemPageOptionsDataOptions | Error,
): MockedResponse<BidItemPageOptionsQueryVariables, BidItemPageOptionsQuery> {
  return {
    request: { query: BidItemPageOptionsDocument },
    result: { data: data instanceof Error ? undefined : newBidItemPageOptionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveBidItemDataOptions {
  saveBidItem?: SaveBidItemResult | SaveBidItemResultOptions;
}

export function newSaveBidItemData(data: SaveBidItemDataOptions): SaveBidItemMutation {
  return {
    __typename: "Mutation" as const,
    saveBidItem: maybeNew("SaveBidItemResult", data["saveBidItem"] || undefined, {}),
  } as any;
}

export function newSaveBidItemResponse(
  variables: SaveBidItemMutationVariables,
  data: SaveBidItemDataOptions | Error,
): MockedResponse<SaveBidItemMutationVariables, SaveBidItemMutation> {
  return {
    request: { query: SaveBidItemDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveBidItemData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ItemCatalogDataOptions {
  bidItemsPage?: BidItemsPage | BidItemsPageOptions;
}

export function newItemCatalogData(data: ItemCatalogDataOptions): ItemCatalogQuery {
  return {
    __typename: "Query" as const,
    bidItemsPage: maybeNew("BidItemsPage", data["bidItemsPage"] || undefined, {}),
  } as any;
}

export function newItemCatalogResponse(
  variables: ItemCatalogQueryVariables,
  data: ItemCatalogDataOptions | Error,
): MockedResponse<ItemCatalogQueryVariables, ItemCatalogQuery> {
  return {
    request: { query: ItemCatalogDocument, variables },
    result: { data: data instanceof Error ? undefined : newItemCatalogData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveBidItemEstimateDataOptions {
  saveBidItemEstimate?: SaveBidItemEstimateResult | SaveBidItemEstimateResultOptions;
}

export function newSaveBidItemEstimateData(data: SaveBidItemEstimateDataOptions): SaveBidItemEstimateMutation {
  return {
    __typename: "Mutation" as const,
    saveBidItemEstimate: maybeNew("SaveBidItemEstimateResult", data["saveBidItemEstimate"] || undefined, {}),
  } as any;
}

export function newSaveBidItemEstimateResponse(
  variables: SaveBidItemEstimateMutationVariables,
  data: SaveBidItemEstimateDataOptions | Error,
): MockedResponse<SaveBidItemEstimateMutationVariables, SaveBidItemEstimateMutation> {
  return {
    request: { query: SaveBidItemEstimateDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveBidItemEstimateData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidEstimateModalOptionsDataOptions {
  markets?: (Market | MarketOptions)[];
  unitsOfMeasure?: (UnitOfMeasure | UnitOfMeasureOptions)[];
}

export function newBidEstimateModalOptionsData(data: BidEstimateModalOptionsDataOptions): BidEstimateModalOptionsQuery {
  return {
    __typename: "Query" as const,
    markets: data["markets"]?.map((d) => newMarket(d)) || [],
    unitsOfMeasure: data["unitsOfMeasure"]?.map((d) => newUnitOfMeasure(d)) || [],
  } as any;
}

export function newBidEstimateModalOptionsResponse(
  data: BidEstimateModalOptionsDataOptions | Error,
): MockedResponse<BidEstimateModalOptionsQueryVariables, BidEstimateModalOptionsQuery> {
  return {
    request: { query: BidEstimateModalOptionsDocument },
    result: { data: data instanceof Error ? undefined : newBidEstimateModalOptionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MaterialCatalogDataOptions {
  materialVariants?: MaterialVariantsPage | MaterialVariantsPageOptions;
}

export function newMaterialCatalogData(data: MaterialCatalogDataOptions): MaterialCatalogQuery {
  return {
    __typename: "Query" as const,
    materialVariants: maybeNew("MaterialVariantsPage", data["materialVariants"] || undefined, {}),
  } as any;
}

export function newMaterialCatalogResponse(
  variables: MaterialCatalogQueryVariables,
  data: MaterialCatalogDataOptions | Error,
): MockedResponse<MaterialCatalogQueryVariables, MaterialCatalogQuery> {
  return {
    request: { query: MaterialCatalogDocument, variables },
    result: { data: data instanceof Error ? undefined : newMaterialCatalogData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MaterialCatalogMetadataDataOptions {
  materialBrands?: (MaterialBrand | MaterialBrandOptions)[];
  items?: (Item | ItemOptions)[];
  markets?: (Market | MarketOptions)[];
  materialVariantTags?: (MaterialVariantTag | MaterialVariantTagOptions)[];
}

export function newMaterialCatalogMetadataData(data: MaterialCatalogMetadataDataOptions): MaterialCatalogMetadataQuery {
  return {
    __typename: "Query" as const,
    materialBrands: data["materialBrands"]?.map((d) => newMaterialBrand(d)) || [],
    items: data["items"]?.map((d) => newItem(d)) || [],
    markets: data["markets"]?.map((d) => newMarket(d)) || [],
    materialVariantTags: data["materialVariantTags"]?.map((d) => newMaterialVariantTag(d)) || [],
  } as any;
}

export function newMaterialCatalogMetadataResponse(
  data: MaterialCatalogMetadataDataOptions | Error,
): MockedResponse<MaterialCatalogMetadataQueryVariables, MaterialCatalogMetadataQuery> {
  return {
    request: { query: MaterialCatalogMetadataDocument },
    result: { data: data instanceof Error ? undefined : newMaterialCatalogMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveMaterialVariantDataOptions {
  saveMaterialVariant?: SaveMaterialVariantResult | SaveMaterialVariantResultOptions;
}

export function newSaveMaterialVariantData(data: SaveMaterialVariantDataOptions): SaveMaterialVariantMutation {
  return {
    __typename: "Mutation" as const,
    saveMaterialVariant: maybeNew("SaveMaterialVariantResult", data["saveMaterialVariant"] || undefined, {}),
  } as any;
}

export function newSaveMaterialVariantResponse(
  variables: SaveMaterialVariantMutationVariables,
  data: SaveMaterialVariantDataOptions | Error,
): MockedResponse<SaveMaterialVariantMutationVariables, SaveMaterialVariantMutation> {
  return {
    request: { query: SaveMaterialVariantDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveMaterialVariantData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveMavDataOptions {
  saveMaterialAttributeValue?: SaveMaterialAttributeValueResult | SaveMaterialAttributeValueResultOptions;
}

export function newSaveMavData(data: SaveMavDataOptions): SaveMavMutation {
  return {
    __typename: "Mutation" as const,
    saveMaterialAttributeValue: maybeNew(
      "SaveMaterialAttributeValueResult",
      data["saveMaterialAttributeValue"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveMavResponse(
  variables: SaveMavMutationVariables,
  data: SaveMavDataOptions | Error,
): MockedResponse<SaveMavMutationVariables, SaveMavMutation> {
  return {
    request: { query: SaveMavDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveMavData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveMaterialBrandDataOptions {
  saveMaterialBrand?: SaveMaterialBrandResult | SaveMaterialBrandResultOptions;
}

export function newSaveMaterialBrandData(data: SaveMaterialBrandDataOptions): SaveMaterialBrandMutation {
  return {
    __typename: "Mutation" as const,
    saveMaterialBrand: maybeNew("SaveMaterialBrandResult", data["saveMaterialBrand"] || undefined, {}),
  } as any;
}

export function newSaveMaterialBrandResponse(
  variables: SaveMaterialBrandMutationVariables,
  data: SaveMaterialBrandDataOptions | Error,
): MockedResponse<SaveMaterialBrandMutationVariables, SaveMaterialBrandMutation> {
  return {
    request: { query: SaveMaterialBrandDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveMaterialBrandData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MaterialCostPageDataOptions {
  materialVariantCostSources?: MaterialVariantCostSourcesPage | MaterialVariantCostSourcesPageOptions;
}

export function newMaterialCostPageData(data: MaterialCostPageDataOptions): MaterialCostPageQuery {
  return {
    __typename: "Query" as const,
    materialVariantCostSources: maybeNew(
      "MaterialVariantCostSourcesPage",
      data["materialVariantCostSources"] || undefined,
      {},
    ),
  } as any;
}

export function newMaterialCostPageResponse(
  variables: MaterialCostPageQueryVariables,
  data: MaterialCostPageDataOptions | Error,
): MockedResponse<MaterialCostPageQueryVariables, MaterialCostPageQuery> {
  return {
    request: { query: MaterialCostPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newMaterialCostPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MilestoneCatalogPageMetaDataDataOptions {
  globalPlanMilestoneGroups?: (GlobalPlanMilestoneGroup | GlobalPlanMilestoneGroupOptions)[];
}

export function newMilestoneCatalogPageMetaDataData(
  data: MilestoneCatalogPageMetaDataDataOptions,
): MilestoneCatalogPageMetaDataQuery {
  return {
    __typename: "Query" as const,
    globalPlanMilestoneGroups: data["globalPlanMilestoneGroups"]?.map((d) => newGlobalPlanMilestoneGroup(d)) || [],
  } as any;
}

export function newMilestoneCatalogPageMetaDataResponse(
  data: MilestoneCatalogPageMetaDataDataOptions | Error,
): MockedResponse<MilestoneCatalogPageMetaDataQueryVariables, MilestoneCatalogPageMetaDataQuery> {
  return {
    request: { query: MilestoneCatalogPageMetaDataDocument },
    result: { data: data instanceof Error ? undefined : newMilestoneCatalogPageMetaDataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MilestoneCatalogPageDataOptions {
  globalPlanMilestones?: GlobalPlanMilestonesPageResult | GlobalPlanMilestonesPageResultOptions;
}

export function newMilestoneCatalogPageData(data: MilestoneCatalogPageDataOptions): MilestoneCatalogPageQuery {
  return {
    __typename: "Query" as const,
    globalPlanMilestones: maybeNew("GlobalPlanMilestonesPageResult", data["globalPlanMilestones"] || undefined, {}),
  } as any;
}

export function newMilestoneCatalogPageResponse(
  variables: MilestoneCatalogPageQueryVariables,
  data: MilestoneCatalogPageDataOptions | Error,
): MockedResponse<MilestoneCatalogPageQueryVariables, MilestoneCatalogPageQuery> {
  return {
    request: { query: MilestoneCatalogPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newMilestoneCatalogPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MilestoneCatalogFormDataOptions {
  globalPlanMilestone?: GlobalPlanMilestone | GlobalPlanMilestoneOptions;
}

export function newMilestoneCatalogFormData(data: MilestoneCatalogFormDataOptions): MilestoneCatalogFormQuery {
  return {
    __typename: "Query" as const,
    globalPlanMilestone: maybeNew("GlobalPlanMilestone", data["globalPlanMilestone"] || undefined, {}),
  } as any;
}

export function newMilestoneCatalogFormResponse(
  variables: MilestoneCatalogFormQueryVariables,
  data: MilestoneCatalogFormDataOptions | Error,
): MockedResponse<MilestoneCatalogFormQueryVariables, MilestoneCatalogFormQuery> {
  return {
    request: { query: MilestoneCatalogFormDocument, variables },
    result: { data: data instanceof Error ? undefined : newMilestoneCatalogFormData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MilestoneCatalogFormDropdownDataOptions {
  globalPlanMilestoneGroups?: (GlobalPlanMilestoneGroup | GlobalPlanMilestoneGroupOptions)[];
  globalPlanConstraintItems?: (GlobalPlanConstraintItem | GlobalPlanConstraintItemOptions)[];
}

export function newMilestoneCatalogFormDropdownData(
  data: MilestoneCatalogFormDropdownDataOptions,
): MilestoneCatalogFormDropdownQuery {
  return {
    __typename: "Query" as const,
    globalPlanMilestoneGroups: data["globalPlanMilestoneGroups"]?.map((d) => newGlobalPlanMilestoneGroup(d)) || [],
    globalPlanConstraintItems: data["globalPlanConstraintItems"]?.map((d) => newGlobalPlanConstraintItem(d)) || [],
  } as any;
}

export function newMilestoneCatalogFormDropdownResponse(
  data: MilestoneCatalogFormDropdownDataOptions | Error,
): MockedResponse<MilestoneCatalogFormDropdownQueryVariables, MilestoneCatalogFormDropdownQuery> {
  return {
    request: { query: MilestoneCatalogFormDropdownDocument },
    result: { data: data instanceof Error ? undefined : newMilestoneCatalogFormDropdownData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveGlobalPlanMilestonesDataOptions {
  saveGlobalPlanMilestones?: SaveGlobalPlanMilestonesResult | SaveGlobalPlanMilestonesResultOptions;
}

export function newSaveGlobalPlanMilestonesData(
  data: SaveGlobalPlanMilestonesDataOptions,
): SaveGlobalPlanMilestonesMutation {
  return {
    __typename: "Mutation" as const,
    saveGlobalPlanMilestones: maybeNew(
      "SaveGlobalPlanMilestonesResult",
      data["saveGlobalPlanMilestones"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveGlobalPlanMilestonesResponse(
  variables: SaveGlobalPlanMilestonesMutationVariables,
  data: SaveGlobalPlanMilestonesDataOptions | Error,
): MockedResponse<SaveGlobalPlanMilestonesMutationVariables, SaveGlobalPlanMilestonesMutation> {
  return {
    request: { query: SaveGlobalPlanMilestonesDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveGlobalPlanMilestonesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProductCatalogDataOptions {
  productsPage?: ProductsPage | ProductsPageOptions;
}

export function newProductCatalogData(data: ProductCatalogDataOptions): ProductCatalogQuery {
  return {
    __typename: "Query" as const,
    productsPage: maybeNew("ProductsPage", data["productsPage"] || undefined, {}),
  } as any;
}

export function newProductCatalogResponse(
  variables: ProductCatalogQueryVariables,
  data: ProductCatalogDataOptions | Error,
): MockedResponse<ProductCatalogQueryVariables, ProductCatalogQuery> {
  return {
    request: { query: ProductCatalogDocument, variables },
    result: { data: data instanceof Error ? undefined : newProductCatalogData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface EditProductOfferingConfigDataOptions {
  productOfferingConfig?: ProductOfferingConfig | ProductOfferingConfigOptions;
}

export function newEditProductOfferingConfigData(
  data: EditProductOfferingConfigDataOptions,
): EditProductOfferingConfigQuery {
  return {
    __typename: "Query" as const,
    productOfferingConfig: maybeNew("ProductOfferingConfig", data["productOfferingConfig"] || undefined, {}),
  } as any;
}

export function newEditProductOfferingConfigResponse(
  variables: EditProductOfferingConfigQueryVariables,
  data: EditProductOfferingConfigDataOptions | Error,
): MockedResponse<EditProductOfferingConfigQueryVariables, EditProductOfferingConfigQuery> {
  return {
    request: { query: EditProductOfferingConfigDocument, variables },
    result: { data: data instanceof Error ? undefined : newEditProductOfferingConfigData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddProductOfferingConfigMetaDataOptions {
  computeProductOfferingCostsAndPrices?:
    | ComputeProductOfferingCostsAndPricesResponse
    | ComputeProductOfferingCostsAndPricesResponseOptions;
  computeProgramData?: NewProgramData | NewProgramDataOptions;
  productOffering?: ProductOffering | ProductOfferingOptions;
}

export function newAddProductOfferingConfigMetaData(
  data: AddProductOfferingConfigMetaDataOptions,
): AddProductOfferingConfigMetaQuery {
  return {
    __typename: "Query" as const,
    computeProductOfferingCostsAndPrices: maybeNew(
      "ComputeProductOfferingCostsAndPricesResponse",
      data["computeProductOfferingCostsAndPrices"] || undefined,
      {},
    ),
    computeProgramData: maybeNew("NewProgramData", data["computeProgramData"] || undefined, {}),
    productOffering: maybeNew("ProductOffering", data["productOffering"] || undefined, {}),
  } as any;
}

export function newAddProductOfferingConfigMetaResponse(
  variables: AddProductOfferingConfigMetaQueryVariables,
  data: AddProductOfferingConfigMetaDataOptions | Error,
): MockedResponse<AddProductOfferingConfigMetaQueryVariables, AddProductOfferingConfigMetaQuery> {
  return {
    request: { query: AddProductOfferingConfigMetaDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddProductOfferingConfigMetaData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddProductOfferingConfigs_DeltasDataOptions {
  computeProductOfferingCostsAndPrices?:
    | ComputeProductOfferingCostsAndPricesResponse
    | ComputeProductOfferingCostsAndPricesResponseOptions;
  computeProgramData?: NewProgramData | NewProgramDataOptions;
}

export function newAddProductOfferingConfigs_DeltasData(
  data: AddProductOfferingConfigs_DeltasDataOptions,
): AddProductOfferingConfigs_DeltasQuery {
  return {
    __typename: "Query" as const,
    computeProductOfferingCostsAndPrices: maybeNew(
      "ComputeProductOfferingCostsAndPricesResponse",
      data["computeProductOfferingCostsAndPrices"] || undefined,
      {},
    ),
    computeProgramData: maybeNew("NewProgramData", data["computeProgramData"] || undefined, {}),
  } as any;
}

export function newAddProductOfferingConfigs_DeltasResponse(
  variables: AddProductOfferingConfigs_DeltasQueryVariables,
  data: AddProductOfferingConfigs_DeltasDataOptions | Error,
): MockedResponse<AddProductOfferingConfigs_DeltasQueryVariables, AddProductOfferingConfigs_DeltasQuery> {
  return {
    request: { query: AddProductOfferingConfigs_DeltasDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddProductOfferingConfigs_DeltasData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateProjectFromConfigMetaDataOptions {
  cohorts?: (Cohort | CohortOptions)[];
  project?: Project | ProjectOptions;
  productOfferingConfig?: ProductOfferingConfig | ProductOfferingConfigOptions;
  enumDetails?: AllEnumDetails | AllEnumDetailsOptions;
  projectsPage?: ProjectsPageResult | ProjectsPageResultOptions;
}

export function newCreateProjectFromConfigMetaData(
  data: CreateProjectFromConfigMetaDataOptions,
): CreateProjectFromConfigMetaQuery {
  return {
    __typename: "Query" as const,
    cohorts: data["cohorts"]?.map((d) => newCohort(d)) || [],
    project: maybeNew("Project", data["project"] || undefined, {}),
    productOfferingConfig: maybeNew("ProductOfferingConfig", data["productOfferingConfig"] || undefined, {}),
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
    projectsPage: maybeNew("ProjectsPageResult", data["projectsPage"] || undefined, {}),
  } as any;
}

export function newCreateProjectFromConfigMetaResponse(
  variables: CreateProjectFromConfigMetaQueryVariables,
  data: CreateProjectFromConfigMetaDataOptions | Error,
): MockedResponse<CreateProjectFromConfigMetaQueryVariables, CreateProjectFromConfigMetaQuery> {
  return {
    request: { query: CreateProjectFromConfigMetaDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateProjectFromConfigMetaData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateProjectFromProductOfferingConfigDataOptions {
  createProjectFromReadyPlan?: SaveProjectResult | SaveProjectResultOptions;
}

export function newCreateProjectFromProductOfferingConfigData(
  data: CreateProjectFromProductOfferingConfigDataOptions,
): CreateProjectFromProductOfferingConfigMutation {
  return {
    __typename: "Mutation" as const,
    createProjectFromReadyPlan: maybeNew("SaveProjectResult", data["createProjectFromReadyPlan"] || undefined, {}),
  } as any;
}

export function newCreateProjectFromProductOfferingConfigResponse(
  variables: CreateProjectFromProductOfferingConfigMutationVariables,
  data: CreateProjectFromProductOfferingConfigDataOptions | Error,
): MockedResponse<
  CreateProjectFromProductOfferingConfigMutationVariables,
  CreateProjectFromProductOfferingConfigMutation
> {
  return {
    request: { query: CreateProjectFromProductOfferingConfigDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateProjectFromProductOfferingConfigData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveProductOfferingConfigDataOptions {
  saveProductOfferingConfig?: SaveProductOfferingConfigResult | SaveProductOfferingConfigResultOptions;
}

export function newSaveProductOfferingConfigData(
  data: SaveProductOfferingConfigDataOptions,
): SaveProductOfferingConfigMutation {
  return {
    __typename: "Mutation" as const,
    saveProductOfferingConfig: maybeNew(
      "SaveProductOfferingConfigResult",
      data["saveProductOfferingConfig"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveProductOfferingConfigResponse(
  variables: SaveProductOfferingConfigMutationVariables,
  data: SaveProductOfferingConfigDataOptions | Error,
): MockedResponse<SaveProductOfferingConfigMutationVariables, SaveProductOfferingConfigMutation> {
  return {
    request: { query: SaveProductOfferingConfigDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveProductOfferingConfigData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProductPageDataOptions {
  products?: (Product | ProductOptions)[];
}

export function newProductPageData(data: ProductPageDataOptions): ProductPageQuery {
  return { __typename: "Query" as const, products: data["products"]?.map((d) => newProduct(d)) || [] } as any;
}

export function newProductPageResponse(
  variables: ProductPageQueryVariables,
  data: ProductPageDataOptions | Error,
): MockedResponse<ProductPageQueryVariables, ProductPageQuery> {
  return {
    request: { query: ProductPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newProductPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProductPageOptionsDataOptions {
  attributes?: (ProductAttribute | ProductAttributeOptions)[];
  items?: (Item | ItemOptions)[];
}

export function newProductPageOptionsData(data: ProductPageOptionsDataOptions): ProductPageOptionsQuery {
  return {
    __typename: "Query" as const,
    attributes: data["attributes"]?.map((d) => newProductAttribute(d)) || [],
    items: data["items"]?.map((d) => newItem(d)) || [],
  } as any;
}

export function newProductPageOptionsResponse(
  data: ProductPageOptionsDataOptions | Error,
): MockedResponse<ProductPageOptionsQueryVariables, ProductPageOptionsQuery> {
  return {
    request: { query: ProductPageOptionsDocument },
    result: { data: data instanceof Error ? undefined : newProductPageOptionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveProductsDataOptions {
  saveProducts?: SaveProductsResult | SaveProductsResultOptions;
}

export function newSaveProductsData(data: SaveProductsDataOptions): SaveProductsMutation {
  return {
    __typename: "Mutation" as const,
    saveProducts: maybeNew("SaveProductsResult", data["saveProducts"] || undefined, {}),
  } as any;
}

export function newSaveProductsResponse(
  variables: SaveProductsMutationVariables,
  data: SaveProductsDataOptions | Error,
): MockedResponse<SaveProductsMutationVariables, SaveProductsMutation> {
  return {
    request: { query: SaveProductsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveProductsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProductOfferingConfigsPageMetadataDataOptions {
  markets?: (Market | MarketOptions)[];
}

export function newProductOfferingConfigsPageMetadataData(
  data: ProductOfferingConfigsPageMetadataDataOptions,
): ProductOfferingConfigsPageMetadataQuery {
  return { __typename: "Query" as const, markets: data["markets"]?.map((d) => newMarket(d)) || [] } as any;
}

export function newProductOfferingConfigsPageMetadataResponse(
  data: ProductOfferingConfigsPageMetadataDataOptions | Error,
): MockedResponse<ProductOfferingConfigsPageMetadataQueryVariables, ProductOfferingConfigsPageMetadataQuery> {
  return {
    request: { query: ProductOfferingConfigsPageMetadataDocument },
    result: { data: data instanceof Error ? undefined : newProductOfferingConfigsPageMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProductOfferingConfigsDataOptions {
  productOfferingConfigs?: ProductOfferingConfigsPage | ProductOfferingConfigsPageOptions;
}

export function newProductOfferingConfigsData(data: ProductOfferingConfigsDataOptions): ProductOfferingConfigsQuery {
  return {
    __typename: "Query" as const,
    productOfferingConfigs: maybeNew("ProductOfferingConfigsPage", data["productOfferingConfigs"] || undefined, {}),
  } as any;
}

export function newProductOfferingConfigsResponse(
  variables: ProductOfferingConfigsQueryVariables,
  data: ProductOfferingConfigsDataOptions | Error,
): MockedResponse<ProductOfferingConfigsQueryVariables, ProductOfferingConfigsQuery> {
  return {
    request: { query: ProductOfferingConfigsDocument, variables },
    result: { data: data instanceof Error ? undefined : newProductOfferingConfigsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface GlobalProductOfferingsMetaDataDataOptions {
  markets?: (Market | MarketOptions)[];
}

export function newGlobalProductOfferingsMetaDataData(
  data: GlobalProductOfferingsMetaDataDataOptions,
): GlobalProductOfferingsMetaDataQuery {
  return { __typename: "Query" as const, markets: data["markets"]?.map((d) => newMarket(d)) || [] } as any;
}

export function newGlobalProductOfferingsMetaDataResponse(
  data: GlobalProductOfferingsMetaDataDataOptions | Error,
): MockedResponse<GlobalProductOfferingsMetaDataQueryVariables, GlobalProductOfferingsMetaDataQuery> {
  return {
    request: { query: GlobalProductOfferingsMetaDataDocument },
    result: { data: data instanceof Error ? undefined : newGlobalProductOfferingsMetaDataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface GlobalProductOfferingsPageDataOptions {
  productOfferings?: ProductOfferingsPageResult | ProductOfferingsPageResultOptions;
}

export function newGlobalProductOfferingsPageData(
  data: GlobalProductOfferingsPageDataOptions,
): GlobalProductOfferingsPageQuery {
  return {
    __typename: "Query" as const,
    productOfferings: maybeNew("ProductOfferingsPageResult", data["productOfferings"] || undefined, {}),
  } as any;
}

export function newGlobalProductOfferingsPageResponse(
  variables: GlobalProductOfferingsPageQueryVariables,
  data: GlobalProductOfferingsPageDataOptions | Error,
): MockedResponse<GlobalProductOfferingsPageQueryVariables, GlobalProductOfferingsPageQuery> {
  return {
    request: { query: GlobalProductOfferingsPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newGlobalProductOfferingsPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentsByMarketDataOptions {
  developments?: (Development | DevelopmentOptions)[];
}

export function newDevelopmentsByMarketData(data: DevelopmentsByMarketDataOptions): DevelopmentsByMarketQuery {
  return {
    __typename: "Query" as const,
    developments: data["developments"]?.map((d) => newDevelopment(d)) || [],
  } as any;
}

export function newDevelopmentsByMarketResponse(
  variables: DevelopmentsByMarketQueryVariables,
  data: DevelopmentsByMarketDataOptions | Error,
): MockedResponse<DevelopmentsByMarketQueryVariables, DevelopmentsByMarketQuery> {
  return {
    request: { query: DevelopmentsByMarketDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentsByMarketData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ConstraintAndAllowanceCatalogPageDataOptions {
  globalPlanConstraintItems?: (GlobalPlanConstraintItem | GlobalPlanConstraintItemOptions)[];
}

export function newConstraintAndAllowanceCatalogPageData(
  data: ConstraintAndAllowanceCatalogPageDataOptions,
): ConstraintAndAllowanceCatalogPageQuery {
  return {
    __typename: "Query" as const,
    globalPlanConstraintItems: data["globalPlanConstraintItems"]?.map((d) => newGlobalPlanConstraintItem(d)) || [],
  } as any;
}

export function newConstraintAndAllowanceCatalogPageResponse(
  data: ConstraintAndAllowanceCatalogPageDataOptions | Error,
): MockedResponse<ConstraintAndAllowanceCatalogPageQueryVariables, ConstraintAndAllowanceCatalogPageQuery> {
  return {
    request: { query: ConstraintAndAllowanceCatalogPageDocument },
    result: { data: data instanceof Error ? undefined : newConstraintAndAllowanceCatalogPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScheduleTemplatesPageMetadataDataOptions {
  markets?: (Market | MarketOptions)[];
}

export function newScheduleTemplatesPageMetadataData(
  data: ScheduleTemplatesPageMetadataDataOptions,
): ScheduleTemplatesPageMetadataQuery {
  return { __typename: "Query" as const, markets: data["markets"]?.map((d) => newMarket(d)) || [] } as any;
}

export function newScheduleTemplatesPageMetadataResponse(
  data: ScheduleTemplatesPageMetadataDataOptions | Error,
): MockedResponse<ScheduleTemplatesPageMetadataQueryVariables, ScheduleTemplatesPageMetadataQuery> {
  return {
    request: { query: ScheduleTemplatesPageMetadataDocument },
    result: { data: data instanceof Error ? undefined : newScheduleTemplatesPageMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScheduleTemplateMetadataDataOptions {
  schedules?: (Schedule | ScheduleOptions)[];
  scheduleTasks?: (ScheduleTask | ScheduleTaskOptions)[];
}

export function newScheduleTemplateMetadataData(
  data: ScheduleTemplateMetadataDataOptions,
): ScheduleTemplateMetadataQuery {
  return {
    __typename: "Query" as const,
    schedules: data["schedules"]?.map((d) => newSchedule(d)) || [],
    scheduleTasks: data["scheduleTasks"]?.map((d) => newScheduleTask(d)) || [],
  } as any;
}

export function newScheduleTemplateMetadataResponse(
  variables: ScheduleTemplateMetadataQueryVariables,
  data: ScheduleTemplateMetadataDataOptions | Error,
): MockedResponse<ScheduleTemplateMetadataQueryVariables, ScheduleTemplateMetadataQuery> {
  return {
    request: { query: ScheduleTemplateMetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newScheduleTemplateMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScheduleTemplatesDataOptions {
  scheduleTemplates?: (ScheduleTemplate | ScheduleTemplateOptions)[];
}

export function newScheduleTemplatesData(data: ScheduleTemplatesDataOptions): ScheduleTemplatesQuery {
  return {
    __typename: "Query" as const,
    scheduleTemplates: data["scheduleTemplates"]?.map((d) => newScheduleTemplate(d)) || [],
  } as any;
}

export function newScheduleTemplatesResponse(
  variables: ScheduleTemplatesQueryVariables,
  data: ScheduleTemplatesDataOptions | Error,
): MockedResponse<ScheduleTemplatesQueryVariables, ScheduleTemplatesQuery> {
  return {
    request: { query: ScheduleTemplatesDocument, variables },
    result: { data: data instanceof Error ? undefined : newScheduleTemplatesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScheduleTemplateDetailDataOptions {
  scheduleTemplate?: ScheduleTemplate | ScheduleTemplateOptions;
}

export function newScheduleTemplateDetailData(data: ScheduleTemplateDetailDataOptions): ScheduleTemplateDetailQuery {
  return {
    __typename: "Query" as const,
    scheduleTemplate: maybeNew("ScheduleTemplate", data["scheduleTemplate"] || undefined, {}),
  } as any;
}

export function newScheduleTemplateDetailResponse(
  variables: ScheduleTemplateDetailQueryVariables,
  data: ScheduleTemplateDetailDataOptions | Error,
): MockedResponse<ScheduleTemplateDetailQueryVariables, ScheduleTemplateDetailQuery> {
  return {
    request: { query: ScheduleTemplateDetailDocument, variables },
    result: { data: data instanceof Error ? undefined : newScheduleTemplateDetailData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScheduleTemplateEditPageDataOptions {
  scheduleTemplate?: ScheduleTemplate | ScheduleTemplateOptions;
  schedules?: (Schedule | ScheduleOptions)[];
  scheduleTasks?: (ScheduleTask | ScheduleTaskOptions)[];
  projectRoleDetails?: (ProjectRoleDetail | ProjectRoleDetailOptions)[];
}

export function newScheduleTemplateEditPageData(
  data: ScheduleTemplateEditPageDataOptions,
): ScheduleTemplateEditPageQuery {
  return {
    __typename: "Query" as const,
    scheduleTemplate: maybeNew("ScheduleTemplate", data["scheduleTemplate"] || undefined, {}),
    schedules: data["schedules"]?.map((d) => newSchedule(d)) || [],
    scheduleTasks: data["scheduleTasks"]?.map((d) => newScheduleTask(d)) || [],
    projectRoleDetails: data["projectRoleDetails"]?.map((d) => newProjectRoleDetail(d)) || [],
  } as any;
}

export function newScheduleTemplateEditPageResponse(
  variables: ScheduleTemplateEditPageQueryVariables,
  data: ScheduleTemplateEditPageDataOptions | Error,
): MockedResponse<ScheduleTemplateEditPageQueryVariables, ScheduleTemplateEditPageQuery> {
  return {
    request: { query: ScheduleTemplateEditPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newScheduleTemplateEditPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveScheduleTemplatesDataOptions {
  saveScheduleTemplates?: SaveScheduleTemplatesResult | SaveScheduleTemplatesResultOptions;
}

export function newSaveScheduleTemplatesData(data: SaveScheduleTemplatesDataOptions): SaveScheduleTemplatesMutation {
  return {
    __typename: "Mutation" as const,
    saveScheduleTemplates: maybeNew("SaveScheduleTemplatesResult", data["saveScheduleTemplates"] || undefined, {}),
  } as any;
}

export function newSaveScheduleTemplatesResponse(
  variables: SaveScheduleTemplatesMutationVariables,
  data: SaveScheduleTemplatesDataOptions | Error,
): MockedResponse<SaveScheduleTemplatesMutationVariables, SaveScheduleTemplatesMutation> {
  return {
    request: { query: SaveScheduleTemplatesDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveScheduleTemplatesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DuplicateScheduleTemplateDataOptions {
  duplicateScheduleTemplate?: DuplicateScheduleTemplateResult | DuplicateScheduleTemplateResultOptions;
}

export function newDuplicateScheduleTemplateData(
  data: DuplicateScheduleTemplateDataOptions,
): DuplicateScheduleTemplateMutation {
  return {
    __typename: "Mutation" as const,
    duplicateScheduleTemplate: maybeNew(
      "DuplicateScheduleTemplateResult",
      data["duplicateScheduleTemplate"] || undefined,
      {},
    ),
  } as any;
}

export function newDuplicateScheduleTemplateResponse(
  variables: DuplicateScheduleTemplateMutationVariables,
  data: DuplicateScheduleTemplateDataOptions | Error,
): MockedResponse<DuplicateScheduleTemplateMutationVariables, DuplicateScheduleTemplateMutation> {
  return {
    request: { query: DuplicateScheduleTemplateDocument, variables },
    result: { data: data instanceof Error ? undefined : newDuplicateScheduleTemplateData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TaskCatalogLaborCostsPageDataOptions {
  bidItemEstimates?: BidItemEstimatesPageResult | BidItemEstimatesPageResultOptions;
}

export function newTaskCatalogLaborCostsPageData(
  data: TaskCatalogLaborCostsPageDataOptions,
): TaskCatalogLaborCostsPageQuery {
  return {
    __typename: "Query" as const,
    bidItemEstimates: maybeNew("BidItemEstimatesPageResult", data["bidItemEstimates"] || undefined, {}),
  } as any;
}

export function newTaskCatalogLaborCostsPageResponse(
  variables: TaskCatalogLaborCostsPageQueryVariables,
  data: TaskCatalogLaborCostsPageDataOptions | Error,
): MockedResponse<TaskCatalogLaborCostsPageQueryVariables, TaskCatalogLaborCostsPageQuery> {
  return {
    request: { query: TaskCatalogLaborCostsPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newTaskCatalogLaborCostsPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TaskCatalogPageMetadataDataOptions {
  regions?: (Region | RegionOptions)[];
  globalPlanTags?: (GlobalPlanTag | GlobalPlanTagOptions)[];
  enumDetails?: AllEnumDetails | AllEnumDetailsOptions;
}

export function newTaskCatalogPageMetadataData(data: TaskCatalogPageMetadataDataOptions): TaskCatalogPageMetadataQuery {
  return {
    __typename: "Query" as const,
    regions: data["regions"]?.map((d) => newRegion(d)) || [],
    globalPlanTags: data["globalPlanTags"]?.map((d) => newGlobalPlanTag(d)) || [],
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
  } as any;
}

export function newTaskCatalogPageMetadataResponse(
  data: TaskCatalogPageMetadataDataOptions | Error,
): MockedResponse<TaskCatalogPageMetadataQueryVariables, TaskCatalogPageMetadataQuery> {
  return {
    request: { query: TaskCatalogPageMetadataDocument },
    result: { data: data instanceof Error ? undefined : newTaskCatalogPageMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TaskCatalogTableMetadataDataOptions {
  globalPlanTags?: (GlobalPlanTag | GlobalPlanTagOptions)[];
}

export function newTaskCatalogTableMetadataData(
  data: TaskCatalogTableMetadataDataOptions,
): TaskCatalogTableMetadataQuery {
  return {
    __typename: "Query" as const,
    globalPlanTags: data["globalPlanTags"]?.map((d) => newGlobalPlanTag(d)) || [],
  } as any;
}

export function newTaskCatalogTableMetadataResponse(
  data: TaskCatalogTableMetadataDataOptions | Error,
): MockedResponse<TaskCatalogTableMetadataQueryVariables, TaskCatalogTableMetadataQuery> {
  return {
    request: { query: TaskCatalogTableMetadataDocument },
    result: { data: data instanceof Error ? undefined : newTaskCatalogTableMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TaskCatalogTableDataOptions {
  globalPlanTasks?: GlobalPlanTasksPageResult | GlobalPlanTasksPageResultOptions;
}

export function newTaskCatalogTableData(data: TaskCatalogTableDataOptions): TaskCatalogTableQuery {
  return {
    __typename: "Query" as const,
    globalPlanTasks: maybeNew("GlobalPlanTasksPageResult", data["globalPlanTasks"] || undefined, {}),
  } as any;
}

export function newTaskCatalogTableResponse(
  variables: TaskCatalogTableQueryVariables,
  data: TaskCatalogTableDataOptions | Error,
): MockedResponse<TaskCatalogTableQueryVariables, TaskCatalogTableQuery> {
  return {
    request: { query: TaskCatalogTableDocument, variables },
    result: { data: data instanceof Error ? undefined : newTaskCatalogTableData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface UserEventsDataOptions {
  userEvents?: (UserEvent | UserEventOptions)[];
}

export function newUserEventsData(data: UserEventsDataOptions): UserEventsQuery {
  return { __typename: "Query" as const, userEvents: data["userEvents"]?.map((d) => newUserEvent(d)) || [] } as any;
}

export function newUserEventsResponse(
  variables: UserEventsQueryVariables,
  data: UserEventsDataOptions | Error,
): MockedResponse<UserEventsQueryVariables, UserEventsQuery> {
  return {
    request: { query: UserEventsDocument, variables },
    result: { data: data instanceof Error ? undefined : newUserEventsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillPdfDataOptions {
  bill?: Bill | BillOptions;
}

export function newBillPdfData(data: BillPdfDataOptions): BillPdfQuery {
  return { __typename: "Query" as const, bill: maybeNew("Bill", data["bill"] || undefined, {}) } as any;
}

export function newBillPdfResponse(
  variables: BillPdfQueryVariables,
  data: BillPdfDataOptions | Error,
): MockedResponse<BillPdfQueryVariables, BillPdfQuery> {
  return {
    request: { query: BillPdfDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillPdfData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillPdfTradePartnerContactDataOptions {
  tradePartner?: TradePartner | TradePartnerOptions;
}

export function newBillPdfTradePartnerContactData(
  data: BillPdfTradePartnerContactDataOptions,
): BillPdfTradePartnerContactQuery {
  return {
    __typename: "Query" as const,
    tradePartner: maybeNew("TradePartner", data["tradePartner"] || undefined, {}),
  } as any;
}

export function newBillPdfTradePartnerContactResponse(
  variables: BillPdfTradePartnerContactQueryVariables,
  data: BillPdfTradePartnerContactDataOptions | Error,
): MockedResponse<BillPdfTradePartnerContactQueryVariables, BillPdfTradePartnerContactQuery> {
  return {
    request: { query: BillPdfTradePartnerContactDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillPdfTradePartnerContactData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CommitmentPdfDataOptions {
  commitment?: Commitment | CommitmentOptions;
}

export function newCommitmentPdfData(data: CommitmentPdfDataOptions): CommitmentPdfQuery {
  return {
    __typename: "Query" as const,
    commitment: maybeNew("Commitment", data["commitment"] || undefined, {}),
  } as any;
}

export function newCommitmentPdfResponse(
  variables: CommitmentPdfQueryVariables,
  data: CommitmentPdfDataOptions | Error,
): MockedResponse<CommitmentPdfQueryVariables, CommitmentPdfQuery> {
  return {
    request: { query: CommitmentPdfDocument, variables },
    result: { data: data instanceof Error ? undefined : newCommitmentPdfData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CommitmentChangeOrderPdfDataOptions {
  commitmentChangeOrder?: CommitmentChangeOrder | CommitmentChangeOrderOptions;
}

export function newCommitmentChangeOrderPdfData(
  data: CommitmentChangeOrderPdfDataOptions,
): CommitmentChangeOrderPdfQuery {
  return {
    __typename: "Query" as const,
    commitmentChangeOrder: maybeNew("CommitmentChangeOrder", data["commitmentChangeOrder"] || undefined, {}),
  } as any;
}

export function newCommitmentChangeOrderPdfResponse(
  variables: CommitmentChangeOrderPdfQueryVariables,
  data: CommitmentChangeOrderPdfDataOptions | Error,
): MockedResponse<CommitmentChangeOrderPdfQueryVariables, CommitmentChangeOrderPdfQuery> {
  return {
    request: { query: CommitmentChangeOrderPdfDocument, variables },
    result: { data: data instanceof Error ? undefined : newCommitmentChangeOrderPdfData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentContractPdfDataOptions {
  bidContract?: BidContract | BidContractOptions;
}

export function newDevelopmentContractPdfData(data: DevelopmentContractPdfDataOptions): DevelopmentContractPdfQuery {
  return {
    __typename: "Query" as const,
    bidContract: maybeNew("BidContract", data["bidContract"] || undefined, {}),
  } as any;
}

export function newDevelopmentContractPdfResponse(
  variables: DevelopmentContractPdfQueryVariables,
  data: DevelopmentContractPdfDataOptions | Error,
): MockedResponse<DevelopmentContractPdfQueryVariables, DevelopmentContractPdfQuery> {
  return {
    request: { query: DevelopmentContractPdfDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentContractPdfData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentCommitmentPdfDataOptions {
  developmentCommitments?: (DevelopmentCommitment | DevelopmentCommitmentOptions)[];
}

export function newDevelopmentCommitmentPdfData(
  data: DevelopmentCommitmentPdfDataOptions,
): DevelopmentCommitmentPdfQuery {
  return {
    __typename: "Query" as const,
    developmentCommitments: data["developmentCommitments"]?.map((d) => newDevelopmentCommitment(d)) || [],
  } as any;
}

export function newDevelopmentCommitmentPdfResponse(
  variables: DevelopmentCommitmentPdfQueryVariables,
  data: DevelopmentCommitmentPdfDataOptions | Error,
): MockedResponse<DevelopmentCommitmentPdfQueryVariables, DevelopmentCommitmentPdfQuery> {
  return {
    request: { query: DevelopmentCommitmentPdfDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentCommitmentPdfData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface InvoicePandaDocPdfDataOptions {
  invoice?: Invoice | InvoiceOptions;
}

export function newInvoicePandaDocPdfData(data: InvoicePandaDocPdfDataOptions): InvoicePandaDocPdfQuery {
  return { __typename: "Query" as const, invoice: maybeNew("Invoice", data["invoice"] || undefined, {}) } as any;
}

export function newInvoicePandaDocPdfResponse(
  variables: InvoicePandaDocPdfQueryVariables,
  data: InvoicePandaDocPdfDataOptions | Error,
): MockedResponse<InvoicePandaDocPdfQueryVariables, InvoicePandaDocPdfQuery> {
  return {
    request: { query: InvoicePandaDocPdfDocument, variables },
    result: { data: data instanceof Error ? undefined : newInvoicePandaDocPdfData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface LienWaiverPdfDataOptions {
  lienWaiver?: LienWaiver | LienWaiverOptions;
}

export function newLienWaiverPdfData(data: LienWaiverPdfDataOptions): LienWaiverPdfQuery {
  return {
    __typename: "Query" as const,
    lienWaiver: maybeNew("LienWaiver", data["lienWaiver"] || undefined, {}),
  } as any;
}

export function newLienWaiverPdfResponse(
  variables: LienWaiverPdfQueryVariables,
  data: LienWaiverPdfDataOptions | Error,
): MockedResponse<LienWaiverPdfQueryVariables, LienWaiverPdfQuery> {
  return {
    request: { query: LienWaiverPdfDocument, variables },
    result: { data: data instanceof Error ? undefined : newLienWaiverPdfData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface LienWaiverLastPaidBillDataOptions {
  billsPage?: BillsPage | BillsPageOptions;
}

export function newLienWaiverLastPaidBillData(data: LienWaiverLastPaidBillDataOptions): LienWaiverLastPaidBillQuery {
  return { __typename: "Query" as const, billsPage: maybeNew("BillsPage", data["billsPage"] || undefined, {}) } as any;
}

export function newLienWaiverLastPaidBillResponse(
  variables: LienWaiverLastPaidBillQueryVariables,
  data: LienWaiverLastPaidBillDataOptions | Error,
): MockedResponse<LienWaiverLastPaidBillQueryVariables, LienWaiverLastPaidBillQuery> {
  return {
    request: { query: LienWaiverLastPaidBillDocument, variables },
    result: { data: data instanceof Error ? undefined : newLienWaiverLastPaidBillData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectFinishSchedulePdfMetadataDataOptions {
  project?: Project | ProjectOptions;
  costCodes?: (CostCode | CostCodeOptions)[];
  locations?: (Location | LocationOptions)[];
}

export function newProjectFinishSchedulePdfMetadataData(
  data: ProjectFinishSchedulePdfMetadataDataOptions,
): ProjectFinishSchedulePdfMetadataQuery {
  return {
    __typename: "Query" as const,
    project: maybeNew("Project", data["project"] || undefined, {}),
    costCodes: data["costCodes"]?.map((d) => newCostCode(d)) || [],
    locations: data["locations"]?.map((d) => newLocation(d)) || [],
  } as any;
}

export function newProjectFinishSchedulePdfMetadataResponse(
  variables: ProjectFinishSchedulePdfMetadataQueryVariables,
  data: ProjectFinishSchedulePdfMetadataDataOptions | Error,
): MockedResponse<ProjectFinishSchedulePdfMetadataQueryVariables, ProjectFinishSchedulePdfMetadataQuery> {
  return {
    request: { query: ProjectFinishSchedulePdfMetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectFinishSchedulePdfMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface FinishScheduleVisualModePdfDataOptions {
  designPackage?: DesignPackage | DesignPackageOptions;
  readyPlanAggregateVersion?: ReadyPlanAggregateVersion | ReadyPlanAggregateVersionOptions;
  designPackageFinishSchedule?: DesignPackageFinishSchedulePageResult | DesignPackageFinishSchedulePageResultOptions;
  locations?: (Location | LocationOptions)[];
}

export function newFinishScheduleVisualModePdfData(
  data: FinishScheduleVisualModePdfDataOptions,
): FinishScheduleVisualModePdfQuery {
  return {
    __typename: "Query" as const,
    designPackage: maybeNew("DesignPackage", data["designPackage"] || undefined, {}),
    readyPlanAggregateVersion: maybeNew(
      "ReadyPlanAggregateVersion",
      data["readyPlanAggregateVersion"] || undefined,
      {},
    ),
    designPackageFinishSchedule: maybeNew(
      "DesignPackageFinishSchedulePageResult",
      data["designPackageFinishSchedule"] || undefined,
      {},
    ),
    locations: data["locations"]?.map((d) => newLocation(d)) || [],
  } as any;
}

export function newFinishScheduleVisualModePdfResponse(
  variables: FinishScheduleVisualModePdfQueryVariables,
  data: FinishScheduleVisualModePdfDataOptions | Error,
): MockedResponse<FinishScheduleVisualModePdfQueryVariables, FinishScheduleVisualModePdfQuery> {
  return {
    request: { query: FinishScheduleVisualModePdfDocument, variables },
    result: { data: data instanceof Error ? undefined : newFinishScheduleVisualModePdfData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectFinishScheduleVisualModePdfDataOptions {
  project?: Project | ProjectOptions;
}

export function newProjectFinishScheduleVisualModePdfData(
  data: ProjectFinishScheduleVisualModePdfDataOptions,
): ProjectFinishScheduleVisualModePdfQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newProjectFinishScheduleVisualModePdfResponse(
  variables: ProjectFinishScheduleVisualModePdfQueryVariables,
  data: ProjectFinishScheduleVisualModePdfDataOptions | Error,
): MockedResponse<ProjectFinishScheduleVisualModePdfQueryVariables, ProjectFinishScheduleVisualModePdfQuery> {
  return {
    request: { query: ProjectFinishScheduleVisualModePdfDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectFinishScheduleVisualModePdfData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScheduleExportPageDataOptions {
  schedules?: (Schedule | ScheduleOptions)[];
  scheduleTasks?: (ScheduleTask | ScheduleTaskOptions)[];
}

export function newScheduleExportPageData(data: ScheduleExportPageDataOptions): ScheduleExportPageQuery {
  return {
    __typename: "Query" as const,
    schedules: data["schedules"]?.map((d) => newSchedule(d)) || [],
    scheduleTasks: data["scheduleTasks"]?.map((d) => newScheduleTask(d)) || [],
  } as any;
}

export function newScheduleExportPageResponse(
  variables: ScheduleExportPageQueryVariables,
  data: ScheduleExportPageDataOptions | Error,
): MockedResponse<ScheduleExportPageQueryVariables, ScheduleExportPageQuery> {
  return {
    request: { query: ScheduleExportPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newScheduleExportPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ToDosPdfDataOptions {
  toDos?: (ToDo | ToDoOptions)[];
}

export function newToDosPdfData(data: ToDosPdfDataOptions): ToDosPdfQuery {
  return { __typename: "Query" as const, toDos: data["toDos"]?.map((d) => newToDo(d)) || [] } as any;
}

export function newToDosPdfResponse(
  variables: ToDosPdfQueryVariables,
  data: ToDosPdfDataOptions | Error,
): MockedResponse<ToDosPdfQueryVariables, ToDosPdfQuery> {
  return {
    request: { query: ToDosPdfDocument, variables },
    result: { data: data instanceof Error ? undefined : newToDosPdfData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TradeSpecificAgreementDataOptions {
  costDivisions?: (CostDivision | CostDivisionOptions)[];
  tradePartner?: TradePartner | TradePartnerOptions;
}

export function newTradeSpecificAgreementData(data: TradeSpecificAgreementDataOptions): TradeSpecificAgreementQuery {
  return {
    __typename: "Query" as const,
    costDivisions: data["costDivisions"]?.map((d) => newCostDivision(d)) || [],
    tradePartner: maybeNew("TradePartner", data["tradePartner"] || undefined, {}),
  } as any;
}

export function newTradeSpecificAgreementResponse(
  variables: TradeSpecificAgreementQueryVariables,
  data: TradeSpecificAgreementDataOptions | Error,
): MockedResponse<TradeSpecificAgreementQueryVariables, TradeSpecificAgreementQuery> {
  return {
    request: { query: TradeSpecificAgreementDocument, variables },
    result: { data: data instanceof Error ? undefined : newTradeSpecificAgreementData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TradesPunchlistPdfDataOptions {
  punchlistItemTodos?: (PunchlistItemTodo | PunchlistItemTodoOptions)[];
}

export function newTradesPunchlistPdfData(data: TradesPunchlistPdfDataOptions): TradesPunchlistPdfQuery {
  return {
    __typename: "Query" as const,
    punchlistItemTodos: data["punchlistItemTodos"]?.map((d) => newPunchlistItemTodo(d)) || [],
  } as any;
}

export function newTradesPunchlistPdfResponse(
  variables: TradesPunchlistPdfQueryVariables,
  data: TradesPunchlistPdfDataOptions | Error,
): MockedResponse<TradesPunchlistPdfQueryVariables, TradesPunchlistPdfQuery> {
  return {
    request: { query: TradesPunchlistPdfDocument, variables },
    result: { data: data instanceof Error ? undefined : newTradesPunchlistPdfData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface LotSummaryDetailsPdfDataOptions {
  projectReadyPlanConfig?: ProjectReadyPlanConfig | ProjectReadyPlanConfigOptions;
}

export function newLotSummaryDetailsPdfData(data: LotSummaryDetailsPdfDataOptions): LotSummaryDetailsPdfQuery {
  return {
    __typename: "Query" as const,
    projectReadyPlanConfig: maybeNew("ProjectReadyPlanConfig", data["projectReadyPlanConfig"] || undefined, {}),
  } as any;
}

export function newLotSummaryDetailsPdfResponse(
  variables: LotSummaryDetailsPdfQueryVariables,
  data: LotSummaryDetailsPdfDataOptions | Error,
): MockedResponse<LotSummaryDetailsPdfQueryVariables, LotSummaryDetailsPdfQuery> {
  return {
    request: { query: LotSummaryDetailsPdfDocument, variables },
    result: { data: data instanceof Error ? undefined : newLotSummaryDetailsPdfData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ApprovalSummaryHeaderDataOptions {
  waitinOnMe?: ApprovalPage | ApprovalPageOptions | null;
  myApprovals?: ApprovalPage | ApprovalPageOptions | null;
}

export function newApprovalSummaryHeaderData(data: ApprovalSummaryHeaderDataOptions): ApprovalSummaryHeaderQuery {
  return {
    __typename: "Query" as const,
    waitinOnMe: maybeNewOrNull("ApprovalPage", data["waitinOnMe"] || undefined, {}),
    myApprovals: maybeNewOrNull("ApprovalPage", data["myApprovals"] || undefined, {}),
  } as any;
}

export function newApprovalSummaryHeaderResponse(
  variables: ApprovalSummaryHeaderQueryVariables,
  data: ApprovalSummaryHeaderDataOptions | Error,
): MockedResponse<ApprovalSummaryHeaderQueryVariables, ApprovalSummaryHeaderQuery> {
  return {
    request: { query: ApprovalSummaryHeaderDocument, variables },
    result: { data: data instanceof Error ? undefined : newApprovalSummaryHeaderData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DashboardCommentsDataOptions {
  userRelevantCommentStreamsPaged?: UserRelevantCommentStreamsResult | UserRelevantCommentStreamsResultOptions;
}

export function newDashboardCommentsData(data: DashboardCommentsDataOptions): DashboardCommentsQuery {
  return {
    __typename: "Query" as const,
    userRelevantCommentStreamsPaged: maybeNew(
      "UserRelevantCommentStreamsResult",
      data["userRelevantCommentStreamsPaged"] || undefined,
      {},
    ),
  } as any;
}

export function newDashboardCommentsResponse(
  variables: DashboardCommentsQueryVariables,
  data: DashboardCommentsDataOptions | Error,
): MockedResponse<DashboardCommentsQueryVariables, DashboardCommentsQuery> {
  return {
    request: { query: DashboardCommentsDocument, variables },
    result: { data: data instanceof Error ? undefined : newDashboardCommentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BillsSummaryHeaderDataOptions {
  unreleasedClickToPayBills?: (Bill | BillOptions)[];
  pendingReviewBills?: (Bill | BillOptions)[];
}

export function newBillsSummaryHeaderData(data: BillsSummaryHeaderDataOptions): BillsSummaryHeaderQuery {
  return {
    __typename: "Query" as const,
    unreleasedClickToPayBills: data["unreleasedClickToPayBills"]?.map((d) => newBill(d)) || [],
    pendingReviewBills: data["pendingReviewBills"]?.map((d) => newBill(d)) || [],
  } as any;
}

export function newBillsSummaryHeaderResponse(
  variables: BillsSummaryHeaderQueryVariables,
  data: BillsSummaryHeaderDataOptions | Error,
): MockedResponse<BillsSummaryHeaderQueryVariables, BillsSummaryHeaderQuery> {
  return {
    request: { query: BillsSummaryHeaderDocument, variables },
    result: { data: data instanceof Error ? undefined : newBillsSummaryHeaderData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectsWidgetFinancialsTabDataOptions {
  projects?: (Project | ProjectOptions)[];
}

export function newProjectsWidgetFinancialsTabData(
  data: ProjectsWidgetFinancialsTabDataOptions,
): ProjectsWidgetFinancialsTabQuery {
  return {
    __typename: "Query" as const,
    projects: data["projects"]?.map((d) => maybeNew("Project", d, {})) || [],
  } as any;
}

export function newProjectsWidgetFinancialsTabResponse(
  variables: ProjectsWidgetFinancialsTabQueryVariables,
  data: ProjectsWidgetFinancialsTabDataOptions | Error,
): MockedResponse<ProjectsWidgetFinancialsTabQueryVariables, ProjectsWidgetFinancialsTabQuery> {
  return {
    request: { query: ProjectsWidgetFinancialsTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectsWidgetFinancialsTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectsWidgetFinancialsTableDataOptions {
  projectStage?: ProjectStage | ProjectStageOptions;
}

export function newProjectsWidgetFinancialsTableData(
  data: ProjectsWidgetFinancialsTableDataOptions,
): ProjectsWidgetFinancialsTableQuery {
  return {
    __typename: "Query" as const,
    projectStage: maybeNew("ProjectStage", data["projectStage"] || undefined, {}),
  } as any;
}

export function newProjectsWidgetFinancialsTableResponse(
  variables: ProjectsWidgetFinancialsTableQueryVariables,
  data: ProjectsWidgetFinancialsTableDataOptions | Error,
): MockedResponse<ProjectsWidgetFinancialsTableQueryVariables, ProjectsWidgetFinancialsTableQuery> {
  return {
    request: { query: ProjectsWidgetFinancialsTableDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectsWidgetFinancialsTableData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SchedulingModalDataOptions {
  tasks?: (Task | TaskOptions)[];
}

export function newSchedulingModalData(data: SchedulingModalDataOptions): SchedulingModalQuery {
  return { __typename: "Query" as const, tasks: data["tasks"]?.map((d) => newTask(d)) || [] } as any;
}

export function newSchedulingModalResponse(
  variables: SchedulingModalQueryVariables,
  data: SchedulingModalDataOptions | Error,
): MockedResponse<SchedulingModalQueryVariables, SchedulingModalQuery> {
  return {
    request: { query: SchedulingModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newSchedulingModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectsWidgetScheduleTabDataOptions {
  projects?: (Project | ProjectOptions)[];
  scheduleTasks?: (ScheduleTask | ScheduleTaskOptions)[];
}

export function newProjectsWidgetScheduleTabData(
  data: ProjectsWidgetScheduleTabDataOptions,
): ProjectsWidgetScheduleTabQuery {
  return {
    __typename: "Query" as const,
    projects: data["projects"]?.map((d) => maybeNew("Project", d, {})) || [],
    scheduleTasks: data["scheduleTasks"]?.map((d) => newScheduleTask(d)) || [],
  } as any;
}

export function newProjectsWidgetScheduleTabResponse(
  variables: ProjectsWidgetScheduleTabQueryVariables,
  data: ProjectsWidgetScheduleTabDataOptions | Error,
): MockedResponse<ProjectsWidgetScheduleTabQueryVariables, ProjectsWidgetScheduleTabQuery> {
  return {
    request: { query: ProjectsWidgetScheduleTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectsWidgetScheduleTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface LotSequenceSheetPdfDataOptions {
  projectReadyPlanConfigs?: (ProjectReadyPlanConfig | ProjectReadyPlanConfigOptions)[];
  development?: Development | DevelopmentOptions;
}

export function newLotSequenceSheetPdfData(data: LotSequenceSheetPdfDataOptions): LotSequenceSheetPdfQuery {
  return {
    __typename: "Query" as const,
    projectReadyPlanConfigs: data["projectReadyPlanConfigs"]?.map((d) => newProjectReadyPlanConfig(d)) || [],
    development: maybeNew("Development", data["development"] || undefined, {}),
  } as any;
}

export function newLotSequenceSheetPdfResponse(
  variables: LotSequenceSheetPdfQueryVariables,
  data: LotSequenceSheetPdfDataOptions | Error,
): MockedResponse<LotSequenceSheetPdfQueryVariables, LotSequenceSheetPdfQuery> {
  return {
    request: { query: LotSequenceSheetPdfDocument, variables },
    result: { data: data instanceof Error ? undefined : newLotSequenceSheetPdfData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TasksSummaryHeaderDataOptions {
  tasks?: (Task | TaskOptions)[];
}

export function newTasksSummaryHeaderData(data: TasksSummaryHeaderDataOptions): TasksSummaryHeaderQuery {
  return { __typename: "Query" as const, tasks: data["tasks"]?.map((d) => newTask(d)) || [] } as any;
}

export function newTasksSummaryHeaderResponse(
  variables: TasksSummaryHeaderQueryVariables,
  data: TasksSummaryHeaderDataOptions | Error,
): MockedResponse<TasksSummaryHeaderQueryVariables, TasksSummaryHeaderQuery> {
  return {
    request: { query: TasksSummaryHeaderDocument, variables },
    result: { data: data instanceof Error ? undefined : newTasksSummaryHeaderData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveTradePartnerAvailabilityRequestDataOptions {
  saveTradePartnerAvailabilityRequest?:
    | SaveTradePartnerAvailabilityRequestResult
    | SaveTradePartnerAvailabilityRequestResultOptions;
}

export function newSaveTradePartnerAvailabilityRequestData(
  data: SaveTradePartnerAvailabilityRequestDataOptions,
): SaveTradePartnerAvailabilityRequestMutation {
  return {
    __typename: "Mutation" as const,
    saveTradePartnerAvailabilityRequest: maybeNew(
      "SaveTradePartnerAvailabilityRequestResult",
      data["saveTradePartnerAvailabilityRequest"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveTradePartnerAvailabilityRequestResponse(
  variables: SaveTradePartnerAvailabilityRequestMutationVariables,
  data: SaveTradePartnerAvailabilityRequestDataOptions | Error,
): MockedResponse<SaveTradePartnerAvailabilityRequestMutationVariables, SaveTradePartnerAvailabilityRequestMutation> {
  return {
    request: { query: SaveTradePartnerAvailabilityRequestDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveTradePartnerAvailabilityRequestData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SubmitApprovalDataOptions {
  saveApproval?: SaveApprovalResult | SaveApprovalResultOptions;
}

export function newSubmitApprovalData(data: SubmitApprovalDataOptions): SubmitApprovalMutation {
  return {
    __typename: "Mutation" as const,
    saveApproval: maybeNew("SaveApprovalResult", data["saveApproval"] || undefined, {}),
  } as any;
}

export function newSubmitApprovalResponse(
  variables: SubmitApprovalMutationVariables,
  data: SubmitApprovalDataOptions | Error,
): MockedResponse<SubmitApprovalMutationVariables, SubmitApprovalMutation> {
  return {
    request: { query: SubmitApprovalDocument, variables },
    result: { data: data instanceof Error ? undefined : newSubmitApprovalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectBidContractOverviewPageDataOptions {
  bidContractRevision?: BidContractRevision | BidContractRevisionOptions;
}

export function newProjectBidContractOverviewPageData(
  data: ProjectBidContractOverviewPageDataOptions,
): ProjectBidContractOverviewPageQuery {
  return {
    __typename: "Query" as const,
    bidContractRevision: maybeNew("BidContractRevision", data["bidContractRevision"] || undefined, {}),
  } as any;
}

export function newProjectBidContractOverviewPageResponse(
  variables: ProjectBidContractOverviewPageQueryVariables,
  data: ProjectBidContractOverviewPageDataOptions | Error,
): MockedResponse<ProjectBidContractOverviewPageQueryVariables, ProjectBidContractOverviewPageQuery> {
  return {
    request: { query: ProjectBidContractOverviewPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectBidContractOverviewPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CeliSelectionOverviewTabDataOptions {
  changeEventLineItems?: (ChangeEventLineItem | ChangeEventLineItemOptions)[];
  locations?: (Location | LocationOptions)[];
}

export function newCeliSelectionOverviewTabData(
  data: CeliSelectionOverviewTabDataOptions,
): CeliSelectionOverviewTabQuery {
  return {
    __typename: "Query" as const,
    changeEventLineItems: data["changeEventLineItems"]?.map((d) => newChangeEventLineItem(d)) || [],
    locations: data["locations"]?.map((d) => newLocation(d)) || [],
  } as any;
}

export function newCeliSelectionOverviewTabResponse(
  variables: CeliSelectionOverviewTabQueryVariables,
  data: CeliSelectionOverviewTabDataOptions | Error,
): MockedResponse<CeliSelectionOverviewTabQueryVariables, CeliSelectionOverviewTabQuery> {
  return {
    request: { query: CeliSelectionOverviewTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newCeliSelectionOverviewTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CeliSelectionOverviewTabSaveCeliDataOptions {
  saveChangeEventLineItems?: SaveChangeEventLineItemsResult | SaveChangeEventLineItemsResultOptions;
}

export function newCeliSelectionOverviewTabSaveCeliData(
  data: CeliSelectionOverviewTabSaveCeliDataOptions,
): CeliSelectionOverviewTabSaveCeliMutation {
  return {
    __typename: "Mutation" as const,
    saveChangeEventLineItems: maybeNew(
      "SaveChangeEventLineItemsResult",
      data["saveChangeEventLineItems"] || undefined,
      {},
    ),
  } as any;
}

export function newCeliSelectionOverviewTabSaveCeliResponse(
  variables: CeliSelectionOverviewTabSaveCeliMutationVariables,
  data: CeliSelectionOverviewTabSaveCeliDataOptions | Error,
): MockedResponse<CeliSelectionOverviewTabSaveCeliMutationVariables, CeliSelectionOverviewTabSaveCeliMutation> {
  return {
    request: { query: CeliSelectionOverviewTabSaveCeliDocument, variables },
    result: { data: data instanceof Error ? undefined : newCeliSelectionOverviewTabSaveCeliData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BudgetSummaryDataOptions {
  project?: Project | ProjectOptions;
}

export function newBudgetSummaryData(data: BudgetSummaryDataOptions): BudgetSummaryQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newBudgetSummaryResponse(
  variables: BudgetSummaryQueryVariables,
  data: BudgetSummaryDataOptions | Error,
): MockedResponse<BudgetSummaryQueryVariables, BudgetSummaryQuery> {
  return {
    request: { query: BudgetSummaryDocument, variables },
    result: { data: data instanceof Error ? undefined : newBudgetSummaryData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface HierarchyBudgetPageDataOptions {
  project?: Project | ProjectOptions;
  costCodes?: (CostCode | CostCodeOptions)[];
}

export function newHierarchyBudgetPageData(data: HierarchyBudgetPageDataOptions): HierarchyBudgetPageQuery {
  return {
    __typename: "Query" as const,
    project: maybeNew("Project", data["project"] || undefined, {}),
    costCodes: data["costCodes"]?.map((d) => newCostCode(d)) || [],
  } as any;
}

export function newHierarchyBudgetPageResponse(
  variables: HierarchyBudgetPageQueryVariables,
  data: HierarchyBudgetPageDataOptions | Error,
): MockedResponse<HierarchyBudgetPageQueryVariables, HierarchyBudgetPageQuery> {
  return {
    request: { query: HierarchyBudgetPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newHierarchyBudgetPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface HierarchyBudgetPage_RollupViewDataOptions {
  projects?: (Project | ProjectOptions)[];
}

export function newHierarchyBudgetPage_RollupViewData(
  data: HierarchyBudgetPage_RollupViewDataOptions,
): HierarchyBudgetPage_RollupViewQuery {
  return {
    __typename: "Query" as const,
    projects: data["projects"]?.map((d) => maybeNew("Project", d, {})) || [],
  } as any;
}

export function newHierarchyBudgetPage_RollupViewResponse(
  variables: HierarchyBudgetPage_RollupViewQueryVariables,
  data: HierarchyBudgetPage_RollupViewDataOptions | Error,
): MockedResponse<HierarchyBudgetPage_RollupViewQueryVariables, HierarchyBudgetPage_RollupViewQuery> {
  return {
    request: { query: HierarchyBudgetPage_RollupViewDocument, variables },
    result: { data: data instanceof Error ? undefined : newHierarchyBudgetPage_RollupViewData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface HierarchyBudgetPage_SharedCostsDataOptions {
  project?: Project | ProjectOptions;
}

export function newHierarchyBudgetPage_SharedCostsData(
  data: HierarchyBudgetPage_SharedCostsDataOptions,
): HierarchyBudgetPage_SharedCostsQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newHierarchyBudgetPage_SharedCostsResponse(
  variables: HierarchyBudgetPage_SharedCostsQueryVariables,
  data: HierarchyBudgetPage_SharedCostsDataOptions | Error,
): MockedResponse<HierarchyBudgetPage_SharedCostsQueryVariables, HierarchyBudgetPage_SharedCostsQuery> {
  return {
    request: { query: HierarchyBudgetPage_SharedCostsDocument, variables },
    result: { data: data instanceof Error ? undefined : newHierarchyBudgetPage_SharedCostsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectBidContractsPageDataOptions {
  project?: Project | ProjectOptions;
}

export function newProjectBidContractsPageData(data: ProjectBidContractsPageDataOptions): ProjectBidContractsPageQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newProjectBidContractsPageResponse(
  variables: ProjectBidContractsPageQueryVariables,
  data: ProjectBidContractsPageDataOptions | Error,
): MockedResponse<ProjectBidContractsPageQueryVariables, ProjectBidContractsPageQuery> {
  return {
    request: { query: ProjectBidContractsPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectBidContractsPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CeliSpecOverviewTabDataOptions {
  changeEventLineItems?: (ChangeEventLineItem | ChangeEventLineItemOptions)[];
  locations?: (Location | LocationOptions)[];
  unitsOfMeasure?: (UnitOfMeasure | UnitOfMeasureOptions)[];
}

export function newCeliSpecOverviewTabData(data: CeliSpecOverviewTabDataOptions): CeliSpecOverviewTabQuery {
  return {
    __typename: "Query" as const,
    changeEventLineItems: data["changeEventLineItems"]?.map((d) => newChangeEventLineItem(d)) || [],
    locations: data["locations"]?.map((d) => newLocation(d)) || [],
    unitsOfMeasure: data["unitsOfMeasure"]?.map((d) => newUnitOfMeasure(d)) || [],
  } as any;
}

export function newCeliSpecOverviewTabResponse(
  variables: CeliSpecOverviewTabQueryVariables,
  data: CeliSpecOverviewTabDataOptions | Error,
): MockedResponse<CeliSpecOverviewTabQueryVariables, CeliSpecOverviewTabQuery> {
  return {
    request: { query: CeliSpecOverviewTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newCeliSpecOverviewTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CeliSpecOverviewTabSaveCeliDataOptions {
  saveChangeEventLineItems?: SaveChangeEventLineItemsResult | SaveChangeEventLineItemsResultOptions;
}

export function newCeliSpecOverviewTabSaveCeliData(
  data: CeliSpecOverviewTabSaveCeliDataOptions,
): CeliSpecOverviewTabSaveCeliMutation {
  return {
    __typename: "Mutation" as const,
    saveChangeEventLineItems: maybeNew(
      "SaveChangeEventLineItemsResult",
      data["saveChangeEventLineItems"] || undefined,
      {},
    ),
  } as any;
}

export function newCeliSpecOverviewTabSaveCeliResponse(
  variables: CeliSpecOverviewTabSaveCeliMutationVariables,
  data: CeliSpecOverviewTabSaveCeliDataOptions | Error,
): MockedResponse<CeliSpecOverviewTabSaveCeliMutationVariables, CeliSpecOverviewTabSaveCeliMutation> {
  return {
    request: { query: CeliSpecOverviewTabSaveCeliDocument, variables },
    result: { data: data instanceof Error ? undefined : newCeliSpecOverviewTabSaveCeliData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CommitmentsForChangeEventDataOptions {
  changeEvent?: ChangeEvent | ChangeEventOptions;
}

export function newCommitmentsForChangeEventData(
  data: CommitmentsForChangeEventDataOptions,
): CommitmentsForChangeEventQuery {
  return {
    __typename: "Query" as const,
    changeEvent: maybeNew("ChangeEvent", data["changeEvent"] || undefined, {}),
  } as any;
}

export function newCommitmentsForChangeEventResponse(
  variables: CommitmentsForChangeEventQueryVariables,
  data: CommitmentsForChangeEventDataOptions | Error,
): MockedResponse<CommitmentsForChangeEventQueryVariables, CommitmentsForChangeEventQuery> {
  return {
    request: { query: CommitmentsForChangeEventDocument, variables },
    result: { data: data instanceof Error ? undefined : newCommitmentsForChangeEventData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChangeEventEstimatesTabDataOptions {
  changeEvent?: ChangeEvent | ChangeEventOptions;
}

export function newChangeEventEstimatesTabData(data: ChangeEventEstimatesTabDataOptions): ChangeEventEstimatesTabQuery {
  return {
    __typename: "Query" as const,
    changeEvent: maybeNew("ChangeEvent", data["changeEvent"] || undefined, {}),
  } as any;
}

export function newChangeEventEstimatesTabResponse(
  variables: ChangeEventEstimatesTabQueryVariables,
  data: ChangeEventEstimatesTabDataOptions | Error,
): MockedResponse<ChangeEventEstimatesTabQueryVariables, ChangeEventEstimatesTabQuery> {
  return {
    request: { query: ChangeEventEstimatesTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newChangeEventEstimatesTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChangeEventHistoryDataOptions {
  changeEvents?: (ChangeEvent | ChangeEventOptions)[];
}

export function newChangeEventHistoryData(data: ChangeEventHistoryDataOptions): ChangeEventHistoryQuery {
  return {
    __typename: "Query" as const,
    changeEvents: data["changeEvents"]?.map((d) => newChangeEvent(d)) || [],
  } as any;
}

export function newChangeEventHistoryResponse(
  variables: ChangeEventHistoryQueryVariables,
  data: ChangeEventHistoryDataOptions | Error,
): MockedResponse<ChangeEventHistoryQueryVariables, ChangeEventHistoryQuery> {
  return {
    request: { query: ChangeEventHistoryDocument, variables },
    result: { data: data instanceof Error ? undefined : newChangeEventHistoryData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChangeEventOverviewTabDataOptions {
  changeEvent?: ChangeEvent | ChangeEventOptions;
  changeEventReasons?: (ChangeEventReason | ChangeEventReasonOptions)[];
  changeEventBudgetPhases?: (ChangeEventBudgetPhaseDetail | ChangeEventBudgetPhaseDetailOptions)[];
}

export function newChangeEventOverviewTabData(data: ChangeEventOverviewTabDataOptions): ChangeEventOverviewTabQuery {
  return {
    __typename: "Query" as const,
    changeEvent: maybeNew("ChangeEvent", data["changeEvent"] || undefined, {}),
    changeEventReasons: data["changeEventReasons"]?.map((d) => newChangeEventReason(d)) || [],
    changeEventBudgetPhases: data["changeEventBudgetPhases"]?.map((d) => newChangeEventBudgetPhaseDetail(d)) || [],
  } as any;
}

export function newChangeEventOverviewTabResponse(
  variables: ChangeEventOverviewTabQueryVariables,
  data: ChangeEventOverviewTabDataOptions | Error,
): MockedResponse<ChangeEventOverviewTabQueryVariables, ChangeEventOverviewTabQuery> {
  return {
    request: { query: ChangeEventOverviewTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newChangeEventOverviewTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveChangeEventOverviewTabDataOptions {
  saveChangeEvent?: SaveChangeEventResult | SaveChangeEventResultOptions;
}

export function newSaveChangeEventOverviewTabData(
  data: SaveChangeEventOverviewTabDataOptions,
): SaveChangeEventOverviewTabMutation {
  return {
    __typename: "Mutation" as const,
    saveChangeEvent: maybeNew("SaveChangeEventResult", data["saveChangeEvent"] || undefined, {}),
  } as any;
}

export function newSaveChangeEventOverviewTabResponse(
  variables: SaveChangeEventOverviewTabMutationVariables,
  data: SaveChangeEventOverviewTabDataOptions | Error,
): MockedResponse<SaveChangeEventOverviewTabMutationVariables, SaveChangeEventOverviewTabMutation> {
  return {
    request: { query: SaveChangeEventOverviewTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveChangeEventOverviewTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChangeEventLineItemsTabDataOptions {
  changeEvent?: ChangeEvent | ChangeEventOptions;
  unitsOfMeasure?: (UnitOfMeasure | UnitOfMeasureOptions)[];
  locations?: (Location | LocationOptions)[];
  items?: (Item | ItemOptions)[];
}

export function newChangeEventLineItemsTabData(data: ChangeEventLineItemsTabDataOptions): ChangeEventLineItemsTabQuery {
  return {
    __typename: "Query" as const,
    changeEvent: maybeNew("ChangeEvent", data["changeEvent"] || undefined, {}),
    unitsOfMeasure: data["unitsOfMeasure"]?.map((d) => newUnitOfMeasure(d)) || [],
    locations: data["locations"]?.map((d) => newLocation(d)) || [],
    items: data["items"]?.map((d) => newItem(d)) || [],
  } as any;
}

export function newChangeEventLineItemsTabResponse(
  variables: ChangeEventLineItemsTabQueryVariables,
  data: ChangeEventLineItemsTabDataOptions | Error,
): MockedResponse<ChangeEventLineItemsTabQueryVariables, ChangeEventLineItemsTabQuery> {
  return {
    request: { query: ChangeEventLineItemsTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newChangeEventLineItemsTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveChangeEventLineItemsTabDataOptions {
  saveChangeEventLineItems?: SaveChangeEventLineItemsResult | SaveChangeEventLineItemsResultOptions;
}

export function newSaveChangeEventLineItemsTabData(
  data: SaveChangeEventLineItemsTabDataOptions,
): SaveChangeEventLineItemsTabMutation {
  return {
    __typename: "Mutation" as const,
    saveChangeEventLineItems: maybeNew(
      "SaveChangeEventLineItemsResult",
      data["saveChangeEventLineItems"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveChangeEventLineItemsTabResponse(
  variables: SaveChangeEventLineItemsTabMutationVariables,
  data: SaveChangeEventLineItemsTabDataOptions | Error,
): MockedResponse<SaveChangeEventLineItemsTabMutationVariables, SaveChangeEventLineItemsTabMutation> {
  return {
    request: { query: SaveChangeEventLineItemsTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveChangeEventLineItemsTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateChangeEventLineItemsTabDataOptions {
  saveChangeEventLineItems?: SaveChangeEventLineItemsResult | SaveChangeEventLineItemsResultOptions;
}

export function newCreateChangeEventLineItemsTabData(
  data: CreateChangeEventLineItemsTabDataOptions,
): CreateChangeEventLineItemsTabMutation {
  return {
    __typename: "Mutation" as const,
    saveChangeEventLineItems: maybeNew(
      "SaveChangeEventLineItemsResult",
      data["saveChangeEventLineItems"] || undefined,
      {},
    ),
  } as any;
}

export function newCreateChangeEventLineItemsTabResponse(
  variables: CreateChangeEventLineItemsTabMutationVariables,
  data: CreateChangeEventLineItemsTabDataOptions | Error,
): MockedResponse<CreateChangeEventLineItemsTabMutationVariables, CreateChangeEventLineItemsTabMutation> {
  return {
    request: { query: CreateChangeEventLineItemsTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateChangeEventLineItemsTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteChangeEventLineItemsTabDataOptions {
  deleteChangeEventLineItems?: EmptyResult | EmptyResultOptions;
}

export function newDeleteChangeEventLineItemsTabData(
  data: DeleteChangeEventLineItemsTabDataOptions,
): DeleteChangeEventLineItemsTabMutation {
  return {
    __typename: "Mutation" as const,
    deleteChangeEventLineItems: maybeNew("EmptyResult", data["deleteChangeEventLineItems"] || undefined, {}),
  } as any;
}

export function newDeleteChangeEventLineItemsTabResponse(
  variables: DeleteChangeEventLineItemsTabMutationVariables,
  data: DeleteChangeEventLineItemsTabDataOptions | Error,
): MockedResponse<DeleteChangeEventLineItemsTabMutationVariables, DeleteChangeEventLineItemsTabMutation> {
  return {
    request: { query: DeleteChangeEventLineItemsTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteChangeEventLineItemsTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddChangeEventLineItemsTabDataOptions {
  saveChangeEventLineItems?: SaveChangeEventLineItemsResult | SaveChangeEventLineItemsResultOptions;
}

export function newAddChangeEventLineItemsTabData(
  data: AddChangeEventLineItemsTabDataOptions,
): AddChangeEventLineItemsTabMutation {
  return {
    __typename: "Mutation" as const,
    saveChangeEventLineItems: maybeNew(
      "SaveChangeEventLineItemsResult",
      data["saveChangeEventLineItems"] || undefined,
      {},
    ),
  } as any;
}

export function newAddChangeEventLineItemsTabResponse(
  variables: AddChangeEventLineItemsTabMutationVariables,
  data: AddChangeEventLineItemsTabDataOptions | Error,
): MockedResponse<AddChangeEventLineItemsTabMutationVariables, AddChangeEventLineItemsTabMutation> {
  return {
    request: { query: AddChangeEventLineItemsTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddChangeEventLineItemsTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ApplyItemTemplateToChangeEventLineItemsTabDataOptions {
  applyItemTemplateToChangeEvent?: ApplyItemTemplateToChangeEventResult | ApplyItemTemplateToChangeEventResultOptions;
}

export function newApplyItemTemplateToChangeEventLineItemsTabData(
  data: ApplyItemTemplateToChangeEventLineItemsTabDataOptions,
): ApplyItemTemplateToChangeEventLineItemsTabMutation {
  return {
    __typename: "Mutation" as const,
    applyItemTemplateToChangeEvent: maybeNew(
      "ApplyItemTemplateToChangeEventResult",
      data["applyItemTemplateToChangeEvent"] || undefined,
      {},
    ),
  } as any;
}

export function newApplyItemTemplateToChangeEventLineItemsTabResponse(
  variables: ApplyItemTemplateToChangeEventLineItemsTabMutationVariables,
  data: ApplyItemTemplateToChangeEventLineItemsTabDataOptions | Error,
): MockedResponse<
  ApplyItemTemplateToChangeEventLineItemsTabMutationVariables,
  ApplyItemTemplateToChangeEventLineItemsTabMutation
> {
  return {
    request: { query: ApplyItemTemplateToChangeEventLineItemsTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newApplyItemTemplateToChangeEventLineItemsTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveHomeownerSelectionChangeEventLineItemsTabDataOptions {
  saveHomeownerSelection?: SaveHomeownerSelectionResult | SaveHomeownerSelectionResultOptions;
}

export function newSaveHomeownerSelectionChangeEventLineItemsTabData(
  data: SaveHomeownerSelectionChangeEventLineItemsTabDataOptions,
): SaveHomeownerSelectionChangeEventLineItemsTabMutation {
  return {
    __typename: "Mutation" as const,
    saveHomeownerSelection: maybeNew("SaveHomeownerSelectionResult", data["saveHomeownerSelection"] || undefined, {}),
  } as any;
}

export function newSaveHomeownerSelectionChangeEventLineItemsTabResponse(
  variables: SaveHomeownerSelectionChangeEventLineItemsTabMutationVariables,
  data: SaveHomeownerSelectionChangeEventLineItemsTabDataOptions | Error,
): MockedResponse<
  SaveHomeownerSelectionChangeEventLineItemsTabMutationVariables,
  SaveHomeownerSelectionChangeEventLineItemsTabMutation
> {
  return {
    request: { query: SaveHomeownerSelectionChangeEventLineItemsTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveHomeownerSelectionChangeEventLineItemsTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChangeEventAssociationsDataOptions {
  changeEvents?: (ChangeEvent | ChangeEventOptions)[];
}

export function newChangeEventAssociationsData(data: ChangeEventAssociationsDataOptions): ChangeEventAssociationsQuery {
  return {
    __typename: "Query" as const,
    changeEvents: data["changeEvents"]?.map((d) => newChangeEvent(d)) || [],
  } as any;
}

export function newChangeEventAssociationsResponse(
  variables: ChangeEventAssociationsQueryVariables,
  data: ChangeEventAssociationsDataOptions | Error,
): MockedResponse<ChangeEventAssociationsQueryVariables, ChangeEventAssociationsQuery> {
  return {
    request: { query: ChangeEventAssociationsDocument, variables },
    result: { data: data instanceof Error ? undefined : newChangeEventAssociationsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChangeEventPageDataOptions {
  changeEvent?: ChangeEvent | ChangeEventOptions;
}

export function newChangeEventPageData(data: ChangeEventPageDataOptions): ChangeEventPageQuery {
  return {
    __typename: "Query" as const,
    changeEvent: maybeNew("ChangeEvent", data["changeEvent"] || undefined, {}),
  } as any;
}

export function newChangeEventPageResponse(
  variables: ChangeEventPageQueryVariables,
  data: ChangeEventPageDataOptions | Error,
): MockedResponse<ChangeEventPageQueryVariables, ChangeEventPageQuery> {
  return {
    request: { query: ChangeEventPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newChangeEventPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteChangeEventDataOptions {
  deleteChangeEvent?: EmptyResult | EmptyResultOptions;
}

export function newDeleteChangeEventData(data: DeleteChangeEventDataOptions): DeleteChangeEventMutation {
  return {
    __typename: "Mutation" as const,
    deleteChangeEvent: maybeNew("EmptyResult", data["deleteChangeEvent"] || undefined, {}),
  } as any;
}

export function newDeleteChangeEventResponse(
  variables: DeleteChangeEventMutationVariables,
  data: DeleteChangeEventDataOptions | Error,
): MockedResponse<DeleteChangeEventMutationVariables, DeleteChangeEventMutation> {
  return {
    request: { query: DeleteChangeEventDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteChangeEventData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChangeEventRposTabDataOptions {
  changeEvent?: ChangeEvent | ChangeEventOptions;
}

export function newChangeEventRposTabData(data: ChangeEventRposTabDataOptions): ChangeEventRposTabQuery {
  return {
    __typename: "Query" as const,
    changeEvent: maybeNew("ChangeEvent", data["changeEvent"] || undefined, {}),
  } as any;
}

export function newChangeEventRposTabResponse(
  variables: ChangeEventRposTabQueryVariables,
  data: ChangeEventRposTabDataOptions | Error,
): MockedResponse<ChangeEventRposTabQueryVariables, ChangeEventRposTabQuery> {
  return {
    request: { query: ChangeEventRposTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newChangeEventRposTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveChangeEventRposDataOptions {
  saveChangeEvent?: SaveChangeEventResult | SaveChangeEventResultOptions;
}

export function newSaveChangeEventRposData(data: SaveChangeEventRposDataOptions): SaveChangeEventRposMutation {
  return {
    __typename: "Mutation" as const,
    saveChangeEvent: maybeNew("SaveChangeEventResult", data["saveChangeEvent"] || undefined, {}),
  } as any;
}

export function newSaveChangeEventRposResponse(
  variables: SaveChangeEventRposMutationVariables,
  data: SaveChangeEventRposDataOptions | Error,
): MockedResponse<SaveChangeEventRposMutationVariables, SaveChangeEventRposMutation> {
  return {
    request: { query: SaveChangeEventRposDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveChangeEventRposData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChangeEventsForProjectStageDataOptions {
  project?: Project | ProjectOptions;
}

export function newChangeEventsForProjectStageData(
  data: ChangeEventsForProjectStageDataOptions,
): ChangeEventsForProjectStageQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newChangeEventsForProjectStageResponse(
  variables: ChangeEventsForProjectStageQueryVariables,
  data: ChangeEventsForProjectStageDataOptions | Error,
): MockedResponse<ChangeEventsForProjectStageQueryVariables, ChangeEventsForProjectStageQuery> {
  return {
    request: { query: ChangeEventsForProjectStageDocument, variables },
    result: { data: data instanceof Error ? undefined : newChangeEventsForProjectStageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CommitmentWithProjectItemsDataOptions {
  commitment?: Commitment | CommitmentOptions;
  tradePartners?: (TradePartner | TradePartnerOptions)[];
}

export function newCommitmentWithProjectItemsData(
  data: CommitmentWithProjectItemsDataOptions,
): CommitmentWithProjectItemsQuery {
  return {
    __typename: "Query" as const,
    commitment: maybeNew("Commitment", data["commitment"] || undefined, {}),
    tradePartners: data["tradePartners"]?.map((d) => newTradePartner(d)) || [],
  } as any;
}

export function newCommitmentWithProjectItemsResponse(
  variables: CommitmentWithProjectItemsQueryVariables,
  data: CommitmentWithProjectItemsDataOptions | Error,
): MockedResponse<CommitmentWithProjectItemsQueryVariables, CommitmentWithProjectItemsQuery> {
  return {
    request: { query: CommitmentWithProjectItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newCommitmentWithProjectItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface NewCommitmentWithProjectItemsDataDataOptions {
  tradePartners?: (TradePartner | TradePartnerOptions)[];
  projectItems?: (ProjectItem | ProjectItemOptions)[];
  project?: Project | ProjectOptions;
}

export function newNewCommitmentWithProjectItemsDataData(
  data: NewCommitmentWithProjectItemsDataDataOptions,
): NewCommitmentWithProjectItemsDataQuery {
  return {
    __typename: "Query" as const,
    tradePartners: data["tradePartners"]?.map((d) => newTradePartner(d)) || [],
    projectItems: data["projectItems"]?.map((d) => newProjectItem(d)) || [],
    project: maybeNew("Project", data["project"] || undefined, {}),
  } as any;
}

export function newNewCommitmentWithProjectItemsDataResponse(
  variables: NewCommitmentWithProjectItemsDataQueryVariables,
  data: NewCommitmentWithProjectItemsDataDataOptions | Error,
): MockedResponse<NewCommitmentWithProjectItemsDataQueryVariables, NewCommitmentWithProjectItemsDataQuery> {
  return {
    request: { query: NewCommitmentWithProjectItemsDataDocument, variables },
    result: { data: data instanceof Error ? undefined : newNewCommitmentWithProjectItemsDataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveCommitmentDataOptions {
  saveCommitment?: SaveCommitmentResult | SaveCommitmentResultOptions;
}

export function newSaveCommitmentData(data: SaveCommitmentDataOptions): SaveCommitmentMutation {
  return {
    __typename: "Mutation" as const,
    saveCommitment: maybeNew("SaveCommitmentResult", data["saveCommitment"] || undefined, {}),
  } as any;
}

export function newSaveCommitmentResponse(
  variables: SaveCommitmentMutationVariables,
  data: SaveCommitmentDataOptions | Error,
): MockedResponse<SaveCommitmentMutationVariables, SaveCommitmentMutation> {
  return {
    request: { query: SaveCommitmentDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveCommitmentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteCommitmentDataOptions {
  deleteCommitment?: EmptyResult | EmptyResultOptions;
}

export function newDeleteCommitmentData(data: DeleteCommitmentDataOptions): DeleteCommitmentMutation {
  return {
    __typename: "Mutation" as const,
    deleteCommitment: maybeNew("EmptyResult", data["deleteCommitment"] || undefined, {}),
  } as any;
}

export function newDeleteCommitmentResponse(
  variables: DeleteCommitmentMutationVariables,
  data: DeleteCommitmentDataOptions | Error,
): MockedResponse<DeleteCommitmentMutationVariables, DeleteCommitmentMutation> {
  return {
    request: { query: DeleteCommitmentDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteCommitmentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ReleaseBidCommitmentsDataOptions {
  releaseBidCommitments?: (CommitmentLike | CommitmentLikeOptions)[];
}

export function newReleaseBidCommitmentsData(data: ReleaseBidCommitmentsDataOptions): ReleaseBidCommitmentsMutation {
  return {
    __typename: "Mutation" as const,
    releaseBidCommitments: data["releaseBidCommitments"]?.map((d) => maybeNew("CommitmentLike", d, {})) || [],
  } as any;
}

export function newReleaseBidCommitmentsResponse(
  variables: ReleaseBidCommitmentsMutationVariables,
  data: ReleaseBidCommitmentsDataOptions | Error,
): MockedResponse<ReleaseBidCommitmentsMutationVariables, ReleaseBidCommitmentsMutation> {
  return {
    request: { query: ReleaseBidCommitmentsDocument, variables },
    result: { data: data instanceof Error ? undefined : newReleaseBidCommitmentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CommitmentHistoryDataOptions {
  commitment?: Commitment | CommitmentOptions;
}

export function newCommitmentHistoryData(data: CommitmentHistoryDataOptions): CommitmentHistoryQuery {
  return {
    __typename: "Query" as const,
    commitment: maybeNew("Commitment", data["commitment"] || undefined, {}),
  } as any;
}

export function newCommitmentHistoryResponse(
  variables: CommitmentHistoryQueryVariables,
  data: CommitmentHistoryDataOptions | Error,
): MockedResponse<CommitmentHistoryQueryVariables, CommitmentHistoryQuery> {
  return {
    request: { query: CommitmentHistoryDocument, variables },
    result: { data: data instanceof Error ? undefined : newCommitmentHistoryData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CommitmentChangeOrderPageDataOptions {
  commitmentChangeOrder?: CommitmentChangeOrder | CommitmentChangeOrderOptions;
  commitment?: Commitment | CommitmentOptions;
  projectItems?: (ProjectItem | ProjectItemOptions)[];
}

export function newCommitmentChangeOrderPageData(
  data: CommitmentChangeOrderPageDataOptions,
): CommitmentChangeOrderPageQuery {
  return {
    __typename: "Query" as const,
    commitmentChangeOrder: maybeNew("CommitmentChangeOrder", data["commitmentChangeOrder"] || undefined, {}),
    commitment: maybeNew("Commitment", data["commitment"] || undefined, {}),
    projectItems: data["projectItems"]?.map((d) => newProjectItem(d)) || [],
  } as any;
}

export function newCommitmentChangeOrderPageResponse(
  variables: CommitmentChangeOrderPageQueryVariables,
  data: CommitmentChangeOrderPageDataOptions | Error,
): MockedResponse<CommitmentChangeOrderPageQueryVariables, CommitmentChangeOrderPageQuery> {
  return {
    request: { query: CommitmentChangeOrderPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newCommitmentChangeOrderPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveCommitmentChangeOrderDataOptions {
  saveCommitmentChangeOrder?: SaveCommitmentChangeOrderResult | SaveCommitmentChangeOrderResultOptions;
}

export function newSaveCommitmentChangeOrderData(
  data: SaveCommitmentChangeOrderDataOptions,
): SaveCommitmentChangeOrderMutation {
  return {
    __typename: "Mutation" as const,
    saveCommitmentChangeOrder: maybeNew(
      "SaveCommitmentChangeOrderResult",
      data["saveCommitmentChangeOrder"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveCommitmentChangeOrderResponse(
  variables: SaveCommitmentChangeOrderMutationVariables,
  data: SaveCommitmentChangeOrderDataOptions | Error,
): MockedResponse<SaveCommitmentChangeOrderMutationVariables, SaveCommitmentChangeOrderMutation> {
  return {
    request: { query: SaveCommitmentChangeOrderDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveCommitmentChangeOrderData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteCommitmentChangeOrderDataOptions {
  deleteCommitmentChangeOrder?: EmptyResult | EmptyResultOptions;
}

export function newDeleteCommitmentChangeOrderData(
  data: DeleteCommitmentChangeOrderDataOptions,
): DeleteCommitmentChangeOrderMutation {
  return {
    __typename: "Mutation" as const,
    deleteCommitmentChangeOrder: maybeNew("EmptyResult", data["deleteCommitmentChangeOrder"] || undefined, {}),
  } as any;
}

export function newDeleteCommitmentChangeOrderResponse(
  variables: DeleteCommitmentChangeOrderMutationVariables,
  data: DeleteCommitmentChangeOrderDataOptions | Error,
): MockedResponse<DeleteCommitmentChangeOrderMutationVariables, DeleteCommitmentChangeOrderMutation> {
  return {
    request: { query: DeleteCommitmentChangeOrderDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteCommitmentChangeOrderData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CommitmentsPageMetadataDataOptions {
  commitments?: (Commitment | CommitmentOptions)[];
  commitmentStatuses?: (CommitmentStatusDetail | CommitmentStatusDetailOptions)[];
}

export function newCommitmentsPageMetadataData(data: CommitmentsPageMetadataDataOptions): CommitmentsPageMetadataQuery {
  return {
    __typename: "Query" as const,
    commitments: data["commitments"]?.map((d) => newCommitment(d)) || [],
    commitmentStatuses: data["commitmentStatuses"]?.map((d) => newCommitmentStatusDetail(d)) || [],
  } as any;
}

export function newCommitmentsPageMetadataResponse(
  variables: CommitmentsPageMetadataQueryVariables,
  data: CommitmentsPageMetadataDataOptions | Error,
): MockedResponse<CommitmentsPageMetadataQueryVariables, CommitmentsPageMetadataQuery> {
  return {
    request: { query: CommitmentsPageMetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newCommitmentsPageMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CommitmentsPageDataOptions {
  commitments?: (Commitment | CommitmentOptions)[];
}

export function newCommitmentsPageData(data: CommitmentsPageDataOptions): CommitmentsPageQuery {
  return { __typename: "Query" as const, commitments: data["commitments"]?.map((d) => newCommitment(d)) || [] } as any;
}

export function newCommitmentsPageResponse(
  variables: CommitmentsPageQueryVariables,
  data: CommitmentsPageDataOptions | Error,
): MockedResponse<CommitmentsPageQueryVariables, CommitmentsPageQuery> {
  return {
    request: { query: CommitmentsPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newCommitmentsPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddLaborItemModal_GlobalPlanTasksDataOptions {
  globalPlanTasks?: GlobalPlanTasksPageResult | GlobalPlanTasksPageResultOptions;
}

export function newAddLaborItemModal_GlobalPlanTasksData(
  data: AddLaborItemModal_GlobalPlanTasksDataOptions,
): AddLaborItemModal_GlobalPlanTasksQuery {
  return {
    __typename: "Query" as const,
    globalPlanTasks: maybeNew("GlobalPlanTasksPageResult", data["globalPlanTasks"] || undefined, {}),
  } as any;
}

export function newAddLaborItemModal_GlobalPlanTasksResponse(
  variables: AddLaborItemModal_GlobalPlanTasksQueryVariables,
  data: AddLaborItemModal_GlobalPlanTasksDataOptions | Error,
): MockedResponse<AddLaborItemModal_GlobalPlanTasksQueryVariables, AddLaborItemModal_GlobalPlanTasksQuery> {
  return {
    request: { query: AddLaborItemModal_GlobalPlanTasksDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddLaborItemModal_GlobalPlanTasksData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddLaborItemModal_EffectiveLocationsDataOptions {
  locations?: (Location | LocationOptions)[];
}

export function newAddLaborItemModal_EffectiveLocationsData(
  data: AddLaborItemModal_EffectiveLocationsDataOptions,
): AddLaborItemModal_EffectiveLocationsQuery {
  return { __typename: "Query" as const, locations: data["locations"]?.map((d) => newLocation(d)) || [] } as any;
}

export function newAddLaborItemModal_EffectiveLocationsResponse(
  variables: AddLaborItemModal_EffectiveLocationsQueryVariables,
  data: AddLaborItemModal_EffectiveLocationsDataOptions | Error,
): MockedResponse<AddLaborItemModal_EffectiveLocationsQueryVariables, AddLaborItemModal_EffectiveLocationsQuery> {
  return {
    request: { query: AddLaborItemModal_EffectiveLocationsDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddLaborItemModal_EffectiveLocationsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddMaterialItemModalMetadataDataOptions {
  locations?: (Location | LocationOptions)[];
}

export function newAddMaterialItemModalMetadataData(
  data: AddMaterialItemModalMetadataDataOptions,
): AddMaterialItemModalMetadataQuery {
  return { __typename: "Query" as const, locations: data["locations"]?.map((d) => newLocation(d)) || [] } as any;
}

export function newAddMaterialItemModalMetadataResponse(
  variables: AddMaterialItemModalMetadataQueryVariables,
  data: AddMaterialItemModalMetadataDataOptions | Error,
): MockedResponse<AddMaterialItemModalMetadataQueryVariables, AddMaterialItemModalMetadataQuery> {
  return {
    request: { query: AddMaterialItemModalMetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddMaterialItemModalMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface LotConfigurationDetailsDataOptions {
  project?: Project | ProjectOptions;
  globalOptionTypes?: (GlobalOptionType | GlobalOptionTypeOptions)[];
}

export function newLotConfigurationDetailsData(data: LotConfigurationDetailsDataOptions): LotConfigurationDetailsQuery {
  return {
    __typename: "Query" as const,
    project: maybeNew("Project", data["project"] || undefined, {}),
    globalOptionTypes: data["globalOptionTypes"]?.map((d) => newGlobalOptionType(d)) || [],
  } as any;
}

export function newLotConfigurationDetailsResponse(
  variables: LotConfigurationDetailsQueryVariables,
  data: LotConfigurationDetailsDataOptions | Error,
): MockedResponse<LotConfigurationDetailsQueryVariables, LotConfigurationDetailsQuery> {
  return {
    request: { query: LotConfigurationDetailsDocument, variables },
    result: { data: data instanceof Error ? undefined : newLotConfigurationDetailsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface RedirectToActiveStageDataOptions {
  project?: Project | ProjectOptions;
}

export function newRedirectToActiveStageData(data: RedirectToActiveStageDataOptions): RedirectToActiveStageQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newRedirectToActiveStageResponse(
  variables: RedirectToActiveStageQueryVariables,
  data: RedirectToActiveStageDataOptions | Error,
): MockedResponse<RedirectToActiveStageQueryVariables, RedirectToActiveStageQuery> {
  return {
    request: { query: RedirectToActiveStageDocument, variables },
    result: { data: data instanceof Error ? undefined : newRedirectToActiveStageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface HierarchyDashboardPage_ProjectsDataOptions {
  projectsPage?: ProjectsPageResult | ProjectsPageResultOptions;
}

export function newHierarchyDashboardPage_ProjectsData(
  data: HierarchyDashboardPage_ProjectsDataOptions,
): HierarchyDashboardPage_ProjectsQuery {
  return {
    __typename: "Query" as const,
    projectsPage: maybeNew("ProjectsPageResult", data["projectsPage"] || undefined, {}),
  } as any;
}

export function newHierarchyDashboardPage_ProjectsResponse(
  variables: HierarchyDashboardPage_ProjectsQueryVariables,
  data: HierarchyDashboardPage_ProjectsDataOptions | Error,
): MockedResponse<HierarchyDashboardPage_ProjectsQueryVariables, HierarchyDashboardPage_ProjectsQuery> {
  return {
    request: { query: HierarchyDashboardPage_ProjectsDocument, variables },
    result: { data: data instanceof Error ? undefined : newHierarchyDashboardPage_ProjectsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface HierarchyDashboardPage_FilterOptionsDataOptions {
  project?: Project | ProjectOptions;
}

export function newHierarchyDashboardPage_FilterOptionsData(
  data: HierarchyDashboardPage_FilterOptionsDataOptions,
): HierarchyDashboardPage_FilterOptionsQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newHierarchyDashboardPage_FilterOptionsResponse(
  variables: HierarchyDashboardPage_FilterOptionsQueryVariables,
  data: HierarchyDashboardPage_FilterOptionsDataOptions | Error,
): MockedResponse<HierarchyDashboardPage_FilterOptionsQueryVariables, HierarchyDashboardPage_FilterOptionsQuery> {
  return {
    request: { query: HierarchyDashboardPage_FilterOptionsDocument, variables },
    result: { data: data instanceof Error ? undefined : newHierarchyDashboardPage_FilterOptionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DocumentsPageMetadataDataOptions {
  documentTypes?: (DocumentTypeDetail | DocumentTypeDetailOptions)[];
  documentCategories?: (DocumentCategoryDetail | DocumentCategoryDetailOptions)[];
  development?: Development | DevelopmentOptions;
  project?: Project | ProjectOptions;
}

export function newDocumentsPageMetadataData(data: DocumentsPageMetadataDataOptions): DocumentsPageMetadataQuery {
  return {
    __typename: "Query" as const,
    documentTypes: data["documentTypes"]?.map((d) => newDocumentTypeDetail(d)) || [],
    documentCategories: data["documentCategories"]?.map((d) => newDocumentCategoryDetail(d)) || [],
    development: maybeNew("Development", data["development"] || undefined, {}),
    project: maybeNew("Project", data["project"] || undefined, {}),
  } as any;
}

export function newDocumentsPageMetadataResponse(
  variables: DocumentsPageMetadataQueryVariables,
  data: DocumentsPageMetadataDataOptions | Error,
): MockedResponse<DocumentsPageMetadataQueryVariables, DocumentsPageMetadataQuery> {
  return {
    request: { query: DocumentsPageMetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newDocumentsPageMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DocumentsPageDataOptions {
  documents?: DocumentsPageResult | DocumentsPageResultOptions;
}

export function newDocumentsPageData(data: DocumentsPageDataOptions): DocumentsPageQuery {
  return {
    __typename: "Query" as const,
    documents: maybeNew("DocumentsPageResult", data["documents"] || undefined, {}),
  } as any;
}

export function newDocumentsPageResponse(
  variables: DocumentsPageQueryVariables,
  data: DocumentsPageDataOptions | Error,
): MockedResponse<DocumentsPageQueryVariables, DocumentsPageQuery> {
  return {
    request: { query: DocumentsPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newDocumentsPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DocumentsAssetDataOptions {
  documents?: (Document | DocumentOptions)[];
}

export function newDocumentsAssetData(data: DocumentsAssetDataOptions): DocumentsAssetQuery {
  return { __typename: "Query" as const, documents: data["documents"]?.map((d) => newDocument(d)) || [] } as any;
}

export function newDocumentsAssetResponse(
  variables: DocumentsAssetQueryVariables,
  data: DocumentsAssetDataOptions | Error,
): MockedResponse<DocumentsAssetQueryVariables, DocumentsAssetQuery> {
  return {
    request: { query: DocumentsAssetDocument, variables },
    result: { data: data instanceof Error ? undefined : newDocumentsAssetData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScheduleTasksForDocumentParentDataOptions {
  scheduleTasks?: (ScheduleTask | ScheduleTaskOptions)[];
}

export function newScheduleTasksForDocumentParentData(
  data: ScheduleTasksForDocumentParentDataOptions,
): ScheduleTasksForDocumentParentQuery {
  return {
    __typename: "Query" as const,
    scheduleTasks: data["scheduleTasks"]?.map((d) => newScheduleTask(d)) || [],
  } as any;
}

export function newScheduleTasksForDocumentParentResponse(
  variables: ScheduleTasksForDocumentParentQueryVariables,
  data: ScheduleTasksForDocumentParentDataOptions | Error,
): MockedResponse<ScheduleTasksForDocumentParentQueryVariables, ScheduleTasksForDocumentParentQuery> {
  return {
    request: { query: ScheduleTasksForDocumentParentDocument, variables },
    result: { data: data instanceof Error ? undefined : newScheduleTasksForDocumentParentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DocumentEditorDataOptions {
  document?: Document | DocumentOptions;
  internalUsers?: (InternalUser | InternalUserOptions)[];
}

export function newDocumentEditorData(data: DocumentEditorDataOptions): DocumentEditorQuery {
  return {
    __typename: "Query" as const,
    document: maybeNew("Document", data["document"] || undefined, {}),
    internalUsers: data["internalUsers"]?.map((d) => newInternalUser(d)) || [],
  } as any;
}

export function newDocumentEditorResponse(
  variables: DocumentEditorQueryVariables,
  data: DocumentEditorDataOptions | Error,
): MockedResponse<DocumentEditorQueryVariables, DocumentEditorQuery> {
  return {
    request: { query: DocumentEditorDocument, variables },
    result: { data: data instanceof Error ? undefined : newDocumentEditorData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DocumentsForParentDataOptions {
  documents?: (Document | DocumentOptions)[];
}

export function newDocumentsForParentData(data: DocumentsForParentDataOptions): DocumentsForParentQuery {
  return { __typename: "Query" as const, documents: data["documents"]?.map((d) => newDocument(d)) || [] } as any;
}

export function newDocumentsForParentResponse(
  variables: DocumentsForParentQueryVariables,
  data: DocumentsForParentDataOptions | Error,
): MockedResponse<DocumentsForParentQueryVariables, DocumentsForParentQuery> {
  return {
    request: { query: DocumentsForParentDocument, variables },
    result: { data: data instanceof Error ? undefined : newDocumentsForParentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DocumentCategoriesDataOptions {
  documentCategories?: (DocumentCategoryDetail | DocumentCategoryDetailOptions)[];
}

export function newDocumentCategoriesData(data: DocumentCategoriesDataOptions): DocumentCategoriesQuery {
  return {
    __typename: "Query" as const,
    documentCategories: data["documentCategories"]?.map((d) => newDocumentCategoryDetail(d)) || [],
  } as any;
}

export function newDocumentCategoriesResponse(
  data: DocumentCategoriesDataOptions | Error,
): MockedResponse<DocumentCategoriesQueryVariables, DocumentCategoriesQuery> {
  return {
    request: { query: DocumentCategoriesDocument },
    result: { data: data instanceof Error ? undefined : newDocumentCategoriesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveDocumentsDataOptions {
  saveDocuments?: SaveDocumentsResult | SaveDocumentsResultOptions;
}

export function newSaveDocumentsData(data: SaveDocumentsDataOptions): SaveDocumentsMutation {
  return {
    __typename: "Mutation" as const,
    saveDocuments: maybeNew("SaveDocumentsResult", data["saveDocuments"] || undefined, {}),
  } as any;
}

export function newSaveDocumentsResponse(
  variables: SaveDocumentsMutationVariables,
  data: SaveDocumentsDataOptions | Error,
): MockedResponse<SaveDocumentsMutationVariables, SaveDocumentsMutation> {
  return {
    request: { query: SaveDocumentsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveDocumentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ToggleDocumentAsFavoritedDataOptions {
  toggleDocumentAsFavorited?: ToggleDocumentAsFavoritedResult | ToggleDocumentAsFavoritedResultOptions;
}

export function newToggleDocumentAsFavoritedData(
  data: ToggleDocumentAsFavoritedDataOptions,
): ToggleDocumentAsFavoritedMutation {
  return {
    __typename: "Mutation" as const,
    toggleDocumentAsFavorited: maybeNew(
      "ToggleDocumentAsFavoritedResult",
      data["toggleDocumentAsFavorited"] || undefined,
      {},
    ),
  } as any;
}

export function newToggleDocumentAsFavoritedResponse(
  variables: ToggleDocumentAsFavoritedMutationVariables,
  data: ToggleDocumentAsFavoritedDataOptions | Error,
): MockedResponse<ToggleDocumentAsFavoritedMutationVariables, ToggleDocumentAsFavoritedMutation> {
  return {
    request: { query: ToggleDocumentAsFavoritedDocument, variables },
    result: { data: data instanceof Error ? undefined : newToggleDocumentAsFavoritedData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteDocumentsDataOptions {
  deleteDocuments?: DeleteDocumentsResult | DeleteDocumentsResultOptions;
}

export function newDeleteDocumentsData(data: DeleteDocumentsDataOptions): DeleteDocumentsMutation {
  return {
    __typename: "Mutation" as const,
    deleteDocuments: maybeNew("DeleteDocumentsResult", data["deleteDocuments"] || undefined, {}),
  } as any;
}

export function newDeleteDocumentsResponse(
  variables: DeleteDocumentsMutationVariables,
  data: DeleteDocumentsDataOptions | Error,
): MockedResponse<DeleteDocumentsMutationVariables, DeleteDocumentsMutation> {
  return {
    request: { query: DeleteDocumentsDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteDocumentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateEstimateStagesDataOptions {
  project?: Project | ProjectOptions;
}

export function newCreateEstimateStagesData(data: CreateEstimateStagesDataOptions): CreateEstimateStagesQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newCreateEstimateStagesResponse(
  variables: CreateEstimateStagesQueryVariables,
  data: CreateEstimateStagesDataOptions | Error,
): MockedResponse<CreateEstimateStagesQueryVariables, CreateEstimateStagesQuery> {
  return {
    request: { query: CreateEstimateStagesDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateEstimateStagesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateEstimateDataOptions {
  saveEstimate?: SaveEstimateResult | SaveEstimateResultOptions;
}

export function newCreateEstimateData(data: CreateEstimateDataOptions): CreateEstimateMutation {
  return {
    __typename: "Mutation" as const,
    saveEstimate: maybeNew("SaveEstimateResult", data["saveEstimate"] || undefined, {}),
  } as any;
}

export function newCreateEstimateResponse(
  variables: CreateEstimateMutationVariables,
  data: CreateEstimateDataOptions | Error,
): MockedResponse<CreateEstimateMutationVariables, CreateEstimateMutation> {
  return {
    request: { query: CreateEstimateDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateEstimateData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface EstimateHistoryDataOptions {
  projectEstimate?: Estimate | EstimateOptions;
}

export function newEstimateHistoryData(data: EstimateHistoryDataOptions): EstimateHistoryQuery {
  return {
    __typename: "Query" as const,
    projectEstimate: maybeNew("Estimate", data["projectEstimate"] || undefined, {}),
  } as any;
}

export function newEstimateHistoryResponse(
  variables: EstimateHistoryQueryVariables,
  data: EstimateHistoryDataOptions | Error,
): MockedResponse<EstimateHistoryQueryVariables, EstimateHistoryQuery> {
  return {
    request: { query: EstimateHistoryDocument, variables },
    result: { data: data instanceof Error ? undefined : newEstimateHistoryData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectEstimatesPageDataOptions {
  project?: Project | ProjectOptions;
}

export function newProjectEstimatesPageData(data: ProjectEstimatesPageDataOptions): ProjectEstimatesPageQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newProjectEstimatesPageResponse(
  variables: ProjectEstimatesPageQueryVariables,
  data: ProjectEstimatesPageDataOptions | Error,
): MockedResponse<ProjectEstimatesPageQueryVariables, ProjectEstimatesPageQuery> {
  return {
    request: { query: ProjectEstimatesPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectEstimatesPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface EstimatePageDataOptions {
  currentInternalUser?: InternalUser | InternalUserOptions | null;
  projectEstimate?: Estimate | EstimateOptions;
}

export function newEstimatePageData(data: EstimatePageDataOptions): EstimatePageQuery {
  return {
    __typename: "Query" as const,
    currentInternalUser: maybeNewOrNull("InternalUser", data["currentInternalUser"] || undefined, {}),
    projectEstimate: maybeNew("Estimate", data["projectEstimate"] || undefined, {}),
  } as any;
}

export function newEstimatePageResponse(
  variables: EstimatePageQueryVariables,
  data: EstimatePageDataOptions | Error,
): MockedResponse<EstimatePageQueryVariables, EstimatePageQuery> {
  return {
    request: { query: EstimatePageDocument, variables },
    result: { data: data instanceof Error ? undefined : newEstimatePageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveEstimateDataOptions {
  saveEstimate?: SaveEstimateResult | SaveEstimateResultOptions;
}

export function newSaveEstimateData(data: SaveEstimateDataOptions): SaveEstimateMutation {
  return {
    __typename: "Mutation" as const,
    saveEstimate: maybeNew("SaveEstimateResult", data["saveEstimate"] || undefined, {}),
  } as any;
}

export function newSaveEstimateResponse(
  variables: SaveEstimateMutationVariables,
  data: SaveEstimateDataOptions | Error,
): MockedResponse<SaveEstimateMutationVariables, SaveEstimateMutation> {
  return {
    request: { query: SaveEstimateDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveEstimateData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface EstimateLineItemTabDataOptions {
  projectEstimate?: Estimate | EstimateOptions;
  costConfidences?: (CostConfidenceDetail | CostConfidenceDetailOptions)[];
}

export function newEstimateLineItemTabData(data: EstimateLineItemTabDataOptions): EstimateLineItemTabQuery {
  return {
    __typename: "Query" as const,
    projectEstimate: maybeNew("Estimate", data["projectEstimate"] || undefined, {}),
    costConfidences: data["costConfidences"]?.map((d) => newCostConfidenceDetail(d)) || [],
  } as any;
}

export function newEstimateLineItemTabResponse(
  variables: EstimateLineItemTabQueryVariables,
  data: EstimateLineItemTabDataOptions | Error,
): MockedResponse<EstimateLineItemTabQueryVariables, EstimateLineItemTabQuery> {
  return {
    request: { query: EstimateLineItemTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newEstimateLineItemTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ExpensesPageMetadataDataOptions {
  project?: Project | ProjectOptions;
}

export function newExpensesPageMetadataData(data: ExpensesPageMetadataDataOptions): ExpensesPageMetadataQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newExpensesPageMetadataResponse(
  variables: ExpensesPageMetadataQueryVariables,
  data: ExpensesPageMetadataDataOptions | Error,
): MockedResponse<ExpensesPageMetadataQueryVariables, ExpensesPageMetadataQuery> {
  return {
    request: { query: ExpensesPageMetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newExpensesPageMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectFinishScheduleDataOptions {
  project?: Project | ProjectOptions;
}

export function newProjectFinishScheduleData(data: ProjectFinishScheduleDataOptions): ProjectFinishScheduleQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newProjectFinishScheduleResponse(
  variables: ProjectFinishScheduleQueryVariables,
  data: ProjectFinishScheduleDataOptions | Error,
): MockedResponse<ProjectFinishScheduleQueryVariables, ProjectFinishScheduleQuery> {
  return {
    request: { query: ProjectFinishScheduleDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectFinishScheduleData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectFinishScheduleMetadataDataOptions {
  project?: Project | ProjectOptions;
}

export function newProjectFinishScheduleMetadataData(
  data: ProjectFinishScheduleMetadataDataOptions,
): ProjectFinishScheduleMetadataQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newProjectFinishScheduleMetadataResponse(
  variables: ProjectFinishScheduleMetadataQueryVariables,
  data: ProjectFinishScheduleMetadataDataOptions | Error,
): MockedResponse<ProjectFinishScheduleMetadataQueryVariables, ProjectFinishScheduleMetadataQuery> {
  return {
    request: { query: ProjectFinishScheduleMetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectFinishScheduleMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface HomeownerContractDataOptions {
  homeownerContract?: HomeownerContract | HomeownerContractOptions;
}

export function newHomeownerContractData(data: HomeownerContractDataOptions): HomeownerContractQuery {
  return {
    __typename: "Query" as const,
    homeownerContract: maybeNew("HomeownerContract", data["homeownerContract"] || undefined, {}),
  } as any;
}

export function newHomeownerContractResponse(
  variables: HomeownerContractQueryVariables,
  data: HomeownerContractDataOptions | Error,
): MockedResponse<HomeownerContractQueryVariables, HomeownerContractQuery> {
  return {
    request: { query: HomeownerContractDocument, variables },
    result: { data: data instanceof Error ? undefined : newHomeownerContractData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveHomeownerContractDataOptions {
  saveHomeownerContract?: SaveHomeownerContractResult | SaveHomeownerContractResultOptions;
}

export function newSaveHomeownerContractData(data: SaveHomeownerContractDataOptions): SaveHomeownerContractMutation {
  return {
    __typename: "Mutation" as const,
    saveHomeownerContract: maybeNew("SaveHomeownerContractResult", data["saveHomeownerContract"] || undefined, {}),
  } as any;
}

export function newSaveHomeownerContractResponse(
  variables: SaveHomeownerContractMutationVariables,
  data: SaveHomeownerContractDataOptions | Error,
): MockedResponse<SaveHomeownerContractMutationVariables, SaveHomeownerContractMutation> {
  return {
    request: { query: SaveHomeownerContractDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveHomeownerContractData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface HomeownerContractLikeScheduleDataOptions {
  homeownerContract?: HomeownerContract | HomeownerContractOptions;
  homeownerContractChangeOrder?: HomeownerContractChangeOrder | HomeownerContractChangeOrderOptions;
  project?: Project | ProjectOptions;
}

export function newHomeownerContractLikeScheduleData(
  data: HomeownerContractLikeScheduleDataOptions,
): HomeownerContractLikeScheduleQuery {
  return {
    __typename: "Query" as const,
    homeownerContract: maybeNew("HomeownerContract", data["homeownerContract"] || undefined, {}),
    homeownerContractChangeOrder: maybeNew(
      "HomeownerContractChangeOrder",
      data["homeownerContractChangeOrder"] || undefined,
      {},
    ),
    project: maybeNew("Project", data["project"] || undefined, {}),
  } as any;
}

export function newHomeownerContractLikeScheduleResponse(
  variables: HomeownerContractLikeScheduleQueryVariables,
  data: HomeownerContractLikeScheduleDataOptions | Error,
): MockedResponse<HomeownerContractLikeScheduleQueryVariables, HomeownerContractLikeScheduleQuery> {
  return {
    request: { query: HomeownerContractLikeScheduleDocument, variables },
    result: { data: data instanceof Error ? undefined : newHomeownerContractLikeScheduleData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveHomeownerContractDrawsDataOptions {
  saveHomeownerContract?: SaveHomeownerContractResult | SaveHomeownerContractResultOptions;
}

export function newSaveHomeownerContractDrawsData(
  data: SaveHomeownerContractDrawsDataOptions,
): SaveHomeownerContractDrawsMutation {
  return {
    __typename: "Mutation" as const,
    saveHomeownerContract: maybeNew("SaveHomeownerContractResult", data["saveHomeownerContract"] || undefined, {}),
  } as any;
}

export function newSaveHomeownerContractDrawsResponse(
  variables: SaveHomeownerContractDrawsMutationVariables,
  data: SaveHomeownerContractDrawsDataOptions | Error,
): MockedResponse<SaveHomeownerContractDrawsMutationVariables, SaveHomeownerContractDrawsMutation> {
  return {
    request: { query: SaveHomeownerContractDrawsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveHomeownerContractDrawsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveHomeownerContractChangeOrderDrawsDataOptions {
  saveHomeownerContractChangeOrder?:
    | SaveHomeownerContractChangeOrderResult
    | SaveHomeownerContractChangeOrderResultOptions;
}

export function newSaveHomeownerContractChangeOrderDrawsData(
  data: SaveHomeownerContractChangeOrderDrawsDataOptions,
): SaveHomeownerContractChangeOrderDrawsMutation {
  return {
    __typename: "Mutation" as const,
    saveHomeownerContractChangeOrder: maybeNew(
      "SaveHomeownerContractChangeOrderResult",
      data["saveHomeownerContractChangeOrder"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveHomeownerContractChangeOrderDrawsResponse(
  variables: SaveHomeownerContractChangeOrderDrawsMutationVariables,
  data: SaveHomeownerContractChangeOrderDrawsDataOptions | Error,
): MockedResponse<
  SaveHomeownerContractChangeOrderDrawsMutationVariables,
  SaveHomeownerContractChangeOrderDrawsMutation
> {
  return {
    request: { query: SaveHomeownerContractChangeOrderDrawsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveHomeownerContractChangeOrderDrawsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface HomeownerContractChangeOrder2DataOptions {
  homeownerContractChangeOrder?: HomeownerContractChangeOrder | HomeownerContractChangeOrderOptions;
}

export function newHomeownerContractChangeOrder2Data(
  data: HomeownerContractChangeOrder2DataOptions,
): HomeownerContractChangeOrder2Query {
  return {
    __typename: "Query" as const,
    homeownerContractChangeOrder: maybeNew(
      "HomeownerContractChangeOrder",
      data["homeownerContractChangeOrder"] || undefined,
      {},
    ),
  } as any;
}

export function newHomeownerContractChangeOrder2Response(
  variables: HomeownerContractChangeOrder2QueryVariables,
  data: HomeownerContractChangeOrder2DataOptions | Error,
): MockedResponse<HomeownerContractChangeOrder2QueryVariables, HomeownerContractChangeOrder2Query> {
  return {
    request: { query: HomeownerContractChangeOrder2Document, variables },
    result: { data: data instanceof Error ? undefined : newHomeownerContractChangeOrder2Data(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveHomeownerContractChangeOrderDataOptions {
  saveHomeownerContractChangeOrder?:
    | SaveHomeownerContractChangeOrderResult
    | SaveHomeownerContractChangeOrderResultOptions;
}

export function newSaveHomeownerContractChangeOrderData(
  data: SaveHomeownerContractChangeOrderDataOptions,
): SaveHomeownerContractChangeOrderMutation {
  return {
    __typename: "Mutation" as const,
    saveHomeownerContractChangeOrder: maybeNew(
      "SaveHomeownerContractChangeOrderResult",
      data["saveHomeownerContractChangeOrder"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveHomeownerContractChangeOrderResponse(
  variables: SaveHomeownerContractChangeOrderMutationVariables,
  data: SaveHomeownerContractChangeOrderDataOptions | Error,
): MockedResponse<SaveHomeownerContractChangeOrderMutationVariables, SaveHomeownerContractChangeOrderMutation> {
  return {
    request: { query: SaveHomeownerContractChangeOrderDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveHomeownerContractChangeOrderData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface InvoiceScheduleDataOptions {
  project?: Project | ProjectOptions;
}

export function newInvoiceScheduleData(data: InvoiceScheduleDataOptions): InvoiceScheduleQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newInvoiceScheduleResponse(
  variables: InvoiceScheduleQueryVariables,
  data: InvoiceScheduleDataOptions | Error,
): MockedResponse<InvoiceScheduleQueryVariables, InvoiceScheduleQuery> {
  return {
    request: { query: InvoiceScheduleDocument, variables },
    result: { data: data instanceof Error ? undefined : newInvoiceScheduleData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface GeneratePocInvoiceDataOptions {
  saveInvoice?: SaveInvoiceResult | SaveInvoiceResultOptions;
}

export function newGeneratePocInvoiceData(data: GeneratePocInvoiceDataOptions): GeneratePocInvoiceMutation {
  return {
    __typename: "Mutation" as const,
    saveInvoice: maybeNew("SaveInvoiceResult", data["saveInvoice"] || undefined, {}),
  } as any;
}

export function newGeneratePocInvoiceResponse(
  variables: GeneratePocInvoiceMutationVariables,
  data: GeneratePocInvoiceDataOptions | Error,
): MockedResponse<GeneratePocInvoiceMutationVariables, GeneratePocInvoiceMutation> {
  return {
    request: { query: GeneratePocInvoiceDocument, variables },
    result: { data: data instanceof Error ? undefined : newGeneratePocInvoiceData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface HomeownerNotesForProjectDataOptions {
  homeownerNotes?: (HomeownerNote | HomeownerNoteOptions)[];
}

export function newHomeownerNotesForProjectData(
  data: HomeownerNotesForProjectDataOptions,
): HomeownerNotesForProjectQuery {
  return {
    __typename: "Query" as const,
    homeownerNotes: data["homeownerNotes"]?.map((d) => newHomeownerNote(d)) || [],
  } as any;
}

export function newHomeownerNotesForProjectResponse(
  variables: HomeownerNotesForProjectQueryVariables,
  data: HomeownerNotesForProjectDataOptions | Error,
): MockedResponse<HomeownerNotesForProjectQueryVariables, HomeownerNotesForProjectQuery> {
  return {
    request: { query: HomeownerNotesForProjectDocument, variables },
    result: { data: data instanceof Error ? undefined : newHomeownerNotesForProjectData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectItemBillDetailsDataOptions {
  projectItem?: ProjectItem | ProjectItemOptions;
}

export function newProjectItemBillDetailsData(data: ProjectItemBillDetailsDataOptions): ProjectItemBillDetailsQuery {
  return {
    __typename: "Query" as const,
    projectItem: maybeNew("ProjectItem", data["projectItem"] || undefined, {}),
  } as any;
}

export function newProjectItemBillDetailsResponse(
  variables: ProjectItemBillDetailsQueryVariables,
  data: ProjectItemBillDetailsDataOptions | Error,
): MockedResponse<ProjectItemBillDetailsQueryVariables, ProjectItemBillDetailsQuery> {
  return {
    request: { query: ProjectItemBillDetailsDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectItemBillDetailsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DrawLineItemsDataOptions {
  project?: Project | ProjectOptions;
}

export function newDrawLineItemsData(data: DrawLineItemsDataOptions): DrawLineItemsQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newDrawLineItemsResponse(
  variables: DrawLineItemsQueryVariables,
  data: DrawLineItemsDataOptions | Error,
): MockedResponse<DrawLineItemsQueryVariables, DrawLineItemsQuery> {
  return {
    request: { query: DrawLineItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newDrawLineItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ContractLineItemsDataOptions {
  project?: Project | ProjectOptions;
}

export function newContractLineItemsData(data: ContractLineItemsDataOptions): ContractLineItemsQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newContractLineItemsResponse(
  variables: ContractLineItemsQueryVariables,
  data: ContractLineItemsDataOptions | Error,
): MockedResponse<ContractLineItemsQueryVariables, ContractLineItemsQuery> {
  return {
    request: { query: ContractLineItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newContractLineItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface InvoiceEditDataOptions {
  invoice?: Invoice | InvoiceOptions;
  currentInternalUser?: InternalUser | InternalUserOptions | null;
}

export function newInvoiceEditData(data: InvoiceEditDataOptions): InvoiceEditQuery {
  return {
    __typename: "Query" as const,
    invoice: maybeNew("Invoice", data["invoice"] || undefined, {}),
    currentInternalUser: maybeNewOrNull("InternalUser", data["currentInternalUser"] || undefined, {}),
  } as any;
}

export function newInvoiceEditResponse(
  variables: InvoiceEditQueryVariables,
  data: InvoiceEditDataOptions | Error,
): MockedResponse<InvoiceEditQueryVariables, InvoiceEditQuery> {
  return {
    request: { query: InvoiceEditDocument, variables },
    result: { data: data instanceof Error ? undefined : newInvoiceEditData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface NewInvoiceDataDataOptions {
  project?: Project | ProjectOptions;
}

export function newNewInvoiceDataData(data: NewInvoiceDataDataOptions): NewInvoiceDataQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newNewInvoiceDataResponse(
  variables: NewInvoiceDataQueryVariables,
  data: NewInvoiceDataDataOptions | Error,
): MockedResponse<NewInvoiceDataQueryVariables, NewInvoiceDataQuery> {
  return {
    request: { query: NewInvoiceDataDocument, variables },
    result: { data: data instanceof Error ? undefined : newNewInvoiceDataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveInvoiceDataOptions {
  saveInvoice?: SaveInvoiceResult | SaveInvoiceResultOptions;
}

export function newSaveInvoiceData(data: SaveInvoiceDataOptions): SaveInvoiceMutation {
  return {
    __typename: "Mutation" as const,
    saveInvoice: maybeNew("SaveInvoiceResult", data["saveInvoice"] || undefined, {}),
  } as any;
}

export function newSaveInvoiceResponse(
  variables: SaveInvoiceMutationVariables,
  data: SaveInvoiceDataOptions | Error,
): MockedResponse<SaveInvoiceMutationVariables, SaveInvoiceMutation> {
  return {
    request: { query: SaveInvoiceDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveInvoiceData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteInvoiceDataOptions {
  deleteInvoice?: EmptyResult | EmptyResultOptions;
}

export function newDeleteInvoiceData(data: DeleteInvoiceDataOptions): DeleteInvoiceMutation {
  return {
    __typename: "Mutation" as const,
    deleteInvoice: maybeNew("EmptyResult", data["deleteInvoice"] || undefined, {}),
  } as any;
}

export function newDeleteInvoiceResponse(
  variables: DeleteInvoiceMutationVariables,
  data: DeleteInvoiceDataOptions | Error,
): MockedResponse<DeleteInvoiceMutationVariables, DeleteInvoiceMutation> {
  return {
    request: { query: DeleteInvoiceDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteInvoiceData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectInvoicesPageDataOptions {
  project?: Project | ProjectOptions;
}

export function newProjectInvoicesPageData(data: ProjectInvoicesPageDataOptions): ProjectInvoicesPageQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newProjectInvoicesPageResponse(
  variables: ProjectInvoicesPageQueryVariables,
  data: ProjectInvoicesPageDataOptions | Error,
): MockedResponse<ProjectInvoicesPageQueryVariables, ProjectInvoicesPageQuery> {
  return {
    request: { query: ProjectInvoicesPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectInvoicesPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface InvoiceProjectStageModalDetailsDataOptions {
  project?: Project | ProjectOptions;
}

export function newInvoiceProjectStageModalDetailsData(
  data: InvoiceProjectStageModalDetailsDataOptions,
): InvoiceProjectStageModalDetailsQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newInvoiceProjectStageModalDetailsResponse(
  variables: InvoiceProjectStageModalDetailsQueryVariables,
  data: InvoiceProjectStageModalDetailsDataOptions | Error,
): MockedResponse<InvoiceProjectStageModalDetailsQueryVariables, InvoiceProjectStageModalDetailsQuery> {
  return {
    request: { query: InvoiceProjectStageModalDetailsDocument, variables },
    result: { data: data instanceof Error ? undefined : newInvoiceProjectStageModalDetailsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface JobLogNoteHistoryTabDataOptions {
  jobLogNote?: JobLogNote | JobLogNoteOptions;
}

export function newJobLogNoteHistoryTabData(data: JobLogNoteHistoryTabDataOptions): JobLogNoteHistoryTabQuery {
  return {
    __typename: "Query" as const,
    jobLogNote: maybeNew("JobLogNote", data["jobLogNote"] || undefined, {}),
  } as any;
}

export function newJobLogNoteHistoryTabResponse(
  variables: JobLogNoteHistoryTabQueryVariables,
  data: JobLogNoteHistoryTabDataOptions | Error,
): MockedResponse<JobLogNoteHistoryTabQueryVariables, JobLogNoteHistoryTabQuery> {
  return {
    request: { query: JobLogNoteHistoryTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newJobLogNoteHistoryTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectItemsDataOptions {
  project?: Project | ProjectOptions;
  items?: (Item | ItemOptions)[];
}

export function newProjectItemsData(data: ProjectItemsDataOptions): ProjectItemsQuery {
  return {
    __typename: "Query" as const,
    project: maybeNew("Project", data["project"] || undefined, {}),
    items: data["items"]?.map((d) => newItem(d)) || [],
  } as any;
}

export function newProjectItemsResponse(
  variables: ProjectItemsQueryVariables,
  data: ProjectItemsDataOptions | Error,
): MockedResponse<ProjectItemsQueryVariables, ProjectItemsQuery> {
  return {
    request: { query: ProjectItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveProjectItemDataOptions {
  saveProjectItems?: SaveProjectItemsResult | SaveProjectItemsResultOptions;
}

export function newSaveProjectItemData(data: SaveProjectItemDataOptions): SaveProjectItemMutation {
  return {
    __typename: "Mutation" as const,
    saveProjectItems: maybeNew("SaveProjectItemsResult", data["saveProjectItems"] || undefined, {}),
  } as any;
}

export function newSaveProjectItemResponse(
  variables: SaveProjectItemMutationVariables,
  data: SaveProjectItemDataOptions | Error,
): MockedResponse<SaveProjectItemMutationVariables, SaveProjectItemMutation> {
  return {
    request: { query: SaveProjectItemDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveProjectItemData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface JobLogDataOptions {
  jobLog?: JobLog | JobLogOptions;
}

export function newJobLogData(data: JobLogDataOptions): JobLogQuery {
  return { __typename: "Query" as const, jobLog: maybeNew("JobLog", data["jobLog"] || undefined, {}) } as any;
}

export function newJobLogResponse(
  variables: JobLogQueryVariables,
  data: JobLogDataOptions | Error,
): MockedResponse<JobLogQueryVariables, JobLogQuery> {
  return {
    request: { query: JobLogDocument, variables },
    result: { data: data instanceof Error ? undefined : newJobLogData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface JobLogsDataOptions {
  jobLogsPage?: JobLogsPageResult | JobLogsPageResultOptions;
  currentInternalUser?: InternalUser | InternalUserOptions | null;
}

export function newJobLogsData(data: JobLogsDataOptions): JobLogsQuery {
  return {
    __typename: "Query" as const,
    jobLogsPage: maybeNew("JobLogsPageResult", data["jobLogsPage"] || undefined, {}),
    currentInternalUser: maybeNewOrNull("InternalUser", data["currentInternalUser"] || undefined, {}),
  } as any;
}

export function newJobLogsResponse(
  variables: JobLogsQueryVariables,
  data: JobLogsDataOptions | Error,
): MockedResponse<JobLogsQueryVariables, JobLogsQuery> {
  return {
    request: { query: JobLogsDocument, variables },
    result: { data: data instanceof Error ? undefined : newJobLogsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface JobLogsForDatePickerDataOptions {
  jobLogs?: (JobLog | JobLogOptions)[];
}

export function newJobLogsForDatePickerData(data: JobLogsForDatePickerDataOptions): JobLogsForDatePickerQuery {
  return { __typename: "Query" as const, jobLogs: data["jobLogs"]?.map((d) => newJobLog(d)) || [] } as any;
}

export function newJobLogsForDatePickerResponse(
  variables: JobLogsForDatePickerQueryVariables,
  data: JobLogsForDatePickerDataOptions | Error,
): MockedResponse<JobLogsForDatePickerQueryVariables, JobLogsForDatePickerQuery> {
  return {
    request: { query: JobLogsForDatePickerDocument, variables },
    result: { data: data instanceof Error ? undefined : newJobLogsForDatePickerData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface JobLogsFilterDataDataOptions {
  scheduleTasks?: (ScheduleTask | ScheduleTaskOptions)[];
}

export function newJobLogsFilterDataData(data: JobLogsFilterDataDataOptions): JobLogsFilterDataQuery {
  return {
    __typename: "Query" as const,
    scheduleTasks: data["scheduleTasks"]?.map((d) => newScheduleTask(d)) || [],
  } as any;
}

export function newJobLogsFilterDataResponse(
  variables: JobLogsFilterDataQueryVariables,
  data: JobLogsFilterDataDataOptions | Error,
): MockedResponse<JobLogsFilterDataQueryVariables, JobLogsFilterDataQuery> {
  return {
    request: { query: JobLogsFilterDataDocument, variables },
    result: { data: data instanceof Error ? undefined : newJobLogsFilterDataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface JobLogsForGivenDateAndProjectsForCopyDataOptions {
  jobLogs?: (JobLog | JobLogOptions)[];
  projects?: (Project | ProjectOptions)[];
}

export function newJobLogsForGivenDateAndProjectsForCopyData(
  data: JobLogsForGivenDateAndProjectsForCopyDataOptions,
): JobLogsForGivenDateAndProjectsForCopyQuery {
  return {
    __typename: "Query" as const,
    jobLogs: data["jobLogs"]?.map((d) => newJobLog(d)) || [],
    projects: data["projects"]?.map((d) => maybeNew("Project", d, {})) || [],
  } as any;
}

export function newJobLogsForGivenDateAndProjectsForCopyResponse(
  variables: JobLogsForGivenDateAndProjectsForCopyQueryVariables,
  data: JobLogsForGivenDateAndProjectsForCopyDataOptions | Error,
): MockedResponse<JobLogsForGivenDateAndProjectsForCopyQueryVariables, JobLogsForGivenDateAndProjectsForCopyQuery> {
  return {
    request: { query: JobLogsForGivenDateAndProjectsForCopyDocument, variables },
    result: { data: data instanceof Error ? undefined : newJobLogsForGivenDateAndProjectsForCopyData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface JobLogsDevelopmentProjectsDataOptions {
  development?: Development | DevelopmentOptions;
}

export function newJobLogsDevelopmentProjectsData(
  data: JobLogsDevelopmentProjectsDataOptions,
): JobLogsDevelopmentProjectsQuery {
  return {
    __typename: "Query" as const,
    development: maybeNew("Development", data["development"] || undefined, {}),
  } as any;
}

export function newJobLogsDevelopmentProjectsResponse(
  variables: JobLogsDevelopmentProjectsQueryVariables,
  data: JobLogsDevelopmentProjectsDataOptions | Error,
): MockedResponse<JobLogsDevelopmentProjectsQueryVariables, JobLogsDevelopmentProjectsQuery> {
  return {
    request: { query: JobLogsDevelopmentProjectsDocument, variables },
    result: { data: data instanceof Error ? undefined : newJobLogsDevelopmentProjectsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScheduleTasksForJobLogsDataOptions {
  scheduleTasks?: (ScheduleTask | ScheduleTaskOptions)[];
}

export function newScheduleTasksForJobLogsData(data: ScheduleTasksForJobLogsDataOptions): ScheduleTasksForJobLogsQuery {
  return {
    __typename: "Query" as const,
    scheduleTasks: data["scheduleTasks"]?.map((d) => newScheduleTask(d)) || [],
  } as any;
}

export function newScheduleTasksForJobLogsResponse(
  variables: ScheduleTasksForJobLogsQueryVariables,
  data: ScheduleTasksForJobLogsDataOptions | Error,
): MockedResponse<ScheduleTasksForJobLogsQueryVariables, ScheduleTasksForJobLogsQuery> {
  return {
    request: { query: ScheduleTasksForJobLogsDocument, variables },
    result: { data: data instanceof Error ? undefined : newScheduleTasksForJobLogsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScheduleTasksOnJobLogNoteDataOptions {
  scheduleTasks?: (ScheduleTask | ScheduleTaskOptions)[];
}

export function newScheduleTasksOnJobLogNoteData(
  data: ScheduleTasksOnJobLogNoteDataOptions,
): ScheduleTasksOnJobLogNoteQuery {
  return {
    __typename: "Query" as const,
    scheduleTasks: data["scheduleTasks"]?.map((d) => newScheduleTask(d)) || [],
  } as any;
}

export function newScheduleTasksOnJobLogNoteResponse(
  variables: ScheduleTasksOnJobLogNoteQueryVariables,
  data: ScheduleTasksOnJobLogNoteDataOptions | Error,
): MockedResponse<ScheduleTasksOnJobLogNoteQueryVariables, ScheduleTasksOnJobLogNoteQuery> {
  return {
    request: { query: ScheduleTasksOnJobLogNoteDocument, variables },
    result: { data: data instanceof Error ? undefined : newScheduleTasksOnJobLogNoteData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScheduleFlagsOnJobLogNoteDataOptions {
  scheduleFlags?: (ScheduleFlag | ScheduleFlagOptions)[];
}

export function newScheduleFlagsOnJobLogNoteData(
  data: ScheduleFlagsOnJobLogNoteDataOptions,
): ScheduleFlagsOnJobLogNoteQuery {
  return {
    __typename: "Query" as const,
    scheduleFlags: data["scheduleFlags"]?.map((d) => newScheduleFlag(d)) || [],
  } as any;
}

export function newScheduleFlagsOnJobLogNoteResponse(
  variables: ScheduleFlagsOnJobLogNoteQueryVariables,
  data: ScheduleFlagsOnJobLogNoteDataOptions | Error,
): MockedResponse<ScheduleFlagsOnJobLogNoteQueryVariables, ScheduleFlagsOnJobLogNoteQuery> {
  return {
    request: { query: ScheduleFlagsOnJobLogNoteDocument, variables },
    result: { data: data instanceof Error ? undefined : newScheduleFlagsOnJobLogNoteData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface JobLogsProjectEditabilityDataOptions {
  project?: Project | ProjectOptions;
}

export function newJobLogsProjectEditabilityData(
  data: JobLogsProjectEditabilityDataOptions,
): JobLogsProjectEditabilityQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newJobLogsProjectEditabilityResponse(
  variables: JobLogsProjectEditabilityQueryVariables,
  data: JobLogsProjectEditabilityDataOptions | Error,
): MockedResponse<JobLogsProjectEditabilityQueryVariables, JobLogsProjectEditabilityQuery> {
  return {
    request: { query: JobLogsProjectEditabilityDocument, variables },
    result: { data: data instanceof Error ? undefined : newJobLogsProjectEditabilityData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveJobLogDataOptions {
  saveJobLog?: SaveJobLogResult | SaveJobLogResultOptions;
}

export function newSaveJobLogData(data: SaveJobLogDataOptions): SaveJobLogMutation {
  return {
    __typename: "Mutation" as const,
    saveJobLog: maybeNew("SaveJobLogResult", data["saveJobLog"] || undefined, {}),
  } as any;
}

export function newSaveJobLogResponse(
  variables: SaveJobLogMutationVariables,
  data: SaveJobLogDataOptions | Error,
): MockedResponse<SaveJobLogMutationVariables, SaveJobLogMutation> {
  return {
    request: { query: SaveJobLogDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveJobLogData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveJobLogNoteDataOptions {
  saveJobLogNote?: SaveJobLogNoteResult | SaveJobLogNoteResultOptions;
}

export function newSaveJobLogNoteData(data: SaveJobLogNoteDataOptions): SaveJobLogNoteMutation {
  return {
    __typename: "Mutation" as const,
    saveJobLogNote: maybeNew("SaveJobLogNoteResult", data["saveJobLogNote"] || undefined, {}),
  } as any;
}

export function newSaveJobLogNoteResponse(
  variables: SaveJobLogNoteMutationVariables,
  data: SaveJobLogNoteDataOptions | Error,
): MockedResponse<SaveJobLogNoteMutationVariables, SaveJobLogNoteMutation> {
  return {
    request: { query: SaveJobLogNoteDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveJobLogNoteData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteJobLogNoteDataOptions {
  deleteJobLogNote?: DeleteJobLogNoteResult | DeleteJobLogNoteResultOptions;
}

export function newDeleteJobLogNoteData(data: DeleteJobLogNoteDataOptions): DeleteJobLogNoteMutation {
  return {
    __typename: "Mutation" as const,
    deleteJobLogNote: maybeNew("DeleteJobLogNoteResult", data["deleteJobLogNote"] || undefined, {}),
  } as any;
}

export function newDeleteJobLogNoteResponse(
  variables: DeleteJobLogNoteMutationVariables,
  data: DeleteJobLogNoteDataOptions | Error,
): MockedResponse<DeleteJobLogNoteMutationVariables, DeleteJobLogNoteMutation> {
  return {
    request: { query: DeleteJobLogNoteDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteJobLogNoteData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveJobLogImageDataOptions {
  saveJobLogImage?: SaveJobLogImageResult | SaveJobLogImageResultOptions;
}

export function newSaveJobLogImageData(data: SaveJobLogImageDataOptions): SaveJobLogImageMutation {
  return {
    __typename: "Mutation" as const,
    saveJobLogImage: maybeNew("SaveJobLogImageResult", data["saveJobLogImage"] || undefined, {}),
  } as any;
}

export function newSaveJobLogImageResponse(
  variables: SaveJobLogImageMutationVariables,
  data: SaveJobLogImageDataOptions | Error,
): MockedResponse<SaveJobLogImageMutationVariables, SaveJobLogImageMutation> {
  return {
    request: { query: SaveJobLogImageDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveJobLogImageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteJobLogImageDataOptions {
  deleteJobLogImage?: DeleteJobLogImageResult | DeleteJobLogImageResultOptions;
}

export function newDeleteJobLogImageData(data: DeleteJobLogImageDataOptions): DeleteJobLogImageMutation {
  return {
    __typename: "Mutation" as const,
    deleteJobLogImage: maybeNew("DeleteJobLogImageResult", data["deleteJobLogImage"] || undefined, {}),
  } as any;
}

export function newDeleteJobLogImageResponse(
  variables: DeleteJobLogImageMutationVariables,
  data: DeleteJobLogImageDataOptions | Error,
): MockedResponse<DeleteJobLogImageMutationVariables, DeleteJobLogImageMutation> {
  return {
    request: { query: DeleteJobLogImageDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteJobLogImageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DuplicateJobLogsDataOptions {
  duplicateJobLogs?: DuplicateJobLogsResult | DuplicateJobLogsResultOptions;
}

export function newDuplicateJobLogsData(data: DuplicateJobLogsDataOptions): DuplicateJobLogsMutation {
  return {
    __typename: "Mutation" as const,
    duplicateJobLogs: maybeNew("DuplicateJobLogsResult", data["duplicateJobLogs"] || undefined, {}),
  } as any;
}

export function newDuplicateJobLogsResponse(
  variables: DuplicateJobLogsMutationVariables,
  data: DuplicateJobLogsDataOptions | Error,
): MockedResponse<DuplicateJobLogsMutationVariables, DuplicateJobLogsMutation> {
  return {
    request: { query: DuplicateJobLogsDocument, variables },
    result: { data: data instanceof Error ? undefined : newDuplicateJobLogsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ApplicableProductOfferingConfigsPageStructureMetadataDataOptions {
  structure?: Structure | StructureOptions;
  changeEventReasons?: (ChangeEventReason | ChangeEventReasonOptions)[];
}

export function newApplicableProductOfferingConfigsPageStructureMetadataData(
  data: ApplicableProductOfferingConfigsPageStructureMetadataDataOptions,
): ApplicableProductOfferingConfigsPageStructureMetadataQuery {
  return {
    __typename: "Query" as const,
    structure: maybeNew("Structure", data["structure"] || undefined, {}),
    changeEventReasons: data["changeEventReasons"]?.map((d) => newChangeEventReason(d)) || [],
  } as any;
}

export function newApplicableProductOfferingConfigsPageStructureMetadataResponse(
  variables: ApplicableProductOfferingConfigsPageStructureMetadataQueryVariables,
  data: ApplicableProductOfferingConfigsPageStructureMetadataDataOptions | Error,
): MockedResponse<
  ApplicableProductOfferingConfigsPageStructureMetadataQueryVariables,
  ApplicableProductOfferingConfigsPageStructureMetadataQuery
> {
  return {
    request: { query: ApplicableProductOfferingConfigsPageStructureMetadataDocument, variables },
    result: {
      data: data instanceof Error ? undefined : newApplicableProductOfferingConfigsPageStructureMetadataData(data),
    },
    error: data instanceof Error ? data : undefined,
  };
}
interface AppliableProductOfferingConfigsDataOptions {
  productOfferingConfigs?: ProductOfferingConfigsPage | ProductOfferingConfigsPageOptions;
  checkoutConfigs?: CheckoutConfigsPage | CheckoutConfigsPageOptions;
}

export function newAppliableProductOfferingConfigsData(
  data: AppliableProductOfferingConfigsDataOptions,
): AppliableProductOfferingConfigsQuery {
  return {
    __typename: "Query" as const,
    productOfferingConfigs: maybeNew("ProductOfferingConfigsPage", data["productOfferingConfigs"] || undefined, {}),
    checkoutConfigs: maybeNew("CheckoutConfigsPage", data["checkoutConfigs"] || undefined, {}),
  } as any;
}

export function newAppliableProductOfferingConfigsResponse(
  variables: AppliableProductOfferingConfigsQueryVariables,
  data: AppliableProductOfferingConfigsDataOptions | Error,
): MockedResponse<AppliableProductOfferingConfigsQueryVariables, AppliableProductOfferingConfigsQuery> {
  return {
    request: { query: AppliableProductOfferingConfigsDocument, variables },
    result: { data: data instanceof Error ? undefined : newAppliableProductOfferingConfigsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AppliableProductOfferingConfigsApplyWithoutChangesDataOptions {
  saveChangeEvent?: SaveChangeEventResult | SaveChangeEventResultOptions;
}

export function newAppliableProductOfferingConfigsApplyWithoutChangesData(
  data: AppliableProductOfferingConfigsApplyWithoutChangesDataOptions,
): AppliableProductOfferingConfigsApplyWithoutChangesMutation {
  return {
    __typename: "Mutation" as const,
    saveChangeEvent: maybeNew("SaveChangeEventResult", data["saveChangeEvent"] || undefined, {}),
  } as any;
}

export function newAppliableProductOfferingConfigsApplyWithoutChangesResponse(
  variables: AppliableProductOfferingConfigsApplyWithoutChangesMutationVariables,
  data: AppliableProductOfferingConfigsApplyWithoutChangesDataOptions | Error,
): MockedResponse<
  AppliableProductOfferingConfigsApplyWithoutChangesMutationVariables,
  AppliableProductOfferingConfigsApplyWithoutChangesMutation
> {
  return {
    request: { query: AppliableProductOfferingConfigsApplyWithoutChangesDocument, variables },
    result: {
      data: data instanceof Error ? undefined : newAppliableProductOfferingConfigsApplyWithoutChangesData(data),
    },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectLotSummaryPageDataOptions {
  project?: Project | ProjectOptions;
}

export function newProjectLotSummaryPageData(data: ProjectLotSummaryPageDataOptions): ProjectLotSummaryPageQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newProjectLotSummaryPageResponse(
  variables: ProjectLotSummaryPageQueryVariables,
  data: ProjectLotSummaryPageDataOptions | Error,
): MockedResponse<ProjectLotSummaryPageQueryVariables, ProjectLotSummaryPageQuery> {
  return {
    request: { query: ProjectLotSummaryPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectLotSummaryPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface StructureLotSummaryPageDataOptions {
  project?: Project | ProjectOptions;
}

export function newStructureLotSummaryPageData(data: StructureLotSummaryPageDataOptions): StructureLotSummaryPageQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newStructureLotSummaryPageResponse(
  variables: StructureLotSummaryPageQueryVariables,
  data: StructureLotSummaryPageDataOptions | Error,
): MockedResponse<StructureLotSummaryPageQueryVariables, StructureLotSummaryPageQuery> {
  return {
    request: { query: StructureLotSummaryPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newStructureLotSummaryPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectSchedulePageV2DataOptions {
  schedules?: (Schedule | ScheduleOptions)[];
  project?: Project | ProjectOptions;
  scheduleTasks?: (ScheduleTask | ScheduleTaskOptions)[];
}

export function newProjectSchedulePageV2Data(data: ProjectSchedulePageV2DataOptions): ProjectSchedulePageV2Query {
  return {
    __typename: "Query" as const,
    schedules: data["schedules"]?.map((d) => newSchedule(d)) || [],
    project: maybeNew("Project", data["project"] || undefined, {}),
    scheduleTasks: data["scheduleTasks"]?.map((d) => newScheduleTask(d)) || [],
  } as any;
}

export function newProjectSchedulePageV2Response(
  variables: ProjectSchedulePageV2QueryVariables,
  data: ProjectSchedulePageV2DataOptions | Error,
): MockedResponse<ProjectSchedulePageV2QueryVariables, ProjectSchedulePageV2Query> {
  return {
    request: { query: ProjectSchedulePageV2Document, variables },
    result: { data: data instanceof Error ? undefined : newProjectSchedulePageV2Data(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TaskStatusesDataOptions {
  taskStatuses?: (TaskStatusDetail | TaskStatusDetailOptions)[];
}

export function newTaskStatusesData(data: TaskStatusesDataOptions): TaskStatusesQuery {
  return {
    __typename: "Query" as const,
    taskStatuses: data["taskStatuses"]?.map((d) => newTaskStatusDetail(d)) || [],
  } as any;
}

export function newTaskStatusesResponse(
  data: TaskStatusesDataOptions | Error,
): MockedResponse<TaskStatusesQueryVariables, TaskStatusesQuery> {
  return {
    request: { query: TaskStatusesDocument },
    result: { data: data instanceof Error ? undefined : newTaskStatusesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AvailableGlobalPhasesDataOptions {
  globalPhases?: (GlobalPhase | GlobalPhaseOptions)[];
  schedulePhases?: (SchedulePhase | SchedulePhaseOptions)[];
}

export function newAvailableGlobalPhasesData(data: AvailableGlobalPhasesDataOptions): AvailableGlobalPhasesQuery {
  return {
    __typename: "Query" as const,
    globalPhases: data["globalPhases"]?.map((d) => newGlobalPhase(d)) || [],
    schedulePhases: data["schedulePhases"]?.map((d) => newSchedulePhase(d)) || [],
  } as any;
}

export function newAvailableGlobalPhasesResponse(
  variables: AvailableGlobalPhasesQueryVariables,
  data: AvailableGlobalPhasesDataOptions | Error,
): MockedResponse<AvailableGlobalPhasesQueryVariables, AvailableGlobalPhasesQuery> {
  return {
    request: { query: AvailableGlobalPhasesDocument, variables },
    result: { data: data instanceof Error ? undefined : newAvailableGlobalPhasesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScheduleParentGlobalMilestoneTasksDataOptions {
  scheduleTasks?: (ScheduleTask | ScheduleTaskOptions)[];
  schedules?: (Schedule | ScheduleOptions)[];
}

export function newScheduleParentGlobalMilestoneTasksData(
  data: ScheduleParentGlobalMilestoneTasksDataOptions,
): ScheduleParentGlobalMilestoneTasksQuery {
  return {
    __typename: "Query" as const,
    scheduleTasks: data["scheduleTasks"]?.map((d) => newScheduleTask(d)) || [],
    schedules: data["schedules"]?.map((d) => newSchedule(d)) || [],
  } as any;
}

export function newScheduleParentGlobalMilestoneTasksResponse(
  variables: ScheduleParentGlobalMilestoneTasksQueryVariables,
  data: ScheduleParentGlobalMilestoneTasksDataOptions | Error,
): MockedResponse<ScheduleParentGlobalMilestoneTasksQueryVariables, ScheduleParentGlobalMilestoneTasksQuery> {
  return {
    request: { query: ScheduleParentGlobalMilestoneTasksDocument, variables },
    result: { data: data instanceof Error ? undefined : newScheduleParentGlobalMilestoneTasksData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveScheduleTasksDataOptions {
  saveScheduleTasks?: SaveScheduleTasksResult | SaveScheduleTasksResultOptions;
}

export function newSaveScheduleTasksData(data: SaveScheduleTasksDataOptions): SaveScheduleTasksMutation {
  return {
    __typename: "Mutation" as const,
    saveScheduleTasks: maybeNew("SaveScheduleTasksResult", data["saveScheduleTasks"] || undefined, {}),
  } as any;
}

export function newSaveScheduleTasksResponse(
  variables: SaveScheduleTasksMutationVariables,
  data: SaveScheduleTasksDataOptions | Error,
): MockedResponse<SaveScheduleTasksMutationVariables, SaveScheduleTasksMutation> {
  return {
    request: { query: SaveScheduleTasksDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveScheduleTasksData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveScheduleStatusDataOptions {
  saveSchedule?: SaveScheduleResult | SaveScheduleResultOptions;
}

export function newSaveScheduleStatusData(data: SaveScheduleStatusDataOptions): SaveScheduleStatusMutation {
  return {
    __typename: "Mutation" as const,
    saveSchedule: maybeNew("SaveScheduleResult", data["saveSchedule"] || undefined, {}),
  } as any;
}

export function newSaveScheduleStatusResponse(
  variables: SaveScheduleStatusMutationVariables,
  data: SaveScheduleStatusDataOptions | Error,
): MockedResponse<SaveScheduleStatusMutationVariables, SaveScheduleStatusMutation> {
  return {
    request: { query: SaveScheduleStatusDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveScheduleStatusData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ApplyProductOfferingConfigPageMetaDataOptions {
  project?: Project | ProjectOptions;
  changeEventReasons?: (ChangeEventReason | ChangeEventReasonOptions)[];
}

export function newApplyProductOfferingConfigPageMetaData(
  data: ApplyProductOfferingConfigPageMetaDataOptions,
): ApplyProductOfferingConfigPageMetaQuery {
  return {
    __typename: "Query" as const,
    project: maybeNew("Project", data["project"] || undefined, {}),
    changeEventReasons: data["changeEventReasons"]?.map((d) => newChangeEventReason(d)) || [],
  } as any;
}

export function newApplyProductOfferingConfigPageMetaResponse(
  variables: ApplyProductOfferingConfigPageMetaQueryVariables,
  data: ApplyProductOfferingConfigPageMetaDataOptions | Error,
): MockedResponse<ApplyProductOfferingConfigPageMetaQueryVariables, ApplyProductOfferingConfigPageMetaQuery> {
  return {
    request: { query: ApplyProductOfferingConfigPageMetaDocument, variables },
    result: { data: data instanceof Error ? undefined : newApplyProductOfferingConfigPageMetaData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ApplyProductOfferingConfig_SelectedDataOptions {
  productOfferingConfig?: ProductOfferingConfig | ProductOfferingConfigOptions;
  checkoutConfig?: CheckoutConfig | CheckoutConfigOptions;
  projectReadyPlanConfig?: ProjectReadyPlanConfig | ProjectReadyPlanConfigOptions;
}

export function newApplyProductOfferingConfig_SelectedData(
  data: ApplyProductOfferingConfig_SelectedDataOptions,
): ApplyProductOfferingConfig_SelectedQuery {
  return {
    __typename: "Query" as const,
    productOfferingConfig: maybeNew("ProductOfferingConfig", data["productOfferingConfig"] || undefined, {}),
    checkoutConfig: maybeNew("CheckoutConfig", data["checkoutConfig"] || undefined, {}),
    projectReadyPlanConfig: maybeNew("ProjectReadyPlanConfig", data["projectReadyPlanConfig"] || undefined, {}),
  } as any;
}

export function newApplyProductOfferingConfig_SelectedResponse(
  variables: ApplyProductOfferingConfig_SelectedQueryVariables,
  data: ApplyProductOfferingConfig_SelectedDataOptions | Error,
): MockedResponse<ApplyProductOfferingConfig_SelectedQueryVariables, ApplyProductOfferingConfig_SelectedQuery> {
  return {
    request: { query: ApplyProductOfferingConfig_SelectedDocument, variables },
    result: { data: data instanceof Error ? undefined : newApplyProductOfferingConfig_SelectedData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ApplyProductOfferingConfigs_DeltasDataOptions {
  computeProductOfferingCostsAndPrices?:
    | ComputeProductOfferingCostsAndPricesResponse
    | ComputeProductOfferingCostsAndPricesResponseOptions;
  computeProgramData?: NewProgramData | NewProgramDataOptions;
}

export function newApplyProductOfferingConfigs_DeltasData(
  data: ApplyProductOfferingConfigs_DeltasDataOptions,
): ApplyProductOfferingConfigs_DeltasQuery {
  return {
    __typename: "Query" as const,
    computeProductOfferingCostsAndPrices: maybeNew(
      "ComputeProductOfferingCostsAndPricesResponse",
      data["computeProductOfferingCostsAndPrices"] || undefined,
      {},
    ),
    computeProgramData: maybeNew("NewProgramData", data["computeProgramData"] || undefined, {}),
  } as any;
}

export function newApplyProductOfferingConfigs_DeltasResponse(
  variables: ApplyProductOfferingConfigs_DeltasQueryVariables,
  data: ApplyProductOfferingConfigs_DeltasDataOptions | Error,
): MockedResponse<ApplyProductOfferingConfigs_DeltasQueryVariables, ApplyProductOfferingConfigs_DeltasQuery> {
  return {
    request: { query: ApplyProductOfferingConfigs_DeltasDocument, variables },
    result: { data: data instanceof Error ? undefined : newApplyProductOfferingConfigs_DeltasData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ApplyProductOfferingConfigMetaDataOptions {
  computeProductOfferingCostsAndPrices?:
    | ComputeProductOfferingCostsAndPricesResponse
    | ComputeProductOfferingCostsAndPricesResponseOptions;
  computeProgramData?: NewProgramData | NewProgramDataOptions;
  productOffering?: ProductOffering | ProductOfferingOptions;
}

export function newApplyProductOfferingConfigMetaData(
  data: ApplyProductOfferingConfigMetaDataOptions,
): ApplyProductOfferingConfigMetaQuery {
  return {
    __typename: "Query" as const,
    computeProductOfferingCostsAndPrices: maybeNew(
      "ComputeProductOfferingCostsAndPricesResponse",
      data["computeProductOfferingCostsAndPrices"] || undefined,
      {},
    ),
    computeProgramData: maybeNew("NewProgramData", data["computeProgramData"] || undefined, {}),
    productOffering: maybeNew("ProductOffering", data["productOffering"] || undefined, {}),
  } as any;
}

export function newApplyProductOfferingConfigMetaResponse(
  variables: ApplyProductOfferingConfigMetaQueryVariables,
  data: ApplyProductOfferingConfigMetaDataOptions | Error,
): MockedResponse<ApplyProductOfferingConfigMetaQueryVariables, ApplyProductOfferingConfigMetaQuery> {
  return {
    request: { query: ApplyProductOfferingConfigMetaDocument, variables },
    result: { data: data instanceof Error ? undefined : newApplyProductOfferingConfigMetaData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ApplyProductOfferingConfigDefaultOptionsDataOptions {
  calculateDefaultOfferingOptions?: (ReadyPlanOption | ReadyPlanOptionOptions)[];
}

export function newApplyProductOfferingConfigDefaultOptionsData(
  data: ApplyProductOfferingConfigDefaultOptionsDataOptions,
): ApplyProductOfferingConfigDefaultOptionsQuery {
  return {
    __typename: "Query" as const,
    calculateDefaultOfferingOptions: data["calculateDefaultOfferingOptions"]?.map((d) => newReadyPlanOption(d)) || [],
  } as any;
}

export function newApplyProductOfferingConfigDefaultOptionsResponse(
  variables: ApplyProductOfferingConfigDefaultOptionsQueryVariables,
  data: ApplyProductOfferingConfigDefaultOptionsDataOptions | Error,
): MockedResponse<
  ApplyProductOfferingConfigDefaultOptionsQueryVariables,
  ApplyProductOfferingConfigDefaultOptionsQuery
> {
  return {
    request: { query: ApplyProductOfferingConfigDefaultOptionsDocument, variables },
    result: { data: data instanceof Error ? undefined : newApplyProductOfferingConfigDefaultOptionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ApplyProductOfferingConfigsDataOptions {
  saveProjectReadyPlanConfigs?: SaveProjectReadyPlanConfigsResult | SaveProjectReadyPlanConfigsResultOptions;
}

export function newApplyProductOfferingConfigsData(
  data: ApplyProductOfferingConfigsDataOptions,
): ApplyProductOfferingConfigsMutation {
  return {
    __typename: "Mutation" as const,
    saveProjectReadyPlanConfigs: maybeNew(
      "SaveProjectReadyPlanConfigsResult",
      data["saveProjectReadyPlanConfigs"] || undefined,
      {},
    ),
  } as any;
}

export function newApplyProductOfferingConfigsResponse(
  variables: ApplyProductOfferingConfigsMutationVariables,
  data: ApplyProductOfferingConfigsDataOptions | Error,
): MockedResponse<ApplyProductOfferingConfigsMutationVariables, ApplyProductOfferingConfigsMutation> {
  return {
    request: { query: ApplyProductOfferingConfigsDocument, variables },
    result: { data: data instanceof Error ? undefined : newApplyProductOfferingConfigsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateProductOfferingConfigChangeEventDataOptions {
  saveChangeEvent?: SaveChangeEventResult | SaveChangeEventResultOptions;
}

export function newCreateProductOfferingConfigChangeEventData(
  data: CreateProductOfferingConfigChangeEventDataOptions,
): CreateProductOfferingConfigChangeEventMutation {
  return {
    __typename: "Mutation" as const,
    saveChangeEvent: maybeNew("SaveChangeEventResult", data["saveChangeEvent"] || undefined, {}),
  } as any;
}

export function newCreateProductOfferingConfigChangeEventResponse(
  variables: CreateProductOfferingConfigChangeEventMutationVariables,
  data: CreateProductOfferingConfigChangeEventDataOptions | Error,
): MockedResponse<
  CreateProductOfferingConfigChangeEventMutationVariables,
  CreateProductOfferingConfigChangeEventMutation
> {
  return {
    request: { query: CreateProductOfferingConfigChangeEventDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateProductOfferingConfigChangeEventData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectScheduleTableTasksDataOptions {
  scheduleTasks?: (ScheduleTask | ScheduleTaskOptions)[];
}

export function newProjectScheduleTableTasksData(
  data: ProjectScheduleTableTasksDataOptions,
): ProjectScheduleTableTasksQuery {
  return {
    __typename: "Query" as const,
    scheduleTasks: data["scheduleTasks"]?.map((d) => newScheduleTask(d)) || [],
  } as any;
}

export function newProjectScheduleTableTasksResponse(
  variables: ProjectScheduleTableTasksQueryVariables,
  data: ProjectScheduleTableTasksDataOptions | Error,
): MockedResponse<ProjectScheduleTableTasksQueryVariables, ProjectScheduleTableTasksQuery> {
  return {
    request: { query: ProjectScheduleTableTasksDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectScheduleTableTasksData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SchedulePhasesDataOptions {
  schedulePhases?: (SchedulePhase | SchedulePhaseOptions)[];
  globalPhases?: (GlobalPhase | GlobalPhaseOptions)[];
}

export function newSchedulePhasesData(data: SchedulePhasesDataOptions): SchedulePhasesQuery {
  return {
    __typename: "Query" as const,
    schedulePhases: data["schedulePhases"]?.map((d) => newSchedulePhase(d)) || [],
    globalPhases: data["globalPhases"]?.map((d) => newGlobalPhase(d)) || [],
  } as any;
}

export function newSchedulePhasesResponse(
  variables: SchedulePhasesQueryVariables,
  data: SchedulePhasesDataOptions | Error,
): MockedResponse<SchedulePhasesQueryVariables, SchedulePhasesQuery> {
  return {
    request: { query: SchedulePhasesDocument, variables },
    result: { data: data instanceof Error ? undefined : newSchedulePhasesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ApplyScheduleTemplatesDataOptions {
  applyScheduleTemplates?: ApplyScheduleTemplatesResult | ApplyScheduleTemplatesResultOptions;
}

export function newApplyScheduleTemplatesData(data: ApplyScheduleTemplatesDataOptions): ApplyScheduleTemplatesMutation {
  return {
    __typename: "Mutation" as const,
    applyScheduleTemplates: maybeNew("ApplyScheduleTemplatesResult", data["applyScheduleTemplates"] || undefined, {}),
  } as any;
}

export function newApplyScheduleTemplatesResponse(
  variables: ApplyScheduleTemplatesMutationVariables,
  data: ApplyScheduleTemplatesDataOptions | Error,
): MockedResponse<ApplyScheduleTemplatesMutationVariables, ApplyScheduleTemplatesMutation> {
  return {
    request: { query: ApplyScheduleTemplatesDocument, variables },
    result: { data: data instanceof Error ? undefined : newApplyScheduleTemplatesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ApplyTemplateModalDataOptions {
  itemTemplates?: (ItemTemplate | ItemTemplateOptions)[];
}

export function newApplyTemplateModalData(data: ApplyTemplateModalDataOptions): ApplyTemplateModalQuery {
  return {
    __typename: "Query" as const,
    itemTemplates: data["itemTemplates"]?.map((d) => newItemTemplate(d)) || [],
  } as any;
}

export function newApplyTemplateModalResponse(
  variables: ApplyTemplateModalQueryVariables,
  data: ApplyTemplateModalDataOptions | Error,
): MockedResponse<ApplyTemplateModalQueryVariables, ApplyTemplateModalQuery> {
  return {
    request: { query: ApplyTemplateModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newApplyTemplateModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ApplyTemplateModalPlanDataOptions {
  itemTemplates?: (ItemTemplate | ItemTemplateOptions)[];
}

export function newApplyTemplateModalPlanData(data: ApplyTemplateModalPlanDataOptions): ApplyTemplateModalPlanQuery {
  return {
    __typename: "Query" as const,
    itemTemplates: data["itemTemplates"]?.map((d) => newItemTemplate(d)) || [],
  } as any;
}

export function newApplyTemplateModalPlanResponse(
  variables: ApplyTemplateModalPlanQueryVariables,
  data: ApplyTemplateModalPlanDataOptions | Error,
): MockedResponse<ApplyTemplateModalPlanQueryVariables, ApplyTemplateModalPlanQuery> {
  return {
    request: { query: ApplyTemplateModalPlanDocument, variables },
    result: { data: data instanceof Error ? undefined : newApplyTemplateModalPlanData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddItemModalDataOptions {
  items?: (Item | ItemOptions)[];
  locations?: (Location | LocationOptions)[];
}

export function newAddItemModalData(data: AddItemModalDataOptions): AddItemModalQuery {
  return {
    __typename: "Query" as const,
    items: data["items"]?.map((d) => newItem(d)) || [],
    locations: data["locations"]?.map((d) => newLocation(d)) || [],
  } as any;
}

export function newAddItemModalResponse(
  data: AddItemModalDataOptions | Error,
): MockedResponse<AddItemModalQueryVariables, AddItemModalQuery> {
  return {
    request: { query: AddItemModalDocument },
    result: { data: data instanceof Error ? undefined : newAddItemModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ToggleFinalizeForHomeownerDataOptions {
  makeHomeownerSelection?: MakeHomeownerSelectionResult | MakeHomeownerSelectionResultOptions;
}

export function newToggleFinalizeForHomeownerData(
  data: ToggleFinalizeForHomeownerDataOptions,
): ToggleFinalizeForHomeownerMutation {
  return {
    __typename: "Mutation" as const,
    makeHomeownerSelection: maybeNew("MakeHomeownerSelectionResult", data["makeHomeownerSelection"] || undefined, {}),
  } as any;
}

export function newToggleFinalizeForHomeownerResponse(
  variables: ToggleFinalizeForHomeownerMutationVariables,
  data: ToggleFinalizeForHomeownerDataOptions | Error,
): MockedResponse<ToggleFinalizeForHomeownerMutationVariables, ToggleFinalizeForHomeownerMutation> {
  return {
    request: { query: ToggleFinalizeForHomeownerDocument, variables },
    result: { data: data instanceof Error ? undefined : newToggleFinalizeForHomeownerData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ImportProjectItemsModalMetadataDataOptions {
  unitsOfMeasure?: (UnitOfMeasure | UnitOfMeasureOptions)[];
  locations?: (Location | LocationOptions)[];
  items?: (Item | ItemOptions)[];
}

export function newImportProjectItemsModalMetadataData(
  data: ImportProjectItemsModalMetadataDataOptions,
): ImportProjectItemsModalMetadataQuery {
  return {
    __typename: "Query" as const,
    unitsOfMeasure: data["unitsOfMeasure"]?.map((d) => newUnitOfMeasure(d)) || [],
    locations: data["locations"]?.map((d) => newLocation(d)) || [],
    items: data["items"]?.map((d) => newItem(d)) || [],
  } as any;
}

export function newImportProjectItemsModalMetadataResponse(
  data: ImportProjectItemsModalMetadataDataOptions | Error,
): MockedResponse<ImportProjectItemsModalMetadataQueryVariables, ImportProjectItemsModalMetadataQuery> {
  return {
    request: { query: ImportProjectItemsModalMetadataDocument },
    result: { data: data instanceof Error ? undefined : newImportProjectItemsModalMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectItemHistoryDataOptions {
  projectItem?: ProjectItem | ProjectItemOptions;
}

export function newProjectItemHistoryData(data: ProjectItemHistoryDataOptions): ProjectItemHistoryQuery {
  return {
    __typename: "Query" as const,
    projectItem: maybeNew("ProjectItem", data["projectItem"] || undefined, {}),
  } as any;
}

export function newProjectItemHistoryResponse(
  variables: ProjectItemHistoryQueryVariables,
  data: ProjectItemHistoryDataOptions | Error,
): MockedResponse<ProjectItemHistoryQueryVariables, ProjectItemHistoryQuery> {
  return {
    request: { query: ProjectItemHistoryDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectItemHistoryData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectItemCommitmentTabDataOptions {
  projectItem?: ProjectItem | ProjectItemOptions;
}

export function newProjectItemCommitmentTabData(
  data: ProjectItemCommitmentTabDataOptions,
): ProjectItemCommitmentTabQuery {
  return {
    __typename: "Query" as const,
    projectItem: maybeNew("ProjectItem", data["projectItem"] || undefined, {}),
  } as any;
}

export function newProjectItemCommitmentTabResponse(
  variables: ProjectItemCommitmentTabQueryVariables,
  data: ProjectItemCommitmentTabDataOptions | Error,
): MockedResponse<ProjectItemCommitmentTabQueryVariables, ProjectItemCommitmentTabQuery> {
  return {
    request: { query: ProjectItemCommitmentTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectItemCommitmentTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface OverviewTabDataOptions {
  currentInternalUser?: InternalUser | InternalUserOptions | null;
  projectItem?: ProjectItem | ProjectItemOptions;
  locations?: (Location | LocationOptions)[];
}

export function newOverviewTabData(data: OverviewTabDataOptions): OverviewTabQuery {
  return {
    __typename: "Query" as const,
    currentInternalUser: maybeNewOrNull("InternalUser", data["currentInternalUser"] || undefined, {}),
    projectItem: maybeNew("ProjectItem", data["projectItem"] || undefined, {}),
    locations: data["locations"]?.map((d) => newLocation(d)) || [],
  } as any;
}

export function newOverviewTabResponse(
  variables: OverviewTabQueryVariables,
  data: OverviewTabDataOptions | Error,
): MockedResponse<OverviewTabQueryVariables, OverviewTabQuery> {
  return {
    request: { query: OverviewTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newOverviewTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface OverviewTabScheduleTasksDataOptions {
  scheduleTasks?: (ScheduleTask | ScheduleTaskOptions)[];
}

export function newOverviewTabScheduleTasksData(
  data: OverviewTabScheduleTasksDataOptions,
): OverviewTabScheduleTasksQuery {
  return {
    __typename: "Query" as const,
    scheduleTasks: data["scheduleTasks"]?.map((d) => newScheduleTask(d)) || [],
  } as any;
}

export function newOverviewTabScheduleTasksResponse(
  variables: OverviewTabScheduleTasksQueryVariables,
  data: OverviewTabScheduleTasksDataOptions | Error,
): MockedResponse<OverviewTabScheduleTasksQueryVariables, OverviewTabScheduleTasksQuery> {
  return {
    request: { query: OverviewTabScheduleTasksDocument, variables },
    result: { data: data instanceof Error ? undefined : newOverviewTabScheduleTasksData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface OverviewTabSaveProjectItemDataOptions {
  saveProjectItems?: SaveProjectItemsResult | SaveProjectItemsResultOptions;
}

export function newOverviewTabSaveProjectItemData(
  data: OverviewTabSaveProjectItemDataOptions,
): OverviewTabSaveProjectItemMutation {
  return {
    __typename: "Mutation" as const,
    saveProjectItems: maybeNew("SaveProjectItemsResult", data["saveProjectItems"] || undefined, {}),
  } as any;
}

export function newOverviewTabSaveProjectItemResponse(
  variables: OverviewTabSaveProjectItemMutationVariables,
  data: OverviewTabSaveProjectItemDataOptions | Error,
): MockedResponse<OverviewTabSaveProjectItemMutationVariables, OverviewTabSaveProjectItemMutation> {
  return {
    request: { query: OverviewTabSaveProjectItemDocument, variables },
    result: { data: data instanceof Error ? undefined : newOverviewTabSaveProjectItemData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface OverviewTabDeleteProjectItemDataOptions {
  deleteProjectItem?: EmptyResult | EmptyResultOptions;
}

export function newOverviewTabDeleteProjectItemData(
  data: OverviewTabDeleteProjectItemDataOptions,
): OverviewTabDeleteProjectItemMutation {
  return {
    __typename: "Mutation" as const,
    deleteProjectItem: maybeNew("EmptyResult", data["deleteProjectItem"] || undefined, {}),
  } as any;
}

export function newOverviewTabDeleteProjectItemResponse(
  variables: OverviewTabDeleteProjectItemMutationVariables,
  data: OverviewTabDeleteProjectItemDataOptions | Error,
): MockedResponse<OverviewTabDeleteProjectItemMutationVariables, OverviewTabDeleteProjectItemMutation> {
  return {
    request: { query: OverviewTabDeleteProjectItemDocument, variables },
    result: { data: data instanceof Error ? undefined : newOverviewTabDeleteProjectItemData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteProjectItemDataOptions {
  deleteProjectItem?: EmptyResult | EmptyResultOptions;
}

export function newDeleteProjectItemData(data: DeleteProjectItemDataOptions): DeleteProjectItemMutation {
  return {
    __typename: "Mutation" as const,
    deleteProjectItem: maybeNew("EmptyResult", data["deleteProjectItem"] || undefined, {}),
  } as any;
}

export function newDeleteProjectItemResponse(
  variables: DeleteProjectItemMutationVariables,
  data: DeleteProjectItemDataOptions | Error,
): MockedResponse<DeleteProjectItemMutationVariables, DeleteProjectItemMutation> {
  return {
    request: { query: DeleteProjectItemDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteProjectItemData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SpecTabDataOptions {
  currentInternalUser?: InternalUser | InternalUserOptions | null;
  projectItem?: ProjectItem | ProjectItemOptions;
  locations?: (Location | LocationOptions)[];
  unitsOfMeasure?: (UnitOfMeasure | UnitOfMeasureOptions)[];
  costConfidences?: (CostConfidenceDetail | CostConfidenceDetailOptions)[];
}

export function newSpecTabData(data: SpecTabDataOptions): SpecTabQuery {
  return {
    __typename: "Query" as const,
    currentInternalUser: maybeNewOrNull("InternalUser", data["currentInternalUser"] || undefined, {}),
    projectItem: maybeNew("ProjectItem", data["projectItem"] || undefined, {}),
    locations: data["locations"]?.map((d) => newLocation(d)) || [],
    unitsOfMeasure: data["unitsOfMeasure"]?.map((d) => newUnitOfMeasure(d)) || [],
    costConfidences: data["costConfidences"]?.map((d) => newCostConfidenceDetail(d)) || [],
  } as any;
}

export function newSpecTabResponse(
  variables: SpecTabQueryVariables,
  data: SpecTabDataOptions | Error,
): MockedResponse<SpecTabQueryVariables, SpecTabQuery> {
  return {
    request: { query: SpecTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newSpecTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveProjectItemDetailsDataOptions {
  saveProjectItems?: SaveProjectItemsResult | SaveProjectItemsResultOptions;
}

export function newSaveProjectItemDetailsData(data: SaveProjectItemDetailsDataOptions): SaveProjectItemDetailsMutation {
  return {
    __typename: "Mutation" as const,
    saveProjectItems: maybeNew("SaveProjectItemsResult", data["saveProjectItems"] || undefined, {}),
  } as any;
}

export function newSaveProjectItemDetailsResponse(
  variables: SaveProjectItemDetailsMutationVariables,
  data: SaveProjectItemDetailsDataOptions | Error,
): MockedResponse<SaveProjectItemDetailsMutationVariables, SaveProjectItemDetailsMutation> {
  return {
    request: { query: SaveProjectItemDetailsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveProjectItemDetailsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SelectionsTabDataOptions {
  projectItem?: ProjectItem | ProjectItemOptions;
  potentialBidItems?: (BidItem | BidItemOptions)[];
  homeownerSelection?: HomeownerSelection | HomeownerSelectionOptions;
}

export function newSelectionsTabData(data: SelectionsTabDataOptions): SelectionsTabQuery {
  return {
    __typename: "Query" as const,
    projectItem: maybeNew("ProjectItem", data["projectItem"] || undefined, {}),
    potentialBidItems: data["potentialBidItems"]?.map((d) => newBidItem(d)) || [],
    homeownerSelection: maybeNew("HomeownerSelection", data["homeownerSelection"] || undefined, {}),
  } as any;
}

export function newSelectionsTabResponse(
  variables: SelectionsTabQueryVariables,
  data: SelectionsTabDataOptions | Error,
): MockedResponse<SelectionsTabQueryVariables, SelectionsTabQuery> {
  return {
    request: { query: SelectionsTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newSelectionsTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SelectionsTabSaveCeliDataOptions {
  saveChangeEventLineItems?: SaveChangeEventLineItemsResult | SaveChangeEventLineItemsResultOptions;
}

export function newSelectionsTabSaveCeliData(data: SelectionsTabSaveCeliDataOptions): SelectionsTabSaveCeliMutation {
  return {
    __typename: "Mutation" as const,
    saveChangeEventLineItems: maybeNew(
      "SaveChangeEventLineItemsResult",
      data["saveChangeEventLineItems"] || undefined,
      {},
    ),
  } as any;
}

export function newSelectionsTabSaveCeliResponse(
  variables: SelectionsTabSaveCeliMutationVariables,
  data: SelectionsTabSaveCeliDataOptions | Error,
): MockedResponse<SelectionsTabSaveCeliMutationVariables, SelectionsTabSaveCeliMutation> {
  return {
    request: { query: SelectionsTabSaveCeliDocument, variables },
    result: { data: data instanceof Error ? undefined : newSelectionsTabSaveCeliData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CheckoutSettingsTab_CommunityDataOptions {
  community?: Community | CommunityOptions;
}

export function newCheckoutSettingsTab_CommunityData(
  data: CheckoutSettingsTab_CommunityDataOptions,
): CheckoutSettingsTab_CommunityQuery {
  return { __typename: "Query" as const, community: maybeNew("Community", data["community"] || undefined, {}) } as any;
}

export function newCheckoutSettingsTab_CommunityResponse(
  variables: CheckoutSettingsTab_CommunityQueryVariables,
  data: CheckoutSettingsTab_CommunityDataOptions | Error,
): MockedResponse<CheckoutSettingsTab_CommunityQueryVariables, CheckoutSettingsTab_CommunityQuery> {
  return {
    request: { query: CheckoutSettingsTab_CommunityDocument, variables },
    result: { data: data instanceof Error ? undefined : newCheckoutSettingsTab_CommunityData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveCommunitySettingsDataOptions {
  saveCommunity?: SaveCommunityResult | SaveCommunityResultOptions;
}

export function newSaveCommunitySettingsData(data: SaveCommunitySettingsDataOptions): SaveCommunitySettingsMutation {
  return {
    __typename: "Mutation" as const,
    saveCommunity: maybeNew("SaveCommunityResult", data["saveCommunity"] || undefined, {}),
  } as any;
}

export function newSaveCommunitySettingsResponse(
  variables: SaveCommunitySettingsMutationVariables,
  data: SaveCommunitySettingsDataOptions | Error,
): MockedResponse<SaveCommunitySettingsMutationVariables, SaveCommunitySettingsMutation> {
  return {
    request: { query: SaveCommunitySettingsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveCommunitySettingsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CheckoutSettingsTab_StructureDataOptions {
  structure?: Structure | StructureOptions;
}

export function newCheckoutSettingsTab_StructureData(
  data: CheckoutSettingsTab_StructureDataOptions,
): CheckoutSettingsTab_StructureQuery {
  return { __typename: "Query" as const, structure: maybeNew("Structure", data["structure"] || undefined, {}) } as any;
}

export function newCheckoutSettingsTab_StructureResponse(
  variables: CheckoutSettingsTab_StructureQueryVariables,
  data: CheckoutSettingsTab_StructureDataOptions | Error,
): MockedResponse<CheckoutSettingsTab_StructureQueryVariables, CheckoutSettingsTab_StructureQuery> {
  return {
    request: { query: CheckoutSettingsTab_StructureDocument, variables },
    result: { data: data instanceof Error ? undefined : newCheckoutSettingsTab_StructureData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CheckoutSettingsTab_ProductOfferingOptionsDataOptions {
  productOffering?: ProductOffering | ProductOfferingOptions;
}

export function newCheckoutSettingsTab_ProductOfferingOptionsData(
  data: CheckoutSettingsTab_ProductOfferingOptionsDataOptions,
): CheckoutSettingsTab_ProductOfferingOptionsQuery {
  return {
    __typename: "Query" as const,
    productOffering: maybeNew("ProductOffering", data["productOffering"] || undefined, {}),
  } as any;
}

export function newCheckoutSettingsTab_ProductOfferingOptionsResponse(
  variables: CheckoutSettingsTab_ProductOfferingOptionsQueryVariables,
  data: CheckoutSettingsTab_ProductOfferingOptionsDataOptions | Error,
): MockedResponse<
  CheckoutSettingsTab_ProductOfferingOptionsQueryVariables,
  CheckoutSettingsTab_ProductOfferingOptionsQuery
> {
  return {
    request: { query: CheckoutSettingsTab_ProductOfferingOptionsDocument, variables },
    result: { data: data instanceof Error ? undefined : newCheckoutSettingsTab_ProductOfferingOptionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveStructureSettingsDataOptions {
  saveStructure?: SaveStructureResult | SaveStructureResultOptions;
}

export function newSaveStructureSettingsData(data: SaveStructureSettingsDataOptions): SaveStructureSettingsMutation {
  return {
    __typename: "Mutation" as const,
    saveStructure: maybeNew("SaveStructureResult", data["saveStructure"] || undefined, {}),
  } as any;
}

export function newSaveStructureSettingsResponse(
  variables: SaveStructureSettingsMutationVariables,
  data: SaveStructureSettingsDataOptions | Error,
): MockedResponse<SaveStructureSettingsMutationVariables, SaveStructureSettingsMutation> {
  return {
    request: { query: SaveStructureSettingsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveStructureSettingsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CheckoutSettingsTab_LotDataOptions {
  lot?: Lot | LotOptions;
}

export function newCheckoutSettingsTab_LotData(data: CheckoutSettingsTab_LotDataOptions): CheckoutSettingsTab_LotQuery {
  return { __typename: "Query" as const, lot: maybeNew("Lot", data["lot"] || undefined, {}) } as any;
}

export function newCheckoutSettingsTab_LotResponse(
  variables: CheckoutSettingsTab_LotQueryVariables,
  data: CheckoutSettingsTab_LotDataOptions | Error,
): MockedResponse<CheckoutSettingsTab_LotQueryVariables, CheckoutSettingsTab_LotQuery> {
  return {
    request: { query: CheckoutSettingsTab_LotDocument, variables },
    result: { data: data instanceof Error ? undefined : newCheckoutSettingsTab_LotData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveLotSettingsDataOptions {
  saveLot?: SaveLotResult | SaveLotResultOptions;
}

export function newSaveLotSettingsData(data: SaveLotSettingsDataOptions): SaveLotSettingsMutation {
  return {
    __typename: "Mutation" as const,
    saveLot: maybeNew("SaveLotResult", data["saveLot"] || undefined, {}),
  } as any;
}

export function newSaveLotSettingsResponse(
  variables: SaveLotSettingsMutationVariables,
  data: SaveLotSettingsDataOptions | Error,
): MockedResponse<SaveLotSettingsMutationVariables, SaveLotSettingsMutation> {
  return {
    request: { query: SaveLotSettingsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveLotSettingsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CommunityStageOrderDataOptions {
  community?: Community | CommunityOptions;
  globalPlanStages?: (GlobalPlanStage | GlobalPlanStageOptions)[];
}

export function newCommunityStageOrderData(data: CommunityStageOrderDataOptions): CommunityStageOrderQuery {
  return {
    __typename: "Query" as const,
    community: maybeNew("Community", data["community"] || undefined, {}),
    globalPlanStages: data["globalPlanStages"]?.map((d) => newGlobalPlanStage(d)) || [],
  } as any;
}

export function newCommunityStageOrderResponse(
  variables: CommunityStageOrderQueryVariables,
  data: CommunityStageOrderDataOptions | Error,
): MockedResponse<CommunityStageOrderQueryVariables, CommunityStageOrderQuery> {
  return {
    request: { query: CommunityStageOrderDocument, variables },
    result: { data: data instanceof Error ? undefined : newCommunityStageOrderData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveGlobalPlanStageVariantsDataOptions {
  saveGlobalPlanStageVariants?: SaveGlobalPlanStageVariantsResult | SaveGlobalPlanStageVariantsResultOptions;
}

export function newSaveGlobalPlanStageVariantsData(
  data: SaveGlobalPlanStageVariantsDataOptions,
): SaveGlobalPlanStageVariantsMutation {
  return {
    __typename: "Mutation" as const,
    saveGlobalPlanStageVariants: maybeNew(
      "SaveGlobalPlanStageVariantsResult",
      data["saveGlobalPlanStageVariants"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveGlobalPlanStageVariantsResponse(
  variables: SaveGlobalPlanStageVariantsMutationVariables,
  data: SaveGlobalPlanStageVariantsDataOptions | Error,
): MockedResponse<SaveGlobalPlanStageVariantsMutationVariables, SaveGlobalPlanStageVariantsMutation> {
  return {
    request: { query: SaveGlobalPlanStageVariantsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveGlobalPlanStageVariantsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SpecsAndSelectionItemsDataOptions {
  project?: Project | ProjectOptions;
  unitsOfMeasure?: (UnitOfMeasure | UnitOfMeasureOptions)[];
  costCodes?: (CostCode | CostCodeOptions)[];
  costConfidences?: (CostConfidenceDetail | CostConfidenceDetailOptions)[];
  locations?: (Location | LocationOptions)[];
  scheduleTasks?: (ScheduleTask | ScheduleTaskOptions)[];
}

export function newSpecsAndSelectionItemsData(data: SpecsAndSelectionItemsDataOptions): SpecsAndSelectionItemsQuery {
  return {
    __typename: "Query" as const,
    project: maybeNew("Project", data["project"] || undefined, {}),
    unitsOfMeasure: data["unitsOfMeasure"]?.map((d) => newUnitOfMeasure(d)) || [],
    costCodes: data["costCodes"]?.map((d) => newCostCode(d)) || [],
    costConfidences: data["costConfidences"]?.map((d) => newCostConfidenceDetail(d)) || [],
    locations: data["locations"]?.map((d) => newLocation(d)) || [],
    scheduleTasks: data["scheduleTasks"]?.map((d) => newScheduleTask(d)) || [],
  } as any;
}

export function newSpecsAndSelectionItemsResponse(
  variables: SpecsAndSelectionItemsQueryVariables,
  data: SpecsAndSelectionItemsDataOptions | Error,
): MockedResponse<SpecsAndSelectionItemsQueryVariables, SpecsAndSelectionItemsQuery> {
  return {
    request: { query: SpecsAndSelectionItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSpecsAndSelectionItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SpecsAndSelectionsRouteHandlerDataOptions {
  projectItem?: ProjectItem | ProjectItemOptions;
}

export function newSpecsAndSelectionsRouteHandlerData(
  data: SpecsAndSelectionsRouteHandlerDataOptions,
): SpecsAndSelectionsRouteHandlerQuery {
  return {
    __typename: "Query" as const,
    projectItem: maybeNew("ProjectItem", data["projectItem"] || undefined, {}),
  } as any;
}

export function newSpecsAndSelectionsRouteHandlerResponse(
  variables: SpecsAndSelectionsRouteHandlerQueryVariables,
  data: SpecsAndSelectionsRouteHandlerDataOptions | Error,
): MockedResponse<SpecsAndSelectionsRouteHandlerQueryVariables, SpecsAndSelectionsRouteHandlerQuery> {
  return {
    request: { query: SpecsAndSelectionsRouteHandlerDocument, variables },
    result: { data: data instanceof Error ? undefined : newSpecsAndSelectionsRouteHandlerData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteProjectItemsDataOptions {
  deleteProjectItems?: EmptyResult | EmptyResultOptions;
}

export function newDeleteProjectItemsData(data: DeleteProjectItemsDataOptions): DeleteProjectItemsMutation {
  return {
    __typename: "Mutation" as const,
    deleteProjectItems: maybeNew("EmptyResult", data["deleteProjectItems"] || undefined, {}),
  } as any;
}

export function newDeleteProjectItemsResponse(
  variables: DeleteProjectItemsMutationVariables,
  data: DeleteProjectItemsDataOptions | Error,
): MockedResponse<DeleteProjectItemsMutationVariables, DeleteProjectItemsMutation> {
  return {
    request: { query: DeleteProjectItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteProjectItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveProjectItemsDataOptions {
  saveProjectItems?: SaveProjectItemsResult | SaveProjectItemsResultOptions;
}

export function newSaveProjectItemsData(data: SaveProjectItemsDataOptions): SaveProjectItemsMutation {
  return {
    __typename: "Mutation" as const,
    saveProjectItems: maybeNew("SaveProjectItemsResult", data["saveProjectItems"] || undefined, {}),
  } as any;
}

export function newSaveProjectItemsResponse(
  variables: SaveProjectItemsMutationVariables,
  data: SaveProjectItemsDataOptions | Error,
): MockedResponse<SaveProjectItemsMutationVariables, SaveProjectItemsMutation> {
  return {
    request: { query: SaveProjectItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveProjectItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DuplicateProjectItemsDataOptions {
  duplicateProjectItems?: DuplicateProjectItemsResult | DuplicateProjectItemsResultOptions;
}

export function newDuplicateProjectItemsData(data: DuplicateProjectItemsDataOptions): DuplicateProjectItemsMutation {
  return {
    __typename: "Mutation" as const,
    duplicateProjectItems: maybeNew("DuplicateProjectItemsResult", data["duplicateProjectItems"] || undefined, {}),
  } as any;
}

export function newDuplicateProjectItemsResponse(
  variables: DuplicateProjectItemsMutationVariables,
  data: DuplicateProjectItemsDataOptions | Error,
): MockedResponse<DuplicateProjectItemsMutationVariables, DuplicateProjectItemsMutation> {
  return {
    request: { query: DuplicateProjectItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newDuplicateProjectItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ApplyItemTemplateDataOptions {
  applyItemTemplate?: ApplyItemTemplateResult | ApplyItemTemplateResultOptions;
}

export function newApplyItemTemplateData(data: ApplyItemTemplateDataOptions): ApplyItemTemplateMutation {
  return {
    __typename: "Mutation" as const,
    applyItemTemplate: maybeNew("ApplyItemTemplateResult", data["applyItemTemplate"] || undefined, {}),
  } as any;
}

export function newApplyItemTemplateResponse(
  variables: ApplyItemTemplateMutationVariables,
  data: ApplyItemTemplateDataOptions | Error,
): MockedResponse<ApplyItemTemplateMutationVariables, ApplyItemTemplateMutation> {
  return {
    request: { query: ApplyItemTemplateDocument, variables },
    result: { data: data instanceof Error ? undefined : newApplyItemTemplateData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddProjectItemDataOptions {
  saveProjectItems?: SaveProjectItemsResult | SaveProjectItemsResultOptions;
}

export function newAddProjectItemData(data: AddProjectItemDataOptions): AddProjectItemMutation {
  return {
    __typename: "Mutation" as const,
    saveProjectItems: maybeNew("SaveProjectItemsResult", data["saveProjectItems"] || undefined, {}),
  } as any;
}

export function newAddProjectItemResponse(
  variables: AddProjectItemMutationVariables,
  data: AddProjectItemDataOptions | Error,
): MockedResponse<AddProjectItemMutationVariables, AddProjectItemMutation> {
  return {
    request: { query: AddProjectItemDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddProjectItemData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveProjectOverallTabDataOptions {
  saveProject?: SaveProjectResult | SaveProjectResultOptions;
}

export function newSaveProjectOverallTabData(data: SaveProjectOverallTabDataOptions): SaveProjectOverallTabMutation {
  return {
    __typename: "Mutation" as const,
    saveProject: maybeNew("SaveProjectResult", data["saveProject"] || undefined, {}),
  } as any;
}

export function newSaveProjectOverallTabResponse(
  variables: SaveProjectOverallTabMutationVariables,
  data: SaveProjectOverallTabDataOptions | Error,
): MockedResponse<SaveProjectOverallTabMutationVariables, SaveProjectOverallTabMutation> {
  return {
    request: { query: SaveProjectOverallTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveProjectOverallTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectStatusChangeReasonsDataOptions {
  projectStatusChangeReasons?: (ProjectStatusChangeReason | ProjectStatusChangeReasonOptions)[];
}

export function newProjectStatusChangeReasonsData(
  data: ProjectStatusChangeReasonsDataOptions,
): ProjectStatusChangeReasonsQuery {
  return {
    __typename: "Query" as const,
    projectStatusChangeReasons: data["projectStatusChangeReasons"]?.map((d) => newProjectStatusChangeReason(d)) || [],
  } as any;
}

export function newProjectStatusChangeReasonsResponse(
  variables: ProjectStatusChangeReasonsQueryVariables,
  data: ProjectStatusChangeReasonsDataOptions | Error,
): MockedResponse<ProjectStatusChangeReasonsQueryVariables, ProjectStatusChangeReasonsQuery> {
  return {
    request: { query: ProjectStatusChangeReasonsDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectStatusChangeReasonsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface OverallTabDataOptions {
  project?: Project | ProjectOptions;
  stages?: (StageDetail | StageDetailOptions)[];
  cohorts?: (Cohort | CohortOptions)[];
}

export function newOverallTabData(data: OverallTabDataOptions): OverallTabQuery {
  return {
    __typename: "Query" as const,
    project: maybeNew("Project", data["project"] || undefined, {}),
    stages: data["stages"]?.map((d) => newStageDetail(d)) || [],
    cohorts: data["cohorts"]?.map((d) => newCohort(d)) || [],
  } as any;
}

export function newOverallTabResponse(
  variables: OverallTabQueryVariables,
  data: OverallTabDataOptions | Error,
): MockedResponse<OverallTabQueryVariables, OverallTabQuery> {
  return {
    request: { query: OverallTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newOverallTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface HomeownersTabDataOptions {
  project?: Project | ProjectOptions;
}

export function newHomeownersTabData(data: HomeownersTabDataOptions): HomeownersTabQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newHomeownersTabResponse(
  variables: HomeownersTabQueryVariables,
  data: HomeownersTabDataOptions | Error,
): MockedResponse<HomeownersTabQueryVariables, HomeownersTabQuery> {
  return {
    request: { query: HomeownersTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newHomeownersTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SendInviteEmailDataOptions {
  sendInviteEmail?: SendInviteEmailResult | SendInviteEmailResultOptions;
}

export function newSendInviteEmailData(data: SendInviteEmailDataOptions): SendInviteEmailMutation {
  return {
    __typename: "Mutation" as const,
    sendInviteEmail: maybeNew("SendInviteEmailResult", data["sendInviteEmail"] || undefined, {}),
  } as any;
}

export function newSendInviteEmailResponse(
  variables: SendInviteEmailMutationVariables,
  data: SendInviteEmailDataOptions | Error,
): MockedResponse<SendInviteEmailMutationVariables, SendInviteEmailMutation> {
  return {
    request: { query: SendInviteEmailDocument, variables },
    result: { data: data instanceof Error ? undefined : newSendInviteEmailData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteProjectCollaboratorDataOptions {
  deleteProjectCollaborator?: EmptyResult | EmptyResultOptions;
}

export function newDeleteProjectCollaboratorData(
  data: DeleteProjectCollaboratorDataOptions,
): DeleteProjectCollaboratorMutation {
  return {
    __typename: "Mutation" as const,
    deleteProjectCollaborator: maybeNew("EmptyResult", data["deleteProjectCollaborator"] || undefined, {}),
  } as any;
}

export function newDeleteProjectCollaboratorResponse(
  variables: DeleteProjectCollaboratorMutationVariables,
  data: DeleteProjectCollaboratorDataOptions | Error,
): MockedResponse<DeleteProjectCollaboratorMutationVariables, DeleteProjectCollaboratorMutation> {
  return {
    request: { query: DeleteProjectCollaboratorDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteProjectCollaboratorData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveProjectCollaboratorDataOptions {
  saveProjectCollaborator?: EmptyResult | EmptyResultOptions;
}

export function newSaveProjectCollaboratorData(
  data: SaveProjectCollaboratorDataOptions,
): SaveProjectCollaboratorMutation {
  return {
    __typename: "Mutation" as const,
    saveProjectCollaborator: maybeNew("EmptyResult", data["saveProjectCollaborator"] || undefined, {}),
  } as any;
}

export function newSaveProjectCollaboratorResponse(
  variables: SaveProjectCollaboratorMutationVariables,
  data: SaveProjectCollaboratorDataOptions | Error,
): MockedResponse<SaveProjectCollaboratorMutationVariables, SaveProjectCollaboratorMutation> {
  return {
    request: { query: SaveProjectCollaboratorDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveProjectCollaboratorData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SetUpTabDataOptions {
  project?: Project | ProjectOptions;
  productTypes?: (ProductType | ProductTypeOptions)[];
  lotRatings?: (LotRating | LotRatingOptions)[];
  preconContractTypes?: (PreconContractType | PreconContractTypeOptions)[];
  readyPlans?: (ReadyPlan | ReadyPlanOptions)[];
  enumDetails?: AllEnumDetails | AllEnumDetailsOptions;
}

export function newSetUpTabData(data: SetUpTabDataOptions): SetUpTabQuery {
  return {
    __typename: "Query" as const,
    project: maybeNew("Project", data["project"] || undefined, {}),
    productTypes: data["productTypes"]?.map((d) => newProductType(d)) || [],
    lotRatings: data["lotRatings"]?.map((d) => newLotRating(d)) || [],
    preconContractTypes: data["preconContractTypes"]?.map((d) => newPreconContractType(d)) || [],
    readyPlans: data["readyPlans"]?.map((d) => newReadyPlan(d)) || [],
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
  } as any;
}

export function newSetUpTabResponse(
  variables: SetUpTabQueryVariables,
  data: SetUpTabDataOptions | Error,
): MockedResponse<SetUpTabQueryVariables, SetUpTabQuery> {
  return {
    request: { query: SetUpTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newSetUpTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveProjectSetUpTabDataOptions {
  saveProject?: SaveProjectResult | SaveProjectResultOptions;
}

export function newSaveProjectSetUpTabData(data: SaveProjectSetUpTabDataOptions): SaveProjectSetUpTabMutation {
  return {
    __typename: "Mutation" as const,
    saveProject: maybeNew("SaveProjectResult", data["saveProject"] || undefined, {}),
  } as any;
}

export function newSaveProjectSetUpTabResponse(
  variables: SaveProjectSetUpTabMutationVariables,
  data: SaveProjectSetUpTabDataOptions | Error,
): MockedResponse<SaveProjectSetUpTabMutationVariables, SaveProjectSetUpTabMutation> {
  return {
    request: { query: SaveProjectSetUpTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveProjectSetUpTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveStructureSetUpTabDataOptions {
  saveStructure?: SaveStructureResult | SaveStructureResultOptions;
}

export function newSaveStructureSetUpTabData(data: SaveStructureSetUpTabDataOptions): SaveStructureSetUpTabMutation {
  return {
    __typename: "Mutation" as const,
    saveStructure: maybeNew("SaveStructureResult", data["saveStructure"] || undefined, {}),
  } as any;
}

export function newSaveStructureSetUpTabResponse(
  variables: SaveStructureSetUpTabMutationVariables,
  data: SaveStructureSetUpTabDataOptions | Error,
): MockedResponse<SaveStructureSetUpTabMutationVariables, SaveStructureSetUpTabMutation> {
  return {
    request: { query: SaveStructureSetUpTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveStructureSetUpTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScheduleTabDataOptions {
  schedules?: (Schedule | ScheduleOptions)[];
}

export function newScheduleTabData(data: ScheduleTabDataOptions): ScheduleTabQuery {
  return { __typename: "Query" as const, schedules: data["schedules"]?.map((d) => newSchedule(d)) || [] } as any;
}

export function newScheduleTabResponse(
  variables: ScheduleTabQueryVariables,
  data: ScheduleTabDataOptions | Error,
): MockedResponse<ScheduleTabQueryVariables, ScheduleTabQuery> {
  return {
    request: { query: ScheduleTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newScheduleTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanScheduleTabDataOptions {
  project?: Project | ProjectOptions;
}

export function newPlanScheduleTabData(data: PlanScheduleTabDataOptions): PlanScheduleTabQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newPlanScheduleTabResponse(
  variables: PlanScheduleTabQueryVariables,
  data: PlanScheduleTabDataOptions | Error,
): MockedResponse<PlanScheduleTabQueryVariables, PlanScheduleTabQuery> {
  return {
    request: { query: PlanScheduleTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanScheduleTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveScheduleSettingsDataOptions {
  saveScheduleSettings?: SaveScheduleSettingsResult | SaveScheduleSettingsResultOptions;
}

export function newSaveScheduleSettingsData(data: SaveScheduleSettingsDataOptions): SaveScheduleSettingsMutation {
  return {
    __typename: "Mutation" as const,
    saveScheduleSettings: maybeNew("SaveScheduleSettingsResult", data["saveScheduleSettings"] || undefined, {}),
  } as any;
}

export function newSaveScheduleSettingsResponse(
  variables: SaveScheduleSettingsMutationVariables,
  data: SaveScheduleSettingsDataOptions | Error,
): MockedResponse<SaveScheduleSettingsMutationVariables, SaveScheduleSettingsMutation> {
  return {
    request: { query: SaveScheduleSettingsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveScheduleSettingsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SavePlanScheduleSettingsDataOptions {
  savePlanSchedule?: SavePlanScheduleResult | SavePlanScheduleResultOptions;
}

export function newSavePlanScheduleSettingsData(
  data: SavePlanScheduleSettingsDataOptions,
): SavePlanScheduleSettingsMutation {
  return {
    __typename: "Mutation" as const,
    savePlanSchedule: maybeNew("SavePlanScheduleResult", data["savePlanSchedule"] || undefined, {}),
  } as any;
}

export function newSavePlanScheduleSettingsResponse(
  variables: SavePlanScheduleSettingsMutationVariables,
  data: SavePlanScheduleSettingsDataOptions | Error,
): MockedResponse<SavePlanScheduleSettingsMutationVariables, SavePlanScheduleSettingsMutation> {
  return {
    request: { query: SavePlanScheduleSettingsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSavePlanScheduleSettingsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveScheduleRemindersDataOptions {
  saveSchedule?: SaveScheduleResult | SaveScheduleResultOptions;
}

export function newSaveScheduleRemindersData(data: SaveScheduleRemindersDataOptions): SaveScheduleRemindersMutation {
  return {
    __typename: "Mutation" as const,
    saveSchedule: maybeNew("SaveScheduleResult", data["saveSchedule"] || undefined, {}),
  } as any;
}

export function newSaveScheduleRemindersResponse(
  variables: SaveScheduleRemindersMutationVariables,
  data: SaveScheduleRemindersDataOptions | Error,
): MockedResponse<SaveScheduleRemindersMutationVariables, SaveScheduleRemindersMutation> {
  return {
    request: { query: SaveScheduleRemindersDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveScheduleRemindersData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ItemTemplateImportModalDataOptions {
  costTypes?: (CostTypeDetail | CostTypeDetailOptions)[];
  unitsOfMeasure?: (UnitOfMeasure | UnitOfMeasureOptions)[];
  locations?: (Location | LocationOptions)[];
  items?: (Item | ItemOptions)[];
  itemTemplate?: ItemTemplate | ItemTemplateOptions;
}

export function newItemTemplateImportModalData(data: ItemTemplateImportModalDataOptions): ItemTemplateImportModalQuery {
  return {
    __typename: "Query" as const,
    costTypes: data["costTypes"]?.map((d) => newCostTypeDetail(d)) || [],
    unitsOfMeasure: data["unitsOfMeasure"]?.map((d) => newUnitOfMeasure(d)) || [],
    locations: data["locations"]?.map((d) => newLocation(d)) || [],
    items: data["items"]?.map((d) => newItem(d)) || [],
    itemTemplate: maybeNew("ItemTemplate", data["itemTemplate"] || undefined, {}),
  } as any;
}

export function newItemTemplateImportModalResponse(
  variables: ItemTemplateImportModalQueryVariables,
  data: ItemTemplateImportModalDataOptions | Error,
): MockedResponse<ItemTemplateImportModalQueryVariables, ItemTemplateImportModalQuery> {
  return {
    request: { query: ItemTemplateImportModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newItemTemplateImportModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TeamMembersDataOptions {
  project?: Project | ProjectOptions;
}

export function newTeamMembersData(data: TeamMembersDataOptions): TeamMembersQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newTeamMembersResponse(
  variables: TeamMembersQueryVariables,
  data: TeamMembersDataOptions | Error,
): MockedResponse<TeamMembersQueryVariables, TeamMembersQuery> {
  return {
    request: { query: TeamMembersDocument, variables },
    result: { data: data instanceof Error ? undefined : newTeamMembersData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AvailableAssigneesDataOptions {
  project?: Project | ProjectOptions;
}

export function newAvailableAssigneesData(data: AvailableAssigneesDataOptions): AvailableAssigneesQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newAvailableAssigneesResponse(
  variables: AvailableAssigneesQueryVariables,
  data: AvailableAssigneesDataOptions | Error,
): MockedResponse<AvailableAssigneesQueryVariables, AvailableAssigneesQuery> {
  return {
    request: { query: AvailableAssigneesDocument, variables },
    result: { data: data instanceof Error ? undefined : newAvailableAssigneesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface UpdateProjectRoleDataOptions {
  updateProjectRole?: UpdateProjectRoleResult | UpdateProjectRoleResultOptions;
}

export function newUpdateProjectRoleData(data: UpdateProjectRoleDataOptions): UpdateProjectRoleMutation {
  return {
    __typename: "Mutation" as const,
    updateProjectRole: maybeNew("UpdateProjectRoleResult", data["updateProjectRole"] || undefined, {}),
  } as any;
}

export function newUpdateProjectRoleResponse(
  variables: UpdateProjectRoleMutationVariables,
  data: UpdateProjectRoleDataOptions | Error,
): MockedResponse<UpdateProjectRoleMutationVariables, UpdateProjectRoleMutation> {
  return {
    request: { query: UpdateProjectRoleDocument, variables },
    result: { data: data instanceof Error ? undefined : newUpdateProjectRoleData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ItemTemplateLineItemsTabDataOptions {
  itemTemplate?: ItemTemplate | ItemTemplateOptions;
  unitsOfMeasure?: (UnitOfMeasure | UnitOfMeasureOptions)[];
  locations?: (Location | LocationOptions)[];
  costCodes?: (CostCode | CostCodeOptions)[];
}

export function newItemTemplateLineItemsTabData(
  data: ItemTemplateLineItemsTabDataOptions,
): ItemTemplateLineItemsTabQuery {
  return {
    __typename: "Query" as const,
    itemTemplate: maybeNew("ItemTemplate", data["itemTemplate"] || undefined, {}),
    unitsOfMeasure: data["unitsOfMeasure"]?.map((d) => newUnitOfMeasure(d)) || [],
    locations: data["locations"]?.map((d) => newLocation(d)) || [],
    costCodes: data["costCodes"]?.map((d) => newCostCode(d)) || [],
  } as any;
}

export function newItemTemplateLineItemsTabResponse(
  variables: ItemTemplateLineItemsTabQueryVariables,
  data: ItemTemplateLineItemsTabDataOptions | Error,
): MockedResponse<ItemTemplateLineItemsTabQueryVariables, ItemTemplateLineItemsTabQuery> {
  return {
    request: { query: ItemTemplateLineItemsTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newItemTemplateLineItemsTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ItemTemplateItemVersionsPage_GroupsDataOptions {
  itemTemplateItemVersionsPage?: ItemTemplateItemVersionsPage | ItemTemplateItemVersionsPageOptions;
}

export function newItemTemplateItemVersionsPage_GroupsData(
  data: ItemTemplateItemVersionsPage_GroupsDataOptions,
): ItemTemplateItemVersionsPage_GroupsQuery {
  return {
    __typename: "Query" as const,
    itemTemplateItemVersionsPage: maybeNew(
      "ItemTemplateItemVersionsPage",
      data["itemTemplateItemVersionsPage"] || undefined,
      {},
    ),
  } as any;
}

export function newItemTemplateItemVersionsPage_GroupsResponse(
  variables: ItemTemplateItemVersionsPage_GroupsQueryVariables,
  data: ItemTemplateItemVersionsPage_GroupsDataOptions | Error,
): MockedResponse<ItemTemplateItemVersionsPage_GroupsQueryVariables, ItemTemplateItemVersionsPage_GroupsQuery> {
  return {
    request: { query: ItemTemplateItemVersionsPage_GroupsDocument, variables },
    result: { data: data instanceof Error ? undefined : newItemTemplateItemVersionsPage_GroupsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ItemTemplateItemVersionsPageDataOptions {
  itemTemplateItemVersionsPage?: ItemTemplateItemVersionsPage | ItemTemplateItemVersionsPageOptions;
}

export function newItemTemplateItemVersionsPageData(
  data: ItemTemplateItemVersionsPageDataOptions,
): ItemTemplateItemVersionsPageQuery {
  return {
    __typename: "Query" as const,
    itemTemplateItemVersionsPage: maybeNew(
      "ItemTemplateItemVersionsPage",
      data["itemTemplateItemVersionsPage"] || undefined,
      {},
    ),
  } as any;
}

export function newItemTemplateItemVersionsPageResponse(
  variables: ItemTemplateItemVersionsPageQueryVariables,
  data: ItemTemplateItemVersionsPageDataOptions | Error,
): MockedResponse<ItemTemplateItemVersionsPageQueryVariables, ItemTemplateItemVersionsPageQuery> {
  return {
    request: { query: ItemTemplateItemVersionsPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newItemTemplateItemVersionsPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddItemsFromExistingTemplateDataOptions {
  itemTemplate?: ItemTemplate | ItemTemplateOptions;
}

export function newAddItemsFromExistingTemplateData(
  data: AddItemsFromExistingTemplateDataOptions,
): AddItemsFromExistingTemplateQuery {
  return {
    __typename: "Query" as const,
    itemTemplate: maybeNew("ItemTemplate", data["itemTemplate"] || undefined, {}),
  } as any;
}

export function newAddItemsFromExistingTemplateResponse(
  variables: AddItemsFromExistingTemplateQueryVariables,
  data: AddItemsFromExistingTemplateDataOptions | Error,
): MockedResponse<AddItemsFromExistingTemplateQueryVariables, AddItemsFromExistingTemplateQuery> {
  return {
    request: { query: AddItemsFromExistingTemplateDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddItemsFromExistingTemplateData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ItemTemplatesDataOptions {
  itemTemplates?: (ItemTemplate | ItemTemplateOptions)[];
}

export function newItemTemplatesData(data: ItemTemplatesDataOptions): ItemTemplatesQuery {
  return {
    __typename: "Query" as const,
    itemTemplates: data["itemTemplates"]?.map((d) => newItemTemplate(d)) || [],
  } as any;
}

export function newItemTemplatesResponse(
  variables: ItemTemplatesQueryVariables,
  data: ItemTemplatesDataOptions | Error,
): MockedResponse<ItemTemplatesQueryVariables, ItemTemplatesQuery> {
  return {
    request: { query: ItemTemplatesDocument, variables },
    result: { data: data instanceof Error ? undefined : newItemTemplatesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveItemTemplateDataOptions {
  saveItemTemplate?: SaveItemTemplateResult | SaveItemTemplateResultOptions;
}

export function newSaveItemTemplateData(data: SaveItemTemplateDataOptions): SaveItemTemplateMutation {
  return {
    __typename: "Mutation" as const,
    saveItemTemplate: maybeNew("SaveItemTemplateResult", data["saveItemTemplate"] || undefined, {}),
  } as any;
}

export function newSaveItemTemplateResponse(
  variables: SaveItemTemplateMutationVariables,
  data: SaveItemTemplateDataOptions | Error,
): MockedResponse<SaveItemTemplateMutationVariables, SaveItemTemplateMutation> {
  return {
    request: { query: SaveItemTemplateDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveItemTemplateData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ItemTemplatesDevelopmentsDataOptions {
  developments?: (Development | DevelopmentOptions)[];
}

export function newItemTemplatesDevelopmentsData(
  data: ItemTemplatesDevelopmentsDataOptions,
): ItemTemplatesDevelopmentsQuery {
  return {
    __typename: "Query" as const,
    developments: data["developments"]?.map((d) => newDevelopment(d)) || [],
  } as any;
}

export function newItemTemplatesDevelopmentsResponse(
  variables: ItemTemplatesDevelopmentsQueryVariables,
  data: ItemTemplatesDevelopmentsDataOptions | Error,
): MockedResponse<ItemTemplatesDevelopmentsQueryVariables, ItemTemplatesDevelopmentsQuery> {
  return {
    request: { query: ItemTemplatesDevelopmentsDocument, variables },
    result: { data: data instanceof Error ? undefined : newItemTemplatesDevelopmentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ItemTemplateItemDetailDataOptions {
  items?: (Item | ItemOptions)[];
  locations?: (Location | LocationOptions)[];
  unitsOfMeasure?: (UnitOfMeasure | UnitOfMeasureOptions)[];
}

export function newItemTemplateItemDetailData(data: ItemTemplateItemDetailDataOptions): ItemTemplateItemDetailQuery {
  return {
    __typename: "Query" as const,
    items: data["items"]?.map((d) => newItem(d)) || [],
    locations: data["locations"]?.map((d) => newLocation(d)) || [],
    unitsOfMeasure: data["unitsOfMeasure"]?.map((d) => newUnitOfMeasure(d)) || [],
  } as any;
}

export function newItemTemplateItemDetailResponse(
  data: ItemTemplateItemDetailDataOptions | Error,
): MockedResponse<ItemTemplateItemDetailQueryVariables, ItemTemplateItemDetailQuery> {
  return {
    request: { query: ItemTemplateItemDetailDocument },
    result: { data: data instanceof Error ? undefined : newItemTemplateItemDetailData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ItemTemplateItemProductsDataOptions {
  products?: (Product | ProductOptions)[];
}

export function newItemTemplateItemProductsData(
  data: ItemTemplateItemProductsDataOptions,
): ItemTemplateItemProductsQuery {
  return { __typename: "Query" as const, products: data["products"]?.map((d) => newProduct(d)) || [] } as any;
}

export function newItemTemplateItemProductsResponse(
  variables: ItemTemplateItemProductsQueryVariables,
  data: ItemTemplateItemProductsDataOptions | Error,
): MockedResponse<ItemTemplateItemProductsQueryVariables, ItemTemplateItemProductsQuery> {
  return {
    request: { query: ItemTemplateItemProductsDocument, variables },
    result: { data: data instanceof Error ? undefined : newItemTemplateItemProductsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TradePartnerContactsRolesPanelMetadataDataOptions {
  tradePartnerMarketRoles?: (TradePartnerMarketRoleDetail | TradePartnerMarketRoleDetailOptions)[];
}

export function newTradePartnerContactsRolesPanelMetadataData(
  data: TradePartnerContactsRolesPanelMetadataDataOptions,
): TradePartnerContactsRolesPanelMetadataQuery {
  return {
    __typename: "Query" as const,
    tradePartnerMarketRoles: data["tradePartnerMarketRoles"]?.map((d) => newTradePartnerMarketRoleDetail(d)) || [],
  } as any;
}

export function newTradePartnerContactsRolesPanelMetadataResponse(
  data: TradePartnerContactsRolesPanelMetadataDataOptions | Error,
): MockedResponse<TradePartnerContactsRolesPanelMetadataQueryVariables, TradePartnerContactsRolesPanelMetadataQuery> {
  return {
    request: { query: TradePartnerContactsRolesPanelMetadataDocument },
    result: { data: data instanceof Error ? undefined : newTradePartnerContactsRolesPanelMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TradePartnerReviewsDataOptions {
  tradePartner?: TradePartner | TradePartnerOptions;
  internalUsers?: (InternalUser | InternalUserOptions)[];
  projects?: (Project | ProjectOptions)[];
}

export function newTradePartnerReviewsData(data: TradePartnerReviewsDataOptions): TradePartnerReviewsQuery {
  return {
    __typename: "Query" as const,
    tradePartner: maybeNew("TradePartner", data["tradePartner"] || undefined, {}),
    internalUsers: data["internalUsers"]?.map((d) => newInternalUser(d)) || [],
    projects: data["projects"]?.map((d) => maybeNew("Project", d, {})) || [],
  } as any;
}

export function newTradePartnerReviewsResponse(
  variables: TradePartnerReviewsQueryVariables,
  data: TradePartnerReviewsDataOptions | Error,
): MockedResponse<TradePartnerReviewsQueryVariables, TradePartnerReviewsQuery> {
  return {
    request: { query: TradePartnerReviewsDocument, variables },
    result: { data: data instanceof Error ? undefined : newTradePartnerReviewsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveTradePartnerReviewDataOptions {
  saveTradePartnerReview?: SaveTradePartnerReviewResult | SaveTradePartnerReviewResultOptions;
}

export function newSaveTradePartnerReviewData(data: SaveTradePartnerReviewDataOptions): SaveTradePartnerReviewMutation {
  return {
    __typename: "Mutation" as const,
    saveTradePartnerReview: maybeNew("SaveTradePartnerReviewResult", data["saveTradePartnerReview"] || undefined, {}),
  } as any;
}

export function newSaveTradePartnerReviewResponse(
  variables: SaveTradePartnerReviewMutationVariables,
  data: SaveTradePartnerReviewDataOptions | Error,
): MockedResponse<SaveTradePartnerReviewMutationVariables, SaveTradePartnerReviewMutation> {
  return {
    request: { query: SaveTradePartnerReviewDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveTradePartnerReviewData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PaymentTermsDataOptions {
  paymentTerms?: (PaymentTerm | PaymentTermOptions)[];
  paymentTermDueFromDetails?: (PaymentTermDueFromDetail | PaymentTermDueFromDetailOptions)[];
}

export function newPaymentTermsData(data: PaymentTermsDataOptions): PaymentTermsQuery {
  return {
    __typename: "Query" as const,
    paymentTerms: data["paymentTerms"]?.map((d) => newPaymentTerm(d)) || [],
    paymentTermDueFromDetails: data["paymentTermDueFromDetails"]?.map((d) => newPaymentTermDueFromDetail(d)) || [],
  } as any;
}

export function newPaymentTermsResponse(
  data: PaymentTermsDataOptions | Error,
): MockedResponse<PaymentTermsQueryVariables, PaymentTermsQuery> {
  return {
    request: { query: PaymentTermsDocument },
    result: { data: data instanceof Error ? undefined : newPaymentTermsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SavePaymentTermDataOptions {
  savePaymentTerm?: SavePaymentTermResult | SavePaymentTermResultOptions;
}

export function newSavePaymentTermData(data: SavePaymentTermDataOptions): SavePaymentTermMutation {
  return {
    __typename: "Mutation" as const,
    savePaymentTerm: maybeNew("SavePaymentTermResult", data["savePaymentTerm"] || undefined, {}),
  } as any;
}

export function newSavePaymentTermResponse(
  variables: SavePaymentTermMutationVariables,
  data: SavePaymentTermDataOptions | Error,
): MockedResponse<SavePaymentTermMutationVariables, SavePaymentTermMutation> {
  return {
    request: { query: SavePaymentTermDocument, variables },
    result: { data: data instanceof Error ? undefined : newSavePaymentTermData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TradeCategoryLeadTimesDataOptions {
  tradeCategoryLeadTimes?: (TradeCategoryLeadTimeLike | TradeCategoryLeadTimeLikeOptions)[];
}

export function newTradeCategoryLeadTimesData(data: TradeCategoryLeadTimesDataOptions): TradeCategoryLeadTimesQuery {
  return {
    __typename: "Query" as const,
    tradeCategoryLeadTimes: data["tradeCategoryLeadTimes"]?.map((d) => maybeNew("TradeCategoryLeadTimeLike", d, {})) ||
      [],
  } as any;
}

export function newTradeCategoryLeadTimesResponse(
  variables: TradeCategoryLeadTimesQueryVariables,
  data: TradeCategoryLeadTimesDataOptions | Error,
): MockedResponse<TradeCategoryLeadTimesQueryVariables, TradeCategoryLeadTimesQuery> {
  return {
    request: { query: TradeCategoryLeadTimesDocument, variables },
    result: { data: data instanceof Error ? undefined : newTradeCategoryLeadTimesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TradeCategoryLeadTimesMetaDataDataOptions {
  tradeCategories?: (TradeCategory | TradeCategoryOptions)[];
  markets?: (Market | MarketOptions)[];
}

export function newTradeCategoryLeadTimesMetaDataData(
  data: TradeCategoryLeadTimesMetaDataDataOptions,
): TradeCategoryLeadTimesMetaDataQuery {
  return {
    __typename: "Query" as const,
    tradeCategories: data["tradeCategories"]?.map((d) => newTradeCategory(d)) || [],
    markets: data["markets"]?.map((d) => newMarket(d)) || [],
  } as any;
}

export function newTradeCategoryLeadTimesMetaDataResponse(
  data: TradeCategoryLeadTimesMetaDataDataOptions | Error,
): MockedResponse<TradeCategoryLeadTimesMetaDataQueryVariables, TradeCategoryLeadTimesMetaDataQuery> {
  return {
    request: { query: TradeCategoryLeadTimesMetaDataDocument },
    result: { data: data instanceof Error ? undefined : newTradeCategoryLeadTimesMetaDataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveTradeCategoryLeadTimesDataOptions {
  saveTradeCategoryLeadTimes?: SaveTradeCategoryLeadTimesResult | SaveTradeCategoryLeadTimesResultOptions;
}

export function newSaveTradeCategoryLeadTimesData(
  data: SaveTradeCategoryLeadTimesDataOptions,
): SaveTradeCategoryLeadTimesMutation {
  return {
    __typename: "Mutation" as const,
    saveTradeCategoryLeadTimes: maybeNew(
      "SaveTradeCategoryLeadTimesResult",
      data["saveTradeCategoryLeadTimes"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveTradeCategoryLeadTimesResponse(
  variables: SaveTradeCategoryLeadTimesMutationVariables,
  data: SaveTradeCategoryLeadTimesDataOptions | Error,
): MockedResponse<SaveTradeCategoryLeadTimesMutationVariables, SaveTradeCategoryLeadTimesMutation> {
  return {
    request: { query: SaveTradeCategoryLeadTimesDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveTradeCategoryLeadTimesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectContactsDataOptions {
  project?: Project | ProjectOptions;
}

export function newProjectContactsData(data: ProjectContactsDataOptions): ProjectContactsQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newProjectContactsResponse(
  variables: ProjectContactsQueryVariables,
  data: ProjectContactsDataOptions | Error,
): MockedResponse<ProjectContactsQueryVariables, ProjectContactsQuery> {
  return {
    request: { query: ProjectContactsDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectContactsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveProjectContactWarrantyDataOptions {
  saveProjectContact?: SaveProjectContactResult | SaveProjectContactResultOptions;
}

export function newSaveProjectContactWarrantyData(
  data: SaveProjectContactWarrantyDataOptions,
): SaveProjectContactWarrantyMutation {
  return {
    __typename: "Mutation" as const,
    saveProjectContact: maybeNew("SaveProjectContactResult", data["saveProjectContact"] || undefined, {}),
  } as any;
}

export function newSaveProjectContactWarrantyResponse(
  variables: SaveProjectContactWarrantyMutationVariables,
  data: SaveProjectContactWarrantyDataOptions | Error,
): MockedResponse<SaveProjectContactWarrantyMutationVariables, SaveProjectContactWarrantyMutation> {
  return {
    request: { query: SaveProjectContactWarrantyDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveProjectContactWarrantyData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface WarrantyModalTicketTypesAndDevelopmentsDataOptions {
  warrantyTicketTypesDetail?: (WarrantyTicketTypeDetail | WarrantyTicketTypeDetailOptions)[];
  developments?: (Development | DevelopmentOptions)[];
}

export function newWarrantyModalTicketTypesAndDevelopmentsData(
  data: WarrantyModalTicketTypesAndDevelopmentsDataOptions,
): WarrantyModalTicketTypesAndDevelopmentsQuery {
  return {
    __typename: "Query" as const,
    warrantyTicketTypesDetail: data["warrantyTicketTypesDetail"]?.map((d) => newWarrantyTicketTypeDetail(d)) || [],
    developments: data["developments"]?.map((d) => newDevelopment(d)) || [],
  } as any;
}

export function newWarrantyModalTicketTypesAndDevelopmentsResponse(
  data: WarrantyModalTicketTypesAndDevelopmentsDataOptions | Error,
): MockedResponse<WarrantyModalTicketTypesAndDevelopmentsQueryVariables, WarrantyModalTicketTypesAndDevelopmentsQuery> {
  return {
    request: { query: WarrantyModalTicketTypesAndDevelopmentsDocument },
    result: { data: data instanceof Error ? undefined : newWarrantyModalTicketTypesAndDevelopmentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface WarrantyModalProjectsDataOptions {
  projectsPage?: ProjectsPageResult | ProjectsPageResultOptions;
}

export function newWarrantyModalProjectsData(data: WarrantyModalProjectsDataOptions): WarrantyModalProjectsQuery {
  return {
    __typename: "Query" as const,
    projectsPage: maybeNew("ProjectsPageResult", data["projectsPage"] || undefined, {}),
  } as any;
}

export function newWarrantyModalProjectsResponse(
  variables: WarrantyModalProjectsQueryVariables,
  data: WarrantyModalProjectsDataOptions | Error,
): MockedResponse<WarrantyModalProjectsQueryVariables, WarrantyModalProjectsQuery> {
  return {
    request: { query: WarrantyModalProjectsDocument, variables },
    result: { data: data instanceof Error ? undefined : newWarrantyModalProjectsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AdminLocationDrawerDataOptions {
  location?: Location | LocationOptions;
}

export function newAdminLocationDrawerData(data: AdminLocationDrawerDataOptions): AdminLocationDrawerQuery {
  return { __typename: "Query" as const, location: maybeNew("Location", data["location"] || undefined, {}) } as any;
}

export function newAdminLocationDrawerResponse(
  variables: AdminLocationDrawerQueryVariables,
  data: AdminLocationDrawerDataOptions | Error,
): MockedResponse<AdminLocationDrawerQueryVariables, AdminLocationDrawerQuery> {
  return {
    request: { query: AdminLocationDrawerDocument, variables },
    result: { data: data instanceof Error ? undefined : newAdminLocationDrawerData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveAdminLocationDrawerDataOptions {
  saveLocations?: SaveLocationsResult | SaveLocationsResultOptions;
}

export function newSaveAdminLocationDrawerData(
  data: SaveAdminLocationDrawerDataOptions,
): SaveAdminLocationDrawerMutation {
  return {
    __typename: "Mutation" as const,
    saveLocations: maybeNew("SaveLocationsResult", data["saveLocations"] || undefined, {}),
  } as any;
}

export function newSaveAdminLocationDrawerResponse(
  variables: SaveAdminLocationDrawerMutationVariables,
  data: SaveAdminLocationDrawerDataOptions | Error,
): MockedResponse<SaveAdminLocationDrawerMutationVariables, SaveAdminLocationDrawerMutation> {
  return {
    request: { query: SaveAdminLocationDrawerDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveAdminLocationDrawerData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidPackageDetailsStepDataOptions {
  bidScopeSourceDetail?: (BidScopeSourceDetail | BidScopeSourceDetailOptions)[];
  markets?: (Market | MarketOptions)[];
  costCodes?: (CostCode | CostCodeOptions)[];
}

export function newBidPackageDetailsStepData(data: BidPackageDetailsStepDataOptions): BidPackageDetailsStepQuery {
  return {
    __typename: "Query" as const,
    bidScopeSourceDetail: data["bidScopeSourceDetail"]?.map((d) => newBidScopeSourceDetail(d)) || [],
    markets: data["markets"]?.map((d) => newMarket(d)) || [],
    costCodes: data["costCodes"]?.map((d) => newCostCode(d)) || [],
  } as any;
}

export function newBidPackageDetailsStepResponse(
  data: BidPackageDetailsStepDataOptions | Error,
): MockedResponse<BidPackageDetailsStepQueryVariables, BidPackageDetailsStepQuery> {
  return {
    request: { query: BidPackageDetailsStepDocument },
    result: { data: data instanceof Error ? undefined : newBidPackageDetailsStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ReviewUnitBidScopeStep_BidPackageGroupDataOptions {
  bidPackageGroup?: BidPackageGroup | BidPackageGroupOptions;
}

export function newReviewUnitBidScopeStep_BidPackageGroupData(
  data: ReviewUnitBidScopeStep_BidPackageGroupDataOptions,
): ReviewUnitBidScopeStep_BidPackageGroupQuery {
  return {
    __typename: "Query" as const,
    bidPackageGroup: maybeNew("BidPackageGroup", data["bidPackageGroup"] || undefined, {}),
  } as any;
}

export function newReviewUnitBidScopeStep_BidPackageGroupResponse(
  variables: ReviewUnitBidScopeStep_BidPackageGroupQueryVariables,
  data: ReviewUnitBidScopeStep_BidPackageGroupDataOptions | Error,
): MockedResponse<ReviewUnitBidScopeStep_BidPackageGroupQueryVariables, ReviewUnitBidScopeStep_BidPackageGroupQuery> {
  return {
    request: { query: ReviewUnitBidScopeStep_BidPackageGroupDocument, variables },
    result: { data: data instanceof Error ? undefined : newReviewUnitBidScopeStep_BidPackageGroupData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ReviewScopeStep_BidPackageGroupDataOptions {
  bidPackageGroupProductOfferingsInfo?:
    | BidPackageGroupProductOfferingsResult
    | BidPackageGroupProductOfferingsResultOptions;
}

export function newReviewScopeStep_BidPackageGroupData(
  data: ReviewScopeStep_BidPackageGroupDataOptions,
): ReviewScopeStep_BidPackageGroupQuery {
  return {
    __typename: "Query" as const,
    bidPackageGroupProductOfferingsInfo: maybeNew(
      "BidPackageGroupProductOfferingsResult",
      data["bidPackageGroupProductOfferingsInfo"] || undefined,
      {},
    ),
  } as any;
}

export function newReviewScopeStep_BidPackageGroupResponse(
  variables: ReviewScopeStep_BidPackageGroupQueryVariables,
  data: ReviewScopeStep_BidPackageGroupDataOptions | Error,
): MockedResponse<ReviewScopeStep_BidPackageGroupQueryVariables, ReviewScopeStep_BidPackageGroupQuery> {
  return {
    request: { query: ReviewScopeStep_BidPackageGroupDocument, variables },
    result: { data: data instanceof Error ? undefined : newReviewScopeStep_BidPackageGroupData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ReviewAndSendStepDataOptions {
  bidPackageGroup?: BidPackageGroup | BidPackageGroupOptions;
}

export function newReviewAndSendStepData(data: ReviewAndSendStepDataOptions): ReviewAndSendStepQuery {
  return {
    __typename: "Query" as const,
    bidPackageGroup: maybeNew("BidPackageGroup", data["bidPackageGroup"] || undefined, {}),
  } as any;
}

export function newReviewAndSendStepResponse(
  variables: ReviewAndSendStepQueryVariables,
  data: ReviewAndSendStepDataOptions | Error,
): MockedResponse<ReviewAndSendStepQueryVariables, ReviewAndSendStepQuery> {
  return {
    request: { query: ReviewAndSendStepDocument, variables },
    result: { data: data instanceof Error ? undefined : newReviewAndSendStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SelectBiddersStepDataOptions {
  bidPackageGroup?: BidPackageGroup | BidPackageGroupOptions;
  tradePartners?: (TradePartner | TradePartnerOptions)[];
}

export function newSelectBiddersStepData(data: SelectBiddersStepDataOptions): SelectBiddersStepQuery {
  return {
    __typename: "Query" as const,
    bidPackageGroup: maybeNew("BidPackageGroup", data["bidPackageGroup"] || undefined, {}),
    tradePartners: data["tradePartners"]?.map((d) => newTradePartner(d)) || [],
  } as any;
}

export function newSelectBiddersStepResponse(
  variables: SelectBiddersStepQueryVariables,
  data: SelectBiddersStepDataOptions | Error,
): MockedResponse<SelectBiddersStepQueryVariables, SelectBiddersStepQuery> {
  return {
    request: { query: SelectBiddersStepDocument, variables },
    result: { data: data instanceof Error ? undefined : newSelectBiddersStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidMetaDataOptions {
  costTypes?: (CostTypeDetail | CostTypeDetailOptions)[];
  items?: (Item | ItemOptions)[];
  materialVariantTags?: (MaterialVariantTag | MaterialVariantTagOptions)[];
}

export function newBidMetaData(data: BidMetaDataOptions): BidMetaQuery {
  return {
    __typename: "Query" as const,
    costTypes: data["costTypes"]?.map((d) => newCostTypeDetail(d)) || [],
    items: data["items"]?.map((d) => newItem(d)) || [],
    materialVariantTags: data["materialVariantTags"]?.map((d) => newMaterialVariantTag(d)) || [],
  } as any;
}

export function newBidMetaResponse(
  variables: BidMetaQueryVariables,
  data: BidMetaDataOptions | Error,
): MockedResponse<BidMetaQueryVariables, BidMetaQuery> {
  return {
    request: { query: BidMetaDocument, variables },
    result: { data: data instanceof Error ? undefined : newBidMetaData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface EditBidMetaDataOptions {
  costTypes?: (CostTypeDetail | CostTypeDetailOptions)[];
  items?: (Item | ItemOptions)[];
  materialVariantTags?: (MaterialVariantTag | MaterialVariantTagOptions)[];
  bidPackageVersion?: BidPackageVersion | BidPackageVersionOptions;
}

export function newEditBidMetaData(data: EditBidMetaDataOptions): EditBidMetaQuery {
  return {
    __typename: "Query" as const,
    costTypes: data["costTypes"]?.map((d) => newCostTypeDetail(d)) || [],
    items: data["items"]?.map((d) => newItem(d)) || [],
    materialVariantTags: data["materialVariantTags"]?.map((d) => newMaterialVariantTag(d)) || [],
    bidPackageVersion: maybeNew("BidPackageVersion", data["bidPackageVersion"] || undefined, {}),
  } as any;
}

export function newEditBidMetaResponse(
  variables: EditBidMetaQueryVariables,
  data: EditBidMetaDataOptions | Error,
): MockedResponse<EditBidMetaQueryVariables, EditBidMetaQuery> {
  return {
    request: { query: EditBidMetaDocument, variables },
    result: { data: data instanceof Error ? undefined : newEditBidMetaData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidPackageLineItemModalDataOptions {
  potentialBidItemsPage?: BidItemsPage | BidItemsPageOptions;
}

export function newBidPackageLineItemModalData(data: BidPackageLineItemModalDataOptions): BidPackageLineItemModalQuery {
  return {
    __typename: "Query" as const,
    potentialBidItemsPage: maybeNew("BidItemsPage", data["potentialBidItemsPage"] || undefined, {}),
  } as any;
}

export function newBidPackageLineItemModalResponse(
  variables: BidPackageLineItemModalQueryVariables,
  data: BidPackageLineItemModalDataOptions | Error,
): MockedResponse<BidPackageLineItemModalQueryVariables, BidPackageLineItemModalQuery> {
  return {
    request: { query: BidPackageLineItemModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newBidPackageLineItemModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidScopeFieldsDataOptions {
  projects?: (Project | ProjectOptions)[];
}

export function newBidScopeFieldsData(data: BidScopeFieldsDataOptions): BidScopeFieldsQuery {
  return {
    __typename: "Query" as const,
    projects: data["projects"]?.map((d) => maybeNew("Project", d, {})) || [],
  } as any;
}

export function newBidScopeFieldsResponse(
  variables: BidScopeFieldsQueryVariables,
  data: BidScopeFieldsDataOptions | Error,
): MockedResponse<BidScopeFieldsQueryVariables, BidScopeFieldsQuery> {
  return {
    request: { query: BidScopeFieldsDocument, variables },
    result: { data: data instanceof Error ? undefined : newBidScopeFieldsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateInvoiceTermsMetadataDataOptions {
  customers?: (Customer | CustomerOptions)[];
  regions?: (Region | RegionOptions)[];
}

export function newCreateInvoiceTermsMetadataData(
  data: CreateInvoiceTermsMetadataDataOptions,
): CreateInvoiceTermsMetadataQuery {
  return {
    __typename: "Query" as const,
    customers: data["customers"]?.map((d) => newCustomer(d)) || [],
    regions: data["regions"]?.map((d) => newRegion(d)) || [],
  } as any;
}

export function newCreateInvoiceTermsMetadataResponse(
  data: CreateInvoiceTermsMetadataDataOptions | Error,
): MockedResponse<CreateInvoiceTermsMetadataQueryVariables, CreateInvoiceTermsMetadataQuery> {
  return {
    request: { query: CreateInvoiceTermsMetadataDocument },
    result: { data: data instanceof Error ? undefined : newCreateInvoiceTermsMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface InvoiceTermsFormMetadataDataOptions {
  customers?: (Customer | CustomerOptions)[];
  regions?: (Region | RegionOptions)[];
  globalPlanMilestones?: GlobalPlanMilestonesPageResult | GlobalPlanMilestonesPageResultOptions;
}

export function newInvoiceTermsFormMetadataData(
  data: InvoiceTermsFormMetadataDataOptions,
): InvoiceTermsFormMetadataQuery {
  return {
    __typename: "Query" as const,
    customers: data["customers"]?.map((d) => newCustomer(d)) || [],
    regions: data["regions"]?.map((d) => newRegion(d)) || [],
    globalPlanMilestones: maybeNew("GlobalPlanMilestonesPageResult", data["globalPlanMilestones"] || undefined, {}),
  } as any;
}

export function newInvoiceTermsFormMetadataResponse(
  variables: InvoiceTermsFormMetadataQueryVariables,
  data: InvoiceTermsFormMetadataDataOptions | Error,
): MockedResponse<InvoiceTermsFormMetadataQueryVariables, InvoiceTermsFormMetadataQuery> {
  return {
    request: { query: InvoiceTermsFormMetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newInvoiceTermsFormMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface InvoiceTermsFormDataOptions {
  invoiceScheduleTemplate?: InvoiceScheduleTemplate | InvoiceScheduleTemplateOptions;
}

export function newInvoiceTermsFormData(data: InvoiceTermsFormDataOptions): InvoiceTermsFormQuery {
  return {
    __typename: "Query" as const,
    invoiceScheduleTemplate: maybeNew("InvoiceScheduleTemplate", data["invoiceScheduleTemplate"] || undefined, {}),
  } as any;
}

export function newInvoiceTermsFormResponse(
  variables: InvoiceTermsFormQueryVariables,
  data: InvoiceTermsFormDataOptions | Error,
): MockedResponse<InvoiceTermsFormQueryVariables, InvoiceTermsFormQuery> {
  return {
    request: { query: InvoiceTermsFormDocument, variables },
    result: { data: data instanceof Error ? undefined : newInvoiceTermsFormData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveInvoiceTermsDataOptions {
  saveInvoiceScheduleTemplate?: SaveInvoiceScheduleTemplateResult | SaveInvoiceScheduleTemplateResultOptions;
}

export function newSaveInvoiceTermsData(data: SaveInvoiceTermsDataOptions): SaveInvoiceTermsMutation {
  return {
    __typename: "Mutation" as const,
    saveInvoiceScheduleTemplate: maybeNew(
      "SaveInvoiceScheduleTemplateResult",
      data["saveInvoiceScheduleTemplate"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveInvoiceTermsResponse(
  variables: SaveInvoiceTermsMutationVariables,
  data: SaveInvoiceTermsDataOptions | Error,
): MockedResponse<SaveInvoiceTermsMutationVariables, SaveInvoiceTermsMutation> {
  return {
    request: { query: SaveInvoiceTermsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveInvoiceTermsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface InvoiceTermsDataOptions {
  invoiceScheduleTemplates?: (InvoiceScheduleTemplate | InvoiceScheduleTemplateOptions)[];
}

export function newInvoiceTermsData(data: InvoiceTermsDataOptions): InvoiceTermsQuery {
  return {
    __typename: "Query" as const,
    invoiceScheduleTemplates: data["invoiceScheduleTemplates"]?.map((d) => newInvoiceScheduleTemplate(d)) || [],
  } as any;
}

export function newInvoiceTermsResponse(
  data: InvoiceTermsDataOptions | Error,
): MockedResponse<InvoiceTermsQueryVariables, InvoiceTermsQuery> {
  return {
    request: { query: InvoiceTermsDocument },
    result: { data: data instanceof Error ? undefined : newInvoiceTermsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ApprovalChangeEventDataOptions {
  changeEvents?: (ChangeEvent | ChangeEventOptions)[];
}

export function newApprovalChangeEventData(data: ApprovalChangeEventDataOptions): ApprovalChangeEventQuery {
  return {
    __typename: "Query" as const,
    changeEvents: data["changeEvents"]?.map((d) => newChangeEvent(d)) || [],
  } as any;
}

export function newApprovalChangeEventResponse(
  variables: ApprovalChangeEventQueryVariables,
  data: ApprovalChangeEventDataOptions | Error,
): MockedResponse<ApprovalChangeEventQueryVariables, ApprovalChangeEventQuery> {
  return {
    request: { query: ApprovalChangeEventDocument, variables },
    result: { data: data instanceof Error ? undefined : newApprovalChangeEventData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveApprovalChangeEventDataOptions {
  saveChangeEvent?: SaveChangeEventResult | SaveChangeEventResultOptions;
}

export function newSaveApprovalChangeEventData(
  data: SaveApprovalChangeEventDataOptions,
): SaveApprovalChangeEventMutation {
  return {
    __typename: "Mutation" as const,
    saveChangeEvent: maybeNew("SaveChangeEventResult", data["saveChangeEvent"] || undefined, {}),
  } as any;
}

export function newSaveApprovalChangeEventResponse(
  variables: SaveApprovalChangeEventMutationVariables,
  data: SaveApprovalChangeEventDataOptions | Error,
): MockedResponse<SaveApprovalChangeEventMutationVariables, SaveApprovalChangeEventMutation> {
  return {
    request: { query: SaveApprovalChangeEventDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveApprovalChangeEventData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ApprovalChangeEventImpactedPosTableTabDataOptions {
  changeEvent?: ChangeEvent | ChangeEventOptions;
}

export function newApprovalChangeEventImpactedPosTableTabData(
  data: ApprovalChangeEventImpactedPosTableTabDataOptions,
): ApprovalChangeEventImpactedPosTableTabQuery {
  return {
    __typename: "Query" as const,
    changeEvent: maybeNew("ChangeEvent", data["changeEvent"] || undefined, {}),
  } as any;
}

export function newApprovalChangeEventImpactedPosTableTabResponse(
  variables: ApprovalChangeEventImpactedPosTableTabQueryVariables,
  data: ApprovalChangeEventImpactedPosTableTabDataOptions | Error,
): MockedResponse<ApprovalChangeEventImpactedPosTableTabQueryVariables, ApprovalChangeEventImpactedPosTableTabQuery> {
  return {
    request: { query: ApprovalChangeEventImpactedPosTableTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newApprovalChangeEventImpactedPosTableTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ApprovalChangeEventBreakDownTabDataOptions {
  changeEvent?: ChangeEvent | ChangeEventOptions;
}

export function newApprovalChangeEventBreakDownTabData(
  data: ApprovalChangeEventBreakDownTabDataOptions,
): ApprovalChangeEventBreakDownTabQuery {
  return {
    __typename: "Query" as const,
    changeEvent: maybeNew("ChangeEvent", data["changeEvent"] || undefined, {}),
  } as any;
}

export function newApprovalChangeEventBreakDownTabResponse(
  variables: ApprovalChangeEventBreakDownTabQueryVariables,
  data: ApprovalChangeEventBreakDownTabDataOptions | Error,
): MockedResponse<ApprovalChangeEventBreakDownTabQueryVariables, ApprovalChangeEventBreakDownTabQuery> {
  return {
    request: { query: ApprovalChangeEventBreakDownTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newApprovalChangeEventBreakDownTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CohortDetailsForFormDataOptions {
  cohort?: Cohort | CohortOptions;
}

export function newCohortDetailsForFormData(data: CohortDetailsForFormDataOptions): CohortDetailsForFormQuery {
  return { __typename: "Query" as const, cohort: maybeNew("Cohort", data["cohort"] || undefined, {}) } as any;
}

export function newCohortDetailsForFormResponse(
  variables: CohortDetailsForFormQueryVariables,
  data: CohortDetailsForFormDataOptions | Error,
): MockedResponse<CohortDetailsForFormQueryVariables, CohortDetailsForFormQuery> {
  return {
    request: { query: CohortDetailsForFormDocument, variables },
    result: { data: data instanceof Error ? undefined : newCohortDetailsForFormData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PopulateCohortFormOptionsDataOptions {
  markets?: (Market | MarketOptions)[];
  projects?: (Project | ProjectOptions)[];
}

export function newPopulateCohortFormOptionsData(
  data: PopulateCohortFormOptionsDataOptions,
): PopulateCohortFormOptionsQuery {
  return {
    __typename: "Query" as const,
    markets: data["markets"]?.map((d) => newMarket(d)) || [],
    projects: data["projects"]?.map((d) => maybeNew("Project", d, {})) || [],
  } as any;
}

export function newPopulateCohortFormOptionsResponse(
  data: PopulateCohortFormOptionsDataOptions | Error,
): MockedResponse<PopulateCohortFormOptionsQueryVariables, PopulateCohortFormOptionsQuery> {
  return {
    request: { query: PopulateCohortFormOptionsDocument },
    result: { data: data instanceof Error ? undefined : newPopulateCohortFormOptionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveCohortsDataOptions {
  saveCohorts?: SaveCohortsResult | SaveCohortsResultOptions;
}

export function newSaveCohortsData(data: SaveCohortsDataOptions): SaveCohortsMutation {
  return {
    __typename: "Mutation" as const,
    saveCohorts: maybeNew("SaveCohortsResult", data["saveCohorts"] || undefined, {}),
  } as any;
}

export function newSaveCohortsResponse(
  variables: SaveCohortsMutationVariables,
  data: SaveCohortsDataOptions | Error,
): MockedResponse<SaveCohortsMutationVariables, SaveCohortsMutation> {
  return {
    request: { query: SaveCohortsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveCohortsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveMapItemsStepDataOptions {
  saveScheduleTemplateItemMappings?:
    | SaveScheduleTemplateItemMappingsResult
    | SaveScheduleTemplateItemMappingsResultOptions;
}

export function newSaveMapItemsStepData(data: SaveMapItemsStepDataOptions): SaveMapItemsStepMutation {
  return {
    __typename: "Mutation" as const,
    saveScheduleTemplateItemMappings: maybeNew(
      "SaveScheduleTemplateItemMappingsResult",
      data["saveScheduleTemplateItemMappings"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveMapItemsStepResponse(
  variables: SaveMapItemsStepMutationVariables,
  data: SaveMapItemsStepDataOptions | Error,
): MockedResponse<SaveMapItemsStepMutationVariables, SaveMapItemsStepMutation> {
  return {
    request: { query: SaveMapItemsStepDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveMapItemsStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CostMappingScheduleTasksDataOptions {
  scheduleTasks?: (ScheduleTask | ScheduleTaskOptions)[];
}

export function newCostMappingScheduleTasksData(
  data: CostMappingScheduleTasksDataOptions,
): CostMappingScheduleTasksQuery {
  return {
    __typename: "Query" as const,
    scheduleTasks: data["scheduleTasks"]?.map((d) => newScheduleTask(d)) || [],
  } as any;
}

export function newCostMappingScheduleTasksResponse(
  variables: CostMappingScheduleTasksQueryVariables,
  data: CostMappingScheduleTasksDataOptions | Error,
): MockedResponse<CostMappingScheduleTasksQueryVariables, CostMappingScheduleTasksQuery> {
  return {
    request: { query: CostMappingScheduleTasksDocument, variables },
    result: { data: data instanceof Error ? undefined : newCostMappingScheduleTasksData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ConfirmTradesStepDataOptions {
  project?: Project | ProjectOptions;
}

export function newConfirmTradesStepData(data: ConfirmTradesStepDataOptions): ConfirmTradesStepQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newConfirmTradesStepResponse(
  variables: ConfirmTradesStepQueryVariables,
  data: ConfirmTradesStepDataOptions | Error,
): MockedResponse<ConfirmTradesStepQueryVariables, ConfirmTradesStepQuery> {
  return {
    request: { query: ConfirmTradesStepDocument, variables },
    result: { data: data instanceof Error ? undefined : newConfirmTradesStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ConfirmTrades_ProjectItemsDataOptions {
  projectItemsPage?: ProjectItemsPage | ProjectItemsPageOptions;
}

export function newConfirmTrades_ProjectItemsData(
  data: ConfirmTrades_ProjectItemsDataOptions,
): ConfirmTrades_ProjectItemsQuery {
  return {
    __typename: "Query" as const,
    projectItemsPage: maybeNew("ProjectItemsPage", data["projectItemsPage"] || undefined, {}),
  } as any;
}

export function newConfirmTrades_ProjectItemsResponse(
  variables: ConfirmTrades_ProjectItemsQueryVariables,
  data: ConfirmTrades_ProjectItemsDataOptions | Error,
): MockedResponse<ConfirmTrades_ProjectItemsQueryVariables, ConfirmTrades_ProjectItemsQuery> {
  return {
    request: { query: ConfirmTrades_ProjectItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newConfirmTrades_ProjectItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AssignWorkToBidContractDataOptions {
  assignWorkToBidContract?: (ChangeEvent | ChangeEventOptions)[];
}

export function newAssignWorkToBidContractData(
  data: AssignWorkToBidContractDataOptions,
): AssignWorkToBidContractMutation {
  return {
    __typename: "Mutation" as const,
    assignWorkToBidContract: data["assignWorkToBidContract"]?.map((d) => newChangeEvent(d)) || [],
  } as any;
}

export function newAssignWorkToBidContractResponse(
  variables: AssignWorkToBidContractMutationVariables,
  data: AssignWorkToBidContractDataOptions | Error,
): MockedResponse<AssignWorkToBidContractMutationVariables, AssignWorkToBidContractMutation> {
  return {
    request: { query: AssignWorkToBidContractDocument, variables },
    result: { data: data instanceof Error ? undefined : newAssignWorkToBidContractData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface UnassignWorkFromBidContractDataOptions {
  unassignWorkFromBidContract?: EmptyResult | EmptyResultOptions;
}

export function newUnassignWorkFromBidContractData(
  data: UnassignWorkFromBidContractDataOptions,
): UnassignWorkFromBidContractMutation {
  return {
    __typename: "Mutation" as const,
    unassignWorkFromBidContract: maybeNew("EmptyResult", data["unassignWorkFromBidContract"] || undefined, {}),
  } as any;
}

export function newUnassignWorkFromBidContractResponse(
  variables: UnassignWorkFromBidContractMutationVariables,
  data: UnassignWorkFromBidContractDataOptions | Error,
): MockedResponse<UnassignWorkFromBidContractMutationVariables, UnassignWorkFromBidContractMutation> {
  return {
    request: { query: UnassignWorkFromBidContractDocument, variables },
    result: { data: data instanceof Error ? undefined : newUnassignWorkFromBidContractData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ReleaseToTradesPageDataOptions {
  project?: Project | ProjectOptions;
}

export function newReleaseToTradesPageData(data: ReleaseToTradesPageDataOptions): ReleaseToTradesPageQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newReleaseToTradesPageResponse(
  variables: ReleaseToTradesPageQueryVariables,
  data: ReleaseToTradesPageDataOptions | Error,
): MockedResponse<ReleaseToTradesPageQueryVariables, ReleaseToTradesPageQuery> {
  return {
    request: { query: ReleaseToTradesPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newReleaseToTradesPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ReleaseToTradesTabDataOptions {
  projectReadyPlanConfigs?: (ProjectReadyPlanConfig | ProjectReadyPlanConfigOptions)[];
  globalOptionTypes?: (GlobalOptionType | GlobalOptionTypeOptions)[];
}

export function newReleaseToTradesTabData(data: ReleaseToTradesTabDataOptions): ReleaseToTradesTabQuery {
  return {
    __typename: "Query" as const,
    projectReadyPlanConfigs: data["projectReadyPlanConfigs"]?.map((d) => newProjectReadyPlanConfig(d)) || [],
    globalOptionTypes: data["globalOptionTypes"]?.map((d) => newGlobalOptionType(d)) || [],
  } as any;
}

export function newReleaseToTradesTabResponse(
  variables: ReleaseToTradesTabQueryVariables,
  data: ReleaseToTradesTabDataOptions | Error,
): MockedResponse<ReleaseToTradesTabQueryVariables, ReleaseToTradesTabQuery> {
  return {
    request: { query: ReleaseToTradesTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newReleaseToTradesTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ApplyProjectReadyPlanConfigsDataOptions {
  applyProjectReadyPlanConfigs?: ApplyProjectReadyPlanConfigsResult | ApplyProjectReadyPlanConfigsResultOptions;
}

export function newApplyProjectReadyPlanConfigsData(
  data: ApplyProjectReadyPlanConfigsDataOptions,
): ApplyProjectReadyPlanConfigsMutation {
  return {
    __typename: "Mutation" as const,
    applyProjectReadyPlanConfigs: maybeNew(
      "ApplyProjectReadyPlanConfigsResult",
      data["applyProjectReadyPlanConfigs"] || undefined,
      {},
    ),
  } as any;
}

export function newApplyProjectReadyPlanConfigsResponse(
  variables: ApplyProjectReadyPlanConfigsMutationVariables,
  data: ApplyProjectReadyPlanConfigsDataOptions | Error,
): MockedResponse<ApplyProjectReadyPlanConfigsMutationVariables, ApplyProjectReadyPlanConfigsMutation> {
  return {
    request: { query: ApplyProjectReadyPlanConfigsDocument, variables },
    result: { data: data instanceof Error ? undefined : newApplyProjectReadyPlanConfigsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveReadyPlansDataOptions {
  saveReadyPlans?: SaveReadyPlansResult | SaveReadyPlansResultOptions;
}

export function newSaveReadyPlansData(data: SaveReadyPlansDataOptions): SaveReadyPlansMutation {
  return {
    __typename: "Mutation" as const,
    saveReadyPlans: maybeNew("SaveReadyPlansResult", data["saveReadyPlans"] || undefined, {}),
  } as any;
}

export function newSaveReadyPlansResponse(
  variables: SaveReadyPlansMutationVariables,
  data: SaveReadyPlansDataOptions | Error,
): MockedResponse<SaveReadyPlansMutationVariables, SaveReadyPlansMutation> {
  return {
    request: { query: SaveReadyPlansDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveReadyPlansData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ReviewOrdersStepDataOptions {
  project?: Project | ProjectOptions;
}

export function newReviewOrdersStepData(data: ReviewOrdersStepDataOptions): ReviewOrdersStepQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newReviewOrdersStepResponse(
  variables: ReviewOrdersStepQueryVariables,
  data: ReviewOrdersStepDataOptions | Error,
): MockedResponse<ReviewOrdersStepQueryVariables, ReviewOrdersStepQuery> {
  return {
    request: { query: ReviewOrdersStepDocument, variables },
    result: { data: data instanceof Error ? undefined : newReviewOrdersStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ReviewOrdersStepReleaseCommitmentsDataOptions {
  releaseBidCommitments?: (CommitmentLike | CommitmentLikeOptions)[];
}

export function newReviewOrdersStepReleaseCommitmentsData(
  data: ReviewOrdersStepReleaseCommitmentsDataOptions,
): ReviewOrdersStepReleaseCommitmentsMutation {
  return {
    __typename: "Mutation" as const,
    releaseBidCommitments: data["releaseBidCommitments"]?.map((d) => maybeNew("CommitmentLike", d, {})) || [],
  } as any;
}

export function newReviewOrdersStepReleaseCommitmentsResponse(
  variables: ReviewOrdersStepReleaseCommitmentsMutationVariables,
  data: ReviewOrdersStepReleaseCommitmentsDataOptions | Error,
): MockedResponse<ReviewOrdersStepReleaseCommitmentsMutationVariables, ReviewOrdersStepReleaseCommitmentsMutation> {
  return {
    request: { query: ReviewOrdersStepReleaseCommitmentsDocument, variables },
    result: { data: data instanceof Error ? undefined : newReviewOrdersStepReleaseCommitmentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveReadyPlanOptionGroupsDataOptions {
  saveReadyPlanOptionGroups?: SaveReadyPlanOptionGroupsResult | SaveReadyPlanOptionGroupsResultOptions;
}

export function newSaveReadyPlanOptionGroupsData(
  data: SaveReadyPlanOptionGroupsDataOptions,
): SaveReadyPlanOptionGroupsMutation {
  return {
    __typename: "Mutation" as const,
    saveReadyPlanOptionGroups: maybeNew(
      "SaveReadyPlanOptionGroupsResult",
      data["saveReadyPlanOptionGroups"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveReadyPlanOptionGroupsResponse(
  variables: SaveReadyPlanOptionGroupsMutationVariables,
  data: SaveReadyPlanOptionGroupsDataOptions | Error,
): MockedResponse<SaveReadyPlanOptionGroupsMutationVariables, SaveReadyPlanOptionGroupsMutation> {
  return {
    request: { query: SaveReadyPlanOptionGroupsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveReadyPlanOptionGroupsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanDetailsStepMetadataDataOptions {
  enumDetails?: AllEnumDetails | AllEnumDetailsOptions;
}

export function newPlanDetailsStepMetadataData(data: PlanDetailsStepMetadataDataOptions): PlanDetailsStepMetadataQuery {
  return {
    __typename: "Query" as const,
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
  } as any;
}

export function newPlanDetailsStepMetadataResponse(
  data: PlanDetailsStepMetadataDataOptions | Error,
): MockedResponse<PlanDetailsStepMetadataQueryVariables, PlanDetailsStepMetadataQuery> {
  return {
    request: { query: PlanDetailsStepMetadataDocument },
    result: { data: data instanceof Error ? undefined : newPlanDetailsStepMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanDetailsStepDataOptions {
  readyPlan?: ReadyPlan | ReadyPlanOptions;
}

export function newPlanDetailsStepData(data: PlanDetailsStepDataOptions): PlanDetailsStepQuery {
  return { __typename: "Query" as const, readyPlan: maybeNew("ReadyPlan", data["readyPlan"] || undefined, {}) } as any;
}

export function newPlanDetailsStepResponse(
  variables: PlanDetailsStepQueryVariables,
  data: PlanDetailsStepDataOptions | Error,
): MockedResponse<PlanDetailsStepQueryVariables, PlanDetailsStepQuery> {
  return {
    request: { query: PlanDetailsStepDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanDetailsStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SavePlanDetailsDataOptions {
  saveReadyPlan?: SaveReadyPlanResult | SaveReadyPlanResultOptions;
}

export function newSavePlanDetailsData(data: SavePlanDetailsDataOptions): SavePlanDetailsMutation {
  return {
    __typename: "Mutation" as const,
    saveReadyPlan: maybeNew("SaveReadyPlanResult", data["saveReadyPlan"] || undefined, {}),
  } as any;
}

export function newSavePlanDetailsResponse(
  variables: SavePlanDetailsMutationVariables,
  data: SavePlanDetailsDataOptions | Error,
): MockedResponse<SavePlanDetailsMutationVariables, SavePlanDetailsMutation> {
  return {
    request: { query: SavePlanDetailsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSavePlanDetailsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateBidContractDataOptions {
  saveBidContract?: SaveBidContractResult | SaveBidContractResultOptions;
}

export function newCreateBidContractData(data: CreateBidContractDataOptions): CreateBidContractMutation {
  return {
    __typename: "Mutation" as const,
    saveBidContract: maybeNew("SaveBidContractResult", data["saveBidContract"] || undefined, {}),
  } as any;
}

export function newCreateBidContractResponse(
  variables: CreateBidContractMutationVariables,
  data: CreateBidContractDataOptions | Error,
): MockedResponse<CreateBidContractMutationVariables, CreateBidContractMutation> {
  return {
    request: { query: CreateBidContractDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateBidContractData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentTradePartnersDataOptions {
  development?: Development | DevelopmentOptions;
}

export function newDevelopmentTradePartnersData(
  data: DevelopmentTradePartnersDataOptions,
): DevelopmentTradePartnersQuery {
  return {
    __typename: "Query" as const,
    development: maybeNew("Development", data["development"] || undefined, {}),
  } as any;
}

export function newDevelopmentTradePartnersResponse(
  variables: DevelopmentTradePartnersQueryVariables,
  data: DevelopmentTradePartnersDataOptions | Error,
): MockedResponse<DevelopmentTradePartnersQueryVariables, DevelopmentTradePartnersQuery> {
  return {
    request: { query: DevelopmentTradePartnersDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentTradePartnersData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface RecentlyActivatedItemTemplatesDataOptions {
  itemTemplates?: (ItemTemplate | ItemTemplateOptions)[];
}

export function newRecentlyActivatedItemTemplatesData(
  data: RecentlyActivatedItemTemplatesDataOptions,
): RecentlyActivatedItemTemplatesQuery {
  return {
    __typename: "Query" as const,
    itemTemplates: data["itemTemplates"]?.map((d) => newItemTemplate(d)) || [],
  } as any;
}

export function newRecentlyActivatedItemTemplatesResponse(
  variables: RecentlyActivatedItemTemplatesQueryVariables,
  data: RecentlyActivatedItemTemplatesDataOptions | Error,
): MockedResponse<RecentlyActivatedItemTemplatesQueryVariables, RecentlyActivatedItemTemplatesQuery> {
  return {
    request: { query: RecentlyActivatedItemTemplatesDocument, variables },
    result: { data: data instanceof Error ? undefined : newRecentlyActivatedItemTemplatesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentTemplateItemsModalDataOptions {
  bidContractItems?: (BidContractPotentialItem | BidContractPotentialItemOptions)[];
}

export function newDevelopmentTemplateItemsModalData(
  data: DevelopmentTemplateItemsModalDataOptions,
): DevelopmentTemplateItemsModalQuery {
  return {
    __typename: "Query" as const,
    bidContractItems: data["bidContractItems"]?.map((d) => newBidContractPotentialItem(d)) || [],
  } as any;
}

export function newDevelopmentTemplateItemsModalResponse(
  variables: DevelopmentTemplateItemsModalQueryVariables,
  data: DevelopmentTemplateItemsModalDataOptions | Error,
): MockedResponse<DevelopmentTemplateItemsModalQueryVariables, DevelopmentTemplateItemsModalQuery> {
  return {
    request: { query: DevelopmentTemplateItemsModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentTemplateItemsModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentTemplateItemsModalMetadataDataOptions {
  readyPlans?: (ReadyPlan | ReadyPlanOptions)[];
  bidContractItems?: (BidContractPotentialItem | BidContractPotentialItemOptions)[];
}

export function newDevelopmentTemplateItemsModalMetadataData(
  data: DevelopmentTemplateItemsModalMetadataDataOptions,
): DevelopmentTemplateItemsModalMetadataQuery {
  return {
    __typename: "Query" as const,
    readyPlans: data["readyPlans"]?.map((d) => newReadyPlan(d)) || [],
    bidContractItems: data["bidContractItems"]?.map((d) => newBidContractPotentialItem(d)) || [],
  } as any;
}

export function newDevelopmentTemplateItemsModalMetadataResponse(
  variables: DevelopmentTemplateItemsModalMetadataQueryVariables,
  data: DevelopmentTemplateItemsModalMetadataDataOptions | Error,
): MockedResponse<DevelopmentTemplateItemsModalMetadataQueryVariables, DevelopmentTemplateItemsModalMetadataQuery> {
  return {
    request: { query: DevelopmentTemplateItemsModalMetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentTemplateItemsModalMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TestGroupDependenciesLineItemsDataOptions {
  testGroupDependenciesLineItems?: (TakeoffLineItem | TakeoffLineItemOptions)[];
  readyPlanOption?: ReadyPlanOption | ReadyPlanOptionOptions;
}

export function newTestGroupDependenciesLineItemsData(
  data: TestGroupDependenciesLineItemsDataOptions,
): TestGroupDependenciesLineItemsQuery {
  return {
    __typename: "Query" as const,
    testGroupDependenciesLineItems: data["testGroupDependenciesLineItems"]?.map((d) => newTakeoffLineItem(d)) || [],
    readyPlanOption: maybeNew("ReadyPlanOption", data["readyPlanOption"] || undefined, {}),
  } as any;
}

export function newTestGroupDependenciesLineItemsResponse(
  variables: TestGroupDependenciesLineItemsQueryVariables,
  data: TestGroupDependenciesLineItemsDataOptions | Error,
): MockedResponse<TestGroupDependenciesLineItemsQueryVariables, TestGroupDependenciesLineItemsQuery> {
  return {
    request: { query: TestGroupDependenciesLineItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newTestGroupDependenciesLineItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PofAvailableUpdatesDataOptions {
  productOffering?: ProductOffering | ProductOfferingOptions;
}

export function newPofAvailableUpdatesData(data: PofAvailableUpdatesDataOptions): PofAvailableUpdatesQuery {
  return {
    __typename: "Query" as const,
    productOffering: maybeNew("ProductOffering", data["productOffering"] || undefined, {}),
  } as any;
}

export function newPofAvailableUpdatesResponse(
  variables: PofAvailableUpdatesQueryVariables,
  data: PofAvailableUpdatesDataOptions | Error,
): MockedResponse<PofAvailableUpdatesQueryVariables, PofAvailableUpdatesQuery> {
  return {
    request: { query: PofAvailableUpdatesDocument, variables },
    result: { data: data instanceof Error ? undefined : newPofAvailableUpdatesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AcceptProductOfferingUpdatesDataOptions {
  acceptProductOfferingUpdates?: ProductOffering | ProductOfferingOptions;
}

export function newAcceptProductOfferingUpdatesData(
  data: AcceptProductOfferingUpdatesDataOptions,
): AcceptProductOfferingUpdatesMutation {
  return {
    __typename: "Mutation" as const,
    acceptProductOfferingUpdates: maybeNew("ProductOffering", data["acceptProductOfferingUpdates"] || undefined, {}),
  } as any;
}

export function newAcceptProductOfferingUpdatesResponse(
  variables: AcceptProductOfferingUpdatesMutationVariables,
  data: AcceptProductOfferingUpdatesDataOptions | Error,
): MockedResponse<AcceptProductOfferingUpdatesMutationVariables, AcceptProductOfferingUpdatesMutation> {
  return {
    request: { query: AcceptProductOfferingUpdatesDocument, variables },
    result: { data: data instanceof Error ? undefined : newAcceptProductOfferingUpdatesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProductOfferingVersionHistoryDataOptions {
  readyPlanAggregateVersionsPage?: ReadyPlanAggregateVersionsPageResult | ReadyPlanAggregateVersionsPageResultOptions;
}

export function newProductOfferingVersionHistoryData(
  data: ProductOfferingVersionHistoryDataOptions,
): ProductOfferingVersionHistoryQuery {
  return {
    __typename: "Query" as const,
    readyPlanAggregateVersionsPage: maybeNew(
      "ReadyPlanAggregateVersionsPageResult",
      data["readyPlanAggregateVersionsPage"] || undefined,
      {},
    ),
  } as any;
}

export function newProductOfferingVersionHistoryResponse(
  variables: ProductOfferingVersionHistoryQueryVariables,
  data: ProductOfferingVersionHistoryDataOptions | Error,
): MockedResponse<ProductOfferingVersionHistoryQueryVariables, ProductOfferingVersionHistoryQuery> {
  return {
    request: { query: ProductOfferingVersionHistoryDocument, variables },
    result: { data: data instanceof Error ? undefined : newProductOfferingVersionHistoryData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TaskLookaheadDataOptions {
  scheduleTasks?: (ScheduleTask | ScheduleTaskOptions)[];
  cohorts?: (Cohort | CohortOptions)[];
}

export function newTaskLookaheadData(data: TaskLookaheadDataOptions): TaskLookaheadQuery {
  return {
    __typename: "Query" as const,
    scheduleTasks: data["scheduleTasks"]?.map((d) => newScheduleTask(d)) || [],
    cohorts: data["cohorts"]?.map((d) => newCohort(d)) || [],
  } as any;
}

export function newTaskLookaheadResponse(
  variables: TaskLookaheadQueryVariables,
  data: TaskLookaheadDataOptions | Error,
): MockedResponse<TaskLookaheadQueryVariables, TaskLookaheadQuery> {
  return {
    request: { query: TaskLookaheadDocument, variables },
    result: { data: data instanceof Error ? undefined : newTaskLookaheadData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TaskLookaheadRightPaneDataOptions {
  scheduleTasks?: (ScheduleTask | ScheduleTaskOptions)[];
  project?: Project | ProjectOptions;
}

export function newTaskLookaheadRightPaneData(data: TaskLookaheadRightPaneDataOptions): TaskLookaheadRightPaneQuery {
  return {
    __typename: "Query" as const,
    scheduleTasks: data["scheduleTasks"]?.map((d) => newScheduleTask(d)) || [],
    project: maybeNew("Project", data["project"] || undefined, {}),
  } as any;
}

export function newTaskLookaheadRightPaneResponse(
  variables: TaskLookaheadRightPaneQueryVariables,
  data: TaskLookaheadRightPaneDataOptions | Error,
): MockedResponse<TaskLookaheadRightPaneQueryVariables, TaskLookaheadRightPaneQuery> {
  return {
    request: { query: TaskLookaheadRightPaneDocument, variables },
    result: { data: data instanceof Error ? undefined : newTaskLookaheadRightPaneData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface StandaloneTaskDetailPaneDataOptions {
  schedule?: Schedule | ScheduleOptions;
  scheduleTasks?: (ScheduleTask | ScheduleTaskOptions)[];
}

export function newStandaloneTaskDetailPaneData(
  data: StandaloneTaskDetailPaneDataOptions,
): StandaloneTaskDetailPaneQuery {
  return {
    __typename: "Query" as const,
    schedule: maybeNew("Schedule", data["schedule"] || undefined, {}),
    scheduleTasks: data["scheduleTasks"]?.map((d) => newScheduleTask(d)) || [],
  } as any;
}

export function newStandaloneTaskDetailPaneResponse(
  variables: StandaloneTaskDetailPaneQueryVariables,
  data: StandaloneTaskDetailPaneDataOptions | Error,
): MockedResponse<StandaloneTaskDetailPaneQueryVariables, StandaloneTaskDetailPaneQuery> {
  return {
    request: { query: StandaloneTaskDetailPaneDocument, variables },
    result: { data: data instanceof Error ? undefined : newStandaloneTaskDetailPaneData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PhaseTaskListPaneDataOptions {
  scheduleTasks?: (ScheduleTask | ScheduleTaskOptions)[];
}

export function newPhaseTaskListPaneData(data: PhaseTaskListPaneDataOptions): PhaseTaskListPaneQuery {
  return {
    __typename: "Query" as const,
    scheduleTasks: data["scheduleTasks"]?.map((d) => newScheduleTask(d)) || [],
  } as any;
}

export function newPhaseTaskListPaneResponse(
  variables: PhaseTaskListPaneQueryVariables,
  data: PhaseTaskListPaneDataOptions | Error,
): MockedResponse<PhaseTaskListPaneQueryVariables, PhaseTaskListPaneQuery> {
  return {
    request: { query: PhaseTaskListPaneDocument, variables },
    result: { data: data instanceof Error ? undefined : newPhaseTaskListPaneData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentHolidayCard_AllProjectsDataOptions {
  projectsPage?: ProjectsPageResult | ProjectsPageResultOptions;
}

export function newDevelopmentHolidayCard_AllProjectsData(
  data: DevelopmentHolidayCard_AllProjectsDataOptions,
): DevelopmentHolidayCard_AllProjectsQuery {
  return {
    __typename: "Query" as const,
    projectsPage: maybeNew("ProjectsPageResult", data["projectsPage"] || undefined, {}),
  } as any;
}

export function newDevelopmentHolidayCard_AllProjectsResponse(
  variables: DevelopmentHolidayCard_AllProjectsQueryVariables,
  data: DevelopmentHolidayCard_AllProjectsDataOptions | Error,
): MockedResponse<DevelopmentHolidayCard_AllProjectsQueryVariables, DevelopmentHolidayCard_AllProjectsQuery> {
  return {
    request: { query: DevelopmentHolidayCard_AllProjectsDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentHolidayCard_AllProjectsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DevelopmentScheduleDataOptions {
  development?: Development | DevelopmentOptions;
  scheduleTasks?: (ScheduleTask | ScheduleTaskOptions)[];
  taskStatuses?: (TaskStatusDetail | TaskStatusDetailOptions)[];
  internalUsers?: (InternalUser | InternalUserOptions)[];
}

export function newDevelopmentScheduleData(data: DevelopmentScheduleDataOptions): DevelopmentScheduleQuery {
  return {
    __typename: "Query" as const,
    development: maybeNew("Development", data["development"] || undefined, {}),
    scheduleTasks: data["scheduleTasks"]?.map((d) => newScheduleTask(d)) || [],
    taskStatuses: data["taskStatuses"]?.map((d) => newTaskStatusDetail(d)) || [],
    internalUsers: data["internalUsers"]?.map((d) => newInternalUser(d)) || [],
  } as any;
}

export function newDevelopmentScheduleResponse(
  variables: DevelopmentScheduleQueryVariables,
  data: DevelopmentScheduleDataOptions | Error,
): MockedResponse<DevelopmentScheduleQueryVariables, DevelopmentScheduleQuery> {
  return {
    request: { query: DevelopmentScheduleDocument, variables },
    result: { data: data instanceof Error ? undefined : newDevelopmentScheduleData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScopeReasonCodesDataOptions {
  scopeChangeReasons?: (ScopeChangeReason | ScopeChangeReasonOptions)[];
}

export function newScopeReasonCodesData(data: ScopeReasonCodesDataOptions): ScopeReasonCodesQuery {
  return {
    __typename: "Query" as const,
    scopeChangeReasons: data["scopeChangeReasons"]?.map((d) => newScopeChangeReason(d)) || [],
  } as any;
}

export function newScopeReasonCodesResponse(
  data: ScopeReasonCodesDataOptions | Error,
): MockedResponse<ScopeReasonCodesQueryVariables, ScopeReasonCodesQuery> {
  return {
    request: { query: ScopeReasonCodesDocument },
    result: { data: data instanceof Error ? undefined : newScopeReasonCodesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveItemTemplatesDataOptions {
  saveItemTemplates?: SaveItemTemplatesResult | SaveItemTemplatesResultOptions;
}

export function newSaveItemTemplatesData(data: SaveItemTemplatesDataOptions): SaveItemTemplatesMutation {
  return {
    __typename: "Mutation" as const,
    saveItemTemplates: maybeNew("SaveItemTemplatesResult", data["saveItemTemplates"] || undefined, {}),
  } as any;
}

export function newSaveItemTemplatesResponse(
  variables: SaveItemTemplatesMutationVariables,
  data: SaveItemTemplatesDataOptions | Error,
): MockedResponse<SaveItemTemplatesMutationVariables, SaveItemTemplatesMutation> {
  return {
    request: { query: SaveItemTemplatesDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveItemTemplatesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddScopeTemplateItemsDataOptions {
  items?: (Item | ItemOptions)[];
  locations?: (Location | LocationOptions)[];
  costTypes?: (CostTypeDetail | CostTypeDetailOptions)[];
  itemTemplate?: ItemTemplate | ItemTemplateOptions;
}

export function newAddScopeTemplateItemsData(data: AddScopeTemplateItemsDataOptions): AddScopeTemplateItemsQuery {
  return {
    __typename: "Query" as const,
    items: data["items"]?.map((d) => newItem(d)) || [],
    locations: data["locations"]?.map((d) => newLocation(d)) || [],
    costTypes: data["costTypes"]?.map((d) => newCostTypeDetail(d)) || [],
    itemTemplate: maybeNew("ItemTemplate", data["itemTemplate"] || undefined, {}),
  } as any;
}

export function newAddScopeTemplateItemsResponse(
  variables: AddScopeTemplateItemsQueryVariables,
  data: AddScopeTemplateItemsDataOptions | Error,
): MockedResponse<AddScopeTemplateItemsQueryVariables, AddScopeTemplateItemsQuery> {
  return {
    request: { query: AddScopeTemplateItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddScopeTemplateItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ArchiveItemTemplateVersionsDataOptions {
  archiveItemTemplateVersions?: EmptyResult | EmptyResultOptions;
}

export function newArchiveItemTemplateVersionsData(
  data: ArchiveItemTemplateVersionsDataOptions,
): ArchiveItemTemplateVersionsMutation {
  return {
    __typename: "Mutation" as const,
    archiveItemTemplateVersions: maybeNew("EmptyResult", data["archiveItemTemplateVersions"] || undefined, {}),
  } as any;
}

export function newArchiveItemTemplateVersionsResponse(
  variables: ArchiveItemTemplateVersionsMutationVariables,
  data: ArchiveItemTemplateVersionsDataOptions | Error,
): MockedResponse<ArchiveItemTemplateVersionsMutationVariables, ArchiveItemTemplateVersionsMutation> {
  return {
    request: { query: ArchiveItemTemplateVersionsDocument, variables },
    result: { data: data instanceof Error ? undefined : newArchiveItemTemplateVersionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveItemTemplateHeaderDataOptions {
  saveItemTemplate?: SaveItemTemplateResult | SaveItemTemplateResultOptions;
}

export function newSaveItemTemplateHeaderData(data: SaveItemTemplateHeaderDataOptions): SaveItemTemplateHeaderMutation {
  return {
    __typename: "Mutation" as const,
    saveItemTemplate: maybeNew("SaveItemTemplateResult", data["saveItemTemplate"] || undefined, {}),
  } as any;
}

export function newSaveItemTemplateHeaderResponse(
  variables: SaveItemTemplateHeaderMutationVariables,
  data: SaveItemTemplateHeaderDataOptions | Error,
): MockedResponse<SaveItemTemplateHeaderMutationVariables, SaveItemTemplateHeaderMutation> {
  return {
    request: { query: SaveItemTemplateHeaderDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveItemTemplateHeaderData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveScopeTemplateHeader_ReadyPlanDataOptions {
  saveReadyPlan?: SaveReadyPlanResult | SaveReadyPlanResultOptions;
}

export function newSaveScopeTemplateHeader_ReadyPlanData(
  data: SaveScopeTemplateHeader_ReadyPlanDataOptions,
): SaveScopeTemplateHeader_ReadyPlanMutation {
  return {
    __typename: "Mutation" as const,
    saveReadyPlan: maybeNew("SaveReadyPlanResult", data["saveReadyPlan"] || undefined, {}),
  } as any;
}

export function newSaveScopeTemplateHeader_ReadyPlanResponse(
  variables: SaveScopeTemplateHeader_ReadyPlanMutationVariables,
  data: SaveScopeTemplateHeader_ReadyPlanDataOptions | Error,
): MockedResponse<SaveScopeTemplateHeader_ReadyPlanMutationVariables, SaveScopeTemplateHeader_ReadyPlanMutation> {
  return {
    request: { query: SaveScopeTemplateHeader_ReadyPlanDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveScopeTemplateHeader_ReadyPlanData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CopyLineItemsModalDataOptions {
  itemTemplates?: (ItemTemplate | ItemTemplateOptions)[];
}

export function newCopyLineItemsModalData(data: CopyLineItemsModalDataOptions): CopyLineItemsModalQuery {
  return {
    __typename: "Query" as const,
    itemTemplates: data["itemTemplates"]?.map((d) => newItemTemplate(d)) || [],
  } as any;
}

export function newCopyLineItemsModalResponse(
  variables: CopyLineItemsModalQueryVariables,
  data: CopyLineItemsModalDataOptions | Error,
): MockedResponse<CopyLineItemsModalQueryVariables, CopyLineItemsModalQuery> {
  return {
    request: { query: CopyLineItemsModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newCopyLineItemsModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CopyItemTemplateDataOptions {
  cloneItemTemplate?: CloneItemTemplateResult | CloneItemTemplateResultOptions;
}

export function newCopyItemTemplateData(data: CopyItemTemplateDataOptions): CopyItemTemplateMutation {
  return {
    __typename: "Mutation" as const,
    cloneItemTemplate: maybeNew("CloneItemTemplateResult", data["cloneItemTemplate"] || undefined, {}),
  } as any;
}

export function newCopyItemTemplateResponse(
  variables: CopyItemTemplateMutationVariables,
  data: CopyItemTemplateDataOptions | Error,
): MockedResponse<CopyItemTemplateMutationVariables, CopyItemTemplateMutation> {
  return {
    request: { query: CopyItemTemplateDocument, variables },
    result: { data: data instanceof Error ? undefined : newCopyItemTemplateData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddSlotModal_PotentialPlaceholdersDataOptions {
  takeoffLineItemsPage?: TakeoffLineItemsPage | TakeoffLineItemsPageOptions;
}

export function newAddSlotModal_PotentialPlaceholdersData(
  data: AddSlotModal_PotentialPlaceholdersDataOptions,
): AddSlotModal_PotentialPlaceholdersQuery {
  return {
    __typename: "Query" as const,
    takeoffLineItemsPage: maybeNew("TakeoffLineItemsPage", data["takeoffLineItemsPage"] || undefined, {}),
  } as any;
}

export function newAddSlotModal_PotentialPlaceholdersResponse(
  variables: AddSlotModal_PotentialPlaceholdersQueryVariables,
  data: AddSlotModal_PotentialPlaceholdersDataOptions | Error,
): MockedResponse<AddSlotModal_PotentialPlaceholdersQueryVariables, AddSlotModal_PotentialPlaceholdersQuery> {
  return {
    request: { query: AddSlotModal_PotentialPlaceholdersDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddSlotModal_PotentialPlaceholdersData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddSlotModal_SelectedPlaceholdersDataOptions {
  takeoffLineItemsPage?: TakeoffLineItemsPage | TakeoffLineItemsPageOptions;
}

export function newAddSlotModal_SelectedPlaceholdersData(
  data: AddSlotModal_SelectedPlaceholdersDataOptions,
): AddSlotModal_SelectedPlaceholdersQuery {
  return {
    __typename: "Query" as const,
    takeoffLineItemsPage: maybeNew("TakeoffLineItemsPage", data["takeoffLineItemsPage"] || undefined, {}),
  } as any;
}

export function newAddSlotModal_SelectedPlaceholdersResponse(
  variables: AddSlotModal_SelectedPlaceholdersQueryVariables,
  data: AddSlotModal_SelectedPlaceholdersDataOptions | Error,
): MockedResponse<AddSlotModal_SelectedPlaceholdersQueryVariables, AddSlotModal_SelectedPlaceholdersQuery> {
  return {
    request: { query: AddSlotModal_SelectedPlaceholdersDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddSlotModal_SelectedPlaceholdersData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CompareModeDesignPackageDataOptions {
  designPackage?: DesignPackage | DesignPackageOptions;
}

export function newCompareModeDesignPackageData(
  data: CompareModeDesignPackageDataOptions,
): CompareModeDesignPackageQuery {
  return {
    __typename: "Query" as const,
    designPackage: maybeNew("DesignPackage", data["designPackage"] || undefined, {}),
  } as any;
}

export function newCompareModeDesignPackageResponse(
  variables: CompareModeDesignPackageQueryVariables,
  data: CompareModeDesignPackageDataOptions | Error,
): MockedResponse<CompareModeDesignPackageQueryVariables, CompareModeDesignPackageQuery> {
  return {
    request: { query: CompareModeDesignPackageDocument, variables },
    result: { data: data instanceof Error ? undefined : newCompareModeDesignPackageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CompareModeDesignPackageTlisDataOptions {
  designPackageFinishSchedule?: DesignPackageFinishSchedulePageResult | DesignPackageFinishSchedulePageResultOptions;
}

export function newCompareModeDesignPackageTlisData(
  data: CompareModeDesignPackageTlisDataOptions,
): CompareModeDesignPackageTlisQuery {
  return {
    __typename: "Query" as const,
    designPackageFinishSchedule: maybeNew(
      "DesignPackageFinishSchedulePageResult",
      data["designPackageFinishSchedule"] || undefined,
      {},
    ),
  } as any;
}

export function newCompareModeDesignPackageTlisResponse(
  variables: CompareModeDesignPackageTlisQueryVariables,
  data: CompareModeDesignPackageTlisDataOptions | Error,
): MockedResponse<CompareModeDesignPackageTlisQueryVariables, CompareModeDesignPackageTlisQuery> {
  return {
    request: { query: CompareModeDesignPackageTlisDocument, variables },
    result: { data: data instanceof Error ? undefined : newCompareModeDesignPackageTlisData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlaceholderProductSearch_RequirementsTliDataOptions {
  takeoffLineItem?: TakeoffLineItem | TakeoffLineItemOptions;
}

export function newPlaceholderProductSearch_RequirementsTliData(
  data: PlaceholderProductSearch_RequirementsTliDataOptions,
): PlaceholderProductSearch_RequirementsTliQuery {
  return {
    __typename: "Query" as const,
    takeoffLineItem: maybeNew("TakeoffLineItem", data["takeoffLineItem"] || undefined, {}),
  } as any;
}

export function newPlaceholderProductSearch_RequirementsTliResponse(
  variables: PlaceholderProductSearch_RequirementsTliQueryVariables,
  data: PlaceholderProductSearch_RequirementsTliDataOptions | Error,
): MockedResponse<
  PlaceholderProductSearch_RequirementsTliQueryVariables,
  PlaceholderProductSearch_RequirementsTliQuery
> {
  return {
    request: { query: PlaceholderProductSearch_RequirementsTliDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlaceholderProductSearch_RequirementsTliData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlaceholderProductSearch_PossibleMaterialsDataOptions {
  materialVariantsForPlaceholderTli?: (MaterialVariant | MaterialVariantOptions)[];
}

export function newPlaceholderProductSearch_PossibleMaterialsData(
  data: PlaceholderProductSearch_PossibleMaterialsDataOptions,
): PlaceholderProductSearch_PossibleMaterialsQuery {
  return {
    __typename: "Query" as const,
    materialVariantsForPlaceholderTli: data["materialVariantsForPlaceholderTli"]?.map((d) => newMaterialVariant(d)) ||
      [],
  } as any;
}

export function newPlaceholderProductSearch_PossibleMaterialsResponse(
  variables: PlaceholderProductSearch_PossibleMaterialsQueryVariables,
  data: PlaceholderProductSearch_PossibleMaterialsDataOptions | Error,
): MockedResponse<
  PlaceholderProductSearch_PossibleMaterialsQueryVariables,
  PlaceholderProductSearch_PossibleMaterialsQuery
> {
  return {
    request: { query: PlaceholderProductSearch_PossibleMaterialsDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlaceholderProductSearch_PossibleMaterialsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DesignPackageConfiguratorDataOptions {
  designPackage?: DesignPackage | DesignPackageOptions;
}

export function newDesignPackageConfiguratorData(
  data: DesignPackageConfiguratorDataOptions,
): DesignPackageConfiguratorQuery {
  return {
    __typename: "Query" as const,
    designPackage: maybeNew("DesignPackage", data["designPackage"] || undefined, {}),
  } as any;
}

export function newDesignPackageConfiguratorResponse(
  variables: DesignPackageConfiguratorQueryVariables,
  data: DesignPackageConfiguratorDataOptions | Error,
): MockedResponse<DesignPackageConfiguratorQueryVariables, DesignPackageConfiguratorQuery> {
  return {
    request: { query: DesignPackageConfiguratorDocument, variables },
    result: { data: data instanceof Error ? undefined : newDesignPackageConfiguratorData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MakeNewDesignPackageDataOptions {
  saveDesignPackage?: SaveDesignPackageResult | SaveDesignPackageResultOptions;
}

export function newMakeNewDesignPackageData(data: MakeNewDesignPackageDataOptions): MakeNewDesignPackageMutation {
  return {
    __typename: "Mutation" as const,
    saveDesignPackage: maybeNew("SaveDesignPackageResult", data["saveDesignPackage"] || undefined, {}),
  } as any;
}

export function newMakeNewDesignPackageResponse(
  variables: MakeNewDesignPackageMutationVariables,
  data: MakeNewDesignPackageDataOptions | Error,
): MockedResponse<MakeNewDesignPackageMutationVariables, MakeNewDesignPackageMutation> {
  return {
    request: { query: MakeNewDesignPackageDocument, variables },
    result: { data: data instanceof Error ? undefined : newMakeNewDesignPackageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface NewDesignPackagePlanPackagesDataOptions {
  planPackages?: PlanPackagesPageResult | PlanPackagesPageResultOptions;
}

export function newNewDesignPackagePlanPackagesData(
  data: NewDesignPackagePlanPackagesDataOptions,
): NewDesignPackagePlanPackagesQuery {
  return {
    __typename: "Query" as const,
    planPackages: maybeNew("PlanPackagesPageResult", data["planPackages"] || undefined, {}),
  } as any;
}

export function newNewDesignPackagePlanPackagesResponse(
  variables: NewDesignPackagePlanPackagesQueryVariables,
  data: NewDesignPackagePlanPackagesDataOptions | Error,
): MockedResponse<NewDesignPackagePlanPackagesQueryVariables, NewDesignPackagePlanPackagesQuery> {
  return {
    request: { query: NewDesignPackagePlanPackagesDocument, variables },
    result: { data: data instanceof Error ? undefined : newNewDesignPackagePlanPackagesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface NewDesignPackage_GlobalOptionGroupsDataOptions {
  scopedGroups?: (GlobalOptionGroup | GlobalOptionGroupOptions)[];
  sharedGroups?: (GlobalOptionGroup | GlobalOptionGroupOptions)[];
  types?: (GlobalOptionType | GlobalOptionTypeOptions)[];
}

export function newNewDesignPackage_GlobalOptionGroupsData(
  data: NewDesignPackage_GlobalOptionGroupsDataOptions,
): NewDesignPackage_GlobalOptionGroupsQuery {
  return {
    __typename: "Query" as const,
    scopedGroups: data["scopedGroups"]?.map((d) => newGlobalOptionGroup(d)) || [],
    sharedGroups: data["sharedGroups"]?.map((d) => newGlobalOptionGroup(d)) || [],
    types: data["types"]?.map((d) => newGlobalOptionType(d)) || [],
  } as any;
}

export function newNewDesignPackage_GlobalOptionGroupsResponse(
  variables: NewDesignPackage_GlobalOptionGroupsQueryVariables,
  data: NewDesignPackage_GlobalOptionGroupsDataOptions | Error,
): MockedResponse<NewDesignPackage_GlobalOptionGroupsQueryVariables, NewDesignPackage_GlobalOptionGroupsQuery> {
  return {
    request: { query: NewDesignPackage_GlobalOptionGroupsDocument, variables },
    result: { data: data instanceof Error ? undefined : newNewDesignPackage_GlobalOptionGroupsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface EditDesignPackageDataOptions {
  designPackage?: DesignPackage | DesignPackageOptions;
}

export function newEditDesignPackageData(data: EditDesignPackageDataOptions): EditDesignPackageQuery {
  return {
    __typename: "Query" as const,
    designPackage: maybeNew("DesignPackage", data["designPackage"] || undefined, {}),
  } as any;
}

export function newEditDesignPackageResponse(
  variables: EditDesignPackageQueryVariables,
  data: EditDesignPackageDataOptions | Error,
): MockedResponse<EditDesignPackageQueryVariables, EditDesignPackageQuery> {
  return {
    request: { query: EditDesignPackageDocument, variables },
    result: { data: data instanceof Error ? undefined : newEditDesignPackageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PreselectOptionsFromPlanPackagesDataOptions {
  planPackages?: PlanPackagesPageResult | PlanPackagesPageResultOptions;
}

export function newPreselectOptionsFromPlanPackagesData(
  data: PreselectOptionsFromPlanPackagesDataOptions,
): PreselectOptionsFromPlanPackagesQuery {
  return {
    __typename: "Query" as const,
    planPackages: maybeNew("PlanPackagesPageResult", data["planPackages"] || undefined, {}),
  } as any;
}

export function newPreselectOptionsFromPlanPackagesResponse(
  variables: PreselectOptionsFromPlanPackagesQueryVariables,
  data: PreselectOptionsFromPlanPackagesDataOptions | Error,
): MockedResponse<PreselectOptionsFromPlanPackagesQueryVariables, PreselectOptionsFromPlanPackagesQuery> {
  return {
    request: { query: PreselectOptionsFromPlanPackagesDocument, variables },
    result: { data: data instanceof Error ? undefined : newPreselectOptionsFromPlanPackagesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DesignPackageProductCardPage_MaterialVariantDataOptions {
  materialVariant?: MaterialVariant | MaterialVariantOptions;
  takeoffLineItem?: TakeoffLineItem | TakeoffLineItemOptions;
}

export function newDesignPackageProductCardPage_MaterialVariantData(
  data: DesignPackageProductCardPage_MaterialVariantDataOptions,
): DesignPackageProductCardPage_MaterialVariantQuery {
  return {
    __typename: "Query" as const,
    materialVariant: maybeNew("MaterialVariant", data["materialVariant"] || undefined, {}),
    takeoffLineItem: maybeNew("TakeoffLineItem", data["takeoffLineItem"] || undefined, {}),
  } as any;
}

export function newDesignPackageProductCardPage_MaterialVariantResponse(
  variables: DesignPackageProductCardPage_MaterialVariantQueryVariables,
  data: DesignPackageProductCardPage_MaterialVariantDataOptions | Error,
): MockedResponse<
  DesignPackageProductCardPage_MaterialVariantQueryVariables,
  DesignPackageProductCardPage_MaterialVariantQuery
> {
  return {
    request: { query: DesignPackageProductCardPage_MaterialVariantDocument, variables },
    result: { data: data instanceof Error ? undefined : newDesignPackageProductCardPage_MaterialVariantData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DesignPackageProductCardPage_ProductTliDataOptions {
  takeoffLineItem?: TakeoffLineItem | TakeoffLineItemOptions;
}

export function newDesignPackageProductCardPage_ProductTliData(
  data: DesignPackageProductCardPage_ProductTliDataOptions,
): DesignPackageProductCardPage_ProductTliQuery {
  return {
    __typename: "Query" as const,
    takeoffLineItem: maybeNew("TakeoffLineItem", data["takeoffLineItem"] || undefined, {}),
  } as any;
}

export function newDesignPackageProductCardPage_ProductTliResponse(
  variables: DesignPackageProductCardPage_ProductTliQueryVariables,
  data: DesignPackageProductCardPage_ProductTliDataOptions | Error,
): MockedResponse<DesignPackageProductCardPage_ProductTliQueryVariables, DesignPackageProductCardPage_ProductTliQuery> {
  return {
    request: { query: DesignPackageProductCardPage_ProductTliDocument, variables },
    result: { data: data instanceof Error ? undefined : newDesignPackageProductCardPage_ProductTliData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DesignPackageProductCardPage_OptionCombinationsDataOptions {
  designPackage?: DesignPackage | DesignPackageOptions;
  placeholderCombinations?: (PlaceholderCombinationsResult | PlaceholderCombinationsResultOptions)[];
}

export function newDesignPackageProductCardPage_OptionCombinationsData(
  data: DesignPackageProductCardPage_OptionCombinationsDataOptions,
): DesignPackageProductCardPage_OptionCombinationsQuery {
  return {
    __typename: "Query" as const,
    designPackage: maybeNew("DesignPackage", data["designPackage"] || undefined, {}),
    placeholderCombinations: data["placeholderCombinations"]?.map((d) => newPlaceholderCombinationsResult(d)) || [],
  } as any;
}

export function newDesignPackageProductCardPage_OptionCombinationsResponse(
  variables: DesignPackageProductCardPage_OptionCombinationsQueryVariables,
  data: DesignPackageProductCardPage_OptionCombinationsDataOptions | Error,
): MockedResponse<
  DesignPackageProductCardPage_OptionCombinationsQueryVariables,
  DesignPackageProductCardPage_OptionCombinationsQuery
> {
  return {
    request: { query: DesignPackageProductCardPage_OptionCombinationsDocument, variables },
    result: { data: data instanceof Error ? undefined : newDesignPackageProductCardPage_OptionCombinationsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DesignPackageProductCardPage_SaveTakeoffLineItemDataOptions {
  saveTakeoffLineItems?: SaveTakeoffLineItemResult | SaveTakeoffLineItemResultOptions;
}

export function newDesignPackageProductCardPage_SaveTakeoffLineItemData(
  data: DesignPackageProductCardPage_SaveTakeoffLineItemDataOptions,
): DesignPackageProductCardPage_SaveTakeoffLineItemMutation {
  return {
    __typename: "Mutation" as const,
    saveTakeoffLineItems: maybeNew("SaveTakeoffLineItemResult", data["saveTakeoffLineItems"] || undefined, {}),
  } as any;
}

export function newDesignPackageProductCardPage_SaveTakeoffLineItemResponse(
  variables: DesignPackageProductCardPage_SaveTakeoffLineItemMutationVariables,
  data: DesignPackageProductCardPage_SaveTakeoffLineItemDataOptions | Error,
): MockedResponse<
  DesignPackageProductCardPage_SaveTakeoffLineItemMutationVariables,
  DesignPackageProductCardPage_SaveTakeoffLineItemMutation
> {
  return {
    request: { query: DesignPackageProductCardPage_SaveTakeoffLineItemDocument, variables },
    result: { data: data instanceof Error ? undefined : newDesignPackageProductCardPage_SaveTakeoffLineItemData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface FinishScheduleDesignPackageDataOptions {
  designPackage?: DesignPackage | DesignPackageOptions;
}

export function newFinishScheduleDesignPackageData(
  data: FinishScheduleDesignPackageDataOptions,
): FinishScheduleDesignPackageQuery {
  return {
    __typename: "Query" as const,
    designPackage: maybeNew("DesignPackage", data["designPackage"] || undefined, {}),
  } as any;
}

export function newFinishScheduleDesignPackageResponse(
  variables: FinishScheduleDesignPackageQueryVariables,
  data: FinishScheduleDesignPackageDataOptions | Error,
): MockedResponse<FinishScheduleDesignPackageQueryVariables, FinishScheduleDesignPackageQuery> {
  return {
    request: { query: FinishScheduleDesignPackageDocument, variables },
    result: { data: data instanceof Error ? undefined : newFinishScheduleDesignPackageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface FinishScheduleDesignPackageTlisDataOptions {
  designPackageFinishSchedule?: DesignPackageFinishSchedulePageResult | DesignPackageFinishSchedulePageResultOptions;
}

export function newFinishScheduleDesignPackageTlisData(
  data: FinishScheduleDesignPackageTlisDataOptions,
): FinishScheduleDesignPackageTlisQuery {
  return {
    __typename: "Query" as const,
    designPackageFinishSchedule: maybeNew(
      "DesignPackageFinishSchedulePageResult",
      data["designPackageFinishSchedule"] || undefined,
      {},
    ),
  } as any;
}

export function newFinishScheduleDesignPackageTlisResponse(
  variables: FinishScheduleDesignPackageTlisQueryVariables,
  data: FinishScheduleDesignPackageTlisDataOptions | Error,
): MockedResponse<FinishScheduleDesignPackageTlisQueryVariables, FinishScheduleDesignPackageTlisQuery> {
  return {
    request: { query: FinishScheduleDesignPackageTlisDocument, variables },
    result: { data: data instanceof Error ? undefined : newFinishScheduleDesignPackageTlisData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface FinishScheduleDesignPackageMetadataDataOptions {
  designPackage?: DesignPackage | DesignPackageOptions;
}

export function newFinishScheduleDesignPackageMetadataData(
  data: FinishScheduleDesignPackageMetadataDataOptions,
): FinishScheduleDesignPackageMetadataQuery {
  return {
    __typename: "Query" as const,
    designPackage: maybeNew("DesignPackage", data["designPackage"] || undefined, {}),
  } as any;
}

export function newFinishScheduleDesignPackageMetadataResponse(
  variables: FinishScheduleDesignPackageMetadataQueryVariables,
  data: FinishScheduleDesignPackageMetadataDataOptions | Error,
): MockedResponse<FinishScheduleDesignPackageMetadataQueryVariables, FinishScheduleDesignPackageMetadataQuery> {
  return {
    request: { query: FinishScheduleDesignPackageMetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newFinishScheduleDesignPackageMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DesignPackagePersonalizationGroupsPageDataOptions {
  designPackage?: DesignPackage | DesignPackageOptions;
  enumDetails?: AllEnumDetails | AllEnumDetailsOptions;
}

export function newDesignPackagePersonalizationGroupsPageData(
  data: DesignPackagePersonalizationGroupsPageDataOptions,
): DesignPackagePersonalizationGroupsPageQuery {
  return {
    __typename: "Query" as const,
    designPackage: maybeNew("DesignPackage", data["designPackage"] || undefined, {}),
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
  } as any;
}

export function newDesignPackagePersonalizationGroupsPageResponse(
  variables: DesignPackagePersonalizationGroupsPageQueryVariables,
  data: DesignPackagePersonalizationGroupsPageDataOptions | Error,
): MockedResponse<DesignPackagePersonalizationGroupsPageQueryVariables, DesignPackagePersonalizationGroupsPageQuery> {
  return {
    request: { query: DesignPackagePersonalizationGroupsPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newDesignPackagePersonalizationGroupsPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeactivatePersonalizationGroupDataOptions {
  savePersonalizationOptionGroup?: SavePersonalizationOptionGroupResult | SavePersonalizationOptionGroupResultOptions;
}

export function newDeactivatePersonalizationGroupData(
  data: DeactivatePersonalizationGroupDataOptions,
): DeactivatePersonalizationGroupMutation {
  return {
    __typename: "Mutation" as const,
    savePersonalizationOptionGroup: maybeNew(
      "SavePersonalizationOptionGroupResult",
      data["savePersonalizationOptionGroup"] || undefined,
      {},
    ),
  } as any;
}

export function newDeactivatePersonalizationGroupResponse(
  variables: DeactivatePersonalizationGroupMutationVariables,
  data: DeactivatePersonalizationGroupDataOptions | Error,
): MockedResponse<DeactivatePersonalizationGroupMutationVariables, DeactivatePersonalizationGroupMutation> {
  return {
    request: { query: DeactivatePersonalizationGroupDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeactivatePersonalizationGroupData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DesignPackageVersionHistoryDataOptions {
  readyPlanAggregateVersionsPage?: ReadyPlanAggregateVersionsPageResult | ReadyPlanAggregateVersionsPageResultOptions;
}

export function newDesignPackageVersionHistoryData(
  data: DesignPackageVersionHistoryDataOptions,
): DesignPackageVersionHistoryQuery {
  return {
    __typename: "Query" as const,
    readyPlanAggregateVersionsPage: maybeNew(
      "ReadyPlanAggregateVersionsPageResult",
      data["readyPlanAggregateVersionsPage"] || undefined,
      {},
    ),
  } as any;
}

export function newDesignPackageVersionHistoryResponse(
  variables: DesignPackageVersionHistoryQueryVariables,
  data: DesignPackageVersionHistoryDataOptions | Error,
): MockedResponse<DesignPackageVersionHistoryQueryVariables, DesignPackageVersionHistoryQuery> {
  return {
    request: { query: DesignPackageVersionHistoryDocument, variables },
    result: { data: data instanceof Error ? undefined : newDesignPackageVersionHistoryData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface GlobalOptionsIconsDataOptions {
  globalOptions?: (GlobalOption | GlobalOptionOptions)[];
}

export function newGlobalOptionsIconsData(data: GlobalOptionsIconsDataOptions): GlobalOptionsIconsQuery {
  return {
    __typename: "Query" as const,
    globalOptions: data["globalOptions"]?.map((d) => newGlobalOption(d)) || [],
  } as any;
}

export function newGlobalOptionsIconsResponse(
  variables: GlobalOptionsIconsQueryVariables,
  data: GlobalOptionsIconsDataOptions | Error,
): MockedResponse<GlobalOptionsIconsQueryVariables, GlobalOptionsIconsQuery> {
  return {
    request: { query: GlobalOptionsIconsDocument, variables },
    result: { data: data instanceof Error ? undefined : newGlobalOptionsIconsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidItemSuperDrawerDetailsDataOptions {
  bidItems?: (BidItem | BidItemOptions)[];
  items?: (Item | ItemOptions)[];
  unitsOfMeasure?: (UnitOfMeasure | UnitOfMeasureOptions)[];
  costTypes?: (CostTypeDetail | CostTypeDetailOptions)[];
}

export function newBidItemSuperDrawerDetailsData(
  data: BidItemSuperDrawerDetailsDataOptions,
): BidItemSuperDrawerDetailsQuery {
  return {
    __typename: "Query" as const,
    bidItems: data["bidItems"]?.map((d) => newBidItem(d)) || [],
    items: data["items"]?.map((d) => newItem(d)) || [],
    unitsOfMeasure: data["unitsOfMeasure"]?.map((d) => newUnitOfMeasure(d)) || [],
    costTypes: data["costTypes"]?.map((d) => newCostTypeDetail(d)) || [],
  } as any;
}

export function newBidItemSuperDrawerDetailsResponse(
  variables: BidItemSuperDrawerDetailsQueryVariables,
  data: BidItemSuperDrawerDetailsDataOptions | Error,
): MockedResponse<BidItemSuperDrawerDetailsQueryVariables, BidItemSuperDrawerDetailsQuery> {
  return {
    request: { query: BidItemSuperDrawerDetailsDocument, variables },
    result: { data: data instanceof Error ? undefined : newBidItemSuperDrawerDetailsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidItemAttributesDataOptions {
  attributes?: (ProductAttribute | ProductAttributeOptions)[];
  costTypes?: (CostTypeDetail | CostTypeDetailOptions)[];
}

export function newBidItemAttributesData(data: BidItemAttributesDataOptions): BidItemAttributesQuery {
  return {
    __typename: "Query" as const,
    attributes: data["attributes"]?.map((d) => newProductAttribute(d)) || [],
    costTypes: data["costTypes"]?.map((d) => newCostTypeDetail(d)) || [],
  } as any;
}

export function newBidItemAttributesResponse(
  data: BidItemAttributesDataOptions | Error,
): MockedResponse<BidItemAttributesQueryVariables, BidItemAttributesQuery> {
  return {
    request: { query: BidItemAttributesDocument },
    result: { data: data instanceof Error ? undefined : newBidItemAttributesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MaterialListingHistoryDataOptions {
  materialListings?: MaterialListingsPage | MaterialListingsPageOptions;
}

export function newMaterialListingHistoryData(data: MaterialListingHistoryDataOptions): MaterialListingHistoryQuery {
  return {
    __typename: "Query" as const,
    materialListings: maybeNew("MaterialListingsPage", data["materialListings"] || undefined, {}),
  } as any;
}

export function newMaterialListingHistoryResponse(
  variables: MaterialListingHistoryQueryVariables,
  data: MaterialListingHistoryDataOptions | Error,
): MockedResponse<MaterialListingHistoryQueryVariables, MaterialListingHistoryQuery> {
  return {
    request: { query: MaterialListingHistoryDocument, variables },
    result: { data: data instanceof Error ? undefined : newMaterialListingHistoryData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanPackagesDataOptions {
  planPackages?: PlanPackagesPageResult | PlanPackagesPageResultOptions;
}

export function newPlanPackagesData(data: PlanPackagesDataOptions): PlanPackagesQuery {
  return {
    __typename: "Query" as const,
    planPackages: maybeNew("PlanPackagesPageResult", data["planPackages"] || undefined, {}),
  } as any;
}

export function newPlanPackagesResponse(
  variables: PlanPackagesQueryVariables,
  data: PlanPackagesDataOptions | Error,
): MockedResponse<PlanPackagesQueryVariables, PlanPackagesQuery> {
  return {
    request: { query: PlanPackagesDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanPackagesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface InstallTasksPageDataOptions {
  items?: (Item | ItemOptions)[];
  locations?: (Location | LocationOptions)[];
  globalPlanTasks?: GlobalPlanTasksPageResult | GlobalPlanTasksPageResultOptions;
}

export function newInstallTasksPageData(data: InstallTasksPageDataOptions): InstallTasksPageQuery {
  return {
    __typename: "Query" as const,
    items: data["items"]?.map((d) => newItem(d)) || [],
    locations: data["locations"]?.map((d) => newLocation(d)) || [],
    globalPlanTasks: maybeNew("GlobalPlanTasksPageResult", data["globalPlanTasks"] || undefined, {}),
  } as any;
}

export function newInstallTasksPageResponse(
  data: InstallTasksPageDataOptions | Error,
): MockedResponse<InstallTasksPageQueryVariables, InstallTasksPageQuery> {
  return {
    request: { query: InstallTasksPageDocument },
    result: { data: data instanceof Error ? undefined : newInstallTasksPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ItemPlanTaskMappingsDataOptions {
  itemPlanTaskMappingPage?: ItemPlanTaskMappingPage | ItemPlanTaskMappingPageOptions;
}

export function newItemPlanTaskMappingsData(data: ItemPlanTaskMappingsDataOptions): ItemPlanTaskMappingsQuery {
  return {
    __typename: "Query" as const,
    itemPlanTaskMappingPage: maybeNew("ItemPlanTaskMappingPage", data["itemPlanTaskMappingPage"] || undefined, {}),
  } as any;
}

export function newItemPlanTaskMappingsResponse(
  variables: ItemPlanTaskMappingsQueryVariables,
  data: ItemPlanTaskMappingsDataOptions | Error,
): MockedResponse<ItemPlanTaskMappingsQueryVariables, ItemPlanTaskMappingsQuery> {
  return {
    request: { query: ItemPlanTaskMappingsDocument, variables },
    result: { data: data instanceof Error ? undefined : newItemPlanTaskMappingsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveItemPlanTaskMappingDataOptions {
  saveItemPlanTaskMapping?: SaveItemPlanTaskMappingResult | SaveItemPlanTaskMappingResultOptions;
}

export function newSaveItemPlanTaskMappingData(
  data: SaveItemPlanTaskMappingDataOptions,
): SaveItemPlanTaskMappingMutation {
  return {
    __typename: "Mutation" as const,
    saveItemPlanTaskMapping: maybeNew(
      "SaveItemPlanTaskMappingResult",
      data["saveItemPlanTaskMapping"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveItemPlanTaskMappingResponse(
  variables: SaveItemPlanTaskMappingMutationVariables,
  data: SaveItemPlanTaskMappingDataOptions | Error,
): MockedResponse<SaveItemPlanTaskMappingMutationVariables, SaveItemPlanTaskMappingMutation> {
  return {
    request: { query: SaveItemPlanTaskMappingDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveItemPlanTaskMappingData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteItemPlanTaskMappingDataOptions {
  deleteItemPlanTaskMapping?: EmptyResult | EmptyResultOptions;
}

export function newDeleteItemPlanTaskMappingData(
  data: DeleteItemPlanTaskMappingDataOptions,
): DeleteItemPlanTaskMappingMutation {
  return {
    __typename: "Mutation" as const,
    deleteItemPlanTaskMapping: maybeNew("EmptyResult", data["deleteItemPlanTaskMapping"] || undefined, {}),
  } as any;
}

export function newDeleteItemPlanTaskMappingResponse(
  variables: DeleteItemPlanTaskMappingMutationVariables,
  data: DeleteItemPlanTaskMappingDataOptions | Error,
): MockedResponse<DeleteItemPlanTaskMappingMutationVariables, DeleteItemPlanTaskMappingMutation> {
  return {
    request: { query: DeleteItemPlanTaskMappingDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteItemPlanTaskMappingData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanPackagePageMetadataDataOptions {
  planPackage?: PlanPackage | PlanPackageOptions;
  globalOptionTypes?: (GlobalOptionType | GlobalOptionTypeOptions)[];
  locations?: (Location | LocationOptions)[];
  globalOptionTags?: (GlobalOptionTag | GlobalOptionTagOptions)[];
  readyPlanStatuses?: (ReadyPlanStatusDetail | ReadyPlanStatusDetailOptions)[];
  currentUser?: User | UserOptions | null;
}

export function newPlanPackagePageMetadataData(data: PlanPackagePageMetadataDataOptions): PlanPackagePageMetadataQuery {
  return {
    __typename: "Query" as const,
    planPackage: maybeNew("PlanPackage", data["planPackage"] || undefined, {}),
    globalOptionTypes: data["globalOptionTypes"]?.map((d) => newGlobalOptionType(d)) || [],
    locations: data["locations"]?.map((d) => newLocation(d)) || [],
    globalOptionTags: data["globalOptionTags"]?.map((d) => newGlobalOptionTag(d)) || [],
    readyPlanStatuses: data["readyPlanStatuses"]?.map((d) => newReadyPlanStatusDetail(d)) || [],
    currentUser: maybeNewOrNull("User", data["currentUser"] || undefined, {}),
  } as any;
}

export function newPlanPackagePageMetadataResponse(
  variables: PlanPackagePageMetadataQueryVariables,
  data: PlanPackagePageMetadataDataOptions | Error,
): MockedResponse<PlanPackagePageMetadataQueryVariables, PlanPackagePageMetadataQuery> {
  return {
    request: { query: PlanPackagePageMetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanPackagePageMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SavePlanPackageDataOptions {
  savePlanPackage?: SavePlanPackageResult | SavePlanPackageResultOptions;
}

export function newSavePlanPackageData(data: SavePlanPackageDataOptions): SavePlanPackageMutation {
  return {
    __typename: "Mutation" as const,
    savePlanPackage: maybeNew("SavePlanPackageResult", data["savePlanPackage"] || undefined, {}),
  } as any;
}

export function newSavePlanPackageResponse(
  variables: SavePlanPackageMutationVariables,
  data: SavePlanPackageDataOptions | Error,
): MockedResponse<SavePlanPackageMutationVariables, SavePlanPackageMutation> {
  return {
    request: { query: SavePlanPackageDocument, variables },
    result: { data: data instanceof Error ? undefined : newSavePlanPackageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CopyPlanPackageDataOptions {
  copyPlanPackage?: SavePlanPackageResult | SavePlanPackageResultOptions;
}

export function newCopyPlanPackageData(data: CopyPlanPackageDataOptions): CopyPlanPackageMutation {
  return {
    __typename: "Mutation" as const,
    copyPlanPackage: maybeNew("SavePlanPackageResult", data["copyPlanPackage"] || undefined, {}),
  } as any;
}

export function newCopyPlanPackageResponse(
  variables: CopyPlanPackageMutationVariables,
  data: CopyPlanPackageDataOptions | Error,
): MockedResponse<CopyPlanPackageMutationVariables, CopyPlanPackageMutation> {
  return {
    request: { query: CopyPlanPackageDocument, variables },
    result: { data: data instanceof Error ? undefined : newCopyPlanPackageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanPackageDetailsStepDataOptions {
  planPackage?: PlanPackage | PlanPackageOptions;
}

export function newPlanPackageDetailsStepData(data: PlanPackageDetailsStepDataOptions): PlanPackageDetailsStepQuery {
  return {
    __typename: "Query" as const,
    planPackage: maybeNew("PlanPackage", data["planPackage"] || undefined, {}),
  } as any;
}

export function newPlanPackageDetailsStepResponse(
  variables: PlanPackageDetailsStepQueryVariables,
  data: PlanPackageDetailsStepDataOptions | Error,
): MockedResponse<PlanPackageDetailsStepQueryVariables, PlanPackageDetailsStepQuery> {
  return {
    request: { query: PlanPackageDetailsStepDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanPackageDetailsStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SavePlanPackageDetailsDataOptions {
  savePlanPackage?: SavePlanPackageResult | SavePlanPackageResultOptions;
}

export function newSavePlanPackageDetailsData(data: SavePlanPackageDetailsDataOptions): SavePlanPackageDetailsMutation {
  return {
    __typename: "Mutation" as const,
    savePlanPackage: maybeNew("SavePlanPackageResult", data["savePlanPackage"] || undefined, {}),
  } as any;
}

export function newSavePlanPackageDetailsResponse(
  variables: SavePlanPackageDetailsMutationVariables,
  data: SavePlanPackageDetailsDataOptions | Error,
): MockedResponse<SavePlanPackageDetailsMutationVariables, SavePlanPackageDetailsMutation> {
  return {
    request: { query: SavePlanPackageDetailsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSavePlanPackageDetailsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BusinessFunctionTypeDataOptions {
  enumDetails?: AllEnumDetails | AllEnumDetailsOptions;
}

export function newBusinessFunctionTypeData(data: BusinessFunctionTypeDataOptions): BusinessFunctionTypeQuery {
  return {
    __typename: "Query" as const,
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
  } as any;
}

export function newBusinessFunctionTypeResponse(
  data: BusinessFunctionTypeDataOptions | Error,
): MockedResponse<BusinessFunctionTypeQueryVariables, BusinessFunctionTypeQuery> {
  return {
    request: { query: BusinessFunctionTypeDocument },
    result: { data: data instanceof Error ? undefined : newBusinessFunctionTypeData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveGlobalPlanMilestoneGroupDataOptions {
  saveGlobalPlanMilestoneGroup?: SaveGlobalPlanMilestoneGroupResult | SaveGlobalPlanMilestoneGroupResultOptions;
}

export function newSaveGlobalPlanMilestoneGroupData(
  data: SaveGlobalPlanMilestoneGroupDataOptions,
): SaveGlobalPlanMilestoneGroupMutation {
  return {
    __typename: "Mutation" as const,
    saveGlobalPlanMilestoneGroup: maybeNew(
      "SaveGlobalPlanMilestoneGroupResult",
      data["saveGlobalPlanMilestoneGroup"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveGlobalPlanMilestoneGroupResponse(
  variables: SaveGlobalPlanMilestoneGroupMutationVariables,
  data: SaveGlobalPlanMilestoneGroupDataOptions | Error,
): MockedResponse<SaveGlobalPlanMilestoneGroupMutationVariables, SaveGlobalPlanMilestoneGroupMutation> {
  return {
    request: { query: SaveGlobalPlanMilestoneGroupDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveGlobalPlanMilestoneGroupData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanPackageLocationStepDataOptions {
  planPackage?: PlanPackage | PlanPackageOptions;
  levels?: (Location | LocationOptions)[];
}

export function newPlanPackageLocationStepData(data: PlanPackageLocationStepDataOptions): PlanPackageLocationStepQuery {
  return {
    __typename: "Query" as const,
    planPackage: maybeNew("PlanPackage", data["planPackage"] || undefined, {}),
    levels: data["levels"]?.map((d) => newLocation(d)) || [],
  } as any;
}

export function newPlanPackageLocationStepResponse(
  variables: PlanPackageLocationStepQueryVariables,
  data: PlanPackageLocationStepDataOptions | Error,
): MockedResponse<PlanPackageLocationStepQueryVariables, PlanPackageLocationStepQuery> {
  return {
    request: { query: PlanPackageLocationStepDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanPackageLocationStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BulkSaveRplsDataOptions {
  saveReadyPlanLocations?: SaveReadyPlanLocationBulkResult | SaveReadyPlanLocationBulkResultOptions;
}

export function newBulkSaveRplsData(data: BulkSaveRplsDataOptions): BulkSaveRplsMutation {
  return {
    __typename: "Mutation" as const,
    saveReadyPlanLocations: maybeNew(
      "SaveReadyPlanLocationBulkResult",
      data["saveReadyPlanLocations"] || undefined,
      {},
    ),
  } as any;
}

export function newBulkSaveRplsResponse(
  variables: BulkSaveRplsMutationVariables,
  data: BulkSaveRplsDataOptions | Error,
): MockedResponse<BulkSaveRplsMutationVariables, BulkSaveRplsMutation> {
  return {
    request: { query: BulkSaveRplsDocument, variables },
    result: { data: data instanceof Error ? undefined : newBulkSaveRplsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProgramDataStepMetadataDataOptions {
  planPackage?: PlanPackage | PlanPackageOptions;
  enumDetails?: AllEnumDetails | AllEnumDetailsOptions;
}

export function newProgramDataStepMetadataData(data: ProgramDataStepMetadataDataOptions): ProgramDataStepMetadataQuery {
  return {
    __typename: "Query" as const,
    planPackage: maybeNew("PlanPackage", data["planPackage"] || undefined, {}),
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
  } as any;
}

export function newProgramDataStepMetadataResponse(
  variables: ProgramDataStepMetadataQueryVariables,
  data: ProgramDataStepMetadataDataOptions | Error,
): MockedResponse<ProgramDataStepMetadataQueryVariables, ProgramDataStepMetadataQuery> {
  return {
    request: { query: ProgramDataStepMetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newProgramDataStepMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveElevationsDataOptions {
  saveReadyPlanOptions?: SaveReadyPlanOptionsResult | SaveReadyPlanOptionsResultOptions;
}

export function newSaveElevationsData(data: SaveElevationsDataOptions): SaveElevationsMutation {
  return {
    __typename: "Mutation" as const,
    saveReadyPlanOptions: maybeNew("SaveReadyPlanOptionsResult", data["saveReadyPlanOptions"] || undefined, {}),
  } as any;
}

export function newSaveElevationsResponse(
  variables: SaveElevationsMutationVariables,
  data: SaveElevationsDataOptions | Error,
): MockedResponse<SaveElevationsMutationVariables, SaveElevationsMutation> {
  return {
    request: { query: SaveElevationsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveElevationsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveReadyPlanOptionGroupDataOptions {
  saveReadyPlanOptionGroup?: SaveReadyPlanOptionGroupResult | SaveReadyPlanOptionGroupResultOptions;
}

export function newSaveReadyPlanOptionGroupData(
  data: SaveReadyPlanOptionGroupDataOptions,
): SaveReadyPlanOptionGroupMutation {
  return {
    __typename: "Mutation" as const,
    saveReadyPlanOptionGroup: maybeNew(
      "SaveReadyPlanOptionGroupResult",
      data["saveReadyPlanOptionGroup"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveReadyPlanOptionGroupResponse(
  variables: SaveReadyPlanOptionGroupMutationVariables,
  data: SaveReadyPlanOptionGroupDataOptions | Error,
): MockedResponse<SaveReadyPlanOptionGroupMutationVariables, SaveReadyPlanOptionGroupMutation> {
  return {
    request: { query: SaveReadyPlanOptionGroupDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveReadyPlanOptionGroupData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanPackage_AddOptionsPageDataOptions {
  planPackage?: PlanPackage | PlanPackageOptions;
}

export function newPlanPackage_AddOptionsPageData(
  data: PlanPackage_AddOptionsPageDataOptions,
): PlanPackage_AddOptionsPageQuery {
  return {
    __typename: "Query" as const,
    planPackage: maybeNew("PlanPackage", data["planPackage"] || undefined, {}),
  } as any;
}

export function newPlanPackage_AddOptionsPageResponse(
  variables: PlanPackage_AddOptionsPageQueryVariables,
  data: PlanPackage_AddOptionsPageDataOptions | Error,
): MockedResponse<PlanPackage_AddOptionsPageQueryVariables, PlanPackage_AddOptionsPageQuery> {
  return {
    request: { query: PlanPackage_AddOptionsPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanPackage_AddOptionsPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanPackage_SaveReadyPlanOptionsDataOptions {
  savePlanPackage?: SavePlanPackageResult | SavePlanPackageResultOptions;
}

export function newPlanPackage_SaveReadyPlanOptionsData(
  data: PlanPackage_SaveReadyPlanOptionsDataOptions,
): PlanPackage_SaveReadyPlanOptionsMutation {
  return {
    __typename: "Mutation" as const,
    savePlanPackage: maybeNew("SavePlanPackageResult", data["savePlanPackage"] || undefined, {}),
  } as any;
}

export function newPlanPackage_SaveReadyPlanOptionsResponse(
  variables: PlanPackage_SaveReadyPlanOptionsMutationVariables,
  data: PlanPackage_SaveReadyPlanOptionsDataOptions | Error,
): MockedResponse<PlanPackage_SaveReadyPlanOptionsMutationVariables, PlanPackage_SaveReadyPlanOptionsMutation> {
  return {
    request: { query: PlanPackage_SaveReadyPlanOptionsDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanPackage_SaveReadyPlanOptionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanPackageTakeoffPageDataOptions {
  planPackage?: PlanPackage | PlanPackageOptions;
}

export function newPlanPackageTakeoffPageData(data: PlanPackageTakeoffPageDataOptions): PlanPackageTakeoffPageQuery {
  return {
    __typename: "Query" as const,
    planPackage: maybeNew("PlanPackage", data["planPackage"] || undefined, {}),
  } as any;
}

export function newPlanPackageTakeoffPageResponse(
  variables: PlanPackageTakeoffPageQueryVariables,
  data: PlanPackageTakeoffPageDataOptions | Error,
): MockedResponse<PlanPackageTakeoffPageQueryVariables, PlanPackageTakeoffPageQuery> {
  return {
    request: { query: PlanPackageTakeoffPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanPackageTakeoffPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanPackageVersionHistoryDataOptions {
  readyPlanAggregateVersionsPage?: ReadyPlanAggregateVersionsPageResult | ReadyPlanAggregateVersionsPageResultOptions;
}

export function newPlanPackageVersionHistoryData(
  data: PlanPackageVersionHistoryDataOptions,
): PlanPackageVersionHistoryQuery {
  return {
    __typename: "Query" as const,
    readyPlanAggregateVersionsPage: maybeNew(
      "ReadyPlanAggregateVersionsPageResult",
      data["readyPlanAggregateVersionsPage"] || undefined,
      {},
    ),
  } as any;
}

export function newPlanPackageVersionHistoryResponse(
  variables: PlanPackageVersionHistoryQueryVariables,
  data: PlanPackageVersionHistoryDataOptions | Error,
): MockedResponse<PlanPackageVersionHistoryQueryVariables, PlanPackageVersionHistoryQuery> {
  return {
    request: { query: PlanPackageVersionHistoryDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanPackageVersionHistoryData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanPackageTakeoffSideBarDataOptions {
  planPackage?: PlanPackage | PlanPackageOptions;
}

export function newPlanPackageTakeoffSideBarData(
  data: PlanPackageTakeoffSideBarDataOptions,
): PlanPackageTakeoffSideBarQuery {
  return {
    __typename: "Query" as const,
    planPackage: maybeNew("PlanPackage", data["planPackage"] || undefined, {}),
  } as any;
}

export function newPlanPackageTakeoffSideBarResponse(
  variables: PlanPackageTakeoffSideBarQueryVariables,
  data: PlanPackageTakeoffSideBarDataOptions | Error,
): MockedResponse<PlanPackageTakeoffSideBarQueryVariables, PlanPackageTakeoffSideBarQuery> {
  return {
    request: { query: PlanPackageTakeoffSideBarDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanPackageTakeoffSideBarData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TakeoffsStore_SaveTakeoffLineItemsDataOptions {
  saveTakeoffLineItems?: SaveTakeoffLineItemResult | SaveTakeoffLineItemResultOptions;
}

export function newTakeoffsStore_SaveTakeoffLineItemsData(
  data: TakeoffsStore_SaveTakeoffLineItemsDataOptions,
): TakeoffsStore_SaveTakeoffLineItemsMutation {
  return {
    __typename: "Mutation" as const,
    saveTakeoffLineItems: maybeNew("SaveTakeoffLineItemResult", data["saveTakeoffLineItems"] || undefined, {}),
  } as any;
}

export function newTakeoffsStore_SaveTakeoffLineItemsResponse(
  variables: TakeoffsStore_SaveTakeoffLineItemsMutationVariables,
  data: TakeoffsStore_SaveTakeoffLineItemsDataOptions | Error,
): MockedResponse<TakeoffsStore_SaveTakeoffLineItemsMutationVariables, TakeoffsStore_SaveTakeoffLineItemsMutation> {
  return {
    request: { query: TakeoffsStore_SaveTakeoffLineItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newTakeoffsStore_SaveTakeoffLineItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TakeoffsStore_CopyTakeoffLineItemsDataOptions {
  copyTakeoffLineItems?: CopyTakeoffLineItemsResult | CopyTakeoffLineItemsResultOptions;
}

export function newTakeoffsStore_CopyTakeoffLineItemsData(
  data: TakeoffsStore_CopyTakeoffLineItemsDataOptions,
): TakeoffsStore_CopyTakeoffLineItemsMutation {
  return {
    __typename: "Mutation" as const,
    copyTakeoffLineItems: maybeNew("CopyTakeoffLineItemsResult", data["copyTakeoffLineItems"] || undefined, {}),
  } as any;
}

export function newTakeoffsStore_CopyTakeoffLineItemsResponse(
  variables: TakeoffsStore_CopyTakeoffLineItemsMutationVariables,
  data: TakeoffsStore_CopyTakeoffLineItemsDataOptions | Error,
): MockedResponse<TakeoffsStore_CopyTakeoffLineItemsMutationVariables, TakeoffsStore_CopyTakeoffLineItemsMutation> {
  return {
    request: { query: TakeoffsStore_CopyTakeoffLineItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newTakeoffsStore_CopyTakeoffLineItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProductAttributesDataOptions {
  attributes?: (ProductAttribute | ProductAttributeOptions)[];
  productStatuses?: (ProductStatusDetail | ProductStatusDetailOptions)[];
}

export function newProductAttributesData(data: ProductAttributesDataOptions): ProductAttributesQuery {
  return {
    __typename: "Query" as const,
    attributes: data["attributes"]?.map((d) => newProductAttribute(d)) || [],
    productStatuses: data["productStatuses"]?.map((d) => newProductStatusDetail(d)) || [],
  } as any;
}

export function newProductAttributesResponse(
  data: ProductAttributesDataOptions | Error,
): MockedResponse<ProductAttributesQueryVariables, ProductAttributesQuery> {
  return {
    request: { query: ProductAttributesDocument },
    result: { data: data instanceof Error ? undefined : newProductAttributesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CheckoutPricingTracePage_OverviewDataOptions {
  checkoutPricingTrace?: CheckoutPricingTrace | CheckoutPricingTraceOptions;
}

export function newCheckoutPricingTracePage_OverviewData(
  data: CheckoutPricingTracePage_OverviewDataOptions,
): CheckoutPricingTracePage_OverviewQuery {
  return {
    __typename: "Query" as const,
    checkoutPricingTrace: maybeNew("CheckoutPricingTrace", data["checkoutPricingTrace"] || undefined, {}),
  } as any;
}

export function newCheckoutPricingTracePage_OverviewResponse(
  variables: CheckoutPricingTracePage_OverviewQueryVariables,
  data: CheckoutPricingTracePage_OverviewDataOptions | Error,
): MockedResponse<CheckoutPricingTracePage_OverviewQueryVariables, CheckoutPricingTracePage_OverviewQuery> {
  return {
    request: { query: CheckoutPricingTracePage_OverviewDocument, variables },
    result: { data: data instanceof Error ? undefined : newCheckoutPricingTracePage_OverviewData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CheckoutPricingTraceGroupDetailDataOptions {
  calculateScopeChange?: CalculateScopeChangeResult | CalculateScopeChangeResultOptions;
}

export function newCheckoutPricingTraceGroupDetailData(
  data: CheckoutPricingTraceGroupDetailDataOptions,
): CheckoutPricingTraceGroupDetailQuery {
  return {
    __typename: "Query" as const,
    calculateScopeChange: maybeNew("CalculateScopeChangeResult", data["calculateScopeChange"] || undefined, {}),
  } as any;
}

export function newCheckoutPricingTraceGroupDetailResponse(
  variables: CheckoutPricingTraceGroupDetailQueryVariables,
  data: CheckoutPricingTraceGroupDetailDataOptions | Error,
): MockedResponse<CheckoutPricingTraceGroupDetailQueryVariables, CheckoutPricingTraceGroupDetailQuery> {
  return {
    request: { query: CheckoutPricingTraceGroupDetailDocument, variables },
    result: { data: data instanceof Error ? undefined : newCheckoutPricingTraceGroupDetailData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveGlobalPlanTagDataOptions {
  saveGlobalPlanTag?: SaveGlobalPlanTagResult | SaveGlobalPlanTagResultOptions;
}

export function newSaveGlobalPlanTagData(data: SaveGlobalPlanTagDataOptions): SaveGlobalPlanTagMutation {
  return {
    __typename: "Mutation" as const,
    saveGlobalPlanTag: maybeNew("SaveGlobalPlanTagResult", data["saveGlobalPlanTag"] || undefined, {}),
  } as any;
}

export function newSaveGlobalPlanTagResponse(
  variables: SaveGlobalPlanTagMutationVariables,
  data: SaveGlobalPlanTagDataOptions | Error,
): MockedResponse<SaveGlobalPlanTagMutationVariables, SaveGlobalPlanTagMutation> {
  return {
    request: { query: SaveGlobalPlanTagDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveGlobalPlanTagData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveGlobalPlanConstraintItemDataOptions {
  saveGlobalPlanConstraintItem?: SaveGlobalPlanConstraintItemResult | SaveGlobalPlanConstraintItemResultOptions;
}

export function newSaveGlobalPlanConstraintItemData(
  data: SaveGlobalPlanConstraintItemDataOptions,
): SaveGlobalPlanConstraintItemMutation {
  return {
    __typename: "Mutation" as const,
    saveGlobalPlanConstraintItem: maybeNew(
      "SaveGlobalPlanConstraintItemResult",
      data["saveGlobalPlanConstraintItem"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveGlobalPlanConstraintItemResponse(
  variables: SaveGlobalPlanConstraintItemMutationVariables,
  data: SaveGlobalPlanConstraintItemDataOptions | Error,
): MockedResponse<SaveGlobalPlanConstraintItemMutationVariables, SaveGlobalPlanConstraintItemMutation> {
  return {
    request: { query: SaveGlobalPlanConstraintItemDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveGlobalPlanConstraintItemData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddStageModalDataOptions {
  saveGlobalPlanStage?: SaveGlobalPlanStageResult | SaveGlobalPlanStageResultOptions;
}

export function newAddStageModalData(data: AddStageModalDataOptions): AddStageModalMutation {
  return {
    __typename: "Mutation" as const,
    saveGlobalPlanStage: maybeNew("SaveGlobalPlanStageResult", data["saveGlobalPlanStage"] || undefined, {}),
  } as any;
}

export function newAddStageModalResponse(
  variables: AddStageModalMutationVariables,
  data: AddStageModalDataOptions | Error,
): MockedResponse<AddStageModalMutationVariables, AddStageModalMutation> {
  return {
    request: { query: AddStageModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddStageModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface EditProductOfferingPageDataOptions {
  enumDetails?: AllEnumDetails | AllEnumDetailsOptions;
  productOffering?: ProductOffering | ProductOfferingOptions;
}

export function newEditProductOfferingPageData(data: EditProductOfferingPageDataOptions): EditProductOfferingPageQuery {
  return {
    __typename: "Query" as const,
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
    productOffering: maybeNew("ProductOffering", data["productOffering"] || undefined, {}),
  } as any;
}

export function newEditProductOfferingPageResponse(
  variables: EditProductOfferingPageQueryVariables,
  data: EditProductOfferingPageDataOptions | Error,
): MockedResponse<EditProductOfferingPageQueryVariables, EditProductOfferingPageQuery> {
  return {
    request: { query: EditProductOfferingPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newEditProductOfferingPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BulkGlobalPlanTagsModalDataOptions {
  globalPlanTags?: (GlobalPlanTag | GlobalPlanTagOptions)[];
}

export function newBulkGlobalPlanTagsModalData(data: BulkGlobalPlanTagsModalDataOptions): BulkGlobalPlanTagsModalQuery {
  return {
    __typename: "Query" as const,
    globalPlanTags: data["globalPlanTags"]?.map((d) => newGlobalPlanTag(d)) || [],
  } as any;
}

export function newBulkGlobalPlanTagsModalResponse(
  data: BulkGlobalPlanTagsModalDataOptions | Error,
): MockedResponse<BulkGlobalPlanTagsModalQueryVariables, BulkGlobalPlanTagsModalQuery> {
  return {
    request: { query: BulkGlobalPlanTagsModalDocument },
    result: { data: data instanceof Error ? undefined : newBulkGlobalPlanTagsModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BulkGlobalPlanTagsDataOptions {
  bulkSaveGlobalPlanTags?: BulkSaveGlobalPlanTagsResult | BulkSaveGlobalPlanTagsResultOptions;
}

export function newBulkGlobalPlanTagsData(data: BulkGlobalPlanTagsDataOptions): BulkGlobalPlanTagsMutation {
  return {
    __typename: "Mutation" as const,
    bulkSaveGlobalPlanTags: maybeNew("BulkSaveGlobalPlanTagsResult", data["bulkSaveGlobalPlanTags"] || undefined, {}),
  } as any;
}

export function newBulkGlobalPlanTagsResponse(
  variables: BulkGlobalPlanTagsMutationVariables,
  data: BulkGlobalPlanTagsDataOptions | Error,
): MockedResponse<BulkGlobalPlanTagsMutationVariables, BulkGlobalPlanTagsMutation> {
  return {
    request: { query: BulkGlobalPlanTagsDocument, variables },
    result: { data: data instanceof Error ? undefined : newBulkGlobalPlanTagsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TaskCatalogFormDataOptions {
  globalPlanTask?: GlobalPlanTask | GlobalPlanTaskOptions;
}

export function newTaskCatalogFormData(data: TaskCatalogFormDataOptions): TaskCatalogFormQuery {
  return {
    __typename: "Query" as const,
    globalPlanTask: maybeNew("GlobalPlanTask", data["globalPlanTask"] || undefined, {}),
  } as any;
}

export function newTaskCatalogFormResponse(
  variables: TaskCatalogFormQueryVariables,
  data: TaskCatalogFormDataOptions | Error,
): MockedResponse<TaskCatalogFormQueryVariables, TaskCatalogFormQuery> {
  return {
    request: { query: TaskCatalogFormDocument, variables },
    result: { data: data instanceof Error ? undefined : newTaskCatalogFormData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TaskCatalogFormDropdownDataOptions {
  enumDetails?: AllEnumDetails | AllEnumDetailsOptions;
  tradeCategories?: (TradeCategory | TradeCategoryOptions)[];
  globalPlanTags?: (GlobalPlanTag | GlobalPlanTagOptions)[];
  regions?: (Region | RegionOptions)[];
  items?: (Item | ItemOptions)[];
}

export function newTaskCatalogFormDropdownData(data: TaskCatalogFormDropdownDataOptions): TaskCatalogFormDropdownQuery {
  return {
    __typename: "Query" as const,
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
    tradeCategories: data["tradeCategories"]?.map((d) => newTradeCategory(d)) || [],
    globalPlanTags: data["globalPlanTags"]?.map((d) => newGlobalPlanTag(d)) || [],
    regions: data["regions"]?.map((d) => newRegion(d)) || [],
    items: data["items"]?.map((d) => newItem(d)) || [],
  } as any;
}

export function newTaskCatalogFormDropdownResponse(
  data: TaskCatalogFormDropdownDataOptions | Error,
): MockedResponse<TaskCatalogFormDropdownQueryVariables, TaskCatalogFormDropdownQuery> {
  return {
    request: { query: TaskCatalogFormDropdownDocument },
    result: { data: data instanceof Error ? undefined : newTaskCatalogFormDropdownData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TaskCatalogFormParentDropdownDataOptions {
  globalPlanTasks?: GlobalPlanTasksPageResult | GlobalPlanTasksPageResultOptions;
}

export function newTaskCatalogFormParentDropdownData(
  data: TaskCatalogFormParentDropdownDataOptions,
): TaskCatalogFormParentDropdownQuery {
  return {
    __typename: "Query" as const,
    globalPlanTasks: maybeNew("GlobalPlanTasksPageResult", data["globalPlanTasks"] || undefined, {}),
  } as any;
}

export function newTaskCatalogFormParentDropdownResponse(
  variables: TaskCatalogFormParentDropdownQueryVariables,
  data: TaskCatalogFormParentDropdownDataOptions | Error,
): MockedResponse<TaskCatalogFormParentDropdownQueryVariables, TaskCatalogFormParentDropdownQuery> {
  return {
    request: { query: TaskCatalogFormParentDropdownDocument, variables },
    result: { data: data instanceof Error ? undefined : newTaskCatalogFormParentDropdownData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TaskCatalogFormSchedulingDropdownDataOptions {
  globalPlanConstraintItems?: (GlobalPlanConstraintItem | GlobalPlanConstraintItemOptions)[];
  globalPlanStages?: (GlobalPlanStage | GlobalPlanStageOptions)[];
  projects?: (Project | ProjectOptions)[];
}

export function newTaskCatalogFormSchedulingDropdownData(
  data: TaskCatalogFormSchedulingDropdownDataOptions,
): TaskCatalogFormSchedulingDropdownQuery {
  return {
    __typename: "Query" as const,
    globalPlanConstraintItems: data["globalPlanConstraintItems"]?.map((d) => newGlobalPlanConstraintItem(d)) || [],
    globalPlanStages: data["globalPlanStages"]?.map((d) => newGlobalPlanStage(d)) || [],
    projects: data["projects"]?.map((d) => maybeNew("Project", d, {})) || [],
  } as any;
}

export function newTaskCatalogFormSchedulingDropdownResponse(
  data: TaskCatalogFormSchedulingDropdownDataOptions | Error,
): MockedResponse<TaskCatalogFormSchedulingDropdownQueryVariables, TaskCatalogFormSchedulingDropdownQuery> {
  return {
    request: { query: TaskCatalogFormSchedulingDropdownDocument },
    result: { data: data instanceof Error ? undefined : newTaskCatalogFormSchedulingDropdownData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TaskCatalogFormDocumentsDataOptions {
  documentTypes?: (DocumentTypeDetail | DocumentTypeDetailOptions)[];
}

export function newTaskCatalogFormDocumentsData(
  data: TaskCatalogFormDocumentsDataOptions,
): TaskCatalogFormDocumentsQuery {
  return {
    __typename: "Query" as const,
    documentTypes: data["documentTypes"]?.map((d) => newDocumentTypeDetail(d)) || [],
  } as any;
}

export function newTaskCatalogFormDocumentsResponse(
  data: TaskCatalogFormDocumentsDataOptions | Error,
): MockedResponse<TaskCatalogFormDocumentsQueryVariables, TaskCatalogFormDocumentsQuery> {
  return {
    request: { query: TaskCatalogFormDocumentsDocument },
    result: { data: data instanceof Error ? undefined : newTaskCatalogFormDocumentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveGlobalPlanTaskDataOptions {
  saveGlobalPlanTask?: SaveGlobalPlanTaskResult | SaveGlobalPlanTaskResultOptions;
}

export function newSaveGlobalPlanTaskData(data: SaveGlobalPlanTaskDataOptions): SaveGlobalPlanTaskMutation {
  return {
    __typename: "Mutation" as const,
    saveGlobalPlanTask: maybeNew("SaveGlobalPlanTaskResult", data["saveGlobalPlanTask"] || undefined, {}),
  } as any;
}

export function newSaveGlobalPlanTaskResponse(
  variables: SaveGlobalPlanTaskMutationVariables,
  data: SaveGlobalPlanTaskDataOptions | Error,
): MockedResponse<SaveGlobalPlanTaskMutationVariables, SaveGlobalPlanTaskMutation> {
  return {
    request: { query: SaveGlobalPlanTaskDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveGlobalPlanTaskData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MermaidDataOptions {
  mermaid?: MermaidResult | MermaidResultOptions;
}

export function newMermaidData(data: MermaidDataOptions): MermaidQuery {
  return { __typename: "Query" as const, mermaid: maybeNew("MermaidResult", data["mermaid"] || undefined, {}) } as any;
}

export function newMermaidResponse(
  variables: MermaidQueryVariables,
  data: MermaidDataOptions | Error,
): MockedResponse<MermaidQueryVariables, MermaidQuery> {
  return {
    request: { query: MermaidDocument, variables },
    result: { data: data instanceof Error ? undefined : newMermaidData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CatalogTaskIdsDataOptions {
  globalPlanTasks?: GlobalPlanTasksPageResult | GlobalPlanTasksPageResultOptions;
}

export function newCatalogTaskIdsData(data: CatalogTaskIdsDataOptions): CatalogTaskIdsQuery {
  return {
    __typename: "Query" as const,
    globalPlanTasks: maybeNew("GlobalPlanTasksPageResult", data["globalPlanTasks"] || undefined, {}),
  } as any;
}

export function newCatalogTaskIdsResponse(
  data: CatalogTaskIdsDataOptions | Error,
): MockedResponse<CatalogTaskIdsQueryVariables, CatalogTaskIdsQuery> {
  return {
    request: { query: CatalogTaskIdsDocument },
    result: { data: data instanceof Error ? undefined : newCatalogTaskIdsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ApprovalsDashboardDataOptions {
  approvals?: ApprovalPage | ApprovalPageOptions | null;
}

export function newApprovalsDashboardData(data: ApprovalsDashboardDataOptions): ApprovalsDashboardQuery {
  return {
    __typename: "Query" as const,
    approvals: maybeNewOrNull("ApprovalPage", data["approvals"] || undefined, {}),
  } as any;
}

export function newApprovalsDashboardResponse(
  variables: ApprovalsDashboardQueryVariables,
  data: ApprovalsDashboardDataOptions | Error,
): MockedResponse<ApprovalsDashboardQueryVariables, ApprovalsDashboardQuery> {
  return {
    request: { query: ApprovalsDashboardDocument, variables },
    result: { data: data instanceof Error ? undefined : newApprovalsDashboardData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface UpdateApproversDataOptions {
  saveApprovers?: SaveApproversResult | SaveApproversResultOptions;
}

export function newUpdateApproversData(data: UpdateApproversDataOptions): UpdateApproversMutation {
  return {
    __typename: "Mutation" as const,
    saveApprovers: maybeNew("SaveApproversResult", data["saveApprovers"] || undefined, {}),
  } as any;
}

export function newUpdateApproversResponse(
  variables: UpdateApproversMutationVariables,
  data: UpdateApproversDataOptions | Error,
): MockedResponse<UpdateApproversMutationVariables, UpdateApproversMutation> {
  return {
    request: { query: UpdateApproversDocument, variables },
    result: { data: data instanceof Error ? undefined : newUpdateApproversData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreatePandaDocSessionDataOptions {
  createPandaDocSession?: PandaDocSession | PandaDocSessionOptions;
}

export function newCreatePandaDocSessionData(data: CreatePandaDocSessionDataOptions): CreatePandaDocSessionMutation {
  return {
    __typename: "Mutation" as const,
    createPandaDocSession: maybeNew("PandaDocSession", data["createPandaDocSession"] || undefined, {}),
  } as any;
}

export function newCreatePandaDocSessionResponse(
  variables: CreatePandaDocSessionMutationVariables,
  data: CreatePandaDocSessionDataOptions | Error,
): MockedResponse<CreatePandaDocSessionMutationVariables, CreatePandaDocSessionMutation> {
  return {
    request: { query: CreatePandaDocSessionDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreatePandaDocSessionData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ActionItemsDelayFlagsDataOptions {
  scheduleFlags?: (ScheduleFlag | ScheduleFlagOptions)[];
}

export function newActionItemsDelayFlagsData(data: ActionItemsDelayFlagsDataOptions): ActionItemsDelayFlagsQuery {
  return {
    __typename: "Query" as const,
    scheduleFlags: data["scheduleFlags"]?.map((d) => newScheduleFlag(d)) || [],
  } as any;
}

export function newActionItemsDelayFlagsResponse(
  variables: ActionItemsDelayFlagsQueryVariables,
  data: ActionItemsDelayFlagsDataOptions | Error,
): MockedResponse<ActionItemsDelayFlagsQueryVariables, ActionItemsDelayFlagsQuery> {
  return {
    request: { query: ActionItemsDelayFlagsDocument, variables },
    result: { data: data instanceof Error ? undefined : newActionItemsDelayFlagsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ActionItemsSchedulingDataOptions {
  tasks?: (Task | TaskOptions)[];
}

export function newActionItemsSchedulingData(data: ActionItemsSchedulingDataOptions): ActionItemsSchedulingQuery {
  return { __typename: "Query" as const, tasks: data["tasks"]?.map((d) => newTask(d)) || [] } as any;
}

export function newActionItemsSchedulingResponse(
  variables: ActionItemsSchedulingQueryVariables,
  data: ActionItemsSchedulingDataOptions | Error,
): MockedResponse<ActionItemsSchedulingQueryVariables, ActionItemsSchedulingQuery> {
  return {
    request: { query: ActionItemsSchedulingDocument, variables },
    result: { data: data instanceof Error ? undefined : newActionItemsSchedulingData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ActionItemsDeferredBillsDataOptions {
  bills?: (Bill | BillOptions)[];
}

export function newActionItemsDeferredBillsData(
  data: ActionItemsDeferredBillsDataOptions,
): ActionItemsDeferredBillsQuery {
  return { __typename: "Query" as const, bills: data["bills"]?.map((d) => newBill(d)) || [] } as any;
}

export function newActionItemsDeferredBillsResponse(
  variables: ActionItemsDeferredBillsQueryVariables,
  data: ActionItemsDeferredBillsDataOptions | Error,
): MockedResponse<ActionItemsDeferredBillsQueryVariables, ActionItemsDeferredBillsQuery> {
  return {
    request: { query: ActionItemsDeferredBillsDocument, variables },
    result: { data: data instanceof Error ? undefined : newActionItemsDeferredBillsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ActionItemsApprovalsDataOptions {
  approvals?: ApprovalPage | ApprovalPageOptions | null;
}

export function newActionItemsApprovalsData(data: ActionItemsApprovalsDataOptions): ActionItemsApprovalsQuery {
  return {
    __typename: "Query" as const,
    approvals: maybeNewOrNull("ApprovalPage", data["approvals"] || undefined, {}),
  } as any;
}

export function newActionItemsApprovalsResponse(
  variables: ActionItemsApprovalsQueryVariables,
  data: ActionItemsApprovalsDataOptions | Error,
): MockedResponse<ActionItemsApprovalsQueryVariables, ActionItemsApprovalsQuery> {
  return {
    request: { query: ActionItemsApprovalsDocument, variables },
    result: { data: data instanceof Error ? undefined : newActionItemsApprovalsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ActionItemsBillsPendingReviewDataOptions {
  bills?: (Bill | BillOptions)[];
}

export function newActionItemsBillsPendingReviewData(
  data: ActionItemsBillsPendingReviewDataOptions,
): ActionItemsBillsPendingReviewQuery {
  return { __typename: "Query" as const, bills: data["bills"]?.map((d) => newBill(d)) || [] } as any;
}

export function newActionItemsBillsPendingReviewResponse(
  variables: ActionItemsBillsPendingReviewQueryVariables,
  data: ActionItemsBillsPendingReviewDataOptions | Error,
): MockedResponse<ActionItemsBillsPendingReviewQueryVariables, ActionItemsBillsPendingReviewQuery> {
  return {
    request: { query: ActionItemsBillsPendingReviewDocument, variables },
    result: { data: data instanceof Error ? undefined : newActionItemsBillsPendingReviewData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ActionItemsStaleTasksDataOptions {
  tasks?: (Task | TaskOptions)[];
}

export function newActionItemsStaleTasksData(data: ActionItemsStaleTasksDataOptions): ActionItemsStaleTasksQuery {
  return { __typename: "Query" as const, tasks: data["tasks"]?.map((d) => newTask(d)) || [] } as any;
}

export function newActionItemsStaleTasksResponse(
  variables: ActionItemsStaleTasksQueryVariables,
  data: ActionItemsStaleTasksDataOptions | Error,
): MockedResponse<ActionItemsStaleTasksQueryVariables, ActionItemsStaleTasksQuery> {
  return {
    request: { query: ActionItemsStaleTasksDocument, variables },
    result: { data: data instanceof Error ? undefined : newActionItemsStaleTasksData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ToDosPageDataDataOptions {
  projects?: (Project | ProjectOptions)[];
  cohorts?: (Cohort | CohortOptions)[];
  developments?: (Development | DevelopmentOptions)[];
  markets?: (Market | MarketOptions)[];
  internalUsers?: (InternalUser | InternalUserOptions)[];
}

export function newToDosPageDataData(data: ToDosPageDataDataOptions): ToDosPageDataQuery {
  return {
    __typename: "Query" as const,
    projects: data["projects"]?.map((d) => maybeNew("Project", d, {})) || [],
    cohorts: data["cohorts"]?.map((d) => newCohort(d)) || [],
    developments: data["developments"]?.map((d) => newDevelopment(d)) || [],
    markets: data["markets"]?.map((d) => newMarket(d)) || [],
    internalUsers: data["internalUsers"]?.map((d) => newInternalUser(d)) || [],
  } as any;
}

export function newToDosPageDataResponse(
  variables: ToDosPageDataQueryVariables,
  data: ToDosPageDataDataOptions | Error,
): MockedResponse<ToDosPageDataQueryVariables, ToDosPageDataQuery> {
  return {
    request: { query: ToDosPageDataDocument, variables },
    result: { data: data instanceof Error ? undefined : newToDosPageDataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BudgetSuperDrawerDataOptions {
  projectItems?: (ProjectItem | ProjectItemOptions)[];
}

export function newBudgetSuperDrawerData(data: BudgetSuperDrawerDataOptions): BudgetSuperDrawerQuery {
  return {
    __typename: "Query" as const,
    projectItems: data["projectItems"]?.map((d) => newProjectItem(d)) || [],
  } as any;
}

export function newBudgetSuperDrawerResponse(
  variables: BudgetSuperDrawerQueryVariables,
  data: BudgetSuperDrawerDataOptions | Error,
): MockedResponse<BudgetSuperDrawerQueryVariables, BudgetSuperDrawerQuery> {
  return {
    request: { query: BudgetSuperDrawerDocument, variables },
    result: { data: data instanceof Error ? undefined : newBudgetSuperDrawerData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BudgetActivityTabMetaDataOptions {
  projects?: (Project | ProjectOptions)[];
  userEventParentTypes?: (UserEventParentType | UserEventParentTypeOptions)[];
  internalUsers?: (InternalUser | InternalUserOptions)[];
  currentUser?: User | UserOptions | null;
}

export function newBudgetActivityTabMetaData(data: BudgetActivityTabMetaDataOptions): BudgetActivityTabMetaQuery {
  return {
    __typename: "Query" as const,
    projects: data["projects"]?.map((d) => maybeNew("Project", d, {})) || [],
    userEventParentTypes: data["userEventParentTypes"]?.map((d) => newUserEventParentType(d)) || [],
    internalUsers: data["internalUsers"]?.map((d) => newInternalUser(d)) || [],
    currentUser: maybeNewOrNull("User", data["currentUser"] || undefined, {}),
  } as any;
}

export function newBudgetActivityTabMetaResponse(
  variables: BudgetActivityTabMetaQueryVariables,
  data: BudgetActivityTabMetaDataOptions | Error,
): MockedResponse<BudgetActivityTabMetaQueryVariables, BudgetActivityTabMetaQuery> {
  return {
    request: { query: BudgetActivityTabMetaDocument, variables },
    result: { data: data instanceof Error ? undefined : newBudgetActivityTabMetaData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface UpcomingTasksDataOptions {
  tasks?: (Task | TaskOptions)[];
  taskStatuses?: (TaskStatusDetail | TaskStatusDetailOptions)[];
}

export function newUpcomingTasksData(data: UpcomingTasksDataOptions): UpcomingTasksQuery {
  return {
    __typename: "Query" as const,
    tasks: data["tasks"]?.map((d) => newTask(d)) || [],
    taskStatuses: data["taskStatuses"]?.map((d) => newTaskStatusDetail(d)) || [],
  } as any;
}

export function newUpcomingTasksResponse(
  variables: UpcomingTasksQueryVariables,
  data: UpcomingTasksDataOptions | Error,
): MockedResponse<UpcomingTasksQueryVariables, UpcomingTasksQuery> {
  return {
    request: { query: UpcomingTasksDocument, variables },
    result: { data: data instanceof Error ? undefined : newUpcomingTasksData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveUpcomingPlanTaskDataOptions {
  savePlanTask?: SavePlanTaskResult | SavePlanTaskResultOptions;
}

export function newSaveUpcomingPlanTaskData(data: SaveUpcomingPlanTaskDataOptions): SaveUpcomingPlanTaskMutation {
  return {
    __typename: "Mutation" as const,
    savePlanTask: maybeNew("SavePlanTaskResult", data["savePlanTask"] || undefined, {}),
  } as any;
}

export function newSaveUpcomingPlanTaskResponse(
  variables: SaveUpcomingPlanTaskMutationVariables,
  data: SaveUpcomingPlanTaskDataOptions | Error,
): MockedResponse<SaveUpcomingPlanTaskMutationVariables, SaveUpcomingPlanTaskMutation> {
  return {
    request: { query: SaveUpcomingPlanTaskDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveUpcomingPlanTaskData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AcceptChangeEventModalDataOptions {
  changeEvent?: ChangeEvent | ChangeEventOptions;
}

export function newAcceptChangeEventModalData(data: AcceptChangeEventModalDataOptions): AcceptChangeEventModalQuery {
  return {
    __typename: "Query" as const,
    changeEvent: maybeNew("ChangeEvent", data["changeEvent"] || undefined, {}),
  } as any;
}

export function newAcceptChangeEventModalResponse(
  variables: AcceptChangeEventModalQueryVariables,
  data: AcceptChangeEventModalDataOptions | Error,
): MockedResponse<AcceptChangeEventModalQueryVariables, AcceptChangeEventModalQuery> {
  return {
    request: { query: AcceptChangeEventModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newAcceptChangeEventModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChangeEventLineItemTradePartnerSelectDataOptions {
  bidContractLineItems?: (BidContractLineItem | BidContractLineItemOptions)[];
}

export function newChangeEventLineItemTradePartnerSelectData(
  data: ChangeEventLineItemTradePartnerSelectDataOptions,
): ChangeEventLineItemTradePartnerSelectQuery {
  return {
    __typename: "Query" as const,
    bidContractLineItems: data["bidContractLineItems"]?.map((d) => newBidContractLineItem(d)) || [],
  } as any;
}

export function newChangeEventLineItemTradePartnerSelectResponse(
  variables: ChangeEventLineItemTradePartnerSelectQueryVariables,
  data: ChangeEventLineItemTradePartnerSelectDataOptions | Error,
): MockedResponse<ChangeEventLineItemTradePartnerSelectQueryVariables, ChangeEventLineItemTradePartnerSelectQuery> {
  return {
    request: { query: ChangeEventLineItemTradePartnerSelectDocument, variables },
    result: { data: data instanceof Error ? undefined : newChangeEventLineItemTradePartnerSelectData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveChangeEventLineItemsDataOptions {
  saveChangeEventLineItems?: SaveChangeEventLineItemsResult | SaveChangeEventLineItemsResultOptions;
}

export function newSaveChangeEventLineItemsData(
  data: SaveChangeEventLineItemsDataOptions,
): SaveChangeEventLineItemsMutation {
  return {
    __typename: "Mutation" as const,
    saveChangeEventLineItems: maybeNew(
      "SaveChangeEventLineItemsResult",
      data["saveChangeEventLineItems"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveChangeEventLineItemsResponse(
  variables: SaveChangeEventLineItemsMutationVariables,
  data: SaveChangeEventLineItemsDataOptions | Error,
): MockedResponse<SaveChangeEventLineItemsMutationVariables, SaveChangeEventLineItemsMutation> {
  return {
    request: { query: SaveChangeEventLineItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveChangeEventLineItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ApplyTemplateChangeEventModalDataOptions {
  itemTemplates?: (ItemTemplate | ItemTemplateOptions)[];
}

export function newApplyTemplateChangeEventModalData(
  data: ApplyTemplateChangeEventModalDataOptions,
): ApplyTemplateChangeEventModalQuery {
  return {
    __typename: "Query" as const,
    itemTemplates: data["itemTemplates"]?.map((d) => newItemTemplate(d)) || [],
  } as any;
}

export function newApplyTemplateChangeEventModalResponse(
  variables: ApplyTemplateChangeEventModalQueryVariables,
  data: ApplyTemplateChangeEventModalDataOptions | Error,
): MockedResponse<ApplyTemplateChangeEventModalQueryVariables, ApplyTemplateChangeEventModalQuery> {
  return {
    request: { query: ApplyTemplateChangeEventModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newApplyTemplateChangeEventModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ApplyTemplatePlanChangeEventModalDataOptions {
  itemTemplates?: (ItemTemplate | ItemTemplateOptions)[];
}

export function newApplyTemplatePlanChangeEventModalData(
  data: ApplyTemplatePlanChangeEventModalDataOptions,
): ApplyTemplatePlanChangeEventModalQuery {
  return {
    __typename: "Query" as const,
    itemTemplates: data["itemTemplates"]?.map((d) => newItemTemplate(d)) || [],
  } as any;
}

export function newApplyTemplatePlanChangeEventModalResponse(
  variables: ApplyTemplatePlanChangeEventModalQueryVariables,
  data: ApplyTemplatePlanChangeEventModalDataOptions | Error,
): MockedResponse<ApplyTemplatePlanChangeEventModalQueryVariables, ApplyTemplatePlanChangeEventModalQuery> {
  return {
    request: { query: ApplyTemplatePlanChangeEventModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newApplyTemplatePlanChangeEventModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateCeModalDataOptions {
  project?: Project | ProjectOptions;
  changeEventReasons?: (ChangeEventReason | ChangeEventReasonOptions)[];
  changeEventBudgetPhases?: (ChangeEventBudgetPhaseDetail | ChangeEventBudgetPhaseDetailOptions)[];
}

export function newCreateCeModalData(data: CreateCeModalDataOptions): CreateCeModalQuery {
  return {
    __typename: "Query" as const,
    project: maybeNew("Project", data["project"] || undefined, {}),
    changeEventReasons: data["changeEventReasons"]?.map((d) => newChangeEventReason(d)) || [],
    changeEventBudgetPhases: data["changeEventBudgetPhases"]?.map((d) => newChangeEventBudgetPhaseDetail(d)) || [],
  } as any;
}

export function newCreateCeModalResponse(
  variables: CreateCeModalQueryVariables,
  data: CreateCeModalDataOptions | Error,
): MockedResponse<CreateCeModalQueryVariables, CreateCeModalQuery> {
  return {
    request: { query: CreateCeModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateCeModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateCeModalSaveCeDataOptions {
  saveChangeEvent?: SaveChangeEventResult | SaveChangeEventResultOptions;
}

export function newCreateCeModalSaveCeData(data: CreateCeModalSaveCeDataOptions): CreateCeModalSaveCeMutation {
  return {
    __typename: "Mutation" as const,
    saveChangeEvent: maybeNew("SaveChangeEventResult", data["saveChangeEvent"] || undefined, {}),
  } as any;
}

export function newCreateCeModalSaveCeResponse(
  variables: CreateCeModalSaveCeMutationVariables,
  data: CreateCeModalSaveCeDataOptions | Error,
): MockedResponse<CreateCeModalSaveCeMutationVariables, CreateCeModalSaveCeMutation> {
  return {
    request: { query: CreateCeModalSaveCeDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateCeModalSaveCeData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateChangeEventLineItemsFromCommittedDataOptions {
  createChangeEventLineItemsFromCommitted?: SaveChangeEventResult | SaveChangeEventResultOptions;
}

export function newCreateChangeEventLineItemsFromCommittedData(
  data: CreateChangeEventLineItemsFromCommittedDataOptions,
): CreateChangeEventLineItemsFromCommittedMutation {
  return {
    __typename: "Mutation" as const,
    createChangeEventLineItemsFromCommitted: maybeNew(
      "SaveChangeEventResult",
      data["createChangeEventLineItemsFromCommitted"] || undefined,
      {},
    ),
  } as any;
}

export function newCreateChangeEventLineItemsFromCommittedResponse(
  variables: CreateChangeEventLineItemsFromCommittedMutationVariables,
  data: CreateChangeEventLineItemsFromCommittedDataOptions | Error,
): MockedResponse<
  CreateChangeEventLineItemsFromCommittedMutationVariables,
  CreateChangeEventLineItemsFromCommittedMutation
> {
  return {
    request: { query: CreateChangeEventLineItemsFromCommittedDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateChangeEventLineItemsFromCommittedData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddDepositModalDataOptions {
  commitment?: Commitment | CommitmentOptions;
  tasks?: (Task | TaskOptions)[];
}

export function newAddDepositModalData(data: AddDepositModalDataOptions): AddDepositModalQuery {
  return {
    __typename: "Query" as const,
    commitment: maybeNew("Commitment", data["commitment"] || undefined, {}),
    tasks: data["tasks"]?.map((d) => newTask(d)) || [],
  } as any;
}

export function newAddDepositModalResponse(
  variables: AddDepositModalQueryVariables,
  data: AddDepositModalDataOptions | Error,
): MockedResponse<AddDepositModalQueryVariables, AddDepositModalQuery> {
  return {
    request: { query: AddDepositModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddDepositModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CommitmentOverviewCommentDrawerDataOptions {
  commitment?: Commitment | CommitmentOptions;
}

export function newCommitmentOverviewCommentDrawerData(
  data: CommitmentOverviewCommentDrawerDataOptions,
): CommitmentOverviewCommentDrawerQuery {
  return {
    __typename: "Query" as const,
    commitment: maybeNew("Commitment", data["commitment"] || undefined, {}),
  } as any;
}

export function newCommitmentOverviewCommentDrawerResponse(
  variables: CommitmentOverviewCommentDrawerQueryVariables,
  data: CommitmentOverviewCommentDrawerDataOptions | Error,
): MockedResponse<CommitmentOverviewCommentDrawerQueryVariables, CommitmentOverviewCommentDrawerQuery> {
  return {
    request: { query: CommitmentOverviewCommentDrawerDocument, variables },
    result: { data: data instanceof Error ? undefined : newCommitmentOverviewCommentDrawerData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateNewCommitmentDataDataOptions {
  tradeCategories?: (TradeCategory | TradeCategoryOptions)[];
  tradePartners?: (TradePartner | TradePartnerOptions)[];
  project?: Project | ProjectOptions;
}

export function newCreateNewCommitmentDataData(data: CreateNewCommitmentDataDataOptions): CreateNewCommitmentDataQuery {
  return {
    __typename: "Query" as const,
    tradeCategories: data["tradeCategories"]?.map((d) => newTradeCategory(d)) || [],
    tradePartners: data["tradePartners"]?.map((d) => newTradePartner(d)) || [],
    project: maybeNew("Project", data["project"] || undefined, {}),
  } as any;
}

export function newCreateNewCommitmentDataResponse(
  variables: CreateNewCommitmentDataQueryVariables,
  data: CreateNewCommitmentDataDataOptions | Error,
): MockedResponse<CreateNewCommitmentDataQueryVariables, CreateNewCommitmentDataQuery> {
  return {
    request: { query: CreateNewCommitmentDataDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateNewCommitmentDataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveNewCommitmentDataOptions {
  saveCommitment?: SaveCommitmentResult | SaveCommitmentResultOptions;
}

export function newSaveNewCommitmentData(data: SaveNewCommitmentDataOptions): SaveNewCommitmentMutation {
  return {
    __typename: "Mutation" as const,
    saveCommitment: maybeNew("SaveCommitmentResult", data["saveCommitment"] || undefined, {}),
  } as any;
}

export function newSaveNewCommitmentResponse(
  variables: SaveNewCommitmentMutationVariables,
  data: SaveNewCommitmentDataOptions | Error,
): MockedResponse<SaveNewCommitmentMutationVariables, SaveNewCommitmentMutation> {
  return {
    request: { query: SaveNewCommitmentDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveNewCommitmentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteUploadedPandaDocDataOptions {
  deletePandaDoc?: DeletePandaDocResult | DeletePandaDocResultOptions;
}

export function newDeleteUploadedPandaDocData(data: DeleteUploadedPandaDocDataOptions): DeleteUploadedPandaDocMutation {
  return {
    __typename: "Mutation" as const,
    deletePandaDoc: maybeNew("DeletePandaDocResult", data["deletePandaDoc"] || undefined, {}),
  } as any;
}

export function newDeleteUploadedPandaDocResponse(
  variables: DeleteUploadedPandaDocMutationVariables,
  data: DeleteUploadedPandaDocDataOptions | Error,
): MockedResponse<DeleteUploadedPandaDocMutationVariables, DeleteUploadedPandaDocMutation> {
  return {
    request: { query: DeleteUploadedPandaDocDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteUploadedPandaDocData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveOwnerPandaDocDataOptions {
  savePandaDoc?: SavePandaDocResult | SavePandaDocResultOptions;
}

export function newSaveOwnerPandaDocData(data: SaveOwnerPandaDocDataOptions): SaveOwnerPandaDocMutation {
  return {
    __typename: "Mutation" as const,
    savePandaDoc: maybeNew("SavePandaDocResult", data["savePandaDoc"] || undefined, {}),
  } as any;
}

export function newSaveOwnerPandaDocResponse(
  variables: SaveOwnerPandaDocMutationVariables,
  data: SaveOwnerPandaDocDataOptions | Error,
): MockedResponse<SaveOwnerPandaDocMutationVariables, SaveOwnerPandaDocMutation> {
  return {
    request: { query: SaveOwnerPandaDocDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveOwnerPandaDocData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ActivityTabDataDataOptions {
  currentUser?: User | UserOptions | null;
  internalUsers?: (InternalUser | InternalUserOptions)[];
  userEventParentTypes?: (UserEventParentType | UserEventParentTypeOptions)[];
}

export function newActivityTabDataData(data: ActivityTabDataDataOptions): ActivityTabDataQuery {
  return {
    __typename: "Query" as const,
    currentUser: maybeNewOrNull("User", data["currentUser"] || undefined, {}),
    internalUsers: data["internalUsers"]?.map((d) => newInternalUser(d)) || [],
    userEventParentTypes: data["userEventParentTypes"]?.map((d) => newUserEventParentType(d)) || [],
  } as any;
}

export function newActivityTabDataResponse(
  data: ActivityTabDataDataOptions | Error,
): MockedResponse<ActivityTabDataQueryVariables, ActivityTabDataQuery> {
  return {
    request: { query: ActivityTabDataDocument },
    result: { data: data instanceof Error ? undefined : newActivityTabDataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PaymentScheduleTabDataOptions {
  commitment?: Commitment | CommitmentOptions;
}

export function newPaymentScheduleTabData(data: PaymentScheduleTabDataOptions): PaymentScheduleTabQuery {
  return {
    __typename: "Query" as const,
    commitment: maybeNew("Commitment", data["commitment"] || undefined, {}),
  } as any;
}

export function newPaymentScheduleTabResponse(
  variables: PaymentScheduleTabQueryVariables,
  data: PaymentScheduleTabDataOptions | Error,
): MockedResponse<PaymentScheduleTabQueryVariables, PaymentScheduleTabQuery> {
  return {
    request: { query: PaymentScheduleTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newPaymentScheduleTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PreConExpectationsTabDataOptions {
  project?: Project | ProjectOptions;
}

export function newPreConExpectationsTabData(data: PreConExpectationsTabDataOptions): PreConExpectationsTabQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newPreConExpectationsTabResponse(
  variables: PreConExpectationsTabQueryVariables,
  data: PreConExpectationsTabDataOptions | Error,
): MockedResponse<PreConExpectationsTabQueryVariables, PreConExpectationsTabQuery> {
  return {
    request: { query: PreConExpectationsTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newPreConExpectationsTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectDashboardTabDataOptions {
  currentInternalUser?: InternalUser | InternalUserOptions | null;
}

export function newProjectDashboardTabData(data: ProjectDashboardTabDataOptions): ProjectDashboardTabQuery {
  return {
    __typename: "Query" as const,
    currentInternalUser: maybeNewOrNull("InternalUser", data["currentInternalUser"] || undefined, {}),
  } as any;
}

export function newProjectDashboardTabResponse(
  data: ProjectDashboardTabDataOptions | Error,
): MockedResponse<ProjectDashboardTabQueryVariables, ProjectDashboardTabQuery> {
  return {
    request: { query: ProjectDashboardTabDocument },
    result: { data: data instanceof Error ? undefined : newProjectDashboardTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveProjectDashboardDataOptions {
  saveInternalUser?: SaveInternalUserResult | SaveInternalUserResultOptions;
}

export function newSaveProjectDashboardData(data: SaveProjectDashboardDataOptions): SaveProjectDashboardMutation {
  return {
    __typename: "Mutation" as const,
    saveInternalUser: maybeNew("SaveInternalUserResult", data["saveInternalUser"] || undefined, {}),
  } as any;
}

export function newSaveProjectDashboardResponse(
  variables: SaveProjectDashboardMutationVariables,
  data: SaveProjectDashboardDataOptions | Error,
): MockedResponse<SaveProjectDashboardMutationVariables, SaveProjectDashboardMutation> {
  return {
    request: { query: SaveProjectDashboardDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveProjectDashboardData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DynamicScheduleSidePaneDataOptions {
  planTask?: PlanTask | PlanTaskOptions;
  enumDetails?: AllEnumDetails | AllEnumDetailsOptions;
}

export function newDynamicScheduleSidePaneData(data: DynamicScheduleSidePaneDataOptions): DynamicScheduleSidePaneQuery {
  return {
    __typename: "Query" as const,
    planTask: maybeNew("PlanTask", data["planTask"] || undefined, {}),
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
  } as any;
}

export function newDynamicScheduleSidePaneResponse(
  variables: DynamicScheduleSidePaneQueryVariables,
  data: DynamicScheduleSidePaneDataOptions | Error,
): MockedResponse<DynamicScheduleSidePaneQueryVariables, DynamicScheduleSidePaneQuery> {
  return {
    request: { query: DynamicScheduleSidePaneDocument, variables },
    result: { data: data instanceof Error ? undefined : newDynamicScheduleSidePaneData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DraftScheduleSidePaneDataOptions {
  draftPlanSchedule?: DraftScheduleResult | DraftScheduleResultOptions;
}

export function newDraftScheduleSidePaneData(data: DraftScheduleSidePaneDataOptions): DraftScheduleSidePaneQuery {
  return {
    __typename: "Query" as const,
    draftPlanSchedule: maybeNew("DraftScheduleResult", data["draftPlanSchedule"] || undefined, {}),
  } as any;
}

export function newDraftScheduleSidePaneResponse(
  variables: DraftScheduleSidePaneQueryVariables,
  data: DraftScheduleSidePaneDataOptions | Error,
): MockedResponse<DraftScheduleSidePaneQueryVariables, DraftScheduleSidePaneQuery> {
  return {
    request: { query: DraftScheduleSidePaneDocument, variables },
    result: { data: data instanceof Error ? undefined : newDraftScheduleSidePaneData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DynamicSchedulesSnapshotsDataOptions {
  planScheduleSnapshots?: PlanScheduleSnapshotsResult | PlanScheduleSnapshotsResultOptions;
}

export function newDynamicSchedulesSnapshotsData(
  data: DynamicSchedulesSnapshotsDataOptions,
): DynamicSchedulesSnapshotsQuery {
  return {
    __typename: "Query" as const,
    planScheduleSnapshots: maybeNew("PlanScheduleSnapshotsResult", data["planScheduleSnapshots"] || undefined, {}),
  } as any;
}

export function newDynamicSchedulesSnapshotsResponse(
  variables: DynamicSchedulesSnapshotsQueryVariables,
  data: DynamicSchedulesSnapshotsDataOptions | Error,
): MockedResponse<DynamicSchedulesSnapshotsQueryVariables, DynamicSchedulesSnapshotsQuery> {
  return {
    request: { query: DynamicSchedulesSnapshotsDocument, variables },
    result: { data: data instanceof Error ? undefined : newDynamicSchedulesSnapshotsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SendTradePartnerAvailabilityRequestEmailDataOptions {
  planTasks?: PlanTasksResult | PlanTasksResultOptions;
  planSchedule?: PlanSchedule | PlanScheduleOptions;
}

export function newSendTradePartnerAvailabilityRequestEmailData(
  data: SendTradePartnerAvailabilityRequestEmailDataOptions,
): SendTradePartnerAvailabilityRequestEmailQuery {
  return {
    __typename: "Query" as const,
    planTasks: maybeNew("PlanTasksResult", data["planTasks"] || undefined, {}),
    planSchedule: maybeNew("PlanSchedule", data["planSchedule"] || undefined, {}),
  } as any;
}

export function newSendTradePartnerAvailabilityRequestEmailResponse(
  variables: SendTradePartnerAvailabilityRequestEmailQueryVariables,
  data: SendTradePartnerAvailabilityRequestEmailDataOptions | Error,
): MockedResponse<
  SendTradePartnerAvailabilityRequestEmailQueryVariables,
  SendTradePartnerAvailabilityRequestEmailQuery
> {
  return {
    request: { query: SendTradePartnerAvailabilityRequestEmailDocument, variables },
    result: { data: data instanceof Error ? undefined : newSendTradePartnerAvailabilityRequestEmailData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SendSingleTradePartnerAvailabilityRequestEmailDataOptions {
  planTask?: PlanTask | PlanTaskOptions;
  planSchedule?: PlanSchedule | PlanScheduleOptions;
}

export function newSendSingleTradePartnerAvailabilityRequestEmailData(
  data: SendSingleTradePartnerAvailabilityRequestEmailDataOptions,
): SendSingleTradePartnerAvailabilityRequestEmailQuery {
  return {
    __typename: "Query" as const,
    planTask: maybeNew("PlanTask", data["planTask"] || undefined, {}),
    planSchedule: maybeNew("PlanSchedule", data["planSchedule"] || undefined, {}),
  } as any;
}

export function newSendSingleTradePartnerAvailabilityRequestEmailResponse(
  variables: SendSingleTradePartnerAvailabilityRequestEmailQueryVariables,
  data: SendSingleTradePartnerAvailabilityRequestEmailDataOptions | Error,
): MockedResponse<
  SendSingleTradePartnerAvailabilityRequestEmailQueryVariables,
  SendSingleTradePartnerAvailabilityRequestEmailQuery
> {
  return {
    request: { query: SendSingleTradePartnerAvailabilityRequestEmailDocument, variables },
    result: { data: data instanceof Error ? undefined : newSendSingleTradePartnerAvailabilityRequestEmailData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveTradePartnerAvailabilityRequestsDataOptions {
  saveTradePartnerAvailabilityRequests?:
    | SaveTradePartnerAvailabilityRequestsResult
    | SaveTradePartnerAvailabilityRequestsResultOptions;
}

export function newSaveTradePartnerAvailabilityRequestsData(
  data: SaveTradePartnerAvailabilityRequestsDataOptions,
): SaveTradePartnerAvailabilityRequestsMutation {
  return {
    __typename: "Mutation" as const,
    saveTradePartnerAvailabilityRequests: maybeNew(
      "SaveTradePartnerAvailabilityRequestsResult",
      data["saveTradePartnerAvailabilityRequests"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveTradePartnerAvailabilityRequestsResponse(
  variables: SaveTradePartnerAvailabilityRequestsMutationVariables,
  data: SaveTradePartnerAvailabilityRequestsDataOptions | Error,
): MockedResponse<SaveTradePartnerAvailabilityRequestsMutationVariables, SaveTradePartnerAvailabilityRequestsMutation> {
  return {
    request: { query: SaveTradePartnerAvailabilityRequestsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveTradePartnerAvailabilityRequestsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PublishDraftScheduleStepperDataOptions {
  planSchedule?: PlanSchedule | PlanScheduleOptions;
}

export function newPublishDraftScheduleStepperData(
  data: PublishDraftScheduleStepperDataOptions,
): PublishDraftScheduleStepperQuery {
  return {
    __typename: "Query" as const,
    planSchedule: maybeNew("PlanSchedule", data["planSchedule"] || undefined, {}),
  } as any;
}

export function newPublishDraftScheduleStepperResponse(
  variables: PublishDraftScheduleStepperQueryVariables,
  data: PublishDraftScheduleStepperDataOptions | Error,
): MockedResponse<PublishDraftScheduleStepperQueryVariables, PublishDraftScheduleStepperQuery> {
  return {
    request: { query: PublishDraftScheduleStepperDocument, variables },
    result: { data: data instanceof Error ? undefined : newPublishDraftScheduleStepperData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DraftPlanScheduleDataOptions {
  draftPlanSchedule?: DraftScheduleResult | DraftScheduleResultOptions;
  globalPlanStages?: (GlobalPlanStage | GlobalPlanStageOptions)[];
  enumDetails?: AllEnumDetails | AllEnumDetailsOptions;
}

export function newDraftPlanScheduleData(data: DraftPlanScheduleDataOptions): DraftPlanScheduleQuery {
  return {
    __typename: "Query" as const,
    draftPlanSchedule: maybeNew("DraftScheduleResult", data["draftPlanSchedule"] || undefined, {}),
    globalPlanStages: data["globalPlanStages"]?.map((d) => newGlobalPlanStage(d)) || [],
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
  } as any;
}

export function newDraftPlanScheduleResponse(
  variables: DraftPlanScheduleQueryVariables,
  data: DraftPlanScheduleDataOptions | Error,
): MockedResponse<DraftPlanScheduleQueryVariables, DraftPlanScheduleQuery> {
  return {
    request: { query: DraftPlanScheduleDocument, variables },
    result: { data: data instanceof Error ? undefined : newDraftPlanScheduleData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScheduleDraftModeScheduleFlagReasonsDataOptions {
  scheduleFlagReasons?: (ScheduleFlagReason | ScheduleFlagReasonOptions)[];
}

export function newScheduleDraftModeScheduleFlagReasonsData(
  data: ScheduleDraftModeScheduleFlagReasonsDataOptions,
): ScheduleDraftModeScheduleFlagReasonsQuery {
  return {
    __typename: "Query" as const,
    scheduleFlagReasons: data["scheduleFlagReasons"]?.map((d) => newScheduleFlagReason(d)) || [],
  } as any;
}

export function newScheduleDraftModeScheduleFlagReasonsResponse(
  data: ScheduleDraftModeScheduleFlagReasonsDataOptions | Error,
): MockedResponse<ScheduleDraftModeScheduleFlagReasonsQueryVariables, ScheduleDraftModeScheduleFlagReasonsQuery> {
  return {
    request: { query: ScheduleDraftModeScheduleFlagReasonsDocument },
    result: { data: data instanceof Error ? undefined : newScheduleDraftModeScheduleFlagReasonsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DraftCatalogTasksDataOptions {
  globalPlanTasks?: GlobalPlanTasksPageResult | GlobalPlanTasksPageResultOptions;
  project?: Project | ProjectOptions;
  globalPlanTags?: (GlobalPlanTag | GlobalPlanTagOptions)[];
}

export function newDraftCatalogTasksData(data: DraftCatalogTasksDataOptions): DraftCatalogTasksQuery {
  return {
    __typename: "Query" as const,
    globalPlanTasks: maybeNew("GlobalPlanTasksPageResult", data["globalPlanTasks"] || undefined, {}),
    project: maybeNew("Project", data["project"] || undefined, {}),
    globalPlanTags: data["globalPlanTags"]?.map((d) => newGlobalPlanTag(d)) || [],
  } as any;
}

export function newDraftCatalogTasksResponse(
  variables: DraftCatalogTasksQueryVariables,
  data: DraftCatalogTasksDataOptions | Error,
): MockedResponse<DraftCatalogTasksQueryVariables, DraftCatalogTasksQuery> {
  return {
    request: { query: DraftCatalogTasksDocument, variables },
    result: { data: data instanceof Error ? undefined : newDraftCatalogTasksData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveDraftPlanScheduleDataOptions {
  saveDraftSchedule?: DraftScheduleResult | DraftScheduleResultOptions;
}

export function newSaveDraftPlanScheduleData(data: SaveDraftPlanScheduleDataOptions): SaveDraftPlanScheduleMutation {
  return {
    __typename: "Mutation" as const,
    saveDraftSchedule: maybeNew("DraftScheduleResult", data["saveDraftSchedule"] || undefined, {}),
  } as any;
}

export function newSaveDraftPlanScheduleResponse(
  variables: SaveDraftPlanScheduleMutationVariables,
  data: SaveDraftPlanScheduleDataOptions | Error,
): MockedResponse<SaveDraftPlanScheduleMutationVariables, SaveDraftPlanScheduleMutation> {
  return {
    request: { query: SaveDraftPlanScheduleDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveDraftPlanScheduleData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TradeConfirmPublishStepDataOptions {
  draftPlanSchedule?: DraftScheduleResult | DraftScheduleResultOptions;
}

export function newTradeConfirmPublishStepData(data: TradeConfirmPublishStepDataOptions): TradeConfirmPublishStepQuery {
  return {
    __typename: "Query" as const,
    draftPlanSchedule: maybeNew("DraftScheduleResult", data["draftPlanSchedule"] || undefined, {}),
  } as any;
}

export function newTradeConfirmPublishStepResponse(
  variables: TradeConfirmPublishStepQueryVariables,
  data: TradeConfirmPublishStepDataOptions | Error,
): MockedResponse<TradeConfirmPublishStepQueryVariables, TradeConfirmPublishStepQuery> {
  return {
    request: { query: TradeConfirmPublishStepDocument, variables },
    result: { data: data instanceof Error ? undefined : newTradeConfirmPublishStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanTaskDetailsPageDataOptions {
  planTask?: PlanTask | PlanTaskOptions;
  enumDetails?: AllEnumDetails | AllEnumDetailsOptions;
}

export function newPlanTaskDetailsPageData(data: PlanTaskDetailsPageDataOptions): PlanTaskDetailsPageQuery {
  return {
    __typename: "Query" as const,
    planTask: maybeNew("PlanTask", data["planTask"] || undefined, {}),
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
  } as any;
}

export function newPlanTaskDetailsPageResponse(
  variables: PlanTaskDetailsPageQueryVariables,
  data: PlanTaskDetailsPageDataOptions | Error,
): MockedResponse<PlanTaskDetailsPageQueryVariables, PlanTaskDetailsPageQuery> {
  return {
    request: { query: PlanTaskDetailsPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanTaskDetailsPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanTaskDetailsDocumentsDataOptions {
  documents?: (Document | DocumentOptions)[];
  documentTypes?: (DocumentTypeDetail | DocumentTypeDetailOptions)[];
}

export function newPlanTaskDetailsDocumentsData(
  data: PlanTaskDetailsDocumentsDataOptions,
): PlanTaskDetailsDocumentsQuery {
  return {
    __typename: "Query" as const,
    documents: data["documents"]?.map((d) => newDocument(d)) || [],
    documentTypes: data["documentTypes"]?.map((d) => newDocumentTypeDetail(d)) || [],
  } as any;
}

export function newPlanTaskDetailsDocumentsResponse(
  variables: PlanTaskDetailsDocumentsQueryVariables,
  data: PlanTaskDetailsDocumentsDataOptions | Error,
): MockedResponse<PlanTaskDetailsDocumentsQueryVariables, PlanTaskDetailsDocumentsQuery> {
  return {
    request: { query: PlanTaskDetailsDocumentsDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanTaskDetailsDocumentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SavePlanTaskChecklistItemDataOptions {
  savePlanTaskChecklistItem?: SavePlanTaskChecklistItemResult | SavePlanTaskChecklistItemResultOptions;
}

export function newSavePlanTaskChecklistItemData(
  data: SavePlanTaskChecklistItemDataOptions,
): SavePlanTaskChecklistItemMutation {
  return {
    __typename: "Mutation" as const,
    savePlanTaskChecklistItem: maybeNew(
      "SavePlanTaskChecklistItemResult",
      data["savePlanTaskChecklistItem"] || undefined,
      {},
    ),
  } as any;
}

export function newSavePlanTaskChecklistItemResponse(
  variables: SavePlanTaskChecklistItemMutationVariables,
  data: SavePlanTaskChecklistItemDataOptions | Error,
): MockedResponse<SavePlanTaskChecklistItemMutationVariables, SavePlanTaskChecklistItemMutation> {
  return {
    request: { query: SavePlanTaskChecklistItemDocument, variables },
    result: { data: data instanceof Error ? undefined : newSavePlanTaskChecklistItemData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeletePlanTaskChecklistItemDataOptions {
  deletePlanTaskChecklistItem?: EmptyResult | EmptyResultOptions;
}

export function newDeletePlanTaskChecklistItemData(
  data: DeletePlanTaskChecklistItemDataOptions,
): DeletePlanTaskChecklistItemMutation {
  return {
    __typename: "Mutation" as const,
    deletePlanTaskChecklistItem: maybeNew("EmptyResult", data["deletePlanTaskChecklistItem"] || undefined, {}),
  } as any;
}

export function newDeletePlanTaskChecklistItemResponse(
  variables: DeletePlanTaskChecklistItemMutationVariables,
  data: DeletePlanTaskChecklistItemDataOptions | Error,
): MockedResponse<DeletePlanTaskChecklistItemMutationVariables, DeletePlanTaskChecklistItemMutation> {
  return {
    request: { query: DeletePlanTaskChecklistItemDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeletePlanTaskChecklistItemData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SavePlanTaskDataOptions {
  savePlanTask?: SavePlanTaskResult | SavePlanTaskResultOptions;
}

export function newSavePlanTaskData(data: SavePlanTaskDataOptions): SavePlanTaskMutation {
  return {
    __typename: "Mutation" as const,
    savePlanTask: maybeNew("SavePlanTaskResult", data["savePlanTask"] || undefined, {}),
  } as any;
}

export function newSavePlanTaskResponse(
  variables: SavePlanTaskMutationVariables,
  data: SavePlanTaskDataOptions | Error,
): MockedResponse<SavePlanTaskMutationVariables, SavePlanTaskMutation> {
  return {
    request: { query: SavePlanTaskDocument, variables },
    result: { data: data instanceof Error ? undefined : newSavePlanTaskData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveRequiredTaskDocumentOnPlanTaskDataOptions {
  saveRequiredTaskDocument?: SaveRequiredTaskDocumentResult | SaveRequiredTaskDocumentResultOptions;
}

export function newSaveRequiredTaskDocumentOnPlanTaskData(
  data: SaveRequiredTaskDocumentOnPlanTaskDataOptions,
): SaveRequiredTaskDocumentOnPlanTaskMutation {
  return {
    __typename: "Mutation" as const,
    saveRequiredTaskDocument: maybeNew(
      "SaveRequiredTaskDocumentResult",
      data["saveRequiredTaskDocument"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveRequiredTaskDocumentOnPlanTaskResponse(
  variables: SaveRequiredTaskDocumentOnPlanTaskMutationVariables,
  data: SaveRequiredTaskDocumentOnPlanTaskDataOptions | Error,
): MockedResponse<SaveRequiredTaskDocumentOnPlanTaskMutationVariables, SaveRequiredTaskDocumentOnPlanTaskMutation> {
  return {
    request: { query: SaveRequiredTaskDocumentOnPlanTaskDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveRequiredTaskDocumentOnPlanTaskData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanMilestoneDetailsPageDataOptions {
  planMilestone?: PlanMilestone | PlanMilestoneOptions;
}

export function newPlanMilestoneDetailsPageData(
  data: PlanMilestoneDetailsPageDataOptions,
): PlanMilestoneDetailsPageQuery {
  return {
    __typename: "Query" as const,
    planMilestone: maybeNew("PlanMilestone", data["planMilestone"] || undefined, {}),
  } as any;
}

export function newPlanMilestoneDetailsPageResponse(
  variables: PlanMilestoneDetailsPageQueryVariables,
  data: PlanMilestoneDetailsPageDataOptions | Error,
): MockedResponse<PlanMilestoneDetailsPageQueryVariables, PlanMilestoneDetailsPageQuery> {
  return {
    request: { query: PlanMilestoneDetailsPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanMilestoneDetailsPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TaskTradePartnerContentMetadataDataOptions {
  tradePartners?: (TradePartner | TradePartnerOptions)[];
}

export function newTaskTradePartnerContentMetadataData(
  data: TaskTradePartnerContentMetadataDataOptions,
): TaskTradePartnerContentMetadataQuery {
  return {
    __typename: "Query" as const,
    tradePartners: data["tradePartners"]?.map((d) => newTradePartner(d)) || [],
  } as any;
}

export function newTaskTradePartnerContentMetadataResponse(
  variables: TaskTradePartnerContentMetadataQueryVariables,
  data: TaskTradePartnerContentMetadataDataOptions | Error,
): MockedResponse<TaskTradePartnerContentMetadataQueryVariables, TaskTradePartnerContentMetadataQuery> {
  return {
    request: { query: TaskTradePartnerContentMetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newTaskTradePartnerContentMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanTaskMaterialsPageDataOptions {
  planTask?: PlanTask | PlanTaskOptions;
}

export function newPlanTaskMaterialsPageData(data: PlanTaskMaterialsPageDataOptions): PlanTaskMaterialsPageQuery {
  return { __typename: "Query" as const, planTask: maybeNew("PlanTask", data["planTask"] || undefined, {}) } as any;
}

export function newPlanTaskMaterialsPageResponse(
  variables: PlanTaskMaterialsPageQueryVariables,
  data: PlanTaskMaterialsPageDataOptions | Error,
): MockedResponse<PlanTaskMaterialsPageQueryVariables, PlanTaskMaterialsPageQuery> {
  return {
    request: { query: PlanTaskMaterialsPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanTaskMaterialsPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveChangeEventExpenseLineItemDataOptions {
  saveChangeEvent?: SaveChangeEventResult | SaveChangeEventResultOptions;
}

export function newSaveChangeEventExpenseLineItemData(
  data: SaveChangeEventExpenseLineItemDataOptions,
): SaveChangeEventExpenseLineItemMutation {
  return {
    __typename: "Mutation" as const,
    saveChangeEvent: maybeNew("SaveChangeEventResult", data["saveChangeEvent"] || undefined, {}),
  } as any;
}

export function newSaveChangeEventExpenseLineItemResponse(
  variables: SaveChangeEventExpenseLineItemMutationVariables,
  data: SaveChangeEventExpenseLineItemDataOptions | Error,
): MockedResponse<SaveChangeEventExpenseLineItemMutationVariables, SaveChangeEventExpenseLineItemMutation> {
  return {
    request: { query: SaveChangeEventExpenseLineItemDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveChangeEventExpenseLineItemData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChangeEventFormContentDataOptions {
  items?: (Item | ItemOptions)[];
  unitsOfMeasure?: (UnitOfMeasure | UnitOfMeasureOptions)[];
  project?: Project | ProjectOptions;
  changeEventReasons?: (ChangeEventReason | ChangeEventReasonOptions)[];
}

export function newChangeEventFormContentData(data: ChangeEventFormContentDataOptions): ChangeEventFormContentQuery {
  return {
    __typename: "Query" as const,
    items: data["items"]?.map((d) => newItem(d)) || [],
    unitsOfMeasure: data["unitsOfMeasure"]?.map((d) => newUnitOfMeasure(d)) || [],
    project: maybeNew("Project", data["project"] || undefined, {}),
    changeEventReasons: data["changeEventReasons"]?.map((d) => newChangeEventReason(d)) || [],
  } as any;
}

export function newChangeEventFormContentResponse(
  variables: ChangeEventFormContentQueryVariables,
  data: ChangeEventFormContentDataOptions | Error,
): MockedResponse<ChangeEventFormContentQueryVariables, ChangeEventFormContentQuery> {
  return {
    request: { query: ChangeEventFormContentDocument, variables },
    result: { data: data instanceof Error ? undefined : newChangeEventFormContentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface HomeownerContractSummariesDataOptions {
  project?: Project | ProjectOptions;
}

export function newHomeownerContractSummariesData(
  data: HomeownerContractSummariesDataOptions,
): HomeownerContractSummariesQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newHomeownerContractSummariesResponse(
  variables: HomeownerContractSummariesQueryVariables,
  data: HomeownerContractSummariesDataOptions | Error,
): MockedResponse<HomeownerContractSummariesQueryVariables, HomeownerContractSummariesQuery> {
  return {
    request: { query: HomeownerContractSummariesDocument, variables },
    result: { data: data instanceof Error ? undefined : newHomeownerContractSummariesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveInvoiceV2DataOptions {
  saveInvoice?: SaveInvoiceResult | SaveInvoiceResultOptions;
}

export function newSaveInvoiceV2Data(data: SaveInvoiceV2DataOptions): SaveInvoiceV2Mutation {
  return {
    __typename: "Mutation" as const,
    saveInvoice: maybeNew("SaveInvoiceResult", data["saveInvoice"] || undefined, {}),
  } as any;
}

export function newSaveInvoiceV2Response(
  variables: SaveInvoiceV2MutationVariables,
  data: SaveInvoiceV2DataOptions | Error,
): MockedResponse<SaveInvoiceV2MutationVariables, SaveInvoiceV2Mutation> {
  return {
    request: { query: SaveInvoiceV2Document, variables },
    result: { data: data instanceof Error ? undefined : newSaveInvoiceV2Data(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteInvoiceV2DataOptions {
  deleteInvoice?: EmptyResult | EmptyResultOptions;
}

export function newDeleteInvoiceV2Data(data: DeleteInvoiceV2DataOptions): DeleteInvoiceV2Mutation {
  return {
    __typename: "Mutation" as const,
    deleteInvoice: maybeNew("EmptyResult", data["deleteInvoice"] || undefined, {}),
  } as any;
}

export function newDeleteInvoiceV2Response(
  variables: DeleteInvoiceV2MutationVariables,
  data: DeleteInvoiceV2DataOptions | Error,
): MockedResponse<DeleteInvoiceV2MutationVariables, DeleteInvoiceV2Mutation> {
  return {
    request: { query: DeleteInvoiceV2Document, variables },
    result: { data: data instanceof Error ? undefined : newDeleteInvoiceV2Data(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface InvoicePageV2DataOptions {
  invoice?: Invoice | InvoiceOptions;
}

export function newInvoicePageV2Data(data: InvoicePageV2DataOptions): InvoicePageV2Query {
  return { __typename: "Query" as const, invoice: maybeNew("Invoice", data["invoice"] || undefined, {}) } as any;
}

export function newInvoicePageV2Response(
  variables: InvoicePageV2QueryVariables,
  data: InvoicePageV2DataOptions | Error,
): MockedResponse<InvoicePageV2QueryVariables, InvoicePageV2Query> {
  return {
    request: { query: InvoicePageV2Document, variables },
    result: { data: data instanceof Error ? undefined : newInvoicePageV2Data(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface InvoiceProjectDataDataOptions {
  project?: Project | ProjectOptions;
}

export function newInvoiceProjectDataData(data: InvoiceProjectDataDataOptions): InvoiceProjectDataQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newInvoiceProjectDataResponse(
  variables: InvoiceProjectDataQueryVariables,
  data: InvoiceProjectDataDataOptions | Error,
): MockedResponse<InvoiceProjectDataQueryVariables, InvoiceProjectDataQuery> {
  return {
    request: { query: InvoiceProjectDataDocument, variables },
    result: { data: data instanceof Error ? undefined : newInvoiceProjectDataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface InvoiceIntacctSyncErrorDataOptions {
  invoice?: Invoice | InvoiceOptions;
}

export function newInvoiceIntacctSyncErrorData(data: InvoiceIntacctSyncErrorDataOptions): InvoiceIntacctSyncErrorQuery {
  return { __typename: "Query" as const, invoice: maybeNew("Invoice", data["invoice"] || undefined, {}) } as any;
}

export function newInvoiceIntacctSyncErrorResponse(
  variables: InvoiceIntacctSyncErrorQueryVariables,
  data: InvoiceIntacctSyncErrorDataOptions | Error,
): MockedResponse<InvoiceIntacctSyncErrorQueryVariables, InvoiceIntacctSyncErrorQuery> {
  return {
    request: { query: InvoiceIntacctSyncErrorDocument, variables },
    result: { data: data instanceof Error ? undefined : newInvoiceIntacctSyncErrorData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SyncInvoiceToIntacctDataOptions {
  syncInvoiceToIntacct?: EmptyResult | EmptyResultOptions;
}

export function newSyncInvoiceToIntacctData(data: SyncInvoiceToIntacctDataOptions): SyncInvoiceToIntacctMutation {
  return {
    __typename: "Mutation" as const,
    syncInvoiceToIntacct: maybeNew("EmptyResult", data["syncInvoiceToIntacct"] || undefined, {}),
  } as any;
}

export function newSyncInvoiceToIntacctResponse(
  variables: SyncInvoiceToIntacctMutationVariables,
  data: SyncInvoiceToIntacctDataOptions | Error,
): MockedResponse<SyncInvoiceToIntacctMutationVariables, SyncInvoiceToIntacctMutation> {
  return {
    request: { query: SyncInvoiceToIntacctDocument, variables },
    result: { data: data instanceof Error ? undefined : newSyncInvoiceToIntacctData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ExpensesTableByProjectIdDataOptions {
  expensesPage?: ExpensesPage | ExpensesPageOptions;
}

export function newExpensesTableByProjectIdData(
  data: ExpensesTableByProjectIdDataOptions,
): ExpensesTableByProjectIdQuery {
  return {
    __typename: "Query" as const,
    expensesPage: maybeNew("ExpensesPage", data["expensesPage"] || undefined, {}),
  } as any;
}

export function newExpensesTableByProjectIdResponse(
  variables: ExpensesTableByProjectIdQueryVariables,
  data: ExpensesTableByProjectIdDataOptions | Error,
): MockedResponse<ExpensesTableByProjectIdQueryVariables, ExpensesTableByProjectIdQuery> {
  return {
    request: { query: ExpensesTableByProjectIdDocument, variables },
    result: { data: data instanceof Error ? undefined : newExpensesTableByProjectIdData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveDocumentsToExpenseDataOptions {
  saveExpenses?: SaveExpensesResult | SaveExpensesResultOptions;
}

export function newSaveDocumentsToExpenseData(data: SaveDocumentsToExpenseDataOptions): SaveDocumentsToExpenseMutation {
  return {
    __typename: "Mutation" as const,
    saveExpenses: maybeNew("SaveExpensesResult", data["saveExpenses"] || undefined, {}),
  } as any;
}

export function newSaveDocumentsToExpenseResponse(
  variables: SaveDocumentsToExpenseMutationVariables,
  data: SaveDocumentsToExpenseDataOptions | Error,
): MockedResponse<SaveDocumentsToExpenseMutationVariables, SaveDocumentsToExpenseMutation> {
  return {
    request: { query: SaveDocumentsToExpenseDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveDocumentsToExpenseData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveExpenseTableDocumentDataOptions {
  saveDocuments?: SaveDocumentsResult | SaveDocumentsResultOptions;
}

export function newSaveExpenseTableDocumentData(
  data: SaveExpenseTableDocumentDataOptions,
): SaveExpenseTableDocumentMutation {
  return {
    __typename: "Mutation" as const,
    saveDocuments: maybeNew("SaveDocumentsResult", data["saveDocuments"] || undefined, {}),
  } as any;
}

export function newSaveExpenseTableDocumentResponse(
  variables: SaveExpenseTableDocumentMutationVariables,
  data: SaveExpenseTableDocumentDataOptions | Error,
): MockedResponse<SaveExpenseTableDocumentMutationVariables, SaveExpenseTableDocumentMutation> {
  return {
    request: { query: SaveExpenseTableDocumentDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveExpenseTableDocumentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveExpenseDataOptions {
  saveExpenses?: SaveExpensesResult | SaveExpensesResultOptions;
}

export function newSaveExpenseData(data: SaveExpenseDataOptions): SaveExpenseMutation {
  return {
    __typename: "Mutation" as const,
    saveExpenses: maybeNew("SaveExpensesResult", data["saveExpenses"] || undefined, {}),
  } as any;
}

export function newSaveExpenseResponse(
  variables: SaveExpenseMutationVariables,
  data: SaveExpenseDataOptions | Error,
): MockedResponse<SaveExpenseMutationVariables, SaveExpenseMutation> {
  return {
    request: { query: SaveExpenseDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveExpenseData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveExpenseAllocationsDataOptions {
  saveExpenseAllocations?: SaveExpenseAllocationsResult | SaveExpenseAllocationsResultOptions;
}

export function newSaveExpenseAllocationsData(data: SaveExpenseAllocationsDataOptions): SaveExpenseAllocationsMutation {
  return {
    __typename: "Mutation" as const,
    saveExpenseAllocations: maybeNew("SaveExpenseAllocationsResult", data["saveExpenseAllocations"] || undefined, {}),
  } as any;
}

export function newSaveExpenseAllocationsResponse(
  variables: SaveExpenseAllocationsMutationVariables,
  data: SaveExpenseAllocationsDataOptions | Error,
): MockedResponse<SaveExpenseAllocationsMutationVariables, SaveExpenseAllocationsMutation> {
  return {
    request: { query: SaveExpenseAllocationsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveExpenseAllocationsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ConvertExpenseToBillDataOptions {
  convertExpenseToBill?: ConvertExpenseToBillResult | ConvertExpenseToBillResultOptions;
}

export function newConvertExpenseToBillData(data: ConvertExpenseToBillDataOptions): ConvertExpenseToBillMutation {
  return {
    __typename: "Mutation" as const,
    convertExpenseToBill: maybeNew("ConvertExpenseToBillResult", data["convertExpenseToBill"] || undefined, {}),
  } as any;
}

export function newConvertExpenseToBillResponse(
  variables: ConvertExpenseToBillMutationVariables,
  data: ConvertExpenseToBillDataOptions | Error,
): MockedResponse<ConvertExpenseToBillMutationVariables, ConvertExpenseToBillMutation> {
  return {
    request: { query: ConvertExpenseToBillDocument, variables },
    result: { data: data instanceof Error ? undefined : newConvertExpenseToBillData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveHomeownerNoteDataOptions {
  saveHomeownerNote?: SaveHomeownerNoteResult | SaveHomeownerNoteResultOptions;
}

export function newSaveHomeownerNoteData(data: SaveHomeownerNoteDataOptions): SaveHomeownerNoteMutation {
  return {
    __typename: "Mutation" as const,
    saveHomeownerNote: maybeNew("SaveHomeownerNoteResult", data["saveHomeownerNote"] || undefined, {}),
  } as any;
}

export function newSaveHomeownerNoteResponse(
  variables: SaveHomeownerNoteMutationVariables,
  data: SaveHomeownerNoteDataOptions | Error,
): MockedResponse<SaveHomeownerNoteMutationVariables, SaveHomeownerNoteMutation> {
  return {
    request: { query: SaveHomeownerNoteDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveHomeownerNoteData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteHomeownerNoteDataOptions {
  deleteHomeownerNote?: EmptyResult | EmptyResultOptions | null;
}

export function newDeleteHomeownerNoteData(data: DeleteHomeownerNoteDataOptions): DeleteHomeownerNoteMutation {
  return {
    __typename: "Mutation" as const,
    deleteHomeownerNote: maybeNewOrNull("EmptyResult", data["deleteHomeownerNote"] || undefined, {}),
  } as any;
}

export function newDeleteHomeownerNoteResponse(
  variables: DeleteHomeownerNoteMutationVariables,
  data: DeleteHomeownerNoteDataOptions | Error,
): MockedResponse<DeleteHomeownerNoteMutationVariables, DeleteHomeownerNoteMutation> {
  return {
    request: { query: DeleteHomeownerNoteDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteHomeownerNoteData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface EditHomeownerNoteDataOptions {
  homeownerNote?: HomeownerNote | HomeownerNoteOptions;
}

export function newEditHomeownerNoteData(data: EditHomeownerNoteDataOptions): EditHomeownerNoteQuery {
  return {
    __typename: "Query" as const,
    homeownerNote: maybeNew("HomeownerNote", data["homeownerNote"] || undefined, {}),
  } as any;
}

export function newEditHomeownerNoteResponse(
  variables: EditHomeownerNoteQueryVariables,
  data: EditHomeownerNoteDataOptions | Error,
): MockedResponse<EditHomeownerNoteQueryVariables, EditHomeownerNoteQuery> {
  return {
    request: { query: EditHomeownerNoteDocument, variables },
    result: { data: data instanceof Error ? undefined : newEditHomeownerNoteData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScheduleTasksForHomeownerNoteDataOptions {
  scheduleTasks?: (ScheduleTask | ScheduleTaskOptions)[];
}

export function newScheduleTasksForHomeownerNoteData(
  data: ScheduleTasksForHomeownerNoteDataOptions,
): ScheduleTasksForHomeownerNoteQuery {
  return {
    __typename: "Query" as const,
    scheduleTasks: data["scheduleTasks"]?.map((d) => newScheduleTask(d)) || [],
  } as any;
}

export function newScheduleTasksForHomeownerNoteResponse(
  variables: ScheduleTasksForHomeownerNoteQueryVariables,
  data: ScheduleTasksForHomeownerNoteDataOptions | Error,
): MockedResponse<ScheduleTasksForHomeownerNoteQueryVariables, ScheduleTasksForHomeownerNoteQuery> {
  return {
    request: { query: ScheduleTasksForHomeownerNoteDocument, variables },
    result: { data: data instanceof Error ? undefined : newScheduleTasksForHomeownerNoteData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScheduleCalendarTasksDataOptions {
  scheduleTasks?: (ScheduleTask | ScheduleTaskOptions)[];
}

export function newScheduleCalendarTasksData(data: ScheduleCalendarTasksDataOptions): ScheduleCalendarTasksQuery {
  return {
    __typename: "Query" as const,
    scheduleTasks: data["scheduleTasks"]?.map((d) => newScheduleTask(d)) || [],
  } as any;
}

export function newScheduleCalendarTasksResponse(
  variables: ScheduleCalendarTasksQueryVariables,
  data: ScheduleCalendarTasksDataOptions | Error,
): MockedResponse<ScheduleCalendarTasksQueryVariables, ScheduleCalendarTasksQuery> {
  return {
    request: { query: ScheduleCalendarTasksDocument, variables },
    result: { data: data instanceof Error ? undefined : newScheduleCalendarTasksData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScheduleHistoryTabDataOptions {
  scheduleTask?: ScheduleTask | ScheduleTaskOptions;
}

export function newScheduleHistoryTabData(data: ScheduleHistoryTabDataOptions): ScheduleHistoryTabQuery {
  return {
    __typename: "Query" as const,
    scheduleTask: maybeNew("ScheduleTask", data["scheduleTask"] || undefined, {}),
  } as any;
}

export function newScheduleHistoryTabResponse(
  variables: ScheduleHistoryTabQueryVariables,
  data: ScheduleHistoryTabDataOptions | Error,
): MockedResponse<ScheduleHistoryTabQueryVariables, ScheduleHistoryTabQuery> {
  return {
    request: { query: ScheduleHistoryTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newScheduleHistoryTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface GlobalTasksHeaderDataDataOptions {
  scheduleTasks?: (ScheduleTask | ScheduleTaskOptions)[];
  schedule?: Schedule | ScheduleOptions;
}

export function newGlobalTasksHeaderDataData(data: GlobalTasksHeaderDataDataOptions): GlobalTasksHeaderDataQuery {
  return {
    __typename: "Query" as const,
    scheduleTasks: data["scheduleTasks"]?.map((d) => newScheduleTask(d)) || [],
    schedule: maybeNew("Schedule", data["schedule"] || undefined, {}),
  } as any;
}

export function newGlobalTasksHeaderDataResponse(
  variables: GlobalTasksHeaderDataQueryVariables,
  data: GlobalTasksHeaderDataDataOptions | Error,
): MockedResponse<GlobalTasksHeaderDataQueryVariables, GlobalTasksHeaderDataQuery> {
  return {
    request: { query: GlobalTasksHeaderDataDocument, variables },
    result: { data: data instanceof Error ? undefined : newGlobalTasksHeaderDataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TaskBillModalContextDataOptions {
  task?: Task | TaskOptions;
}

export function newTaskBillModalContextData(data: TaskBillModalContextDataOptions): TaskBillModalContextQuery {
  return { __typename: "Query" as const, task: maybeNew("Task", data["task"] || undefined, {}) } as any;
}

export function newTaskBillModalContextResponse(
  variables: TaskBillModalContextQueryVariables,
  data: TaskBillModalContextDataOptions | Error,
): MockedResponse<TaskBillModalContextQueryVariables, TaskBillModalContextQuery> {
  return {
    request: { query: TaskBillModalContextDocument, variables },
    result: { data: data instanceof Error ? undefined : newTaskBillModalContextData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TaskDetailPaneDataOptions {
  scheduleTask?: ScheduleTask | ScheduleTaskOptions;
  tradePartners?: (TradePartner | TradePartnerOptions)[];
  documents?: (Document | DocumentOptions)[];
}

export function newTaskDetailPaneData(data: TaskDetailPaneDataOptions): TaskDetailPaneQuery {
  return {
    __typename: "Query" as const,
    scheduleTask: maybeNew("ScheduleTask", data["scheduleTask"] || undefined, {}),
    tradePartners: data["tradePartners"]?.map((d) => newTradePartner(d)) || [],
    documents: data["documents"]?.map((d) => newDocument(d)) || [],
  } as any;
}

export function newTaskDetailPaneResponse(
  variables: TaskDetailPaneQueryVariables,
  data: TaskDetailPaneDataOptions | Error,
): MockedResponse<TaskDetailPaneQueryVariables, TaskDetailPaneQuery> {
  return {
    request: { query: TaskDetailPaneDocument, variables },
    result: { data: data instanceof Error ? undefined : newTaskDetailPaneData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TaskDetailPaneDropdownOptionsDataOptions {
  taskStatuses?: (TaskStatusDetail | TaskStatusDetailOptions)[];
  documentTypes?: (DocumentTypeDetail | DocumentTypeDetailOptions)[];
}

export function newTaskDetailPaneDropdownOptionsData(
  data: TaskDetailPaneDropdownOptionsDataOptions,
): TaskDetailPaneDropdownOptionsQuery {
  return {
    __typename: "Query" as const,
    taskStatuses: data["taskStatuses"]?.map((d) => newTaskStatusDetail(d)) || [],
    documentTypes: data["documentTypes"]?.map((d) => newDocumentTypeDetail(d)) || [],
  } as any;
}

export function newTaskDetailPaneDropdownOptionsResponse(
  data: TaskDetailPaneDropdownOptionsDataOptions | Error,
): MockedResponse<TaskDetailPaneDropdownOptionsQueryVariables, TaskDetailPaneDropdownOptionsQuery> {
  return {
    request: { query: TaskDetailPaneDropdownOptionsDocument },
    result: { data: data instanceof Error ? undefined : newTaskDetailPaneDropdownOptionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveTaskDocumentsDataOptions {
  saveDocuments?: SaveDocumentsResult | SaveDocumentsResultOptions;
}

export function newSaveTaskDocumentsData(data: SaveTaskDocumentsDataOptions): SaveTaskDocumentsMutation {
  return {
    __typename: "Mutation" as const,
    saveDocuments: maybeNew("SaveDocumentsResult", data["saveDocuments"] || undefined, {}),
  } as any;
}

export function newSaveTaskDocumentsResponse(
  variables: SaveTaskDocumentsMutationVariables,
  data: SaveTaskDocumentsDataOptions | Error,
): MockedResponse<SaveTaskDocumentsMutationVariables, SaveTaskDocumentsMutation> {
  return {
    request: { query: SaveTaskDocumentsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveTaskDocumentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveRequiredTaskDocumentDataOptions {
  saveRequiredTaskDocument?: SaveRequiredTaskDocumentResult | SaveRequiredTaskDocumentResultOptions;
}

export function newSaveRequiredTaskDocumentData(
  data: SaveRequiredTaskDocumentDataOptions,
): SaveRequiredTaskDocumentMutation {
  return {
    __typename: "Mutation" as const,
    saveRequiredTaskDocument: maybeNew(
      "SaveRequiredTaskDocumentResult",
      data["saveRequiredTaskDocument"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveRequiredTaskDocumentResponse(
  variables: SaveRequiredTaskDocumentMutationVariables,
  data: SaveRequiredTaskDocumentDataOptions | Error,
): MockedResponse<SaveRequiredTaskDocumentMutationVariables, SaveRequiredTaskDocumentMutation> {
  return {
    request: { query: SaveRequiredTaskDocumentDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveRequiredTaskDocumentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteRequiredTaskDocumentDataOptions {
  deleteRequireTaskDocument?: DeleteRequiredTaskDocumentResult | DeleteRequiredTaskDocumentResultOptions;
}

export function newDeleteRequiredTaskDocumentData(
  data: DeleteRequiredTaskDocumentDataOptions,
): DeleteRequiredTaskDocumentMutation {
  return {
    __typename: "Mutation" as const,
    deleteRequireTaskDocument: maybeNew(
      "DeleteRequiredTaskDocumentResult",
      data["deleteRequireTaskDocument"] || undefined,
      {},
    ),
  } as any;
}

export function newDeleteRequiredTaskDocumentResponse(
  variables: DeleteRequiredTaskDocumentMutationVariables,
  data: DeleteRequiredTaskDocumentDataOptions | Error,
): MockedResponse<DeleteRequiredTaskDocumentMutationVariables, DeleteRequiredTaskDocumentMutation> {
  return {
    request: { query: DeleteRequiredTaskDocumentDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteRequiredTaskDocumentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectRoleDetailsDataOptions {
  projectRoleDetails?: (ProjectRoleDetail | ProjectRoleDetailOptions)[];
}

export function newProjectRoleDetailsData(data: ProjectRoleDetailsDataOptions): ProjectRoleDetailsQuery {
  return {
    __typename: "Query" as const,
    projectRoleDetails: data["projectRoleDetails"]?.map((d) => newProjectRoleDetail(d)) || [],
  } as any;
}

export function newProjectRoleDetailsResponse(
  data: ProjectRoleDetailsDataOptions | Error,
): MockedResponse<ProjectRoleDetailsQueryVariables, ProjectRoleDetailsQuery> {
  return {
    request: { query: ProjectRoleDetailsDocument },
    result: { data: data instanceof Error ? undefined : newProjectRoleDetailsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteScheduleTaskChecklistItemDataOptions {
  deleteScheduleTaskChecklistItem?: EmptyResult | EmptyResultOptions;
}

export function newDeleteScheduleTaskChecklistItemData(
  data: DeleteScheduleTaskChecklistItemDataOptions,
): DeleteScheduleTaskChecklistItemMutation {
  return {
    __typename: "Mutation" as const,
    deleteScheduleTaskChecklistItem: maybeNew("EmptyResult", data["deleteScheduleTaskChecklistItem"] || undefined, {}),
  } as any;
}

export function newDeleteScheduleTaskChecklistItemResponse(
  variables: DeleteScheduleTaskChecklistItemMutationVariables,
  data: DeleteScheduleTaskChecklistItemDataOptions | Error,
): MockedResponse<DeleteScheduleTaskChecklistItemMutationVariables, DeleteScheduleTaskChecklistItemMutation> {
  return {
    request: { query: DeleteScheduleTaskChecklistItemDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteScheduleTaskChecklistItemData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveScheduleTaskChecklistItemDataOptions {
  saveScheduleTaskChecklistItem?: SaveScheduleTaskChecklistItemResult | SaveScheduleTaskChecklistItemResultOptions;
}

export function newSaveScheduleTaskChecklistItemData(
  data: SaveScheduleTaskChecklistItemDataOptions,
): SaveScheduleTaskChecklistItemMutation {
  return {
    __typename: "Mutation" as const,
    saveScheduleTaskChecklistItem: maybeNew(
      "SaveScheduleTaskChecklistItemResult",
      data["saveScheduleTaskChecklistItem"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveScheduleTaskChecklistItemResponse(
  variables: SaveScheduleTaskChecklistItemMutationVariables,
  data: SaveScheduleTaskChecklistItemDataOptions | Error,
): MockedResponse<SaveScheduleTaskChecklistItemMutationVariables, SaveScheduleTaskChecklistItemMutation> {
  return {
    request: { query: SaveScheduleTaskChecklistItemDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveScheduleTaskChecklistItemData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScheduleGanttDataOptions {
  schedule?: Schedule | ScheduleOptions;
  scheduleTasks?: (ScheduleTask | ScheduleTaskOptions)[];
  schedulePhases?: (SchedulePhase | SchedulePhaseOptions)[];
}

export function newScheduleGanttData(data: ScheduleGanttDataOptions): ScheduleGanttQuery {
  return {
    __typename: "Query" as const,
    schedule: maybeNew("Schedule", data["schedule"] || undefined, {}),
    scheduleTasks: data["scheduleTasks"]?.map((d) => newScheduleTask(d)) || [],
    schedulePhases: data["schedulePhases"]?.map((d) => newSchedulePhase(d)) || [],
  } as any;
}

export function newScheduleGanttResponse(
  variables: ScheduleGanttQueryVariables,
  data: ScheduleGanttDataOptions | Error,
): MockedResponse<ScheduleGanttQueryVariables, ScheduleGanttQuery> {
  return {
    request: { query: ScheduleGanttDocument, variables },
    result: { data: data instanceof Error ? undefined : newScheduleGanttData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveGanttScheduleTasksDataOptions {
  saveScheduleTasks?: SaveScheduleTasksResult | SaveScheduleTasksResultOptions;
}

export function newSaveGanttScheduleTasksData(data: SaveGanttScheduleTasksDataOptions): SaveGanttScheduleTasksMutation {
  return {
    __typename: "Mutation" as const,
    saveScheduleTasks: maybeNew("SaveScheduleTasksResult", data["saveScheduleTasks"] || undefined, {}),
  } as any;
}

export function newSaveGanttScheduleTasksResponse(
  variables: SaveGanttScheduleTasksMutationVariables,
  data: SaveGanttScheduleTasksDataOptions | Error,
): MockedResponse<SaveGanttScheduleTasksMutationVariables, SaveGanttScheduleTasksMutation> {
  return {
    request: { query: SaveGanttScheduleTasksDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveGanttScheduleTasksData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveScheduleSubPhasesDataOptions {
  saveScheduleSubPhases?: SaveScheduleSubPhasesResult | SaveScheduleSubPhasesResultOptions;
}

export function newSaveScheduleSubPhasesData(data: SaveScheduleSubPhasesDataOptions): SaveScheduleSubPhasesMutation {
  return {
    __typename: "Mutation" as const,
    saveScheduleSubPhases: maybeNew("SaveScheduleSubPhasesResult", data["saveScheduleSubPhases"] || undefined, {}),
  } as any;
}

export function newSaveScheduleSubPhasesResponse(
  variables: SaveScheduleSubPhasesMutationVariables,
  data: SaveScheduleSubPhasesDataOptions | Error,
): MockedResponse<SaveScheduleSubPhasesMutationVariables, SaveScheduleSubPhasesMutation> {
  return {
    request: { query: SaveScheduleSubPhasesDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveScheduleSubPhasesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddScheduleTaskDataOptions {
  tradePartners?: (TradePartner | TradePartnerOptions)[];
  internalUsers?: (InternalUser | InternalUserOptions)[];
}

export function newAddScheduleTaskData(data: AddScheduleTaskDataOptions): AddScheduleTaskQuery {
  return {
    __typename: "Query" as const,
    tradePartners: data["tradePartners"]?.map((d) => newTradePartner(d)) || [],
    internalUsers: data["internalUsers"]?.map((d) => newInternalUser(d)) || [],
  } as any;
}

export function newAddScheduleTaskResponse(
  variables: AddScheduleTaskQueryVariables,
  data: AddScheduleTaskDataOptions | Error,
): MockedResponse<AddScheduleTaskQueryVariables, AddScheduleTaskQuery> {
  return {
    request: { query: AddScheduleTaskDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddScheduleTaskData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScheduleTaskPhasesDataOptions {
  schedule?: Schedule | ScheduleOptions;
}

export function newScheduleTaskPhasesData(data: ScheduleTaskPhasesDataOptions): ScheduleTaskPhasesQuery {
  return { __typename: "Query" as const, schedule: maybeNew("Schedule", data["schedule"] || undefined, {}) } as any;
}

export function newScheduleTaskPhasesResponse(
  variables: ScheduleTaskPhasesQueryVariables,
  data: ScheduleTaskPhasesDataOptions | Error,
): MockedResponse<ScheduleTaskPhasesQueryVariables, ScheduleTaskPhasesQuery> {
  return {
    request: { query: ScheduleTaskPhasesDocument, variables },
    result: { data: data instanceof Error ? undefined : newScheduleTaskPhasesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteScheduleSubPhaseDataOptions {
  deleteScheduleSubPhases?: DeleteScheduleSubPhasesResult | DeleteScheduleSubPhasesResultOptions;
}

export function newDeleteScheduleSubPhaseData(data: DeleteScheduleSubPhaseDataOptions): DeleteScheduleSubPhaseMutation {
  return {
    __typename: "Mutation" as const,
    deleteScheduleSubPhases: maybeNew(
      "DeleteScheduleSubPhasesResult",
      data["deleteScheduleSubPhases"] || undefined,
      {},
    ),
  } as any;
}

export function newDeleteScheduleSubPhaseResponse(
  variables: DeleteScheduleSubPhaseMutationVariables,
  data: DeleteScheduleSubPhaseDataOptions | Error,
): MockedResponse<DeleteScheduleSubPhaseMutationVariables, DeleteScheduleSubPhaseMutation> {
  return {
    request: { query: DeleteScheduleSubPhaseDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteScheduleSubPhaseData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteSchedulePhaseDataOptions {
  deleteSchedulePhases?: DeleteSchedulePhasesResult | DeleteSchedulePhasesResultOptions;
}

export function newDeleteSchedulePhaseData(data: DeleteSchedulePhaseDataOptions): DeleteSchedulePhaseMutation {
  return {
    __typename: "Mutation" as const,
    deleteSchedulePhases: maybeNew("DeleteSchedulePhasesResult", data["deleteSchedulePhases"] || undefined, {}),
  } as any;
}

export function newDeleteSchedulePhaseResponse(
  variables: DeleteSchedulePhaseMutationVariables,
  data: DeleteSchedulePhaseDataOptions | Error,
): MockedResponse<DeleteSchedulePhaseMutationVariables, DeleteSchedulePhaseMutation> {
  return {
    request: { query: DeleteSchedulePhaseDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteSchedulePhaseData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SetDateViaPredecessorModalDataOptions {
  scheduleTask?: ScheduleTask | ScheduleTaskOptions;
}

export function newSetDateViaPredecessorModalData(
  data: SetDateViaPredecessorModalDataOptions,
): SetDateViaPredecessorModalQuery {
  return {
    __typename: "Query" as const,
    scheduleTask: maybeNew("ScheduleTask", data["scheduleTask"] || undefined, {}),
  } as any;
}

export function newSetDateViaPredecessorModalResponse(
  variables: SetDateViaPredecessorModalQueryVariables,
  data: SetDateViaPredecessorModalDataOptions | Error,
): MockedResponse<SetDateViaPredecessorModalQueryVariables, SetDateViaPredecessorModalQuery> {
  return {
    request: { query: SetDateViaPredecessorModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newSetDateViaPredecessorModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveHomeownerUndecidedSelectionDataOptions {
  saveHomeownerSelection?: SaveHomeownerSelectionResult | SaveHomeownerSelectionResultOptions;
}

export function newSaveHomeownerUndecidedSelectionData(
  data: SaveHomeownerUndecidedSelectionDataOptions,
): SaveHomeownerUndecidedSelectionMutation {
  return {
    __typename: "Mutation" as const,
    saveHomeownerSelection: maybeNew("SaveHomeownerSelectionResult", data["saveHomeownerSelection"] || undefined, {}),
  } as any;
}

export function newSaveHomeownerUndecidedSelectionResponse(
  variables: SaveHomeownerUndecidedSelectionMutationVariables,
  data: SaveHomeownerUndecidedSelectionDataOptions | Error,
): MockedResponse<SaveHomeownerUndecidedSelectionMutationVariables, SaveHomeownerUndecidedSelectionMutation> {
  return {
    request: { query: SaveHomeownerUndecidedSelectionDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveHomeownerUndecidedSelectionData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateCommitmentModalProjectItemDataOptions {
  projectItems?: (ProjectItem | ProjectItemOptions)[];
}

export function newCreateCommitmentModalProjectItemData(
  data: CreateCommitmentModalProjectItemDataOptions,
): CreateCommitmentModalProjectItemQuery {
  return {
    __typename: "Query" as const,
    projectItems: data["projectItems"]?.map((d) => newProjectItem(d)) || [],
  } as any;
}

export function newCreateCommitmentModalProjectItemResponse(
  variables: CreateCommitmentModalProjectItemQueryVariables,
  data: CreateCommitmentModalProjectItemDataOptions | Error,
): MockedResponse<CreateCommitmentModalProjectItemQueryVariables, CreateCommitmentModalProjectItemQuery> {
  return {
    request: { query: CreateCommitmentModalProjectItemDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateCommitmentModalProjectItemData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveHomeownerSelectionDataOptions {
  saveHomeownerSelection?: SaveHomeownerSelectionResult | SaveHomeownerSelectionResultOptions;
}

export function newSaveHomeownerSelectionData(data: SaveHomeownerSelectionDataOptions): SaveHomeownerSelectionMutation {
  return {
    __typename: "Mutation" as const,
    saveHomeownerSelection: maybeNew("SaveHomeownerSelectionResult", data["saveHomeownerSelection"] || undefined, {}),
  } as any;
}

export function newSaveHomeownerSelectionResponse(
  variables: SaveHomeownerSelectionMutationVariables,
  data: SaveHomeownerSelectionDataOptions | Error,
): MockedResponse<SaveHomeownerSelectionMutationVariables, SaveHomeownerSelectionMutation> {
  return {
    request: { query: SaveHomeownerSelectionDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveHomeownerSelectionData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveHomeownerSelectionOptionDataOptions {
  saveHomeownerSelectionOption?: SaveHomeownerSelectionOptionResult | SaveHomeownerSelectionOptionResultOptions;
}

export function newSaveHomeownerSelectionOptionData(
  data: SaveHomeownerSelectionOptionDataOptions,
): SaveHomeownerSelectionOptionMutation {
  return {
    __typename: "Mutation" as const,
    saveHomeownerSelectionOption: maybeNew(
      "SaveHomeownerSelectionOptionResult",
      data["saveHomeownerSelectionOption"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveHomeownerSelectionOptionResponse(
  variables: SaveHomeownerSelectionOptionMutationVariables,
  data: SaveHomeownerSelectionOptionDataOptions | Error,
): MockedResponse<SaveHomeownerSelectionOptionMutationVariables, SaveHomeownerSelectionOptionMutation> {
  return {
    request: { query: SaveHomeownerSelectionOptionDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveHomeownerSelectionOptionData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ItApi_SaveItemTemplateItemVersionsDataOptions {
  saveItemTemplateItemVersions?: SaveItemTemplateItemVersionsResult | SaveItemTemplateItemVersionsResultOptions;
}

export function newItApi_SaveItemTemplateItemVersionsData(
  data: ItApi_SaveItemTemplateItemVersionsDataOptions,
): ItApi_SaveItemTemplateItemVersionsMutation {
  return {
    __typename: "Mutation" as const,
    saveItemTemplateItemVersions: maybeNew(
      "SaveItemTemplateItemVersionsResult",
      data["saveItemTemplateItemVersions"] || undefined,
      {},
    ),
  } as any;
}

export function newItApi_SaveItemTemplateItemVersionsResponse(
  variables: ItApi_SaveItemTemplateItemVersionsMutationVariables,
  data: ItApi_SaveItemTemplateItemVersionsDataOptions | Error,
): MockedResponse<ItApi_SaveItemTemplateItemVersionsMutationVariables, ItApi_SaveItemTemplateItemVersionsMutation> {
  return {
    request: { query: ItApi_SaveItemTemplateItemVersionsDocument, variables },
    result: { data: data instanceof Error ? undefined : newItApi_SaveItemTemplateItemVersionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ItApi_CopyItemTemplateItemsDataOptions {
  copyItemTemplateItems?: CopyItemTemplateItemsResult | CopyItemTemplateItemsResultOptions;
}

export function newItApi_CopyItemTemplateItemsData(
  data: ItApi_CopyItemTemplateItemsDataOptions,
): ItApi_CopyItemTemplateItemsMutation {
  return {
    __typename: "Mutation" as const,
    copyItemTemplateItems: maybeNew("CopyItemTemplateItemsResult", data["copyItemTemplateItems"] || undefined, {}),
  } as any;
}

export function newItApi_CopyItemTemplateItemsResponse(
  variables: ItApi_CopyItemTemplateItemsMutationVariables,
  data: ItApi_CopyItemTemplateItemsDataOptions | Error,
): MockedResponse<ItApi_CopyItemTemplateItemsMutationVariables, ItApi_CopyItemTemplateItemsMutation> {
  return {
    request: { query: ItApi_CopyItemTemplateItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newItApi_CopyItemTemplateItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ItemTemplateAnomaliesContextDataOptions {
  itemTemplate?: ItemTemplate | ItemTemplateOptions;
}

export function newItemTemplateAnomaliesContextData(
  data: ItemTemplateAnomaliesContextDataOptions,
): ItemTemplateAnomaliesContextQuery {
  return {
    __typename: "Query" as const,
    itemTemplate: maybeNew("ItemTemplate", data["itemTemplate"] || undefined, {}),
  } as any;
}

export function newItemTemplateAnomaliesContextResponse(
  variables: ItemTemplateAnomaliesContextQueryVariables,
  data: ItemTemplateAnomaliesContextDataOptions | Error,
): MockedResponse<ItemTemplateAnomaliesContextQueryVariables, ItemTemplateAnomaliesContextQuery> {
  return {
    request: { query: ItemTemplateAnomaliesContextDocument, variables },
    result: { data: data instanceof Error ? undefined : newItemTemplateAnomaliesContextData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChooseOptionsStepBodyV1DataOptions {
  readyPlanLike2?: ReadyPlanLike | ReadyPlanLikeOptions;
  globalOptions?: (GlobalOption | GlobalOptionOptions)[];
}

export function newChooseOptionsStepBodyV1Data(data: ChooseOptionsStepBodyV1DataOptions): ChooseOptionsStepBodyV1Query {
  return {
    __typename: "Query" as const,
    readyPlanLike2: maybeNew("ReadyPlanLike", data["readyPlanLike2"] || undefined, {}),
    globalOptions: data["globalOptions"]?.map((d) => newGlobalOption(d)) || [],
  } as any;
}

export function newChooseOptionsStepBodyV1Response(
  variables: ChooseOptionsStepBodyV1QueryVariables,
  data: ChooseOptionsStepBodyV1DataOptions | Error,
): MockedResponse<ChooseOptionsStepBodyV1QueryVariables, ChooseOptionsStepBodyV1Query> {
  return {
    request: { query: ChooseOptionsStepBodyV1Document, variables },
    result: { data: data instanceof Error ? undefined : newChooseOptionsStepBodyV1Data(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChooseOptionsStepBodyV1_SaveReadyPlanChosenOptionsDataOptions {
  saveReadyPlanOptions?: SaveReadyPlanOptionsResult | SaveReadyPlanOptionsResultOptions;
}

export function newChooseOptionsStepBodyV1_SaveReadyPlanChosenOptionsData(
  data: ChooseOptionsStepBodyV1_SaveReadyPlanChosenOptionsDataOptions,
): ChooseOptionsStepBodyV1_SaveReadyPlanChosenOptionsMutation {
  return {
    __typename: "Mutation" as const,
    saveReadyPlanOptions: maybeNew("SaveReadyPlanOptionsResult", data["saveReadyPlanOptions"] || undefined, {}),
  } as any;
}

export function newChooseOptionsStepBodyV1_SaveReadyPlanChosenOptionsResponse(
  variables: ChooseOptionsStepBodyV1_SaveReadyPlanChosenOptionsMutationVariables,
  data: ChooseOptionsStepBodyV1_SaveReadyPlanChosenOptionsDataOptions | Error,
): MockedResponse<
  ChooseOptionsStepBodyV1_SaveReadyPlanChosenOptionsMutationVariables,
  ChooseOptionsStepBodyV1_SaveReadyPlanChosenOptionsMutation
> {
  return {
    request: { query: ChooseOptionsStepBodyV1_SaveReadyPlanChosenOptionsDocument, variables },
    result: {
      data: data instanceof Error ? undefined : newChooseOptionsStepBodyV1_SaveReadyPlanChosenOptionsData(data),
    },
    error: data instanceof Error ? data : undefined,
  };
}
interface ManageProjectsBudgetsStepDataOptions {
  bidContractRevision?: BidContractRevision | BidContractRevisionOptions;
}

export function newManageProjectsBudgetsStepData(
  data: ManageProjectsBudgetsStepDataOptions,
): ManageProjectsBudgetsStepQuery {
  return {
    __typename: "Query" as const,
    bidContractRevision: maybeNew("BidContractRevision", data["bidContractRevision"] || undefined, {}),
  } as any;
}

export function newManageProjectsBudgetsStepResponse(
  variables: ManageProjectsBudgetsStepQueryVariables,
  data: ManageProjectsBudgetsStepDataOptions | Error,
): MockedResponse<ManageProjectsBudgetsStepQueryVariables, ManageProjectsBudgetsStepQuery> {
  return {
    request: { query: ManageProjectsBudgetsStepDocument, variables },
    result: { data: data instanceof Error ? undefined : newManageProjectsBudgetsStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AssignWorkToBidContractsDataOptions {
  assignWorkToBidContract?: (ChangeEvent | ChangeEventOptions)[];
}

export function newAssignWorkToBidContractsData(
  data: AssignWorkToBidContractsDataOptions,
): AssignWorkToBidContractsMutation {
  return {
    __typename: "Mutation" as const,
    assignWorkToBidContract: data["assignWorkToBidContract"]?.map((d) => newChangeEvent(d)) || [],
  } as any;
}

export function newAssignWorkToBidContractsResponse(
  variables: AssignWorkToBidContractsMutationVariables,
  data: AssignWorkToBidContractsDataOptions | Error,
): MockedResponse<AssignWorkToBidContractsMutationVariables, AssignWorkToBidContractsMutation> {
  return {
    request: { query: AssignWorkToBidContractsDocument, variables },
    result: { data: data instanceof Error ? undefined : newAssignWorkToBidContractsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface EditOptionsHeaderDataOptions {
  readyPlan?: ReadyPlan | ReadyPlanOptions;
}

export function newEditOptionsHeaderData(data: EditOptionsHeaderDataOptions): EditOptionsHeaderQuery {
  return { __typename: "Query" as const, readyPlan: maybeNew("ReadyPlan", data["readyPlan"] || undefined, {}) } as any;
}

export function newEditOptionsHeaderResponse(
  variables: EditOptionsHeaderQueryVariables,
  data: EditOptionsHeaderDataOptions | Error,
): MockedResponse<EditOptionsHeaderQueryVariables, EditOptionsHeaderQuery> {
  return {
    request: { query: EditOptionsHeaderDocument, variables },
    result: { data: data instanceof Error ? undefined : newEditOptionsHeaderData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface LotSummaryDataOptions {
  project?: Project | ProjectOptions;
}

export function newLotSummaryData(data: LotSummaryDataOptions): LotSummaryQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newLotSummaryResponse(
  variables: LotSummaryQueryVariables,
  data: LotSummaryDataOptions | Error,
): MockedResponse<LotSummaryQueryVariables, LotSummaryQuery> {
  return {
    request: { query: LotSummaryDocument, variables },
    result: { data: data instanceof Error ? undefined : newLotSummaryData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProductOfferingCardDataOptions {
  productOfferingConfig?: ProductOfferingConfig | ProductOfferingConfigOptions;
}

export function newProductOfferingCardData(data: ProductOfferingCardDataOptions): ProductOfferingCardQuery {
  return {
    __typename: "Query" as const,
    productOfferingConfig: maybeNew("ProductOfferingConfig", data["productOfferingConfig"] || undefined, {}),
  } as any;
}

export function newProductOfferingCardResponse(
  variables: ProductOfferingCardQueryVariables,
  data: ProductOfferingCardDataOptions | Error,
): MockedResponse<ProductOfferingCardQueryVariables, ProductOfferingCardQuery> {
  return {
    request: { query: ProductOfferingCardDocument, variables },
    result: { data: data instanceof Error ? undefined : newProductOfferingCardData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScopeTemplatesReviewStepDataOptions {
  itemTemplates?: (ItemTemplate | ItemTemplateOptions)[];
  itemTemplateItemVersions?: (ItemTemplateItemVersion | ItemTemplateItemVersionOptions)[];
  scopeChangeReasons?: (ScopeChangeReason | ScopeChangeReasonOptions)[];
  developments?: (Development | DevelopmentOptions)[];
}

export function newScopeTemplatesReviewStepData(
  data: ScopeTemplatesReviewStepDataOptions,
): ScopeTemplatesReviewStepQuery {
  return {
    __typename: "Query" as const,
    itemTemplates: data["itemTemplates"]?.map((d) => newItemTemplate(d)) || [],
    itemTemplateItemVersions: data["itemTemplateItemVersions"]?.map((d) => newItemTemplateItemVersion(d)) || [],
    scopeChangeReasons: data["scopeChangeReasons"]?.map((d) => newScopeChangeReason(d)) || [],
    developments: data["developments"]?.map((d) => newDevelopment(d)) || [],
  } as any;
}

export function newScopeTemplatesReviewStepResponse(
  variables: ScopeTemplatesReviewStepQueryVariables,
  data: ScopeTemplatesReviewStepDataOptions | Error,
): MockedResponse<ScopeTemplatesReviewStepQueryVariables, ScopeTemplatesReviewStepQuery> {
  return {
    request: { query: ScopeTemplatesReviewStepDocument, variables },
    result: { data: data instanceof Error ? undefined : newScopeTemplatesReviewStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScopeTemplatesReviewStepTableDataOptions {
  itemTemplates?: (ItemTemplate | ItemTemplateOptions)[];
}

export function newScopeTemplatesReviewStepTableData(
  data: ScopeTemplatesReviewStepTableDataOptions,
): ScopeTemplatesReviewStepTableQuery {
  return {
    __typename: "Query" as const,
    itemTemplates: data["itemTemplates"]?.map((d) => newItemTemplate(d)) || [],
  } as any;
}

export function newScopeTemplatesReviewStepTableResponse(
  variables: ScopeTemplatesReviewStepTableQueryVariables,
  data: ScopeTemplatesReviewStepTableDataOptions | Error,
): MockedResponse<ScopeTemplatesReviewStepTableQueryVariables, ScopeTemplatesReviewStepTableQuery> {
  return {
    request: { query: ScopeTemplatesReviewStepTableDocument, variables },
    result: { data: data instanceof Error ? undefined : newScopeTemplatesReviewStepTableData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScopeTemplateItemsReviewStepTableDataOptions {
  itemTemplateItemVersionsPage?: ItemTemplateItemVersionsPage | ItemTemplateItemVersionsPageOptions;
}

export function newScopeTemplateItemsReviewStepTableData(
  data: ScopeTemplateItemsReviewStepTableDataOptions,
): ScopeTemplateItemsReviewStepTableQuery {
  return {
    __typename: "Query" as const,
    itemTemplateItemVersionsPage: maybeNew(
      "ItemTemplateItemVersionsPage",
      data["itemTemplateItemVersionsPage"] || undefined,
      {},
    ),
  } as any;
}

export function newScopeTemplateItemsReviewStepTableResponse(
  variables: ScopeTemplateItemsReviewStepTableQueryVariables,
  data: ScopeTemplateItemsReviewStepTableDataOptions | Error,
): MockedResponse<ScopeTemplateItemsReviewStepTableQueryVariables, ScopeTemplateItemsReviewStepTableQuery> {
  return {
    request: { query: ScopeTemplateItemsReviewStepTableDocument, variables },
    result: { data: data instanceof Error ? undefined : newScopeTemplateItemsReviewStepTableData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveScopeChangeReasonReviewStepDataOptions {
  saveItemTemplates?: SaveItemTemplatesResult | SaveItemTemplatesResultOptions;
  saveItemTemplateItemVersions?: SaveItemTemplateItemVersionsResult | SaveItemTemplateItemVersionsResultOptions;
}

export function newSaveScopeChangeReasonReviewStepData(
  data: SaveScopeChangeReasonReviewStepDataOptions,
): SaveScopeChangeReasonReviewStepMutation {
  return {
    __typename: "Mutation" as const,
    saveItemTemplates: maybeNew("SaveItemTemplatesResult", data["saveItemTemplates"] || undefined, {}),
    saveItemTemplateItemVersions: maybeNew(
      "SaveItemTemplateItemVersionsResult",
      data["saveItemTemplateItemVersions"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveScopeChangeReasonReviewStepResponse(
  variables: SaveScopeChangeReasonReviewStepMutationVariables,
  data: SaveScopeChangeReasonReviewStepDataOptions | Error,
): MockedResponse<SaveScopeChangeReasonReviewStepMutationVariables, SaveScopeChangeReasonReviewStepMutation> {
  return {
    request: { query: SaveScopeChangeReasonReviewStepDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveScopeChangeReasonReviewStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ActivateTemplateVersionsReviewStepDataOptions {
  activateItemTemplateVersions?: ActivateItemTemplateVersionsResult | ActivateItemTemplateVersionsResultOptions;
}

export function newActivateTemplateVersionsReviewStepData(
  data: ActivateTemplateVersionsReviewStepDataOptions,
): ActivateTemplateVersionsReviewStepMutation {
  return {
    __typename: "Mutation" as const,
    activateItemTemplateVersions: maybeNew(
      "ActivateItemTemplateVersionsResult",
      data["activateItemTemplateVersions"] || undefined,
      {},
    ),
  } as any;
}

export function newActivateTemplateVersionsReviewStepResponse(
  variables: ActivateTemplateVersionsReviewStepMutationVariables,
  data: ActivateTemplateVersionsReviewStepDataOptions | Error,
): MockedResponse<ActivateTemplateVersionsReviewStepMutationVariables, ActivateTemplateVersionsReviewStepMutation> {
  return {
    request: { query: ActivateTemplateVersionsReviewStepDocument, variables },
    result: { data: data instanceof Error ? undefined : newActivateTemplateVersionsReviewStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScopeTemplatesApplyStepMetadataDataOptions {
  milestoneTasksForTemplates?: (ScheduleTask | ScheduleTaskOptions)[];
}

export function newScopeTemplatesApplyStepMetadataData(
  data: ScopeTemplatesApplyStepMetadataDataOptions,
): ScopeTemplatesApplyStepMetadataQuery {
  return {
    __typename: "Query" as const,
    milestoneTasksForTemplates: data["milestoneTasksForTemplates"]?.map((d) => newScheduleTask(d)) || [],
  } as any;
}

export function newScopeTemplatesApplyStepMetadataResponse(
  variables: ScopeTemplatesApplyStepMetadataQueryVariables,
  data: ScopeTemplatesApplyStepMetadataDataOptions | Error,
): MockedResponse<ScopeTemplatesApplyStepMetadataQueryVariables, ScopeTemplatesApplyStepMetadataQuery> {
  return {
    request: { query: ScopeTemplatesApplyStepMetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newScopeTemplatesApplyStepMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScopeTemplatesApplyStepDataOptions {
  projectsToUpdateByTemplates?: ProjectsToUpdateByTemplatesResult | ProjectsToUpdateByTemplatesResultOptions;
}

export function newScopeTemplatesApplyStepData(data: ScopeTemplatesApplyStepDataOptions): ScopeTemplatesApplyStepQuery {
  return {
    __typename: "Query" as const,
    projectsToUpdateByTemplates: maybeNew(
      "ProjectsToUpdateByTemplatesResult",
      data["projectsToUpdateByTemplates"] || undefined,
      {},
    ),
  } as any;
}

export function newScopeTemplatesApplyStepResponse(
  variables: ScopeTemplatesApplyStepQueryVariables,
  data: ScopeTemplatesApplyStepDataOptions | Error,
): MockedResponse<ScopeTemplatesApplyStepQueryVariables, ScopeTemplatesApplyStepQuery> {
  return {
    request: { query: ScopeTemplatesApplyStepDocument, variables },
    result: { data: data instanceof Error ? undefined : newScopeTemplatesApplyStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScopeTemplateApplyStepApplyToProjectDataOptions {
  applyProjectReadyPlanConfigs?: ApplyProjectReadyPlanConfigsResult | ApplyProjectReadyPlanConfigsResultOptions;
}

export function newScopeTemplateApplyStepApplyToProjectData(
  data: ScopeTemplateApplyStepApplyToProjectDataOptions,
): ScopeTemplateApplyStepApplyToProjectMutation {
  return {
    __typename: "Mutation" as const,
    applyProjectReadyPlanConfigs: maybeNew(
      "ApplyProjectReadyPlanConfigsResult",
      data["applyProjectReadyPlanConfigs"] || undefined,
      {},
    ),
  } as any;
}

export function newScopeTemplateApplyStepApplyToProjectResponse(
  variables: ScopeTemplateApplyStepApplyToProjectMutationVariables,
  data: ScopeTemplateApplyStepApplyToProjectDataOptions | Error,
): MockedResponse<ScopeTemplateApplyStepApplyToProjectMutationVariables, ScopeTemplateApplyStepApplyToProjectMutation> {
  return {
    request: { query: ScopeTemplateApplyStepApplyToProjectDocument, variables },
    result: { data: data instanceof Error ? undefined : newScopeTemplateApplyStepApplyToProjectData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DesignPackageAddProductMetadataDataOptions {
  materialBrands?: (MaterialBrand | MaterialBrandOptions)[];
}

export function newDesignPackageAddProductMetadataData(
  data: DesignPackageAddProductMetadataDataOptions,
): DesignPackageAddProductMetadataQuery {
  return {
    __typename: "Query" as const,
    materialBrands: data["materialBrands"]?.map((d) => newMaterialBrand(d)) || [],
  } as any;
}

export function newDesignPackageAddProductMetadataResponse(
  data: DesignPackageAddProductMetadataDataOptions | Error,
): MockedResponse<DesignPackageAddProductMetadataQueryVariables, DesignPackageAddProductMetadataQuery> {
  return {
    request: { query: DesignPackageAddProductMetadataDocument },
    result: { data: data instanceof Error ? undefined : newDesignPackageAddProductMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddProductTliPlaceholderDataOptions {
  takeoffLineItem?: TakeoffLineItem | TakeoffLineItemOptions;
}

export function newAddProductTliPlaceholderData(
  data: AddProductTliPlaceholderDataOptions,
): AddProductTliPlaceholderQuery {
  return {
    __typename: "Query" as const,
    takeoffLineItem: maybeNew("TakeoffLineItem", data["takeoffLineItem"] || undefined, {}),
  } as any;
}

export function newAddProductTliPlaceholderResponse(
  variables: AddProductTliPlaceholderQueryVariables,
  data: AddProductTliPlaceholderDataOptions | Error,
): MockedResponse<AddProductTliPlaceholderQueryVariables, AddProductTliPlaceholderQuery> {
  return {
    request: { query: AddProductTliPlaceholderDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddProductTliPlaceholderData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddToOptionModal_PotentialOptionsDataOptions {
  designPackage?: DesignPackage | DesignPackageOptions;
}

export function newAddToOptionModal_PotentialOptionsData(
  data: AddToOptionModal_PotentialOptionsDataOptions,
): AddToOptionModal_PotentialOptionsQuery {
  return {
    __typename: "Query" as const,
    designPackage: maybeNew("DesignPackage", data["designPackage"] || undefined, {}),
  } as any;
}

export function newAddToOptionModal_PotentialOptionsResponse(
  variables: AddToOptionModal_PotentialOptionsQueryVariables,
  data: AddToOptionModal_PotentialOptionsDataOptions | Error,
): MockedResponse<AddToOptionModal_PotentialOptionsQueryVariables, AddToOptionModal_PotentialOptionsQuery> {
  return {
    request: { query: AddToOptionModal_PotentialOptionsDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddToOptionModal_PotentialOptionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DesignPackageDesignNotePaneDataOptions {
  takeoffLineItem?: TakeoffLineItem | TakeoffLineItemOptions;
}

export function newDesignPackageDesignNotePaneData(
  data: DesignPackageDesignNotePaneDataOptions,
): DesignPackageDesignNotePaneQuery {
  return {
    __typename: "Query" as const,
    takeoffLineItem: maybeNew("TakeoffLineItem", data["takeoffLineItem"] || undefined, {}),
  } as any;
}

export function newDesignPackageDesignNotePaneResponse(
  variables: DesignPackageDesignNotePaneQueryVariables,
  data: DesignPackageDesignNotePaneDataOptions | Error,
): MockedResponse<DesignPackageDesignNotePaneQueryVariables, DesignPackageDesignNotePaneQuery> {
  return {
    request: { query: DesignPackageDesignNotePaneDocument, variables },
    result: { data: data instanceof Error ? undefined : newDesignPackageDesignNotePaneData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DesignPackageDesignNotePane_MetadataDataOptions {
  designPackage?: DesignPackage | DesignPackageOptions;
}

export function newDesignPackageDesignNotePane_MetadataData(
  data: DesignPackageDesignNotePane_MetadataDataOptions,
): DesignPackageDesignNotePane_MetadataQuery {
  return {
    __typename: "Query" as const,
    designPackage: maybeNew("DesignPackage", data["designPackage"] || undefined, {}),
  } as any;
}

export function newDesignPackageDesignNotePane_MetadataResponse(
  variables: DesignPackageDesignNotePane_MetadataQueryVariables,
  data: DesignPackageDesignNotePane_MetadataDataOptions | Error,
): MockedResponse<DesignPackageDesignNotePane_MetadataQueryVariables, DesignPackageDesignNotePane_MetadataQuery> {
  return {
    request: { query: DesignPackageDesignNotePane_MetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newDesignPackageDesignNotePane_MetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveReadyPlanDesignNoteDataOptions {
  saveReadyPlanDesignNote?: SaveReadyPlanDesignNoteResult | SaveReadyPlanDesignNoteResultOptions;
}

export function newSaveReadyPlanDesignNoteData(
  data: SaveReadyPlanDesignNoteDataOptions,
): SaveReadyPlanDesignNoteMutation {
  return {
    __typename: "Mutation" as const,
    saveReadyPlanDesignNote: maybeNew(
      "SaveReadyPlanDesignNoteResult",
      data["saveReadyPlanDesignNote"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveReadyPlanDesignNoteResponse(
  variables: SaveReadyPlanDesignNoteMutationVariables,
  data: SaveReadyPlanDesignNoteDataOptions | Error,
): MockedResponse<SaveReadyPlanDesignNoteMutationVariables, SaveReadyPlanDesignNoteMutation> {
  return {
    request: { query: SaveReadyPlanDesignNoteDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveReadyPlanDesignNoteData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CopyDesignPackageCardsDataOptions {
  copyDesignPackageCards?: CopyDesignPackageCardsResult | CopyDesignPackageCardsResultOptions;
}

export function newCopyDesignPackageCardsData(data: CopyDesignPackageCardsDataOptions): CopyDesignPackageCardsMutation {
  return {
    __typename: "Mutation" as const,
    copyDesignPackageCards: maybeNew("CopyDesignPackageCardsResult", data["copyDesignPackageCards"] || undefined, {}),
  } as any;
}

export function newCopyDesignPackageCardsResponse(
  variables: CopyDesignPackageCardsMutationVariables,
  data: CopyDesignPackageCardsDataOptions | Error,
): MockedResponse<CopyDesignPackageCardsMutationVariables, CopyDesignPackageCardsMutation> {
  return {
    request: { query: CopyDesignPackageCardsDocument, variables },
    result: { data: data instanceof Error ? undefined : newCopyDesignPackageCardsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CopyDesignPackageCardsModalDataOptions {
  takeoffLineItemsPage?: TakeoffLineItemsPage | TakeoffLineItemsPageOptions;
}

export function newCopyDesignPackageCardsModalData(
  data: CopyDesignPackageCardsModalDataOptions,
): CopyDesignPackageCardsModalQuery {
  return {
    __typename: "Query" as const,
    takeoffLineItemsPage: maybeNew("TakeoffLineItemsPage", data["takeoffLineItemsPage"] || undefined, {}),
  } as any;
}

export function newCopyDesignPackageCardsModalResponse(
  variables: CopyDesignPackageCardsModalQueryVariables,
  data: CopyDesignPackageCardsModalDataOptions | Error,
): MockedResponse<CopyDesignPackageCardsModalQueryVariables, CopyDesignPackageCardsModalQuery> {
  return {
    request: { query: CopyDesignPackageCardsModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newCopyDesignPackageCardsModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteAltenratesConfirmationModalDataOptions {
  designPackage?: DesignPackage | DesignPackageOptions;
}

export function newDeleteAltenratesConfirmationModalData(
  data: DeleteAltenratesConfirmationModalDataOptions,
): DeleteAltenratesConfirmationModalQuery {
  return {
    __typename: "Query" as const,
    designPackage: maybeNew("DesignPackage", data["designPackage"] || undefined, {}),
  } as any;
}

export function newDeleteAltenratesConfirmationModalResponse(
  variables: DeleteAltenratesConfirmationModalQueryVariables,
  data: DeleteAltenratesConfirmationModalDataOptions | Error,
): MockedResponse<DeleteAltenratesConfirmationModalQueryVariables, DeleteAltenratesConfirmationModalQuery> {
  return {
    request: { query: DeleteAltenratesConfirmationModalDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteAltenratesConfirmationModalData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteDpAlternateRplDataOptions {
  deleteDesignPackageAlternateLocation?:
    | SaveDesignPackageLocationPlanMappingsResult
    | SaveDesignPackageLocationPlanMappingsResultOptions;
}

export function newDeleteDpAlternateRplData(data: DeleteDpAlternateRplDataOptions): DeleteDpAlternateRplMutation {
  return {
    __typename: "Mutation" as const,
    deleteDesignPackageAlternateLocation: maybeNew(
      "SaveDesignPackageLocationPlanMappingsResult",
      data["deleteDesignPackageAlternateLocation"] || undefined,
      {},
    ),
  } as any;
}

export function newDeleteDpAlternateRplResponse(
  variables: DeleteDpAlternateRplMutationVariables,
  data: DeleteDpAlternateRplDataOptions | Error,
): MockedResponse<DeleteDpAlternateRplMutationVariables, DeleteDpAlternateRplMutation> {
  return {
    request: { query: DeleteDpAlternateRplDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteDpAlternateRplData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DesignPackageItemSlotEditorDataOptions {
  designPackage?: DesignPackage | DesignPackageOptions;
}

export function newDesignPackageItemSlotEditorData(
  data: DesignPackageItemSlotEditorDataOptions,
): DesignPackageItemSlotEditorQuery {
  return {
    __typename: "Query" as const,
    designPackage: maybeNew("DesignPackage", data["designPackage"] || undefined, {}),
  } as any;
}

export function newDesignPackageItemSlotEditorResponse(
  variables: DesignPackageItemSlotEditorQueryVariables,
  data: DesignPackageItemSlotEditorDataOptions | Error,
): MockedResponse<DesignPackageItemSlotEditorQueryVariables, DesignPackageItemSlotEditorQuery> {
  return {
    request: { query: DesignPackageItemSlotEditorDocument, variables },
    result: { data: data instanceof Error ? undefined : newDesignPackageItemSlotEditorData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DesignPackageItemSlotEditor_DeleteTliDataOptions {
  saveTakeoffLineItems?: SaveTakeoffLineItemResult | SaveTakeoffLineItemResultOptions;
}

export function newDesignPackageItemSlotEditor_DeleteTliData(
  data: DesignPackageItemSlotEditor_DeleteTliDataOptions,
): DesignPackageItemSlotEditor_DeleteTliMutation {
  return {
    __typename: "Mutation" as const,
    saveTakeoffLineItems: maybeNew("SaveTakeoffLineItemResult", data["saveTakeoffLineItems"] || undefined, {}),
  } as any;
}

export function newDesignPackageItemSlotEditor_DeleteTliResponse(
  variables: DesignPackageItemSlotEditor_DeleteTliMutationVariables,
  data: DesignPackageItemSlotEditor_DeleteTliDataOptions | Error,
): MockedResponse<
  DesignPackageItemSlotEditor_DeleteTliMutationVariables,
  DesignPackageItemSlotEditor_DeleteTliMutation
> {
  return {
    request: { query: DesignPackageItemSlotEditor_DeleteTliDocument, variables },
    result: { data: data instanceof Error ? undefined : newDesignPackageItemSlotEditor_DeleteTliData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DesignPackagePruneSlotsModal_DataDataOptions {
  takeoffLineItemsPage?: TakeoffLineItemsPage | TakeoffLineItemsPageOptions;
}

export function newDesignPackagePruneSlotsModal_DataData(
  data: DesignPackagePruneSlotsModal_DataDataOptions,
): DesignPackagePruneSlotsModal_DataQuery {
  return {
    __typename: "Query" as const,
    takeoffLineItemsPage: maybeNew("TakeoffLineItemsPage", data["takeoffLineItemsPage"] || undefined, {}),
  } as any;
}

export function newDesignPackagePruneSlotsModal_DataResponse(
  variables: DesignPackagePruneSlotsModal_DataQueryVariables,
  data: DesignPackagePruneSlotsModal_DataDataOptions | Error,
): MockedResponse<DesignPackagePruneSlotsModal_DataQueryVariables, DesignPackagePruneSlotsModal_DataQuery> {
  return {
    request: { query: DesignPackagePruneSlotsModal_DataDocument, variables },
    result: { data: data instanceof Error ? undefined : newDesignPackagePruneSlotsModal_DataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DesignPackagePruneSlotsModal_SaveDraftDataOptions {
  saveTakeoffLineItems?: SaveTakeoffLineItemResult | SaveTakeoffLineItemResultOptions;
}

export function newDesignPackagePruneSlotsModal_SaveDraftData(
  data: DesignPackagePruneSlotsModal_SaveDraftDataOptions,
): DesignPackagePruneSlotsModal_SaveDraftMutation {
  return {
    __typename: "Mutation" as const,
    saveTakeoffLineItems: maybeNew("SaveTakeoffLineItemResult", data["saveTakeoffLineItems"] || undefined, {}),
  } as any;
}

export function newDesignPackagePruneSlotsModal_SaveDraftResponse(
  variables: DesignPackagePruneSlotsModal_SaveDraftMutationVariables,
  data: DesignPackagePruneSlotsModal_SaveDraftDataOptions | Error,
): MockedResponse<
  DesignPackagePruneSlotsModal_SaveDraftMutationVariables,
  DesignPackagePruneSlotsModal_SaveDraftMutation
> {
  return {
    request: { query: DesignPackagePruneSlotsModal_SaveDraftDocument, variables },
    result: { data: data instanceof Error ? undefined : newDesignPackagePruneSlotsModal_SaveDraftData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DesignPackageRequiredOptionsPageDataOptions {
  designPackage?: DesignPackage | DesignPackageOptions;
}

export function newDesignPackageRequiredOptionsPageData(
  data: DesignPackageRequiredOptionsPageDataOptions,
): DesignPackageRequiredOptionsPageQuery {
  return {
    __typename: "Query" as const,
    designPackage: maybeNew("DesignPackage", data["designPackage"] || undefined, {}),
  } as any;
}

export function newDesignPackageRequiredOptionsPageResponse(
  variables: DesignPackageRequiredOptionsPageQueryVariables,
  data: DesignPackageRequiredOptionsPageDataOptions | Error,
): MockedResponse<DesignPackageRequiredOptionsPageQueryVariables, DesignPackageRequiredOptionsPageQuery> {
  return {
    request: { query: DesignPackageRequiredOptionsPageDocument, variables },
    result: { data: data instanceof Error ? undefined : newDesignPackageRequiredOptionsPageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DesignPackageRequiredOptionsPage_AddOnsDataOptions {
  designPackage?: DesignPackage | DesignPackageOptions;
}

export function newDesignPackageRequiredOptionsPage_AddOnsData(
  data: DesignPackageRequiredOptionsPage_AddOnsDataOptions,
): DesignPackageRequiredOptionsPage_AddOnsQuery {
  return {
    __typename: "Query" as const,
    designPackage: maybeNew("DesignPackage", data["designPackage"] || undefined, {}),
  } as any;
}

export function newDesignPackageRequiredOptionsPage_AddOnsResponse(
  variables: DesignPackageRequiredOptionsPage_AddOnsQueryVariables,
  data: DesignPackageRequiredOptionsPage_AddOnsDataOptions | Error,
): MockedResponse<DesignPackageRequiredOptionsPage_AddOnsQueryVariables, DesignPackageRequiredOptionsPage_AddOnsQuery> {
  return {
    request: { query: DesignPackageRequiredOptionsPage_AddOnsDocument, variables },
    result: { data: data instanceof Error ? undefined : newDesignPackageRequiredOptionsPage_AddOnsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DesignPackageRequiredOptionsPage_CombinationsDataOptions {
  designPackage?: DesignPackage | DesignPackageOptions;
}

export function newDesignPackageRequiredOptionsPage_CombinationsData(
  data: DesignPackageRequiredOptionsPage_CombinationsDataOptions,
): DesignPackageRequiredOptionsPage_CombinationsQuery {
  return {
    __typename: "Query" as const,
    designPackage: maybeNew("DesignPackage", data["designPackage"] || undefined, {}),
  } as any;
}

export function newDesignPackageRequiredOptionsPage_CombinationsResponse(
  variables: DesignPackageRequiredOptionsPage_CombinationsQueryVariables,
  data: DesignPackageRequiredOptionsPage_CombinationsDataOptions | Error,
): MockedResponse<
  DesignPackageRequiredOptionsPage_CombinationsQueryVariables,
  DesignPackageRequiredOptionsPage_CombinationsQuery
> {
  return {
    request: { query: DesignPackageRequiredOptionsPage_CombinationsDocument, variables },
    result: { data: data instanceof Error ? undefined : newDesignPackageRequiredOptionsPage_CombinationsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveDesignPackageRequiredOptionsDataOptions {
  saveReadyPlanRequiredOptions?: SaveReadyPlanRequiredOptionsResult | SaveReadyPlanRequiredOptionsResultOptions;
}

export function newSaveDesignPackageRequiredOptionsData(
  data: SaveDesignPackageRequiredOptionsDataOptions,
): SaveDesignPackageRequiredOptionsMutation {
  return {
    __typename: "Mutation" as const,
    saveReadyPlanRequiredOptions: maybeNew(
      "SaveReadyPlanRequiredOptionsResult",
      data["saveReadyPlanRequiredOptions"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveDesignPackageRequiredOptionsResponse(
  variables: SaveDesignPackageRequiredOptionsMutationVariables,
  data: SaveDesignPackageRequiredOptionsDataOptions | Error,
): MockedResponse<SaveDesignPackageRequiredOptionsMutationVariables, SaveDesignPackageRequiredOptionsMutation> {
  return {
    request: { query: SaveDesignPackageRequiredOptionsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveDesignPackageRequiredOptionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AcceptDesignUpdatesDataOptions {
  acceptDesignPackageUpdates?: SaveDesignPackageUpdatesResult | SaveDesignPackageUpdatesResultOptions;
}

export function newAcceptDesignUpdatesData(data: AcceptDesignUpdatesDataOptions): AcceptDesignUpdatesMutation {
  return {
    __typename: "Mutation" as const,
    acceptDesignPackageUpdates: maybeNew(
      "SaveDesignPackageUpdatesResult",
      data["acceptDesignPackageUpdates"] || undefined,
      {},
    ),
  } as any;
}

export function newAcceptDesignUpdatesResponse(
  variables: AcceptDesignUpdatesMutationVariables,
  data: AcceptDesignUpdatesDataOptions | Error,
): MockedResponse<AcceptDesignUpdatesMutationVariables, AcceptDesignUpdatesMutation> {
  return {
    request: { query: AcceptDesignUpdatesDocument, variables },
    result: { data: data instanceof Error ? undefined : newAcceptDesignUpdatesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DesignPackageSlotsDataOptions {
  designPackage?: DesignPackage | DesignPackageOptions;
}

export function newDesignPackageSlotsData(data: DesignPackageSlotsDataOptions): DesignPackageSlotsQuery {
  return {
    __typename: "Query" as const,
    designPackage: maybeNew("DesignPackage", data["designPackage"] || undefined, {}),
  } as any;
}

export function newDesignPackageSlotsResponse(
  variables: DesignPackageSlotsQueryVariables,
  data: DesignPackageSlotsDataOptions | Error,
): MockedResponse<DesignPackageSlotsQueryVariables, DesignPackageSlotsQuery> {
  return {
    request: { query: DesignPackageSlotsDocument, variables },
    result: { data: data instanceof Error ? undefined : newDesignPackageSlotsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateAlternateLocationDataOptions {
  createDesignPackageAlternateLocation?:
    | CreateDesignPackageAlternateLocationResult
    | CreateDesignPackageAlternateLocationResultOptions;
}

export function newCreateAlternateLocationData(
  data: CreateAlternateLocationDataOptions,
): CreateAlternateLocationMutation {
  return {
    __typename: "Mutation" as const,
    createDesignPackageAlternateLocation: maybeNew(
      "CreateDesignPackageAlternateLocationResult",
      data["createDesignPackageAlternateLocation"] || undefined,
      {},
    ),
  } as any;
}

export function newCreateAlternateLocationResponse(
  variables: CreateAlternateLocationMutationVariables,
  data: CreateAlternateLocationDataOptions | Error,
): MockedResponse<CreateAlternateLocationMutationVariables, CreateAlternateLocationMutation> {
  return {
    request: { query: CreateAlternateLocationDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateAlternateLocationData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DesignPackageRoomAlternatesDrawerDataOptions {
  designPackage?: DesignPackage | DesignPackageOptions;
}

export function newDesignPackageRoomAlternatesDrawerData(
  data: DesignPackageRoomAlternatesDrawerDataOptions,
): DesignPackageRoomAlternatesDrawerQuery {
  return {
    __typename: "Query" as const,
    designPackage: maybeNew("DesignPackage", data["designPackage"] || undefined, {}),
  } as any;
}

export function newDesignPackageRoomAlternatesDrawerResponse(
  variables: DesignPackageRoomAlternatesDrawerQueryVariables,
  data: DesignPackageRoomAlternatesDrawerDataOptions | Error,
): MockedResponse<DesignPackageRoomAlternatesDrawerQueryVariables, DesignPackageRoomAlternatesDrawerQuery> {
  return {
    request: { query: DesignPackageRoomAlternatesDrawerDocument, variables },
    result: { data: data instanceof Error ? undefined : newDesignPackageRoomAlternatesDrawerData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveDpRplAlternateLocationsDataOptions {
  saveDesignPackageLocationPlanMappings?:
    | SaveDesignPackageLocationPlanMappingsResult
    | SaveDesignPackageLocationPlanMappingsResultOptions;
}

export function newSaveDpRplAlternateLocationsData(
  data: SaveDpRplAlternateLocationsDataOptions,
): SaveDpRplAlternateLocationsMutation {
  return {
    __typename: "Mutation" as const,
    saveDesignPackageLocationPlanMappings: maybeNew(
      "SaveDesignPackageLocationPlanMappingsResult",
      data["saveDesignPackageLocationPlanMappings"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveDpRplAlternateLocationsResponse(
  variables: SaveDpRplAlternateLocationsMutationVariables,
  data: SaveDpRplAlternateLocationsDataOptions | Error,
): MockedResponse<SaveDpRplAlternateLocationsMutationVariables, SaveDpRplAlternateLocationsMutation> {
  return {
    request: { query: SaveDpRplAlternateLocationsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveDpRplAlternateLocationsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MaterialAssemblyForm_AssemblyComponentsDataOptions {
  materialVariant?: MaterialVariant | MaterialVariantOptions;
}

export function newMaterialAssemblyForm_AssemblyComponentsData(
  data: MaterialAssemblyForm_AssemblyComponentsDataOptions,
): MaterialAssemblyForm_AssemblyComponentsQuery {
  return {
    __typename: "Query" as const,
    materialVariant: maybeNew("MaterialVariant", data["materialVariant"] || undefined, {}),
  } as any;
}

export function newMaterialAssemblyForm_AssemblyComponentsResponse(
  variables: MaterialAssemblyForm_AssemblyComponentsQueryVariables,
  data: MaterialAssemblyForm_AssemblyComponentsDataOptions | Error,
): MockedResponse<MaterialAssemblyForm_AssemblyComponentsQueryVariables, MaterialAssemblyForm_AssemblyComponentsQuery> {
  return {
    request: { query: MaterialAssemblyForm_AssemblyComponentsDocument, variables },
    result: { data: data instanceof Error ? undefined : newMaterialAssemblyForm_AssemblyComponentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MaterialAssemblyForm_MaterialVariantsDataOptions {
  materialVariants?: MaterialVariantsPage | MaterialVariantsPageOptions;
}

export function newMaterialAssemblyForm_MaterialVariantsData(
  data: MaterialAssemblyForm_MaterialVariantsDataOptions,
): MaterialAssemblyForm_MaterialVariantsQuery {
  return {
    __typename: "Query" as const,
    materialVariants: maybeNew("MaterialVariantsPage", data["materialVariants"] || undefined, {}),
  } as any;
}

export function newMaterialAssemblyForm_MaterialVariantsResponse(
  variables: MaterialAssemblyForm_MaterialVariantsQueryVariables,
  data: MaterialAssemblyForm_MaterialVariantsDataOptions | Error,
): MockedResponse<MaterialAssemblyForm_MaterialVariantsQueryVariables, MaterialAssemblyForm_MaterialVariantsQuery> {
  return {
    request: { query: MaterialAssemblyForm_MaterialVariantsDocument, variables },
    result: { data: data instanceof Error ? undefined : newMaterialAssemblyForm_MaterialVariantsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MaterialAssemblyForm_ItemsDataOptions {
  items?: (Item | ItemOptions)[];
}

export function newMaterialAssemblyForm_ItemsData(
  data: MaterialAssemblyForm_ItemsDataOptions,
): MaterialAssemblyForm_ItemsQuery {
  return { __typename: "Query" as const, items: data["items"]?.map((d) => newItem(d)) || [] } as any;
}

export function newMaterialAssemblyForm_ItemsResponse(
  data: MaterialAssemblyForm_ItemsDataOptions | Error,
): MockedResponse<MaterialAssemblyForm_ItemsQueryVariables, MaterialAssemblyForm_ItemsQuery> {
  return {
    request: { query: MaterialAssemblyForm_ItemsDocument },
    result: { data: data instanceof Error ? undefined : newMaterialAssemblyForm_ItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BidItemCostHistoryDataOptions {
  bidContractLineItemsPage?: BidContractLineItemsPageResult | BidContractLineItemsPageResultOptions;
}

export function newBidItemCostHistoryData(data: BidItemCostHistoryDataOptions): BidItemCostHistoryQuery {
  return {
    __typename: "Query" as const,
    bidContractLineItemsPage: maybeNew(
      "BidContractLineItemsPageResult",
      data["bidContractLineItemsPage"] || undefined,
      {},
    ),
  } as any;
}

export function newBidItemCostHistoryResponse(
  variables: BidItemCostHistoryQueryVariables,
  data: BidItemCostHistoryDataOptions | Error,
): MockedResponse<BidItemCostHistoryQueryVariables, BidItemCostHistoryQuery> {
  return {
    request: { query: BidItemCostHistoryDocument, variables },
    result: { data: data instanceof Error ? undefined : newBidItemCostHistoryData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MaterialSuperDrawerDataOptions {
  materialVariants?: MaterialVariantsPage | MaterialVariantsPageOptions;
}

export function newMaterialSuperDrawerData(data: MaterialSuperDrawerDataOptions): MaterialSuperDrawerQuery {
  return {
    __typename: "Query" as const,
    materialVariants: maybeNew("MaterialVariantsPage", data["materialVariants"] || undefined, {}),
  } as any;
}

export function newMaterialSuperDrawerResponse(
  variables: MaterialSuperDrawerQueryVariables,
  data: MaterialSuperDrawerDataOptions | Error,
): MockedResponse<MaterialSuperDrawerQueryVariables, MaterialSuperDrawerQuery> {
  return {
    request: { query: MaterialSuperDrawerDocument, variables },
    result: { data: data instanceof Error ? undefined : newMaterialSuperDrawerData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveMaterialListingDataOptions {
  saveMaterialListing?: MaterialListing | MaterialListingOptions;
}

export function newSaveMaterialListingData(data: SaveMaterialListingDataOptions): SaveMaterialListingMutation {
  return {
    __typename: "Mutation" as const,
    saveMaterialListing: maybeNew("MaterialListing", data["saveMaterialListing"] || undefined, {}),
  } as any;
}

export function newSaveMaterialListingResponse(
  variables: SaveMaterialListingMutationVariables,
  data: SaveMaterialListingDataOptions | Error,
): MockedResponse<SaveMaterialListingMutationVariables, SaveMaterialListingMutation> {
  return {
    request: { query: SaveMaterialListingDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveMaterialListingData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ConfirmDiscardDraftVersionModal_ConfirmActionDataOptions {
  deleteReadyPlanAggregateVersion?:
    | DeleteReadyPlanAggregateVersionResult
    | DeleteReadyPlanAggregateVersionResultOptions;
}

export function newConfirmDiscardDraftVersionModal_ConfirmActionData(
  data: ConfirmDiscardDraftVersionModal_ConfirmActionDataOptions,
): ConfirmDiscardDraftVersionModal_ConfirmActionMutation {
  return {
    __typename: "Mutation" as const,
    deleteReadyPlanAggregateVersion: maybeNew(
      "DeleteReadyPlanAggregateVersionResult",
      data["deleteReadyPlanAggregateVersion"] || undefined,
      {},
    ),
  } as any;
}

export function newConfirmDiscardDraftVersionModal_ConfirmActionResponse(
  variables: ConfirmDiscardDraftVersionModal_ConfirmActionMutationVariables,
  data: ConfirmDiscardDraftVersionModal_ConfirmActionDataOptions | Error,
): MockedResponse<
  ConfirmDiscardDraftVersionModal_ConfirmActionMutationVariables,
  ConfirmDiscardDraftVersionModal_ConfirmActionMutation
> {
  return {
    request: { query: ConfirmDiscardDraftVersionModal_ConfirmActionDocument, variables },
    result: { data: data instanceof Error ? undefined : newConfirmDiscardDraftVersionModal_ConfirmActionData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveReadyPlanAggregateVersionDataOptions {
  saveReadyPlanAggregateVersion?: SaveReadyPlanAggregateVersionResult | SaveReadyPlanAggregateVersionResultOptions;
}

export function newSaveReadyPlanAggregateVersionData(
  data: SaveReadyPlanAggregateVersionDataOptions,
): SaveReadyPlanAggregateVersionMutation {
  return {
    __typename: "Mutation" as const,
    saveReadyPlanAggregateVersion: maybeNew(
      "SaveReadyPlanAggregateVersionResult",
      data["saveReadyPlanAggregateVersion"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveReadyPlanAggregateVersionResponse(
  variables: SaveReadyPlanAggregateVersionMutationVariables,
  data: SaveReadyPlanAggregateVersionDataOptions | Error,
): MockedResponse<SaveReadyPlanAggregateVersionMutationVariables, SaveReadyPlanAggregateVersionMutation> {
  return {
    request: { query: SaveReadyPlanAggregateVersionDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveReadyPlanAggregateVersionData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanPackageOverviewDataOptions {
  itemCount?: TakeoffLineItemsPage | TakeoffLineItemsPageOptions;
}

export function newPlanPackageOverviewData(data: PlanPackageOverviewDataOptions): PlanPackageOverviewQuery {
  return {
    __typename: "Query" as const,
    itemCount: maybeNew("TakeoffLineItemsPage", data["itemCount"] || undefined, {}),
  } as any;
}

export function newPlanPackageOverviewResponse(
  variables: PlanPackageOverviewQueryVariables,
  data: PlanPackageOverviewDataOptions | Error,
): MockedResponse<PlanPackageOverviewQueryVariables, PlanPackageOverviewQuery> {
  return {
    request: { query: PlanPackageOverviewDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanPackageOverviewData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanSummaryAndOptionsDataOptions {
  planPackage?: PlanPackage | PlanPackageOptions;
}

export function newPlanSummaryAndOptionsData(data: PlanSummaryAndOptionsDataOptions): PlanSummaryAndOptionsQuery {
  return {
    __typename: "Query" as const,
    planPackage: maybeNew("PlanPackage", data["planPackage"] || undefined, {}),
  } as any;
}

export function newPlanSummaryAndOptionsResponse(
  variables: PlanSummaryAndOptionsQueryVariables,
  data: PlanSummaryAndOptionsDataOptions | Error,
): MockedResponse<PlanSummaryAndOptionsQueryVariables, PlanSummaryAndOptionsQuery> {
  return {
    request: { query: PlanSummaryAndOptionsDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanSummaryAndOptionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanPackageEditorHeaderDataOptions {
  planPackage?: PlanPackage | PlanPackageOptions;
}

export function newPlanPackageEditorHeaderData(data: PlanPackageEditorHeaderDataOptions): PlanPackageEditorHeaderQuery {
  return {
    __typename: "Query" as const,
    planPackage: maybeNew("PlanPackage", data["planPackage"] || undefined, {}),
  } as any;
}

export function newPlanPackageEditorHeaderResponse(
  variables: PlanPackageEditorHeaderQueryVariables,
  data: PlanPackageEditorHeaderDataOptions | Error,
): MockedResponse<PlanPackageEditorHeaderQueryVariables, PlanPackageEditorHeaderQuery> {
  return {
    request: { query: PlanPackageEditorHeaderDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanPackageEditorHeaderData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChooseOptionsStepBody_PlanPackageDataOptions {
  planPackage?: PlanPackage | PlanPackageOptions;
}

export function newChooseOptionsStepBody_PlanPackageData(
  data: ChooseOptionsStepBody_PlanPackageDataOptions,
): ChooseOptionsStepBody_PlanPackageQuery {
  return {
    __typename: "Query" as const,
    planPackage: maybeNew("PlanPackage", data["planPackage"] || undefined, {}),
  } as any;
}

export function newChooseOptionsStepBody_PlanPackageResponse(
  variables: ChooseOptionsStepBody_PlanPackageQueryVariables,
  data: ChooseOptionsStepBody_PlanPackageDataOptions | Error,
): MockedResponse<ChooseOptionsStepBody_PlanPackageQueryVariables, ChooseOptionsStepBody_PlanPackageQuery> {
  return {
    request: { query: ChooseOptionsStepBody_PlanPackageDocument, variables },
    result: { data: data instanceof Error ? undefined : newChooseOptionsStepBody_PlanPackageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ChooseOptionsStepBody_GlobalOptionsDataOptions {
  globalOptions?: (GlobalOption | GlobalOptionOptions)[];
}

export function newChooseOptionsStepBody_GlobalOptionsData(
  data: ChooseOptionsStepBody_GlobalOptionsDataOptions,
): ChooseOptionsStepBody_GlobalOptionsQuery {
  return {
    __typename: "Query" as const,
    globalOptions: data["globalOptions"]?.map((d) => newGlobalOption(d)) || [],
  } as any;
}

export function newChooseOptionsStepBody_GlobalOptionsResponse(
  variables: ChooseOptionsStepBody_GlobalOptionsQueryVariables,
  data: ChooseOptionsStepBody_GlobalOptionsDataOptions | Error,
): MockedResponse<ChooseOptionsStepBody_GlobalOptionsQueryVariables, ChooseOptionsStepBody_GlobalOptionsQuery> {
  return {
    request: { query: ChooseOptionsStepBody_GlobalOptionsDocument, variables },
    result: { data: data instanceof Error ? undefined : newChooseOptionsStepBody_GlobalOptionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BulkEditModal_GetTlisDataOptions {
  takeoffLineItemsPage?: TakeoffLineItemsPage | TakeoffLineItemsPageOptions;
}

export function newBulkEditModal_GetTlisData(data: BulkEditModal_GetTlisDataOptions): BulkEditModal_GetTlisQuery {
  return {
    __typename: "Query" as const,
    takeoffLineItemsPage: maybeNew("TakeoffLineItemsPage", data["takeoffLineItemsPage"] || undefined, {}),
  } as any;
}

export function newBulkEditModal_GetTlisResponse(
  variables: BulkEditModal_GetTlisQueryVariables,
  data: BulkEditModal_GetTlisDataOptions | Error,
): MockedResponse<BulkEditModal_GetTlisQueryVariables, BulkEditModal_GetTlisQuery> {
  return {
    request: { query: BulkEditModal_GetTlisDocument, variables },
    result: { data: data instanceof Error ? undefined : newBulkEditModal_GetTlisData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TakeoffUploader_ValidateTlisDataOptions {
  takeoffLineItemsPage?: TakeoffLineItemsPage | TakeoffLineItemsPageOptions;
}

export function newTakeoffUploader_ValidateTlisData(
  data: TakeoffUploader_ValidateTlisDataOptions,
): TakeoffUploader_ValidateTlisQuery {
  return {
    __typename: "Query" as const,
    takeoffLineItemsPage: maybeNew("TakeoffLineItemsPage", data["takeoffLineItemsPage"] || undefined, {}),
  } as any;
}

export function newTakeoffUploader_ValidateTlisResponse(
  variables: TakeoffUploader_ValidateTlisQueryVariables,
  data: TakeoffUploader_ValidateTlisDataOptions | Error,
): MockedResponse<TakeoffUploader_ValidateTlisQueryVariables, TakeoffUploader_ValidateTlisQuery> {
  return {
    request: { query: TakeoffUploader_ValidateTlisDocument, variables },
    result: { data: data instanceof Error ? undefined : newTakeoffUploader_ValidateTlisData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DuplicateItemsConfirmationModal_GetTlisDataOptions {
  takeoffLineItemsPage?: TakeoffLineItemsPage | TakeoffLineItemsPageOptions;
}

export function newDuplicateItemsConfirmationModal_GetTlisData(
  data: DuplicateItemsConfirmationModal_GetTlisDataOptions,
): DuplicateItemsConfirmationModal_GetTlisQuery {
  return {
    __typename: "Query" as const,
    takeoffLineItemsPage: maybeNew("TakeoffLineItemsPage", data["takeoffLineItemsPage"] || undefined, {}),
  } as any;
}

export function newDuplicateItemsConfirmationModal_GetTlisResponse(
  variables: DuplicateItemsConfirmationModal_GetTlisQueryVariables,
  data: DuplicateItemsConfirmationModal_GetTlisDataOptions | Error,
): MockedResponse<DuplicateItemsConfirmationModal_GetTlisQueryVariables, DuplicateItemsConfirmationModal_GetTlisQuery> {
  return {
    request: { query: DuplicateItemsConfirmationModal_GetTlisDocument, variables },
    result: { data: data instanceof Error ? undefined : newDuplicateItemsConfirmationModal_GetTlisData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveProductAttributesDataOptions {
  saveProductAttributes?: SaveProductAttributesResult | SaveProductAttributesResultOptions;
}

export function newSaveProductAttributesData(data: SaveProductAttributesDataOptions): SaveProductAttributesMutation {
  return {
    __typename: "Mutation" as const,
    saveProductAttributes: maybeNew("SaveProductAttributesResult", data["saveProductAttributes"] || undefined, {}),
  } as any;
}

export function newSaveProductAttributesResponse(
  variables: SaveProductAttributesMutationVariables,
  data: SaveProductAttributesDataOptions | Error,
): MockedResponse<SaveProductAttributesMutationVariables, SaveProductAttributesMutation> {
  return {
    request: { query: SaveProductAttributesDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveProductAttributesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProductSuperDrawerDetailsDataOptions {
  products?: (Product | ProductOptions)[];
  attributes?: (ProductAttribute | ProductAttributeOptions)[];
  items?: (Item | ItemOptions)[];
}

export function newProductSuperDrawerDetailsData(
  data: ProductSuperDrawerDetailsDataOptions,
): ProductSuperDrawerDetailsQuery {
  return {
    __typename: "Query" as const,
    products: data["products"]?.map((d) => newProduct(d)) || [],
    attributes: data["attributes"]?.map((d) => newProductAttribute(d)) || [],
    items: data["items"]?.map((d) => newItem(d)) || [],
  } as any;
}

export function newProductSuperDrawerDetailsResponse(
  variables: ProductSuperDrawerDetailsQueryVariables,
  data: ProductSuperDrawerDetailsDataOptions | Error,
): MockedResponse<ProductSuperDrawerDetailsQueryVariables, ProductSuperDrawerDetailsQuery> {
  return {
    request: { query: ProductSuperDrawerDetailsDocument, variables },
    result: { data: data instanceof Error ? undefined : newProductSuperDrawerDetailsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanPackageStepDataOptions {
  planPackages?: PlanPackagesPageResult | PlanPackagesPageResultOptions;
}

export function newPlanPackageStepData(data: PlanPackageStepDataOptions): PlanPackageStepQuery {
  return {
    __typename: "Query" as const,
    planPackages: maybeNew("PlanPackagesPageResult", data["planPackages"] || undefined, {}),
  } as any;
}

export function newPlanPackageStepResponse(
  data: PlanPackageStepDataOptions | Error,
): MockedResponse<PlanPackageStepQueryVariables, PlanPackageStepQuery> {
  return {
    request: { query: PlanPackageStepDocument },
    result: { data: data instanceof Error ? undefined : newPlanPackageStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DesignPackagesStepDataOptions {
  designPackages?: DesignPackagesPageResult | DesignPackagesPageResultOptions;
}

export function newDesignPackagesStepData(data: DesignPackagesStepDataOptions): DesignPackagesStepQuery {
  return {
    __typename: "Query" as const,
    designPackages: maybeNew("DesignPackagesPageResult", data["designPackages"] || undefined, {}),
  } as any;
}

export function newDesignPackagesStepResponse(
  data: DesignPackagesStepDataOptions | Error,
): MockedResponse<DesignPackagesStepQueryVariables, DesignPackagesStepQuery> {
  return {
    request: { query: DesignPackagesStepDocument },
    result: { data: data instanceof Error ? undefined : newDesignPackagesStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface OfferingDetailsStep_DevelopmentsDataOptions {
  developments?: (Development | DevelopmentOptions)[];
}

export function newOfferingDetailsStep_DevelopmentsData(
  data: OfferingDetailsStep_DevelopmentsDataOptions,
): OfferingDetailsStep_DevelopmentsQuery {
  return {
    __typename: "Query" as const,
    developments: data["developments"]?.map((d) => newDevelopment(d)) || [],
  } as any;
}

export function newOfferingDetailsStep_DevelopmentsResponse(
  data: OfferingDetailsStep_DevelopmentsDataOptions | Error,
): MockedResponse<OfferingDetailsStep_DevelopmentsQueryVariables, OfferingDetailsStep_DevelopmentsQuery> {
  return {
    request: { query: OfferingDetailsStep_DevelopmentsDocument },
    result: { data: data instanceof Error ? undefined : newOfferingDetailsStep_DevelopmentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface OfferingDetailsStep_CommunitiesDataOptions {
  projects?: (Project | ProjectOptions)[];
}

export function newOfferingDetailsStep_CommunitiesData(
  data: OfferingDetailsStep_CommunitiesDataOptions,
): OfferingDetailsStep_CommunitiesQuery {
  return {
    __typename: "Query" as const,
    projects: data["projects"]?.map((d) => maybeNew("Project", d, {})) || [],
  } as any;
}

export function newOfferingDetailsStep_CommunitiesResponse(
  data: OfferingDetailsStep_CommunitiesDataOptions | Error,
): MockedResponse<OfferingDetailsStep_CommunitiesQueryVariables, OfferingDetailsStep_CommunitiesQuery> {
  return {
    request: { query: OfferingDetailsStep_CommunitiesDocument },
    result: { data: data instanceof Error ? undefined : newOfferingDetailsStep_CommunitiesData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface OptionsStepDataOptions {
  potentialOptions?: (ReadyPlanOption | ReadyPlanOptionOptions)[];
}

export function newOptionsStepData(data: OptionsStepDataOptions): OptionsStepQuery {
  return {
    __typename: "Query" as const,
    potentialOptions: data["potentialOptions"]?.map((d) => newReadyPlanOption(d)) || [],
  } as any;
}

export function newOptionsStepResponse(
  variables: OptionsStepQueryVariables,
  data: OptionsStepDataOptions | Error,
): MockedResponse<OptionsStepQueryVariables, OptionsStepQuery> {
  return {
    request: { query: OptionsStepDocument, variables },
    result: { data: data instanceof Error ? undefined : newOptionsStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ReviewStepDataOptions {
  planPackage?: PlanPackage | PlanPackageOptions;
  exteriorDesignPackage?: DesignPackage | DesignPackageOptions;
  interiorDesignPackage?: DesignPackage | DesignPackageOptions;
  readyPlanOptions?: (ReadyPlanOption | ReadyPlanOptionOptions)[];
}

export function newReviewStepData(data: ReviewStepDataOptions): ReviewStepQuery {
  return {
    __typename: "Query" as const,
    planPackage: maybeNew("PlanPackage", data["planPackage"] || undefined, {}),
    exteriorDesignPackage: maybeNew("DesignPackage", data["exteriorDesignPackage"] || undefined, {}),
    interiorDesignPackage: maybeNew("DesignPackage", data["interiorDesignPackage"] || undefined, {}),
    readyPlanOptions: data["readyPlanOptions"]?.map((d) => newReadyPlanOption(d)) || [],
  } as any;
}

export function newReviewStepResponse(
  variables: ReviewStepQueryVariables,
  data: ReviewStepDataOptions | Error,
): MockedResponse<ReviewStepQueryVariables, ReviewStepQuery> {
  return {
    request: { query: ReviewStepDocument, variables },
    result: { data: data instanceof Error ? undefined : newReviewStepData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ReviewStep_SaveProductOfferingDataOptions {
  saveProductOffering?: SaveProductOfferingResult | SaveProductOfferingResultOptions;
}

export function newReviewStep_SaveProductOfferingData(
  data: ReviewStep_SaveProductOfferingDataOptions,
): ReviewStep_SaveProductOfferingMutation {
  return {
    __typename: "Mutation" as const,
    saveProductOffering: maybeNew("SaveProductOfferingResult", data["saveProductOffering"] || undefined, {}),
  } as any;
}

export function newReviewStep_SaveProductOfferingResponse(
  variables: ReviewStep_SaveProductOfferingMutationVariables,
  data: ReviewStep_SaveProductOfferingDataOptions | Error,
): MockedResponse<ReviewStep_SaveProductOfferingMutationVariables, ReviewStep_SaveProductOfferingMutation> {
  return {
    request: { query: ReviewStep_SaveProductOfferingDocument, variables },
    result: { data: data instanceof Error ? undefined : newReviewStep_SaveProductOfferingData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CommittedAtStartTabDataOptions {
  projectCostCodes?: ProjectCostCodesPageResult | ProjectCostCodesPageResultOptions;
}

export function newCommittedAtStartTabData(data: CommittedAtStartTabDataOptions): CommittedAtStartTabQuery {
  return {
    __typename: "Query" as const,
    projectCostCodes: maybeNew("ProjectCostCodesPageResult", data["projectCostCodes"] || undefined, {}),
  } as any;
}

export function newCommittedAtStartTabResponse(
  variables: CommittedAtStartTabQueryVariables,
  data: CommittedAtStartTabDataOptions | Error,
): MockedResponse<CommittedAtStartTabQueryVariables, CommittedAtStartTabQuery> {
  return {
    request: { query: CommittedAtStartTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newCommittedAtStartTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CommittedAtStartTab_CommitmentsByProjectCostCodeDataOptions {
  commitments?: (Commitment | CommitmentOptions)[];
}

export function newCommittedAtStartTab_CommitmentsByProjectCostCodeData(
  data: CommittedAtStartTab_CommitmentsByProjectCostCodeDataOptions,
): CommittedAtStartTab_CommitmentsByProjectCostCodeQuery {
  return { __typename: "Query" as const, commitments: data["commitments"]?.map((d) => newCommitment(d)) || [] } as any;
}

export function newCommittedAtStartTab_CommitmentsByProjectCostCodeResponse(
  variables: CommittedAtStartTab_CommitmentsByProjectCostCodeQueryVariables,
  data: CommittedAtStartTab_CommitmentsByProjectCostCodeDataOptions | Error,
): MockedResponse<
  CommittedAtStartTab_CommitmentsByProjectCostCodeQueryVariables,
  CommittedAtStartTab_CommitmentsByProjectCostCodeQuery
> {
  return {
    request: { query: CommittedAtStartTab_CommitmentsByProjectCostCodeDocument, variables },
    result: { data: data instanceof Error ? undefined : newCommittedAtStartTab_CommitmentsByProjectCostCodeData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DirectMarginTabDataOptions {
  projectDirectMarginGraph?: ProjectDirectMarginGraph | ProjectDirectMarginGraphOptions;
  project?: Project | ProjectOptions;
}

export function newDirectMarginTabData(data: DirectMarginTabDataOptions): DirectMarginTabQuery {
  return {
    __typename: "Query" as const,
    projectDirectMarginGraph: maybeNew("ProjectDirectMarginGraph", data["projectDirectMarginGraph"] || undefined, {}),
    project: maybeNew("Project", data["project"] || undefined, {}),
  } as any;
}

export function newDirectMarginTabResponse(
  variables: DirectMarginTabQueryVariables,
  data: DirectMarginTabDataOptions | Error,
): MockedResponse<DirectMarginTabQueryVariables, DirectMarginTabQuery> {
  return {
    request: { query: DirectMarginTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newDirectMarginTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BudgetOverviewTabDataOptions {
  project?: Project | ProjectOptions;
}

export function newBudgetOverviewTabData(data: BudgetOverviewTabDataOptions): BudgetOverviewTabQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newBudgetOverviewTabResponse(
  variables: BudgetOverviewTabQueryVariables,
  data: BudgetOverviewTabDataOptions | Error,
): MockedResponse<BudgetOverviewTabQueryVariables, BudgetOverviewTabQuery> {
  return {
    request: { query: BudgetOverviewTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newBudgetOverviewTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface VarianceTabDataOptions {
  projectChangeEventGraphs?: ProjectChangeEventGraphsResult | ProjectChangeEventGraphsResultOptions;
  project?: Project | ProjectOptions;
}

export function newVarianceTabData(data: VarianceTabDataOptions): VarianceTabQuery {
  return {
    __typename: "Query" as const,
    projectChangeEventGraphs: maybeNew(
      "ProjectChangeEventGraphsResult",
      data["projectChangeEventGraphs"] || undefined,
      {},
    ),
    project: maybeNew("Project", data["project"] || undefined, {}),
  } as any;
}

export function newVarianceTabResponse(
  variables: VarianceTabQueryVariables,
  data: VarianceTabDataOptions | Error,
): MockedResponse<VarianceTabQueryVariables, VarianceTabQuery> {
  return {
    request: { query: VarianceTabDocument, variables },
    result: { data: data instanceof Error ? undefined : newVarianceTabData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectDashboardFinancialsDataOptions {
  project?: Project | ProjectOptions;
}

export function newProjectDashboardFinancialsData(
  data: ProjectDashboardFinancialsDataOptions,
): ProjectDashboardFinancialsQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newProjectDashboardFinancialsResponse(
  variables: ProjectDashboardFinancialsQueryVariables,
  data: ProjectDashboardFinancialsDataOptions | Error,
): MockedResponse<ProjectDashboardFinancialsQueryVariables, ProjectDashboardFinancialsQuery> {
  return {
    request: { query: ProjectDashboardFinancialsDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectDashboardFinancialsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface UserProjectDocumentsDataOptions {
  userProjectDocuments?: (Document | DocumentOptions)[];
}

export function newUserProjectDocumentsData(data: UserProjectDocumentsDataOptions): UserProjectDocumentsQuery {
  return {
    __typename: "Query" as const,
    userProjectDocuments: data["userProjectDocuments"]?.map((d) => newDocument(d)) || [],
  } as any;
}

export function newUserProjectDocumentsResponse(
  variables: UserProjectDocumentsQueryVariables,
  data: UserProjectDocumentsDataOptions | Error,
): MockedResponse<UserProjectDocumentsQueryVariables, UserProjectDocumentsQuery> {
  return {
    request: { query: UserProjectDocumentsDocument, variables },
    result: { data: data instanceof Error ? undefined : newUserProjectDocumentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface JobLogsTileDataOptions {
  jobLogs?: (JobLog | JobLogOptions)[];
}

export function newJobLogsTileData(data: JobLogsTileDataOptions): JobLogsTileQuery {
  return { __typename: "Query" as const, jobLogs: data["jobLogs"]?.map((d) => newJobLog(d)) || [] } as any;
}

export function newJobLogsTileResponse(
  variables: JobLogsTileQueryVariables,
  data: JobLogsTileDataOptions | Error,
): MockedResponse<JobLogsTileQueryVariables, JobLogsTileQuery> {
  return {
    request: { query: JobLogsTileDocument, variables },
    result: { data: data instanceof Error ? undefined : newJobLogsTileData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectInfoTileDataOptions {
  project?: Project | ProjectOptions;
  systemTasks?: (ScheduleTask | ScheduleTaskOptions)[];
  completedMilestoneTasks?: (ScheduleTask | ScheduleTaskOptions)[];
}

export function newProjectInfoTileData(data: ProjectInfoTileDataOptions): ProjectInfoTileQuery {
  return {
    __typename: "Query" as const,
    project: maybeNew("Project", data["project"] || undefined, {}),
    systemTasks: data["systemTasks"]?.map((d) => newScheduleTask(d)) || [],
    completedMilestoneTasks: data["completedMilestoneTasks"]?.map((d) => newScheduleTask(d)) || [],
  } as any;
}

export function newProjectInfoTileResponse(
  variables: ProjectInfoTileQueryVariables,
  data: ProjectInfoTileDataOptions | Error,
): MockedResponse<ProjectInfoTileQueryVariables, ProjectInfoTileQuery> {
  return {
    request: { query: ProjectInfoTileDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectInfoTileData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface RecentActivityRailDataOptions {
  project?: Project | ProjectOptions;
}

export function newRecentActivityRailData(data: RecentActivityRailDataOptions): RecentActivityRailQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newRecentActivityRailResponse(
  variables: RecentActivityRailQueryVariables,
  data: RecentActivityRailDataOptions | Error,
): MockedResponse<RecentActivityRailQueryVariables, RecentActivityRailQuery> {
  return {
    request: { query: RecentActivityRailDocument, variables },
    result: { data: data instanceof Error ? undefined : newRecentActivityRailData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PhotosTileDataOptions {
  jobLogImages?: (JobLogImage | JobLogImageOptions)[];
}

export function newPhotosTileData(data: PhotosTileDataOptions): PhotosTileQuery {
  return {
    __typename: "Query" as const,
    jobLogImages: data["jobLogImages"]?.map((d) => newJobLogImage(d)) || [],
  } as any;
}

export function newPhotosTileResponse(
  variables: PhotosTileQueryVariables,
  data: PhotosTileDataOptions | Error,
): MockedResponse<PhotosTileQueryVariables, PhotosTileQuery> {
  return {
    request: { query: PhotosTileDocument, variables },
    result: { data: data instanceof Error ? undefined : newPhotosTileData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectScheduleTileDataOptions {
  schedules?: (Schedule | ScheduleOptions)[];
  scheduleTasks?: (ScheduleTask | ScheduleTaskOptions)[];
}

export function newProjectScheduleTileData(data: ProjectScheduleTileDataOptions): ProjectScheduleTileQuery {
  return {
    __typename: "Query" as const,
    schedules: data["schedules"]?.map((d) => newSchedule(d)) || [],
    scheduleTasks: data["scheduleTasks"]?.map((d) => newScheduleTask(d)) || [],
  } as any;
}

export function newProjectScheduleTileResponse(
  variables: ProjectScheduleTileQueryVariables,
  data: ProjectScheduleTileDataOptions | Error,
): MockedResponse<ProjectScheduleTileQueryVariables, ProjectScheduleTileQuery> {
  return {
    request: { query: ProjectScheduleTileDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectScheduleTileData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanTaskBillModal_ProtoBillsDataOptions {
  planTask?: PlanTask | PlanTaskOptions;
}

export function newPlanTaskBillModal_ProtoBillsData(
  data: PlanTaskBillModal_ProtoBillsDataOptions,
): PlanTaskBillModal_ProtoBillsQuery {
  return { __typename: "Query" as const, planTask: maybeNew("PlanTask", data["planTask"] || undefined, {}) } as any;
}

export function newPlanTaskBillModal_ProtoBillsResponse(
  variables: PlanTaskBillModal_ProtoBillsQueryVariables,
  data: PlanTaskBillModal_ProtoBillsDataOptions | Error,
): MockedResponse<PlanTaskBillModal_ProtoBillsQueryVariables, PlanTaskBillModal_ProtoBillsQuery> {
  return {
    request: { query: PlanTaskBillModal_ProtoBillsDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanTaskBillModal_ProtoBillsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TeamMembersTileInternalUsersDataOptions {
  project?: Project | ProjectOptions;
}

export function newTeamMembersTileInternalUsersData(
  data: TeamMembersTileInternalUsersDataOptions,
): TeamMembersTileInternalUsersQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newTeamMembersTileInternalUsersResponse(
  variables: TeamMembersTileInternalUsersQueryVariables,
  data: TeamMembersTileInternalUsersDataOptions | Error,
): MockedResponse<TeamMembersTileInternalUsersQueryVariables, TeamMembersTileInternalUsersQuery> {
  return {
    request: { query: TeamMembersTileInternalUsersDocument, variables },
    result: { data: data instanceof Error ? undefined : newTeamMembersTileInternalUsersData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TeamMembersTileTradePartnersDataOptions {
  tradePartners?: (TradePartner | TradePartnerOptions)[];
}

export function newTeamMembersTileTradePartnersData(
  data: TeamMembersTileTradePartnersDataOptions,
): TeamMembersTileTradePartnersQuery {
  return {
    __typename: "Query" as const,
    tradePartners: data["tradePartners"]?.map((d) => newTradePartner(d)) || [],
  } as any;
}

export function newTeamMembersTileTradePartnersResponse(
  variables: TeamMembersTileTradePartnersQueryVariables,
  data: TeamMembersTileTradePartnersDataOptions | Error,
): MockedResponse<TeamMembersTileTradePartnersQueryVariables, TeamMembersTileTradePartnersQuery> {
  return {
    request: { query: TeamMembersTileTradePartnersDocument, variables },
    result: { data: data instanceof Error ? undefined : newTeamMembersTileTradePartnersData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ConfirmDrawProjectStageDataOptions {
  projectStage?: ProjectStage | ProjectStageOptions;
}

export function newConfirmDrawProjectStageData(data: ConfirmDrawProjectStageDataOptions): ConfirmDrawProjectStageQuery {
  return {
    __typename: "Query" as const,
    projectStage: maybeNew("ProjectStage", data["projectStage"] || undefined, {}),
  } as any;
}

export function newConfirmDrawProjectStageResponse(
  variables: ConfirmDrawProjectStageQueryVariables,
  data: ConfirmDrawProjectStageDataOptions | Error,
): MockedResponse<ConfirmDrawProjectStageQueryVariables, ConfirmDrawProjectStageQuery> {
  return {
    request: { query: ConfirmDrawProjectStageDocument, variables },
    result: { data: data instanceof Error ? undefined : newConfirmDrawProjectStageData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProjectToDosTileDataOptions {
  toDos?: (ToDo | ToDoOptions)[];
}

export function newProjectToDosTileData(data: ProjectToDosTileDataOptions): ProjectToDosTileQuery {
  return { __typename: "Query" as const, toDos: data["toDos"]?.map((d) => newToDo(d)) || [] } as any;
}

export function newProjectToDosTileResponse(
  variables: ProjectToDosTileQueryVariables,
  data: ProjectToDosTileDataOptions | Error,
): MockedResponse<ProjectToDosTileQueryVariables, ProjectToDosTileQuery> {
  return {
    request: { query: ProjectToDosTileDocument, variables },
    result: { data: data instanceof Error ? undefined : newProjectToDosTileData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ConfirmLineItemsDataDataOptions {
  projectStage?: ProjectStage | ProjectStageOptions;
}

export function newConfirmLineItemsDataData(data: ConfirmLineItemsDataDataOptions): ConfirmLineItemsDataQuery {
  return {
    __typename: "Query" as const,
    projectStage: maybeNew("ProjectStage", data["projectStage"] || undefined, {}),
  } as any;
}

export function newConfirmLineItemsDataResponse(
  variables: ConfirmLineItemsDataQueryVariables,
  data: ConfirmLineItemsDataDataOptions | Error,
): MockedResponse<ConfirmLineItemsDataQueryVariables, ConfirmLineItemsDataQuery> {
  return {
    request: { query: ConfirmLineItemsDataDocument, variables },
    result: { data: data instanceof Error ? undefined : newConfirmLineItemsDataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SelectFixedItemsDataDataOptions {
  projectStage?: ProjectStage | ProjectStageOptions;
}

export function newSelectFixedItemsDataData(data: SelectFixedItemsDataDataOptions): SelectFixedItemsDataQuery {
  return {
    __typename: "Query" as const,
    projectStage: maybeNew("ProjectStage", data["projectStage"] || undefined, {}),
  } as any;
}

export function newSelectFixedItemsDataResponse(
  variables: SelectFixedItemsDataQueryVariables,
  data: SelectFixedItemsDataDataOptions | Error,
): MockedResponse<SelectFixedItemsDataQueryVariables, SelectFixedItemsDataQuery> {
  return {
    request: { query: SelectFixedItemsDataDocument, variables },
    result: { data: data instanceof Error ? undefined : newSelectFixedItemsDataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TaskBillModal_SaveBillsDataOptions {
  saveBills?: SaveBillsResult | SaveBillsResultOptions;
}

export function newTaskBillModal_SaveBillsData(
  data: TaskBillModal_SaveBillsDataOptions,
): TaskBillModal_SaveBillsMutation {
  return {
    __typename: "Mutation" as const,
    saveBills: maybeNew("SaveBillsResult", data["saveBills"] || undefined, {}),
  } as any;
}

export function newTaskBillModal_SaveBillsResponse(
  variables: TaskBillModal_SaveBillsMutationVariables,
  data: TaskBillModal_SaveBillsDataOptions | Error,
): MockedResponse<TaskBillModal_SaveBillsMutationVariables, TaskBillModal_SaveBillsMutation> {
  return {
    request: { query: TaskBillModal_SaveBillsDocument, variables },
    result: { data: data instanceof Error ? undefined : newTaskBillModal_SaveBillsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface TaskBillModal_ProtoBillsDataOptions {
  task?: Task | TaskOptions;
}

export function newTaskBillModal_ProtoBillsData(
  data: TaskBillModal_ProtoBillsDataOptions,
): TaskBillModal_ProtoBillsQuery {
  return { __typename: "Query" as const, task: maybeNew("Task", data["task"] || undefined, {}) } as any;
}

export function newTaskBillModal_ProtoBillsResponse(
  variables: TaskBillModal_ProtoBillsQueryVariables,
  data: TaskBillModal_ProtoBillsDataOptions | Error,
): MockedResponse<TaskBillModal_ProtoBillsQueryVariables, TaskBillModal_ProtoBillsQuery> {
  return {
    request: { query: TaskBillModal_ProtoBillsDocument, variables },
    result: { data: data instanceof Error ? undefined : newTaskBillModal_ProtoBillsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ScheduleFlagReasonsDataOptions {
  scheduleFlagReasons?: (ScheduleFlagReason | ScheduleFlagReasonOptions)[];
}

export function newScheduleFlagReasonsData(data: ScheduleFlagReasonsDataOptions): ScheduleFlagReasonsQuery {
  return {
    __typename: "Query" as const,
    scheduleFlagReasons: data["scheduleFlagReasons"]?.map((d) => newScheduleFlagReason(d)) || [],
  } as any;
}

export function newScheduleFlagReasonsResponse(
  data: ScheduleFlagReasonsDataOptions | Error,
): MockedResponse<ScheduleFlagReasonsQueryVariables, ScheduleFlagReasonsQuery> {
  return {
    request: { query: ScheduleFlagReasonsDocument },
    result: { data: data instanceof Error ? undefined : newScheduleFlagReasonsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveScheduleFlagDataOptions {
  saveScheduleFlag?: SaveScheduleFlagResult | SaveScheduleFlagResultOptions;
}

export function newSaveScheduleFlagData(data: SaveScheduleFlagDataOptions): SaveScheduleFlagMutation {
  return {
    __typename: "Mutation" as const,
    saveScheduleFlag: maybeNew("SaveScheduleFlagResult", data["saveScheduleFlag"] || undefined, {}),
  } as any;
}

export function newSaveScheduleFlagResponse(
  variables: SaveScheduleFlagMutationVariables,
  data: SaveScheduleFlagDataOptions | Error,
): MockedResponse<SaveScheduleFlagMutationVariables, SaveScheduleFlagMutation> {
  return {
    request: { query: SaveScheduleFlagDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveScheduleFlagData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteScheduleFlagDataOptions {
  deleteScheduleFlag?: DeleteScheduleFlagResult | DeleteScheduleFlagResultOptions;
}

export function newDeleteScheduleFlagData(data: DeleteScheduleFlagDataOptions): DeleteScheduleFlagMutation {
  return {
    __typename: "Mutation" as const,
    deleteScheduleFlag: maybeNew("DeleteScheduleFlagResult", data["deleteScheduleFlag"] || undefined, {}),
  } as any;
}

export function newDeleteScheduleFlagResponse(
  variables: DeleteScheduleFlagMutationVariables,
  data: DeleteScheduleFlagDataOptions | Error,
): MockedResponse<DeleteScheduleFlagMutationVariables, DeleteScheduleFlagMutation> {
  return {
    request: { query: DeleteScheduleFlagDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteScheduleFlagData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface LotDetailDrawerDataOptions {
  projectReadyPlanConfig?: ProjectReadyPlanConfig | ProjectReadyPlanConfigOptions;
  globalOptionTypes?: (GlobalOptionType | GlobalOptionTypeOptions)[];
  readyPlans?: (ReadyPlan | ReadyPlanOptions)[];
  internalUsers?: (InternalUser | InternalUserOptions)[];
  currentUser?: User | UserOptions | null;
  enumDetails?: AllEnumDetails | AllEnumDetailsOptions;
}

export function newLotDetailDrawerData(data: LotDetailDrawerDataOptions): LotDetailDrawerQuery {
  return {
    __typename: "Query" as const,
    projectReadyPlanConfig: maybeNew("ProjectReadyPlanConfig", data["projectReadyPlanConfig"] || undefined, {}),
    globalOptionTypes: data["globalOptionTypes"]?.map((d) => newGlobalOptionType(d)) || [],
    readyPlans: data["readyPlans"]?.map((d) => newReadyPlan(d)) || [],
    internalUsers: data["internalUsers"]?.map((d) => newInternalUser(d)) || [],
    currentUser: maybeNewOrNull("User", data["currentUser"] || undefined, {}),
    enumDetails: maybeNew("AllEnumDetails", data["enumDetails"] || undefined, {}),
  } as any;
}

export function newLotDetailDrawerResponse(
  variables: LotDetailDrawerQueryVariables,
  data: LotDetailDrawerDataOptions | Error,
): MockedResponse<LotDetailDrawerQueryVariables, LotDetailDrawerQuery> {
  return {
    request: { query: LotDetailDrawerDocument, variables },
    result: { data: data instanceof Error ? undefined : newLotDetailDrawerData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ComputedProgramDataPreviewDataOptions {
  computeProgramData?: NewProgramData | NewProgramDataOptions;
}

export function newComputedProgramDataPreviewData(
  data: ComputedProgramDataPreviewDataOptions,
): ComputedProgramDataPreviewQuery {
  return {
    __typename: "Query" as const,
    computeProgramData: maybeNew("NewProgramData", data["computeProgramData"] || undefined, {}),
  } as any;
}

export function newComputedProgramDataPreviewResponse(
  variables: ComputedProgramDataPreviewQueryVariables,
  data: ComputedProgramDataPreviewDataOptions | Error,
): MockedResponse<ComputedProgramDataPreviewQueryVariables, ComputedProgramDataPreviewQuery> {
  return {
    request: { query: ComputedProgramDataPreviewDocument, variables },
    result: { data: data instanceof Error ? undefined : newComputedProgramDataPreviewData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveProjectReadyPlanConfigDataOptions {
  saveProjectReadyPlanConfigs?: SaveProjectReadyPlanConfigsResult | SaveProjectReadyPlanConfigsResultOptions;
}

export function newSaveProjectReadyPlanConfigData(
  data: SaveProjectReadyPlanConfigDataOptions,
): SaveProjectReadyPlanConfigMutation {
  return {
    __typename: "Mutation" as const,
    saveProjectReadyPlanConfigs: maybeNew(
      "SaveProjectReadyPlanConfigsResult",
      data["saveProjectReadyPlanConfigs"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveProjectReadyPlanConfigResponse(
  variables: SaveProjectReadyPlanConfigMutationVariables,
  data: SaveProjectReadyPlanConfigDataOptions | Error,
): MockedResponse<SaveProjectReadyPlanConfigMutationVariables, SaveProjectReadyPlanConfigMutation> {
  return {
    request: { query: SaveProjectReadyPlanConfigDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveProjectReadyPlanConfigData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveProjectLotDetailDataOptions {
  saveProjectLotDetails?: SaveProjectLotDetailsResult | SaveProjectLotDetailsResultOptions;
}

export function newSaveProjectLotDetailData(data: SaveProjectLotDetailDataOptions): SaveProjectLotDetailMutation {
  return {
    __typename: "Mutation" as const,
    saveProjectLotDetails: maybeNew("SaveProjectLotDetailsResult", data["saveProjectLotDetails"] || undefined, {}),
  } as any;
}

export function newSaveProjectLotDetailResponse(
  variables: SaveProjectLotDetailMutationVariables,
  data: SaveProjectLotDetailDataOptions | Error,
): MockedResponse<SaveProjectLotDetailMutationVariables, SaveProjectLotDetailMutation> {
  return {
    request: { query: SaveProjectLotDetailDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveProjectLotDetailData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface LotCheckTableMetadataDataOptions {
  siteSpecificInfos?: (SiteSpecificInfo | SiteSpecificInfoOptions)[];
}

export function newLotCheckTableMetadataData(data: LotCheckTableMetadataDataOptions): LotCheckTableMetadataQuery {
  return {
    __typename: "Query" as const,
    siteSpecificInfos: data["siteSpecificInfos"]?.map((d) => newSiteSpecificInfo(d)) || [],
  } as any;
}

export function newLotCheckTableMetadataResponse(
  data: LotCheckTableMetadataDataOptions | Error,
): MockedResponse<LotCheckTableMetadataQueryVariables, LotCheckTableMetadataQuery> {
  return {
    request: { query: LotCheckTableMetadataDocument },
    result: { data: data instanceof Error ? undefined : newLotCheckTableMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveProjectSiteSpecificInfoDataOptions {
  saveProjectSiteSpecificInfo?: SaveProjectSiteSpecificInfoResult | SaveProjectSiteSpecificInfoResultOptions;
}

export function newSaveProjectSiteSpecificInfoData(
  data: SaveProjectSiteSpecificInfoDataOptions,
): SaveProjectSiteSpecificInfoMutation {
  return {
    __typename: "Mutation" as const,
    saveProjectSiteSpecificInfo: maybeNew(
      "SaveProjectSiteSpecificInfoResult",
      data["saveProjectSiteSpecificInfo"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveProjectSiteSpecificInfoResponse(
  variables: SaveProjectSiteSpecificInfoMutationVariables,
  data: SaveProjectSiteSpecificInfoDataOptions | Error,
): MockedResponse<SaveProjectSiteSpecificInfoMutationVariables, SaveProjectSiteSpecificInfoMutation> {
  return {
    request: { query: SaveProjectSiteSpecificInfoDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveProjectSiteSpecificInfoData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface LotCheckFormDrawerMetadataDataOptions {
  internalUsers?: (InternalUser | InternalUserOptions)[];
  development?: Development | DevelopmentOptions;
}

export function newLotCheckFormDrawerMetadataData(
  data: LotCheckFormDrawerMetadataDataOptions,
): LotCheckFormDrawerMetadataQuery {
  return {
    __typename: "Query" as const,
    internalUsers: data["internalUsers"]?.map((d) => newInternalUser(d)) || [],
    development: maybeNew("Development", data["development"] || undefined, {}),
  } as any;
}

export function newLotCheckFormDrawerMetadataResponse(
  variables: LotCheckFormDrawerMetadataQueryVariables,
  data: LotCheckFormDrawerMetadataDataOptions | Error,
): MockedResponse<LotCheckFormDrawerMetadataQueryVariables, LotCheckFormDrawerMetadataQuery> {
  return {
    request: { query: LotCheckFormDrawerMetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newLotCheckFormDrawerMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface LotCheckFormDrawerDataOptions {
  project?: Project | ProjectOptions;
}

export function newLotCheckFormDrawerData(data: LotCheckFormDrawerDataOptions): LotCheckFormDrawerQuery {
  return { __typename: "Query" as const, project: maybeNew("Project", data["project"] || undefined, {}) } as any;
}

export function newLotCheckFormDrawerResponse(
  variables: LotCheckFormDrawerQueryVariables,
  data: LotCheckFormDrawerDataOptions | Error,
): MockedResponse<LotCheckFormDrawerQueryVariables, LotCheckFormDrawerQuery> {
  return {
    request: { query: LotCheckFormDrawerDocument, variables },
    result: { data: data instanceof Error ? undefined : newLotCheckFormDrawerData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveProjectSiteConditionsDataOptions {
  saveProjectSiteCondition?: SaveProjectSiteConditionResult | SaveProjectSiteConditionResultOptions;
}

export function newSaveProjectSiteConditionsData(
  data: SaveProjectSiteConditionsDataOptions,
): SaveProjectSiteConditionsMutation {
  return {
    __typename: "Mutation" as const,
    saveProjectSiteCondition: maybeNew(
      "SaveProjectSiteConditionResult",
      data["saveProjectSiteCondition"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveProjectSiteConditionsResponse(
  variables: SaveProjectSiteConditionsMutationVariables,
  data: SaveProjectSiteConditionsDataOptions | Error,
): MockedResponse<SaveProjectSiteConditionsMutationVariables, SaveProjectSiteConditionsMutation> {
  return {
    request: { query: SaveProjectSiteConditionsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveProjectSiteConditionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SendProjectSiteConditionsNotificationDataOptions {
  sendProjectSiteConditionsNotification?: EmptyResult | EmptyResultOptions;
}

export function newSendProjectSiteConditionsNotificationData(
  data: SendProjectSiteConditionsNotificationDataOptions,
): SendProjectSiteConditionsNotificationMutation {
  return {
    __typename: "Mutation" as const,
    sendProjectSiteConditionsNotification: maybeNew(
      "EmptyResult",
      data["sendProjectSiteConditionsNotification"] || undefined,
      {},
    ),
  } as any;
}

export function newSendProjectSiteConditionsNotificationResponse(
  variables: SendProjectSiteConditionsNotificationMutationVariables,
  data: SendProjectSiteConditionsNotificationDataOptions | Error,
): MockedResponse<
  SendProjectSiteConditionsNotificationMutationVariables,
  SendProjectSiteConditionsNotificationMutation
> {
  return {
    request: { query: SendProjectSiteConditionsNotificationDocument, variables },
    result: { data: data instanceof Error ? undefined : newSendProjectSiteConditionsNotificationData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CohortDevelopmentsDataOptions {
  cohorts?: (Cohort | CohortOptions)[];
}

export function newCohortDevelopmentsData(data: CohortDevelopmentsDataOptions): CohortDevelopmentsQuery {
  return { __typename: "Query" as const, cohorts: data["cohorts"]?.map((d) => newCohort(d)) || [] } as any;
}

export function newCohortDevelopmentsResponse(
  data: CohortDevelopmentsDataOptions | Error,
): MockedResponse<CohortDevelopmentsQueryVariables, CohortDevelopmentsQuery> {
  return {
    request: { query: CohortDevelopmentsDocument },
    result: { data: data instanceof Error ? undefined : newCohortDevelopmentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface UpdateProjectCohortDataOptions {
  saveProject?: SaveProjectResult | SaveProjectResultOptions;
}

export function newUpdateProjectCohortData(data: UpdateProjectCohortDataOptions): UpdateProjectCohortMutation {
  return {
    __typename: "Mutation" as const,
    saveProject: maybeNew("SaveProjectResult", data["saveProject"] || undefined, {}),
  } as any;
}

export function newUpdateProjectCohortResponse(
  variables: UpdateProjectCohortMutationVariables,
  data: UpdateProjectCohortDataOptions | Error,
): MockedResponse<UpdateProjectCohortMutationVariables, UpdateProjectCohortMutation> {
  return {
    request: { query: UpdateProjectCohortDocument, variables },
    result: { data: data instanceof Error ? undefined : newUpdateProjectCohortData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface LotSequenceSheetTableMetadataDataOptions {
  cohorts?: (Cohort | CohortOptions)[];
  readyPlans?: (ReadyPlan | ReadyPlanOptions)[];
  globalOptionTypes?: (GlobalOptionType | GlobalOptionTypeOptions)[];
}

export function newLotSequenceSheetTableMetadataData(
  data: LotSequenceSheetTableMetadataDataOptions,
): LotSequenceSheetTableMetadataQuery {
  return {
    __typename: "Query" as const,
    cohorts: data["cohorts"]?.map((d) => newCohort(d)) || [],
    readyPlans: data["readyPlans"]?.map((d) => newReadyPlan(d)) || [],
    globalOptionTypes: data["globalOptionTypes"]?.map((d) => newGlobalOptionType(d)) || [],
  } as any;
}

export function newLotSequenceSheetTableMetadataResponse(
  variables: LotSequenceSheetTableMetadataQueryVariables,
  data: LotSequenceSheetTableMetadataDataOptions | Error,
): MockedResponse<LotSequenceSheetTableMetadataQueryVariables, LotSequenceSheetTableMetadataQuery> {
  return {
    request: { query: LotSequenceSheetTableMetadataDocument, variables },
    result: { data: data instanceof Error ? undefined : newLotSequenceSheetTableMetadataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface LotSequenceSheetTableDataOptions {
  projectReadyPlanConfigs?: (ProjectReadyPlanConfig | ProjectReadyPlanConfigOptions)[];
  globalTasks?: (GlobalTask | GlobalTaskOptions)[];
  cohorts?: (Cohort | CohortOptions)[];
}

export function newLotSequenceSheetTableData(data: LotSequenceSheetTableDataOptions): LotSequenceSheetTableQuery {
  return {
    __typename: "Query" as const,
    projectReadyPlanConfigs: data["projectReadyPlanConfigs"]?.map((d) => newProjectReadyPlanConfig(d)) || [],
    globalTasks: data["globalTasks"]?.map((d) => newGlobalTask(d)) || [],
    cohorts: data["cohorts"]?.map((d) => newCohort(d)) || [],
  } as any;
}

export function newLotSequenceSheetTableResponse(
  variables: LotSequenceSheetTableQueryVariables,
  data: LotSequenceSheetTableDataOptions | Error,
): MockedResponse<LotSequenceSheetTableQueryVariables, LotSequenceSheetTableQuery> {
  return {
    request: { query: LotSequenceSheetTableDocument, variables },
    result: { data: data instanceof Error ? undefined : newLotSequenceSheetTableData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface HomeownerSelectionOptionDataOptions {
  homeownerSelectionOption?: HomeownerSelectionOptionLike | HomeownerSelectionOptionLikeOptions;
}

export function newHomeownerSelectionOptionData(
  data: HomeownerSelectionOptionDataOptions,
): HomeownerSelectionOptionQuery {
  return {
    __typename: "Query" as const,
    homeownerSelectionOption: maybeNew(
      "HomeownerSelectionOptionLike",
      data["homeownerSelectionOption"] || undefined,
      {},
    ),
  } as any;
}

export function newHomeownerSelectionOptionResponse(
  variables: HomeownerSelectionOptionQueryVariables,
  data: HomeownerSelectionOptionDataOptions | Error,
): MockedResponse<HomeownerSelectionOptionQueryVariables, HomeownerSelectionOptionQuery> {
  return {
    request: { query: HomeownerSelectionOptionDocument, variables },
    result: { data: data instanceof Error ? undefined : newHomeownerSelectionOptionData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProductSearchPage_CurrentMaterialDataOptions {
  takeoffLineItem?: TakeoffLineItem | TakeoffLineItemOptions;
}

export function newProductSearchPage_CurrentMaterialData(
  data: ProductSearchPage_CurrentMaterialDataOptions,
): ProductSearchPage_CurrentMaterialQuery {
  return {
    __typename: "Query" as const,
    takeoffLineItem: maybeNew("TakeoffLineItem", data["takeoffLineItem"] || undefined, {}),
  } as any;
}

export function newProductSearchPage_CurrentMaterialResponse(
  variables: ProductSearchPage_CurrentMaterialQueryVariables,
  data: ProductSearchPage_CurrentMaterialDataOptions | Error,
): MockedResponse<ProductSearchPage_CurrentMaterialQueryVariables, ProductSearchPage_CurrentMaterialQuery> {
  return {
    request: { query: ProductSearchPage_CurrentMaterialDocument, variables },
    result: { data: data instanceof Error ? undefined : newProductSearchPage_CurrentMaterialData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MaterialAttributeDimensionsDataOptions {
  materialAttributeDimensions?: (MaterialAttributeDimension | MaterialAttributeDimensionOptions)[];
}

export function newMaterialAttributeDimensionsData(
  data: MaterialAttributeDimensionsDataOptions,
): MaterialAttributeDimensionsQuery {
  return {
    __typename: "Query" as const,
    materialAttributeDimensions: data["materialAttributeDimensions"]?.map((d) => newMaterialAttributeDimension(d)) ||
      [],
  } as any;
}

export function newMaterialAttributeDimensionsResponse(
  variables: MaterialAttributeDimensionsQueryVariables,
  data: MaterialAttributeDimensionsDataOptions | Error,
): MockedResponse<MaterialAttributeDimensionsQueryVariables, MaterialAttributeDimensionsQuery> {
  return {
    request: { query: MaterialAttributeDimensionsDocument, variables },
    result: { data: data instanceof Error ? undefined : newMaterialAttributeDimensionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateDesignPackagePlaceholderTliDataOptions {
  createDesignPackagePlaceholderTli?:
    | CreateDesignPackagePlaceholderTliResult
    | CreateDesignPackagePlaceholderTliResultOptions;
}

export function newCreateDesignPackagePlaceholderTliData(
  data: CreateDesignPackagePlaceholderTliDataOptions,
): CreateDesignPackagePlaceholderTliMutation {
  return {
    __typename: "Mutation" as const,
    createDesignPackagePlaceholderTli: maybeNew(
      "CreateDesignPackagePlaceholderTliResult",
      data["createDesignPackagePlaceholderTli"] || undefined,
      {},
    ),
  } as any;
}

export function newCreateDesignPackagePlaceholderTliResponse(
  variables: CreateDesignPackagePlaceholderTliMutationVariables,
  data: CreateDesignPackagePlaceholderTliDataOptions | Error,
): MockedResponse<CreateDesignPackagePlaceholderTliMutationVariables, CreateDesignPackagePlaceholderTliMutation> {
  return {
    request: { query: CreateDesignPackagePlaceholderTliDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateDesignPackagePlaceholderTliData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanPackageRecentActivityDataOptions {
  planPackage?: PlanPackage | PlanPackageOptions;
}

export function newPlanPackageRecentActivityData(
  data: PlanPackageRecentActivityDataOptions,
): PlanPackageRecentActivityQuery {
  return {
    __typename: "Query" as const,
    planPackage: maybeNew("PlanPackage", data["planPackage"] || undefined, {}),
  } as any;
}

export function newPlanPackageRecentActivityResponse(
  variables: PlanPackageRecentActivityQueryVariables,
  data: PlanPackageRecentActivityDataOptions | Error,
): MockedResponse<PlanPackageRecentActivityQueryVariables, PlanPackageRecentActivityQuery> {
  return {
    request: { query: PlanPackageRecentActivityDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanPackageRecentActivityData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ElevationDetailsDataOptions {
  readyPlanOption?: ReadyPlanOption | ReadyPlanOptionOptions;
}

export function newElevationDetailsData(data: ElevationDetailsDataOptions): ElevationDetailsQuery {
  return {
    __typename: "Query" as const,
    readyPlanOption: maybeNew("ReadyPlanOption", data["readyPlanOption"] || undefined, {}),
  } as any;
}

export function newElevationDetailsResponse(
  variables: ElevationDetailsQueryVariables,
  data: ElevationDetailsDataOptions | Error,
): MockedResponse<ElevationDetailsQueryVariables, ElevationDetailsQuery> {
  return {
    request: { query: ElevationDetailsDocument, variables },
    result: { data: data instanceof Error ? undefined : newElevationDetailsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddEditItemModal_GetTliDataOptions {
  takeoffLineItem?: TakeoffLineItem | TakeoffLineItemOptions;
}

export function newAddEditItemModal_GetTliData(data: AddEditItemModal_GetTliDataOptions): AddEditItemModal_GetTliQuery {
  return {
    __typename: "Query" as const,
    takeoffLineItem: maybeNew("TakeoffLineItem", data["takeoffLineItem"] || undefined, {}),
  } as any;
}

export function newAddEditItemModal_GetTliResponse(
  variables: AddEditItemModal_GetTliQueryVariables,
  data: AddEditItemModal_GetTliDataOptions | Error,
): MockedResponse<AddEditItemModal_GetTliQueryVariables, AddEditItemModal_GetTliQuery> {
  return {
    request: { query: AddEditItemModal_GetTliDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddEditItemModal_GetTliData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddEditItemModal_GetItemsDataOptions {
  items?: (Item | ItemOptions)[];
}

export function newAddEditItemModal_GetItemsData(
  data: AddEditItemModal_GetItemsDataOptions,
): AddEditItemModal_GetItemsQuery {
  return { __typename: "Query" as const, items: data["items"]?.map((d) => newItem(d)) || [] } as any;
}

export function newAddEditItemModal_GetItemsResponse(
  variables: AddEditItemModal_GetItemsQueryVariables,
  data: AddEditItemModal_GetItemsDataOptions | Error,
): MockedResponse<AddEditItemModal_GetItemsQueryVariables, AddEditItemModal_GetItemsQuery> {
  return {
    request: { query: AddEditItemModal_GetItemsDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddEditItemModal_GetItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddEditItemModal_GetMaterialVariantsDataOptions {
  materialVariants?: MaterialVariantsPage | MaterialVariantsPageOptions;
}

export function newAddEditItemModal_GetMaterialVariantsData(
  data: AddEditItemModal_GetMaterialVariantsDataOptions,
): AddEditItemModal_GetMaterialVariantsQuery {
  return {
    __typename: "Query" as const,
    materialVariants: maybeNew("MaterialVariantsPage", data["materialVariants"] || undefined, {}),
  } as any;
}

export function newAddEditItemModal_GetMaterialVariantsResponse(
  variables: AddEditItemModal_GetMaterialVariantsQueryVariables,
  data: AddEditItemModal_GetMaterialVariantsDataOptions | Error,
): MockedResponse<AddEditItemModal_GetMaterialVariantsQueryVariables, AddEditItemModal_GetMaterialVariantsQuery> {
  return {
    request: { query: AddEditItemModal_GetMaterialVariantsDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddEditItemModal_GetMaterialVariantsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddEditItemModal_GetReadyPlanDataOptions {
  readyPlan?: ReadyPlan | ReadyPlanOptions;
}

export function newAddEditItemModal_GetReadyPlanData(
  data: AddEditItemModal_GetReadyPlanDataOptions,
): AddEditItemModal_GetReadyPlanQuery {
  return { __typename: "Query" as const, readyPlan: maybeNew("ReadyPlan", data["readyPlan"] || undefined, {}) } as any;
}

export function newAddEditItemModal_GetReadyPlanResponse(
  variables: AddEditItemModal_GetReadyPlanQueryVariables,
  data: AddEditItemModal_GetReadyPlanDataOptions | Error,
): MockedResponse<AddEditItemModal_GetReadyPlanQueryVariables, AddEditItemModal_GetReadyPlanQuery> {
  return {
    request: { query: AddEditItemModal_GetReadyPlanDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddEditItemModal_GetReadyPlanData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddEditItemModal_GlobalPlanTasksDataOptions {
  globalPlanTasks?: GlobalPlanTasksPageResult | GlobalPlanTasksPageResultOptions;
}

export function newAddEditItemModal_GlobalPlanTasksData(
  data: AddEditItemModal_GlobalPlanTasksDataOptions,
): AddEditItemModal_GlobalPlanTasksQuery {
  return {
    __typename: "Query" as const,
    globalPlanTasks: maybeNew("GlobalPlanTasksPageResult", data["globalPlanTasks"] || undefined, {}),
  } as any;
}

export function newAddEditItemModal_GlobalPlanTasksResponse(
  variables: AddEditItemModal_GlobalPlanTasksQueryVariables,
  data: AddEditItemModal_GlobalPlanTasksDataOptions | Error,
): MockedResponse<AddEditItemModal_GlobalPlanTasksQueryVariables, AddEditItemModal_GlobalPlanTasksQuery> {
  return {
    request: { query: AddEditItemModal_GlobalPlanTasksDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddEditItemModal_GlobalPlanTasksData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddEditItemModal_GetLocationsDataOptions {
  locations?: (Location | LocationOptions)[];
}

export function newAddEditItemModal_GetLocationsData(
  data: AddEditItemModal_GetLocationsDataOptions,
): AddEditItemModal_GetLocationsQuery {
  return { __typename: "Query" as const, locations: data["locations"]?.map((d) => newLocation(d)) || [] } as any;
}

export function newAddEditItemModal_GetLocationsResponse(
  variables: AddEditItemModal_GetLocationsQueryVariables,
  data: AddEditItemModal_GetLocationsDataOptions | Error,
): MockedResponse<AddEditItemModal_GetLocationsQueryVariables, AddEditItemModal_GetLocationsQuery> {
  return {
    request: { query: AddEditItemModal_GetLocationsDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddEditItemModal_GetLocationsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddEditPlaceholderItemModal_GetItemsDataOptions {
  items?: (Item | ItemOptions)[];
}

export function newAddEditPlaceholderItemModal_GetItemsData(
  data: AddEditPlaceholderItemModal_GetItemsDataOptions,
): AddEditPlaceholderItemModal_GetItemsQuery {
  return { __typename: "Query" as const, items: data["items"]?.map((d) => newItem(d)) || [] } as any;
}

export function newAddEditPlaceholderItemModal_GetItemsResponse(
  data: AddEditPlaceholderItemModal_GetItemsDataOptions | Error,
): MockedResponse<AddEditPlaceholderItemModal_GetItemsQueryVariables, AddEditPlaceholderItemModal_GetItemsQuery> {
  return {
    request: { query: AddEditPlaceholderItemModal_GetItemsDocument },
    result: { data: data instanceof Error ? undefined : newAddEditPlaceholderItemModal_GetItemsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface BulkTaskAllocationModal_GlobalPlanTasksDataOptions {
  globalPlanTasks?: GlobalPlanTasksPageResult | GlobalPlanTasksPageResultOptions;
}

export function newBulkTaskAllocationModal_GlobalPlanTasksData(
  data: BulkTaskAllocationModal_GlobalPlanTasksDataOptions,
): BulkTaskAllocationModal_GlobalPlanTasksQuery {
  return {
    __typename: "Query" as const,
    globalPlanTasks: maybeNew("GlobalPlanTasksPageResult", data["globalPlanTasks"] || undefined, {}),
  } as any;
}

export function newBulkTaskAllocationModal_GlobalPlanTasksResponse(
  variables: BulkTaskAllocationModal_GlobalPlanTasksQueryVariables,
  data: BulkTaskAllocationModal_GlobalPlanTasksDataOptions | Error,
): MockedResponse<BulkTaskAllocationModal_GlobalPlanTasksQueryVariables, BulkTaskAllocationModal_GlobalPlanTasksQuery> {
  return {
    request: { query: BulkTaskAllocationModal_GlobalPlanTasksDocument, variables },
    result: { data: data instanceof Error ? undefined : newBulkTaskAllocationModal_GlobalPlanTasksData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PlanPackageTakeoffTableDataOptions {
  takeoffLineItemsPage?: TakeoffLineItemsPage | TakeoffLineItemsPageOptions;
}

export function newPlanPackageTakeoffTableData(data: PlanPackageTakeoffTableDataOptions): PlanPackageTakeoffTableQuery {
  return {
    __typename: "Query" as const,
    takeoffLineItemsPage: maybeNew("TakeoffLineItemsPage", data["takeoffLineItemsPage"] || undefined, {}),
  } as any;
}

export function newPlanPackageTakeoffTableResponse(
  variables: PlanPackageTakeoffTableQueryVariables,
  data: PlanPackageTakeoffTableDataOptions | Error,
): MockedResponse<PlanPackageTakeoffTableQueryVariables, PlanPackageTakeoffTableQuery> {
  return {
    request: { query: PlanPackageTakeoffTableDocument, variables },
    result: { data: data instanceof Error ? undefined : newPlanPackageTakeoffTableData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CompletedTaskBudgetReviewWidgetDataOptions {
  projectCompletedTaskBudgetReview?: (ProjectCompletedTaskBudgetReview | ProjectCompletedTaskBudgetReviewOptions)[];
}

export function newCompletedTaskBudgetReviewWidgetData(
  data: CompletedTaskBudgetReviewWidgetDataOptions,
): CompletedTaskBudgetReviewWidgetQuery {
  return {
    __typename: "Query" as const,
    projectCompletedTaskBudgetReview:
      data["projectCompletedTaskBudgetReview"]?.map((d) => newProjectCompletedTaskBudgetReview(d)) || [],
  } as any;
}

export function newCompletedTaskBudgetReviewWidgetResponse(
  variables: CompletedTaskBudgetReviewWidgetQueryVariables,
  data: CompletedTaskBudgetReviewWidgetDataOptions | Error,
): MockedResponse<CompletedTaskBudgetReviewWidgetQueryVariables, CompletedTaskBudgetReviewWidgetQuery> {
  return {
    request: { query: CompletedTaskBudgetReviewWidgetDocument, variables },
    result: { data: data instanceof Error ? undefined : newCompletedTaskBudgetReviewWidgetData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface HomeownerNotesTileDataOptions {
  homeownerNotes?: (HomeownerNote | HomeownerNoteOptions)[];
}

export function newHomeownerNotesTileData(data: HomeownerNotesTileDataOptions): HomeownerNotesTileQuery {
  return {
    __typename: "Query" as const,
    homeownerNotes: data["homeownerNotes"]?.map((d) => newHomeownerNote(d)) || [],
  } as any;
}

export function newHomeownerNotesTileResponse(
  variables: HomeownerNotesTileQueryVariables,
  data: HomeownerNotesTileDataOptions | Error,
): MockedResponse<HomeownerNotesTileQueryVariables, HomeownerNotesTileQuery> {
  return {
    request: { query: HomeownerNotesTileDocument, variables },
    result: { data: data instanceof Error ? undefined : newHomeownerNotesTileData(data) },
    error: data instanceof Error ? data : undefined,
  };
}

  export type MockedResponse<V, Q> = {
    request: {
      query: any;
      variables?: V;
    };
    result: {
      data?: Q;
    };
    error?: Error;
    // Note this only works if using Homebound's better-apollo-mocked-provider
    requestedCount?: number;
  };
